module.exports = {
    "zhcn": {
        "P_YS_FED_FW_1606608847296266242": "保存成功，请刷新当前页面生效",
        "P_YS_FI_CM_0000029697": "五月",
        "P_YS_SD_SDMB_0000139476": "未上传",
        "P_YS_FED_IMP_IOT0000006664": "花垣县",
        "P_YS_FED_IMP_IOT0000007994": "民和回族土族自治县",
        "P_YS_FED_IMP_IOT0000006666": "呼图壁县",
        "P_YS_FED_IMP_IOT0000007997": "丹巴县",
        "P_YS_FED_IMP_IOT0000006668": "喀喇沁左翼蒙古族自治县",
        "P_YS_FED_IMP_IOT0000006669": "川汇区",
        "P_YS_SD_UDHLIB_0000133275": "页签",
        "P_YS_FED_IMP_IOT0000006660": "察哈尔右翼后旗",
        "P_YS_FED_IMP_IOT0000006662": "七星区",
        "P_YS_OA_XTMENHU_0000046692": "下级",
        "P_YS_SD_UDHWN_0000120629": "名字",
        "P_YS_OA_XTMENHU_0000046694": "查看大图",
        "P_YS_PF_PRINT_0000057000": "自定义项10",
        "P_YS_FED_IMP_IOT0000006653": "凌河区",
        "P_YS_FED_IMP_IOT0000007984": "平顺县",
        "P_YS_FED_IMP_IOT0000006652": "罗甸县",
        "P_YS_FED_IMP_IOT0000006655": "玉环县",
        "P_YS_FED_IMP_IOT0000007986": "龙凤区",
        "P_YS_FED_IMP_IOT0000006654": "来安县",
        "P_YS_FED_IMP_IOT0000007985": "寻乌县",
        "P_YS_FED_IMP_IOT0000007988": "哈尔滨",
        "P_YS_FED_IMP_IOT0000006656": "碾子山区",
        "P_YS_FED_IMP_IOT0000006658": "铜梁县",
        "P_YS_FED_IMP_IOT0000007989": "紫云苗族布依族自治县",
        "P_YS_FED_IMP_IOT0000006650": "景泰县",
        "P_YS_FED_IMP_IOT0000007981": "邱县",
        "country66": "泰国",
        "P_YS_FED_IMP_IOT0000006649": "张湾区",
        "country65": "新加坡",
        "country63": "菲律宾",
        "country62": "印度尼西亚",
        "P_YS_FED_FW_1582822863149727762": "并且",
        "country61": "澳大利亚",
        "P_YS_FED_FW_1582822863149727765": "新增表达式",
        "country60": "马来西亚",
        "P_YS_FED_IMP_IOT0000006644": "齐河县",
        "P_YS_FED_IMP_IOT_0001080960": "仪表盘",
        "P_YS_FED_IMP_IOT0000006643": "鼎城区",
        "P_YS_FED_IMP_IOT0000006646": "镇安县",
        "P_YS_FED_IMP_IOT0000007977": "西市区",
        "P_YS_FED_IMP_IOT0000006645": "漳县",
        "P_YS_SD_URETAILF_0001130905": "完成刷新",
        "P_YS_FED_IMP_IOT0000006648": "临湘市",
        "P_YS_FED_IMP_IOT0000007979": "桃城区",
        "P_YS_FED_IMP_IOT0000006647": "罗山县",
        "P_YS_FED_FW_0001044586": "没有取得任何模板信息,请检查当前操作员是否有模板权限",
        "P_YS_FED_IMP_IOT0000007971": "定边县",
        "P_YS_FED_FW_0001044585": "大屏轮播：没有取得任何模板信息,请检查当前操作员是否有模板权限",
        "P_YS_FED_FW_1582822863149727756": "介于",
        "P_YS_FED_FW_1582822863149727759": "与",
        "P_YS_FED_IMP_IOT0000007969": "六枝特区",
        "P_YS_FED_FW_1582822863149727750": "或者",
        "P_YS_FED_FW_0000055406": "开钱箱失败！",
        "P_YS_FED_FW_0000055407": "-¥",
        "P_YS_FED_FW_1582822863149727753": "高级方案",
        "P_YS_FED_IMP_IOT0000007962": "武昌区",
        "P_YS_FED_IMP_IOT0000007961": "灵川县",
        "P_YS_FED_IMP_IOT0000007964": "永济市",
        "P_YS_FED_IMP_IOT0000006632": "龙南县",
        "P_YS_FED_FW_0000157443": "%c 语法错误",
        "P_YS_FED_FW_0000157444": "%c 未找到",
        "P_YS_FED_IMP_IOT0000006628": "云霄县",
        "P_YS_FED_IMP_IOT0000007959": "沾化县",
        "P_YS_FED_IMP_IOT0000006627": "自流井区",
        "P_YS_FED_IMP_IOT0000007958": "鹤庆县",
        "P_YS_FED_IMP_IOT0000006629": "条件筛选",
        "P_YS_PF_PRINT_0000057032": "自定义项13",
        "P_YS_PF_PRINT_0000057031": "自定义项14",
        "P_YS_PF_PRINT_0000057030": "自定义项11",
        "P_YS_FED_IMP_IOT0000007951": "霞浦县",
        "P_YS_FED_IMP_IOT0000006622": "祥云县",
        "P_YS_FED_IMP_IOT0000007953": "澧县",
        "P_YS_FED_IMP_IOT0000006621": "四子王旗",
        "P_YS_FED_IMP_IOT0000006625": "新乡县",
        "P_YS_SD_URETAILF_0001130967": "松开立即刷新",
        "P_YS_FED_FW_1550127458969190407": "上报失败",
        "P_YS_FED_IMP_IOT0000007949": "淇滨区",
        "P_YS_SD_UDHWN_0000047462": "金山区",
        "P_YS_FED_IMP_IOT0000007940": "策勒县",
        "P_YS_FED_FW_1554033164811763719": "数据展示列数",
        "P_YS_FED_IMP_IOT0000006610": "丘北县",
        "P_YS_FED_IMP_IOT0000007941": "阳山县",
        "P_YS_FED_IMP_IOT0000007944": "西城区",
        "P_YS_FED_IMP_IOT0000007943": "陇西县",
        "P_YS_FED_IMP_IOT0000006615": "沂源县",
        "P_YS_FED_IMP_IOT0000007946": "泰宁县",
        "P_YS_FED_IMP_IOT0000006614": "高阳县",
        "P_YS_FED_IMP_IOT0000007945": "城子河区",
        "P_YS_FED_MDF-COMPS_0001573315": "么?",
        "P_YS_OA_XTMENHU_0000046682": "关键字",
        "P_YS_FED_IMP_IOT0000007939": "甘洛县",
        "P_YS_FED_IMP_IOT0000006607": "石棉县",
        "P_YS_FED_IMP_IOT0000006609": "新巴尔虎左旗",
        "P_YS_SD_UDHWN_0000047473": "潜江市",
        "P_YS_FED_FW_0001663472": "存在尚未完成的check",
        "P_YS_FED_IMP_IOT0000006600": "台江县",
        "P_YS_FED_IMP_IOT0000007932": "萨迦县",
        "P_YS_PF_PROCENTER_0000022911": "上架",
        "P_YS_FED_IMP_IOT0000006604": "鸠江区",
        "P_YS_FED_IMP_IOT0000007934": "闸北区",
        "P_YS_FED_IMP_IOT0000007928": "江油市",
        "P_YS_FED_IMP_IOT0000007927": "长安区",
        "P_YS_SD_UDHWN_0000047486": "怀柔区",
        "P_YS_FED_IMP_IOT0000007922": "娄星区",
        "P_YS_FED_IMP_IOT0000007923": "兴海县",
        "P_YS_HR_HRXC_0001197527": "数据不合法",
        "P_YS_FED_FW_1555933876791541761": "刷新当前列表",
        "P_YS_FED_FW_1475374970712358918": "中午|下午|晚上",
        "P_YS_FED_IMP_IOT0000007915": "牟平区",
        "P_YS_FED_FW_1551464301900857353": "整单",
        "P_YS_FED_IMP_IOT0000007914": "商河县",
        "P_YS_FED_IMP_IOT0000007917": "枣阳市",
        "P_YS_FED_FW_1551464301900857356": "当前为明细模式",
        "P_YS_FED_IMP_IOT0000007919": "江东区",
        "P_YS_PF_PRINT_0000057075": "联系方式",
        "P_YS_FED_FW_1581128902296207365": "模糊搜",
        "P_YS_SCM_STOCK_0000132840": "有错误：",
        "P_YS_FED_IMP_IOT0000007913": "洞口县",
        "P_YS_FED_IMP_IOT0000007912": "婺城区",
        "P_YS_PF_GZTSYS_0000012816": "个人",
        "P_YS_SCM_STOCK_0000132843": "参照携带定义",
        "P_YS_PF_GZTSYS_0000012812": "待办",
        "P_YS_FED_FW_1581128902296207362": "精确搜",
        "P_YS_FED_FW_0001050401": "展开<%=text%>级",
        "P_YS_FED_IMP_IOT0000007904": "萨嘎县",
        "P_YS_FED_IMP_IOT0000007906": "高邑县",
        "P_YS_FED_IMP_IOT0000007909": "陆河县",
        "P_YS_FED_IMP_IOT0000007900": "管城回族区",
        "P_YS_FED_IMP_IOT0000007902": "茶陵县",
        "P_YS_FED_FW_0001025471": "获取数据失败!",
        "P_YS_FED_FW_0001025472": "未配置模板服务地址或地址配置有误!当前SERVER_ENV为",
        "P_YS_FED_FW_1535286379871207432": "删除方案",
        "P_YS_PF_GZTSYS_0000012800": "客户分类",
        "P_YS_PF_GZTSYS_0000012805": "角色管理",
        "P_YS_FED_FW_0001491879": "复制文本",
        "P_YS_FED_FW_1487292800403243012": "抱歉，保存时出了点小错误，是否重试？",
        "P_YS_SCM_STOCK_0000034385": "当前门店",
        "P_YS_SCM_STOCK_0000034388": "预订信息详情",
        "P_YS_SCM_STOCK_0000034389": "行",
        "country84": "越南",
        "P_YS_FED_FW_0001320413": "，请填写正确！",
        "P_YS_SCM_STOCK_0000034392": "加入购物车",
        "P_YS_SCM_STOCK_0000034395": "扫描优惠券",
        "P_YS_SCM_STOCK_0000034397": "电商订单不允许使用会员储值",
        "P_YS_PF_GZTTMP_0000075261": "开始以",
        "country95": "缅甸",
        "P_YS_FI_AR_0000058973": "订单日期",
        "P_YS_FED_FW_1617786585604947979": "年-月-日 时:分:秒",
        "P_YS_OA_XTMENHUCMS_0000045131": "错误提示",
        "P_YS_FED_FW_1617786585604947976": "年-月-日 时",
        "P_YS_SD_SDMBF_0000141364": "扫码查询",
        "P_YS_SCM_STOCK_0000034363": "生产日期",
        "P_YS_SCM_STOCK_0000034364": "供应商：",
        "P_YS_OA_XTLCZX_0000030196": "附件",
        "P_YS_SCM_STOCK_0000034367": "已收款",
        "P_YS_FED_FW_0001620384": "当前访问的是百度地图API，公网才能访问，专属化环境访问不到",
        "P_YS_FED_IMP_IOT0000011200": "宕昌县",
        "P_YS_FED_FW_1564304845386022921": "查看引用详情",
        "P_YS_FED_FW_0001291470": "二维表第",
        "P_YS_FED_FW_0001573430": "! 重复的control对象为:%o",
        "P_YS_SCM_STOCK_0000132863": "错误信息：",
        "P_YS_FED_IMP_IOT0000011204": "沭阳县",
        "P_YS_FED_IMP_IOT0000011203": "万秀区",
        "P_YS_SCM_STOCK_0000132860": "离线登陆读取缓存数据错误",
        "P_YS_FED_FW_0001573427": "{\\\"1\\\":\\\"年\\\",\\\"2\\\":\\\"月\\\",\\\"6\\\":\\\"天\\\"}",
        "P_YS_FED_FW_0001007612": "导入操作",
        "P_YS_FED_FW_0001573428": "[{\\\"key\\\":\\\"1\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"年\\\"},{\\\"key\\\":\\\"2\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"月\\\"},{\\\"key\\\":\\\"6\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"天\\\"}]",
        "P_YS_FED_FW_0001573429": "获取删除之后的数据",
        "P_YS_SCM_STOCK_0000034372": "当前已处于验货状态!",
        "P_YS_SCM_STOCK_0000034375": "待入库数量和入库数量匹配有差异,请确认是否终止验货并保存?",
        "P_YS_SCM_STOCK_0000034377": "退款金额",
        "P_YS_FED_FW_1500243140406149121": "您好，是否覆盖已存在的用户级列表设置（用户级模板）？",
        "P_YS_FED_IMP_IOT0000011211": "老城区",
        "P_YS_FED_IMP_IOT0000011210": "滦南县",
        "P_YS_FED_IMP_IOT0000011213": "四方台区",
        "P_YS_FED_IMP_IOT0000011212": "城固县",
        "P_YS_FED_FW_0001573431": "[bill-setting] [BillModal] [updateGridModelDataValueByCRefRetId()] 获取参照返回值ERROR:[",
        "P_YS_FED_FW_0001573432": "[bill-setting-new] [BillModal] [updateGridModelDataValueByCRefRetId()] 获取参照返回值ERROR:[",
        "P_YS_FED_FW_0001573433": "%c[bill-setting] [redux billmodal] [mergeDirtyDataInModalDataOriginal()] 重复的cName",
        "P_YS_FED_FW_0001080297": "无可用操作，请先配置业务流",
        "P_YS_SCM_STOCK_0000132853": "门户组件布局",
        "P_YS_FED_FW_0001573434": ",阻止执行",
        "P_YS_FED_FW_0001573435": "渲染表格方法与组件",
        "P_YS_FED_FW_0001573436": "参照缺少必要配置cRefRetId、cRefType",
        "P_YS_FED_FW_0001573437": "获取下标为",
        "P_YS_FED_IMP_IOT0000011216": "拉孜县",
        "P_YS_SCM_STOCK_0000132858": "错误代码：离线登录错误 ==>",
        "P_YS_SCM_STOCK_0000132859": "错误代码：",
        "P_YS_SCM_STOCK_0000034380": "折扣率%",
        "P_YS_FED_FW_1604492734089396228": "暂不支持<%=maxExpendLevel%>级以上的属性穿透",
        "P_YS_OA_XTLCZX_0000030132": "无数据",
        "P_YS_SCM_STOCK_0000034464": "原单折扣额",
        "P_YS_SCM_STOCK_0000034465": "购物车空空如也",
        "P_YS_FED_FW_0001151071": "未获取到domainKey",
        "P_YS_SCM_STOCK_0000034467": "实退价",
        "P_YS_FED_IMP_IOT0000011101": "静海县",
        "P_YS_FED_IMP_IOT0000011103": "西峰区",
        "P_YS_PF_PRINT_0000065417": "供应商名称",
        "P_YS_FED_IMP_IOT0000011108": "义乌市",
        "P_YS_FED_IMP_IOT0000011105": "凉城县",
        "P_YS_FED_IMP_IOT0000011106": "赤城县",
        "P_YS_FED_UCFBASEDOC_0000025614": "手机",
        "ficloud.000550": "无操作权限",
        "P_YS_SCM_STOCK_0000034470": "请输入商品条形码",
        "P_YS_SCM_STOCK_0000034471": "联系电话",
        "P_YS_SCM_STOCK_0000034472": "删除所选",
        "P_YS_FED_FW_0001542394": "您有一份暂存数据，是否载入？",
        "P_YS_SCM_STOCK_0000034473": "预订交款比例不得低于",
        "P_YS_SD_USMP-UI_0001315551": "树形参照",
        "P_YS_SCM_STOCK_0000034475": "选择促销活动",
        "P_YS_SCM_STOCK_0000034476": "单据",
        "P_YS_FED_FW_0001007613": "value 格式错误",
        "P_YS_FED_IMP_IOT0000011112": "玉田县",
        "P_YS_FED_IMP_IOT0000011114": "钟祥市",
        "P_YS_FED_IMP_IOT0000011113": "南雄市",
        "P_YS_OA_XTLCZX_0000030140": "字段名称",
        "P_YS_FED_IMP_IOT0000011118": "南部县",
        "P_YS_FED_UCFBASEDOC_0000025601": "请输入邮箱",
        "P_YS_SCM_STOCK_0000034442": "原销售日期",
        "P_YS_SCM_STOCK_0000034443": "主营业员",
        "P_YS_SCM_STOCK_0000034444": "交货日期",
        "P_YS_OA_XTLCZX_0000030159": "审批时间",
        "P_YS_SCM_STOCK_0000034446": "已选中",
        "P_YS_FED_IMP_IOT0000011120": "崇礼县",
        "P_YS_FED_IMP_IOT0000011127": "介休市",
        "P_YS_FED_FW_1556016546332540933": "刷新搜索",
        "P_YS_FED_IMP_IOT0000011128": "武夷山市",
        "P_YS_OA_XTLCZX_0000030149": "编辑公式",
        "P_YS_SCM_STOCK_0000034450": "希望交货日期",
        "P_YS_SCM_STOCK_0000034451": "可退",
        "P_YS_SCM_STOCK_0000034454": "验证码登录",
        "P_YS_SCM_STOCK_0000034455": "未读",
        "P_YS_SCM_STOCK_0000034456": "退款金额不等于原单该支付方式的金额",
        "P_YS_SCM_STOCK_0000034457": "0积分",
        "P_YS_SCM_STOCK_0000034458": "订金金额",
        "P_YS_FED_IMP_IOT0000011134": "八公山区",
        "P_YS_FED_IMP_IOT0000011133": "盐源县",
        "P_YS_FED_IMP_IOT0000011136": "山城区",
        "P_YS_FED_IMP_IOT0000011135": "大洼县",
        "P_YS_FED_IMP_IOT0000011131": "昭苏县",
        "P_YS_OA_XTMENHUCMS_0000045155": "新闻",
        "P_YS_SCM_STOCK_0000034421": "已收款金额（定金）",
        "P_YS_FED_FW_0000055378": "！！！配置文件中没有列标题，使用bodyItem!define6",
        "P_YS_FED_FW_0000055379": "和小数位数",
        "P_YS_SCM_STOCK_0000034423": "应收",
        "P_YS_FED_FW_0000055376": "所有信息-2维表数据 getRows =",
        "P_YS_SCM_STOCK_0000034424": "请选择营业员！",
        "P_YS_FED_FW_0000055377": "，请确认是否继续?",
        "P_YS_SCM_STOCK_0000034428": "订单时间",
        "P_YS_FED_IMP_IOT0000011147": "江安县",
        "P_YS_FED_IMP_IOT0000011141": "呼玛县",
        "P_YS_FED_IMP_IOT0000011140": "诸暨市",
        "P_YS_FED_IMP_IOT0000011142": "海阳市",
        "P_YS_FED_FW_1576846192821665795": "条数据允许打印，",
        "P_YS_FED_FW_1576846192821665798": "打印确认",
        "P_YS_FED_FW_1576846192821665792": "条数据业务阶段未结束，不允许打印：",
        "P_YS_FED_UIMG_0000025893": "请先将该字段设为显示！",
        "P_YS_FED_UIMG_0000025894": "请先将该字段设为非必输",
        "P_YS_PES_PES-FE_0001104859": "变更说明",
        "P_YS_FED_FW_0000055383": "设置的小数位数为",
        "P_YS_FED_FW_0000055384": "参照名称",
        "P_YS_FED_FW_0000055381": ", groupFields将被置空。",
        "P_YS_FED_FW_0000055382": "不能大于",
        "P_YS_FED_FW_0000055380": "！！！分组信息缺失， 接口返回的groupFields =",
        "P_YS_SCM_STOCK_0000034430": "去结算",
        "P_YS_FED_FW_1545658296411619334": "您好，若用户列表右上角设置了列宽/字段显隐后，便有“用户级设置”，您的模板级设置是否对其覆盖？",
        "P_YS_SCM_STOCK_0000034432": "退货折扣率",
        "P_YS_SCM_STOCK_0000034435": "选择优惠券",
        "P_YS_PLM_GDS-FE_0001096721": "把文件拖入指定区域，完成上传，同样支持点击上传。",
        "P_YS_SCM_STOCK_0000034438": "匹配正确",
        "P_YS_FED_IMP_IOT0000011157": "平定县",
        "P_YS_FED_IMP_IOT0000011151": "户县",
        "P_YS_FED_IMP_IOT0000011154": "汉川市",
        "P_YS_FED_IMP_IOT0000011159": "景谷傣族彝族自治县",
        "P_YS_PF_GZTSYS_0000012907": "核算服务",
        "P_YS_PF_GZTSYS_0000012902": "其它",
        "P_YS_SCM_STOCK_0000034402": "暂不支持混合结算方式退货~",
        "P_YS_SCM_STOCK_0000034404": "销售金额",
        "P_YS_SCM_STOCK_0000034405": "修改预订信息",
        "P_YS_FED_IMP_IOT0000011166": "如皋市",
        "P_YS_FED_IMP_IOT0000011168": "太平区",
        "P_YS_FED_IMP_IOT0000011163": "田家庵区",
        "P_YS_FED_IMP_IOT0000011164": "白水县",
        "P_YS_PF_PRINT_0000065438": "应收件数",
        "P_YS_FED_FW_0001253037": "导出异常",
        "P_YS_FED_FW_0001388904": "全部批改",
        "P_YS_FED_IMP_IOT0000011170": "会东县",
        "P_YS_FED_FW_1535273091242393606": "已参与审批流程的单据不允许删除",
        "P_YS_SCM_STOCK_0000034412": "请录入优惠券。",
        "P_YS_SCM_STOCK_0000034413": "交货时间",
        "P_YS_SCM_STOCK_0000034415": "应收金额不能小于最低订金金额(",
        "P_YS_FED_IMP_IOT0000011178": "焉耆回族自治县",
        "P_YS_SCM_STOCK_0000034418": "切换扫描",
        "P_YS_SCM_STOCK_0000034419": "手动输入条形码",
        "P_YS_FED_IMP_IOT0000011176": "门源回族自治县",
        "P_YS_FED_FW_0000157485": "路由",
        "P_YS_FED_FW_0001157215": "为必输项,请填写!",
        "P_YS_FED_FW_0000157486": "包含controls或者containers字段,只渲染其中一种，containers优先级大于controls",
        "P_YS_FED_IMP_IOT0000011180": "安图县",
        "P_YS_FED_FW_0000157487": "只渲染containers",
        "P_YS_FED_FW_0000157488": "获取state.action",
        "P_YS_FED_IMP_IOT0000011182": "覃塘区",
        "P_YS_FED_FW_0000157482": "图标库",
        "P_YS_FED_FW_0000157483": "<SvgIcon/>支持的icon类型",
        "P_YS_FED_FW_0000157484": "可以有menuId字段",
        "P_YS_FED_IMP_IOT0000011188": "岱山县",
        "P_YS_FED_FW_0000157480": "点击事件",
        "P_YS_FED_FW_0001409434": "显示小计/合计",
        "P_YS_FED_FW_0001409433": "链接文本和地址需同时输入",
        "P_YS_FED_FW_0001409432": "网址格式不正确，请输入正确的网址。(注：网址不能包含中文)",
        "P_YS_FED_IMP_IOT0000011186": "洛龙区",
        "P_YS_FED_FW_0001409431": "合并列",
        "P_YS_FED_FW_0001255676": "请检查icon配置--",
        "P_YS_FED_FW_0000157478": "列数量",
        "P_YS_FI_CM_0000029738": "四月",
        "P_YS_FED_FW_0000157479": "更换图标",
        "P_YS_FED_FW_0000055349": "】存在隐藏必输数据项：",
        "P_YS_FED_IMP_IOT0000011192": "卓资县",
        "P_YS_FED_FW_0000157475": "显示SVG",
        "P_YS_FED_FW_0000055347": "存在隐藏必输数据项：",
        "P_YS_FED_FW_0000157476": "文件类型",
        "P_YS_FED_FW_0000055348": "请求出错",
        "P_YS_FED_FW_0000157477": "显示上传列表",
        "P_YS_SD_SDMA_0000061917": "信息",
        "P_YS_FED_FW_0000055346": "请选择数据",
        "P_YS_FED_IMP_IOT0000011199": "雷山县",
        "P_YS_FI_FP_0000034914": "本年",
        "P_YS_FED_FW_0000055352": "减少[",
        "P_YS_FED_FW_0000055353": "设置的最大长度",
        "P_YS_FED_FW_0000055350": "修改为[",
        "P_YS_FED_FW_0000055351": "(每张图片大小不可超过5M，图片仅支持JPG、PNG、BMP、GIF格式",
        "P_YS_FED_FW_0000055358": "增加[",
        "P_YS_FED_FW_0000055359": "配置文件中没有行标题，使用bodyItem!define5",
        "P_YS_FED_FW_0000055356": "选择数量超过上传限制，请选择上传！",
        "P_YS_FI_CM_0000029752": "ár",
        "P_YS_FED_FW_0000055357": "符合过滤条件的所有记录",
        "P_YS_FED_FW_0000055354": "勾选的",
        "P_YS_FED_FW_0000055355": "所有信息-1维表数据 getRows =",
        "P_YS_FI_YYFI-UI_0001071709": "黑色",
        "P_YS_FED_FW_0000055363": "张)",
        "P_YS_FED_FW_0000055364": "乘[",
        "P_YS_FED_FW_0000055361": "所有信息-2维表初始化数据源 dataSource =",
        "P_YS_FED_FW_0000055362": "所有信息-2维表栏目 columns =",
        "P_YS_FED_FW_0000055360": "，最多可上传",
        "P_YS_FED_IMP_IOT0000005395": "已办结",
        "P_YS_FED_FW_0000157496": "可以包含itemName、menuId、parentItem字段",
        "P_YS_FED_FW_0000157497": "只使用meta.controls[0]",
        "P_YS_FED_FW_0000055369": "所有信息-1维表和2维表行数 1维表行数 =",
        "P_YS_FED_FW_0000055367": "小计(",
        "P_YS_FED_FW_0000157492": "可以包含controls字段",
        "P_YS_FED_FW_0000157493": "browse或者其他",
        "P_YS_FED_FW_0000055368": "重新计算总计 Begin bReCalc =",
        "P_YS_FED_FW_0000055365": "条记录",
        "P_YS_FED_FW_0000157494": "可以有params字段",
        "P_YS_FED_FW_0000157495": "可以包含containers字段",
        "P_YS_FED_FW_0000055366": "重新计算总计 End totalSum =",
        "P_YS_FED_FW_0000157491": "包含itemName、menuId、itemIndex",
        "P_YS_SD_UDHWN_0000047440": "临高县",
        "P_YS_FED_FW_0001297661": "%c捕捉到快捷键：%c",
        "P_YS_FED_FW_0000055374": "您本次要将当前列表",
        "P_YS_FED_FW_0000055375": "全部清空",
        "P_YS_HR_HRRCPDF_0001303021": "仅看已选",
        "P_YS_FED_FW_0000055372": "除[",
        "P_YS_FED_FW_0000055373": ",加上输入数字的长度和小数点,",
        "P_YS_FED_UCFBASEDOC_0000025667": "件",
        "P_YS_FED_FW_0000055370": "名称已超过10个字符！",
        "P_YS_FED_FW_0000157489": "是否展示cShowCaption",
        "P_YS_FED_FW_0000055371": "文件必须小于2M",
        "P_YS_FED_IMP_IOT0000005384": "部门2",
        "P_YS_FED_IMP_IOT0000005385": "部门3",
        "P_YS_FED_IMP_IOT0000005386": "部门1",
        "P_YS_SD_SDMAF_0000137022": "排序规则",
        "P_YS_SD_UDHWN_0000048714": "武清区",
        "P_YS_FED_FW_0001312014": "请您配置行编辑元数据",
        "P_YS_FED_IMP_IOT0000006697": "名山县",
        "P_YS_FED_IMP_IOT0000006696": "如东县",
        "P_YS_FED_IMP_IOT0000006691": "酉阳土家族苗族自治县",
        "P_YS_FED_IMP_IOT0000006690": "翁源县",
        "P_YS_FI_FP_0000034988": "上年",
        "P_YS_OA_XTHUATI_0000046210": "点击加载更多",
        "P_YS_FED_IMP_IOT0000006686": "阳原县",
        "P_YS_FED_IMP_IOT0000006685": "乐至县",
        "P_YS_FED_IMP_IOT0000006687": "社旗县",
        "P_YS_FED_IMP_IOT0000006689": "米林县",
        "P_YS_SD_SDMA_0000039189": "审批状态",
        "P_YS_FED_FW_0001229378": "请选择需要恢复的数据",
        "P_YS_FED_IMP_IOT0000006682": "隆尧县",
        "P_YS_SD_UDHWN_0000048734": "陵水黎族自治县",
        "P_YS_SD_UDHWN_0000047405": "苹果",
        "P_YS_PES_PES-FE_0001108397": "未读信息",
        "P_YS_PES_PES-FE_0001108394": "已读信息",
        "P_YS_FED_IMP_IOT0000006675": "黄岩区",
        "P_YS_FED_IMP_IOT0000006674": "昂仁县",
        "P_YS_FED_IMP_IOT0000006676": "高要市",
        "P_YS_FED_IMP_IOT0000006678": "贞丰县",
        "P_YS_FED_FW_0001097161": "页面中有未保存的数据，点击确定后将关闭页面，是否继续？",
        "P_YS_FED_FW_0001097160": "天（不含当天）的销售数量",
        "P_YS_FED_IMP_IOT0000006671": "太子河区",
        "P_YS_FED_IMP_IOT0000006670": "宁津县",
        "P_YS_FED_IMP_IOT0000006673": "镇坪县",
        "P_YS_FED_IMP_IOT0000006672": "罗庄区",
        "P_YS_FED_FW_1510095451785789446": "展开为悬停按钮",
        "P_YS_HR_HRYG_0000154297": "参数类型错误",
        "P_YS_PF_GZTSYS_0000012776": "模板管理",
        "P_YS_FED_IMP_IOT0000006543": "蜀山区",
        "P_YS_FED_IMP_IOT0000006542": "市北区",
        "P_YS_FED_IMP_IOT0000006545": "西青区",
        "P_YS_FED_IMP_IOT0000007876": "宜章县",
        "P_YS_PF_GZTSYS_0000012772": "供应商",
        "P_YS_FED_IMP_IOT0000007878": "颍州区",
        "P_YS_FED_IMP_IOT0000006546": "五大连池市",
        "P_YS_FED_IMP_IOT0000007877": "红古区",
        "P_YS_FED_IMP_IOT0000006549": "盐山县",
        "P_YS_FED_IMP_IOT0000006548": "美姑县",
        "P_YS_FED_IMP_IOT0000007879": "长宁县",
        "P_YS_FED_IMP_IOT0000007870": "亚东县",
        "P_YS_FED_FW_1510095451785789449": "收起为常驻按钮",
        "P_YS_FED_IMP_IOT0000007871": "鹤山区",
        "P_YS_FED_IMP_IOT0000006531": "渝水区",
        "P_YS_FED_IMP_IOT0000007862": "嵩明县",
        "P_YS_FED_IMP_IOT0000007865": "柞水县",
        "P_YS_PF_GZTSYS_0000012789": "采购合同",
        "P_YS_FED_IMP_IOT0000007864": "阿拉善左旗",
        "P_YS_FED_IMP_IOT0000006536": "磴口县",
        "P_YS_FED_IMP_IOT0000007867": "双辽市",
        "P_YS_FED_IMP_IOT0000006535": "贡觉县",
        "P_YS_FED_IMP_IOT0000007866": "武宣县",
        "P_YS_FED_IMP_IOT0000006538": "灞桥区",
        "P_YS_FED_IMP_IOT0000007869": "迎泽区",
        "P_YS_FED_IMP_IOT0000007861": "锡山区",
        "P_YS_SD_SDMBF_0000143804": "前选择",
        "P_YS_FED_IMP_IOT0000006529": "南明区",
        "P_YS_FED_IMP_IOT0000007851": "上虞市",
        "P_YS_FED_IMP_IOT0000007854": "建阳市",
        "P_YS_FED_IMP_IOT0000007853": "秀洲区",
        "P_YS_PF_GZTSYS_0000012755": "报销",
        "P_YS_FED_IMP_IOT0000006525": "东乡县",
        "P_YS_FED_IMP_IOT0000007855": "海南区",
        "P_YS_FED_IMP_IOT0000006527": "襄阳区",
        "P_YS_FED_IMP_IOT0000007858": "樟树市",
        "P_YS_FED_IMP_IOT0000006526": "瑞安市",
        "P_YS_FED_IMP_IOT0000007857": "遵义县",
        "P_YS_FED_IMP_IOT0000006517": "尖草坪区",
        "P_YS_FED_IMP_IOT0000006519": "宽甸满族自治县",
        "P_YS_FED_IMP_IOT0000007841": "开封县",
        "P_YS_FED_IMP_IOT0000007840": "麻阳苗族自治县",
        "P_YS_FED_IMP_IOT0000006514": "洪江市",
        "P_YS_FED_IMP_IOT0000007845": "吴堡县",
        "P_YS_FED_IMP_IOT0000006516": "南昌县",
        "P_YS_FED_FW_0001193013": "请正确录入以下表头必输字段",
        "P_YS_FED_IMP_IOT0000007838": "柳林县",
        "P_YS_FED_IMP_IOT0000006506": "山阳县",
        "P_YS_PF_GZTPRE_0000071096": "立即执行",
        "P_YS_FED_IMP_IOT0000006508": "三江侗族自治县",
        "P_YS_FED_IMP_IOT0000007839": "南召县",
        "P_YS_HR_HRYG_0000154257": "错误描述",
        "P_YS_OA_XTMENHU_0000046789": "复制成功！",
        "P_YS_FED_IMP_IOT0000006501": "白河县",
        "P_YS_FED_IMP_IOT0000007831": "惠水县",
        "P_YS_FED_IMP_IOT0000006502": "乌什县",
        "P_YS_FED_IMP_IOT0000007833": "鄄城县",
        "P_YS_FED_IMP_IOT0000006505": "平湖市",
        "P_YS_FED_IMP_IOT0000007836": "斗门区",
        "P_YS_FED_IMP_IOT0000006504": "都安瑶族自治县",
        "P_YS_FI_CM_0000029778": "十月",
        "P_YS_FED_IMP_IOT0000007827": "宜川县",
        "P_YS_FED_FW_0001079325": "图形展示",
        "P_YS_FED_IMP_IOT0000007829": "大理市",
        "P_YS_FED_IMP_IOT0000007828": "玛多县",
        "P_YS_FED_FW_0001079326": "列表展示",
        "P_YS_FED_IMP_IOT0000007821": "西湖区",
        "P_YS_FED_IMP_IOT0000007820": "元宝山区",
        "P_YS_FED_IMP_IOT0000007823": "双塔区",
        "P_YS_FED_FW_0001469036": "全选(",
        "P_YS_FED_IMP_IOT0000007822": "丹江口市",
        "P_YS_FED_IMP_IOT0000007824": "阜康市",
        "P_YS_FED_IMP_IOT0000007816": "福山区",
        "P_YS_FED_IMP_IOT0000007815": "宛城区",
        "P_YS_FED_IMP_IOT0000007813": "连山区",
        "P_YS_PF_GZTSYS_0000012795": "职级",
        "P_YS_FED_IMP_IOT0000007805": "阳信县",
        "P_YS_FED_IMP_IOT0000007804": "友谊县",
        "P_YS_FED_IMP_IOT0000007806": "桃江县",
        "P_YS_FED_IMP_IOT0000007808": "涉县",
        "P_YS_FED_IMP_IOT0000007801": "揭西县",
        "P_YS_FED_IMP_IOT0000007802": "云县",
        "P_YS_HR_HRYGF_0000055686": "日历",
        "P_YS_PF_SUPPORT-UI_0001152916": "日期格式",
        "P_YS_FED_FW_0001121379": "请先设置行标题的值",
        "P_YS_FED_FW_0001140573": "]不存在于源表栏目中，请检查",
        "P_YS_PF_GZTSYS_0000012701": "品牌",
        "P_YS_SCM_USTOCK-UI_0000173950": "查看历史日结",
        "P_YS_SD_UDHLIB_0000133325": "开关",
        "P_YS_PF_SOCD-O_0000182693": "初中",
        "P_YS_FED_FW_0001246031": "当前所访问页面已被删除或其他异常，请重新返回列表访问",
        "P_YS_SD_SDMA_0000060490": "删除失败！",
        "P_YS_FED_FW_1458899089362518016": "行子表的",
        "P_YS_FED_FW_1614877844774584320": "草稿箱空空如也",
        "P_YS_FED_FW_0001086504": "模板内未发现有效数据",
        "P_YS_SD_URETAILF_0001130882": "下拉可以刷新",
        "P_YS_HR_HRYGF_0000055671": "请输入姓名",
        "P_YS_FED_FW_0001025574": "输入的数字的最大长度不能大于",
        "P_YS_PF_SOCD_0000154844": "军官证",
        "P_YS_FED_FW_1463414594656534528": "地图请求出现错误",
        "P_YS_PF_GZTSYS_0000012731": "编码规则",
        "P_YS_PF_GZTSYS_0000012736": "支付方式",
        "P_YS_PES_PES-UI_0001234764": "数据表格",
        "P_YS_FED_FW_1467090828949192704": "输入长度超出限制：中文最多10个汉字，英文最多20个字母",
        "P_YS_PF_GZTSYS_0000012745": "自定义档案",
        "P_YS_SCM_STOCK_0000034485": "选规格",
        "P_YS_SCM_STOCK_0000034487": "找零金额超出限制，最大找零为",
        "P_YS_SCM_STOCK_0000034490": "错误数量",
        "P_YS_SCM_STOCK_0000034493": "不可用的券",
        "P_YS_SCM_STOCK_0000034495": "折扣率",
        "P_YS_PF_SOCD_0000154855": "美元",
        "P_YS_SCM_STOCK_0000034497": "删除\bDB数据库",
        "P_YS_SCM_STOCK_0000034498": "扫描条形码",
        "P_YS_SCM_STOCK_0000034585": "商品金额",
        "P_YS_SCM_STOCK_0000034586": "联查原单",
        "P_YS_FED_FW_1575188275308527622": "“非空”或“为空”类型条件不允许清除，请点击“高级”进入弹窗中操作",
        "P_YS_PF_PC-UI_0001072138": "显示项，不用输入",
        "P_YS_OA_XTLCZX_0000030265": "加载中",
        "P_YS_SCM_STOCK_0000034595": "暂无优惠券，请手动添加～",
        "P_YS_SCM_STOCK_0000034596": "暂无可选客户",
        "ficloud.000415": "暂不支持",
        "P_YS_SCM_STOCK_0000034599": "已扫描过该序列号[",
        "P_YS_SCM_STOCK_0000034564": "交货仓库",
        "P_YS_SCM_STOCK_0000034569": "，余额不足。",
        "P_YS_FED_IMP_IOT0000011003": "碑林区",
        "P_YS_FED_IMP_IOT0000011000": "民丰县",
        "P_YS_FED_FW_1483255496785264644": "字段触发check，check前值为:",
        "P_YS_FED_IMP_IOT0000011009": "铁岭县",
        "P_YS_FED_IMP_IOT0000011006": "厦门",
        "P_YS_FED_IMP_IOT0000011007": "金口河区",
        "P_YS_FED_UCFBASEDOC_0000025713": "请输入角色编码",
        "P_YS_SD_UDHWN_0000048808": "文山市",
        "P_YS_FED_FW_0001301257": "以下表头字段有误",
        "P_YS_SCM_STOCK_0000034570": "超待入库数量",
        "P_YS_SCM_STOCK_0000034572": "请输入验证码！",
        "P_YS_SCM_STOCK_0000034573": "确定全部标为已读吗？",
        "P_YS_SCM_STOCK_0000034574": "优惠合计",
        "P_YS_OA_XTLCZX_0000030284": "保密期限",
        "P_YS_SCM_STOCK_0000034579": "单据日期：",
        "P_YS_OA_XTLCZX_0000030288": "加载更多",
        "P_YS_FED_IMP_IOT0000011015": "屯溪区",
        "P_YS_FED_IMP_IOT0000011014": "壤塘县",
        "P_YS_FED_FW_1510116436995997696": "文本长度不允许为负值，请修改",
        "P_YS_FED_FW_1510116436995997699": "数字精度不允许为负值，请修改",
        "P_YS_FED_UCFBASEDOC_0000025709": "項目",
        "P_YS_FED_IMP_IOT0000011016": "日喀则市",
        "P_YS_FED_IMP_IOT0000011018": "潮南区",
        "P_YS_FED_UCFBASEDOC_0000025703": "对象",
        "P_YS_SCM_STOCK_0000034581": "错误原因",
        "P_YS_SCM_STOCK_0000034582": "请输入或扫描优惠券",
        "P_YS_SCM_STOCK_0000034545": "参数不全",
        "P_YS_FED_IMP_IOT0000011020": "涪陵区",
        "P_YS_FED_IMP_IOT0000011022": "桦甸市",
        "P_YS_FED_IMP_IOT0000011028": "友好区",
        "P_YS_FED_IMP_IOT0000011027": "元氏县",
        "P_YS_OA_XTLCZX_0000030206": "隐藏",
        "P_YS_FED_FW_1550175803122122759": "不合法信息提示（禁止下一步）",
        "P_YS_SCM_STOCK_0000034550": "退款明细",
        "P_YS_SCM_STOCK_0000034551": "正在开发中...",
        "P_YS_HR_HRSSC_0000135746": "标题为空",
        "P_YS_SCM_STOCK_0000034554": "关灯",
        "P_YS_FED_FW_1488664372439416833": "无图片ds",
        "P_YS_SCM_STOCK_0000034555": "选择账号",
        "P_YS_OA_XTLCZX_0000030224": "必填",
        "P_YS_SCM_STOCK_0000034557": "联系人",
        "P_YS_FED_FW_1550175803122122762": "预警信息提示",
        "P_YS_SCM_STOCK_0000034559": "你确定要放弃结算吗?",
        "P_YS_FED_IMP_IOT0000011034": "沁县",
        "P_YS_FED_FW_1483255496785264650": "。两个值不一样会再次触发check。请保持一样。",
        "P_YS_FED_IMP_IOT0000011037": "芦山县",
        "P_YS_FED_IMP_IOT0000011031": "镇雄县",
        "P_YS_FED_FW_1483255496785264653": ", check后值为:",
        "P_YS_FED_FW_1483255496785264647": "%c updateRows新旧值不一样会触发公式.. >>>target =>旧值 =>新值 => updateRows Params",
        "P_YS_FED_IMP_IOT0000011039": "阿克塞哈萨克族自治县",
        "P_YS_FED_IMP_IOT0000011038": "张家川回族自治县",
        "P_YS_PF_PRINT_0000065582": "需求日期",
        "P_YS_SCM_STOCK_0000034523": "已读",
        "P_YS_SCM_STOCK_0000034525": "收银员",
        "P_YS_FED_IMP_IOT0000011045": "宁晋县",
        "P_YS_SCM_STOCK_0000034529": "匹配到多个商品",
        "P_YS_FED_IMP_IOT0000011044": "府谷县",
        "P_YS_FED_IMP_IOT0000011043": "舞阳县",
        "P_YS_PF_GZTSYS_0000108857": "失败原因：",
        "P_YS_SCM_USTOCK-UI_0001077879": "显示项，不需要输入",
        "P_YS_OA_XTLCZX_0000030242": "主表",
        "P_YS_SCM_STOCK_0000034530": "修改单据信息",
        "P_YS_SCM_STOCK_0000034531": "制单时间",
        "P_YS_FED_IMP_IOT0000011050": "拱墅区",
        "P_YS_SCM_STOCK_0000034533": "收货地址",
        "P_YS_FED_FW_1461189750035054592": "日历天数",
        "P_YS_FED_IMP_IOT0000011057": "库车县",
        "P_YS_SCM_STOCK_0000034538": "开单-预订",
        "P_YS_FED_IMP_IOT0000011053": "岳西县",
        "P_YS_OA_XTLCZX_0000030239": "选项",
        "P_YS_FED_FW_0001159999": "前7周",
        "P_YS_FED_IMP_IOT0000011060": "寿县",
        "P_YS_FED_FW_0001159998": "第七周",
        "P_YS_FED_FW_0001159997": "派送业务员",
        "P_YS_FED_FW_0001159996": "以下数据项校验失败：'",
        "P_YS_FED_IMP_IOT0000011061": "余杭区",
        "P_YS_SCM_STOCK_0000034501": "账号",
        "P_YS_FED_IMP_IOT0000011068": "尚志市",
        "P_YS_SCM_STOCK_0000034504": "清空全部",
        "P_YS_FED_IMP_IOT0000011067": "射洪县",
        "P_YS_FED_IMP_IOT0000011064": "晋源区",
        "P_YS_FED_IMP_IOT0000011066": "正镶白旗",
        "P_YS_FED_IMP_IOT0000011071": "会泽县",
        "P_YS_FED_IMP_IOT0000011070": "曲阳县",
        "P_YS_FED_FW_0001265118": "正在保存，请稍后",
        "P_YS_FED_FW_0001265119": "异步保存超时",
        "P_YS_SCM_STOCK_0000034513": "选择退货单",
        "P_YS_FED_FW_0001567737": "无图片",
        "P_YS_SCM_STOCK_0000034514": "立即加入",
        "P_YS_FED_IMP_IOT0000011079": "盐池县",
        "P_YS_FED_IMP_IOT0000011078": "巴林右旗",
        "P_YS_SCM_STOCK_0000034518": "至少选择一种结算方式",
        "P_YS_FED_IMP_IOT0000011075": "北道区",
        "P_YS_FED_IMP_IOT0000011077": "清水河县",
        "P_YS_FED_IMP_IOT0000011076": "双柏县",
        "P_YS_FI_CM_0000029869": "请选择日期",
        "P_YS_FED_IMP_IOT0000011082": "盘县",
        "P_YS_FED_IMP_IOT0000011081": "双清区",
        "P_YS_FED_IMP_IOT0000011084": "米泉市",
        "P_YS_FI_CM_0000029876": "YYYY年",
        "P_YS_PF_QITDFE_0000113168": "失败原因",
        "P_YS_FED_IMP_IOT0000011088": "南郑县",
        "P_YS_PF_PRINT_0000065599": "组号",
        "P_YS_FED_UIMG_0001156156": "多语文本",
        "P_YS_HR_HRXC_0000177247": "最新版本",
        "P_YS_FED_IMP_IOT0000011091": "建水县",
        "P_YS_FED_IMP_IOT0000011090": "祁东县",
        "P_YS_FED_FW_1431429243042529280": "以下字段有误，请正确输入一下必填字段",
        "P_YS_FED_FW_0001253130": "地址不合法",
        "P_YS_PF_PROCENTER_0001131739": "UI模板",
        "P_YS_FED_IMP_IOT0000011099": "杏花岭区",
        "P_YS_FED_IMP_IOT0000006598": "东风区",
        "P_YS_FED_IMP_IOT0000006597": "岚县",
        "P_YS_FED_IMP_IOT0000006599": "噶尔县",
        "P_YS_FED_IMP_IOT0000006592": "梨树区",
        "P_YS_FED_IMP_IOT0000006591": "临西县",
        "P_YS_FED_IMP_IOT0000006594": "武都区",
        "P_YS_FED_IMP_IOT0000006595": "阿巴嘎旗",
        "P_YS_PF_PRINT_0000106529": "打印模版",
        "P_YS_FI_CM_0000029811": "请选择时间",
        "P_YS_FED_FW_0001097273": "没找到子表",
        "P_YS_FED_FW_0001097272": "没有关联gridmodel",
        "P_YS_FED_IMP_IOT0000006583": "铁锋区",
        "P_YS_FED_IMP_IOT0000006582": "贡嘎县",
        "P_YS_FED_IMP_IOT0000006584": "刪除成功",
        "P_YS_FED_IMP_IOT0000006577": "宁陵县",
        "P_YS_FED_IMP_IOT0000006579": "藤县",
        "P_YS_FED_FW_1549253106706939908": "网络开小差了，刷新试试吧~",
        "P_YS_FED_IMP_IOT0000006574": "札达县",
        "P_YS_FED_IMP_IOT0000006567": "越城区",
        "P_YS_FED_IMP_IOT0000007898": "万州区",
        "P_YS_FED_IMP_IOT0000007897": "宝兴县",
        "P_YS_FED_IMP_IOT0000006569": "八道江区",
        "P_YS_FED_IMP_IOT0000007899": "金家庄区",
        "P_YS_FED_IMP_IOT0000006561": "龙港区",
        "P_YS_FED_IMP_IOT0000006562": "万柏林区",
        "P_YS_FED_IMP_IOT0000007893": "北关区",
        "P_YS_FED_IMP_IOT0000007884": "林州市",
        "P_YS_FED_IMP_IOT0000006556": "榕江县",
        "P_YS_FED_IMP_IOT0000007887": "涧西区",
        "P_YS_FED_IMP_IOT0000007886": "杞县",
        "P_YS_FED_IMP_IOT0000006559": "头屯河区",
        "P_YS_FED_IMP_IOT0000006551": "田林县",
        "P_YS_FED_IMP_IOT0000007882": "京山县",
        "P_YS_FED_IMP_IOT0000006429": "卓尼县",
        "P_YS_FED_FW_0000020988": "详情",
        "P_YS_PF_GZTSYS_0000012655": "数据权限",
        "P_YS_FED_FW_0000020987": "二",
        "P_YS_FED_IMP_IOT0000006424": "兰考县",
        "P_YS_FED_IMP_IOT0000007755": "莱州市",
        "P_YS_FED_FW_0000020989": "确定要放弃当前修改吗？",
        "P_YS_FED_IMP_IOT0000006423": "喜德县",
        "P_YS_FED_IMP_IOT0000006426": "丹徒区",
        "P_YS_FED_IMP_IOT0000007757": "万全县",
        "P_YS_FED_IMP_IOT0000006425": "鹤城区",
        "P_YS_FED_FW_0001608880": "%c[mdf-cube] [staterule] [rule] parseCondition(), 无条件直接执行",
        "P_YS_FED_IMP_IOT0000006428": "滕州市",
        "P_YS_FED_IMP_IOT0000007759": "胶州市",
        "P_YS_FED_FW_0001608881": "%c是否反转：",
        "P_YS_FED_IMP_IOT0000006427": "泉港区",
        "P_YS_FED_FW_0001608882": "%c[mdf-cube] [staterule] [rule] runRule(), 执行交互规则事件监听：",
        "P_YS_FED_FW_0000020980": "条, 其中成功",
        "P_YS_FED_FW_0000020982": "成功",
        "P_YS_FED_FW_0000020984": "文本",
        "P_YS_FED_FW_0000020983": "未作任何修改",
        "P_YS_FED_FW_0000020986": "请选择一条数据",
        "P_YS_FED_FW_0000020985": "星期日",
        "P_YS_PF_GZTSYS_0001106485": "事件查询",
        "P_YS_FED_IMP_IOT0000007750": "泗阳县",
        "P_YS_PF_GZTSYS_0000012671": "计量单位",
        "P_YS_PF_GZTSYS_0000012670": "企业信息",
        "P_YS_PF_PRINT_0000057241": "本币无税单价",
        "P_YS_FED_FW_0000055626": "必输字段不允许隐藏",
        "P_YS_FED_FW_0000020999": "星期三",
        "P_YS_FED_IMP_IOT0000006411": "乌当区",
        "P_YS_FED_IMP_IOT0000007742": "云安县",
        "P_YS_FED_FW_0001608872": "%c[mdf-cube] [staterule] [rule] runRule(), 给以下字段/表格绑定事件：",
        "P_YS_FED_FW_0001608873": "%c前端主动执行公式>>> ==>rules ==>targets",
        "P_YS_FED_IMP_IOT0000007744": "凯里市",
        "P_YS_FED_IMP_IOT0000006413": "罗平县",
        "P_YS_PF_GZTSYS_0000012668": "授权",
        "P_YS_FED_FW_0001608874": "%c[mdf-cube] [staterule] [rule] showModal(), the parameter target==>, property=>, value==>, rule===> 弹出框：",
        "P_YS_FED_FW_0001608875": "%c>> 交互规则过滤出表格actions",
        "P_YS_FED_IMP_IOT0000006415": "泸西县",
        "P_YS_FED_IMP_IOT0000007746": "泾川县",
        "P_YS_FED_IMP_IOT0000007745": "河曲县",
        "P_YS_FED_FW_1498007515453456390": "值改变搜索：",
        "P_YS_FED_IMP_IOT0000006417": "大通回族土族自治县",
        "P_YS_FED_FW_0001608870": "%c[mdf-cube] [staterule] [rule] parseExprsCondtion(), 条件验证多列表格：",
        "P_YS_FED_IMP_IOT0000006416": "界首市",
        "P_YS_FED_IMP_IOT0000007747": "临泽县",
        "P_YS_FED_FW_0001608871": "%c[mdf-cube] [staterule] [rule] runActionGroup(), 解析单个rule所有动作的条件：",
        "P_YS_FED_FW_0000020991": "五",
        "P_YS_FED_FW_1498007515453456393": "手动搜索：",
        "P_YS_FED_FW_0000020990": "确定要删除么",
        "P_YS_FED_FW_0000020993": "刷新缓存成功",
        "P_YS_FED_FW_0000020992": "以下数据项校验失败：",
        "P_YS_FED_FW_1498007515453456396": "当搜索条件改变后，不会立即查询，需要手动点击 [搜索]",
        "P_YS_FED_FW_0000020995": "分类已是同级次的最后一个",
        "P_YS_FED_FW_0001608876": "%c[mdf-cube] [staterule] [rule] setGroupMeta(), the parameter target==>, property=>, value==> 设置容器：",
        "P_YS_FED_FW_0000020994": "整型",
        "P_YS_FED_FW_0001608877": "%c页面规则>>> rules => 执行方式 => 来源 =>",
        "P_YS_FED_FW_0000020997": "获取权限列表失败--",
        "P_YS_FED_IMP_IOT0000007740": "启东市",
        "P_YS_FED_FW_0001608878": "%c[mdf-cube] [staterule] [rule] runRule(), 执行交互规则事件监听 条件返回结果：",
        "P_YS_FED_FW_1498007515453456399": "当查询条件值改变后，立即触发搜索",
        "P_YS_FED_FW_0000020996": "及其子",
        "P_YS_FED_FW_0001608879": "%c[mdf-cube] [staterule] [rule] runRule(), 绑定：",
        "P_YS_FED_IMP_IOT0000006408": "屏山县",
        "P_YS_FED_IMP_IOT0000007739": "黎川县",
        "P_YS_FED_IMP_IOT0000006407": "港南区",
        "P_YS_FED_IMP_IOT0000006409": "商水县",
        "P_YS_FED_FW_0000020965": "条",
        "P_YS_FED_FW_0001608862": "%c执行动作 start time：",
        "P_YS_FED_FW_0000020968": "周",
        "P_YS_FED_IMP_IOT0000006402": "睢县",
        "P_YS_FED_FW_0001608863": "%c公式解析失败>>",
        "P_YS_FED_FW_0000020967": "未找到具体单据",
        "P_YS_FED_FW_0001608864": "%c执行动作 end time：",
        "P_YS_FED_IMP_IOT0000006404": "东区",
        "P_YS_FED_IMP_IOT0000007735": "扶沟县",
        "P_YS_FED_FW_0000020969": "表单自定义项升级成功",
        "P_YS_FED_IMP_IOT0000006403": "文安县",
        "P_YS_FED_IMP_IOT0000006406": "请输入联系方式",
        "P_YS_PF_GZTSYS_0000012631": "交易类型",
        "P_YS_FED_IMP_IOT0000007736": "香河县",
        "P_YS_FED_FW_0001608869": "%c[mdf-cube] [staterule] [rule] runRule(), 解析所有rules条件：",
        "P_YS_FED_FW_0000020960": "，是否继续？",
        "P_YS_FED_FW_0000020962": "简体中文",
        "P_YS_FED_FW_0001608865": "%c调用后端计算接口获取到值 /bill/executeFormulaCalculate：",
        "P_YS_PF_PROCENTER_0000027569": "打印预览",
        "P_YS_FED_FW_0000020961": "保存成功",
        "P_YS_FED_FW_0001608866": "%c[mdf-cube] [staterule] [rule] setValue(), the parameter target==>, value==> 赋值：",
        "P_YS_FED_FW_0000020964": "请预置打印按钮的cParameter信息{printTplItemName : 打印模板的cItemName}",
        "P_YS_FED_FW_0001608867": "%c[mdf-cube] [staterule] [rule] compareJSON(), JSON串左右不匹配：",
        "P_YS_FED_FW_0000020963": "模板内容导入返回信息： xhr.readyState =",
        "P_YS_FED_FW_0001608868": "%c[mdf-cube] [staterule] [rule] setMeta(), the parameter target==>, property=>, value==> 设置属性：",
        "P_YS_PF_PROCENTER_0000027553": "提示",
        "P_YS_FED_IMP_IOT0000007728": "向阳区",
        "P_YS_PF_MANAGER-FE_0001087905": "标签模式",
        "P_YS_FED_IMP_IOT0000007727": "导出",
        "P_YS_PF_QITDFE_0001085652": "组织树",
        "P_YS_FED_FW_0000020977": "请输入作废理由",
        "P_YS_FED_FW_0000020976": "请选择打印模板。",
        "P_YS_FED_FW_0000020978": "直接打印插件启动异常，如需帮助请点击确认！",
        "P_YS_FED_IMP_IOT0000007723": "靖州苗族侗族自治县",
        "P_YS_PF_GZTSYS_0000012642": "供应商分类",
        "P_YS_FED_IMP_IOT0000007725": "北碚区",
        "P_YS_FED_FW_0000020971": "模板内容导入失败，",
        "P_YS_FED_FW_0000020970": "六",
        "P_YS_FED_FW_0000020973": "不能为空",
        "P_YS_FED_FW_0000020972": "星期四",
        "P_YS_FED_FW_0000020975": "获取单据编码规则错误:",
        "P_YS_FED_FW_0000020974": "请求数据失败",
        "P_YS_SD_SDMAUF_0001023417": "永川市",
        "P_YS_FED_IMP_IOT0000007717": "林西县",
        "P_YS_SD_SDMAUF_0001023413": "铜仁地区",
        "P_YS_PF_PRINT_0000057278": "自定义项5",
        "P_YS_FED_IMP_IOT0000007716": "朝阳县",
        "P_YS_PF_PRINT_0000057281": "自定义项4",
        "P_YS_FED_IMP_IOT0000007714": "望谟县",
        "P_YS_FED_FW_0001473890": "UI模板:",
        "P_YS_FED_FW_0001447586": "共选中数据",
        "P_YS_PF_PRINT_0000057288": "自定义项1",
        "P_YS_PF_PRINT_0000057286": "自定义项6",
        "P_YS_PF_PRINT_0000057283": "自定义项7",
        "P_YS_PF_PRINT_0000057293": "自定义项2",
        "P_YS_PF_PRINT_0000057291": "自定义项3",
        "P_YS_FED_IMP_IOT0000007700": "纳溪区",
        "P_YS_FED_IMP_IOT0000007702": "连平县",
        "P_YS_FED_IMP_IOT0000007704": "绵竹市",
        "P_YS_SD_SDMB-FE_0001535210": "渲染异常。可通过控制台查看异常信息。 comInfo =",
        "P_YS_FED_FW_0001235097": "缺少settingNavBar方法",
        "P_YS_SD_SDMBF_0000143729": "高级筛选",
        "P_YS_PF_PRINT_0000057259": "销售类型汇总",
        "P_YS_PF_GZTSYS_0000012680": "供应商档案",
        "end": "已完成",
        "P_YS_HR_HRRCPDF_0001077675": "已选(",
        "P_YS_PF_GZTSYS_0000012689": "数据分析",
        "P_YS_PF_GZTSYS_0000012684": "结算方式",
        "P_YS_SCM_STOCK_0000034188": "商品行入库数量与序列号数量不一致，请检查！",
        "P_YS_SCM_STOCK_0000034189": "优惠券金额将超出应收金额，是否继续？",
        "P_YS_FED_FW_0000122939": "未获取到行号",
        "P_YS_HR_HRJXF_0000059283": "进度条",
        "HR": "人力",
        "P_YS_FED_FW_0001191808": "缺少mdfChangeCustomScanMode方法",
        "P_YS_FED_FW_0001191809": "缺少mdfCustomScanQRCode方法",
        "P_YS_FED_FW_1482770783956107324": "文本编辑栏目",
        "P_YS_PF_PROCENTER_0000022730": "女",
        "P_YS_SCM_STOCK_0000034195": "预订单",
        "P_YS_SCM_STOCK_0000034197": "不支持移动端退货，请在PC端操作",
        "P_YS_SCM_STOCK_0000034198": "未收金额",
        "P_YS_FED_FW_0000020919": "一",
        "P_YS_FED_FW_0000020918": "√",
        "P_YS_FED_FW_1603072749183959045": "标签一",
        "P_YS_FED_FW_0001191810": "缺少mdfChangeFlashLightStatus方法",
        "P_YS_FED_FW_0000020917": "确认",
        "P_YS_FED_FW_0001191811": "扫码成功结果",
        "P_YS_FED_FW_1603072749183959042": "标签二",
        "P_YS_SCM_STOCK_0000034166": "客单价",
        "P_YS_SCM_STOCK_0000034167": "请输入条形码",
        "000357": "删除文件",
        "P_YS_PF_GZTTMP_0000077606": "物流信息",
        "P_YS_FED_FW_0000097427": "getMeasureValues没有在一维表找到 t2DRowKey =",
        "P_YS_FED_FW_0000097426": "二维表行列变化异常，没有列类型t2DColType。data=",
        "P_YS_FED_FW_0000097425": "在一维表中发现多行符合当前交叉点行列键值的数据 t2DRowKey =",
        "P_YS_FED_FW_0000097423": "初始化没有找到一维表editRowModel或者editRowModel中没找到物料Model或者物料Model类型不是ReferModel",
        "P_YS_SCM_STOCK_0000034171": "成功添加一件商品",
        "P_YS_FI_IA_0000054929": "单据类型",
        "P_YS_FED_FW_0000097420": "table2DRowColChange 一维表当前index =",
        "P_YS_FED_FW_0000110980": "存在重复行。信息如下 code=",
        "P_YS_SCM_STOCK_0000034175": "联系人手机",
        "P_YS_FED_FW_1536786757976588288": "销售合同-即时分析",
        "P_YS_FED_FW_1601623034510704640": "数据校验发生异常,请联系支持人员排查\\n",
        "P_YS_FED_FW_0000097418": "所有信息-二维表栏目 columns =",
        "P_YS_FED_FW_0000097417": "一维表存在行键值为空的行。 一维表所有行  =",
        "P_YS_FED_FW_0000097416": "一维表存在行键值为空的行。 空行 =",
        "P_YS_SCM_STOCK_0000034182": "批号",
        "P_YS_SCM_STOCK_0000034183": "原销售价",
        "P_YS_FED_FW_1588021594661322759": "请选择要导出的数据",
        "P_YS_FED_FW_0001200368": "已扫(",
        "P_YS_PF_PRINT_0000065739": "物料sku编码",
        "P_YS_FED_FW_0000020944": "确定要放弃么",
        "P_YS_FED_FW_0000020943": "模板内容导入失败",
        "P_YS_FED_FW_0000020946": "星期五",
        "P_YS_FED_FW_0000020945": "条,失败",
        "P_YS_FED_FW_0000020948": "单次最大导出2000条,请重新选择后重试！",
        "P_YS_FED_FW_0000020947": "单据联查结果显示",
        "P_YS_FED_FW_0000020949": "繁体中文",
        "P_YS_FED_FW_0000020940": "分类最多",
        "P_YS_FED_FW_0000020941": "共导入",
        "P_YS_FED_FW_0000020955": "停用",
        "P_YS_FED_FW_0000020954": "接口返回格式不是application/json格式：",
        "P_YS_FED_FW_0000020957": "档案",
        "P_YS_FED_FW_0000020956": "么",
        "P_YS_FED_FW_0000020959": "没有取到保存参数",
        "P_YS_FED_FW_0000020958": "设置单据编码规则错误:",
        "P_YS_PES_PES-FE_0001193111": "清空已选",
        "P_YS_SD_SDSD-FE_0001491730": "數量",
        "P_YS_FED_FW_0000020951": "请选择打印模板",
        "P_YS_FED_FW_0000020950": "是否确认停用此记录",
        "P_YS_SD_SDMA_0000061679": "商城",
        "P_YS_FED_FW_0001212374": "该单据已经被删除或者没有权限",
        "P_YS_FED_FW_1529944651755683856": "默认枚举值",
        "P_YS_PF_METADATA_0001044255": "确认状态",
        "P_YS_FED_FW_1529944651755683853": "枚举项最多可选五个！",
        "P_YS_FED_FW_0000020929": "出错啦后台->",
        "P_YS_FED_FW_1529944651755683850": "请选择枚举日期项！",
        "P_YS_FED_FW_0000020922": "审批流初始化成功",
        "P_YS_FED_FW_0000020921": "数据量较大，预览可能比较慢，是否使用打印插件，是否直接静默打印",
        "P_YS_FED_FW_0000020924": "请预置打印按钮的cParameter信息 { printTplItemName : 打印模板的cItemName}",
        "P_YS_FED_FW_0000020923": "条, 成功",
        "P_YS_FED_FW_0000020926": "三",
        "P_YS_FED_FW_0000020925": "合并请求提交失败:",
        "P_YS_PF_PROCENTER_0000022757": "财务",
        "P_YS_FED_FW_0001656543": "请选择或录入",
        "P_YS_FED_FW_0000020927": "导入已转入后台处理，可进行其它操作！",
        "P_YS_FED_FW_0000020920": "星期六",
        "P_YS_FED_FW_1529944651755683847": "常用枚举项",
        "P_YS_FED_FW_0000020933": "请先提交",
        "P_YS_FED_FW_0000020932": "导出模板的地址为空",
        "P_YS_FED_FW_0000020935": "失败",
        "P_YS_FED_FW_0000020934": "分类已是同级次的第一个",
        "P_YS_FED_FW_0000020937": "星期二",
        "P_YS_FED_FW_0000020936": "未选择数据，请选择数据后重试！",
        "P_YS_FED_FW_0000020939": "保存业务对象成功",
        "P_YS_FED_FW_0000020938": ",返回信息：",
        "P_YS_FED_FW_0000020930": "保存出错",
        "P_YS_SCM_STOCK_0000034222": "退货折扣额",
        "P_YS_SCM_STOCK_0000034225": "扫码支付",
        "P_YS_OA_XTHUIYI_0000046356": "选项 2",
        "P_YS_PF_GZTTMP_0000076264": "对账",
        "P_YS_OA_XTHUIYI_0000046353": "选项 1",
        "P_YS_OA_XTHUIYI_0000046352": "选项 6",
        "P_YS_OA_XTHUIYI_0000046355": "选项 3",
        "P_YS_HR_HRJXF_0001080015": "取值方式",
        "P_YS_OA_XTHUIYI_0000046351": "选项 4",
        "P_YS_SCM_STOCK_0000034231": "未识别到该商品",
        "P_YS_SCM_STOCK_0000034232": "请选择操作员！",
        "P_YS_SCM_STOCK_0000034234": "推送时间",
        "P_YS_SCM_STOCK_0000034235": "未选中任何规格！",
        "P_YS_SCM_STOCK_0000034238": "总计",
        "P_YS_SD_UDHWN_0001010199": "%s内",
        "P_YS_FED_FW_0001049265": "{value} 星",
        "P_YS_SCM_PU_0000028093": "已审核",
        "P_YS_SCM_STOCK_0000034202": "开灯",
        "P_YS_SCM_STOCK_0000034208": "改折扣率",
        "P_YS_FI_FA_0000033394": "方案名称",
        "P_YS_SCM_STOCK_0000034214": "折后金额",
        "P_YS_SCM_STOCK_0000034216": "有效期至",
        "P_YS_FI_CM_0000029922": "ден",
        "P_YS_FED_FW_0001201615": "存在必输项:",
        "P_YS_FED_FW_1587131084714803208": "范围值精度不允许超过15，请修改",
        "P_YS_FED_FW_0001202951": "页面中有未保存的数据，点击确定后将清除数据并重启页面，确定继续？",
        "P_YS_SD_SDMAF_0000135935": "加载",
        "P_YS_FED_FW_1498007515453456402": "若预置方案中没有您想要的条件，可以自定义过滤条件",
        "P_YS_FED_FW_1498007515453456405": "选择该查询条件的所在位置",
        "P_YS_SD_SDMAF_0000135940": "请输入日期",
        "P_YS_FED_FW_1618507375587098631": "没有code或name",
        "P_YS_OA_app_xtywlj_0000037814": "预测",
        "P_YS_OA_XTHUIYI_0000046348": "选项 5",
        "P_YS_FED_FW_0001256796": "默认全部",
        "P_YS_FED_FW_0001382541": "移动方案(仅移动端生效)",
        "P_YS_FED_FW_0001382542": "Web个人方案",
        "P_YS_FED_FW_0001382543": "移动公共方案",
        "P_YS_FED_FW_0001382544": "Web方案",
        "P_YS_FED_FW_0001382540": "Web公共方案",
        "P_YS_FED_FW_0001382545": "移动个人方案",
        "P_YS_FED_UCFBASEDOC_0000025456": "出库",
        "P_YS_FED_FW_0000080521": "分组信息缺失，默认为 product product_cCode product_cName",
        "P_YS_FED_FW_0000080522": "分组信息缺失， 接口返回的groupFields =",
        "P_YS_FED_FW_0000080520": "供应商档案模版.xlsx",
        "P_YS_FED_FW_0001147663": "请求模板失败：",
        "P_YS_FED_FW_0001147664": "返回了异常值",
        "P_YS_SD_UDHWN_0001010118": "几秒",
        "P_YS_FED_IMP_IOT0000006491": "若尔盖县",
        "P_YS_FED_IMP_IOT0000006493": "皮山县",
        "P_YS_FED_UCFBASEDOC_0000025448": "重发",
        "P_YS_FED_IMP_IOT0000006492": "山阴县",
        "P_YS_FED_FW_1441618872572051456": "%未找到对应页签",
        "P_YS_FED_FW_1575378258895044792": "您好，1.“增加”按钮不支持表体“多行”数据取值；2，“增加”按钮预计于2022.12.30切换为“公式”，请使用高级设计器设置，如：“高级设计器-字段设置”、“高级设计器-公式”。",
        "P_YS_FED_IMP_IOT0000006487": "安定区",
        "P_YS_FED_IMP_IOT0000006489": "石屏县",
        "P_YS_FED_IMP_IOT0000006480": "翠屏区",
        "P_YS_FED_IMP_IOT0000006482": "遂平县",
        "P_YS_FED_IMP_IOT0000006483": "冷水滩区",
        "P_YS_FED_UCFBASEDOC_0000025433": "打印",
        "P_YS_FED_IMP_IOT0000006486": "长乐市",
        "P_YS_FED_IMP_IOT0000006485": "新泰市",
        "P_YS_FED_FW_0001428307": "单据将被撤回为开立态，确定要撤回单据吗？",
        "P_YS_SD_UDHWN_0000120920": "切换语言",
        "P_YS_FED_IMP_IOT0000006479": "丰泽区",
        "P_YS_FI_CM_0000026019": "】",
        "P_YS_FI_CM_0000026016": "【",
        "P_YS_FED_IMP_IOT0000006471": "石阡县",
        "P_YS_FED_IMP_IOT0000006470": "阳城县",
        "P_YS_FED_IMP_IOT0000006475": "怀宁县",
        "P_YS_SD_UDHWN_0000048940": "石河子市",
        "P_YS_FI_CM_0000029930": "我知道了",
        "P_YS_SD_UDHWN_0001010147": "%d 天",
        "P_YS_FED_IMP_IOT0000006468": "明水县",
        "P_YS_FED_FW_1545722866933170185": "为按单",
        "P_YS_FED_IMP_IOT0000006467": "永顺县",
        "P_YS_FED_IMP_IOT0000007798": "尼勒克县",
        "P_YS_FED_FW_1598599506385436673": "个,请调整后重试",
        "P_YS_FED_FW_1598599506385436676": "已选数据项总数超过最大限制",
        "P_YS_FED_FW_1545722866933170188": "(当前为明细模式，",
        "P_YS_FED_IMP_IOT0000006460": "松滋市",
        "P_YS_FED_IMP_IOT0000007791": "通化县",
        "P_YS_FED_IMP_IOT0000006462": "苍山县",
        "P_YS_FED_IMP_IOT0000007793": "文登市",
        "P_YS_FED_IMP_IOT0000006464": "乐平市",
        "P_YS_OA_XTRICHENG_0000046040": "娱乐",
        "P_YS_SD_UDHWN_0001010155": "星期日_星期一_星期二_星期三_星期四_星期五_星期六",
        "P_YS_HR_HRJQ_0000030978": "您",
        "P_YS_SD_UDHWN_0000120944": "向后 5 页",
        "P_YS_FED_IMP_IOT0000006454": "南关区",
        "P_YS_FED_IMP_IOT0000007785": "禹会区",
        "P_YS_FED_IMP_IOT0000006456": "定南县",
        "P_YS_FED_IMP_IOT0000007787": "大港区",
        "P_YS_FED_IMP_IOT0000006459": "双桥区",
        "P_YS_SD_SDMAUF_0000151805": "暂无物流信息",
        "P_YS_FED_IMP_IOT0000007784": "海港区",
        "P_YS_FED_IMP_IOT0000006452": "高碑店市",
        "P_YS_FED_FW_0001296125": "imagesUrl : 未获取到打印图片url",
        "P_YS_FED_FW_0001296124": "缺少getBlueToothState方法",
        "P_YS_FED_FW_0001296123": "未扫描到附近蓝牙打印机",
        "P_YS_FED_IMP_IOT0000007774": "和林格尔县",
        "P_YS_OA_app_xtywlj_0000037899": "时",
        "P_YS_FED_IMP_IOT0000006446": "麒麟区",
        "P_YS_SD_UDHWN_0001010128": "日_一_二_三_四_五_六",
        "P_YS_FED_IMP_IOT0000006445": "泸溪县",
        "P_YS_FED_IMP_IOT0000006448": "巫溪县",
        "P_YS_FED_IMP_IOT0000007779": "安溪县",
        "P_YS_FI_CM_0000029954": "切换为折线图",
        "P_YS_FED_IMP_IOT0000006442": "应城市",
        "P_YS_FED_FW_0001368219": "当前登陆人",
        "P_YS_FED_IMP_IOT0000007772": "佛冈县",
        "P_YS_SD_UDHWN_0001010130": "早上",
        "P_YS_FED_IMP_IOT0000006433": "莎车县",
        "P_YS_FED_IMP_IOT0000007763": "汤原县",
        "P_YS_FED_IMP_IOT0000006435": "共和县",
        "P_YS_FED_IMP_IOT0000007766": "巴青县",
        "P_YS_FED_IMP_IOT0000006434": "嘉禾县",
        "P_YS_FED_IMP_IOT0000007765": "朝阳区",
        "P_YS_FED_IMP_IOT0000006439": "兴山县",
        "P_YS_FED_IMP_IOT0000007760": "靖边县",
        "P_YS_FED_IMP_IOT0000006431": "兴庆区",
        "P_YS_FED_IMP_IOT0000006430": "醴陵市",
        "P_YS_IDOC_RECORD-BE_0001375534": "密级",
        "P_YS_FED_FW_0001504309": "‰",
        "P_YS_FED_IMP_IOT0000006301": "路桥区",
        "P_YS_FED_IMP_IOT0000006300": "太和区",
        "P_YS_FED_IMP_IOT0000007631": "子洲县",
        "P_YS_FED_IMP_IOT0000008965": "茅箭区",
        "P_YS_FED_IMP_IOT0000007634": "双阳区",
        "P_YS_SD_UDHWN_0000120730": "向前 5 页",
        "P_YS_FED_FW_0000157519": "是否是空值",
        "P_YS_FED_IMP_IOT0000008968": "佳木斯",
        "P_YS_FED_IMP_IOT0000006305": "红旗区",
        "P_YS_FED_IMP_IOT0000007635": "龙沙区",
        "P_YS_FED_IMP_IOT0000008969": "海盐县",
        "P_YS_FED_FW_0001504310": "填写信息有误！请重新填写",
        "P_YS_FED_IMP_IOT0000007638": "攸县",
        "P_YS_FED_IMP_IOT0000006306": "鲁甸县",
        "P_YS_FED_IMP_IOT0000008967": "津南区",
        "P_YS_FED_FW_0000157515": "时间选择",
        "P_YS_FED_FW_0000157516": "行选择事件",
        "P_YS_FED_FW_0000157517": "上拉加载",
        "P_YS_FED_FW_0000157518": "返回方法",
        "P_YS_FED_FW_0000157511": "选择框",
        "P_YS_FED_FW_0000157512": "行点击事件",
        "P_YS_FED_FW_0000157513": "是否编辑",
        "P_YS_FED_IMP_IOT0000007630": "平塘县",
        "P_YS_FED_FW_0000157514": "输入InspectionSheet框",
        "P_YS_FED_FW_0000157510": "改变的回调",
        "P_YS_PF_GZTSYS_0000012545": "元数据",
        "P_YS_FED_IMP_IOT0000007620": "霍林郭勒市",
        "P_YS_FED_IMP_IOT0000007623": "资中县",
        "P_YS_FED_IMP_IOT0000007622": "雄县",
        "P_YS_FED_FW_0000157508": "关闭方法",
        "P_YS_FED_FW_0000157509": "取消方法",
        "P_YS_FED_IMP_IOT0000008958": "长汀县",
        "P_YS_FED_IMP_IOT0000008955": "抚远县",
        "P_YS_FED_IMP_IOT0000007626": "明溪县",
        "P_YS_FED_IMP_IOT0000008956": "广安区",
        "P_YS_FED_FW_0000157504": "树参照",
        "P_YS_FED_FW_0000157505": "多行输入",
        "P_YS_FED_FW_0000157506": "搜索框",
        "P_YS_FED_FW_0000157507": "是否加载",
        "P_YS_FED_FW_0000157502": "允许多选",
        "P_YS_FED_FW_0000157503": "数字输入框",
        "P_YS_FED_IMP_IOT0000007618": "大安区",
        "P_YS_FED_IMP_IOT0000007617": "顺城区",
        "P_YS_FED_IMP_IOT0000008948": "坡头区",
        "P_YS_FED_IMP_IOT0000008949": "五华县",
        "P_YS_FED_IMP_IOT0000007610": "旅顺口区",
        "P_YS_FED_IMP_IOT0000008943": "红山区",
        "P_YS_HR_HRXCF_0000072620": "1日",
        "P_YS_FED_IMP_IOT0000008941": "三原县",
        "P_YS_FED_IMP_IOT0000008947": "榆阳区",
        "P_YS_FED_IMP_IOT0000008944": "松桃苗族自治县",
        "P_YS_FED_FW_1581848446750425093": "同步下级",
        "P_YS_PF_GZTSYS_0000012516": "单据号",
        "P_YS_FED_FW_0000096297": "是否确认删除已选附件？",
        "P_YS_FED_IMP_IOT0000007607": "宜宾县",
        "P_YS_PF_PRINT_0000057345": "集团",
        "P_YS_FED_IMP_IOT0000007606": "宁武县",
        "P_YS_SD_SDMAUF_0001023367": "阿城市",
        "P_YS_FED_IMP_IOT0000008938": "筠连县",
        "P_YS_FED_IMP_IOT0000008931": "安泽县",
        "P_YS_FED_IMP_IOT0000008932": "泉山区",
        "P_YS_FED_IMP_IOT0000007601": "三穗县",
        "P_YS_FED_IMP_IOT0000008930": "林甸县",
        "P_YS_FED_IMP_IOT0000007602": "河东区",
        "P_YS_FED_IMP_IOT0000007605": "迁安市",
        "P_YS_FED_IMP_IOT0000008933": "太白县",
        "P_YS_FED_FW_1607451373850853376": "UI模板ID：",
        "P_YS_FED_IMP_IOT0000008934": "新华区",
        "P_YS_FED_FW_1607451373850853379": "UI模板名称：",
        "P_YS_FED_FW_1440911671847026691": "～～不支持的展示类型～～",
        "P_YS_PF_GZTSYS_0000012580": "个人信息",
        "P_YS_FED_IMP_IOT0000008929": "武侯区",
        "P_YS_PF_GZTSYS_0000012583": "客户",
        "P_YS_FED_FW_0001388572": "打印模版:",
        "P_YS_PF_PROCENTER_0000022808": "保质期单位",
        "P_YS_FED_IMP_IOT0000008920": "麻山区",
        "P_YS_PF_GZTSYS_0000012577": "发运方式",
        "P_YS_FED_IMP_IOT0000008921": "蓬安县",
        "P_YS_FED_IMP_IOT0000008924": "阳曲县",
        "P_YS_FED_IMP_IOT0000008922": "广饶县",
        "P_YS_FED_FW_0001344100": "关闭参照弹窗",
        "P_YS_FED_IMP_IOT0000008917": "霍邱县",
        "P_YS_PF_GZTSYS_0000012594": "任务",
        "P_YS_FED_IMP_IOT0000008916": "兴文县",
        "P_YS_FED_FW_1440911671847026688": "～～数据格式错误, 应为数组～～",
        "P_YS_PF_GZTSYS_0000012589": "审批",
        "P_YS_FED_IMP_IOT0000008910": "若羌县",
        "P_YS_SD_SDDM_0001141756": "当天",
        "P_YS_FED_FW_1465534710770827264": "calsControls接口错误",
        "P_YS_FED_IMP_IOT0000008913": "多伦县",
        "P_YS_PF_GZTSYS_0000012587": "序列号",
        "P_YS_FED_IMP_IOT0000008911": "银州区",
        "P_YS_FED_FW_1465534710770827267": "getAssignValue接口错误",
        "P_YS_FED_IMP_IOT0000008912": "玉树县",
        "P_YS_PF_GZTSYS_0000012586": "培训",
        "P_YS_FED_FW_0001026604": "文件必须小于<%=text%>",
        "P_YS_FED_IMP_IOT0000008906": "吉水县",
        "P_YS_PF_GZTSYS_0000012561": "仓库",
        "P_YS_FED_IMP_IOT0000008904": "乐安县",
        "P_YS_FED_IMP_IOT0000008908": "海晏县",
        "P_YS_FI_CM_0000026041": "未审批",
        "P_YS_PF_GZTSYS_0000012557": "部门",
        "P_YS_FED_IMP_IOT0000008902": "新安县",
        "P_YS_FED_IMP_IOT0000008901": "松北区",
        "P_YS_FED_FW_1593218831501230088": "以下字段有误(或存在必填项):",
        "P_YS_PF_ANALYTIC-FE_0001650866": "近10天",
        "P_YS_PF_GZTSYS_0000012567": "客户属性",
        "P_YS_PF_GZTSYS_0000012563": "自定义项",
        "P_YS_PF_GZTSYS_0000012565": "产品线",
        "P_YS_OA_XTLCZX_0000030093": "提交时间",
        "P_YS_SD_SDMA_0000060271": "二维码",
        "P_YS_FED_FW_0000162048": "重复行信息",
        "P_YS_FED_FW_0000162047": "setTable2DEditRowModel 二维表 editRowModel修改为二维表自己的",
        "P_YS_FED_FW_0000162046": "setTable2DEditRowModel 二维表 editRowModel修改为一维表的",
        "P_YS_PF_GZTTMP_0000075105": "结束以",
        "P_YS_HR_HRRCPDF_0000071164": "标准",
        "P_YS_SCM_STOCK_0000034286": "选好了",
        "P_YS_SCM_STOCK_0000034289": "请选择规格属性 !",
        "P_YS_FED_FW_0001479880": "变更生效失败",
        "P_YS_YYGJFW_YBUC_0001336088": "更多操作",
        "P_YS_SD_SDMA_0000060254": "订单编号",
        "P_YS_SCM_STOCK_0000034290": "订单号",
        "P_YS_SCM_STOCK_0000034292": "选择提货方式",
        "P_YS_SCM_STOCK_0000034293": "请先录入仓库!",
        "000241": "执行查询",
        "P_YS_SCM_STOCK_0000034295": "可用量",
        "P_YS_SCM_STOCK_0000034297": "扫码录入",
        "P_YS_SCM_STOCK_0000034298": "切换扫码",
        "P_YS_SD_SDMBF_0000142308": "选项2",
        "P_YS_SD_SDMBF_0000142307": "选项3",
        "P_YS_FED_FW_0001543963": "终点",
        "P_YS_SD_SDMBF_0000142309": "选项1",
        "P_YS_FED_FW_0001543962": "步行",
        "P_YS_FED_FW_1483362578909888518": "查询条件在导航区时不允许手动搜索",
        "P_YS_SCM_STOCK_0000034265": "实销金额：",
        "P_YS_SCM_STOCK_0000034269": "消息",
        "P_YS_SD_SDSD-FE_0001357089": "数据加载中...",
        "P_YS_FED_FW_0001543959": "起点",
        "P_YS_FED_FW_1441228949671116830": "分组折叠",
        "P_YS_FED_FW_0001543961": "圆形",
        "P_YS_FED_FW_0001543960": "驾车",
        "P_YS_SD_SDSD-FE_0001491840": "單據日期",
        "P_YS_SCM_STOCK_0000034275": "电商订单不允许使用多种支付方式",
        "P_YS_PF_BD-UI_0000157869": "普通采购",
        "P_YS_SCM_STOCK_0000034276": "选择退货原因",
        "P_YS_SCM_STOCK_0000034278": "重打小票",
        "P_YS_FED_FW_1441228949671116824": "查询区调整",
        "P_YS_SD_SDMAUF_0001023389": "思茅市",
        "P_YS_FED_FW_1441228949671116827": "lineTab切换",
        "P_YS_SD_SDMAUF_0001023380": "毕节地区",
        "P_YS_FED_FW_1441228949671116821": "表头明细切换",
        "P_YS_FED_FW_0001656634": "删除草稿失败",
        "P_YS_PF_PROCENTER_0000022885": "保质期",
        "P_YS_SCM_STOCK_0000034280": "继续开单",
        "P_YS_SCM_STOCK_0000034281": "输入",
        "P_YS_SD_SDMA_0000061552": "货到付款",
        "P_YS_SCM_STOCK_0000034282": "，本单应收金额",
        "P_YS_SCM_UPU-UI_0001368234": "近3月",
        "P_YS_SCM_STOCK_0000034284": "退货商品",
        "P_YS_SCM_STOCK_0000034285": "选好了？",
        "P_YS_SCM_STOCK_0000034243": "请输入密码！",
        "P_YS_SCM_STOCK_0000034244": "收款成功",
        "P_YS_SCM_STOCK_0000034247": "超出最大找零金额，无法结算",
        "P_YS_FED_FW_1441228949671116815": "查询方案pop展示切换",
        "P_YS_FED_FW_1441228949671116818": "查询方案设为默认",
        "P_YS_FED_FW_1441228949671116812": "查询方案自动搜索设置",
        "P_YS_SD_SDMB_0000140551": "自定义2",
        "P_YS_HR_HRRCPDF_0000071178": "方案名称不能为空",
        "P_YS_SD_SDMB_0000140553": "自定义1",
        "P_YS_SCM_STOCK_0000034250": "版本号",
        "P_YS_SCM_STOCK_0000034254": "实退金额",
        "P_YS_SCM_STOCK_0000034257": "实收金额",
        "P_YS_SCM_STOCK_0000034259": "优惠券已经存在，请检查。",
        "P_YS_FED_FW_1441228949671116803": "方案编辑|新增弹窗确认",
        "P_YS_FED_FW_1441228949671116806": "方案编辑|新增弹窗取消",
        "P_YS_FED_FW_1441228949671116809": "最大化按钮",
        "P_YS_FED_FW_1441228949671116800": "展示更多查询区",
        "P_YS_HR_HRRCPDF_0000071186": "用友网络科技股份有限公司",
        "P_YS_FED_FW_1615403591714471941": "请在搜索框中录入关键字搜索",
        "P_YS_SCM_STOCK_0000034263": "个促销活动",
        "P_YS_SCM_STOCK_0000034341": "单价",
        "P_YS_SCM_STOCK_0000034343": "已发送至",
        "P_YS_FED_FW_0001523503": "智能搜索中...",
        "P_YS_PF_PRINT_0000065776": "物料sku名称",
        "P_YS_SCM_STOCK_0000034351": "预订单详情",
        "P_YS_PF_SOCD-E_0000490245": "康定市",
        "P_YS_SCM_STOCK_0000034354": "商品不存在",
        "P_YS_SCM_STOCK_0000034357": "查看并编辑个人资料",
        "P_YS_SCM_STOCK_0000034358": "表里的ID为",
        "P_YS_OA_XTMENHUCMS_0000045057": "执行中",
        "P_YS_FED_FW_0000113165": "至少录入一行数据！",
        "P_YS_FED_FW_0000113164": "暂无审批详情",
        "P_YS_FED_FW_0001455872": "单据未审核通过，不允许打印！",
        "P_YS_SCM_STOCK_0000034362": "会员/手机号",
        "P_YS_FED_FW_0001455873": "<%=abandonText%>条数据未审核通过，不允许打印",
        "P_YS_SCM_STOCK_0000034320": "当前商品行没有可用sku数据",
        "P_YS_SCM_STOCK_0000034321": "提货方式",
        "P_YS_SCM_STOCK_0000034328": "没有更多了哦~",
        "P_YS_SD_UDHWN_0001010044": "%d 小时",
        "P_YS_FED_FW_0001301010": "正在计算时间",
        "P_YS_FED_FW_1555177996907708424": "子表第<%=rowno%>行",
        "P_YS_SCM_STOCK_0000034335": "商品合计",
        "P_YS_PF_GZTORG_0000035173": "修改人",
        "P_YS_OA_XTMENHUCMS_0000045039": "完成率",
        "P_YS_SCM_STOCK_0000034302": "应收金额",
        "P_YS_SCM_STOCK_0000034305": "超入库范围",
        "P_YS_SCM_STOCK_0000034307": "入库数量不能为空!",
        "P_YS_SCM_STOCK_0000034309": "收款总额",
        "P_YS_FED_FW_0001625448": "当前页面数据未更改",
        "P_YS_SCM_STOCK_0000034310": "规格：",
        "P_YS_SCM_STOCK_0000034311": "选择退货商品",
        "P_YS_SCM_STOCK_0000034312": "没有商品了哦",
        "P_YS_SCM_STOCK_0000034318": "退款成功",
        "P_YS_SCM_STOCK_0000034319": "未设置最大可找零金额",
        "P_YS_FED_FW_0001061059": "command cParameters JSON格式错误-->",
        "P_YS_FED_FW_0001061051": "吉尔吉斯坦",
        "P_YS_FED_FW_0001061052": "圣文森特",
        "P_YS_FED_FW_0001061053": "蒙特塞拉特岛",
        "P_YS_FED_FW_0001061054": "法属玻利尼西亚",
        "P_YS_FED_FW_0001061055": "百慕大群岛",
        "P_YS_FED_FW_0001061056": "圣文森特岛",
        "P_YS_FED_FW_0001061057": "安道尔共和国",
        "P_YS_FED_FW_0001061058": "autocomplete 没有model",
        "P_YS_FED_FW_0001455874": "<%=abandonText%>条数据允许打印",
        "P_YS_OA_YBMOB_0000177961": "请输入最小值",
        "P_YS_OA_YBMOB_0000177960": "请输入最大值",
        "P_YS_SD_UDHWN_0001010080": "周日_周一_周二_周三_周四_周五_周六",
        "P_YS_FED_MDF-COMPS_0001064728": "【提示】若系统语言（<%=enterprise%>）内容未维护，系统将默认按当前语言（<%=current%>）内容赋值处理",
        "P_YS_SD_UDHWN_0001010095": "[明天]LT",
        "P_YS_FED_IMP_IOT0000006391": "德兴市",
        "P_YS_FED_IMP_IOT0000006396": "巨鹿县",
        "P_YS_FED_IMP_IOT0000006395": "上街区",
        "P_YS_FED_IMP_IOT0000006398": "民勤县",
        "P_YS_FED_FW_0001126032": "!!!未处理的键盘事件, e ==>",
        "P_YS_FED_FW_1575376867322494991": "简版设计器-",
        "P_YS_FED_IMP_IOT0000006388": "永丰县",
        "P_YS_FED_FW_1546407879852949523": "头部信息区",
        "P_YS_FED_FW_1546407879852949526": "移动布局示例",
        "P_YS_FED_IMP_IOT0000006381": "蓬莱市",
        "P_YS_FED_IMP_IOT0000006383": "兴山区",
        "P_YS_FED_IMP_IOT0000006385": "湟源县",
        "P_YS_FED_FW_1546407879852949520": "*数据展示列数",
        "P_YS_FED_IMP_IOT0000006379": "天峻县",
        "P_YS_FI_CM_0000026118": "不存在",
        "P_YS_FED_IMP_IOT0000006370": "和静县",
        "P_YS_FED_FW_0001383748": "取整",
        "P_YS_MF_MR-FE_0001156422": "只能选择一条数据",
        "P_YS_FED_IMP_IOT0000006374": "金安区",
        "P_YS_FED_IMP_IOT0000006376": "泰来县",
        "P_YS_FED_IMP_IOT0000006375": "克拉玛依区",
        "P_YS_FED_UCFBASEDOC_0000025564": "办公用品",
        "P_YS_FED_FW_0001255540": "系统默认模板不支持修改",
        "P_YS_FED_FW_0001255541": "模板已发布，不允许修改",
        "P_YS_FED_FW_1546407879852949508": "请设置头部信息区！",
        "P_DIWORK_YC_YC-UI_0000058082": "请输入供应商名称",
        "P_YS_FED_FW_0001255537": "模板版本号",
        "P_YS_FED_IMP_IOT0000006366": "全州县",
        "P_YS_FED_FW_0001255538": "请输入模板版本号!",
        "P_YS_FED_IMP_IOT0000006368": "梁河县",
        "P_YS_PF_GZTSYS_0000012596": "请假",
        "P_YS_FED_IMP_IOT0000007692": "戚墅堰区",
        "P_YS_FED_IMP_IOT0000006363": "南汇区",
        "P_YS_FED_IMP_IOT0000006362": "怀安县",
        "P_YS_FED_IMP_IOT0000007693": "虎林市",
        "P_YS_PF_METADATA_0000086517": "库存方向",
        "P_YS_FED_FW_0001255539": "您选择的模板尚未发布",
        "P_YS_SD_SDMAUF_0000151992": "两次输入不一致！",
        "P_YS_FED_IMP_IOT0000006356": "陕县",
        "P_YS_FED_IMP_IOT0000007687": "安西县",
        "P_YS_FED_FW_0001255548": "系统必填时不能修改",
        "P_YS_IPAAS_SSB-BE_1431199659860689346": "集合",
        "P_YS_FED_IMP_IOT0000006355": "瓯海区",
        "P_YS_FED_FW_0001255549": "请先选择行再进行操作！",
        "P_YS_FED_FW_1546407879852949511": "主要信息区",
        "P_YS_FED_FW_1575376867322494982": "初始化是需要判断是否有其他展开的如果有先走一次清除",
        "P_YS_FED_IMP_IOT0000006358": "洋县",
        "P_YS_FED_IMP_IOT0000007689": "长子县",
        "P_YS_FED_FW_0001255546": "请输入模板名称!",
        "P_YS_FED_FW_1556630812555214849": "规则条件：",
        "P_YS_FED_FW_1575376867322494985": "您好，请到高级设计器使用特征相关的扩展和设计，简版设计器暂不支持显示特征。",
        "P_YS_FED_FW_0001255547": "枚举字段",
        "P_YS_FED_FW_0001255544": "系统必填",
        "P_YS_FED_FW_1546407879852949514": "请设置主要信息区！",
        "P_YS_FED_IMP_IOT0000006359": "寒亭区",
        "P_YS_FED_FW_0001255545": "请输入模板编号!",
        "P_YS_FED_FW_0001255542": "是否设置为必填",
        "P_YS_FED_FW_0001255543": "是否列入模板",
        "P_YS_FED_FW_1546407879852949517": "数据展示区",
        "P_YS_FED_FW_1575376867322494988": "渲染表格的重要数据 没有的话没必要渲染modal",
        "P_YS_SCM_STOCK_0001113984": "按料",
        "P_YS_FED_IMP_IOT0000007681": "巫山县",
        "P_YS_FED_IMP_IOT0000007680": "潞西市",
        "P_YS_FED_IMP_IOT0000006352": "错那县",
        "P_YS_FED_IMP_IOT0000006351": "邹平县",
        "P_YS_FED_IMP_IOT0000007682": "平鲁区",
        "P_YS_FED_UCFBASEDOC_0000025543": "现场折扣权限",
        "P_YS_FED_IMP_IOT0000006354": "富拉尔基区",
        "P_YS_FED_IMP_IOT0000007685": "环县",
        "P_YS_SCM_STOCK_0001113981": "按单",
        "P_YS_FED_IMP_IOT0000007684": "吴江市",
        "P_YS_SD_UDHWN_0001010021": "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月",
        "P_YS_FED_IMP_IOT0000007675": "饶平县",
        "P_YS_FED_IMP_IOT0000006346": "栾城县",
        "P_YS_SCM_PU_0000028165": "处理中",
        "P_YS_FED_UCFBASEDOC_0000025533": "提交成功",
        "P_YS_FED_IMP_IOT0000006343": "鲁山县",
        "P_YS_FED_IMP_IOT0000007674": "浑源县",
        "P_YS_FED_IMP_IOT0000006342": "巴楚县",
        "P_YS_FED_IMP_IOT0000007673": "禄劝彝族苗族自治县",
        "P_YS_SD_UDHWN_0001010033": "1 个月",
        "P_YS_FED_IMP_IOT0000006333": "蔡甸区",
        "P_YS_FED_IMP_IOT0000007664": "永康市",
        "P_YS_FED_IMP_IOT0000008998": "夹江县",
        "P_YS_FED_IMP_IOT0000007667": "桐城市",
        "P_YS_FED_IMP_IOT0000007666": "肃宁县",
        "P_YS_FED_IMP_IOT0000006339": "行唐县",
        "P_YS_FED_IMP_IOT0000008990": "建邺区",
        "P_YS_FED_IMP_IOT0000006330": "岢岚县",
        "P_YS_FED_IMP_IOT0000007660": "花溪区",
        "P_YS_FED_IMP_IOT0000008991": "乡宁县",
        "P_YS_FED_IMP_IOT0000006331": "平房区",
        "P_YS_FED_IMP_IOT0000007662": "西工区",
        "P_YS_FED_IMP_IOT0000008992": "开平区",
        "P_YS_SD_UDHWN_0000047752": "巢湖市",
        "P_YS_SD_UDHWN_0001010005": "1 年",
        "P_YS_FED_IMP_IOT0000007654": "饶阳县",
        "P_YS_FED_IMP_IOT0000007656": "德令哈市",
        "P_YS_FED_IMP_IOT0000008984": "东港区",
        "P_YS_FED_IMP_IOT0000007655": "湘乡市",
        "P_YS_FED_IMP_IOT0000006327": "临城县",
        "P_YS_FED_IMP_IOT0000007650": "长清区",
        "P_YS_FED_IMP_IOT0000008982": "宣化县",
        "P_YS_FED_IMP_IOT0000006321": "从江县",
        "P_YS_FED_IMP_IOT0000007652": "江阳区",
        "P_YS_FED_IMP_IOT0000008981": "正阳县",
        "P_YS_FED_FW_0001097037": "【config】=>",
        "P_YS_FED_FW_0001097036": "请求user/getOrgsAndStores接口success：【json.code】=>",
        "P_YS_FED_FW_0001097039": "【json.data】=>",
        "P_YS_FED_FW_0001097038": "请求user/getOrgsAndStores接口：【url】=>",
        "P_YS_PF_PRINT_0000057301": "自定义项8",
        "P_YS_FED_IMP_IOT0000006319": "城步苗族自治县",
        "P_YS_HR_HRXCF_1457191573584347175": "普通方案",
        "P_YS_FED_IMP_IOT0000006312": "莲花县",
        "P_YS_FED_IMP_IOT0000007643": "井陉矿区",
        "P_YS_FED_IMP_IOT0000006311": "天峨县",
        "P_YS_FED_IMP_IOT0000008976": "上栗县",
        "P_YS_FED_IMP_IOT0000007645": "萝北县",
        "P_YS_FED_IMP_IOT0000006313": "应县",
        "P_YS_FED_IMP_IOT0000007644": "澄城县",
        "P_YS_FED_IMP_IOT0000006316": "英吉沙县",
        "P_YS_FED_FW_1602706809380405256": "级以上的属性穿透",
        "P_YS_FED_IMP_IOT0000007649": "营山县",
        "P_YS_OA_app_xtywlj_0000037784": "通知",
        "P_YS_FED_FW_1602706809380405259": "特征对象",
        "P_YS_FED_IMP_IOT0000008971": "绩溪县",
        "P_YS_FED_IMP_IOT0000008972": "天全县",
        "P_YS_FED_IMP_IOT0000007640": "临猗县",
        "P_YS_FED_FW_1575377786445496320": "简版设计器编辑",
        "P_YS_SD_UDHWN_0000048340": "白沙黎族自治县",
        "P_YS_FED_IMP_IOT_0001087104": "duplicated and/or omitted — the behavior is unsupported and",
        "P_YS_FED_EXAMP_0000020753": "未录入商品“",
        "P_YS_FED_IMP_IOT0000008843": "烈山区",
        "P_YS_FED_EXAMP_0000020752": "新密码",
        "P_YS_FED_IMP_IOT0000007510": "蒲城县",
        "P_YS_FED_EXAMP_0000020755": "周五",
        "P_YS_FED_IMP_IOT0000007513": "通道侗族自治县",
        "P_YS_FED_IMP_IOT0000008841": "梓潼县",
        "P_YS_FED_EXAMP_0000020754": "网络打印失败！",
        "P_YS_FED_IMP_IOT0000008847": "大竹县",
        "P_YS_FED_IMP_IOT0000008848": "浏阳市",
        "P_YS_FED_EXAMP_0000020751": "离线单据",
        "P_YS_FED_IMP_IOT0000007517": "云龙区",
        "P_YS_FED_EXAMP_0000020750": "？",
        "P_YS_FED_EXAMP_0000020757": "原因",
        "P_YS_FED_EXAMP_0000020756": "获取登录用户失败：【接口】",
        "P_YS_FED_EXAMP_0000020759": "入库通知",
        "P_YS_FED_EXAMP_0000020758": "该商品行不允许修改数量！",
        "P_YS_FED_UCFBASEDOC_0000025299": "待日结数据",
        "P_YS_FED_IMP_IOT0000007508": "兴和县",
        "P_YS_FED_IMP_IOT0000007507": "济阳县",
        "P_YS_FED_FW_0001078398": "请先配置报表服务地址",
        "P_YS_FED_IMP_IOT0000007509": "章丘市",
        "P_YS_SD_UDHWN_0000047023": "五指山市",
        "P_YS_FED_FW_0001241569": "以下<%=name%>表体字段不能为空",
        "P_YS_FED_FW_0000021605": "数据",
        "P_YS_FED_EXAMP_0000020764": "套餐商品未录入完毕,不允许执行改行",
        "P_YS_FED_IMP_IOT0000008832": "曲水县",
        "P_YS_FED_FW_0000021606": "内蒙古",
        "P_YS_FED_EXAMP_0000020763": "张零售单的开票状态!",
        "P_YS_FED_FW_0000021603": "毕节市",
        "P_YS_FED_EXAMP_0000020766": "批发价 :",
        "P_YS_FED_IMP_IOT0000008830": "涪城区",
        "P_YS_FED_FW_0000021604": "鹤岗市",
        "P_YS_FED_EXAMP_0000020765": "房费商品开始时间不能为空！",
        "P_YS_FED_IMP_IOT0000008831": "江山市",
        "P_YS_FED_FW_0000021609": "商丘市",
        "P_YS_FED_EXAMP_0000020760": "周二",
        "P_YS_FED_IMP_IOT0000008836": "洛隆县",
        "P_YS_FED_FW_0000021607": "上4下1",
        "P_YS_FED_EXAMP_0000020762": "企业",
        "P_YS_FED_FW_0000021608": "南通市",
        "P_YS_FED_EXAMP_0000020761": "库存",
        "P_YS_FED_IMP_IOT0000007505": "福田区",
        "P_YS_FED_FW_0001241570": "以下<%=name%>表体的孙表字段不能为空",
        "P_YS_FED_IMP_IOT_0000761504": "适应屏幕",
        "P_YS_FED_FW_0001241571": "第<%=text%>行子表的<%=name%>孙表",
        "P_YS_FED_FW_0000021601": "错误详情",
        "P_YS_FED_EXAMP_0000020768": "当前商品的退货数量不能小于换货数量",
        "P_YS_FED_FW_0000021602": "芜湖市",
        "P_YS_FED_EXAMP_0000020767": "回龙观店",
        "P_YS_FED_FW_0000021600": "固原市",
        "P_YS_FED_EXAMP_0000020769": "整单全退时，请使用退订功能！",
        "P_YS_SD_UDHWN_0000050688": "延庆县",
        "P_YS_FED_IMP_IOT0000008829": "香洲区",
        "P_YS_FED_EXAMP_0000020780": "调整后金额不能小于0！",
        "P_YS_FED_UIMG_0000101674": "系统预制的必输字段不允许修改为非必输",
        "P_YS_FED_EXAMP_0000020775": "优惠券",
        "P_YS_FED_IMP_IOT0000008821": "古蔺县",
        "P_YS_FED_EXAMP_0000020774": "预订交款比例低于",
        "P_YS_FED_IMP_IOT0000008822": "宜州市",
        "P_YS_IMP_IBD-FE_0001110516": "导出数据.xlsx",
        "P_YS_FED_EXAMP_0000020777": "未录入商品，不允许进行选配!",
        "P_YS_FED_EXAMP_0000020776": "打开相册",
        "P_YS_FED_IMP_IOT0000008820": "汪清县",
        "P_YS_FED_EXAMP_0000020771": "卡券商品,不能同时选择卡券号与卡券范围",
        "P_YS_PF_GZTTMP_0000073892": "订单类型",
        "P_YS_FED_EXAMP_0000020770": "电商订单不支持该种操作！",
        "P_YS_FED_IMP_IOT0000008826": "兴国县",
        "P_YS_FED_EXAMP_0000020773": "职业",
        "P_YS_FED_IMP_IOT0000008823": "巩义市",
        "P_YS_FED_EXAMP_0000020772": "[公告] 关于十一促销活动的说明",
        "P_YS_FED_IMP_IOT0000008824": "洪雅县",
        "P_YS_FED_EXAMP_0000020779": "没有关联单据",
        "P_YS_FED_EXAMP_0000020778": "储值业务类型下不能使用储值卡或会员钱包支付",
        "P_YS_FED_UCFBASEDOC_0000025276": "日结库存",
        "P_YS_FED_FW_0001587626": "协作套件不能为空",
        "P_YS_FED_IMP_IOT0000008818": "彬县",
        "P_YS_FED_EXAMP_0000020791": "当前业务类型不能退卡",
        "P_YS_FED_EXAMP_0000020790": "未录入商品[",
        "P_YS_FED_IMP_IOT0000008817": "雨花区",
        "P_YS_FED_IMP_IOT_0001087115": "▶",
        "P_YS_FED_EXAMP_0000020786": "退货商品的积分已经大于等于新购买商品的积分，不必再进行积分抵扣操作。",
        "P_YS_FED_EXAMP_0000020785": "共更新",
        "P_YS_FED_EXAMP_0000020788": "执行过促销活动或现场折扣或积分抵扣或优惠券，断网络状态下不允许结算！",
        "P_YS_FED_EXAMP_0000020787": "请录入卡券号",
        "P_YS_FED_EXAMP_0000020782": "]是材料类商品!",
        "P_YS_FED_IMP_IOT0000008815": "大姚县",
        "P_YS_FED_EXAMP_0000020784": "当前单据状态下不允许增加商品行！",
        "P_YS_FED_EXAMP_0000020783": "已录入",
        "P_YS_FED_EXAMP_0000020789": "),不得低于当前操作员折扣率下限(",
        "P_YS_FED_FW_0001047201": "三十四",
        "P_YS_FED_FW_0001047200": "四十",
        "P_YS_FI_CM_0000026146": "存在",
        "P_YS_FED_IMP_IOT0000008805": "龙口市",
        "P_YS_SD_SDMB_0000139037": "近三个月",
        "P_YS_PF_GZTSYS_0000012457": "草稿箱",
        "P_YS_FED_FW_0000021638": "初始化条件中没有billNo。",
        "P_YS_FED_FW_0001269095": "新增指标公式",
        "P_YS_FED_FW_0000021636": "存在重复行。信息如下",
        "P_YS_FED_EXAMP_0000020711": "卡券非原单退",
        "P_YS_FED_FW_0001269093": "指标全为零不显示",
        "P_YS_FED_FW_0000021637": "存在为必填项，请填写！",
        "P_YS_FED_EXAMP_0000020710": "查看二维码",
        "P_YS_FED_FW_0001269094": "编辑指标公式",
        "P_YS_FED_IMP_IOT0000008804": "罗城仫佬族自治县",
        "P_YS_PF_GZTSYS_0000012455": "物流公司",
        "P_YS_FED_IMP_IOT0000008801": "仁怀市",
        "P_YS_FED_FW_0000021630": "右侧Y轴",
        "P_YS_FED_EXAMP_0000020717": "存在商品行，不允许执行赠品！",
        "P_YS_FED_FW_0000021631": "例：YYYY-MM-DD HH:mm:ss",
        "P_YS_FED_EXAMP_0000020716": "商品模板",
        "P_YS_FED_EXAMP_0000020719": "没有找着编码为",
        "P_YS_FED_EXAMP_0000020718": "西二旗店",
        "P_YS_FED_FW_1550827916596609026": "您好，若用户列表右上角设置了列宽/字段显隐后，便有“用户级设置”，您的最新模板级设置是否对其覆盖？",
        "P_YS_FED_FW_0000021634": "审批流",
        "P_YS_FED_FW_0000111693": "发起的【",
        "P_YS_FED_EXAMP_0000020713": "手机号",
        "P_YS_FED_FW_0000021635": "图形",
        "P_YS_FED_FW_0000111692": ",是否输入最大数字？",
        "P_YS_FED_EXAMP_0000020712": "现销时才能使用卡券作为收款方式!",
        "P_YS_FED_FW_0000021632": "请选择区域。",
        "P_YS_FED_EXAMP_0000020715": "审核不通过原因",
        "P_YS_FED_FW_0000021633": "订阅周期",
        "P_YS_FED_EXAMP_0000020714": "零",
        "P_YS_FED_FW_0001047212": "二十九",
        "P_YS_FED_FW_0001047211": "二十五",
        "P_YS_FED_FW_0001047210": "四十七",
        "P_YS_FED_UCFBASEDOC_0000025251": "请输入手机号",
        "P_YS_PF_PROCENTER_0000027371": "打印设计",
        "P_YS_FED_IMP_IOT_0001087134": "1分",
        "P_YS_FED_FW_0000021649": "没有获取正确的UEType",
        "P_YS_FED_EXAMP_0000020720": "已出品的商品不能退，请交货后进行原单退货！",
        "P_YS_FED_FW_0000021647": "筛选指标",
        "P_YS_FED_EXAMP_0000020722": "当前网络状况不能重取序列号商品价格！",
        "P_YS_FED_FW_0000021648": "启用敏感数据权限控制",
        "P_YS_FED_EXAMP_0000020721": "不允许使用优惠券",
        "P_YS_SD_UDHWS_0000117752": "订单编号：",
        "P_YS_PF_GZTSYS_0000012466": "货品查询",
        "P_YS_FED_FW_0000021641": "根据使用频率自动设置常用功能",
        "P_YS_FED_FW_0001047209": "四十一",
        "P_YS_FED_EXAMP_0000020728": "”,请输入后重试！",
        "P_YS_FED_FW_0000021642": "获取天气：调用服务出错   params=",
        "P_YS_FED_FW_0001047208": "二十七",
        "P_YS_FED_EXAMP_0000020727": "不存在序列号管理的商品行!",
        "P_YS_FED_FW_0001047207": "二十一",
        "P_YS_FED_FW_0000021640": "年月日",
        "P_YS_FED_FW_0001047206": "二十三",
        "P_YS_FED_EXAMP_0000020729": "开始卡券号不能大于结束卡券号",
        "P_YS_FED_FW_0000021645": "居右",
        "P_YS_FED_FW_0001047205": "四十五",
        "P_YS_FED_EXAMP_0000020724": "！",
        "P_YS_FED_FW_0000021646": "默认图文示例",
        "P_YS_FED_FW_0001047204": "四十二",
        "P_YS_FED_EXAMP_0000020723": "该商品为可选配，请先进行选配！",
        "P_YS_FED_FW_0000021643": "严重",
        "P_YS_FED_FW_0001047203": "四十三",
        "P_YS_FED_EXAMP_0000020726": "选择优惠券失败。信息:",
        "P_YS_FED_FW_0000021644": "设置成功！",
        "P_YS_FED_FW_0001047202": "四十九",
        "P_YS_FED_EXAMP_0000020725": "服务内部错误:（错误信息）！",
        "P_YS_HR_HRJQ_0000031679": "非法字符",
        "P_YS_PF_PRINT_0000057492": "归属部门",
        "P_YS_FED_FW_0000021616": "请设置condition",
        "P_YS_FED_EXAMP_0000020731": "中心配送",
        "P_YS_FED_FW_0000021617": "数量精度",
        "P_YS_FED_EXAMP_0000020730": "该商品行不能许修改营业员！",
        "P_YS_FED_FW_0000021614": "公司",
        "P_YS_FED_EXAMP_0000020733": "门店信息",
        "P_YS_FED_FW_0000021615": "草稿",
        "P_YS_FED_EXAMP_0000020732": "请设置有效卡",
        "P_YS_FED_FW_0001078375": "eChartCommon.LogChartInfo('大屏方案 设计 eChartPanelDesigngetPreView End', '', 900);",
        "P_YS_FED_FW_0000021618": "公式编辑器",
        "P_YS_FED_FW_0000021619": "拆分",
        "P_YS_FED_EXAMP_0000020739": "会员信息参与结算",
        "P_YS_FED_EXAMP_0000020738": "调整状态不允许执行选配！",
        "P_YS_HR_HRJXF_0000059422": "进度",
        "P_YS_FED_FW_0000021612": "加载失败",
        "P_YS_FED_EXAMP_0000020735": "电商退货状态",
        "P_YS_FED_FW_0000021613": "请录入1-999的整数。",
        "P_YS_FED_EXAMP_0000020734": "，",
        "P_YS_FED_FW_0000021610": "漳州市",
        "P_YS_PF_PROCENTER_0000027368": "直接打印",
        "P_YS_FED_EXAMP_0000020737": "本单使用了优惠券收款方式，不允许删行",
        "P_YS_FED_EXAMP_0000020736": "收起",
        "P_YS_FED_FW_0000021611": "删除物料",
        "P_YS_FED_FW_0001162218": "查看错误明细",
        "P_YS_FI_CM_0000026177": "已审批",
        "P_YS_FED_FW_0000021627": "周触发一次",
        "P_YS_FED_EXAMP_0000020742": "请先勾选要操作的记录！",
        "P_YS_FED_FW_0000021628": "看板配置信息-模块配置-图文示例",
        "P_YS_FED_EXAMP_0000020741": "每周一次",
        "P_YS_FED_FW_0000021625": "大屏轮播:获取系统有权限的所有看板。 json.data.kanbans",
        "P_YS_FED_EXAMP_0000020744": "将清除全部促销活动，是否继续？",
        "P_YS_FED_FW_0000021626": "大屏轮播: eChartCarousel Render isInDesign =",
        "P_YS_FED_EXAMP_0000020743": "]不存在！",
        "P_YS_FED_FW_0000021629": "查询参数 =",
        "P_YS_FED_EXAMP_0000020740": "存在必输项 “",
        "P_YS_FED_EXAMP_0000020749": "确定要切换组织吗？该操作将重新刷新页面！",
        "P_YS_FED_FW_0000021620": "是否确定要删除？",
        "P_YS_FED_FW_0000021623": "大屏方案 Save params",
        "P_YS_FED_EXAMP_0000020746": "零售单",
        "P_YS_FED_FW_0000021624": "操作失败!",
        "P_YS_FED_EXAMP_0000020745": "参照携带预制错误",
        "P_YS_FED_FW_0000021621": "排名行数",
        "P_YS_FED_EXAMP_0000020748": "储值状态不允许增加商品行！",
        "P_YS_FED_FW_0000021622": "拆分比例",
        "P_YS_FED_EXAMP_0000020747": "请输入移动地址",
        "P_YS_HR_HRJXF_0000059438": "对齐",
        "P_YS_SD_SDMAUF_0000152156": "请选择地址",
        "P_YS_FED_FW_0001396022": "更新数据sql为：",
        "P_YS_FED_FW_0001396021": "不支持executeDBOperate缓存！！！",
        "P_YS_FED_FW_0001396020": "建表sql为：",
        "P_YS_FED_FW_0001396025": "删除数据sql为：",
        "P_YS_FED_FW_0001396024": "删表sql为：",
        "P_YS_FED_FW_0001396023": "查询数据sql为：",
        "P_YS_FED_EXAMP_0000020709": "性别",
        "P_YS_FED_FW_0000112925": "调用获取配置文件接口-整理后",
        "P_YS_FED_EXAMP_0000020700": "调整状态不允许执行积分折扣！",
        "P_YS_FED_EXAMP_0000020706": "获取业务参数失败：【接口】",
        "P_YS_FED_EXAMP_0000020705": "已存在该批次号的商品行!",
        "P_YS_FED_EXAMP_0000020708": "获取",
        "P_YS_FED_EXAMP_0000020707": "请输入会员的卡号或手机号",
        "P_YS_FED_EXAMP_0000020702": "已录入商品,不允许修改卡券业务类型",
        "P_YS_FED_EXAMP_0000020701": "返回结果为空",
        "P_YS_FED_EXAMP_0000020704": "没有选中的商品行，不允许执行退品!",
        "P_YS_FED_EXAMP_0000020703": "规格",
        "P_YS_FED_FW_0001456239": "条数据未审核通过，不允许打印",
        "P_YS_PF_GZTTMP_0000077446": "下一页",
        "P_YS_PF_PC-UI_0000159832": "人员参照",
        "P_YS_FED_FW_0001588923": "当前页面筛选出条数：",
        "P_YS_SD_SDMAF_0000136999": "咨询",
        "OA_web_login_000000016": "请输入您的手机号",
        "P_YS_FED_FW_0001272625": "请您选择环节审批人",
        "P_DIWORK_YC_MALL-BASEDOC_0000061927": "主体",
        "P_YS_FED_UCFORG_0000066179": "展开4层",
        "P_YS_FED_FW_0001072283": "已转入后台处理，可进行其它操作！",
        "P_YS_FED_UCFORG_0000066176": "png 格式",
        "P_YS_FED_FW_0001120450": "树节点6",
        "P_YS_FED_UCFORG_0000066181": "展开2层",
        "P_YS_FED_FW_0001120448": "树节点5",
        "P_YS_FED_FW_0001120449": "树节点4",
        "P_YS_FED_FW_0000115212": "不能调用抽象类的方法parse",
        "P_YS_FED_UCFORG_0000066189": "显示内容",
        "P_YS_FED_UCFORG_0000066191": "展开1层",
        "P_YS_PF_PROCENTER_0000022566": "停用",
        "P_YS_FED_UCFORG_0000066193": "展开5层",
        "P_YS_FED_UCFORG_0000066194": "展开3层",
        "P_YS_FED_UCFORG_0000066190": "下载结构图",
        "P_YS_PF_GZTLOG_0000025980": "列表",
        "P_YS_FED_UCFORG_0000066197": "展开全部",
        "P_YS_PF_GZTLOG_0000025988": "解锁",
        "P_YS_PF_GZTTMP_0000078669": "实盘金额",
        "P_YS_FI_CM_0000028824": "切换为柱状图",
        "P_YS_HR_HRYGF_0001023444": "安圭拉岛",
        "P_YS_FED_FW_1488377941070446601": "阻止钉耙点击事件",
        "P_YS_PF_SOCD-G_0000827848": "二十二",
        "P_YS_PF_GZTLOG_0000025976": "锁定",
        "P_YS_PF_GZTLOG_0000025975": "自定义",
        "P_YS_FI_CM_0000028839": "选择时间",
        "P_YS_OA_XTLCZX_0000030575": "年-月-日",
        "P_YS_PF_GZTLOG_0000025967": "下架",
        "P_YS_IMP_QAM-BE_0001122431": "-∞",
        "P_YS_FED_FW_0000115265": "存在必输项，请填写完整！",
        "country886": "中国台湾",
        "P_YS_FED_IMP_IOT0000006296": "鹿泉市",
        "P_YS_PF_GZTSYS_0000109837": "组织部门",
        "P_YS_FED_IMP_IOT0000006299": "张家口",
        "P_YS_PF_PROCENTER_0000022591": "校验失败",
        "P_YS_OA_XTLCZX_0000030592": "关联",
        "P_YS_FED_FW_0001097561": "网络状况不佳，已切换成离线模式！等待网络通畅后，可点击开单页顶部网络标识，切换成在线模式。",
        "P_YS_OA_XTLCZX_0000030590": "电话",
        "P_YS_FED_FW_0001486020": "【提示】若基准语言（<%=enterprise%>）内容未维护，系统将默认按当前语言（<%=current%>）内容赋值处理",
        "country855": "柬埔寨",
        "P_YS_FED_IMP_IOT0000006282": "广陵区",
        "P_YS_FED_FW_0001264181": "以下",
        "P_YS_FED_IMP_IOT0000006286": "屯留县",
        "P_YS_FED_IMP_IOT0000006285": "华阴市",
        "P_YS_FED_FW_0001084248": "删除附件失败",
        "P_YS_FED_FW_1513779442797772807": "审批流js还在加载中",
        "P_YS_FED_FW_1513779442797772804": "开立态单据还未创建审批流",
        "P_YS_FED_FW_0000153522": "必填项为空",
        "P_YS_FED_FW_0000021560": "益阳市",
        "P_YS_FED_FW_0000021561": "蚌埠市",
        "P_YS_FED_IMP_IOT0000006268": "嘉黎县",
        "P_YS_FED_FW_0000021559": "莱芜市",
        "P_YS_PF_GZTSYS_0000012499": "组织",
        "P_YS_FED_FW_0000021553": "嘉兴市",
        "P_YS_FED_IMP_IOT0000006260": "盐田区",
        "P_YS_FED_IMP_IOT0000007591": "宁海县",
        "P_YS_FED_FW_0000021554": "铜川市",
        "P_YS_FED_IMP_IOT0000007590": "乾县",
        "P_YS_FED_FW_0000021551": "朝阳市",
        "P_YS_FED_IMP_IOT0000006262": "广丰县",
        "P_YS_FED_IMP_IOT0000007593": "贺兰县",
        "P_YS_FED_FW_0000021552": "武威市",
        "P_YS_FED_FW_0000021557": "盘锦市",
        "P_YS_FED_UCFBASEDOC_0000025215": "登录",
        "P_YS_FED_FW_0000021558": "香港",
        "P_YS_FED_IMP_IOT0000006263": "灵武市",
        "P_YS_FED_IMP_IOT0000007594": "分宜县",
        "P_YS_FED_FW_0000021555": "报表分组方案不支持移动端展现，请检查。",
        "P_YS_FED_IMP_IOT0000007597": "召陵区",
        "P_YS_FED_FW_0000021556": "单行",
        "P_YS_FED_IMP_IOT0000006265": "马村区",
        "P_YS_FED_IMP_IOT0000007596": "靖江市",
        "P_YS_FED_FW_0001300469": "查看更多",
        "P_YS_FED_FW_0001300466": "单据号",
        "P_YS_FED_FW_0001300467": "单据日期",
        "P_YS_FED_FW_0000021571": "贵港市",
        "P_YS_FED_FW_0000021572": "南充市",
        "P_YS_FED_FW_0000021570": "那曲地区",
        "P_YS_OA_XTLCZX_0000030541": "表格",
        "P_YS_FED_IMP_IOT0000007588": "新城子区",
        "P_YS_FED_IMP_IOT0000007587": "平利县",
        "P_YS_PF_UCFMDF_0000162014": "员工入职",
        "P_YS_FI_CM_0000028899": "退出登录",
        "P_YS_FED_FW_0000021564": "淮安市",
        "P_YS_FED_IMP_IOT0000007580": "谢通门县",
        "P_YS_FED_FW_0001300471": "按单",
        "P_YS_FED_FW_0000021565": "中山市",
        "P_YS_FED_FW_0001300472": "上一页",
        "P_YS_FED_FW_0000021562": "全选",
        "P_YS_FED_FW_0000021563": "日照市",
        "P_YS_FED_IMP_IOT0000007581": "盖州市",
        "P_YS_FED_FW_0001300470": "按料",
        "P_YS_FED_FW_0000021568": "昆明市",
        "P_YS_FED_IMP_IOT0000007584": "邵武市",
        "P_YS_FED_FW_0000021569": "宣城市",
        "P_YS_FED_UCFBASEDOC_0000025203": "获取验证码",
        "P_YS_FED_IMP_IOT0000007583": "内乡县",
        "P_YS_HR_HRJQF_0000054016": "司龄",
        "P_YS_FED_FW_0000021566": "中3",
        "P_YS_FED_IMP_IOT0000006255": "富锦市",
        "P_YS_FED_IMP_IOT0000007586": "崇仁县",
        "P_YS_FED_FW_0001300473": "下一页",
        "P_YS_FED_FW_0000021567": "攀枝花市",
        "P_YS_FED_UCFBASEDOC_0000025201": "字符串",
        "P_YS_FED_UCFBASEDOC_0000025200": "移动",
        "P_YS_PF_GZTVPA_0001137669": "垂直",
        "P_YS_OA_XTLCZX_0000030555": "平铺",
        "P_YS_OA_XTLCZX_0000030553": "流程",
        "P_YS_FED_FW_0000021539": "柱折图配置信息-yySetting",
        "P_YS_FED_IMP_IOT0000006246": "定日县",
        "P_YS_FED_IMP_IOT0000007576": "博兴县",
        "P_YS_FED_FW_0000021537": "海南藏族自治州",
        "P_YS_FED_IMP_IOT0000006248": "山阳区",
        "P_YS_FED_FW_0000021538": "葫芦岛市",
        "P_YS_FED_IMP_IOT0000007578": "徽州区",
        "P_YS_FED_IMP_IOT0000006249": "蓝山县",
        "P_YS_FED_FW_0000021531": "林芝地区",
        "P_YS_FED_FW_0000021532": "绍兴市",
        "P_YS_FED_IMP_IOT0000007571": "元谋县",
        "P_YS_FED_FW_0000021530": "黔东南苗族侗族自治州",
        "P_YS_FED_IMP_IOT0000007570": "武定县",
        "P_YS_FED_FW_0000021535": "大同市",
        "P_YS_FED_FW_0000021536": "乌海市",
        "P_YS_FED_FW_0000021533": "齐齐哈尔市",
        "P_YS_FED_FW_0000021534": "自定义大屏看板",
        "P_YS_FED_IMP_IOT0000007574": "马龙县",
        "P_YS_SD_UDHWN_0000049625": "琼海市",
        "P_YS_OA_XTLCZX_0000030560": "1月",
        "P_YS_FED_FW_0000021550": "黔西南布依族苗族自治州",
        "P_YS_FED_FW_1481951579073937412": "当前为模板级设置",
        "P_YS_FED_FW_1481951579073937415": "当前为用户级设置",
        "P_YS_FED_FW_0001427697": "条记录：",
        "P_YS_FED_FW_0001223614": "打印的内容",
        "P_YS_FED_FW_1481951579073937418": "默认为模板级设置，字段修改后为用户级设置。",
        "P_YS_FED_FW_0001223613": "请打开蓝牙",
        "P_YS_FED_FW_0001427696": "请确认是否继续?",
        "P_YS_FED_IMP_IOT0000007566": "绿园区",
        "P_YS_PF_GZTSYS_0000012489": "公告",
        "P_YS_FED_IMP_IOT0000006234": "西林县",
        "P_YS_FED_IMP_IOT0000007565": "宽城区",
        "P_YS_FED_FW_0000021548": "西双版纳傣族自治州",
        "P_YS_FED_FW_0000021549": "邵阳市",
        "P_YS_FED_IMP_IOT0000006236": "和硕县",
        "P_YS_FED_IMP_IOT0000008897": "东昌府区",
        "P_YS_FED_FW_0000021542": "移动看板A",
        "P_YS_FED_IMP_IOT0000008890": "广宁县",
        "P_YS_FED_FW_0000021543": "格式化字段预制错误！",
        "P_YS_FED_IMP_IOT0000008891": "平邑县",
        "P_YS_FED_FW_0000021540": "图形报表 因为x轴坐标信息倾斜需要增加的高度",
        "P_YS_FED_IMP_IOT0000007560": "城西区",
        "P_YS_FED_FW_0000021541": "移动看板B",
        "P_YS_FED_FW_0000021546": "错误原因：",
        "P_YS_FED_IMP_IOT0000006231": "李沧区",
        "P_YS_FED_FW_0000021547": "海口市",
        "P_YS_FED_IMP_IOT0000007561": "开县",
        "P_YS_FED_FW_0000021544": "湖北",
        "P_YS_FED_IMP_IOT0000006233": "沁源县",
        "P_YS_FED_FW_0000021545": "十堰市",
        "P_YS_FED_FW_1481951579073937421": "UI模板可以将用户级设置刷新后变成模板级设置",
        "P_YS_FED_FW_1481951579073937424": "也可以使用“恢复默认”回到模板级设置",
        "P_YS_FED_EXAMP_0000020681": "当前为充值状态，不允许添加退货充值行。",
        "P_YS_FED_EXAMP_0000020680": "请选择具体单据",
        "P_YS_FED_EXAMP_0000020676": "赠品中含有实体卡券商品,卡券号必输",
        "P_YS_FED_IMP_IOT0000007555": "右江区",
        "P_YS_FED_EXAMP_0000020675": "]的商品！",
        "P_YS_FED_IMP_IOT0000007554": "海林市",
        "P_YS_FED_EXAMP_0000020678": "非会员和客户的单据只能选择一张单据进行结算",
        "P_YS_FED_IMP_IOT0000006226": "成华区",
        "P_YS_FED_IMP_IOT0000007557": "洪洞县",
        "P_YS_FED_IMP_IOT0000008885": "古冶区",
        "P_YS_FED_EXAMP_0000020677": "即提",
        "P_YS_FED_IMP_IOT0000007556": "海安县",
        "P_YS_FED_IMP_IOT0000008886": "红塔区",
        "P_YS_FED_EXAMP_0000020672": "销售金额(元)",
        "P_YS_FED_IMP_IOT0000007559": "崇文区",
        "P_YS_FED_EXAMP_0000020671": "注册来源",
        "P_YS_FED_IMP_IOT0000007558": "云龙县",
        "P_YS_FED_EXAMP_0000020674": "未收款金额只能改小不能改大！",
        "P_YS_FED_IMP_IOT0000008889": "五华区",
        "P_YS_FED_EXAMP_0000020673": "使用卡券结算且商品行金额有变化时，需要取消已经执行的促销，并重新执行",
        "P_YS_FED_FW_0000021597": "茂名市",
        "P_YS_PF_METADATA_0000088630": "政务",
        "P_YS_FED_FW_0000021598": "舟山市",
        "P_YS_FED_IMP_IOT0000008880": "岚山区",
        "P_YS_FED_FW_0000021595": "看板配置信息-大屏",
        "P_YS_FED_FW_0000021596": "上饶市",
        "P_YS_HR_HRYGF_0001023467": "中非共和国",
        "P_YS_FED_EXAMP_0000020679": "电商",
        "P_YS_FED_FW_1523248273733189640": "切换至列表",
        "P_YS_FED_FW_0000021599": "移动报表 MobileReport Render",
        "P_YS_FED_IMP_IOT0000007553": "宾川县",
        "P_YS_FED_FW_1523248273733189643": "切换至卡片",
        "P_YS_PF_PROCENTER_0000027411": "仓库档案",
        "P_YS_OA_XTLCZX_0000030500": "网关",
        "P_YS_PF_SOCD_0000065988": "海地",
        "P_YS_FED_EXAMP_0000020692": "当前操作员没有售后权限！",
        "P_YS_FED_EXAMP_0000020691": "预订退订状态",
        "P_YS_FED_EXAMP_0000020687": "商城上架数 :",
        "P_YS_FED_IMP_IOT0000006213": "北仑区",
        "P_YS_FED_EXAMP_0000020686": "商品[",
        "P_YS_FED_IMP_IOT0000007543": "红桥区",
        "P_YS_FED_IMP_IOT0000008877": "马关县",
        "P_YS_FED_FW_1499700110520483841": "名称不可为空且长度小于50个字。",
        "P_YS_FED_EXAMP_0000020689": "登录账号不能为空",
        "P_YS_FED_IMP_IOT0000007546": "长葛市",
        "P_YS_FED_IMP_IOT0000008874": "云城区",
        "P_YS_FED_EXAMP_0000020688": "删除失败",
        "P_YS_FED_EXAMP_0000020683": "返回数据：",
        "P_YS_FED_EXAMP_0000020682": "没有选中行。",
        "P_YS_FED_EXAMP_0000020685": "不能改数量",
        "P_YS_FED_IMP_IOT0000006219": "海珠区",
        "P_YS_FED_EXAMP_0000020684": "退款失败!!",
        "P_YS_FED_IMP_IOT0000008879": "南岗区",
        "P_YS_FED_FW_0001228492": "请选择需要恢复的数据：",
        "P_YS_FED_IMP_IOT0000008872": "台前县",
        "P_YS_SD_SDOC_0001150619": "派送失败",
        "P_YS_FED_IMP_IOT0000008873": "互助土族自治县",
        "P_YS_FED_IMP_IOT0000006211": "正宁县",
        "P_YS_FED_IMP_IOT0000008870": "蕉岭县",
        "P_YS_FED_FW_0001228491": "数据恢复确认",
        "P_YS_FED_IMP_IOT0000006210": "红安县",
        "P_YS_FED_IMP_IOT0000008871": "武鸣县",
        "P_YS_FED_FW_0001228490": "请选择有效恢复数据",
        "P_YS_FED_FW_0000021582": "临沂市",
        "P_YS_FED_FW_0000021583": "石嘴山市",
        "P_YS_FED_FW_0000021580": "辽源市",
        "P_YS_FED_FW_0000021581": "上海市",
        "P_YS_FED_IMP_IOT0000006209": "北林区",
        "P_YS_SD_UDHWN_0001010363": "[上]ddddLT",
        "P_YS_FED_EXAMP_0000020698": "当前网络不可用，不能使用此功能",
        "P_YS_FED_IMP_IOT0000006202": "石泉县",
        "P_YS_FED_IMP_IOT0000008865": "富顺县",
        "P_YS_FED_EXAMP_0000020697": "近90天",
        "P_YS_PF_GZTTMP_0000073851": "行政区划",
        "P_YS_FED_IMP_IOT0000006204": "泾县",
        "P_YS_FED_IMP_IOT0000007535": "锦江区",
        "P_YS_FED_EXAMP_0000020699": "不能执行促销活动",
        "P_YS_FED_IMP_IOT0000008864": "桂阳县",
        "P_YS_FED_EXAMP_0000020694": "获取启用会员钱包参数失败",
        "P_YS_FED_IMP_IOT0000007537": "萧县",
        "P_YS_FED_IMP_IOT0000008869": "魏县",
        "P_YS_FED_EXAMP_0000020693": "pos返回成功，但无返回值！",
        "P_YS_FED_IMP_IOT0000006205": "闽侯县",
        "P_YS_FED_EXAMP_0000020696": "要货待提交",
        "P_YS_FED_IMP_IOT0000006208": "涵江区",
        "P_YS_FED_IMP_IOT0000008867": "贡井区",
        "P_YS_FED_EXAMP_0000020695": "可用余额",
        "P_YS_FED_FW_0000021575": "山东",
        "P_YS_FED_FW_0000021576": "汕头市",
        "P_YS_FED_FW_0000021573": "全部附件大小不可超过",
        "P_YS_FED_FW_0000021574": "永州市",
        "P_YS_FED_FW_0000021579": "看板配置信息-移动",
        "P_YS_FED_IMP_IOT0000008862": "金阊区",
        "P_YS_FED_FW_0000021577": "宜宾市",
        "P_YS_FED_FW_0000021578": "清远市",
        "P_YS_FED_FW_0000021590": "滁州市",
        "P_YS_FED_FW_0000021593": "崇明县",
        "P_YS_FED_FW_0000021594": "get参数格式不正确",
        "P_YS_OA_XTLCZX_0000030521": "年-月",
        "P_YS_FED_FW_0000021591": "自治区直辖县级行政区划",
        "P_YS_FED_FW_0000021592": "松原市",
        "P_YS_PF_PRINT_0000057423": "出入库汇总",
        "P_YS_FED_IMP_IOT0000007529": "金寨县",
        "P_YS_FED_IMP_IOT0000007521": "忻府区",
        "P_YS_PF_METADATA_0000088629": "财经",
        "P_YS_FED_IMP_IOT0000008853": "鸡泽县",
        "P_YS_FED_IMP_IOT0000007525": "金湾区",
        "P_YS_FED_IMP_IOT0000008859": "利辛县",
        "P_YS_FED_IMP_IOT0000007528": "博湖县",
        "P_YS_FED_IMP_IOT0000008856": "安达市",
        "P_YS_FED_IMP_IOT0000007527": "庄河市",
        "P_YS_FED_IMP_IOT0000008857": "余庆县",
        "P_YS_FED_FW_0000021586": "中卫市",
        "P_YS_FED_FW_0000021587": "湖南",
        "P_YS_FED_FW_0000021584": "泉州市",
        "P_YS_FED_FW_0000021585": "玉树藏族自治州",
        "P_YS_FED_IMP_IOT0000008850": "临潭县",
        "P_YS_FED_FW_0000021588": "广州市",
        "P_YS_FED_IMP_IOT0000007520": "乐亭县",
        "P_YS_FED_FW_0000021589": "总额",
        "P_YS_FED_IMP_IOT_0000724684": "文件上传错误",
        "P_YS_FED_IMP_IOT_0000724683": "詳情",
        "P_YS_FED_FW_0001253660": "==========> preProcessCommonViewMeta()...查找commonToolbarb并且已经删除",
        "P_YS_PF_PRINT_0000057596": "打印份数",
        "P_YS_FED_FW_0000021715": "缓存类型",
        "P_YS_FED_EXAMP_0000020632": "补货数量=指定时间段内的销量-在途数量",
        "P_YS_FED_FW_0001253655": "==========> preProcessCommonViewMeta()...发生不可预期的错误，直接返回！根据[",
        "P_YS_FED_FW_0000021716": "大屏方案 设计 getDesignColType_Sum curCol",
        "P_YS_FED_EXAMP_0000020631": "没有设置打印模板，请检查",
        "P_YS_FED_FW_0001253654": "==========> preProcessCommonViewMeta()...ERROR，异常信息为",
        "P_YS_FED_FW_0000021713": "]不存在于源表栏目中，请检查。",
        "P_YS_FED_EXAMP_0000020634": "套餐商品未录入完毕,不允许执行改零售价",
        "P_YS_FED_FW_0001253657": "===> [mdf-cube] [preprocessViewMeta()] 开始预处理viewmeta",
        "P_YS_FED_FW_0000021714": "ü",
        "P_YS_FED_EXAMP_0000020633": "周日",
        "P_YS_FED_FW_0001253656": "==========> preProcessCommonViewMeta方法未能合并CommonToobar!",
        "P_YS_FED_FW_0000021719": "所在地区",
        "P_YS_FED_IMP_IOT0000008726": "来凤县",
        "P_YS_FED_FW_0001253651": "initVM()时UI元数据meta协议错误!",
        "P_YS_FED_IMP_IOT0000008727": "镇平县",
        "P_YS_FED_FW_0001253650": "请覆盖effectivedate(生效日期)，expirationdate(失效日期)，creationtime(创建日期)字段，方便MDF统一处理",
        "P_YS_PF_GZTSYS_0000013621": "批次号",
        "P_YS_FED_FW_0000021717": "经度字段不可为空",
        "P_YS_FED_EXAMP_0000020630": "销售时间",
        "P_YS_FED_IMP_IOT0000008724": "水富县",
        "P_YS_FED_FW_0001253653": "===> [mdf-cube] [preprocessViewMeta()] [findCommonToolbar()]viewmeta.view.containers中找到commonToolbarb且已删除",
        "P_YS_FED_FW_0000021718": "自定义过滤条件",
        "P_YS_FED_FW_0001253652": "==========> preProcessCommonViewMeta()...[兼容]在#1中查找到targetToolbar#2:",
        "P_YS_FED_EXAMP_0000020639": "取 消",
        "P_YS_FED_FW_0000021711": "打开数据库失败，缓存功能不可用！",
        "P_YS_FED_EXAMP_0000020636": "不能储值卡结算",
        "P_YS_FED_FW_0001253659": "===> [mdf-cube] preprocessViewMeta()...return, because commonToolbar不存在或不是一个Array",
        "P_YS_FED_FW_0000021712": "ö",
        "P_YS_FED_EXAMP_0000020635": "商城下架数 :",
        "P_YS_FED_FW_0001253658": "===> [mdf-cube] preprocessViewMeta()...viewmeta?.cBillType 未知，无法处理",
        "P_YS_FED_EXAMP_0000020638": "没有",
        "P_YS_FED_FW_0000021710": "监控视图 设置自动刷新频率定时器 renderTime",
        "P_YS_FED_EXAMP_0000020637": "[公告] 关于门店美观陈设的说明",
        "P_YS_FED_FW_0001253671": "===> [mdf-cube] preprocessViewMeta()...return, 未找到能处理的Header组件[",
        "P_YS_FED_FW_0001253670": "===> [mdf-cube] preprocessViewMeta方法未能合并CommonToobar!",
        "P_YS_FED_FW_0000021726": "eChartDisplay 散点图地图信息不正确  errInfo =",
        "P_YS_FED_EXAMP_0000020643": "请填写退货原因!",
        "P_YS_FED_FW_0001253666": "==========> preProcessCommonViewMeta()...return, 未找到能处理的Header组件[",
        "P_YS_FED_FW_0000021727": "标题名称",
        "P_YS_FED_EXAMP_0000020642": "门店销售趋势",
        "P_YS_FED_FW_0001253665": "===> [mdf-cube] preprocessViewMeta()...ERROR，异常信息为",
        "P_YS_FED_FW_0000021724": "没有符合条件的行记录",
        "P_YS_FED_EXAMP_0000020645": "https://cdn.yonyoucloud.com/iprint/用友云打印助手.exe",
        "P_YS_FED_FW_0001253668": "==========> preProcessCommonViewMeta()...viewmeta?.cBillType 未知，无法处理",
        "P_YS_FED_FW_0000021725": "图表",
        "P_YS_FED_EXAMP_0000020644": "[ 公告 ]",
        "P_YS_FED_FW_0001253667": "不支持Header组件类型【",
        "P_YS_FED_FW_0001253662": "】, 无法处理CommonToolbar",
        "P_YS_FED_FW_0001253661": "]能找到targetHeader，但未找到targetHeaderParent, targetHeader为:",
        "P_YS_FED_FW_0000021728": "图片不可大于 10MB!",
        "P_YS_FED_EXAMP_0000020641": "房费商品数量小于1小时，是否按1小时收费？",
        "P_YS_FED_FW_0001253664": "==========> preProcessCommonViewMeta()...return, because commonToolbar不存在或不是一个Array",
        "P_YS_FED_FW_0000021729": "天",
        "P_YS_FED_EXAMP_0000020640": "不能抹零",
        "P_YS_FED_FW_0001253663": "===> [mdf-cube] preprocessViewMeta()...[兼容]在#1中查找到targetToolbar#2:",
        "P_YS_HR_HRJXF_0000059335": "创建任务",
        "P_YS_FED_FW_0000021722": "图表列数请输入1-3的整数。",
        "P_YS_FED_EXAMP_0000020647": "(本门店)",
        "P_YS_FED_FW_0000021723": "已启用",
        "P_YS_FED_EXAMP_0000020646": "不存在可用账号",
        "P_YS_FED_FW_0001253669": "===> [mdf-cube] preprocessViewMeta()...发生不可预期的错误，直接返回！根据[",
        "P_YS_FED_FW_0000021720": "重新选择模板将覆盖当前的模板信息，是否继续?",
        "P_YS_FED_EXAMP_0000020649": "周一",
        "P_YS_PF_PROCENTER_0000027456": "手工输入",
        "P_YS_FED_FW_0000021721": "】么？",
        "P_YS_FED_EXAMP_0000020648": "序",
        "P_YS_FED_IMP_IOT_0000724660": "打印設計",
        "P_YS_FED_IMP_IOT_0000724664": "第一条",
        "P_YS_HR_HRJQ_0000031751": "次",
        "P_YS_FED_IMP_IOT0000008709": "河津市",
        "P_YS_FED_IMP_IOT0000008707": "繁昌县",
        "P_YS_FED_IMP_IOT_0001010702": "YYYY年M月D日 HH:mm",
        "P_YS_FED_EXAMP_0000020654": "固定套餐",
        "P_YS_FED_FW_0001253633": ", 不返回meta，client端可以使用viewApplication的缓存",
        "P_YS_FED_EXAMP_0000020653": "推荐人",
        "P_YS_FED_EXAMP_0000020656": "没有选中商品行，不能新增序列号,请检查!",
        "P_YS_FED_EXAMP_0000020655": "不能选择当前优惠券。",
        "P_YS_FED_EXAMP_0000020650": "中国,",
        "P_YS_FED_EXAMP_0000020652": "暂无日志",
        "P_YS_FED_IMP_IOT0000008702": "複製",
        "P_YS_FED_EXAMP_0000020651": "不符，请重新选择",
        "P_YS_FED_IMP_IOT0000008703": "宁都县",
        "P_YS_HR_HRJQF_0000054083": "时间范围",
        "P_YS_FED_IMP_IOT_0000724668": "最後一條",
        "P_YS_OA_XTRIZHI_0000036759": "复选框",
        "P_YS_FED_IMP_IOT_0000724667": "最小化",
        "P_YS_PF_GZTSYS_0000013609": "其他入库",
        "P_YS_OA_XTLCZX_0000030706": "的",
        "P_YS_FED_EXAMP_0000020658": "零售开单校验失败：【接口】",
        "P_YS_FED_FW_0001253637": "初始化FilterViewModel_Extend开始",
        "P_YS_FED_EXAMP_0000020657": "获取POS编号失败：",
        "P_YS_FED_FW_0001253636": "voucher editRow方法异常",
        "P_YS_FED_FW_0001253639": "Group:meta客户端缓存",
        "P_YS_FED_EXAMP_0000020659": "序列号数量和商品数量不符！",
        "P_YS_FED_FW_0001253638": "开始执行",
        "P_YS_FED_UCFBASEDOC_0000025398": "菜单",
        "P_YS_PF_PROCENTER_0000027432": "小明",
        "P_YS_FED_IMP_IOT_0000724653": "複製行",
        "P_YS_FED_FW_0001302904": "请求接口地址",
        "P_YS_HR_HRJQ_0000031765": "李四",
        "P_YS_FED_EXAMP_0000020670": "销售排行",
        "P_YS_FED_FW_0001302905": "接口返回数据",
        "P_YS_FED_IMP_IOT_0001010712": "YYYY年M月D日ddddAh点mm分",
        "P_YS_FED_FW_0000021704": "最多只支持三级维度导航！",
        "P_YS_FED_EXAMP_0000020665": "交货不能修改商品时，",
        "P_YS_FED_FW_0001253644": "]时遇到无法处理的不规范数据，暂时兼容处理，请联系相关开发及时修改。cell的值应该为JSON Object, cell ==>",
        "P_YS_FED_FW_0000021705": "添加汇总",
        "P_YS_FED_EXAMP_0000020664": "地址档案",
        "P_YS_FED_FW_0001253643": "行的_status,",
        "P_YS_FED_FW_0000021702": "4、示例：各类型字段的过滤表达式示例如下：",
        "P_YS_FED_FW_0001253646": "]尝试获取UI模板!",
        "P_YS_FED_FW_0000021703": "已停用",
        "P_YS_FED_EXAMP_0000020666": "周三",
        "P_YS_FED_FW_0001253645": "调用communicateBillSetting()时，未指定envConfig.DOMAIN_CODE, 并且也未指定params.cParameter.domain参数，暂使用domainKey[",
        "P_YS_FED_FW_0000021708": "展示指标必选，且最多10项",
        "P_YS_FED_EXAMP_0000020661": "电商订单状态下不能新增商品！",
        "P_YS_FED_FW_0001253640": "初始化FilterViewModel_Extend结束",
        "P_YS_FED_EXAMP_0000020660": "我的",
        "P_YS_FED_EXAMP_0000020663": "卡券号",
        "P_YS_FED_FW_0001253642": "]时遇到无法处理的不规范数据，兼容处理时异常，cell ==>",
        "P_YS_FED_FW_0000021707": "ä",
        "P_YS_FED_EXAMP_0000020662": "复制成功",
        "P_YS_FED_FW_0001253641": "]---不存在",
        "P_YS_OA_XTLCZX_0000030711": "单位",
        "P_YS_FED_FW_0000021700": "订阅名称",
        "P_YS_FED_EXAMP_0000020669": "现场折扣审批",
        "P_YS_FED_FW_0001253648": "[mdf-cube] [getCellDataByCtrlType()] 处理[controlType=",
        "P_YS_FED_FW_0000021701": "主维度行数不可大于31",
        "P_YS_FED_EXAMP_0000020668": "不允许同时结算电子卡券与实体卡券",
        "P_YS_FED_FW_0001253647": "] restoreRowState() 更新第",
        "P_YS_FED_FW_0001253649": "返回值result ==>",
        "P_YS_SD_UDHWN_0001010302": "%d 个月",
        "P_YS_FED_FW_0000021759": "标题",
        "P_YS_SD_UDHWN_0001010306": "晚上",
        "P_YS_FED_FW_0000021757": "调用获取单据配置的服务返回错误。url =",
        "P_YS_FED_FW_0000021758": "主维度不可为空且最多三项",
        "P_YS_FED_FW_0000021751": "不显示指标全为零的数据行",
        "P_YS_FED_FW_0000021752": "· 档案类型字段：[客户分类.分类名称]",
        "P_YS_FED_FW_0000021750": "显示千分位",
        "P_YS_SD_SDMBF_0000142981": "★",
        "P_YS_FED_FW_0000021755": "小数位数必须为1~8之间的整数!",
        "P_YS_FED_FW_0000021756": "经纬度字段不可相同",
        "P_YS_FED_FW_0000021753": "模版名称/组织名称",
        "P_YS_FED_FW_0000021754": "筛选行数",
        "P_YS_FED_IMP_IOT_0000724647": "打印預覽",
        "P_YS_FED_FW_0000021770": "交叉",
        "P_YS_PF_GZTSYS_0000012346": "品牌属性",
        "P_YS_FED_FW_0000021768": "大屏轮播: Render activeTabKey",
        "P_YS_FED_EXAMP_0000020601": "]是非材料类商品!",
        "P_YS_FED_EXAMP_0000020600": "是",
        "P_YS_FED_FW_0000021769": "精度",
        "P_YS_FED_FW_0000021762": "删除草稿失败！",
        "P_YS_FED_EXAMP_0000020607": ",比例不得低于",
        "P_YS_FED_FW_0000021763": "存在空白行标题的行，请检查。",
        "P_YS_FED_EXAMP_0000020606": "线上零售价 :",
        "P_YS_FED_FW_0000021760": "汇总区域设置不自动刷新。 refreshInterval",
        "P_YS_FED_EXAMP_0000020609": "改行前后商品不相同",
        "P_YS_FED_FW_0000021761": "新增范本",
        "P_YS_FED_EXAMP_0000020608": "商品审核",
        "P_YS_FED_FW_0000021766": "返回",
        "P_YS_FED_EXAMP_0000020603": "套餐商品未录入完毕,不允许执行促销活动",
        "P_YS_FED_FW_0000021767": "确定删除此栏目么？",
        "P_YS_FED_EXAMP_0000020602": "金价不合法。",
        "P_YS_FED_FW_0000021764": "· not运算符（!）：[规格型号]!=null",
        "P_YS_FED_EXAMP_0000020605": "样例",
        "P_YS_FED_FW_0000021765": "请输入行业",
        "P_YS_FED_EXAMP_0000020604": "订金比例控制不能低于",
        "P_YS_FED_FW_0001238003": "这是第一条数据了, 没有更多数据了",
        "P_YS_FED_FW_0001238005": "这是最后一条数据了, 没有更多数据了",
        "P_YS_SD_UDHWN_0000050766": "海东市",
        "P_YS_FED_FW_0001238004": "这是最后一条了, 没有更多数据了",
        "P_YS_PF_PROCENTER_0000027482": "分享",
        "P_YS_FED_FW_0000021737": "请选择行",
        "P_YS_FED_EXAMP_0000020610": "当前单据状态下，该操作不可用！",
        "P_YS_FED_FW_0000021738": "大屏轮播:获取系统有权限的type=1看板。 kanbans",
        "P_YS_FED_FW_0000021735": "韩语",
        "P_YS_FED_EXAMP_0000020612": "预订交款不得低于",
        "P_YS_FED_FW_0000021736": "显示样式",
        "P_YS_FED_EXAMP_0000020611": "原单退货中，退货行不允许修改营业员！",
        "P_YS_FED_FW_0000021739": "当前区域已经有控件，请先清除。",
        "P_YS_FED_EXAMP_0000020618": "进货价格",
        "P_YS_FED_FW_0000021730": "主组织不能为空",
        "P_YS_FED_EXAMP_0000020617": "没有更多了~",
        "P_YS_FED_EXAMP_0000020619": "采购类型的采购入库单无需自动拣货！",
        "P_YS_FED_FW_0000021733": "每次只能选择一个数据项！",
        "P_YS_FED_EXAMP_0000020614": "删除成功",
        "P_YS_FED_FW_0000021734": "操作失败！",
        "P_YS_FED_EXAMP_0000020613": "未启用消费密码管理，不能修改密码",
        "P_YS_FED_FW_0000021731": "设置界面 EChartDesign初始化  state",
        "P_YS_FED_EXAMP_0000020616": "折扣额",
        "P_YS_FED_FW_0000021732": "匹配一维表的行时，当前行前面已经匹配过，请检查。 valueArr =",
        "P_YS_FED_EXAMP_0000020615": "已执行过优惠活动,不允许修改卡券号和卡券号范围",
        "P_YS_FED_UCFORG_0000066201": "jpg 格式",
        "P_YS_PF_GZTSYS_0000012330": "地址",
        "P_YS_FED_FW_0001037993": "当前字段不可为空",
        "P_YS_FED_FW_0000021748": "请设置字体大小",
        "P_YS_FED_FW_0000021749": "您可以稍后尝试，刷新该服务 如仍不成功，请联系IT管理员解决！",
        "P_YS_FED_EXAMP_0000020620": "未找到对应商品信息！",
        "P_YS_FED_FW_1492257198466662407": "请点击录入框右侧图标，维护多语名称",
        "P_YS_FED_FW_0000021746": "公司网址",
        "P_YS_FED_EXAMP_0000020623": "结束时间应大于开始时间！",
        "P_YS_FED_FW_0000021747": "有权",
        "P_YS_FED_EXAMP_0000020622": "当前状态不允许打小票",
        "P_YS_FED_FW_0000021740": "元",
        "P_YS_FED_EXAMP_0000020629": "10积分抵1元",
        "P_YS_FED_FW_0000021741": "请选择记录",
        "P_YS_FED_EXAMP_0000020628": "储值卡充值不允许修改数量",
        "P_YS_HR_HRJQF_0000054031": "全国",
        "P_YS_FED_FW_0000021744": "大于等于",
        "P_YS_FED_EXAMP_0000020625": "预订待发",
        "P_YS_FED_FW_0000021745": "信息设置",
        "P_YS_FED_EXAMP_0000020624": "下不能修改表头信息",
        "P_YS_FED_FW_0000021742": "监控视图汇总设置",
        "P_YS_FED_UCFBASEDOC_0000025345": "移动到",
        "P_YS_FED_EXAMP_0000020627": "选择批号",
        "P_YS_FED_FW_0000021743": "数据类型",
        "P_YS_FED_EXAMP_0000020626": "当前工费折扣率为(",
        "P_YS_FI_IA_0000054828": "单据号:",
        "P_YS_FED_FW_0000153308": "数值列只允许粘贴数字，请修改后重试！",
        "P_YS_FED_FW_0001084311": "保存接口回调结束",
        "P_YS_FED_FW_0001084312": "fetchMeta请求回调开始",
        "P_YS_FED_FW_0000153307": "获取参照元数据失败：",
        "P_YS_FED_FW_0001084310": "开始调用",
        "P_YS_FED_FW_0001084319": "ajax请求开始",
        "P_YS_FED_FW_0001084317": "卡片页数据接口回调开始",
        "P_YS_FED_FW_0001084318": "fetchMeta请求回调结束",
        "P_YS_FED_FW_0001084315": "结束执行voucherlist init方法",
        "P_YS_FED_FW_0001084316": "保存接口回调开始",
        "P_YS_FED_FW_0001084313": "开始执行initVM",
        "P_YS_FED_FW_0001084314": "结束调用",
        "P_YS_FED_FW_0001084322": "初始化viewmodel回调结束",
        "P_YS_FED_FW_0001084323": "结束请求meta数据fetchMeta",
        "P_YS_FED_FW_0001084320": "开始请求meta数据fetchMeta",
        "P_YS_FED_FW_0001084321": "ajax请求结束",
        "P_YS_FED_FW_0001084328": "结束执行voucher init方法",
        "P_YS_SD_SDMA_0000040405": "身份证号",
        "P_YS_FED_FW_0001084329": "保存按钮点击",
        "P_YS_FED_FW_0001084326": "卡片页数据接口回调结束",
        "P_YS_FED_FW_0001084327": "开始执行voucher init方法",
        "P_YS_FED_FW_0001084324": "初始化viewmodel回调开始",
        "P_YS_FED_FW_0001084325": "页面初始化",
        "P_YS_SD_SDMB_0000147380": "汽车",
        "P_YS_FED_FW_0001084333": "开始执行DynamicView的componentDidMount方法",
        "P_YS_FED_FW_0001084334": "按钮点击，调用Button组件内部onClick方法结束",
        "P_YS_FED_FW_1494583954049597443": "主维度不可为空且最多四项",
        "P_YS_FED_FW_0001084331": "开始执行voucherlist init方法",
        "P_YS_FED_FW_0001084332": "按钮点击",
        "P_YS_FED_FW_0001084330": "结束执行initVM",
        "P_YS_FED_FW_0001086990": "下推失败",
        "P_YS_FED_FW_0001084337": "上报成功",
        "P_YS_FED_FW_0001084335": "结束执行DynamicView的componentDidMount方法",
        "P_YS_FED_FW_0001084336": "按钮点击，调用Button组件内部onClick方法开始",
        "P_YS_SCM_PU_0000027985": "要货申请单",
        "P_YS_HR_HRCOREF_0000058682": "导出全部数据",
        "P_YS_FED_FW_0001331438": "未配置searchTable",
        "P_YS_PF_BD-UI_0001050131": "采购要货",
        "P_YS_FED_FW_0001186384": "打印服务报错",
        "P_YS_FED_FW_1619244168636792834": "没有code和name",
        "P_YS_PLM_BASE-UI_0001105607": "物料管理",
        "P_YS_FED_FW_0001483717": "已选条件:",
        "P_YS_FED_FW_0001098936": "未配置jointQuery",
        "P_YS_FED_FW_0001549489": "存在校验失败项，可以点击查看",
        "P_YS_FED_FW_0001086945": "银行卡格式错误！",
        "P_YS_PF_METADATA_0000084934": "文件名称",
        "P_YS_FED_IMP_IOT_0000724693": "下一條",
        "P_YS_FED_IMP_IOT_0000724695": "機構圖",
        "P_YS_FED_FW_0001260767": "存在重复行标题",
        "P_YS_FED_FW_1464019858621464576": "系统打印失败错误信息：",
        "P_YS_FED_FW_0001120451": "树节点1",
        "P_YS_FED_FW_0001120452": "树节点3",
        "P_YS_FED_FW_0001120453": "树节点2",
        "P_YS_FED_FW_0001272748": "<%=name%>表体以下字段有误(或存在必填项)",
        "P_YS_FED_IMP_IOT_0000761604": "放大",
        "P_YS_FED_FW_0001272749": "<%=name%>表体的以下孙表有误(或存在必填项)",
        "P_YS_PF_MANAGER-FE_0001087798": "集成开发",
        "P_YS_PF_PROCENTER_0000022691": "商品编码",
        "P_YS_FED_FW_1540589728190955535": "必填项未填，请补充每张单据的指派人",
        "P_YS_FED_FW_1565833123598958592": "获取定位失败",
        "P_YS_PF_GZTTMP_0000076150": "方法",
        "P_YS_FED_FW_1540589728190955529": "批量指派",
        "P_YS_FED_FW_1540589728190955532": "添加指派人",
        "P_YS_PF_PROCENTER_0000022686": "单据日期",
        "P_YS_SD_UDHWN_0001010281": "[下]ddddLT",
        "P_YS_SD_UDHWN_0001010291": "[今天]LT",
        "P_YS_FI_CM_0000028959": "十二月",
        "P_YS_FI_TP_0000071860": "大拿",
        "P_YS_FED_IMP_IOT0000006194": "南长区",
        "P_YS_SD_UDHWN_0001131752": "新增模板",
        "P_YS_FED_IMP_IOT0000006198": "东至县",
        "P_YS_FED_IMP_IOT0000006197": "普陀区",
        "P_YS_OA_XTLCZX_0000030692": "进行中",
        "P_YS_FED_IMP_IOT0000006191": "正安县",
        "P_YS_FED_IMP_IOT0000006182": "漾濞彝族自治县",
        "P_YS_FED_IMP_IOT0000006185": "献县",
        "P_YS_FED_IMP_IOT0000006187": "葫芦岛",
        "P_YS_SD_SCMSA-UI_0000162252": "累计收款金额",
        "P_YS_FED_IMP_IOT0000006189": "阿克陶县",
        "P_YS_FED_IMP_IOT0000006188": "荷塘区",
        "P_YS_FED_FW_1592308169585459201": "扫描数量",
        "P_YS_FED_FW_1521051784508342287": "%c 未找到相关数据",
        "P_YS_FED_FW_0001295306": "图片大小不大于2MB,请重新上传",
        "P_YS_FED_FW_1521051784508342284": "%c 索引为负数，当前索引",
        "P_YS_FED_IMP_IOT0000006181": "温泉县",
        "P_YS_FED_FW_0001295305": "图片格式仅支持JPG、PNG、BMP,请重新上传",
        "P_YS_FED_IMP_IOT0000006179": "西林区",
        "P_YS_FED_IMP_IOT0000006171": "商南县",
        "P_YS_FED_FW_1521051784508342281": "%c 索引超出范围，当前索引",
        "P_YS_FED_IMP_IOT0000006174": "盘龙区",
        "P_YS_FED_IMP_IOT0000006173": "岗巴县",
        "P_YS_FED_IMP_IOT0000006176": "上高县",
        "P_YS_FED_IMP_IOT0000006175": "容城县",
        "P_YS_SD_SDMB_0000090886": "支付",
        "P_YS_FED_IMP_IOT0000006177": "陇县",
        "P_YS_FED_IMP_IOT0000006170": "治多县",
        "P_YS_FED_IMP_IOT0000007499": "杜集区",
        "P_YS_FED_FW_0001085694": "и",
        "P_YS_FED_IMP_IOT0000006161": "银海区",
        "P_YS_FED_IMP_IOT0000007491": "平山区",
        "P_YS_FED_FW_0001155140": "无可用打印模板!",
        "P_YS_FED_IMP_IOT0000007494": "高县",
        "P_YS_FI_TP_0000071815": "联通",
        "P_YS_FED_IMP_IOT0000006164": "前郭尔罗斯蒙古族自治县",
        "P_YS_FED_IMP_IOT0000006167": "吴兴区",
        "P_YS_FED_IMP_IOT0000006166": "蒙山县",
        "P_YS_FED_IMP_IOT0000007497": "呼兰区",
        "P_YS_FED_IMP_IOT0000006157": "宁陕县",
        "P_YS_FED_IMP_IOT0000006159": "亭湖区",
        "P_YS_FED_IMP_IOT0000007481": "新邱区",
        "P_YS_FED_IMP_IOT0000006152": "柘城县",
        "P_YS_FED_IMP_IOT0000007483": "惠民县",
        "P_YS_FED_IMP_IOT0000006154": "成安县",
        "P_YS_FED_IMP_IOT0000007485": "株洲县",
        "P_YS_FED_IMP_IOT0000007484": "武宁县",
        "P_YS_FI_CM_0000028918": "十一月",
        "P_YS_FED_IMP_IOT0000006155": "阳明区",
        "P_YS_FED_IMP_IOT0000007486": "得荣县",
        "P_YS_FED_FW_0000021681": "最多选择8个汇总项。",
        "P_YS_FED_FW_0000021682": "普通汇总显示",
        "P_YS_OA_XTLCZX_0000030653": "常用",
        "P_YS_OA_XTLCZX_0000030652": "创建时间",
        "P_YS_FED_FW_0000021680": "显示周",
        "P_YS_FED_IMP_IOT_0001010685": "YYYY年M月D日Ah点mm分",
        "P_YS_FED_EXAMP_0000020599": "请录入店铺。",
        "P_YS_FED_IMP_IOT0000006147": "滨江区",
        "P_YS_FED_EXAMP_0000020598": "收款金额与应收金额不符！应收金额为：",
        "P_YS_FED_IMP_IOT0000006146": "墨脱县",
        "module1.UserExcelExportController_0000": "无数据可导出",
        "P_YS_FED_IMP_IOT_0000761593": "基础组件",
        "P_YS_FED_EXAMP_0000020595": "客单价(元)",
        "P_YS_FED_EXAMP_0000020594": "老昌",
        "P_YS_FED_EXAMP_0000020597": "请录入商品。",
        "P_YS_FED_EXAMP_0000020596": "重新生成SKU",
        "P_YS_FED_IMP_IOT0000007470": "吴川市",
        "P_YS_FED_FW_0000021675": "条形末端显示数字",
        "P_YS_OA_XTLCZX_0000030646": "左",
        "P_YS_FED_FW_0000021672": "配置文件中行标题为空或者配置字段不存在于源表栏目中，请检查。",
        "P_YS_FED_FW_0000021673": "主维度",
        "P_YS_FED_IMP_IOT0000006140": "临安市",
        "P_YS_FED_IMP_IOT0000007471": "华亭县",
        "P_YS_SD_UDHWN_0000049719": "五家渠市",
        "P_YS_FED_FW_0000021678": "添加查询条件",
        "P_YS_FED_IMP_IOT0000006143": "太和县",
        "P_YS_FED_IMP_IOT0000007474": "红原县",
        "P_YS_FED_FW_0000021679": "暂时没有数据哦~(监控视图)",
        "P_YS_FED_IMP_IOT0000007473": "昭阳区",
        "P_YS_FED_FW_0000021676": "分组方案",
        "P_YS_FED_IMP_IOT0000006145": "河口区",
        "P_YS_FED_IMP_IOT0000007476": "志丹县",
        "P_YS_FED_FW_0000021677": "单据名称",
        "P_YS_FED_IMP_IOT0000006144": "西乌珠穆沁旗",
        "P_YS_OA_XTLCZX_0000030661": "上",
        "P_YS_FED_FW_0000021692": "点",
        "P_YS_FED_FW_0000021693": "获取图形报表数据Err 查询参数 =",
        "P_YS_FED_FW_0000021690": "·",
        "P_YS_OA_XTLCZX_0000030663": "下",
        "P_YS_FED_FW_0000021691": "数据模版名称",
        "P_YS_FED_FW_0001209438": "租户级扩展脚本有语法错误，请修改正确后刷新浏览器重试！",
        "P_YS_FED_IMP_IOT0000007467": "腾冲县",
        "P_YS_FED_IMP_IOT0000008799": "莱山区",
        "P_YS_FED_IMP_IOT0000007466": "芦淞区",
        "P_YS_FED_IMP_IOT0000006138": "昂昂溪区",
        "P_YS_FED_IMP_IOT0000007469": "铁山港区",
        "P_YS_FED_IMP_IOT0000008797": "阳谷县",
        "P_YS_FED_IMP_IOT0000007468": "桦南县",
        "P_YS_FED_IMP_IOT0000008798": "富川瑶族自治县",
        "P_YS_FED_FW_0000021685": "堆叠柱形图",
        "P_YS_FED_IMP_IOT0000008791": "余干县",
        "P_YS_FED_FW_0000021686": "操作全部成功共",
        "P_YS_FED_FW_0000021683": "英文",
        "P_YS_FED_IMP_IOT0000006130": "安龙县",
        "P_YS_FED_FW_0000021684": "冗余",
        "P_YS_FED_IMP_IOT0000008790": "赫山区",
        "P_YS_FED_FW_0000021689": "初始化",
        "P_YS_FED_IMP_IOT0000007463": "龙湾区",
        "P_YS_FED_IMP_IOT0000007462": "阳春市",
        "P_YS_FED_FW_0000021687": "设置界面 render",
        "P_YS_FED_IMP_IOT0000006134": "虹口区",
        "P_YS_FED_IMP_IOT0000007465": "八宿县",
        "P_YS_FED_IMP_IOT0000008793": "安平县",
        "P_YS_FED_UCFBASEDOC_0000025323": "入库",
        "P_YS_FED_FW_0000021688": "行业应用不可修改自定义项。",
        "P_YS_FED_IMP_IOT0000008794": "个旧市",
        "P_YS_OA_XTLCZX_0000030671": "下拉",
        "P_YS_FED_FW_0000021660": "单价精度",
        "P_YS_FED_FW_0001223748": "请连接蓝牙设备",
        "P_YS_FED_IMP_IOT_0001010667": "%d 秒",
        "P_YS_FED_IMP_IOT_0001010668": "YYYY年M月D日dddd HH:mm",
        "P_YS_FED_IMP_IOT0000007456": "莒南县",
        "P_YS_FED_FW_0000021658": "正在刷新，请稍后。。。",
        "P_YS_FED_IMP_IOT0000006127": "延吉市",
        "P_YS_FED_FW_0000021659": "我的公告",
        "P_YS_FED_IMP_IOT0000007457": "上林县",
        "P_YS_FED_IMP_IOT0000006128": "繁峙县",
        "P_YS_FED_UCFBASEDOC_0000025319": "验证码",
        "P_YS_FED_FW_0000021652": "名称:",
        "P_YS_FED_FW_0000021653": "正在导入(",
        "P_YS_FED_FW_0000021650": "停",
        "P_YS_FED_IMP_IOT0000007450": "金湖县",
        "P_YS_FED_FW_0000021651": "已选",
        "P_YS_FED_FW_0000021656": "必输",
        "P_YS_FED_FW_0000021657": "大屏汇总区域设置的自动刷新间隔错误。 refreshInterval",
        "P_YS_FED_IMP_IOT0000006120": "泸县",
        "P_YS_FED_IMP_IOT0000007451": "歙县",
        "P_YS_FED_FW_0000021654": "eChartWeather 获取当前所在城市：调用服务出错   params=",
        "P_YS_FED_IMP_IOT0000006123": "鄂伦春自治旗",
        "P_YS_FED_FW_0000021655": "请输入1-999数字",
        "P_YS_FED_IMP_IOT0000006122": "科尔沁左翼后旗",
        "P_YS_FED_IMP_IOT0000007453": "昭觉县",
        "P_YS_FED_FW_0000021670": "大屏方案 设计 eChartPanelDesigngetPreView Begin",
        "P_YS_OA_XTLCZX_0000030687": "开始时间",
        "P_YS_FED_FW_0000021671": "新增方案",
        "P_YS_SD_UDHWN_0001010211": "%s前",
        "P_YS_OA_XTGONGGAO_0000045819": "参照新增",
        "P_YS_FED_IMP_IOT0000008777": "方山县",
        "P_YS_FED_IMP_IOT0000007444": "宁蒗彝族自治县",
        "P_YS_FED_IMP_IOT0000008778": "崇安区",
        "P_YS_SD_UDHWN_0001010219": "%d 年",
        "P_YS_FED_FW_0000021669": "specialcom  cstyle预制错误！",
        "P_YS_FED_IMP_IOT0000006116": "延津县",
        "P_YS_FED_IMP_IOT0000007447": "黄骅市",
        "P_YS_FED_IMP_IOT0000007446": "乌尔禾区",
        "P_YS_FED_IMP_IOT0000008776": "灯塔市",
        "P_YS_FED_IMP_IOT0000007449": "乃东县",
        "P_YS_FED_IMP_IOT0000006117": "临桂县",
        "P_YS_FED_FW_0000021663": "项",
        "P_YS_FED_FW_0000021664": "，请检查。",
        "P_YS_FED_IMP_IOT0000008770": "鄂托克旗",
        "P_YS_FED_FW_0000021661": "数值字体大小设置不正确",
        "P_YS_FED_FW_0000021662": "· and运算符（&&：[规格型号]!=null&&[物料简称]!=null",
        "P_YS_FED_FW_0001415599": "自定义数量",
        "P_YS_FED_FW_0000021667": "主维度行数",
        "P_YS_FED_IMP_IOT0000007441": "蒙自县",
        "P_YS_FED_FW_0000021668": "列标题",
        "P_YS_FED_IMP_IOT0000008774": "华宁县",
        "P_YS_FED_FW_0000021665": "一维表存在没有匹配到二维表单元格的行。 index =",
        "P_YS_FED_FW_0000021666": "批改范围",
        "P_YS_FED_IMP_IOT0000008772": "新龙县",
        "P_YS_FED_EXAMP_0000020560": "计算效期/生产日期失败",
        "P_YS_FED_EXAMP_0000020555": "U订货下架数 :",
        "P_YS_FED_IMP_IOT0000008766": "合水县",
        "P_YS_FED_EXAMP_0000020554": "请先选择规格",
        "P_YS_FED_IMP_IOT0000007433": "兴平市",
        "P_YS_FED_IMP_IOT0000008767": "平舆县",
        "P_YS_FED_EXAMP_0000020557": "会员钱包状态不允许增加商品行！",
        "P_YS_FED_IMP_IOT0000007436": "顺昌县",
        "P_YS_FED_EXAMP_0000020556": "当前处于离线状态,不允许修改卡券业务类型",
        "P_YS_FED_IMP_IOT0000006104": "景宁畲族自治县",
        "P_YS_FED_IMP_IOT0000007435": "巴彦县",
        "P_YS_FED_EXAMP_0000020551": "姓名/手机号",
        "P_YS_FED_IMP_IOT0000007438": "请选择此字段",
        "P_YS_FED_EXAMP_0000020550": "暂不支持其他类型",
        "P_YS_FED_EXAMP_0000020553": "获取优惠券信息失败。错误信息 =",
        "P_YS_FED_IMP_IOT0000006109": "黄岛区",
        "P_YS_FED_IMP_IOT0000008768": "鸡东县",
        "P_YS_FED_EXAMP_0000020552": "退货原因不可为空。",
        "P_YS_FED_IMP_IOT0000008769": "太仓市",
        "P_YS_SD_SDMB_0000137925": "第五",
        "P_YS_FED_EXAMP_0000020559": "版本",
        "P_YS_FED_IMP_IOT0000007430": "惠安县",
        "P_YS_FED_IMP_IOT0000008762": "古城区",
        "P_YS_FED_EXAMP_0000020558": "：指需要现场销售制作的加工商品，如：咖啡、饮品等；现制商品不受业务参数“允许负出库”控制。",
        "P_YS_FED_IMP_IOT0000007432": "九龙县",
        "P_YS_FED_EXAMP_0000020571": "已经执行了优惠，不允许删行！",
        "P_YS_FED_IMP_IOT_0001010653": "YYYY年M月D日",
        "P_YS_FED_EXAMP_0000020570": "预订交货状态下,批号效期为必输！",
        "P_YS_FED_FW_0001079845": "，支持格式：",
        "P_YS_FED_FW_0001079846": "未配置",
        "P_YS_FED_EXAMP_0000020566": "微信",
        "P_YS_FED_IMP_IOT0000008755": "海城区",
        "P_YS_FED_EXAMP_0000020565": "卡券商品,请输入卡券号或卡券号范围",
        "P_YS_FED_IMP_IOT0000007422": "饶河县",
        "P_YS_FED_EXAMP_0000020568": "请先确认称重商品",
        "P_YS_FED_IMP_IOT0000007425": "开江县",
        "P_YS_FED_IMP_IOT0000008753": "东安县",
        "P_YS_FED_EXAMP_0000020567": "积分",
        "P_YS_FED_EXAMP_0000020562": "违规下架原因",
        "P_YS_FED_EXAMP_0000020561": "获取是否启用会员钱包参数失败",
        "P_YS_FED_IMP_IOT0000007426": "麦盖提县",
        "P_YS_FED_EXAMP_0000020564": "非售卡状态不允许添加实体储值卡商品行！",
        "P_YS_FED_EXAMP_0000020563": "当前网络状况不能取金价！",
        "P_YS_FED_EXAMP_0000020569": "卡券商品原单退货不能选择其它商品！",
        "P_YS_FED_IMP_IOT0000008752": "淳化县",
        "P_YS_FED_IMP_IOT0000007421": "河间市",
        "P_YS_OA_XTLCZX_0000030616": "结束时间",
        "P_YS_FED_IMP_IOT0000007420": "兴隆县",
        "P_YS_FED_EXAMP_0000020580": "切换云地址",
        "P_YS_FED_IMP_IOT0000007419": "千阳县",
        "P_YS_FED_EXAMP_0000020582": "未录入商品，",
        "P_YS_FED_EXAMP_0000020581": "头像",
        "P_YS_OA_XTGONGGAO_0000045847": "撤销",
        "P_YS_FED_EXAMP_0000020577": "U订货未上架",
        "P_YS_FED_IMP_IOT0000008744": "南票区",
        "P_YS_FED_EXAMP_0000020576": "登录失败，用户不存在",
        "P_YS_FED_EXAMP_0000020579": "\"待退货审批！",
        "P_YS_FED_IMP_IOT0000007414": "昭平县",
        "P_YS_FED_IMP_IOT0000008742": "蕲春县",
        "P_YS_FED_EXAMP_0000020578": "商品\"",
        "P_YS_FED_EXAMP_0000020573": "商品(",
        "P_YS_FED_IMP_IOT0000007416": "阿荣旗",
        "P_YS_FED_IMP_IOT0000008748": "万盛区",
        "P_YS_FED_EXAMP_0000020572": "未获取到卡券[",
        "P_YS_FED_IMP_IOT0000008749": "石楼县",
        "P_YS_FED_EXAMP_0000020575": "分配积分信息失败。错误信息 =",
        "P_YS_FED_IMP_IOT0000007418": "隰县",
        "P_YS_FED_EXAMP_0000020574": "确定要退订吗?",
        "P_YS_FED_IMP_IOT0000008747": "代县",
        "P_YS_FED_FW_0000021696": "保存业务对象",
        "P_YS_FED_FW_0000021697": "上传图片：调用服务出错  info.file.response",
        "P_YS_FED_FW_0000021694": "图形报表_配置信息读取失败或者交叉表不支持图形显示 param =",
        "P_YS_FED_FW_0000021695": "汇总区域设置的自动刷新间隔错误。 refreshInterval",
        "P_YS_FED_FW_0001514845": "应用所属领域",
        "P_YS_FED_IMP_IOT0000008741": "塘沽区",
        "P_YS_FED_FW_0001514846": "暂无历史数据",
        "P_YS_FED_FW_0000021698": "监控视图汇总设置 触发事件 filterClick",
        "P_YS_FED_FW_0001514847": "暂无重试历史数据",
        "P_YS_FED_FW_0000021699": "用友软件园",
        "P_YS_FED_FW_0001514844": "历史日期",
        "P_YS_FED_EXAMP_0000020591": "未交货",
        "P_YS_FED_EXAMP_0000020590": "套餐价",
        "P_YS_FED_IMP_IOT0000007408": "咸丰县",
        "P_YS_FED_EXAMP_0000020593": "本店配送",
        "P_YS_FED_EXAMP_0000020592": "根据yxyToken获取token失败：【接口】",
        "P_YS_FED_IMP_IOT0000008733": "平顶山",
        "P_YS_FED_EXAMP_0000020588": "当前选中行不是序列号管理的商品,请检查!",
        "P_YS_FED_EXAMP_0000020587": "商品查询",
        "P_YS_FED_IMP_IOT0000007400": "秀山土家族苗族自治县",
        "P_YS_FED_IMP_IOT0000007403": "泽州县",
        "P_YS_FED_EXAMP_0000020589": "线上订单网络打印失败！",
        "P_YS_FED_EXAMP_0000020584": "上拉加载更多",
        "P_YS_FED_IMP_IOT0000008737": "沧源佤族自治县",
        "P_YS_FED_EXAMP_0000020583": "已经执行了：",
        "P_YS_FED_IMP_IOT0000007404": "龙江县",
        "P_YS_FED_EXAMP_0000020586": "变更",
        "P_YS_FED_EXAMP_0000020585": "发运",
        "P_YS_FED_IMP_IOT0000007406": "文成县",
        "P_YS_FED_UCFBASEDOC_0000025061": "角色编码",
        "P_YS_FED_IMP_IOT0000008609": "华龙区",
        "P_YS_FED_IMP_IOT0000009938": "荥经县",
        "P_YS_FED_FW_0000021836": "请求数据失败！",
        "P_YS_FED_FW_0001078150": "无效单据！",
        "P_YS_FED_IMP_IOT0000009932": "临夏县",
        "P_YS_FED_IMP_IOT0000010932": "三河市",
        "P_YS_FED_FW_0000021837": "保留外层边框",
        "P_YS_FED_IMP_IOT0000009933": "兴安县",
        "P_YS_FED_FW_0000021834": "维度导航树 查询返回的数据存在空树节点。行数据",
        "P_YS_FED_FW_0001295182": "您没有打开此单据的权限，确认关闭页面",
        "P_YS_FED_FW_0000021835": "设置汇总区_配置信息读取失败或者交叉表不支持 查询参数 =",
        "P_YS_FED_IMP_IOT0000010935": "五台县",
        "P_YS_FED_FW_0000021838": "没有查找到处理行需要的信息。",
        "P_YS_FED_IMP_IOT0000009934": "木兰县",
        "P_YS_FED_FW_0000021839": "工厂",
        "P_YS_FED_FW_0001432065": "网络开小差，请稍后重试~",
        "P_YS_SD_URETAIL_0001049126": "rebootSave_per保存服务错误！",
        "P_YS_FED_FW_0000021832": "最大",
        "P_YS_FED_FW_0000021833": "请购单打印模板1",
        "P_YS_FED_FW_0000021830": "名称长度不可超过10个字",
        "P_YS_FED_IMP_IOT0000010938": "温宿县",
        "P_YS_FED_FW_0000021831": "请输入小数位数",
        "P_YS_FED_IMP_IOT0000010939": "利津县",
        "P_YS_SD_SDOC_0000163818": "未返回数据",
        "P_YS_FED_IMP_IOT0000009927": "伍家岗区",
        "P_YS_FED_IMP_IOT0000009928": "独山县",
        "P_YS_PF_SOCD-E_0000317811": "刚果",
        "P_YS_FED_FW_0000021847": "所有信息-配置信息 config =",
        "P_YS_FED_FW_0000021848": "大于",
        "P_YS_FED_IMP_IOT0000009922": "永昌县",
        "P_YS_FED_FW_0000021845": "eChartPanelDesign cancelOpereate 设计模板取消操作",
        "P_YS_FED_FW_0000021846": "居左",
        "P_YS_FED_IMP_IOT0000009920": "章贡区",
        "P_YS_FED_IMP_IOT0000009925": "田阳县",
        "P_YS_FED_IMP_IOT0000010940": "平安县",
        "P_YS_FED_FW_0000021849": "操作列",
        "P_YS_FED_IMP_IOT0000010942": "山海关区",
        "P_YS_FED_FW_0000021840": "暂无数据！",
        "P_YS_FED_FW_0000021843": "下移当前行",
        "P_YS_FED_FW_0000021844": "联动下级",
        "P_YS_FED_FW_0000021841": "监控视图自动定时刷新。 renderTime",
        "P_YS_FED_IMP_IOT0000010949": "武隆县",
        "P_YS_FED_FW_0000021842": "图册",
        "P_YS_SD_URETAIL_0001049152": "删除缓存数据过程失败：",
        "P_YS_PF_PRINT_0000057698": "本币无税金额",
        "P_YS_FED_FW_0000021814": "分",
        "P_YS_FED_IMP_IOT0000009910": "湖口县",
        "P_YS_FED_IMP_IOT0000010954": "马尔康县",
        "P_YS_FED_FW_0000021815": "向右",
        "P_YS_FED_IMP_IOT0000010955": "天山区",
        "P_YS_FED_FW_0000021812": "请选择展示指标",
        "P_YS_FED_IMP_IOT0000010956": "察布查尔锡伯自治县",
        "P_YS_FED_FW_0000021813": "不等于",
        "P_YS_FED_IMP_IOT0000010957": "嫩江县",
        "P_YS_FED_FW_0000021818": "没有更多的可用的查询条件了...",
        "P_YS_PF_GZTTMP_0000074981": "不在列表中",
        "P_YS_FED_IMP_IOT0000009914": "黄州区",
        "P_YS_FED_FW_0000021819": "最多",
        "P_YS_FED_IMP_IOT0000009915": "波密县",
        "P_YS_FED_FW_0000021816": "缩小",
        "P_YS_FED_IMP_IOT0000009912": "惠山区",
        "P_YS_FED_FW_0000021817": "未启用",
        "P_YS_PF_METADATA_0001147963": "展示图片",
        "P_YS_FED_FW_0000021810": "汇总设置",
        "P_YS_FED_FW_0000021811": "按条件",
        "P_YS_FED_UCFBASEDOC_0000025038": "日结单销售日报_",
        "P_YS_FED_UCFBASEDOC_0000025036": "功能权限",
        "P_YS_SD_URETAIL_0001049164": "upLoaded表存入数据错误！",
        "P_YS_FED_IMP_IOT0000009908": "三台县",
        "P_YS_FED_FW_0000021825": "切换失败。",
        "P_YS_FED_FW_0000021826": "所有查询记录",
        "P_YS_FED_FW_0000021823": "请购单打印模板3",
        "P_YS_FED_FW_0000021824": "请购单打印模板2",
        "P_YS_PES_PES-BE_0001231166": "行重复",
        "P_YS_FED_FW_0000021829": "大屏轮播: 切换 beforeChange",
        "P_YS_FED_IMP_IOT0000009904": "安陆市",
        "P_YS_FED_IMP_IOT0000010962": "马山县",
        "P_YS_FED_FW_0000021827": "删行",
        "P_YS_FED_IMP_IOT0000009901": "工农区",
        "P_YS_FED_FW_0000021828": "撤销拆分",
        "P_YS_FED_IMP_IOT0000010964": "新河县",
        "P_YS_FED_FW_0001367336": "PredicateDatePicker_Popover referPopover",
        "P_YS_FED_FW_0000021821": "默认语种",
        "P_YS_FED_IMP_IOT0000010969": "榆次市",
        "P_YS_FED_FW_0000021822": "柱形图",
        "P_YS_FED_FW_0001066127": "不能超过20个字符",
        "P_YS_FED_FW_0000021820": "维度导航树 选择点的过滤项目",
        "P_YS_FED_UCFBASEDOC_0000025024": "点击查询库存静态报表",
        "P_YS_FED_UCFBASEDOC_0000025023": "导出",
        "P_YS_FED_FW_0000021880": "1、数值类型的字段支持进行四则运算、比较运算、逻辑运算，可组成简单的四则运算表达式、关系表达式、逻辑表达式。",
        "P_YS_FED_IMP_IOT_0000724760": "上一条",
        "P_YS_FED_EXAMP_0000019969": "验证码发送成功",
        "P_YS_FED_EXAMP_0000019968": "[公告] 门店销售业绩大PK的说明",
        "P_YS_FED_EXAMP_0000019967": ")启用了批次管理，请输入批号！",
        "P_YS_SD_UDHWN_0000049873": "个字符",
        "P_YS_FED_EXAMP_0000019973": "]没有指定默认货位！请录手工入货位！",
        "P_YS_FED_IMP_IOT0000010976": "保德县",
        "P_YS_FED_EXAMP_0000019972": "]请输入卡券号！",
        "P_YS_FED_EXAMP_0000019971": "已经执行促销，不能再修改退货信息",
        "P_YS_SD_UDHWS_0000118830": "数量：",
        "P_YS_FED_FW_0000021879": "交叉点",
        "P_YS_FED_EXAMP_0000019970": "请先选择单据",
        "P_YS_FED_IMP_IOT0000010979": "遵化市",
        "P_YS_FED_EXAMP_0000019977": "请求地址：",
        "P_YS_FED_IMP_IOT0000010972": "和政县",
        "P_YS_PF_GZTSYS_0000012211": "租户",
        "P_YS_FED_EXAMP_0000019976": "正在初始化，请稍后重试",
        "P_YS_FED_IMP_IOT0000010973": "玄武区",
        "P_YS_FED_EXAMP_0000019975": "卡券非原单退不允许修改数量",
        "P_YS_FED_EXAMP_0000019974": "加工方式说明",
        "P_YS_FED_IMP_IOT0000010975": "海陵区",
        "P_YS_FED_FW_0000021872": "· 日期类型字段：[成立时间]",
        "P_YS_FED_FW_0000021873": "控制录入长度",
        "P_YS_FED_FW_0000021870": "空",
        "P_YS_FED_FW_0000021871": "未选中",
        "P_YS_FED_FW_0000021876": "显示角度",
        "P_YS_FED_UCFBASEDOC_0000025017": "只读",
        "P_YS_FED_FW_0000021877": "居中",
        "P_YS_FED_FW_0000021874": "类型",
        "P_YS_FED_FW_0000021875": "宽度",
        "P_YS_FED_MDF-COMPS_0001573108": "物料名稱",
        "P_YS_FED_MDF-COMPS_0001573109": "表体-0528test",
        "P_YS_FED_MDF-COMPS_0001573106": "組號",
        "P_YS_FED_MDF-COMPS_0001573107": "移到",
        "P_YS_FED_FW_0000021890": "日语",
        "P_YS_FED_FW_0000021891": "匹配一维表的行时，当前行前面已经匹配过，请检查。 rows =",
        "P_YS_SD_URETAIL_0001049188": "删除多条数据过程失败！",
        "P_YS_FED_IMP_IOT0000010980": "静乐县",
        "P_YS_FED_EXAMP_0000019979": "按历史销量补货",
        "P_YS_FED_EXAMP_0000019978": "请先选择组织！",
        "P_YS_HR_HRJQ_0000055859": "开始日期",
        "P_YS_FED_EXAMP_0000019984": "请选择配送频次",
        "P_YS_FED_IMP_IOT0000010987": "沙坡头区",
        "P_YS_FED_EXAMP_0000019983": "请选择相同的会员进行结算",
        "P_YS_FED_FW_0000021889": "字体大小设置不正确",
        "P_YS_FED_EXAMP_0000019982": "错误代码:",
        "P_YS_FED_EXAMP_0000019981": ",实际收款：",
        "P_YS_HR_HRJQF_0000054172": "禁用",
        "P_YS_FED_EXAMP_0000019988": "套餐商品没有录入完毕！",
        "P_YS_PF_GZTSYS_0000012221": "品牌分组",
        "P_YS_FED_EXAMP_0000019987": "存在多个营业员，只能全额收款，是否继续",
        "P_YS_FED_IMP_IOT0000010984": "建昌县",
        "P_YS_FED_EXAMP_0000019986": "调整状态不允许增加商品行！",
        "P_YS_FED_IMP_IOT0000010985": "都昌县",
        "P_YS_FED_EXAMP_0000019985": "已存在",
        "P_YS_FED_FW_0000021883": "控制录入长度必须为1~255之间的整数!",
        "P_YS_FED_IMP_IOT_0000724756": "粘貼至末行",
        "P_YS_FED_MDF-COMPS_0001573100": "ycx文本",
        "P_YS_FED_FW_0000021884": "看板配置信息-模块配置-图表分组方案",
        "P_YS_FED_MDF-COMPS_0001573101": "表头-0528test",
        "P_YS_FED_FW_0000021881": "个汇总项",
        "P_YS_FED_IMP_IOT_0000724754": "審批",
        "P_YS_FED_FW_0000021882": "大屏方案 展现 constructor panelConfig",
        "P_YS_FED_FW_0000021887": "联系人电话",
        "P_YS_FED_MDF-COMPS_0001573104": "應收件數",
        "P_YS_FED_FW_0000021888": "添加更多查询条件",
        "P_YS_FED_MDF-COMPS_0001573105": "客户分类3",
        "P_YS_FED_FW_0000021885": "！！！分组信息缺失，默认为 product product_cCode product_cName",
        "P_YS_FED_MDF-COMPS_0001573102": "仓档案",
        "P_YS_SD_SDSD-FE_0001277778": "近3天",
        "P_YS_FED_FW_0000021886": "枚举项",
        "P_YS_FED_MDF-COMPS_0001573103": "主計量",
        "P_YS_FED_IMP_IOT0000010990": "海丰县",
        "P_YS_FED_IMP_IOT0000010991": "闻喜县",
        "P_YS_FED_EXAMP_0000019989": "没有可用的班次",
        "P_YS_FED_FW_0000021858": "辅维度",
        "P_YS_FED_EXAMP_0000019995": "服务正在更新，请稍等几秒后重试！",
        "P_YS_FED_IMP_IOT0000010998": "元宝区",
        "P_YS_FED_FW_0000021859": "，支持格式：PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF）",
        "P_YS_FED_EXAMP_0000019994": "套餐成员项数量对比关系需符合：",
        "P_YS_FED_FW_0000021856": "eChartWeather 获取当前所在城市 getLocalCity this.serieNum =",
        "P_YS_FED_FW_0001081771": "请求已经执行完毕！",
        "P_YS_FED_EXAMP_0000019993": "不能执行会员优惠",
        "P_YS_FED_FW_0000021857": "时间分隔符",
        "P_YS_FED_EXAMP_0000019992": "赠送金额",
        "P_YS_FED_EXAMP_0000019999": "店存入库",
        "P_YS_FED_IMP_IOT0000010994": "让胡路区",
        "P_YS_FED_EXAMP_0000019998": "买断房费不允许修改数量！",
        "P_YS_FED_IMP_IOT0000010995": "阜城县",
        "P_YS_FED_EXAMP_0000019997": "调试用户校验成功",
        "P_YS_SD_UDHWN_0000121761": "谷歌",
        "P_YS_FED_EXAMP_0000019996": "钱包可用余额不足, 不能快速结算",
        "P_YS_FED_IMP_IOT0000010997": "辛集市",
        "P_YS_HR_HRJQF_0000054160": "导入失败",
        "P_YS_FED_FW_0000021850": "前",
        "P_YS_FED_FW_0000021851": "名称不可为空。",
        "P_YS_FED_FW_0001457385": "请先保存!",
        "P_YS_FED_FW_0001457386": "变更日期:",
        "P_YS_FED_FW_0001457387": "变更说明:",
        "P_YS_FED_FW_0000021854": "正在加载..",
        "P_YS_FED_EXAMP_0000019991": "退品数量不能大于未出品数量！",
        "P_YS_FED_FW_0001457388": "...查看全部",
        "P_YS_FED_FW_0000021855": "生单操作完毕。",
        "P_YS_FED_EXAMP_0000019990": "请求参数：",
        "P_YS_FED_FW_0000021852": "刷新",
        "P_YS_HR_HRJXF_0000059668": "取消成功",
        "P_YS_FED_FW_0000021853": "请添加数据项到已选区域!",
        "P_YS_FED_IMP_IOT_0000724746": "導出",
        "P_YS_PF_PROCENTER_0000027111": "修改",
        "P_YS_SCM_USTOCK_0001078433": "收货完成率",
        "P_YS_FED_FW_0000021869": "选择全部",
        "P_YS_FED_FW_0000021867": "明细",
        "P_YS_FED_FW_0000021868": "没有数据",
        "P_YS_PF_GZTSYS_0000012205": "会员级别",
        "P_YS_FED_IMP_IOT_0000724739": "下一条",
        "P_YS_FED_FW_0000021861": "居下",
        "P_YS_FED_FW_0000021862": "居上",
        "P_YS_FED_IMP_IOT_0000724733": "刪行",
        "P_YS_FED_FW_0000021860": "数据库 eChartConfig",
        "P_YS_FED_IMP_IOT_0000724731": "重新上傳",
        "P_YS_FED_FW_0000021865": "未搜索到匹配的行！",
        "P_YS_FED_IMP_IOT_0000724738": "粘贴至末行",
        "P_YS_FED_FW_0000021866": "请选择适用于PC/移动。",
        "P_YS_FED_IMP_IOT_0000724737": "導入模板下載",
        "P_YS_FED_FW_0000021863": "良",
        "P_YS_FED_FW_0000021864": "清除背景图",
        "P_YS_FI_FIEFP-UI_0001288287": "多包含",
        "P_YS_FED_EXAMP_0000019926": "]未找到卡券对应结算方式，请设置卡券门店收款方式！",
        "P_YS_FED_EXAMP_0000019925": "尚未开房，不能交货",
        "P_YS_FED_EXAMP_0000019924": "储值业务类型下充值不能使用储值卡支付",
        "P_YS_FED_EXAMP_0000019923": "未选中商品",
        "P_YS_FED_EXAMP_0000019929": "密码不能为空",
        "P_YS_FED_EXAMP_0000019928": "不存在卡券号管理的商品行!",
        "P_YS_FED_EXAMP_0000019927": "调整状态不允许执行优惠券！",
        "P_YS_FED_EXAMP_0000019933": "分摊优惠券失败。信息:",
        "P_YS_FED_EXAMP_0000019932": "本单使用了优惠券收款方式，不允许修改商品数量",
        "P_YS_FED_EXAMP_0000019931": "邮箱",
        "P_YS_FED_FW_0001566083": "清空并返回",
        "P_YS_FED_EXAMP_0000019930": ",商品行金额合计为：",
        "P_YS_FED_EXAMP_0000019937": "获取时段信息！",
        "P_YS_FED_EXAMP_0000019936": "退货行不允许改零售价",
        "P_YS_FED_EXAMP_0000019935": "（房间号）非空闲状态，请重新选择",
        "P_YS_FED_EXAMP_0000019934": "商品行不能为空！",
        "P_YS_FED_EXAMP_0000019939": "确定",
        "P_YS_FED_EXAMP_0000019938": "门店名称",
        "P_YS_FED_EXAMP_0000019940": "未取得商品的SKU!",
        "P_YS_FED_EXAMP_0000019944": "状态下，不能挂单！",
        "P_YS_FED_EXAMP_0000019943": "开始时间不能晚于或等于结束时间",
        "P_YS_FED_EXAMP_0000019942": "物品识别服务器连上不上或连接超时！",
        "P_YS_FED_EXAMP_0000019941": "未找到该卡券号对应卡券商品！",
        "P_YS_FED_MDF-COMPS_0001573117": "提交時間",
        "P_YS_FED_MDF-COMPS_0001573118": "自定義項目測試202008060001",
        "P_YS_FED_EXAMP_0000019948": "充值金额",
        "P_YS_FED_EXAMP_0000019947": "电商结算失败",
        "P_YS_FED_EXAMP_0000019946": "当前网络状况不能查询可用量！",
        "P_YS_FED_EXAMP_0000019945": "没有选中序列号行，无法批量指定,请检查!",
        "P_YS_FED_EXAMP_0000019949": "卡券状态不允许执行该操作 请重新开单",
        "P_YS_FED_EXAMP_0000019951": "工作日送",
        "P_YS_FED_EXAMP_0000019950": "该商品行不允许改行！",
        "P_YS_FED_EXAMP_0000019955": "充值金额为空",
        "P_YS_FED_FW_0001272432": "拍摄模糊",
        "P_YS_FED_EXAMP_0000019954": "会员优惠",
        "P_YS_FED_FW_0001272431": "信息不完整，请完善",
        "P_YS_FED_EXAMP_0000019953": "当前网络状况不能执行促销赠品！",
        "P_YS_FED_FW_0001272434": "边框缺失",
        "P_YS_FED_EXAMP_0000019952": "存在商品行，不允许调整！",
        "P_YS_FED_FW_0001272433": "曝光过度",
        "P_YS_FI_YYFI-UI_0001096480": "子表行",
        "P_YS_FED_FW_0001272436": "上传身份证",
        "P_YS_FED_MDF-COMPS_0001573111": "ycx檔案類型",
        "P_YS_FED_FW_0000177620": "输入内容",
        "P_YS_FED_FW_0001272435": "资料填写",
        "P_YS_FED_MDF-COMPS_0001573112": "likun-表体自定义项[文本]",
        "P_YS_FED_MDF-COMPS_0001573110": "枚舉",
        "P_YS_FED_MDF-COMPS_0001573115": "上游單據號",
        "P_YS_FED_MDF-COMPS_0001573116": "保質期單位",
        "P_YS_FED_MDF-COMPS_0001573113": "物料編碼",
        "P_YS_FED_MDF-COMPS_0001573114": "倉庫",
        "P_YS_PF_PROCENTER_0000027156": "查看更多",
        "P_YS_FED_EXAMP_0000019959": "，是否重新选择操作员？",
        "P_YS_FED_EXAMP_0000019958": "金额",
        "P_YS_FED_EXAMP_0000019957": "卡券号与商品数量不等,请检查",
        "P_YS_FED_EXAMP_0000019956": "记次券",
        "P_YS_FED_EXAMP_0000019962": "系统设置",
        "P_YS_FED_FW_0001122799": "恢复为",
        "P_YS_FED_EXAMP_0000019961": "还可以输入",
        "P_YS_FED_EXAMP_0000019960": "领卡时间",
        "P_YS_FED_FW_1572432323657859076": "直接返回将清空本次编辑内容",
        "P_YS_FED_EXAMP_0000019966": "计时房费",
        "P_YS_FED_EXAMP_0000019965": "双休日送",
        "P_YS_FED_EXAMP_0000019964": "状态下，不允许删除商品！",
        "P_YS_FED_EXAMP_0000019963": "该商品不支持选配!",
        "P_YS_FED_FW_1580622998083207174": "只允许精准搜索",
        "P_YS_FED_FW_0000021809": "至",
        "P_YS_FED_FW_1472458481506189318": "searchDevices complete，信息：",
        "P_YS_FED_FW_1472458481506189315": "获取已连接的设备信息失败：",
        "P_YS_FED_FW_0000021803": "辅维度行数不可大于5",
        "P_YS_FED_FW_0000021804": "批改",
        "P_YS_FED_FW_0000021801": "*模板编码:",
        "P_YS_FED_FW_0000021802": "支持多选，最多选择",
        "P_YS_FED_FW_0000021807": "降序",
        "P_YS_FED_EXAMP_0000019900": "时间区间最多允许跨一天！请重新选择时间!",
        "P_YS_FED_FW_1472458481506189312": "searchDevices failed，错误信息：",
        "P_YS_FED_FW_0000021808": "模板编码/模板名称必输！",
        "P_YS_FED_FW_0000021805": "展现",
        "P_YS_FED_FW_0000021806": "区间",
        "P_YS_FED_FW_0000021800": "符合条件的分组方案(displayStyle == 2 or 3,移动看板则需要isMobile == true)中没有找到任何分组方案。",
        "P_YS_FED_EXAMP_0000019909": "业务类型",
        "P_YS_FED_EXAMP_0000019904": "本单使用了优惠券收款方式，请整单退货",
        "P_YS_FED_FW_0001318326": "filterId查询报错",
        "P_YS_FED_EXAMP_0000019903": "挂单",
        "P_YS_FED_EXAMP_0000019902": "营业概览",
        "P_YS_FED_EXAMP_0000019901": "更新成功",
        "P_YS_FED_EXAMP_0000019908": "行商品行营业员为空！请分配营业员！",
        "P_YS_FED_EXAMP_0000019907": "业务类型非储值且开单行非空, 不允许充值",
        "P_YS_FED_EXAMP_0000019906": "更多",
        "P_YS_FED_EXAMP_0000019905": "\"定制改型\"为\"改型\"时，商品(",
        "P_YS_FED_FW_1472458481506189327": "缺少YYEsnBridge,方法丢失",
        "P_YS_FED_FW_1472458481506189324": "未连接到打印设备,请按打印设备配网说明书配网或尝试重启打印设备",
        "P_YS_FED_EXAMP_0000019911": "未收款金额",
        "P_YS_FED_EXAMP_0000019910": "打印小票失败！",
        "P_YS_FED_FW_1472458481506189321": "未搜索到打印设备,请先扫描打印机上的二维码,配置网络或尝试重启打印设备",
        "P_YS_PF_SOCD-G_0000934651": "小王",
        "P_YS_FED_EXAMP_0000019915": "请先取消",
        "P_YS_FED_FW_0001246115": "code: 999 服务端逻辑异常!",
        "P_YS_FED_FW_0001290394": "imgUrl : 不存在",
        "P_YS_FED_FW_1536786620552839169": "销售订单-即时分析",
        "P_YS_FED_EXAMP_0000019914": "常用功能",
        "P_YS_FED_UCFBASEDOC_0000025070": "请输入对角色的简单描述",
        "P_YS_FED_FW_0001290395": "蓝牙未开启",
        "P_YS_FED_EXAMP_0000019913": "暂不支持多种支付方式退订~",
        "P_YS_FED_EXAMP_0000019912": "卡券商品[",
        "P_YS_FED_EXAMP_0000019919": "退款失败, 金额为",
        "P_YS_FED_FW_0001319664": "测试一下",
        "P_YS_FED_EXAMP_0000019918": "退货行退货原因不能为空!",
        "P_YS_FED_FW_0001319665": "存在重复行，第<%=index1%>, <%=index2%>行重复",
        "P_YS_FED_EXAMP_0000019917": "储值卡非原单退功能",
        "P_YS_FED_EXAMP_0000019916": "密码确认",
        "P_YS_FED_FW_0001290393": "获取图片失败",
        "P_YS_HR_HRCOREF_0000058569": "正在导入",
        "P_YS_FED_FW_1472458481506189336": "getConnectedDevice执行成功，但是未获取到已连接设备",
        "P_YS_FED_FW_1472458481506189333": "printPicture failed，错误信息：",
        "P_YS_FED_EXAMP_0000019922": "]的卡券号，不能执行",
        "P_YS_FED_EXAMP_0000019921": "当前操作员无卡券非原单退权限",
        "P_YS_FED_EXAMP_0000019920": "选择营业员",
        "P_YS_FED_FW_1472458481506189330": "搜索打印设备失败,错误信息：",
        "P_YS_OA_XTLCZX_0000030377": "结束",
        "P_YS_FI_FCWEB_0001324088": "未连接多语中心的词条:",
        "P_YS_FI_FCWEB_0001324089": "不存在,请检查词条!",
        "P_YS_FED_IMP_IOT0000006094": "青山湖区",
        "P_YS_FED_IMP_IOT0000006096": "松山区",
        "P_YS_OA_XTLCZX_0000030396": "指派",
        "P_YS_FED_IMP_IOT0000006091": "宿松县",
        "P_YS_FED_IMP_IOT0000006093": "铁力市",
        "P_YS_FED_IMP_IOT0000006092": "绥德县",
        "P_YS_FED_FW_1564919833163202571": "拖拽：可以自定义上下表格的高度",
        "P_YS_FED_IMP_IOT0000006083": "兴城市",
        "P_YS_FED_IMP_IOT0000006086": "新津县",
        "P_YS_FED_IMP_IOT0000006089": "龙华区",
        "P_YS_FED_IMP_IOT0000006080": "甘井子区",
        "P_YS_FED_IMP_IOT0000006082": "资兴市",
        "P_YS_FED_IMP_IOT0000006081": "琼结县",
        "P_YS_HR_HRYGF_0000055713": "全部分类",
        "P_YS_FED_FW_1564919833163202562": "双击：可将上下布局变为左右布局",
        "P_YS_FED_FW_1564919833163202565": "拖拽：可以自定义左右表格的宽度",
        "P_YS_FED_IMP_IOT0000006072": "芮城县",
        "P_YS_FED_IMP_IOT0000006075": "樊城区",
        "P_YS_SD_SDMB_0000146326": "珠宝",
        "P_YS_FED_IMP_IOT0000006077": "固阳县",
        "P_YS_FED_IMP_IOT0000006079": "崆峒区",
        "P_YS_FED_FW_1564919833163202568": "双击：可将左右布局变为上下布局",
        "P_YS_HR_HRJQF_0000066215": "请输入员工姓名",
        "P_YS_FED_IMP_IOT0000006069": "滨湖区",
        "P_YS_FED_IMP_IOT0000007393": "左云县",
        "P_YS_FED_IMP_IOT0000006061": "奈曼旗",
        "P_YS_FED_IMP_IOT0000007392": "白云矿区",
        "P_YS_FED_IMP_IOT0000006064": "谢家集区",
        "P_YS_OA_XTLCZX_0000030325": "上传",
        "P_YS_FED_IMP_IOT0000007394": "新乐市",
        "P_YS_FED_IMP_IOT0000006068": "迎江区",
        "P_YS_FED_IMP_IOT0000007399": "清浦区",
        "P_YS_FED_IMP_IOT0000006060": "青州市",
        "RPA_L7_00050014": "确认要删除吗？",
        "P_YS_FED_IMP_IOT0000007389": "西充县",
        "P_YS_FED_FW_0001236707": "至过去",
        "P_YS_FED_IMP_IOT0000006051": "北戴河区",
        "P_YS_FED_IMP_IOT0000006050": "长武县",
        "P_YS_FED_IMP_IOT0000006052": "通海县",
        "P_YS_FED_IMP_IOT0000007383": "康马县",
        "P_YS_FED_IMP_IOT0000006055": "浮梁县",
        "P_YS_FED_IMP_IOT0000007386": "弥渡县",
        "P_YS_FED_FW_0001236706": "至未来",
        "P_YS_FED_IMP_IOT0000007388": "石景山区",
        "P_YS_OA_app_xtyyjm_0000035731": "生效",
        "P_YS_FED_IMP_IOT0000007387": "新邵县",
        "P_YS_OA_XTLCZX_0000030351": "显示",
        "P_YS_FED_FW_0001277251": "交互规则解析错误：",
        "P_YS_FED_FW_0001072028": "当前已经有8个汇总项，不可再增加公式",
        "P_YS_HR_HRJQF_0000066237": "最近",
        "P_YS_FED_FW_0001277253": "%c绑定事件",
        "P_YS_FED_FW_0001277252": "%c执行动作：",
        "P_YS_FED_IMP_IOT0000006048": "防城区",
        "P_YS_FED_IMP_IOT0000007379": "青神县",
        "P_YS_FED_FW_0001087994": "请修改后重试；",
        "P_YS_FED_FW_1607526372569776128": "获取上下文信息失败：【接口】",
        "P_YS_FED_IMP_IOT0000006040": "石台县",
        "P_YS_FED_IMP_IOT0000007371": "额济纳旗",
        "P_YS_FED_IMP_IOT0000007370": "平陆县",
        "P_YS_FED_IMP_IOT0000006042": "贵池区",
        "P_YS_FED_IMP_IOT0000007373": "大宁县",
        "P_YS_OA_XTLCZX_0000030347": "已上传",
        "P_YS_FED_IMP_IOT0000006044": "蝶山区",
        "P_YS_FED_IMP_IOT0000007375": "南溪县",
        "P_YS_FED_IMP_IOT0000006046": "长海县",
        "P_YS_FED_IMP_IOT0000007377": "峰峰矿区",
        "P_YS_FED_IMP_IOT0000006045": "仁化县",
        "P_YS_OA_XTLCZX_0000030361": "审批流程",
        "P_YS_OA_XTLCZX_0000030367": "请输入数字",
        "P_YS_FED_FW_0001209138": "查看单据详情",
        "P_YS_FED_IMP_IOT0000007368": "高陵县",
        "P_YS_FED_IMP_IOT0000008698": "大石桥市",
        "P_YS_FED_IMP_IOT0000006038": "郯城县",
        "P_YS_FED_IMP_IOT0000007369": "安源区",
        "P_YS_FED_IMP_IOT0000008699": "通川区",
        "P_YS_FED_IMP_IOT0000007362": "环翠区",
        "P_YS_FED_IMP_IOT0000006030": "福安市",
        "P_YS_FED_IMP_IOT0000008691": "长兴县",
        "P_YS_HR_HRCOREF_0000058606": "身份证",
        "P_YS_FED_IMP_IOT0000008697": "修武县",
        "P_YS_FED_IMP_IOT0000007365": "蒲江县",
        "P_YS_FED_IMP_IOT0000008695": "木里藏族自治县",
        "P_YS_SD_UDHWN_0000050822": "青浦区",
        "P_YS_SD_UDHWN_0000049836": "儋州市",
        "P_YS_PF_PRINT_0000057631": "表体自定义项7",
        "P_YS_PF_PRINT_0000057630": "表体自定义项8",
        "P_YS_SD_SDMA_0000123136": "主页",
        "P_YS_FED_IMP_IOT0000007357": "德庆县",
        "P_YS_FED_IMP_IOT0000008689": "日土县",
        "P_YS_FED_IMP_IOT0000006025": "洪湖市",
        "P_YS_FED_IMP_IOT0000007356": "爱民区",
        "P_YS_FED_IMP_IOT0000006028": "资溪县",
        "P_YS_FED_IMP_IOT0000007359": "法库县",
        "P_YS_FED_IMP_IOT0000008687": "德钦县",
        "P_YS_FED_IMP_IOT0000006027": "新丰县",
        "P_YS_FED_IMP_IOT0000007358": "汾阳市",
        "P_YS_FED_IMP_IOT0000006029": "崇义县",
        "P_YS_FED_FW_0000021795": "显示日期",
        "P_YS_FED_IMP_IOT0000008681": "吴中区",
        "P_YS_QMS_QMS-QIT-WALSIN-MD_1545738062544242278": "选用",
        "P_YS_FED_FW_0000021796": "确定要删除",
        "P_YS_FED_FW_0000021793": "原始gridmodel没数据",
        "P_YS_FED_IMP_IOT0000006020": "乌兰浩特市",
        "P_YS_FED_IMP_IOT0000007351": "裕安区",
        "P_YS_OA_app_xtyyjm_0000035760": "选择年",
        "P_YS_FED_FW_0000021794": "选择需要添加至常用功能的菜单",
        "P_YS_FED_IMP_IOT0000007350": "鹿邑县",
        "P_YS_FED_FW_0000021799": "保存中~",
        "P_YS_FED_IMP_IOT0000008685": "龙山县",
        "P_YS_FED_IMP_IOT0000007352": "番禺区",
        "P_YS_FED_IMP_IOT0000008686": "兴仁县",
        "P_YS_FED_FW_0000021797": "报表没有设置汇总字段，请检查。",
        "P_YS_FED_IMP_IOT0000006024": "洛江区",
        "P_YS_FED_IMP_IOT0000008683": "唐县",
        "P_YS_FED_FW_0000021798": "大屏轮播：调用服务出错  json.message",
        "P_YS_FED_IMP_IOT0000008684": "宣化区",
        "P_YS_SD_UDHWN_0000048515": "保亭黎族苗族自治县",
        "P_YS_FED_IMP_IOT0000007346": "平山县",
        "P_YS_FED_IMP_IOT0000008678": "禅城区",
        "P_YS_FED_IMP_IOT_0000724719": "机构图",
        "P_YS_FED_IMP_IOT0000006017": "垣曲县",
        "P_YS_FED_IMP_IOT0000007348": "加查县",
        "P_YS_FED_IMP_IOT0000008676": "渑池县",
        "P_YS_FED_IMP_IOT0000006016": "汝州市",
        "P_YS_FED_IMP_IOT0000008677": "平度市",
        "P_YS_FED_IMP_IOT0000006019": "请搜索",
        "P_YS_FED_IMP_IOT0000008671": "大埔县",
        "P_YS_FED_IMP_IOT0000006011": "潍城区",
        "P_YS_FED_IMP_IOT0000007342": "门头沟区",
        "P_YS_FED_IMP_IOT0000008674": "新会区",
        "P_YS_FED_IMP_IOT0000007341": "和龙市",
        "P_YS_FED_IMP_IOT0000008675": "吐鲁番市",
        "P_YS_FED_IMP_IOT_0000724715": "第一條",
        "P_YS_FED_IMP_IOT0000008672": "新郑市",
        "P_YS_FED_FW_0001228293": "该单据无法编辑",
        "P_YS_FED_IMP_IOT_0000724713": "查詢",
        "P_YS_SD_UDHWN_0000048524": "玉树市",
        "P_YS_OA_app_xtyyjm_0000035788": "已发布",
        "P_YS_FED_FW_0000021780": "关联字段不允许修改！",
        "P_YS_FED_FW_0000021781": "您浏览的页面躲起来了～～",
        "P_YS_FED_IMP_IOT0000007335": "麻章区",
        "P_YS_FED_IMP_IOT0000008667": "理县",
        "P_YS_FED_IMP_IOT0000009998": "涞水县",
        "P_YS_FED_IMP_IOT_0000724709": "上一條",
        "P_YS_FED_FW_0000021779": "外半径百分比",
        "P_YS_FED_IMP_IOT0000008665": "兰坪白族普米族自治县",
        "P_YS_FED_IMP_IOT0000007339": "石嘴山",
        "P_YS_FED_IMP_IOT0000006008": "寻甸回族彝族自治县",
        "P_YS_FED_IMP_IOT0000006007": "依安县",
        "P_YS_FED_IMP_IOT0000007338": "黄浦区",
        "P_YS_PF_GZTSYS_0000013564": "其他出库",
        "P_YS_FED_FW_0000021773": "顶部插入行",
        "P_YS_OA_XTLCZX_0000030306": "多选",
        "P_YS_FED_IMP_IOT0000009990": "柳城县",
        "P_YS_FED_FW_0000021774": "法语",
        "P_YS_FED_IMP_IOT0000008660": "华安县",
        "P_YS_FED_FW_0000021771": "分公司",
        "P_YS_FED_FW_0000021772": "录入信息重复，请检查。",
        "P_YS_FED_FW_0000021777": "不包含",
        "P_YS_FED_IMP_IOT0000006000": "弥勒县",
        "P_YS_FED_IMP_IOT0000009994": "祁连县",
        "P_YS_FED_FW_0000021778": "显示比例",
        "P_YS_FED_IMP_IOT0000007330": "穆棱市",
        "P_YS_FED_FW_0000021775": "经度",
        "P_YS_FED_IMP_IOT0000006002": "龙马潭区",
        "P_YS_FED_IMP_IOT0000008661": "柳南区",
        "P_YS_FED_IMP_IOT0000009992": "当雄县",
        "P_YS_FED_FW_0000021776": "自定义过滤条件列表",
        "P_YS_FED_IMP_IOT0000007332": "谷城县",
        "P_YS_FED_IMP_IOT0000008662": "庄浪县",
        "P_YS_FED_IMP_IOT0000009993": "东城区",
        "P_YS_FED_IMP_IOT_0000724702": "最后一条",
        "P_YS_OA_PACK_0001100802": "请上传文件",
        "P_YS_PF_PRINT_0000057628": "表体自定义项3",
        "P_YS_PF_PRINT_0000057627": "表体自定义项4",
        "P_YS_FED_FW_0000021791": "天触发一次",
        "P_YS_PF_PRINT_0000057624": "表体自定义项5",
        "P_YS_FED_FW_0000021792": "预览",
        "P_YS_PF_PRINT_0000057622": "表体自定义项6",
        "P_YS_FED_FW_0000021790": "角",
        "P_YS_SD_UDHWN_0000049869": "琼中黎族苗族自治县",
        "P_YS_PF_PRINT_0000057621": "表体自定义项1",
        "P_YS_PF_PRINT_0000057620": "表体自定义项2",
        "P_YS_FED_IMP_IOT0000009987": "兴宁区",
        "P_YS_FED_IMP_IOT0000007323": "玛纳斯县",
        "P_YS_FED_IMP_IOT0000009986": "库尔勒市",
        "P_YS_FED_IMP_IOT0000007328": "千山区",
        "P_YS_FED_IMP_IOT0000009989": "鲅鱼圈区",
        "P_YS_FED_IMP_IOT0000007329": "隆阳区",
        "P_YS_FED_IMP_IOT0000008659": "安阳县",
        "P_YS_FED_FW_0000021784": "确定启用此条订阅吗？",
        "P_YS_FED_FW_0000021785": "包含",
        "P_YS_FED_FW_0000021782": "滚动计数显示方式只能显示一个字段",
        "P_YS_FED_FW_0000021783": "保存草稿",
        "P_YS_HR_HRRCPDF_0000058740": "搜索历史",
        "P_YS_FED_FW_0000021788": "请选择分组项。",
        "P_YS_FED_IMP_IOT0000008652": "招远市",
        "P_YS_FED_FW_0000021789": "秒",
        "P_YS_FED_IMP_IOT0000008653": "隆林各族自治县",
        "P_YS_FED_IMP_IOT0000009984": "合作市",
        "P_YS_FED_FW_0000021786": "热区信息",
        "P_YS_FED_IMP_IOT0000008650": "化州市",
        "P_YS_FED_FW_0000021787": "获取图形报表 /report/list 本次List请求结束 时间 （秒） =",
        "P_YS_FED_IMP_IOT0000008651": "大城县",
        "P_YS_OA_app_xtyyjm_0000035798": "同步",
        "P_YS_FED_IMP_IOT0000009977": "下城区",
        "P_YS_FED_IMP_IOT0000007315": "宣武区",
        "P_YS_FED_IMP_IOT0000008643": "铁西区",
        "P_YS_FED_IMP_IOT0000007314": "南木林县",
        "P_YS_FED_IMP_IOT0000008644": "郫县",
        "P_YS_FED_IMP_IOT0000009975": "永善县",
        "P_YS_FED_IMP_IOT0000008649": "浦城县",
        "P_YS_FED_IMP_IOT0000009978": "乌拉特后旗",
        "P_YS_FED_IMP_IOT0000007318": "房山区",
        "P_YS_FED_IMP_IOT0000008648": "昌黎县",
        "P_YS_IPAAS_UCG_0001072863": "安全",
        "P_YS_FED_IMP_IOT0000008641": "龙山区",
        "P_YS_FED_IMP_IOT0000008642": "华坪县",
        "P_YS_FED_IMP_IOT0000007311": "江干区",
        "P_YS_FED_IMP_IOT0000009971": "西岗区",
        "P_YS_FED_IMP_IOT0000007309": "疏附县",
        "P_YS_FED_IMP_IOT0000007302": "镇巴县",
        "P_YS_FED_IMP_IOT0000008634": "奇台县",
        "P_YS_FED_IMP_IOT0000009965": "和顺县",
        "P_YS_FED_IMP_IOT0000007301": "明光市",
        "P_YS_FED_IMP_IOT0000008635": "二七区",
        "P_YS_FED_FW_0001084078": "敏感数据",
        "P_YS_FED_IMP_IOT0000007304": "绥芬河市",
        "P_YS_FED_IMP_IOT0000009964": "永胜县",
        "P_YS_FED_IMP_IOT0000009969": "大同区",
        "P_YS_FED_IMP_IOT0000007308": "居巢区",
        "P_YS_FED_IMP_IOT0000007307": "格尔木市",
        "P_YS_FED_IMP_IOT0000009961": "庆云县",
        "P_YS_FED_IMP_IOT0000009962": "惠阳区",
        "P_YS_FED_IMP_IOT0000010906": "凤翔县",
        "P_YS_PF_PRINT_0000057651": "收款方式汇总",
        "P_YS_FED_IMP_IOT0000008629": "长垣县",
        "P_YS_FED_IMP_IOT0000008624": "郓城县",
        "P_YS_FED_IMP_IOT0000009955": "雁山区",
        "P_YS_FED_IMP_IOT0000010911": "冠县",
        "P_YS_FED_IMP_IOT0000009952": "万年县",
        "P_YS_FED_IMP_IOT0000010912": "镇海区",
        "P_YS_FED_IMP_IOT0000008622": "鹰手营子矿区",
        "P_YS_FED_IMP_IOT0000010913": "卢湾区",
        "P_YS_FED_IMP_IOT0000009958": "卢氏县",
        "P_YS_FED_IMP_IOT0000009959": "隆子县",
        "P_YS_FED_FW_0001084085": "敏感数据分组",
        "P_YS_FED_IMP_IOT0000008625": "姜堰市",
        "P_YS_FED_IMP_IOT0000009956": "通河县",
        "P_YS_FED_IMP_IOT0000008626": "海宁市",
        "P_YS_FED_IMP_IOT0000010919": "崇信县",
        "P_YS_IMP_WJM-UI_0001114297": "孙表",
        "P_YS_OA_XTMENHUCMS_0000044952": "佛山",
        "P_YS_FED_IMP_IOT0000010914": "道真仡佬族苗族自治县",
        "P_YS_FED_IMP_IOT0000008620": "秀峰区",
        "P_YS_FI_AR_0001121578": "正在处理",
        "P_YS_FED_IMP_IOT0000010916": "休宁县",
        "P_YS_FED_IMP_IOT0000010917": "八步区",
        "P_YS_FED_IMP_IOT0000008618": "土默特右旗",
        "P_YS_FED_FW_0001280803": "1、发送链接可邀请加入该单据的录入",
        "P_YS_FED_IMP_IOT0000008610": "南山区",
        "P_YS_FED_IMP_IOT0000010924": "巴塘县",
        "P_YS_FED_IMP_IOT0000008616": "张店区",
        "P_YS_FED_IMP_IOT0000008617": "沁阳市",
        "P_YS_FED_IMP_IOT0000009946": "灵山县",
        "P_YS_FED_IMP_IOT0000010920": "兴宁市",
        "P_YS_SD_UDHWN_0000049828": "神农架林区",
        "P_YS_FED_IMP_IOT0000010925": "五河县",
        "P_YS_FED_IMP_IOT0000009940": "江夏区",
        "P_YS_FED_IMP_IOT0000010927": "德安县",
        "P_YS_FED_IMP_IOT0000010928": "蓬溪县",
        "P_YS_HR_HRCOREF_0000058484": "学历",
        "P_YS_FED_FW_1588016191592464396": "[保存全部] 按钮从右上角移到了这里~",
        "P_YS_FED_FW_1588016191592464393": "按钮位置有更新哦~",
        "P_YS_FED_FW_0000021957": "拆分方向",
        "P_YS_FED_EXAMP_0000019896": "POS退款失败:",
        "P_YS_FED_FW_0000021958": "监控视图图表设置",
        "P_YS_FED_EXAMP_0000019895": "无标准重量信息！",
        "P_YS_FED_FW_0000021955": "汇总区域设置的自动刷新间隔太短。 refreshInterval",
        "P_YS_FED_EXAMP_0000019894": "补单日期不能小于预订日期！",
        "P_YS_FED_IMP_IOT0000010813": "盂县",
        "P_YS_FED_FW_0000021956": "大屏方案保存失败。err",
        "P_YS_FED_EXAMP_0000019893": "请先录入商品！",
        "P_YS_HR_HRPUBF_0001009300": "无匹配结果",
        "P_YS_FED_EXAMP_0000019899": "原单退货中，换货行不允许修改零售价！",
        "P_YS_FED_FW_0000021959": "控制",
        "P_YS_FED_EXAMP_0000019898": "挂单成功:",
        "P_YS_FED_EXAMP_0000019897": "查询缓存数据出错！",
        "P_YS_FED_IMP_IOT0000009814": "滨海县",
        "P_YS_FED_IMP_IOT0000010810": "克什克腾旗",
        "P_YS_FED_IMP_IOT0000010819": "太仆寺旗",
        "P_YS_FED_FW_0000021950": "十",
        "P_YS_FED_FW_0000021953": "背景图片不可为空",
        "P_YS_FED_EXAMP_0000019892": "会员卡号",
        "P_YS_FED_FW_0000021954": "系统项，不允许设计！",
        "P_YS_FED_EXAMP_0000019891": "网络不可用，必须使用上次登录的账号",
        "P_YS_FED_IMP_IOT0000010816": "大厂回族自治县",
        "P_YS_FED_FW_0000021951": "千",
        "P_YS_FED_EXAMP_0000019890": "业务类型必输！",
        "P_YS_FED_IMP_IOT0000010817": "元坝区",
        "P_YS_FED_FW_0000021952": "项目号",
        "P_YS_FED_IMP_IOT0000010818": "月湖区",
        "P_YS_FED_IMP_IOT0000009809": "徽县",
        "P_YS_FED_FW_0000021968": "跳转到Index =",
        "P_YS_FED_IMP_IOT0000009800": "轮台县",
        "P_YS_FED_FW_0000021969": "上传图片",
        "P_YS_FED_IMP_IOT0000009801": "睢阳区",
        "P_YS_FED_FW_0000021966": "menuUrl为空",
        "P_YS_FED_FW_0000021967": "比较符",
        "P_YS_FED_IMP_IOT0000010825": "大东区",
        "P_YS_FED_IMP_IOT0000009804": "莱阳市",
        "P_YS_FED_IMP_IOT0000009805": "林周县",
        "P_YS_FED_IMP_IOT0000010820": "南澳县",
        "P_YS_FED_FW_0000021960": "增行",
        "P_YS_FED_FW_0000021961": "失败信息",
        "P_YS_FED_FW_0000021964": "请核对以上信息是否正确，并确认房间内设备是否完好，配套物品请勿带走！若无问题请签字确认，谢谢！",
        "P_YS_FED_FW_0000021965": "eChartDisplay状态改变 shouldComponentUpdate  查询条件 changed End True",
        "P_YS_FED_FW_0000021962": "是否显示",
        "P_YS_FED_FW_0000021963": "大屏汇总区域设置的自动刷新间隔太短。 refreshInterval",
        "P_YS_FED_IMP_IOT0000010829": "彭州市",
        "P_YS_FED_FW_0000177590": "沿用原报表权限",
        "P_YS_FED_FW_0000177591": "更新!",
        "P_YS_FED_FW_0000177592": "公式引用不可取消",
        "P_YS_FED_FW_0000177593": "请选择PC或移动",
        "P_YS_FED_FW_0000177594": "公式不可清空",
        "P_YS_FED_FW_0000177595": "中文",
        "P_YS_FED_UCFBASEDOC_0000025160": "权限",
        "P_YS_FED_FW_0000177596": "已被此公式引用，不可循环引用",
        "P_YS_FED_FW_0000021935": "请选中一行后增加！",
        "P_YS_FED_IMP_IOT0000010833": "玉泉区",
        "P_YS_FED_IMP_IOT0000010834": "龙胜各族自治县",
        "P_YS_FED_FW_0000021933": "大屏方案 设计 getDesignColType_Title curCol",
        "P_YS_FED_IMP_IOT0000010835": "纳雍县",
        "P_YS_FED_FW_0000021934": "过滤表达式说明:",
        "P_YS_FED_IMP_IOT0000010836": "耿马傣族佤族自治县",
        "P_YS_FED_FW_0000021939": "确定么",
        "P_YS_FED_IMP_IOT0000010830": "肥东县",
        "P_YS_FED_FW_0000021937": "内外半径",
        "P_YS_FED_FW_0000021938": "请输入定位内容",
        "P_YS_FED_FW_0000177586": "公式别名不可为空",
        "P_YS_FED_FW_0000177587": "精度值",
        "P_YS_FED_FW_0000177588": "确定删除此自定义公式么？",
        "P_YS_FED_FW_0000177589": "非数值列不允许修改此属性！",
        "P_YS_FED_FW_0000021931": "新增过滤项",
        "P_YS_FED_IMP_IOT0000010837": "荣成市",
        "P_YS_FED_FW_0000021932": "请输入公司名称",
        "P_YS_FED_FW_0000021930": "曲线图",
        "P_YS_FED_FW_0001152737": "导入记录",
        "P_YS_FED_FW_0001152738": "查看导入历史",
        "P_YS_FED_FW_0000021946": "没有选择列信息。",
        "P_YS_FED_IMP_IOT0000010844": "布拖县",
        "P_YS_FED_FW_0000021947": "多语言设置",
        "P_YS_FED_FW_0000021944": "增加图形报表",
        "P_YS_FED_FW_0000021945": "热区显示图 初始化 cStyle =",
        "P_YS_FED_FW_0000021948": "分类",
        "P_YS_FED_FW_0000021949": "最大长度为50个字符",
        "P_YS_FED_FW_0000177597": "立即升级",
        "P_YS_FED_FW_0000177598": "已经存在当前菜单，是否覆盖PC端",
        "P_YS_FED_FW_0000177599": "重新获取?",
        "P_YS_OA_XTMENHUCMS_0000044985": "组件",
        "P_YS_FED_FW_0000021942": "报表设置不自动刷新。 refreshInterval",
        "P_YS_FED_FW_0000021943": "部件",
        "P_YS_FED_FW_0000021940": "看板配置信息-模块配置-汇总",
        "P_YS_FED_FW_0001367218": "选中匹配项",
        "P_YS_FED_FW_0000021941": "德语",
        "P_YS_FED_FW_0001367219": "取消匹配项",
        "P_YS_PF_PROCENTER_0000027267": "默认组织",
        "P_YS_PF_PROCENTER_0000027268": "结算",
        "P_YS_SD_SDOC-UI_0000175089": "关闭状态",
        "P_YS_PF_PROCENTER_0000027262": "保存为草稿",
        "P_YS_FED_EXAMP_0000019849": "当前网络状况不能执行最低价格！",
        "P_YS_FED_EXAMP_0000019848": "，不能再新增商品！",
        "P_YS_FED_EXAMP_0000019847": "已存在商品行，不能进行",
        "P_YS_FED_EXAMP_0000019846": "结算费率",
        "P_YS_FED_FW_0001271292": "当前变更记录为空",
        "P_YS_FED_EXAMP_0000020830": "当前业务类型不能售卡",
        "P_YS_FED_EXAMP_0000019852": "实收金额不等于应收金额。",
        "P_YS_FED_EXAMP_0000019851": "获取打印模板失败：",
        "P_YS_FED_FW_0000021999": "对应的行。",
        "P_YS_FED_EXAMP_0000019850": "品牌列表",
        "P_YS_FED_EXAMP_0000020832": "非原单退货",
        "P_YS_FED_IMP_IOT0000010857": "文峰区",
        "P_YS_FED_EXAMP_0000020831": "隔天送",
        "P_YS_FED_EXAMP_0000019856": "获取积分信息失败。信息:",
        "P_YS_FED_IMP_IOT0000010851": "聂荣县",
        "P_YS_FED_EXAMP_0000019855": "价格",
        "P_YS_FED_EXAMP_0000019854": "当前行不参与折扣计算/金额为零，不能执行现场折扣",
        "P_YS_FED_EXAMP_0000019853": "当前操作员没有设置此分类商品的现场折扣权限",
        "P_YS_FED_IMP_IOT0000010854": "宁城县",
        "P_YS_FED_FW_0000021993": "无对应值",
        "P_YS_FED_EXAMP_0000020838": "卡券商品请输入卡券号",
        "P_YS_FED_FW_0000021994": "设为默认",
        "P_YS_FED_EXAMP_0000020837": "定制类型不允许删行！",
        "P_YS_SD_SDMAUF_0000152050": "添加图标",
        "P_YS_FED_FW_0000021991": "cEnumString，预制错误！",
        "P_YS_FED_FW_0000021992": "获取报表的所有分组方案列表服务返回异常。",
        "P_YS_FED_EXAMP_0000020839": "商品数量",
        "P_YS_FED_FW_0000021997": "数据模版管理",
        "P_YS_FED_EXAMP_0000020834": "我的待办",
        "P_YS_FED_FW_0000021998": "数据未更改~",
        "P_YS_FED_EXAMP_0000020833": "取消自动促销成功",
        "P_YS_FED_FW_0000021995": "上传背景图",
        "P_YS_FED_EXAMP_0000020836": "获取周边库存失败。信息 :",
        "P_YS_FED_FW_0000021996": "扩展类名_",
        "P_YS_FED_EXAMP_0000020835": "公司员工",
        "P_YS_FED_FW_0001050721": "确定删除栏目\"<%=cShowCaptionName%>\"么?",
        "P_YS_SD_SDMAUF_0000152068": "暂无信息",
        "P_YS_FED_UCFBASEDOC_0000025132": "打开",
        "P_YS_FED_FW_0001050720": "编辑<%=templateName%>",
        "P_YS_FED_UCFBASEDOC_0000025130": "100字以内",
        "P_YS_FED_EXAMP_0000019859": "会员钱包可用余额不足",
        "P_YS_FED_EXAMP_0000019858": "已经执行整单折扣，不能执行单行折扣，请取消折扣后重试！",
        "P_YS_FED_IMP_IOT0000010860": "凉州区",
        "P_YS_FED_EXAMP_0000019857": "硬件设备适配",
        "P_YS_FED_IMP_IOT0000010861": "二道江区",
        "P_YS_FED_EXAMP_0000019863": "值",
        "P_YS_FED_EXAMP_0000020841": "未录入客户，只能全额收款，是否继续",
        "P_YS_FED_EXAMP_0000019862": "请先录入要充值的会员",
        "P_YS_FED_EXAMP_0000020840": "”的规格，",
        "P_YS_FED_EXAMP_0000019861": "启用批次管理的表体行批号不能为空！",
        "P_YS_FED_EXAMP_0000020843": "通知公告",
        "P_YS_FED_FW_1535342643957989385": "按钮点击，调用RadioButtonGroup组件内部handleButtonClick方法开始",
        "P_YS_FED_EXAMP_0000020842": "序列号管理商品不允许修改数量！",
        "P_YS_FED_EXAMP_0000019860": "请填写需要更改的值",
        "P_YS_FED_IMP_IOT0000010869": "隆德县",
        "P_YS_FED_EXAMP_0000019867": "当前行不允许删除！",
        "P_YS_FED_EXAMP_0000019866": "请选择相同的客户进行结算",
        "P_YS_FED_FW_0001062705": "voucher->do——",
        "P_YS_FED_EXAMP_0000019865": "储值业务类型下不能使用储值卡支付",
        "P_YS_FED_EXAMP_0000019864": "未选择商品，不允许删行！",
        "P_YS_FED_IMP_IOT0000010865": "察哈尔右翼前旗",
        "P_YS_FED_EXAMP_0000020849": "调整状态不允许修改零售价！",
        "P_YS_FED_FW_0001204460": "不支持-",
        "P_YS_FED_EXAMP_0000020848": "会员钱包充值不允许修改数量",
        "P_YS_FED_FW_0001469273": "组织存在未生效的变更，不支持再次变更，请在生效后或删除未生效的变更，再次操作。",
        "P_YS_FED_EXAMP_0000020845": "￥",
        "P_YS_FED_EXAMP_0000020844": "未录入业务类型，请检查！",
        "P_YS_FED_EXAMP_0000020847": "未找到商品信息！",
        "P_YS_FED_EXAMP_0000020846": "的卡券号，不能执行",
        "P_YS_FED_EXAMP_0000019869": "启用缓存设置时，不能进行厨打，是否继续？",
        "P_YS_FED_IMP_IOT0000010871": "化隆回族自治县",
        "P_YS_FED_EXAMP_0000019868": "：指先预定再根据订单加工、入库、销售的商品，如：蛋糕、珠宝、其它订制品；定制商品受业务参数‘允许负出库’控制，但允许负可用。",
        "P_YS_FED_IMP_IOT0000010872": "右玉县",
        "P_YS_FED_FW_0000021979": "2、文本、日期、枚举、档案类型字段不支持进行四则运算、比较运算（=、!=除外）。因此这些类型字段一般都是选取字段本身作为表达式，或者组成等式表达式或简单逻辑表达式。",
        "P_YS_FED_EXAMP_0000020852": "储值卡充值",
        "P_YS_FED_EXAMP_0000019874": "提示优惠券金额将超出应收金额，是否继续？",
        "P_YS_FED_IMP_IOT0000010877": "汝南县",
        "P_YS_FED_EXAMP_0000019873": "储值卡售卡",
        "P_YS_FED_EXAMP_0000020851": "样品不支持选配！",
        "P_YS_FED_FW_0000021977": "存在过滤字段或者操作符为空的过滤行，请检查",
        "P_YS_FED_EXAMP_0000020854": "卡券商品原单退货,请输入卡券号",
        "P_YS_FED_EXAMP_0000019872": "套餐数量",
        "P_YS_FED_FW_0000021978": "封面",
        "P_YS_FED_EXAMP_0000020853": "销售分析",
        "P_YS_FED_EXAMP_0000019871": "删除",
        "P_YS_FED_EXAMP_0000019878": "应收金额必须大于等于零",
        "P_YS_FED_EXAMP_0000019877": "会员钱包可用余额不足或不适用全部商品",
        "P_YS_FED_IMP_IOT0000010874": "缙云县",
        "P_YS_FED_EXAMP_0000019876": "没有获取到当前序列号，无法自动指定,请检查!",
        "P_YS_FED_EXAMP_0000020850": "没有可以执行现场折扣的商品行",
        "P_YS_FED_IMP_IOT0000010875": "禄丰县",
        "P_YS_FED_EXAMP_0000019875": "预订状态不允许执行",
        "P_YS_FED_IMP_IOT0000010876": "察哈尔右翼中旗",
        "P_YS_FED_FW_0000021971": "显示名称",
        "P_YS_FED_FW_0000021972": "当前修改的二维表单元格没有在一维表匹配到行，请检查。data  =",
        "P_YS_FED_FW_0001050719": "查看<%=templateName%>",
        "P_YS_FED_FW_0000021975": "仅支持JPG、JPEG、BMP、PNG格式，文件小于1M（建议最佳尺寸144*60px）",
        "P_YS_FED_FW_0000021976": "匹配一维表的行时，有多个匹配行，请检查。 rows =",
        "P_YS_FED_FW_0000021973": "过滤条件",
        "P_YS_FED_FW_0000021974": "展示指标必选，且最多5项",
        "P_YS_SD_UDHWN_0000047368": "阿拉尔市",
        "P_YS_FED_FW_0000021990": "辅维度行数不可大于99",
        "P_YS_FED_IMP_IOT0000010882": "略阳县",
        "P_YS_FED_FW_1509407191866540036": "文本内容超出最大长度限制，请修改",
        "P_YS_FED_EXAMP_0000019879": "零售价字段请录入数字。",
        "P_YS_OA_XTHUATI_0000046180": "单选",
        "P_YS_FED_EXAMP_0000019885": "数量小数位",
        "P_YS_FED_IMP_IOT0000010888": "龙亭区",
        "P_YS_FED_EXAMP_0000019884": "未启用会员钱包",
        "P_YS_FED_IMP_IOT0000010889": "姚安县",
        "P_YS_FED_FW_0000021988": "移动端展现",
        "P_YS_FED_EXAMP_0000019883": "未查询到该卡券号信息",
        "P_YS_FED_FW_0000021989": "参照返回字段",
        "P_YS_FED_EXAMP_0000019882": "电商交货不可改状态下不能新增商品！",
        "P_YS_FED_EXAMP_0000019889": "默认收货地址",
        "P_YS_FED_IMP_IOT0000010884": "塔什库尔干塔吉克自治县",
        "P_YS_FED_FW_1546381431444340739": "点击按钮或按下空格键还原视图",
        "P_YS_FED_EXAMP_0000019888": "没有数量按钮的功能权限，不能操作",
        "P_YS_FED_EXAMP_0000019887": "电商结算成功",
        "P_YS_FED_IMP_IOT0000010886": "封开县",
        "P_YS_FED_EXAMP_0000019886": "储值卡",
        "P_YS_FED_FW_0000021982": "选项与主维度互斥",
        "P_YS_FED_FW_0000021983": "请输入模板名称",
        "P_YS_FED_UCFBASEDOC_0000025108": "点击查询销售静态报表",
        "P_YS_FED_FW_0000021980": "已经在图形报表中使用，不能删除。",
        "P_YS_FED_FW_0000021981": "默认值",
        "P_YS_FED_FW_0000021986": "大屏轮播:获取模板完毕。模板ID=",
        "P_YS_FED_EXAMP_0000019881": "违规下架原因：",
        "P_YS_FED_EXAMP_0000019880": "请支付剩余",
        "P_YS_FED_UCFBASEDOC_0000025104": "撤回",
        "P_YS_FED_FW_0000021984": "公司邮箱",
        "P_YS_FED_FW_0000021985": "删除草稿成功",
        "P_YS_SD_SDMBF_0000141424": "网店",
        "P_YS_FED_UCFORG_0000025904": "您确认要停用该组织及其下级组织与部门吗？",
        "P_YS_PF_PRINT_0000064968": "累计付款金额",
        "P_YS_SCM_USTOCK_0001084187": "预期可完成",
        "P_YS_FED_IMP_IOT0000010899": "印台区",
        "P_YS_SCM_USTOCK_0001084186": "按时完成率：所选时间范围内按时完成的订单行数/订单总行数。",
        "P_YS_FED_FW_0001321828": "缺少assignComp",
        "P_YS_FED_IMP_IOT0000010897": "勃利县",
        "P_YS_FED_IMP_IOT0000010898": "嵊泗县",
        "P_YS_FED_FW_0001321820": "重置列宽",
        "P_YS_SD_UDHMC_0000050989": "¥",
        "P_YS_FED_EXAMP_0000020809": "操作员",
        "P_YS_FED_EXAMP_0000020808": "名称",
        "P_YS_FED_FW_0001186101": "代理接口失败:",
        "P_YS_FED_FW_0000153548": "收款期初表头",
        "P_YS_FED_EXAMP_0000020805": "退货信息",
        "P_YS_FED_EXAMP_0000020804": "]零售价与券档案减免金额不符,请检查",
        "P_YS_FED_EXAMP_0000020807": "机构",
        "P_YS_FED_EXAMP_0000020806": "选择支付方式",
        "P_YS_FED_EXAMP_0000020800": "打开钱箱失败",
        "P_YS_FED_EXAMP_0000020803": "预订交货且“交货时可修改商品”为否, 不允许储值卡结算",
        "P_YS_FED_EXAMP_0000020802": "补单",
        "P_YS_FED_EXAMP_0000020819": "新密码不能与旧密码相同!",
        "P_YS_FED_EXAMP_0000020810": "有商品待退货审批！",
        "P_YS_FED_EXAMP_0000019834": "未选择营业员",
        "P_YS_FED_EXAMP_0000019833": "。",
        "P_YS_FED_EXAMP_0000019832": "、",
        "P_YS_FED_EXAMP_0000020816": "门店名称类型不合法!",
        "P_YS_FED_EXAMP_0000020815": "获取树结构失败：【接口】",
        "P_YS_FED_EXAMP_0000020818": "存在商品行，不允许定制！",
        "P_YS_FED_EXAMP_0000020817": "商品货位必输！",
        "P_YS_FED_EXAMP_0000020812": "调整后折扣不能为空！",
        "P_YS_FED_EXAMP_0000020811": "行商品",
        "P_YS_FED_EXAMP_0000020814": "录入的[",
        "P_YS_FED_EXAMP_0000020813": "撤销成功",
        "P_YS_FED_FW_0001007915": "'暂无搜索结果哦~'",
        "P_YS_FED_FW_0001149184": "最多设置五个搜索列！",
        "P_YS_FED_EXAMP_0000019838": "当前行不允许修改数量！",
        "P_YS_PF_PRINT_0000064959": "打印信息",
        "P_YS_FED_EXAMP_0000019837": "获取线上自动打印数据失败！",
        "P_YS_FED_EXAMP_0000019836": "未售出, 不能退卡",
        "P_YS_FED_EXAMP_0000019835": "该会员没有积分。",
        "P_YS_FED_EXAMP_0000019839": "昨天",
        "P_YS_FED_EXAMP_0000019841": "使用积分必须大于等于",
        "P_YS_FED_EXAMP_0000019840": "与预订的",
        "P_YS_FED_EXAMP_0000020821": "订金低于预定比例金额",
        "P_YS_FED_EXAMP_0000020820": "最大找零金额为：",
        "P_YS_FED_EXAMP_0000019845": "昌平店",
        "P_YS_HR_HRCOREF_0000058401": "请选择出生日期",
        "P_YS_FED_EXAMP_0000019844": "零售单零售金额与商品行金额合计不等！零售金额为：",
        "P_YS_FED_FW_0001387688": "图表不能正常显示，需要 report/getGroupSetting(获取报表分组方案的详细设置进行显示) 返回的配置信息中 isEmpty(json.data.chartConfig) == false",
        "P_YS_FED_EXAMP_0000019843": "重量不可为空或者零。",
        "P_YS_FED_EXAMP_0000019842": "不能执行积分抵扣",
        "P_YS_FED_EXAMP_0000020827": "实退金额应少于应退金额！",
        "P_YS_FED_EXAMP_0000020826": "启用货位管理的仓库行的货位不能为空,请检查!",
        "P_YS_FED_EXAMP_0000020829": "要货申请",
        "P_YS_FED_EXAMP_0000020828": "重量不能为空或者0！",
        "P_YS_FED_EXAMP_0000020823": "信息修改成功！！",
        "P_YS_FED_EXAMP_0000020822": "不能改行",
        "P_YS_FED_FW_0000154897": "设计态模拟出错",
        "P_YS_FED_EXAMP_0000020825": "周边库存",
        "P_YS_FED_EXAMP_0000020824": "该储值卡号已录入, 请勿重复录入",
        "P_YS_FED_FW_0000177570": "收到的短信验证码",
        "P_YS_FED_FW_0000177571": "生成新权限",
        "P_YS_FED_FW_0000177572": "】，缓存数据失败！",
        "P_YS_FED_FW_0000177573": "公式名称",
        "P_YS_FED_FW_0000177574": "已经存在当前菜单，是否覆盖移动端端？",
        "P_YS_SD_UDHMC_0000050930": "—",
        "P_YS_FED_FW_0000021919": "展示指标支持多选，最多共选择",
        "P_YS_FED_FW_0000021913": "别名代码",
        "P_YS_FED_FW_0001061466": "个人方案",
        "P_YS_FED_FW_0000021914": "当前积分：",
        "P_YS_FED_FW_0000021911": "替换图片",
        "P_YS_FED_FW_0000021912": "订阅时点",
        "P_YS_FED_FW_0000021917": "图文形式",
        "P_YS_FED_FW_0000021918": "新发布的报表名字不可与系统报表重名。",
        "P_YS_FED_FW_0000021916": "导入请求已经执行完毕！",
        "P_YS_FED_FW_0000177564": "】，实际表名【",
        "P_YS_FED_MDF-COMPS_0001573056": "日期时间测试",
        "P_YS_FED_FW_0000177565": "msgcode--cStyle预制错误",
        "P_YS_FED_MDF-COMPS_0001573057": "固定資產檔案導出測試",
        "P_YS_FED_FW_0000177566": "精度值不能小于0大于6",
        "P_YS_FED_FW_0000177567": "】，保存数据事务失败",
        "P_YS_FED_FW_0000177568": "输入数字后，点击后方的按钮插入数字",
        "P_YS_FED_FW_0000021910": "交叉点在一维表对应多行，请检查。data  =",
        "P_YS_FED_FW_0000177569": "】传入表名【",
        "P_YS_FED_MDF-COMPS_0001573058": "z0客户3255830",
        "P_YS_FED_FW_0001061465": "公共方案",
        "P_YS_FED_MDF-COMPS_0001573059": "表體-0528test",
        "P_YS_FED_FW_0000177580": "该名称已存在移动端不可修改权限",
        "P_YS_FED_FW_0000177581": "@@db日志@@【",
        "P_YS_FED_FW_0000177582": "已经存在当前菜单，是否覆盖PC端和移动端？",
        "P_YS_FED_FW_0000177583": "此汇总项已被",
        "P_YS_FED_FW_0000177584": "该名称已存在PC端不可修改权限",
        "P_YS_FED_FW_0000177585": "请输入公式别名",
        "P_YS_FED_FW_0000021924": "大屏轮播:开始轮播。大屏数量",
        "P_YS_FED_FW_0000021925": "此前插入行",
        "P_YS_FED_MDF-COMPS_0001573060": "庫存組織",
        "P_YS_FED_FW_0000021922": "您于",
        "P_YS_FED_FW_0000021923": "知道了",
        "P_YS_FED_FW_0000021928": "金额精度",
        "P_YS_FED_MDF-COMPS_0001573063": "產地",
        "P_YS_FED_FW_0000021929": "配置信息中栏目验证OK",
        "P_YS_FED_MDF-COMPS_0001573064": "ycx档案类型",
        "P_YS_FED_FW_0000021926": "模版管理",
        "P_YS_FED_MDF-COMPS_0001573061": "庫管員",
        "P_YS_FED_FW_0000021927": "添加数据项",
        "P_YS_FED_MDF-COMPS_0001573062": "型號",
        "P_YS_FED_FW_0000177575": "S后重新发送",
        "P_YS_FED_MDF-COMPS_0001573067": "您对必输项设置了隐藏，请注意！",
        "P_YS_FED_FW_0000177576": "公式所需条件数量不可大于7",
        "P_YS_FED_MDF-COMPS_0001573068": "交易類型",
        "P_YS_FED_FW_0000177577": "该名称已存在PC端和移动端不可修改权限",
        "P_YS_FED_MDF-COMPS_0001573065": "NN表頭數值0630",
        "P_YS_FED_FW_0000177578": "已经存在当前菜单，是否覆盖PC端？",
        "P_YS_FED_MDF-COMPS_0001573066": "庫存單位",
        "P_YS_FED_FW_0000021920": "操作成功!",
        "P_YS_FED_FW_0000177579": "已经存在当前菜单，是否覆盖移动端",
        "P_YS_FED_FW_0000021921": "确定停用此条订阅吗？",
        "P_YS_FED_MDF-COMPS_0001573069": "表頭-0528test",
        "P_YS_FED_FW_0000177552": "txd_表头文本(20190531启用)",
        "P_YS_FED_UCFBASEDOC_0000025199": "表单",
        "P_YS_FED_FW_0000177560": "日结卡片",
        "P_YS_FED_FW_0000177561": "此设备可以直接用扫码枪！",
        "P_YS_FED_FW_0000177562": "cParameter解析失败~",
        "P_YS_FED_FW_0000177563": "选择公式所需条件后才可新增公式",
        "P_YS_FED_FW_0000021908": "请选择更改字段",
        "P_YS_FED_FW_0000021909": "请输入1-5数字",
        "P_YS_FED_FW_0000021902": "请输入公司邮箱",
        "P_YS_FED_FW_0000021903": "当前操作将撤销上次所做的拆分操作，是否继续?",
        "P_YS_FED_FW_0000021900": "确定删除栏目【",
        "P_YS_FED_FW_0000021901": "上传附件",
        "P_YS_FED_FW_0000021906": "删除失败!",
        "P_YS_FED_FW_0000021907": ",至少录入一行数据！",
        "P_YS_FED_FW_0000021904": "热区显示图  设置的刷新时间太短,更改为5秒。",
        "P_YS_FED_FW_0000021905": "公司名称",
        "P_YS_FED_FW_0000177553": "{\"0\":\"未提交\",\"1\":\"已提交\",\"2\":\"已批复\",\"3\":\"已驳回\"}",
        "P_YS_FED_FW_0000177554": "要货申请单显示模板(移动端)",
        "P_YS_FED_FW_0000177555": "业务商品汇总区",
        "P_YS_FED_FW_0000177556": "商品汇总",
        "P_YS_FED_FW_0000177557": "{\"decimal\":\"<%option.amountofdecimal%>\",\"prefix\":\"￥\"}",
        "P_YS_FED_FW_0000177558": "{\"1\":\"现销\",\"2\":\"预订\",\"3\":\"交货\",\"4\":\"退订\",\"5\":\"退货\",\"6\":\"其他\",\"7\":\"售后\"}",
        "P_YS_FED_FW_0000177559": "日结单(移动端)",
        "P_YS_FED_FW_0001062762": "请选择要删除的模板",
        "P_YS_PF_GZTTMP_0000077237": "型号",
        "P_YS_FED_MDF-COMPS_0001573092": "请选择操作行",
        "P_YS_FED_MDF-COMPS_0001573093": "z0客户3627661",
        "P_YS_FED_MDF-COMPS_0001573090": "單據編號",
        "P_YS_FED_MDF-COMPS_0001573091": "likun-表頭自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573096": "likun-表體自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573097": "必輸，請精確到sku",
        "P_YS_FED_MDF-COMPS_0001573094": "保質期",
        "P_YS_FED_MDF-COMPS_0001573095": "wjl测试自定义项",
        "P_YS_FED_MDF-COMPS_0001573098": "wjl測試自定義項",
        "P_YS_FED_MDF-COMPS_0001573099": "件數",
        "P_YS_FED_FW_1524792374620323848": "地图调用次数超限，请申请独立的高德key",
        "P_YS_SD_SDOC_0001149954": "疑难件",
        "P_YS_FED_FW_0001047189": "四十六",
        "P_YS_FED_FW_0001047188": "十九",
        "P_YS_OA_app_xtyyjm_0000035823": "选择月",
        "P_YS_FED_FW_0001047187": "四十八",
        "P_YS_OA_app_xtyyjm_0000035824": "未生效",
        "P_YS_FED_FW_0001047186": "三十九",
        "P_YS_FED_FW_0001047185": "三十二",
        "P_YS_FED_FW_0001047184": "三十五",
        "P_YS_FED_FW_0001047183": "二十六",
        "P_YS_FED_FW_0001047182": "二十八",
        "P_YS_FED_FW_0001084171": "详细信息<NO.",
        "P_YS_FED_FW_0001084172": "代理接口请求<NO.",
        "P_YS_FED_MDF-COMPS_0001573070": "NN物料查询1",
        "P_YS_FED_MDF-COMPS_0001573071": "请重新选择，输入数字大于可选最大值",
        "P_YS_FED_MDF-COMPS_0001573074": "專案編碼",
        "P_YS_FED_MDF-COMPS_0001573075": "数值型字段",
        "P_YS_FED_MDF-COMPS_0001573072": "數值型字段",
        "P_YS_FED_MDF-COMPS_0001573073": "请重新选择，输入数字小于可选最小值",
        "P_YS_FED_MDF-COMPS_0001573078": "物料sku編碼",
        "P_YS_FED_IMP_IOT0000007293": "宁乡县",
        "P_YS_FED_MDF-COMPS_0001573079": "自定义项目测试202008060001",
        "P_YS_FED_MDF-COMPS_0001573076": "計量單位",
        "P_YS_FED_MDF-COMPS_0001573077": "固定资产档案导出测试",
        "P_YS_FED_FW_1556701636555440133": "刷新当前页面",
        "P_YS_SD_SDMB_0000147545": "时尚",
        "P_YS_FED_FW_1556701636555440136": "上次刷新时间:",
        "P_YS_FED_IMP_IOT0000007297": "英山县",
        "P_YS_FED_FW_0001047199": "三十八",
        "P_YS_FED_FW_0001047198": "三十六",
        "P_YS_FED_FW_0001047197": "五十",
        "P_YS_FED_IMP_IOT0000007290": "大方县",
        "P_YS_FED_FW_0001047196": "四十四",
        "P_YS_FED_FW_0001047195": "二十四",
        "P_YS_FED_FW_0001047194": "三十",
        "P_YS_FED_IMP_IOT0000007291": "石狮市",
        "P_YS_FED_FW_0001047193": "二十",
        "P_YS_FED_FW_0001084182": "未配置参照编码，请检查配置",
        "P_YS_FED_FW_0001047192": "三十三",
        "P_YS_FED_FW_0001465649": "元数据未配置billNum",
        "P_YS_FED_FW_0001047191": "三十一",
        "P_YS_FED_FW_0001047190": "三十七",
        "P_YS_FED_MDF-COMPS_0001573081": "業務員",
        "P_YS_FED_MDF-COMPS_0001573082": "时间H",
        "P_YS_FED_MDF-COMPS_0001573080": "物料sku名稱",
        "P_YS_FED_MDF-COMPS_0001573085": "自定義檔案",
        "P_YS_FED_MDF-COMPS_0001573086": "批次號",
        "P_YS_FED_FW_0001084173": "代理接口成功<NO.",
        "P_YS_FED_MDF-COMPS_0001573083": "跟踪号123",
        "P_YS_FED_FW_0001084174": "代理接口失败<NO.",
        "P_YS_FED_MDF-COMPS_0001573084": "likun-表头自定义项[文本]",
        "P_YS_FED_IMP_IOT0000007283": "潢川县",
        "P_YS_FED_MDF-COMPS_0001573089": "門店",
        "P_YS_FED_IMP_IOT0000007285": "康平县",
        "P_YS_FED_MDF-COMPS_0001573087": "會計主體",
        "P_YS_FED_MDF-COMPS_0001573088": "NN表头数值0630",
        "P_YS_FED_IMP_IOT0000007289": "历下区",
        "P_YS_OA_XTLCZX_0000030451": "审批人",
        "P_YS_SD_SDMA_0000060759": "已揽件",
        "P_YS_FED_FW_0001157538": "(control+回车)",
        "P_YS_OA_app_xtyyjm_0000035849": "显示标题",
        "P_YS_FED_IMP_IOT0000007280": "舞钢市",
        "P_YS_FED_FW_0001097428": "配置参数错误",
        "P_YS_FED_FW_0001145546": "ctrl+回车",
        "P_YS_FED_IMP_IOT0000007272": "维扬区",
        "P_YS_FED_IMP_IOT0000007274": "金坛市",
        "P_YS_FED_FW_0000177600": "】，保存数据keyPath【",
        "P_YS_FED_IMP_IOT0000007273": "山丹县",
        "P_YS_FED_IMP_IOT0000007275": "镇原县",
        "P_YS_FED_IMP_IOT0000007278": "靖西县",
        "P_YS_FED_FW_0001031669": "工行",
        "P_YS_FED_IMP_IOT0000007270": "尼玛县",
        "P_YS_FED_IMP_IOT0000007269": "赫章县",
        "P_YS_FED_IMP_IOT0000007268": "浚县",
        "P_YS_FED_FW_0000177619": "请输入文字:",
        "P_YS_FED_IMP_IOT0000007261": "孝义市",
        "P_YS_FED_IMP_IOT0000007263": "塔河县",
        "P_YS_FED_IMP_IOT0000008591": "沙坪坝区",
        "P_YS_FED_FW_1456067245639729152": "打开参照弹窗",
        "P_YS_FED_IMP_IOT0000008592": "金堂县",
        "P_YS_FED_IMP_IOT0000008597": "昌吉市",
        "P_YS_OA_app_xtyyjm_0000035850": "未发布",
        "P_YS_FED_FW_0000177614": "主按钮",
        "P_YS_FED_IMP_IOT0000007266": "犍为县",
        "P_YS_FED_IMP_IOT0000008596": "郧县",
        "P_YS_FED_UCFORG_0000025923": "启用成功",
        "P_YS_OA_XTLCZX_0000030473": "已选择",
        "P_YS_PF_SOCD-G_0000807705": "健康",
        "P_YS_FED_IMP_IOT0000007257": "双城市",
        "P_YS_FED_IMP_IOT0000008588": "天心区",
        "P_YS_FED_IMP_IOT0000007259": "秀屿区",
        "P_YS_FED_IMP_IOT0000008582": "北市区",
        "P_YS_FED_IMP_IOT0000008583": "迁西县",
        "P_YS_FED_IMP_IOT0000007252": "定襄县",
        "P_YS_FED_IMP_IOT0000008580": "江岸区",
        "P_YS_OA_XTLCZX_0000030468": "右",
        "P_YS_FED_IMP_IOT0000007254": "凌源市",
        "P_YS_FED_IMP_IOT0000008584": "突泉县",
        "P_YS_OA_XTLCZX_0000030486": "列表项",
        "P_YS_FED_IMP_IOT0000007247": "铜山县",
        "P_YS_FED_IMP_IOT0000008579": "雁江区",
        "P_YS_FED_IMP_IOT0000007249": "离石区",
        "P_YS_FED_IMP_IOT0000008577": "安吉县",
        "P_YS_FED_IMP_IOT0000007248": "城厢区",
        "P_YS_FED_IMP_IOT0000008571": "同仁县",
        "P_YS_FED_IMP_IOT0000007241": "白塔区",
        "P_YS_FED_IMP_IOT0000008570": "九江县",
        "P_YS_FED_IMP_IOT0000007243": "乾安县",
        "P_YS_FED_IMP_IOT0000008575": "惠城区",
        "P_YS_FED_IMP_IOT0000007242": "莱城区",
        "P_YS_FED_IMP_IOT0000008576": "爱辉区",
        "P_YS_FED_IMP_IOT0000007245": "余江县",
        "P_YS_FED_IMP_IOT0000008573": "沙湾区",
        "P_YS_FED_IMP_IOT0000007244": "岫岩满族自治县",
        "P_YS_FED_IMP_IOT0000008574": "温岭市",
        "P_YS_FED_UCFBASEDOC_0000025100": "]只能录入大于0的值，请检查后重试！",
        "P_YS_FED_FW_1572482677854961725": "你确定要离开吗？",
        "P_YS_FED_IMP_IOT0000007236": "碌曲县",
        "P_YS_FED_IMP_IOT0000009899": "五原县",
        "P_YS_FED_FW_0001144258": "gridModel.lineNoStep(val)参数[val]不是一个有效的数",
        "P_YS_FED_IMP_IOT0000008566": "灵寿县",
        "P_YS_FED_IMP_IOT0000009897": "宝塔区",
        "P_YS_FED_IMP_IOT0000007237": "辉县市",
        "P_YS_FED_IMP_IOT0000009898": "龙潭区",
        "P_YS_FED_IMP_IOT0000007239": "理塘县",
        "P_YS_FED_IMP_IOT0000008560": "米脂县",
        "P_YS_FED_IMP_IOT0000009891": "察隅县",
        "P_YS_OA_XTLCZX_0000030402": "字段",
        "P_YS_FED_IMP_IOT0000007232": "乐陵市",
        "P_YS_FED_IMP_IOT0000009896": "庐江县",
        "P_YS_FED_IMP_IOT0000009893": "南开区",
        "P_YS_PF_GZTSYS_0000013482": "UI模板",
        "P_YS_PF_GZTSYS_0000012149": "商家商品",
        "P_YS_FED_IMP_IOT0000007225": "小金县",
        "P_YS_FED_IMP_IOT0000008557": "旬阳县",
        "P_YS_FED_IMP_IOT0000008558": "泗洪县",
        "P_YS_FED_IMP_IOT0000009889": "绿春县",
        "P_YS_FED_IMP_IOT0000007227": "金川县",
        "P_YS_PF_GZTSYS_0000013477": "保存",
        "P_YS_FED_IMP_IOT0000007229": "炎陵县",
        "P_YS_FED_IMP_IOT0000007228": "化德县",
        "P_YS_FED_IMP_IOT0000008559": "袁州区",
        "P_YS_SD_SDMBF_0000145004": "亚马逊",
        "P_YS_FED_IMP_IOT0000007221": "炉霍县",
        "P_YS_FED_IMP_IOT0000009884": "兴安区",
        "P_YS_FED_IMP_IOT0000008554": "江阴市",
        "P_YS_FED_IMP_IOT0000007223": "市南区",
        "P_YS_FED_IMP_IOT0000008551": "山亭区",
        "P_YS_FED_IMP_IOT0000007222": "元阳县",
        "P_YS_FED_IMP_IOT0000008552": "临颍县",
        "P_YS_FED_IMP_IOT0000009883": "钟山县",
        "P_YS_FED_FW_0001078323": "确定要<%=abandonText%>吗?",
        "P_YS_FED_FW_0001078324": "确定要<%=abandonText%>么",
        "P_YS_FED_FW_0001078322": "是否确认<%=cCaption%><%=text%>",
        "P_YS_FED_FW_0001078325": "共<%=total%>条",
        "P_YS_FED_IMP_IOT0000007214": "常熟市",
        "P_YS_FED_IMP_IOT0000009875": "淮阴区",
        "P_YS_PF_GZTSYS_0000013447": "未开票",
        "P_YS_FED_IMP_IOT0000009876": "当涂县",
        "P_YS_FED_IMP_IOT0000009879": "马尾区",
        "P_YS_PF_GZTSYS_0000012113": "客户级别",
        "P_YS_FED_FW_0000021894": "数值不可为空，请检查",
        "P_YS_FED_FW_0000021895": "已经回退到最初拆分前的状态。",
        "P_YS_FED_IMP_IOT0000009870": "新民市",
        "P_YS_FED_FW_0000021892": "成功信息",
        "P_YS_FED_FW_0000021893": "默认模板不允许删除！",
        "P_YS_OA_XTLCZX_0000030424": "合并",
        "P_YS_FED_FW_0000021898": "模版名称不能超过20个字符",
        "P_YS_FED_FW_0000021899": "获取枚举失败",
        "P_YS_FED_IMP_IOT0000009874": "冀州市",
        "P_YS_FED_FW_0000021896": "大屏方案 设计 getDesignColType_Notice curCol",
        "P_YS_FED_FW_0000021897": "请录入主维度行数。",
        "P_YS_PF_PRINT_0000056408": "日结单",
        "P_YS_FED_IMP_IOT0000009872": "汶上县",
        "P_YS_SD_URETAIL_0001049201": "后端报错：",
        "P_YS_FED_FW_0001224826": "单据提交成功。",
        "P_YS_FED_IMP_IOT0000009867": "大观区",
        "P_YS_FED_IMP_IOT0000007205": "博白县",
        "P_YS_FED_IMP_IOT0000008533": "明山区",
        "P_YS_FED_IMP_IOT0000009864": "同心县",
        "P_YS_FED_IMP_IOT0000008534": "黑水县",
        "P_YS_FED_IMP_IOT0000009865": "平果县",
        "P_YS_PF_GZTSYS_0000012122": "卡券",
        "P_YS_PF_GZTSYS_0000012125": "商品订单属性",
        "P_YS_FED_IMP_IOT0000008537": "平和县",
        "P_YS_FED_IMP_IOT0000008538": "文县",
        "P_YS_FED_FW_0001381584": "&nbsp;/ 当前页面筛选出条",
        "P_YS_FED_FW_0001081985": "请勾选需要删除的附件！",
        "P_YS_FED_FW_0001212858": "加载更多,剩余",
        "P_YS_FED_IMP_IOT0000008531": "会昌县",
        "P_YS_HR_HRJXF_0000059516": "取消发布",
        "P_YS_HR_HRJXF_0000059517": "按时完成率",
        "P_YS_FED_FW_0001081984": "批量下载",
        "P_YS_FED_IMP_IOT0000007201": "拜城县",
        "P_YS_FED_FW_0001081983": "请勾选需要下载的附件！",
        "P_YS_FED_IMP_IOT0000009861": "宝山区",
        "P_YS_FED_FW_0001241359": "为模糊搜索类型控件，需设置默认搜索字段；",
        "P_YS_SD_URETAIL_0001049211": "IDB_deleteSomeData 删除事务失败",
        "P_YS_PF_PRINT_0000057797": "表头自定义项4",
        "P_YS_PF_GZTSYS_0000012184": "客户行业",
        "P_YS_PF_PRINT_0000057795": "表头自定义项5",
        "P_YS_PF_PRINT_0000057794": "表头自定义项6",
        "P_YS_PF_PRINT_0000057793": "表头自定义项7",
        "P_YS_PF_PRINT_0000057792": "表头自定义项1",
        "P_YS_PF_PRINT_0000057791": "表头自定义项2",
        "P_YS_PF_PRINT_0000057790": "表头自定义项3",
        "P_YS_FED_EXAMP_0000020797": "运费",
        "P_YS_FED_IMP_IOT0000009855": "石龙区",
        "P_YS_FED_EXAMP_0000020796": "正在开发中，敬请期待...",
        "P_YS_FED_EXAMP_0000020799": "周四",
        "P_YS_FED_EXAMP_0000020798": "当前处于离线状态,不允许结算保存",
        "P_YS_FED_IMP_IOT0000008523": "城阳区",
        "P_YS_FED_EXAMP_0000020793": "当前单据状态下不允许修改表头！",
        "P_YS_FED_EXAMP_0000020792": "拍照选图",
        "P_YS_FED_IMP_IOT0000008529": "海伦市",
        "P_YS_FED_EXAMP_0000020795": "预订退订状态下不允许删除商品！",
        "P_YS_FED_EXAMP_0000020794": "按克",
        "P_YS_FED_IMP_IOT0000009858": "桂平市",
        "P_YS_FED_FW_0001241361": "均为模糊搜索类型的控件，单个方案只能设置至多一个模糊搜索",
        "P_YS_SD_UDHWN_0000049917": "昌平区",
        "P_YS_FED_FW_0001241360": "为模糊搜索，比较符只可选择包含；",
        "P_YS_FED_IMP_IOT0000009851": "泌阳县",
        "P_YS_FED_IMP_IOT0000008521": "通渭县",
        "P_YS_SD_URETAIL_0001049224": "刷新token 成功！",
        "P_YS_FED_IMP_IOT0000008519": "东安区",
        "P_YS_FED_IMP_IOT0000008513": "平潭县",
        "P_YS_FED_FW_0001195898": "已选 (",
        "P_YS_FED_IMP_IOT0000008514": "淇县",
        "P_YS_FED_FW_0001195897": "已选参照",
        "P_YS_FED_IMP_IOT0000008512": "临朐县",
        "P_YS_FED_IMP_IOT0000008517": "班戈县",
        "P_YS_FED_IMP_IOT0000008515": "椒江区",
        "P_YS_FED_IMP_IOT0000009846": "卫东区",
        "P_YS_FED_IMP_IOT0000008516": "梅列区",
        "P_YS_FED_IMP_IOT0000009847": "武平县",
        "P_YS_FED_IMP_IOT0000009840": "上思县",
        "P_YS_FED_FW_0001195896": "关联下级",
        "P_YS_ZNBZ_BZBX-MFE_0001617926": "前天",
        "P_YS_SD_UDHWN_0000049937": "全屏",
        "P_YS_PF_GZTTMP_0000073729": "护照",
        "P_YS_FED_IMP_IOT0000008508": "砚山县",
        "P_YS_FED_IMP_IOT0000009839": "新兴县",
        "P_YS_PF_GZTSYS_0000012164": "移动报表",
        "P_YS_FED_IMP_IOT0000008509": "宜兴市",
        "P_YS_SCM_USTOCK-UI_0000174298": "要货申请单列表",
        "P_YS_FED_IMP_IOT0000008502": "海勃湾区",
        "P_YS_FED_IMP_IOT0000008500": "墨玉县",
        "P_YS_FED_IMP_IOT0000008501": "花山区",
        "P_YS_FED_IMP_IOT0000009832": "宁南县",
        "P_YS_FED_IMP_IOT0000008506": "鄢陵县",
        "P_YS_FED_IMP_IOT0000009837": "开福区",
        "P_YS_FED_IMP_IOT0000009835": "牡丹区",
        "P_YS_FED_IMP_IOT0000009836": "顺河回族区",
        "P_YS_FED_FW_0000082817": "全部附件",
        "P_YS_FED_IMP_IOT0000009830": "柳江县",
        "P_YS_SD_URETAIL_0001049242": "IDB_deleteOneData删除数据出错！",
        "P_YS_FED_IMP_IOT0000009822": "贾汪区",
        "P_YS_FED_IMP_IOT0000010800": "德清县",
        "P_YS_FED_IMP_IOT0000009823": "安岳县",
        "P_YS_FED_IMP_IOT0000010801": "新密市",
        "P_YS_FED_IMP_IOT0000010802": "城区",
        "P_YS_FED_IMP_IOT0000009821": "仓山区",
        "P_YS_FED_IMP_IOT0000010803": "西秀区",
        "P_YS_FED_IMP_IOT0000009827": "乐清市",
        "P_YS_FED_IMP_IOT0000009824": "象州县",
        "P_YS_FED_IMP_IOT0000009825": "周至县",
        "P_YS_SD_SCMSA-UI_0000162068": "下推",
        "P_YS_FED_IMP_IOT0000010808": "西乡县",
        "P_YS_FED_IMP_IOT0000010809": "东河区",
        "P_YS_FED_FW_1628158682522976263": "UI模板名称",
        "P_YS_FED_FW_0001252682": "请完善数据后重新上传",
        "P_YS_HR_HRXCF_0000056236": "重新上传",
        "P_YS_SD_UDHWN_0001009862": "凌晨",
        "P_YS_FED_FW_0001073947": "输入内容错误",
        "P_YS_HR_HRCOREF_0000058351": "变更日期",
        "P_YS_FED_IMP_IOT0000010702": "清原满族自治县",
        "P_YS_SD_UDHWN_0001008520": "矩形选择",
        "P_YS_FED_IMP_IOT0000010707": "涿州市",
        "P_YS_HR_HRXCF_0000056229": "倒序",
        "P_YS_FED_FW_0001160009": "超过交期完成的订单行",
        "P_YS_FED_FW_0001160008": "缺少cAction参数",
        "P_YS_FED_FW_0001300832": "单",
        "P_YS_FED_FW_0001160005": "缺少mtl.dail",
        "P_YS_FED_FW_0001300835": "已揽件",
        "P_YS_FED_FW_0001160004": "\\n 节点信息：",
        "P_YS_FED_FW_0001300836": "派送失败",
        "P_YS_HR_HRXCF_0000056212": "正序",
        "P_YS_FED_FW_0001160007": "缺少flowComp",
        "P_YS_FED_FW_0001300833": "已签收",
        "P_YS_FED_FW_0001160006": "extra 提示",
        "P_YS_FED_FW_0001300834": "派送中",
        "P_YS_FED_FW_0001160001": "已送达",
        "P_YS_FED_FW_0001300839": "运输中",
        "P_YS_FED_FW_0001160000": "交期内完成的订单行",
        "P_YS_FED_FW_0001160003": "缺少window.flowCompParams.host",
        "P_YS_FED_FW_0001300837": "疑难件",
        "P_YS_FED_FW_0001160002": "缺少window.YYCooperationBridge",
        "P_YS_PF_GZTTMP_0000074737": "网址",
        "P_YS_FED_FW_0001300838": "退件签收",
        "P_YS_AM_AMC-UI_0000170775": "树",
        "P_YS_FED_IMP_IOT0000010712": "清城区",
        "P_YS_FED_IMP_IOT0000010710": "达尔罕茂明安联合旗",
        "P_YS_FED_FW_1525457613522206720": "<%=caption%>详情",
        "P_YS_FED_IMP_IOT0000010718": "新荣区",
        "P_YS_PF_GZTSYS_0000015903": "门店",
        "P_YS_SD_SDOC_0001150114": "揽件",
        "P_YS_AM_AMC-UI_0000170769": "查询区",
        "P_YS_SD_UDHWN_0000049220": "宝坻区",
        "P_YS_FED_EXAMP_0000020302": "上传成功",
        "P_YS_FED_EXAMP_0000020301": "演示行业账号登录失败：【接口】",
        "P_YS_FED_IMP_IOT0000010724": "永寿县",
        "P_YS_FED_EXAMP_0000020304": "未录入商品，不能执行退品！",
        "P_YS_FED_EXAMP_0000020303": "已经执行了现场折扣,不允许改零售价！",
        "P_YS_FED_IMP_IOT0000010726": "普格县",
        "P_YS_FED_EXAMP_0000020300": "未查询到该计次卡可退金额信息",
        "P_YS_FED_IMP_IOT0000010721": "恭城瑶族自治县",
        "P_YS_FED_EXAMP_0000020309": "钱包支付金额不能大于钱包可用金额",
        "P_YS_HR_HRXCF_0000056205": "下载模板",
        "P_YS_FED_FW_1530135219434684425": "打印设备",
        "P_YS_OA_app_xtyyjm_0000036003": "冲突",
        "P_YS_FED_EXAMP_0000020306": "权限验证",
        "P_YS_FED_IMP_IOT0000010727": "西和县",
        "P_YS_FED_EXAMP_0000020305": "使用积分必须为整数。",
        "P_YS_PF_GZTSYS_0000015916": "分析",
        "P_YS_FED_IMP_IOT0000010728": "泰山区",
        "P_YS_FED_EXAMP_0000020308": "menuId为空",
        "P_YS_FED_EXAMP_0000020307": "序列号商品行未录入序列号,请检查!",
        "P_YS_FED_FW_0001160027": "开始配送",
        "P_YS_FED_FW_0001160026": "预计送达时间：",
        "P_YS_FED_FW_0001160029": "前5周",
        "P_YS_FED_FW_0001160028": "第二个圈",
        "P_YS_FED_FW_0001160023": "缺少协同套件方法缺失",
        "P_YS_FED_FW_0001160022": "缺失FilterViewModel",
        "P_YS_PF_SUPPORT-UI_0001122350": "事件源",
        "P_YS_FED_FW_0001160025": "前6周",
        "P_YS_FED_FW_0001160024": "modelKey获取错误",
        "P_YS_FED_FW_0001160021": "暂无排序字段",
        "P_YS_FED_FW_0001160020": "供应商：$var{vendor_name}$var_end",
        "P_YS_PF_GZTSYS_0000015967": "设置",
        "P_YS_FED_IMP_IOT0000010735": "原平市",
        "P_YS_FED_IMP_IOT0000010737": "昔阳县",
        "P_YS_FED_IMP_IOT0000010731": "苏尼特左旗",
        "P_YS_FED_IMP_IOT0000010732": "慈利县",
        "P_YS_FED_IMP_IOT0000010733": "河南蒙古族自治县",
        "P_YS_FED_IMP_IOT0000010739": "茂港区",
        "P_YS_FED_FW_0001160019": "派送中",
        "P_YS_FED_FW_0001160016": "派送",
        "P_YS_FED_FW_0001160015": "国内承运：",
        "P_YS_FED_FW_0001160018": "金额$var{oriSum}$var_end $var{currency_name}$var_end",
        "P_YS_FED_FW_0001160017": "按时完成率=时间范围内未逾期收货的订单行数/订单行总数*100%",
        "P_YS_FED_FW_0001160012": "缺少section格式错误",
        "P_YS_FED_FW_0001160011": "cell的宽度超过表格的宽度,无法渲染",
        "P_YS_FED_FW_0001160014": "没有物流单号",
        "P_YS_FED_FW_0001160013": "第三周",
        "P_YS_FED_IMP_IOT0000010740": "无棣县",
        "P_YS_PF_TRS-FE_0000103832": "导入中...",
        "P_YS_FED_FW_0001160010": "/10行",
        "P_YS_FED_FW_1503374162989678595": "打开侧滑面板",
        "P_YS_PF_GZTSYS_0000015975": "条码",
        "P_YS_FED_IMP_IOT0000010741": "汉源县",
        "P_YS_FED_IMP_IOT0000010742": "关岭布依族苗族自治县",
        "P_YS_FED_IMP_IOT0000010749": "长泰县",
        "P_YS_FED_FW_0001160049": "缺少window.mtl",
        "P_YS_FED_FW_0001160048": "搜索地点",
        "P_YS_FED_FW_0001160045": "parsecontrols缺少Collapse容器组件",
        "P_YS_FED_FW_0001160044": "listType 错误，不是refer",
        "P_YS_FED_FW_0001160047": "(已选择",
        "P_YS_FED_IMP_IOT0000010750": "茂南区",
        "P_YS_FED_FW_0001160046": "portal缺少tabs",
        "P_YS_FED_IMP_IOT0000010751": "合阳县",
        "P_YS_FED_FW_0001160041": "context缺失",
        "P_YS_FED_FW_0001312860": "鼠标滑过时展示的信息",
        "P_YS_FED_FW_0001160040": "cTemplateTitle为空",
        "P_YS_FED_FW_0001160043": "路由params解析错误",
        "P_YS_FED_FW_0001312862": "GIS地图配置信息",
        "P_YS_FED_FW_0001160042": "这里是个toolbar",
        "P_YS_FED_FW_0001312861": "鼠标滑过时展示的信息的标题",
        "P_YS_FED_IMP_IOT0000010756": "常山县",
        "P_YS_FED_FW_0001201089": "查看订单详情",
        "P_YS_PF_GZTSYS_0000015945": "会员",
        "P_YS_FED_FW_0001160050": "（已选",
        "P_YS_FED_IMP_IOT0000010758": "罗湖区",
        "P_YS_FED_IMP_IOT0000010759": "察雅县",
        "P_YS_FED_FW_0001312857": "GIS地图配置信息-yySetting",
        "P_YS_FED_IMP_IOT0000010753": "怀集县",
        "P_YS_FED_FW_0001312856": "展示标题",
        "P_YS_FED_FW_1427569433243549696": "交叉点不可为空。",
        "P_YS_FED_FW_0001312859": "GIS地图配置信息-eChartSetting",
        "P_YS_FED_FW_1427569433243549699": "列标题不可为空。",
        "P_YS_OA_app_xtyyjm_0000036032": "非必填",
        "P_YS_FED_FW_0001312858": "GIS地图",
        "P_YS_FED_FW_0001160038": "行）",
        "P_YS_FED_FW_0001160037": "确定删除嘛?",
        "P_YS_FED_FW_0001160039": "移动端暂不支持打开此单据",
        "P_YS_FED_FW_0001160034": "您好，我方向贵单位所购之货物，望及时安排发货并告知我方。",
        "P_YS_FED_FW_0001160033": "请输入必填字段",
        "P_YS_FED_FW_0001377324": "请粘贴正确的字段进行搜索~",
        "P_YS_FED_FW_0001160036": "缺少phone number",
        "P_YS_FED_FW_0001160035": "前4周",
        "P_YS_FED_FW_0001160030": "揽收",
        "P_YS_FED_FW_0001160032": "缺少sectionParams",
        "P_YS_PF_GZTBDM_0000036354": "刷新成功",
        "P_YS_FED_FW_0001160031": "六角螺母-细牙DIN934【DIN93489074873984】",
        "P_YS_FED_IMP_IOT0000010767": "涞源县",
        "P_YS_FED_FW_0001312864": "GIS地图示例",
        "P_YS_FED_IMP_IOT0000010768": "屏边苗族自治县",
        "P_YS_FED_FW_0001312863": "位置字段",
        "P_YS_FED_IMP_IOT0000010769": "广汉市",
        "P_YS_FED_FW_0001493696": "已到达底部",
        "P_YS_FED_IMP_IOT0000010763": "平坝县",
        "P_YS_FED_FW_0001493695": "⇅",
        "P_YS_FED_IMP_IOT0000010765": "遂昌县",
        "P_YS_FED_FW_0001071353": "编辑方案",
        "P_YS_FED_FW_0001241952": "模板内容校验失败",
        "P_YS_FED_FW_0001241953": "数据校验中",
        "P_YS_FED_FW_0001241950": "文件类型必须为",
        "P_YS_FED_FW_0001241951": "个，您将继续导入吗?",
        "P_YS_FED_IMP_IOT0000010770": "潮安县",
        "P_YS_FED_IMP_IOT0000010771": "新野县",
        "P_YS_FED_IMP_IOT0000010772": "武陵区",
        "P_YS_FED_FW_0001241958": "引用参照异常数",
        "P_YS_FED_FW_0001241956": "上传导入文件",
        "P_YS_FED_FW_0001241957": "经系统校验",
        "P_YS_FED_FW_0001241954": "共存在",
        "P_YS_FED_FW_0001241955": "无异常数据，可进行导入",
        "P_YS_FED_IMP_IOT0000010778": "昌都县",
        "P_YS_FED_IMP_IOT0000010779": "苏州",
        "P_YS_FED_IMP_IOT0000010777": "赵县",
        "P_YS_FED_FW_0001241963": "异常总数",
        "P_YS_HR_HRJQ_0000031222": "所属部门",
        "P_YS_FED_FW_0001241964": "必填为空数",
        "P_YS_FED_FW_1566299230629789705": "查看旧附件",
        "P_YS_FED_FW_0001241961": "格式异常数",
        "P_YS_FED_FW_0001241962": "导入工作台",
        "P_YS_FED_FW_0001241960": "查看更多明细",
        "P_YS_FED_FW_1566299230629789708": "查看旧图",
        "P_YS_FED_FW_0001160056": "此处是个iframe",
        "P_YS_FED_FW_0001160055": "没有更多数据",
        "P_YS_FED_FW_0001160052": "单据时间:",
        "P_YS_FED_FW_0001160051": "输入查询",
        "P_YS_FED_FW_0001160054": "缺少toolbar",
        "P_YS_FED_FW_0001160053": "请定位",
        "P_YS_FED_FW_1438107719627702272": "最多设置5个搜索列！",
        "P_YS_OA_app_xtyyjm_0000036063": "是否刷新",
        "P_YS_FED_IMP_IOT0000010786": "玉龙纳西族自治县",
        "P_YS_FED_IMP_IOT0000010787": "柳河县",
        "P_YS_OA_XTSPZX_0000034801": "結束日期",
        "P_YS_FED_FW_1529514021144231942": "审批中单据暂不能直接跳编辑态",
        "P_YS_FED_FW_1566299230629789711": "查看历史附件",
        "P_YS_PF_ANALYTIC-FE_0001652971": "地图类型",
        "P_YS_FED_FW_0001636725": "模板校验失败!",
        "P_YS_FED_IMP_IOT0000010791": "邛崃市",
        "P_YS_FED_IMP_IOT0000010796": "通山县",
        "P_YS_FED_IMP_IOT0000010797": "江孜县",
        "P_YS_FED_IMP_IOT0000010798": "天等县",
        "P_YS_SD_UDHWN_0000050285": "澄迈县",
        "P_YS_FED_FW_0001241949": "目前初步校验，异常总数",
        "P_YS_FED_FW_0001241948": "导出修改",
        "P_YS_FED_FW_0001033077": "商店",
        "P_YS_OA_app_xtyyjm_0000036082": "数字",
        "P_YS_SD_UDHMC_0001057227": "吗",
        "P_YS_OA_app_xtyyjm_0000036083": "过滤",
        "P_YS_FED_FW_0001256170": "二手房产权纠纷有哪些？ \\n",
        "P_YS_FED_FW_0001256171": "我是折叠区域的内容，点击按钮我就显示，再次点击就会隐藏。快来点击按钮体验我的交互效果吧，是不是很棒！赶快使用吧~~~",
        "P_YS_HR_HRJQ_0000031253": "十一",
        "P_YS_HR_HRJQ_0000031259": "已超期",
        "P_YS_FED_FW_0001256178": "住宅小区的大件垃圾有望得到回收利用 \\n",
        "P_YS_MF_ED-UI_0001095584": "过去",
        "P_YS_FED_FW_0001256179": "国际新闻",
        "P_YS_FED_FW_0001256176": "大按钮",
        "P_YS_FED_FW_0001256177": "中國",
        "P_YS_FED_FW_0001256174": "汽车保养只换机油，4个零件要是不换的 \\n",
        "P_YS_FED_FW_0001256175": "小按钮",
        "P_YS_FED_FW_0001256172": "最均衡国产10万元SUV推荐",
        "P_YS_FED_FW_0001256173": "Basic Slider，`step默认1`",
        "P_YS_FED_FW_0001256169": "网友偶遇贴特大号“实习”标志的豪车 \\n",
        "P_YS_SD_UDHWN_0001009822": "中午",
        "P_YS_FED_FW_0001256181": "15万预算，适合年轻人的2台运动轿车，颜值高实力强 \\n",
        "P_YS_FED_FW_0001256182": "小户型榻榻米的制作流程 这样准没错 \\n",
        "P_YS_FED_FW_1609500210710446085": "mainOrigin值为：",
        "P_YS_FED_FW_0001256180": "地上忽现大坑 瞬间吞掉两幢房子 \\n",
        "P_YS_FED_FW_0001300824": "点击加载更多",
        "P_YS_FED_FW_0001300825": "关联下级",
        "P_YS_FED_FW_0001300823": "加载更多",
        "P_YS_FED_FW_0001300828": "请定位",
        "P_YS_FED_FW_0001300829": "继续添加",
        "P_YS_SD_UDHWN_0000049240": "顺义区",
        "P_YS_FED_FW_0001300826": "复制成功",
        "P_YS_FED_FW_0001256183": "暫無數據~",
        "P_YS_SD_UDHWN_0001009818": "1 小时",
        "P_YS_FED_FW_0001256156": "更大更好吃的海蛎子有望端上青岛市民餐桌！ \\n",
        "P_YS_FED_FW_0001256157": "最低工资标准上调窗口开启 京鲁冀等多个省市 \\n",
        "P_YS_FED_FW_0001256154": "磁贴标题",
        "P_YS_FED_FW_0001256155": "这是一个很强的提醒！",
        "P_YS_FED_FW_0001256152": "「评论」“小降准”的大意义",
        "P_YS_FED_FW_0001256153": "追剧听相声玩手游 “歪果仁”为了学汉语也是拼了 \\n",
        "P_YS_FED_FW_0001256150": "测绘准入放宽在即，新玩家新规则倒逼产业转型 \\n",
        "P_YS_FED_FW_0001256151": "房产",
        "P_YS_FED_FW_0001256149": "戏曲进高校玩快闪 “圈粉”大学生 \\n",
        "P_YS_FED_FW_1583355559353516056": "暂无数据哦～",
        "P_YS_FED_FW_0001256147": "智慧城市建设莫一哄而上 \\n",
        "P_YS_FED_FW_0001256148": "大众系SUV多到脸盲？一招教你如何选 \\n",
        "P_YS_FED_IMP_IOT0000007096": "蠡县",
        "P_YS_FED_IMP_IOT0000007098": "尼木县",
        "P_YS_FED_IMP_IOT0000007097": "公主岭市",
        "P_YS_FED_FW_0001256160": "請輸入您的手機號",
        "P_YS_FED_IMP_IOT0000007090": "额尔古纳市",
        "P_YS_FED_IMP_IOT0000007092": "静安区",
        "P_YS_FED_FW_0001256167": "电商平台不该为“代吵架服务”设摊 \\n",
        "P_YS_FED_FW_0001256168": "民众成都博物馆里享“餐桌上的文化之旅 \\n",
        "P_YS_FED_FW_0001256165": "点我啦",
        "P_YS_FED_FW_0001256166": "又一80后上市公司实控人被刑拘！ \\n",
        "P_YS_FED_FW_0001256163": "自定义 top",
        "P_YS_PF_GZTTMP_0000079605": "发票",
        "P_YS_FED_FW_0001256164": "回顾20年前A股那场轰轰烈烈的“519行情”",
        "P_YS_FED_FW_0001256161": "五月种菜大全来了，这些蔬菜您种了没有？ \\n",
        "P_YS_FED_FW_0001256162": "牌子大口碑好销量还高，12万左右的自动挡合资轿车 \\n",
        "P_YS_FED_FW_0001256158": "自定义 width",
        "P_YS_FED_FW_0001256159": "巨大按钮",
        "P_YS_FED_IMP_IOT0000007087": "台儿庄区",
        "P_YS_HR_HRJQ_0000031282": "邮箱格式不正确",
        "P_YS_FED_FW_0000021160": "×",
        "P_YS_FED_FW_0000022491": "展开一级",
        "P_YS_FED_FW_0000021161": "折线图示例",
        "P_YS_FED_FW_0000022492": "候选条件",
        "P_YS_FED_FW_0000022490": "下月",
        "P_YS_FED_FW_0000021164": "亳州市",
        "P_YS_FED_FW_0000022495": "八",
        "P_YS_FED_FW_0000021165": "饼形图配置信息",
        "P_YS_FED_FW_0000022496": "执行时包含下级",
        "P_YS_FED_FW_0000021162": "秦皇岛市",
        "P_YS_FED_FW_0000022493": "九",
        "P_YS_FED_FW_1473069861501927428": "系统打印失败错误信息:",
        "P_YS_FED_FW_0000021163": "怀化市",
        "P_YS_FED_FW_0000022494": "清空值",
        "P_YS_FED_FW_0001256134": "鼠标滑过显示",
        "P_YS_FED_FW_0001256135": "如何解决室内干燥 一个加湿器是不行的 \\n",
        "P_YS_FED_FW_0001256132": "如何降低购房风险？ \\n",
        "P_YS_FED_FW_0001256133": "投资2000万美元狂赚7000倍 \\n",
        "P_YS_FED_FW_0001256130": "一季度轿车市场分析 \\n",
        "P_YS_FED_FW_0001256131": "《从0到1》序二——读书笔记 \\n",
        "P_YS_PF_GZTTMP_0000078208": "往来件数",
        "P_YS_SD_SDMAUF_0000152533": "提交申请",
        "P_YS_FED_FW_0001256129": "哪些城市亮瞎眼，哪些城市很失落 \\n",
        "P_YS_FED_FW_0001256127": "当初没好好装卫生间 现在后悔死了 \\n",
        "P_YS_FED_FW_0001256128": "「重磅发布」2019年欧洲十大海上风电场排行榜！ \\n",
        "P_YS_FED_FW_0001256125": "美男摔落悬崖掉进活火山，躲过摄氏超过1000度 \\n",
        "P_YS_FED_FW_0001256126": "那些还在发朋友圈的朋友们，才是人间珍品 \\n",
        "P_YS_FED_FW_0000021157": "需要显示为Legend的名字超长，需要截断，截断前：",
        "P_YS_FED_FW_0000022488": "本月",
        "P_YS_FED_IMP_IOT0000007195": "平阳县",
        "P_YS_FED_FW_0000021158": "饼形图配置信息-yySetting",
        "P_YS_FED_FW_0000022489": "今日",
        "P_YS_FED_IMP_IOT0000007194": "龙城区",
        "P_YS_FED_FW_0000021155": "海南",
        "P_YS_FED_FW_0000022486": "显示停用",
        "P_YS_FED_FW_0000021156": "upgradeConfig_ForScatter 没找到对应的待升级地区。yySetting",
        "P_YS_FED_FW_0000022487": "查询条件",
        "P_YS_FED_IMP_IOT0000007196": "胶南市",
        "P_YS_FED_FW_0000021159": "cFormatData，预制错误！",
        "P_YS_FED_FW_0000021171": "随州市",
        "P_YS_FED_FW_0000021172": "新乡市",
        "P_YS_FED_FW_0000021170": "清除",
        "P_YS_PF_PRINT_0000057801": "表头自定义项8",
        "P_YS_FED_FW_0000021175": "塔城地区",
        "P_YS_PF_PRINT_0000057800": "表头自定义项9",
        "P_YS_FED_FW_0000021176": "银川市",
        "P_YS_FED_FW_0000021173": "内江市",
        "P_YS_FED_FW_1452079643387494400": "%c未找到对应页签",
        "P_YS_FED_FW_0000021174": "六安市",
        "P_YS_FED_FW_0001030895": "←",
        "P_YS_FED_FW_0001256145": "苏格兰媒体：凯尔特人没有向穆里尼奥开出邀约 \\n",
        "P_YS_FED_FW_0001256146": "去4S店“首保”，这3个细节要注意 \\n",
        "P_YS_FED_FW_0001256143": "一只好莱坞的 巨星猪 是怎么诞生的 \\n",
        "P_YS_FED_FW_0001256144": "五一消费账单来了！这个小长假，你的钱花哪了？ \\n",
        "P_YS_FED_FW_0001256141": "青少年手机成瘾危害大 各国政府纷纷出招应对 \\n",
        "P_YS_FED_FW_0001256142": "这是一段描述",
        "P_YS_FED_FW_0001256140": "光明日报头版：读懂中国经济的巨大韧性 \\n",
        "P_YS_FED_FW_0001256138": "一等奖得主齐现身 领奖不忘捐款献爱心 \\n",
        "P_YS_FED_FW_0001256139": "他或是安倍唯一不敢反对的男人！ \\n",
        "P_YS_FED_FW_0001256136": "长春年近六旬男子上演花样自行车绝技 \\n",
        "P_YS_FED_FW_0001256137": "状态(disabled)",
        "P_YS_FED_FW_0000021168": "highlight-control-cstyle-预制错误！",
        "P_YS_FED_FW_0000022499": "预置方案不能覆盖",
        "P_YS_FED_FW_0000021169": "信阳市",
        "P_YS_FED_FW_0000021166": "重庆市",
        "P_YS_FED_FW_0000022497": "查询条件:(",
        "P_YS_FED_IMP_IOT0000007186": "平阴县",
        "P_YS_FED_FW_0000021167": "安庆市",
        "P_YS_FED_FW_0000022498": "为空",
        "P_YS_FED_IMP_IOT0000007185": "蛟河市",
        "P_YS_FED_IMP_IOT0000007188": "黟县",
        "P_YS_FED_FW_0000022470": "没有任何分组信息。",
        "P_YS_FED_FW_0001077518": "实际大小",
        "P_YS_SD_UDHWN_0000046985": "通州区",
        "P_YS_FED_FW_0000021142": "湛江市",
        "P_YS_FED_FW_0000022473": "修改项",
        "P_YS_FED_IMP_IOT0000007180": "和县",
        "P_YS_FED_FW_0000022474": "不能存在编码为空的区域。",
        "P_YS_FED_FW_0000021143": "普票",
        "P_YS_FED_FW_0000021140": "商品编码：",
        "P_YS_FED_FW_0000022471": "table2DRowColChange 1维表当前index =",
        "P_YS_FED_IMP_IOT0000007182": "滦平县",
        "P_YS_FED_FW_0000021141": "柱形图示例",
        "P_YS_FED_FW_0000022472": "增行异常。self.addGroupInfo =",
        "P_YS_FED_FW_0001232180": "环境变量hubble_collect_url未配置，哈勃收集失败！",
        "P_YS_FED_FW_0000021135": "商品名称：",
        "P_YS_FED_FW_0000022466": "默认",
        "P_YS_FED_IMP_IOT0000007173": "萨尔图区",
        "P_YS_FED_FW_0000021136": "科技蓝色",
        "P_YS_FED_FW_0000022467": "5、点击【校验】按钮，系统按SQL-where子句的语法来校验“过滤表达式”的语法正确性，如存在语法错误校验不通过。",
        "P_YS_FED_FW_0000021133": "上海",
        "P_YS_FED_FW_0000022464": "有辅维度支持单选，无辅维度支持多选，最多选择",
        "P_YS_FED_IMP_IOT0000007175": "方城县",
        "P_YS_FED_FW_0000021134": "折线图配置信息",
        "P_YS_FED_FW_0000022465": "名称不可为空且长度小于16个字。",
        "P_YS_FED_IMP_IOT0000007174": "金川区",
        "P_YS_FED_FW_0000021139": "东营市",
        "P_YS_FED_IMP_IOT0000007177": "洪泽县",
        "P_YS_FED_IMP_IOT0000007176": "双滦区",
        "P_YS_FED_FW_0000021137": "德州市",
        "P_YS_FED_FW_0000022468": "至少保留一行。",
        "P_YS_FED_IMP_IOT0000007179": "信宜市",
        "P_YS_FED_FW_0000021138": "博尔塔拉蒙古自治州",
        "P_YS_FED_FW_0000022469": "改名失败!",
        "P_YS_FED_IMP_IOT0000007178": "万安县",
        "P_YS_FED_FW_0000022480": "模版名称",
        "P_YS_FED_FW_0000021150": "当前regionInfo",
        "P_YS_FED_FW_0000022481": "七",
        "P_YS_FED_FW_0000021153": "榆林市",
        "P_YS_FED_FW_0000022484": "程序错误",
        "P_YS_FED_FW_0000021154": "河北",
        "P_YS_FED_FW_0000022485": "包含下级",
        "P_YS_FED_FW_0000021151": "气泡值前N个",
        "P_YS_FED_FW_0000022482": "级次展开",
        "P_YS_FED_FW_0000021152": "鹰潭市",
        "P_YS_FED_FW_0000022483": "：",
        "P_YS_FED_IMP_IOT0000007170": "高平市",
        "P_YS_FED_FW_0001256123": "人民铁道“中央厨房”今日上线 \\n",
        "P_YS_FED_FW_0001256124": "查找关键字,请输入1",
        "P_YS_FED_FW_0001256121": "新风系统有没有用 到底要不要装呢",
        "P_YS_FED_FW_0001256122": "国内要闻",
        "P_YS_FED_FW_0001256120": "单据状态异常，请重新提交。",
        "P_YS_FED_FW_0001256118": "记住这个落井之人 \\n",
        "P_YS_FED_FW_0001256119": "北京项目近况一览 \\n",
        "P_YS_FED_FW_0001256116": "让数字经济更好助力高质量发展 \\n",
        "P_YS_FED_FW_0001256117": "條/頁",
        "P_YS_FED_FW_0001256115": "要想涡轮坏得快，这四个错误天天犯！ \\n",
        "P_YS_FED_FW_0000021146": "阳江市",
        "P_YS_FED_FW_0000022477": "表头＋明细",
        "P_YS_FED_IMP_IOT0000007162": "金州区",
        "P_YS_FED_IMP_IOT0000008494": "浦江县",
        "P_YS_FED_FW_0000021147": "数据格式错误！",
        "P_YS_FED_FW_0000022478": "新增维度导航方案",
        "P_YS_FED_IMP_IOT0000007161": "灌阳县",
        "P_YS_FED_FW_0000021144": "条数据读取失败!",
        "P_YS_FED_FW_0000022475": "所属行业",
        "P_YS_FED_FW_0000021145": "气泡图配置信息-yySetting",
        "P_YS_FED_FW_0000022476": "调用add失败:",
        "P_YS_FED_IMP_IOT0000007163": "内黄县",
        "P_YS_FED_IMP_IOT0000008493": "虞城县",
        "P_YS_FED_IMP_IOT0000007165": "秭归县",
        "P_YS_FED_FW_0000021148": "延边朝鲜族自治州",
        "P_YS_FED_FW_0000022479": "编辑界面",
        "P_YS_FED_FW_0000021149": "河源市",
        "P_YS_FED_IMP_IOT0000007167": "密山市",
        "P_YS_FED_IMP_IOT0000008490": "綦江县",
        "P_YS_FED_EXAMP_0000020283": "商品行有数量为0的数据，不可进行结算",
        "P_YS_FED_FW_0001470928": "网址不能为空",
        "P_YS_FED_EXAMP_0000020282": "请选择商品！",
        "P_YS_FED_EXAMP_0000020285": "退品数量不能为负！",
        "P_YS_FED_EXAMP_0000020284": "客商管理",
        "P_YS_FED_FW_0001470929": "文本不能为空",
        "P_YS_FED_EXAMP_0000020281": ")详情",
        "P_YS_FED_EXAMP_0000020280": "不能改零售价",
        "P_YS_FED_IMP_IOT0000007159": "临泉县",
        "P_YS_FED_EXAMP_0000020279": "选择序列号",
        "P_YS_FED_EXAMP_0000020276": "预订",
        "P_YS_FED_EXAMP_0000020275": "管理分类",
        "P_YS_FED_EXAMP_0000020278": "请先录入仓库",
        "P_YS_FED_FW_0001470926": "{\"linkText\":\"百度\",\"linkAddress\":\"http://baudi.com\"}",
        "P_YS_FED_EXAMP_0000020277": "记录行中无记录需要修改!",
        "P_YS_FED_IMP_IOT0000007150": "柯坪县",
        "P_YS_FED_FW_0000021199": "廊坊市",
        "P_YS_FED_IMP_IOT0000007152": "东乡族自治县",
        "P_YS_FED_IMP_IOT0000007155": "九寨沟县",
        "P_YS_FED_IMP_IOT0000008487": "掇刀区",
        "P_YS_PF_PROCENTER_0000023464": "启用",
        "P_YS_FED_IMP_IOT0000007156": "澄江县",
        "P_YS_FED_IMP_IOT0000008486": "中宁县",
        "P_YS_FED_IMP_IOT0000008480": "沙市区",
        "P_YS_FED_EXAMP_0000020294": "成交笔数",
        "P_YS_FED_EXAMP_0000020293": "最多选择5个规格",
        "P_YS_FED_EXAMP_0000020296": "系统版本低，暂时不支持切换!",
        "P_YS_FED_EXAMP_0000020295": "只能选择一个套餐商品！",
        "P_YS_FED_EXAMP_0000020290": "退订",
        "P_YS_FED_EXAMP_0000020292": "当前为退货充值状态，不允许添加充值行。",
        "P_YS_FED_EXAMP_0000020291": "已经执行过促销,不允许录入会员！",
        "P_YS_FED_IMP_IOT0000008478": "请输入此字段",
        "P_YS_FED_IMP_IOT0000007149": "小河区",
        "P_YS_FED_EXAMP_0000020286": "编码",
        "P_YS_FED_EXAMP_0000020289": "条数据bootSave保存时报错！",
        "P_YS_FED_EXAMP_0000020288": "未取得班次!",
        "P_YS_FED_IMP_IOT0000007140": "巩留县",
        "P_YS_FED_IMP_IOT0000008472": "馆陶县",
        "P_YS_FED_IMP_IOT0000008473": "平乡县",
        "P_YS_OA_XTSPZX_0000034846": "展開",
        "P_YS_FED_IMP_IOT0000007144": "桐梓县",
        "P_YS_FED_IMP_IOT0000007146": "宝安区",
        "P_YS_FED_IMP_IOT0000008474": "金门县",
        "P_YS_FED_FW_0000021182": "江西",
        "P_YS_FED_FW_0000021183": "cStyle预制错误！",
        "P_YS_FED_FW_0000021180": "自定义模板",
        "P_YS_FED_FW_0000021181": "河南",
        "P_YS_SD_SDMB_0000149613": "运输中",
        "P_YS_FED_FW_0000021186": "返回错误信息",
        "P_YS_FED_FW_0001204909": "导出已完成, 文件名为【",
        "P_YS_FED_FW_0000021187": "湖州市",
        "P_YS_FED_FW_0000021184": "北京朝阳第二门店",
        "P_YS_FED_FW_0000021185": "宁德市",
        "P_YS_FED_IMP_IOT0000007137": "梁山县",
        "P_YS_FED_IMP_IOT0000008469": "大安市",
        "P_YS_FED_IMP_IOT0000009798": "三门县",
        "P_YS_FED_IMP_IOT0000007138": "商城县",
        "P_YS_FED_IMP_IOT0000008468": "吉安县",
        "P_YS_FED_EXAMP_0000020298": "增品中含有实体卡券商品,卡券号不能为空",
        "P_YS_FED_EXAMP_0000020297": "当前单据状态下不允许执行退品!",
        "P_YS_FED_EXAMP_0000020299": "按日配送",
        "P_YS_FED_FW_0000021179": "中国100000",
        "P_YS_FED_IMP_IOT0000009792": "伽师县",
        "P_YS_OA_XTSPZX_0000034833": "時間",
        "P_YS_FED_IMP_IOT0000008462": "东宁县",
        "P_YS_FED_IMP_IOT0000009793": "曲沃县",
        "P_YS_FED_FW_0000021177": "百色市",
        "P_YS_OA_XTSPZX_0000034835": "啟用",
        "P_YS_FED_FW_0000021178": "酒泉市",
        "P_YS_FED_IMP_IOT0000007130": "耒阳市",
        "P_YS_FED_IMP_IOT0000008460": "那坡县",
        "P_YS_FED_IMP_IOT0000007133": "陇川县",
        "P_YS_FED_IMP_IOT0000009795": "延川县",
        "P_YS_FED_FW_0000021193": "阿勒泰地区",
        "P_YS_OA_XTSPZX_0000034819": "確認",
        "P_YS_FED_FW_0000021194": "湘潭市",
        "P_YS_FED_FW_0000021191": "沈阳市",
        "P_YS_FED_FW_0000021192": "武汉市",
        "P_YS_FED_FW_0000021197": "气泡图配置信息",
        "P_YS_FED_FW_0000021198": "辅维度空值数据",
        "P_YS_FED_FW_0000021195": "莆田市",
        "P_YS_FED_FW_0000021196": "洛阳市",
        "P_YS_FED_FW_0000021190": "排名表配置信息",
        "P_YS_FED_FW_0001204910": "】, 请您参阅查看。",
        "P_YS_FED_IMP_IOT0000007125": "敦化市",
        "P_YS_FED_IMP_IOT0000008459": "新青区",
        "P_YS_FED_IMP_IOT0000007128": "宜都市",
        "P_YS_FED_IMP_IOT0000009787": "永登县",
        "P_YS_FED_IMP_IOT0000007127": "会理县",
        "P_YS_FED_IMP_IOT0000008457": "马边彝族自治县",
        "P_YS_FED_IMP_IOT0000009788": "阎良区",
        "P_YS_FED_IMP_IOT0000007129": "左权县",
        "P_YS_FED_IMP_IOT0000008450": "岳普湖县",
        "P_YS_FED_IMP_IOT0000009781": "六合区",
        "P_YS_FED_FW_0000021188": "天津",
        "P_YS_FED_FW_0001154160": "个人方案无法修改为公共方案，将另存为公共方案，是否继续？",
        "P_YS_FED_FW_0000021189": "湖北省直辖县市",
        "P_YS_FED_IMP_IOT0000007122": "南宫市",
        "P_YS_FED_IMP_IOT0000009785": "苏仙区",
        "P_YS_FED_IMP_IOT0000007121": "曲松县",
        "P_YS_FED_IMP_IOT0000009786": "钢城区",
        "P_YS_FED_IMP_IOT0000009783": "卢龙县",
        "P_YS_FED_IMP_IOT0000007123": "白下区",
        "P_YS_FED_IMP_IOT0000009784": "西平县",
        "P_YS_PF_PRINT_0000057874": "整单数量",
        "P_YS_FED_EXAMP_0000020241": "请先选择出库仓库！",
        "P_YS_PF_GZTSYS_0000012021": "SKU属性",
        "P_YS_FED_EXAMP_0000020240": "正在开发中，敬请期待",
        "P_YS_HR_HRRCPDF_0001127373": "查看进度",
        "P_YS_FED_FW_0000022408": "排名列",
        "P_YS_FED_EXAMP_0000020236": "复制链接",
        "P_YS_FED_FW_0000022409": "平均",
        "P_YS_FED_EXAMP_0000020235": "本次调整金额不能大于0！",
        "P_YS_FED_IMP_IOT0000008448": "莱西市",
        "P_YS_FED_IMP_IOT0000009779": "手机号格式不正确",
        "P_YS_FED_FW_0000022406": "元数据配置有误",
        "P_YS_FED_EXAMP_0000020238": "未启用卡券销售业务,不允许选择卡券业务类型",
        "P_YS_FED_IMP_IOT0000007117": "扶绥县",
        "P_YS_FED_FW_0000022407": "确定停用此模版吗？",
        "P_YS_PF_GZTACT_0000015996": "人员",
        "P_YS_FED_EXAMP_0000020237": "商品分类显示数据错误！",
        "P_YS_FED_IMP_IOT0000007116": "相城区",
        "P_YS_FED_IMP_IOT0000009777": "中站区",
        "P_YS_FED_EXAMP_0000020232": "商品品牌",
        "P_YS_FED_EXAMP_0000020231": "会员钱包充值状态不允许执行",
        "P_YS_FED_IMP_IOT0000007118": "南涧彝族自治县",
        "P_YS_FED_EXAMP_0000020234": "仅挂单",
        "P_YS_FED_IMP_IOT0000008449": "临翔区",
        "P_YS_FED_EXAMP_0000020233": "第",
        "P_YS_FED_FW_0000022400": "仓储中心",
        "P_YS_FED_FW_0000022401": "接收人",
        "P_YS_FED_FW_0000022404": "关闭其他",
        "P_YS_FED_IMP_IOT0000007111": "坊子区",
        "P_YS_FED_IMP_IOT0000008443": "东坡区",
        "P_YS_FED_FW_0000022405": "配置信息中字段验证失败。包含栏目中不存在的字段 转换前",
        "P_YS_FED_EXAMP_0000020239": "更改交货仓库将同步更新已添加商品，是否确认更新？",
        "P_YS_FED_FW_0000022402": "方案名称:",
        "P_YS_FED_FW_0000022403": "间隔",
        "P_YS_FED_IMP_IOT0000008442": "双流县",
        "P_YS_FED_IMP_IOT0000009773": "高淳县",
        "P_YS_FED_EXAMP_0000020250": "货品档案",
        "P_YS_FED_EXAMP_0000020252": "抹零",
        "P_YS_PF_PRINT_0000057882": "出生日期",
        "P_YS_FED_EXAMP_0000020251": "选择门店",
        "P_YS_FED_FW_1525642288515514373": "查询后面板自动收起",
        "P_YS_FED_FW_0000022419": "（最大1M，支持格式：jpg、bmp、png、jpeg，700*700 以上的图片可以在商品详情页主图提供图片放大功能）",
        "P_YS_FED_EXAMP_0000020247": "确定整单清除吗?",
        "P_YS_FED_IMP_IOT0000008436": "怀远县",
        "P_YS_FED_IMP_IOT0000009767": "南县",
        "P_YS_FED_EXAMP_0000020246": "已执行过促销优惠活动,不允许修改卡券号",
        "P_YS_FED_IMP_IOT0000007103": "盐津县",
        "P_YS_FED_IMP_IOT0000009768": "中原区",
        "P_YS_FED_FW_0000022417": "位",
        "P_YS_FED_EXAMP_0000020249": "登录124",
        "P_YS_FED_IMP_IOT0000007106": "宝清县",
        "P_YS_FED_IMP_IOT0000008434": "海原县",
        "P_YS_FED_FW_0000022418": "发布报表方案saveMenu 参数 name =",
        "P_YS_FED_EXAMP_0000020248": "POS机未指定摄像头ID/IP，请配置！",
        "P_YS_FED_IMP_IOT0000007105": "芝罘区",
        "P_YS_FED_EXAMP_0000020243": "电商/电商退货状态下，表体行仓库必须一致！",
        "P_YS_FED_IMP_IOT0000007108": "夏河县",
        "P_YS_FED_EXAMP_0000020242": "%, 确认结算？",
        "P_YS_PF_GZTSYS_0000012026": "相册",
        "P_YS_FED_EXAMP_0000020245": "表单模版设计",
        "P_YS_FED_IMP_IOT0000009769": "无锡",
        "P_YS_FED_EXAMP_0000020244": "当前时段不允许跨日！请重新选择时间！",
        "P_YS_FED_IMP_IOT0000007109": "金牛区",
        "P_YS_FED_IMP_IOT0000008439": "游仙区",
        "P_YS_FED_FW_0000022411": "获取数据失败！",
        "P_YS_FED_FW_0000022412": "公司传真",
        "P_YS_FED_FW_0000022410": "请输入详细地址",
        "P_YS_FED_FW_0000022415": "是否启用",
        "P_YS_FED_IMP_IOT0000007100": "渭源县",
        "P_YS_FED_FW_0000022413": "过滤名称",
        "P_YS_FED_IMP_IOT0000007102": "肇东市",
        "P_YS_FED_IMP_IOT0000008430": "青秀区",
        "P_YS_FED_FW_0000022414": "订阅频率",
        "P_YS_FED_IMP_IOT0000009762": "桓仁满族自治县",
        "P_YS_HR_HRXCF_0000056174": "近一年",
        "P_YS_FED_FW_0001138953": "数据错误，未找到对应的方案",
        "P_YS_SCM_USTOCK_0001131722": "新增",
        "P_YS_FED_EXAMP_0000020261": "开始卡券号和结束卡券号后缀不同",
        "P_YS_FED_EXAMP_0000020260": "此",
        "P_YS_FED_EXAMP_0000020263": "赠品",
        "P_YS_FED_EXAMP_0000020262": "当前行不允许改行！",
        "P_YS_FED_EXAMP_0000020258": "实体卡券商品销售,卡券数量应为1",
        "P_YS_FED_EXAMP_0000020257": "本单金额为0，是否继续？",
        "P_YS_FED_IMP_IOT0000008426": "福泉市",
        "P_YS_FED_IMP_IOT0000009757": "土默特左旗",
        "P_YS_PF_GZTSYS_0000013325": "标签",
        "P_YS_FED_IMP_IOT0000009754": "濠江区",
        "P_YS_FED_EXAMP_0000020259": "调整状态不允许修改营业员！",
        "P_YS_FED_IMP_IOT0000009755": "龙陵县",
        "P_YS_FED_EXAMP_0000020254": "原单退货中，换货行不允许修改营业员！",
        "P_YS_FED_IMP_IOT0000008429": "武城县",
        "P_YS_PF_GZTSYS_0000015985": "查询方案",
        "P_YS_FED_EXAMP_0000020253": "请先录入会员！",
        "P_YS_FED_EXAMP_0000020256": "店存出库",
        "P_YS_FED_EXAMP_0000020255": "用户及角色",
        "P_YS_SCM_USTOCK_0001131725": "保存",
        "P_YS_FED_IMP_IOT0000009752": "中江县",
        "P_YS_FED_FW_0001322216": "当前选中节点包含下级，确定删除么？",
        "P_YS_FED_IMP_IOT0000009753": "融水苗族自治县",
        "P_YS_FED_IMP_IOT0000009750": "阳高县",
        "P_YS_FED_IMP_IOT0000008420": "横峰县",
        "P_YS_FED_IMP_IOT0000009751": "临澧县",
        "P_YS_FED_EXAMP_0000020272": "预定",
        "P_YS_FED_EXAMP_0000020271": "6-20位数字或字母 不允许有空格",
        "P_YS_FED_EXAMP_0000020274": "退品数据处理失败！",
        "P_YS_FED_EXAMP_0000020273": "已经存在该序列号商品！",
        "P_YS_FED_EXAMP_0000020270": "获取是否弹出厨打提示信息失败！",
        "P_YS_FED_EXAMP_0000020269": "固定套餐的商品需要全选",
        "P_YS_FED_IMP_IOT0000009745": "敖汉旗",
        "P_YS_FED_EXAMP_0000020268": "实退金额必须小于等于零。",
        "P_YS_FED_IMP_IOT0000008415": "夏津县",
        "P_YS_FED_IMP_IOT0000008413": "安远县",
        "P_YS_FED_FW_1602282827388813325": "不显示列的值",
        "P_YS_FED_EXAMP_0000020265": "应收金额不能小于卡券结算金额，请检查！",
        "P_YS_FI_FP_0001126682": "服务异常",
        "P_YS_FED_EXAMP_0000020264": "该状态下不能使用快捷结算！",
        "P_YS_FED_EXAMP_0000020267": "优惠券功能",
        "P_YS_FED_FW_1602282827388813328": "计算该数值列的平均值",
        "P_YS_FED_EXAMP_0000020266": "”未能在营业员列表中找着",
        "P_YS_FED_IMP_IOT0000008417": "伊宁县",
        "P_YS_FED_IMP_IOT0000008410": "安居区",
        "P_YS_FED_FW_1602282827388813322": "计算该数值列所有数据的和",
        "P_YS_FED_IMP_IOT0000009742": "南和县",
        "P_YS_FED_IMP_IOT0000009740": "天桥区",
        "P_YS_FED_FW_0000021120": "晋中市",
        "P_YS_FED_FW_0000022451": "最多选择",
        "P_YS_FED_FW_0000021121": "数量/金额/单价，预制错误！",
        "P_YS_FED_FW_0000022452": "意大利语",
        "P_YS_FED_FW_0000022450": "左侧Y轴",
        "P_YS_PF_GZTSYS_0000013395": "销售区域",
        "P_YS_PF_GZTSYS_0000013390": "日结",
        "P_YS_FED_FW_1602282827388813316": "显示该列所有值，并用逗号分隔",
        "P_YS_FED_FW_0000021119": "德宏傣族景颇族自治州",
        "P_YS_FED_IMP_IOT0000008401": "上饶县",
        "P_YS_FED_FW_1602282827388813313": "显示该列中的最小值",
        "P_YS_FED_IMP_IOT0000008407": "北安市",
        "P_YS_FED_FW_1602282827388813319": "显示该列中的最大值",
        "P_YS_FED_IMP_IOT0000008408": "余姚市",
        "P_YS_FED_IMP_IOT0000008405": "木垒哈萨克自治县",
        "P_YS_FED_IMP_IOT0000009737": "单县",
        "P_YS_FED_FW_0000021113": "辽阳市",
        "P_YS_FED_FW_0000022444": "至少保留一行数据。",
        "P_YS_FED_FW_0001376079": "不正确,请输入后重试",
        "P_YS_FED_FW_0000021114": "阿坝藏族羌族自治州",
        "P_YS_FED_FW_0000022445": "关闭全部",
        "P_YS_FED_FW_1435192751107342336": "已达最小值,不可减小",
        "P_YS_FED_FW_0000021111": "焦作市",
        "P_YS_FED_FW_0000022442": "显示条形",
        "P_YS_FED_FW_0000021112": "缓存数据失败！",
        "P_YS_FED_FW_0000022443": "获取过滤条件错误。",
        "P_YS_FED_FW_0000021117": "台湾",
        "P_YS_FED_FW_0000022448": "最多选择16项菜单！",
        "P_YS_FED_FW_1435192751107342339": "已达最大值,不可增加",
        "P_YS_FED_FW_0000021118": "移动报表 MobileReport Render sumFieldsCount",
        "P_YS_FED_FW_0000022449": "报表分组方案配置信息",
        "P_YS_FED_IMP_IOT0000009731": "长寿区",
        "P_YS_FED_FW_0000021115": "烟台市",
        "P_YS_FED_FW_0000022446": "刷新频率设置不正确",
        "P_YS_FED_FW_0000021116": "贺州市",
        "P_YS_FED_FW_0000022447": "草稿名称",
        "P_YS_FED_FW_0000021131": "营口市",
        "P_YS_FED_FW_0000022462": "更新失败！返回信息：",
        "P_YS_FED_FW_0000021132": "吉林",
        "P_YS_FED_FW_0000022463": "监控视图的图形报表 getConfig",
        "P_YS_FED_FW_0000022460": "关键字段不允许移动！",
        "P_YS_FED_FW_0000022461": "栏目名称/公式为必输项！请填写完整后重试！",
        "P_YS_FED_FW_0000021130": "在线",
        "P_YS_FED_IMP_IOT0000009729": "留坝县",
        "P_YS_FED_EXAMP_0000020203": "退回门店为否时,退货仓库不能为空！",
        "P_YS_FED_EXAMP_0000020202": "商品行金额不能为0！",
        "P_YS_FED_EXAMP_0000020205": "商品档案中没有匹配到识别到的商品!",
        "P_YS_FED_EXAMP_0000020204": "行商品未输入储值卡号",
        "P_YS_FED_IMP_IOT0000009727": "沾益县",
        "P_YS_FED_EXAMP_0000020201": "角色",
        "P_YS_FED_IMP_IOT0000009725": "孟村回族自治县",
        "P_YS_FED_EXAMP_0000020200": "未填写房间信息，是否继续结算？",
        "P_YS_FED_FW_0000021124": "合计",
        "P_YS_FED_FW_0000022455": "目前只支持 JPG/PNG file!",
        "P_YS_FED_FW_0000021125": "暂时没有数据哦~",
        "P_YS_FED_FW_0000022456": "设计",
        "P_YS_FED_FW_0000021122": "澳门特别行政区",
        "P_YS_FED_FW_0000022453": "获取常用功能列表失败！",
        "P_YS_FED_FW_0000022454": "匹配一维表的行时，有多个匹配行，请检查。 rowItemMatchInfo =",
        "P_YS_FED_FW_0000021123": "体验账号",
        "P_YS_FED_FW_0000021128": "乌兰察布市",
        "P_YS_FED_FW_0000022459": "办事处",
        "P_YS_FED_EXAMP_0000020207": "通过",
        "P_YS_FED_FW_0000021129": "澳门",
        "P_YS_FED_FW_0000021126": "鹤壁市",
        "P_YS_FED_FW_0000022457": "保存为常用方案",
        "P_YS_FED_EXAMP_0000020209": "统计指定日期范围内的销量",
        "P_YS_FED_FW_0000021127": "桂林市",
        "P_YS_FED_EXAMP_0000020208": "图片",
        "P_YS_FED_FW_0000022458": "复制模板",
        "P_YS_FED_FW_0000022430": "日期分隔符",
        "P_YS_FED_IMP_IOT0000009719": "长白朝鲜族自治县",
        "P_YS_FED_EXAMP_0000020214": "请修改固定套餐的子行退货信息。",
        "P_YS_FED_IMP_IOT0000009712": "温县",
        "P_YS_FED_EXAMP_0000020213": "卡券业务类型下才能选择卡券商品！",
        "P_YS_FED_FW_0000022428": "请设置filterId",
        "P_YS_FED_EXAMP_0000020216": "商品行必须进行金额调整！",
        "P_YS_FED_IMP_IOT0000009710": "肥城市",
        "P_YS_FED_FW_0000022429": "获取敏感数据列表失败！",
        "P_YS_FED_EXAMP_0000020215": "是否取消自动促销？",
        "P_YS_FED_EXAMP_0000020210": "交货",
        "P_YS_FED_EXAMP_0000020212": "已经执行促销活动，不能改零售价！",
        "P_YS_FED_IMP_IOT0000009714": "安义县",
        "P_YS_FED_EXAMP_0000020211": "表体行仓库不能为空！",
        "P_YS_FED_IMP_IOT0000009715": "修文县",
        "P_YS_FED_FW_0000022422": "*模板名称:",
        "P_YS_HR_HRJQF_0000054440": "显示未启用",
        "P_YS_FED_FW_0000022423": "请输入模板编码",
        "P_YS_FED_FW_0000022420": "添加日期时间",
        "P_YS_FED_FW_0000022421": "存在编码重复的区域：",
        "P_YS_FED_FW_0000022426": "热区显示图 不进行刷新。",
        "P_YS_FED_EXAMP_0000020218": "固定套餐不允许改零售价",
        "P_YS_FED_FW_0000022427": "档案值，名称字段不能为空！",
        "P_YS_FED_EXAMP_0000020217": "按钮的功能权限，不能操作",
        "P_YS_FED_FW_0000022424": "添加规格值",
        "P_YS_FED_FW_0000022425": "条形图",
        "P_YS_FED_EXAMP_0000020219": "较前期",
        "P_YS_HR_HRJQF_0000054435": "员工姓名",
        "P_YS_FED_FW_0000022440": "背景风格",
        "P_YS_FED_FW_1435759635250806784": "环境变量process.env[domain.gpaas.url]和process.env[public.domain.gpaas.url]未配置，哈勃收集失败！",
        "P_YS_FED_FW_0000021110": "宜春市",
        "P_YS_FED_FW_0000022441": "暂无搜索结果～",
        "P_YS_HR_HRJQF_0000054439": "工龄",
        "P_YS_FED_IMP_IOT0000009709": "同德县",
        "P_YS_FED_FW_0001287429": "锁定显示",
        "P_YS_FED_EXAMP_0000020230": "已经执行了",
        "P_YS_PF_GZTSYS_0000013382": "表单模板",
        "P_YS_FED_FW_1628198325042282505": "证件内容为空",
        "P_YS_FED_FW_1564270202179813377": "合法值：",
        "P_YS_FED_EXAMP_0000020225": "王府井店",
        "P_YS_FED_IMP_IOT0000009701": "颍泉区",
        "P_YS_HR_HRJXF_0000059839": "反馈",
        "P_YS_FED_EXAMP_0000020224": "交货不能修改商品时，不能新增商品！",
        "P_YS_FED_FW_0000021108": "青海",
        "P_YS_FED_FW_0000022439": "展示",
        "P_YS_FED_EXAMP_0000020227": "退回门店为否且退货仓库为空时，不允许结算",
        "P_YS_FED_FW_0000021109": "两列",
        "P_YS_FED_EXAMP_0000020226": ")启用了序列号管理，请输入序列号！",
        "P_YS_FED_IMP_IOT0000009700": "禹州市",
        "P_YS_FED_EXAMP_0000020221": "已经执行了促销活动，不允许执行优惠券！",
        "P_YS_FED_EXAMP_0000020220": "]不存在,或序列号为已出库状态！",
        "P_YS_FED_IMP_IOT0000009706": "榆中县",
        "P_YS_FED_EXAMP_0000020223": "电话：",
        "P_YS_FED_IMP_IOT0000009703": "神木县",
        "P_YS_FED_EXAMP_0000020222": "卡券业务类型下只允许录入卡券商品！",
        "P_YS_FED_IMP_IOT0000009704": "迭部县",
        "P_YS_FED_FW_0000021102": "忻州市",
        "P_YS_FED_FW_0000022433": "无控件",
        "P_YS_FED_FW_0000021103": "威海市",
        "P_YS_FED_FW_0000022434": "数值字体大小",
        "P_YS_FED_FW_0001604215": "请选择行在进行下移操作！",
        "P_YS_FED_FW_0000021100": "表",
        "P_YS_FED_FW_0000022431": "当前只允许上传一个附件，请删除后重新上传！",
        "P_YS_FED_FW_0000021101": "兰州市",
        "P_YS_FED_FW_0000022432": "请输入公司传真",
        "P_YS_FED_FW_0000021106": "朔州市",
        "P_YS_FED_FW_0000022437": "模板编码/模板名称不支持全角！",
        "P_YS_FED_EXAMP_0000020229": "会员钱包充值功能",
        "P_YS_FED_FW_0000021107": "长沙市",
        "P_YS_FED_FW_0000022438": "加载图片错误。图片地址：",
        "P_YS_FED_EXAMP_0000020228": "本次调整金额不能为0！",
        "P_YS_FED_FW_0000021104": "移动报表 getSolutionList Err",
        "P_YS_FED_FW_0000022435": "输入不合法，请检查",
        "P_YS_FED_FW_0001287430": "清空筛选",
        "P_YS_FED_FW_0001604216": "请选择行在进行上移操作！",
        "P_YS_FED_FW_0000021105": "东莞市",
        "P_YS_FED_FW_0000022436": "请设置报表",
        "P_YS_SD_UDHWN_0000049316": "济源市",
        "P_YS_SD_UDHWN_0000050306": "平谷区",
        "P_YS_PF_METADATA_0000084512": "事件类型",
        "P_YS_FI_FIEIA-FE_1519816251266301957": "子表第",
        "P_YS_PF_METADATA_0000085849": "商标",
        "P_YS_SD_UDHWN_0000050316": "大兴区",
        "P_YS_FED_FW_1535350529502740485": "暂无可用打印模板图片",
        "P_YS_FED_FW_1582845738146070530": "点击开始扫码",
        "P_YS_PF_METADATA_0000085850": "网站",
        "P_YS_FED_FW_1535350529502740488": "无可用打印模板图片",
        "P_YS_PF_GZTSYS_0000015817": "看板",
        "P_YS_FED_FW_0001045104": "restoreEditPanel 需要从items中获取过滤信息赋到pageLayout上，但items为空，可能信息丢失  pageLayout =",
        "P_YS_SD_URETAIL_0001049031": "数据更新错误原因失败：",
        "P_YS_FED_FW_0001563307": "&region=北京&output=json&ak=",
        "P_YS_SD_UDHWN_0000050326": "乐东黎族自治县",
        "P_YS_FED_UCFORG_0000031966": "上一步",
        "P_YS_FED_UIMG_0000111351": "表达式不能为空",
        "P_YS_FED_FW_1593218496493781008": "文献共同検索の結果",
        "P_YS_FED_IMP_IOT0000010600": "丹阳市",
        "P_YS_FED_IMP_IOT0000010606": "兴隆台区",
        "P_YS_FED_IMP_IOT0000010607": "兴化市",
        "P_YS_FED_FW_0000137710": "to ：",
        "P_YS_FED_IMP_IOT0000010613": "松江区",
        "P_YS_FED_IMP_IOT0000010614": "荔湾区",
        "P_YS_PF_SOCD_0000089309": "乌克兰",
        "P_YS_PF_SOCD_0000089307": "南斯拉夫",
        "P_YS_FED_IMP_IOT0000010611": "铁东区",
        "P_YS_FED_FW_0000137708": "当前批量修改的字段ele：",
        "P_YS_PF_SOCD_0000089308": "西班牙",
        "P_YS_FED_FW_0000137707": "在栏目中未能找到全部的列表区配置字段 codeField stateField captionFields",
        "P_YS_PF_SOCD_0000089305": "塞拉利昂",
        "P_YS_FED_FW_0000137706": "批改错误：this.gridModel.getColumns()为空!",
        "P_YS_PF_SOCD_0000089306": "阿塞拜疆",
        "P_YS_FED_FW_0000137705": "batchModify 尚不支持当前操作符。filter =",
        "P_YS_FED_FW_0000137704": "未设置刷新时间或者设置的刷新时间太短。",
        "P_YS_PF_SOCD_0000089304": "哈萨克斯坦",
        "P_YS_FED_FW_0000137703": "batchModify setUETypeAndDataType Err.批改没有获取正确的字段类型 --》cControlType =",
        "P_YS_FED_IMP_IOT0000010617": "路北区",
        "P_YS_FED_FW_0000137702": "获取列定义失败。信息 :",
        "P_YS_FED_FW_0000137701": "获取分组权限信息失败。信息 :",
        "P_YS_FED_FW_0000137700": "::::[StatusBar] ,info: cus/getCusDigest 未请求到数据",
        "P_YS_FED_FW_0000137721": "communication ---参数转换-->错误",
        "P_YS_FED_FW_0000137720": "条件返回false，如有疑问参考文档https://www.yuque.com/gpgy5k/ucf/nzso9u",
        "P_YS_FED_IMP_IOT0000010626": "西丰县",
        "P_YS_FED_IMP_IOT0000010620": "西陵区",
        "P_YS_FED_IMP_IOT0000010621": "甘孜县",
        "P_YS_FED_IMP_IOT0000010623": "大悟县",
        "P_YS_FED_FW_0000137718": "dbName---错误",
        "P_YS_FED_FW_0000137717": "匹配不到数据",
        "P_YS_FED_FW_0000137716": "extendField数据配置错误",
        "P_YS_SD_UDHWN_0001008443": "↑",
        "P_YS_FED_FW_0000137714": "批改错误：初始化 batchModify 没有找到GridModel!",
        "P_YS_FED_IMP_IOT0000010628": "建华区",
        "P_YS_SD_UDHWN_0001008444": "↓",
        "P_YS_FED_FW_0000137713": "你的浏览器不支持IndexedDB",
        "P_YS_FED_IMP_IOT0000010629": "闽清县",
        "P_YS_FED_FW_0000137712": "保存分组条件失败。信息 :",
        "P_YS_FED_FW_0000137711": "当前录入的过滤的字段信息 filterObjs：",
        "P_YS_PF_GZTSYS_0000015859": "数据源",
        "P_YS_FED_FW_0000137730": "---------确定 按钮-----------",
        "P_YS_SD_URETAIL_0001049078": "监听中日志...",
        "P_YS_FED_IMP_IOT0000010630": "福鼎市",
        "P_YS_FED_IMP_IOT0000010632": "雷州市",
        "P_YS_FED_IMP_IOT0000010633": "槐荫区",
        "P_YS_FED_FW_0000137729": "已禁止根据返回数据render",
        "P_YS_FED_FW_0000137728": "扩展脚本需要配置addAttachment",
        "P_YS_FED_FW_0000137727": "缺少子表id",
        "P_YS_PF_SOCD_0000089325": "科威特",
        "P_YS_FED_FW_0000137726": "cb.lang没有加载，多语配置出问题",
        "P_YS_PF_SOCD_0000089326": "牙买加",
        "P_YS_PF_GZTSYS_0000015829": "报表",
        "P_YS_FED_FW_0000137725": "inputnumber没有model",
        "P_YS_FED_IMP_IOT0000010639": "惠东县",
        "P_YS_FED_FW_0000137724": "input 没有model",
        "P_YS_PF_SOCD_0000089324": "塞内加尔",
        "P_YS_FED_FW_0000137723": "%c 二维表日志 警告",
        "P_YS_PF_SOCD_0000089321": "马达加斯加",
        "P_YS_FED_FW_0000137722": "二维表日志",
        "P_YS_PF_SOCD_0000089322": "冈比亚",
        "P_YS_SD_URETAIL_0001049087": "确定要清空已选商品吗？",
        "P_YS_FED_FW_1437398955540348928": "最多选择15个汇总项。",
        "P_YS_FED_FW_0000111115": "条/页",
        "P_YS_FED_FW_0001425472": "条选中",
        "P_YS_FED_IMP_IOT0000010641": "宜黄县",
        "P_YS_FED_IMP_IOT0000010646": "东辽县",
        "P_YS_FED_IMP_IOT0000010647": "田东县",
        "P_YS_FED_IMP_IOT0000010642": "谯城区",
        "P_YS_FED_IMP_IOT0000010643": "湖滨区",
        "P_YS_PF_SOCD_0000089318": "爱沙尼亚",
        "P_YS_PF_SOCD_0000089316": "加拿大",
        "P_YS_PF_SOCD_0000089317": "日本",
        "P_YS_PF_SOCD_0000089314": "塔吉克斯坦",
        "P_YS_PF_SOCD_0000089315": "乌干达",
        "P_YS_PF_SOCD_0000089310": "乌拉圭",
        "P_YS_PF_SOCD_0000089311": "苏里南",
        "P_YS_HR_HRJQ_0000031330": "十二",
        "P_YS_FED_IMP_IOT0000010651": "仁和区",
        "P_YS_FED_IMP_IOT0000010652": "江城哈尼族彝族自治县",
        "P_YS_FED_IMP_IOT0000010656": "成县",
        "P_YS_SD_UDHWN_0000050384": "仙桃市",
        "P_YS_FED_IMP_IOT0000010661": "沙河市",
        "P_YS_FED_IMP_IOT0000010662": "颍东区",
        "P_YS_FED_IMP_IOT0000010669": "沙洋县",
        "P_YS_FED_IMP_IOT0000010664": "宁安市",
        "P_YS_FED_IMP_IOT0000010665": "王益区",
        "P_YS_FED_IMP_IOT0000010666": "夷陵区",
        "P_YS_FED_IMP_IOT0000010671": "清镇市",
        "P_YS_FED_IMP_IOT0000010672": "乌鲁木齐县",
        "P_YS_FED_IMP_IOT0000010679": "满洲里市",
        "P_YS_PF_PROCENTER_0000027049": "另存为",
        "P_YS_FED_IMP_IOT0000010682": "普宁市",
        "P_YS_FED_IMP_IOT0000010685": "杭锦旗",
        "P_YS_FED_UIMG_0001237120": "向左",
        "P_YS_FED_UIMG_0001237119": "向上",
        "P_YS_FED_IMP_IOT0000010686": "汉寿县",
        "P_YS_FED_IMP_IOT0000010689": "南郊区",
        "P_YS_SD_SDMB-UI_0001140276": "请输入订单编号",
        "P_YS_FED_FW_0001083419": "身份证格式错误！",
        "P_YS_FED_IMP_IOT0000010693": "隆安县",
        "P_YS_FED_IMP_IOT0000010692": "子长县",
        "P_YS_PF_PROCENTER_0000023508": "；",
        "P_YS_SD_SDSD-FE_0001486259": "日期時間",
        "P_YS_FED_IMP_IOT0000010697": "都兰县",
        "P_YS_FED_FW_1525783781928599556": "请获取定位",
        "P_YS_FED_IMP_IOT0000010699": "嘉荫县",
        "P_YS_FED_FW_1443151222423420928": "——————————",
        "P_YS_OA_XTLCZX_0000032004": "无匹配数据",
        "P_YS_SD_SDOC_0001150290": "退件签收",
        "P_YS_SD_UDHWN_0000122310": "订单类型：",
        "P_YS_FED_FW_0001083420": "银行卡式错误！",
        "P_YS_FED_FW_0001154320": "请录入以下<%=text%>必输字段",
        "P_YS_FED_UIMG_0001065827": "非数值类型的字段不能合计",
        "P_YS_FED_FW_0001154325": "请录入以下表头必输字段",
        "P_YS_FED_FW_0001071458": "文件名称长度不能超过10个字符！",
        "P_YS_SD_UDHWN_0001009722": "1 分钟",
        "P_YS_SD_SDMB_0000148279": "～",
        "P_YS_FED_FW_1572544576923631641": "数据加载中~",
        "P_YS_FED_FW_1473069861501927437": "searchDevices failed,错误信息:",
        "P_YS_FED_FW_1473069861501927434": "printPicture failed,错误信息:",
        "P_YS_SD_SDMB_0000150570": "应用中心",
        "P_YS_FED_FW_0001096749": "获取数据失败，接口报错!",
        "P_YS_SD_UDHWN_0001009713": "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月",
        "P_YS_SD_UDHWN_0001009717": "[昨天]LT",
        "P_YS_FED_FW_1572544576923631638": "已经到底了~",
        "P_YS_FED_IMP_IOT0000008294": "夏县",
        "P_YS_FED_IMP_IOT0000008298": "镇远县",
        "P_YS_FED_FW_1473069861501927431": "searchDevices complete,信息:",
        "P_YS_FED_FW_1572544576923631635": "tag需要配置为select/input类型",
        "P_YS_FED_FW_0000021281": "眉山市",
        "P_YS_FED_FW_0001026029": "图片仅支持<%=accept%>格式",
        "P_YS_FED_FW_0000021282": "锦州市",
        "P_YS_HR_HRJQ_0000031296": "员工编号",
        "P_YS_FED_FW_0000021280": "龙岩市",
        "P_YS_FED_FW_0000021285": "太原市",
        "P_YS_PF_SOCD-E_0000354672": "阿拉伯联合酋长国",
        "P_YS_FED_FW_0000021286": "咸阳市",
        "P_YS_FED_IMP_IOT0000007080": "仲巴县",
        "P_YS_FED_FW_0000021283": "惠州市",
        "P_YS_FED_IMP_IOT0000007083": "梅江区",
        "P_YS_FED_FW_0000021284": "丽江市",
        "P_YS_FED_IMP_IOT0000007082": "瑞昌市",
        "P_YS_SD_SDSD-FE_0001486298": "創建人",
        "P_YS_FED_EXAMP_0000020199": "标签列表",
        "P_YS_FED_EXAMP_0000020198": "输入两次新密码不一致!",
        "P_YS_FED_FW_0000021278": "超出上传限制，请删除后重新上传！",
        "P_YS_FED_FW_0001445807": "共选中数据条数",
        "P_YS_FED_FW_0000021279": "数据显示区域 width =",
        "P_YS_FED_IMP_IOT0000007073": "廉江市",
        "P_YS_HR_HRJQ_0000031291": "導入",
        "P_YS_FED_FW_0001445806": "共选中数据条数",
        "P_YS_FED_FW_0000021276": "；失败",
        "P_YS_FED_IMP_IOT0000007076": "朗县",
        "P_YS_FED_FW_0000021277": "潍坊市",
        "P_YS_FED_IMP_IOT0000007075": "临江市",
        "P_YS_FED_IMP_IOT0000007078": "古交市",
        "P_YS_FED_FW_0001026037": "<%=caption%> 已被此公式引用，不可循环引用",
        "P_YS_FED_IMP_IOT0000007077": "鄂城区",
        "P_YS_FED_FW_0000021292": "济宁市",
        "P_YS_FED_FW_0000021293": "衢州市",
        "P_YS_FED_FW_0000021290": "操作出错",
        "P_YS_FED_FW_0001026038": "确定要 <%=abandonText%>么?",
        "P_YS_FED_FW_0000021291": "甘孜藏族自治州",
        "P_YS_FED_FW_0000021296": "格式化字段，预制错误！",
        "P_YS_FED_FW_0001094183": "]方法",
        "P_YS_FED_FW_0000021297": "refer  cFormatData，预制错误！",
        "P_YS_FED_FW_0001094184": "结束调用Action[",
        "P_YS_FED_FW_0000021294": "香港特别行政区",
        "P_YS_FED_IMP_IOT0000007072": "寿光市",
        "P_YS_FED_FW_0000021295": "移动报表 MobileReport setSumFieldsCount sumFieldsCount",
        "P_YS_FED_IMP_IOT0000007071": "霍山县",
        "P_YS_HR_HRJQF_0000054539": "年份",
        "P_YS_HR_HRRCPDF_0000073182": "未选",
        "P_YS_FED_FW_1515244353091534848": "请查看错误原因，修改后重新导入。",
        "P_YS_OA_XTXIANGMU_0000063901": "添加标签",
        "P_YS_FED_FW_0000021289": "宁波市",
        "P_YS_FED_IMP_IOT0000007062": "溧水县",
        "P_YS_FED_FW_0000021287": "鞍山市",
        "P_YS_FED_FW_0000021288": "黄南藏族自治州",
        "P_YS_FED_FW_0001026042": "是否确认<%=cShowCaption%>此记录",
        "P_YS_FED_IMP_IOT0000008394": "天柱县",
        "P_YS_FED_IMP_IOT0000007068": "乌马河区",
        "P_YS_FED_FW_0000021260": "文山壮族苗族自治州",
        "P_YS_FED_FW_0000021263": "九江市",
        "P_YS_FED_IMP_IOT0000008391": "喀什市",
        "P_YS_FED_FW_0000021264": "凉山彝族自治州",
        "P_YS_FED_IMP_IOT0000008392": "辽中县",
        "P_YS_FED_FW_0000021261": "云浮市",
        "P_YS_FED_FW_0000021262": "自贡市",
        "P_YS_FED_FW_0000021256": "北海市",
        "P_YS_FED_IMP_IOT0000007052": "潘集区",
        "P_YS_FED_FW_0000021257": "subConfig_Get 没有找到对应的eChart  chartKey =",
        "P_YS_FED_IMP_IOT0000007051": "静宁县",
        "P_YS_FED_IMP_IOT0000008385": "岳阳楼区",
        "P_YS_FED_FW_0000021254": "孝感市",
        "P_YS_FED_FW_0000021255": "昭通市",
        "P_YS_FED_IMP_IOT0000007056": "永和县",
        "P_YS_FED_IMP_IOT0000008388": "乐都县",
        "P_YS_FED_IMP_IOT0000008389": "洱源县",
        "P_YS_FED_FW_0000021258": "唐山市",
        "P_YS_FED_IMP_IOT0000008386": "天祝藏族自治县",
        "P_YS_FED_FW_0000021259": "阳泉市",
        "P_YS_FED_FW_0000021270": "周口市",
        "P_YS_FED_FW_0000021271": "省直辖县级行政区划",
        "P_YS_FED_FW_0000021274": "宁夏",
        "P_YS_FED_FW_0000021275": "来宾市",
        "P_YS_FED_IMP_IOT0000008381": "翁牛特旗",
        "P_YS_FED_FW_0000021272": "怒江傈僳族自治州",
        "P_YS_FED_IMP_IOT0000007050": "广州",
        "P_YS_FED_FW_0000021273": "根据filterId没有获取到任何移动端过滤方案",
        "P_YS_FED_FW_0001104071": "导航区",
        "P_YS_FED_IMP_IOT0000007049": "唐河县",
        "P_YS_FED_FW_0000021267": "eChartCommon 更新过滤条件，去除里面的空值 after param =",
        "P_YS_FED_IMP_IOT0000007041": "越西县",
        "P_YS_FED_IMP_IOT0000008373": "泽普县",
        "P_YS_FED_FW_0000021268": "杭州市",
        "P_YS_FED_IMP_IOT0000008374": "沅江市",
        "P_YS_FED_FW_0000021265": "吐鲁番地区",
        "P_YS_FED_FW_0000021266": "区域经理大屏看板",
        "P_YS_FED_IMP_IOT0000007042": "乳源瑶族自治县",
        "P_YS_FED_IMP_IOT0000008372": "苏家屯区",
        "P_YS_FED_IMP_IOT0000008378": "海州区",
        "P_YS_FED_FW_0000021269": "淮北市",
        "P_YS_FED_IMP_IOT0000007047": "莲湖区",
        "P_YS_FED_FW_0001026024": "<%=text%> 上传失败！<%=code%> : <%=message%>",
        "P_YS_FED_IMP_IOT0000007046": "新宾满族自治县",
        "P_YS_FED_FW_1486872262975422477": "已保存为草稿",
        "P_YS_FED_FW_1486872262975422474": "是否保存为草稿？",
        "P_YS_FED_EXAMP_0000020162": "房费商品时长不能为空！",
        "P_YS_FED_FW_1486872262975422471": "若不保存，所做编辑将不会被储存",
        "P_YS_FED_EXAMP_0000020161": "),不得低于当前操作员金价折扣额上限(",
        "P_YS_FED_EXAMP_0000020164": "此种网络状况下，不允许电商结算！",
        "P_YS_FED_EXAMP_0000020163": "储值卡售卡功能",
        "P_YS_FED_EXAMP_0000020160": "序列号[",
        "P_YS_FED_EXAMP_0000020159": "实体卡券不允许修改数量",
        "P_YS_FED_IMP_IOT0000007038": "鄂托克前旗",
        "P_YS_FED_EXAMP_0000020158": "当前时段区间为：",
        "P_YS_FED_IMP_IOT0000008368": "白玉县",
        "P_YS_FED_IMP_IOT0000009699": "原阳县",
        "P_YS_FED_IMP_IOT0000007039": "佛坪县",
        "P_YS_FED_IMP_IOT0000008369": "衡南县",
        "P_YS_FED_EXAMP_0000020155": "预订退订状态下,不允许修改营业员！",
        "P_YS_FED_EXAMP_0000020154": "缴款",
        "P_YS_FED_EXAMP_0000020156": "登录令牌失效，即将跳转登陆页面？",
        "P_YS_FED_IMP_IOT0000008362": "大关县",
        "P_YS_FED_IMP_IOT0000009694": "清苑县",
        "P_YS_FED_IMP_IOT0000008360": "景洪市",
        "P_YS_FED_IMP_IOT0000007032": "松潘县",
        "P_YS_FED_IMP_IOT0000009691": "湖里区",
        "P_YS_FED_IMP_IOT0000007031": "红星区",
        "P_YS_FED_IMP_IOT0000008361": "金凤区",
        "P_YS_FED_IMP_IOT0000009697": "上犹县",
        "P_YS_FED_IMP_IOT0000007033": "浮山县",
        "P_YS_FED_IMP_IOT0000008367": "桥西区",
        "P_YS_FED_IMP_IOT0000009698": "沅陵县",
        "P_YS_FED_FW_0001026078": "此汇总项已被<%=text%>公式引用不可取消",
        "P_YS_FED_IMP_IOT0000007036": "柘荣县",
        "P_YS_FED_IMP_IOT0000009695": "郸城县",
        "P_YS_FED_IMP_IOT0000007035": "公安县",
        "P_YS_FED_IMP_IOT0000008365": "聂拉木县",
        "P_YS_FED_IMP_IOT0000009696": "芦溪县",
        "P_YS_FED_EXAMP_0000020173": "全部应用",
        "P_YS_FED_EXAMP_0000020172": "该卡券卡号已录入, 请勿重复录入",
        "P_YS_FED_EXAMP_0000020175": "房费商品结束时间不能为空！",
        "P_YS_FED_EXAMP_0000020174": "当前业务类型非储值, 不允许使用充值调整",
        "P_YS_FED_EXAMP_0000020171": "卡券售卡功能",
        "P_YS_FED_FW_0001142287": "为单选，比较符不可选择在列表中/不在列表中，请修改为等于/不等于；",
        "P_YS_FED_IMP_IOT0000007027": "甘泉县",
        "P_YS_FED_FW_0001445832": "单据将被撤回为未提交状态，确定要撤回单据吗？",
        "P_YS_FED_EXAMP_0000020169": ";错误信息:",
        "P_YS_FED_IMP_IOT0000007029": "鄱阳县",
        "P_YS_FED_IMP_IOT0000009688": "华池县",
        "P_YS_FED_FW_0001142288": "为多选，比较符不可选择等于/不等于，请修改为在列表中/不在列表中；",
        "P_YS_FED_IMP_IOT0000008358": "寿阳县",
        "P_YS_FED_FW_0001026083": "模板内容导入失败，<%=text%>。",
        "P_YS_FED_EXAMP_0000020166": "电商退货状态下不能新增商品！",
        "P_YS_FED_FW_0001026084": "模板内容导入失败,返回信息：<%=text%>",
        "P_YS_FED_EXAMP_0000020165": "未找到该储值卡号对应实体卡",
        "P_YS_FED_FW_0001444504": "共选中数据条数",
        "P_YS_FED_FW_0001026081": "<%=text%> 上传成功!",
        "P_YS_FED_EXAMP_0000020168": "行中的商品没有可用的批号，请调整！",
        "P_YS_FED_FW_0001026082": "确定删除栏目【<%=text%>】么？",
        "P_YS_FED_EXAMP_0000020167": "当前换货行数量不能大于退货行数量",
        "P_YS_FED_FW_0001026087": "共<%=actionText%><%=count%>条, 其中成功<%=sucessCount%>条,失败<%=failCount%>条",
        "P_YS_FED_IMP_IOT0000008351": "肃州区",
        "P_YS_FED_FW_0001026088": "<%=actionText%>失败：<%=messages%>",
        "P_YS_FED_IMP_IOT0000009683": "楚州区",
        "P_YS_FED_FW_0001026085": "<%=text%>成功",
        "P_YS_FED_FW_0001026086": "共<%=actionText%><%=count%>条, 其中成功<%=sucessCount%>条",
        "P_YS_FED_IMP_IOT0000009681": "泰兴市",
        "P_YS_FED_IMP_IOT0000008355": "新北区",
        "P_YS_PF_PROCENTER_0000023573": "异常",
        "P_YS_FED_UIMG_0000154415": "模板校验失败！",
        "P_YS_FED_IMP_IOT0000007022": "潮阳区",
        "P_YS_FED_FW_0001026089": "<%=actionText%>成功",
        "P_YS_FED_IMP_IOT0000009684": "交城县",
        "P_YS_FED_IMP_IOT0000008354": "奎文区",
        "P_YS_FED_IMP_IOT0000009685": "潼南县",
        "P_YS_FED_EXAMP_0000020184": "预订退订状态下，",
        "P_YS_FED_EXAMP_0000020183": "关闭",
        "P_YS_FED_EXAMP_0000020186": "调整状态不允许执行现场折扣！",
        "P_YS_FED_EXAMP_0000020185": ")领位信息",
        "P_YS_FED_EXAMP_0000020180": "已经执行过优惠，不允许修改序列号！",
        "P_YS_FED_EXAMP_0000020182": "演示用户密码登录失败：【接口】",
        "P_YS_FED_EXAMP_0000020181": "充值状态不允许执行",
        "P_YS_FED_IMP_IOT0000007016": "清流县",
        "P_YS_FED_IMP_IOT0000009679": "船营区",
        "P_YS_FED_IMP_IOT0000007015": "霞山区",
        "P_YS_FED_IMP_IOT0000007017": "浦北县",
        "P_YS_FED_IMP_IOT0000008347": "海兴县",
        "P_YS_FED_IMP_IOT0000009678": "桥东区",
        "P_YS_FED_EXAMP_0000020177": "请登录会员并录入商品。",
        "P_YS_FED_EXAMP_0000020176": "零售价",
        "P_YS_FED_EXAMP_0000020179": "获取大屏开单设置失败：",
        "P_YS_FED_FW_0001026054": "是否确认<%=cCaption%>此<%=text%>",
        "P_YS_FED_IMP_IOT0000008341": "万载县",
        "P_YS_FED_FW_0000021298": "其他信息:",
        "P_YS_FED_FW_0001026052": "该操作将会删除当前<%=text%>及其子<%=text%>，是否继续?",
        "P_YS_FED_FW_0000021299": "渭南市",
        "P_YS_FED_FW_0001026053": "是否确认删除此<%=text%>",
        "P_YS_FED_FW_0001094182": "开始调用Action[",
        "P_YS_FED_FW_0001026058": "确定要<%=abandonText%>吗？",
        "P_YS_FED_IMP_IOT0000008344": "西昌市",
        "P_YS_FED_IMP_IOT0000007012": "通榆县",
        "P_YS_FED_IMP_IOT0000009675": "华县",
        "P_YS_FED_IMP_IOT0000007011": "类乌齐县",
        "P_YS_FED_IMP_IOT0000008345": "凤冈县",
        "P_YS_FED_IMP_IOT0000009676": "仪征市",
        "P_YS_FED_IMP_IOT0000008342": "江陵县",
        "P_YS_FED_IMP_IOT0000009673": "且末县",
        "P_YS_FED_FW_0001026057": "分类最多<%=level%>级",
        "P_YS_FED_IMP_IOT0000008343": "中方县",
        "P_YS_FED_EXAMP_0000020195": "子件商品不允许执行优惠券",
        "P_YS_FED_EXAMP_0000020194": "当前摄像头（摄像头IP/ID）已离线,请检查线路!",
        "P_YS_FED_EXAMP_0000020197": "当前网络状况不允许录入会员，请重新开单！",
        "P_YS_FED_EXAMP_0000020196": "确定要切换账号吗？该操作将重新刷新页面！",
        "P_YS_FED_EXAMP_0000020191": "调整后金额不能为空！",
        "P_YS_FED_EXAMP_0000020190": "已经存在相同的商品行!",
        "P_YS_FED_EXAMP_0000020193": "调整状态不允许录入会员！",
        "P_YS_FED_EXAMP_0000020192": "存在未录入序列号的序列号商品行,请检查!",
        "P_YS_FED_IMP_IOT0000007005": "富源县",
        "P_YS_FED_IMP_IOT0000008337": "新晃侗族自治县",
        "P_YS_FED_IMP_IOT0000009668": "天长市",
        "P_YS_FED_IMP_IOT0000007004": "洮南市",
        "P_YS_FED_IMP_IOT0000008335": "船山区",
        "P_YS_FED_IMP_IOT0000007006": "义县",
        "P_YS_FED_EXAMP_0000020188": "驳回",
        "P_YS_FED_EXAMP_0000020187": "房费",
        "P_YS_FED_IMP_IOT0000008339": "富平县",
        "P_YS_FED_EXAMP_0000020189": "再按一次退出应用",
        "P_YS_FED_IMP_IOT0000008330": "泾源县",
        "P_YS_FED_IMP_IOT0000008333": "临漳县",
        "P_YS_FED_IMP_IOT0000007000": "睢宁县",
        "P_YS_FED_IMP_IOT0000008334": "定远县",
        "P_YS_FED_IMP_IOT0000007003": "龙湖区",
        "P_YS_FED_IMP_IOT0000009663": "集贤县",
        "P_YS_PF_PRINT_0000057998": "上游单据号",
        "P_YS_FED_FW_0001220211": "参数返回数据错误,编码为空.row =",
        "P_YS_FED_FW_0001220210": "func_CellCheck没找到匹配的行信息",
        "P_YS_FED_FW_1478287954777997318": "显示轨迹",
        "P_YS_FED_EXAMP_0000020120": "工费折扣率必须大于等于0小于等于100！",
        "P_YS_FED_FW_0001246843": "<%=name%>表体以下字段不能为空",
        "P_YS_FED_FW_0001246844": "<%=name%>表体的以下孙表不能为空",
        "P_YS_FED_FW_0000022529": "不存在, cBillType 只允许是",
        "P_YS_FED_EXAMP_0000020115": "切换",
        "P_YS_FED_EXAMP_0000020114": "获取是否密码校验参数失败",
        "P_YS_FED_IMP_IOT0000008327": "开封",
        "P_YS_FED_IMP_IOT0000009658": "徐汇区",
        "P_YS_FED_FW_0000022527": "没有查询到数据",
        "P_YS_FED_EXAMP_0000020117": "[公告] 门店新员工培训学习",
        "P_YS_FED_IMP_IOT0000008324": "武江区",
        "P_YS_FED_IMP_IOT0000009655": "海城市",
        "P_YS_FED_FW_0000022528": "友零售",
        "P_YS_FED_IMP_IOT0000008325": "麟游县",
        "P_YS_FED_EXAMP_0000020111": "套餐商品未录入完毕,不允许执行保存",
        "P_YS_PF_GZTSYS_0000015887": "设备",
        "P_YS_FED_EXAMP_0000020110": "储值卡充值功能",
        "P_YS_FED_EXAMP_0000020113": "没有可以改零售价的商品行",
        "P_YS_FED_IMP_IOT0000009659": "浔阳区",
        "P_YS_FED_EXAMP_0000020112": "暂无数据哦~",
        "P_YS_FED_IMP_IOT0000008329": "康乐县",
        "P_YS_FED_FW_0000022521": "名称不能为空",
        "P_YS_FED_FW_0000022522": "默认值最多保存5项",
        "P_YS_FED_FW_0000022520": "级次选择",
        "P_YS_FED_FW_0000022525": "【接口】",
        "P_YS_FED_EXAMP_0000020119": "线上零售价",
        "P_YS_FED_IMP_IOT0000008322": "金台区",
        "P_YS_FED_IMP_IOT0000009653": "桃山区",
        "P_YS_FED_FW_0000022526": "参数：",
        "P_YS_FED_EXAMP_0000020118": "客户名称",
        "P_YS_FED_FW_0000022523": "文件打开出错",
        "P_YS_FED_FW_0000022524": "billType 未录入",
        "P_YS_FED_IMP_IOT0000009652": "邳州市",
        "P_YS_FED_FW_0001220209": "参数返回数据异常,编码为空。",
        "P_YS_FED_EXAMP_0000020131": "规格:",
        "P_YS_FED_EXAMP_0000020130": "数量",
        "P_YS_PF_PRINT_0000056670": "操作人",
        "P_YS_FED_FW_0000021209": "许昌市",
        "P_YS_FED_EXAMP_0000020126": "该状态下不能使用快捷结算",
        "P_YS_FED_IMP_IOT0000009646": "凤城市",
        "P_YS_SCM_SACT-FE_0001196577": "/premises-cdn/iprint/用友云打印助手.exe",
        "P_YS_FED_EXAMP_0000020125": "：指预先加工入库在销售的加工商品，如面包、饼干等；预制商品受业务参数“允许负出库”控制。",
        "P_YS_FED_IMP_IOT0000008316": "威信县",
        "P_YS_FED_IMP_IOT0000009647": "二道区",
        "P_YS_HR_HRJXF_0000184400": "取消关联",
        "P_YS_PF_WORKBENCH-FE_0001242096": "暂不了解",
        "P_YS_FED_FW_0000021207": "临夏回族自治州",
        "P_YS_FED_EXAMP_0000020128": "获取开单设置失败：",
        "P_YS_FED_IMP_IOT0000008313": "武安市",
        "P_YS_FED_EXAMP_0000020127": "上传失败",
        "P_YS_FED_FW_0000021208": "非预订",
        "P_YS_FED_IMP_IOT0000009645": "宜阳县",
        "P_YS_FED_EXAMP_0000020122": "改行",
        "P_YS_PF_GZTSYS_0000013235": "业务档案",
        "P_YS_FED_EXAMP_0000020121": "已存在商品行，不能进行退订！",
        "P_YS_FED_EXAMP_0000020124": "本次调整金额不能为空！",
        "P_YS_FED_EXAMP_0000020123": "确认结算",
        "P_YS_FED_IMP_IOT0000008318": "桓台县",
        "P_YS_FED_FW_0000021201": "株洲市",
        "P_YS_FED_FW_0000021202": "分组方案由支持单图改为支持多图升级整个报表的配置信息出错。eChartConfig",
        "P_YS_FED_FW_0000021200": "泰安市",
        "P_YS_FED_FW_0000021205": "张家口市",
        "P_YS_FED_IMP_IOT0000008311": "平遥县",
        "P_YS_FED_FW_0000021206": "宝鸡市",
        "P_YS_FED_EXAMP_0000020129": "不能执行促销活动！您确定要取消",
        "P_YS_FED_IMP_IOT0000009643": "调兵山市",
        "P_YS_FED_FW_0000021203": "钦州市",
        "P_YS_FED_IMP_IOT0000009640": "晋安区",
        "P_YS_FED_FW_0000021204": "柱形图配置信息",
        "OA_web_ad_000000095": "未分组",
        "P_YS_FED_EXAMP_0000020140": "数据权限设置",
        "P_YS_FED_FW_0001051041": "服务器连接失败！",
        "P_YS_FED_EXAMP_0000020142": "销售排名",
        "P_YS_FED_FW_0001051042": "{value} 星",
        "P_YS_FED_EXAMP_0000020141": "审核不通过",
        "P_YS_FED_FW_0000022507": "另存新方案",
        "P_YS_FED_EXAMP_0000020137": "个字",
        "P_YS_FED_IMP_IOT0000008304": "临洮县",
        "P_YS_FED_IMP_IOT0000009635": "开远市",
        "P_YS_FED_FW_0000022508": "保存方案",
        "P_YS_FED_EXAMP_0000020136": "自动拣货失败！",
        "P_YS_FED_IMP_IOT0000009636": "高青县",
        "P_YS_FED_FW_0000022505": "本周",
        "P_YS_FED_EXAMP_0000020139": "业务类型非售卡且开单行非空, 不允许售卡",
        "P_YS_FED_FW_0000022506": "下周",
        "P_YS_FED_EXAMP_0000020138": "原单退货中，换货行不允许改行！",
        "P_YS_FED_EXAMP_0000020133": "昵称",
        "P_YS_FED_IMP_IOT0000008308": "郏县",
        "P_YS_FED_IMP_IOT0000009639": "良庆区",
        "P_YS_FED_EXAMP_0000020132": "退品原因不能为空！",
        "P_YS_FED_IMP_IOT0000008309": "柯城区",
        "P_YS_FED_FW_0000022509": "日期选择",
        "P_YS_FED_EXAMP_0000020135": "本次新增行请直接删除！",
        "P_YS_FED_EXAMP_0000020134": "当前单据状态下，不允许删除行！",
        "P_YS_FED_FW_0000022500": "查看已选",
        "P_YS_FED_FW_0000022503": "预置方案",
        "P_YS_FED_IMP_IOT0000008300": "阳东县",
        "P_YS_FED_FW_0000022504": "全部收起",
        "P_YS_FED_FW_0000022501": "查询项不能为空",
        "P_YS_FED_FW_0000022502": "方案操作成功",
        "P_YS_FED_EXAMP_0000020151": "请先选择单据！",
        "P_YS_FED_EXAMP_0000020150": "新增会员",
        "P_YS_FED_EXAMP_0000020153": "优惠券[",
        "P_YS_FED_FW_1556970089191309315": "编辑方案内查询",
        "P_YS_FED_EXAMP_0000020152": "统计近",
        "P_YS_FED_FW_1556970089191309318": "编辑方案内",
        "P_YS_FED_FW_0000022518": "全部展开",
        "P_YS_FED_EXAMP_0000020148": "请输入正确的卡券号码",
        "P_YS_FED_FW_0000022519": "置底",
        "P_YS_FED_EXAMP_0000020147": "上次上传任务未进行完",
        "P_YS_FED_IMP_IOT0000009625": "易门县",
        "P_YS_FED_FW_0000022516": "已选（",
        "P_YS_FED_FW_0000022517": "今年",
        "P_YS_FED_EXAMP_0000020149": "称重量高于标准重量，请检查产品是否有堆叠并重新摆放商品！",
        "P_YS_FED_IMP_IOT0000009623": "驿城区",
        "P_YS_FED_EXAMP_0000020144": "请选择商城订单！",
        "P_YS_FED_EXAMP_0000020143": "没有条码为[",
        "P_YS_FED_IMP_IOT0000009629": "娄烦县",
        "P_YS_FED_FW_1556970089191309321": "自定义过滤条件列表新增",
        "P_YS_FED_EXAMP_0000020146": "确定拨打",
        "P_YS_FED_EXAMP_0000020145": "获取租户信息失败：【接口】",
        "P_YS_FED_FW_0000022510": "恢复默认",
        "P_YS_FED_FW_0000022511": "移除",
        "P_YS_FED_FW_0000022514": "高级",
        "P_YS_FED_FW_0000022515": "换位置拉",
        "P_YS_FED_FW_0000022512": "没有搜索结果",
        "P_YS_FED_FW_0000022513": "置顶",
        "P_YS_FED_FW_0000021241": "看板配置信息-桌面-行列布局",
        "P_YS_FED_FW_0000021242": "report/getGroupSetting(获取报表分组方案的详细设置进行显示) 返回错误信息。",
        "P_YS_FED_FW_0000021240": "赤峰市",
        "P_YS_FED_FW_0001289933": "缺少scanQRCode方法",
        "P_YS_PF_GZTTMP_0000073505": "交换状态",
        "P_YS_FED_IMP_IOT0000009611": "冕宁县",
        "P_YS_FED_IMP_IOT0000009612": "白银区",
        "P_YS_FED_FW_1593218496493781002": "單據聯查結果顯示",
        "P_YS_FED_IMP_IOT0000009618": "上城区",
        "P_YS_FED_IMP_IOT0000009615": "渠县",
        "P_YS_FED_FW_1556970089191309312": "lineTab切换为",
        "P_YS_FED_FW_1593218496493781005": "Les résultats de la recherche conjointe de documents montrent",
        "P_YS_FED_FW_0000021234": "三沙市",
        "P_YS_FED_FW_0000021235": "通化市",
        "P_YS_FED_FW_0000021232": "滨州市",
        "P_YS_FED_FW_0000021233": "黄冈市",
        "P_YS_FED_FW_0000021238": "抚顺市",
        "P_YS_FED_FW_0000021239": "开始日期",
        "P_YS_FED_IMP_IOT0000009610": "凤凰县",
        "P_YS_FED_FW_0000021236": "无明确信息",
        "P_YS_FED_FW_0000021237": "哈密地区",
        "P_YS_HR_HRJXF_0000184457": "确定删除吗？",
        "P_YS_FED_FW_0000021252": "南宁市",
        "P_YS_FED_FW_0000021253": "柱折图配置信息",
        "P_YS_FED_FW_0000021250": "台湾省",
        "P_YS_FED_FW_0000021251": "表体存在必输项，请输入完整再尝试保存！",
        "P_YS_FED_IMP_IOT0000009609": "伊通满族自治县",
        "P_YS_FED_IMP_IOT0000009600": "桂东县",
        "P_YS_FED_FW_0000021245": "红河哈尼族彝族自治州",
        "P_YS_FED_FW_0000021246": "萍乡市",
        "P_YS_FED_FW_0000021243": "泰州市",
        "P_YS_FED_FW_0000021244": "常州市",
        "P_YS_FED_FW_0000021249": "保山市",
        "P_YS_FED_FW_0000021247": "小计",
        "P_YS_FED_FW_0000021248": "佛山市",
        "P_YS_FED_FW_0000021220": "崇左市",
        "P_YS_FED_FW_1596335448733515784": "(最多选择5项)",
        "P_YS_FED_FW_1596335448733515781": "最多选择5个分组项。",
        "P_YS_FED_FW_1596335448733515787": "分组项",
        "P_YS_FED_FW_0000021218": "菏泽市",
        "P_YS_FED_FW_0000021219": "大兴安岭地区",
        "P_YS_FED_FW_0000021212": "汕尾市",
        "P_YS_FED_FW_0000021213": "cStyle，预制错误！",
        "P_YS_FED_FW_0000021210": "金昌市",
        "P_YS_FED_FW_0000021211": "天津市",
        "P_YS_FED_FW_0000021216": "吕梁市",
        "P_YS_FED_FW_0000021217": "商洛市",
        "P_YS_FED_FW_0000021214": "张掖市",
        "P_YS_FED_FW_0000021215": "伊犁哈萨克自治州",
        "P_YS_FED_FW_0000021230": "德阳市",
        "P_YS_SD_URETAIL_0001049003": "promiseExecute1内部出错：",
        "P_YS_FED_FW_0001322153": "还没有图表卡片哦",
        "P_YS_FED_FW_0000021231": "安徽",
        "P_YS_PF_METADATA_0001040101": "模板编号",
        "P_YS_FED_FW_1596335448733515790": "分组项设置",
        "P_YS_PF_PRINT_0000056691": "销售类型",
        "P_YS_FED_FW_1596335448733515793": "(最多选择15项)",
        "P_YS_FED_EXAMP_0000020104": "非原单退货应收金额为负, 不能使用会员钱包支付",
        "P_YS_FED_EXAMP_0000020103": "套餐商品未录入完毕,不允许执行结算",
        "P_YS_FED_FW_0000021229": "-￥",
        "P_YS_FED_EXAMP_0000020106": "积分抵扣",
        "P_YS_FED_EXAMP_0000020105": "退货数量不能大于原单未退货数量。",
        "P_YS_FED_FW_1596335448733515796": "汇总项设置",
        "P_YS_FED_EXAMP_0000020100": "应收不等于实收，无法结算",
        "P_YS_FED_EXAMP_0000020102": "定制类型不允许增加商品行！",
        "P_YS_FED_EXAMP_0000020101": "套餐商品需要全选",
        "P_YS_FED_FW_0000021223": "铁岭市",
        "P_YS_FED_FW_0000021224": "需要显示为XY轴的名字超长，需要截断，截断前：",
        "P_YS_FED_FW_0000021221": "本单积分",
        "P_YS_FED_FW_0000021222": "合肥市",
        "P_YS_FED_FW_0000021227": "本溪市",
        "P_YS_FED_EXAMP_0000020108": "调整状态不允许执行促销活动！",
        "P_YS_FED_FW_0000021228": "移动报表 MobileReportSum firstQueryDone params =",
        "P_YS_FED_EXAMP_0000020107": "售卡状态不允许执行该操作 请重新开单",
        "P_YS_FED_FW_0000021225": "通辽市",
        "P_YS_FED_FW_0000021226": "表全部数据成功",
        "P_YS_FED_EXAMP_0000020109": "获取支付方式失败",
        "P_YS_SD_UDHWN_0000050426": "万宁市",
        "P_YS_SCM_USTOCK_0000064406": "未变更",
        "P_YS_FED_EXAMP_0000020511": "确认POS已经为闲置状态？",
        "P_YS_FED_EXAMP_0000020510": "当前网络不可用并且当前操作员无删行权限，不能使用此功能！",
        "P_YS_FED_EXAMP_0000020513": "请选择门店",
        "P_YS_FED_EXAMP_0000020512": "没有选中商品行，无法批量指定,请检查!",
        "P_YS_FED_EXAMP_0000020519": "已存在商品行，不能进行交货！",
        "P_YS_FED_EXAMP_0000020518": "挂单并打印",
        "P_YS_FED_EXAMP_0000020515": "向主界面发送数据参数不正确。",
        "P_YS_FED_EXAMP_0000020514": "已收款:",
        "P_YS_FED_EXAMP_0000020517": "无该会员信息",
        "P_YS_FED_EXAMP_0000020516": "近7天",
        "P_YS_FED_EXAMP_0000020522": "三里屯店",
        "P_YS_FED_EXAMP_0000020521": "元数据失败：",
        "P_YS_FED_EXAMP_0000020524": "已存在相同sku商品行!",
        "P_YS_FED_EXAMP_0000020523": "当前商品不参与抵扣操作。",
        "P_YS_FED_EXAMP_0000020520": "密码修改成功",
        "P_YS_FED_EXAMP_0000020529": "上拉加载更多...",
        "P_YS_FED_EXAMP_0000020526": "套餐商品未录入完毕,不允许执行现场折扣",
        "P_YS_FED_EXAMP_0000020525": "代金券",
        "P_YS_FED_EXAMP_0000020528": "当前房间存在未交货的零售单，请处理后再领位",
        "P_YS_SD_SDMBF_0000141962": "输入有误",
        "P_YS_FED_EXAMP_0000020527": "已存在商品行，不能进行变更！",
        "P_YS_FED_FW_0001265743": "请检查BUSINESS_LOG_SERVER配置是否正确",
        "P_YS_FED_FW_1430606138330578944": "除数不能为 0",
        "P_YS_FED_EXAMP_0000020533": "获取储值打印模板失败",
        "P_YS_FED_IMP_IOT0000011802": "衡东县",
        "P_YS_FED_FW_0001253754": "缺少changeScreenOrientation方法",
        "P_YS_FED_EXAMP_0000020532": "电商订单退货不能进行挂单解挂操作！",
        "P_YS_FED_FW_0001253753": "请录入",
        "P_YS_FED_EXAMP_0000020535": "存在重复的序列号[",
        "P_YS_FED_FW_0001253756": "{\"（\":\"(\",\"）\":\")\",\"！\":\"!\",\"，\":\",\",\"。\":\".\",\"：\":\":\",\"；\":\";\",\"、\":\" \"}",
        "P_YS_FED_EXAMP_0000020534": "进货价 :",
        "P_YS_FED_FW_0001253755": "确定取消操作嘛?",
        "P_YS_FED_FW_0001253750": "711连锁便利店",
        "P_YS_FED_EXAMP_0000020531": "mac地址未取到，请退出程序重新登录！",
        "P_YS_FED_FW_0001253752": "共&nbsp;",
        "P_YS_FED_EXAMP_0000020530": "]为在库状态,请检查!",
        "P_YS_FED_FW_0001253751": "zjj普通",
        "P_YS_FED_IMP_IOT0000011809": "汝城县",
        "P_YS_FED_EXAMP_0000020537": "SKU编码",
        "P_YS_FED_IMP_IOT0000011806": "新巴尔虎右旗",
        "P_YS_FED_FW_1471272821425963008": "全部加载完成",
        "P_YS_FED_EXAMP_0000020536": "当前网络不可用，不能销售批次管理的商品！",
        "P_YS_FED_FW_0001253757": "缺少restoreScreenOrientation方法",
        "P_YS_FED_EXAMP_0000020539": "未取得门店的默认仓库!",
        "P_YS_OA_XTLCZX_0000030825": "上传中",
        "P_YS_FED_EXAMP_0000020538": "确 定",
        "P_YS_FED_EXAMP_0000020544": "当前操作员无卡券权限",
        "P_YS_FED_EXAMP_0000020543": "表体行营业员不能为空!",
        "P_YS_FED_IMP_IOT0000011812": "七里河区",
        "P_YS_FED_EXAMP_0000020546": "退品数量不能为空！",
        "P_YS_FED_EXAMP_0000020545": "无效钱包账号",
        "P_YS_FED_IMP_IOT0000011814": "商都县",
        "P_YS_FED_EXAMP_0000020540": "是否退出开单界面？",
        "P_YS_FED_FW_1439654302997020672": "没有指定进度组件类型！",
        "P_YS_FED_EXAMP_0000020542": "您的软件是最新版本",
        "P_YS_FED_IMP_IOT0000011811": "长丰县",
        "P_YS_FED_EXAMP_0000020541": "重量不合法！",
        "P_YS_FED_EXAMP_0000020548": "没有识别到商品!",
        "P_YS_FED_IMP_IOT0000011817": "诏安县",
        "P_YS_FED_EXAMP_0000020547": "请输入用户名",
        "P_YS_FED_IMP_IOT0000011816": "武功县",
        "P_YS_FED_FW_1575980902936215553": "｜",
        "P_YS_FED_EXAMP_0000020549": "卡券非原单退功能",
        "P_YS_FED_IMP_IOT0000011818": "襄城区",
        "P_YS_FED_FW_1529421301390245894": "请点击侧栏中的侯选条件进行添加",
        "P_YS_FED_IMP_IOT0000011824": "老边区",
        "P_YS_FED_IMP_IOT0000011823": "永城市",
        "P_YS_FED_IMP_IOT0000011826": "嘉祥县",
        "P_YS_PF_METADATA_0000083588": "文件大小",
        "P_YS_FED_IMP_IOT0000011822": "石首市",
        "P_YS_FED_IMP_IOT0000011827": "象山县",
        "P_YS_FED_IMP_IOT0000011829": "清河县",
        "P_YS_FI_FINBD-UI_0000161964": "表参照",
        "P_YS_FED_FW_0000021407": "漯河市",
        "P_YS_FED_IMP_IOT0000010503": "攀枝花",
        "P_YS_FED_FW_0000021408": "广元市",
        "P_YS_FED_FW_0000021405": "佳木斯市",
        "P_YS_FED_IMP_IOT0000011837": "官渡区",
        "P_YS_FED_FW_0001253745": "请输入必填字段,",
        "P_YS_FED_FW_0000021406": "排名表配置信息-yySetting",
        "P_YS_FED_IMP_IOT0000010506": "崇州市",
        "P_YS_FED_IMP_IOT0000011836": "新田县",
        "P_YS_ZNBZ_BZBX-FE_0001141300": "担保合同",
        "P_YS_FED_FW_0000021409": "昌都地区",
        "P_YS_ZNBZ_BZBX-FE_0001141303": "借款",
        "P_YS_FED_IMP_IOT0000010502": "珠晖区",
        "P_YS_PF_GZTTMP_0000074571": "触屏",
        "P_YS_FED_FW_0001023490": "cStyle配置异常",
        "P_YS_ZNBZ_BZBX-FE_0001141305": "抵/质押合同跟踪",
        "P_YS_FED_FW_0000021400": "看板配置信息-模块配置-公告",
        "P_YS_ZNBZ_BZBX-FE_0001141304": "联保合同",
        "P_YS_HR_HRYGF_0001153277": "提示:",
        "P_YS_FED_FW_0000021403": "获取图形报表数据Err  查询参数 =",
        "P_YS_FED_FW_0001253747": "连续扫码",
        "P_YS_FED_IMP_IOT0000011838": "盱眙县",
        "P_YS_FED_FW_0001253746": "数据区必输字段",
        "P_YS_FED_FW_0000021401": "海西蒙古族藏族自治州",
        "P_YS_FED_IMP_IOT0000010509": "茌平县",
        "P_YS_FED_FW_0001253749": "cell的宽度超过表格的宽度，无法渲染；节点信息：",
        "P_YS_FED_FW_0000021402": "看板配置信息-移动-行列布局",
        "P_YS_FED_FW_0001253748": "连扫",
        "P_YS_FED_FW_0001238122": "失败&nbsp;",
        "P_YS_FED_IMP_IOT0000011840": "同江市",
        "P_YS_FED_FW_0001035432": "<p>无提示文字~</p>",
        "P_YS_FED_FW_0001576776": "&region=全国&output=json&ak=",
        "P_YS_FED_FW_0001035433": "您于<%=tmpTime%>发起的【<%=busName%>】",
        "P_YS_FED_IMP_IOT0000011845": "博乐市",
        "P_YS_FED_IMP_IOT0000005995": "新洲区",
        "P_YS_FED_IMP_IOT_0000115234": ",最小为",
        "P_YS_FED_IMP_IOT0000005994": "太谷县",
        "P_YS_FED_IMP_IOT0000010510": "隆化县",
        "P_YS_PF_SOCD_0000089208": "瑞典",
        "P_YS_FED_IMP_IOT0000005999": "东阳市",
        "P_YS_FED_IMP_IOT0000010512": "成武县",
        "P_YS_FED_IMP_IOT_0000115238": "请选择...",
        "P_YS_PF_SOCD_0000089209": "摩洛哥",
        "P_YS_FED_IMP_IOT0000011843": "宁远县",
        "P_YS_PF_SOCD_0000089206": "荷兰",
        "P_YS_PF_SOCD_0000089207": "斯洛文尼亚",
        "P_YS_PF_SOCD_0000089204": "俄罗斯",
        "P_YS_PF_SOCD_0000089205": "斯里兰卡",
        "P_YS_PF_SOCD_0000089203": "法国",
        "P_YS_FED_IMP_IOT0000011849": "嘉鱼县",
        "P_YS_FED_IMP_IOT0000005991": "五峰土家族自治县",
        "P_YS_PF_SOCD_0000089201": "波兰",
        "P_YS_FED_IMP_IOT0000005990": "江城区",
        "P_YS_FED_IMP_IOT0000005989": "合浦县",
        "P_YS_FED_IMP_IOT0000011850": "平川区",
        "P_YS_PF_PRINT_0000062612": "子表",
        "P_YS_FED_EXAMP_0000020500": "待入库",
        "P_YS_FED_IMP_IOT0000011857": "襄城县",
        "P_YS_OA_XTXIANGMU_0000063884": "剩余",
        "P_YS_FED_IMP_IOT0000005981": "达拉特旗",
        "P_YS_FED_EXAMP_0000020502": "获取系统参数失败：【接口】",
        "P_YS_FED_IMP_IOT0000010527": "武陟县",
        "P_YS_FED_EXAMP_0000020501": "调整状态不允许解挂！",
        "P_YS_FED_IMP_IOT0000011858": "彭泽县",
        "P_YS_FED_IMP_IOT0000010521": "荔城区",
        "P_YS_FED_IMP_IOT_0000115225": "输入值,最大值为",
        "P_YS_FED_IMP_IOT0000005985": "蒙阴县",
        "P_YS_FED_IMP_IOT0000010523": "广水市",
        "P_YS_FED_IMP_IOT0000011855": "沁水县",
        "P_YS_FED_IMP_IOT0000010524": "朝天区",
        "P_YS_FED_EXAMP_0000020508": "座机",
        "P_YS_FED_EXAMP_0000020507": "每月一次",
        "P_YS_FED_EXAMP_0000020509": "商城上架数",
        "P_YS_FED_EXAMP_0000020504": "退货充值",
        "P_YS_FED_EXAMP_0000020503": "解挂",
        "P_YS_FED_EXAMP_0000020506": "当前每克金价折扣额为(",
        "P_YS_FED_IMP_IOT0000005980": "昌江区",
        "P_YS_FED_EXAMP_0000020505": "已有商品行, 不允许钱包充值",
        "P_YS_PF_SOCD_0000089220": "南非",
        "P_YS_PF_SOCD_0000089221": "圣多美和普林西比",
        "P_YS_FED_FW_1551561479829848067": "按单操作",
        "P_YS_HR_HRJQ_0000055421": "类型",
        "P_YS_OA_XTRIZHI_0000036814": "继续编辑",
        "P_YS_FED_IMP_IOT0000005979": "龙安区",
        "P_YS_FED_IMP_IOT0000005978": "于都县",
        "P_YS_FED_IMP_IOT0000010531": "宝丰县",
        "P_YS_FI_CM_0000029055": "八月",
        "P_YS_FED_IMP_IOT0000010536": "通许县",
        "P_YS_FED_IMP_IOT0000005970": "武强县",
        "P_YS_FED_IMP_IOT0000010538": "景德镇",
        "P_YS_FED_FW_0001661900": "超出最大长度限制\\t\\n",
        "P_YS_FED_IMP_IOT0000005972": "根河市",
        "P_YS_FED_IMP_IOT0000010539": "克东县",
        "P_YS_FED_IMP_IOT0000010532": "兴宾区",
        "P_YS_FED_IMP_IOT0000005974": "安宁区",
        "P_YS_FED_IMP_IOT0000010533": "沈丘县",
        "P_YS_FED_IMP_IOT0000005977": "平桥区",
        "P_YS_FED_IMP_IOT0000010534": "西盟佤族自治县",
        "P_YS_FED_IMP_IOT0000005976": "邹城市",
        "P_YS_PF_SOCD_0000089228": "多哥",
        "P_YS_PF_SOCD_0000089226": "津巴布韦",
        "P_YS_PF_SOCD_0000089227": "孟加拉国",
        "P_YS_PF_SOCD_0000089225": "葡萄牙",
        "P_YS_PF_SOCD_0000089222": "巴哈马",
        "P_YS_PF_SOCD_0000089223": "马里",
        "P_YS_SD_SDMAUF_0000152388": "全部取消",
        "P_YS_FI_CM_0000030058": "单据编号",
        "P_YS_HR_HRJQ_0000055417": "部门",
        "P_YS_FED_IMP_IOT0000005967": "蓝田县",
        "P_YS_FED_IMP_IOT0000010540": "都匀市",
        "P_YS_FED_IMP_IOT0000010541": "望花区",
        "P_YS_FED_IMP_IOT0000010542": "澄海区",
        "P_YS_FED_IMP_IOT0000010547": "慈溪市",
        "P_YS_OA_XTWENKU_0000035690": "請選擇日期",
        "P_YS_FED_IMP_IOT0000005962": "五通桥区",
        "P_YS_FED_IMP_IOT0000005961": "登封市",
        "P_YS_FED_FW_0001253700": "没有一维表模型",
        "P_DIWORK_YC_ORDER_0000061342": "－",
        "P_YS_PF_SOCD_0000089219": "伯利兹",
        "P_YS_FED_IMP_IOT0000005966": "连城县",
        "P_YS_FED_IMP_IOT0000005965": "河西区",
        "P_YS_PF_SOCD_0000089217": "马拉维",
        "P_YS_PF_SOCD_0000089218": "巴布亚新几内亚",
        "P_YS_PF_SOCD_0000089215": "乍得",
        "P_YS_PF_SOCD_0000089216": "突尼斯",
        "P_YS_PF_SOCD_0000089213": "冰岛",
        "P_YS_PF_SOCD_0000089214": "智利",
        "P_YS_FED_FW_0001073796": "永州冷",
        "P_YS_PF_SOCD_0000089243": "肯尼亚",
        "P_YS_FED_FW_0001073795": "达县市",
        "P_YS_PF_SOCD_0000089240": "莱索托",
        "P_YS_FED_FW_0001073794": "襄城市",
        "P_YS_FI_CM_0000029074": "六月",
        "P_YS_FED_FW_0001380706": "请您先上传附件",
        "P_YS_PF_SOCD_0000089241": "美国",
        "P_YS_FED_FW_0001073793": "株州市",
        "P_YS_FED_FW_0001073792": "锡林浩特",
        "P_YS_FED_IMP_IOT0000005957": "富民县",
        "P_YS_FED_IMP_IOT0000010552": "集安市",
        "P_YS_FED_IMP_IOT0000010553": "海曙区",
        "P_YS_FED_FW_0001073799": "离石市",
        "P_YS_FED_FW_0001073798": "日喀则",
        "P_YS_FED_FW_0001073797": "揭西市",
        "P_YS_FED_IMP_IOT0000010559": "佳县",
        "P_YS_FED_IMP_IOT0000010554": "固始县",
        "P_YS_FED_IMP_IOT0000010555": "吉木萨尔县",
        "P_YS_SD_SDMA_0000038452": "业务员",
        "P_YS_FED_IMP_IOT0000005954": "仪陇县",
        "P_YS_ZNBZ_BZBX-FE_0001135440": "ⓧ",
        "P_YS_PF_SOCD_0000089247": "巴拿马",
        "P_YS_PF_SOCD_0000089245": "尼加拉瓜",
        "P_YS_FI_CM_0000029087": "确认删除？",
        "P_YS_PF_SOCD_0000089231": "赞比亚",
        "P_YS_PF_SOCD_0000089232": "文莱",
        "P_YS_FI_CM_0000029084": "此刻",
        "P_YS_FED_IMP_IOT0000010561": "赣县",
        "P_YS_FED_IMP_IOT0000005945": "石门县",
        "P_YS_FED_IMP_IOT0000005948": "绥宁县",
        "P_YS_FED_IMP_IOT0000010563": "普兰县",
        "P_YS_FED_IMP_IOT0000010569": "两当县",
        "P_YS_FED_IMP_IOT0000005940": "太康县",
        "P_YS_FED_FW_1602981773186695169": "领域扩展的上下文中没获取到key为",
        "P_YS_FED_IMP_IOT0000005942": "栾川县",
        "P_YS_FED_IMP_IOT0000010565": "孟连傣族拉祜族佤族自治县",
        "P_YS_FED_IMP_IOT0000010566": "勐海县",
        "P_YS_FED_IMP_IOT0000005944": "韩城市",
        "P_YS_PF_SOCD_0000089239": "伊拉克",
        "P_YS_OA_XTWENKU_0000035676": "創建時間",
        "P_YS_PF_SOCD_0000089237": "巴拉圭",
        "P_YS_PF_SOCD_0000089235": "朝鲜",
        "P_YS_PF_SOCD_0000089236": "莫桑比克",
        "P_YS_PF_SOCD_0000089234": "尼日利亚",
        "P_YS_PF_SOCD_0000089265": "苏丹",
        "P_YS_PF_SOCD_0000089262": "瑙鲁",
        "P_YS_SCM_PU_0000027628": "已完成",
        "P_YS_PF_SOCD_0000089263": "白俄罗斯",
        "P_YS_PF_SOCD_0000089261": "伊朗",
        "P_YS_FED_IMP_IOT0000005935": "汉阴县",
        "P_YS_FED_IMP_IOT0000005934": "牟定县",
        "P_YS_FI_CM_0000030006": "切换为平铺",
        "P_YS_FI_CM_0000029016": "≥",
        "P_YS_FED_IMP_IOT0000010575": "剑川县",
        "P_YS_FI_CM_0000030008": "还原",
        "P_YS_FED_IMP_IOT0000005939": "阆中市",
        "P_YS_FED_IMP_IOT0000005938": "西夏区",
        "P_YS_FED_IMP_IOT0000005931": "福清市",
        "P_YS_FED_IMP_IOT0000005930": "东陵区",
        "P_YS_FED_IMP_IOT0000005933": "讷河市",
        "P_YS_FED_FW_0001384244": "每张图片大小不可超过",
        "P_YS_PF_SOCD_0000089268": "也门",
        "P_YS_PF_SOCD_0000089269": "尼日尔",
        "P_YS_PF_SOCD_0000089266": "阿尔及利亚",
        "P_YS_PF_SOCD_0000089267": "斯洛伐克",
        "P_YS_PF_SOCD_0000089253": "埃塞俄比亚",
        "P_YS_FI_CM_0000029021": "跳至",
        "P_YS_PF_SOCD_0000089251": "老挝",
        "P_YS_PF_SOCD_0000089252": "摩纳哥",
        "P_YS_FED_IMP_IOT0000010583": "保靖县",
        "P_YS_FED_IMP_IOT0000005926": "融安县",
        "P_YS_FED_IMP_IOT0000005925": "沂水县",
        "P_YS_FED_IMP_IOT0000010586": "丰镇市",
        "P_YS_FED_IMP_IOT0000010580": "站前区",
        "P_YS_FED_IMP_IOT0000010581": "乐昌市",
        "P_YS_FED_IMP_IOT0000010582": "三门峡",
        "P_YS_FED_IMP_IOT0000005920": "永年县",
        "P_YS_FED_IMP_IOT0000010589": "云阳县",
        "P_YS_FED_IMP_IOT0000008197": "港口区",
        "P_YS_FED_FW_0001029632": "报价管理",
        "P_YS_PF_SOCD_0000089259": "安提瓜和巴布达",
        "P_YS_FED_IMP_IOT0000008195": "礼泉县",
        "P_YS_FED_IMP_IOT0000008196": "铜陵县",
        "P_YS_PF_SOCD_0000089257": "塞舌尔",
        "P_YS_PF_SOCD_0000089255": "印度",
        "P_YS_FED_IMP_IOT0000008199": "确山县",
        "P_YS_PF_SOCD_0000089256": "圣卢西亚",
        "P_YS_PF_SOCD_0000089287": "布基纳法索",
        "P_YS_PF_SOCD_0000089285": "洪都拉斯",
        "P_YS_PF_SOCD_0000089282": "列支敦士登",
        "P_YS_PF_SOCD_0000089283": "波多黎各",
        "P_YS_FED_IMP_IOT0000008192": "恩施市",
        "P_YS_FED_IMP_IOT0000005912": "岳麓区",
        "P_YS_FED_IMP_IOT0000005915": "丰满区",
        "P_YS_FED_IMP_IOT0000010596": "昌邑市",
        "P_YS_FED_IMP_IOT0000010597": "利通区",
        "P_YS_FED_IMP_IOT0000010591": "东兴市",
        "P_YS_FED_IMP_IOT0000005919": "淅川县",
        "P_YS_FED_IMP_IOT0000005918": "忻城县",
        "P_YS_FED_IMP_IOT0000010599": "磁县",
        "P_YS_FED_IMP_IOT0000005911": "雨山区",
        "P_YS_FED_FW_1474274290590810117": "缺少 getConnectedDevice,方法丢失",
        "P_YS_FED_IMP_IOT0000005910": "鱼峰区",
        "P_YS_FED_IMP_IOT0000008186": "沙河口区",
        "P_YS_FED_IMP_IOT0000008187": "河口瑶族自治县",
        "P_YS_FED_IMP_IOT0000008184": "靖远县",
        "P_YS_PF_SOCD_0000089289": "沙特阿拉伯",
        "P_YS_PF_SOCD_0000089275": "土库曼斯坦",
        "P_YS_PF_SOCD_0000089276": "关岛",
        "P_YS_FED_IMP_IOT0000005909": "周宁县",
        "P_YS_PF_SOCD_0000089274": "格鲁吉亚",
        "P_YS_PF_SOCD_0000089271": "拉脱维亚",
        "P_YS_SD_UDHWN_0000122691": "物流单号：",
        "P_YS_PF_SOCD_0000089272": "喀麦隆",
        "P_YS_FED_UIMG_0001071360": "设计字段不能设为必输",
        "P_YS_PF_SOCD_0000089270": "格林纳达",
        "P_YS_FED_IMP_IOT0000005902": "江川县",
        "P_YS_FED_IMP_IOT0000005901": "望城县",
        "P_YS_FED_FW_0001120581": "公共默认方案不可取消默认状态",
        "P_YS_FED_IMP_IOT0000005904": "东丰县",
        "P_YS_FED_IMP_IOT0000005903": "麻栗坡县",
        "P_YS_FED_FW_0001204759": "】，请您参阅查看。",
        "P_YS_FED_FW_1474274290590810123": "getConnectedDevice success execute,但是未获取到已连接设备",
        "P_YS_FED_FW_0001204758": "导出已完成，文件名为【",
        "P_YS_FED_IMP_IOT0000005908": "全南县",
        "P_YS_FED_FW_1474274290590810120": "不支持当前平台,缺少必要方法",
        "P_YS_SD_SDOC_0000163474": "中华人民共和国",
        "P_YS_PF_SOCD_0000089279": "丹麦",
        "P_YS_PF_SOCD_0000089277": "坦桑尼亚",
        "P_YS_PF_SOCD_0000089278": "毛里求斯",
        "P_YS_FED_FW_1514390015376883745": "a ---直接填入数据",
        "P_YS_FED_FW_1514390015376883748": "&gt;=a ---大于等于a",
        "P_YS_FED_IMP_IOT0000008292": "新化县",
        "P_YS_FED_IMP_IOT0000008290": "灵宝市",
        "P_YS_FED_IMP_IOT0000008291": "惠农区",
        "P_YS_FED_IMP_IOT0000010495": "长治县",
        "P_YS_FED_FW_1616973608405958661": "的数据无操作权限",
        "P_YS_FED_IMP_IOT0000010496": "九台市",
        "P_YS_PF_GZTSYS_0000013194": "工作台",
        "P_YS_FED_FW_1514390015376883742": "[a,b] ---大于或等于a小于或等于b",
        "P_YS_FED_IMP_IOT0000010492": "尖山区",
        "P_YS_FED_IMP_IOT0000010494": "进贤县",
        "P_YS_OA_XTSPZX_0000034652": "排序",
        "P_YS_FED_FW_0000021399": "抵扣积分",
        "P_YS_FED_IMP_IOT0000008286": "三水区",
        "P_YS_FED_FW_0000021397": "赣州市",
        "P_YS_FED_IMP_IOT0000008283": "扎囊县",
        "P_YS_FED_FW_0000021398": "eChartDisplay 散点图地图信息正确 return",
        "P_YS_FED_IMP_IOT0000008284": "湟中县",
        "P_YS_OA_XTWENKU_0000035721": "項目名稱",
        "P_YS_FED_IMP_IOT0000008288": "绥阳县",
        "P_YS_PF_SOCD_0000089297": "圣马力诺",
        "P_YS_SD_URETAIL-UI_0001036607": "继续添加",
        "P_YS_FED_FW_1514390015376883757": "(a,b] ---大于a小于或等于b",
        "P_YS_PF_SOCD_0000089298": "博茨瓦纳",
        "P_YS_PF_SOCD_0000089295": "塞浦路斯",
        "P_YS_FED_IMP_IOT0000008282": "兴义市",
        "P_YS_PF_SOCD_0000089291": "厄瓜多尔",
        "P_YS_PF_SOCD_0000089292": "玻利维亚",
        "P_YS_FED_IMP_IOT0000008280": "石鼓区",
        "P_YS_PF_SOCD_0000089290": "秘鲁",
        "P_YS_FED_FW_1514390015376883751": "示例:大于2.5, 小于等于8.7,则输入(2.5,8.7]",
        "P_YS_FED_FW_1514390015376883754": "范围值输入有误，请按照正确格式输入",
        "P_YS_FI_RA_0000071687": "已确认",
        "P_YS_FED_UCFBASEDOC_0000024997": "退货原因",
        "P_YS_SD_URETAILF_0001154205": "请至少选择一条单据",
        "P_YS_FED_IMP_IOT0000008279": "沙依巴克区",
        "P_YS_FED_UCFBASEDOC_0000024992": "错误信息",
        "P_YS_FED_IMP_IOT0000008277": "项城市",
        "P_YS_FED_FW_0000021380": "抚州市",
        "P_YS_FED_UCFBASEDOC_0000024990": "密码",
        "P_YS_FED_FW_0000021381": "恩施土家族苗族自治州",
        "P_YS_HR_HRJQF_0000054647": "占位",
        "P_YS_FED_FW_0000021384": "柳州市",
        "P_YS_FED_FW_0000021385": "eChartCommon UnionDimensionName 出错。Err =",
        "P_YS_FED_FW_0000021382": "楚雄彝族自治州",
        "P_YS_FED_FW_0000021383": "需验货数量",
        "P_YS_FED_UCFBASEDOC_0000024989": "读写",
        "P_YS_FED_FW_0000021377": "饼形图示例",
        "P_YS_FED_IMP_IOT0000008263": "盐亭县",
        "P_YS_FED_IMP_IOT0000009594": "新昌县",
        "P_YS_FED_FW_0000021378": "潮州市",
        "P_YS_FED_IMP_IOT0000008264": "威远县",
        "P_YS_FED_FW_0000021375": "丽水市",
        "P_YS_FED_IMP_IOT0000009592": "安县",
        "P_YS_FED_FW_0000021376": "中国",
        "P_YS_FED_UCFBASEDOC_0000024986": "导入",
        "P_YS_FED_IMP_IOT0000008267": "即墨市",
        "P_YS_FED_IMP_IOT0000009598": "阿克苏市",
        "P_YS_FED_UCFBASEDOC_0000024984": "提交",
        "P_YS_FED_IMP_IOT0000008268": "平乐县",
        "P_YS_FED_FW_0000021379": "北京",
        "P_YS_FED_IMP_IOT0000008265": "宿城区",
        "P_YS_FED_UCFBASEDOC_0000024982": "不保存",
        "P_YS_HR_HRJQF_0000054641": "申请人",
        "P_YS_FED_IMP_IOT0000008266": "甘谷县",
        "P_YS_FED_IMP_IOT0000009597": "汉南区",
        "P_YS_FED_FW_0000021391": "销售净额",
        "P_YS_FED_FW_0000021392": "条数据",
        "P_YS_FED_FW_0000021390": "南阳市",
        "P_YS_FED_FW_0000021395": "哈尔滨市",
        "P_YS_FED_FW_0000021396": "鄂尔多斯市",
        "P_YS_FED_IMP_IOT0000008260": "镜湖区",
        "P_YS_FED_FW_0000021393": "台州市",
        "P_YS_FED_FW_0000021394": "承德市",
        "P_YS_FED_IMP_IOT0000009589": "镇康县",
        "P_YS_FED_FW_0000021388": "石家庄市",
        "P_YS_FED_IMP_IOT0000008252": "故城县",
        "P_YS_FED_FW_0000021389": "珠海市",
        "P_YS_FED_IMP_IOT0000009584": "宾阳县",
        "P_YS_FED_FW_0000021386": "宿州市",
        "P_YS_FED_IMP_IOT0000009581": "凤泉区",
        "P_YS_FED_FW_0000021387": "阿克苏地区",
        "P_YS_FED_IMP_IOT0000009582": "疏勒县",
        "P_YS_FED_IMP_IOT0000009587": "光山县",
        "P_YS_OA_XTWENKU_0000035713": "上傳",
        "P_YS_FED_IMP_IOT0000009586": "句容市",
        "P_YS_FI_CM_0000029097": "今天",
        "P_YS_FED_IMP_IOT0000008249": "辰溪县",
        "P_YS_FED_IMP_IOT0000008247": "相山区",
        "P_YS_FED_IMP_IOT0000008248": "开原市",
        "P_YS_FED_IMP_IOT0000008241": "尤溪县",
        "P_YS_SD_SDMB_0000147207": "《",
        "P_YS_FED_IMP_IOT0000009570": "云溪区",
        "P_YS_FED_IMP_IOT0000008240": "天元区",
        "P_YS_FED_IMP_IOT0000009576": "东川区",
        "P_YS_FED_UCFBASEDOC_0000024962": "开单",
        "P_YS_FED_IMP_IOT0000009577": "崇川区",
        "P_YS_FED_IMP_IOT0000009574": "鱼台县",
        "P_YS_FED_UCFBASEDOC_0000024960": "发布",
        "P_YS_PF_PRINT_0000056755": "家庭住址",
        "P_YS_FED_IMP_IOT0000008236": "金城江区",
        "P_YS_FED_IMP_IOT0000009567": "道孚县",
        "P_YS_FI_CM_0000030090": "获取参数失败：【接口】",
        "P_YS_FED_IMP_IOT0000008230": "栖霞区",
        "P_YS_FED_IMP_IOT0000009561": "封丘县",
        "P_YS_FED_IMP_IOT0000009560": "沽源县",
        "P_YS_SD_UDHBN_0001144941": "交期：",
        "P_YS_SD_UDHBN_0001144942": "单号：",
        "P_YS_FED_IMP_IOT0000009566": "电白县",
        "P_YS_PF_PROCENTER_0000023211": "男",
        "P_DIWORK_YC_ORDER_0000061307": "生效成功",
        "P_YS_PF_PRINT_0000056726": "变更时间",
        "P_YS_FED_FW_1514390015376883724": "范围值按以下格式书写:",
        "P_YS_FI_IA_0000151381": "保存数据失败",
        "P_YS_FED_FW_1514390015376883727": "&gt;a ---大于a",
        "P_YS_FED_FW_1514390015376883721": "[a,b) ---大于或等于a小于b",
        "P_YS_FED_IMP_IOT0000009558": "武进区",
        "P_YS_FED_UCFBASEDOC_0000024949": "门户控件",
        "P_YS_FED_FW_0001194811": "您的点击频率过高，请耐心等待...",
        "P_YS_FED_IMP_IOT0000009550": "苏尼特右旗",
        "P_YS_FED_IMP_IOT0000009551": "磐石市",
        "P_YS_FED_UCFBASEDOC_0000024942": "添加",
        "P_YS_FED_IMP_IOT0000009554": "徐水县",
        "P_YS_FED_IMP_IOT0000008224": "九龙坡区",
        "P_YS_FED_IMP_IOT0000008221": "勐腊县",
        "P_YS_FED_IMP_IOT0000009553": "泽库县",
        "P_YS_FED_FW_1514390015376883736": "(a,b) ---大于a小于b",
        "P_YS_FED_FW_1514390015376883739": "&lt;b ---小于b",
        "P_YS_FED_FW_1514390015376883730": "&lt;=b ---小于等于b",
        "P_YS_FED_FW_1514390015376883733": "范围值输入有误，左值需小于右值！",
        "P_YS_FED_IMP_IOT0000008217": "大余县",
        "P_YS_FED_IMP_IOT0000009548": "承德县",
        "P_YS_FED_UCFBASEDOC_0000024939": "看板权限",
        "P_YS_FED_IMP_IOT0000009549": "安次区",
        "P_YS_FED_IMP_IOT0000009540": "阿坝县",
        "P_YS_FED_IMP_IOT0000008212": "柳北区",
        "P_YS_FED_IMP_IOT0000009542": "泾阳县",
        "P_YS_FED_EXAMP_0000020481": "保存成功！",
        "P_YS_FED_EXAMP_0000020480": "预订交货且“交货时可修改商品”为否, 不允许执行退品",
        "P_YS_FED_EXAMP_0000020483": "卡券商品原单退货,卡券数量应为-1",
        "P_YS_FED_EXAMP_0000020482": "预订时未使用会员钱包支付, 退订时不允许使用会员钱包支付",
        "P_YS_FED_FW_0000021319": "商品条码：",
        "P_YS_FED_EXAMP_0000020478": "归属门店",
        "P_YS_FED_IMP_IOT0000008205": "林口县",
        "P_YS_FED_EXAMP_0000020477": "将替换所有行营业员，是否继续！",
        "P_YS_FED_FW_0000021317": "移动报表 MobileData Render",
        "P_YS_FED_FW_0000021318": "连云港市",
        "P_YS_FED_EXAMP_0000020479": "富文本编辑器",
        "P_YS_FED_IMP_IOT0000008204": "琼山区",
        "P_YS_FED_EXAMP_0000020474": "联系人：",
        "P_YS_FED_IMP_IOT0000008209": "长宁区",
        "P_YS_FED_EXAMP_0000020473": "错：",
        "P_YS_FED_EXAMP_0000020476": "退货",
        "P_YS_FED_IMP_IOT0000008207": "紫金县",
        "P_YS_FED_IMP_IOT0000009538": "永定区",
        "P_YS_FED_EXAMP_0000020475": "预订交货且“交货时可修改商品”为否, 不允许会员钱包结算",
        "P_YS_FED_IMP_IOT0000008208": "郊区",
        "P_YS_FED_IMP_IOT0000009539": "南浔区",
        "P_YS_FED_FW_0000021311": "张家界市",
        "P_YS_FED_FW_0000021312": "不限",
        "P_YS_FED_FW_0000021310": "侯厉害穷神卡（塑料会员）（普通会员）",
        "P_YS_FED_FW_0000021315": "郴州市",
        "P_YS_FED_FW_0000021316": "选择数量超过上传限制，请重新上传！",
        "P_YS_FED_IMP_IOT0000008202": "天宁区",
        "P_YS_FED_IMP_IOT0000009533": "西山区",
        "P_YS_FED_FW_0000021313": "保存为图片",
        "P_YS_FED_FW_0000021314": "参照",
        "P_YS_FED_IMP_IOT0000008200": "新平彝族傣族自治县",
        "P_YS_FED_IMP_IOT0000009531": "尖扎县",
        "P_YS_OA_XTLCZX_0000030786": "全部数据",
        "P_YS_FED_FW_0000021330": "邢台市",
        "P_YS_FED_EXAMP_0000020492": "赠品状态不允许执行",
        "P_YS_FED_EXAMP_0000020494": "U订货上架数 :",
        "P_YS_FED_EXAMP_0000020493": "原单退货中，换货行不允许修改数量！",
        "P_YS_FED_FW_0001247825": "交互规则>>>",
        "P_YS_FED_EXAMP_0000020490": "权限范围",
        "P_YS_FED_EXAMP_0000020489": "已经执行了现场折扣,不允许改数量！",
        "P_YS_PF_GZTSYS_0000013119": "用户管理",
        "P_YS_FED_EXAMP_0000020488": "请检查储值卡是否正确有效",
        "P_YS_FED_IMP_IOT0000009526": "同安区",
        "P_YS_FED_FW_0000021328": "乌鲁木齐市",
        "P_YS_PF_GZTSYS_0000015779": "商品",
        "P_YS_FED_IMP_IOT0000009523": "乌审旗",
        "P_YS_FED_FW_0000021329": "安康市",
        "P_YS_FED_EXAMP_0000020484": "未找到对应商品信息",
        "P_YS_FED_EXAMP_0000020487": "未录入第",
        "P_YS_FED_IMP_IOT0000009527": "广昌县",
        "P_YS_FED_EXAMP_0000020486": "的商品行",
        "P_YS_FED_FW_0000021322": "徐州市",
        "P_YS_FED_FW_0000021323": "绵阳市",
        "P_YS_FED_FW_0000021320": "七台河市",
        "P_YS_FED_FW_0000021321": "达州市",
        "P_YS_OA_XTLCZX_0000030776": "正常",
        "P_YS_FED_FW_0000021326": "安阳市",
        "P_YS_FED_FW_0000021327": "零售金额",
        "P_YS_FED_IMP_IOT0000009522": "衢江区",
        "P_YS_FED_FW_0000021324": "阿拉善盟",
        "P_YS_FED_FW_0000021325": "厦门市",
        "P_YS_OA_XTLCZX_0000030790": "手动输入",
        "P_YS_FED_EXAMP_0000020499": "改零售价",
        "P_YS_FED_IMP_IOT0000009515": "金秀瑶族自治县",
        "P_YS_YYGJFW_YBUC_0001335796": "快捷键",
        "P_YS_FED_IMP_IOT0000009513": "博山区",
        "P_YS_FED_EXAMP_0000020496": "已经执行了促销活动,不允许修改商品数量！",
        "P_YS_FED_EXAMP_0000020495": "支付。执行线上撤销？",
        "P_YS_FED_EXAMP_0000020498": "储值卡非原单退",
        "P_YS_FED_IMP_IOT0000009516": "万源市",
        "P_YS_FED_EXAMP_0000020497": "获取商品规格失败。信息:",
        "P_YS_FED_IMP_IOT0000009510": "永德县",
        "P_YS_FED_IMP_IOT0000009509": "固安县",
        "P_YS_FED_FW_0000021308": "运城市",
        "P_YS_FED_FW_0000021309": "池州市",
        "P_YS_FED_FW_0000021306": "新疆",
        "P_YS_FED_IMP_IOT0000009501": "新兴区",
        "P_YS_FED_FW_0000021307": "，支持格式：PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF",
        "P_YS_FED_IMP_IOT0000009502": "井冈山市",
        "P_YS_FED_IMP_IOT0000009507": "新绛县",
        "P_YS_FED_FW_0000021300": "驻马店市",
        "P_YS_FED_FW_0000021301": "subConfigArray_Operate  没有找到对应的eChart  chartKey =",
        "P_YS_PF_PROCENTER_0000023238": "请至少选择一条数据",
        "P_YS_FED_FW_0000021304": "陕西",
        "P_YS_FED_FW_0000021305": "青岛市",
        "P_YS_FED_FW_0000021302": "兴安盟",
        "P_YS_FED_FW_0000021303": "delete参数格式应为Array或者String",
        "P_YS_FED_FW_0000021362": "郑州市",
        "P_YS_FED_FW_0000021363": "平凉市",
        "P_YS_FED_FW_0000021360": "老板模板",
        "P_YS_FED_FW_0000021361": "淮南市",
        "P_YS_OA_XTSPZX_0000034691": "提交人",
        "P_YS_FED_EXAMP_0000020434": "交货不能修改商品时，不允许删除商品！",
        "P_YS_FED_FW_0001253699": "[mdf-metaui-web] [CellModel] [RemodelingCell()] RemodelingFormatControl()返回用于显示的text ==>",
        "P_YS_FED_FW_0001253698": "参照回显字段",
        "P_YS_FED_EXAMP_0000020436": "零售",
        "P_YS_FED_EXAMP_0000020435": "POS退款成功",
        "P_YS_FED_EXAMP_0000020430": "选择仓库",
        "P_YS_FED_FW_0001253695": "加载查询方案组件componentDidMount开始",
        "P_YS_FED_FW_0001253694": "]类型的模板",
        "P_YS_FED_EXAMP_0000020432": "预订且“交货时可修改商品”为是, 不允许会员钱包结算",
        "P_YS_FED_FW_0001253697": "PrintButton: 缺少printDomain设置",
        "P_YS_FED_EXAMP_0000020431": "采购订单不能增加非自采商品!",
        "P_YS_FED_FW_0001253696": "配置信息失败。",
        "P_YS_FED_FW_0000021355": "图表不能正常显示，需要 report/getGroupSetting(获取报表分组方案的详细设置进行显示) 返回的配置信息中 _.isEmpty(json.data.chartConfig) == false",
        "P_YS_FED_FW_0000021356": "夜班",
        "P_YS_FED_FW_0000021353": "保存多条数据失败！",
        "P_YS_FED_FW_0000021354": "六盘水市",
        "P_YS_SD_SDMB_0000137806": "”",
        "P_YS_FED_FW_0000021359": "江苏",
        "P_YS_FED_EXAMP_0000020438": "交货不能修改商品时,不允许修改营业员！",
        "P_YS_FED_EXAMP_0000020437": "未生成",
        "P_YS_FED_FW_0000021357": "吉林市",
        "P_YS_FED_FW_0000021358": "临沧市",
        "P_YS_FED_EXAMP_0000020439": ",实际子表抹零合计：",
        "P_YS_FED_FW_0000021370": "移动报表 MobileReportSum Render",
        "P_YS_FED_FW_0000021373": "丹东市",
        "P_YS_FED_FW_0000021374": "神秘黑色",
        "P_YS_SD_UDHMC_0000051115": "下次再说",
        "P_YS_FED_FW_0000021371": "天水市",
        "P_YS_FED_FW_0000021372": "西宁市",
        "P_YS_FED_EXAMP_0000020450": "电商订单",
        "P_YS_FED_EXAMP_0000020445": "钱包不适用全部商品, 不能快速结算",
        "P_YS_FED_EXAMP_0000020444": "（房间号）与预订的房间号",
        "P_YS_FED_EXAMP_0000020447": "商品单价不能小于0！",
        "P_YS_FED_EXAMP_0000020446": "本单实收金额为0，请进行确认！",
        "P_YS_FED_EXAMP_0000020441": "非原单退不能使用会员多钱包支付",
        "P_YS_FED_EXAMP_0000020440": "未审核",
        "P_YS_PF_GZTSYS_0000013159": "报价",
        "P_YS_FED_EXAMP_0000020443": "手机号/会员号",
        "P_YS_FED_EXAMP_0000020442": "无可用会员钱包",
        "P_YS_FED_FW_0000021366": "温州市",
        "P_YS_FED_FW_0000021367": "马鞍山市",
        "P_YS_FED_FW_0001350929": "点聚合",
        "P_YS_FED_FW_0000021364": "衡水市",
        "P_YS_FED_FW_0000021365": "平顶山市",
        "P_YS_FED_EXAMP_0000020449": "欢迎登录",
        "P_YS_FED_EXAMP_0000020448": "此账号没有该折扣的权限",
        "P_YS_FED_FW_0000021368": "甘肃",
        "P_YS_FED_FW_0000021369": "四川",
        "P_YS_FED_FW_0001350931": "2列",
        "P_YS_FED_FW_0001350932": "展示列数",
        "P_YS_FED_FW_0000021340": "嘉峪关市",
        "P_YS_OA_XTLCZX_0000030753": "未开始",
        "P_YS_FED_FW_0000021341": "删除数据失败",
        "P_YS_OA_XTLCZX_0000030752": "定位",
        "P_YS_FED_FW_0001253680": "加载查询方案组件componentDidMount结束",
        "P_YS_FED_EXAMP_0000020461": "修改密码成功！",
        "P_YS_PF_GZTSYS_0000015793": "组织机构",
        "P_YS_FED_FW_0001253682": "[mdf-metaui-web] [amap] [setValue()] saveType为json时，setValue(value)的参数value不是一个有效的JSONString",
        "P_YS_FED_EXAMP_0000020460": "市场价",
        "P_YS_FED_FW_0001253681": "，兼容返回空字符串! text is",
        "P_YS_PF_GZTSYS_0000015790": "店员",
        "P_YS_FED_FW_0001350930": "1列",
        "P_YS_FED_EXAMP_0000020456": "调整状态不允许修改商品行数量！",
        "P_YS_FED_FW_0001253677": "按钮点击，调用ConvenientQuery组件内部buttonClick方法开始",
        "P_YS_FED_EXAMP_0000020455": "回收品不允许修改数量！",
        "P_YS_FED_FW_0001253676": "InputIdentity [onBlur] canBubbleBlur == true,继续冒泡blur事件",
        "P_YS_FED_FW_0000021339": "扬州市",
        "P_YS_FED_EXAMP_0000020458": "商品属性",
        "P_YS_FED_FW_0001253679": "InputIdentity [onBlur] canBubbleBlur == false, 不冒泡blur事件",
        "P_YS_FED_EXAMP_0000020457": "本店自提",
        "P_YS_FED_FW_0001253678": "二维表第",
        "P_YS_FED_EXAMP_0000020452": "信息修改失败！！",
        "P_YS_FED_FW_0001253673": "PrintButton: 缺少user信息",
        "P_YS_PF_GZTSYS_0000015787": "查询",
        "P_YS_FED_EXAMP_0000020451": "选择地区",
        "P_YS_FED_FW_0001253672": "得到UI元数据，开始执行setState",
        "P_YS_PF_GZTLOG_0000028817": "请求失败",
        "P_YS_FED_FW_0001253675": "领域为[",
        "P_YS_FED_EXAMP_0000020453": "电商退货",
        "P_YS_FED_FW_0001253674": "加载查询方案组件构造函数结束",
        "P_YS_FED_FW_0000021333": "堆叠柱形图示例",
        "P_YS_FED_FW_0000021334": "看板配置信息-模块配置-天气",
        "P_YS_FED_FW_0000021331": "老板大屏看板",
        "P_YS_FED_FW_0000021332": "空数据",
        "P_YS_FED_FW_0000021337": "横",
        "P_YS_FED_FW_0000021338": "浙江",
        "P_YS_FED_EXAMP_0000020459": "重量小数位",
        "P_YS_OA_XTLCZX_0000030749": "年-月-日 时:分",
        "P_YS_FED_FW_0000021335": "遵义市",
        "P_YS_OA_XTLCZX_0000030748": "待选字段",
        "P_YS_FED_FW_1463482661291950083": "加密文本长度小于加密起始位(encryptStart),加密数量(encryptCount)两者相加长度,不在加密",
        "P_YS_FED_FW_0000021336": "果洛藏族自治州",
        "P_YS_FED_FW_1463482661291950080": "加密规则配置错误,加密起始位(encryptStart),加密数量(encryptCount)不能同时为负数,不在加密",
        "P_YS_FED_FW_0000021351": "重庆",
        "P_YS_FED_FW_0000021352": "娄底市",
        "P_YS_FED_FW_0000021350": "曲靖市",
        "P_YS_FED_EXAMP_0000020470": "正在开发中，敬请期待！",
        "P_YS_FED_FW_0001253691": "[mdf-metaui-web] [CellModel] RemodelingFormatControl() case map时，无法处理的数据，text is",
        "P_YS_FED_FW_0001253690": "得到UI元数据，结束执行setState",
        "P_YS_FED_FW_0001253693": "[mdf-cube] [getCellDataByCtrlType()] 不规范数据的map数据，兼容处理时没有合法的属性address, 返回空字符串，text ==>",
        "P_YS_FED_EXAMP_0000020471": "预订退订状态下不能新增商品！",
        "P_YS_FED_FW_0001253692": "按钮点击，调用ConvenientQuery组件内部buttonClick方法结束",
        "P_YS_FED_FW_0001265659": "显示角度y轴",
        "P_YS_FED_EXAMP_0000020467": "预订且“交货时可修改商品”为是, 不允许储值卡结算",
        "P_YS_FED_FW_0001253688": "]菜单服务，",
        "P_YS_FED_FW_0001253687": "行存在重复行标题",
        "P_YS_FED_EXAMP_0000020469": "该商品行不允许修改零售价！",
        "P_YS_FED_EXAMP_0000020468": "必输！",
        "P_YS_FED_FW_0001253689": "加载查询方案组件构造函数开始",
        "P_YS_FED_EXAMP_0000020463": "兑换券",
        "P_YS_FED_FW_0001253684": "配置信息不全，请检查。",
        "P_YS_FED_EXAMP_0000020462": "清空",
        "P_YS_FED_FW_0001253683": "支持excel格式文件、单文件；单个文件的大小限制不超过50MB，不超过5万条数据",
        "P_YS_FED_EXAMP_0000020465": "输入框不能为空!",
        "P_YS_FED_FW_0001253686": "该组织无参照编码",
        "P_YS_FED_EXAMP_0000020464": "已交货",
        "P_YS_FED_FW_0001253685": "[mdf-cube] [getCellDataByCtrlType()] 不规范数据的map数据，正在尝试兼容处理，text ==>",
        "P_YS_FED_FW_0000021344": "庆阳市",
        "P_YS_FED_FW_0000021345": "曲线图示例",
        "P_YS_FED_FW_0000021342": "没有更多数据了~",
        "P_YS_FED_FW_0001136114": "node端",
        "P_YS_FED_FW_0001265660": "显示角度x轴",
        "P_YS_FED_FW_0000021343": "选择文件格式不正确，请重新选择！",
        "P_YS_FED_FW_0001265661": "显示角度应该在-90-90之间",
        "P_YS_FED_FW_0000021348": "牡丹江市",
        "P_YS_FED_FW_0000021349": "鄂州市",
        "P_YS_FED_FW_0000021346": "铜陵市",
        "P_YS_FED_FW_0000021347": "南昌市",
        "P_YS_FI_ETL_0000111662": "网络",
        "P_YS_FED_FW_0001073815": "中甸市",
        "P_YS_FED_FW_0001073814": "都均市",
        "P_YS_FED_FW_0001073813": "顺德市",
        "P_YS_FED_FW_0001073812": "万县市",
        "P_YS_FED_FW_0001073811": "浑江市",
        "P_YS_SD_UDHWN_0000048223": "屯昌县",
        "P_YS_FED_FW_0001073810": "德令哈",
        "P_YS_FED_FW_0001073819": "荆沙市",
        "P_YS_FED_FW_0001073818": "潮阳市",
        "P_YS_FED_FW_0001073817": "贵池市",
        "P_YS_FED_FW_0001073816": "海拉尔",
        "P_YS_SD_UDHWN_0001008650": "横向选择",
        "P_YS_SD_UDHWN_0000049569": "奉贤区",
        "P_YS_HR_HRFZ-UI_1474270717181689857": "UI模板ID",
        "P_YS_FED_FW_0001073826": "黄州市",
        "P_YS_FED_FW_0001073825": "东川市",
        "P_YS_FED_FW_0001073824": "随枣市",
        "P_YS_FED_FW_0001073823": "临川市",
        "P_YS_SD_UDHWN_0000049565": "百度地图",
        "P_YS_FED_FW_0001073822": "玛沁市",
        "P_YS_FED_FW_0001073821": "淮坊市",
        "P_YS_FED_FW_0001073820": "甘南州",
        "P_YS_FED_FW_0000088641": "请选择左侧树节点",
        "P_YS_FED_EXAMP_0000020401": "修改密码",
        "P_YS_FED_EXAMP_0000020400": "体验账户信息错误！",
        "P_YS_FED_EXAMP_0000020403": "套餐商品未录入完毕,不允许执行积分抵扣",
        "P_YS_FED_EXAMP_0000020402": "储值",
        "P_YS_FED_EXAMP_0000020409": "售后",
        "P_YS_FED_FW_0001112266": "]的商品",
        "P_YS_FED_EXAMP_0000020408": "未取到该储值卡号对应实体卡的初始价格",
        "P_YS_FED_EXAMP_0000020405": "生日",
        "P_YS_FED_EXAMP_0000020404": "--次日",
        "P_YS_FED_EXAMP_0000020407": "未获取到重量，请检查托盘是否放置正确！",
        "P_YS_FED_EXAMP_0000020406": "旧密码",
        "P_YS_FED_FW_0001149575": "最多设置十个搜索列！",
        "P_YS_FED_FW_0001097806": "，结果：",
        "P_YS_FED_EXAMP_0000020412": "调整状态不允许修改数量！",
        "P_YS_FED_EXAMP_0000020411": "建议零售价",
        "P_YS_PF_AUTHF_0000096105": "待选",
        "P_YS_FED_EXAMP_0000020414": "当前网络不可用，不能销售有效期管理的商品！",
        "P_YS_FED_EXAMP_0000020413": "立即体验",
        "P_YS_FED_FW_0001097807": "当前平台：",
        "P_YS_FED_EXAMP_0000020410": "请先设置默认的支付方式",
        "P_YS_FI_CM_0000029118": "单据状态",
        "P_YS_FED_EXAMP_0000020419": "储值卡非原单退不允许修改数量",
        "P_YS_FED_EXAMP_0000020416": "商品中心",
        "P_YS_FED_EXAMP_0000020415": "未取得门店信息!",
        "P_YS_FED_EXAMP_0000020418": "已存在该序列号的商品！",
        "P_YS_FED_EXAMP_0000020417": "业务功能菜单(可调试)",
        "P_YS_PLM_PLM-GDS-UI_0001095906": "查看历史",
        "P_YS_HR_HRJQ_0000031525": "张三",
        "P_YS_FED_FW_0001149583": "未来",
        "P_YS_FED_EXAMP_0000020423": "零售开单校验失败：未登录到门店，不能开单",
        "P_YS_FED_EXAMP_0000020422": "当前商品不允许开单改价",
        "P_YS_FED_EXAMP_0000020425": "下不能进行预订",
        "P_YS_FED_EXAMP_0000020424": "录入电子卡券商品时请先登录会员！",
        "P_YS_SD_DGYL-FE_1541228913807589381": "请配置移动模板",
        "P_YS_FED_EXAMP_0000020421": "请选择商品明细！",
        "P_YS_FED_EXAMP_0000020420": "此模式下无法进行云打印,请重新设置！！",
        "P_YS_FED_EXAMP_0000020427": "改数量",
        "P_YS_FED_EXAMP_0000020426": "详细地址",
        "P_YS_FED_EXAMP_0000020429": "售卡状态不允许添加非实体储值卡商品行！",
        "P_YS_FED_EXAMP_0000020428": ")启用了效期管理，请输入效期！",
        "P_YS_FED_FW_0001367630": "无(计数)",
        "P_YS_SD_UDHWN_0000050500": "昌江黎族自治县",
        "P_YS_FED_FW_0001367631": "聚合字段",
        "P_YS_PLM_GDS-BE_0001160301": "上传错误",
        "P_YS_FED_FW_0000021517": "移动报表 MobileFilter Render",
        "P_YS_FED_FW_0000021518": "看板配置信息-桌面",
        "P_YS_FED_IMP_IOT0000011702": "凤县",
        "P_YS_FED_FW_0001034253": "员工性别",
        "P_YS_FED_FW_0000021515": "北京市",
        "P_YS_FED_IMP_IOT0000011705": "丰台区",
        "P_YS_FED_FW_0001367629": "图片字段",
        "P_YS_FED_FW_0000021516": "巴彦淖尔市",
        "P_YS_FED_IMP_IOT0000005898": "北流市",
        "P_YS_FED_FW_0000021519": "无锡市",
        "P_YS_FED_FW_0001380601": "请录入多语环境中的方案名称",
        "P_YS_FED_FW_0000021510": "梧州市",
        "P_YS_FED_FW_0001100234": "该操作，对必输项目<%=confirmMSGFields%>设置了隐藏，请再次确认",
        "P_YS_FED_FW_0001100235": "）设置了隐藏，请再次确认",
        "P_YS_FED_FW_0000021513": "锡林郭勒盟",
        "P_YS_FED_IMP_IOT0000005890": "阿拉善右旗",
        "P_YS_FED_IMP_IOT0000011707": "沙雅县",
        "P_YS_FED_FW_0000021514": "沧州市",
        "P_YS_FED_FW_0000021511": "三亚市",
        "P_YS_FED_FW_0000021512": "雅安市",
        "P_YS_FED_FW_0000110004": "仅支持<%=text%>格式",
        "P_YS_SCM_STOCK_0001230696": "扫码删除",
        "P_YS_FED_FW_0000021528": "气泡图示例",
        "P_YS_PF_GZTSUPPLIER_0001241184": "]，",
        "P_YS_FED_FW_0000021529": "安顺市",
        "P_YS_FED_IMP_IOT0000011713": "杨浦区",
        "P_YS_FED_FW_0000021526": "广东",
        "P_YS_FED_FW_0000021527": "泸州市",
        "P_YS_FED_IMP_IOT0000011710": "永修县",
        "P_YS_FED_IMP_IOT0000005886": "闵行区",
        "P_YS_FED_FW_0000021520": "枣庄市",
        "P_YS_FED_FW_0000021521": "保定市",
        "P_YS_FED_FW_0001367632": "切换聚合字段",
        "P_YS_FED_FW_0000021524": "宜昌市",
        "P_YS_FED_IMP_IOT0000011718": "隆昌县",
        "P_YS_FED_FW_0000021525": "克拉玛依市",
        "P_YS_FED_IMP_IOT0000011717": "历城区",
        "P_YS_FED_FW_0000021522": "确定要返回么",
        "P_YS_FED_FW_0000021523": "辽宁",
        "P_YS_FED_IMP_IOT0000005880": "精河县",
        "P_YS_FED_IMP_IOT0000011719": "长岛县",
        "P_YS_FED_FW_1456081762615033856": "选择起止时间",
        "P_YS_PF_GZTTMP_0000075994": "在列表中",
        "P_YS_FED_FW_0001253831": "展开2级",
        "P_YS_FED_FW_0001253830": "展开3级",
        "P_YS_FED_IMP_IOT0000011727": "武邑县",
        "P_YS_FED_FW_0001253833": "展开1级",
        "P_YS_FED_IMP_IOT0000005873": "莘县",
        "P_YS_FED_IMP_IOT0000011726": "庆元县",
        "P_YS_FED_FW_0001253832": "展开4级",
        "P_YS_FED_IMP_IOT0000011721": "江永县",
        "P_YS_FED_IMP_IOT0000005877": "准格尔旗",
        "P_YS_FED_IMP_IOT0000011722": "叶县",
        "P_YS_OA_XTWENKU_0000035585": "暫無數據",
        "P_YS_FED_IMP_IOT0000011729": "赤水市",
        "P_YS_FED_FW_0000111353": "行缺少附件id",
        "P_YS_FED_IMP_IOT0000005870": "西固区",
        "P_YS_FED_FW_0000111354": "附件管理只能单行显示",
        "P_YS_FED_FW_0000111355": "表格为空",
        "P_YS_FED_FW_0000111356": "附件管理",
        "P_YS_FED_FW_0000111357": "必输项",
        "P_YS_FED_FW_0000111358": "未输入，请输入完整再尝试保存！",
        "P_YS_FED_FW_0000111359": "输入数字的整数部分长度不能大于",
        "P_YS_FED_FW_0001073804": "西峰市",
        "P_YS_FED_IMP_IOT0000005869": "黄平县",
        "P_YS_FED_FW_0001073803": "江汉市",
        "P_YS_FED_FW_0001073802": "加格达奇",
        "P_YS_FED_IMP_IOT0000011730": "阿鲁科尔沁旗",
        "P_YS_FED_FW_0001073801": "六库市",
        "P_YS_FED_FW_0001073800": "马尔康",
        "P_YS_FED_FW_0000021506": "四平市",
        "P_YS_FED_IMP_IOT0000005861": "莲都区",
        "P_YS_FED_FW_0000021507": "现销",
        "P_YS_FED_IMP_IOT0000005860": "林芝县",
        "P_YS_FED_FW_0000021504": "大理白族自治州",
        "P_YS_FED_IMP_IOT0000010406": "雨花台区",
        "P_YS_FED_FW_0000021505": "喀什地区",
        "P_YS_FED_FW_0001073809": "同仁市",
        "P_YS_FED_IMP_IOT0000005862": "丰城市",
        "P_YS_FED_IMP_IOT0000011737": "剑阁县",
        "P_YS_FED_FW_0001073808": "共和市",
        "P_YS_OA_XTWENKU_0000035594": "正在上傳",
        "P_YS_FED_FW_0001073807": "淮阴市",
        "P_YS_FED_IMP_IOT0000005864": "下花园区",
        "P_YS_FED_IMP_IOT0000010401": "安丘市",
        "P_YS_FED_FW_0000021508": "气泡图配置信息-eChartSetting",
        "P_YS_FED_FW_0001073806": "乌兰浩特",
        "P_YS_FED_IMP_IOT0000010402": "新源县",
        "P_YS_FED_IMP_IOT0000011734": "龙海市",
        "P_YS_FED_FW_0000021509": "柱折图配置信息-eChartSetting",
        "P_YS_FED_FW_0001073805": "涪陵市",
        "P_YS_FED_IMP_IOT0000005866": "桑日县",
        "P_YS_FED_IMP_IOT0000011733": "湄潭县",
        "P_YS_FED_FW_0000111360": "请配置文件地址",
        "P_YS_FED_FW_0000111361": "方案名称不能重复",
        "P_YS_FED_FW_0000021502": "西安市",
        "P_YS_FED_FW_0000111362": "条件已添加",
        "P_YS_FED_FW_0000021503": "贵州",
        "P_YS_FED_IMP_IOT0000010409": "叙永县",
        "P_YS_FED_IMP_IOT0000011739": "普洱哈尼族彝族自治县",
        "P_YS_FED_FW_0000021500": "揭阳市",
        "P_YS_FED_FW_0000021501": "采购部",
        "P_YS_FI_CM_0000029174": "备注",
        "P_YS_FED_IMP_IOT0000005858": "临川区",
        "P_YS_FED_IMP_IOT0000005857": "涟源市",
        "P_YS_FED_IMP_IOT0000011741": "涿鹿县",
        "P_YS_FED_IMP_IOT0000005859": "开化县",
        "P_YS_FED_IMP_IOT0000011740": "永吉县",
        "P_YS_SD_SDMAUF_0001064722": "繁体",
        "P_YS_FED_FW_1502904499728023562": "上一行",
        "P_YS_FED_IMP_IOT0000011747": "香坊区",
        "P_YS_FED_IMP_IOT0000010416": "海门市",
        "P_YS_FED_IMP_IOT0000011746": "科尔沁区",
        "P_YS_FED_FW_0000154407": "command cParameter JSON格式错误-->",
        "P_YS_FED_IMP_IOT0000005853": "高州市",
        "P_YS_FED_IMP_IOT0000010412": "宝应县",
        "P_YS_FED_IMP_IOT0000011742": "岳阳县",
        "P_YS_PF_SOCD_0000089109": "加纳",
        "P_YS_FED_IMP_IOT0000010413": "淮上区",
        "P_YS_FED_IMP_IOT0000011745": "汾西县",
        "P_YS_FED_IMP_IOT0000010414": "富县",
        "P_YS_FED_IMP_IOT0000011744": "辉南县",
        "P_YS_PF_SOCD_0000089107": "贝宁",
        "P_YS_PF_SOCD_0000089105": "新西兰",
        "P_YS_PF_SOCD_0000089106": "布隆迪",
        "P_YS_PF_SOCD_0000089103": "委内瑞拉",
        "P_YS_PF_SOCD_0000089104": "约旦",
        "P_YS_PF_SOCD_0000089101": "斯威士兰",
        "P_YS_FED_FW_1502904499728023559": "下一行",
        "P_YS_FED_IMP_IOT0000005847": "井陉县",
        "P_YS_FED_IMP_IOT0000005846": "牡丹江",
        "P_YS_SD_SDMA_0000038357": "已签收",
        "P_YS_FED_IMP_IOT0000010420": "桐乡市",
        "P_YS_FED_IMP_IOT0000005848": "响水县",
        "P_YS_FED_IMP_IOT0000010426": "施甸县",
        "P_YS_FED_IMP_IOT0000011758": "五莲县",
        "P_YS_FED_IMP_IOT0000005841": "振兴区",
        "P_YS_FED_IMP_IOT0000010428": "丛台区",
        "P_YS_FED_FW_0001253822": "if 配置不正确",
        "P_YS_FED_IMP_IOT0000010423": "莫力达瓦达斡尔族自治旗",
        "P_YS_FED_IMP_IOT0000011753": "铅山县",
        "P_YS_FED_IMP_IOT0000010424": "玛沁县",
        "P_YS_FED_IMP_IOT0000005844": "农安县",
        "P_YS_FED_FW_0001253828": "单据id属性不存在，请检查数据建模",
        "P_YS_FED_FW_0001253827": "条。失败原因",
        "P_YS_FED_FW_0001253829": "isMdfMobile 判断出错",
        "P_YS_FED_FW_0001253824": "，请填写完整！",
        "P_YS_FED_FW_0001253823": "子表：",
        "P_YS_FED_FW_0001253826": "if 不符合条件",
        "P_YS_FED_FW_0000130443": "将文件拖拽至此区域上传",
        "P_YS_FED_FW_0001253825": "条数据？",
        "P_YS_PF_SOCD_0000089121": "乌兹别克斯坦",
        "P_YS_PF_SOCD_0000089122": "韩国",
        "P_YS_PF_SOCD_0000089120": "卡塔尔",
        "P_YS_SD_SDMB_0000148482": "通知时间",
        "P_YS_FI_CM_0000029191": "区域缩放还原",
        "P_YS_FED_IMP_IOT0000005835": "邵东县",
        "P_YS_FED_IMP_IOT0000011760": "龙泉驿区",
        "P_YS_FED_IMP_IOT0000010431": "贡山独龙族怒族自治县",
        "P_YS_FED_IMP_IOT0000005839": "浠水县",
        "P_YS_FED_IMP_IOT0000010437": "红花岗区",
        "P_YS_SD_UDHWN_0000122549": "请输入部门",
        "P_YS_FED_IMP_IOT0000010438": "高明区",
        "P_YS_FED_IMP_IOT0000011768": "南芬区",
        "P_YS_FED_FW_0000154428": "[{\"nameType\":\"text\",\"value\":\"菜单\",\"key\":\"menu\"},{\"nameType\":\"text\",\"value\":\"权限\",\"key\":\"auth\"},{\"nameType\":\"text\",\"value\":\"按钮权限\",\"key\":\"actionAuth\"},{\"nameType\":\"text\",\"value\":\"规则\",\"key\":\"rule\"},{\"nameType\":\"text\",\"value\":\"选项\",\"key\":\"option\"},{\"nameType\":\"text\",\"value\":\"枚举\",\"key\":\"enum\"},{\"nameType\":\"text\",\"value\":\"ViewModel\",\"key\":\"viewmodel\"}]",
        "P_YS_FED_IMP_IOT0000010439": "峄城区",
        "P_YS_FI_RA_0000071633": "执行时间",
        "P_YS_FED_FW_0000116163": "确定删除当前行么",
        "P_YS_OA_XTWENKU_0000035540": "選擇日期",
        "P_YS_FED_FW_1610361428967424002": "文件类型必须为excel格式",
        "P_YS_FED_FW_0000116162": "确定删除分组么",
        "P_YS_FED_IMP_IOT0000010435": "黔西县",
        "P_YS_FED_IMP_IOT0000011767": "巨野县",
        "P_YS_FED_IMP_IOT0000011766": "沂南县",
        "P_YS_PF_SOCD_0000089128": "立陶宛",
        "P_YS_PF_SOCD_0000089125": "哥伦比亚",
        "P_YS_PF_SOCD_0000089126": "德国",
        "P_YS_PF_SOCD_0000089124": "巴林",
        "P_YS_PF_SOCD_0000089111": "挪威",
        "P_YS_FED_FW_0001647750": "<%=type%>已转入后台处理，可进行其它操作！",
        "P_YS_FED_IMP_IOT0000005825": "祁县",
        "P_YS_FED_IMP_IOT0000011772": "滑县",
        "P_YS_FED_FW_1516608649439477761": "默认是模板级设置，若用户设置了列宽或字段显隐后，便为用户级设置",
        "P_YS_FED_IMP_IOT0000011771": "汉滨区",
        "P_YS_FED_IMP_IOT0000010442": "邓州市",
        "P_YS_FED_IMP_IOT0000011774": "广平县",
        "P_YS_FED_IMP_IOT0000005826": "东丽区",
        "P_YS_FED_IMP_IOT0000011773": "君山区",
        "P_YS_FED_FW_1516608649439477764": "点击”恢复默认”则恢复到模板级设置",
        "P_YS_FED_IMP_IOT0000005829": "宜良县",
        "P_YS_FED_IMP_IOT0000005828": "永泰县",
        "P_YS_FED_IMP_IOT0000011779": "洞头县",
        "P_YS_FED_FW_1427569433243549702": "行标题不可为空。",
        "P_YS_FED_IMP_IOT0000005821": "吉隆县",
        "P_YS_FED_IMP_IOT0000010444": "黑山县",
        "P_YS_FED_IMP_IOT0000005820": "本溪满族自治县",
        "P_YS_FED_IMP_IOT0000011775": "措勤县",
        "P_YS_FED_IMP_IOT0000010446": "旬邑县",
        "P_YS_FED_IMP_IOT0000005822": "始兴县",
        "P_YS_FED_IMP_IOT0000010447": "临海市",
        "P_YS_FED_IMP_IOT0000011777": "四会市",
        "P_YS_FED_FW_0000154412": "〖当前租户类型〗：",
        "P_YS_FED_IMP_IOT0000008099": "扎赉特旗",
        "P_YS_PF_SOCD_0000089116": "纳米比亚",
        "P_YS_FED_IMP_IOT0000008096": "龙里县",
        "P_YS_PF_SOCD_0000089117": "特立尼达和多巴哥",
        "P_YS_FED_IMP_IOT0000008097": "凭祥市",
        "P_YS_OA_XTWENKU_0000035553": "上传完成",
        "P_YS_PF_SOCD_0000089114": "阿根廷",
        "P_YS_PF_SOCD_0000089115": "摩尔多瓦",
        "P_YS_FED_FW_0001647748": "共处理<%=totalCount%>条数据，成功<%=sucessCount%>条数据，失败<%=failCount%>条数据。",
        "P_YS_FED_FW_0000154413": "〖客户端原始协议类型〗：",
        "P_YS_FED_FW_0001647749": "最多只展示<%=count%>条数据，查看更多请点击右上角按钮【<%=title%>】",
        "P_YS_FED_FW_0000154414": "〖当前系统客户端类型〗：",
        "P_YS_PF_SOCD_0000089113": "直布罗陀",
        "P_YS_PF_SOCD_0000089141": "土耳其",
        "P_YS_FED_FW_1457429918499995648": "最多只可输入",
        "P_YS_PF_SOCD_0000089142": "芬兰",
        "P_YS_FED_IMP_IOT0000008094": "正蓝旗",
        "P_YS_FED_IMP_IOT0000008095": "黎城县",
        "P_YS_FED_FW_0000154450": "内容区宽度",
        "P_YS_FED_IMP_IOT0000008093": "运河区",
        "P_YS_FED_IMP_IOT0000005813": "江华瑶族自治县",
        "P_YS_SD_UDHWN_0000048262": "蓟县",
        "P_YS_FED_IMP_IOT0000005818": "南华县",
        "P_YS_FED_IMP_IOT0000011781": "象山区",
        "P_YS_FED_IMP_IOT0000005819": "安国市",
        "P_YS_FED_IMP_IOT0000010450": "建宁县",
        "P_YS_FED_IMP_IOT0000010459": "永春县",
        "P_YS_SD_UDHWN_0001009945": "%d 分钟",
        "P_YS_FED_IMP_IOT0000005810": "莒县",
        "P_YS_SD_UDHWN_0001008617": "保持选择",
        "P_YS_FED_IMP_IOT0000010456": "方正县",
        "P_YS_SD_UDHWN_0001009949": "1 天",
        "P_YS_FED_IMP_IOT0000010457": "绍兴县",
        "P_YS_FED_IMP_IOT0000011789": "狮子山区",
        "P_YS_FED_IMP_IOT0000005811": "苍梧县",
        "P_YS_FED_IMP_IOT0000008088": "绥滨县",
        "P_YS_PF_SOCD_0000089149": "圭亚那",
        "P_YS_FED_IMP_IOT0000008085": "峡江县",
        "P_YS_PF_PRINT_0000056908": "表头自定义项24",
        "P_YS_FED_IMP_IOT0000008086": "贵溪市",
        "P_YS_SD_SDOC_0000165986": "提交失败",
        "P_YS_PF_PRINT_0000056906": "表头自定义项20",
        "P_YS_PF_PRINT_0000056905": "表头自定义项21",
        "P_YS_PF_SOCD_0000089145": "比利时",
        "P_YS_FED_IMP_IOT0000008089": "灵璧县",
        "P_YS_FI_ETL_0000111612": "引用参照",
        "P_YS_PF_SOCD_0000089133": "所罗门群岛",
        "P_YS_PF_SOCD_0000089130": "英国",
        "P_YS_FI_CM_0000029140": "九月",
        "P_YS_PF_PRINT_0000056911": "表头自定义项22",
        "P_YS_PF_SOCD_0000089131": "马耳他",
        "P_YS_PF_PRINT_0000056910": "表头自定义项23",
        "P_YS_FED_FW_0001097815": "当前访问的是高德地图API，公网才能访问，专属化环境访问不到",
        "P_YS_FED_IMP_IOT0000005803": "息烽县",
        "P_YS_FED_IMP_IOT0000010463": "达坂城区",
        "P_YS_FED_IMP_IOT0000010464": "皋兰县",
        "P_YS_FED_IMP_IOT0000011796": "富裕县",
        "P_YS_FED_IMP_IOT0000011795": "霍城县",
        "P_YS_FED_IMP_IOT0000005807": "洛川县",
        "P_YS_FED_IMP_IOT0000011790": "澜沧拉祜族自治县",
        "P_YS_FED_IMP_IOT0000005809": "松阳县",
        "P_YS_FED_IMP_IOT0000011792": "庆安县",
        "P_YS_FED_IMP_IOT0000005808": "嘉陵区",
        "P_YS_FED_IMP_IOT0000011791": "古浪县",
        "P_DIWORK_YC_ORDER_0000061269": "未关闭",
        "P_YS_FED_IMP_IOT0000011797": "秀城区",
        "P_YS_SD_SDOC_0000163330": "交易完成",
        "P_YS_FED_IMP_IOT0000005801": "宣威市",
        "P_YS_FED_IMP_IOT0000010468": "天台县",
        "P_YS_FED_IMP_IOT0000011799": "曲周县",
        "P_YS_FED_IMP_IOT0000008076": "拜泉县",
        "P_YS_CRM_CRM-FE_0001319951": "交易类型:",
        "P_YS_PF_SOCD_0000089138": "加蓬",
        "P_YS_FED_IMP_IOT0000008074": "濉溪县",
        "P_YS_FED_IMP_IOT0000008075": "蚌山区",
        "P_YS_PF_SOCD_0000089136": "马尔代夫",
        "P_YS_PF_PRINT_0000056917": "是否隐藏",
        "P_YS_OA_XTWENKU_0000035536": "下載",
        "P_YS_PF_SOCD_0000089137": "意大利",
        "P_YS_PF_SOCD_0000089134": "瑞士",
        "P_YS_PF_SOCD_0000089135": "奥地利",
        "P_YS_FI_ETL_0000111601": "新增公式",
        "P_YS_PF_SOCD_0000089165": "阿曼",
        "P_YS_FED_FW_0001318684": "存在重复行，第",
        "P_YS_FED_FW_1570959055392342017": "网络开小差了，请稍后再试",
        "P_YS_FED_IMP_IOT0000008072": "宁强县",
        "P_YS_FED_IMP_IOT0000008073": "红河县",
        "P_YS_FED_IMP_IOT0000008070": "溪湖区",
        "P_YS_OA_XTWENKU_0000035509": "文件名",
        "P_YS_FED_IMP_IOT0000010475": "黄埔区",
        "P_YS_FED_IMP_IOT0000010476": "蔚县",
        "P_YS_FED_IMP_IOT0000010471": "濮阳县",
        "P_YS_FED_IMP_IOT0000010472": "四方区",
        "P_YS_FED_IMP_IOT0000010477": "满城县",
        "P_YS_FED_IMP_IOT0000010479": "鄯善县",
        "P_YS_PF_SOCD-E_0000277718": "多米尼加共和国",
        "P_YS_FED_IMP_IOT0000009396": "上蔡县",
        "P_YS_FED_IMP_IOT0000009397": "临武县",
        "P_YS_SD_UDHWN_0000121240": "共计：",
        "P_YS_FED_IMP_IOT0000009395": "唐海县",
        "P_YS_FED_FW_1570959055392342020": "服务出错了，请稍后再试",
        "P_YS_PF_SOCD_0000089169": "卢森堡",
        "P_YS_FED_IMP_IOT0000008069": "米易县",
        "P_YS_PF_SOCD_0000089167": "巴基斯坦",
        "P_YS_FED_IMP_IOT0000008067": "武穴市",
        "P_YS_FED_IMP_IOT0000009398": "南丹县",
        "P_YS_FED_IMP_IOT0000008068": "龙门县",
        "P_YS_PF_SOCD_0000089155": "巴巴多斯",
        "P_YS_PF_SOCD_0000089152": "利比亚",
        "P_YS_PF_SOCD_0000089153": "叙利亚",
        "P_YS_PF_SOCD_0000089150": "索马里",
        "P_YS_FED_IMP_IOT0000008061": "婺源县",
        "P_YS_FED_IMP_IOT0000009392": "黄龙县",
        "P_YS_PF_SOCD_0000089151": "埃及",
        "P_YS_FED_IMP_IOT0000009393": "深圳",
        "P_YS_FED_IMP_IOT0000008060": "辽阳县",
        "P_YS_FED_IMP_IOT0000009391": "广南县",
        "P_YS_FED_FW_1587381824922845184": "已勾选“移动端展现”，请设置移动端布局？",
        "P_YS_FED_IMP_IOT0000010480": "江北区",
        "P_YS_FED_IMP_IOT0000010481": "颍上县",
        "P_YS_FED_FW_0000154455": "navbar,点击左侧返回图标的回调",
        "P_YS_FED_IMP_IOT0000009385": "霸州市",
        "P_YS_FED_FW_0000154456": "卡片页",
        "P_YS_FED_FW_0000154453": "显示数据为空",
        "P_YS_FED_IMP_IOT0000009383": "清徐县",
        "P_YS_FED_FW_0000154454": "列表高度",
        "P_YS_FED_IMP_IOT0000008053": "乌伊岭区",
        "P_YS_PF_SOCD_0000089158": "阿尔巴尼亚",
        "P_YS_FED_IMP_IOT0000008058": "石柱土家族自治县",
        "P_YS_FED_IMP_IOT0000009389": "蒸湘区",
        "P_YS_PF_SOCD_0000089159": "蒙古",
        "P_YS_FED_IMP_IOT0000008059": "彝良县",
        "P_YS_FED_FW_0001215524": "]的",
        "P_YS_PF_SOCD_0000089156": "爱尔兰",
        "P_YS_FED_FW_0000154457": "内容区高度",
        "P_YS_PF_SOCD_0000089187": "墨西哥",
        "P_YS_FED_FW_1563508103188054030": "%c check前后[childrenField][index][cellName]=>",
        "P_YS_PF_SOCD_0000089188": "危地马拉",
        "P_YS_PF_SOCD_0000089185": "以色列",
        "P_YS_FED_FW_1462036124903407616": "点此编辑长内容",
        "P_YS_PF_SOCD_0000089183": "汤加",
        "P_YS_PF_SOCD_0000089184": "吉布提",
        "P_YS_FED_FW_1563508103188054033": "%c 当前操作列和check触发源是同一个字段，触发target为",
        "P_YS_PF_SOCD_0000089181": "安哥拉",
        "P_YS_OA_XTWENKU_0000035608": "模糊搜索",
        "P_YS_FED_FW_1563508103188054036": "的公式",
        "P_YS_PF_SOCD_0000089182": "库克群岛",
        "P_YS_FED_IMP_IOT0000010375": "范县",
        "P_YS_FED_IMP_IOT0000010376": "古塔区",
        "P_YS_FED_IMP_IOT0000010372": "望奎县",
        "P_YS_ZNBZ_BZBX-FE_0001141299": "借款合同",
        "P_YS_FED_IMP_IOT0000010378": "和田市",
        "P_YS_FED_FW_1563508103188054027": "字段都无值，不触发target为",
        "P_YS_FED_IMP_IOT0000008165": "删除",
        "P_YS_FED_IMP_IOT0000009496": "托克托县",
        "P_YS_FED_IMP_IOT0000008162": "确认要删除吗 ?",
        "P_YS_FED_IMP_IOT0000008163": "桃源县",
        "P_YS_FED_IMP_IOT0000008168": "连山壮族瑶族自治县",
        "P_YS_PF_SOCD_0000089189": "希腊",
        "P_YS_FED_IMP_IOT0000009497": "鹤峰县",
        "P_YS_PF_SOCD_0000089177": "利比里亚",
        "P_YS_PF_SOCD_0000089174": "尼泊尔",
        "P_YS_PF_SOCD_0000089175": "罗马尼亚",
        "P_YS_FED_FW_1563508103188054042": "%c 公式中没有因子，触发target为",
        "P_YS_PF_SOCD_0000089172": "哥斯达黎加",
        "P_YS_FED_IMP_IOT0000008160": "翠峦区",
        "P_YS_PF_SOCD_0000089173": "法属圭亚那",
        "P_YS_FED_IMP_IOT0000008161": "天镇县",
        "P_YS_FED_IMP_IOT0000009492": "阜南县",
        "P_YS_PF_SOCD_0000089170": "古巴",
        "P_YS_PF_SOCD_0000089171": "黎巴嫩",
        "P_YS_SD_URETAILF_0001131470": "请输入搜索",
        "P_YS_FED_IMP_IOT0000009490": "宁县",
        "P_YS_FED_IMP_IOT0000010385": "金乡县",
        "P_YS_SD_UDHBI_0000082840": "数据异常",
        "P_YS_FED_IMP_IOT0000010383": "石渠县",
        "P_YS_FED_FW_0001318710": ")项",
        "P_YS_PF_GZTTMP_0000079419": "上一页",
        "P_YS_FED_FW_0001318704": "<%=count%>单",
        "P_YS_FED_IMP_IOT0000008153": "三元区",
        "P_YS_FED_IMP_IOT0000009484": "增城市",
        "P_YS_FED_IMP_IOT0000008154": "仁寿县",
        "P_YS_FED_IMP_IOT0000009485": "色达县",
        "P_YS_FED_IMP_IOT0000008151": "白朗县",
        "P_YS_FED_IMP_IOT0000009482": "安福县",
        "P_YS_FED_IMP_IOT0000009483": "南乐县",
        "P_YS_FED_FW_1563508103188054039": "%c 字段触发check，check前值为:",
        "P_YS_FED_IMP_IOT0000008157": "矿区",
        "P_YS_OA_XTWENKU_0000035613": "正在上传",
        "P_YS_FED_IMP_IOT0000009489": "光泽县",
        "P_YS_PF_SOCD_0000089178": "几内亚",
        "P_YS_FED_IMP_IOT0000009486": "定陶县",
        "P_YS_FED_IMP_IOT0000008156": "东方",
        "P_YS_FED_IMP_IOT0000009487": "简阳市",
        "P_YS_FED_IMP_IOT0000010391": "获嘉县",
        "P_YS_FED_IMP_IOT0000009480": "永定县",
        "P_YS_FED_IMP_IOT0000008150": "大英县",
        "P_YS_FED_IMP_IOT0000010396": "市中区",
        "P_YS_FED_IMP_IOT0000010397": "宜丰县",
        "P_YS_FED_IMP_IOT0000010392": "祁阳县",
        "P_YS_FED_IMP_IOT0000010393": "周村区",
        "P_YS_FED_FW_0000021498": "堆叠条形图示例",
        "P_YS_FI_YYFI-UI_0000161175": "发起讨论",
        "P_YS_FED_FW_0001197167": "扫码编辑",
        "P_YS_FED_FW_0000021499": "重置",
        "P_YS_FED_IMP_IOT0000008143": "瓮安县",
        "P_YS_FED_FW_0000021496": "临汾市",
        "P_YS_FED_FW_0000021497": "岳阳市",
        "P_YS_FED_IMP_IOT0000008141": "港闸区",
        "P_YS_FED_IMP_IOT0000008146": "珙县",
        "P_YS_FED_IMP_IOT0000008144": "楚雄市",
        "P_YS_PF_SOCD_0000089198": "保加利亚",
        "P_YS_PF_SOCD_0000089199": "匈牙利",
        "P_YS_FED_FW_1577614631207698483": "请输入URL",
        "P_YS_FED_FW_1563508103188054021": "%c 公式中表体字段公式等于表头，触发target为",
        "P_YS_PF_SOCD_0000089194": "亚美尼亚",
        "P_YS_FED_FW_1577614631207698480": "请输入链接文本",
        "P_YS_PF_SOCD_0000089195": "捷克",
        "P_YS_FED_FW_1563508103188054024": "字段值不一样，触发target为",
        "P_YS_PF_SOCD_0000089191": "阿富汗",
        "P_YS_ZNBZ_BZBX-FE_0001141291": "合同审批",
        "P_YS_ZNBZ_BZBX-FE_0001141295": "抵/质押合同",
        "P_YS_FED_IMP_IOT0000008137": "武川县",
        "P_YS_FED_IMP_IOT0000008138": "永仁县",
        "P_YS_FED_IMP_IOT0000009469": "特克斯县",
        "P_YS_FED_FW_1563508103188054018": "字段值一样，不触发target为",
        "P_YS_FED_IMP_IOT0000008130": "双江拉祜族佤族布朗族傣族自治县",
        "P_YS_FED_IMP_IOT0000009461": "赤坎区",
        "P_YS_FED_FW_1576845857814216711": "业务阶段未结束，不允许打印！",
        "P_YS_FED_IMP_IOT0000009464": "仙游县",
        "P_YS_SCM_STOCK_0001145534": "编辑行",
        "P_YS_FED_IMP_IOT0000008128": "瑞金市",
        "P_YS_FED_IMP_IOT0000009459": "偏关县",
        "P_YS_FED_IMP_IOT0000008129": "桐庐县",
        "P_YS_FED_EXAMP_0000020397": "姓名",
        "P_YS_FED_EXAMP_0000020396": "套餐商品未录入完毕,不允许执行优惠券",
        "P_YS_FED_EXAMP_0000020399": "请继续支付",
        "P_YS_FED_EXAMP_0000020398": "应收金额:",
        "P_YS_FED_IMP_IOT0000009451": "围场满族蒙古族自治县",
        "P_YS_FED_IMP_IOT0000008121": "竹溪县",
        "P_YS_FED_IMP_IOT0000009452": "夏邑县",
        "P_YS_FED_IMP_IOT0000009455": "金东区",
        "P_YS_FED_IMP_IOT0000009456": "崂山区",
        "P_YS_FED_IMP_IOT0000009453": "竹山县",
        "P_YS_FED_IMP_IOT0000008123": "巴南区",
        "P_YS_FED_IMP_IOT0000008117": "金山屯区",
        "P_YS_FED_IMP_IOT0000009448": "东湖区",
        "P_YS_FED_FW_0001084598": "cStyle解析错误:",
        "P_YS_FED_IMP_IOT0000009446": "顺平县",
        "P_YS_FED_IMP_IOT0000009447": "邯山区",
        "P_YS_FED_IMP_IOT0000008119": "点军区",
        "P_YS_FED_IMP_IOT0000008113": "金平苗族瑶族傣族自治县",
        "P_YS_FED_IMP_IOT0000009442": "玉州区",
        "P_YS_FED_IMP_IOT0000008112": "北宁市",
        "P_YS_FI_FIEFA-FE_1498230827983044620": "观看视频",
        "P_YS_FED_FW_0001083281": "渲染异常，可通过控制台查看异常信息!",
        "P_YS_FED_IMP_IOT0000008106": "井研县",
        "P_YS_FED_IMP_IOT0000009437": "嘉善县",
        "P_YS_FED_IMP_IOT0000008104": "石峰区",
        "P_YS_FED_IMP_IOT0000009435": "南谯区",
        "P_YS_FED_IMP_IOT0000009436": "高唐县",
        "P_YS_FED_IMP_IOT0000008108": "小店区",
        "P_YS_FI_AP_0000072097": "凭证日期",
        "P_YS_FED_IMP_IOT0000009430": "乌拉特前旗",
        "P_YS_FED_IMP_IOT0000008102": "萧山区",
        "P_YS_FED_IMP_IOT0000008103": "乌兰县",
        "P_YS_FED_IMP_IOT0000009431": "乌达区",
        "P_YS_FED_IMP_IOT0000008101": "宏伟区",
        "P_YS_FED_FW_0001260928": "列表共",
        "P_YS_FED_IMP_IOT0000009427": "东明县",
        "P_YS_FED_FW_0001260926": "枚举：值对象配置，比如表示性别的字段，有固定的值配置和选择范围，包括男、女。",
        "P_YS_FED_FW_0001260927": "参照：用来确认引用关系定义。比如：采购订单上的管理组织字段，表示的是该字段选择的数据范围为对应组织档案的内容。（是系统已存在的启用状态下的数据，需在系统内查找进行填写）",
        "P_YS_FED_IMP_IOT0000009429": "梁园区",
        "P_YS_FED_IMP_IOT0000009423": "临邑县",
        "P_YS_FED_FW_1495277402289340422": "保存成功，未做任何修改",
        "P_YS_FED_IMP_IOT0000009421": "华容县",
        "P_YS_FED_FW_1581884103568916483": "协作助手",
        "P_YS_PF_PROCENTER_0000023382": "银行卡",
        "P_YS_IMP_PCC-UI_0001116011": "卡片头部",
        "P_YS_FED_FW_0000021440": "晋城市",
        "P_YS_FED_EXAMP_0000020360": "资金收付",
        "P_YS_FED_EXAMP_0000020362": "请选择SKU的值",
        "P_YS_FED_EXAMP_0000020361": "当前网络不可用，不能销售序列号管理的商品！",
        "P_YS_FED_FW_0001312565": "列配置有问题，可能会导致打印内容错误!",
        "P_YS_FED_EXAMP_0000020357": "请求服务地址有误!",
        "P_YS_FED_IMP_IOT0000009415": "旌阳区",
        "P_YS_FED_FW_1423240990981357568": "这是最后一条数据啦, 没有更多数据了",
        "P_YS_FED_IMP_IOT0000009416": "马鞍山",
        "P_YS_FED_EXAMP_0000020356": "该卡号已经录入, 请勿重复录入",
        "P_YS_FED_FW_0000021438": "添加图片",
        "P_YS_FED_EXAMP_0000020359": "当前操作员无删行权限！是否使用其他 操作员的删行权限？",
        "P_YS_FED_IMP_IOT0000009413": "吉州区",
        "P_YS_FED_FW_0000021439": "----------- 点击事件 选择区域 params.name =",
        "P_YS_FED_EXAMP_0000020358": "原因码",
        "P_YS_FED_IMP_IOT0000009414": "长阳土家族自治县",
        "P_YS_FED_EXAMP_0000020353": "调拨待出",
        "P_YS_FED_IMP_IOT0000009419": "汤旺河区",
        "P_YS_FED_EXAMP_0000020352": "储值卡售卡不允许修改数量",
        "P_YS_FED_EXAMP_0000020355": "现场折扣",
        "P_YS_FED_IMP_IOT0000009417": "城中区",
        "P_YS_FED_EXAMP_0000020354": "测试成功",
        "P_YS_FED_FW_0000021432": "截断后：",
        "P_YS_FED_FW_0000021433": "区域经理模板",
        "P_YS_SD_UDHMC_0000051023": "÷",
        "P_YS_FED_FW_0000021430": "录入不合法~",
        "P_YS_FED_FW_0000021431": "排名表配置信息-eChartSetting",
        "P_YS_FED_FW_0000021436": "云南",
        "P_YS_FED_FW_0000021437": "结束日期",
        "P_YS_FED_FW_0000021434": "广西",
        "P_YS_FED_FW_0000021435": "肇庆市",
        "P_YS_FED_FW_0000021450": "商品详情",
        "P_YS_FED_FW_0000021451": "（",
        "P_YS_FED_FW_1555410955943804936": "服务出错了，别担心，刷新试试吧~",
        "P_YS_FED_EXAMP_0000020371": "],请检查!",
        "P_YS_FED_EXAMP_0000020370": "个规格)",
        "P_YS_FED_EXAMP_0000020373": "商品规格",
        "P_YS_FED_EXAMP_0000020372": "POS退款失败",
        "P_YS_FED_FW_1502799547894071302": "无效数据，请从新选择数据",
        "P_YS_FED_EXAMP_0000020368": "硬件适配方案未启用储值卡",
        "P_YS_FED_IMP_IOT0000009404": "盘山县",
        "P_YS_FED_IMP_IOT0000009405": "太湖县",
        "P_YS_FED_FW_0000021449": "苏州市",
        "P_YS_FED_EXAMP_0000020369": "验证成功",
        "P_YS_FED_IMP_IOT0000009403": "凤台县",
        "P_YS_FED_EXAMP_0000020363": "是否需要厨打？",
        "P_YS_FED_IMP_IOT0000009409": "隆回县",
        "P_YS_FED_FW_1452018122265460736": "导出错误原因",
        "P_YS_FED_EXAMP_0000020366": "序列号商品行的序列号不能为空,请检查!",
        "P_YS_FED_IMP_IOT0000009406": "富阳市",
        "P_YS_FED_EXAMP_0000020365": "商城未上架",
        "P_YS_FED_IMP_IOT0000009407": "乌拉特中旗",
        "P_YS_FED_FW_0000021443": "济南市",
        "P_YS_FED_FW_0000021444": "图",
        "P_YS_FED_FW_0000021441": "白城市",
        "P_YS_FED_FW_0000021442": "大庆市",
        "P_YS_OA_XTLCZX_0000030897": "收藏成功",
        "P_YS_FED_FW_0000021447": "巴中市",
        "P_YS_FED_FW_0000021448": "铜仁市",
        "P_YS_FED_FW_0000021445": "新余市",
        "P_YS_FED_FW_0000021446": "已收款完毕",
        "P_YS_FED_FW_0000110058": "设置交叉点的editRowModel时，不能从为gridModel缓存中获取EditRowModel_2D",
        "P_YS_FED_EXAMP_0000020382": "比率小数位",
        "P_YS_FED_EXAMP_0000020381": "原单退货",
        "P_YS_FED_EXAMP_0000020384": "支付失败，需撤销杉德支付。执行线上撤销？",
        "P_YS_FED_EXAMP_0000020383": "请输入",
        "P_YS_FED_EXAMP_0000020380": "余额",
        "P_YS_FED_FW_0000021418": "白银市",
        "P_YS_FED_EXAMP_0000020379": ")改型说明必输！",
        "P_YS_FED_FW_0000021419": "成功删除",
        "P_YS_FED_EXAMP_0000020378": "子件商品不允许执行现场折扣",
        "P_YS_FED_FW_0000021416": "折线图配置信息-eChartSetting",
        "P_YS_FED_FW_0000021417": "南平市",
        "P_YS_FED_EXAMP_0000020375": "已退订",
        "P_YS_FED_EXAMP_0000020374": "抹零金额不正确，请检查抹零金额！预计抹零金额为：",
        "P_YS_FED_EXAMP_0000020377": "等于",
        "P_YS_FED_EXAMP_0000020376": "支付金额不相等",
        "P_YS_FED_FW_0001527931": "包含同级",
        "P_YS_FED_FW_0000021410": "eChartCommon 更新过滤条件，去除里面的空值 before param =",
        "P_YS_FED_FW_0000021411": "绥化市",
        "P_YS_FED_FW_1431347776103383040": "确认要删除",
        "P_YS_FED_FW_0000021414": "海东地区",
        "P_YS_FED_FW_1431347776103383043": "嘛",
        "P_YS_FED_FW_0000021415": "移动报表  isVertical =",
        "P_YS_FED_FW_0000021412": "排名",
        "P_YS_FED_FW_0000021413": "梅州市",
        "P_YS_FED_EXAMP_0000020393": "套餐中有未选择的商品",
        "P_YS_FED_EXAMP_0000020392": "现制",
        "P_YS_FED_EXAMP_0000020395": "搜索",
        "P_YS_FED_EXAMP_0000020394": "全部",
        "P_YS_FED_EXAMP_0000020391": "加载中...",
        "P_YS_FED_FW_0000021429": "呼和浩特市",
        "P_YS_FED_EXAMP_0000020389": "已有充值或消费记录, 不能退卡",
        "P_YS_FED_FW_0000021427": "图表不能正常显示，需要 report/getGroupSetting(获取报表分组方案的详细设置进行显示) 返回的配置信息中 json.data.isCrossTable == false && (json.data.displayStyle == 2 || json.data.displayStyle == 3)",
        "P_YS_FED_FW_0000021428": "拉萨市",
        "P_YS_FED_EXAMP_0000020386": "已经执行了促销活动，不允许执行积分抵扣！",
        "P_YS_FED_EXAMP_0000020385": "取消",
        "P_YS_FED_EXAMP_0000020388": "(我自己)",
        "P_YS_FED_EXAMP_0000020387": "查询商品失败",
        "P_YS_FED_FW_0000021421": "景德镇市",
        "P_YS_FED_FW_0000021422": "巴音郭楞蒙古自治州",
        "P_YS_FED_FW_0000110072": "所有信息-一维表数据 getRows  length =",
        "P_YS_FED_FW_0000110073": "所有信息-二维表数据 getRows  length =",
        "P_YS_FED_FW_0000021420": "邯郸市",
        "P_YS_FED_FW_0000021425": "山南地区",
        "P_YS_FED_FW_0000021426": "汉中市",
        "P_YS_FED_FW_0000021423": "竖",
        "P_YS_FED_FW_0000021424": "看板配置信息-模块配置-日期时间",
        "P_YS_FED_FW_0000021480": "玉林市",
        "P_YS_FED_FW_0001515920": "三列布局右",
        "P_YS_FED_FW_0001515921": "头像上传",
        "P_YS_FED_FW_0001515922": "按单表头",
        "P_YS_FED_FW_0000021483": "濮阳市",
        "P_YS_FED_FW_0000021484": "气泡值",
        "P_YS_FED_FW_0000021481": "条保存失败",
        "P_YS_FED_FW_0000021482": "基本信息",
        "P_YS_FED_EXAMP_0000020313": ",请重新选择时间！",
        "P_YS_FED_EXAMP_0000020312": "相应退货productId下的rowkey",
        "P_YS_FED_EXAMP_0000020315": "生成卡券号范围失败,请检查",
        "P_YS_FED_EXAMP_0000020314": "销售日期不可大于当前日期。",
        "P_YS_FED_EXAMP_0000020311": ";房型:",
        "P_YS_FED_EXAMP_0000020310": "有识别到的商品在商品档案没匹配到!",
        "P_YS_FED_FW_0000021476": "山西",
        "P_YS_FED_FW_0001515916": "卡片面板",
        "P_YS_FED_FW_0000021477": "白山市",
        "P_YS_FED_FW_0001515917": "固定按钮",
        "P_YS_FED_FW_0000021474": "韶关市",
        "P_YS_FED_FW_0001515918": "列表拓展项",
        "P_YS_FED_FW_0000021475": "选择日期",
        "P_YS_FED_FW_0001515919": "头部导航",
        "P_YS_FED_EXAMP_0000020317": "开始卡券号和结束卡券号必须同时录入",
        "P_YS_FED_FW_0001515912": "试图切换",
        "P_YS_FED_EXAMP_0000020316": "该门店未启用储值卡业务",
        "P_YS_FED_FW_0001515913": "html片段",
        "P_YS_FED_FW_0000021478": "双鸭山市",
        "P_YS_FED_EXAMP_0000020319": "请输入密码",
        "P_YS_FED_FW_0001515914": "三列布局中",
        "P_YS_FED_FW_0000021479": "黄山市",
        "P_YS_OA_XTLCZX_0000030846": "发起协作",
        "P_YS_FED_EXAMP_0000020318": "号",
        "P_YS_FED_FW_0001515915": "高德地图",
        "P_YS_FED_FW_0000021490": "三门峡市",
        "P_YS_FED_FW_0000021491": "成都市",
        "P_YS_FED_FW_0001515910": "metaui-mobile组件库",
        "P_YS_FED_FW_0001515911": "ys按钮",
        "P_YS_FED_FW_0000021494": "福建",
        "P_YS_FED_FW_0000021495": "深圳市",
        "P_YS_FED_FW_0000021492": "IDB_saveData存储操作成功，事务失败！",
        "P_YS_SD_SDMBF_0000141915": "今",
        "P_YS_FED_FW_0000021493": "呼伦贝尔市",
        "P_YS_FED_EXAMP_0000020324": "展开剩余",
        "P_YS_PF_YHTTNT-FE_0001045613": "所在行",
        "P_YS_FED_EXAMP_0000020323": "已经执行了商品促销/秒杀，不能录入会员！",
        "P_YS_FED_EXAMP_0000020326": "中关村店",
        "P_YS_FED_EXAMP_0000020325": "批发价",
        "P_YS_FED_EXAMP_0000020320": "同马店",
        "P_YS_FED_FW_0001515909": "图片展示",
        "P_YS_FED_EXAMP_0000020322": "权限管理维度",
        "P_YS_FED_EXAMP_0000020321": "售卡",
        "P_YS_FED_FW_0000021487": "乐山市",
        "P_YS_FED_FW_0000021488": "广安市",
        "P_YS_FED_FW_0001515906": "ys固定按钮",
        "P_YS_FED_FW_0000021485": "阜新市",
        "P_YS_FED_FW_0001515907": "卡片头部组",
        "P_YS_FED_FW_0000021486": "南京市",
        "P_YS_FED_FW_0001515908": "扫码子表",
        "P_YS_FED_EXAMP_0000020328": "状态",
        "P_YS_FED_EXAMP_0000020327": "已经执行了促销活动，不允许执行现场折扣！",
        "P_YS_FED_FW_0000021489": "镇江市",
        "P_YS_FED_FW_1587986667977310214": "获取推拉按钮的信息失败",
        "P_YS_FED_EXAMP_0000020329": "微信回调失败：【接口】",
        "P_YS_FED_FW_0001515941": "ys主按钮",
        "P_YS_FED_FW_0001515942": "三列布局",
        "P_YS_FED_FW_0001078769": "字段元数据配置错误！",
        "P_YS_FED_FW_0001515943": "附件按钮",
        "P_YS_FED_FW_0000021461": "昌吉回族自治州",
        "P_YS_FED_FW_0000021462": "最多可上传",
        "P_YS_FED_FW_0000021460": "黔南布依族苗族自治州",
        "P_YS_FED_FW_0001515940": "列表表头",
        "P_YS_FED_EXAMP_0000020340": "当前行营业员“",
        "P_YS_FED_EXAMP_0000020334": "选择",
        "P_YS_FED_EXAMP_0000020337": "会员钱包充值",
        "P_YS_FED_EXAMP_0000020336": "数量字段请录入小于零的数字。",
        "P_YS_FED_EXAMP_0000020331": "没有商品地址",
        "P_YS_FED_FW_1505489468750561282": "长度限制",
        "P_YS_FED_EXAMP_0000020330": "),不得低于当前操作员工费折扣率下限(",
        "P_YS_FED_EXAMP_0000020333": "该商品行不允许执行退品！",
        "P_YS_FED_EXAMP_0000020332": "当前折扣率为(",
        "P_YS_FED_FW_0000021454": "淄博市",
        "P_YS_FED_FW_0001515938": "扫码区域",
        "P_YS_FED_FW_0000021455": "表体数据为空！不允许保存！",
        "P_YS_OA_XTLCZX_0000030866": "发起协作流程",
        "P_YS_FED_FW_0001515939": "卡片面板项",
        "P_YS_FED_FW_0000021452": "）",
        "P_YS_FED_FW_0000021453": "宿迁市",
        "P_YS_FED_FW_0000021458": "盐城市",
        "P_YS_FED_EXAMP_0000020339": "当前退货行存在对应的换货行，不能删除!",
        "P_YS_FED_FW_0001515934": "ys子表页签",
        "P_YS_FED_FW_0000021459": "阜阳市",
        "P_YS_FED_EXAMP_0000020338": "子件商品不允许执行退品！",
        "P_YS_FED_FW_0001515935": "ys附件按钮",
        "P_YS_FED_FW_0000021456": "看板配置信息-模块配置-常用功能",
        "P_YS_FED_FW_0001515936": "日历面板",
        "P_YS_FED_FW_0000021457": "中油一建",
        "P_YS_FED_FW_0001515937": "按单子表",
        "P_YS_FED_FW_0001515930": "纯文字项",
        "P_YS_FED_FW_0001515931": "日期下拉分组",
        "P_YS_FED_FW_0001515932": "ys卡片头部",
        "P_YS_FED_FW_0001515933": "链接(拨打电话)",
        "P_YS_FED_FW_0000021472": "模板C",
        "P_YS_FED_FW_0000021473": "张",
        "P_YS_FED_FW_0000021470": "荆门市",
        "P_YS_FED_FW_0000021471": "和田地区",
        "P_YS_FED_EXAMP_0000020351": "现销充值",
        "P_YS_FED_EXAMP_0000020350": "找零",
        "P_YS_FED_EXAMP_0000020345": "请选择",
        "P_YS_FED_EXAMP_0000020348": "启用效期管理的表体行,有效期至不能为空!",
        "P_YS_FED_EXAMP_0000020347": "网络不可用，密码必须与上次登录相同",
        "P_YS_OA_XTSPZX_0000034785": "確定",
        "P_YS_FED_EXAMP_0000020344": "否",
        "P_YS_FED_EXAMP_0000020343": "营",
        "P_YS_FED_FW_0000021465": "模板A",
        "P_YS_FED_FW_0001515927": "身份证上传",
        "P_YS_FED_FW_0000021466": "模板D",
        "P_YS_FED_FW_0001515928": "三列布局左",
        "P_YS_FED_FW_0000021463": "请输入商品条码",
        "P_YS_SD_UDHBI_0000032531": "订单",
        "P_YS_FED_FW_0001515929": "页面区域",
        "P_YS_FED_FW_0000021464": "防城港市",
        "P_YS_FED_FW_0000021469": "模板B",
        "P_YS_FED_FW_0001515923": "ys图片展示",
        "P_YS_FED_EXAMP_0000020349": "选择客户",
        "P_YS_FED_FW_0001515924": "多页签切换",
        "P_YS_FED_FW_0000021467": "模板E",
        "P_YS_FED_FW_0001515925": "列表参照",
        "P_YS_FED_FW_0000021468": "甘南藏族自治州",
        "P_YS_FED_FW_0001515926": "扫码框",
        "P_YS_FED_FW_1478297498195329033": "获取数据模板列表失败",
        "P_YS_FED_FW_1478297498195329030": "暂无模板数据～",
        "P_YS_FED_UIMG_0000082816": "只读状态不可进行删除操作",
        "P_YS_ZNBZ_BZBX-MFE_0001618094": "未保存",
        "P_YS_OA_YBMOB_0000036918": "开始",
        "P_YS_FED_FW_0001207667": "单据助手",
        "P_YS_FED_IMP_IOT0000005795": "玛曲县",
        "P_YS_FED_IMP_IOT0000005794": "东洲区",
        "P_YS_FED_IMP_IOT0000005797": "瑶海区",
        "P_YS_FED_FW_0001309650": "(已选择<%placeholder%>条)",
        "P_YS_FED_IMP_IOT0000005793": "德城区",
        "P_YS_FED_IMP_IOT0000005792": "翔安区",
        "P_YS_IMP_DFM-UI_0001095230": "容器",
        "P_YS_OA_app_xtywlj_0000037585": "表达式",
        "P_YS_FED_IMP_IOT0000005789": "宁阳县",
        "P_YS_FED_IMP_IOT0000005782": "梁子湖区",
        "P_YS_FED_FW_0001388453": "文本域录入框换行",
        "P_YS_FED_IMP_IOT0000005775": "北川羌族自治县",
        "P_YS_FED_IMP_IOT0000005777": "元江哈尼族彝族傣族自治县",
        "P_YS_FED_IMP_IOT0000005776": "乐业县",
        "P_YS_FED_IMP_IOT0000005779": "美兰区",
        "P_YS_FED_FW_0001045499": "十八",
        "P_YS_FED_FW_0001045497": "十七",
        "P_YS_FED_FW_0001045498": "十五",
        "P_YS_FED_FW_0001237484": "该订单中存在校验失败项，可以点击查看",
        "P_YS_FED_IMP_IOT0000005769": "礼县",
        "P_YS_SCM_PU_0000028333": "请先选择仓库！",
        "P_YS_OA_XTWENKU_0000035495": "修改時間",
        "P_YS_FED_IMP_IOT0000005765": "薛城区",
        "P_YS_PF_GZTORG_0000035405": "修改时间",
        "P_YS_FED_IMP_IOT0000005750": "陈巴尔虎旗",
        "P_YS_FED_IMP_IOT0000005753": "霍州市",
        "P_YS_FED_IMP_IOT0000011606": "星子县",
        "P_YS_FED_IMP_IOT0000005752": "班玛县",
        "P_YS_FED_IMP_IOT0000011605": "图们市",
        "P_YS_FED_IMP_IOT0000005755": "回民区",
        "P_YS_FED_IMP_IOT0000005757": "寿宁县",
        "P_YS_FED_IMP_IOT0000011602": "振安区",
        "P_YS_FED_IMP_IOT0000005756": "甘州区",
        "P_YS_FED_IMP_IOT0000011609": "宿豫区",
        "P_YS_FED_FW_0001045496": "十三",
        "P_YS_FED_FW_1442544300594823168": "吗 ?",
        "P_YS_FED_IMP_IOT0000005749": "巴马瑶族自治县",
        "P_YS_FED_IMP_IOT0000005740": "舒兰市",
        "P_YS_FED_IMP_IOT0000011615": "福贡县",
        "P_YS_FED_IMP_IOT0000005742": "玉屏侗族自治县",
        "P_YS_FED_IMP_IOT0000011616": "襄汾县",
        "P_YS_FED_FW_1497426122910466048": "参照扩展脚本加载异常",
        "P_YS_FED_IMP_IOT0000011610": "贵定县",
        "P_YS_FED_IMP_IOT0000011613": "东阿县",
        "P_YS_PF_WORKBENCH-FE_0001133350": "用友集团",
        "P_YS_FED_FW_0000022095": "ю",
        "P_YS_FED_FW_0000022096": "я",
        "P_YS_FED_FW_0000022093": "ь",
        "P_YS_FED_FW_0000022094": "э",
        "P_YS_FED_FW_0000022099": "小于",
        "P_YS_FED_FW_0000022097": "替换",
        "P_YS_FED_FW_0000022098": "热区显示图 在CStyle中未能找到全部的热区配置字段 codeField stateField captionFields mapConfigField",
        "P_YS_FED_FW_1520473424212262918": "卡片展示",
        "P_YS_FED_IMP_IOT0000005737": "安化县",
        "P_YS_FED_IMP_IOT0000005739": "大邑县",
        "P_YS_FED_IMP_IOT0000011620": "彭阳县",
        "P_YS_FED_FW_0000022091": "ы",
        "P_YS_FED_FW_0000022092": "请填写正确的邮箱号",
        "P_YS_FED_FW_0000022090": "模版",
        "P_YS_FED_UCFBASEDOC_0000024807": "密码登录",
        "P_YS_MF_PO-FE_0001156335": "是否取消？",
        "P_YS_FED_IMP_IOT0000005733": "从化市",
        "P_YS_FED_IMP_IOT0000005732": "泗县",
        "YS_YC_PORTAL-FE_1122935812": "创建人：",
        "P_YS_FED_IMP_IOT0000005728": "阿图什市",
        "P_YS_FED_IMP_IOT0000010305": "永安市",
        "P_YS_FED_IMP_IOT0000011637": "汉沽区",
        "P_YS_FED_IMP_IOT0000011636": "高密市",
        "P_YS_FED_IMP_IOT0000005720": "文圣区",
        "P_YS_FED_IMP_IOT0000011639": "平昌县",
        "P_YS_FED_IMP_IOT0000011638": "青铜峡市",
        "P_YS_FED_IMP_IOT0000005721": "连江县",
        "P_YS_FED_IMP_IOT0000011632": "仙居县",
        "P_YS_FED_FW_0000096305": "图片必须小于",
        "P_YS_FED_FW_0000096304": "M，图片仅支持JPG、PNG、BMP、GIF格式",
        "P_YS_FED_FW_0000096303": "(每张图片大小不可超过",
        "P_YS_FED_FW_0000096302": "（每个附件大小不可超过",
        "P_YS_FED_FW_0000096300": "是否确认删除此附件？",
        "P_YS_FED_IMP_IOT0000010309": "枝江市",
        "P_YS_PF_GZTORG_0000035435": "采购组织",
        "P_YS_FED_FW_0000022073": "о",
        "P_YS_FED_FW_0001077912": "条件配置错误",
        "P_YS_FED_FW_0000022074": "п",
        "P_YS_FED_FW_0000022071": "暂无附件~",
        "P_YS_FED_FW_0000022072": "н",
        "P_YS_FED_FW_0000022077": "с",
        "P_YS_FED_FW_0000022078": "т",
        "P_YS_FED_FW_0000022075": "р",
        "P_YS_FED_FW_0000022076": "基础行操作",
        "P_YS_FED_IMP_IOT0000011640": "叠彩区",
        "P_YS_FED_IMP_IOT0000005714": "滦县",
        "P_YS_FED_IMP_IOT0000011642": "枞阳县",
        "P_YS_FED_IMP_IOT0000005716": "阿尔山市",
        "P_YS_FED_IMP_IOT0000010311": "延寿县",
        "P_YS_FED_FW_0000022070": "м",
        "P_YS_FED_IMP_IOT0000010316": "大祥区",
        "P_YS_FED_IMP_IOT0000011648": "深泽县",
        "P_YS_FED_IMP_IOT0000010317": "潼关县",
        "P_YS_FED_IMP_IOT0000010318": "前进区",
        "P_YS_FED_IMP_IOT0000010319": "鄞州区",
        "P_YS_SD_SDSD-FE_0001486556": "備註",
        "P_YS_FED_IMP_IOT0000005710": "德格县",
        "P_YS_FED_IMP_IOT0000011646": "花都区",
        "P_YS_FED_FW_1588736741075845125": "已选数据项不能为空，请先添加再保存",
        "P_YS_FED_FW_0000022068": "堆叠条形图",
        "P_YS_FED_FW_0000022069": "л",
        "P_YS_PF_GZTSYS_0000011944": "自定义项设置",
        "P_YS_FED_FW_0000022084": "ч",
        "P_YS_FED_FW_0000022085": "ш",
        "P_YS_FED_FW_0000022082": "х",
        "P_YS_FED_FW_0000022083": "ц",
        "P_YS_FED_FW_0000022088": "大屏方案 设计 info",
        "P_YS_FED_FW_0000022089": "ъ",
        "P_YS_FED_FW_0000022086": "通过气泡大小显示数量信息",
        "P_YS_FED_FW_0000022087": "щ",
        "P_YS_FED_IMP_IOT0000005704": "珠山区",
        "P_YS_FED_IMP_IOT0000010320": "宁江区",
        "P_YS_FED_IMP_IOT0000011650": "东山县",
        "P_YS_FED_IMP_IOT0000005706": "岑溪市",
        "P_YS_FED_IMP_IOT0000010321": "西畴县",
        "P_YS_FED_IMP_IOT0000005705": "什邡市",
        "P_YS_FED_FW_0000022080": "у",
        "P_YS_FED_FW_0000022081": "ф",
        "P_YS_FED_IMP_IOT0000005707": "平江县",
        "P_YS_FED_IMP_IOT0000005709": "南靖县",
        "P_YS_FED_IMP_IOT0000011658": "宁河县",
        "P_YS_FED_IMP_IOT0000010329": "陆丰市",
        "P_YS_FED_FW_1540539167842238469": "保存新建方案",
        "P_YS_PF_GZTSYS_0000011952": "商品分类",
        "P_YS_FED_IMP_IOT0000011655": "上甘岭区",
        "P_YS_FED_IMP_IOT0000011657": "下陆区",
        "P_YS_FED_FW_0000022079": "最大化",
        "P_YS_FI_CM_0000029252": "警告",
        "P_YS_PF_ANALYTIC-FE_0001651222": "近15天",
        "P_YS_FED_IMP_IOT0000011662": "湘阴县",
        "P_YS_FED_IMP_IOT0000010332": "大通区",
        "P_YS_FED_IMP_IOT0000011660": "漳平市",
        "P_YS_FED_IMP_IOT0000010338": "务川仡佬族苗族自治县",
        "P_YS_FI_RA_0000071535": "空值",
        "P_YS_FED_IMP_IOT0000011666": "科尔沁右翼前旗",
        "P_YS_FED_FW_0001249401": "为必,请输入后重试",
        "P_YS_FED_IMP_IOT0000011665": "眉县",
        "P_YS_FED_FW_0001249400": "不合法，请修改后重试",
        "P_YS_FED_IMP_IOT0000010336": "兴县",
        "P_YS_FED_IMP_IOT0000009297": "师宗县",
        "P_YS_FED_IMP_IOT0000009299": "海沧区",
        "P_YS_FI_YYFI-UI_0000167698": "其他入库单列表区域",
        "P_YS_OA_LCGL_0000037077": "模版类型",
        "P_YS_FED_FW_1624915715923902472": "表头+明显",
        "P_YS_FED_IMP_IOT0000009290": "德惠市",
        "P_YS_FED_FW_0001025027": "请检查SERVER_ENV配置是否正确",
        "P_YS_FI_CM_0000029260": "数据视图",
        "P_YS_FED_IMP_IOT0000010341": "比如县",
        "P_YS_FED_IMP_IOT0000011673": "鼓楼区",
        "P_YS_FED_IMP_IOT0000010344": "交口县",
        "P_YS_FED_IMP_IOT0000011674": "科尔沁右翼中旗",
        "P_YS_FED_IMP_IOT0000011671": "延平区",
        "P_YS_SD_SDMA_0000122990": "获取失败",
        "P_YS_FED_IMP_IOT0000010340": "解放区",
        "P_YS_OA_XTTMCENTER_0000035125": "编号",
        "P_YS_FED_IMP_IOT0000010349": "古丈县",
        "P_YS_FED_IMP_IOT0000010346": "定海区",
        "P_YS_FED_IMP_IOT0000010347": "伊金霍洛旗",
        "P_YS_FED_IMP_IOT0000011678": "东台市",
        "P_YS_FED_IMP_IOT0000009286": "晋宁县",
        "P_YS_FED_FW_0001025032": "表格参照",
        "P_YS_FED_IMP_IOT0000009284": "道外区",
        "P_YS_FED_IMP_IOT0000009285": "环江毛南族自治县",
        "P_YS_FED_IMP_IOT0000009289": "刚察县",
        "P_YS_FED_IMP_IOT0000009282": "下关区",
        "P_YS_FED_IMP_IOT0000009283": "南岸区",
        "P_YS_FED_IMP_IOT0000011684": "达孜县",
        "P_YS_FED_IMP_IOT0000011683": "长顺县",
        "P_YS_FED_FW_0001065929": "refEntity.extendField 不是标准的json字符串",
        "P_YS_FED_IMP_IOT0000010354": "浪卡子县",
        "P_YS_FED_IMP_IOT0000011686": "源城区",
        "P_YS_FED_IMP_IOT0000011685": "望江县",
        "P_YS_FED_IMP_IOT0000011680": "城北区",
        "P_YS_FED_IMP_IOT0000010350": "成都",
        "P_YS_FED_FW_0001065923": ",输入小数精度由",
        "P_YS_FED_FW_0001065924": ",输入小数精度为",
        "P_YS_FED_FW_0001065921": "最多允许输入15位，目前整数长度为",
        "P_YS_FED_FW_0001065922": "位改为",
        "P_YS_FED_IMP_IOT0000011688": "青川县",
        "P_YS_FED_IMP_IOT0000010357": "茂县",
        "P_YS_FED_IMP_IOT0000011687": "庐山区",
        "P_YS_FED_FW_0001065925": "暂时没有数据~",
        "P_YS_FED_FW_0001065926": "元数据协议错误",
        "P_YS_FED_FW_0001200151": "不允许上传以下类型的文件:",
        "P_YS_FED_IMP_IOT0000009276": "东兴区",
        "P_YS_FED_IMP_IOT0000009279": "左贡县",
        "P_YS_FED_FW_1536081971023183878": "打印模板图片地址为空,无法打印,请联系工作人员排查",
        "P_YS_FED_IMP_IOT0000009272": "昌邑区",
        "P_YS_FED_IMP_IOT0000009270": "东兰县",
        "P_YS_FED_IMP_IOT0000010363": "耀州区",
        "P_YS_FED_IMP_IOT0000010364": "虎丘区",
        "P_YS_FED_IMP_IOT0000011697": "改则县",
        "P_YS_FED_IMP_IOT0000011696": "云和县",
        "P_YS_FED_IMP_IOT0000011691": "邻水县",
        "P_YS_FED_IMP_IOT0000010360": "微山县",
        "P_YS_FED_IMP_IOT0000011692": "英德市",
        "P_YS_PF_GZTSYS_0000011991": "标签分组",
        "P_YS_OA_LCGL_0000037083": "未完成",
        "P_YS_FED_IMP_IOT0000011699": "剑河县",
        "P_YS_FED_IMP_IOT0000011698": "宣恩县",
        "P_YS_FED_IMP_IOT0000010369": "会同县",
        "P_YS_FED_IMP_IOT0000009264": "浦口区",
        "P_YS_FED_IMP_IOT0000009262": "孝昌县",
        "P_YS_SD_URETAIL_0001048944": "%%db错误日志%%【",
        "P_YS_FED_FW_0001389709": "取余",
        "P_YS_FED_IMP_IOT0000009269": "红岗区",
        "P_YS_FED_FW_0001389708": "切换查询方式",
        "P_YS_FED_IMP_IOT0000009266": "尉氏县",
        "P_YS_SD_SDMA_0000062743": "注册",
        "P_YS_PF_PRINT_0000056946": "表头自定义项14",
        "P_YS_PF_PRINT_0000056943": "表头自定义项10",
        "P_YS_FED_FW_0000022011": "小票打印",
        "P_YS_FED_IMP_IOT0000008050": "清涧县",
        "P_YS_FED_IMP_IOT0000009381": "阿合奇县",
        "P_YS_FED_FW_0000022012": "2维表行列变化异常，没有列类型t2DColType。data=",
        "P_YS_FED_IMP_IOT0000008051": "勉县",
        "P_YS_FED_FW_0000022010": "未知控件",
        "P_YS_FED_IMP_IOT0000009380": "和田县",
        "P_YS_FED_IMP_IOT0000010254": "钟山区",
        "P_YS_FED_IMP_IOT0000010256": "诸城市",
        "P_YS_FED_IMP_IOT0000011586": "洮北区",
        "P_YS_FED_IMP_IOT0000011583": "肥乡县",
        "P_YS_FED_FW_0001077975": "控件崩溃!",
        "P_YS_FED_FW_1585773806330314768": "范围值精度不允许为负值，请修改",
        "P_YS_FED_IMP_IOT0000010257": "淮阳县",
        "P_YS_FED_IMP_IOT0000010258": "磐安县",
        "P_YS_FED_IMP_IOT0000010259": "芗城区",
        "P_YS_FED_FW_0000022004": "查看",
        "P_YS_FED_IMP_IOT0000008043": "桦川县",
        "P_YS_SD_UDHWS_0000066531": "主计量数量",
        "P_YS_FED_FW_0000022005": "报表分组方案配置信息-图表Arr",
        "P_YS_FED_FW_0000022002": "大屏轮播：没有找到能够展示的大屏。模板ID",
        "P_YS_FED_IMP_IOT0000008041": "囊谦县",
        "P_YS_FED_IMP_IOT0000009372": "南岳区",
        "P_YS_SD_UDHWN_0000047815": "分页",
        "P_YS_FED_FW_0000022003": "请选择行再进行下移操作！",
        "P_YS_FED_IMP_IOT0000008042": "彰武县",
        "P_YS_FED_IMP_IOT0000009373": "牙克石市",
        "P_YS_FED_FW_0000022008": "热区显示图  通过返回的数据集获取 mapConfig 。 mapConfig",
        "P_YS_FED_IMP_IOT0000008047": "新都区",
        "P_YS_FED_IMP_IOT0000009378": "鹤山市",
        "P_YS_FED_FW_0000022009": "批量操作",
        "P_YS_PF_PRINT_0000056949": "表头自定义项12",
        "P_YS_FED_FW_0000022006": "eChartDisplay 散点图地图信息正确    return",
        "P_YS_FED_IMP_IOT0000009376": "翼城县",
        "P_YS_FED_FW_0000022007": "月触发一次",
        "P_YS_FED_IMP_IOT0000008046": "称多县",
        "P_YS_FED_IMP_IOT0000009377": "金阳县",
        "P_YS_PF_PRINT_0000056947": "表头自定义项13",
        "P_YS_PF_PRINT_0000056956": "表头自定义项18",
        "P_YS_FED_IMP_IOT0000011590": "贵南县",
        "P_YS_FED_FW_0000022022": "请输入别名代码",
        "P_YS_FED_IMP_IOT0000009370": "伊川县",
        "P_YS_FED_FW_0000022023": "筛选排序",
        "P_YS_FED_FW_0000022020": "eChartDisplay状态改变 shouldComponentUpdate Begin",
        "P_YS_FED_FW_0000022021": "支持上传10M以下png/jpg格式的图片",
        "P_YS_PF_PRINT_0000056950": "表头自定义项11",
        "P_YS_FED_IMP_IOT0000011596": "罗源县",
        "P_YS_FED_IMP_IOT0000010265": "北塔区",
        "P_YS_FED_IMP_IOT0000011595": "杂多县",
        "P_YS_FED_IMP_IOT0000010266": "易县",
        "P_YS_FED_IMP_IOT0000010267": "肇源县",
        "P_YS_FED_IMP_IOT0000011597": "东山区",
        "P_YS_FED_IMP_IOT0000011591": "卧龙区",
        "P_YS_FED_IMP_IOT0000011594": "石城县",
        "P_YS_SCM_USTOCK-UI_0000173671": "增组",
        "P_YS_FED_IMP_IOT0000009369": "枣强县",
        "P_YS_FED_FW_0001381042": "每张图片大小不可超过50M, 支持格式:JPG、PNG等",
        "P_YS_FED_FW_0001381041": "图片管理",
        "P_YS_FED_FW_1600567391678889987": "UI模板名称:",
        "P_YS_FED_FW_1600567391678889984": "UI模板tplid:",
        "P_YS_FED_FW_0000022015": "确定删除此模版么？",
        "P_YS_FED_IMP_IOT0000008032": "金沙县",
        "P_YS_FED_FW_0000022016": "报表方案已发布。",
        "P_YS_FED_IMP_IOT0000008033": "武胜县",
        "P_YS_FED_IMP_IOT0000009364": "九里区",
        "P_YS_FED_FW_0000022013": "保存失败",
        "P_YS_FED_FW_0000022014": "刷新频率",
        "P_YS_FED_IMP_IOT0000009362": "华容区",
        "P_YS_FED_FW_0000022019": "搜索无结果",
        "P_YS_FED_IMP_IOT0000009367": "永宁县",
        "P_YS_FED_IMP_IOT0000008037": "奉化市",
        "P_YS_FED_FW_0000022017": "输入的数字不能小于",
        "P_YS_FED_IMP_IOT0000008034": "白碱滩区",
        "P_YS_FED_FW_0000022018": "展示指标",
        "P_YS_FED_IMP_IOT0000009366": "魏都区",
        "P_YS_PF_PRINT_0000056958": "表头自定义项17",
        "P_YS_PF_PRINT_0000056924": "出库组织",
        "P_YS_FED_FW_0001344099": "可录入单元格中“Z”字形顺次跳转",
        "P_YS_SCM_USTOCK-UI_0001025485": "必输，请精确到sku",
        "P_YS_FED_FW_0001344095": "空格键",
        "P_YS_FED_IMP_IOT0000009360": "开鲁县",
        "P_YS_FED_FW_0001344096": "新增 (空白单据/档案)",
        "P_YS_FED_FW_0001344097": "打开光标所在位置的参照对话框",
        "P_YS_FED_FW_0001344098": "表头分组展开与收起",
        "P_YS_FED_IMP_IOT0000010275": "远安县",
        "P_YS_FED_FW_0001344091": "可录入单元格中“Z”字形逆向跳转",
        "P_YS_FED_FW_0001344092": "表格内焦点快速跳转",
        "P_YS_FED_FW_0001344093": "↑;↓;←;→",
        "P_YS_FED_FW_0001344094": "↑/↓",
        "P_YS_FED_IMP_IOT0000010271": "芒康县",
        "P_YS_FED_IMP_IOT0000010273": "德化县",
        "P_YS_FED_FW_0001344090": "参照弹窗",
        "P_YS_FED_FW_1422515029828173824": "请录入关键字搜索",
        "P_YS_FED_IMP_IOT0000008028": "丹寨县",
        "P_YS_FED_IMP_IOT0000009359": "凌云县",
        "P_YS_FED_UCFBASEDOC_0000024749": "敏感数据权限",
        "P_YS_FED_IMP_IOT0000010279": "扶风县",
        "P_YS_SD_URETAIL_0001048852": "==>>db日志调用点【changeTable】【",
        "P_YS_FED_IMP_IOT0000009352": "积石山保安族东乡族撒拉族自治县",
        "P_YS_FED_IMP_IOT0000009350": "大荔县",
        "P_YS_FED_IMP_IOT0000008020": "临河市",
        "P_YS_FED_IMP_IOT0000008025": "汶川县",
        "P_YS_FED_IMP_IOT0000008026": "城口县",
        "P_YS_FED_IMP_IOT0000009357": "峨山彝族自治县",
        "P_YS_FED_IMP_IOT0000008023": "赞皇县",
        "P_YS_FED_IMP_IOT0000008024": "金溪县",
        "P_YS_FED_IMP_IOT0000009355": "淳安县",
        "P_YS_FED_FW_0001344088": "参照表格焦点上移 / 下移",
        "P_YS_FED_FW_0001154596": "导入文件大小不能大于",
        "P_YS_FED_FW_0001344089": "底部操作栏",
        "P_YS_FED_IMP_IOT0000010281": "义马市",
        "P_YS_FED_FW_0000022000": "消息内容",
        "P_YS_FED_FW_0001344084": "下拉面板中焦点上移 / 下移",
        "P_YS_FED_FW_0000022001": "宽度/高度",
        "P_YS_FED_FW_0001344085": "表头与表体区域间循环跳转",
        "P_YS_FED_FW_0001344086": "表单录入",
        "P_YS_FED_FW_0001344087": "参照弹窗执行“确定”操作",
        "P_YS_FED_IMP_IOT0000010286": "侯马市",
        "P_YS_FED_IMP_IOT0000010288": "深州市",
        "P_YS_FED_IMP_IOT0000010289": "西塞山区",
        "P_YS_FED_IMP_IOT0000008018": "会宁县",
        "P_YS_FED_IMP_IOT0000009349": "伊春区",
        "P_YS_FED_IMP_IOT0000008019": "恒山区",
        "P_YS_FED_IMP_IOT0000008016": "盈江县",
        "P_YS_FED_IMP_IOT0000009347": "晴隆县",
        "P_YS_FED_IMP_IOT0000009341": "利川市",
        "P_YS_FED_IMP_IOT0000008011": "保康县",
        "P_YS_FED_IMP_IOT0000009342": "通江县",
        "P_YS_FED_IMP_IOT0000008014": "北湖区",
        "P_YS_FED_IMP_IOT0000008015": "原州区",
        "P_YS_FED_IMP_IOT0000009346": "武冈市",
        "P_YS_FED_IMP_IOT0000009343": "琅琊区",
        "P_YS_FED_FW_0000022051": "启",
        "P_YS_FED_FW_0000022052": "а",
        "P_YS_FED_FW_0000022050": "大屏方案 设计 getDesignColType_Chart curCol",
        "P_YS_FED_IMP_IOT0000010292": "万山特区",
        "P_YS_FED_FW_0000022055": "请输入...",
        "P_YS_FED_FW_0000022056": "в",
        "P_YS_FED_FW_0000022053": "只显示已选",
        "P_YS_FED_FW_0000022054": "б",
        "P_YS_FED_IMP_IOT0000010297": "任城区",
        "P_YS_FED_IMP_IOT0000010298": "雨城区",
        "P_YS_FED_IMP_IOT0000010293": "绛县",
        "P_YS_FED_FW_1545658640009003030": "您好，“增加”按钮不支持表体“1对多”类型的取值方式，请使用高级设计器设置，如：“高级设计器-字段设置”、“高级设计器-公式”。",
        "P_YS_FED_IMP_IOT0000010296": "沧浪区",
        "P_YS_TBS_TBS-FE_0001148975": "南海诸岛",
        "P_YS_FED_IMP_IOT0000008008": "仁布县",
        "P_YS_FED_IMP_IOT0000009339": "台山市",
        "P_YS_FED_UCFBASEDOC_0000024727": "审核",
        "P_YS_FED_IMP_IOT0000008009": "麻城市",
        "P_YS_FED_FW_0000022048": "升序",
        "P_YS_FED_FW_0000022049": "过滤类型",
        "P_YS_FED_IMP_IOT0000008000": "赣榆县",
        "P_YS_FED_FW_0000022046": "匹配一维表的行时，有多个匹配行，请检查。 valueArr =",
        "P_YS_SD_URETAIL_0001048876": "==>>db日志调用点【存储元数据】【",
        "P_YS_FED_FW_0000022047": "订阅条件",
        "P_YS_FED_IMP_IOT0000009334": "阳朔县",
        "P_YS_FED_IMP_IOT0000008004": "定州市",
        "P_YS_FED_IMP_IOT0000009335": "延长县",
        "P_YS_FED_IMP_IOT0000008001": "榆树市",
        "P_YS_FED_IMP_IOT0000008002": "渭滨区",
        "P_YS_FED_FW_0000022062": "з",
        "P_YS_PF_SOCD_0000089099": "巴西",
        "P_YS_FED_FW_0000022063": "是否<%=abandonText%>?",
        "P_YS_FED_FW_0000022060": "е",
        "P_YS_FED_FW_0000022061": "ж",
        "P_YS_FED_FW_0000022066": "没有找着用户id，请确认",
        "P_YS_FED_FW_0000022067": "к",
        "P_YS_PF_PRINT_0000056996": "行号",
        "P_YS_FED_FW_0000022064": "暂无数据",
        "P_YS_FED_FW_0000022065": "й",
        "P_YS_FED_FW_1588671285764292613": "已勾选“移动端展现”，请设置移动端布局!",
        "P_YS_SD_SDMAUF_0000152989": "已失效",
        "P_YS_FI_RA_0000071482": "id为",
        "P_YS_FED_IMP_IOT0000009327": "朔城区",
        "P_YS_FED_IMP_IOT0000009325": "沈河区",
        "P_YS_FED_IMP_IOT0000009329": "锦屏县",
        "P_YS_FED_FW_0000022059": "模版名称更改",
        "P_YS_FED_UCFBASEDOC_0000024712": "保存并新增",
        "P_YS_FED_FW_0000022057": "г",
        "P_YS_FED_FW_0000022058": "д",
        "P_YS_FED_IMP_IOT0000009324": "汤阴县",
        "P_YS_FED_IMP_IOT0000009321": "宜君县",
        "P_YS_FED_FW_0000022030": "校验成功",
        "P_YS_FED_FW_1545658640009003012": "selectFiled--要查询的字段",
        "P_YS_FED_FW_0000022033": "请设置solutionId",
        "P_YS_FED_FW_1545658640009003015": "1.打开高级设计器，选中表体，右边属性区点击“字段设置”按钮，在弹窗左边树上，查询到目标字段拖到列表，最后保存。",
        "P_YS_FED_FW_0000022034": "仅支持",
        "P_YS_PF_PRINT_0000056963": "表头自定义项15",
        "P_YS_FED_FW_0000022031": "标题字体大小设置不正确",
        "P_YS_FED_FW_0000022032": "eChartDisplay 没有传入 chartDisplayType ，请检查",
        "P_YS_PF_PRINT_0000056961": "表头自定义项16",
        "P_YS_FED_IMP_IOT0000009314": "铜鼓县",
        "P_YS_FED_UCFBASEDOC_0000024708": "角色描述",
        "P_YS_FED_IMP_IOT0000009315": "大足县",
        "P_YS_FED_IMP_IOT0000009319": "青县",
        "P_YS_FED_FW_0000022026": "档案值不可为空。",
        "P_YS_FED_UCFBASEDOC_0000024701": "出库仓库和入库仓库不可以相同！",
        "P_YS_FED_FW_0000022027": "2维表行数 =",
        "P_YS_FED_FW_0000022024": "上移当前行",
        "P_YS_FED_FW_0000022025": "保留外层间距",
        "P_YS_FED_IMP_IOT0000009312": "于田县",
        "P_YS_FED_FW_0000022028": "模版组织名称",
        "P_YS_FED_FW_0000022029": "每日",
        "P_YS_FED_IMP_IOT0000009311": "越秀区",
        "P_YS_FED_FW_0000022040": "向下",
        "P_YS_FED_FW_0000022041": "运算符",
        "P_YS_FED_FW_1545658640009003021": "conditionField--条件字段",
        "P_YS_FED_FW_0000022044": "添加公告",
        "P_YS_FED_FW_0000022045": "增加物料",
        "P_YS_SD_UDHWN_0000047803": "定安县",
        "P_YS_SD_UDHBN_0000032639": "内容",
        "P_YS_FED_FW_1545658640009003027": "fullName--档案的uri",
        "P_YS_FED_FW_0000022042": "饼形图",
        "P_YS_PF_PRINT_0000056973": "出库仓库",
        "P_YS_FED_FW_1545658640009003024": "conditionValue--条件值",
        "P_YS_FED_FW_0000022043": "您输入的地址有误，请填写正确的地址",
        "P_YS_PF_PRINT_0000056970": "表头自定义项19",
        "P_YS_FED_IMP_IOT0000009307": "金平区",
        "P_YS_FED_IMP_IOT0000009308": "措美县",
        "P_YS_FED_FW_0000022037": "PC端展现",
        "P_YS_FED_FW_0001025097": "是否确定恢复默认？",
        "P_YS_FED_FW_0000022038": "大屏方案 Save editPanel",
        "P_YS_FED_FW_0000022035": "默认模板",
        "P_YS_FED_FW_0000022036": "请输入联系人电话",
        "P_YS_FED_FW_1545658640009003018": "2.设置公式-业务函数",
        "P_YS_FED_IMP_IOT0000009302": "固镇县",
        "P_YS_FED_FW_0000022039": "大屏轮播：请检查当前操作员是否有模板权限",
        "P_YS_OA_YBMOB_0000036998": "撤回成功",
        "P_YS_FED_FW_0001045501": "十四",
        "P_YS_FED_FW_0001045500": "十六",
        "P_YS_FED_FW_0001473539": "请输入网址名称",
        "P_YS_PF_METADATA_0001040427": "产地",
        "P_YS_FED_FW_0001071829": "带有navbar的表格参照或者树参照",
        "P_YS_FED_FW_0001071827": "带有navbar和确认按钮等树参照",
        "P_YS_FED_FW_0001071828": "头部返回回调",
        "P_YS_FED_FW_0001473541": "请配置弹窗类型fromType",
        "P_YS_SD_SDSD-FE_0001491115": "金額",
        "P_YS_FED_FW_0001473540": "组织存在未生效的变更，不支持停用，请在生效后或删除未生效的变更，再次操作。",
        "P_YS_SD_SDMB_0000146962": "返回顶部",
        "P_YS_FED_FW_0001344079": "快捷键帮助",
        "P_YS_PF_PROCENTER_0000023062": "其他",
        "P_YS_FED_FW_0001034888": "定标",
        "P_YS_SD_SDMA_0000125113": "总部",
        "P_YS_OA_YBMOB_0000036941": "审批历史",
        "P_YS_FED_FW_1551057439648907272": "参照配置错误: 未返回参照数据唯一值",
        "P_YS_PF_PROCENTER_0000023057": "库存单位",
        "P_YS_SD_SDMAF_0000136181": "条件：",
        "P_YS_SD_UDHWN_0000047879": "东方市",
        "P_YS_FED_FW_0001534303": "搜索字段设置",
        "P_YS_FED_FW_0001648230": "失败行号",
        "P_YS_FED_FW_0001662538": "请输入关键字或者选择分类",
        "P_YS_FED_UCFBASEDOC_0000024789": "删除中...",
        "P_YS_FI_YYFI-UI_0001152516": "手动关闭",
        "P_YS_FED_UCFBASEDOC_0000024782": "操作失败",
        "P_YS_FED_FW_0001219575": "<%=text%>不能为空",
        "P_YS_PF_PRINT_0000065042": "物料编码",
        "P_YS_FED_FW_1497279621567610881": "请点击录入框右侧图标，补充其他语种名称",
        "P_YS_FI_CM_0000029334": "下午",
        "P_YS_FED_FW_1422567557278203904": "数据处理中，请稍后...",
        "P_YS_FED_IMP_IOT0000005698": "靖安县",
        "P_YS_FED_IMP_IOT0000005697": "五常市",
        "P_YS_SD_UDHWN_0000120970": "无标题",
        "P_YS_SD_UDHWN_0001008893": "圈选",
        "P_YS_FED_IMP_IOT0000005692": "抚松县",
        "P_YS_FED_FW_0001411240": "值改变搜索",
        "P_YS_SD_UDHWN_0001008897": "纵向选择",
        "P_YS_FED_FW_0001045594": "是否确认<%=params.cShowCaption%>此记录",
        "P_YS_FED_FW_0001045595": "确定删除栏目【<%=text%>】么？",
        "P_YS_FED_FW_0001045593": "确定要删除<%=text%>么?",
        "P_YS_PF_GZTPRE_0001381653": "事件监听",
        "P_YS_FI_FCWEB_0001131731": "打印",
        "P_YS_PF_PROCENTER_0000023090": "采购",
        "P_YS_SCM_PU_0000028400": "已关闭",
        "P_YS_FED_IMP_IOT0000005684": "资源县",
        "P_YS_FED_IMP_IOT0000005687": "湘东区",
        "P_YS_FED_IMP_IOT0000005683": "鼎湖区",
        "P_YS_FED_IMP_IOT0000005676": "陈仓区",
        "P_YS_FED_IMP_IOT0000005679": "息县",
        "P_YS_FED_FW_0001248291": "复原",
        "P_YS_FED_IMP_IOT0000005672": "湛河区",
        "P_YS_PES_PES-FE_0001231284": "未选择",
        "P_YS_FED_IMP_IOT0000005663": "民权县",
        "P_YS_FED_IMP_IOT0000006993": "秦皇岛",
        "P_YS_FED_IMP_IOT0000005662": "维西傈僳族自治县",
        "P_YS_FED_IMP_IOT0000005664": "江汉区",
        "P_YS_FED_IMP_IOT0000006995": "兖州市",
        "P_YS_FED_FW_0001273232": "系统级模板不可修改栏目",
        "P_YS_FED_FW_0001094529": "%c未处理的类型",
        "P_YS_FED_IMP_IOT0000006998": "安宁市",
        "P_YS_FED_IMP_IOT0000005666": "平江区",
        "P_YS_FED_IMP_IOT0000006997": "滴道区",
        "P_YS_FED_IMP_IOT0000006999": "默认筛选",
        "P_YS_FED_IMP_IOT0000005660": "石家庄",
        "P_YS_FED_FW_0001345200": "查询区渲染成功，默认方案数据为空",
        "P_YS_FED_FW_0001345201": "查询区渲染完成",
        "P_YS_FED_FW_0001071834": "支持方法：addListener、removeListener、select",
        "P_YS_FED_FW_0001071835": "addListener、removeListener、select、unselect、setPageIndex、execute",
        "P_YS_FED_FW_0001071832": "支持方法：addListener、removeListener、",
        "P_YS_FED_FW_0001071833": "搭配params中menuId使用，portal.tabs[menuId].panes",
        "P_YS_FED_FW_0001071830": "addListener、removeListener、_set_data、select、setFocusedRowIndex、execute",
        "P_YS_FED_FW_0001071831": "支持的方法：get、getCache",
        "P_DIWORK_YC_CPU-PORTAL_0000064667": "供应商名称：",
        "P_YS_FED_IMP_IOT0000005651": "黄山区",
        "P_YS_FED_IMP_IOT0000006982": "吴桥县",
        "P_YS_FED_IMP_IOT0000005654": "集美区",
        "P_YS_FED_IMP_IOT0000006985": "墨江哈尼族自治县",
        "P_YS_FED_IMP_IOT0000005653": "阜平县",
        "P_YS_FED_IMP_IOT0000005656": "合山市",
        "P_YS_FED_IMP_IOT0000006987": "梁平县",
        "P_YS_FED_IMP_IOT0000006989": "潞城市",
        "P_YS_OA_LCGL_0000037113": "动作",
        "P_YS_FED_IMP_IOT0000006981": "连州市",
        "P_YS_SCM_USCMPUB-FE_1528671786657906690": "形状备份",
        "P_YS_FED_IMP_IOT0000005648": "高台县",
        "P_YS_FED_FW_0000083161": "调用获取配置文件接口前",
        "P_YS_FED_FW_0000083160": "调用获取配置文件接口后",
        "P_YS_FED_IMP_IOT0000005640": "灵石县",
        "P_YS_FED_IMP_IOT0000006971": "京口区",
        "P_YS_FED_IMP_IOT0000005643": "汉阳区",
        "P_YS_FED_IMP_IOT0000005645": "吉县",
        "P_YS_FED_IMP_IOT0000005644": "港北区",
        "P_YS_FED_IMP_IOT0000006975": "久治县",
        "P_YS_OA_XTTMCENTER_0000035097": "上传时间",
        "P_YS_FED_IMP_IOT0000005647": "临清市",
        "P_YS_FED_IMP_IOT0000005646": "平原县",
        "P_YS_OA_LCGL_0000037104": "激活",
        "P_YS_OA_XTTMCENTER_0000035090": "创建人",
        "P_YS_FED_FW_1581128541507420175": "休",
        "P_YS_FED_FW_1581128541507420172": "是否包含下级",
        "P_YS_FED_IMP_IOT0000005637": "曾都区",
        "P_YS_FI_CM_0000029313": "上午",
        "P_YS_FED_IMP_IOT0000005639": "青龙满族自治县",
        "P_YS_FED_FW_1541189374344953860": "正在加载数据",
        "P_YS_FED_IMP_IOT0000006961": "洪山区",
        "P_YS_FED_IMP_IOT0000006963": "茄子河区",
        "P_YS_FED_IMP_IOT0000006964": "奉新县",
        "P_YS_FED_FW_1487823486562336780": "暂无公共方案",
        "P_YS_FED_IMP_IOT0000006966": "南市区",
        "P_YS_FI_CM_0000029316": "切换为堆叠",
        "P_YS_FED_FW_1541192982117482504": "正在加载数据~",
        "P_YS_FED_FW_0001236297": "任务进度",
        "P_YS_FED_FW_0001236296": "商品码不存在",
        "P_YS_FED_IMP_IOT0000005627": "道里区",
        "P_YS_FED_IMP_IOT0000006957": "大新县",
        "P_YS_FED_IMP_IOT0000005628": "岳塘区",
        "P_YS_HR_HRPUBF_0000053688": "设置成功",
        "P_YS_FED_FW_1581128541507420169": "还有",
        "P_YS_FED_IMP_IOT0000005621": "惠来县",
        "P_YS_FED_IMP_IOT0000006952": "任丘市",
        "P_YS_FED_IMP_IOT0000006951": "顺德区",
        "P_YS_FED_IMP_IOT0000006954": "建瓯市",
        "P_YS_FED_IMP_IOT0000005624": "靖宇县",
        "P_YS_SD_SDMB_0000149198": "共计",
        "P_YS_OA_LCGL_0000037124": "组织架构",
        "P_YS_FED_FW_1487823486562336777": "暂无个人方案",
        "P_YS_FED_IMP_IOT0000005616": "将乐县",
        "P_YS_FED_IMP_IOT0000006947": "宽城满族自治县",
        "P_YS_FED_IMP_IOT0000005618": "黄陂区",
        "P_YS_FED_IMP_IOT0000006949": "独山子区",
        "P_YS_FED_IMP_IOT0000005617": "舟曲县",
        "P_YS_FED_IMP_IOT0000006948": "南城县",
        "P_YS_OA_XTTMCENTER_0000035047": "友空间",
        "P_YS_OA_LCGL_0000037152": "异常信息",
        "P_YS_FED_IMP_IOT0000005610": "邯郸县",
        "P_YS_FED_IMP_IOT0000011507": "长洲区",
        "P_YS_FED_IMP_IOT0000006940": "清丰县",
        "P_YS_FED_FW_0001249563": "取消包含",
        "P_YS_SD_SDMB_0000140730": "是否开票",
        "P_YS_FED_IMP_IOT0000005612": "荔波县",
        "P_YS_OA_XTTMCENTER_0000035043": "链接",
        "P_YS_FED_IMP_IOT0000006942": "青山区",
        "P_YS_FED_IMP_IOT0000011500": "苍溪县",
        "P_YS_FED_IMP_IOT0000005614": "达日县",
        "P_YS_FED_IMP_IOT0000006944": "西华县",
        "P_YS_FED_IMP_IOT0000011502": "施秉县",
        "P_YS_HR_HRPXF_0000056086": "导入模板下载",
        "P_YS_FED_IMP_IOT0000011508": "盐边县",
        "P_YS_FED_FW_0001026436": "«",
        "P_YS_FED_IMP_IOT0000006936": "梨树县",
        "P_YS_FED_IMP_IOT0000005604": "秦安县",
        "P_YS_FED_FW_0001249569": "不能选择小于1870-01-01的日期",
        "P_YS_FED_IMP_IOT0000005607": "齐齐哈尔",
        "P_YS_FED_IMP_IOT0000006937": "岷县",
        "P_YS_FED_IMP_IOT0000005609": "泗水县",
        "P_YS_FED_IMP_IOT0000011515": "长岭县",
        "P_YS_FED_UCFBASEDOC_0000024916": "请输入角色名称",
        "P_YS_FED_IMP_IOT0000006930": "奉节县",
        "P_YS_FED_IMP_IOT0000011518": "巴林左旗",
        "P_YS_OA_XTTMCENTER_0000035056": "更新时间",
        "P_YS_FED_IMP_IOT0000011517": "古县",
        "P_YS_FED_UCFBASEDOC_0000024914": "日结单库存日报_",
        "P_YS_FED_IMP_IOT0000005601": "韶山市",
        "P_YS_FED_IMP_IOT0000006932": "道县",
        "P_YS_FED_IMP_IOT0000011512": "渝北区",
        "P_YS_FED_UCFBASEDOC_0000024915": "最多支持100字哦！",
        "P_YS_FED_IMP_IOT0000005600": "大丰市",
        "P_YS_FED_IMP_IOT0000006934": "郁南县",
        "P_YS_FED_IMP_IOT0000011514": "曲阜市",
        "P_YS_OA_XTTMCENTER_0000035052": "请上传",
        "P_YS_FED_IMP_IOT0000006933": "都江堰市",
        "P_YS_FED_IMP_IOT0000011513": "青冈县",
        "P_YS_FED_FW_0001249571": "不能选择超过9999-12-31的日期",
        "P_YS_FED_FW_0001249570": "为必输,请输入后重试",
        "P_YS_FED_FW_0000022194": "在1维表中发现多行符合当前交叉点行列键值的数据 t2DRowKey =",
        "P_YS_FED_FW_0000022195": "是否必输",
        "P_YS_FED_FW_0000022192": "上移",
        "P_YS_FED_FW_0000022193": "请输入1-100数字",
        "P_YS_FED_FW_0000022198": "发布菜单",
        "P_YS_FED_FW_0000022199": "编辑过滤项",
        "P_YS_FED_FW_0001294823": "您没有打开此单据的权限，确认关闭页面",
        "P_YS_FED_FW_0000022197": "展开",
        "P_YS_FED_IMP_IOT0000006927": "杜尔伯特蒙古族自治县",
        "P_YS_FED_IMP_IOT0000011520": "德昌县",
        "P_YS_FED_FW_0000022190": "折线图",
        "P_YS_FED_IMP_IOT0000006929": "阳西县",
        "P_YS_FED_FW_0000022191": "请设置图形报表信息。",
        "P_YS_FED_IMP_IOT0000006928": "内丘县",
        "P_YS_FED_IMP_IOT0000011526": "怀仁县",
        "P_YS_FED_UCFBASEDOC_0000024903": "商品清单",
        "P_YS_FED_IMP_IOT0000011523": "淄川区",
        "P_YS_OA_XTTMCENTER_0000035064": "下载",
        "P_YS_FED_IMP_IOT0000006920": "博爱县",
        "P_YS_PF_GZTTMP_0000074463": "公共",
        "P_YS_SD_SDMA_0000062670": "€",
        "P_YS_FED_FW_0000022189": "底部插入行",
        "P_YS_FED_IMP_IOT0000009196": "壶关县",
        "P_YS_FED_IMP_IOT0000009197": "清新县",
        "P_YS_FED_IMP_IOT0000009190": "叶城县",
        "P_YS_FED_IMP_IOT0000009191": "盐都区",
        "P_YS_FED_IMP_IOT0000009194": "通城县",
        "P_YS_FED_IMP_IOT0000009192": "博罗县",
        "P_YS_FED_IMP_IOT0000009193": "全椒县",
        "P_YS_FED_IMP_IOT0000011530": "郾城区",
        "P_YS_FED_IMP_IOT0000006913": "岚皋县",
        "P_YS_FED_IMP_IOT0000011532": "晋江市",
        "P_YS_FED_IMP_IOT0000010200": "岭东区",
        "P_YS_FED_IMP_IOT0000006915": "江达县",
        "P_YS_FED_IMP_IOT0000010201": "大化瑶族自治县",
        "P_YS_FED_IMP_IOT0000011531": "庐阳区",
        "P_YS_FED_IMP_IOT0000006917": "蕉城区",
        "P_YS_FED_IMP_IOT0000006919": "新浦区",
        "P_YS_FED_IMP_IOT0000010206": "东源县",
        "P_YS_FED_IMP_IOT0000010207": "清水县",
        "P_YS_FED_IMP_IOT0000011537": "岐山县",
        "P_YS_FED_IMP_IOT0000010208": "南海区",
        "P_YS_FED_IMP_IOT0000006910": "昆山市",
        "P_YS_FED_IMP_IOT0000011533": "雁峰区",
        "P_YS_FED_IMP_IOT0000010204": "凌海市",
        "P_YS_FED_IMP_IOT0000010205": "郧西县",
        "P_YS_FED_IMP_IOT0000011535": "哈密市",
        "P_YS_FED_IMP_IOT0000009188": "习水县",
        "P_YS_HR_HRPXF_0000056097": "扫码",
        "P_YS_FED_IMP_IOT0000009189": "蒲县",
        "P_YS_FED_IMP_IOT0000009180": "阜宁县",
        "P_YS_FI_CM_0000029370": "区域缩放",
        "P_YS_FED_IMP_IOT0000009184": "金塔县",
        "P_YS_FED_IMP_IOT0000009181": "水城县",
        "P_YS_FED_IMP_IOT0000006903": "商州区",
        "P_YS_FED_IMP_IOT0000011541": "泸水县",
        "P_YS_FED_IMP_IOT0000011540": "砀山县",
        "P_YS_FED_IMP_IOT0000006905": "渭城区",
        "P_YS_FED_IMP_IOT0000011543": "荣县",
        "P_YS_FED_FW_0001570014": "暂无数据模型",
        "P_YS_FED_IMP_IOT0000006904": "荥阳市",
        "P_YS_FED_FW_0001570015": "未找到匹配的特征",
        "P_YS_FED_IMP_IOT0000006907": "巍山彝族回族自治县",
        "P_YS_FI_CM_0000029374": "国",
        "P_YS_FED_FW_0001064735": "输入小数位超出",
        "P_YS_FED_IMP_IOT0000011549": "新干县",
        "P_YS_FED_FW_0001064736": "限制小数位为0",
        "P_YS_FED_IMP_IOT0000010219": "射阳县",
        "P_YS_FED_IMP_IOT0000006901": "杭锦后旗",
        "P_YS_FED_IMP_IOT0000006900": "扬中市",
        "P_YS_FED_IMP_IOT0000011546": "永嘉县",
        "P_YS_FED_IMP_IOT0000009176": "绥中县",
        "P_YS_FED_IMP_IOT0000009174": "顺庆区",
        "P_YS_FED_IMP_IOT0000009175": "永清县",
        "P_YS_FED_IMP_IOT0000009178": "灌云县",
        "P_YS_FED_IMP_IOT0000009179": "临潼区",
        "P_YS_FED_IMP_IOT0000009171": "漠河县",
        "P_YS_FED_IMP_IOT0000010221": "巧家县",
        "P_YS_FED_IMP_IOT0000011551": "贵德县",
        "P_YS_FED_IMP_IOT0000010222": "浈江区",
        "P_YS_OA_XTTMCENTER_0000035014": "上传人",
        "P_YS_OA_LCGL_0000037185": "总数量",
        "P_YS_FED_FW_0001141477": "表格不能为空",
        "P_YS_FED_IMP_IOT0000010224": "安乡县",
        "P_YS_FED_FW_0001141476": "无此条记录，请重新输入",
        "P_YS_PF_GZTSYS_0000011894": "菜单管理",
        "P_YS_FED_FW_0001141479": "以下表头字段不能为空",
        "P_YS_FED_FW_0001141478": "未找到dom节点",
        "P_YS_FED_IMP_IOT0000010227": "高坪区",
        "P_YS_FED_IMP_IOT0000009166": "巴里坤哈萨克自治县",
        "P_YS_FED_IMP_IOT0000009169": "黄石港区",
        "P_YS_FED_IMP_IOT0000009167": "中牟县",
        "P_YS_FED_FW_1622974871724097545": "---[本地读取JSON文件报错:]",
        "P_YS_FED_IMP_IOT0000009161": "卫辉市",
        "P_YS_FED_IMP_IOT0000009160": "安塞县",
        "P_YS_FED_FW_1622974871724097548": "---[获取Redis缓存报错:]",
        "P_YS_FED_IMP_IOT0000011564": "建德市",
        "P_YS_OA_XTTMCENTER_0000035019": "用户名",
        "P_YS_FED_IMP_IOT0000011567": "彭山县",
        "P_YS_FED_IMP_IOT0000010236": "嵊州市",
        "P_YS_FED_IMP_IOT0000011566": "那曲县",
        "P_YS_FED_IMP_IOT0000010237": "宾县",
        "P_YS_FED_IMP_IOT0000009155": "连云区",
        "P_YS_FED_IMP_IOT0000009152": "东昌区",
        "P_YS_FED_FW_1442618603529043968": "请在搜索框中录入关键字搜索,或切换左侧分类",
        "P_YS_SD_SDMA_0000062635": "…",
        "P_YS_FED_IMP_IOT0000009157": "邕宁区",
        "P_YS_FED_FW_1455751582723342336": "文件.xlsx",
        "P_YS_FED_FW_0001152150": "您的权限不足，将另存为个人方案，是否继续？",
        "P_YS_FED_IMP_IOT0000009150": "织金县",
        "P_YS_FED_IMP_IOT0000010242": "忠县",
        "P_YS_FED_UIMG_0000080080": "关联字段不允许隐藏",
        "P_YS_FED_IMP_IOT0000010243": "宁明县",
        "P_YS_FED_IMP_IOT0000011573": "陵川县",
        "P_YS_FED_IMP_IOT0000010244": "邢台县",
        "P_YS_FED_IMP_IOT0000010245": "普定县",
        "P_YS_FED_IMP_IOT0000011570": "江都市",
        "P_YS_FED_IMP_IOT0000010240": "钦南区",
        "P_YS_FED_FW_1421773194486874118": "公式赋值 表头 >>:",
        "P_YS_SD_SDMB_0000139799": "请求超时!",
        "P_YS_FED_IMP_IOT0000011578": "龙井市",
        "P_YS_FED_IMP_IOT0000011577": "老河口市",
        "P_YS_FED_FW_1421773194486874115": "公式赋值 表体>>:",
        "P_YS_FED_IMP_IOT0000010248": "凤庆县",
        "P_YS_FED_FW_0001152149": "个人方案无法修改为公共方案，将另存为个人方案，是否继续？",
        "P_YS_FED_FW_0001152148": "公共方案无法修改为个人方案，将另存为个人方案，是否继续？",
        "P_YS_FED_FW_1421773194486874112": "耗时>>",
        "P_YS_FED_IMP_IOT0000009142": "双峰县",
        "P_YS_FED_IMP_IOT0000009145": "江海区",
        "P_YS_FED_FW_0001026464": "»",
        "P_YS_FED_FW_0000022132": "行标题",
        "P_YS_FED_IMP_IOT0000009260": "汇川区",
        "P_YS_FED_FW_0000022133": "请输入1-99数字",
        "P_YS_FED_FW_0000022130": "系统项不允许进行删除操作！",
        "P_YS_FED_FW_0000022131": "删除成功！",
        "P_YS_FED_IMP_IOT0000010133": "咸安区",
        "P_YS_FED_IMP_IOT0000011463": "桐柏县",
        "P_YS_FED_IMP_IOT0000010134": "克山县",
        "P_YS_FED_IMP_IOT0000011466": "邗江区",
        "P_YS_FED_IMP_IOT0000011465": "北票市",
        "P_YS_SCM_UPU-UI_0001085778": "订单动向",
        "P_YS_FED_IMP_IOT0000010131": "禹城市",
        "P_YS_FED_IMP_IOT0000011461": "沐川县",
        "P_YS_FED_IMP_IOT0000010136": "雨湖区",
        "P_YS_FED_IMP_IOT0000011468": "阳新县",
        "P_YS_FED_IMP_IOT0000011467": "松溪县",
        "P_YS_FED_IMP_IOT0000010138": "武山县",
        "P_YS_FED_FW_1570021833376792583": "跳过",
        "P_YS_FED_FW_0000022125": "仅选中记录",
        "P_YS_FED_FW_0000022126": "（最多显示16项）",
        "P_YS_FED_FW_0000022123": "编辑订阅方案",
        "P_YS_FED_IMP_IOT0000009251": "张家界",
        "P_YS_FED_FW_0000022124": "贸易公司",
        "P_YS_FED_FW_0000022129": "保存数据模版",
        "P_YS_FED_FW_0000022127": "俄语",
        "P_YS_FED_IMP_IOT0000009255": "芙蓉区",
        "P_YS_FED_FW_0000022128": "辅维度最多一项",
        "P_YS_FED_IMP_IOT0000009256": "伊宁市",
        "P_YS_FED_FW_1582115439097413635": "请选择移动端布局。",
        "P_YS_FED_FW_0000022140": "辅维度行数",
        "P_YS_FED_FW_0001152050": "新失效日期不能早于新生效时间~请修改新失效日期",
        "P_YS_FED_FW_0000022143": "包含于",
        "P_YS_FED_FW_0000022144": "啊哦！没此节点哦！",
        "P_YS_FED_IMP_IOT0000009250": "信丰县",
        "P_YS_FED_FW_0000022141": "没有可以更改的记录",
        "P_YS_FED_IMP_IOT0000010144": "横县",
        "P_YS_FED_IMP_IOT0000011474": "源汇区",
        "P_YS_FED_IMP_IOT0000011477": "沿滩区",
        "P_YS_FED_IMP_IOT0000010146": "乡城县",
        "P_YS_FED_IMP_IOT0000011476": "达县",
        "P_YS_FED_IMP_IOT0000011470": "甘德县",
        "P_YS_FED_IMP_IOT0000011473": "六盘水",
        "P_YS_FED_IMP_IOT0000010141": "兰西县",
        "P_YS_FED_IMP_IOT0000011472": "张北县",
        "P_YS_FED_IMP_IOT0000009248": "祁门县",
        "P_YS_FED_IMP_IOT0000011479": "梅县",
        "P_YS_FED_IMP_IOT0000011478": "芷江侗族自治县",
        "P_YS_FED_IMP_IOT0000010149": "梅河口市",
        "P_YS_FED_FW_0000022136": "请选择筛选指标",
        "P_YS_FED_IMP_IOT0000009242": "未央区",
        "P_YS_FED_FW_0000022137": "项目名称",
        "P_YS_FED_FW_0001152049": "新生效日期不能早于当前时间~请修改新生效日期",
        "P_YS_FED_IMP_IOT0000009243": "和平区",
        "P_YS_FED_FW_0000022134": "存在行标题重复的行",
        "P_YS_FED_FW_0000022135": "所有信息-分组数据 group =",
        "P_YS_FED_IMP_IOT0000009241": "桑植县",
        "P_YS_FED_UCFBASEDOC_0000024874": "角色名称",
        "P_YS_FED_FW_0000022138": "刷新失败",
        "P_YS_FED_FW_0000022139": "显示数值",
        "P_YS_FED_UCFBASEDOC_0000024870": "查看详情",
        "P_YS_FED_IMP_IOT0000011480": "中阳县",
        "P_YS_FED_FW_0000022111": "标题字体大小",
        "P_YS_SD_URETAIL_0001048982": "请传递正确的参数!",
        "P_YS_FED_IMP_IOT0000010154": "许昌县",
        "P_YS_FED_IMP_IOT0000011486": "东平县",
        "P_YS_FED_IMP_IOT0000011485": "沧县",
        "P_YS_FED_IMP_IOT0000010156": "东胜市",
        "P_YS_FED_IMP_IOT0000011488": "黄梅县",
        "P_YS_FED_IMP_IOT0000011487": "泸定县",
        "P_YS_FED_IMP_IOT0000010153": "黔江区",
        "P_YS_FED_FW_0000022109": "图+表",
        "P_YS_FED_IMP_IOT0000009237": "宜城市",
        "P_YS_FED_FW_0000022103": "上传失败！",
        "P_YS_FED_FW_0000022104": "请选择地图信息。",
        "P_YS_FED_IMP_IOT0000009232": "龙泉市",
        "P_YS_FED_FW_0000022101": "有辅维度存在，展示指标只支持单选",
        "P_YS_FED_FW_0000022102": "· 数值类型字段：[注册资金]*1000、[物料详情.线上零售价]*[物料详情.商城-线上库存量]",
        "P_YS_FED_IMP_IOT0000009230": "双台子区",
        "P_YS_FED_FW_0000022107": "行列=",
        "P_YS_FED_FW_0000022108": "展开更多",
        "P_YS_FED_FW_1426978763591122944": "确定要撤回单据吗？",
        "P_YS_FED_FW_0000022105": "请选择行再进行上移操作！",
        "P_YS_FED_FW_0000022106": "请设置方案",
        "P_YS_FED_IMP_IOT0000011490": "洛南县",
        "P_YS_FED_FW_0000022122": "编码不允许存在中文！",
        "P_YS_FED_FW_0000022120": "排名表",
        "P_YS_SCM_UPU-UI_0001085764": "未收齐",
        "P_YS_FED_IMP_IOT0000010167": "云梦县",
        "P_YS_FED_IMP_IOT0000011499": "新抚区",
        "P_YS_FED_IMP_IOT0000010168": "抚顺县",
        "P_YS_FED_FW_1583735397671763971": "+添加标签",
        "P_YS_FED_IMP_IOT0000011493": "清河区",
        "P_YS_FED_IMP_IOT0000011495": "青原区",
        "P_YS_FED_FW_0001316754": "无名节点",
        "P_YS_FI_FCWEB_0001047917": "请选择至少一条数据",
        "P_YS_FED_FW_0000022114": "会计主体",
        "P_YS_FED_IMP_IOT0000009220": "城东区",
        "P_YS_FED_FW_0000022115": "标题不可为空",
        "P_YS_FED_IMP_IOT0000009221": "肃北蒙古族自治县",
        "P_YS_FED_FW_0000022112": "当前文件不允许下载！",
        "P_YS_FED_FW_0000022113": "请输入公司网址",
        "P_YS_FED_FW_0000022118": "展示指标必选，且最多4项",
        "P_YS_FED_FW_0000022119": "项，勾选多个主维度将用\"/\"拼接显示",
        "P_YS_FED_IMP_IOT0000009225": "南漳县",
        "P_YS_FED_FW_0000022116": "拆分数量",
        "P_YS_FED_FW_0000022117": "删除当前行",
        "P_YS_SD_UDHBI_0000032336": "待确认",
        "P_YS_FED_FW_0000022172": "内半径百分比",
        "P_YS_FED_FW_0000022173": "热区设置图 上传图片：调用服务出错  info.file.response",
        "P_YS_FED_FW_0000022170": "输入数字的长度不能大于",
        "P_YS_FED_IMP_IOT0000010170": "苍南县",
        "P_YS_FED_FW_0000022171": "啊哦~没有搜索到~",
        "P_YS_FED_IMP_IOT0000010171": "望都县",
        "P_YS_FED_FW_0000022176": "（最多支持三级导航）",
        "P_YS_FED_FW_0000022177": "大屏轮播: 切换 afterChange",
        "P_YS_FED_FW_0000022174": "上传成功！",
        "P_YS_FED_IMP_IOT0000010178": "铁山区",
        "P_YS_FED_IMP_IOT0000010179": "河北区",
        "P_YS_FED_IMP_IOT0000010173": "大冶市",
        "P_YS_FED_IMP_IOT0000010175": "容县",
        "P_YS_FED_IMP_IOT0000009217": "武陵源区",
        "P_YS_FED_IMP_IOT0000009218": "当阳市",
        "P_YS_FED_IMP_IOT0000009219": "高邮市",
        "P_YS_FED_UCFBASEDOC_0000024847": "折",
        "P_YS_FED_FW_0000022169": "大屏方案 设计 eChartPanelDesigngetPreView End",
        "P_YS_FED_FW_0000022167": "当前模板无数据",
        "P_YS_FED_FW_0000022168": "请输入关键字",
        "P_YS_FED_IMP_IOT0000009212": "丰都县",
        "P_YS_FED_FW_0000022183": "大屏轮播:获取模板列表信息出错。模板 panelIds =",
        "P_YS_FED_FW_0000022184": "eChartPanelDisplay 双击事件",
        "P_YS_FED_IMP_IOT0000010180": "新城区",
        "P_YS_FED_FW_0000022181": "设置汇总区  eChartConfig",
        "P_YS_FED_IMP_IOT0000010181": "通州市",
        "P_YS_FED_FW_0000022187": "企业LOGO",
        "P_YS_FED_FW_0000022188": "更新",
        "P_YS_FED_FW_0000022186": "保存汇总区设置失败。信息 :",
        "P_YS_FED_IMP_IOT0000010183": "五寨县",
        "P_YS_FED_FW_0000022180": "字体大小",
        "P_YS_FED_IMP_IOT0000010185": "边坝县",
        "P_YS_FED_IMP_IOT0000010186": "彭水苗族土家族自治县",
        "P_YS_FED_IMP_IOT0000009205": "皇姑区",
        "P_YS_FED_FW_0000022178": "按您喜欢的顺序拖放菜单",
        "P_YS_FED_FW_0000022179": "对齐方式",
        "P_YS_FED_FW_0000022150": "eChartDisplay状态改变 shouldComponentUpdate  End false",
        "P_YS_FED_FW_0000022151": "确认要停用吗？",
        "P_YS_FED_FW_0000022154": "恢复",
        "P_YS_FED_FW_0000022155": "事业部",
        "P_YS_FED_FW_0001456968": "条数据允许打印\\n",
        "P_YS_FED_FW_0000022152": "大屏看板已保存。",
        "P_YS_OA_XTWEIYOU_0000046261": "文件夹",
        "P_YS_FED_FW_0000022153": "不包含于",
        "P_YS_FED_IMP_IOT0000010198": "凤山县",
        "P_YS_FED_IMP_IOT0000010194": "于洪区",
        "P_YS_OA_XTWEIYOU_0000046266": "发送",
        "P_YS_FED_FW_0000022147": "热区获取FieldValue出错。 obj =",
        "P_YS_FED_FW_0000022148": "参照类型",
        "P_YS_FED_FW_0000022145": "添加图表",
        "P_YS_FED_UCFBASEDOC_0000024820": "到",
        "P_YS_FED_FW_0000022146": "获取维度列表失败！",
        "P_YS_FED_FW_0000022149": "汇总",
        "P_YS_PF_GZTSYS_0000011901": "立账规则",
        "P_YS_FED_FW_0000022161": "气泡图",
        "P_YS_FED_FW_0000022162": ")。",
        "P_YS_FED_FW_0000022160": "当前页面加载不成功～",
        "P_YS_FED_FW_0000022165": "配置文件中分组项字段[",
        "P_YS_FED_FW_0000022166": "是否合计",
        "P_YS_FED_FW_0000022163": "档案值",
        "P_YS_FED_FW_0000022164": "最小",
        "P_YS_FED_FW_1593218496493780999": "Los resultados de la búsqueda conjunta de documentos muestran",
        "P_YS_FED_FW_0000022158": "上传大小超出限制，请重新上传！",
        "P_YS_FED_FW_0000022159": "请输入1-31数字",
        "P_YS_FED_FW_0000022156": "条!",
        "P_YS_FED_FW_0000022157": "订阅设置",
        "P_YS_PF_GZTSYS_0000011912": "供应商属性",
        "P_YS_FED_FW_0001460129": "请输入有效邮箱地址",
        "P_YS_FED_FW_0001243335": "支持excel格式文件、单文件；单个文件的大小限制不超过",
        "P_YS_FED_FW_0001243334": "MB，不超过10万条数据",
        "P_YS_FED_FW_0001243333": "进行中...",
        "P_YS_FED_FW_1554658615102537733": "最多允许输入15位",
        "P_YS_OA_app_xtywlj_0000037515": "凭证名称",
        "P_YS_FED_FW_0001460130": "请输入7~8位电话号码",
        "P_YS_FED_FW_0001460133": "请输入有效手机号码",
        "P_YS_FED_FW_0001460132": "请输入3~4位区号",
        "P_YS_FED_FW_0001460131": "请输入11位手机号码",
        "P_YS_OA_XTWEIYOU_0000046277": "全部关闭",
        "P_YS_SD_UDHAR_0000116811": "附件不能为空",
        "P_YS_FED_FW_0001134231": "存在空白行标题的行或行标题未赋新值",
        "P_YS_FI_YYFI-UI_0000161301": "复制行",
        "P_YS_FED_FW_1604430517195243523": "不允许使用user.tenant.和user.option.获取，请使用tenan.和option.！！",
        "P_YS_SD_UDHWS_0000067925": "单号",
        "P_YS_SD_UDHBA_0000137530": "总行数",
        "P_YS_SD_SDMAUF_0000151755": "定金",
        "P_YS_FED_FW_0001045602": "共 <%=total%> 条",
        "P_YS_FED_FW_0001045601": "不知道",
        "P_YS_FED_FW_1467112879311290368": "只看必填项",
        "P_YS_HR_HRXCF_0000072919": "全部选择",
        "P_YS_FED_FW_0001031014": "≤",
        "P_YS_PF_PRINT_0000065174": "主计量",
        "P_YS_FED_FW_0001473475": "变更失败",
        "P_YS_FED_UIMG_0001088007": "关联tips",
        "P_YS_FED_FW_0001473474": "生效后将更新业务领域使用的业务单元，并且将不可逆回，是否继续？",
        "P_YS_FED_FW_1610061184968425476": "---[获取JSON文件报错:]",
        "P_YS_PF_PROCENTER_0000023174": "商品名称",
        "P_YS_FED_FW_0001160539": "缺少电话号码",
        "P_YS_FED_FW_0000022100": "订阅状态",
        "P_YS_SCM_UPU-UI_0001085746": "按单视图-物料子表区域",
        "P_YS_FED_FW_0001007382": "暂无数据~",
        "P_YS_PF_PRINT_0000065185": "件数",
        "P_YS_FED_FW_1450555256411258883": "获取定位失败, ERROR(",
        "P_YS_FED_FW_1450555256411258880": "%c重置地理位置为当前用户所在位置",
        "P_YS_SCM_UPU-UI_0001085715": "催单",
        "P_YS_SD_UDHWN_0000047991": "海淀区",
        "P_YS_FED_FW_1521253227064459268": "有交集",
        "P_YS_FED_FW_0001233973": "缺少wpsPreview方法",
        "P_YS_FED_UIMG_0000157462": "【提示】若“系统语言”为空，则按照“当前语言”进行保存。",
        "P_YS_FED_UIMG_0000157460": "当前语言",
        "P_YS_FED_UIMG_0000157461": "系统语言",
        "P_YS_SD_UDHBN_0001144476": "单号：$var{code}$var_end",
        "P_YS_FED_IMP_IOT0000005578": "漳浦县",
        "P_YS_FED_IMP_IOT0000005571": "泰和县",
        "P_YS_FED_IMP_IOT0000005570": "台安县",
        "P_YS_FED_IMP_IOT0000005572": "柏乡县",
        "P_YS_FED_FW_0001123276": "是否导出全部数据？",
        "P_YS_FED_FW_0001123277": "自动搜索",
        "P_YS_FED_FW_0001123274": "单次最大导出50000条,请重新设置查询条件后重试！",
        "P_YS_FED_FW_0001123275": "当前查询数据为空，请重新设置查询条件",
        "000723": "请输入网址",
        "P_YS_FED_IMP_IOT0000006894": "资阳区",
        "P_YS_FED_IMP_IOT0000006897": "南江县",
        "P_YS_FED_IMP_IOT0000006899": "依兰县",
        "P_YS_FED_IMP_IOT0000005568": "组织3",
        "P_YS_FED_IMP_IOT0000005567": "确认",
        "P_YS_OA_app_xtywlj_0000037365": "忽略",
        "P_YS_FED_IMP_IOT0000006891": "丰顺县",
        "P_YS_FED_IMP_IOT0000006890": "信州区",
        "P_YS_FED_IMP_IOT0000006893": "垦利县",
        "P_YS_FED_IMP_IOT0000006892": "郎溪县",
        "P_YS_FED_UCFORG_0000027586": "开",
        "P_YS_FED_IMP_IOT0000006884": "垫江县",
        "P_YS_FED_IMP_IOT0000006883": "江口县",
        "P_YS_FED_IMP_IOT0000005557": "组织2",
        "P_YS_FED_IMP_IOT0000006887": "青羊区",
        "P_YS_FED_IMP_IOT0000005558": "组织1",
        "P_YS_FED_IMP_IOT0000006889": "平罗县",
        "P_YS_FED_IMP_IOT0000006882": "东海县",
        "P_YS_FED_IMP_IOT0000006873": "建平县",
        "P_YS_FED_IMP_IOT0000005541": "非空",
        "P_YS_FED_IMP_IOT0000006872": "尚义县",
        "P_YS_FED_IMP_IOT0000006875": "麻江县",
        "P_YS_FED_IMP_IOT0000006877": "冷水江市",
        "P_YS_FED_IMP_IOT0000006876": "镇赉县",
        "P_YS_FED_FW_1482737996175769616": "布局位置",
        "P_YS_FED_FW_1482737996175769619": "移动方案",
        "P_YS_FED_IMP_IOT0000006869": "龙子湖区",
        "P_YS_FED_FW_1482737996175769610": "设置项",
        "P_YS_FED_FW_1482737996175769613": "另存为新方案",
        "P_YS_FED_IMP_IOT0000005531": "开始 ~ 结束",
        "P_YS_FED_IMP_IOT0000006862": "大渡口区",
        "P_YS_FED_IMP_IOT0000006864": "弋阳县",
        "P_YS_FED_UCFORG_0000027572": "关",
        "P_YS_FED_IMP_IOT0000006863": "普兰店市",
        "P_YS_FED_IMP_IOT0000006866": "偃师市",
        "P_YS_FED_IMP_IOT0000006865": "锡林浩特市",
        "P_YS_FED_FW_1482737996175769604": "设为默认方案",
        "P_YS_FED_FW_1482737996175769607": "手动搜索",
        "P_YS_FI_CM_0000029423": "右键另存为图片",
        "P_YS_FED_FW_1482737996175769601": "别看了啥也没有",
        "P_YS_FED_IMP_IOT0000006851": "铜官山区",
        "P_YS_FED_FW_0001249254": "已复制到剪贴板",
        "P_YS_FED_IMP_IOT0000006850": "金水区",
        "P_YS_FED_IMP_IOT0000005522": "行，订单编号为:",
        "P_YS_FED_IMP_IOT0000006854": "南皮县",
        "P_YS_FED_IMP_IOT0000006856": "大武口区",
        "P_YS_HR_HRYGF_0000058851": "布尔",
        "P_YS_OA_XTGONGWEN_0000045538": "签收",
        "P_YS_FED_FW_0001131726": "人员",
        "P_YS_FED_IMP_IOT0000006848": "城关区",
        "P_YS_FED_IMP_IOT0000006847": "鸡冠区",
        "P_YS_FED_IMP_IOT0000006849": "青田县",
        "P_YS_FED_FW_0001131728": "确 定",
        "P_YS_FED_FW_0001131727": "取 消",
        "P_YS_FED_FW_0001060872": "字段值无效！",
        "P_YS_FED_IMP_IOT0000006840": "绥江县",
        "P_YS_FED_FW_0001060873": "没有配置文件服务！",
        "P_YS_FED_IMP_IOT0000006844": "康保县",
        "P_YS_FED_IMP_IOT0000005514": "下一步",
        "P_YS_FED_FW_1556026785534574596": "当前查询方案存在“非空”（或“为空”）查询，是否继续保存？",
        "P_YS_OA_LCGL_0000037254": "批量删除",
        "P_YS_FED_FW_0001060869": "切换主组织将清空数据，是否继续",
        "P_YS_FED_IMP_IOT0000006837": "扶余县",
        "P_YS_FED_IMP_IOT0000006836": "抚宁县",
        "P_YS_SCM_PU_0000028543": "获取数据失败",
        "P_YS_SD_UDHBN_0001144481": "交期：$var{recieveDate}$var_end数量：$var{qty}$var_end",
        "P_YS_FED_IMP_IOT0000005507": "终止",
        "P_YS_FED_FW_1482737996175769622": "搜索方式",
        "P_YS_FED_IMP_IOT0000006830": "青云谱区",
        "P_YS_FED_IMP_IOT0000006833": "稻城县",
        "P_YS_FED_IMP_IOT0000006832": "青阳县",
        "P_YS_FED_IMP_IOT0000006835": "定结县",
        "P_YS_FED_IMP_IOT0000005503": "查询",
        "P_YS_SCM_USTOCK-UI_0000176083": "电子围栏",
        "P_YS_FED_IMP_IOT0000006826": "涡阳县",
        "P_YS_FED_IMP_IOT0000006828": "润州区",
        "P_YS_HR_HRYGF_0000058837": "枚举",
        "P_YS_FED_IMP_IOT0000006829": "神池县",
        "P_YS_FED_IMP_IOT0000006822": "临沭县",
        "P_YS_FED_IMP_IOT0000006823": "曲麻莱县",
        "P_YS_FED_IMP_IOT0000009098": "张家港市",
        "P_YS_FED_IMP_IOT0000009091": "揭东县",
        "P_YS_FED_IMP_IOT0000009090": "鄂温克族自治旗",
        "P_YS_PF_SOCD-E_0000433293": "山南市",
        "P_YS_FED_IMP_IOT0000009096": "南丰县",
        "P_YS_FED_IMP_IOT0000009093": "东西湖区",
        "P_YS_FED_IMP_IOT0000006815": "阿瓦提县",
        "P_YS_FED_IMP_IOT0000006817": "龙川县",
        "P_YS_FED_IMP_IOT0000006816": "平泉县",
        "P_YS_OA_LCGL_0000037261": "高级查询",
        "P_YS_FED_FW_0001143732": "lineNoStep()参数不是一个有效的数",
        "P_YS_FED_IMP_IOT0000009080": "渝中区",
        "P_YS_PF_SOCD_0000066122": "萨尔瓦多",
        "P_YS_FED_IMP_IOT0000009081": "荣昌县",
        "project.tag.tag07": "互联网",
        "P_YS_MF_PO-FE_0001118286": "✔",
        "P_YS_FED_IMP_IOT0000009083": "万荣县",
        "P_YS_FED_IMP_IOT0000006804": "龙州县",
        "P_YS_FED_FW_0001264815": "列表设置",
        "P_YS_FED_IMP_IOT0000011400": "威宁彝族回族苗族自治县",
        "P_YS_FED_IMP_IOT0000006808": "西安区",
        "P_YS_FED_IMP_IOT0000006809": "汝阳县",
        "P_YS_FED_IMP_IOT0000011406": "温江区",
        "P_YS_FED_IMP_IOT0000011405": "玉山县",
        "P_YS_FED_IMP_IOT0000011408": "荆州区",
        "P_YS_FED_IMP_IOT0000006800": "监利县",
        "P_YS_FED_IMP_IOT0000011403": "安仁县",
        "P_YS_FED_IMP_IOT0000009075": "钦北区",
        "P_YS_PF_TRS_0000034743": "年龄",
        "P_YS_FED_IMP_IOT0000009076": "杭州",
        "P_YS_FED_IMP_IOT0000009079": "任县",
        "P_YS_FED_IMP_IOT0000009074": "濮阳",
        "P_YS_FED_IMP_IOT0000011411": "洛宁县",
        "P_YS_FED_IMP_IOT0000011416": "无为县",
        "P_YS_FED_IMP_IOT0000011419": "云岩区",
        "P_YS_FED_IMP_IOT0000011418": "驻马店",
        "P_YS_PF_GZTTMP_0000074112": "食品",
        "P_YS_SD_UDHWN_0000050056": "文昌市",
        "P_YS_FED_IMP_IOT0000009065": "南岔区",
        "P_YS_FED_IMP_IOT0000009068": "合江县",
        "P_YS_PF_SOCD_0000066131": "斐济",
        "P_YS_FED_IMP_IOT0000009069": "新县",
        "P_YS_FED_FW_0001026106": "<%=alertStrPrefix%>至少录入一行数据！",
        "P_YS_FED_IMP_IOT0000009062": "防城港",
        "P_YS_FED_IMP_IOT0000009063": "昌乐县",
        "P_YS_FED_IMP_IOT0000009060": "嘉定区",
        "P_YS_FED_IMP_IOT0000009061": "包河区",
        "P_YS_FED_IMP_IOT0000011421": "兰溪市",
        "P_YS_FED_IMP_IOT0000011429": "复兴区",
        "P_YS_FED_IMP_IOT0000011424": "景县",
        "P_YS_FED_IMP_IOT0000011426": "修水县",
        "P_YS_FED_IMP_IOT0000011425": "關閉",
        "P_YS_FED_IMP_IOT0000009054": "托克逊县",
        "P_YS_FED_IMP_IOT0000009057": "永新县",
        "P_YS_FED_IMP_IOT0000009051": "榆社县",
        "P_YS_FED_IMP_IOT0000009050": "赤壁市",
        "P_YS_FED_IMP_IOT0000010100": "灵丘县",
        "P_YS_FED_IMP_IOT0000010101": "北塘区",
        "P_YS_FED_IMP_IOT0000011432": "兰山区",
        "P_YS_PF_VPA_0000082557": "调用失败",
        "P_YS_FED_FW_0001125804": "specialcom的cStyle未配置:",
        "P_YS_FED_FW_0001125803": "未找到specialcom的目标model:",
        "P_YS_FED_IMP_IOT0000010104": "南康市",
        "P_YS_FED_IMP_IOT0000010105": "雅江县",
        "P_YS_FED_IMP_IOT0000011437": "遂川县",
        "P_YS_SD_SDOC_0000164303": "派件",
        "P_YS_FED_IMP_IOT0000009042": "细河区",
        "P_YS_FED_IMP_IOT0000009046": "宁化县",
        "P_YS_FED_IMP_IOT0000009040": "紫阳县",
        "P_YS_FED_IMP_IOT0000009041": "白云区",
        "P_YS_FED_IMP_IOT0000010111": "天河区",
        "P_YS_FED_IMP_IOT0000011441": "旺苍县",
        "P_YS_FED_IMP_IOT0000011443": "衡山县",
        "P_YS_FED_IMP_IOT0000011440": "巴东县",
        "P_YS_FED_FW_0001143784": "交互规则",
        "P_YS_FED_IMP_IOT0000010118": "宣州区",
        "P_YS_FED_IMP_IOT0000010119": "新市区",
        "P_YS_FED_IMP_IOT0000011449": "敦煌市",
        "P_YS_FED_IMP_IOT0000009039": "革吉县",
        "P_YS_FED_FW_0001143783": "交互规则初始化",
        "P_YS_FED_IMP_IOT0000010114": "峨眉山市",
        "P_YS_FED_IMP_IOT0000011447": "喀喇沁旗",
        "P_YS_FED_IMP_IOT0000009031": "水磨沟区",
        "P_YS_FED_IMP_IOT0000009037": "常宁市",
        "P_YS_FED_IMP_IOT0000009036": "政和县",
        "P_YS_FED_FW_0001155764": "您的权限不足!",
        "P_YS_FED_FW_1503620195896262656": "精准搜索",
        "P_YS_FED_IMP_IOT0000011453": "含山县",
        "P_YS_FED_IMP_IOT0000010122": "溧阳市",
        "P_YS_FED_IMP_IOT0000010123": "蓬江区",
        "P_YS_FED_IMP_IOT0000011454": "甘南县",
        "P_YS_FED_IMP_IOT0000010120": "永兴县",
        "P_YS_FED_IMP_IOT0000011450": "秦都区",
        "P_YS_FED_IMP_IOT0000010129": "屏南县",
        "P_YS_FED_IMP_IOT0000009028": "北辰区",
        "P_YS_FED_IMP_IOT0000010125": "大田县",
        "P_YS_FED_IMP_IOT0000011456": "玉门市",
        "P_YS_FED_IMP_IOT0000009023": "开阳县",
        "P_YS_OA_XTMENHUCMS_0000045358": "添加描述",
        "P_YS_FED_IMP_IOT0000009027": "平武县",
        "P_YS_FED_IMP_IOT0000009025": "东光县",
        "P_YS_FED_FW_0000022250": "初始化出错。",
        "P_YS_FED_FW_0000022253": "当前区域没有地图组件。",
        "P_YS_FED_FW_0000022254": "的整数",
        "P_YS_FED_FW_0000022251": "地图",
        "P_YS_FED_FW_0000022252": "操作成功！",
        "P_YS_FED_FW_1435891525106532352": "以下字段有误(或存在必填项)",
        "P_YS_FED_EXAMP_0000020085": "订单属性",
        "P_YS_FED_IMP_IOT0000010011": "西乡塘区",
        "P_YS_FED_EXAMP_0000020084": "没有需要自动拣货的商品行！",
        "P_YS_FED_EXAMP_0000020087": "请输入起始卡券号",
        "P_YS_FED_IMP_IOT0000011345": "鲤城区",
        "server.rest.idcard.is.wrong": "身份证号格式不正确",
        "P_YS_FED_EXAMP_0000020086": "【异常】",
        "P_YS_OA_XTWEIYOU_0000046327": "全部已读",
        "P_YS_FED_EXAMP_0000020081": "SKU名称",
        "P_YS_FED_EXAMP_0000020080": "不能使用会员钱包结算",
        "P_YS_FED_EXAMP_0000020082": "没有适用的促销活动！",
        "P_YS_FED_IMP_IOT0000010010": "凤阳县",
        "P_YS_FED_IMP_IOT0000010019": "集宁市",
        "P_YS_FED_IMP_IOT0000009139": "堆龙德庆县",
        "P_YS_FED_EXAMP_0000020078": "子件商品不允许执行积分抵扣",
        "P_YS_FED_IMP_IOT0000011347": "沛县",
        "P_YS_FED_EXAMP_0000020077": "调试用户校验失败",
        "P_YS_FED_IMP_IOT0000010017": "开平市",
        "P_YS_FED_EXAMP_0000020079": "获取网络打印设置失败！",
        "P_YS_FED_FW_0000022246": "显示条数设置不正确",
        "P_YS_FED_FW_0000022247": "保留内层间距",
        "P_YS_FED_FW_0001065740": "名称长度不可超过20个字符",
        "P_YS_FED_IMP_IOT0000009133": "广德县",
        "P_YS_FED_FW_0000022244": "请设置汇总字段",
        "P_YS_FED_IMP_IOT0000009130": "龙岗区",
        "P_YS_FED_FW_0000022245": "样式",
        "P_YS_FED_IMP_IOT0000009137": "洛浦县",
        "P_YS_FED_FW_0000022248": "大屏汇总区域设置不自动刷新。 refreshInterval",
        "P_YS_FED_FW_0001065741": "名称已超过20个字符！",
        "P_YS_FED_IMP_IOT0000009134": "永靖县",
        "P_YS_FED_FW_0000022249": "修改为",
        "P_YS_FED_IMP_IOT0000009135": "南陵县",
        "P_YS_FED_FW_0000022260": "输入的数字不能大于",
        "P_YS_FED_FW_0001345199": "当前模板没有配置filterId,无法获取查询方案数据",
        "P_YS_FED_FW_0000022261": "反选",
        "P_YS_FED_EXAMP_0000020090": "称重重量低于标准重量，请检查托盘和产品是否摆放正确！",
        "P_YS_FED_FW_0000022264": "操作符不可为空，请检查",
        "P_YS_FED_FW_0000022265": "折线展现",
        "P_YS_FED_FW_0000022262": "暂无模版数据～",
        "P_YS_FED_FW_0001371485": "聚合浮动显示",
        "P_YS_FED_FW_0000022263": "条，失败",
        "P_YS_FED_EXAMP_0000020096": "已使用卡券号范围录入方式, 不允许输入卡号",
        "P_YS_FED_FW_0001292111": "请求接口地址:(",
        "P_YS_FED_EXAMP_0000020095": "当前网络不可用，不能使用此功能!",
        "P_YS_FED_IMP_IOT0000011353": "建始县",
        "P_YS_FED_EXAMP_0000020098": "不能执行现场折扣",
        "P_YS_FED_EXAMP_0000020097": "支付失败，需撤销畅捷支付。执行线上撤销？",
        "P_YS_FED_IMP_IOT0000011355": "秦淮区",
        "P_YS_FED_FW_0001292112": "接口返回数据:(",
        "P_YS_FED_EXAMP_0000020092": "已经执行了整单折扣，不能再新增商品！",
        "P_YS_FED_IMP_IOT0000011350": "墨竹工卡县",
        "P_YS_FED_EXAMP_0000020091": "周六",
        "P_YS_FED_EXAMP_0000020094": "零售金额为0，计算折扣错误！",
        "P_YS_FED_IMP_IOT0000010020": "雁塔区",
        "P_YS_FED_EXAMP_0000020093": "时段:",
        "P_YS_FED_IMP_IOT0000010021": "乌恰县",
        "P_YS_FED_IMP_IOT0000011351": "肃南裕固族自治县",
        "P_YS_FED_IMP_IOT0000009129": "文山县",
        "P_YS_FED_EXAMP_0000020089": "银联",
        "P_YS_FED_EXAMP_0000020088": "服务器地址格式不正确",
        "P_YS_FED_IMP_IOT0000010028": "武汉",
        "P_YS_FED_IMP_IOT0000010029": "连南瑶族自治县",
        "P_YS_FED_IMP_IOT0000011359": "舒城县",
        "P_YS_FED_IMP_IOT0000009121": "广宗县",
        "P_YS_FED_FW_0000022258": "新增订阅方案",
        "P_YS_FED_FW_0000022255": "增加",
        "P_YS_FED_FW_0000022256": "未选中任何行！",
        "P_YS_FED_IMP_IOT0000009125": "卫滨区",
        "P_YS_FED_FW_0001648419": "设为租户级模版",
        "P_YS_FED_FW_0000022259": "气泡图展示指标只支持单选",
        "P_YS_FED_IMP_IOT0000009123": "梅里斯达斡尔族区",
        "P_YS_FED_FW_0001026167": "没有找着编码为<%=menuCode%>的菜单",
        "P_YS_FED_IMP_IOT0000009124": "灵台县",
        "P_YS_FED_FW_0000022232": "小数位数",
        "P_YS_FED_FW_0000022230": "标题内容",
        "P_YS_FED_IMP_IOT0000010033": "费县",
        "P_YS_FED_IMP_IOT0000011365": "思明区",
        "P_YS_FED_IMP_IOT0000011367": "吉利区",
        "P_YS_FED_IMP_IOT0000010036": "吉首市",
        "P_YS_FED_IMP_IOT0000011360": "西峡县",
        "P_YS_FED_IMP_IOT0000010031": "鹿城区",
        "P_YS_FED_IMP_IOT0000011363": "扎鲁特旗",
        "P_YS_FED_IMP_IOT0000009116": "黎平县",
        "P_YS_FED_EXAMP_0000020099": "预制",
        "P_YS_FED_IMP_IOT0000010038": "大同县",
        "P_YS_FED_IMP_IOT0000011368": "江南区",
        "P_YS_FED_FW_0000022224": "维度导航方案",
        "P_YS_FED_FW_0000022225": "共处理",
        "P_YS_FED_FW_0000022222": "（全部附件大小不可超过",
        "P_YS_FED_FW_0000022223": "使用",
        "P_YS_FED_FW_0001026130": "<%=text%> 上传失败!",
        "P_YS_FED_FW_0000022228": "栏目名称",
        "P_YS_FED_IMP_IOT0000009114": "曲江区",
        "P_YS_FED_FW_0000022229": "请输入涟漪特效个数",
        "P_YS_FED_IMP_IOT0000009115": "栖霞市",
        "P_YS_FED_FW_0000022226": "常用功能设置",
        "P_YS_FED_FW_0001026133": "文件必须小于<%=text%>M",
        "P_YS_FED_IMP_IOT0000009112": "西吉县",
        "P_YS_FED_FW_0000022227": "未找到",
        "P_YS_FED_FW_0001026137": "<%=text%>已经在图形报表中使用，不能删除。",
        "P_YS_FED_FW_0000022242": "确认要启用吗？",
        "P_YS_FED_FW_0000022243": "数据项",
        "P_YS_FED_FW_0000022240": "主组织和模版名称不能为空",
        "P_YS_FED_FW_0000022241": "请输入方案名称",
        "P_YS_FED_IMP_IOT0000010045": "丹棱县",
        "P_YS_FED_IMP_IOT0000011375": "罗定市",
        "P_YS_FED_IMP_IOT0000011378": "泰顺县",
        "P_YS_FED_IMP_IOT0000010040": "鹿寨县",
        "P_YS_FED_IMP_IOT0000011371": "襄垣县",
        "P_YS_FED_IMP_IOT0000010042": "镶黄旗",
        "P_YS_FED_IMP_IOT0000011374": "临渭区",
        "P_YS_FED_IMP_IOT0000010043": "普安县",
        "P_YS_FED_IMP_IOT0000011373": "索县",
        "P_YS_FED_IMP_IOT0000009105": "宁国市",
        "P_YS_FED_IMP_IOT0000010048": "广灵县",
        "P_YS_FED_IMP_IOT0000010049": "大名县",
        "P_YS_FED_IMP_IOT0000011379": "民乐县",
        "P_YS_FED_FW_0000022235": "最多选择5个汇总项。",
        "P_YS_SD_SDMBF_0000143365": "游戏",
        "P_YS_FED_FW_0000022236": "导航",
        "P_YS_FED_FW_0000022233": "大屏方案 展现 this.serieNum =",
        "P_YS_FED_FW_0000022234": "葡萄牙语",
        "P_YS_FED_FW_0000022239": "点击上传背景图片",
        "P_YS_FED_FW_0000022237": "显示条数",
        "P_YS_FED_IMP_IOT0000009101": "和平县",
        "P_YS_FED_FW_0000022238": "模版名称不能为空",
        "P_YS_FED_IMP_IOT0000009102": "肥西县",
        "P_YS_FED_FW_0000022293": "中度",
        "P_YS_FED_FW_0000022294": "操作信息",
        "P_YS_FED_FW_0000022291": "库存组织",
        "P_YS_FED_IMP_IOT0000011381": "孟州市",
        "P_YS_FED_FW_0000022292": "大屏方案2 eChartPanelDisplay2 展现 constructor",
        "P_YS_FED_IMP_IOT0000010050": "新蔡县",
        "P_YS_FED_IMP_IOT0000011380": "昌宁县",
        "P_YS_FED_FW_0000022297": "确定要删除吗?",
        "P_YS_FED_FW_0000022298": "保存失败！",
        "P_YS_FED_FW_0000022295": "暂无图片~",
        "P_YS_FED_FW_0000022296": "请确保数据类型设置正确，启用后不允许调整！",
        "P_YS_FED_EXAMP_0000020041": "建议零售价 :",
        "P_YS_FED_EXAMP_0000020040": "智能补货规则",
        "P_YS_FED_EXAMP_0000020043": "数据错误,请检查！",
        "P_YS_FED_IMP_IOT0000010057": "镇沅彝族哈尼族拉祜族自治县",
        "P_YS_FED_EXAMP_0000020042": "钱包账户信息错误",
        "P_YS_FED_IMP_IOT0000010058": "东港市",
        "P_YS_FED_IMP_IOT0000011388": "路南区",
        "P_YS_FED_IMP_IOT0000011383": "晋州市",
        "P_YS_SD_SDMAUF_0000152734": "你好",
        "P_YS_FED_FW_0000022290": "小于等于",
        "P_YS_FED_IMP_IOT0000010053": "淮滨县",
        "P_YS_FED_IMP_IOT0000011385": "中山区",
        "P_YS_FED_EXAMP_0000020038": "折扣券",
        "P_YS_FED_EXAMP_0000020037": "重量",
        "P_YS_FED_EXAMP_0000020039": "选择行业",
        "P_YS_FED_EXAMP_0000020034": "西单店",
        "P_YS_FED_IMP_IOT0000010059": "瑞丽市",
        "P_YS_FED_EXAMP_0000020033": "请检查退款储值卡是否正确有效",
        "P_YS_FED_EXAMP_0000020036": "本地未适配电子秤",
        "P_YS_FED_EXAMP_0000020035": "的菜单",
        "P_YS_FED_FW_0000022288": "(提示:刷新太频繁会造成服务器压力过大)",
        "P_YS_FED_FW_0000022289": "标题内容不可为空",
        "P_YS_FED_FW_1607450978713862149": "<div>UI模板名称：",
        "P_YS_FED_FW_1607450978713862146": "</div><div>UI模板ID：",
        "P_YS_FED_IMP_IOT0000011392": "汉台区",
        "P_YS_SD_UDHWN_0000122271": "请输入身份证号",
        "P_YS_FED_EXAMP_0000020052": "没有可以执行",
        "P_YS_FED_IMP_IOT0000011398": "武乡县",
        "P_YS_FED_EXAMP_0000020051": "卡号范围内",
        "P_YS_FED_IMP_IOT0000011397": "伊吾县",
        "P_YS_FED_EXAMP_0000020054": "删除行",
        "P_YS_FED_EXAMP_0000020053": "商品档案",
        "P_YS_FED_IMP_IOT0000011399": "新沂市",
        "P_YS_FED_IMP_IOT0000010062": "昌图县",
        "P_YS_FED_IMP_IOT0000010063": "石林彝族自治县",
        "P_YS_FED_EXAMP_0000020050": "业务菜单",
        "P_YS_FED_IMP_IOT0000011395": "双牌县",
        "P_YS_FED_EXAMP_0000020049": "未录入储值卡",
        "P_YS_FED_EXAMP_0000020048": "预订成功",
        "P_YS_FED_EXAMP_0000020045": "交班",
        "P_YS_FED_FW_1420997849809682432": "YYYY-ww周",
        "P_YS_FED_EXAMP_0000020044": "称重设备连接异常！",
        "P_YS_FED_EXAMP_0000020047": "点击是将选择当前优惠券，否则不选。",
        "P_YS_FED_EXAMP_0000020046": "调整",
        "P_YS_FED_FW_0000022299": "主维度排序",
        "P_YS_FED_FW_0000022271": "是否增加排名列",
        "P_YS_FED_FW_0000022272": "确定删除所选模版么？",
        "P_YS_FED_FW_0000022270": "3、逻辑表达式仅支持由“=、!=”构成的等式表达式之间的逻辑运算，例如：",
        "P_YS_FED_IMP_IOT0000010072": "临淄区",
        "P_YS_FED_FW_0000022275": "指标",
        "P_YS_FED_FW_0000022276": "· or运算符（||）：[规格型号]!=null||[物料简称]!=null",
        "P_YS_FED_FW_0000022273": "暂无搜索结果哦~",
        "P_YS_FED_FW_0000022274": "研发中心",
        "P_YS_FED_EXAMP_0000020063": "]所对用的收款方式!",
        "P_YS_FED_EXAMP_0000020062": "商品标签",
        "P_YS_FED_EXAMP_0000020065": "当前单据状态下不允许修改数量！",
        "P_YS_FED_EXAMP_0000020064": "无此优惠券~",
        "P_YS_FED_IMP_IOT0000010074": "宣汉县",
        "P_YS_FED_EXAMP_0000020061": "该卡号已经录入",
        "P_YS_FED_EXAMP_0000020060": "推荐人手机",
        "P_YS_FED_IMP_IOT0000010076": "岑巩县",
        "P_YS_FED_EXAMP_0000020059": "定制",
        "P_YS_FED_EXAMP_0000020056": "无选配",
        "P_YS_FED_EXAMP_0000020055": "（房间号）的房间类型",
        "P_YS_FED_EXAMP_0000020058": "验证码错误",
        "P_YS_FED_EXAMP_0000020057": "售后服务",
        "P_YS_FED_FW_0000022268": "表头",
        "P_YS_FED_FW_0001010614": "图片高度不能超过",
        "P_YS_FED_FW_0000022269": "图片大小要小于 1MB!",
        "P_YS_FED_FW_0001010613": "图片尺寸不能超过",
        "P_YS_FED_FW_0000022266": "大屏方案3 eChartPanelDisplay3展现Render End",
        "P_YS_FED_FW_0001010616": "大图预览",
        "P_YS_FED_FW_0000022267": "大屏轮播:获取模板配置信息。返回 json.data.length",
        "P_YS_FED_FW_0001010615": "像素的图片！",
        "P_YS_FED_FW_0001010618": "图片宽度不能超过",
        "P_YS_FED_FW_0001010617": "删除后不可恢复，确认删除已选附件？",
        "P_YS_FED_FW_0001010619": "只允许上传",
        "P_YS_FED_FW_0000022282": "采购单",
        "P_YS_FED_IMP_IOT0000010080": "古田县",
        "P_YS_FED_FW_0000022283": "计数",
        "P_YS_FED_IMP_IOT0000010081": "长沙县",
        "P_YS_FED_FW_0000022280": "改名",
        "P_YS_FED_IMP_IOT0000010082": "岳池县",
        "P_YS_FED_FW_0000022281": "请增加过滤条件。",
        "P_YS_FED_IMP_IOT0000010083": "尉犁县",
        "P_YS_FED_FW_0000022286": "通过颜色深浅显示数量信息",
        "P_YS_FED_FW_0000022287": "万",
        "P_YS_FED_FW_0000022284": "地图显示",
        "P_YS_FED_FW_0000022285": "至少保留一个显示列！",
        "P_YS_FED_EXAMP_0000020074": "录入的序列号中不存在数值数据，无法自动指定,请检查!",
        "P_YS_FED_EXAMP_0000020073": "本单使用了优惠券收款方式，不允许增行",
        "P_YS_FED_EXAMP_0000020076": "状态下不能进行",
        "P_YS_FED_EXAMP_0000020075": "操作成功",
        "P_YS_FED_EXAMP_0000020070": "请输入结束卡券号",
        "P_YS_FED_IMP_IOT0000010085": "涟水县",
        "P_YS_FED_EXAMP_0000020072": "退货待出",
        "P_YS_FED_EXAMP_0000020071": "整单金额小于原单金额，不能结算!",
        "P_YS_FED_IMP_IOT0000010087": "孙吴县",
        "P_YS_FED_EXAMP_0000020067": "进货价",
        "P_YS_FED_EXAMP_0000020066": "序列号重复!",
        "P_YS_FED_EXAMP_0000020069": "上传中...",
        "P_YS_FED_EXAMP_0000020068": "买断房费",
        "P_YS_FED_FW_0000022279": "未知",
        "P_YS_FED_FW_0000022277": "配置信息中字段验证失败。包含栏目中不存在的字段 转换后",
        "P_YS_FED_FW_0000022278": "显示名称:",
        "P_YS_FED_IMP_IOT0000010092": "申扎县",
        "P_YS_SCM_STOCK_0000034620": "保存并结算",
        "P_YS_SCM_STOCK_0000034621": "这里空空荡荡的～",
        "P_YS_SCM_STOCK_0000034622": "新开单",
        "P_YS_FED_IMP_IOT0000010090": "丰宁满族自治县",
        "P_YS_FED_IMP_IOT0000010099": "牧野区",
        "P_YS_SCM_STOCK_0000034627": "的数据失败！",
        "P_YS_SCM_STOCK_0000034628": "选择业务类型",
        "P_YS_FED_IMP_IOT0000010096": "湘桥区",
        "P_YS_SD_URETAIL_0001048677": "】表出现其他表的数据！具体数据为::",
        "P_YS_FED_FW_0000111015": "当前选择会导致行标题存在重复信息,请检查。",
        "P_YS_FED_EXAMP_0000020010": "套餐没有商品",
        "P_YS_FI_CM_0000029500": "页",
        "P_YS_AM_AMBDF_0001625636": "手电筒",
        "P_YS_FED_EXAMP_0000020005": "模板",
        "P_YS_FED_FW_0001118762": "选择文件格式不正确，请重新选择",
        "P_YS_FED_EXAMP_0000020004": "共",
        "P_YS_FED_FW_0001118763": "支持jpg、bmp、png、jpeg，最大1M，700*700 以上的图片可以在商品详情页主图提供图片放大功能",
        "P_YS_FED_EXAMP_0000020007": "储值卡号为空",
        "P_YS_FED_FW_0001118761": "支持格式：jpg、bmp、png、jpeg",
        "P_YS_FED_EXAMP_0000020001": "支付失败，需撤销",
        "P_YS_FED_FW_0001010620": "像素！",
        "P_YS_FED_EXAMP_0000020000": "促销活动",
        "P_YS_FED_EXAMP_0000020003": "未登录到门店，不能开单",
        "P_YS_FED_EXAMP_0000020002": "促销优惠",
        "P_YS_PF_PRINT_0000065262": "物料名称",
        "P_YS_FED_EXAMP_0000020009": "该商品执行过促销活动，退品后可能不满足原促销条件！",
        "P_YS_FED_EXAMP_0000020008": "会员账号为空",
        "P_YS_FED_FW_0000137655": "必输项<%=text%>未输入，请输入完整再尝试保存！",
        "P_YS_FED_FW_0000137654": "Refer关联定义",
        "P_YS_FED_FW_0000137653": "value值格式错误",
        "P_YS_FED_FW_0000137652": "有错误",
        "P_YS_FED_FW_0000137651": "未获得billType",
        "P_YS_FED_FW_0000137650": "未配置tree 的billnumber ,在commend表的target中设置",
        "P_YS_FED_EXAMP_0000020021": "西直门店",
        "P_YS_FED_EXAMP_0000020020": "按钮的功能权限，不能操作！",
        "P_YS_PF_QITDFE_0001344211": "导出异常原因",
        "P_YS_SD_SDMAUF_0000152710": "页签名称",
        "P_YS_FED_EXAMP_0000020016": "首页",
        "P_YS_FED_EXAMP_0000020015": "经营概况",
        "P_YS_FED_EXAMP_0000020018": "开始卡券号和结束卡券号长度必须相等",
        "P_YS_FED_EXAMP_0000020017": "卡券非原单退,卡券数量应为-1,请勾选退货商品",
        "P_YS_FED_EXAMP_0000020012": "仅选择一条单据情况下才能执行确定操作！",
        "P_YS_FED_EXAMP_0000020011": "此操作不能恢复，所选零售单是否已开票完毕？",
        "P_YS_FED_FW_0001557217": "【第<%=text%>行】",
        "P_YS_FED_EXAMP_0000020014": "预订交货状态",
        "P_YS_FED_EXAMP_0000020013": "储值业务类型下不能使用会员钱包支付",
        "P_YS_FED_FW_0000137649": "参照自定义项错误：",
        "P_YS_FED_EXAMP_0000020019": "机构人员",
        "P_YS_FED_FW_0000137666": "Tag关联定义",
        "P_YS_FED_FW_0000137665": "列表cCarry JSON格式错误-->",
        "P_YS_FED_FW_0000137664": "孙表暂存出错",
        "P_YS_FED_FW_0000137663": "[{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"菜单\\\",\\\"key\\\":\\\"menu\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"权限\\\",\\\"key\\\":\\\"auth\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"按钮权限\\\",\\\"key\\\":\\\"actionAuth\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"规则\\\",\\\"key\\\":\\\"rule\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"选项\\\",\\\"key\\\":\\\"option\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"枚举\\\",\\\"key\\\":\\\"enum\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"ViewModel\\\",\\\"key\\\":\\\"viewmodel\\\"}]",
        "P_YS_FED_FW_0000137661": "保存失败--【",
        "P_YS_SCM_STOCK_0000034610": "验货中",
        "P_YS_FED_FW_0000137660": "menu中预制的billtype:",
        "P_YS_SCM_STOCK_0000034612": "无现金支付时实收大于应收，无法结算",
        "P_YS_SCM_STOCK_0000034613": ", 比例不得低于",
        "P_YS_FED_EXAMP_0000020030": "每天送",
        "P_YS_FED_EXAMP_0000020032": "确定要切换门店吗？该操作将重新刷新页面！",
        "P_YS_SCM_STOCK_0000034615": "单据编号/联系人/联系电话",
        "P_YS_FED_EXAMP_0000020031": "重量不合法",
        "P_YS_SCM_STOCK_0000034617": "退款时不能使用",
        "P_YS_FED_EXAMP_0000020027": "(最多选择",
        "P_YS_FED_EXAMP_0000020026": "卡券原单退功能",
        "P_YS_FED_EXAMP_0000020029": "违规下架",
        "P_YS_FED_EXAMP_0000020028": "受控对象",
        "P_YS_FED_EXAMP_0000020023": "营业员",
        "P_YS_FED_EXAMP_0000020022": "近30天",
        "P_YS_FED_EXAMP_0000020025": "以下商品存量不足，请调整！",
        "P_YS_FED_FW_0000137659": "未在表单中定义",
        "P_YS_FED_FW_0000137658": "参照携带字段",
        "P_YS_FED_FW_0000137657": "保存失败---以下数据项校验失败：",
        "P_YS_FED_FW_0000137656": "删除<%=text%>失败!",
        "P_YS_FED_FW_0000137677": "删除多条数据时候，id为：",
        "P_YS_FED_FW_0000137676": "数据删除时候出错；错误为：",
        "P_YS_FED_FW_0000137675": "openDB参数错误！",
        "P_YS_FED_FW_0000137674": "图形报表&热区日志",
        "P_YS_FED_FW_0000137673": "连接数据库成功",
        "P_YS_FED_FW_0000022210": "柱状展现",
        "P_YS_FED_FW_0000137672": "的数据",
        "P_YS_FED_FW_0000137671": "数据库版本变化时触发（发生upgradeneeded事件，或调用indexedDB.deleteDatabase()）",
        "P_YS_FED_FW_0000137670": "方法不存在",
        "P_YS_FED_FW_0000022208": "纳税人识别号",
        "P_YS_FED_FW_0000022209": "eChartDisplay状态改变 shouldComponentUpdate  params changed End True",
        "P_YS_FED_FW_0000022202": "初始化条件中没有Model。",
        "P_YS_FED_FW_0000022203": "测试文字是否按规则显示测试文字是否按规则显示测试文字是否按规则显示",
        "P_YS_FED_FW_0000022200": "当前",
        "P_YS_PF_PROCENTER_1518927132915400722": "的值",
        "P_YS_FED_FW_0000022201": "获取表单模板列表失败！",
        "P_YS_FED_FW_0000022206": "· 文本类型字段：[客户名称]、[物料详情.物料简称]=[物料名称]",
        "P_YS_FED_FW_0000022207": "大屏方案 设计 doSetImageText info",
        "P_YS_FED_FW_0000137669": "url condition 参数JSON格式错误-->",
        "P_YS_FED_FW_0000137668": "校验失败：",
        "P_YS_FED_FW_0000022205": "下移",
        "P_YS_FED_FW_0000137688": "生单工作台传入参数中没有viewModel！",
        "P_YS_FED_FW_0000137687": "修改后ContainerModel中的脏数据字段 ：",
        "P_YS_FED_FW_0000137686": "加载图片错误。imgUrl =",
        "P_YS_FED_FW_0001219316": "请选择表体数据",
        "P_YS_FED_FW_0000137685": "删除多条数据时候tansaction error:",
        "P_YS_FED_FW_0000022220": "热区设置图 在CStyle中未能找到全部的热区配置字段 codeField nameField fieldsCaption mapConfigField",
        "P_YS_FED_FW_0000137684": "取消选择图片",
        "P_YS_FED_FW_0000022221": "新增分组",
        "P_YS_FED_FW_0000137683": "表全部数据失败！",
        "P_YS_FED_FW_0000137682": "上一次的数据库连接还未关闭",
        "P_YS_FED_FW_0000137681": "成功保存多条数据:",
        "P_YS_FED_FW_0000137680": "成功保存id为",
        "P_YS_FED_FW_0001617303": "%c发起后端计算接口 /bill/executeFormulaCalculate： =>params =>action =>rule =>exprTag =>childTrigger",
        "P_YS_FED_FW_0001221613": "失败,返回信息：",
        "P_YS_FED_FW_0001221611": "未发现有效数据",
        "P_YS_FED_FW_0000022219": "图表列数",
        "P_YS_FED_FW_0000022213": "无权",
        "P_YS_FED_FW_0000022214": "已选菜单",
        "P_YS_FED_FW_0000022211": "文件必须小于",
        "P_YS_SD_SDMA_0000098574": "加",
        "P_YS_FED_FW_0000022212": "条，成功",
        "P_YS_FED_FW_0000022217": "纬度",
        "P_YS_FED_FW_0000022218": "负责人",
        "P_YS_SD_SDMAF_0000137273": "收货",
        "P_YS_FED_FW_0000022215": "分组",
        "P_YS_FED_FW_0000137679": "你的浏览器不支持IndexedDB!",
        "P_YS_FED_FW_0000022216": "保存全部",
        "P_YS_FED_FW_0000137678": "数据库意外关闭",
        "P_YS_FED_FW_0000137699": "单据批改 row=",
        "P_YS_FED_FW_0000137698": "备注portal--tabs",
        "P_YS_FED_FW_0000137697": ":::[StatusBar] , 组件过期，不推荐使用.....",
        "P_YS_FED_FW_0000137696": "clearDimensionCache成功:groupCode =",
        "P_YS_FED_FW_0000137695": "clearDimensionCache失败: json.message =",
        "P_YS_FED_FW_0000137694": "删除分组条件失败。信息 :",
        "P_YS_FED_FW_0000137693": "setShowActionRows------参数错误！",
        "P_YS_FED_FW_0000137692": "related控件不显示  EcsuiteChat Render this.keyModel.getValue() =",
        "P_YS_FED_FW_0000137691": "列表批改 调用批改列表服务  参数 /bill/batchModify ----->",
        "P_YS_FED_FW_0001060913": "即时分析",
        "P_YS_FED_FW_0000137690": "获取分组条件失败。信息 :",
        "P_YS_FED_FW_0001060919": "-即时分析",
        "P_YS_FED_IMP_IOT0000005597": "印江土家族苗族自治县",
        "P_YS_FED_IMP_IOT0000005599": "湾里区",
        "P_YS_FED_IMP_IOT0000005591": "景东彝族自治县",
        "P_YS_FED_IMP_IOT0000005592": "永平县",
        "P_YS_FED_FW_1524239912962359303": "您的浏览器不支持此种视频格式。",
        "P_YS_FED_IMP_IOT0000005595": "富宁县",
        "P_YS_FED_FW_0000137689": "单据批改 符合条件行信息 ----->",
        "P_YS_FED_FW_1578184126673977344": "appCode使用错误，请联系文件服务朱士友zhushy@yonyou.com",
        "P_YS_FED_FW_0001060905": "成功调用custom/do/",
        "P_YS_FED_FW_0001060906": "select 没有model",
        "P_YS_FED_FW_0001060907": "输入的整数的最大长度不能大于",
        "P_YS_FED_IMP_IOT0000005586": "安新县",
        "P_YS_FED_IMP_IOT0000005585": "连云港",
        "P_YS_FED_IMP_IOT0000005588": "岱岳区",
        "P_YS_FED_IMP_IOT0000005587": "遂溪县",
        "P_YS_FED_IMP_IOT0000005589": "德江县",
        "P_YS_FED_IMP_IOT0000005580": "钟楼区",
        "P_YS_FI_FP_0001073056": "主表：",
        "P_YS_FED_IMP_IOT0000005582": "二连浩特市",
        "P_YS_FED_IMP_IOT0000005581": "库伦旗",
        "P_YS_FED_FW_0001287431": "列宽自适应",
        "P_YS_FED_FW_0001287435": "[object Object]",
        "P_YS_FI_CM_0000029573": "刪除",
        "P_YS_FED_IMP_IOT0000006784": "潜山县",
        "P_YS_FED_IMP_IOT0000006787": "南安市",
        "P_YS_FED_IMP_IOT0000006789": "陆川县",
        "draft": "草稿",
        "P_YS_FED_IMP_IOT0000006781": "平远县",
        "P_YS_FED_IMP_IOT0000006782": "兴业县",
        "P_YS_PF_METADATA_0000085603": "优先级",
        "P_YS_FED_FW_1530670329410093060": "<=b ---小于等于b",
        "P_YS_FED_FW_1530670329410093066": ">=a ---大于等于a",
        "P_YS_FED_FW_1530670329410093063": ">a ---大于a",
        "P_YS_FED_FW_0001503457": "填写信息有误!请重新填写",
        "P_YS_FED_IMP_IOT0000005442": "删除成功",
        "P_YS_FED_IMP_IOT0000006773": "呈贡县",
        "P_YS_FED_IMP_IOT0000006775": "上杭县",
        "P_YS_FED_IMP_IOT0000006778": "文水县",
        "P_YS_FED_IMP_IOT0000006777": "乳山市",
        "P_YS_FED_IMP_IOT0000005448": "模板名称",
        "P_YS_FED_FW_1530670329410093069": "<b ---小于b",
        "P_YS_FED_IMP_IOT0000006770": "秦城区",
        "P_YS_FED_IMP_IOT0000006763": "稷山县",
        "P_YS_FED_FW_0001249386": "下载/制作模板工作台",
        "P_YS_FED_FW_0001249385": "支持excel格式，文件大小限制不超过",
        "P_YS_FED_FW_0001249388": "异常位置",
        "P_YS_FED_IMP_IOT0000006764": "泊头市",
        "P_YS_FED_FW_0001249387": "导出异常数据",
        "P_YS_FED_IMP_IOT0000006767": "旌德县",
        "P_YS_FED_IMP_IOT0000006766": "新建县",
        "P_YS_FED_FW_0001249389": "请重新上传文件",
        "P_YS_SCM_STOCK_0001082855": "获取数据错误",
        "P_YS_PF_GZTTMP_0000079071": "单据时间",
        "P_YS_FED_IMP_IOT0000006761": "美溪区",
        "P_YS_FED_IMP_IOT0000006759": "洛扎县",
        "P_YS_SD_SDMB_0000150374": "未查询到数据",
        "P_YS_FED_IMP_IOT0000005422": "未确认",
        "P_YS_FED_IMP_IOT0000005424": "编辑",
        "P_YS_FED_IMP_IOT0000006755": "榕城区",
        "P_YS_FED_IMP_IOT0000006757": "奎屯市",
        "P_YS_FED_IMP-DFM-FE_0000020911": "显示全部",
        "P_YS_FED_IMP-DFM-FE_0000020910": "清除选择",
        "P_YS_FED_IMP_IOT0000006748": "德保县",
        "P_YS_FED_UIMG_0001050959": "查询方案列表",
        "P_YS_FED_IMP_IOT0000006740": "青白江区",
        "P_YS_FED_IMP_IOT0000006742": "陵县",
        "P_YS_FED_IMP_IOT0000006745": "峨边彝族自治县",
        "P_YS_FED_IMP_IOT0000005413": "操作",
        "P_YS_FED_IMP_IOT0000006747": "临县",
        "P_YS_PF_SOCD-K_0000182238": "千克",
        "P_YS_FED_IMP_IOT0000006738": "永福县",
        "P_YS_FED_IMP_IOT0000006737": "新和县",
        "P_YS_FI_CM_0000029543": "一月",
        "P_YS_FED_IMP_IOT0000006730": "台江区",
        "P_YS_FED_IMP_IOT0000006731": "康县",
        "P_YS_FED_IMP_IOT0000006733": "东营区",
        "P_YS_FED_IMP_IOT0000006736": "曹县",
        "P_YS_FED_IMP_IOT0000006735": "湘潭县",
        "P_YS_FED_IMP_IOT0000006728": "庆城县",
        "P_YS_FED_FW_0001377458": "/iprint/用友云打印助手.exe",
        "P_YS_FED_UIMG_0001050970": "隐藏关联字段会对运行时产生影响，请谨慎操作",
        "P_YS_FED_IMP_IOT0000006721": "罗田县",
        "P_YS_FED_IMP_IOT0000006720": "黄陵县",
        "P_YS_FED_FW_0001208829": "选择信息重复。",
        "P_YS_FED_UCFORG_0000088691": "再缩小就看不清了",
        "P_YS_FED_UCFORG_0000088692": "已到放大极限",
        "P_YS_FED_IMP_IOT0000006715": "孟津县",
        "P_YS_FED_IMP_IOT0000006717": "滨城区",
        "P_YS_PF_GZTSYS_0001010812": "企业认证",
        "P_YS_FED_UIMG_0001050967": "模板校验失败",
        "P_YS_FED_UIMG_0001050968": "当前搜索结果对应实体元数据的属性，非UI元数据属性",
        "P_YS_FED_IMP_IOT0000006714": "无极县",
        "P_YS_FI_CM_0000029569": "七月",
        "P_YS_FED_UIMG_0001050969": "确定删除栏目",
        "P_YS_FED_IMP_IOT0000006705": "正定县",
        "P_YS_FED_IMP_IOT0000006704": "科尔沁左翼中旗",
        "P_YS_FED_IMP_IOT0000006700": "龙游县",
        "P_YS_FED_FW_0001142513": "[mdf-cube] [lineNoGenerator] [_binaryGenerate()] 不能处理的index[",
        "P_YS_FED_IMP_IOT0000006702": "丰县",
        "P_YS_FED_FW_0001142515": ", 按照",
        "P_YS_FED_FW_0001142514": "%c未识别的status:",
        "P_YS_FED_FW_0001142517": "至少设置一个搜索列！",
        "P_YS_FED_FW_0001142516": "状态处理",
        "P_YS_FED_FW_1565223229652992000": "公式赋值 表头特征 >>:",
        "P_YS_FED_MDF-COMPS_0001378486": "基准语言",
        "P_YS_FED_MDF-COMPS_0001378484": "基准语言为空时，则默认取当前语言内容。",
        "P_YS_SD_UDHWN_0000049167": "图木舒克市",
        "P_YS_PF_GZTSYS_0001010835": "多语言",
        "P_YS_FED_FW_1554678844398501896": "%c批量触发动作： setCellStates >>>",
        "P_YS_FED_FW_0001377414": "/ 当前页面筛选出",
        "P_YS_FED_FW_0001377415": "当前页面筛选出",
        "P_YS_FI_FCWEB_0001498545": "结果：",
        "P_YS_FED_FW_1534689396612136962": "当前访问的是用友企业云API，公网才能访问，专属化环境访问不到",
        "P_YS_SD_UDHMC_0000130713": "收起更多",
        "P_YS_FED_FW_0001026227": "<%=text%>参照",
        "P_YS_FED_FW_1497486003344506888": "请点击侧栏中的候选条件进行添加",
        "P_YS_FED_IMP_IOT0000011306": "高安市",
        "P_YS_FED_FW_0001141221": "%cGroup:meta客户端缓存信息",
        "P_YS_FED_IMP_IOT0000011303": "雷波县",
        "P_YS_FED_IMP_IOT0000011305": "衡阳县",
        "P_YS_HR_HRJQ_0000031143": "无",
        "P_YS_PF_METADATA_0000086908": "矩形",
        "P_YS_FED_IMP_IOT0000011310": "芜湖县",
        "P_YS_FED_FW_0001141240": "按钮点击，调用dropdownbutton组件内部handleMenuClick方法结束",
        "P_YS_FED_IMP_IOT0000011318": "沙县",
        "P_YS_FED_IMP_IOT0000011319": "团风县",
        "P_YS_FED_IMP_IOT0000011314": "扎兰屯市",
        "P_YS_FED_IMP_IOT0000011313": "香格里拉县",
        "P_YS_FED_FW_0001141239": "按钮点击，调用dropdownbutton组件内部handleButtonClick方法结束",
        "P_YS_FED_FW_0001141238": "按钮点击，调用dropdownbutton组件内部handleMenuClick方法开始",
        "P_YS_FED_FW_0001295958": "请您注册appcode",
        "P_YS_SD_UDHWN_0000050125": "天门市",
        "P_YS_SD_UDHWN_0000050128": "浦东新区",
        "P_YS_FED_IMP_IOT0000011321": "珲春市",
        "P_YS_FED_IMP_IOT0000011320": "安多县",
        "P_YS_FED_FW_0001141241": "按钮点击，调用dropdownbutton组件内部handleButtonClick方法开始",
        "P_YS_FED_IMP_IOT0000011328": "崇阳县",
        "P_YS_FED_FW_0001065806": "输入错误",
        "P_YS_FED_FW_0001141246": "以下<%=text%>字段不能为空",
        "P_YS_FED_FW_0001065807": "IP格式错误！",
        "P_YS_FED_IMP_IOT0000011324": "汨罗市",
        "P_YS_FED_FW_0001065805": "邮箱格式错误！",
        "P_YS_FED_FW_0001141247": "第<%=text%>行",
        "P_YS_FED_FW_0001026213": "<%=text%><%=cName%>",
        "P_YS_HR_HRJQ_0000031164": "失败！",
        "P_YS_FED_IMP_IOT0000011332": "沿河土家族自治县",
        "P_YS_FED_IMP_IOT0000010001": "肇州县",
        "P_YS_FED_FW_0001094323": "请求接口:",
        "P_YS_FED_FW_0001094324": ", 返回值为:",
        "P_YS_FED_FW_0001612626": "获取操作列失败",
        "P_YS_FED_IMP_IOT0000010008": "端州区",
        "P_YS_PF_GZTSYS_0000012963": "库管员",
        "P_YS_FED_IMP_IOT0000010009": "璧山县",
        "P_YS_FED_IMP_IOT0000010004": "清河门区",
        "P_YS_FED_IMP_IOT0000011338": "殷都区",
        "P_YS_FED_IMP_IOT0000011337": "呼和浩特",
        "P_YS_FED_IMP_IOT0000010007": "高港区",
        "P_YS_SD_URETAIL_0001048820": "】indexedDB中【",
        "P_YS_FED_FW_0000022370": "显示时分",
        "P_YS_FED_FW_0000021040": "门店编码",
        "P_YS_FED_FW_0000022371": "当前语种",
        "P_YS_FED_FW_0000021043": "咸宁市",
        "P_YS_FED_FW_0000022374": "配置文件中交叉点为空或者配置字段不存在于源表栏目中，请检查。",
        "P_YS_FED_FW_0000021044": "江门市",
        "P_YS_FED_FW_0000022375": "显示角度应该在0-60之间",
        "P_YS_FED_FW_0000021041": "常德市",
        "P_YS_FED_FW_0000022372": "getMeasureValues没有在1维表找到 t2DRowKey =",
        "P_YS_FED_FW_0000021042": "完成",
        "P_YS_FED_FW_0000022373": "报表分组方案配置信息-行列布局",
        "P_YS_FED_IMP_IOT0000011224": "立山区",
        "P_YS_FED_FW_0001065868": ",已将输入精度设置为",
        "P_YS_FED_FW_0001065869": "输入的整数长度为",
        "P_YS_FED_IMP_IOT0000011226": "康定县",
        "P_YS_FED_IMP_IOT0000011228": "临夏市",
        "P_YS_FED_FW_0000022367": "亿",
        "P_YS_FED_FW_0000021036": "筛选",
        "P_YS_FED_IMP_IOT0000009011": "巴州区",
        "P_YS_FED_FW_0000022368": "请录入正确的数值",
        "P_YS_FED_FW_0000021037": "长春市",
        "P_YS_FED_IMP_IOT0000009012": "嵩县",
        "P_YS_FED_FW_0000021034": "天气",
        "P_YS_FED_FW_0000022366": "修改成功！",
        "P_YS_FED_FW_0000021035": "贵阳市",
        "P_YS_FED_IMP_IOT0000009016": "新宁县",
        "P_YS_FED_FW_0000022369": "(推荐)",
        "P_YS_FED_FW_0000021038": "set参数格式应是：{key: someKey, value: someValue}或者：[{key: someKey, value: someValue}]",
        "P_YS_FED_IMP_IOT0000009013": "孝南区",
        "P_YS_PF_SOCD-O_0000182516": "专科",
        "P_YS_FED_FW_0000021039": "柱折图示例",
        "P_YS_FI_FP_0000034880": "维护",
        "P_YS_FED_FW_0000021050": "一列",
        "P_YS_FED_FW_0000022381": "请输入0-99数字",
        "P_YS_FED_FW_0000021051": "黑河市",
        "P_YS_FED_FW_0000022382": "秒,系统设置轮播时间。cb.rest.AppContext.option.screenPlayTime",
        "P_YS_FED_FW_0000022380": "获取图形报表 /report/list 本次List请求开始 时间 =",
        "P_YS_FED_FW_0000021054": "连接数据库失败",
        "P_YS_FED_FW_0000022385": "保留内层边框",
        "P_YS_FED_FW_0000021055": "饼形图配置信息-eChartSetting",
        "P_YS_FED_FW_0000022386": "空分组项",
        "P_YS_FED_FW_0000021052": "西藏",
        "P_YS_FED_FW_0000022383": "暂无搜索结果~",
        "P_YS_FED_FW_0000021053": "吉安市",
        "P_YS_FED_FW_0000022384": "内外径请输入0到100的整数，且外径大于内径。",
        "P_YS_FI_FP_0000034879": "上月",
        "P_YS_FED_IMP_IOT0000011231": "罗江县",
        "P_YS_FED_IMP_IOT0000011230": "灌南县",
        "P_YS_FED_IMP_IOT0000009009": "丹凤县",
        "P_YS_FED_IMP_IOT0000009006": "逊克县",
        "P_YS_FED_FW_0001317858": "该子表中存在未校验通过的字段，可进入详情中查看",
        "P_YS_FED_IMP_IOT0000009007": "绥棱县",
        "P_YS_FED_IMP_IOT0000011237": "思南县",
        "P_YS_FED_IMP_IOT0000011236": "邵阳县",
        "P_YS_PF_SOCD-O_0000182522": "本科",
        "P_YS_FED_FW_0000021047": "定西市",
        "P_YS_FED_FW_0000022378": "无法找到",
        "P_YS_FED_IMP_IOT0000009000": "镇宁布依族苗族自治县",
        "P_YS_FED_FW_0000021048": "海北藏族自治州",
        "P_YS_FED_FW_0000022379": "名使用涟漪特效",
        "P_YS_FED_FW_0000021045": "黑龙江",
        "P_YS_FED_FW_0000022376": "纬度字段不可为空",
        "P_YS_FED_FW_0000021046": "左2右1",
        "P_YS_FED_FW_0000022377": "过滤表达式",
        "P_YS_HR_HRJQ_0000031063": "已驳回",
        "P_YS_FED_FW_0000021049": "吴忠市",
        "P_YS_FED_IMP_IOT0000009002": "东宝区",
        "P_YS_SD_URETAIL_0001048725": "离线数据转换状态成功",
        "P_YS_FED_FW_0000022352": "布局",
        "P_YS_FED_FW_0000021021": "导出数据不允许为空，请重新选择后重试！",
        "P_YS_FED_FW_0000022353": "查看错误日志",
        "P_YS_FED_FW_0000021022": "日",
        "P_YS_FED_FW_0000022350": "请填写正确的电话号码",
        "P_YS_FED_FW_0000021020": "新增",
        "P_YS_FED_FW_0000022351": "请输入关键词",
        "P_YS_FED_IMP_IOT0000011243": "广河县",
        "P_YS_FED_IMP_IOT0000011246": "工布江达县",
        "P_YS_FED_FW_0001255142": "此功能需要远程地图，当前无法访问公网，暂时无法使用~",
        "P_YS_FED_IMP_IOT0000011240": "丁青县",
        "P_YS_FED_IMP_IOT0000011241": "阜新蒙古族自治县",
        "P_YS_FED_IMP_IOT0000011248": "恩平市",
        "P_YS_FED_IMP_IOT0000011247": "房县",
        "P_YS_FED_FW_0000021014": "启用",
        "P_YS_FED_FW_0000022345": "图片仅支持",
        "P_YS_FED_FW_0000022346": "数据类型不可为空字符。",
        "P_YS_FED_FW_0000021015": "日期",
        "P_YS_FED_FW_0000022343": "发布报表方案失败。err",
        "P_YS_FED_FW_0000021012": "删除时要做业务引用校验，可能等待的时间较长，是否确认删除？",
        "P_YS_FED_FW_0000022344": "-----------点击事件  scatterData",
        "P_YS_FED_FW_0000021013": "是否确认删除此",
        "P_YS_FED_FW_0000022349": "设置为默认查询方案",
        "P_YS_FED_FW_0000021018": "四",
        "P_YS_FED_FW_0000021019": "请选择有效数据",
        "P_YS_FED_FW_0000022347": "签名保存成功",
        "P_YS_FED_FW_0000021016": "所选数据中存在不符合生单规则的数据！",
        "P_YS_FED_FW_0000022348": "饼形图展示指标只支持单选",
        "P_YS_FED_FW_0000021017": "确定要",
        "P_YS_FED_FW_0000022360": "数据类型不可为空,请检查。",
        "P_YS_FED_FW_0000021032": "没有取到提交参数",
        "P_YS_FED_FW_0000022363": "已经存在当前菜单，是否覆盖？",
        "P_YS_FED_FW_0000022364": "监控视图 删除刷新频率定时器 renderTime",
        "P_YS_FED_FW_0000021033": "元数据未配置cCardKey",
        "P_YS_FED_FW_0000022361": "格式化",
        "P_YS_FED_FW_0000021030": "模板内容导入失败,返回信息：",
        "P_YS_FED_FW_0000022362": "编辑区",
        "P_YS_FED_FW_0000021031": "日期时间",
        "P_YS_FED_IMP_IOT0000011255": "怀来县",
        "P_YS_FED_IMP_IOT0000011254": "西区",
        "P_YS_FED_IMP_IOT0000011256": "龙文区",
        "P_YS_FED_IMP_IOT0000011251": "津市市",
        "P_YS_FED_IMP_IOT0000011259": "平南县",
        "P_YS_FED_FW_0000022356": "全部类别",
        "P_YS_FED_FW_0000022357": "报表设置的自动刷新间隔太短。 refreshInterval",
        "P_YS_FED_FW_0000021026": "星期",
        "P_YS_FED_FW_0000022354": "轻度",
        "P_YS_FED_FW_0000021023": "失败：",
        "P_YS_FED_FW_0000022355": "请设置显示内容",
        "P_YS_FED_FW_0000021029": "参照数据中无此条记录！请重试",
        "P_YS_FED_FW_0000022358": "去重计数",
        "P_YS_FED_FW_0000021027": "该操作将会删除当前",
        "P_YS_FED_FW_0000022359": "提示信息",
        "P_YS_FED_FW_0000021028": "请选择组织！",
        "P_YS_FED_FW_0000021083": "包头市",
        "P_YS_FED_FW_0000021084": "开封市",
        "P_YS_FED_FW_0000021081": "三明市",
        "P_YS_FED_IMP_IOT0000011260": "册亨县",
        "P_YS_FED_FW_0000021082": "阿里地区",
        "P_YS_FED_FW_0000021087": "聊城市",
        "P_YS_FED_FW_0000021088": "荆州市",
        "P_YS_FED_FW_0000021085": "黄石市",
        "P_YS_FED_FW_0000021086": "普洱市",
        "P_YS_FED_IMP_IOT0000011266": "东乌珠穆沁旗",
        "P_YS_FED_FW_0001317893": "还没有报表哦",
        "P_YS_FED_FW_0000021080": "遂宁市",
        "P_YS_SD_SDMB_0000139941": "行数据",
        "P_YS_SD_UDHWS_0000118032": "普通仓",
        "P_YS_FED_FW_0000021078": "自定义时间",
        "P_YS_FED_FW_0001008402": "参照编辑",
        "P_YS_SD_SDDM-UI_0001141637": "微博",
        "P_YS_FED_FW_0000021079": "看板配置信息-大屏-行列布局",
        "P_YS_HR_HRJQF_0000053894": "是否取消",
        "P_YS_FED_FW_0000021094": "玉溪市",
        "P_YS_FED_FW_0000021095": "柱形图配置信息-yySetting",
        "P_YS_FED_FW_0000021092": "长治市",
        "P_YS_FED_IMP_IOT0000011271": "陆良县",
        "P_YS_FED_FW_0000021093": "累计",
        "P_YS_FED_FW_0000021098": "襄阳市",
        "P_YS_FED_FW_0000021099": "福州市",
        "P_YS_FED_FW_0000021096": "eChartDisplay 散点图地图信息不正确 errInfo =",
        "P_YS_FED_FW_0000021097": "延安市",
        "P_YS_FED_IMP_IOT0000011277": "徐闻县",
        "P_YS_FED_IMP_IOT0000011276": "带岭区",
        "P_YS_FED_IMP_IOT0000011278": "建湖县",
        "P_YS_FED_FW_0000021090": "左1右2",
        "P_YS_FED_IMP_IOT0000011273": "溆浦县",
        "P_YS_FED_FW_0000021091": "资阳市",
        "P_YS_FED_FW_0000021089": "移动报表 MobileData renderTable  mobileDataScale",
        "P_YS_FED_FW_0000021061": "陇南市",
        "P_YS_FED_FW_0000022392": "月",
        "P_YS_FED_IMP_IOT0000011280": "威县",
        "P_YS_FED_FW_0000021062": "扇区数值",
        "P_YS_FED_FW_0000022393": "没有规格值",
        "P_YS_FED_FW_0000022390": "大屏方案2 eChartPanelDisplay2展现Render End",
        "P_YS_FED_IMP_IOT0000011282": "武义县",
        "P_YS_FED_FW_0001509661": "搜索或点击箭头选择",
        "P_YS_FED_FW_0000021060": "大连市",
        "P_YS_FED_FW_0000022391": "匹配一维表的行时，当前行前面已经匹配过，请检查。 rowItemMatchInfo =",
        "P_YS_FED_IMP_IOT0000011281": "江宁区",
        "P_YS_HR_HRJQF_0000053875": "月份",
        "P_YS_HR_HRJQF_0001044571": "王五",
        "P_YS_FED_FW_0000021065": "河池市",
        "P_YS_FED_FW_0000022396": "显示秒",
        "P_YS_FED_FW_1622974871736680453": "记录上下文调用次数",
        "P_YS_FED_FW_0000021066": "折线图配置信息-yySetting",
        "P_YS_FED_FW_0000022397": "仅支持JPG、JPEG、BMP、PNG格式，文件小于2M",
        "P_YS_FED_FW_0000021063": "湘西土家族苗族自治州",
        "P_YS_FED_FW_0000021064": "柱形图配置信息-eChartSetting",
        "P_YS_FED_FW_0000022395": "优",
        "P_YS_FED_IMP_IOT0000011289": "蒙城县",
        "P_YS_FED_IMP_IOT0000011286": "秀英区",
        "P_YS_FED_FW_0000021058": "迪庆藏族自治州",
        "P_YS_FED_FW_0000022389": "桌面看板已保存。",
        "P_YS_FED_FW_0000021059": "金华市",
        "P_YS_FED_FW_0000021056": "移动报表 MobileReportSum filterClick",
        "P_YS_FED_FW_0000021057": "鸡西市",
        "P_YS_FED_FW_0000022388": "当前报表没有移动过滤方案，不能发布到移动端。filterId",
        "P_YS_SD_UDHWN_0000050084": "密云县",
        "P_YS_FED_FW_0000021072": "成功保存",
        "P_YS_FED_FW_0000021073": "排名表示例",
        "P_YS_FED_FW_0000021070": "拍照",
        "P_YS_FED_FW_0000021071": "-----------点击事件 scatterData",
        "P_YS_FED_FW_0000021076": "克孜勒苏柯尔克孜自治州",
        "P_YS_FED_FW_0000021077": "衡阳市",
        "P_YS_FED_FW_0000021074": "销售",
        "P_YS_FED_FW_1428685300106788864": "被除数不能为 0",
        "P_YS_FED_FW_0000021075": "读取多条数据失败！",
        "P_YS_FED_IMP_IOT0000011295": "新罗区",
        "P_YS_PF_SOCD-O_0000182541": "高中",
        "P_YS_FED_FW_0000021069": "日喀则地区",
        "P_YS_SD_UDHWS_0000119391": "不正确",
        "P_YS_FED_FW_0000021067": "伊春市",
        "P_YS_FED_FW_0000022398": "新增查询方案",
        "P_YS_FED_FW_0000021068": "条形图示例",
        "P_YS_FED_FW_0000022399": "获取dimension失败:",
        "P_YS_FED_FW_0001065870": "输入的整数长度不能大于15位",
        "P_YS_FED_FW_1583596695997382657": "已勾选“移动端展现”，是否设置移动端布局？",
        "P_YS_OA_YBMOB_0000036871": "下拉刷新",
        "P_YS_FED_FW_1583596695997382660": "请设置移动端布局。",
        "P_YS_IMP_HSE-UI_0001216387": "子表页签",
        "P_YS_FI_CM_0000029614": "二月",
        "P_YS_SD_SDSD-FE_0001491485": "規格",
        "P_YS_PF_ANALYTIC-FE_0001652194": "移动端布局",
        "P_YS_SD_SDSD-FE_0001491490": "單價",
        "P_YS_FED_FW_0001221777": "是否确认<%=cCaption%>选中的<%=text%>",
        "P_YS_FED_FW_0001010742": "有异步处理正在进行，请检查。",
        "P_YS_FI_CM_0000029625": "三月",
        "P_YS_FI_CM_0000029624": "返回首页",
        "P_YS_FED_FW_1476478433683308552": "图例1",
        "P_YS_FED_FW_1476478433683308555": "图例2",
        "P_YS_FED_FW_1528487034344701957": "点击确定过滤空值",
        "P_YS_OA_YBMOB_0000036891": "暂无相关数据",
        "P_YS_FED_FW_0001148642": "搜索(control+回车)",
        "P_YS_OA_YBMOB_0000036890": "文件",
        "P_YS_OA_XTMENHU_0000046524": "待办中心",
        "P_YS_FI_CM_0000029635": "单选框",
        "P_YS_FED_IMP-DFM-FE_0000020869": "箭头",
        "P_YS_FED_IMP-DFM-FE_0000020868": "操作",
        "P_YS_PF_PRINT_0000065360": "项目编码",
        "P_YS_FED_FW_0000022330": "请输入纳税人识别号",
        "P_YS_FED_FW_0000021000": "级",
        "P_YS_FED_FW_0000022331": "初始化eChartDisplay的props里没有viewModel",
        "P_YS_SD_SDMAF_0000137147": "信息提示",
        "P_YS_FED_IMP-DFM-FE_0000020875": "编辑",
        "P_YS_FED_IMP-DFM-FE_0000020872": "°",
        "P_YS_FED_FW_0000022329": "没有可设置信息。",
        "P_YS_FED_IMP_IOT0000005499": "全部",
        "P_YS_FED_FW_1550269983163940871": "预警信息提示：",
        "P_YS_FED_FW_0000022323": "回车方向",
        "P_YS_FED_FW_0000022324": "请设置背景图片",
        "P_YS_FED_FW_0000022321": "格式",
        "P_YS_FED_FW_0000022322": "背景色",
        "P_YS_FED_FW_0000022327": "重度",
        "P_YS_FED_FW_0000022328": "年",
        "P_YS_FED_FW_0000022325": "确定删除此过滤项么？",
        "P_YS_FED_FW_0000022326": "Toolbar cStyle，预制错误！",
        "P_YS_FED_FW_0000022341": "柱折图",
        "P_YS_FED_FW_0000021010": "有下级，不能删除",
        "P_YS_FED_FW_0000022342": "校验",
        "P_YS_FED_FW_0000021011": "所选数据不符合生单规则，请重新选择数据！",
        "P_YS_FED_FW_0000022340": "大屏方案 设计 doSetChart info",
        "P_YS_FED_IMP-DFM-FE_0000020888": "序号",
        "P_YS_FED_IMP-DFM-FE_0000020886": "复制",
        "P_YS_YYGJFW_YBUC_0001336571": "协作套件",
        "P_YS_OA_XTYUNHUIWU_0000162483": "组织",
        "P_YS_FED_FW_0000021009": "切换主组织将清空数据，是否继续？",
        "P_YS_FED_FW_0000021003": "星期一",
        "P_YS_FED_FW_0000022334": "热区显示图渲染 热区配置文件或者楼层图片为空。",
        "P_YS_FED_FW_0000022335": "参照ID",
        "P_YS_FED_FW_0000021004": "此记录",
        "P_YS_FED_FW_0000021001": "网络异常",
        "P_YS_FED_FW_0000022332": "存在重复行,请检查。",
        "P_YS_FED_FW_0000021002": "后台数据返回错误",
        "P_YS_FED_FW_0000022333": "设置图形报表",
        "P_YS_FED_FW_0000021007": "数值",
        "P_YS_FED_FW_0000022338": "大屏方案日期时间 props.componentConfig",
        "P_YS_FED_FW_0000021008": "正在校验中",
        "P_YS_FED_FW_0000022339": "分组条件",
        "P_YS_FED_FW_0001661538": "协作套件中附件",
        "P_YS_FED_FW_0000021005": "时间",
        "P_YS_FED_FW_0000022336": "百",
        "P_YS_FED_FW_0000022337": "监控视图的图形报表 eChartDisplay componentDidMount",
        "P_YS_FED_FW_0000021006": "是否确认",
        "P_YS_FED_FW_0001134039": "存在重复行",
        "P_YS_FED_IMP-DFM-FE_0000020898": "剪切",
        "P_YS_FED_FW_0000022309": "抵扣",
        "P_YS_FED_FW_1551057130410213379": "参照配置错误：未返回参照数据唯一值！",
        "P_YS_FED_FW_0000022307": "Абв",
        "P_YS_FED_FW_0000022308": "当前选择的行的Index",
        "P_YS_FED_FW_0000022301": "匹配一维表的行时，当前行前面已经匹配过，请检查。 matchArr =",
        "P_YS_FED_FW_0000022302": "大屏方案2 eChartPanelDisplay2展现Render Begin",
        "P_YS_FED_FW_0000022300": "滚动计数显示",
        "P_YS_FED_FW_0000022305": "获取数据模版列表失败",
        "P_YS_FED_FW_0000022306": "维度",
        "P_YS_FED_IMP_IOT0000005471": "提示",
        "P_YS_FED_FW_0000022303": "添加图文",
        "P_YS_FED_FW_0000022304": "确定启用此模版吗？",
        "P_YS_HR_HRXCF_0000056241": "近半年",
        "P_YS_FED_FW_0000022320": "已选数据项",
        "P_YS_FED_FW_1550269983163940868": "不合法信息提示（禁止下一步）：",
        "P_YS_FED_IMP_IOT0000006796": "瓦房店市",
        "P_YS_HR_HRJQF_0001007593": "是否系统模板",
        "P_YS_FED_FW_0000022318": "初始化没有找到1维表editRowModel或者editRowModel中没找到物料Model或者物料Model类型不是ReferModel",
        "P_YS_FED_IMP_IOT0000006798": "定兴县",
        "P_YS_FED_IMP_IOT0000005467": "这是第",
        "P_YS_FED_FW_0000022319": "过滤项名称",
        "P_YS_FED_IMP_IOT0000006799": "弓长岭区",
        "P_YS_FED_FW_0000022312": "大屏轮播: Carousel render 显示轮播时间",
        "P_YS_FED_FW_0000022313": "一维表存在没有匹配到二维表单元格的行。 rows =",
        "P_YS_FED_FW_0000022310": "点击上传",
        "P_YS_FED_IMP_IOT0000006790": "循化撒拉族自治县",
        "P_YS_FED_FW_0000022311": "图文",
        "P_YS_FED_FW_0000022316": "· 枚举类型字段：[是否散户]",
        "P_YS_FED_FW_0000022317": "，支持格式：P12）",
        "P_YS_FED_IMP_IOT0000006791": "五营区",
        "P_YS_FED_FW_0000022314": "请选择菜单！",
        "P_YS_FED_IMP_IOT0000006794": "横山县",
        "P_YS_FED_FW_0000022315": "符合条件的分组方案(displayStyle == 2 or 3,移动看板则需要isMobile == true)中没有找到当前的分组方案(groupSchemaId=",
        "P_YS_FED_IMP_IOT0000006793": "三都水族自治县",
        "P_YS_PF_ECON-FE_0001658831": "认证须知",
        "P_YS_PF_YHTU_1541976126441127960": "图片要求",
        "P_YS_PF_YHTU_1541976126447943698": "认证内容：高效验证本人的运营商信息",
        "P_YS_SD_SDMA_0000060954": "姓名不能为空",
        "P_YS_PF_YHTU_1541976126441127963": "需要提供运营商手机号关联的姓名和身份证号信息",
        "P_YS_SD_SDMAF_0000137341": "已认证",
        "P_YS_PF_ECON-CONSLE_0001157552": "立即认证",
        "P_YS_PF_YHTU_1541976126441127969": "上传文件应不超过3MB",
        "P_YS_PF_YHTU_1541976126447943695": "《运营商三要素-认证服务协议》",
        "P_YS_PF_YHTU_1541976126441127966": "如果需要变更姓名和身份证号，需要取消之前所有认证后进行变更",
        "P_YS_PF_YHTU_1541976126447943692": "请勾选阅读并同意认证协议",
        "P_YS_PF_PC-UI_0000160789": "身份证国徽面",
        "P_YS_PF_PC-UI_0000160788": "身份证人像面",
        "P_YS_PF_YHTU_1541976126441127972": "认证资料",
        "P_YS_FED_UCFBASEDOC_0000025252": "已阅读并同意",
        "P_YS_PF_YHTU_1541976126447943686": "《银行卡四要素-认证服务协议》",
        "P_YS_PF_YHTU_1557523229449912325": "《",
        "P_YS_PF_YHTU_1541976126447943689": "认证内容：高效验证本人的银行卡信息",
        "P_YS_PF_YHTU_1551617615053455362": "个人实名认证服务协议",
        "P_DIWORK_YC_SUP-MGR_0000059259": "认证中",
        "P_YS_PF_YHTU_1541976126447943680": "认证时效：1-2个工作日",
        "P_YS_PF_YHTU_1541976126441127975": "2、图片大小：≦3MB",
        "P_YS_PF_YHTU_1541976126447943683": "《个人证件认证-认证服务协议》",
        "P_YS_SD_UDHMC_0001084273": "取消认证",
        "P_YS_PF_YHTU_1541976126441127978": "(包括面部)",
        "P_YS_PF_YHTU_1557523229449912320": "请输入",
        "P_YS_SD_SDMBF_0000145206": "银行卡号",
        "P_YS_PF_YHTU_1541976126441127984": "需要提供与银行卡预留信息一致的相关信息",
        "P_YS_PF_YHTU_1541976126441127981": "运营商三要素认证",
        "P_YS_PF_YHTU_1541976126441127948": "1、图片类型：jpg、jpeg、bmp、gif、png",
        "P_YS_PF_YHTU_1541976126441127942": "银行卡四要素认证",
        "P_YS_PF_YHTU_1541976126441127987": "3、身份证反面照要求：身份证原件国徽面的彩色电子版图片，不可使用复印件照片",
        "P_YS_PF_YHTU_1541976126441127945": "个人证件认证",
        "P_YS_PF_YHTU_1541976126441127939": "手机帐号变更或解绑时，三要素和四要素的认证状态自动变更为未认证",
        "P_YS_PF_ECON-FE_0001136547": "身份证号不能为空",
        "P_YS_FED_UCFBASEDOC_0000024745": "验证码不能为空",
        "P_YS_FED_UCFBASEDOC_0000025558": "手机验证码",
        "P_YS_PF_YHTU_1541976126447943704": "认证时效：10分钟内",
        "P_YS_SD_SDMBF_0000142003": "银行卡号不能为空",
        "P_YS_IMP_PRM-BE_0001108771": "认证失败",
        "P_YS_SD_SDMBF_0000141415": "修改手机号",
        "P_YS_PF_YHTU_1541976126441127951": "手持身份证合照",
        "P_YS_PF_YHTU_1541976126447943701": "认证内容：验证身份证实名信息",
        "P_YS_PF_YHTU_1541976126441127957": "已完成至少一种个人认证时，姓名认证信息复用",
        "P_YS_PF_YHTU_1541976126441127954": "3、身份证手持照要求：本人手持身份证原件正面彩色电子版图片",
        "P_YS_SD_SDMBF_0000144292": "未认证",
        "P_YS_PF_YHTU_1541976117851193351": "3、身份证正面照要求：身份证原件正面的彩色电子版图片，不可使用复印件照片"
    },
    "zhtw": {
        "P_YS_FED_FW_1606608847296266242": "保存成功，請刷新當前頁面生效",
        "P_YS_FI_CM_0000029697": "五月",
        "P_YS_SD_SDMB_0000139476": "未上傳",
        "P_YS_FED_IMP_IOT0000006664": "花垣縣",
        "P_YS_FED_IMP_IOT0000007994": "民和回族土族自治縣",
        "P_YS_FED_IMP_IOT0000006666": "呼圖壁縣",
        "P_YS_FED_IMP_IOT0000007997": "丹巴縣",
        "P_YS_FED_IMP_IOT0000006668": "喀喇沁左翼蒙古族自治縣",
        "P_YS_FED_IMP_IOT0000006669": "川匯區",
        "P_YS_SD_UDHLIB_0000133275": "分頁",
        "P_YS_FED_IMP_IOT0000006660": "察哈爾右翼後旗",
        "P_YS_FED_IMP_IOT0000006662": "七星區",
        "P_YS_OA_XTMENHU_0000046692": "下級",
        "P_YS_SD_UDHWN_0000120629": "名字",
        "P_YS_OA_XTMENHU_0000046694": "查看大圖",
        "P_YS_PF_PRINT_0000057000": "自定義項10",
        "P_YS_FED_IMP_IOT0000006653": "凌河區",
        "P_YS_FED_IMP_IOT0000007984": "平順縣",
        "P_YS_FED_IMP_IOT0000006652": "羅甸縣",
        "P_YS_FED_IMP_IOT0000006655": "玉環縣",
        "P_YS_FED_IMP_IOT0000007986": "龍鳳區",
        "P_YS_FED_IMP_IOT0000006654": "來安縣",
        "P_YS_FED_IMP_IOT0000007985": "尋烏縣",
        "P_YS_FED_IMP_IOT0000007988": "哈爾濱",
        "P_YS_FED_IMP_IOT0000006656": "碾子山區",
        "P_YS_FED_IMP_IOT0000006658": "銅梁縣",
        "P_YS_FED_IMP_IOT0000007989": "紫雲苗族布依族自治縣",
        "P_YS_FED_IMP_IOT0000006650": "景泰縣",
        "P_YS_FED_IMP_IOT0000007981": "邱縣",
        "country66": "泰國",
        "P_YS_FED_IMP_IOT0000006649": "張灣區",
        "country65": "新加坡",
        "country63": "菲律賓",
        "country62": "印度尼西亞",
        "P_YS_FED_FW_1582822863149727762": "並且",
        "country61": "澳大利亞",
        "P_YS_FED_FW_1582822863149727765": "新增表達式",
        "country60": "馬來西亞",
        "P_YS_FED_IMP_IOT0000006644": "齊河縣",
        "P_YS_FED_IMP_IOT_0001080960": "儀表盤",
        "P_YS_FED_IMP_IOT0000006643": "鼎城區",
        "P_YS_FED_IMP_IOT0000006646": "鎮安縣",
        "P_YS_FED_IMP_IOT0000007977": "西市區",
        "P_YS_FED_IMP_IOT0000006645": "漳縣",
        "P_YS_SD_URETAILF_0001130905": "完成刷新",
        "P_YS_FED_IMP_IOT0000006648": "臨湘市",
        "P_YS_FED_IMP_IOT0000007979": "桃城區",
        "P_YS_FED_IMP_IOT0000006647": "羅山縣",
        "P_YS_FED_FW_0001044586": "沒有取得任何模板信息,請檢查當前操作員是否有模板權限",
        "P_YS_FED_IMP_IOT0000007971": "定邊縣",
        "P_YS_FED_FW_0001044585": "大屏輪播：沒有取得任何模板信息,請檢查當前操作員是否有模板權限",
        "P_YS_FED_FW_1582822863149727756": "介於",
        "P_YS_FED_FW_1582822863149727759": "與",
        "P_YS_FED_IMP_IOT0000007969": "六枝特區",
        "P_YS_FED_FW_1582822863149727750": "或者",
        "P_YS_FED_FW_0000055406": "開錢箱失敗！",
        "P_YS_FED_FW_0000055407": "-¥",
        "P_YS_FED_FW_1582822863149727753": "高級方案",
        "P_YS_FED_IMP_IOT0000007962": "武昌區",
        "P_YS_FED_IMP_IOT0000007961": "靈川縣",
        "P_YS_FED_IMP_IOT0000007964": "永濟市",
        "P_YS_FED_IMP_IOT0000006632": "龍南縣",
        "P_YS_FED_FW_0000157443": "%c 語法錯誤",
        "P_YS_FED_FW_0000157444": "%c 未找到",
        "P_YS_FED_IMP_IOT0000006628": "雲霄縣",
        "P_YS_FED_IMP_IOT0000007959": "沾化縣",
        "P_YS_FED_IMP_IOT0000006627": "自流井區",
        "P_YS_FED_IMP_IOT0000007958": "鶴慶縣",
        "P_YS_FED_IMP_IOT0000006629": "條件篩選",
        "P_YS_PF_PRINT_0000057032": "自定義項13",
        "P_YS_PF_PRINT_0000057031": "自定義項14",
        "P_YS_PF_PRINT_0000057030": "自定義項11",
        "P_YS_FED_IMP_IOT0000007951": "霞浦縣",
        "P_YS_FED_IMP_IOT0000006622": "祥雲縣",
        "P_YS_FED_IMP_IOT0000007953": "澧縣",
        "P_YS_FED_IMP_IOT0000006621": "四子王旗",
        "P_YS_FED_IMP_IOT0000006625": "新鄉縣",
        "P_YS_SD_URETAILF_0001130967": "鬆開立即刷新",
        "P_YS_FED_FW_1550127458969190407": "上報失敗",
        "P_YS_FED_IMP_IOT0000007949": "淇濱區",
        "P_YS_SD_UDHWN_0000047462": "金山區",
        "P_YS_FED_IMP_IOT0000007940": "策勒縣",
        "P_YS_FED_FW_1554033164811763719": "資料展示列數",
        "P_YS_FED_IMP_IOT0000006610": "丘北縣",
        "P_YS_FED_IMP_IOT0000007941": "陽山縣",
        "P_YS_FED_IMP_IOT0000007944": "西城區",
        "P_YS_FED_IMP_IOT0000007943": "隴西縣",
        "P_YS_FED_IMP_IOT0000006615": "沂源縣",
        "P_YS_FED_IMP_IOT0000007946": "泰寧縣",
        "P_YS_FED_IMP_IOT0000006614": "高陽縣",
        "P_YS_FED_IMP_IOT0000007945": "城子河區",
        "P_YS_FED_MDF-COMPS_0001573315": "麼?",
        "P_YS_OA_XTMENHU_0000046682": "關鍵字",
        "P_YS_FED_IMP_IOT0000007939": "甘洛縣",
        "P_YS_FED_IMP_IOT0000006607": "石棉縣",
        "P_YS_FED_IMP_IOT0000006609": "新巴爾虎左旗",
        "P_YS_SD_UDHWN_0000047473": "潛江市",
        "P_YS_FED_FW_0001663472": "存在尚未完成的check",
        "P_YS_FED_IMP_IOT0000006600": "台江縣",
        "P_YS_FED_IMP_IOT0000007932": "薩迦縣",
        "P_YS_PF_PROCENTER_0000022911": "上架",
        "P_YS_FED_IMP_IOT0000006604": "鳩江區",
        "P_YS_FED_IMP_IOT0000007934": "閘北區",
        "P_YS_FED_IMP_IOT0000007928": "江油市",
        "P_YS_FED_IMP_IOT0000007927": "長安區",
        "P_YS_SD_UDHWN_0000047486": "懷柔區",
        "P_YS_FED_IMP_IOT0000007922": "婁星區",
        "P_YS_FED_IMP_IOT0000007923": "興海縣",
        "P_YS_HR_HRXC_0001197527": "數據不合法",
        "P_YS_FED_FW_1555933876791541761": "刷新當前清單",
        "P_YS_FED_FW_1475374970712358918": "中午|下午|晚上",
        "P_YS_FED_IMP_IOT0000007915": "牟平區",
        "P_YS_FED_FW_1551464301900857353": "為整單操作",
        "P_YS_FED_IMP_IOT0000007914": "商河縣",
        "P_YS_FED_IMP_IOT0000007917": "棗陽市",
        "P_YS_FED_FW_1551464301900857356": "當前為明細模式",
        "P_YS_FED_IMP_IOT0000007919": "江東區",
        "P_YS_PF_PRINT_0000057075": "聯繫方式",
        "P_YS_FED_FW_1581128902296207365": "模糊搜",
        "P_YS_SCM_STOCK_0000132840": "有錯誤：",
        "P_YS_FED_IMP_IOT0000007913": "洞口縣",
        "P_YS_FED_IMP_IOT0000007912": "婺城區",
        "P_YS_PF_GZTSYS_0000012816": "個人",
        "P_YS_SCM_STOCK_0000132843": "參照攜帶定義",
        "P_YS_PF_GZTSYS_0000012812": "待辦",
        "P_YS_FED_FW_1581128902296207362": "精確搜",
        "P_YS_FED_FW_0001050401": "展開<%=text%>級",
        "P_YS_FED_IMP_IOT0000007904": "薩嘎縣",
        "P_YS_FED_IMP_IOT0000007906": "高邑縣",
        "P_YS_FED_IMP_IOT0000007909": "陸河縣",
        "P_YS_FED_IMP_IOT0000007900": "管城回族區",
        "P_YS_FED_IMP_IOT0000007902": "茶陵縣",
        "P_YS_FED_FW_0001025471": "獲取數據失敗!",
        "P_YS_FED_FW_0001025472": "未配置模板服務地址或地址配置有誤!當前SERVER_ENV為",
        "P_YS_FED_FW_1535286379871207432": "刪除方案",
        "P_YS_PF_GZTSYS_0000012800": "客戶分類",
        "P_YS_PF_GZTSYS_0000012805": "角色管理",
        "P_YS_FED_FW_0001491879": "複製纯文字档案",
        "P_YS_FED_FW_1487292800403243012": "抱歉，保存時出了點小錯誤，是否重試？",
        "P_YS_SCM_STOCK_0000034385": "當前門店",
        "P_YS_SCM_STOCK_0000034388": "預訂信息詳情",
        "P_YS_SCM_STOCK_0000034389": "行",
        "country84": "越南",
        "P_YS_FED_FW_0001320413": "，請填寫正確！",
        "P_YS_SCM_STOCK_0000034392": "加入購物車",
        "P_YS_SCM_STOCK_0000034395": "掃描優惠券",
        "P_YS_SCM_STOCK_0000034397": "電商訂單不允許使用會員儲值",
        "P_YS_PF_GZTTMP_0000075261": "開始以",
        "country95": "緬甸",
        "P_YS_FI_AR_0000058973": "訂單日期",
        "P_YS_FED_FW_1617786585604947979": "年-月-日 時:分:秒",
        "P_YS_OA_XTMENHUCMS_0000045131": "錯誤提示",
        "P_YS_FED_FW_1617786585604947976": "年-月-日 時",
        "P_YS_SD_SDMBF_0000141364": "掃碼查詢",
        "P_YS_SCM_STOCK_0000034363": "生產日期",
        "P_YS_SCM_STOCK_0000034364": "供應商：",
        "P_YS_OA_XTLCZX_0000030196": "附件",
        "P_YS_SCM_STOCK_0000034367": "已收款",
        "P_YS_FED_FW_0001620384": "當前訪問的是百度地圖API，公網才能訪問，專屬化環境訪問不到",
        "P_YS_FED_IMP_IOT0000011200": "宕昌縣",
        "P_YS_FED_FW_1564304845386022921": "查看參考詳情",
        "P_YS_FED_FW_0001291470": "二維表第",
        "P_YS_FED_FW_0001573430": "! 重複的control對象為:%o",
        "P_YS_SCM_STOCK_0000132863": "錯誤信息：",
        "P_YS_FED_IMP_IOT0000011204": "沭陽縣",
        "P_YS_FED_IMP_IOT0000011203": "萬秀區",
        "P_YS_SCM_STOCK_0000132860": "離線登陸讀取緩存數據錯誤",
        "P_YS_FED_FW_0001573427": "{\\\"1\\\":\\\"年\\\",\\\"2\\\":\\\"月\\\",\\\"6\\\":\\\"天\\\"}",
        "P_YS_FED_FW_0001007612": "匯入操作",
        "P_YS_FED_FW_0001573428": "[{\\\"key\\\":\\\"1\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"年\\\"},{\\\"key\\\":\\\"2\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"月\\\"},{\\\"key\\\":\\\"6\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"天\\\"}]",
        "P_YS_FED_FW_0001573429": "獲取刪除之後的數據",
        "P_YS_SCM_STOCK_0000034372": "當前已處於驗貨狀態!",
        "P_YS_SCM_STOCK_0000034375": "待入庫數量和入庫數量匹配有差異,請確認是否終止驗貨並保存?",
        "P_YS_SCM_STOCK_0000034377": "退款金額",
        "P_YS_FED_FW_1500243140406149121": "您好，是否覆蓋已存在的用戶級清單設置（用戶級模板）？",
        "P_YS_FED_IMP_IOT0000011211": "老城區",
        "P_YS_FED_IMP_IOT0000011210": "灤南縣",
        "P_YS_FED_IMP_IOT0000011213": "四方檯區",
        "P_YS_FED_IMP_IOT0000011212": "城固縣",
        "P_YS_FED_FW_0001573431": "[bill-setting] [BillModal] [updateGridModelDataValueByCRefRetId()] 獲取參照返回值ERROR:[",
        "P_YS_FED_FW_0001573432": "[bill-setting-new] [BillModal] [updateGridModelDataValueByCRefRetId()] 獲取參照返回值ERROR:[",
        "P_YS_FED_FW_0001573433": "%c[bill-setting] [redux billmodal] [mergeDirtyDataInModalDataOriginal()] 重複的cName",
        "P_YS_FED_FW_0001080297": "無可用操作，請先配置業務流",
        "P_YS_SCM_STOCK_0000132853": "門戶組件布局",
        "P_YS_FED_FW_0001573434": ",阻止執行",
        "P_YS_FED_FW_0001573435": "渲染表格方法與組件",
        "P_YS_FED_FW_0001573436": "參照缺少必要配置cRefRetId、cRefType",
        "P_YS_FED_FW_0001573437": "獲取下標為",
        "P_YS_FED_IMP_IOT0000011216": "拉孜縣",
        "P_YS_SCM_STOCK_0000132858": "錯誤代碼：離線登錄錯誤 ==>",
        "P_YS_SCM_STOCK_0000132859": "錯誤代碼：",
        "P_YS_SCM_STOCK_0000034380": "折扣率%",
        "P_YS_FED_FW_1604492734089396228": "暫不支持<%=maxExpendLevel%>級以上的屬性穿透",
        "P_YS_OA_XTLCZX_0000030132": "無數據",
        "P_YS_SCM_STOCK_0000034464": "原單折扣額",
        "P_YS_SCM_STOCK_0000034465": "購物車空空如也",
        "P_YS_FED_FW_0001151071": "未獲取到domainKey",
        "P_YS_SCM_STOCK_0000034467": "實退價",
        "P_YS_FED_IMP_IOT0000011101": "靜海縣",
        "P_YS_FED_IMP_IOT0000011103": "西峰區",
        "P_YS_PF_PRINT_0000065417": "供應商名稱",
        "P_YS_FED_IMP_IOT0000011108": "義烏市",
        "P_YS_FED_IMP_IOT0000011105": "涼城縣",
        "P_YS_FED_IMP_IOT0000011106": "赤城縣",
        "P_YS_FED_UCFBASEDOC_0000025614": "手機",
        "ficloud.000550": "無操作權限",
        "P_YS_SCM_STOCK_0000034470": "請輸入商品條形碼",
        "P_YS_SCM_STOCK_0000034471": "聯繫電話",
        "P_YS_SCM_STOCK_0000034472": "刪除所選",
        "P_YS_FED_FW_0001542394": "您有一份暫存數據，是否載入？",
        "P_YS_SCM_STOCK_0000034473": "預訂交款比例不得低於",
        "P_YS_SD_USMP-UI_0001315551": "樹形參照",
        "P_YS_SCM_STOCK_0000034475": "選擇促銷活動",
        "P_YS_SCM_STOCK_0000034476": "單據",
        "P_YS_FED_FW_0001007613": "value 格式錯誤",
        "P_YS_FED_IMP_IOT0000011112": "玉田縣",
        "P_YS_FED_IMP_IOT0000011114": "鐘祥市",
        "P_YS_FED_IMP_IOT0000011113": "南雄市",
        "P_YS_OA_XTLCZX_0000030140": "欄位名稱",
        "P_YS_FED_IMP_IOT0000011118": "南部縣",
        "P_YS_FED_UCFBASEDOC_0000025601": "請輸入電郵",
        "P_YS_SCM_STOCK_0000034442": "原銷售日期",
        "P_YS_SCM_STOCK_0000034443": "主營業員",
        "P_YS_SCM_STOCK_0000034444": "交貨日期",
        "P_YS_OA_XTLCZX_0000030159": "審批時間",
        "P_YS_SCM_STOCK_0000034446": "已選中",
        "P_YS_FED_IMP_IOT0000011120": "崇禮縣",
        "P_YS_FED_IMP_IOT0000011127": "介休市",
        "P_YS_FED_FW_1556016546332540933": "刷新搜索",
        "P_YS_FED_IMP_IOT0000011128": "武夷山市",
        "P_YS_OA_XTLCZX_0000030149": "編輯公式",
        "P_YS_SCM_STOCK_0000034450": "希望交貨日期",
        "P_YS_SCM_STOCK_0000034451": "可退",
        "P_YS_SCM_STOCK_0000034454": "驗證碼登錄",
        "P_YS_SCM_STOCK_0000034455": "未讀",
        "P_YS_SCM_STOCK_0000034456": "退款金額不等於原單該支付方式的金額",
        "P_YS_SCM_STOCK_0000034457": "0積分",
        "P_YS_SCM_STOCK_0000034458": "訂金金額",
        "P_YS_FED_IMP_IOT0000011134": "八公山區",
        "P_YS_FED_IMP_IOT0000011133": "鹽源縣",
        "P_YS_FED_IMP_IOT0000011136": "山城區",
        "P_YS_FED_IMP_IOT0000011135": "大窪縣",
        "P_YS_FED_IMP_IOT0000011131": "昭蘇縣",
        "P_YS_OA_XTMENHUCMS_0000045155": "新聞",
        "P_YS_SCM_STOCK_0000034421": "已收款金額（定金）",
        "P_YS_FED_FW_0000055378": "！！！配置文件中沒有列標題，使用bodyItem!define6",
        "P_YS_FED_FW_0000055379": "和小數位數",
        "P_YS_SCM_STOCK_0000034423": "應收",
        "P_YS_FED_FW_0000055376": "所有信息-2維表數據 getRows =",
        "P_YS_SCM_STOCK_0000034424": "請選擇營業員！",
        "P_YS_FED_FW_0000055377": "，請確認是否繼續?",
        "P_YS_SCM_STOCK_0000034428": "訂單時間",
        "P_YS_FED_IMP_IOT0000011147": "江安縣",
        "P_YS_FED_IMP_IOT0000011141": "呼瑪縣",
        "P_YS_FED_IMP_IOT0000011140": "諸暨市",
        "P_YS_FED_IMP_IOT0000011142": "海陽市",
        "P_YS_FED_FW_1576846192821665795": "條數據允許打印，",
        "P_YS_FED_FW_1576846192821665798": "打印確認",
        "P_YS_FED_FW_1576846192821665792": "條數據業務階段未結束，不允許打印：",
        "P_YS_FED_UIMG_0000025893": "請先將該欄位設為顯示！",
        "P_YS_FED_UIMG_0000025894": "請先將該欄位設為非必輸",
        "P_YS_PES_PES-FE_0001104859": "變更說明",
        "P_YS_FED_FW_0000055383": "設置的小數位數為",
        "P_YS_FED_FW_0000055384": "參照名稱",
        "P_YS_FED_FW_0000055381": ", groupFields將被置空。",
        "P_YS_FED_FW_0000055382": "不能大於",
        "P_YS_FED_FW_0000055380": "！！！分組信息缺失， 接口返回的groupFields =",
        "P_YS_SCM_STOCK_0000034430": "去結算",
        "P_YS_FED_FW_1545658296411619334": "您好，若用戶清單右上角設置了列寬/欄位顯隱後，便有“用戶級設置”，您的模板級設置是否對其覆蓋？",
        "P_YS_SCM_STOCK_0000034432": "退貨折扣率",
        "P_YS_SCM_STOCK_0000034435": "選擇優惠券",
        "P_YS_PLM_GDS-FE_0001096721": "把文件拖入指定區域，完成上傳，同樣支持點擊上傳。",
        "P_YS_SCM_STOCK_0000034438": "匹配正確",
        "P_YS_FED_IMP_IOT0000011157": "平定縣",
        "P_YS_FED_IMP_IOT0000011151": "戶縣",
        "P_YS_FED_IMP_IOT0000011154": "漢川市",
        "P_YS_FED_IMP_IOT0000011159": "景谷傣族彞族自治縣",
        "P_YS_PF_GZTSYS_0000012907": "核算服務",
        "P_YS_PF_GZTSYS_0000012902": "其它",
        "P_YS_SCM_STOCK_0000034402": "暫不支持混合結算方式退貨~",
        "P_YS_SCM_STOCK_0000034404": "銷售金額",
        "P_YS_SCM_STOCK_0000034405": "修改預訂信息",
        "P_YS_FED_IMP_IOT0000011166": "如皋市",
        "P_YS_FED_IMP_IOT0000011168": "太平區",
        "P_YS_FED_IMP_IOT0000011163": "田家庵區",
        "P_YS_FED_IMP_IOT0000011164": "白水縣",
        "P_YS_PF_PRINT_0000065438": "應收件數",
        "P_YS_FED_FW_0001253037": "導出異常",
        "P_YS_FED_FW_0001388904": "全部批改",
        "P_YS_FED_IMP_IOT0000011170": "會東縣",
        "P_YS_FED_FW_1535273091242393606": "已參與審批流程的單據不允許刪除",
        "P_YS_SCM_STOCK_0000034412": "請錄入優惠券。",
        "P_YS_SCM_STOCK_0000034413": "交貨時間",
        "P_YS_SCM_STOCK_0000034415": "應收金額不能小於最低訂金金額(",
        "P_YS_FED_IMP_IOT0000011178": "焉耆回族自治縣",
        "P_YS_SCM_STOCK_0000034418": "切換掃描",
        "P_YS_SCM_STOCK_0000034419": "手動輸入條形碼",
        "P_YS_FED_IMP_IOT0000011176": "門源回族自治縣",
        "P_YS_FED_FW_0000157485": "路由",
        "P_YS_FED_FW_0001157215": "為必輸項,請填寫!",
        "P_YS_FED_FW_0000157486": "包含controls或者containers字段,只渲染其中一種，containers優先順序大於controls",
        "P_YS_FED_IMP_IOT0000011180": "安圖縣",
        "P_YS_FED_FW_0000157487": "只渲染containers",
        "P_YS_FED_FW_0000157488": "獲取state.action",
        "P_YS_FED_IMP_IOT0000011182": "覃塘區",
        "P_YS_FED_FW_0000157482": "圖標庫",
        "P_YS_FED_FW_0000157483": "<SvgIcon/>支持的icon類型",
        "P_YS_FED_FW_0000157484": "可以有menuId欄位",
        "P_YS_FED_IMP_IOT0000011188": "岱山縣",
        "P_YS_FED_FW_0000157480": "點擊事件",
        "P_YS_FED_FW_0001409434": "顯示小計/合計",
        "P_YS_FED_FW_0001409433": "鏈接纯文字档案和地址需同時輸入",
        "P_YS_FED_FW_0001409432": "網址格式不正確，請輸入正確的網址。(註：網址不能包含中文)",
        "P_YS_FED_IMP_IOT0000011186": "洛龍區",
        "P_YS_FED_FW_0001409431": "合併列",
        "P_YS_FED_FW_0001255676": "請檢查icon配置--",
        "P_YS_FED_FW_0000157478": "列數量",
        "P_YS_FI_CM_0000029738": "四月",
        "P_YS_FED_FW_0000157479": "更換圖標",
        "P_YS_FED_FW_0000055349": "】存在隱藏必輸數據項：",
        "P_YS_FED_IMP_IOT0000011192": "卓資縣",
        "P_YS_FED_FW_0000157475": "顯示SVG",
        "P_YS_FED_FW_0000055347": "存在隱藏必輸數據項：",
        "P_YS_FED_FW_0000157476": "檔案類型",
        "P_YS_FED_FW_0000055348": "請求出錯",
        "P_YS_FED_FW_0000157477": "顯示上傳列表",
        "P_YS_SD_SDMA_0000061917": "信息",
        "P_YS_FED_FW_0000055346": "請選擇資料",
        "P_YS_FED_IMP_IOT0000011199": "雷山縣",
        "P_YS_FI_FP_0000034914": "本年",
        "P_YS_FED_FW_0000055352": "減少[",
        "P_YS_FED_FW_0000055353": "設置的最大長度",
        "P_YS_FED_FW_0000055350": "修改為[",
        "P_YS_FED_FW_0000055351": "(每張圖片大小不可超過5M，圖片僅支持JPG、PNG、BMP、GIF格式",
        "P_YS_FED_FW_0000055358": "增加[",
        "P_YS_FED_FW_0000055359": "配置文件中沒有行標題，使用bodyItem!define5",
        "P_YS_FED_FW_0000055356": "選擇數量超過上傳限制，請選擇上傳！",
        "P_YS_FI_CM_0000029752": "ár",
        "P_YS_FED_FW_0000055357": "符合過濾條件的所有記錄",
        "P_YS_FED_FW_0000055354": "勾選的",
        "P_YS_FED_FW_0000055355": "所有信息-1維表數據 getRows =",
        "P_YS_FI_YYFI-UI_0001071709": "黑色",
        "P_YS_FED_FW_0000055363": "張)",
        "P_YS_FED_FW_0000055364": "乘[",
        "P_YS_FED_FW_0000055361": "所有信息-2維表初始化數據源 dataSource =",
        "P_YS_FED_FW_0000055362": "所有信息-2維表欄目 columns =",
        "P_YS_FED_FW_0000055360": "，最多可上傳",
        "P_YS_FED_IMP_IOT0000005395": "已辦結",
        "P_YS_FED_FW_0000157496": "可以包含itemName、menuId、parentItem欄位",
        "P_YS_FED_FW_0000157497": "只使用meta.controls[0]",
        "P_YS_FED_FW_0000055369": "所有信息-1維表和2維表行數 1維表行數 =",
        "P_YS_FED_FW_0000055367": "小計(",
        "P_YS_FED_FW_0000157492": "可以包含controls欄位",
        "P_YS_FED_FW_0000157493": "browse或者其他",
        "P_YS_FED_FW_0000055368": "重新計算總計 Begin bReCalc =",
        "P_YS_FED_FW_0000055365": "條記錄",
        "P_YS_FED_FW_0000157494": "可以有params欄位",
        "P_YS_FED_FW_0000157495": "可以包含containers欄位",
        "P_YS_FED_FW_0000055366": "重新計算總計 End totalSum =",
        "P_YS_FED_FW_0000157491": "包含itemName、menuId、itemIndex",
        "P_YS_SD_UDHWN_0000047440": "臨高縣",
        "P_YS_FED_FW_0001297661": "%c捕捉到快捷鍵：%c",
        "P_YS_FED_FW_0000055374": "您本次要將當前列表",
        "P_YS_FED_FW_0000055375": "全部清空",
        "P_YS_HR_HRRCPDF_0001303021": "僅看已選",
        "P_YS_FED_FW_0000055372": "除[",
        "P_YS_FED_FW_0000055373": ",加上輸入數字的長度和小數點,",
        "P_YS_FED_UCFBASEDOC_0000025667": "件",
        "P_YS_FED_FW_0000055370": "名稱已超過10個字符！",
        "P_YS_FED_FW_0000157489": "是否展示cShowCaption",
        "P_YS_FED_FW_0000055371": "文件必須小於2M",
        "P_YS_FED_IMP_IOT0000005384": "部門2",
        "P_YS_FED_IMP_IOT0000005385": "部門3",
        "P_YS_FED_IMP_IOT0000005386": "部門1",
        "P_YS_SD_SDMAF_0000137022": "排序規則",
        "P_YS_SD_UDHWN_0000048714": "武清區",
        "P_YS_FED_FW_0001312014": "請您配置行編輯元資料",
        "P_YS_FED_IMP_IOT0000006697": "名山縣",
        "P_YS_FED_IMP_IOT0000006696": "如東縣",
        "P_YS_FED_IMP_IOT0000006691": "酉陽土家族苗族自治縣",
        "P_YS_FED_IMP_IOT0000006690": "翁源縣",
        "P_YS_FI_FP_0000034988": "上年",
        "P_YS_OA_XTHUATI_0000046210": "點擊加載更多",
        "P_YS_FED_IMP_IOT0000006686": "陽原縣",
        "P_YS_FED_IMP_IOT0000006685": "樂至縣",
        "P_YS_FED_IMP_IOT0000006687": "社旗縣",
        "P_YS_FED_IMP_IOT0000006689": "米林縣",
        "P_YS_SD_SDMA_0000039189": "審批狀態",
        "P_YS_FED_FW_0001229378": "請選擇需要恢復的數據",
        "P_YS_FED_IMP_IOT0000006682": "隆堯縣",
        "P_YS_SD_UDHWN_0000048734": "陵水黎族自治縣",
        "P_YS_SD_UDHWN_0000047405": "蘋果",
        "P_YS_PES_PES-FE_0001108397": "未讀信息",
        "P_YS_PES_PES-FE_0001108394": "已讀信息",
        "P_YS_FED_IMP_IOT0000006675": "黃岩區",
        "P_YS_FED_IMP_IOT0000006674": "昂仁縣",
        "P_YS_FED_IMP_IOT0000006676": "高要市",
        "P_YS_FED_IMP_IOT0000006678": "貞豐縣",
        "P_YS_FED_FW_0001097161": "頁面中有未保存的數據，點擊確定後將關閉頁面，是否繼續？",
        "P_YS_FED_FW_0001097160": "天（不含當天）的銷售數量",
        "P_YS_FED_IMP_IOT0000006671": "太子河區",
        "P_YS_FED_IMP_IOT0000006670": "寧津縣",
        "P_YS_FED_IMP_IOT0000006673": "鎮坪縣",
        "P_YS_FED_IMP_IOT0000006672": "羅莊區",
        "P_YS_FED_FW_1510095451785789446": "展開為懸停按鈕",
        "P_YS_HR_HRYG_0000154297": "參數型別錯誤",
        "P_YS_PF_GZTSYS_0000012776": "模板管理",
        "P_YS_FED_IMP_IOT0000006543": "蜀山區",
        "P_YS_FED_IMP_IOT0000006542": "市北區",
        "P_YS_FED_IMP_IOT0000006545": "西青區",
        "P_YS_FED_IMP_IOT0000007876": "宜章縣",
        "P_YS_PF_GZTSYS_0000012772": "供應商",
        "P_YS_FED_IMP_IOT0000007878": "潁州區",
        "P_YS_FED_IMP_IOT0000006546": "五大連池市",
        "P_YS_FED_IMP_IOT0000007877": "紅古區",
        "P_YS_FED_IMP_IOT0000006549": "鹽山縣",
        "P_YS_FED_IMP_IOT0000006548": "美姑縣",
        "P_YS_FED_IMP_IOT0000007879": "長寧縣",
        "P_YS_FED_IMP_IOT0000007870": "亞東縣",
        "P_YS_FED_FW_1510095451785789449": "收起為常駐按鈕",
        "P_YS_FED_IMP_IOT0000007871": "鶴山區",
        "P_YS_FED_IMP_IOT0000006531": "渝水區",
        "P_YS_FED_IMP_IOT0000007862": "嵩明縣",
        "P_YS_FED_IMP_IOT0000007865": "柞水縣",
        "P_YS_PF_GZTSYS_0000012789": "採購合約",
        "P_YS_FED_IMP_IOT0000007864": "阿拉善左旗",
        "P_YS_FED_IMP_IOT0000006536": "磴口縣",
        "P_YS_FED_IMP_IOT0000007867": "雙遼市",
        "P_YS_FED_IMP_IOT0000006535": "貢覺縣",
        "P_YS_FED_IMP_IOT0000007866": "武宣縣",
        "P_YS_FED_IMP_IOT0000006538": "灞橋區",
        "P_YS_FED_IMP_IOT0000007869": "迎澤區",
        "P_YS_FED_IMP_IOT0000007861": "錫山區",
        "P_YS_SD_SDMBF_0000143804": "前選擇",
        "P_YS_FED_IMP_IOT0000006529": "南明區",
        "P_YS_FED_IMP_IOT0000007851": "上虞市",
        "P_YS_FED_IMP_IOT0000007854": "建陽市",
        "P_YS_FED_IMP_IOT0000007853": "秀洲區",
        "P_YS_PF_GZTSYS_0000012755": "報銷",
        "P_YS_FED_IMP_IOT0000006525": "東鄉縣",
        "P_YS_FED_IMP_IOT0000007855": "海南區",
        "P_YS_FED_IMP_IOT0000006527": "襄陽區",
        "P_YS_FED_IMP_IOT0000007858": "樟樹市",
        "P_YS_FED_IMP_IOT0000006526": "瑞安市",
        "P_YS_FED_IMP_IOT0000007857": "遵義縣",
        "P_YS_FED_IMP_IOT0000006517": "尖草坪區",
        "P_YS_FED_IMP_IOT0000006519": "寬甸滿族自治縣",
        "P_YS_FED_IMP_IOT0000007841": "開封縣",
        "P_YS_FED_IMP_IOT0000007840": "麻陽苗族自治縣",
        "P_YS_FED_IMP_IOT0000006514": "洪江市",
        "P_YS_FED_IMP_IOT0000007845": "吳堡縣",
        "P_YS_FED_IMP_IOT0000006516": "南昌縣",
        "P_YS_FED_FW_0001193013": "請正確錄入以下表頭必輸欄位",
        "P_YS_FED_IMP_IOT0000007838": "柳林縣",
        "P_YS_FED_IMP_IOT0000006506": "山陽縣",
        "P_YS_PF_GZTPRE_0000071096": "立即執行",
        "P_YS_FED_IMP_IOT0000006508": "三江侗族自治縣",
        "P_YS_FED_IMP_IOT0000007839": "南召縣",
        "P_YS_HR_HRYG_0000154257": "錯誤描述",
        "P_YS_OA_XTMENHU_0000046789": "複製成功！",
        "P_YS_FED_IMP_IOT0000006501": "白河縣",
        "P_YS_FED_IMP_IOT0000007831": "惠水縣",
        "P_YS_FED_IMP_IOT0000006502": "烏什縣",
        "P_YS_FED_IMP_IOT0000007833": "鄄城縣",
        "P_YS_FED_IMP_IOT0000006505": "平湖市",
        "P_YS_FED_IMP_IOT0000007836": "斗門區",
        "P_YS_FED_IMP_IOT0000006504": "都安瑤族自治縣",
        "P_YS_FI_CM_0000029778": "十月",
        "P_YS_FED_IMP_IOT0000007827": "宜川縣",
        "P_YS_FED_FW_0001079325": "圖形展示",
        "P_YS_FED_IMP_IOT0000007829": "大理市",
        "P_YS_FED_IMP_IOT0000007828": "瑪多縣",
        "P_YS_FED_FW_0001079326": "列表展示",
        "P_YS_FED_IMP_IOT0000007821": "西湖區",
        "P_YS_FED_IMP_IOT0000007820": "元寶山區",
        "P_YS_FED_IMP_IOT0000007823": "雙塔區",
        "P_YS_FED_FW_0001469036": "全選(",
        "P_YS_FED_IMP_IOT0000007822": "丹江口市",
        "P_YS_FED_IMP_IOT0000007824": "阜康市",
        "P_YS_FED_IMP_IOT0000007816": "福山區",
        "P_YS_FED_IMP_IOT0000007815": "宛城區",
        "P_YS_FED_IMP_IOT0000007813": "連山區",
        "P_YS_PF_GZTSYS_0000012795": "職級",
        "P_YS_FED_IMP_IOT0000007805": "陽信縣",
        "P_YS_FED_IMP_IOT0000007804": "友誼縣",
        "P_YS_FED_IMP_IOT0000007806": "桃江縣",
        "P_YS_FED_IMP_IOT0000007808": "涉縣",
        "P_YS_FED_IMP_IOT0000007801": "揭西縣",
        "P_YS_FED_IMP_IOT0000007802": "雲縣",
        "P_YS_HR_HRYGF_0000055686": "日曆",
        "P_YS_PF_SUPPORT-UI_0001152916": "日期格式",
        "P_YS_FED_FW_0001121379": "請先設置行標題的值",
        "P_YS_FED_FW_0001140573": "]不存在於源表欄目中，請檢查",
        "P_YS_PF_GZTSYS_0000012701": "品牌",
        "P_YS_SCM_USTOCK-UI_0000173950": "查看歷史日結",
        "P_YS_SD_UDHLIB_0000133325": "開關",
        "P_YS_PF_SOCD-O_0000182693": "初中",
        "P_YS_FED_FW_0001246031": "當前所訪問頁面已被刪除或其他異常，請重新返回列表訪問",
        "P_YS_SD_SDMA_0000060490": "刪除失敗！",
        "P_YS_FED_FW_1458899089362518016": "行子表的",
        "P_YS_FED_FW_1614877844774584320": "草稿箱空空如也",
        "P_YS_FED_FW_0001086504": "模板內未發現有效數據",
        "P_YS_SD_URETAILF_0001130882": "下拉可以刷新",
        "P_YS_HR_HRYGF_0000055671": "請輸入姓名",
        "P_YS_FED_FW_0001025574": "輸入的數字的最大長度不能大於",
        "P_YS_PF_SOCD_0000154844": "軍官證",
        "P_YS_FED_FW_1463414594656534528": "地圖請求出現錯誤",
        "P_YS_PF_GZTSYS_0000012731": "編碼規則",
        "P_YS_PF_GZTSYS_0000012736": "支付方式",
        "P_YS_PES_PES-UI_0001234764": "數據表格",
        "P_YS_FED_FW_1467090828949192704": "輸入長度超出限制：中文最多10個漢字，英文最多20個字母",
        "P_YS_PF_GZTSYS_0000012745": "自定義檔案",
        "P_YS_SCM_STOCK_0000034485": "選規格",
        "P_YS_SCM_STOCK_0000034487": "找零金額超出限制，最大找零為",
        "P_YS_SCM_STOCK_0000034490": "錯誤數量",
        "P_YS_SCM_STOCK_0000034493": "不可用的券",
        "P_YS_SCM_STOCK_0000034495": "折扣率",
        "P_YS_PF_SOCD_0000154855": "美元",
        "P_YS_SCM_STOCK_0000034497": "刪除_x0008_DB數據庫",
        "P_YS_SCM_STOCK_0000034498": "掃描條形碼",
        "P_YS_SCM_STOCK_0000034585": "商品金額",
        "P_YS_SCM_STOCK_0000034586": "聯查原單",
        "P_YS_FED_FW_1575188275308527622": "“非空”或“為空”型別條件不允許清除，請點擊“高級”進入彈窗中操作",
        "P_YS_PF_PC-UI_0001072138": "顯示項，不用輸入",
        "P_YS_OA_XTLCZX_0000030265": "加載中",
        "P_YS_SCM_STOCK_0000034595": "暫無優惠券，請手動添加～",
        "P_YS_SCM_STOCK_0000034596": "暫無可選客戶",
        "ficloud.000415": "暫不支持",
        "P_YS_SCM_STOCK_0000034599": "已掃描過該序列號[",
        "P_YS_SCM_STOCK_0000034564": "交貨倉庫",
        "P_YS_SCM_STOCK_0000034569": "，餘額不足。",
        "P_YS_FED_IMP_IOT0000011003": "碑林區",
        "P_YS_FED_IMP_IOT0000011000": "民豐縣",
        "P_YS_FED_FW_1483255496785264644": "字段觸發check，check前值為:",
        "P_YS_FED_IMP_IOT0000011009": "鐵嶺縣",
        "P_YS_FED_IMP_IOT0000011006": "廈門",
        "P_YS_FED_IMP_IOT0000011007": "金口河區",
        "P_YS_FED_UCFBASEDOC_0000025713": "請輸入角色編碼",
        "P_YS_SD_UDHWN_0000048808": "文山市",
        "P_YS_FED_FW_0001301257": "以下表頭欄位有誤",
        "P_YS_SCM_STOCK_0000034570": "超待入庫數量",
        "P_YS_SCM_STOCK_0000034572": "請輸入驗證碼！",
        "P_YS_SCM_STOCK_0000034573": "確定全部標為已讀嗎？",
        "P_YS_SCM_STOCK_0000034574": "優惠合計",
        "P_YS_OA_XTLCZX_0000030284": "保密期限",
        "P_YS_SCM_STOCK_0000034579": "單據日期：",
        "P_YS_OA_XTLCZX_0000030288": "加載更多",
        "P_YS_FED_IMP_IOT0000011015": "屯溪區",
        "P_YS_FED_IMP_IOT0000011014": "壤塘縣",
        "P_YS_FED_FW_1510116436995997696": "纯文字档案長度不允許為負值，請修改",
        "P_YS_FED_FW_1510116436995997699": "數字小數位不允許為負值，請修改",
        "P_YS_FED_UCFBASEDOC_0000025709": "項目",
        "P_YS_FED_IMP_IOT0000011016": "日喀則市",
        "P_YS_FED_IMP_IOT0000011018": "潮南區",
        "P_YS_FED_UCFBASEDOC_0000025703": "對象",
        "P_YS_SCM_STOCK_0000034581": "錯誤原因",
        "P_YS_SCM_STOCK_0000034582": "請輸入或掃描優惠券",
        "P_YS_SCM_STOCK_0000034545": "參數不全",
        "P_YS_FED_IMP_IOT0000011020": "涪陵區",
        "P_YS_FED_IMP_IOT0000011022": "樺甸市",
        "P_YS_FED_IMP_IOT0000011028": "友好區",
        "P_YS_FED_IMP_IOT0000011027": "元氏縣",
        "P_YS_OA_XTLCZX_0000030206": "隱藏",
        "P_YS_FED_FW_1550175803122122759": "不合法信息提示（禁止下一步）",
        "P_YS_SCM_STOCK_0000034550": "退款明細",
        "P_YS_SCM_STOCK_0000034551": "正在開發中...",
        "P_YS_HR_HRSSC_0000135746": "標題為空",
        "P_YS_SCM_STOCK_0000034554": "關燈",
        "P_YS_FED_FW_1488664372439416833": "無圖片ds",
        "P_YS_SCM_STOCK_0000034555": "選擇帳號",
        "P_YS_OA_XTLCZX_0000030224": "必填",
        "P_YS_SCM_STOCK_0000034557": "聯繫人",
        "P_YS_FED_FW_1550175803122122762": "預警信息提示",
        "P_YS_SCM_STOCK_0000034559": "你確定要放棄結算嗎?",
        "P_YS_FED_IMP_IOT0000011034": "沁縣",
        "P_YS_FED_FW_1483255496785264650": "。兩個值不一樣會再次觸發check。請保持一樣。",
        "P_YS_FED_IMP_IOT0000011037": "蘆山縣",
        "P_YS_FED_IMP_IOT0000011031": "鎮雄縣",
        "P_YS_FED_FW_1483255496785264653": ", check後值為:",
        "P_YS_FED_FW_1483255496785264647": "%c updateRows新舊值不一樣會觸發公式.. >>>target =>舊值 =>新值 => updateRows Params",
        "P_YS_FED_IMP_IOT0000011039": "阿克塞哈薩克族自治縣",
        "P_YS_FED_IMP_IOT0000011038": "張家川回族自治縣",
        "P_YS_PF_PRINT_0000065582": "需求日期",
        "P_YS_SCM_STOCK_0000034523": "已讀",
        "P_YS_SCM_STOCK_0000034525": "收銀員",
        "P_YS_FED_IMP_IOT0000011045": "寧晉縣",
        "P_YS_SCM_STOCK_0000034529": "匹配到多個商品",
        "P_YS_FED_IMP_IOT0000011044": "府谷縣",
        "P_YS_FED_IMP_IOT0000011043": "舞陽縣",
        "P_YS_PF_GZTSYS_0000108857": "失敗原因：",
        "P_YS_SCM_USTOCK-UI_0001077879": "顯示項，不需要輸入",
        "P_YS_OA_XTLCZX_0000030242": "主表",
        "P_YS_SCM_STOCK_0000034530": "修改單據信息",
        "P_YS_SCM_STOCK_0000034531": "制單時間",
        "P_YS_FED_IMP_IOT0000011050": "拱墅區",
        "P_YS_SCM_STOCK_0000034533": "收貨地址",
        "P_YS_FED_FW_1461189750035054592": "日曆天數",
        "P_YS_FED_IMP_IOT0000011057": "庫車縣",
        "P_YS_SCM_STOCK_0000034538": "開單-預訂",
        "P_YS_FED_IMP_IOT0000011053": "岳西縣",
        "P_YS_OA_XTLCZX_0000030239": "選項",
        "P_YS_FED_FW_0001159999": "前7周",
        "P_YS_FED_IMP_IOT0000011060": "壽縣",
        "P_YS_FED_FW_0001159998": "第七周",
        "P_YS_FED_FW_0001159997": "派送業務員",
        "P_YS_FED_FW_0001159996": "以下資料項目校驗失敗：'",
        "P_YS_FED_IMP_IOT0000011061": "餘杭區",
        "P_YS_SCM_STOCK_0000034501": "帳號",
        "P_YS_FED_IMP_IOT0000011068": "尚志市",
        "P_YS_SCM_STOCK_0000034504": "清空全部",
        "P_YS_FED_IMP_IOT0000011067": "射洪縣",
        "P_YS_FED_IMP_IOT0000011064": "晉源區",
        "P_YS_FED_IMP_IOT0000011066": "正鑲白旗",
        "P_YS_FED_IMP_IOT0000011071": "會澤縣",
        "P_YS_FED_IMP_IOT0000011070": "曲陽縣",
        "P_YS_FED_FW_0001265118": "正在保存，請稍後",
        "P_YS_FED_FW_0001265119": "非同步保存超時",
        "P_YS_SCM_STOCK_0000034513": "選擇退貨單",
        "P_YS_FED_FW_0001567737": "無圖片",
        "P_YS_SCM_STOCK_0000034514": "立即加入",
        "P_YS_FED_IMP_IOT0000011079": "鹽池縣",
        "P_YS_FED_IMP_IOT0000011078": "巴林右旗",
        "P_YS_SCM_STOCK_0000034518": "至少選擇一種結算方式",
        "P_YS_FED_IMP_IOT0000011075": "北道區",
        "P_YS_FED_IMP_IOT0000011077": "清水河縣",
        "P_YS_FED_IMP_IOT0000011076": "雙柏縣",
        "P_YS_FI_CM_0000029869": "請選擇日期",
        "P_YS_FED_IMP_IOT0000011082": "盤縣",
        "P_YS_FED_IMP_IOT0000011081": "雙清區",
        "P_YS_FED_IMP_IOT0000011084": "米泉市",
        "P_YS_FI_CM_0000029876": "YYYY年",
        "P_YS_PF_QITDFE_0000113168": "失敗原因",
        "P_YS_FED_IMP_IOT0000011088": "南鄭縣",
        "P_YS_PF_PRINT_0000065599": "組號",
        "P_YS_FED_UIMG_0001156156": "多語文本",
        "P_YS_HR_HRXC_0000177247": "最新版本",
        "P_YS_FED_IMP_IOT0000011091": "建水縣",
        "P_YS_FED_IMP_IOT0000011090": "祁東縣",
        "P_YS_FED_FW_1431429243042529280": "以下字段有誤，請正確輸入一下必填字段",
        "P_YS_FED_FW_0001253130": "地址不合法",
        "P_YS_PF_PROCENTER_0001131739": "UI模板",
        "P_YS_FED_IMP_IOT0000011099": "杏花嶺區",
        "P_YS_FED_IMP_IOT0000006598": "東風區",
        "P_YS_FED_IMP_IOT0000006597": "嵐縣",
        "P_YS_FED_IMP_IOT0000006599": "噶爾縣",
        "P_YS_FED_IMP_IOT0000006592": "梨樹區",
        "P_YS_FED_IMP_IOT0000006591": "臨西縣",
        "P_YS_FED_IMP_IOT0000006594": "武都區",
        "P_YS_FED_IMP_IOT0000006595": "阿巴嘎旗",
        "P_YS_PF_PRINT_0000106529": "打印模版",
        "P_YS_FI_CM_0000029811": "請選擇時間",
        "P_YS_FED_FW_0001097273": "沒找到子表",
        "P_YS_FED_FW_0001097272": "沒有關聯gridmodel",
        "P_YS_FED_IMP_IOT0000006583": "鐵鋒區",
        "P_YS_FED_IMP_IOT0000006582": "貢嘎縣",
        "P_YS_FED_IMP_IOT0000006584": "刪除成功",
        "P_YS_FED_IMP_IOT0000006577": "寧陵縣",
        "P_YS_FED_IMP_IOT0000006579": "藤縣",
        "P_YS_FED_FW_1549253106706939908": "網路開小差了，刷新試試吧~",
        "P_YS_FED_IMP_IOT0000006574": "札達縣",
        "P_YS_FED_IMP_IOT0000006567": "越城區",
        "P_YS_FED_IMP_IOT0000007898": "萬州區",
        "P_YS_FED_IMP_IOT0000007897": "寶興縣",
        "P_YS_FED_IMP_IOT0000006569": "八道江區",
        "P_YS_FED_IMP_IOT0000007899": "金家莊區",
        "P_YS_FED_IMP_IOT0000006561": "龍港區",
        "P_YS_FED_IMP_IOT0000006562": "萬柏林區",
        "P_YS_FED_IMP_IOT0000007893": "北關區",
        "P_YS_FED_IMP_IOT0000007884": "林州市",
        "P_YS_FED_IMP_IOT0000006556": "榕江縣",
        "P_YS_FED_IMP_IOT0000007887": "澗西區",
        "P_YS_FED_IMP_IOT0000007886": "杞縣",
        "P_YS_FED_IMP_IOT0000006559": "頭屯河區",
        "P_YS_FED_IMP_IOT0000006551": "田林縣",
        "P_YS_FED_IMP_IOT0000007882": "京山縣",
        "P_YS_FED_IMP_IOT0000006429": "卓尼縣",
        "P_YS_FED_FW_0000020988": "詳情",
        "P_YS_PF_GZTSYS_0000012655": "資料權限",
        "P_YS_FED_FW_0000020987": "二",
        "P_YS_FED_IMP_IOT0000006424": "蘭考縣",
        "P_YS_FED_IMP_IOT0000007755": "萊州市",
        "P_YS_FED_FW_0000020989": "確定要放棄當前修改嗎？",
        "P_YS_FED_IMP_IOT0000006423": "喜德縣",
        "P_YS_FED_IMP_IOT0000006426": "丹徒區",
        "P_YS_FED_IMP_IOT0000007757": "萬全縣",
        "P_YS_FED_IMP_IOT0000006425": "鶴城區",
        "P_YS_FED_FW_0001608880": "%c[mdf-cube] [staterule] [rule] parseCondition(), 無條件直接執行",
        "P_YS_FED_IMP_IOT0000006428": "滕州市",
        "P_YS_FED_IMP_IOT0000007759": "膠州市",
        "P_YS_FED_FW_0001608881": "%c是否反轉：",
        "P_YS_FED_IMP_IOT0000006427": "泉港區",
        "P_YS_FED_FW_0001608882": "%c[mdf-cube] [staterule] [rule] runRule(), 執行交互規則事件監聽：",
        "P_YS_FED_FW_0000020980": "條, 其中成功",
        "P_YS_FED_FW_0000020982": "成功",
        "P_YS_FED_FW_0000020984": "文本",
        "P_YS_FED_FW_0000020983": "未作任何修改",
        "P_YS_FED_FW_0000020986": "請選擇一條數據",
        "P_YS_FED_FW_0000020985": "星期日",
        "P_YS_PF_GZTSYS_0001106485": "事件查詢",
        "P_YS_FED_IMP_IOT0000007750": "泗陽縣",
        "P_YS_PF_GZTSYS_0000012671": "計量單位",
        "P_YS_PF_GZTSYS_0000012670": "企業信息",
        "P_YS_PF_PRINT_0000057241": "本幣未稅單價",
        "P_YS_FED_FW_0000055626": "必輸欄位不允許隱藏",
        "P_YS_FED_FW_0000020999": "星期三",
        "P_YS_FED_IMP_IOT0000006411": "烏當區",
        "P_YS_FED_IMP_IOT0000007742": "雲安縣",
        "P_YS_FED_FW_0001608872": "%c[mdf-cube] [staterule] [rule] runRule(), 給以下字段/表格綁定事件：",
        "P_YS_FED_FW_0001608873": "%c前端主動執行公式>>> ==>rules ==>targets",
        "P_YS_FED_IMP_IOT0000007744": "凱里市",
        "P_YS_FED_IMP_IOT0000006413": "羅平縣",
        "P_YS_PF_GZTSYS_0000012668": "授權",
        "P_YS_FED_FW_0001608874": "%c[mdf-cube] [staterule] [rule] showModal(), the parameter target==>, property=>, value==>, rule===> 彈出框：",
        "P_YS_FED_FW_0001608875": "%c>> 交互規則過濾出表格actions",
        "P_YS_FED_IMP_IOT0000006415": "瀘西縣",
        "P_YS_FED_IMP_IOT0000007746": "涇川縣",
        "P_YS_FED_IMP_IOT0000007745": "河曲縣",
        "P_YS_FED_FW_1498007515453456390": "值改變搜索：",
        "P_YS_FED_IMP_IOT0000006417": "大通回族土族自治縣",
        "P_YS_FED_FW_0001608870": "%c[mdf-cube] [staterule] [rule] parseExprsCondtion(), 條件驗證多列表格：",
        "P_YS_FED_IMP_IOT0000006416": "界首市",
        "P_YS_FED_IMP_IOT0000007747": "臨澤縣",
        "P_YS_FED_FW_0001608871": "%c[mdf-cube] [staterule] [rule] runActionGroup(), 解析單個rule所有動作的條件：",
        "P_YS_FED_FW_0000020991": "五",
        "P_YS_FED_FW_1498007515453456393": "手動搜索：",
        "P_YS_FED_FW_0000020990": "確定要刪除麼",
        "P_YS_FED_FW_0000020993": "刷新緩存成功",
        "P_YS_FED_FW_0000020992": "以下數據項校驗失敗：",
        "P_YS_FED_FW_1498007515453456396": "當搜索條件改變後，不會立即查詢，需要手動點擊 [搜索]",
        "P_YS_FED_FW_0000020995": "分類已是同級次的最後一個",
        "P_YS_FED_FW_0001608876": "%c[mdf-cube] [staterule] [rule] setGroupMeta(), the parameter target==>, property=>, value==> 設置容器：",
        "P_YS_FED_FW_0000020994": "整型",
        "P_YS_FED_FW_0001608877": "%c頁面規則>>> rules => 執行方式 => 來源 =>",
        "P_YS_FED_FW_0000020997": "獲取權限列表失敗--",
        "P_YS_FED_IMP_IOT0000007740": "啟東市",
        "P_YS_FED_FW_0001608878": "%c[mdf-cube] [staterule] [rule] runRule(), 執行交互規則事件監聽 條件返回結果：",
        "P_YS_FED_FW_1498007515453456399": "當查詢條件值改變後，立即觸發搜索",
        "P_YS_FED_FW_0000020996": "及其子",
        "P_YS_FED_FW_0001608879": "%c[mdf-cube] [staterule] [rule] runRule(), 綁定：",
        "P_YS_FED_IMP_IOT0000006408": "屏山縣",
        "P_YS_FED_IMP_IOT0000007739": "黎川縣",
        "P_YS_FED_IMP_IOT0000006407": "港南區",
        "P_YS_FED_IMP_IOT0000006409": "商水縣",
        "P_YS_FED_FW_0000020965": "條",
        "P_YS_FED_FW_0001608862": "%c執行動作 start time：",
        "P_YS_FED_FW_0000020968": "周",
        "P_YS_FED_IMP_IOT0000006402": "睢縣",
        "P_YS_FED_FW_0001608863": "%c公式解析失敗>>",
        "P_YS_FED_FW_0000020967": "未找到具體單據",
        "P_YS_FED_FW_0001608864": "%c執行動作 end time：",
        "P_YS_FED_IMP_IOT0000006404": "東區",
        "P_YS_FED_IMP_IOT0000007735": "扶溝縣",
        "P_YS_FED_FW_0000020969": "表單自定義項升級成功",
        "P_YS_FED_IMP_IOT0000006403": "文安縣",
        "P_YS_FED_IMP_IOT0000006406": "請輸入聯繫方式",
        "P_YS_PF_GZTSYS_0000012631": "交易類型",
        "P_YS_FED_IMP_IOT0000007736": "香河縣",
        "P_YS_FED_FW_0001608869": "%c[mdf-cube] [staterule] [rule] runRule(), 解析所有rules條件：",
        "P_YS_FED_FW_0000020960": "，是否繼續？",
        "P_YS_FED_FW_0000020962": "簡體中文",
        "P_YS_FED_FW_0001608865": "%c調用後端計算介面獲取到值 /bill/executeFormulaCalculate：",
        "P_YS_PF_PROCENTER_0000027569": "打印預覽",
        "P_YS_FED_FW_0000020961": "保存成功",
        "P_YS_FED_FW_0001608866": "%c[mdf-cube] [staterule] [rule] setValue(), the parameter target==>, value==> 賦值：",
        "P_YS_FED_FW_0000020964": "請預置列印按鈕的cParameter資訊{printTplItemName : 列印模板的cItemName}",
        "P_YS_FED_FW_0001608867": "%c[mdf-cube] [staterule] [rule] compareJSON(), JSON串左右不匹配：",
        "P_YS_FED_FW_0000020963": "模板內容匯入返回信息： xhr.readyState =",
        "P_YS_FED_FW_0001608868": "%c[mdf-cube] [staterule] [rule] setMeta(), the parameter target==>, property=>, value==> 設置屬性：",
        "P_YS_PF_PROCENTER_0000027553": "提示",
        "P_YS_FED_IMP_IOT0000007728": "向陽區",
        "P_YS_PF_MANAGER-FE_0001087905": "標籤模式",
        "P_YS_FED_IMP_IOT0000007727": "匯出",
        "P_YS_PF_QITDFE_0001085652": "組織樹",
        "P_YS_FED_FW_0000020977": "請輸入作廢理由",
        "P_YS_FED_FW_0000020976": "請選擇打印模板。",
        "P_YS_FED_FW_0000020978": "直接打印插件啟動異常，如需幫助請點擊確認！",
        "P_YS_FED_IMP_IOT0000007723": "靖州苗族侗族自治縣",
        "P_YS_PF_GZTSYS_0000012642": "供應商分類",
        "P_YS_FED_IMP_IOT0000007725": "北碚區",
        "P_YS_FED_FW_0000020971": "模板內容匯入失敗，",
        "P_YS_FED_FW_0000020970": "六",
        "P_YS_FED_FW_0000020973": "不能為空",
        "P_YS_FED_FW_0000020972": "星期四",
        "P_YS_FED_FW_0000020975": "獲取單據編碼規則錯誤:",
        "P_YS_FED_FW_0000020974": "請求數據失敗",
        "P_YS_SD_SDMAUF_0001023417": "永川市",
        "P_YS_FED_IMP_IOT0000007717": "林西縣",
        "P_YS_SD_SDMAUF_0001023413": "銅仁地區",
        "P_YS_PF_PRINT_0000057278": "自定義項5",
        "P_YS_FED_IMP_IOT0000007716": "朝陽縣",
        "P_YS_PF_PRINT_0000057281": "自定義項4",
        "P_YS_FED_IMP_IOT0000007714": "望謨縣",
        "P_YS_FED_FW_0001473890": "UI模板:",
        "P_YS_FED_FW_0001447586": "共選中資料",
        "P_YS_PF_PRINT_0000057288": "自定義項1",
        "P_YS_PF_PRINT_0000057286": "自定義項6",
        "P_YS_PF_PRINT_0000057283": "自定義項7",
        "P_YS_PF_PRINT_0000057293": "自定義項2",
        "P_YS_PF_PRINT_0000057291": "自定義項3",
        "P_YS_FED_IMP_IOT0000007700": "納溪區",
        "P_YS_FED_IMP_IOT0000007702": "連平縣",
        "P_YS_FED_IMP_IOT0000007704": "綿竹市",
        "P_YS_SD_SDMB-FE_0001535210": "渲染異常。可通過控制臺查看異常資訊。 comInfo =",
        "P_YS_FED_FW_0001235097": "缺少settingNavBar方法",
        "P_YS_SD_SDMBF_0000143729": "高級篩選",
        "P_YS_PF_PRINT_0000057259": "銷售型別匯總",
        "P_YS_PF_GZTSYS_0000012680": "供應商檔案",
        "end": "已完成",
        "P_YS_HR_HRRCPDF_0001077675": "已選(",
        "P_YS_PF_GZTSYS_0000012689": "數據分析",
        "P_YS_PF_GZTSYS_0000012684": "結算方式",
        "P_YS_SCM_STOCK_0000034188": "商品行入庫數量與序列號數量不一致，請檢查！",
        "P_YS_SCM_STOCK_0000034189": "優惠券金額將超出應收金額，是否繼續？",
        "P_YS_FED_FW_0000122939": "未獲取到行號",
        "P_YS_HR_HRJXF_0000059283": "進度條",
        "HR": "人力",
        "P_YS_FED_FW_0001191808": "缺少mdfChangeCustomScanMode方法",
        "P_YS_FED_FW_0001191809": "缺少mdfCustomScanQRCode方法",
        "P_YS_FED_FW_1482770783956107324": "文本編輯欄目",
        "P_YS_PF_PROCENTER_0000022730": "女",
        "P_YS_SCM_STOCK_0000034195": "預訂單",
        "P_YS_SCM_STOCK_0000034197": "不支持移動端退貨，請在PC端操作",
        "P_YS_SCM_STOCK_0000034198": "未收金額",
        "P_YS_FED_FW_0000020919": "一",
        "P_YS_FED_FW_0000020918": "√",
        "P_YS_FED_FW_1603072749183959045": "標籤一",
        "P_YS_FED_FW_0001191810": "缺少mdfChangeFlashLightStatus方法",
        "P_YS_FED_FW_0000020917": "確認",
        "P_YS_FED_FW_0001191811": "掃碼成功結果",
        "P_YS_FED_FW_1603072749183959042": "標籤二",
        "P_YS_SCM_STOCK_0000034166": "客單價",
        "P_YS_SCM_STOCK_0000034167": "請輸入條形碼",
        "000357": "刪除檔",
        "P_YS_PF_GZTTMP_0000077606": "物流信息",
        "P_YS_FED_FW_0000097427": "getMeasureValues沒有在一維表找到 t2DRowKey =",
        "P_YS_FED_FW_0000097426": "二維表行列變化異常，沒有列型別t2DColType。data=",
        "P_YS_FED_FW_0000097425": "在一維表中發現多行符合當前交叉點行列鍵值的數據 t2DRowKey =",
        "P_YS_FED_FW_0000097423": "初始化沒有找到一維表editRowModel或者editRowModel中沒找到物料Model或者物料Model型別不是ReferModel",
        "P_YS_SCM_STOCK_0000034171": "成功添加一件商品",
        "P_YS_FI_IA_0000054929": "單據類型",
        "P_YS_FED_FW_0000097420": "table2DRowColChange 一維表當前index =",
        "P_YS_FED_FW_0000110980": "存在重複行。信息如下 code=",
        "P_YS_SCM_STOCK_0000034175": "聯繫人手機",
        "P_YS_FED_FW_1536786757976588288": "銷售合約-即時分析",
        "P_YS_FED_FW_1601623034510704640": "數據校驗發生異常,請聯繫支持人員排查\\n",
        "P_YS_FED_FW_0000097418": "所有信息-二維表欄目 columns =",
        "P_YS_FED_FW_0000097417": "一維表存在行鍵值為空的行。 一維表所有行  =",
        "P_YS_FED_FW_0000097416": "一維表存在行鍵值為空的行。 空行 =",
        "P_YS_SCM_STOCK_0000034182": "批號",
        "P_YS_SCM_STOCK_0000034183": "原銷售價",
        "P_YS_FED_FW_1588021594661322759": "請選擇要導出的數據",
        "P_YS_FED_FW_0001200368": "已掃(",
        "P_YS_PF_PRINT_0000065739": "物料sku編碼",
        "P_YS_FED_FW_0000020944": "確定要放棄麼",
        "P_YS_FED_FW_0000020943": "模板內容匯入失敗",
        "P_YS_FED_FW_0000020946": "星期五",
        "P_YS_FED_FW_0000020945": "條,失敗",
        "P_YS_FED_FW_0000020948": "單次最大匯出2000條,請重新選擇後重試！",
        "P_YS_FED_FW_0000020947": "單據聯查結果顯示",
        "P_YS_FED_FW_0000020949": "繁體中文",
        "P_YS_FED_FW_0000020940": "分類最多",
        "P_YS_FED_FW_0000020941": "共匯入",
        "P_YS_FED_FW_0000020955": "停用",
        "P_YS_FED_FW_0000020954": "接口返回格式不是application/json格式：",
        "P_YS_FED_FW_0000020957": "檔案",
        "P_YS_FED_FW_0000020956": "麼",
        "P_YS_FED_FW_0000020959": "沒有取到保存參數",
        "P_YS_FED_FW_0000020958": "設置單據編碼規則錯誤:",
        "P_YS_PES_PES-FE_0001193111": "清空已選",
        "P_YS_SD_SDSD-FE_0001491730": "數量",
        "P_YS_FED_FW_0000020951": "請選擇打印模板",
        "P_YS_FED_FW_0000020950": "是否確認停用此記錄",
        "P_YS_SD_SDMA_0000061679": "商城",
        "P_YS_FED_FW_0001212374": "該單據已經被刪除或者沒有許可權",
        "P_YS_FED_FW_1529944651755683856": "預設列舉值",
        "P_YS_PF_METADATA_0001044255": "確認狀態",
        "P_YS_FED_FW_1529944651755683853": "列舉項最多可選五個！",
        "P_YS_FED_FW_0000020929": "出錯啦後台->",
        "P_YS_FED_FW_1529944651755683850": "請選擇列舉日期項！",
        "P_YS_FED_FW_0000020922": "審批流初始化成功",
        "P_YS_FED_FW_0000020921": "數據量較大，預覽可能比較慢，是否使用打印插件，是否直接靜默打印",
        "P_YS_FED_FW_0000020924": "請預置列印按鈕的cParameter資訊 { printTplItemName : 列印模板的cItemName}",
        "P_YS_FED_FW_0000020923": "條, 成功",
        "P_YS_FED_FW_0000020926": "三",
        "P_YS_FED_FW_0000020925": "合併請求提交失敗:",
        "P_YS_PF_PROCENTER_0000022757": "財務",
        "P_YS_FED_FW_0001656543": "請選擇或錄入",
        "P_YS_FED_FW_0000020927": "匯入已轉入後台處理，可進行其它操作！",
        "P_YS_FED_FW_0000020920": "星期六",
        "P_YS_FED_FW_1529944651755683847": "常用列舉項",
        "P_YS_FED_FW_0000020933": "請先提交",
        "P_YS_FED_FW_0000020932": "匯出模板的地址為空",
        "P_YS_FED_FW_0000020935": "失敗",
        "P_YS_FED_FW_0000020934": "分類已是同級次的第一個",
        "P_YS_FED_FW_0000020937": "星期二",
        "P_YS_FED_FW_0000020936": "未選擇數據，請選擇數據後重試！",
        "P_YS_FED_FW_0000020939": "保存業務對象成功",
        "P_YS_FED_FW_0000020938": ",返回信息：",
        "P_YS_FED_FW_0000020930": "保存出錯",
        "P_YS_SCM_STOCK_0000034222": "退貨折扣額",
        "P_YS_SCM_STOCK_0000034225": "掃碼支付",
        "P_YS_OA_XTHUIYI_0000046356": "選項 2",
        "P_YS_PF_GZTTMP_0000076264": "對帳",
        "P_YS_OA_XTHUIYI_0000046353": "選項 1",
        "P_YS_OA_XTHUIYI_0000046352": "選項 6",
        "P_YS_OA_XTHUIYI_0000046355": "選項 3",
        "P_YS_HR_HRJXF_0001080015": "取值方式",
        "P_YS_OA_XTHUIYI_0000046351": "選項 4",
        "P_YS_SCM_STOCK_0000034231": "未識別到該商品",
        "P_YS_SCM_STOCK_0000034232": "請選擇操作員！",
        "P_YS_SCM_STOCK_0000034234": "推送時間",
        "P_YS_SCM_STOCK_0000034235": "未選中任何規格！",
        "P_YS_SCM_STOCK_0000034238": "總計",
        "P_YS_SD_UDHWN_0001010199": "%s內",
        "P_YS_FED_FW_0001049265": "{value} 星",
        "P_YS_SCM_PU_0000028093": "已審核",
        "P_YS_SCM_STOCK_0000034202": "開燈",
        "P_YS_SCM_STOCK_0000034208": "改折扣率",
        "P_YS_FI_FA_0000033394": "方案名稱",
        "P_YS_SCM_STOCK_0000034214": "折後金額",
        "P_YS_SCM_STOCK_0000034216": "有效期至",
        "P_YS_FI_CM_0000029922": "ден",
        "P_YS_FED_FW_0001201615": "存在必輸項:",
        "P_YS_FED_FW_1587131084714803208": "範圍值精度不允許超過15，請修改",
        "P_YS_FED_FW_0001202951": "頁面中有未保存的數據，點擊確定後將清除數據並重啟頁面，確定繼續？",
        "P_YS_SD_SDMAF_0000135935": "加載",
        "P_YS_FED_FW_1498007515453456402": "若預置方案中沒有您想要的條件，可以自定義過濾條件",
        "P_YS_FED_FW_1498007515453456405": "選擇該查詢條件的所在位置",
        "P_YS_SD_SDMAF_0000135940": "請輸入日期",
        "P_YS_FED_FW_1618507375587098631": "沒有code或name",
        "P_YS_OA_app_xtywlj_0000037814": "預測",
        "P_YS_OA_XTHUIYI_0000046348": "選項 5",
        "P_YS_FED_FW_0001256796": "默認全部",
        "P_YS_FED_FW_0001382541": "移動方案(僅移動端生效)",
        "P_YS_FED_FW_0001382542": "Web個人方案",
        "P_YS_FED_FW_0001382543": "移動公共方案",
        "P_YS_FED_FW_0001382544": "Web方案",
        "P_YS_FED_FW_0001382540": "Web公共方案",
        "P_YS_FED_FW_0001382545": "移動個人方案",
        "P_YS_FED_UCFBASEDOC_0000025456": "出庫",
        "P_YS_FED_FW_0000080521": "分組信息缺失，默認為 product product_cCode product_cName",
        "P_YS_FED_FW_0000080522": "分組信息缺失， 接口返回的groupFields =",
        "P_YS_FED_FW_0000080520": "供應商檔案模版.xlsx",
        "P_YS_FED_FW_0001147663": "請求模板失敗：",
        "P_YS_FED_FW_0001147664": "返回了異常值",
        "P_YS_SD_UDHWN_0001010118": "幾秒",
        "P_YS_FED_IMP_IOT0000006491": "若爾蓋縣",
        "P_YS_FED_IMP_IOT0000006493": "皮山縣",
        "P_YS_FED_UCFBASEDOC_0000025448": "重發",
        "P_YS_FED_IMP_IOT0000006492": "山陰縣",
        "P_YS_FED_FW_1441618872572051456": "%未找到對應頁簽",
        "P_YS_FED_FW_1575378258895044792": "您好，1.“增加”按鈕不支持表體“多行”數據取值；2，“增加”按鈕預計於2022.12.30切換為“公式”，請使用高級設計器設置，如：“高級設計器-字段設置”、“高級設計器-公式”。",
        "P_YS_FED_IMP_IOT0000006487": "安定區",
        "P_YS_FED_IMP_IOT0000006489": "石屏縣",
        "P_YS_FED_IMP_IOT0000006480": "翠屏區",
        "P_YS_FED_IMP_IOT0000006482": "遂平縣",
        "P_YS_FED_IMP_IOT0000006483": "冷水灘區",
        "P_YS_FED_UCFBASEDOC_0000025433": "列印",
        "P_YS_FED_IMP_IOT0000006486": "長樂市",
        "P_YS_FED_IMP_IOT0000006485": "新泰市",
        "P_YS_FED_FW_0001428307": "單據將被撤回為開立態，確定要撤回單據嗎？",
        "P_YS_SD_UDHWN_0000120920": "切換語言",
        "P_YS_FED_IMP_IOT0000006479": "豐澤區",
        "P_YS_FI_CM_0000026019": "】",
        "P_YS_FI_CM_0000026016": "【",
        "P_YS_FED_IMP_IOT0000006471": "石阡縣",
        "P_YS_FED_IMP_IOT0000006470": "陽城縣",
        "P_YS_FED_IMP_IOT0000006475": "懷寧縣",
        "P_YS_SD_UDHWN_0000048940": "石河子市",
        "P_YS_FI_CM_0000029930": "我知道了",
        "P_YS_SD_UDHWN_0001010147": "%d 天",
        "P_YS_FED_IMP_IOT0000006468": "明水縣",
        "P_YS_FED_FW_1545722866933170185": "為按單",
        "P_YS_FED_IMP_IOT0000006467": "永順縣",
        "P_YS_FED_IMP_IOT0000007798": "尼勒克縣",
        "P_YS_FED_FW_1598599506385436673": "個,請調整後重試",
        "P_YS_FED_FW_1598599506385436676": "已選數據項總數超過最大限制",
        "P_YS_FED_FW_1545722866933170188": "(當前為明細模式，",
        "P_YS_FED_IMP_IOT0000006460": "松滋市",
        "P_YS_FED_IMP_IOT0000007791": "通化縣",
        "P_YS_FED_IMP_IOT0000006462": "蒼山縣",
        "P_YS_FED_IMP_IOT0000007793": "文登市",
        "P_YS_FED_IMP_IOT0000006464": "樂平市",
        "P_YS_OA_XTRICHENG_0000046040": "娛樂",
        "P_YS_SD_UDHWN_0001010155": "星期日_星期一_星期二_星期三_星期四_星期五_星期六",
        "P_YS_HR_HRJQ_0000030978": "您",
        "P_YS_SD_UDHWN_0000120944": "向後 5 頁",
        "P_YS_FED_IMP_IOT0000006454": "南關區",
        "P_YS_FED_IMP_IOT0000007785": "禹會區",
        "P_YS_FED_IMP_IOT0000006456": "定南縣",
        "P_YS_FED_IMP_IOT0000007787": "大港區",
        "P_YS_FED_IMP_IOT0000006459": "雙橋區",
        "P_YS_SD_SDMAUF_0000151805": "暫無物流信息",
        "P_YS_FED_IMP_IOT0000007784": "海港區",
        "P_YS_FED_IMP_IOT0000006452": "高碑店市",
        "P_YS_FED_FW_0001296125": "imagesUrl : 未獲取到列印圖片url",
        "P_YS_FED_FW_0001296124": "缺少getBlueToothState方法",
        "P_YS_FED_FW_0001296123": "未掃描到附近藍牙印表機",
        "P_YS_FED_IMP_IOT0000007774": "和林格爾縣",
        "P_YS_OA_app_xtywlj_0000037899": "時",
        "P_YS_FED_IMP_IOT0000006446": "麒麟區",
        "P_YS_SD_UDHWN_0001010128": "日_一_二_三_四_五_六",
        "P_YS_FED_IMP_IOT0000006445": "瀘溪縣",
        "P_YS_FED_IMP_IOT0000006448": "巫溪縣",
        "P_YS_FED_IMP_IOT0000007779": "安溪縣",
        "P_YS_FI_CM_0000029954": "切換為折線圖",
        "P_YS_FED_IMP_IOT0000006442": "應城市",
        "P_YS_FED_FW_0001368219": "當前登陸人",
        "P_YS_FED_IMP_IOT0000007772": "佛岡縣",
        "P_YS_SD_UDHWN_0001010130": "早上",
        "P_YS_FED_IMP_IOT0000006433": "莎車縣",
        "P_YS_FED_IMP_IOT0000007763": "湯原縣",
        "P_YS_FED_IMP_IOT0000006435": "共和縣",
        "P_YS_FED_IMP_IOT0000007766": "巴青縣",
        "P_YS_FED_IMP_IOT0000006434": "嘉禾縣",
        "P_YS_FED_IMP_IOT0000007765": "朝陽區",
        "P_YS_FED_IMP_IOT0000006439": "興山縣",
        "P_YS_FED_IMP_IOT0000007760": "靖邊縣",
        "P_YS_FED_IMP_IOT0000006431": "興慶區",
        "P_YS_FED_IMP_IOT0000006430": "醴陵市",
        "P_YS_IDOC_RECORD-BE_0001375534": "密級",
        "P_YS_FED_FW_0001504309": "‰",
        "P_YS_FED_IMP_IOT0000006301": "路橋區",
        "P_YS_FED_IMP_IOT0000006300": "太和區",
        "P_YS_FED_IMP_IOT0000007631": "子洲縣",
        "P_YS_FED_IMP_IOT0000008965": "茅箭區",
        "P_YS_FED_IMP_IOT0000007634": "雙陽區",
        "P_YS_SD_UDHWN_0000120730": "向前 5 頁",
        "P_YS_FED_FW_0000157519": "是否是空值",
        "P_YS_FED_IMP_IOT0000008968": "佳木斯",
        "P_YS_FED_IMP_IOT0000006305": "紅旗區",
        "P_YS_FED_IMP_IOT0000007635": "龍沙區",
        "P_YS_FED_IMP_IOT0000008969": "海鹽縣",
        "P_YS_FED_FW_0001504310": "填寫信息有誤！請重新填寫",
        "P_YS_FED_IMP_IOT0000007638": "攸縣",
        "P_YS_FED_IMP_IOT0000006306": "魯甸縣",
        "P_YS_FED_IMP_IOT0000008967": "津南區",
        "P_YS_FED_FW_0000157515": "時間選擇",
        "P_YS_FED_FW_0000157516": "行選擇事件",
        "P_YS_FED_FW_0000157517": "上拉加載",
        "P_YS_FED_FW_0000157518": "返回方法",
        "P_YS_FED_FW_0000157511": "選擇框",
        "P_YS_FED_FW_0000157512": "行點擊事件",
        "P_YS_FED_FW_0000157513": "是否編輯",
        "P_YS_FED_IMP_IOT0000007630": "平塘縣",
        "P_YS_FED_FW_0000157514": "輸入InspectionSheet框",
        "P_YS_FED_FW_0000157510": "改變的回調",
        "P_YS_PF_GZTSYS_0000012545": "元數據",
        "P_YS_FED_IMP_IOT0000007620": "霍林郭勒市",
        "P_YS_FED_IMP_IOT0000007623": "資中縣",
        "P_YS_FED_IMP_IOT0000007622": "雄縣",
        "P_YS_FED_FW_0000157508": "關閉方法",
        "P_YS_FED_FW_0000157509": "取消方法",
        "P_YS_FED_IMP_IOT0000008958": "長汀縣",
        "P_YS_FED_IMP_IOT0000008955": "撫遠縣",
        "P_YS_FED_IMP_IOT0000007626": "明溪縣",
        "P_YS_FED_IMP_IOT0000008956": "廣安區",
        "P_YS_FED_FW_0000157504": "樹參照",
        "P_YS_FED_FW_0000157505": "多行輸入",
        "P_YS_FED_FW_0000157506": "搜索框",
        "P_YS_FED_FW_0000157507": "是否加載",
        "P_YS_FED_FW_0000157502": "允許多選",
        "P_YS_FED_FW_0000157503": "數字輸入框",
        "P_YS_FED_IMP_IOT0000007618": "大安區",
        "P_YS_FED_IMP_IOT0000007617": "順城區",
        "P_YS_FED_IMP_IOT0000008948": "坡頭區",
        "P_YS_FED_IMP_IOT0000008949": "五華縣",
        "P_YS_FED_IMP_IOT0000007610": "旅順口區",
        "P_YS_FED_IMP_IOT0000008943": "紅山區",
        "P_YS_HR_HRXCF_0000072620": "1日",
        "P_YS_FED_IMP_IOT0000008941": "三原縣",
        "P_YS_FED_IMP_IOT0000008947": "榆陽區",
        "P_YS_FED_IMP_IOT0000008944": "松桃苗族自治縣",
        "P_YS_FED_FW_1581848446750425093": "同步下級",
        "P_YS_PF_GZTSYS_0000012516": "單據號",
        "P_YS_FED_FW_0000096297": "是否確認刪除已選附件？",
        "P_YS_FED_IMP_IOT0000007607": "宜賓縣",
        "P_YS_PF_PRINT_0000057345": "集團",
        "P_YS_FED_IMP_IOT0000007606": "寧武縣",
        "P_YS_SD_SDMAUF_0001023367": "阿城市",
        "P_YS_FED_IMP_IOT0000008938": "筠連縣",
        "P_YS_FED_IMP_IOT0000008931": "安澤縣",
        "P_YS_FED_IMP_IOT0000008932": "泉山區",
        "P_YS_FED_IMP_IOT0000007601": "三穗縣",
        "P_YS_FED_IMP_IOT0000008930": "林甸縣",
        "P_YS_FED_IMP_IOT0000007602": "河東區",
        "P_YS_FED_IMP_IOT0000007605": "遷安市",
        "P_YS_FED_IMP_IOT0000008933": "太白縣",
        "P_YS_FED_FW_1607451373850853376": "UI模板ID：",
        "P_YS_FED_IMP_IOT0000008934": "新華區",
        "P_YS_FED_FW_1607451373850853379": "UI模板名稱：",
        "P_YS_FED_FW_1440911671847026691": "～～不支持的展示型別～～",
        "P_YS_PF_GZTSYS_0000012580": "個人信息",
        "P_YS_FED_IMP_IOT0000008929": "武侯區",
        "P_YS_PF_GZTSYS_0000012583": "客戶",
        "P_YS_FED_FW_0001388572": "列印模版:",
        "P_YS_PF_PROCENTER_0000022808": "保質期單位",
        "P_YS_FED_IMP_IOT0000008920": "麻山區",
        "P_YS_PF_GZTSYS_0000012577": "發運方式",
        "P_YS_FED_IMP_IOT0000008921": "蓬安縣",
        "P_YS_FED_IMP_IOT0000008924": "陽曲縣",
        "P_YS_FED_IMP_IOT0000008922": "廣饒縣",
        "P_YS_FED_FW_0001344100": "關閉參照彈窗",
        "P_YS_FED_IMP_IOT0000008917": "霍邱縣",
        "P_YS_PF_GZTSYS_0000012594": "任務",
        "P_YS_FED_IMP_IOT0000008916": "興文縣",
        "P_YS_FED_FW_1440911671847026688": "～～數據格式錯誤, 應為數組～～",
        "P_YS_PF_GZTSYS_0000012589": "審批",
        "P_YS_FED_IMP_IOT0000008910": "若羌縣",
        "P_YS_SD_SDDM_0001141756": "當天",
        "P_YS_FED_FW_1465534710770827264": "calsControls介面錯誤",
        "P_YS_FED_IMP_IOT0000008913": "多倫縣",
        "P_YS_PF_GZTSYS_0000012587": "序列號",
        "P_YS_FED_IMP_IOT0000008911": "銀州區",
        "P_YS_FED_FW_1465534710770827267": "getAssignValue介面錯誤",
        "P_YS_FED_IMP_IOT0000008912": "玉樹縣",
        "P_YS_PF_GZTSYS_0000012586": "培訓",
        "P_YS_FED_FW_0001026604": "文件必須小於<%=text%>",
        "P_YS_FED_IMP_IOT0000008906": "吉水縣",
        "P_YS_PF_GZTSYS_0000012561": "倉庫",
        "P_YS_FED_IMP_IOT0000008904": "樂安縣",
        "P_YS_FED_IMP_IOT0000008908": "海晏縣",
        "P_YS_FI_CM_0000026041": "未審批",
        "P_YS_PF_GZTSYS_0000012557": "部門",
        "P_YS_FED_IMP_IOT0000008902": "新安縣",
        "P_YS_FED_IMP_IOT0000008901": "松北區",
        "P_YS_FED_FW_1593218831501230088": "以下字段有誤(或存在必填項):",
        "P_YS_PF_ANALYTIC-FE_0001650866": "近10天",
        "P_YS_PF_GZTSYS_0000012567": "客戶屬性",
        "P_YS_PF_GZTSYS_0000012563": "自定義項",
        "P_YS_PF_GZTSYS_0000012565": "產品線",
        "P_YS_OA_XTLCZX_0000030093": "提交時間",
        "P_YS_SD_SDMA_0000060271": "二維碼",
        "P_YS_FED_FW_0000162048": "重複行信息",
        "P_YS_FED_FW_0000162047": "setTable2DEditRowModel 二維表 editRowModel修改為二維表自己的",
        "P_YS_FED_FW_0000162046": "setTable2DEditRowModel 二維表 editRowModel修改為一維表的",
        "P_YS_PF_GZTTMP_0000075105": "結束以",
        "P_YS_HR_HRRCPDF_0000071164": "標準",
        "P_YS_SCM_STOCK_0000034286": "選好了",
        "P_YS_SCM_STOCK_0000034289": "請選擇規格屬性 !",
        "P_YS_FED_FW_0001479880": "變更生效失敗",
        "P_YS_YYGJFW_YBUC_0001336088": "更多操作",
        "P_YS_SD_SDMA_0000060254": "訂單編號",
        "P_YS_SCM_STOCK_0000034290": "訂單號",
        "P_YS_SCM_STOCK_0000034292": "選擇提貨方式",
        "P_YS_SCM_STOCK_0000034293": "請先錄入倉庫!",
        "000241": "執行查詢",
        "P_YS_SCM_STOCK_0000034295": "可用量",
        "P_YS_SCM_STOCK_0000034297": "掃碼錄入",
        "P_YS_SCM_STOCK_0000034298": "切換掃碼",
        "P_YS_SD_SDMBF_0000142308": "選項2",
        "P_YS_SD_SDMBF_0000142307": "選項3",
        "P_YS_FED_FW_0001543963": "終點",
        "P_YS_SD_SDMBF_0000142309": "選項1",
        "P_YS_FED_FW_0001543962": "步行",
        "P_YS_FED_FW_1483362578909888518": "查詢條件在導航區時不允許手動搜索",
        "P_YS_SCM_STOCK_0000034265": "實銷金額：",
        "P_YS_SCM_STOCK_0000034269": "消息",
        "P_YS_SD_SDSD-FE_0001357089": "資料加載中...",
        "P_YS_FED_FW_0001543959": "起點",
        "P_YS_FED_FW_1441228949671116830": "分組折疊",
        "P_YS_FED_FW_0001543961": "圓形",
        "P_YS_FED_FW_0001543960": "駕車",
        "P_YS_SD_SDSD-FE_0001491840": "單據日期",
        "P_YS_SCM_STOCK_0000034275": "電商訂單不允許使用多種支付方式",
        "P_YS_PF_BD-UI_0000157869": "普通採購",
        "P_YS_SCM_STOCK_0000034276": "選擇退貨原因",
        "P_YS_SCM_STOCK_0000034278": "重打小票",
        "P_YS_FED_FW_1441228949671116824": "查詢區調整",
        "P_YS_SD_SDMAUF_0001023389": "思茅市",
        "P_YS_FED_FW_1441228949671116827": "lineTab切換",
        "P_YS_SD_SDMAUF_0001023380": "畢節地區",
        "P_YS_FED_FW_1441228949671116821": "表頭明細切換",
        "P_YS_FED_FW_0001656634": "刪除草稿失敗",
        "P_YS_PF_PROCENTER_0000022885": "保質期",
        "P_YS_SCM_STOCK_0000034280": "繼續開單",
        "P_YS_SCM_STOCK_0000034281": "輸入",
        "P_YS_SD_SDMA_0000061552": "貨到付款",
        "P_YS_SCM_STOCK_0000034282": "，本單應收金額",
        "P_YS_SCM_UPU-UI_0001368234": "近3月",
        "P_YS_SCM_STOCK_0000034284": "退貨商品",
        "P_YS_SCM_STOCK_0000034285": "選好了？",
        "P_YS_SCM_STOCK_0000034243": "請輸入密碼！",
        "P_YS_SCM_STOCK_0000034244": "收款成功",
        "P_YS_SCM_STOCK_0000034247": "超出最大找零金額，無法結算",
        "P_YS_FED_FW_1441228949671116815": "查詢方案pop展示切換",
        "P_YS_FED_FW_1441228949671116818": "查詢方案設為默認",
        "P_YS_FED_FW_1441228949671116812": "查詢方案自動搜索設置",
        "P_YS_SD_SDMB_0000140551": "自定義2",
        "P_YS_HR_HRRCPDF_0000071178": "方案名稱不能為空",
        "P_YS_SD_SDMB_0000140553": "自定義1",
        "P_YS_SCM_STOCK_0000034250": "版本號",
        "P_YS_SCM_STOCK_0000034254": "實退金額",
        "P_YS_SCM_STOCK_0000034257": "實收金額",
        "P_YS_SCM_STOCK_0000034259": "優惠券已經存在，請檢查。",
        "P_YS_FED_FW_1441228949671116803": "方案編輯|新增彈窗確認",
        "P_YS_FED_FW_1441228949671116806": "方案編輯|新增彈窗取消",
        "P_YS_FED_FW_1441228949671116809": "最大化按鈕",
        "P_YS_FED_FW_1441228949671116800": "展示更多查詢區",
        "P_YS_HR_HRRCPDF_0000071186": "用友網絡科技股份有限公司",
        "P_YS_FED_FW_1615403591714471941": "請在搜索框中錄入關鍵字搜索",
        "P_YS_SCM_STOCK_0000034263": "個促銷活動",
        "P_YS_SCM_STOCK_0000034341": "單價",
        "P_YS_SCM_STOCK_0000034343": "已發送至",
        "P_YS_FED_FW_0001523503": "智能搜索中...",
        "P_YS_PF_PRINT_0000065776": "物料sku名稱",
        "P_YS_SCM_STOCK_0000034351": "預訂單詳情",
        "P_YS_PF_SOCD-E_0000490245": "康定市",
        "P_YS_SCM_STOCK_0000034354": "商品不存在",
        "P_YS_SCM_STOCK_0000034357": "查看並編輯個人資料",
        "P_YS_SCM_STOCK_0000034358": "表裡的ID為",
        "P_YS_OA_XTMENHUCMS_0000045057": "執行中",
        "P_YS_FED_FW_0000113165": "至少錄入一行數據！",
        "P_YS_FED_FW_0000113164": "暫無審批詳情",
        "P_YS_FED_FW_0001455872": "單據未審核通過，不允許列印！",
        "P_YS_SCM_STOCK_0000034362": "會員/手機號",
        "P_YS_FED_FW_0001455873": "<%=abandonText%>條資料未審核通過，不允許列印",
        "P_YS_SCM_STOCK_0000034320": "當前商品行沒有可用sku數據",
        "P_YS_SCM_STOCK_0000034321": "提貨方式",
        "P_YS_SCM_STOCK_0000034328": "沒有更多了哦~",
        "P_YS_SD_UDHWN_0001010044": "%d 小時",
        "P_YS_FED_FW_0001301010": "正在計算時間",
        "P_YS_FED_FW_1555177996907708424": "子表第<%=rowno%>行",
        "P_YS_SCM_STOCK_0000034335": "商品合計",
        "P_YS_PF_GZTORG_0000035173": "修改人",
        "P_YS_OA_XTMENHUCMS_0000045039": "完成率",
        "P_YS_SCM_STOCK_0000034302": "應收金額",
        "P_YS_SCM_STOCK_0000034305": "超入庫範圍",
        "P_YS_SCM_STOCK_0000034307": "入庫數量不能為空!",
        "P_YS_SCM_STOCK_0000034309": "收款總額",
        "P_YS_FED_FW_0001625448": "當前頁面數據未更改",
        "P_YS_SCM_STOCK_0000034310": "規格：",
        "P_YS_SCM_STOCK_0000034311": "選擇退貨商品",
        "P_YS_SCM_STOCK_0000034312": "沒有商品了哦",
        "P_YS_SCM_STOCK_0000034318": "退款成功",
        "P_YS_SCM_STOCK_0000034319": "未設置最大可找零金額",
        "P_YS_FED_FW_0001061059": "command cParameters JSON格式錯誤-->",
        "P_YS_FED_FW_0001061051": "吉爾吉斯坦",
        "P_YS_FED_FW_0001061052": "聖文森特",
        "P_YS_FED_FW_0001061053": "蒙特塞拉特島",
        "P_YS_FED_FW_0001061054": "法屬玻利尼西亞",
        "P_YS_FED_FW_0001061055": "百慕大群島",
        "P_YS_FED_FW_0001061056": "聖文森特島",
        "P_YS_FED_FW_0001061057": "安道爾共和國",
        "P_YS_FED_FW_0001061058": "autocomplete 沒有model",
        "P_YS_FED_FW_0001455874": "<%=abandonText%>條資料允許列印",
        "P_YS_OA_YBMOB_0000177961": "請輸入最小值",
        "P_YS_OA_YBMOB_0000177960": "請輸入最大值",
        "P_YS_SD_UDHWN_0001010080": "周日_週一_週二_週三_週四_週五_週六",
        "P_YS_FED_MDF-COMPS_0001064728": "【提示】若系統語言（<%=enterprise%>）內容未維護，系統將默認按當前語言（<%=current%>）內容賦值處理",
        "P_YS_SD_UDHWN_0001010095": "[明天]LT",
        "P_YS_FED_IMP_IOT0000006391": "德興市",
        "P_YS_FED_IMP_IOT0000006396": "巨鹿縣",
        "P_YS_FED_IMP_IOT0000006395": "上街區",
        "P_YS_FED_IMP_IOT0000006398": "民勤縣",
        "P_YS_FED_FW_0001126032": "!!!未處理的鍵盤事件, e ==>",
        "P_YS_FED_FW_1575376867322494991": "簡版設計器-",
        "P_YS_FED_IMP_IOT0000006388": "永豐縣",
        "P_YS_FED_FW_1546407879852949523": "頭部信息區",
        "P_YS_FED_FW_1546407879852949526": "移動布局示例",
        "P_YS_FED_IMP_IOT0000006381": "蓬萊市",
        "P_YS_FED_IMP_IOT0000006383": "興山區",
        "P_YS_FED_IMP_IOT0000006385": "湟源縣",
        "P_YS_FED_FW_1546407879852949520": "*資料展示列數",
        "P_YS_FED_IMP_IOT0000006379": "天峻縣",
        "P_YS_FI_CM_0000026118": "不存在",
        "P_YS_FED_IMP_IOT0000006370": "和靜縣",
        "P_YS_FED_FW_0001383748": "取整",
        "P_YS_MF_MR-FE_0001156422": "只能選擇一條數據",
        "P_YS_FED_IMP_IOT0000006374": "金安區",
        "P_YS_FED_IMP_IOT0000006376": "泰來縣",
        "P_YS_FED_IMP_IOT0000006375": "克拉瑪依區",
        "P_YS_FED_UCFBASEDOC_0000025564": "辦公用品",
        "P_YS_FED_FW_0001255540": "系統默認模板不支持修改",
        "P_YS_FED_FW_0001255541": "模板已發佈，不允許修改",
        "P_YS_FED_FW_1546407879852949508": "請設置頭部信息區！",
        "P_DIWORK_YC_YC-UI_0000058082": "請輸入供應商名稱",
        "P_YS_FED_FW_0001255537": "模板版本號",
        "P_YS_FED_IMP_IOT0000006366": "全州縣",
        "P_YS_FED_FW_0001255538": "請輸入模板版本號!",
        "P_YS_FED_IMP_IOT0000006368": "梁河縣",
        "P_YS_PF_GZTSYS_0000012596": "請假",
        "P_YS_FED_IMP_IOT0000007692": "戚墅堰區",
        "P_YS_FED_IMP_IOT0000006363": "南匯區",
        "P_YS_FED_IMP_IOT0000006362": "懷安縣",
        "P_YS_FED_IMP_IOT0000007693": "虎林市",
        "P_YS_PF_METADATA_0000086517": "庫存方向",
        "P_YS_FED_FW_0001255539": "您選擇的模板尚未發佈",
        "P_YS_SD_SDMAUF_0000151992": "兩次輸入不一致！",
        "P_YS_FED_IMP_IOT0000006356": "陝縣",
        "P_YS_FED_IMP_IOT0000007687": "安西縣",
        "P_YS_FED_FW_0001255548": "系統必填時不能修改",
        "P_YS_IPAAS_SSB-BE_1431199659860689346": "集合",
        "P_YS_FED_IMP_IOT0000006355": "甌海區",
        "P_YS_FED_FW_0001255549": "請先選擇行再進行操作！",
        "P_YS_FED_FW_1546407879852949511": "主要信息區",
        "P_YS_FED_FW_1575376867322494982": "初始化是需要判斷是否有其他展開的如果有先走一次清除",
        "P_YS_FED_IMP_IOT0000006358": "洋縣",
        "P_YS_FED_IMP_IOT0000007689": "長子縣",
        "P_YS_FED_FW_0001255546": "請輸入模板名稱!",
        "P_YS_FED_FW_1556630812555214849": "規則條件：",
        "P_YS_FED_FW_1575376867322494985": "您好，請到高級設計器使用特徵相關的擴展和設計，簡版設計器暫不支持顯示特徵。",
        "P_YS_FED_FW_0001255547": "枚舉字段",
        "P_YS_FED_FW_0001255544": "系統必填",
        "P_YS_FED_FW_1546407879852949514": "請設置主要信息區！",
        "P_YS_FED_IMP_IOT0000006359": "寒亭區",
        "P_YS_FED_FW_0001255545": "請輸入模板編號!",
        "P_YS_FED_FW_0001255542": "是否設置為必填",
        "P_YS_FED_FW_0001255543": "是否列入模板",
        "P_YS_FED_FW_1546407879852949517": "資料展示區",
        "P_YS_FED_FW_1575376867322494988": "渲染表格的重要數據 沒有的話沒必要渲染modal",
        "P_YS_SCM_STOCK_0001113984": "按料",
        "P_YS_FED_IMP_IOT0000007681": "巫山縣",
        "P_YS_FED_IMP_IOT0000007680": "潞西市",
        "P_YS_FED_IMP_IOT0000006352": "錯那縣",
        "P_YS_FED_IMP_IOT0000006351": "鄒平縣",
        "P_YS_FED_IMP_IOT0000007682": "平魯區",
        "P_YS_FED_UCFBASEDOC_0000025543": "現場折扣權限",
        "P_YS_FED_IMP_IOT0000006354": "富拉爾基區",
        "P_YS_FED_IMP_IOT0000007685": "環縣",
        "P_YS_SCM_STOCK_0001113981": "按單",
        "P_YS_FED_IMP_IOT0000007684": "吳江市",
        "P_YS_SD_UDHWN_0001010021": "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月",
        "P_YS_FED_IMP_IOT0000007675": "饒平縣",
        "P_YS_FED_IMP_IOT0000006346": "欒城縣",
        "P_YS_SCM_PU_0000028165": "處理中",
        "P_YS_FED_UCFBASEDOC_0000025533": "提交成功",
        "P_YS_FED_IMP_IOT0000006343": "魯山縣",
        "P_YS_FED_IMP_IOT0000007674": "渾源縣",
        "P_YS_FED_IMP_IOT0000006342": "巴楚縣",
        "P_YS_FED_IMP_IOT0000007673": "祿勸彝族苗族自治縣",
        "P_YS_SD_UDHWN_0001010033": "1 個月",
        "P_YS_FED_IMP_IOT0000006333": "蔡甸區",
        "P_YS_FED_IMP_IOT0000007664": "永康市",
        "P_YS_FED_IMP_IOT0000008998": "夾江縣",
        "P_YS_FED_IMP_IOT0000007667": "桐城市",
        "P_YS_FED_IMP_IOT0000007666": "肅寧縣",
        "P_YS_FED_IMP_IOT0000006339": "行唐縣",
        "P_YS_FED_IMP_IOT0000008990": "建鄴區",
        "P_YS_FED_IMP_IOT0000006330": "岢嵐縣",
        "P_YS_FED_IMP_IOT0000007660": "花溪區",
        "P_YS_FED_IMP_IOT0000008991": "鄉寧縣",
        "P_YS_FED_IMP_IOT0000006331": "平房區",
        "P_YS_FED_IMP_IOT0000007662": "西工區",
        "P_YS_FED_IMP_IOT0000008992": "開平區",
        "P_YS_SD_UDHWN_0000047752": "巢湖市",
        "P_YS_SD_UDHWN_0001010005": "1 年",
        "P_YS_FED_IMP_IOT0000007654": "饒陽縣",
        "P_YS_FED_IMP_IOT0000007656": "德令哈市",
        "P_YS_FED_IMP_IOT0000008984": "東港區",
        "P_YS_FED_IMP_IOT0000007655": "湘鄉市",
        "P_YS_FED_IMP_IOT0000006327": "臨城縣",
        "P_YS_FED_IMP_IOT0000007650": "長清區",
        "P_YS_FED_IMP_IOT0000008982": "宣化縣",
        "P_YS_FED_IMP_IOT0000006321": "從江縣",
        "P_YS_FED_IMP_IOT0000007652": "江陽區",
        "P_YS_FED_IMP_IOT0000008981": "正陽縣",
        "P_YS_FED_FW_0001097037": "【config】=>",
        "P_YS_FED_FW_0001097036": "請求user/getOrgsAndStores接口success：【json.code】=>",
        "P_YS_FED_FW_0001097039": "【json.data】=>",
        "P_YS_FED_FW_0001097038": "請求user/getOrgsAndStores接口：【url】=>",
        "P_YS_PF_PRINT_0000057301": "自定義項8",
        "P_YS_FED_IMP_IOT0000006319": "城步苗族自治縣",
        "P_YS_HR_HRXCF_1457191573584347175": "普通方案",
        "P_YS_FED_IMP_IOT0000006312": "蓮花縣",
        "P_YS_FED_IMP_IOT0000007643": "井陘礦區",
        "P_YS_FED_IMP_IOT0000006311": "天峨縣",
        "P_YS_FED_IMP_IOT0000008976": "上栗縣",
        "P_YS_FED_IMP_IOT0000007645": "蘿北縣",
        "P_YS_FED_IMP_IOT0000006313": "應縣",
        "P_YS_FED_IMP_IOT0000007644": "澄城縣",
        "P_YS_FED_IMP_IOT0000006316": "英吉沙縣",
        "P_YS_FED_FW_1602706809380405256": "級以上的屬性穿透",
        "P_YS_FED_IMP_IOT0000007649": "營山縣",
        "P_YS_OA_app_xtywlj_0000037784": "通知",
        "P_YS_FED_FW_1602706809380405259": "特徵對象",
        "P_YS_FED_IMP_IOT0000008971": "績溪縣",
        "P_YS_FED_IMP_IOT0000008972": "天全縣",
        "P_YS_FED_IMP_IOT0000007640": "臨猗縣",
        "P_YS_FED_FW_1575377786445496320": "簡版設計器編輯",
        "P_YS_SD_UDHWN_0000048340": "白沙黎族自治縣",
        "P_YS_FED_IMP_IOT_0001087104": "duplicated and/or omitted — the behavior is unsupported and",
        "P_YS_FED_EXAMP_0000020753": "未錄入商品“",
        "P_YS_FED_IMP_IOT0000008843": "烈山區",
        "P_YS_FED_EXAMP_0000020752": "新密碼",
        "P_YS_FED_IMP_IOT0000007510": "蒲城縣",
        "P_YS_FED_EXAMP_0000020755": "周五",
        "P_YS_FED_IMP_IOT0000007513": "通道侗族自治縣",
        "P_YS_FED_IMP_IOT0000008841": "梓潼縣",
        "P_YS_FED_EXAMP_0000020754": "網絡打印失敗！",
        "P_YS_FED_IMP_IOT0000008847": "大竹縣",
        "P_YS_FED_IMP_IOT0000008848": "瀏陽市",
        "P_YS_FED_EXAMP_0000020751": "離線單據",
        "P_YS_FED_IMP_IOT0000007517": "雲龍區",
        "P_YS_FED_EXAMP_0000020750": "？",
        "P_YS_FED_EXAMP_0000020757": "原因",
        "P_YS_FED_EXAMP_0000020756": "獲取登錄用戶失敗：【接口】",
        "P_YS_FED_EXAMP_0000020759": "入庫通知",
        "P_YS_FED_EXAMP_0000020758": "該商品行不允許修改數量！",
        "P_YS_FED_UCFBASEDOC_0000025299": "待日結數據",
        "P_YS_FED_IMP_IOT0000007508": "興和縣",
        "P_YS_FED_IMP_IOT0000007507": "濟陽縣",
        "P_YS_FED_FW_0001078398": "請先配置報表服務地址",
        "P_YS_FED_IMP_IOT0000007509": "章丘市",
        "P_YS_SD_UDHWN_0000047023": "五指山市",
        "P_YS_FED_FW_0001241569": "以下<%=name%>表體字段不能為空",
        "P_YS_FED_FW_0000021605": "數據",
        "P_YS_FED_EXAMP_0000020764": "套餐商品未錄入完畢,不允許執行改行",
        "P_YS_FED_IMP_IOT0000008832": "曲水縣",
        "P_YS_FED_FW_0000021606": "內蒙古",
        "P_YS_FED_EXAMP_0000020763": "張零售單的開票狀態!",
        "P_YS_FED_FW_0000021603": "畢節市",
        "P_YS_FED_EXAMP_0000020766": "批發價 :",
        "P_YS_FED_IMP_IOT0000008830": "涪城區",
        "P_YS_FED_FW_0000021604": "鶴崗市",
        "P_YS_FED_EXAMP_0000020765": "房費商品開始時間不能為空！",
        "P_YS_FED_IMP_IOT0000008831": "江山市",
        "P_YS_FED_FW_0000021609": "商丘市",
        "P_YS_FED_EXAMP_0000020760": "周二",
        "P_YS_FED_IMP_IOT0000008836": "洛隆縣",
        "P_YS_FED_FW_0000021607": "上4下1",
        "P_YS_FED_EXAMP_0000020762": "企業",
        "P_YS_FED_FW_0000021608": "南通市",
        "P_YS_FED_EXAMP_0000020761": "庫存",
        "P_YS_FED_IMP_IOT0000007505": "福田區",
        "P_YS_FED_FW_0001241570": "以下<%=name%>表體的孫表字段不能為空",
        "P_YS_FED_IMP_IOT_0000761504": "適應屏幕",
        "P_YS_FED_FW_0001241571": "第<%=text%>行子表的<%=name%>孫表",
        "P_YS_FED_FW_0000021601": "錯誤詳情",
        "P_YS_FED_EXAMP_0000020768": "當前商品的退貨數量不能小於換貨數量",
        "P_YS_FED_FW_0000021602": "蕪湖市",
        "P_YS_FED_EXAMP_0000020767": "回龍觀店",
        "P_YS_FED_FW_0000021600": "固原市",
        "P_YS_FED_EXAMP_0000020769": "整單全退時，請使用退訂功能！",
        "P_YS_SD_UDHWN_0000050688": "延慶縣",
        "P_YS_FED_IMP_IOT0000008829": "香洲區",
        "P_YS_FED_EXAMP_0000020780": "調整後金額不能小於0！",
        "P_YS_FED_UIMG_0000101674": "系統預製的必輸欄位不允許修改為非必輸",
        "P_YS_FED_EXAMP_0000020775": "優惠券",
        "P_YS_FED_IMP_IOT0000008821": "古藺縣",
        "P_YS_FED_EXAMP_0000020774": "預訂交款比例低於",
        "P_YS_FED_IMP_IOT0000008822": "宜州市",
        "P_YS_IMP_IBD-FE_0001110516": "匯出數據.xlsx",
        "P_YS_FED_EXAMP_0000020777": "未錄入商品，不允許進行選配!",
        "P_YS_FED_EXAMP_0000020776": "打開相冊",
        "P_YS_FED_IMP_IOT0000008820": "汪清縣",
        "P_YS_FED_EXAMP_0000020771": "卡券商品,不能同時選擇卡券號與卡券範圍",
        "P_YS_PF_GZTTMP_0000073892": "訂單類型",
        "P_YS_FED_EXAMP_0000020770": "電商訂單不支持該種操作！",
        "P_YS_FED_IMP_IOT0000008826": "興國縣",
        "P_YS_FED_EXAMP_0000020773": "職業",
        "P_YS_FED_IMP_IOT0000008823": "鞏義市",
        "P_YS_FED_EXAMP_0000020772": "[公告] 關於十一促銷活動的說明",
        "P_YS_FED_IMP_IOT0000008824": "洪雅縣",
        "P_YS_FED_EXAMP_0000020779": "沒有關聯單據",
        "P_YS_FED_EXAMP_0000020778": "儲值業務型別下不能使用儲值卡或會員錢包支付",
        "P_YS_FED_UCFBASEDOC_0000025276": "日結庫存",
        "P_YS_FED_FW_0001587626": "協作套件不能為空",
        "P_YS_FED_IMP_IOT0000008818": "彬縣",
        "P_YS_FED_EXAMP_0000020791": "當前業務型別不能退卡",
        "P_YS_FED_EXAMP_0000020790": "未錄入商品[",
        "P_YS_FED_IMP_IOT0000008817": "雨花區",
        "P_YS_FED_IMP_IOT_0001087115": "▶",
        "P_YS_FED_EXAMP_0000020786": "退貨商品的積分已經大於等於新購買商品的積分，不必再進行積分抵扣操作。",
        "P_YS_FED_EXAMP_0000020785": "共更新",
        "P_YS_FED_EXAMP_0000020788": "執行過促銷活動或現場折扣或積分抵扣或優惠券，斷網絡狀態下不允許結算！",
        "P_YS_FED_EXAMP_0000020787": "請錄入卡券號",
        "P_YS_FED_EXAMP_0000020782": "]是材料類商品!",
        "P_YS_FED_IMP_IOT0000008815": "大姚縣",
        "P_YS_FED_EXAMP_0000020784": "當前單據狀態下不允許增加商品行！",
        "P_YS_FED_EXAMP_0000020783": "已錄入",
        "P_YS_FED_EXAMP_0000020789": "),不得低於當前操作員折扣率下限(",
        "P_YS_FED_FW_0001047201": "三十四",
        "P_YS_FED_FW_0001047200": "四十",
        "P_YS_FI_CM_0000026146": "存在",
        "P_YS_FED_IMP_IOT0000008805": "龍口市",
        "P_YS_SD_SDMB_0000139037": "近三個月",
        "P_YS_PF_GZTSYS_0000012457": "草稿箱",
        "P_YS_FED_FW_0000021638": "初始化條件中沒有billNo。",
        "P_YS_FED_FW_0001269095": "新增指標公式",
        "P_YS_FED_FW_0000021636": "存在重複行。信息如下",
        "P_YS_FED_EXAMP_0000020711": "卡券非原單退",
        "P_YS_FED_FW_0001269093": "指標全為零不顯示",
        "P_YS_FED_FW_0000021637": "存在為必填項，請填寫！",
        "P_YS_FED_EXAMP_0000020710": "查看二維碼",
        "P_YS_FED_FW_0001269094": "編輯指標公式",
        "P_YS_FED_IMP_IOT0000008804": "羅城仫佬族自治縣",
        "P_YS_PF_GZTSYS_0000012455": "物流公司",
        "P_YS_FED_IMP_IOT0000008801": "仁懷市",
        "P_YS_FED_FW_0000021630": "右側Y軸",
        "P_YS_FED_EXAMP_0000020717": "存在商品行，不允許執行贈品！",
        "P_YS_FED_FW_0000021631": "例：YYYY-MM-DD HH:mm:ss",
        "P_YS_FED_EXAMP_0000020716": "商品模板",
        "P_YS_FED_EXAMP_0000020719": "沒有找著編碼為",
        "P_YS_FED_EXAMP_0000020718": "西二旗店",
        "P_YS_FED_FW_1550827916596609026": "您好，若用戶清單右上角設置了列寬/欄位顯隱後，便有“用戶級設置”，您的最新模板級設置是否對其覆蓋？",
        "P_YS_FED_FW_0000021634": "審批流",
        "P_YS_FED_FW_0000111693": "發起的【",
        "P_YS_FED_EXAMP_0000020713": "手機號",
        "P_YS_FED_FW_0000021635": "圖形",
        "P_YS_FED_FW_0000111692": ",是否輸入最大數字？",
        "P_YS_FED_EXAMP_0000020712": "現銷時才能使用卡券作為收款方式!",
        "P_YS_FED_FW_0000021632": "請選擇區域。",
        "P_YS_FED_EXAMP_0000020715": "審核不通過原因",
        "P_YS_FED_FW_0000021633": "訂閱週期",
        "P_YS_FED_EXAMP_0000020714": "零",
        "P_YS_FED_FW_0001047212": "二十九",
        "P_YS_FED_FW_0001047211": "二十五",
        "P_YS_FED_FW_0001047210": "四十七",
        "P_YS_FED_UCFBASEDOC_0000025251": "請輸入手機號",
        "P_YS_PF_PROCENTER_0000027371": "打印設計",
        "P_YS_FED_IMP_IOT_0001087134": "1分",
        "P_YS_FED_FW_0000021649": "沒有獲取正確的UEType",
        "P_YS_FED_EXAMP_0000020720": "已出品的商品不能退，請交貨後進行原單退貨！",
        "P_YS_FED_FW_0000021647": "篩選指標",
        "P_YS_FED_EXAMP_0000020722": "當前網絡狀況不能重取序列號商品價格！",
        "P_YS_FED_FW_0000021648": "啟用敏感數據權限控制",
        "P_YS_FED_EXAMP_0000020721": "不允許使用優惠券",
        "P_YS_SD_UDHWS_0000117752": "訂單編號：",
        "P_YS_PF_GZTSYS_0000012466": "貨品查詢",
        "P_YS_FED_FW_0000021641": "根據使用頻率自動設置常用功能",
        "P_YS_FED_FW_0001047209": "四十一",
        "P_YS_FED_EXAMP_0000020728": "”,請輸入後重試！",
        "P_YS_FED_FW_0000021642": "獲取天氣：調用服務出錯   params=",
        "P_YS_FED_FW_0001047208": "二十七",
        "P_YS_FED_EXAMP_0000020727": "不存在序列號管理的商品行!",
        "P_YS_FED_FW_0001047207": "二十一",
        "P_YS_FED_FW_0000021640": "年月日",
        "P_YS_FED_FW_0001047206": "二十三",
        "P_YS_FED_EXAMP_0000020729": "開始卡券號不能大於結束卡券號",
        "P_YS_FED_FW_0000021645": "居右",
        "P_YS_FED_FW_0001047205": "四十五",
        "P_YS_FED_EXAMP_0000020724": "！",
        "P_YS_FED_FW_0000021646": "默認圖文示例",
        "P_YS_FED_FW_0001047204": "四十二",
        "P_YS_FED_EXAMP_0000020723": "該商品為可選配，請先進行選配！",
        "P_YS_FED_FW_0000021643": "嚴重",
        "P_YS_FED_FW_0001047203": "四十三",
        "P_YS_FED_EXAMP_0000020726": "選擇優惠券失敗。信息:",
        "P_YS_FED_FW_0000021644": "設置成功！",
        "P_YS_FED_FW_0001047202": "四十九",
        "P_YS_FED_EXAMP_0000020725": "服務內部錯誤:（錯誤信息）！",
        "P_YS_HR_HRJQ_0000031679": "非法字符",
        "P_YS_PF_PRINT_0000057492": "歸屬部門",
        "P_YS_FED_FW_0000021616": "請設置condition",
        "P_YS_FED_EXAMP_0000020731": "中心配送",
        "P_YS_FED_FW_0000021617": "數量小數位",
        "P_YS_FED_EXAMP_0000020730": "該商品行不能許修改營業員！",
        "P_YS_FED_FW_0000021614": "公司",
        "P_YS_FED_EXAMP_0000020733": "門店信息",
        "P_YS_FED_FW_0000021615": "草稿",
        "P_YS_FED_EXAMP_0000020732": "請設置有效卡",
        "P_YS_FED_FW_0001078375": "eChartCommon.LogChartInfo('大屏方案 設計 eChartPanelDesigngetPreView End', '', 900);",
        "P_YS_FED_FW_0000021618": "公式編輯器",
        "P_YS_FED_FW_0000021619": "拆分",
        "P_YS_FED_EXAMP_0000020739": "會員信息參與結算",
        "P_YS_FED_EXAMP_0000020738": "調整狀態不允許執行選配！",
        "P_YS_HR_HRJXF_0000059422": "進度",
        "P_YS_FED_FW_0000021612": "加載失敗",
        "P_YS_FED_EXAMP_0000020735": "電商退貨狀態",
        "P_YS_FED_FW_0000021613": "請錄入1-999的整數。",
        "P_YS_FED_EXAMP_0000020734": "，",
        "P_YS_FED_FW_0000021610": "漳州市",
        "P_YS_PF_PROCENTER_0000027368": "直接打印",
        "P_YS_FED_EXAMP_0000020737": "本單使用了優惠券收款方式，不允許刪行",
        "P_YS_FED_EXAMP_0000020736": "收起",
        "P_YS_FED_FW_0000021611": "刪除物料",
        "P_YS_FED_FW_0001162218": "查看錯誤明細",
        "P_YS_FI_CM_0000026177": "已審批",
        "P_YS_FED_FW_0000021627": "周觸發一次",
        "P_YS_FED_EXAMP_0000020742": "請先勾選要操作的記錄！",
        "P_YS_FED_FW_0000021628": "看板配置信息-模塊配置-圖文示例",
        "P_YS_FED_EXAMP_0000020741": "每週一次",
        "P_YS_FED_FW_0000021625": "大屏輪播:獲取系統有權限的所有看板。 json.data.kanbans",
        "P_YS_FED_EXAMP_0000020744": "將清除全部促銷活動，是否繼續？",
        "P_YS_FED_FW_0000021626": "大屏輪播: eChartCarousel Render isInDesign =",
        "P_YS_FED_EXAMP_0000020743": "]不存在！",
        "P_YS_FED_FW_0000021629": "查詢參數 =",
        "P_YS_FED_EXAMP_0000020740": "存在必輸項 “",
        "P_YS_FED_EXAMP_0000020749": "確定要切換組織嗎？該操作將重新刷新頁面！",
        "P_YS_FED_FW_0000021620": "是否確定要刪除？",
        "P_YS_FED_FW_0000021623": "大屏方案 Save params",
        "P_YS_FED_EXAMP_0000020746": "零售單",
        "P_YS_FED_FW_0000021624": "操作失敗!",
        "P_YS_FED_EXAMP_0000020745": "參照攜帶預製錯誤",
        "P_YS_FED_FW_0000021621": "排名行數",
        "P_YS_FED_EXAMP_0000020748": "儲值狀態不允許增加商品行！",
        "P_YS_FED_FW_0000021622": "拆分比例",
        "P_YS_FED_EXAMP_0000020747": "請輸入移動地址",
        "P_YS_HR_HRJXF_0000059438": "對齊",
        "P_YS_SD_SDMAUF_0000152156": "請選擇地址",
        "P_YS_FED_FW_0001396022": "更新資料sql為：",
        "P_YS_FED_FW_0001396021": "不支持executeDBOperate快取！！！",
        "P_YS_FED_FW_0001396020": "建表sql為：",
        "P_YS_FED_FW_0001396025": "刪除資料sql為：",
        "P_YS_FED_FW_0001396024": "刪表sql為：",
        "P_YS_FED_FW_0001396023": "查詢資料sql為：",
        "P_YS_FED_EXAMP_0000020709": "性別",
        "P_YS_FED_FW_0000112925": "調用獲取配置文件接口-整理後",
        "P_YS_FED_EXAMP_0000020700": "調整狀態不允許執行積分折扣！",
        "P_YS_FED_EXAMP_0000020706": "獲取業務參數失敗：【接口】",
        "P_YS_FED_EXAMP_0000020705": "已存在該批次號的商品行!",
        "P_YS_FED_EXAMP_0000020708": "獲取",
        "P_YS_FED_EXAMP_0000020707": "請輸入會員的卡號或手機號",
        "P_YS_FED_EXAMP_0000020702": "已錄入商品,不允許修改卡券業務類型",
        "P_YS_FED_EXAMP_0000020701": "返回結果為空",
        "P_YS_FED_EXAMP_0000020704": "沒有選中的商品行，不允許執行退品!",
        "P_YS_FED_EXAMP_0000020703": "規格",
        "P_YS_FED_FW_0001456239": "條資料未審核通過，不允許列印",
        "P_YS_PF_GZTTMP_0000077446": "下一頁",
        "P_YS_PF_PC-UI_0000159832": "人員參照",
        "P_YS_FED_FW_0001588923": "當前頁面篩選出條數：",
        "P_YS_SD_SDMAF_0000136999": "咨詢",
        "OA_web_login_000000016": "請輸入您的手機號",
        "P_YS_FED_FW_0001272625": "請您選擇環節審批人",
        "P_DIWORK_YC_MALL-BASEDOC_0000061927": "主體",
        "P_YS_FED_UCFORG_0000066179": "展開4層",
        "P_YS_FED_FW_0001072283": "已轉入後台處理，可進行其它操作！",
        "P_YS_FED_UCFORG_0000066176": "png 格式",
        "P_YS_FED_FW_0001120450": "樹節點6",
        "P_YS_FED_UCFORG_0000066181": "展開2層",
        "P_YS_FED_FW_0001120448": "樹節點5",
        "P_YS_FED_FW_0001120449": "樹節點4",
        "P_YS_FED_FW_0000115212": "不能調用抽象類的方法parse",
        "P_YS_FED_UCFORG_0000066189": "顯示內容",
        "P_YS_FED_UCFORG_0000066191": "展開1層",
        "P_YS_PF_PROCENTER_0000022566": "停用",
        "P_YS_FED_UCFORG_0000066193": "展開5層",
        "P_YS_FED_UCFORG_0000066194": "展開3層",
        "P_YS_FED_UCFORG_0000066190": "下載結構圖",
        "P_YS_PF_GZTLOG_0000025980": "列表",
        "P_YS_FED_UCFORG_0000066197": "展開全部",
        "P_YS_PF_GZTLOG_0000025988": "解鎖",
        "P_YS_PF_GZTTMP_0000078669": "實盤金額",
        "P_YS_FI_CM_0000028824": "切換為柱狀圖",
        "P_YS_HR_HRYGF_0001023444": "安圭拉島",
        "P_YS_FED_FW_1488377941070446601": "阻止釘耙點擊事件",
        "P_YS_PF_SOCD-G_0000827848": "二十二",
        "P_YS_PF_GZTLOG_0000025976": "鎖定",
        "P_YS_PF_GZTLOG_0000025975": "自定義",
        "P_YS_FI_CM_0000028839": "選擇時間",
        "P_YS_OA_XTLCZX_0000030575": "年-月-日",
        "P_YS_PF_GZTLOG_0000025967": "下架",
        "P_YS_IMP_QAM-BE_0001122431": "-∞",
        "P_YS_FED_FW_0000115265": "存在必輸項，請填寫完整！",
        "country886": "中國台灣",
        "P_YS_FED_IMP_IOT0000006296": "鹿泉市",
        "P_YS_PF_GZTSYS_0000109837": "組織部門",
        "P_YS_FED_IMP_IOT0000006299": "張家口",
        "P_YS_PF_PROCENTER_0000022591": "校驗失敗",
        "P_YS_OA_XTLCZX_0000030592": "關聯",
        "P_YS_FED_FW_0001097561": "網絡狀況不佳，已切換成離線模式！等待網絡通暢後，可點擊開單頁頂部網絡標識，切換成在線模式。",
        "P_YS_OA_XTLCZX_0000030590": "電話",
        "P_YS_FED_FW_0001486020": "【提示】若基準語言（<%=enterprise%>）內容未維護，系統將預設按當前語言（<%=current%>）內容賦值處理",
        "country855": "柬埔寨",
        "P_YS_FED_IMP_IOT0000006282": "廣陵區",
        "P_YS_FED_FW_0001264181": "以下",
        "P_YS_FED_IMP_IOT0000006286": "屯留縣",
        "P_YS_FED_IMP_IOT0000006285": "華陰市",
        "P_YS_FED_FW_0001084248": "刪除附件失敗",
        "P_YS_FED_FW_1513779442797772807": "審批流js還在加載中",
        "P_YS_FED_FW_1513779442797772804": "開立態單據還未創建審批流",
        "P_YS_FED_FW_0000153522": "必填項為空",
        "P_YS_FED_FW_0000021560": "益陽市",
        "P_YS_FED_FW_0000021561": "蚌埠市",
        "P_YS_FED_IMP_IOT0000006268": "嘉黎縣",
        "P_YS_FED_FW_0000021559": "萊蕪市",
        "P_YS_PF_GZTSYS_0000012499": "組織",
        "P_YS_FED_FW_0000021553": "嘉興市",
        "P_YS_FED_IMP_IOT0000006260": "鹽田區",
        "P_YS_FED_IMP_IOT0000007591": "寧海縣",
        "P_YS_FED_FW_0000021554": "銅川市",
        "P_YS_FED_IMP_IOT0000007590": "乾縣",
        "P_YS_FED_FW_0000021551": "朝陽市",
        "P_YS_FED_IMP_IOT0000006262": "廣豐縣",
        "P_YS_FED_IMP_IOT0000007593": "賀蘭縣",
        "P_YS_FED_FW_0000021552": "武威市",
        "P_YS_FED_FW_0000021557": "盤錦市",
        "P_YS_FED_UCFBASEDOC_0000025215": "登錄",
        "P_YS_FED_FW_0000021558": "香港",
        "P_YS_FED_IMP_IOT0000006263": "靈武市",
        "P_YS_FED_IMP_IOT0000007594": "分宜縣",
        "P_YS_FED_FW_0000021555": "報表分組方案不支持移動端展現，請檢查。",
        "P_YS_FED_IMP_IOT0000007597": "召陵區",
        "P_YS_FED_FW_0000021556": "單行",
        "P_YS_FED_IMP_IOT0000006265": "馬村區",
        "P_YS_FED_IMP_IOT0000007596": "靖江市",
        "P_YS_FED_FW_0001300469": "查看更多",
        "P_YS_FED_FW_0001300466": "單據號",
        "P_YS_FED_FW_0001300467": "單據日期",
        "P_YS_FED_FW_0000021571": "貴港市",
        "P_YS_FED_FW_0000021572": "南充市",
        "P_YS_FED_FW_0000021570": "那曲地區",
        "P_YS_OA_XTLCZX_0000030541": "表格",
        "P_YS_FED_IMP_IOT0000007588": "新城子區",
        "P_YS_FED_IMP_IOT0000007587": "平利縣",
        "P_YS_PF_UCFMDF_0000162014": "員工入職",
        "P_YS_FI_CM_0000028899": "退出登錄",
        "P_YS_FED_FW_0000021564": "淮安市",
        "P_YS_FED_IMP_IOT0000007580": "謝通門縣",
        "P_YS_FED_FW_0001300471": "按單",
        "P_YS_FED_FW_0000021565": "中山市",
        "P_YS_FED_FW_0001300472": "上一頁",
        "P_YS_FED_FW_0000021562": "全選",
        "P_YS_FED_FW_0000021563": "日照市",
        "P_YS_FED_IMP_IOT0000007581": "蓋州市",
        "P_YS_FED_FW_0001300470": "按料",
        "P_YS_FED_FW_0000021568": "昆明市",
        "P_YS_FED_IMP_IOT0000007584": "邵武市",
        "P_YS_FED_FW_0000021569": "宣城市",
        "P_YS_FED_UCFBASEDOC_0000025203": "獲取驗證碼",
        "P_YS_FED_IMP_IOT0000007583": "內鄉縣",
        "P_YS_HR_HRJQF_0000054016": "司齡",
        "P_YS_FED_FW_0000021566": "中3",
        "P_YS_FED_IMP_IOT0000006255": "富錦市",
        "P_YS_FED_IMP_IOT0000007586": "崇仁縣",
        "P_YS_FED_FW_0001300473": "下一頁",
        "P_YS_FED_FW_0000021567": "攀枝花市",
        "P_YS_FED_UCFBASEDOC_0000025201": "字符串",
        "P_YS_FED_UCFBASEDOC_0000025200": "移動",
        "P_YS_PF_GZTVPA_0001137669": "垂直",
        "P_YS_OA_XTLCZX_0000030555": "平鋪",
        "P_YS_OA_XTLCZX_0000030553": "流程",
        "P_YS_FED_FW_0000021539": "柱折圖配置信息-yySetting",
        "P_YS_FED_IMP_IOT0000006246": "定日縣",
        "P_YS_FED_IMP_IOT0000007576": "博興縣",
        "P_YS_FED_FW_0000021537": "海南藏族自治州",
        "P_YS_FED_IMP_IOT0000006248": "山陽區",
        "P_YS_FED_FW_0000021538": "葫蘆島市",
        "P_YS_FED_IMP_IOT0000007578": "徽州區",
        "P_YS_FED_IMP_IOT0000006249": "藍山縣",
        "P_YS_FED_FW_0000021531": "林芝地區",
        "P_YS_FED_FW_0000021532": "紹興市",
        "P_YS_FED_IMP_IOT0000007571": "元謀縣",
        "P_YS_FED_FW_0000021530": "黔東南苗族侗族自治州",
        "P_YS_FED_IMP_IOT0000007570": "武定縣",
        "P_YS_FED_FW_0000021535": "大同市",
        "P_YS_FED_FW_0000021536": "烏海市",
        "P_YS_FED_FW_0000021533": "齊齊哈爾市",
        "P_YS_FED_FW_0000021534": "自定義大屏看板",
        "P_YS_FED_IMP_IOT0000007574": "馬龍縣",
        "P_YS_SD_UDHWN_0000049625": "瓊海市",
        "P_YS_OA_XTLCZX_0000030560": "1月",
        "P_YS_FED_FW_0000021550": "黔西南布依族苗族自治州",
        "P_YS_FED_FW_1481951579073937412": "當前為模板級設置",
        "P_YS_FED_FW_1481951579073937415": "當前為用戶級設置",
        "P_YS_FED_FW_0001427697": "條記錄：",
        "P_YS_FED_FW_0001223614": "打印的內容",
        "P_YS_FED_FW_1481951579073937418": "默認為模板級設置，字段修改後為用戶級設置。",
        "P_YS_FED_FW_0001223613": "請打開藍牙",
        "P_YS_FED_FW_0001427696": "請確認是否繼續?",
        "P_YS_FED_IMP_IOT0000007566": "綠園區",
        "P_YS_PF_GZTSYS_0000012489": "公告",
        "P_YS_FED_IMP_IOT0000006234": "西林縣",
        "P_YS_FED_IMP_IOT0000007565": "寬城區",
        "P_YS_FED_FW_0000021548": "西雙版納傣族自治州",
        "P_YS_FED_FW_0000021549": "邵陽市",
        "P_YS_FED_IMP_IOT0000006236": "和碩縣",
        "P_YS_FED_IMP_IOT0000008897": "東昌府區",
        "P_YS_FED_FW_0000021542": "移動看板A",
        "P_YS_FED_IMP_IOT0000008890": "廣寧縣",
        "P_YS_FED_FW_0000021543": "格式化欄位預製錯誤！",
        "P_YS_FED_IMP_IOT0000008891": "平邑縣",
        "P_YS_FED_FW_0000021540": "圖形報表 因為x軸坐標信息傾斜需要增加的高度",
        "P_YS_FED_IMP_IOT0000007560": "城西區",
        "P_YS_FED_FW_0000021541": "移動看板B",
        "P_YS_FED_FW_0000021546": "錯誤原因：",
        "P_YS_FED_IMP_IOT0000006231": "李滄區",
        "P_YS_FED_FW_0000021547": "海口市",
        "P_YS_FED_IMP_IOT0000007561": "開縣",
        "P_YS_FED_FW_0000021544": "湖北",
        "P_YS_FED_IMP_IOT0000006233": "沁源縣",
        "P_YS_FED_FW_0000021545": "十堰市",
        "P_YS_FED_FW_1481951579073937421": "UI模板可以將用戶級設置刷新後變成模板級設置",
        "P_YS_FED_FW_1481951579073937424": "也可以使用“恢復默認”回到模板級設置",
        "P_YS_FED_EXAMP_0000020681": "當前為充值狀態，不允許添加退貨充值行。",
        "P_YS_FED_EXAMP_0000020680": "請選擇具體單據",
        "P_YS_FED_EXAMP_0000020676": "贈品中含有實體卡券商品,卡券號必輸",
        "P_YS_FED_IMP_IOT0000007555": "右江區",
        "P_YS_FED_EXAMP_0000020675": "]的商品！",
        "P_YS_FED_IMP_IOT0000007554": "海林市",
        "P_YS_FED_EXAMP_0000020678": "非會員和客戶的單據只能選擇一張單據進行結算",
        "P_YS_FED_IMP_IOT0000006226": "成華區",
        "P_YS_FED_IMP_IOT0000007557": "洪洞縣",
        "P_YS_FED_IMP_IOT0000008885": "古冶區",
        "P_YS_FED_EXAMP_0000020677": "即提",
        "P_YS_FED_IMP_IOT0000007556": "海安縣",
        "P_YS_FED_IMP_IOT0000008886": "紅塔區",
        "P_YS_FED_EXAMP_0000020672": "銷售金額(元)",
        "P_YS_FED_IMP_IOT0000007559": "崇文區",
        "P_YS_FED_EXAMP_0000020671": "註冊來源",
        "P_YS_FED_IMP_IOT0000007558": "雲龍縣",
        "P_YS_FED_EXAMP_0000020674": "未收款金額只能改小不能改大！",
        "P_YS_FED_IMP_IOT0000008889": "五華區",
        "P_YS_FED_EXAMP_0000020673": "使用卡券結算且商品行金額有變化時，需要取消已經執行的促銷，並重新執行",
        "P_YS_FED_FW_0000021597": "茂名市",
        "P_YS_PF_METADATA_0000088630": "政務",
        "P_YS_FED_FW_0000021598": "舟山市",
        "P_YS_FED_IMP_IOT0000008880": "嵐山區",
        "P_YS_FED_FW_0000021595": "看板配置信息-大屏",
        "P_YS_FED_FW_0000021596": "上饒市",
        "P_YS_HR_HRYGF_0001023467": "中非共和國",
        "P_YS_FED_EXAMP_0000020679": "電商",
        "P_YS_FED_FW_1523248273733189640": "切換至清單",
        "P_YS_FED_FW_0000021599": "移動報表 MobileReport Render",
        "P_YS_FED_IMP_IOT0000007553": "賓川縣",
        "P_YS_FED_FW_1523248273733189643": "切換至卡片",
        "P_YS_PF_PROCENTER_0000027411": "倉庫檔案",
        "P_YS_OA_XTLCZX_0000030500": "網關",
        "P_YS_PF_SOCD_0000065988": "海地",
        "P_YS_FED_EXAMP_0000020692": "當前操作員沒有售後權限！",
        "P_YS_FED_EXAMP_0000020691": "預訂退訂狀態",
        "P_YS_FED_EXAMP_0000020687": "商城上架數 :",
        "P_YS_FED_IMP_IOT0000006213": "北侖區",
        "P_YS_FED_EXAMP_0000020686": "商品[",
        "P_YS_FED_IMP_IOT0000007543": "紅橋區",
        "P_YS_FED_IMP_IOT0000008877": "馬關縣",
        "P_YS_FED_FW_1499700110520483841": "名稱不可為空且長度小於50個字。",
        "P_YS_FED_EXAMP_0000020689": "登錄帳號不能為空",
        "P_YS_FED_IMP_IOT0000007546": "長葛市",
        "P_YS_FED_IMP_IOT0000008874": "雲城區",
        "P_YS_FED_EXAMP_0000020688": "刪除失敗",
        "P_YS_FED_EXAMP_0000020683": "返回數據：",
        "P_YS_FED_EXAMP_0000020682": "沒有選中行。",
        "P_YS_FED_EXAMP_0000020685": "不能改數量",
        "P_YS_FED_IMP_IOT0000006219": "海珠區",
        "P_YS_FED_EXAMP_0000020684": "退款失敗!!",
        "P_YS_FED_IMP_IOT0000008879": "南崗區",
        "P_YS_FED_FW_0001228492": "請選擇需要恢復的數據：",
        "P_YS_FED_IMP_IOT0000008872": "台前縣",
        "P_YS_SD_SDOC_0001150619": "派送失敗",
        "P_YS_FED_IMP_IOT0000008873": "互助土族自治縣",
        "P_YS_FED_IMP_IOT0000006211": "正寧縣",
        "P_YS_FED_IMP_IOT0000008870": "蕉嶺縣",
        "P_YS_FED_FW_0001228491": "數據恢復確認",
        "P_YS_FED_IMP_IOT0000006210": "紅安縣",
        "P_YS_FED_IMP_IOT0000008871": "武鳴縣",
        "P_YS_FED_FW_0001228490": "請選擇有效恢復數據",
        "P_YS_FED_FW_0000021582": "臨沂市",
        "P_YS_FED_FW_0000021583": "石嘴山市",
        "P_YS_FED_FW_0000021580": "遼源市",
        "P_YS_FED_FW_0000021581": "上海市",
        "P_YS_FED_IMP_IOT0000006209": "北林區",
        "P_YS_SD_UDHWN_0001010363": "[上]ddddLT",
        "P_YS_FED_EXAMP_0000020698": "當前網絡不可用，不能使用此功能",
        "P_YS_FED_IMP_IOT0000006202": "石泉縣",
        "P_YS_FED_IMP_IOT0000008865": "富順縣",
        "P_YS_FED_EXAMP_0000020697": "近90天",
        "P_YS_PF_GZTTMP_0000073851": "行政區劃",
        "P_YS_FED_IMP_IOT0000006204": "涇縣",
        "P_YS_FED_IMP_IOT0000007535": "錦江區",
        "P_YS_FED_EXAMP_0000020699": "不能執行促銷活動",
        "P_YS_FED_IMP_IOT0000008864": "桂陽縣",
        "P_YS_FED_EXAMP_0000020694": "獲取啟用會員錢包參數失敗",
        "P_YS_FED_IMP_IOT0000007537": "蕭縣",
        "P_YS_FED_IMP_IOT0000008869": "魏縣",
        "P_YS_FED_EXAMP_0000020693": "pos返回成功，但無返回值！",
        "P_YS_FED_IMP_IOT0000006205": "閩侯縣",
        "P_YS_FED_EXAMP_0000020696": "要貨待提交",
        "P_YS_FED_IMP_IOT0000006208": "涵江區",
        "P_YS_FED_IMP_IOT0000008867": "貢井區",
        "P_YS_FED_EXAMP_0000020695": "可用餘額",
        "P_YS_FED_FW_0000021575": "山東",
        "P_YS_FED_FW_0000021576": "汕頭市",
        "P_YS_FED_FW_0000021573": "全部附件大小不可超過",
        "P_YS_FED_FW_0000021574": "永州市",
        "P_YS_FED_FW_0000021579": "看板配置信息-移動",
        "P_YS_FED_IMP_IOT0000008862": "金閶區",
        "P_YS_FED_FW_0000021577": "宜賓市",
        "P_YS_FED_FW_0000021578": "清遠市",
        "P_YS_FED_FW_0000021590": "滁州市",
        "P_YS_FED_FW_0000021593": "崇明縣",
        "P_YS_FED_FW_0000021594": "get參數格式不正確",
        "P_YS_OA_XTLCZX_0000030521": "年-月",
        "P_YS_FED_FW_0000021591": "自治區直轄縣級行政區劃",
        "P_YS_FED_FW_0000021592": "松原市",
        "P_YS_PF_PRINT_0000057423": "出入庫彙總",
        "P_YS_FED_IMP_IOT0000007529": "金寨縣",
        "P_YS_FED_IMP_IOT0000007521": "忻府區",
        "P_YS_PF_METADATA_0000088629": "財經",
        "P_YS_FED_IMP_IOT0000008853": "雞澤縣",
        "P_YS_FED_IMP_IOT0000007525": "金灣區",
        "P_YS_FED_IMP_IOT0000008859": "利辛縣",
        "P_YS_FED_IMP_IOT0000007528": "博湖縣",
        "P_YS_FED_IMP_IOT0000008856": "安達市",
        "P_YS_FED_IMP_IOT0000007527": "莊河市",
        "P_YS_FED_IMP_IOT0000008857": "餘慶縣",
        "P_YS_FED_FW_0000021586": "中衛市",
        "P_YS_FED_FW_0000021587": "湖南",
        "P_YS_FED_FW_0000021584": "泉州市",
        "P_YS_FED_FW_0000021585": "玉樹藏族自治州",
        "P_YS_FED_IMP_IOT0000008850": "臨潭縣",
        "P_YS_FED_FW_0000021588": "廣州市",
        "P_YS_FED_IMP_IOT0000007520": "樂亭縣",
        "P_YS_FED_FW_0000021589": "總額",
        "P_YS_FED_IMP_IOT_0000724684": "文件上傳錯誤",
        "P_YS_FED_IMP_IOT_0000724683": "詳情",
        "P_YS_FED_FW_0001253660": "==========> preProcessCommonViewMeta()...查找commonToolbarb並且已經刪除",
        "P_YS_PF_PRINT_0000057596": "打印份數",
        "P_YS_FED_FW_0000021715": "緩存類型",
        "P_YS_FED_EXAMP_0000020632": "補貨數量=指定時間段內的銷量-在途數量",
        "P_YS_FED_FW_0001253655": "==========> preProcessCommonViewMeta()...發生不可預期的錯誤，直接返回！根據[",
        "P_YS_FED_FW_0000021716": "大屏方案 設計 getDesignColType_Sum curCol",
        "P_YS_FED_EXAMP_0000020631": "沒有設置打印模板，請檢查",
        "P_YS_FED_FW_0001253654": "==========> preProcessCommonViewMeta()...ERROR，異常資訊為",
        "P_YS_FED_FW_0000021713": "]不存在於源表欄目中，請檢查。",
        "P_YS_FED_EXAMP_0000020634": "套餐商品未錄入完畢,不允許執行改零售價",
        "P_YS_FED_FW_0001253657": "===> [mdf-cube] [preprocessViewMeta()] 開始預處理viewmeta",
        "P_YS_FED_FW_0000021714": "ü",
        "P_YS_FED_EXAMP_0000020633": "周日",
        "P_YS_FED_FW_0001253656": "==========> preProcessCommonViewMeta方法未能合併CommonToobar!",
        "P_YS_FED_FW_0000021719": "所在地區",
        "P_YS_FED_IMP_IOT0000008726": "來鳳縣",
        "P_YS_FED_FW_0001253651": "initVM()時UI元數據meta協議錯誤!",
        "P_YS_FED_IMP_IOT0000008727": "鎮平縣",
        "P_YS_FED_FW_0001253650": "請覆蓋effectivedate(生效日期)，expirationdate(失效日期)，creationtime(創建日期)字段，方便MDF統一處理",
        "P_YS_PF_GZTSYS_0000013621": "批次號",
        "P_YS_FED_FW_0000021717": "經度欄位不可為空",
        "P_YS_FED_EXAMP_0000020630": "銷售時間",
        "P_YS_FED_IMP_IOT0000008724": "水富縣",
        "P_YS_FED_FW_0001253653": "===> [mdf-cube] [preprocessViewMeta()] [findCommonToolbar()]viewmeta.view.containers中找到commonToolbarb且已刪除",
        "P_YS_FED_FW_0000021718": "自定義過濾條件",
        "P_YS_FED_FW_0001253652": "==========> preProcessCommonViewMeta()...[相容]在#1中查找到targetToolbar#2:",
        "P_YS_FED_EXAMP_0000020639": "取 消",
        "P_YS_FED_FW_0000021711": "打開數據庫失敗，緩存功能不可用！",
        "P_YS_FED_EXAMP_0000020636": "不能儲值卡結算",
        "P_YS_FED_FW_0001253659": "===> [mdf-cube] preprocessViewMeta()...return, because commonToolbar不存在或不是一個Array",
        "P_YS_FED_FW_0000021712": "ö",
        "P_YS_FED_EXAMP_0000020635": "商城下架數 :",
        "P_YS_FED_FW_0001253658": "===> [mdf-cube] preprocessViewMeta()...viewmeta?.cBillType 未知，無法處理",
        "P_YS_FED_EXAMP_0000020638": "沒有",
        "P_YS_FED_FW_0000021710": "監控視圖 設置自動刷新頻率定時器 renderTime",
        "P_YS_FED_EXAMP_0000020637": "[公告] 關於門店美觀陳設的說明",
        "P_YS_FED_FW_0001253671": "===> [mdf-cube] preprocessViewMeta()...return, 未找到能處理的Header組件[",
        "P_YS_FED_FW_0001253670": "===> [mdf-cube] preprocessViewMeta方法未能合併CommonToobar!",
        "P_YS_FED_FW_0000021726": "eChartDisplay 散點圖地圖信息不正確  errInfo =",
        "P_YS_FED_EXAMP_0000020643": "請填寫退貨原因!",
        "P_YS_FED_FW_0001253666": "==========> preProcessCommonViewMeta()...return, 未找到能處理的Header組件[",
        "P_YS_FED_FW_0000021727": "標題名稱",
        "P_YS_FED_EXAMP_0000020642": "門店銷售趨勢",
        "P_YS_FED_FW_0001253665": "===> [mdf-cube] preprocessViewMeta()...ERROR，異常資訊為",
        "P_YS_FED_FW_0000021724": "沒有符合條件的行記錄",
        "P_YS_FED_EXAMP_0000020645": "https://cdn.yonyoucloud.com/iprint/用友雲打印助手.exe",
        "P_YS_FED_FW_0001253668": "==========> preProcessCommonViewMeta()...viewmeta?.cBillType 未知，無法處理",
        "P_YS_FED_FW_0000021725": "圖表",
        "P_YS_FED_EXAMP_0000020644": "[ 公告 ]",
        "P_YS_FED_FW_0001253667": "不支持Header組件型別【",
        "P_YS_FED_FW_0001253662": "】, 無法處理CommonToolbar",
        "P_YS_FED_FW_0001253661": "]能找到targetHeader，但未找到targetHeaderParent, targetHeader為:",
        "P_YS_FED_FW_0000021728": "圖片不可大於 10MB!",
        "P_YS_FED_EXAMP_0000020641": "房費商品數量小於1小時，是否按1小時收費？",
        "P_YS_FED_FW_0001253664": "==========> preProcessCommonViewMeta()...return, because commonToolbar不存在或不是一個Array",
        "P_YS_FED_FW_0000021729": "天",
        "P_YS_FED_EXAMP_0000020640": "不能抹零",
        "P_YS_FED_FW_0001253663": "===> [mdf-cube] preprocessViewMeta()...[相容]在#1中查找到targetToolbar#2:",
        "P_YS_HR_HRJXF_0000059335": "創建任務",
        "P_YS_FED_FW_0000021722": "圖表列數請輸入1-3的整數。",
        "P_YS_FED_EXAMP_0000020647": "(本門店)",
        "P_YS_FED_FW_0000021723": "已啟用",
        "P_YS_FED_EXAMP_0000020646": "不存在可用帳號",
        "P_YS_FED_FW_0001253669": "===> [mdf-cube] preprocessViewMeta()...發生不可預期的錯誤，直接返回！根據[",
        "P_YS_FED_FW_0000021720": "重新選擇模板將覆蓋當前的模板信息，是否繼續?",
        "P_YS_FED_EXAMP_0000020649": "週一",
        "P_YS_PF_PROCENTER_0000027456": "手工輸入",
        "P_YS_FED_FW_0000021721": "】麼？",
        "P_YS_FED_EXAMP_0000020648": "序",
        "P_YS_FED_IMP_IOT_0000724660": "打印設計",
        "P_YS_FED_IMP_IOT_0000724664": "第一條",
        "P_YS_HR_HRJQ_0000031751": "次",
        "P_YS_FED_IMP_IOT0000008709": "河津市",
        "P_YS_FED_IMP_IOT0000008707": "繁昌縣",
        "P_YS_FED_IMP_IOT_0001010702": "YYYY年M月D日 HH:mm",
        "P_YS_FED_EXAMP_0000020654": "固定套餐",
        "P_YS_FED_FW_0001253633": ", 不返回meta，client端可以使用viewApplication的緩存",
        "P_YS_FED_EXAMP_0000020653": "推薦人",
        "P_YS_FED_EXAMP_0000020656": "沒有選中商品行，不能新增序列號,請檢查!",
        "P_YS_FED_EXAMP_0000020655": "不能選擇當前優惠券。",
        "P_YS_FED_EXAMP_0000020650": "中國,",
        "P_YS_FED_EXAMP_0000020652": "暫無日誌",
        "P_YS_FED_IMP_IOT0000008702": "複製",
        "P_YS_FED_EXAMP_0000020651": "不符，請重新選擇",
        "P_YS_FED_IMP_IOT0000008703": "寧都縣",
        "P_YS_HR_HRJQF_0000054083": "時間範圍",
        "P_YS_FED_IMP_IOT_0000724668": "最後一條",
        "P_YS_OA_XTRIZHI_0000036759": "複選框",
        "P_YS_FED_IMP_IOT_0000724667": "最小化",
        "P_YS_PF_GZTSYS_0000013609": "其他入庫",
        "P_YS_OA_XTLCZX_0000030706": "的",
        "P_YS_FED_EXAMP_0000020658": "零售開單校驗失敗：【接口】",
        "P_YS_FED_FW_0001253637": "初始化FilterViewModel_Extend開始",
        "P_YS_FED_EXAMP_0000020657": "獲取POS編號失敗：",
        "P_YS_FED_FW_0001253636": "voucher editRow方法異常",
        "P_YS_FED_FW_0001253639": "Group:meta客戶端緩存",
        "P_YS_FED_EXAMP_0000020659": "序列號數量和商品數量不符！",
        "P_YS_FED_FW_0001253638": "開始執行",
        "P_YS_FED_UCFBASEDOC_0000025398": "菜單",
        "P_YS_PF_PROCENTER_0000027432": "小明",
        "P_YS_FED_IMP_IOT_0000724653": "複製行",
        "P_YS_FED_FW_0001302904": "請求介面地址",
        "P_YS_HR_HRJQ_0000031765": "李四",
        "P_YS_FED_EXAMP_0000020670": "銷售排行",
        "P_YS_FED_FW_0001302905": "介面返回資料",
        "P_YS_FED_IMP_IOT_0001010712": "YYYY年M月D日ddddAh點mm分",
        "P_YS_FED_FW_0000021704": "最多只支持三級維度導航！",
        "P_YS_FED_EXAMP_0000020665": "交貨不能修改商品時，",
        "P_YS_FED_FW_0001253644": "]時遇到無法處理的不規範數據，暫時相容處理，請聯繫相關開發及時修改。cell的值應該為JSON Object, cell ==>",
        "P_YS_FED_FW_0000021705": "添加彙總",
        "P_YS_FED_EXAMP_0000020664": "地址檔案",
        "P_YS_FED_FW_0001253643": "行的_status,",
        "P_YS_FED_FW_0000021702": "4、示例：各型別欄位的過濾表達式示例如下：",
        "P_YS_FED_FW_0001253646": "]嘗試獲取UI模板!",
        "P_YS_FED_FW_0000021703": "已停用",
        "P_YS_FED_EXAMP_0000020666": "周三",
        "P_YS_FED_FW_0001253645": "調用communicateBillSetting()時，未指定envConfig.DOMAIN_CODE, 並且也未指定params.cParameter.domain參數，暫使用domainKey[",
        "P_YS_FED_FW_0000021708": "展示指標必選，且最多10項",
        "P_YS_FED_EXAMP_0000020661": "電商訂單狀態下不能新增商品！",
        "P_YS_FED_FW_0001253640": "初始化FilterViewModel_Extend結束",
        "P_YS_FED_EXAMP_0000020660": "我的",
        "P_YS_FED_EXAMP_0000020663": "卡券號",
        "P_YS_FED_FW_0001253642": "]時遇到無法處理的不規範數據，相容處理時異常，cell ==>",
        "P_YS_FED_FW_0000021707": "ä",
        "P_YS_FED_EXAMP_0000020662": "複製成功",
        "P_YS_FED_FW_0001253641": "]---不存在",
        "P_YS_OA_XTLCZX_0000030711": "單位",
        "P_YS_FED_FW_0000021700": "訂閱名稱",
        "P_YS_FED_EXAMP_0000020669": "現場折扣審批",
        "P_YS_FED_FW_0001253648": "[mdf-cube] [getCellDataByCtrlType()] 處理[controlType=",
        "P_YS_FED_FW_0000021701": "主維度行數不可大於31",
        "P_YS_FED_EXAMP_0000020668": "不允許同時結算電子卡券與實體卡券",
        "P_YS_FED_FW_0001253647": "] restoreRowState() 更新第",
        "P_YS_FED_FW_0001253649": "返回值result ==>",
        "P_YS_SD_UDHWN_0001010302": "%d 個月",
        "P_YS_FED_FW_0000021759": "標題",
        "P_YS_SD_UDHWN_0001010306": "晚上",
        "P_YS_FED_FW_0000021757": "調用獲取單據配置的服務返回錯誤。url =",
        "P_YS_FED_FW_0000021758": "主維度不可為空且最多三項",
        "P_YS_FED_FW_0000021751": "不顯示指標全為零的數據行",
        "P_YS_FED_FW_0000021752": "· 檔案型別欄位：[客戶分類.分類名稱]",
        "P_YS_FED_FW_0000021750": "顯示千分位",
        "P_YS_SD_SDMBF_0000142981": "★",
        "P_YS_FED_FW_0000021755": "小數位數必須為1~8之間的整數!",
        "P_YS_FED_FW_0000021756": "經緯度欄位不可相同",
        "P_YS_FED_FW_0000021753": "模版名稱/組織名稱",
        "P_YS_FED_FW_0000021754": "篩選行數",
        "P_YS_FED_IMP_IOT_0000724647": "打印預覽",
        "P_YS_FED_FW_0000021770": "交叉",
        "P_YS_PF_GZTSYS_0000012346": "品牌屬性",
        "P_YS_FED_FW_0000021768": "大屏輪播: Render activeTabKey",
        "P_YS_FED_EXAMP_0000020601": "]是非材料類商品!",
        "P_YS_FED_EXAMP_0000020600": "是",
        "P_YS_FED_FW_0000021769": "小數位",
        "P_YS_FED_FW_0000021762": "刪除草稿失敗！",
        "P_YS_FED_EXAMP_0000020607": ",比例不得低於",
        "P_YS_FED_FW_0000021763": "存在空白行標題的行，請檢查。",
        "P_YS_FED_EXAMP_0000020606": "線上零售價 :",
        "P_YS_FED_FW_0000021760": "匯總區域設置不自動刷新。 refreshInterval",
        "P_YS_FED_EXAMP_0000020609": "改行前後商品不相同",
        "P_YS_FED_FW_0000021761": "新增範本",
        "P_YS_FED_EXAMP_0000020608": "商品審核",
        "P_YS_FED_FW_0000021766": "返回",
        "P_YS_FED_EXAMP_0000020603": "套餐商品未錄入完畢,不允許執行促銷活動",
        "P_YS_FED_FW_0000021767": "確定刪除此欄目麼？",
        "P_YS_FED_EXAMP_0000020602": "金價不合法。",
        "P_YS_FED_FW_0000021764": "· not運算符（!）：[規格型號]!=null",
        "P_YS_FED_EXAMP_0000020605": "樣例",
        "P_YS_FED_FW_0000021765": "請輸入行業",
        "P_YS_FED_EXAMP_0000020604": "訂金比例控制不能低於",
        "P_YS_FED_FW_0001238003": "這是第一條數據了, 沒有更多數據了",
        "P_YS_FED_FW_0001238005": "這是最後一條數據啦, 沒有更多數據了",
        "P_YS_SD_UDHWN_0000050766": "海東市",
        "P_YS_FED_FW_0001238004": "這是最後一條了, 沒有更多數據了",
        "P_YS_PF_PROCENTER_0000027482": "分享",
        "P_YS_FED_FW_0000021737": "請選擇行",
        "P_YS_FED_EXAMP_0000020610": "當前單據狀態下，該操作不可用！",
        "P_YS_FED_FW_0000021738": "大屏輪播:獲取系統有權限的type=1看板。 kanbans",
        "P_YS_FED_FW_0000021735": "韓語",
        "P_YS_FED_EXAMP_0000020612": "預訂交款不得低於",
        "P_YS_FED_FW_0000021736": "顯示樣式",
        "P_YS_FED_EXAMP_0000020611": "原單退貨中，退貨行不允許修改營業員！",
        "P_YS_FED_FW_0000021739": "當前區域已經有控件，請先清除。",
        "P_YS_FED_EXAMP_0000020618": "進貨價格",
        "P_YS_FED_FW_0000021730": "主組織不能為空",
        "P_YS_FED_EXAMP_0000020617": "沒有更多了~",
        "P_YS_FED_EXAMP_0000020619": "採購型別的採購入庫單無需自動揀貨！",
        "P_YS_FED_FW_0000021733": "每次只能選擇一個數據項！",
        "P_YS_FED_EXAMP_0000020614": "刪除成功",
        "P_YS_FED_FW_0000021734": "操作失敗！",
        "P_YS_FED_EXAMP_0000020613": "未啟用消費密碼管理，不能修改密碼",
        "P_YS_FED_FW_0000021731": "設置界面 EChartDesign初始化  state",
        "P_YS_FED_EXAMP_0000020616": "折扣額",
        "P_YS_FED_FW_0000021732": "匹配一維表的行時，當前行前面已經匹配過，請檢查。 valueArr =",
        "P_YS_FED_EXAMP_0000020615": "已執行過優惠活動,不允許修改卡券號和卡券號範圍",
        "P_YS_FED_UCFORG_0000066201": "jpg 格式",
        "P_YS_PF_GZTSYS_0000012330": "地址",
        "P_YS_FED_FW_0001037993": "當前欄位不可為空",
        "P_YS_FED_FW_0000021748": "請設置字體大小",
        "P_YS_FED_FW_0000021749": "您可以稍後嘗試，刷新該服務 如仍不成功，請聯繫IT管理員解決！",
        "P_YS_FED_EXAMP_0000020620": "未找到對應商品信息！",
        "P_YS_FED_FW_1492257198466662407": "請點擊錄入框右側圖示，維護多語名稱",
        "P_YS_FED_FW_0000021746": "公司網址",
        "P_YS_FED_EXAMP_0000020623": "結束時間應大於開始時間！",
        "P_YS_FED_FW_0000021747": "有權",
        "P_YS_FED_EXAMP_0000020622": "當前狀態不允許打小票",
        "P_YS_FED_FW_0000021740": "元",
        "P_YS_FED_EXAMP_0000020629": "10積分抵1元",
        "P_YS_FED_FW_0000021741": "請選擇記錄",
        "P_YS_FED_EXAMP_0000020628": "儲值卡充值不允許修改數量",
        "P_YS_HR_HRJQF_0000054031": "全國",
        "P_YS_FED_FW_0000021744": "大於等於",
        "P_YS_FED_EXAMP_0000020625": "預訂待發",
        "P_YS_FED_FW_0000021745": "信息設置",
        "P_YS_FED_EXAMP_0000020624": "下不能修改表頭信息",
        "P_YS_FED_FW_0000021742": "監控視圖匯總設置",
        "P_YS_FED_UCFBASEDOC_0000025345": "移動到",
        "P_YS_FED_EXAMP_0000020627": "選擇批號",
        "P_YS_FED_FW_0000021743": "資料類型",
        "P_YS_FED_EXAMP_0000020626": "當前工費折扣率為(",
        "P_YS_FI_IA_0000054828": "單據號:",
        "P_YS_FED_FW_0000153308": "數值列只允許黏貼數字，請修改後重試！",
        "P_YS_FED_FW_0001084311": "保存接口回調結束",
        "P_YS_FED_FW_0001084312": "fetchMeta請求回調開始",
        "P_YS_FED_FW_0000153307": "獲取參照元數據失敗：",
        "P_YS_FED_FW_0001084310": "開始調用",
        "P_YS_FED_FW_0001084319": "ajax請求開始",
        "P_YS_FED_FW_0001084317": "卡片頁數據接口回調開始",
        "P_YS_FED_FW_0001084318": "fetchMeta請求回調結束",
        "P_YS_FED_FW_0001084315": "結束執行voucherlist init方法",
        "P_YS_FED_FW_0001084316": "保存接口回調開始",
        "P_YS_FED_FW_0001084313": "開始執行initVM",
        "P_YS_FED_FW_0001084314": "結束調用",
        "P_YS_FED_FW_0001084322": "初始化viewmodel回調結束",
        "P_YS_FED_FW_0001084323": "結束請求meta數據fetchMeta",
        "P_YS_FED_FW_0001084320": "開始請求meta數據fetchMeta",
        "P_YS_FED_FW_0001084321": "ajax請求結束",
        "P_YS_FED_FW_0001084328": "結束執行voucher init方法",
        "P_YS_SD_SDMA_0000040405": "身份證號",
        "P_YS_FED_FW_0001084329": "保存按鈕點擊",
        "P_YS_FED_FW_0001084326": "卡片頁數據接口回調結束",
        "P_YS_FED_FW_0001084327": "開始執行voucher init方法",
        "P_YS_FED_FW_0001084324": "初始化viewmodel回調開始",
        "P_YS_FED_FW_0001084325": "頁面初始化",
        "P_YS_SD_SDMB_0000147380": "汽車",
        "P_YS_FED_FW_0001084333": "開始執行DynamicView的componentDidMount方法",
        "P_YS_FED_FW_0001084334": "按鈕點擊，調用Button組件內部onClick方法結束",
        "P_YS_FED_FW_1494583954049597443": "主維度不可為空且最多四項",
        "P_YS_FED_FW_0001084331": "開始執行voucherlist init方法",
        "P_YS_FED_FW_0001084332": "按鈕點擊",
        "P_YS_FED_FW_0001084330": "結束執行initVM",
        "P_YS_FED_FW_0001086990": "下推失敗",
        "P_YS_FED_FW_0001084337": "上報成功",
        "P_YS_FED_FW_0001084335": "結束執行DynamicView的componentDidMount方法",
        "P_YS_FED_FW_0001084336": "按鈕點擊，調用Button組件內部onClick方法開始",
        "P_YS_SCM_PU_0000027985": "要貨申請單",
        "P_YS_HR_HRCOREF_0000058682": "匯出全部數據",
        "P_YS_FED_FW_0001331438": "未配置searchTable",
        "P_YS_PF_BD-UI_0001050131": "採購要貨",
        "P_YS_FED_FW_0001186384": "打印服務報錯",
        "P_YS_FED_FW_1619244168636792834": "沒有code和name",
        "P_YS_PLM_BASE-UI_0001105607": "物料管理",
        "P_YS_FED_FW_0001483717": "已選條件:",
        "P_YS_FED_FW_0001098936": "未配置jointQuery",
        "P_YS_FED_FW_0001549489": "存在校驗失敗項，可以點擊查看",
        "P_YS_FED_FW_0001086945": "銀行卡格式錯誤！",
        "P_YS_PF_METADATA_0000084934": "檔案名稱",
        "P_YS_FED_IMP_IOT_0000724693": "下一條",
        "P_YS_FED_IMP_IOT_0000724695": "機構圖",
        "P_YS_FED_FW_0001260767": "存在重複行標題",
        "P_YS_FED_FW_1464019858621464576": "系統列印失敗錯誤資訊：",
        "P_YS_FED_FW_0001120451": "樹節點1",
        "P_YS_FED_FW_0001120452": "樹節點3",
        "P_YS_FED_FW_0001120453": "樹節點2",
        "P_YS_FED_FW_0001272748": "<%=name%>表體以下字段有誤",
        "P_YS_FED_IMP_IOT_0000761604": "放大",
        "P_YS_FED_FW_0001272749": "<%=name%>表體的以下孫表有誤(或存在必填項)",
        "P_YS_PF_MANAGER-FE_0001087798": "集成開發",
        "P_YS_PF_PROCENTER_0000022691": "商品編碼",
        "P_YS_FED_FW_1540589728190955535": "必填項未填，請補充每張單據的指派人",
        "P_YS_FED_FW_1565833123598958592": "獲取定位失敗",
        "P_YS_PF_GZTTMP_0000076150": "方法",
        "P_YS_FED_FW_1540589728190955529": "批量指派",
        "P_YS_FED_FW_1540589728190955532": "加入指派人",
        "P_YS_PF_PROCENTER_0000022686": "單據日期",
        "P_YS_SD_UDHWN_0001010281": "[下]ddddLT",
        "P_YS_SD_UDHWN_0001010291": "[今天]LT",
        "P_YS_FI_CM_0000028959": "十二月",
        "P_YS_FI_TP_0000071860": "大拿",
        "P_YS_FED_IMP_IOT0000006194": "南長區",
        "P_YS_SD_UDHWN_0001131752": "新增模板",
        "P_YS_FED_IMP_IOT0000006198": "東至縣",
        "P_YS_FED_IMP_IOT0000006197": "普陀區",
        "P_YS_OA_XTLCZX_0000030692": "進行中",
        "P_YS_FED_IMP_IOT0000006191": "正安縣",
        "P_YS_FED_IMP_IOT0000006182": "漾濞彝族自治縣",
        "P_YS_FED_IMP_IOT0000006185": "獻縣",
        "P_YS_FED_IMP_IOT0000006187": "葫蘆島",
        "P_YS_SD_SCMSA-UI_0000162252": "累計收款金額",
        "P_YS_FED_IMP_IOT0000006189": "阿克陶縣",
        "P_YS_FED_IMP_IOT0000006188": "荷塘區",
        "P_YS_FED_FW_1592308169585459201": "掃描數量",
        "P_YS_FED_FW_1521051784508342287": "%c 未找到相關資料",
        "P_YS_FED_FW_0001295306": "圖片大小不大於2MB,請重新上傳",
        "P_YS_FED_FW_1521051784508342284": "%c 索引為負數，當前索引",
        "P_YS_FED_IMP_IOT0000006181": "溫泉縣",
        "P_YS_FED_FW_0001295305": "圖片格式僅支持JPG、PNG、BMP,請重新上傳",
        "P_YS_FED_IMP_IOT0000006179": "西林區",
        "P_YS_FED_IMP_IOT0000006171": "商南縣",
        "P_YS_FED_FW_1521051784508342281": "%c 索引超出範圍，當前索引",
        "P_YS_FED_IMP_IOT0000006174": "盤龍區",
        "P_YS_FED_IMP_IOT0000006173": "崗巴縣",
        "P_YS_FED_IMP_IOT0000006176": "上高縣",
        "P_YS_FED_IMP_IOT0000006175": "容城縣",
        "P_YS_SD_SDMB_0000090886": "支付",
        "P_YS_FED_IMP_IOT0000006177": "隴縣",
        "P_YS_FED_IMP_IOT0000006170": "治多縣",
        "P_YS_FED_IMP_IOT0000007499": "杜集區",
        "P_YS_FED_FW_0001085694": "и",
        "P_YS_FED_IMP_IOT0000006161": "銀海區",
        "P_YS_FED_IMP_IOT0000007491": "平山區",
        "P_YS_FED_FW_0001155140": "無可用打印模板!",
        "P_YS_FED_IMP_IOT0000007494": "高縣",
        "P_YS_FI_TP_0000071815": "聯通",
        "P_YS_FED_IMP_IOT0000006164": "前郭爾羅斯蒙古族自治縣",
        "P_YS_FED_IMP_IOT0000006167": "吳興區",
        "P_YS_FED_IMP_IOT0000006166": "蒙山縣",
        "P_YS_FED_IMP_IOT0000007497": "呼蘭區",
        "P_YS_FED_IMP_IOT0000006157": "寧陝縣",
        "P_YS_FED_IMP_IOT0000006159": "亭湖區",
        "P_YS_FED_IMP_IOT0000007481": "新邱區",
        "P_YS_FED_IMP_IOT0000006152": "柘城縣",
        "P_YS_FED_IMP_IOT0000007483": "惠民縣",
        "P_YS_FED_IMP_IOT0000006154": "成安縣",
        "P_YS_FED_IMP_IOT0000007485": "株洲縣",
        "P_YS_FED_IMP_IOT0000007484": "武寧縣",
        "P_YS_FI_CM_0000028918": "十一月",
        "P_YS_FED_IMP_IOT0000006155": "陽明區",
        "P_YS_FED_IMP_IOT0000007486": "得榮縣",
        "P_YS_FED_FW_0000021681": "最多選擇8個匯總項。",
        "P_YS_FED_FW_0000021682": "普通匯總顯示",
        "P_YS_OA_XTLCZX_0000030653": "常用",
        "P_YS_OA_XTLCZX_0000030652": "創建時間",
        "P_YS_FED_FW_0000021680": "顯示周",
        "P_YS_FED_IMP_IOT_0001010685": "YYYY年M月D日Ah點mm分",
        "P_YS_FED_EXAMP_0000020599": "請錄入店鋪。",
        "P_YS_FED_IMP_IOT0000006147": "濱江區",
        "P_YS_FED_EXAMP_0000020598": "收款金額與應收金額不符！應收金額為：",
        "P_YS_FED_IMP_IOT0000006146": "墨脫縣",
        "module1.UserExcelExportController_0000": "無數據可匯出",
        "P_YS_FED_IMP_IOT_0000761593": "基礎組件",
        "P_YS_FED_EXAMP_0000020595": "客單價(元)",
        "P_YS_FED_EXAMP_0000020594": "老昌",
        "P_YS_FED_EXAMP_0000020597": "請錄入商品。",
        "P_YS_FED_EXAMP_0000020596": "重新生成SKU",
        "P_YS_FED_IMP_IOT0000007470": "吳川市",
        "P_YS_FED_FW_0000021675": "條形末端顯示數字",
        "P_YS_OA_XTLCZX_0000030646": "左",
        "P_YS_FED_FW_0000021672": "配置文件中行標題為空或者配置欄位不存在於源表欄目中，請檢查。",
        "P_YS_FED_FW_0000021673": "主維度",
        "P_YS_FED_IMP_IOT0000006140": "臨安市",
        "P_YS_FED_IMP_IOT0000007471": "華亭縣",
        "P_YS_SD_UDHWN_0000049719": "五家渠市",
        "P_YS_FED_FW_0000021678": "添加查詢條件",
        "P_YS_FED_IMP_IOT0000006143": "太和縣",
        "P_YS_FED_IMP_IOT0000007474": "紅原縣",
        "P_YS_FED_FW_0000021679": "暫時沒有數據哦~(監控視圖)",
        "P_YS_FED_IMP_IOT0000007473": "昭陽區",
        "P_YS_FED_FW_0000021676": "分組方案",
        "P_YS_FED_IMP_IOT0000006145": "河口區",
        "P_YS_FED_IMP_IOT0000007476": "志丹縣",
        "P_YS_FED_FW_0000021677": "單據名稱",
        "P_YS_FED_IMP_IOT0000006144": "西烏珠穆沁旗",
        "P_YS_OA_XTLCZX_0000030661": "上",
        "P_YS_FED_FW_0000021692": "點",
        "P_YS_FED_FW_0000021693": "獲取圖形報表數據Err 查詢參數 =",
        "P_YS_FED_FW_0000021690": "·",
        "P_YS_OA_XTLCZX_0000030663": "下",
        "P_YS_FED_FW_0000021691": "數據模版名稱",
        "P_YS_FED_FW_0001209438": "租戶級擴展腳本有語法錯誤，請修改正確後刷新瀏覽器重試！",
        "P_YS_FED_IMP_IOT0000007467": "騰衝縣",
        "P_YS_FED_IMP_IOT0000008799": "萊山區",
        "P_YS_FED_IMP_IOT0000007466": "蘆淞區",
        "P_YS_FED_IMP_IOT0000006138": "昂昂溪區",
        "P_YS_FED_IMP_IOT0000007469": "鐵山港區",
        "P_YS_FED_IMP_IOT0000008797": "陽谷縣",
        "P_YS_FED_IMP_IOT0000007468": "樺南縣",
        "P_YS_FED_IMP_IOT0000008798": "富川瑤族自治縣",
        "P_YS_FED_FW_0000021685": "堆疊柱形圖",
        "P_YS_FED_IMP_IOT0000008791": "餘幹縣",
        "P_YS_FED_FW_0000021686": "操作全部成功共",
        "P_YS_FED_FW_0000021683": "英文",
        "P_YS_FED_IMP_IOT0000006130": "安龍縣",
        "P_YS_FED_FW_0000021684": "冗餘",
        "P_YS_FED_IMP_IOT0000008790": "赫山區",
        "P_YS_FED_FW_0000021689": "初始化",
        "P_YS_FED_IMP_IOT0000007463": "龍灣區",
        "P_YS_FED_IMP_IOT0000007462": "陽春市",
        "P_YS_FED_FW_0000021687": "設置界面 render",
        "P_YS_FED_IMP_IOT0000006134": "虹口區",
        "P_YS_FED_IMP_IOT0000007465": "八宿縣",
        "P_YS_FED_IMP_IOT0000008793": "安平縣",
        "P_YS_FED_UCFBASEDOC_0000025323": "入庫",
        "P_YS_FED_FW_0000021688": "行業應用不可修改自定義項。",
        "P_YS_FED_IMP_IOT0000008794": "個舊市",
        "P_YS_OA_XTLCZX_0000030671": "下拉",
        "P_YS_FED_FW_0000021660": "單價小數位",
        "P_YS_FED_FW_0001223748": "請連接藍牙設備",
        "P_YS_FED_IMP_IOT_0001010667": "%d 秒",
        "P_YS_FED_IMP_IOT_0001010668": "YYYY年M月D日dddd HH:mm",
        "P_YS_FED_IMP_IOT0000007456": "莒南縣",
        "P_YS_FED_FW_0000021658": "正在刷新，請稍後。。。",
        "P_YS_FED_IMP_IOT0000006127": "延吉市",
        "P_YS_FED_FW_0000021659": "我的公告",
        "P_YS_FED_IMP_IOT0000007457": "上林縣",
        "P_YS_FED_IMP_IOT0000006128": "繁峙縣",
        "P_YS_FED_UCFBASEDOC_0000025319": "驗證碼",
        "P_YS_FED_FW_0000021652": "名稱:",
        "P_YS_FED_FW_0000021653": "正在匯入(",
        "P_YS_FED_FW_0000021650": "停",
        "P_YS_FED_IMP_IOT0000007450": "金湖縣",
        "P_YS_FED_FW_0000021651": "已選",
        "P_YS_FED_FW_0000021656": "必輸",
        "P_YS_FED_FW_0000021657": "大屏匯總區域設置的自動刷新間隔錯誤。 refreshInterval",
        "P_YS_FED_IMP_IOT0000006120": "瀘縣",
        "P_YS_FED_IMP_IOT0000007451": "歙縣",
        "P_YS_FED_FW_0000021654": "eChartWeather 獲取當前所在城市：調用服務出錯   params=",
        "P_YS_FED_IMP_IOT0000006123": "鄂倫春自治旗",
        "P_YS_FED_FW_0000021655": "請輸入1-999數字",
        "P_YS_FED_IMP_IOT0000006122": "科爾沁左翼後旗",
        "P_YS_FED_IMP_IOT0000007453": "昭覺縣",
        "P_YS_FED_FW_0000021670": "大屏方案 設計 eChartPanelDesigngetPreView Begin",
        "P_YS_OA_XTLCZX_0000030687": "開始時間",
        "P_YS_FED_FW_0000021671": "新增方案",
        "P_YS_SD_UDHWN_0001010211": "%s前",
        "P_YS_OA_XTGONGGAO_0000045819": "參照新增",
        "P_YS_FED_IMP_IOT0000008777": "方山縣",
        "P_YS_FED_IMP_IOT0000007444": "寧蒗彞族自治縣",
        "P_YS_FED_IMP_IOT0000008778": "崇安區",
        "P_YS_SD_UDHWN_0001010219": "%d 年",
        "P_YS_FED_FW_0000021669": "specialcom  cstyle預製錯誤！",
        "P_YS_FED_IMP_IOT0000006116": "延津縣",
        "P_YS_FED_IMP_IOT0000007447": "黃驊市",
        "P_YS_FED_IMP_IOT0000007446": "烏爾禾區",
        "P_YS_FED_IMP_IOT0000008776": "燈塔市",
        "P_YS_FED_IMP_IOT0000007449": "乃東縣",
        "P_YS_FED_IMP_IOT0000006117": "臨桂縣",
        "P_YS_FED_FW_0000021663": "項",
        "P_YS_FED_FW_0000021664": "，請檢查。",
        "P_YS_FED_IMP_IOT0000008770": "鄂托克旗",
        "P_YS_FED_FW_0000021661": "數值字體大小設置不正確",
        "P_YS_FED_FW_0000021662": "· and運算符（&&：[規格型號]!=null&&[物料簡稱]!=null",
        "P_YS_FED_FW_0001415599": "自定義數量",
        "P_YS_FED_FW_0000021667": "主維度行數",
        "P_YS_FED_IMP_IOT0000007441": "蒙自縣",
        "P_YS_FED_FW_0000021668": "列標題",
        "P_YS_FED_IMP_IOT0000008774": "華寧縣",
        "P_YS_FED_FW_0000021665": "一維表存在沒有匹配到二維表單元格的行。 index =",
        "P_YS_FED_FW_0000021666": "批改範圍",
        "P_YS_FED_IMP_IOT0000008772": "新龍縣",
        "P_YS_FED_EXAMP_0000020560": "計算效期/生產日期失敗",
        "P_YS_FED_EXAMP_0000020555": "U訂貨下架數 :",
        "P_YS_FED_IMP_IOT0000008766": "合水縣",
        "P_YS_FED_EXAMP_0000020554": "請先選擇規格",
        "P_YS_FED_IMP_IOT0000007433": "興平市",
        "P_YS_FED_IMP_IOT0000008767": "平輿縣",
        "P_YS_FED_EXAMP_0000020557": "會員錢包狀態不允許增加商品行！",
        "P_YS_FED_IMP_IOT0000007436": "順昌縣",
        "P_YS_FED_EXAMP_0000020556": "當前處於離線狀態,不允許修改卡券業務類型",
        "P_YS_FED_IMP_IOT0000006104": "景寧畬族自治縣",
        "P_YS_FED_IMP_IOT0000007435": "巴彥縣",
        "P_YS_FED_EXAMP_0000020551": "姓名/手機號",
        "P_YS_FED_IMP_IOT0000007438": "請選擇此欄位",
        "P_YS_FED_EXAMP_0000020550": "暫不支持其他類型",
        "P_YS_FED_EXAMP_0000020553": "獲取優惠券信息失敗。錯誤信息 =",
        "P_YS_FED_IMP_IOT0000006109": "黃島區",
        "P_YS_FED_IMP_IOT0000008768": "雞東縣",
        "P_YS_FED_EXAMP_0000020552": "退貨原因不可為空。",
        "P_YS_FED_IMP_IOT0000008769": "太倉市",
        "P_YS_SD_SDMB_0000137925": "第五",
        "P_YS_FED_EXAMP_0000020559": "版本",
        "P_YS_FED_IMP_IOT0000007430": "惠安縣",
        "P_YS_FED_IMP_IOT0000008762": "古城區",
        "P_YS_FED_EXAMP_0000020558": "：指需要現場銷售製作的加工商品，如：咖啡、飲品等；現製商品不受業務參數“允許負出庫”控制。",
        "P_YS_FED_IMP_IOT0000007432": "九龍縣",
        "P_YS_FED_EXAMP_0000020571": "已經執行了優惠，不允許刪行！",
        "P_YS_FED_IMP_IOT_0001010653": "YYYY年M月D日",
        "P_YS_FED_EXAMP_0000020570": "預訂交貨狀態下,批號效期為必輸！",
        "P_YS_FED_FW_0001079845": "，支持格式：",
        "P_YS_FED_FW_0001079846": "未配置",
        "P_YS_FED_EXAMP_0000020566": "微信",
        "P_YS_FED_IMP_IOT0000008755": "海城區",
        "P_YS_FED_EXAMP_0000020565": "卡券商品,請輸入卡券號或卡券號範圍",
        "P_YS_FED_IMP_IOT0000007422": "饒河縣",
        "P_YS_FED_EXAMP_0000020568": "請先確認稱重商品",
        "P_YS_FED_IMP_IOT0000007425": "開江縣",
        "P_YS_FED_IMP_IOT0000008753": "東安縣",
        "P_YS_FED_EXAMP_0000020567": "積分",
        "P_YS_FED_EXAMP_0000020562": "違規下架原因",
        "P_YS_FED_EXAMP_0000020561": "獲取是否啟用會員錢包參數失敗",
        "P_YS_FED_IMP_IOT0000007426": "麥蓋提縣",
        "P_YS_FED_EXAMP_0000020564": "非售卡狀態不允許添加實體儲值卡商品行！",
        "P_YS_FED_EXAMP_0000020563": "當前網絡狀況不能取金價！",
        "P_YS_FED_EXAMP_0000020569": "卡券商品原單退貨不能選擇其它商品！",
        "P_YS_FED_IMP_IOT0000008752": "淳化縣",
        "P_YS_FED_IMP_IOT0000007421": "河間市",
        "P_YS_OA_XTLCZX_0000030616": "結束時間",
        "P_YS_FED_IMP_IOT0000007420": "興隆縣",
        "P_YS_FED_EXAMP_0000020580": "切換雲地址",
        "P_YS_FED_IMP_IOT0000007419": "千陽縣",
        "P_YS_FED_EXAMP_0000020582": "未錄入商品，",
        "P_YS_FED_EXAMP_0000020581": "頭像",
        "P_YS_OA_XTGONGGAO_0000045847": "撤銷",
        "P_YS_FED_EXAMP_0000020577": "U訂貨未上架",
        "P_YS_FED_IMP_IOT0000008744": "南票區",
        "P_YS_FED_EXAMP_0000020576": "登錄失敗，用戶不存在",
        "P_YS_FED_EXAMP_0000020579": "\"待退貨審批！",
        "P_YS_FED_IMP_IOT0000007414": "昭平縣",
        "P_YS_FED_IMP_IOT0000008742": "蘄春縣",
        "P_YS_FED_EXAMP_0000020578": "商品\"",
        "P_YS_FED_EXAMP_0000020573": "商品(",
        "P_YS_FED_IMP_IOT0000007416": "阿榮旗",
        "P_YS_FED_IMP_IOT0000008748": "萬盛區",
        "P_YS_FED_EXAMP_0000020572": "未獲取到卡券[",
        "P_YS_FED_IMP_IOT0000008749": "石樓縣",
        "P_YS_FED_EXAMP_0000020575": "分配積分信息失敗。錯誤信息 =",
        "P_YS_FED_IMP_IOT0000007418": "隰縣",
        "P_YS_FED_EXAMP_0000020574": "確定要退訂嗎?",
        "P_YS_FED_IMP_IOT0000008747": "代縣",
        "P_YS_FED_FW_0000021696": "保存業務對象",
        "P_YS_FED_FW_0000021697": "上傳圖片：調用服務出錯  info.file.response",
        "P_YS_FED_FW_0000021694": "圖形報表_配置信息讀取失敗或者交叉表不支持圖形顯示 param =",
        "P_YS_FED_FW_0000021695": "匯總區域設置的自動刷新間隔錯誤。 refreshInterval",
        "P_YS_FED_FW_0001514845": "應用所屬領域",
        "P_YS_FED_IMP_IOT0000008741": "塘沽區",
        "P_YS_FED_FW_0001514846": "暫無歷史資料",
        "P_YS_FED_FW_0000021698": "監控視圖匯總設置 觸發事件 filterClick",
        "P_YS_FED_FW_0001514847": "暫無重試歷史資料",
        "P_YS_FED_FW_0000021699": "用友軟件園",
        "P_YS_FED_FW_0001514844": "歷史日期",
        "P_YS_FED_EXAMP_0000020591": "未交貨",
        "P_YS_FED_EXAMP_0000020590": "套餐價",
        "P_YS_FED_IMP_IOT0000007408": "咸豐縣",
        "P_YS_FED_EXAMP_0000020593": "本店配送",
        "P_YS_FED_EXAMP_0000020592": "根據yxyToken獲取token失敗：【接口】",
        "P_YS_FED_IMP_IOT0000008733": "平頂山",
        "P_YS_FED_EXAMP_0000020588": "當前選中行不是序列號管理的商品,請檢查!",
        "P_YS_FED_EXAMP_0000020587": "商品查詢",
        "P_YS_FED_IMP_IOT0000007400": "秀山土家族苗族自治縣",
        "P_YS_FED_IMP_IOT0000007403": "澤州縣",
        "P_YS_FED_EXAMP_0000020589": "線上訂單網絡打印失敗！",
        "P_YS_FED_EXAMP_0000020584": "上拉加載更多",
        "P_YS_FED_IMP_IOT0000008737": "滄源佤族自治縣",
        "P_YS_FED_EXAMP_0000020583": "已經執行了：",
        "P_YS_FED_IMP_IOT0000007404": "龍江縣",
        "P_YS_FED_EXAMP_0000020586": "變更",
        "P_YS_FED_EXAMP_0000020585": "發運",
        "P_YS_FED_IMP_IOT0000007406": "文成縣",
        "P_YS_FED_UCFBASEDOC_0000025061": "角色編碼",
        "P_YS_FED_IMP_IOT0000008609": "華龍區",
        "P_YS_FED_IMP_IOT0000009938": "滎經縣",
        "P_YS_FED_FW_0000021836": "請求數據失敗！",
        "P_YS_FED_FW_0001078150": "無效單據！",
        "P_YS_FED_IMP_IOT0000009932": "臨夏縣",
        "P_YS_FED_IMP_IOT0000010932": "三河市",
        "P_YS_FED_FW_0000021837": "保留外層邊框",
        "P_YS_FED_IMP_IOT0000009933": "興安縣",
        "P_YS_FED_FW_0000021834": "維度導航樹 查詢返回的數據存在空樹節點。行數據",
        "P_YS_FED_FW_0001295182": "您沒有打開此單據的權限，確認關閉頁面",
        "P_YS_FED_FW_0000021835": "設置匯總區_配置信息讀取失敗或者交叉表不支持 查詢參數 =",
        "P_YS_FED_IMP_IOT0000010935": "五台縣",
        "P_YS_FED_FW_0000021838": "沒有查找到處理行需要的信息。",
        "P_YS_FED_IMP_IOT0000009934": "木蘭縣",
        "P_YS_FED_FW_0000021839": "工廠",
        "P_YS_FED_FW_0001432065": "網路開小差，請稍後重試~",
        "P_YS_SD_URETAIL_0001049126": "rebootSave_per保存服務錯誤！",
        "P_YS_FED_FW_0000021832": "最大",
        "P_YS_FED_FW_0000021833": "請購單打印模板1",
        "P_YS_FED_FW_0000021830": "名稱長度不可超過10個字",
        "P_YS_FED_IMP_IOT0000010938": "溫宿縣",
        "P_YS_FED_FW_0000021831": "請輸入小數位數",
        "P_YS_FED_IMP_IOT0000010939": "利津縣",
        "P_YS_SD_SDOC_0000163818": "未返回數據",
        "P_YS_FED_IMP_IOT0000009927": "伍家崗區",
        "P_YS_FED_IMP_IOT0000009928": "獨山縣",
        "P_YS_PF_SOCD-E_0000317811": "剛果",
        "P_YS_FED_FW_0000021847": "所有信息-配置信息 config =",
        "P_YS_FED_FW_0000021848": "大於",
        "P_YS_FED_IMP_IOT0000009922": "永昌縣",
        "P_YS_FED_FW_0000021845": "eChartPanelDesign cancelOpereate 設計模板取消操作",
        "P_YS_FED_FW_0000021846": "居左",
        "P_YS_FED_IMP_IOT0000009920": "章貢區",
        "P_YS_FED_IMP_IOT0000009925": "田陽縣",
        "P_YS_FED_IMP_IOT0000010940": "平安縣",
        "P_YS_FED_FW_0000021849": "操作列",
        "P_YS_FED_IMP_IOT0000010942": "山海關區",
        "P_YS_FED_FW_0000021840": "暫無數據！",
        "P_YS_FED_FW_0000021843": "下移當前行",
        "P_YS_FED_FW_0000021844": "聯動下級",
        "P_YS_FED_FW_0000021841": "監控視圖自動定時刷新。 renderTime",
        "P_YS_FED_IMP_IOT0000010949": "武隆縣",
        "P_YS_FED_FW_0000021842": "圖冊",
        "P_YS_SD_URETAIL_0001049152": "刪除緩存數據過程失敗：",
        "P_YS_PF_PRINT_0000057698": "本幣未稅金額",
        "P_YS_FED_FW_0000021814": "分",
        "P_YS_FED_IMP_IOT0000009910": "湖口縣",
        "P_YS_FED_IMP_IOT0000010954": "馬爾康縣",
        "P_YS_FED_FW_0000021815": "向右",
        "P_YS_FED_IMP_IOT0000010955": "天山區",
        "P_YS_FED_FW_0000021812": "請選擇展示指標",
        "P_YS_FED_IMP_IOT0000010956": "察布查爾錫伯自治縣",
        "P_YS_FED_FW_0000021813": "不等於",
        "P_YS_FED_IMP_IOT0000010957": "嫩江縣",
        "P_YS_FED_FW_0000021818": "沒有更多的可用的查詢條件了...",
        "P_YS_PF_GZTTMP_0000074981": "不在列表中",
        "P_YS_FED_IMP_IOT0000009914": "黃州區",
        "P_YS_FED_FW_0000021819": "最多",
        "P_YS_FED_IMP_IOT0000009915": "波密縣",
        "P_YS_FED_FW_0000021816": "縮小",
        "P_YS_FED_IMP_IOT0000009912": "惠山區",
        "P_YS_FED_FW_0000021817": "未啟用",
        "P_YS_PF_METADATA_0001147963": "展示圖片",
        "P_YS_FED_FW_0000021810": "匯總設置",
        "P_YS_FED_FW_0000021811": "按條件",
        "P_YS_FED_UCFBASEDOC_0000025038": "日結單銷售日報_",
        "P_YS_FED_UCFBASEDOC_0000025036": "功能權限",
        "P_YS_SD_URETAIL_0001049164": "upLoaded表存入數據錯誤！",
        "P_YS_FED_IMP_IOT0000009908": "三台縣",
        "P_YS_FED_FW_0000021825": "切換失敗。",
        "P_YS_FED_FW_0000021826": "所有查詢記錄",
        "P_YS_FED_FW_0000021823": "請購單打印模板3",
        "P_YS_FED_FW_0000021824": "請購單打印模板2",
        "P_YS_PES_PES-BE_0001231166": "行重複",
        "P_YS_FED_FW_0000021829": "大屏輪播: 切換 beforeChange",
        "P_YS_FED_IMP_IOT0000009904": "安陸市",
        "P_YS_FED_IMP_IOT0000010962": "馬山縣",
        "P_YS_FED_FW_0000021827": "刪行",
        "P_YS_FED_IMP_IOT0000009901": "工農區",
        "P_YS_FED_FW_0000021828": "撤銷拆分",
        "P_YS_FED_IMP_IOT0000010964": "新河縣",
        "P_YS_FED_FW_0001367336": "PredicateDatePicker_Popover referPopover",
        "P_YS_FED_FW_0000021821": "默認語種",
        "P_YS_FED_IMP_IOT0000010969": "榆次市",
        "P_YS_FED_FW_0000021822": "柱形圖",
        "P_YS_FED_FW_0001066127": "不能超過20個字符",
        "P_YS_FED_FW_0000021820": "維度導航樹 選擇點的過濾項目",
        "P_YS_FED_UCFBASEDOC_0000025024": "點擊查詢庫存靜態報表",
        "P_YS_FED_UCFBASEDOC_0000025023": "匯出",
        "P_YS_FED_FW_0000021880": "1、數值型別的字段支持進行四則運算、比較運算、邏輯運算，可組成簡單的四則運算運算式、關係運算式、邏輯運算式。",
        "P_YS_FED_IMP_IOT_0000724760": "上一條",
        "P_YS_FED_EXAMP_0000019969": "驗證碼發送成功",
        "P_YS_FED_EXAMP_0000019968": "[公告] 門店銷售業績大PK的說明",
        "P_YS_FED_EXAMP_0000019967": ")啟用了批次管理，請輸入批號！",
        "P_YS_SD_UDHWN_0000049873": "個字符",
        "P_YS_FED_EXAMP_0000019973": "]沒有指定默認貨位！請錄手工入貨位！",
        "P_YS_FED_IMP_IOT0000010976": "保德縣",
        "P_YS_FED_EXAMP_0000019972": "]請輸入卡券號！",
        "P_YS_FED_EXAMP_0000019971": "已經執行促銷，不能再修改退貨信息",
        "P_YS_SD_UDHWS_0000118830": "數量：",
        "P_YS_FED_FW_0000021879": "交叉點",
        "P_YS_FED_EXAMP_0000019970": "請先選擇單據",
        "P_YS_FED_IMP_IOT0000010979": "遵化市",
        "P_YS_FED_EXAMP_0000019977": "請求地址：",
        "P_YS_FED_IMP_IOT0000010972": "和政縣",
        "P_YS_PF_GZTSYS_0000012211": "租戶",
        "P_YS_FED_EXAMP_0000019976": "正在初始化，請稍後重試",
        "P_YS_FED_IMP_IOT0000010973": "玄武區",
        "P_YS_FED_EXAMP_0000019975": "卡券非原單退不允許修改數量",
        "P_YS_FED_EXAMP_0000019974": "加工方式說明",
        "P_YS_FED_IMP_IOT0000010975": "海陵區",
        "P_YS_FED_FW_0000021872": "· 日期型別欄位：[成立時間]",
        "P_YS_FED_FW_0000021873": "控制錄入長度",
        "P_YS_FED_FW_0000021870": "空",
        "P_YS_FED_FW_0000021871": "未選中",
        "P_YS_FED_FW_0000021876": "顯示角度",
        "P_YS_FED_UCFBASEDOC_0000025017": "只讀",
        "P_YS_FED_FW_0000021877": "居中",
        "P_YS_FED_FW_0000021874": "類型",
        "P_YS_FED_FW_0000021875": "寬度",
        "P_YS_FED_MDF-COMPS_0001573108": "物料名稱",
        "P_YS_FED_MDF-COMPS_0001573109": "表體-0528test",
        "P_YS_FED_MDF-COMPS_0001573106": "組號",
        "P_YS_FED_MDF-COMPS_0001573107": "移到",
        "P_YS_FED_FW_0000021890": "日語",
        "P_YS_FED_FW_0000021891": "匹配一維表的行時，當前行前面已經匹配過，請檢查。 rows =",
        "P_YS_SD_URETAIL_0001049188": "刪除多條數據過程失敗！",
        "P_YS_FED_IMP_IOT0000010980": "靜樂縣",
        "P_YS_FED_EXAMP_0000019979": "按歷史銷量補貨",
        "P_YS_FED_EXAMP_0000019978": "請先選擇組織！",
        "P_YS_HR_HRJQ_0000055859": "開始日期",
        "P_YS_FED_EXAMP_0000019984": "請選擇配送頻次",
        "P_YS_FED_IMP_IOT0000010987": "沙坡頭區",
        "P_YS_FED_EXAMP_0000019983": "請選擇相同的會員進行結算",
        "P_YS_FED_FW_0000021889": "字體大小設置不正確",
        "P_YS_FED_EXAMP_0000019982": "錯誤代碼:",
        "P_YS_FED_EXAMP_0000019981": ",實際收款：",
        "P_YS_HR_HRJQF_0000054172": "禁用",
        "P_YS_FED_EXAMP_0000019988": "套餐商品沒有錄入完畢！",
        "P_YS_PF_GZTSYS_0000012221": "品牌分組",
        "P_YS_FED_EXAMP_0000019987": "存在多個營業員，只能全額收款，是否繼續",
        "P_YS_FED_IMP_IOT0000010984": "建昌縣",
        "P_YS_FED_EXAMP_0000019986": "調整狀態不允許增加商品行！",
        "P_YS_FED_IMP_IOT0000010985": "都昌縣",
        "P_YS_FED_EXAMP_0000019985": "已存在",
        "P_YS_FED_FW_0000021883": "控制錄入長度必須為1~255之間的整數!",
        "P_YS_FED_IMP_IOT_0000724756": "黏貼至末行",
        "P_YS_FED_MDF-COMPS_0001573100": "ycx文本",
        "P_YS_FED_FW_0000021884": "看板配置信息-模塊配置-圖表分組方案",
        "P_YS_FED_MDF-COMPS_0001573101": "表頭-0528test",
        "P_YS_FED_FW_0000021881": "個匯總項",
        "P_YS_FED_IMP_IOT_0000724754": "審批",
        "P_YS_FED_FW_0000021882": "大屏方案 展現 constructor panelConfig",
        "P_YS_FED_FW_0000021887": "聯繫人電話",
        "P_YS_FED_MDF-COMPS_0001573104": "應收件數",
        "P_YS_FED_FW_0000021888": "添加更多查詢條件",
        "P_YS_FED_MDF-COMPS_0001573105": "客戶分類3",
        "P_YS_FED_FW_0000021885": "！！！分組信息缺失，默認為 product product_cCode product_cName",
        "P_YS_FED_MDF-COMPS_0001573102": "倉檔案",
        "P_YS_SD_SDSD-FE_0001277778": "近3天",
        "P_YS_FED_FW_0000021886": "枚舉項",
        "P_YS_FED_MDF-COMPS_0001573103": "主計量",
        "P_YS_FED_IMP_IOT0000010990": "海豐縣",
        "P_YS_FED_IMP_IOT0000010991": "聞喜縣",
        "P_YS_FED_EXAMP_0000019989": "沒有可用的班次",
        "P_YS_FED_FW_0000021858": "輔維度",
        "P_YS_FED_EXAMP_0000019995": "服務正在更新，請稍等幾秒後重試！",
        "P_YS_FED_IMP_IOT0000010998": "元寶區",
        "P_YS_FED_FW_0000021859": "，支持格式：PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF）",
        "P_YS_FED_EXAMP_0000019994": "套餐成員項數量對比關係需符合：",
        "P_YS_FED_FW_0000021856": "eChartWeather 獲取當前所在城市 getLocalCity this.serieNum =",
        "P_YS_FED_FW_0001081771": "請求已經執行完畢！",
        "P_YS_FED_EXAMP_0000019993": "不能執行會員優惠",
        "P_YS_FED_FW_0000021857": "時間分隔符",
        "P_YS_FED_EXAMP_0000019992": "贈送金額",
        "P_YS_FED_EXAMP_0000019999": "店存入庫",
        "P_YS_FED_IMP_IOT0000010994": "讓胡路區",
        "P_YS_FED_EXAMP_0000019998": "買斷房費不允許修改數量！",
        "P_YS_FED_IMP_IOT0000010995": "阜城縣",
        "P_YS_FED_EXAMP_0000019997": "調試用戶校驗成功",
        "P_YS_SD_UDHWN_0000121761": "谷歌",
        "P_YS_FED_EXAMP_0000019996": "錢包可用餘額不足, 不能快速結算",
        "P_YS_FED_IMP_IOT0000010997": "辛集市",
        "P_YS_HR_HRJQF_0000054160": "匯入失敗",
        "P_YS_FED_FW_0000021850": "前",
        "P_YS_FED_FW_0000021851": "名稱不可為空。",
        "P_YS_FED_FW_0001457385": "請先保存!",
        "P_YS_FED_FW_0001457386": "變更日期:",
        "P_YS_FED_FW_0001457387": "變更說明:",
        "P_YS_FED_FW_0000021854": "正在加載..",
        "P_YS_FED_EXAMP_0000019991": "退品數量不能大於未出品數量！",
        "P_YS_FED_FW_0001457388": "...查看全部",
        "P_YS_FED_FW_0000021855": "生單操作完畢。",
        "P_YS_FED_EXAMP_0000019990": "請求參數：",
        "P_YS_FED_FW_0000021852": "刷新",
        "P_YS_HR_HRJXF_0000059668": "取消成功",
        "P_YS_FED_FW_0000021853": "請添加數據項到已選區域!",
        "P_YS_FED_IMP_IOT_0000724746": "導出",
        "P_YS_PF_PROCENTER_0000027111": "修改",
        "P_YS_SCM_USTOCK_0001078433": "收貨完成率",
        "P_YS_FED_FW_0000021869": "選擇全部",
        "P_YS_FED_FW_0000021867": "明細",
        "P_YS_FED_FW_0000021868": "沒有數據",
        "P_YS_PF_GZTSYS_0000012205": "會員級別",
        "P_YS_FED_IMP_IOT_0000724739": "下一條",
        "P_YS_FED_FW_0000021861": "居下",
        "P_YS_FED_FW_0000021862": "居上",
        "P_YS_FED_IMP_IOT_0000724733": "刪行",
        "P_YS_FED_FW_0000021860": "數據庫 eChartConfig",
        "P_YS_FED_IMP_IOT_0000724731": "重新上傳",
        "P_YS_FED_FW_0000021865": "未搜索到匹配的行！",
        "P_YS_FED_IMP_IOT_0000724738": "黏貼至末行",
        "P_YS_FED_FW_0000021866": "請選擇適用於PC/移動。",
        "P_YS_FED_IMP_IOT_0000724737": "導入模板下載",
        "P_YS_FED_FW_0000021863": "良",
        "P_YS_FED_FW_0000021864": "清除背景圖",
        "P_YS_FI_FIEFP-UI_0001288287": "多包含",
        "P_YS_FED_EXAMP_0000019926": "]未找到卡券對應結算方式，請設置卡券門店收款方式！",
        "P_YS_FED_EXAMP_0000019925": "尚未開房，不能交貨",
        "P_YS_FED_EXAMP_0000019924": "儲值業務型別下充值不能使用儲值卡支付",
        "P_YS_FED_EXAMP_0000019923": "未選中商品",
        "P_YS_FED_EXAMP_0000019929": "密碼不能為空",
        "P_YS_FED_EXAMP_0000019928": "不存在卡券號管理的商品行!",
        "P_YS_FED_EXAMP_0000019927": "調整狀態不允許執行優惠券！",
        "P_YS_FED_EXAMP_0000019933": "分攤優惠券失敗。信息:",
        "P_YS_FED_EXAMP_0000019932": "本單使用了優惠券收款方式，不允許修改商品數量",
        "P_YS_FED_EXAMP_0000019931": "電郵",
        "P_YS_FED_FW_0001566083": "清空並返回",
        "P_YS_FED_EXAMP_0000019930": ",商品行金額合計為：",
        "P_YS_FED_EXAMP_0000019937": "獲取時段信息！",
        "P_YS_FED_EXAMP_0000019936": "退貨行不允許改零售價",
        "P_YS_FED_EXAMP_0000019935": "（房間號）非空閒狀態，請重新選擇",
        "P_YS_FED_EXAMP_0000019934": "商品行不能為空！",
        "P_YS_FED_EXAMP_0000019939": "確定",
        "P_YS_FED_EXAMP_0000019938": "門店名稱",
        "P_YS_FED_EXAMP_0000019940": "未取得商品的SKU!",
        "P_YS_FED_EXAMP_0000019944": "狀態下，不能掛單！",
        "P_YS_FED_EXAMP_0000019943": "開始時間不能晚於或等於結束時間",
        "P_YS_FED_EXAMP_0000019942": "物品識別服務器連上不上或連接超時！",
        "P_YS_FED_EXAMP_0000019941": "未找到該卡券號對應卡券商品！",
        "P_YS_FED_MDF-COMPS_0001573117": "提交時間",
        "P_YS_FED_MDF-COMPS_0001573118": "自定義項目測試202008060001",
        "P_YS_FED_EXAMP_0000019948": "充值金額",
        "P_YS_FED_EXAMP_0000019947": "電商結算失敗",
        "P_YS_FED_EXAMP_0000019946": "當前網絡狀況不能查詢可用量！",
        "P_YS_FED_EXAMP_0000019945": "沒有選中序列號行，無法批量指定,請檢查!",
        "P_YS_FED_EXAMP_0000019949": "卡券狀態不允許執行該操作 請重新開單",
        "P_YS_FED_EXAMP_0000019951": "工作日送",
        "P_YS_FED_EXAMP_0000019950": "該商品行不允許改行！",
        "P_YS_FED_EXAMP_0000019955": "充值金額為空",
        "P_YS_FED_FW_0001272432": "拍攝模糊",
        "P_YS_FED_EXAMP_0000019954": "會員優惠",
        "P_YS_FED_FW_0001272431": "資訊不完整，請完善",
        "P_YS_FED_EXAMP_0000019953": "當前網絡狀況不能執行促銷贈品！",
        "P_YS_FED_FW_0001272434": "邊框缺失",
        "P_YS_FED_EXAMP_0000019952": "存在商品行，不允許調整！",
        "P_YS_FED_FW_0001272433": "曝光過度",
        "P_YS_FI_YYFI-UI_0001096480": "子表行",
        "P_YS_FED_FW_0001272436": "上傳身份證",
        "P_YS_FED_MDF-COMPS_0001573111": "ycx檔案類型",
        "P_YS_FED_FW_0000177620": "輸入內容",
        "P_YS_FED_FW_0001272435": "資料填寫",
        "P_YS_FED_MDF-COMPS_0001573112": "likun-表體自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573110": "枚舉",
        "P_YS_FED_MDF-COMPS_0001573115": "上游單據號",
        "P_YS_FED_MDF-COMPS_0001573116": "保質期單位",
        "P_YS_FED_MDF-COMPS_0001573113": "物料編碼",
        "P_YS_FED_MDF-COMPS_0001573114": "倉庫",
        "P_YS_PF_PROCENTER_0000027156": "查看更多",
        "P_YS_FED_EXAMP_0000019959": "，是否重新選擇操作員？",
        "P_YS_FED_EXAMP_0000019958": "金額",
        "P_YS_FED_EXAMP_0000019957": "卡券號與商品數量不等,請檢查",
        "P_YS_FED_EXAMP_0000019956": "記次券",
        "P_YS_FED_EXAMP_0000019962": "系統設置",
        "P_YS_FED_FW_0001122799": "恢復為",
        "P_YS_FED_EXAMP_0000019961": "還可以輸入",
        "P_YS_FED_EXAMP_0000019960": "領卡時間",
        "P_YS_FED_FW_1572432323657859076": "直接返回將清空本次編輯內容",
        "P_YS_FED_EXAMP_0000019966": "計時房費",
        "P_YS_FED_EXAMP_0000019965": "雙休日送",
        "P_YS_FED_EXAMP_0000019964": "狀態下，不允許刪除商品！",
        "P_YS_FED_EXAMP_0000019963": "該商品不支持選配!",
        "P_YS_FED_FW_1580622998083207174": "只允許精準搜索",
        "P_YS_FED_FW_0000021809": "至",
        "P_YS_FED_FW_1472458481506189318": "searchDevices complete，資訊：",
        "P_YS_FED_FW_1472458481506189315": "獲取已連接的設備資訊失敗：",
        "P_YS_FED_FW_0000021803": "輔維度行數不可大於5",
        "P_YS_FED_FW_0000021804": "批改",
        "P_YS_FED_FW_0000021801": "*模板編碼:",
        "P_YS_FED_FW_0000021802": "支持多選，最多選擇",
        "P_YS_FED_FW_0000021807": "降序",
        "P_YS_FED_EXAMP_0000019900": "時間區間最多允許跨一天！請重新選擇時間!",
        "P_YS_FED_FW_1472458481506189312": "searchDevices failed，錯誤資訊：",
        "P_YS_FED_FW_0000021808": "模板編碼/模板名稱必輸！",
        "P_YS_FED_FW_0000021805": "展現",
        "P_YS_FED_FW_0000021806": "區間",
        "P_YS_FED_FW_0000021800": "符合條件的分組方案(displayStyle == 2 or 3,移動看板則需要isMobile == true)中沒有找到任何分組方案。",
        "P_YS_FED_EXAMP_0000019909": "業務類型",
        "P_YS_FED_EXAMP_0000019904": "本單使用了優惠券收款方式，請整單退貨",
        "P_YS_FED_FW_0001318326": "filterId查詢報錯",
        "P_YS_FED_EXAMP_0000019903": "掛單",
        "P_YS_FED_EXAMP_0000019902": "營業概覽",
        "P_YS_FED_EXAMP_0000019901": "更新成功",
        "P_YS_FED_EXAMP_0000019908": "行商品行營業員為空！請分配營業員！",
        "P_YS_FED_EXAMP_0000019907": "業務型別非儲值且開單行非空, 不允許充值",
        "P_YS_FED_EXAMP_0000019906": "更多",
        "P_YS_FED_EXAMP_0000019905": "\"定制改型\"為\"改型\"時，商品(",
        "P_YS_FED_FW_1472458481506189327": "缺少YYEsnBridge,方法丟失",
        "P_YS_FED_FW_1472458481506189324": "未連接到列印設備,請按列印設備配網說明書配網或嘗試重啟列印設備",
        "P_YS_FED_EXAMP_0000019911": "未收款金額",
        "P_YS_FED_EXAMP_0000019910": "打印小票失敗！",
        "P_YS_FED_FW_1472458481506189321": "未搜索到列印設備,請先掃描印表機上的二維碼,配置網路或嘗試重啟列印設備",
        "P_YS_PF_SOCD-G_0000934651": "小王",
        "P_YS_FED_EXAMP_0000019915": "請先取消",
        "P_YS_FED_FW_0001246115": "code: 999 服務端邏輯異常!",
        "P_YS_FED_FW_0001290394": "imgUrl : 不存在",
        "P_YS_FED_FW_1536786620552839169": "銷售訂單-即時分析",
        "P_YS_FED_EXAMP_0000019914": "常用功能",
        "P_YS_FED_UCFBASEDOC_0000025070": "請輸入對角色的簡單描述",
        "P_YS_FED_FW_0001290395": "藍牙未開啟",
        "P_YS_FED_EXAMP_0000019913": "暫不支持多種支付方式退訂~",
        "P_YS_FED_EXAMP_0000019912": "卡券商品[",
        "P_YS_FED_EXAMP_0000019919": "退款失敗, 金額為",
        "P_YS_FED_FW_0001319664": "測試一下",
        "P_YS_FED_EXAMP_0000019918": "退貨行退貨原因不能為空!",
        "P_YS_FED_FW_0001319665": "存在重複行，第<%=index1%>, <%=index2%>行重複",
        "P_YS_FED_EXAMP_0000019917": "儲值卡非原單退功能",
        "P_YS_FED_EXAMP_0000019916": "密碼確認",
        "P_YS_FED_FW_0001290393": "獲取圖片失敗",
        "P_YS_HR_HRCOREF_0000058569": "正在匯入",
        "P_YS_FED_FW_1472458481506189336": "getConnectedDevice執行成功，但是未獲取到已連接設備",
        "P_YS_FED_FW_1472458481506189333": "printPicture failed，錯誤資訊：",
        "P_YS_FED_EXAMP_0000019922": "]的卡券號，不能執行",
        "P_YS_FED_EXAMP_0000019921": "當前操作員無卡券非原單退權限",
        "P_YS_FED_EXAMP_0000019920": "選擇營業員",
        "P_YS_FED_FW_1472458481506189330": "搜索列印設備失敗,錯誤資訊：",
        "P_YS_OA_XTLCZX_0000030377": "結束",
        "P_YS_FI_FCWEB_0001324088": "未連接多語中心的詞條:",
        "P_YS_FI_FCWEB_0001324089": "不存在,請檢查詞條!",
        "P_YS_FED_IMP_IOT0000006094": "青山湖區",
        "P_YS_FED_IMP_IOT0000006096": "松山區",
        "P_YS_OA_XTLCZX_0000030396": "指派",
        "P_YS_FED_IMP_IOT0000006091": "宿松縣",
        "P_YS_FED_IMP_IOT0000006093": "鐵力市",
        "P_YS_FED_IMP_IOT0000006092": "綏德縣",
        "P_YS_FED_FW_1564919833163202571": "拖拽：可以自定義上下表格的高度",
        "P_YS_FED_IMP_IOT0000006083": "興城市",
        "P_YS_FED_IMP_IOT0000006086": "新津縣",
        "P_YS_FED_IMP_IOT0000006089": "龍華區",
        "P_YS_FED_IMP_IOT0000006080": "甘井子區",
        "P_YS_FED_IMP_IOT0000006082": "資興市",
        "P_YS_FED_IMP_IOT0000006081": "瓊結縣",
        "P_YS_HR_HRYGF_0000055713": "全部分類",
        "P_YS_FED_FW_1564919833163202562": "雙擊：可將上下佈局變為左右佈局",
        "P_YS_FED_FW_1564919833163202565": "拖拽：可以自定義左右表格的寬度",
        "P_YS_FED_IMP_IOT0000006072": "芮城縣",
        "P_YS_FED_IMP_IOT0000006075": "樊城區",
        "P_YS_SD_SDMB_0000146326": "珠寶",
        "P_YS_FED_IMP_IOT0000006077": "固陽縣",
        "P_YS_FED_IMP_IOT0000006079": "崆峒區",
        "P_YS_FED_FW_1564919833163202568": "雙擊：可將左右佈局變為上下佈局",
        "P_YS_HR_HRJQF_0000066215": "請輸入員工姓名",
        "P_YS_FED_IMP_IOT0000006069": "濱湖區",
        "P_YS_FED_IMP_IOT0000007393": "左雲縣",
        "P_YS_FED_IMP_IOT0000006061": "奈曼旗",
        "P_YS_FED_IMP_IOT0000007392": "白雲礦區",
        "P_YS_FED_IMP_IOT0000006064": "謝家集區",
        "P_YS_OA_XTLCZX_0000030325": "上傳",
        "P_YS_FED_IMP_IOT0000007394": "新樂市",
        "P_YS_FED_IMP_IOT0000006068": "迎江區",
        "P_YS_FED_IMP_IOT0000007399": "清浦區",
        "P_YS_FED_IMP_IOT0000006060": "青州市",
        "RPA_L7_00050014": "確認要刪除嗎？",
        "P_YS_FED_IMP_IOT0000007389": "西充縣",
        "P_YS_FED_FW_0001236707": "至過去",
        "P_YS_FED_IMP_IOT0000006051": "北戴河區",
        "P_YS_FED_IMP_IOT0000006050": "長武縣",
        "P_YS_FED_IMP_IOT0000006052": "通海縣",
        "P_YS_FED_IMP_IOT0000007383": "康馬縣",
        "P_YS_FED_IMP_IOT0000006055": "浮梁縣",
        "P_YS_FED_IMP_IOT0000007386": "彌渡縣",
        "P_YS_FED_FW_0001236706": "至未來",
        "P_YS_FED_IMP_IOT0000007388": "石景山區",
        "P_YS_OA_app_xtyyjm_0000035731": "生效",
        "P_YS_FED_IMP_IOT0000007387": "新邵縣",
        "P_YS_OA_XTLCZX_0000030351": "顯示",
        "P_YS_FED_FW_0001277251": "交互規則解析錯誤：",
        "P_YS_FED_FW_0001072028": "當前已經有8個匯總項，不可再增加公式",
        "P_YS_HR_HRJQF_0000066237": "最近",
        "P_YS_FED_FW_0001277253": "%c綁定事件",
        "P_YS_FED_FW_0001277252": "%c執行動作：",
        "P_YS_FED_IMP_IOT0000006048": "防城區",
        "P_YS_FED_IMP_IOT0000007379": "青神縣",
        "P_YS_FED_FW_0001087994": "請修改後重試；",
        "P_YS_FED_FW_1607526372569776128": "獲取上下文資訊失敗：【介面】",
        "P_YS_FED_IMP_IOT0000006040": "石台縣",
        "P_YS_FED_IMP_IOT0000007371": "額濟納旗",
        "P_YS_FED_IMP_IOT0000007370": "平陸縣",
        "P_YS_FED_IMP_IOT0000006042": "貴池區",
        "P_YS_FED_IMP_IOT0000007373": "大寧縣",
        "P_YS_OA_XTLCZX_0000030347": "已上傳",
        "P_YS_FED_IMP_IOT0000006044": "蝶山區",
        "P_YS_FED_IMP_IOT0000007375": "南溪縣",
        "P_YS_FED_IMP_IOT0000006046": "長海縣",
        "P_YS_FED_IMP_IOT0000007377": "峰峰礦區",
        "P_YS_FED_IMP_IOT0000006045": "仁化縣",
        "P_YS_OA_XTLCZX_0000030361": "審批流程",
        "P_YS_OA_XTLCZX_0000030367": "請輸入數字",
        "P_YS_FED_FW_0001209138": "查看單據詳情",
        "P_YS_FED_IMP_IOT0000007368": "高陵縣",
        "P_YS_FED_IMP_IOT0000008698": "大石橋市",
        "P_YS_FED_IMP_IOT0000006038": "郯城縣",
        "P_YS_FED_IMP_IOT0000007369": "安源區",
        "P_YS_FED_IMP_IOT0000008699": "通川區",
        "P_YS_FED_IMP_IOT0000007362": "環翠區",
        "P_YS_FED_IMP_IOT0000006030": "福安市",
        "P_YS_FED_IMP_IOT0000008691": "長興縣",
        "P_YS_HR_HRCOREF_0000058606": "身份證",
        "P_YS_FED_IMP_IOT0000008697": "修武縣",
        "P_YS_FED_IMP_IOT0000007365": "蒲江縣",
        "P_YS_FED_IMP_IOT0000008695": "木里藏族自治縣",
        "P_YS_SD_UDHWN_0000050822": "青浦區",
        "P_YS_SD_UDHWN_0000049836": "儋州市",
        "P_YS_PF_PRINT_0000057631": "表體自定義項7",
        "P_YS_PF_PRINT_0000057630": "表體自定義項8",
        "P_YS_SD_SDMA_0000123136": "主頁",
        "P_YS_FED_IMP_IOT0000007357": "德慶縣",
        "P_YS_FED_IMP_IOT0000008689": "日土縣",
        "P_YS_FED_IMP_IOT0000006025": "洪湖市",
        "P_YS_FED_IMP_IOT0000007356": "愛民區",
        "P_YS_FED_IMP_IOT0000006028": "資溪縣",
        "P_YS_FED_IMP_IOT0000007359": "法庫縣",
        "P_YS_FED_IMP_IOT0000008687": "德欽縣",
        "P_YS_FED_IMP_IOT0000006027": "新豐縣",
        "P_YS_FED_IMP_IOT0000007358": "汾陽市",
        "P_YS_FED_IMP_IOT0000006029": "崇義縣",
        "P_YS_FED_FW_0000021795": "顯示日期",
        "P_YS_FED_IMP_IOT0000008681": "吳中區",
        "P_YS_QMS_QMS-QIT-WALSIN-MD_1545738062544242278": "選用",
        "P_YS_FED_FW_0000021796": "確定要刪除",
        "P_YS_FED_FW_0000021793": "原始gridmodel沒數據",
        "P_YS_FED_IMP_IOT0000006020": "烏蘭浩特市",
        "P_YS_FED_IMP_IOT0000007351": "裕安區",
        "P_YS_OA_app_xtyyjm_0000035760": "選擇年",
        "P_YS_FED_FW_0000021794": "選擇需要添加至常用功能的菜單",
        "P_YS_FED_IMP_IOT0000007350": "鹿邑縣",
        "P_YS_FED_FW_0000021799": "保存中~",
        "P_YS_FED_IMP_IOT0000008685": "龍山縣",
        "P_YS_FED_IMP_IOT0000007352": "番禺區",
        "P_YS_FED_IMP_IOT0000008686": "興仁縣",
        "P_YS_FED_FW_0000021797": "報表沒有設置匯總欄位，請檢查。",
        "P_YS_FED_IMP_IOT0000006024": "洛江區",
        "P_YS_FED_IMP_IOT0000008683": "唐縣",
        "P_YS_FED_FW_0000021798": "大屏輪播：調用服務出錯  json.message",
        "P_YS_FED_IMP_IOT0000008684": "宣化區",
        "P_YS_SD_UDHWN_0000048515": "保亭黎族苗族自治縣",
        "P_YS_FED_IMP_IOT0000007346": "平山縣",
        "P_YS_FED_IMP_IOT0000008678": "禪城區",
        "P_YS_FED_IMP_IOT_0000724719": "機構圖",
        "P_YS_FED_IMP_IOT0000006017": "垣曲縣",
        "P_YS_FED_IMP_IOT0000007348": "加查縣",
        "P_YS_FED_IMP_IOT0000008676": "澠池縣",
        "P_YS_FED_IMP_IOT0000006016": "汝州市",
        "P_YS_FED_IMP_IOT0000008677": "平度市",
        "P_YS_FED_IMP_IOT0000006019": "請搜索",
        "P_YS_FED_IMP_IOT0000008671": "大埔縣",
        "P_YS_FED_IMP_IOT0000006011": "濰城區",
        "P_YS_FED_IMP_IOT0000007342": "門頭溝區",
        "P_YS_FED_IMP_IOT0000008674": "新會區",
        "P_YS_FED_IMP_IOT0000007341": "和龍市",
        "P_YS_FED_IMP_IOT0000008675": "吐魯番市",
        "P_YS_FED_IMP_IOT_0000724715": "第一條",
        "P_YS_FED_IMP_IOT0000008672": "新鄭市",
        "P_YS_FED_FW_0001228293": "該單據無法編輯",
        "P_YS_FED_IMP_IOT_0000724713": "查詢",
        "P_YS_SD_UDHWN_0000048524": "玉樹市",
        "P_YS_OA_app_xtyyjm_0000035788": "已發布",
        "P_YS_FED_FW_0000021780": "關聯欄位不允許修改！",
        "P_YS_FED_FW_0000021781": "您瀏覽的頁面躲起來了～～",
        "P_YS_FED_IMP_IOT0000007335": "麻章區",
        "P_YS_FED_IMP_IOT0000008667": "理縣",
        "P_YS_FED_IMP_IOT0000009998": "淶水縣",
        "P_YS_FED_IMP_IOT_0000724709": "上一條",
        "P_YS_FED_FW_0000021779": "外半徑百分比",
        "P_YS_FED_IMP_IOT0000008665": "蘭坪白族普米族自治縣",
        "P_YS_FED_IMP_IOT0000007339": "石嘴山",
        "P_YS_FED_IMP_IOT0000006008": "尋甸回族彝族自治縣",
        "P_YS_FED_IMP_IOT0000006007": "依安縣",
        "P_YS_FED_IMP_IOT0000007338": "黃浦區",
        "P_YS_PF_GZTSYS_0000013564": "其他出庫",
        "P_YS_FED_FW_0000021773": "頂部插入行",
        "P_YS_OA_XTLCZX_0000030306": "多選",
        "P_YS_FED_IMP_IOT0000009990": "柳城縣",
        "P_YS_FED_FW_0000021774": "法語",
        "P_YS_FED_IMP_IOT0000008660": "華安縣",
        "P_YS_FED_FW_0000021771": "分公司",
        "P_YS_FED_FW_0000021772": "錄入信息重複，請檢查。",
        "P_YS_FED_FW_0000021777": "不包含",
        "P_YS_FED_IMP_IOT0000006000": "彌勒縣",
        "P_YS_FED_IMP_IOT0000009994": "祁連縣",
        "P_YS_FED_FW_0000021778": "顯示比例",
        "P_YS_FED_IMP_IOT0000007330": "穆棱市",
        "P_YS_FED_FW_0000021775": "經度",
        "P_YS_FED_IMP_IOT0000006002": "龍馬潭區",
        "P_YS_FED_IMP_IOT0000008661": "柳南區",
        "P_YS_FED_IMP_IOT0000009992": "當雄縣",
        "P_YS_FED_FW_0000021776": "自定義過濾條件列表",
        "P_YS_FED_IMP_IOT0000007332": "穀城縣",
        "P_YS_FED_IMP_IOT0000008662": "莊浪縣",
        "P_YS_FED_IMP_IOT0000009993": "東城區",
        "P_YS_FED_IMP_IOT_0000724702": "最後一條",
        "P_YS_OA_PACK_0001100802": "請上傳文件",
        "P_YS_PF_PRINT_0000057628": "表體自定義項3",
        "P_YS_PF_PRINT_0000057627": "表體自定義項4",
        "P_YS_FED_FW_0000021791": "天觸發一次",
        "P_YS_PF_PRINT_0000057624": "表體自定義項5",
        "P_YS_FED_FW_0000021792": "預覽",
        "P_YS_PF_PRINT_0000057622": "表體自定義項6",
        "P_YS_FED_FW_0000021790": "角",
        "P_YS_SD_UDHWN_0000049869": "瓊中黎族苗族自治縣",
        "P_YS_PF_PRINT_0000057621": "表體自定義項1",
        "P_YS_PF_PRINT_0000057620": "表體自定義項2",
        "P_YS_FED_IMP_IOT0000009987": "興寧區",
        "P_YS_FED_IMP_IOT0000007323": "瑪納斯縣",
        "P_YS_FED_IMP_IOT0000009986": "庫爾勒市",
        "P_YS_FED_IMP_IOT0000007328": "千山區",
        "P_YS_FED_IMP_IOT0000009989": "鮁魚圈區",
        "P_YS_FED_IMP_IOT0000007329": "隆陽區",
        "P_YS_FED_IMP_IOT0000008659": "安陽縣",
        "P_YS_FED_FW_0000021784": "確定啟用此條訂閱嗎？",
        "P_YS_FED_FW_0000021785": "包含",
        "P_YS_FED_FW_0000021782": "滾動計數顯示方式只能顯示一個欄位",
        "P_YS_FED_FW_0000021783": "保存草稿",
        "P_YS_HR_HRRCPDF_0000058740": "搜索歷史",
        "P_YS_FED_FW_0000021788": "請選擇分組項。",
        "P_YS_FED_IMP_IOT0000008652": "招遠市",
        "P_YS_FED_FW_0000021789": "秒",
        "P_YS_FED_IMP_IOT0000008653": "隆林各族自治縣",
        "P_YS_FED_IMP_IOT0000009984": "合作市",
        "P_YS_FED_FW_0000021786": "熱區信息",
        "P_YS_FED_IMP_IOT0000008650": "化州市",
        "P_YS_FED_FW_0000021787": "獲取圖形報表 /report/list 本次List請求結束 時間 （秒） =",
        "P_YS_FED_IMP_IOT0000008651": "大城縣",
        "P_YS_OA_app_xtyyjm_0000035798": "同步",
        "P_YS_FED_IMP_IOT0000009977": "下城區",
        "P_YS_FED_IMP_IOT0000007315": "宣武區",
        "P_YS_FED_IMP_IOT0000008643": "鐵西區",
        "P_YS_FED_IMP_IOT0000007314": "南木林縣",
        "P_YS_FED_IMP_IOT0000008644": "郫縣",
        "P_YS_FED_IMP_IOT0000009975": "永善縣",
        "P_YS_FED_IMP_IOT0000008649": "浦城縣",
        "P_YS_FED_IMP_IOT0000009978": "烏拉特後旗",
        "P_YS_FED_IMP_IOT0000007318": "房山區",
        "P_YS_FED_IMP_IOT0000008648": "昌黎縣",
        "P_YS_IPAAS_UCG_0001072863": "安全",
        "P_YS_FED_IMP_IOT0000008641": "龍山區",
        "P_YS_FED_IMP_IOT0000008642": "華坪縣",
        "P_YS_FED_IMP_IOT0000007311": "江乾區",
        "P_YS_FED_IMP_IOT0000009971": "西崗區",
        "P_YS_FED_IMP_IOT0000007309": "疏附縣",
        "P_YS_FED_IMP_IOT0000007302": "鎮巴縣",
        "P_YS_FED_IMP_IOT0000008634": "奇台縣",
        "P_YS_FED_IMP_IOT0000009965": "和順縣",
        "P_YS_FED_IMP_IOT0000007301": "明光市",
        "P_YS_FED_IMP_IOT0000008635": "二七區",
        "P_YS_FED_FW_0001084078": "敏感數據",
        "P_YS_FED_IMP_IOT0000007304": "綏芬河市",
        "P_YS_FED_IMP_IOT0000009964": "永勝縣",
        "P_YS_FED_IMP_IOT0000009969": "大同區",
        "P_YS_FED_IMP_IOT0000007308": "居巢區",
        "P_YS_FED_IMP_IOT0000007307": "格爾木市",
        "P_YS_FED_IMP_IOT0000009961": "慶雲縣",
        "P_YS_FED_IMP_IOT0000009962": "惠陽區",
        "P_YS_FED_IMP_IOT0000010906": "鳳翔縣",
        "P_YS_PF_PRINT_0000057651": "收款方式彙總",
        "P_YS_FED_IMP_IOT0000008629": "長垣縣",
        "P_YS_FED_IMP_IOT0000008624": "鄆城縣",
        "P_YS_FED_IMP_IOT0000009955": "雁山區",
        "P_YS_FED_IMP_IOT0000010911": "冠縣",
        "P_YS_FED_IMP_IOT0000009952": "萬年縣",
        "P_YS_FED_IMP_IOT0000010912": "鎮海區",
        "P_YS_FED_IMP_IOT0000008622": "鷹手營子礦區",
        "P_YS_FED_IMP_IOT0000010913": "盧灣區",
        "P_YS_FED_IMP_IOT0000009958": "盧氏縣",
        "P_YS_FED_IMP_IOT0000009959": "隆子縣",
        "P_YS_FED_FW_0001084085": "敏感數據分組",
        "P_YS_FED_IMP_IOT0000008625": "姜堰市",
        "P_YS_FED_IMP_IOT0000009956": "通河縣",
        "P_YS_FED_IMP_IOT0000008626": "海寧市",
        "P_YS_FED_IMP_IOT0000010919": "崇信縣",
        "P_YS_IMP_WJM-UI_0001114297": "孫表",
        "P_YS_OA_XTMENHUCMS_0000044952": "佛山",
        "P_YS_FED_IMP_IOT0000010914": "道真仡佬族苗族自治縣",
        "P_YS_FED_IMP_IOT0000008620": "秀峰區",
        "P_YS_FI_AR_0001121578": "正在處理",
        "P_YS_FED_IMP_IOT0000010916": "休寧縣",
        "P_YS_FED_IMP_IOT0000010917": "八步區",
        "P_YS_FED_IMP_IOT0000008618": "土默特右旗",
        "P_YS_FED_FW_0001280803": "1、發送鏈接可邀請加入該單據的錄入",
        "P_YS_FED_IMP_IOT0000008610": "南山區",
        "P_YS_FED_IMP_IOT0000010924": "巴塘縣",
        "P_YS_FED_IMP_IOT0000008616": "張店區",
        "P_YS_FED_IMP_IOT0000008617": "沁陽市",
        "P_YS_FED_IMP_IOT0000009946": "靈山縣",
        "P_YS_FED_IMP_IOT0000010920": "興寧市",
        "P_YS_SD_UDHWN_0000049828": "神農架林區",
        "P_YS_FED_IMP_IOT0000010925": "五河縣",
        "P_YS_FED_IMP_IOT0000009940": "江夏區",
        "P_YS_FED_IMP_IOT0000010927": "德安縣",
        "P_YS_FED_IMP_IOT0000010928": "蓬溪縣",
        "P_YS_HR_HRCOREF_0000058484": "學歷",
        "P_YS_FED_FW_1588016191592464396": "[保存全部] 按鈕從右上角移到了這裡~",
        "P_YS_FED_FW_1588016191592464393": "按鈕位置有更新哦~",
        "P_YS_FED_FW_0000021957": "拆分方向",
        "P_YS_FED_EXAMP_0000019896": "POS退款失敗:",
        "P_YS_FED_FW_0000021958": "監控視圖圖表設置",
        "P_YS_FED_EXAMP_0000019895": "無標準重量信息！",
        "P_YS_FED_FW_0000021955": "匯總區域設置的自動刷新間隔太短。 refreshInterval",
        "P_YS_FED_EXAMP_0000019894": "補單日期不能小於預訂日期！",
        "P_YS_FED_IMP_IOT0000010813": "盂縣",
        "P_YS_FED_FW_0000021956": "大屏方案保存失敗。err",
        "P_YS_FED_EXAMP_0000019893": "請先錄入商品！",
        "P_YS_HR_HRPUBF_0001009300": "無匹配結果",
        "P_YS_FED_EXAMP_0000019899": "原單退貨中，換貨行不允許修改零售價！",
        "P_YS_FED_FW_0000021959": "控制",
        "P_YS_FED_EXAMP_0000019898": "掛單成功:",
        "P_YS_FED_EXAMP_0000019897": "查詢緩存數據出錯！",
        "P_YS_FED_IMP_IOT0000009814": "濱海縣",
        "P_YS_FED_IMP_IOT0000010810": "克什克騰旗",
        "P_YS_FED_IMP_IOT0000010819": "太仆寺旗",
        "P_YS_FED_FW_0000021950": "十",
        "P_YS_FED_FW_0000021953": "背景圖片不可為空",
        "P_YS_FED_EXAMP_0000019892": "會員卡號",
        "P_YS_FED_FW_0000021954": "系統項，不允許設計！",
        "P_YS_FED_EXAMP_0000019891": "網絡不可用，必須使用上次登錄的帳號",
        "P_YS_FED_IMP_IOT0000010816": "大廠回族自治縣",
        "P_YS_FED_FW_0000021951": "千",
        "P_YS_FED_EXAMP_0000019890": "業務型別必輸！",
        "P_YS_FED_IMP_IOT0000010817": "元壩區",
        "P_YS_FED_FW_0000021952": "項目號",
        "P_YS_FED_IMP_IOT0000010818": "月湖區",
        "P_YS_FED_IMP_IOT0000009809": "徽縣",
        "P_YS_FED_FW_0000021968": "跳轉到Index =",
        "P_YS_FED_IMP_IOT0000009800": "輪台縣",
        "P_YS_FED_FW_0000021969": "上傳圖片",
        "P_YS_FED_IMP_IOT0000009801": "睢陽區",
        "P_YS_FED_FW_0000021966": "menuUrl為空",
        "P_YS_FED_FW_0000021967": "比較符",
        "P_YS_FED_IMP_IOT0000010825": "大東區",
        "P_YS_FED_IMP_IOT0000009804": "萊陽市",
        "P_YS_FED_IMP_IOT0000009805": "林周縣",
        "P_YS_FED_IMP_IOT0000010820": "南澳縣",
        "P_YS_FED_FW_0000021960": "增行",
        "P_YS_FED_FW_0000021961": "失敗信息",
        "P_YS_FED_FW_0000021964": "請核對以上信息是否正確，並確認房間內設備是否完好，配套物品請勿帶走！若無問題請簽字確認，謝謝！",
        "P_YS_FED_FW_0000021965": "eChartDisplay狀態改變 shouldComponentUpdate  查詢條件 changed End True",
        "P_YS_FED_FW_0000021962": "是否顯示",
        "P_YS_FED_FW_0000021963": "大屏匯總區域設置的自動刷新間隔太短。 refreshInterval",
        "P_YS_FED_IMP_IOT0000010829": "彭州市",
        "P_YS_FED_FW_0000177590": "沿用原報表權限",
        "P_YS_FED_FW_0000177591": "更新!",
        "P_YS_FED_FW_0000177592": "公式引用不可取消",
        "P_YS_FED_FW_0000177593": "請選擇PC或移動",
        "P_YS_FED_FW_0000177594": "公式不可清空",
        "P_YS_FED_FW_0000177595": "中文",
        "P_YS_FED_UCFBASEDOC_0000025160": "權限",
        "P_YS_FED_FW_0000177596": "已被此公式引用，不可循環引用",
        "P_YS_FED_FW_0000021935": "請選中一行後增加！",
        "P_YS_FED_IMP_IOT0000010833": "玉泉區",
        "P_YS_FED_IMP_IOT0000010834": "龍勝各族自治縣",
        "P_YS_FED_FW_0000021933": "大屏方案 設計 getDesignColType_Title curCol",
        "P_YS_FED_IMP_IOT0000010835": "納雍縣",
        "P_YS_FED_FW_0000021934": "過濾表達式說明:",
        "P_YS_FED_IMP_IOT0000010836": "耿馬傣族佤族自治縣",
        "P_YS_FED_FW_0000021939": "確定麼",
        "P_YS_FED_IMP_IOT0000010830": "肥東縣",
        "P_YS_FED_FW_0000021937": "內外半徑",
        "P_YS_FED_FW_0000021938": "請輸入定位內容",
        "P_YS_FED_FW_0000177586": "公式別名不可為空",
        "P_YS_FED_FW_0000177587": "小數位值",
        "P_YS_FED_FW_0000177588": "確定刪除此自定義公式麼？",
        "P_YS_FED_FW_0000177589": "非數值列不允許修改此屬性！",
        "P_YS_FED_FW_0000021931": "新增過濾項",
        "P_YS_FED_IMP_IOT0000010837": "榮成市",
        "P_YS_FED_FW_0000021932": "請輸入公司名稱",
        "P_YS_FED_FW_0000021930": "曲線圖",
        "P_YS_FED_FW_0001152737": "匯入記錄",
        "P_YS_FED_FW_0001152738": "查看匯入歷史",
        "P_YS_FED_FW_0000021946": "沒有選擇列信息。",
        "P_YS_FED_IMP_IOT0000010844": "布拖縣",
        "P_YS_FED_FW_0000021947": "多語言設置",
        "P_YS_FED_FW_0000021944": "增加圖形報表",
        "P_YS_FED_FW_0000021945": "熱區顯示圖 初始化 cStyle =",
        "P_YS_FED_FW_0000021948": "分類",
        "P_YS_FED_FW_0000021949": "最大長度為50個字符",
        "P_YS_FED_FW_0000177597": "立即升級",
        "P_YS_FED_FW_0000177598": "已經存在當前菜單，是否覆蓋PC端",
        "P_YS_FED_FW_0000177599": "重新獲取?",
        "P_YS_OA_XTMENHUCMS_0000044985": "組件",
        "P_YS_FED_FW_0000021942": "報表設置不自動刷新。 refreshInterval",
        "P_YS_FED_FW_0000021943": "部件",
        "P_YS_FED_FW_0000021940": "看板配置信息-模塊配置-彙總",
        "P_YS_FED_FW_0001367218": "選中匹配項",
        "P_YS_FED_FW_0000021941": "德語",
        "P_YS_FED_FW_0001367219": "取消匹配項",
        "P_YS_PF_PROCENTER_0000027267": "默認組織",
        "P_YS_PF_PROCENTER_0000027268": "結算",
        "P_YS_SD_SDOC-UI_0000175089": "關閉狀態",
        "P_YS_PF_PROCENTER_0000027262": "保存為草稿",
        "P_YS_FED_EXAMP_0000019849": "當前網絡狀況不能執行最低價格！",
        "P_YS_FED_EXAMP_0000019848": "，不能再新增商品！",
        "P_YS_FED_EXAMP_0000019847": "已存在商品行，不能進行",
        "P_YS_FED_EXAMP_0000019846": "結算費率",
        "P_YS_FED_FW_0001271292": "當前變更記錄為空",
        "P_YS_FED_EXAMP_0000020830": "當前業務型別不能售卡",
        "P_YS_FED_EXAMP_0000019852": "實收金額不等於應收金額。",
        "P_YS_FED_EXAMP_0000019851": "獲取打印模板失敗：",
        "P_YS_FED_FW_0000021999": "對應的行。",
        "P_YS_FED_EXAMP_0000019850": "品牌列表",
        "P_YS_FED_EXAMP_0000020832": "非原單退貨",
        "P_YS_FED_IMP_IOT0000010857": "文峰區",
        "P_YS_FED_EXAMP_0000020831": "隔天送",
        "P_YS_FED_EXAMP_0000019856": "獲取積分信息失敗。信息:",
        "P_YS_FED_IMP_IOT0000010851": "聶榮縣",
        "P_YS_FED_EXAMP_0000019855": "價格",
        "P_YS_FED_EXAMP_0000019854": "當前行不參與折扣計算/金額為零，不能執行現場折扣",
        "P_YS_FED_EXAMP_0000019853": "當前操作員沒有設置此分類商品的現場折扣權限",
        "P_YS_FED_IMP_IOT0000010854": "寧城縣",
        "P_YS_FED_FW_0000021993": "無對應值",
        "P_YS_FED_EXAMP_0000020838": "卡券商品請輸入卡券號",
        "P_YS_FED_FW_0000021994": "設為默認",
        "P_YS_FED_EXAMP_0000020837": "定製型別不允許刪行！",
        "P_YS_SD_SDMAUF_0000152050": "添加圖標",
        "P_YS_FED_FW_0000021991": "cEnumString，預製錯誤！",
        "P_YS_FED_FW_0000021992": "獲取報表的所有分組方案列表服務返回異常。",
        "P_YS_FED_EXAMP_0000020839": "商品數量",
        "P_YS_FED_FW_0000021997": "數據模版管理",
        "P_YS_FED_EXAMP_0000020834": "我的待辦",
        "P_YS_FED_FW_0000021998": "數據未更改~",
        "P_YS_FED_EXAMP_0000020833": "取消自動促銷成功",
        "P_YS_FED_FW_0000021995": "上傳背景圖",
        "P_YS_FED_EXAMP_0000020836": "獲取周邊庫存失敗。信息 :",
        "P_YS_FED_FW_0000021996": "擴展類名_",
        "P_YS_FED_EXAMP_0000020835": "公司員工",
        "P_YS_FED_FW_0001050721": "確定刪除欄目\"<%=cShowCaptionName%>\"麼?",
        "P_YS_SD_SDMAUF_0000152068": "暫無信息",
        "P_YS_FED_UCFBASEDOC_0000025132": "打開",
        "P_YS_FED_FW_0001050720": "編輯<%=templateName%>",
        "P_YS_FED_UCFBASEDOC_0000025130": "100字以內",
        "P_YS_FED_EXAMP_0000019859": "會員錢包可用餘額不足",
        "P_YS_FED_EXAMP_0000019858": "已經執行整單折扣，不能執行單行折扣，請取消折扣後重試！",
        "P_YS_FED_IMP_IOT0000010860": "涼州區",
        "P_YS_FED_EXAMP_0000019857": "硬件設備適配",
        "P_YS_FED_IMP_IOT0000010861": "二道江區",
        "P_YS_FED_EXAMP_0000019863": "值",
        "P_YS_FED_EXAMP_0000020841": "未錄入客戶，只能全額收款，是否繼續",
        "P_YS_FED_EXAMP_0000019862": "請先錄入要充值的會員",
        "P_YS_FED_EXAMP_0000020840": "”的規格，",
        "P_YS_FED_EXAMP_0000019861": "啟用批次管理的表體行批號不能為空！",
        "P_YS_FED_EXAMP_0000020843": "通知公告",
        "P_YS_FED_FW_1535342643957989385": "按鈕點擊，調用RadioButtonGroup元件內部handleButtonClick方法開始",
        "P_YS_FED_EXAMP_0000020842": "序列號管理商品不允許修改數量！",
        "P_YS_FED_EXAMP_0000019860": "請填寫需要更改的值",
        "P_YS_FED_IMP_IOT0000010869": "隆德縣",
        "P_YS_FED_EXAMP_0000019867": "當前行不允許刪除！",
        "P_YS_FED_EXAMP_0000019866": "請選擇相同的客戶進行結算",
        "P_YS_FED_FW_0001062705": "voucher->do——",
        "P_YS_FED_EXAMP_0000019865": "儲值業務型別下不能使用儲值卡支付",
        "P_YS_FED_EXAMP_0000019864": "未選擇商品，不允許刪行！",
        "P_YS_FED_IMP_IOT0000010865": "察哈爾右翼前旗",
        "P_YS_FED_EXAMP_0000020849": "調整狀態不允許修改零售價！",
        "P_YS_FED_FW_0001204460": "不支持-",
        "P_YS_FED_EXAMP_0000020848": "會員錢包充值不允許修改數量",
        "P_YS_FED_FW_0001469273": "組織存在未生效的變更，不支持再次變更，請在生效後或刪除未生效的變更，再次操作。",
        "P_YS_FED_EXAMP_0000020845": "￥",
        "P_YS_FED_EXAMP_0000020844": "未錄入業務型別，請檢查！",
        "P_YS_FED_EXAMP_0000020847": "未找到商品信息！",
        "P_YS_FED_EXAMP_0000020846": "的卡券號，不能執行",
        "P_YS_FED_EXAMP_0000019869": "啟用緩存設置時，不能進行廚打，是否繼續？",
        "P_YS_FED_IMP_IOT0000010871": "化隆回族自治縣",
        "P_YS_FED_EXAMP_0000019868": "：指先預定再根據訂單加工、入庫、銷售的商品，如：蛋糕、珠寶、其他訂製品；定制商品受業務參數‘允許負出庫’控制，但允許負可用。",
        "P_YS_FED_IMP_IOT0000010872": "右玉縣",
        "P_YS_FED_FW_0000021979": "2、文本、日期、枚舉、檔案型別字段不支持進行四則運算、比較運算（=、!=除外）。因此這些型別字段一般都是選取字段本身作為運算式，或者組成等式運算式或簡單邏輯運算式。",
        "P_YS_FED_EXAMP_0000020852": "儲值卡充值",
        "P_YS_FED_EXAMP_0000019874": "提示優惠券金額將超出應收金額，是否繼續？",
        "P_YS_FED_IMP_IOT0000010877": "汝南縣",
        "P_YS_FED_EXAMP_0000019873": "儲值卡售卡",
        "P_YS_FED_EXAMP_0000020851": "樣品不支持選配！",
        "P_YS_FED_FW_0000021977": "存在過濾欄位或者操作符為空的過濾行，請檢查",
        "P_YS_FED_EXAMP_0000020854": "卡券商品原單退貨,請輸入卡券號",
        "P_YS_FED_EXAMP_0000019872": "套餐數量",
        "P_YS_FED_FW_0000021978": "封面",
        "P_YS_FED_EXAMP_0000020853": "銷售分析",
        "P_YS_FED_EXAMP_0000019871": "刪除",
        "P_YS_FED_EXAMP_0000019878": "應收金額必須大於等於零",
        "P_YS_FED_EXAMP_0000019877": "會員錢包可用餘額不足或不適用全部商品",
        "P_YS_FED_IMP_IOT0000010874": "縉雲縣",
        "P_YS_FED_EXAMP_0000019876": "沒有獲取到當前序列號，無法自動指定,請檢查!",
        "P_YS_FED_EXAMP_0000020850": "沒有可以執行現場折扣的商品行",
        "P_YS_FED_IMP_IOT0000010875": "祿豐縣",
        "P_YS_FED_EXAMP_0000019875": "預訂狀態不允許執行",
        "P_YS_FED_IMP_IOT0000010876": "察哈爾右翼中旗",
        "P_YS_FED_FW_0000021971": "顯示名稱",
        "P_YS_FED_FW_0000021972": "當前修改的二維表單元格沒有在一維表匹配到行，請檢查。data  =",
        "P_YS_FED_FW_0001050719": "查看<%=templateName%>",
        "P_YS_FED_FW_0000021975": "僅支持JPG、JPEG、BMP、PNG格式，文件小於1M（建議最佳尺寸144*60px）",
        "P_YS_FED_FW_0000021976": "匹配一維表的行時，有多個匹配行，請檢查。 rows =",
        "P_YS_FED_FW_0000021973": "過濾條件",
        "P_YS_FED_FW_0000021974": "展示指標必選，且最多5項",
        "P_YS_SD_UDHWN_0000047368": "阿拉爾市",
        "P_YS_FED_FW_0000021990": "輔維度行數不可大於99",
        "P_YS_FED_IMP_IOT0000010882": "略陽縣",
        "P_YS_FED_FW_1509407191866540036": "纯文字档案內容超出最大長度限制，請修改",
        "P_YS_FED_EXAMP_0000019879": "零售價欄位請錄入數字。",
        "P_YS_OA_XTHUATI_0000046180": "單選",
        "P_YS_FED_EXAMP_0000019885": "數量小數位",
        "P_YS_FED_IMP_IOT0000010888": "龍亭區",
        "P_YS_FED_EXAMP_0000019884": "未啟用會員錢包",
        "P_YS_FED_IMP_IOT0000010889": "姚安縣",
        "P_YS_FED_FW_0000021988": "移動端展現",
        "P_YS_FED_EXAMP_0000019883": "未查詢到該卡券號信息",
        "P_YS_FED_FW_0000021989": "參照返回欄位",
        "P_YS_FED_EXAMP_0000019882": "電商交貨不可改狀態下不能新增商品！",
        "P_YS_FED_EXAMP_0000019889": "默認收貨地址",
        "P_YS_FED_IMP_IOT0000010884": "塔什庫爾干塔吉克自治縣",
        "P_YS_FED_FW_1546381431444340739": "點擊按鈕或按下空格鍵還原檢視表",
        "P_YS_FED_EXAMP_0000019888": "沒有數量按鈕的功能權限，不能操作",
        "P_YS_FED_EXAMP_0000019887": "電商結算成功",
        "P_YS_FED_IMP_IOT0000010886": "封開縣",
        "P_YS_FED_EXAMP_0000019886": "儲值卡",
        "P_YS_FED_FW_0000021982": "選項與主維度互斥",
        "P_YS_FED_FW_0000021983": "請輸入模板名稱",
        "P_YS_FED_UCFBASEDOC_0000025108": "點擊查詢銷售靜態報表",
        "P_YS_FED_FW_0000021980": "已經在圖形報表中使用，不能刪除。",
        "P_YS_FED_FW_0000021981": "默認值",
        "P_YS_FED_FW_0000021986": "大屏輪播:獲取模板完畢。模板ID=",
        "P_YS_FED_EXAMP_0000019881": "違規下架原因：",
        "P_YS_FED_EXAMP_0000019880": "請支付剩餘",
        "P_YS_FED_UCFBASEDOC_0000025104": "撤回",
        "P_YS_FED_FW_0000021984": "公司電郵",
        "P_YS_FED_FW_0000021985": "刪除草稿成功",
        "P_YS_SD_SDMBF_0000141424": "網店",
        "P_YS_FED_UCFORG_0000025904": "您確認要停用該組織及其下級組織與部門嗎？",
        "P_YS_PF_PRINT_0000064968": "累計付款金額",
        "P_YS_SCM_USTOCK_0001084187": "預期可完成",
        "P_YS_FED_IMP_IOT0000010899": "印台區",
        "P_YS_SCM_USTOCK_0001084186": "按時完成率：所選時間範圍內按時完成的訂單行數/訂單總行數。",
        "P_YS_FED_FW_0001321828": "缺少assignComp",
        "P_YS_FED_IMP_IOT0000010897": "勃利縣",
        "P_YS_FED_IMP_IOT0000010898": "嵊泗縣",
        "P_YS_FED_FW_0001321820": "重置列寬",
        "P_YS_SD_UDHMC_0000050989": "¥",
        "P_YS_FED_EXAMP_0000020809": "操作員",
        "P_YS_FED_EXAMP_0000020808": "名稱",
        "P_YS_FED_FW_0001186101": "代理接口失敗:",
        "P_YS_FED_FW_0000153548": "收款期初表頭",
        "P_YS_FED_EXAMP_0000020805": "退貨信息",
        "P_YS_FED_EXAMP_0000020804": "]零售價與券檔案減免金額不符,請檢查",
        "P_YS_FED_EXAMP_0000020807": "機構",
        "P_YS_FED_EXAMP_0000020806": "選擇支付方式",
        "P_YS_FED_EXAMP_0000020800": "打開錢箱失敗",
        "P_YS_FED_EXAMP_0000020803": "預訂交貨且“交貨時可修改商品”為否, 不允許儲值卡結算",
        "P_YS_FED_EXAMP_0000020802": "補單",
        "P_YS_FED_EXAMP_0000020819": "新密碼不能與舊密碼相同!",
        "P_YS_FED_EXAMP_0000020810": "有商品待退貨審批！",
        "P_YS_FED_EXAMP_0000019834": "未選擇營業員",
        "P_YS_FED_EXAMP_0000019833": "。",
        "P_YS_FED_EXAMP_0000019832": "、",
        "P_YS_FED_EXAMP_0000020816": "門店名稱型別不合法!",
        "P_YS_FED_EXAMP_0000020815": "獲取樹結構失敗：【接口】",
        "P_YS_FED_EXAMP_0000020818": "存在商品行，不允許定製！",
        "P_YS_FED_EXAMP_0000020817": "商品貨位必輸！",
        "P_YS_FED_EXAMP_0000020812": "調整後折扣不能為空！",
        "P_YS_FED_EXAMP_0000020811": "行商品",
        "P_YS_FED_EXAMP_0000020814": "錄入的[",
        "P_YS_FED_EXAMP_0000020813": "撤銷成功",
        "P_YS_FED_FW_0001007915": "'暫無搜索結果哦~'",
        "P_YS_FED_FW_0001149184": "最多設置五個搜索列！",
        "P_YS_FED_EXAMP_0000019838": "當前行不允許修改數量！",
        "P_YS_PF_PRINT_0000064959": "打印信息",
        "P_YS_FED_EXAMP_0000019837": "獲取線上自動打印數據失敗！",
        "P_YS_FED_EXAMP_0000019836": "未售出, 不能退卡",
        "P_YS_FED_EXAMP_0000019835": "該會員沒有積分。",
        "P_YS_FED_EXAMP_0000019839": "昨天",
        "P_YS_FED_EXAMP_0000019841": "使用積分必須大於等於",
        "P_YS_FED_EXAMP_0000019840": "與預訂的",
        "P_YS_FED_EXAMP_0000020821": "訂金低於預定比例金額",
        "P_YS_FED_EXAMP_0000020820": "最大找零金額為：",
        "P_YS_FED_EXAMP_0000019845": "昌平店",
        "P_YS_HR_HRCOREF_0000058401": "請選擇出生日期",
        "P_YS_FED_EXAMP_0000019844": "零售單零售金額與商品行金額合計不等！零售金額為：",
        "P_YS_FED_FW_0001387688": "圖表不能正常顯示，需要 report/getGroupSetting(獲取報表分組方案的詳細設置進行顯示) 返回的配置信息中 isEmpty(json.data.chartConfig) == false",
        "P_YS_FED_EXAMP_0000019843": "重量不可為空或者零。",
        "P_YS_FED_EXAMP_0000019842": "不能執行積分抵扣",
        "P_YS_FED_EXAMP_0000020827": "實退金額應少於應退金額！",
        "P_YS_FED_EXAMP_0000020826": "啟用貨位管理的倉庫行的貨位不能為空,請檢查!",
        "P_YS_FED_EXAMP_0000020829": "要貨申請",
        "P_YS_FED_EXAMP_0000020828": "重量不能為空或者0！",
        "P_YS_FED_EXAMP_0000020823": "信息修改成功！！",
        "P_YS_FED_EXAMP_0000020822": "不能改行",
        "P_YS_FED_FW_0000154897": "設計態模擬出錯",
        "P_YS_FED_EXAMP_0000020825": "周邊庫存",
        "P_YS_FED_EXAMP_0000020824": "該儲值卡號已錄入, 請勿重複錄入",
        "P_YS_FED_FW_0000177570": "收到的短信驗證碼",
        "P_YS_FED_FW_0000177571": "生成新權限",
        "P_YS_FED_FW_0000177572": "】，緩存數據失敗！",
        "P_YS_FED_FW_0000177573": "公式名稱",
        "P_YS_FED_FW_0000177574": "已經存在當前菜單，是否覆蓋移動端端？",
        "P_YS_SD_UDHMC_0000050930": "—",
        "P_YS_FED_FW_0000021919": "展示指標支持多選，最多共選擇",
        "P_YS_FED_FW_0000021913": "別名代碼",
        "P_YS_FED_FW_0001061466": "個人方案",
        "P_YS_FED_FW_0000021914": "當前積分：",
        "P_YS_FED_FW_0000021911": "替換圖片",
        "P_YS_FED_FW_0000021912": "訂閱時點",
        "P_YS_FED_FW_0000021917": "圖文形式",
        "P_YS_FED_FW_0000021918": "新發布的報表名字不可與系統報表重名。",
        "P_YS_FED_FW_0000021916": "匯入請求已經執行完畢！",
        "P_YS_FED_FW_0000177564": "】，實際表名【",
        "P_YS_FED_MDF-COMPS_0001573056": "日期時間測試",
        "P_YS_FED_FW_0000177565": "msgcode--cStyle預製錯誤",
        "P_YS_FED_MDF-COMPS_0001573057": "固定資產檔案導出測試",
        "P_YS_FED_FW_0000177566": "小數位值不能小於0大於6",
        "P_YS_FED_FW_0000177567": "】，保存數據事務失敗",
        "P_YS_FED_FW_0000177568": "輸入數字後，點擊後方的按鈕插入數字",
        "P_YS_FED_FW_0000021910": "交叉點在一維表對應多行，請檢查。data  =",
        "P_YS_FED_FW_0000177569": "】傳入表名【",
        "P_YS_FED_MDF-COMPS_0001573058": "z0客戶3255830",
        "P_YS_FED_FW_0001061465": "公共方案",
        "P_YS_FED_MDF-COMPS_0001573059": "表體-0528test",
        "P_YS_FED_FW_0000177580": "該名稱已存在移動端不可修改權限",
        "P_YS_FED_FW_0000177581": "@@db日誌@@【",
        "P_YS_FED_FW_0000177582": "已經存在當前菜單，是否覆蓋PC端和移動端？",
        "P_YS_FED_FW_0000177583": "此匯總項已被",
        "P_YS_FED_FW_0000177584": "該名稱已存在PC端不可修改權限",
        "P_YS_FED_FW_0000177585": "請輸入公式別名",
        "P_YS_FED_FW_0000021924": "大屏輪播:開始輪播。大屏數量",
        "P_YS_FED_FW_0000021925": "此前插入行",
        "P_YS_FED_MDF-COMPS_0001573060": "庫存組織",
        "P_YS_FED_FW_0000021922": "您於",
        "P_YS_FED_FW_0000021923": "知道了",
        "P_YS_FED_FW_0000021928": "金額小數位",
        "P_YS_FED_MDF-COMPS_0001573063": "產地",
        "P_YS_FED_FW_0000021929": "配置信息中欄目驗證OK",
        "P_YS_FED_MDF-COMPS_0001573064": "ycx檔案型別",
        "P_YS_FED_FW_0000021926": "模版管理",
        "P_YS_FED_MDF-COMPS_0001573061": "庫管員",
        "P_YS_FED_FW_0000021927": "添加數據項",
        "P_YS_FED_MDF-COMPS_0001573062": "型號",
        "P_YS_FED_FW_0000177575": "S後重新發送",
        "P_YS_FED_MDF-COMPS_0001573067": "您對必輸項設置了隱藏，請注意！",
        "P_YS_FED_FW_0000177576": "公式所需條件數量不可大於7",
        "P_YS_FED_MDF-COMPS_0001573068": "交易類型",
        "P_YS_FED_FW_0000177577": "該名稱已存在PC端和移動端不可修改權限",
        "P_YS_FED_MDF-COMPS_0001573065": "NN表頭數值0630",
        "P_YS_FED_FW_0000177578": "已經存在當前菜單，是否覆蓋PC端？",
        "P_YS_FED_MDF-COMPS_0001573066": "庫存單位",
        "P_YS_FED_FW_0000021920": "操作成功!",
        "P_YS_FED_FW_0000177579": "已經存在當前菜單，是否覆蓋移動端",
        "P_YS_FED_FW_0000021921": "確定停用此條訂閱嗎？",
        "P_YS_FED_MDF-COMPS_0001573069": "表頭-0528test",
        "P_YS_FED_FW_0000177552": "txd_表頭文本(20190531啟用)",
        "P_YS_FED_UCFBASEDOC_0000025199": "表單",
        "P_YS_FED_FW_0000177560": "日結卡片",
        "P_YS_FED_FW_0000177561": "此設備可以直接用掃碼槍！",
        "P_YS_FED_FW_0000177562": "cParameter解析失敗~",
        "P_YS_FED_FW_0000177563": "選擇公式所需條件後才可新增公式",
        "P_YS_FED_FW_0000021908": "請選擇更改欄位",
        "P_YS_FED_FW_0000021909": "請輸入1-5數字",
        "P_YS_FED_FW_0000021902": "請輸入公司電郵",
        "P_YS_FED_FW_0000021903": "當前操作將撤銷上次所做的拆分操作，是否繼續?",
        "P_YS_FED_FW_0000021900": "確定刪除欄目【",
        "P_YS_FED_FW_0000021901": "上傳附件",
        "P_YS_FED_FW_0000021906": "刪除失敗!",
        "P_YS_FED_FW_0000021907": ",至少錄入一行數據！",
        "P_YS_FED_FW_0000021904": "熱區顯示圖  設置的刷新時間太短,更改為5秒。",
        "P_YS_FED_FW_0000021905": "公司名稱",
        "P_YS_FED_FW_0000177553": "{\"0\":\"未提交\",\"1\":\"已提交\",\"2\":\"已批復\",\"3\":\"已駁回\"}",
        "P_YS_FED_FW_0000177554": "要貨申請單顯示模板(移動端)",
        "P_YS_FED_FW_0000177555": "業務商品匯總區",
        "P_YS_FED_FW_0000177556": "商品彙總",
        "P_YS_FED_FW_0000177557": "{\"decimal\":\"<%option.amountofdecimal%>\",\"prefix\":\"￥\"}",
        "P_YS_FED_FW_0000177558": "{\"1\":\"現銷\",\"2\":\"預訂\",\"3\":\"交貨\",\"4\":\"退訂\",\"5\":\"退貨\",\"6\":\"其他\",\"7\":\"售後\"}",
        "P_YS_FED_FW_0000177559": "日結單(移動端)",
        "P_YS_FED_FW_0001062762": "請選擇要刪除的模板",
        "P_YS_PF_GZTTMP_0000077237": "型號",
        "P_YS_FED_MDF-COMPS_0001573092": "請選擇操作行",
        "P_YS_FED_MDF-COMPS_0001573093": "z0客戶3627661",
        "P_YS_FED_MDF-COMPS_0001573090": "單據編號",
        "P_YS_FED_MDF-COMPS_0001573091": "likun-表頭自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573096": "likun-表體自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573097": "必輸，請精確到sku",
        "P_YS_FED_MDF-COMPS_0001573094": "保質期",
        "P_YS_FED_MDF-COMPS_0001573095": "wjl測試自定義項",
        "P_YS_FED_MDF-COMPS_0001573098": "wjl測試自定義項",
        "P_YS_FED_MDF-COMPS_0001573099": "件數",
        "P_YS_FED_FW_1524792374620323848": "地圖調用次數超限，請申請獨立的高德key",
        "P_YS_SD_SDOC_0001149954": "疑難件",
        "P_YS_FED_FW_0001047189": "四十六",
        "P_YS_FED_FW_0001047188": "十九",
        "P_YS_OA_app_xtyyjm_0000035823": "選擇月",
        "P_YS_FED_FW_0001047187": "四十八",
        "P_YS_OA_app_xtyyjm_0000035824": "未生效",
        "P_YS_FED_FW_0001047186": "三十九",
        "P_YS_FED_FW_0001047185": "三十二",
        "P_YS_FED_FW_0001047184": "三十五",
        "P_YS_FED_FW_0001047183": "二十六",
        "P_YS_FED_FW_0001047182": "二十八",
        "P_YS_FED_FW_0001084171": "詳細信息<NO.",
        "P_YS_FED_FW_0001084172": "代理接口請求<NO.",
        "P_YS_FED_MDF-COMPS_0001573070": "NN物料查詢1",
        "P_YS_FED_MDF-COMPS_0001573071": "請重新選擇，輸入數字大於可選最大值",
        "P_YS_FED_MDF-COMPS_0001573074": "專案編碼",
        "P_YS_FED_MDF-COMPS_0001573075": "數值型字段",
        "P_YS_FED_MDF-COMPS_0001573072": "數值型字段",
        "P_YS_FED_MDF-COMPS_0001573073": "請重新選擇，輸入數字小於可選最小值",
        "P_YS_FED_MDF-COMPS_0001573078": "物料sku編碼",
        "P_YS_FED_IMP_IOT0000007293": "寧鄉縣",
        "P_YS_FED_MDF-COMPS_0001573079": "自定義專案測試202008060001",
        "P_YS_FED_MDF-COMPS_0001573076": "計量單位",
        "P_YS_FED_MDF-COMPS_0001573077": "固定資產檔案導出測試",
        "P_YS_FED_FW_1556701636555440133": "刷新當前頁面",
        "P_YS_SD_SDMB_0000147545": "時尚",
        "P_YS_FED_FW_1556701636555440136": "上次刷新時間:",
        "P_YS_FED_IMP_IOT0000007297": "英山縣",
        "P_YS_FED_FW_0001047199": "三十八",
        "P_YS_FED_FW_0001047198": "三十六",
        "P_YS_FED_FW_0001047197": "五十",
        "P_YS_FED_IMP_IOT0000007290": "大方縣",
        "P_YS_FED_FW_0001047196": "四十四",
        "P_YS_FED_FW_0001047195": "二十四",
        "P_YS_FED_FW_0001047194": "三十",
        "P_YS_FED_IMP_IOT0000007291": "石獅市",
        "P_YS_FED_FW_0001047193": "二十",
        "P_YS_FED_FW_0001084182": "未配置參照編碼，請檢查配置",
        "P_YS_FED_FW_0001047192": "三十三",
        "P_YS_FED_FW_0001465649": "元資料未配置billNum",
        "P_YS_FED_FW_0001047191": "三十一",
        "P_YS_FED_FW_0001047190": "三十七",
        "P_YS_FED_MDF-COMPS_0001573081": "業務員",
        "P_YS_FED_MDF-COMPS_0001573082": "時間H",
        "P_YS_FED_MDF-COMPS_0001573080": "物料sku名稱",
        "P_YS_FED_MDF-COMPS_0001573085": "自定義檔案",
        "P_YS_FED_MDF-COMPS_0001573086": "批次號",
        "P_YS_FED_FW_0001084173": "代理接口成功<NO.",
        "P_YS_FED_MDF-COMPS_0001573083": "跟蹤號123",
        "P_YS_FED_FW_0001084174": "代理接口失敗<NO.",
        "P_YS_FED_MDF-COMPS_0001573084": "likun-表頭自定義項[文本]",
        "P_YS_FED_IMP_IOT0000007283": "潢川縣",
        "P_YS_FED_MDF-COMPS_0001573089": "門店",
        "P_YS_FED_IMP_IOT0000007285": "康平縣",
        "P_YS_FED_MDF-COMPS_0001573087": "會計主體",
        "P_YS_FED_MDF-COMPS_0001573088": "NN表頭數值0630",
        "P_YS_FED_IMP_IOT0000007289": "歷下區",
        "P_YS_OA_XTLCZX_0000030451": "審批人",
        "P_YS_SD_SDMA_0000060759": "已攬件",
        "P_YS_FED_FW_0001157538": "(control+回車)",
        "P_YS_OA_app_xtyyjm_0000035849": "顯示標題",
        "P_YS_FED_IMP_IOT0000007280": "舞鋼市",
        "P_YS_FED_FW_0001097428": "配置參數錯誤",
        "P_YS_FED_FW_0001145546": "ctrl+回車",
        "P_YS_FED_IMP_IOT0000007272": "維揚區",
        "P_YS_FED_IMP_IOT0000007274": "金壇市",
        "P_YS_FED_FW_0000177600": "】，保存數據keyPath【",
        "P_YS_FED_IMP_IOT0000007273": "山丹縣",
        "P_YS_FED_IMP_IOT0000007275": "鎮原縣",
        "P_YS_FED_IMP_IOT0000007278": "靖西縣",
        "P_YS_FED_FW_0001031669": "工行",
        "P_YS_FED_IMP_IOT0000007270": "尼瑪縣",
        "P_YS_FED_IMP_IOT0000007269": "赫章縣",
        "P_YS_FED_IMP_IOT0000007268": "浚縣",
        "P_YS_FED_FW_0000177619": "請輸入文字:",
        "P_YS_FED_IMP_IOT0000007261": "孝義市",
        "P_YS_FED_IMP_IOT0000007263": "塔河縣",
        "P_YS_FED_IMP_IOT0000008591": "沙坪垻區",
        "P_YS_FED_FW_1456067245639729152": "打開參照彈窗",
        "P_YS_FED_IMP_IOT0000008592": "金堂縣",
        "P_YS_FED_IMP_IOT0000008597": "昌吉市",
        "P_YS_OA_app_xtyyjm_0000035850": "未發布",
        "P_YS_FED_FW_0000177614": "主按鈕",
        "P_YS_FED_IMP_IOT0000007266": "犍為縣",
        "P_YS_FED_IMP_IOT0000008596": "鄖縣",
        "P_YS_FED_UCFORG_0000025923": "啟用成功",
        "P_YS_OA_XTLCZX_0000030473": "已選擇",
        "P_YS_PF_SOCD-G_0000807705": "健康",
        "P_YS_FED_IMP_IOT0000007257": "雙城市",
        "P_YS_FED_IMP_IOT0000008588": "天心區",
        "P_YS_FED_IMP_IOT0000007259": "秀嶼區",
        "P_YS_FED_IMP_IOT0000008582": "北市區",
        "P_YS_FED_IMP_IOT0000008583": "遷西縣",
        "P_YS_FED_IMP_IOT0000007252": "定襄縣",
        "P_YS_FED_IMP_IOT0000008580": "江岸區",
        "P_YS_OA_XTLCZX_0000030468": "右",
        "P_YS_FED_IMP_IOT0000007254": "淩源市",
        "P_YS_FED_IMP_IOT0000008584": "突泉縣",
        "P_YS_OA_XTLCZX_0000030486": "列表項",
        "P_YS_FED_IMP_IOT0000007247": "銅山縣",
        "P_YS_FED_IMP_IOT0000008579": "雁江區",
        "P_YS_FED_IMP_IOT0000007249": "離石區",
        "P_YS_FED_IMP_IOT0000008577": "安吉縣",
        "P_YS_FED_IMP_IOT0000007248": "城廂區",
        "P_YS_FED_IMP_IOT0000008571": "同仁縣",
        "P_YS_FED_IMP_IOT0000007241": "白塔區",
        "P_YS_FED_IMP_IOT0000008570": "九江縣",
        "P_YS_FED_IMP_IOT0000007243": "乾安縣",
        "P_YS_FED_IMP_IOT0000008575": "惠城區",
        "P_YS_FED_IMP_IOT0000007242": "萊城區",
        "P_YS_FED_IMP_IOT0000008576": "愛輝區",
        "P_YS_FED_IMP_IOT0000007245": "余江縣",
        "P_YS_FED_IMP_IOT0000008573": "沙灣區",
        "P_YS_FED_IMP_IOT0000007244": "岫岩滿族自治縣",
        "P_YS_FED_IMP_IOT0000008574": "溫嶺市",
        "P_YS_FED_UCFBASEDOC_0000025100": "]只能錄入大於0的值，請檢查後重試！",
        "P_YS_FED_FW_1572482677854961725": "你確定要離開嗎？",
        "P_YS_FED_IMP_IOT0000007236": "碌曲縣",
        "P_YS_FED_IMP_IOT0000009899": "五原縣",
        "P_YS_FED_FW_0001144258": "gridModel.lineNoStep(val)參數[val]不是一個有效的數",
        "P_YS_FED_IMP_IOT0000008566": "靈壽縣",
        "P_YS_FED_IMP_IOT0000009897": "寶塔區",
        "P_YS_FED_IMP_IOT0000007237": "輝縣市",
        "P_YS_FED_IMP_IOT0000009898": "龍潭區",
        "P_YS_FED_IMP_IOT0000007239": "理塘縣",
        "P_YS_FED_IMP_IOT0000008560": "米脂縣",
        "P_YS_FED_IMP_IOT0000009891": "察隅縣",
        "P_YS_OA_XTLCZX_0000030402": "欄位",
        "P_YS_FED_IMP_IOT0000007232": "樂陵市",
        "P_YS_FED_IMP_IOT0000009896": "廬江縣",
        "P_YS_FED_IMP_IOT0000009893": "南開區",
        "P_YS_PF_GZTSYS_0000013482": "UI模板",
        "P_YS_PF_GZTSYS_0000012149": "商家商品",
        "P_YS_FED_IMP_IOT0000007225": "小金縣",
        "P_YS_FED_IMP_IOT0000008557": "旬陽縣",
        "P_YS_FED_IMP_IOT0000008558": "泗洪縣",
        "P_YS_FED_IMP_IOT0000009889": "綠春縣",
        "P_YS_FED_IMP_IOT0000007227": "金川縣",
        "P_YS_PF_GZTSYS_0000013477": "保存",
        "P_YS_FED_IMP_IOT0000007229": "炎陵縣",
        "P_YS_FED_IMP_IOT0000007228": "化德縣",
        "P_YS_FED_IMP_IOT0000008559": "袁州區",
        "P_YS_SD_SDMBF_0000145004": "亞馬遜",
        "P_YS_FED_IMP_IOT0000007221": "爐霍縣",
        "P_YS_FED_IMP_IOT0000009884": "興安區",
        "P_YS_FED_IMP_IOT0000008554": "江陰市",
        "P_YS_FED_IMP_IOT0000007223": "市南區",
        "P_YS_FED_IMP_IOT0000008551": "山亭區",
        "P_YS_FED_IMP_IOT0000007222": "元陽縣",
        "P_YS_FED_IMP_IOT0000008552": "臨潁縣",
        "P_YS_FED_IMP_IOT0000009883": "鍾山縣",
        "P_YS_FED_FW_0001078323": "確定要<%=abandonText%>嗎?",
        "P_YS_FED_FW_0001078324": "確定要<%=abandonText%>麼",
        "P_YS_FED_FW_0001078322": "是否確認<%=cCaption%><%=text%>",
        "P_YS_FED_FW_0001078325": "共<%=total%>條",
        "P_YS_FED_IMP_IOT0000007214": "常熟市",
        "P_YS_FED_IMP_IOT0000009875": "淮陰區",
        "P_YS_PF_GZTSYS_0000013447": "未開票",
        "P_YS_FED_IMP_IOT0000009876": "當塗縣",
        "P_YS_FED_IMP_IOT0000009879": "馬尾區",
        "P_YS_PF_GZTSYS_0000012113": "客戶級別",
        "P_YS_FED_FW_0000021894": "數值不可為空，請檢查",
        "P_YS_FED_FW_0000021895": "已經回退到最初拆分前的狀態。",
        "P_YS_FED_IMP_IOT0000009870": "新民市",
        "P_YS_FED_FW_0000021892": "成功信息",
        "P_YS_FED_FW_0000021893": "默認模板不允許刪除！",
        "P_YS_OA_XTLCZX_0000030424": "合併",
        "P_YS_FED_FW_0000021898": "模版名稱不能超過20個字符",
        "P_YS_FED_FW_0000021899": "獲取枚舉失敗",
        "P_YS_FED_IMP_IOT0000009874": "冀州市",
        "P_YS_FED_FW_0000021896": "大屏方案 設計 getDesignColType_Notice curCol",
        "P_YS_FED_FW_0000021897": "請錄入主維度行數。",
        "P_YS_PF_PRINT_0000056408": "日結單",
        "P_YS_FED_IMP_IOT0000009872": "汶上縣",
        "P_YS_SD_URETAIL_0001049201": "後端報錯：",
        "P_YS_FED_FW_0001224826": "單據提交成功。",
        "P_YS_FED_IMP_IOT0000009867": "大觀區",
        "P_YS_FED_IMP_IOT0000007205": "博白縣",
        "P_YS_FED_IMP_IOT0000008533": "明山區",
        "P_YS_FED_IMP_IOT0000009864": "同心縣",
        "P_YS_FED_IMP_IOT0000008534": "黑水縣",
        "P_YS_FED_IMP_IOT0000009865": "平果縣",
        "P_YS_PF_GZTSYS_0000012122": "卡券",
        "P_YS_PF_GZTSYS_0000012125": "商品訂單屬性",
        "P_YS_FED_IMP_IOT0000008537": "平和縣",
        "P_YS_FED_IMP_IOT0000008538": "文縣",
        "P_YS_FED_FW_0001381584": "&nbsp;/ 當前頁面篩選出條",
        "P_YS_FED_FW_0001081985": "請勾選需要刪除的附件！",
        "P_YS_FED_FW_0001212858": "加載更多,剩餘",
        "P_YS_FED_IMP_IOT0000008531": "會昌縣",
        "P_YS_HR_HRJXF_0000059516": "取消發布",
        "P_YS_HR_HRJXF_0000059517": "按時完成率",
        "P_YS_FED_FW_0001081984": "批量下載",
        "P_YS_FED_IMP_IOT0000007201": "拜城縣",
        "P_YS_FED_FW_0001081983": "請勾選需要下載的附件！",
        "P_YS_FED_IMP_IOT0000009861": "寶山區",
        "P_YS_FED_FW_0001241359": "為模糊搜索型別控件，需設置默認搜索字段；",
        "P_YS_SD_URETAIL_0001049211": "IDB_deleteSomeData 刪除事務失敗",
        "P_YS_PF_PRINT_0000057797": "表頭自定義項4",
        "P_YS_PF_GZTSYS_0000012184": "客戶行業",
        "P_YS_PF_PRINT_0000057795": "表頭自定義項5",
        "P_YS_PF_PRINT_0000057794": "表頭自定義項6",
        "P_YS_PF_PRINT_0000057793": "表頭自定義項7",
        "P_YS_PF_PRINT_0000057792": "表頭自定義項1",
        "P_YS_PF_PRINT_0000057791": "表頭自定義項2",
        "P_YS_PF_PRINT_0000057790": "表頭自定義項3",
        "P_YS_FED_EXAMP_0000020797": "運費",
        "P_YS_FED_IMP_IOT0000009855": "石龍區",
        "P_YS_FED_EXAMP_0000020796": "正在開發中，敬請期待...",
        "P_YS_FED_EXAMP_0000020799": "周四",
        "P_YS_FED_EXAMP_0000020798": "當前處於離線狀態,不允許結算保存",
        "P_YS_FED_IMP_IOT0000008523": "城陽區",
        "P_YS_FED_EXAMP_0000020793": "當前單據狀態下不允許修改表頭！",
        "P_YS_FED_EXAMP_0000020792": "拍照選圖",
        "P_YS_FED_IMP_IOT0000008529": "海倫市",
        "P_YS_FED_EXAMP_0000020795": "預訂退訂狀態下不允許刪除商品！",
        "P_YS_FED_EXAMP_0000020794": "按克",
        "P_YS_FED_IMP_IOT0000009858": "桂平市",
        "P_YS_FED_FW_0001241361": "均為模糊搜索型別的控件，單個方案只能設置至多一個模糊搜索",
        "P_YS_SD_UDHWN_0000049917": "昌平區",
        "P_YS_FED_FW_0001241360": "為模糊搜索，比較符只可選擇包含；",
        "P_YS_FED_IMP_IOT0000009851": "泌陽縣",
        "P_YS_FED_IMP_IOT0000008521": "通渭縣",
        "P_YS_SD_URETAIL_0001049224": "刷新token 成功！",
        "P_YS_FED_IMP_IOT0000008519": "東安區",
        "P_YS_FED_IMP_IOT0000008513": "平潭縣",
        "P_YS_FED_FW_0001195898": "已選 (",
        "P_YS_FED_IMP_IOT0000008514": "淇縣",
        "P_YS_FED_FW_0001195897": "已選參照",
        "P_YS_FED_IMP_IOT0000008512": "臨朐縣",
        "P_YS_FED_IMP_IOT0000008517": "班戈縣",
        "P_YS_FED_IMP_IOT0000008515": "椒江區",
        "P_YS_FED_IMP_IOT0000009846": "衛東區",
        "P_YS_FED_IMP_IOT0000008516": "梅列區",
        "P_YS_FED_IMP_IOT0000009847": "武平縣",
        "P_YS_FED_IMP_IOT0000009840": "上思縣",
        "P_YS_FED_FW_0001195896": "關聯下級",
        "P_YS_ZNBZ_BZBX-MFE_0001617926": "前天",
        "P_YS_SD_UDHWN_0000049937": "全屏",
        "P_YS_PF_GZTTMP_0000073729": "護照",
        "P_YS_FED_IMP_IOT0000008508": "硯山縣",
        "P_YS_FED_IMP_IOT0000009839": "新興縣",
        "P_YS_PF_GZTSYS_0000012164": "移動報表",
        "P_YS_FED_IMP_IOT0000008509": "宜興市",
        "P_YS_SCM_USTOCK-UI_0000174298": "要貨申請單列表",
        "P_YS_FED_IMP_IOT0000008502": "海勃灣區",
        "P_YS_FED_IMP_IOT0000008500": "墨玉縣",
        "P_YS_FED_IMP_IOT0000008501": "花山區",
        "P_YS_FED_IMP_IOT0000009832": "寧南縣",
        "P_YS_FED_IMP_IOT0000008506": "鄢陵縣",
        "P_YS_FED_IMP_IOT0000009837": "開福區",
        "P_YS_FED_IMP_IOT0000009835": "牡丹區",
        "P_YS_FED_IMP_IOT0000009836": "順河回族區",
        "P_YS_FED_FW_0000082817": "全部附件",
        "P_YS_FED_IMP_IOT0000009830": "柳江縣",
        "P_YS_SD_URETAIL_0001049242": "IDB_deleteOneData刪除數據出錯！",
        "P_YS_FED_IMP_IOT0000009822": "賈汪區",
        "P_YS_FED_IMP_IOT0000010800": "德清縣",
        "P_YS_FED_IMP_IOT0000009823": "安岳縣",
        "P_YS_FED_IMP_IOT0000010801": "新密市",
        "P_YS_FED_IMP_IOT0000010802": "城區",
        "P_YS_FED_IMP_IOT0000009821": "倉山區",
        "P_YS_FED_IMP_IOT0000010803": "西秀區",
        "P_YS_FED_IMP_IOT0000009827": "樂清市",
        "P_YS_FED_IMP_IOT0000009824": "象州縣",
        "P_YS_FED_IMP_IOT0000009825": "周至縣",
        "P_YS_SD_SCMSA-UI_0000162068": "下推",
        "P_YS_FED_IMP_IOT0000010808": "西鄉縣",
        "P_YS_FED_IMP_IOT0000010809": "東河區",
        "P_YS_FED_FW_1628158682522976263": "UI模板名稱",
        "P_YS_FED_FW_0001252682": "請完善數據後重新上傳",
        "P_YS_HR_HRXCF_0000056236": "重新上傳",
        "P_YS_SD_UDHWN_0001009862": "凌晨",
        "P_YS_FED_FW_0001073947": "輸入內容錯誤",
        "P_YS_HR_HRCOREF_0000058351": "變更日期",
        "P_YS_FED_IMP_IOT0000010702": "清原滿族自治縣",
        "P_YS_SD_UDHWN_0001008520": "矩形選擇",
        "P_YS_FED_IMP_IOT0000010707": "涿州市",
        "P_YS_HR_HRXCF_0000056229": "倒序",
        "P_YS_FED_FW_0001160009": "超過交期完成的訂單行",
        "P_YS_FED_FW_0001160008": "缺少cAction參數",
        "P_YS_FED_FW_0001300832": "單",
        "P_YS_FED_FW_0001160005": "缺少mtl.dail",
        "P_YS_FED_FW_0001300835": "已攬件",
        "P_YS_FED_FW_0001160004": "\\\\n 節點資訊：",
        "P_YS_FED_FW_0001300836": "派送失敗",
        "P_YS_HR_HRXCF_0000056212": "正序",
        "P_YS_FED_FW_0001160007": "缺少flowComp",
        "P_YS_FED_FW_0001300833": "已簽收",
        "P_YS_FED_FW_0001160006": "extra 提示",
        "P_YS_FED_FW_0001300834": "派送中",
        "P_YS_FED_FW_0001160001": "已送達",
        "P_YS_FED_FW_0001300839": "運輸中",
        "P_YS_FED_FW_0001160000": "交期內完成的訂單行",
        "P_YS_FED_FW_0001160003": "缺少window.flowCompParams.host",
        "P_YS_FED_FW_0001300837": "疑難件",
        "P_YS_FED_FW_0001160002": "缺少window.YYCooperationBridge",
        "P_YS_PF_GZTTMP_0000074737": "網址",
        "P_YS_FED_FW_0001300838": "退件簽收",
        "P_YS_AM_AMC-UI_0000170775": "樹",
        "P_YS_FED_IMP_IOT0000010712": "清城區",
        "P_YS_FED_IMP_IOT0000010710": "達爾罕茂明安聯合旗",
        "P_YS_FED_FW_1525457613522206720": "<%=caption%>詳情",
        "P_YS_FED_IMP_IOT0000010718": "新榮區",
        "P_YS_PF_GZTSYS_0000015903": "門店",
        "P_YS_SD_SDOC_0001150114": "攬件",
        "P_YS_AM_AMC-UI_0000170769": "查詢區",
        "P_YS_SD_UDHWN_0000049220": "寶坻區",
        "P_YS_FED_EXAMP_0000020302": "上傳成功",
        "P_YS_FED_EXAMP_0000020301": "演示行業帳號登錄失敗：【接口】",
        "P_YS_FED_IMP_IOT0000010724": "永壽縣",
        "P_YS_FED_EXAMP_0000020304": "未錄入商品，不能執行退品！",
        "P_YS_FED_EXAMP_0000020303": "已經執行了現場折扣,不允許改零售價！",
        "P_YS_FED_IMP_IOT0000010726": "普格縣",
        "P_YS_FED_EXAMP_0000020300": "未查詢到該計次卡可退金額信息",
        "P_YS_FED_IMP_IOT0000010721": "恭城瑤族自治縣",
        "P_YS_FED_EXAMP_0000020309": "錢包支付金額不能大於錢包可用金額",
        "P_YS_HR_HRXCF_0000056205": "下載模板",
        "P_YS_FED_FW_1530135219434684425": "列印設備",
        "P_YS_OA_app_xtyyjm_0000036003": "衝突",
        "P_YS_FED_EXAMP_0000020306": "權限驗證",
        "P_YS_FED_IMP_IOT0000010727": "西和縣",
        "P_YS_FED_EXAMP_0000020305": "使用積分必須為整數。",
        "P_YS_PF_GZTSYS_0000015916": "分析",
        "P_YS_FED_IMP_IOT0000010728": "泰山區",
        "P_YS_FED_EXAMP_0000020308": "menuId為空",
        "P_YS_FED_EXAMP_0000020307": "序列號商品行未錄入序列號,請檢查!",
        "P_YS_FED_FW_0001160027": "開始配送",
        "P_YS_FED_FW_0001160026": "預計送達時間：",
        "P_YS_FED_FW_0001160029": "前5周",
        "P_YS_FED_FW_0001160028": "第二個圈",
        "P_YS_FED_FW_0001160023": "缺少協同套件方法缺失",
        "P_YS_FED_FW_0001160022": "缺失FilterViewModel",
        "P_YS_PF_SUPPORT-UI_0001122350": "事件源",
        "P_YS_FED_FW_0001160025": "前6周",
        "P_YS_FED_FW_0001160024": "modelKey獲取錯誤",
        "P_YS_FED_FW_0001160021": "暫無排序字段",
        "P_YS_FED_FW_0001160020": "供應商：$var{vendor_name}$var_end",
        "P_YS_PF_GZTSYS_0000015967": "設置",
        "P_YS_FED_IMP_IOT0000010735": "原平市",
        "P_YS_FED_IMP_IOT0000010737": "昔陽縣",
        "P_YS_FED_IMP_IOT0000010731": "蘇尼特左旗",
        "P_YS_FED_IMP_IOT0000010732": "慈利縣",
        "P_YS_FED_IMP_IOT0000010733": "河南蒙古族自治縣",
        "P_YS_FED_IMP_IOT0000010739": "茂港區",
        "P_YS_FED_FW_0001160019": "派送中",
        "P_YS_FED_FW_0001160016": "派送",
        "P_YS_FED_FW_0001160015": "國內承運：",
        "P_YS_FED_FW_0001160018": "金額$var{oriSum}$var_end $var{currency_name}$var_end",
        "P_YS_FED_FW_0001160017": "按時完成率=時間範圍內未逾期收貨的訂單行數/訂單行總數*100%",
        "P_YS_FED_FW_0001160012": "缺少section格式錯誤",
        "P_YS_FED_FW_0001160011": "cell的寬度超過表格的寬度,無法渲染",
        "P_YS_FED_FW_0001160014": "沒有物流單號",
        "P_YS_FED_FW_0001160013": "第三周",
        "P_YS_FED_IMP_IOT0000010740": "無棣縣",
        "P_YS_PF_TRS-FE_0000103832": "匯入中...",
        "P_YS_FED_FW_0001160010": "/10行",
        "P_YS_FED_FW_1503374162989678595": "打開側滑面板",
        "P_YS_PF_GZTSYS_0000015975": "條碼",
        "P_YS_FED_IMP_IOT0000010741": "漢源縣",
        "P_YS_FED_IMP_IOT0000010742": "關嶺布依族苗族自治縣",
        "P_YS_FED_IMP_IOT0000010749": "長泰縣",
        "P_YS_FED_FW_0001160049": "缺少window.mtl",
        "P_YS_FED_FW_0001160048": "搜索地點",
        "P_YS_FED_FW_0001160045": "parsecontrols缺少Collapse容器組件",
        "P_YS_FED_FW_0001160044": "listType 錯誤，不是refer",
        "P_YS_FED_FW_0001160047": "(已選擇",
        "P_YS_FED_IMP_IOT0000010750": "茂南區",
        "P_YS_FED_FW_0001160046": "portal缺少tabs",
        "P_YS_FED_IMP_IOT0000010751": "合陽縣",
        "P_YS_FED_FW_0001160041": "context缺失",
        "P_YS_FED_FW_0001312860": "滑鼠滑過時展示的信息",
        "P_YS_FED_FW_0001160040": "cTemplateTitle為空",
        "P_YS_FED_FW_0001160043": "路由params解析錯誤",
        "P_YS_FED_FW_0001312862": "GIS地圖配置信息",
        "P_YS_FED_FW_0001160042": "這裏是個toolbar",
        "P_YS_FED_FW_0001312861": "滑鼠滑過時展示的信息的標題",
        "P_YS_FED_IMP_IOT0000010756": "常山縣",
        "P_YS_FED_FW_0001201089": "查看訂單詳情",
        "P_YS_PF_GZTSYS_0000015945": "會員",
        "P_YS_FED_FW_0001160050": "（已選",
        "P_YS_FED_IMP_IOT0000010758": "羅湖區",
        "P_YS_FED_IMP_IOT0000010759": "察雅縣",
        "P_YS_FED_FW_0001312857": "GIS地圖配置信息-yySetting",
        "P_YS_FED_IMP_IOT0000010753": "懷集縣",
        "P_YS_FED_FW_0001312856": "展示標題",
        "P_YS_FED_FW_1427569433243549696": "交叉點不可為空。",
        "P_YS_FED_FW_0001312859": "GIS地圖配置信息-eChartSetting",
        "P_YS_FED_FW_1427569433243549699": "列標題不可為空。",
        "P_YS_OA_app_xtyyjm_0000036032": "非必填",
        "P_YS_FED_FW_0001312858": "GIS地圖",
        "P_YS_FED_FW_0001160038": "行）",
        "P_YS_FED_FW_0001160037": "確定刪除嘛?",
        "P_YS_FED_FW_0001160039": "移動端暫不支持打開此單據",
        "P_YS_FED_FW_0001160034": "您好，我方向貴單位所購之貨物，望及時安排發貨並告知我方。",
        "P_YS_FED_FW_0001160033": "請輸入必填字段",
        "P_YS_FED_FW_0001377324": "請貼上正確的欄位進行搜索~",
        "P_YS_FED_FW_0001160036": "缺少phone number",
        "P_YS_FED_FW_0001160035": "前4周",
        "P_YS_FED_FW_0001160030": "攬收",
        "P_YS_FED_FW_0001160032": "缺少sectionParams",
        "P_YS_PF_GZTBDM_0000036354": "刷新成功",
        "P_YS_FED_FW_0001160031": "六角螺母-細牙DIN934【DIN93489074873984】",
        "P_YS_FED_IMP_IOT0000010767": "淶源縣",
        "P_YS_FED_FW_0001312864": "GIS地圖示例",
        "P_YS_FED_IMP_IOT0000010768": "屏邊苗族自治縣",
        "P_YS_FED_FW_0001312863": "位置欄位",
        "P_YS_FED_IMP_IOT0000010769": "廣漢市",
        "P_YS_FED_FW_0001493696": "已到達底部",
        "P_YS_FED_IMP_IOT0000010763": "平壩縣",
        "P_YS_FED_FW_0001493695": "⇅",
        "P_YS_FED_IMP_IOT0000010765": "遂昌縣",
        "P_YS_FED_FW_0001071353": "編輯方案",
        "P_YS_FED_FW_0001241952": "模板內容校驗失敗",
        "P_YS_FED_FW_0001241953": "數據校驗中",
        "P_YS_FED_FW_0001241950": "檔型別必須為",
        "P_YS_FED_FW_0001241951": "個，您將繼續導入嗎?",
        "P_YS_FED_IMP_IOT0000010770": "潮安縣",
        "P_YS_FED_IMP_IOT0000010771": "新野縣",
        "P_YS_FED_IMP_IOT0000010772": "武陵區",
        "P_YS_FED_FW_0001241958": "引用參照異常數",
        "P_YS_FED_FW_0001241956": "上傳導入檔",
        "P_YS_FED_FW_0001241957": "經系統校驗",
        "P_YS_FED_FW_0001241954": "共存在",
        "P_YS_FED_FW_0001241955": "無異常數據，可進行導入",
        "P_YS_FED_IMP_IOT0000010778": "昌都縣",
        "P_YS_FED_IMP_IOT0000010779": "蘇州",
        "P_YS_FED_IMP_IOT0000010777": "趙縣",
        "P_YS_FED_FW_0001241963": "異常總數",
        "P_YS_HR_HRJQ_0000031222": "所屬部門",
        "P_YS_FED_FW_0001241964": "必填為空數",
        "P_YS_FED_FW_1566299230629789705": "查看舊附件",
        "P_YS_FED_FW_0001241961": "格式異常數",
        "P_YS_FED_FW_0001241962": "導入工作臺",
        "P_YS_FED_FW_0001241960": "查看更多明細",
        "P_YS_FED_FW_1566299230629789708": "查看舊圖",
        "P_YS_FED_FW_0001160056": "此處是個iframe",
        "P_YS_FED_FW_0001160055": "沒有更多數據",
        "P_YS_FED_FW_0001160052": "單據時間:",
        "P_YS_FED_FW_0001160051": "輸入查詢",
        "P_YS_FED_FW_0001160054": "缺少toolbar",
        "P_YS_FED_FW_0001160053": "請定位",
        "P_YS_FED_FW_1438107719627702272": "最多設置5個搜索列！",
        "P_YS_OA_app_xtyyjm_0000036063": "是否刷新",
        "P_YS_FED_IMP_IOT0000010786": "玉龍納西族自治縣",
        "P_YS_FED_IMP_IOT0000010787": "柳河縣",
        "P_YS_OA_XTSPZX_0000034801": "結束日期",
        "P_YS_FED_FW_1529514021144231942": "審批中單據暫不能直接跳編輯態",
        "P_YS_FED_FW_1566299230629789711": "查看歷史附件",
        "P_YS_PF_ANALYTIC-FE_0001652971": "地圖類型",
        "P_YS_FED_FW_0001636725": "模板校驗失敗!",
        "P_YS_FED_IMP_IOT0000010791": "邛崍市",
        "P_YS_FED_IMP_IOT0000010796": "通山縣",
        "P_YS_FED_IMP_IOT0000010797": "江孜縣",
        "P_YS_FED_IMP_IOT0000010798": "天等縣",
        "P_YS_SD_UDHWN_0000050285": "澄邁縣",
        "P_YS_FED_FW_0001241949": "目前初步校驗，異常總數",
        "P_YS_FED_FW_0001241948": "導出修改",
        "P_YS_FED_FW_0001033077": "商店",
        "P_YS_OA_app_xtyyjm_0000036082": "數字",
        "P_YS_SD_UDHMC_0001057227": "嗎",
        "P_YS_OA_app_xtyyjm_0000036083": "過濾",
        "P_YS_FED_FW_0001256170": "二手房產權糾紛有哪些？ \\n",
        "P_YS_FED_FW_0001256171": "我是折疊區域的內容，點擊按鈕我就顯示，再次點擊就會隱藏。快來點擊按鈕體驗我的交互效果吧，是不是很棒！趕快使用吧~~~",
        "P_YS_HR_HRJQ_0000031253": "十一",
        "P_YS_HR_HRJQ_0000031259": "已超期",
        "P_YS_FED_FW_0001256178": "住宅社區的大件垃圾有望得到回收利用 \\n",
        "P_YS_MF_ED-UI_0001095584": "過去",
        "P_YS_FED_FW_0001256179": "國際新聞",
        "P_YS_FED_FW_0001256176": "大按鈕",
        "P_YS_FED_FW_0001256177": "中國",
        "P_YS_FED_FW_0001256174": "汽車保養只換機油，4個零件要是不換的 \\n",
        "P_YS_FED_FW_0001256175": "小按鈕",
        "P_YS_FED_FW_0001256172": "最均衡國產10萬元SUV推薦",
        "P_YS_FED_FW_0001256173": "Basic Slider，`step默認1`",
        "P_YS_FED_FW_0001256169": "網友偶遇貼特大號“實習”標誌的豪車 \\n",
        "P_YS_SD_UDHWN_0001009822": "中午",
        "P_YS_FED_FW_0001256181": "15萬預算，適合年輕人的2臺運動轎車，顏值高實力強 \\n",
        "P_YS_FED_FW_0001256182": "小戶型榻榻米的製作流程 這樣准沒錯 \\n",
        "P_YS_FED_FW_1609500210710446085": "mainOrigin值為：",
        "P_YS_FED_FW_0001256180": "地上忽現大坑 瞬間吞掉兩幢房子 \\n",
        "P_YS_FED_FW_0001300824": "點擊加載更多",
        "P_YS_FED_FW_0001300825": "關聯下級",
        "P_YS_FED_FW_0001300823": "加載更多",
        "P_YS_FED_FW_0001300828": "請定位",
        "P_YS_FED_FW_0001300829": "繼續加入",
        "P_YS_SD_UDHWN_0000049240": "順義區",
        "P_YS_FED_FW_0001300826": "複製成功",
        "P_YS_FED_FW_0001256183": "暫無數據~",
        "P_YS_SD_UDHWN_0001009818": "1 小時",
        "P_YS_FED_FW_0001256156": "更大更好吃的海蠣子有望端上青島市民餐桌！ \\n",
        "P_YS_FED_FW_0001256157": "最低工資標準上調窗口開啟 京魯冀等多個省市 \\n",
        "P_YS_FED_FW_0001256154": "磁貼標題",
        "P_YS_FED_FW_0001256155": "這是一個很強的提醒！",
        "P_YS_FED_FW_0001256152": "「評論」“小降准”的大意義",
        "P_YS_FED_FW_0001256153": "追劇聽相聲玩手遊 “歪果仁”為了學漢語也是拼了 \\n",
        "P_YS_FED_FW_0001256150": "測繪准入放寬在即，新玩家新規則倒逼產業轉型 \\n",
        "P_YS_FED_FW_0001256151": "房產",
        "P_YS_FED_FW_0001256149": "戲曲進高校玩快閃 “圈粉”大學生 \\n",
        "P_YS_FED_FW_1583355559353516056": "暫無數據哦～",
        "P_YS_FED_FW_0001256147": "智慧城市建設莫一哄而上 \\n",
        "P_YS_FED_FW_0001256148": "大眾系SUV多到臉盲？一招教你如何選 \\n",
        "P_YS_FED_IMP_IOT0000007096": "蠡縣",
        "P_YS_FED_IMP_IOT0000007098": "尼木縣",
        "P_YS_FED_IMP_IOT0000007097": "公主嶺市",
        "P_YS_FED_FW_0001256160": "請輸入您的手機號",
        "P_YS_FED_IMP_IOT0000007090": "額爾古納市",
        "P_YS_FED_IMP_IOT0000007092": "靜安區",
        "P_YS_FED_FW_0001256167": "電商平臺不該為“代吵架服務”設攤 \\n",
        "P_YS_FED_FW_0001256168": "民眾成都博物館裏享“餐桌上的文化之旅 \\n",
        "P_YS_FED_FW_0001256165": "點我啦",
        "P_YS_FED_FW_0001256166": "又一80後上市公司實控人被刑拘！ \\n",
        "P_YS_FED_FW_0001256163": "自定義 top",
        "P_YS_PF_GZTTMP_0000079605": "發票",
        "P_YS_FED_FW_0001256164": "回顧20年前A股那場轟轟烈烈的“519行情”",
        "P_YS_FED_FW_0001256161": "五月種菜大全來了，這些蔬菜您種了沒有？ \\n",
        "P_YS_FED_FW_0001256162": "牌子大口碑好銷量還高，12萬左右的自動擋合資轎車 \\n",
        "P_YS_FED_FW_0001256158": "自定義 width",
        "P_YS_FED_FW_0001256159": "巨大按鈕",
        "P_YS_FED_IMP_IOT0000007087": "台兒莊區",
        "P_YS_HR_HRJQ_0000031282": "電郵格式不正確",
        "P_YS_FED_FW_0000021160": "×",
        "P_YS_FED_FW_0000022491": "展開一級",
        "P_YS_FED_FW_0000021161": "折線圖示例",
        "P_YS_FED_FW_0000022492": "候選條件",
        "P_YS_FED_FW_0000022490": "下月",
        "P_YS_FED_FW_0000021164": "亳州市",
        "P_YS_FED_FW_0000022495": "八",
        "P_YS_FED_FW_0000021165": "餅形圖配置信息",
        "P_YS_FED_FW_0000022496": "執行時包含下級",
        "P_YS_FED_FW_0000021162": "秦皇島市",
        "P_YS_FED_FW_0000022493": "九",
        "P_YS_FED_FW_1473069861501927428": "系統列印失敗錯誤資訊:",
        "P_YS_FED_FW_0000021163": "懷化市",
        "P_YS_FED_FW_0000022494": "清空值",
        "P_YS_FED_FW_0001256134": "滑鼠滑過顯示",
        "P_YS_FED_FW_0001256135": "如何解決室內乾燥 一個加濕器是不行的 \\n",
        "P_YS_FED_FW_0001256132": "如何降低購房風險？ \\n",
        "P_YS_FED_FW_0001256133": "投資2000萬美元狂賺7000倍 \\n",
        "P_YS_FED_FW_0001256130": "一季度轎車市場分析 \\n",
        "P_YS_FED_FW_0001256131": "《從0到1》序二——讀書筆記 \\n",
        "P_YS_PF_GZTTMP_0000078208": "往來件數",
        "P_YS_SD_SDMAUF_0000152533": "提交申請",
        "P_YS_FED_FW_0001256129": "哪些城市亮瞎眼，哪些城市很失落 \\n",
        "P_YS_FED_FW_0001256127": "當初沒好好裝衛生間 現在後悔死了 \\n",
        "P_YS_FED_FW_0001256128": "「重磅發佈」2019年歐洲十大海上風電場排行榜！ \\n",
        "P_YS_FED_FW_0001256125": "美男摔落懸崖掉進活火山，躲過攝氏超過1000度 \\n",
        "P_YS_FED_FW_0001256126": "那些還在發朋友圈的朋友們，才是人間珍品 \\n",
        "P_YS_FED_FW_0000021157": "需要顯示為Legend的名字超長，需要截斷，截斷前：",
        "P_YS_FED_FW_0000022488": "本月",
        "P_YS_FED_IMP_IOT0000007195": "平陽縣",
        "P_YS_FED_FW_0000021158": "餅形圖配置信息-yySetting",
        "P_YS_FED_FW_0000022489": "今日",
        "P_YS_FED_IMP_IOT0000007194": "龍城區",
        "P_YS_FED_FW_0000021155": "海南",
        "P_YS_FED_FW_0000022486": "顯示停用",
        "P_YS_FED_FW_0000021156": "upgradeConfig_ForScatter 沒找到對應的待升級地區。yySetting",
        "P_YS_FED_FW_0000022487": "查詢條件",
        "P_YS_FED_IMP_IOT0000007196": "膠南市",
        "P_YS_FED_FW_0000021159": "cFormatData，預製錯誤！",
        "P_YS_FED_FW_0000021171": "隨州市",
        "P_YS_FED_FW_0000021172": "新鄉市",
        "P_YS_FED_FW_0000021170": "清除",
        "P_YS_PF_PRINT_0000057801": "表頭自定義項8",
        "P_YS_FED_FW_0000021175": "塔城地區",
        "P_YS_PF_PRINT_0000057800": "表頭自定義項9",
        "P_YS_FED_FW_0000021176": "銀川市",
        "P_YS_FED_FW_0000021173": "內江市",
        "P_YS_FED_FW_1452079643387494400": "%c未找到對應頁簽",
        "P_YS_FED_FW_0000021174": "六安市",
        "P_YS_FED_FW_0001030895": "←",
        "P_YS_FED_FW_0001256145": "蘇格蘭媒體：凱爾特人沒有向穆裏尼奧開出邀約 \\n",
        "P_YS_FED_FW_0001256146": "去4S店“首保”，這3個細節要注意 \\n",
        "P_YS_FED_FW_0001256143": "一只好萊塢的 巨星豬 是怎麼誕生的 \\n",
        "P_YS_FED_FW_0001256144": "五一消費帳單來了！這個小長假，你的錢花哪了？ \\n",
        "P_YS_FED_FW_0001256141": "青少年手機成癮危害大 各國政府紛紛出招應對 \\n",
        "P_YS_FED_FW_0001256142": "這是一段描述",
        "P_YS_FED_FW_0001256140": "光明日報頭版：讀懂中國經濟的巨大韌性 \\n",
        "P_YS_FED_FW_0001256138": "一等獎得主齊現身 領獎不忘捐款獻愛心 \\n",
        "P_YS_FED_FW_0001256139": "他或是安倍唯一不敢反對的男人！ \\n",
        "P_YS_FED_FW_0001256136": "長春年近六旬男子上演花樣自行車絕技 \\n",
        "P_YS_FED_FW_0001256137": "狀態(disabled)",
        "P_YS_FED_FW_0000021168": "highlight-control-cstyle-預製錯誤！",
        "P_YS_FED_FW_0000022499": "預置方案不能覆蓋",
        "P_YS_FED_FW_0000021169": "信陽市",
        "P_YS_FED_FW_0000021166": "重慶市",
        "P_YS_FED_FW_0000022497": "查詢條件:(",
        "P_YS_FED_IMP_IOT0000007186": "平陰縣",
        "P_YS_FED_FW_0000021167": "安慶市",
        "P_YS_FED_FW_0000022498": "為空",
        "P_YS_FED_IMP_IOT0000007185": "蛟河市",
        "P_YS_FED_IMP_IOT0000007188": "黟縣",
        "P_YS_FED_FW_0000022470": "沒有任何分組信息。",
        "P_YS_FED_FW_0001077518": "實際大小",
        "P_YS_SD_UDHWN_0000046985": "通州區",
        "P_YS_FED_FW_0000021142": "湛江市",
        "P_YS_FED_FW_0000022473": "修改項",
        "P_YS_FED_IMP_IOT0000007180": "和縣",
        "P_YS_FED_FW_0000022474": "不能存在編碼為空的區域。",
        "P_YS_FED_FW_0000021143": "普票",
        "P_YS_FED_FW_0000021140": "商品編碼：",
        "P_YS_FED_FW_0000022471": "table2DRowColChange 1維表當前index =",
        "P_YS_FED_IMP_IOT0000007182": "灤平縣",
        "P_YS_FED_FW_0000021141": "柱形圖示例",
        "P_YS_FED_FW_0000022472": "增行異常。self.addGroupInfo =",
        "P_YS_FED_FW_0001232180": "環境變數hubble_collect_url未配置，哈勃收集失敗！",
        "P_YS_FED_FW_0000021135": "商品名稱：",
        "P_YS_FED_FW_0000022466": "預設",
        "P_YS_FED_IMP_IOT0000007173": "薩爾圖區",
        "P_YS_FED_FW_0000021136": "科技藍色",
        "P_YS_FED_FW_0000022467": "5、點擊【校驗】按鈕，系統按SQL-where子句的語法來校驗“過濾運算式”的語法正確性，如存在語法錯誤校驗不通過。",
        "P_YS_FED_FW_0000021133": "上海",
        "P_YS_FED_FW_0000022464": "有輔維度支持單選，無輔維度支持多選，最多選擇",
        "P_YS_FED_IMP_IOT0000007175": "方城縣",
        "P_YS_FED_FW_0000021134": "折線圖配置信息",
        "P_YS_FED_FW_0000022465": "名稱不可為空且長度小於16個字。",
        "P_YS_FED_IMP_IOT0000007174": "金川區",
        "P_YS_FED_FW_0000021139": "東營市",
        "P_YS_FED_IMP_IOT0000007177": "洪澤縣",
        "P_YS_FED_IMP_IOT0000007176": "雙灤區",
        "P_YS_FED_FW_0000021137": "德州市",
        "P_YS_FED_FW_0000022468": "至少保留一行。",
        "P_YS_FED_IMP_IOT0000007179": "信宜市",
        "P_YS_FED_FW_0000021138": "博爾塔拉蒙古自治州",
        "P_YS_FED_FW_0000022469": "改名失敗!",
        "P_YS_FED_IMP_IOT0000007178": "萬安縣",
        "P_YS_FED_FW_0000022480": "模版名稱",
        "P_YS_FED_FW_0000021150": "當前regionInfo",
        "P_YS_FED_FW_0000022481": "七",
        "P_YS_FED_FW_0000021153": "榆林市",
        "P_YS_FED_FW_0000022484": "程序錯誤",
        "P_YS_FED_FW_0000021154": "河北",
        "P_YS_FED_FW_0000022485": "包含下級",
        "P_YS_FED_FW_0000021151": "氣泡值前N個",
        "P_YS_FED_FW_0000022482": "級次展開",
        "P_YS_FED_FW_0000021152": "鷹潭市",
        "P_YS_FED_FW_0000022483": "：",
        "P_YS_FED_IMP_IOT0000007170": "高平市",
        "P_YS_FED_FW_0001256123": "人民鐵道“中央廚房”今日上線 \\n",
        "P_YS_FED_FW_0001256124": "查找關鍵字,請輸入1",
        "P_YS_FED_FW_0001256121": "新風系統有沒有用 到底要不要裝呢",
        "P_YS_FED_FW_0001256122": "國內要聞",
        "P_YS_FED_FW_0001256120": "單據狀態異常，請重新提交。",
        "P_YS_FED_FW_0001256118": "記住這個落井之人 \\n",
        "P_YS_FED_FW_0001256119": "北京專案近況一覽 \\n",
        "P_YS_FED_FW_0001256116": "讓數字經濟更好助力高質量發展 \\n",
        "P_YS_FED_FW_0001256117": "條/頁",
        "P_YS_FED_FW_0001256115": "要想渦輪壞得快，這四個錯誤天天犯！ \\n",
        "P_YS_FED_FW_0000021146": "陽江市",
        "P_YS_FED_FW_0000022477": "表頭＋明細",
        "P_YS_FED_IMP_IOT0000007162": "金州區",
        "P_YS_FED_IMP_IOT0000008494": "浦江縣",
        "P_YS_FED_FW_0000021147": "數據格式錯誤！",
        "P_YS_FED_FW_0000022478": "新增維度導航方案",
        "P_YS_FED_IMP_IOT0000007161": "灌陽縣",
        "P_YS_FED_FW_0000021144": "條數據讀取失敗!",
        "P_YS_FED_FW_0000022475": "所屬行業",
        "P_YS_FED_FW_0000021145": "氣泡圖配置信息-yySetting",
        "P_YS_FED_FW_0000022476": "調用add失敗:",
        "P_YS_FED_IMP_IOT0000007163": "內黃縣",
        "P_YS_FED_IMP_IOT0000008493": "虞城縣",
        "P_YS_FED_IMP_IOT0000007165": "秭歸縣",
        "P_YS_FED_FW_0000021148": "延邊朝鮮族自治州",
        "P_YS_FED_FW_0000022479": "編輯界面",
        "P_YS_FED_FW_0000021149": "河源市",
        "P_YS_FED_IMP_IOT0000007167": "密山市",
        "P_YS_FED_IMP_IOT0000008490": "綦江縣",
        "P_YS_FED_EXAMP_0000020283": "商品行有數量為0的數據，不可進行結算",
        "P_YS_FED_FW_0001470928": "網址不能為空",
        "P_YS_FED_EXAMP_0000020282": "請選擇商品！",
        "P_YS_FED_EXAMP_0000020285": "退品數量不能為負！",
        "P_YS_FED_EXAMP_0000020284": "客商管理",
        "P_YS_FED_FW_0001470929": "纯文字档案不能為空",
        "P_YS_FED_EXAMP_0000020281": ")詳情",
        "P_YS_FED_EXAMP_0000020280": "不能改零售價",
        "P_YS_FED_IMP_IOT0000007159": "臨泉縣",
        "P_YS_FED_EXAMP_0000020279": "選擇序列號",
        "P_YS_FED_EXAMP_0000020276": "預訂",
        "P_YS_FED_EXAMP_0000020275": "管理分類",
        "P_YS_FED_EXAMP_0000020278": "請先錄入倉庫",
        "P_YS_FED_FW_0001470926": "{\"linkText\":\"百度\",\"linkAddress\":\"http://baudi.com\"}",
        "P_YS_FED_EXAMP_0000020277": "記錄行中無記錄需要修改!",
        "P_YS_FED_IMP_IOT0000007150": "柯坪縣",
        "P_YS_FED_FW_0000021199": "廊坊市",
        "P_YS_FED_IMP_IOT0000007152": "東鄉族自治縣",
        "P_YS_FED_IMP_IOT0000007155": "九寨溝縣",
        "P_YS_FED_IMP_IOT0000008487": "掇刀區",
        "P_YS_PF_PROCENTER_0000023464": "啟用",
        "P_YS_FED_IMP_IOT0000007156": "澄江縣",
        "P_YS_FED_IMP_IOT0000008486": "中寧縣",
        "P_YS_FED_IMP_IOT0000008480": "沙市區",
        "P_YS_FED_EXAMP_0000020294": "成交筆數",
        "P_YS_FED_EXAMP_0000020293": "最多選擇5個規格",
        "P_YS_FED_EXAMP_0000020296": "系統版本低，暫時不支持切換!",
        "P_YS_FED_EXAMP_0000020295": "只能選擇一個套餐商品！",
        "P_YS_FED_EXAMP_0000020290": "退訂",
        "P_YS_FED_EXAMP_0000020292": "當前為退貨充值狀態，不允許添加充值行。",
        "P_YS_FED_EXAMP_0000020291": "已經執行過促銷,不允許錄入會員！",
        "P_YS_FED_IMP_IOT0000008478": "請輸入此欄位",
        "P_YS_FED_IMP_IOT0000007149": "小河區",
        "P_YS_FED_EXAMP_0000020286": "編碼",
        "P_YS_FED_EXAMP_0000020289": "條數據bootSave保存時報錯！",
        "P_YS_FED_EXAMP_0000020288": "未取得班次!",
        "P_YS_FED_IMP_IOT0000007140": "鞏留縣",
        "P_YS_FED_IMP_IOT0000008472": "館陶縣",
        "P_YS_FED_IMP_IOT0000008473": "平鄉縣",
        "P_YS_OA_XTSPZX_0000034846": "展開",
        "P_YS_FED_IMP_IOT0000007144": "桐梓縣",
        "P_YS_FED_IMP_IOT0000007146": "寶安區",
        "P_YS_FED_IMP_IOT0000008474": "金門縣",
        "P_YS_FED_FW_0000021182": "江西",
        "P_YS_FED_FW_0000021183": "cStyle預製錯誤！",
        "P_YS_FED_FW_0000021180": "自定義模板",
        "P_YS_FED_FW_0000021181": "河南",
        "P_YS_SD_SDMB_0000149613": "運輸中",
        "P_YS_FED_FW_0000021186": "返回錯誤信息",
        "P_YS_FED_FW_0001204909": "匯出已完成, 文件名為【",
        "P_YS_FED_FW_0000021187": "湖州市",
        "P_YS_FED_FW_0000021184": "北京朝陽第二門店",
        "P_YS_FED_FW_0000021185": "寧德市",
        "P_YS_FED_IMP_IOT0000007137": "梁山縣",
        "P_YS_FED_IMP_IOT0000008469": "大安市",
        "P_YS_FED_IMP_IOT0000009798": "三門縣",
        "P_YS_FED_IMP_IOT0000007138": "商城縣",
        "P_YS_FED_IMP_IOT0000008468": "吉安縣",
        "P_YS_FED_EXAMP_0000020298": "增品中含有實體卡券商品,卡券號不能為空",
        "P_YS_FED_EXAMP_0000020297": "當前單據狀態下不允許執行退品!",
        "P_YS_FED_EXAMP_0000020299": "按日配送",
        "P_YS_FED_FW_0000021179": "中國100000",
        "P_YS_FED_IMP_IOT0000009792": "伽師縣",
        "P_YS_OA_XTSPZX_0000034833": "時間",
        "P_YS_FED_IMP_IOT0000008462": "東寧縣",
        "P_YS_FED_IMP_IOT0000009793": "曲沃縣",
        "P_YS_FED_FW_0000021177": "百色市",
        "P_YS_OA_XTSPZX_0000034835": "啟用",
        "P_YS_FED_FW_0000021178": "酒泉市",
        "P_YS_FED_IMP_IOT0000007130": "耒陽市",
        "P_YS_FED_IMP_IOT0000008460": "那坡縣",
        "P_YS_FED_IMP_IOT0000007133": "隴川縣",
        "P_YS_FED_IMP_IOT0000009795": "延川縣",
        "P_YS_FED_FW_0000021193": "阿勒泰地區",
        "P_YS_OA_XTSPZX_0000034819": "確認",
        "P_YS_FED_FW_0000021194": "湘潭市",
        "P_YS_FED_FW_0000021191": "瀋陽市",
        "P_YS_FED_FW_0000021192": "武漢市",
        "P_YS_FED_FW_0000021197": "氣泡圖配置信息",
        "P_YS_FED_FW_0000021198": "輔維度空值數據",
        "P_YS_FED_FW_0000021195": "莆田市",
        "P_YS_FED_FW_0000021196": "洛陽市",
        "P_YS_FED_FW_0000021190": "排名表配置信息",
        "P_YS_FED_FW_0001204910": "】, 請您參閱查看。",
        "P_YS_FED_IMP_IOT0000007125": "敦化市",
        "P_YS_FED_IMP_IOT0000008459": "新青區",
        "P_YS_FED_IMP_IOT0000007128": "宜都市",
        "P_YS_FED_IMP_IOT0000009787": "永登縣",
        "P_YS_FED_IMP_IOT0000007127": "會理縣",
        "P_YS_FED_IMP_IOT0000008457": "馬邊彝族自治縣",
        "P_YS_FED_IMP_IOT0000009788": "閻良區",
        "P_YS_FED_IMP_IOT0000007129": "左權縣",
        "P_YS_FED_IMP_IOT0000008450": "岳普湖縣",
        "P_YS_FED_IMP_IOT0000009781": "六合區",
        "P_YS_FED_FW_0000021188": "天津",
        "P_YS_FED_FW_0001154160": "個人方案無法修改為公共方案，將另存為公共方案，是否繼續？",
        "P_YS_FED_FW_0000021189": "湖北省直轄縣市",
        "P_YS_FED_IMP_IOT0000007122": "南宮市",
        "P_YS_FED_IMP_IOT0000009785": "蘇仙區",
        "P_YS_FED_IMP_IOT0000007121": "曲松縣",
        "P_YS_FED_IMP_IOT0000009786": "鋼城區",
        "P_YS_FED_IMP_IOT0000009783": "盧龍縣",
        "P_YS_FED_IMP_IOT0000007123": "白下區",
        "P_YS_FED_IMP_IOT0000009784": "西平縣",
        "P_YS_PF_PRINT_0000057874": "整單數量",
        "P_YS_FED_EXAMP_0000020241": "請先選擇出庫倉庫！",
        "P_YS_PF_GZTSYS_0000012021": "SKU屬性",
        "P_YS_FED_EXAMP_0000020240": "正在開發中，敬請期待",
        "P_YS_HR_HRRCPDF_0001127373": "查看進度",
        "P_YS_FED_FW_0000022408": "排名列",
        "P_YS_FED_EXAMP_0000020236": "複製鏈接",
        "P_YS_FED_FW_0000022409": "平均",
        "P_YS_FED_EXAMP_0000020235": "本次調整金額不能大於0！",
        "P_YS_FED_IMP_IOT0000008448": "萊西市",
        "P_YS_FED_IMP_IOT0000009779": "手機號格式不正確",
        "P_YS_FED_FW_0000022406": "元數據配置有誤",
        "P_YS_FED_EXAMP_0000020238": "未啟用卡券銷售業務,不允許選擇卡券業務類型",
        "P_YS_FED_IMP_IOT0000007117": "扶綏縣",
        "P_YS_FED_FW_0000022407": "確定停用此模版嗎？",
        "P_YS_PF_GZTACT_0000015996": "人員",
        "P_YS_FED_EXAMP_0000020237": "商品分類顯示數據錯誤！",
        "P_YS_FED_IMP_IOT0000007116": "相城區",
        "P_YS_FED_IMP_IOT0000009777": "中站區",
        "P_YS_FED_EXAMP_0000020232": "商品品牌",
        "P_YS_FED_EXAMP_0000020231": "會員錢包充值狀態不允許執行",
        "P_YS_FED_IMP_IOT0000007118": "南澗彞族自治縣",
        "P_YS_FED_EXAMP_0000020234": "僅掛單",
        "P_YS_FED_IMP_IOT0000008449": "臨翔區",
        "P_YS_FED_EXAMP_0000020233": "第",
        "P_YS_FED_FW_0000022400": "倉儲中心",
        "P_YS_FED_FW_0000022401": "接收人",
        "P_YS_FED_FW_0000022404": "關閉其他",
        "P_YS_FED_IMP_IOT0000007111": "坊子區",
        "P_YS_FED_IMP_IOT0000008443": "東坡區",
        "P_YS_FED_FW_0000022405": "配置信息中欄位驗證失敗。包含欄目中不存在的欄位 轉換前",
        "P_YS_FED_EXAMP_0000020239": "更改交貨倉庫將同步更新已添加商品，是否確認更新？",
        "P_YS_FED_FW_0000022402": "方案名稱:",
        "P_YS_FED_FW_0000022403": "間隔",
        "P_YS_FED_IMP_IOT0000008442": "雙流縣",
        "P_YS_FED_IMP_IOT0000009773": "高淳縣",
        "P_YS_FED_EXAMP_0000020250": "貨品檔案",
        "P_YS_FED_EXAMP_0000020252": "抹零",
        "P_YS_PF_PRINT_0000057882": "出生日期",
        "P_YS_FED_EXAMP_0000020251": "選擇門店",
        "P_YS_FED_FW_1525642288515514373": "查詢後面板自動收起",
        "P_YS_FED_FW_0000022419": "（最大1M，支持格式：jpg、bmp、png、jpeg，700*700 以上的圖片可以在商品詳情頁主圖提供圖片放大功能）",
        "P_YS_FED_EXAMP_0000020247": "確定整單清除嗎?",
        "P_YS_FED_IMP_IOT0000008436": "懷遠縣",
        "P_YS_FED_IMP_IOT0000009767": "南縣",
        "P_YS_FED_EXAMP_0000020246": "已執行過促銷優惠活動,不允許修改卡券號",
        "P_YS_FED_IMP_IOT0000007103": "鹽津縣",
        "P_YS_FED_IMP_IOT0000009768": "中原區",
        "P_YS_FED_FW_0000022417": "位",
        "P_YS_FED_EXAMP_0000020249": "登錄124",
        "P_YS_FED_IMP_IOT0000007106": "寶清縣",
        "P_YS_FED_IMP_IOT0000008434": "海原縣",
        "P_YS_FED_FW_0000022418": "發布報表方案saveMenu 參數 name =",
        "P_YS_FED_EXAMP_0000020248": "POS機未指定攝像頭ID/IP，請配置！",
        "P_YS_FED_IMP_IOT0000007105": "芝罘區",
        "P_YS_FED_EXAMP_0000020243": "電商/電商退貨狀態下，表體行倉庫必須一致！",
        "P_YS_FED_IMP_IOT0000007108": "夏河縣",
        "P_YS_FED_EXAMP_0000020242": "%, 確認結算？",
        "P_YS_PF_GZTSYS_0000012026": "相冊",
        "P_YS_FED_EXAMP_0000020245": "表單模版設計",
        "P_YS_FED_IMP_IOT0000009769": "無錫",
        "P_YS_FED_EXAMP_0000020244": "當前時段不允許跨日！請重新選擇時間！",
        "P_YS_FED_IMP_IOT0000007109": "金牛區",
        "P_YS_FED_IMP_IOT0000008439": "遊仙區",
        "P_YS_FED_FW_0000022411": "獲取數據失敗！",
        "P_YS_FED_FW_0000022412": "公司傳真",
        "P_YS_FED_FW_0000022410": "請輸入詳細地址",
        "P_YS_FED_FW_0000022415": "是否啟用",
        "P_YS_FED_IMP_IOT0000007100": "渭源縣",
        "P_YS_FED_FW_0000022413": "過濾名稱",
        "P_YS_FED_IMP_IOT0000007102": "肇東市",
        "P_YS_FED_IMP_IOT0000008430": "青秀區",
        "P_YS_FED_FW_0000022414": "訂閱頻率",
        "P_YS_FED_IMP_IOT0000009762": "桓仁滿族自治縣",
        "P_YS_HR_HRXCF_0000056174": "近一年",
        "P_YS_FED_FW_0001138953": "數據錯誤，未找到對應的方案",
        "P_YS_SCM_USTOCK_0001131722": "新增",
        "P_YS_FED_EXAMP_0000020261": "開始卡券號和結束卡券號後綴不同",
        "P_YS_FED_EXAMP_0000020260": "此",
        "P_YS_FED_EXAMP_0000020263": "贈品",
        "P_YS_FED_EXAMP_0000020262": "當前行不允許改行！",
        "P_YS_FED_EXAMP_0000020258": "實體卡券商品銷售,卡券數量應為1",
        "P_YS_FED_EXAMP_0000020257": "本單金額為0，是否繼續？",
        "P_YS_FED_IMP_IOT0000008426": "福泉市",
        "P_YS_FED_IMP_IOT0000009757": "土默特左旗",
        "P_YS_PF_GZTSYS_0000013325": "標籤",
        "P_YS_FED_IMP_IOT0000009754": "濠江區",
        "P_YS_FED_EXAMP_0000020259": "調整狀態不允許修改營業員！",
        "P_YS_FED_IMP_IOT0000009755": "龍陵縣",
        "P_YS_FED_EXAMP_0000020254": "原單退貨中，換貨行不允許修改營業員！",
        "P_YS_FED_IMP_IOT0000008429": "武城縣",
        "P_YS_PF_GZTSYS_0000015985": "查詢方案",
        "P_YS_FED_EXAMP_0000020253": "請先錄入會員！",
        "P_YS_FED_EXAMP_0000020256": "店存出庫",
        "P_YS_FED_EXAMP_0000020255": "用戶及角色",
        "P_YS_SCM_USTOCK_0001131725": "保存",
        "P_YS_FED_IMP_IOT0000009752": "中江縣",
        "P_YS_FED_FW_0001322216": "當前選中節點包含下級，確定刪除麼？",
        "P_YS_FED_IMP_IOT0000009753": "融水苗族自治縣",
        "P_YS_FED_IMP_IOT0000009750": "陽高縣",
        "P_YS_FED_IMP_IOT0000008420": "橫峰縣",
        "P_YS_FED_IMP_IOT0000009751": "臨澧縣",
        "P_YS_FED_EXAMP_0000020272": "預定",
        "P_YS_FED_EXAMP_0000020271": "6-20位數字或字母 不允許有空格",
        "P_YS_FED_EXAMP_0000020274": "退品數據處理失敗！",
        "P_YS_FED_EXAMP_0000020273": "已經存在該序列號商品！",
        "P_YS_FED_EXAMP_0000020270": "獲取是否彈出廚打提示信息失敗！",
        "P_YS_FED_EXAMP_0000020269": "固定套餐的商品需要全選",
        "P_YS_FED_IMP_IOT0000009745": "敖漢旗",
        "P_YS_FED_EXAMP_0000020268": "實退金額必須小於等於零。",
        "P_YS_FED_IMP_IOT0000008415": "夏津縣",
        "P_YS_FED_IMP_IOT0000008413": "安遠縣",
        "P_YS_FED_FW_1602282827388813325": "不顯示列的值",
        "P_YS_FED_EXAMP_0000020265": "應收金額不能小於卡券結算金額，請檢查！",
        "P_YS_FI_FP_0001126682": "服務異常",
        "P_YS_FED_EXAMP_0000020264": "該狀態下不能使用快捷結算！",
        "P_YS_FED_EXAMP_0000020267": "優惠券功能",
        "P_YS_FED_FW_1602282827388813328": "計算該數值列的平均值",
        "P_YS_FED_EXAMP_0000020266": "”未能在營業員列表中找著",
        "P_YS_FED_IMP_IOT0000008417": "伊寧縣",
        "P_YS_FED_IMP_IOT0000008410": "安居區",
        "P_YS_FED_FW_1602282827388813322": "計算該數值列所有數據的和",
        "P_YS_FED_IMP_IOT0000009742": "南和縣",
        "P_YS_FED_IMP_IOT0000009740": "天橋區",
        "P_YS_FED_FW_0000021120": "晉中市",
        "P_YS_FED_FW_0000022451": "最多選擇",
        "P_YS_FED_FW_0000021121": "數量/金額/單價，預製錯誤！",
        "P_YS_FED_FW_0000022452": "意大利語",
        "P_YS_FED_FW_0000022450": "左側Y軸",
        "P_YS_PF_GZTSYS_0000013395": "銷售區域",
        "P_YS_PF_GZTSYS_0000013390": "日結",
        "P_YS_FED_FW_1602282827388813316": "顯示該列所有值，並用逗號分隔",
        "P_YS_FED_FW_0000021119": "德宏傣族景頗族自治州",
        "P_YS_FED_IMP_IOT0000008401": "上饒縣",
        "P_YS_FED_FW_1602282827388813313": "顯示該列中的最小值",
        "P_YS_FED_IMP_IOT0000008407": "北安市",
        "P_YS_FED_FW_1602282827388813319": "顯示該列中的最大值",
        "P_YS_FED_IMP_IOT0000008408": "餘姚市",
        "P_YS_FED_IMP_IOT0000008405": "木壘哈薩克自治縣",
        "P_YS_FED_IMP_IOT0000009737": "單縣",
        "P_YS_FED_FW_0000021113": "遼陽市",
        "P_YS_FED_FW_0000022444": "至少保留一行數據。",
        "P_YS_FED_FW_0001376079": "不正確,請輸入後重試",
        "P_YS_FED_FW_0000021114": "阿壩藏族羌族自治州",
        "P_YS_FED_FW_0000022445": "關閉全部",
        "P_YS_FED_FW_1435192751107342336": "已達最小值,不可減小",
        "P_YS_FED_FW_0000021111": "焦作市",
        "P_YS_FED_FW_0000022442": "顯示條形",
        "P_YS_FED_FW_0000021112": "緩存數據失敗！",
        "P_YS_FED_FW_0000022443": "獲取過濾條件錯誤。",
        "P_YS_FED_FW_0000021117": "台灣",
        "P_YS_FED_FW_0000022448": "最多選擇16項菜單！",
        "P_YS_FED_FW_1435192751107342339": "已達最大值,不可增加",
        "P_YS_FED_FW_0000021118": "移動報表 MobileReport Render sumFieldsCount",
        "P_YS_FED_FW_0000022449": "報表分組方案配置信息",
        "P_YS_FED_IMP_IOT0000009731": "長壽區",
        "P_YS_FED_FW_0000021115": "煙台市",
        "P_YS_FED_FW_0000022446": "刷新頻率設置不正確",
        "P_YS_FED_FW_0000021116": "賀州市",
        "P_YS_FED_FW_0000022447": "草稿名稱",
        "P_YS_FED_FW_0000021131": "營口市",
        "P_YS_FED_FW_0000022462": "更新失敗！返回信息：",
        "P_YS_FED_FW_0000021132": "吉林",
        "P_YS_FED_FW_0000022463": "監控視圖的圖形報表 getConfig",
        "P_YS_FED_FW_0000022460": "關鍵欄位不允許移動！",
        "P_YS_FED_FW_0000022461": "欄目名稱/公式為必輸項！請填寫完整後重試！",
        "P_YS_FED_FW_0000021130": "在線",
        "P_YS_FED_IMP_IOT0000009729": "留壩縣",
        "P_YS_FED_EXAMP_0000020203": "退回門店為否時,退貨倉庫不能為空！",
        "P_YS_FED_EXAMP_0000020202": "商品行金額不能為0！",
        "P_YS_FED_EXAMP_0000020205": "商品檔案中沒有匹配到識別到的商品!",
        "P_YS_FED_EXAMP_0000020204": "行商品未輸入儲值卡號",
        "P_YS_FED_IMP_IOT0000009727": "沾益縣",
        "P_YS_FED_EXAMP_0000020201": "角色",
        "P_YS_FED_IMP_IOT0000009725": "孟村回族自治縣",
        "P_YS_FED_EXAMP_0000020200": "未填寫房間信息，是否繼續結算？",
        "P_YS_FED_FW_0000021124": "合計",
        "P_YS_FED_FW_0000022455": "目前只支持 JPG/PNG file!",
        "P_YS_FED_FW_0000021125": "暫時沒有數據哦~",
        "P_YS_FED_FW_0000022456": "設計",
        "P_YS_FED_FW_0000021122": "澳門特別行政區",
        "P_YS_FED_FW_0000022453": "獲取常用功能列表失敗！",
        "P_YS_FED_FW_0000022454": "匹配一維表的行時，有多個匹配行，請檢查。 rowItemMatchInfo =",
        "P_YS_FED_FW_0000021123": "體驗帳號",
        "P_YS_FED_FW_0000021128": "烏蘭察布市",
        "P_YS_FED_FW_0000022459": "辦事處",
        "P_YS_FED_EXAMP_0000020207": "通過",
        "P_YS_FED_FW_0000021129": "澳門",
        "P_YS_FED_FW_0000021126": "鶴壁市",
        "P_YS_FED_FW_0000022457": "保存為常用方案",
        "P_YS_FED_EXAMP_0000020209": "統計指定日期範圍內的銷量",
        "P_YS_FED_FW_0000021127": "桂林市",
        "P_YS_FED_EXAMP_0000020208": "圖片",
        "P_YS_FED_FW_0000022458": "複製模板",
        "P_YS_FED_FW_0000022430": "日期分隔符",
        "P_YS_FED_IMP_IOT0000009719": "長白朝鮮族自治縣",
        "P_YS_FED_EXAMP_0000020214": "請修改固定套餐的子行退貨信息。",
        "P_YS_FED_IMP_IOT0000009712": "溫縣",
        "P_YS_FED_EXAMP_0000020213": "卡券業務型別下才能選擇卡券商品！",
        "P_YS_FED_FW_0000022428": "請設置filterId",
        "P_YS_FED_EXAMP_0000020216": "商品行必須進行金額調整！",
        "P_YS_FED_IMP_IOT0000009710": "肥城市",
        "P_YS_FED_FW_0000022429": "獲取敏感數據列表失敗！",
        "P_YS_FED_EXAMP_0000020215": "是否取消自動促銷？",
        "P_YS_FED_EXAMP_0000020210": "交貨",
        "P_YS_FED_EXAMP_0000020212": "已經執行促銷活動，不能改零售價！",
        "P_YS_FED_IMP_IOT0000009714": "安義縣",
        "P_YS_FED_EXAMP_0000020211": "表體行倉庫不能為空！",
        "P_YS_FED_IMP_IOT0000009715": "修文縣",
        "P_YS_FED_FW_0000022422": "*模板名稱:",
        "P_YS_HR_HRJQF_0000054440": "顯示未啟用",
        "P_YS_FED_FW_0000022423": "請輸入模板編碼",
        "P_YS_FED_FW_0000022420": "添加日期時間",
        "P_YS_FED_FW_0000022421": "存在編碼重複的區域：",
        "P_YS_FED_FW_0000022426": "熱區顯示圖 不進行刷新。",
        "P_YS_FED_EXAMP_0000020218": "固定套餐不允許改零售價",
        "P_YS_FED_FW_0000022427": "檔案值，名稱欄位不能為空！",
        "P_YS_FED_EXAMP_0000020217": "按鈕的功能權限，不能操作",
        "P_YS_FED_FW_0000022424": "添加規格值",
        "P_YS_FED_FW_0000022425": "條形圖",
        "P_YS_FED_EXAMP_0000020219": "較前期",
        "P_YS_HR_HRJQF_0000054435": "員工姓名",
        "P_YS_FED_FW_0000022440": "背景風格",
        "P_YS_FED_FW_1435759635250806784": "環境變數process.env[domain.gpaas.url]和process.env[public.domain.gpaas.url]未配置，哈勃收集失敗！",
        "P_YS_FED_FW_0000021110": "宜春市",
        "P_YS_FED_FW_0000022441": "暫無搜索結果～",
        "P_YS_HR_HRJQF_0000054439": "工齡",
        "P_YS_FED_IMP_IOT0000009709": "同德縣",
        "P_YS_FED_FW_0001287429": "鎖定顯示",
        "P_YS_FED_EXAMP_0000020230": "已經執行了",
        "P_YS_PF_GZTSYS_0000013382": "表單模板",
        "P_YS_FED_FW_1628198325042282505": "證件內容為空",
        "P_YS_FED_FW_1564270202179813377": "合法值：",
        "P_YS_FED_EXAMP_0000020225": "王府井店",
        "P_YS_FED_IMP_IOT0000009701": "潁泉區",
        "P_YS_HR_HRJXF_0000059839": "反饋",
        "P_YS_FED_EXAMP_0000020224": "交貨不能修改商品時，不能新增商品！",
        "P_YS_FED_FW_0000021108": "青海",
        "P_YS_FED_FW_0000022439": "展示",
        "P_YS_FED_EXAMP_0000020227": "退回門店為否且退貨倉庫為空時，不允許結算",
        "P_YS_FED_FW_0000021109": "兩列",
        "P_YS_FED_EXAMP_0000020226": ")啟用了序列號管理，請輸入序列號！",
        "P_YS_FED_IMP_IOT0000009700": "禹州市",
        "P_YS_FED_EXAMP_0000020221": "已經執行了促銷活動，不允許執行優惠券！",
        "P_YS_FED_EXAMP_0000020220": "]不存在,或序列號為已出庫狀態！",
        "P_YS_FED_IMP_IOT0000009706": "榆中縣",
        "P_YS_FED_EXAMP_0000020223": "電話：",
        "P_YS_FED_IMP_IOT0000009703": "神木縣",
        "P_YS_FED_EXAMP_0000020222": "卡券業務型別下只允許錄入卡券商品！",
        "P_YS_FED_IMP_IOT0000009704": "迭部縣",
        "P_YS_FED_FW_0000021102": "忻州市",
        "P_YS_FED_FW_0000022433": "無控件",
        "P_YS_FED_FW_0000021103": "威海市",
        "P_YS_FED_FW_0000022434": "數值字體大小",
        "P_YS_FED_FW_0001604215": "請選擇行在進行下移操作！",
        "P_YS_FED_FW_0000021100": "表",
        "P_YS_FED_FW_0000022431": "當前只允許上傳一個附件，請刪除後重新上傳！",
        "P_YS_FED_FW_0000021101": "蘭州市",
        "P_YS_FED_FW_0000022432": "請輸入公司傳真",
        "P_YS_FED_FW_0000021106": "朔州市",
        "P_YS_FED_FW_0000022437": "模板編碼/模板名稱不支持全角！",
        "P_YS_FED_EXAMP_0000020229": "會員錢包充值功能",
        "P_YS_FED_FW_0000021107": "長沙市",
        "P_YS_FED_FW_0000022438": "加載圖片錯誤。圖片地址：",
        "P_YS_FED_EXAMP_0000020228": "本次調整金額不能為0！",
        "P_YS_FED_FW_0000021104": "移動報表 getSolutionList Err",
        "P_YS_FED_FW_0000022435": "輸入不合法，請檢查",
        "P_YS_FED_FW_0001287430": "清空篩選",
        "P_YS_FED_FW_0001604216": "請選擇行在進行上移操作！",
        "P_YS_FED_FW_0000021105": "東莞市",
        "P_YS_FED_FW_0000022436": "請設置報表",
        "P_YS_SD_UDHWN_0000049316": "濟源市",
        "P_YS_SD_UDHWN_0000050306": "平谷區",
        "P_YS_PF_METADATA_0000084512": "事件類型",
        "P_YS_FI_FIEIA-FE_1519816251266301957": "子表第",
        "P_YS_PF_METADATA_0000085849": "商標",
        "P_YS_SD_UDHWN_0000050316": "大興區",
        "P_YS_FED_FW_1535350529502740485": "暫無可用列印模板圖片",
        "P_YS_FED_FW_1582845738146070530": "點擊開始掃碼",
        "P_YS_PF_METADATA_0000085850": "網站",
        "P_YS_FED_FW_1535350529502740488": "無可用列印模板圖片",
        "P_YS_PF_GZTSYS_0000015817": "看板",
        "P_YS_FED_FW_0001045104": "restoreEditPanel 需要從items中獲取過濾資訊賦到pageLayout上，但items為空，可能資訊丟失  pageLayout =",
        "P_YS_SD_URETAIL_0001049031": "數據更新錯誤原因失敗：",
        "P_YS_FED_FW_0001563307": "&region=北京&output=json&ak=",
        "P_YS_SD_UDHWN_0000050326": "樂東黎族自治縣",
        "P_YS_FED_UCFORG_0000031966": "上一步",
        "P_YS_FED_UIMG_0000111351": "表達式不能為空",
        "P_YS_FED_FW_1593218496493781008": "文獻共同検索の結果",
        "P_YS_FED_IMP_IOT0000010600": "丹陽市",
        "P_YS_FED_IMP_IOT0000010606": "興隆台區",
        "P_YS_FED_IMP_IOT0000010607": "興化市",
        "P_YS_FED_FW_0000137710": "to ：",
        "P_YS_FED_IMP_IOT0000010613": "松江區",
        "P_YS_FED_IMP_IOT0000010614": "荔灣區",
        "P_YS_PF_SOCD_0000089309": "烏克蘭",
        "P_YS_PF_SOCD_0000089307": "南斯拉夫",
        "P_YS_FED_IMP_IOT0000010611": "鐵東區",
        "P_YS_FED_FW_0000137708": "當前批量修改的欄位ele：",
        "P_YS_PF_SOCD_0000089308": "西班牙",
        "P_YS_FED_FW_0000137707": "在欄目中未能找到全部的列表區配置字段 codeField stateField captionFields",
        "P_YS_PF_SOCD_0000089305": "塞拉利昂",
        "P_YS_FED_FW_0000137706": "批改錯誤：this.gridModel.getColumns()為空!",
        "P_YS_PF_SOCD_0000089306": "阿塞拜疆",
        "P_YS_FED_FW_0000137705": "batchModify 尚不支持當前操作符。filter =",
        "P_YS_FED_FW_0000137704": "未設置刷新時間或者設置的刷新時間太短。",
        "P_YS_PF_SOCD_0000089304": "哈薩克斯坦",
        "P_YS_FED_FW_0000137703": "batchModify setUETypeAndDataType Err.批改沒有獲取正確的字段型別 --》cControlType =",
        "P_YS_FED_IMP_IOT0000010617": "路北區",
        "P_YS_FED_FW_0000137702": "獲取列定義失敗。信息 :",
        "P_YS_FED_FW_0000137701": "獲取分組權限信息失敗。信息 :",
        "P_YS_FED_FW_0000137700": "::::[StatusBar] ,info: cus/getCusDigest 未請求到數據",
        "P_YS_FED_FW_0000137721": "communication ---參數轉換-->錯誤",
        "P_YS_FED_FW_0000137720": "條件返回false，如有疑問參考文檔https://www.yuque.com/gpgy5k/ucf/nzso9u",
        "P_YS_FED_IMP_IOT0000010626": "西豐縣",
        "P_YS_FED_IMP_IOT0000010620": "西陵區",
        "P_YS_FED_IMP_IOT0000010621": "甘孜縣",
        "P_YS_FED_IMP_IOT0000010623": "大悟縣",
        "P_YS_FED_FW_0000137718": "dbName---錯誤",
        "P_YS_FED_FW_0000137717": "匹配不到數據",
        "P_YS_FED_FW_0000137716": "extendField數據配置錯誤",
        "P_YS_SD_UDHWN_0001008443": "↑",
        "P_YS_FED_FW_0000137714": "批改錯誤：初始化 batchModify 沒有找到GridModel!",
        "P_YS_FED_IMP_IOT0000010628": "建華區",
        "P_YS_SD_UDHWN_0001008444": "↓",
        "P_YS_FED_FW_0000137713": "你的瀏覽器不支持IndexedDB",
        "P_YS_FED_IMP_IOT0000010629": "閩清縣",
        "P_YS_FED_FW_0000137712": "保存分組條件失敗。信息 :",
        "P_YS_FED_FW_0000137711": "當前錄入的過濾的欄位信息 filterObjs：",
        "P_YS_PF_GZTSYS_0000015859": "資料源",
        "P_YS_FED_FW_0000137730": "---------確定 按鈕-----------",
        "P_YS_SD_URETAIL_0001049078": "監聽中日誌...",
        "P_YS_FED_IMP_IOT0000010630": "福鼎市",
        "P_YS_FED_IMP_IOT0000010632": "雷州市",
        "P_YS_FED_IMP_IOT0000010633": "槐蔭區",
        "P_YS_FED_FW_0000137729": "已禁止根據返回數據render",
        "P_YS_FED_FW_0000137728": "擴展腳本需要配置addAttachment",
        "P_YS_FED_FW_0000137727": "缺少子表id",
        "P_YS_PF_SOCD_0000089325": "科威特",
        "P_YS_FED_FW_0000137726": "cb.lang沒有加載，多語配置出問題",
        "P_YS_PF_SOCD_0000089326": "牙買加",
        "P_YS_PF_GZTSYS_0000015829": "報表",
        "P_YS_FED_FW_0000137725": "inputnumber沒有model",
        "P_YS_FED_IMP_IOT0000010639": "惠東縣",
        "P_YS_FED_FW_0000137724": "input 沒有model",
        "P_YS_PF_SOCD_0000089324": "塞內加爾",
        "P_YS_FED_FW_0000137723": "%c 二維表日誌 警告",
        "P_YS_PF_SOCD_0000089321": "馬達加斯加",
        "P_YS_FED_FW_0000137722": "二維表日誌",
        "P_YS_PF_SOCD_0000089322": "岡比亞",
        "P_YS_SD_URETAIL_0001049087": "確定要清空已選商品嗎？",
        "P_YS_FED_FW_1437398955540348928": "最多選擇15個匯總項。",
        "P_YS_FED_FW_0000111115": "條/頁",
        "P_YS_FED_FW_0001425472": "條選中",
        "P_YS_FED_IMP_IOT0000010641": "宜黃縣",
        "P_YS_FED_IMP_IOT0000010646": "東遼縣",
        "P_YS_FED_IMP_IOT0000010647": "田東縣",
        "P_YS_FED_IMP_IOT0000010642": "譙城區",
        "P_YS_FED_IMP_IOT0000010643": "湖濱區",
        "P_YS_PF_SOCD_0000089318": "愛沙尼亞",
        "P_YS_PF_SOCD_0000089316": "加拿大",
        "P_YS_PF_SOCD_0000089317": "日本",
        "P_YS_PF_SOCD_0000089314": "塔吉克斯坦",
        "P_YS_PF_SOCD_0000089315": "烏干達",
        "P_YS_PF_SOCD_0000089310": "烏拉圭",
        "P_YS_PF_SOCD_0000089311": "蘇里南",
        "P_YS_HR_HRJQ_0000031330": "十二",
        "P_YS_FED_IMP_IOT0000010651": "仁和區",
        "P_YS_FED_IMP_IOT0000010652": "江城哈尼族彝族自治縣",
        "P_YS_FED_IMP_IOT0000010656": "成縣",
        "P_YS_SD_UDHWN_0000050384": "仙桃市",
        "P_YS_FED_IMP_IOT0000010661": "沙河市",
        "P_YS_FED_IMP_IOT0000010662": "潁東區",
        "P_YS_FED_IMP_IOT0000010669": "沙洋縣",
        "P_YS_FED_IMP_IOT0000010664": "寧安市",
        "P_YS_FED_IMP_IOT0000010665": "王益區",
        "P_YS_FED_IMP_IOT0000010666": "夷陵區",
        "P_YS_FED_IMP_IOT0000010671": "清鎮市",
        "P_YS_FED_IMP_IOT0000010672": "烏魯木齊縣",
        "P_YS_FED_IMP_IOT0000010679": "滿洲里市",
        "P_YS_PF_PROCENTER_0000027049": "另存為",
        "P_YS_FED_IMP_IOT0000010682": "普寧市",
        "P_YS_FED_IMP_IOT0000010685": "杭錦旗",
        "P_YS_FED_UIMG_0001237120": "向左",
        "P_YS_FED_UIMG_0001237119": "向上",
        "P_YS_FED_IMP_IOT0000010686": "漢壽縣",
        "P_YS_FED_IMP_IOT0000010689": "南郊區",
        "P_YS_SD_SDMB-UI_0001140276": "請輸入訂單編號",
        "P_YS_FED_FW_0001083419": "身份證格式錯誤！",
        "P_YS_FED_IMP_IOT0000010693": "隆安縣",
        "P_YS_FED_IMP_IOT0000010692": "子長縣",
        "P_YS_PF_PROCENTER_0000023508": "；",
        "P_YS_SD_SDSD-FE_0001486259": "日期時間",
        "P_YS_FED_IMP_IOT0000010697": "都蘭縣",
        "P_YS_FED_FW_1525783781928599556": "請獲取定位",
        "P_YS_FED_IMP_IOT0000010699": "嘉蔭縣",
        "P_YS_FED_FW_1443151222423420928": "——————————",
        "P_YS_OA_XTLCZX_0000032004": "無匹配數據",
        "P_YS_SD_SDOC_0001150290": "退件簽收",
        "P_YS_SD_UDHWN_0000122310": "訂單型別：",
        "P_YS_FED_FW_0001083420": "銀行卡式錯誤！",
        "P_YS_FED_FW_0001154320": "請錄入以下<%=text%>必輸欄位",
        "P_YS_FED_UIMG_0001065827": "非數值型別的欄位不能合計",
        "P_YS_FED_FW_0001154325": "請錄入以下表頭必輸欄位",
        "P_YS_FED_FW_0001071458": "文件名稱長度不能超過10個字符！",
        "P_YS_SD_UDHWN_0001009722": "1 分鐘",
        "P_YS_SD_SDMB_0000148279": "～",
        "P_YS_FED_FW_1572544576923631641": "數據加載中~",
        "P_YS_FED_FW_1473069861501927437": "searchDevices failed,錯誤資訊:",
        "P_YS_FED_FW_1473069861501927434": "printPicture failed,錯誤資訊:",
        "P_YS_SD_SDMB_0000150570": "應用中心",
        "P_YS_FED_FW_0001096749": "獲取數據失敗，接口報錯!",
        "P_YS_SD_UDHWN_0001009713": "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月",
        "P_YS_SD_UDHWN_0001009717": "[昨天]LT",
        "P_YS_FED_FW_1572544576923631638": "已經到底了~",
        "P_YS_FED_IMP_IOT0000008294": "夏縣",
        "P_YS_FED_IMP_IOT0000008298": "鎮遠縣",
        "P_YS_FED_FW_1473069861501927431": "searchDevices complete,資訊:",
        "P_YS_FED_FW_1572544576923631635": "tag需要配置為select/input類型",
        "P_YS_FED_FW_0000021281": "眉山市",
        "P_YS_FED_FW_0001026029": "圖片僅支持<%=accept%>格式",
        "P_YS_FED_FW_0000021282": "錦州市",
        "P_YS_HR_HRJQ_0000031296": "員工編號",
        "P_YS_FED_FW_0000021280": "龍岩市",
        "P_YS_FED_FW_0000021285": "太原市",
        "P_YS_PF_SOCD-E_0000354672": "阿拉伯聯合酋長國",
        "P_YS_FED_FW_0000021286": "咸陽市",
        "P_YS_FED_IMP_IOT0000007080": "仲巴縣",
        "P_YS_FED_FW_0000021283": "惠州市",
        "P_YS_FED_IMP_IOT0000007083": "梅江區",
        "P_YS_FED_FW_0000021284": "麗江市",
        "P_YS_FED_IMP_IOT0000007082": "瑞昌市",
        "P_YS_SD_SDSD-FE_0001486298": "創建人",
        "P_YS_FED_EXAMP_0000020199": "標籤列表",
        "P_YS_FED_EXAMP_0000020198": "輸入兩次新密碼不一致!",
        "P_YS_FED_FW_0000021278": "超出上傳限制，請刪除後重新上傳！",
        "P_YS_FED_FW_0001445807": "共選中資料",
        "P_YS_FED_FW_0000021279": "數據顯示區域 width =",
        "P_YS_FED_IMP_IOT0000007073": "廉江市",
        "P_YS_HR_HRJQ_0000031291": "導入",
        "P_YS_FED_FW_0001445806": "共選中資料條數",
        "P_YS_FED_FW_0000021276": "；失敗",
        "P_YS_FED_IMP_IOT0000007076": "朗縣",
        "P_YS_FED_FW_0000021277": "濰坊市",
        "P_YS_FED_IMP_IOT0000007075": "臨江市",
        "P_YS_FED_IMP_IOT0000007078": "古交市",
        "P_YS_FED_FW_0001026037": "<%=caption%> 已被此公式引用，不可循環引用",
        "P_YS_FED_IMP_IOT0000007077": "鄂城區",
        "P_YS_FED_FW_0000021292": "濟寧市",
        "P_YS_FED_FW_0000021293": "衢州市",
        "P_YS_FED_FW_0000021290": "操作出錯",
        "P_YS_FED_FW_0001026038": "確定要 <%=abandonText%>麼?",
        "P_YS_FED_FW_0000021291": "甘孜藏族自治州",
        "P_YS_FED_FW_0000021296": "格式化欄位，預製錯誤！",
        "P_YS_FED_FW_0001094183": "]方法",
        "P_YS_FED_FW_0000021297": "refer  cFormatData，預製錯誤！",
        "P_YS_FED_FW_0001094184": "結束調用Action[",
        "P_YS_FED_FW_0000021294": "香港特別行政區",
        "P_YS_FED_IMP_IOT0000007072": "壽光市",
        "P_YS_FED_FW_0000021295": "移動報表 MobileReport setSumFieldsCount sumFieldsCount",
        "P_YS_FED_IMP_IOT0000007071": "霍山縣",
        "P_YS_HR_HRJQF_0000054539": "年份",
        "P_YS_HR_HRRCPDF_0000073182": "未選",
        "P_YS_FED_FW_1515244353091534848": "請查看錯誤原因，修改後重新匯入。",
        "P_YS_OA_XTXIANGMU_0000063901": "添加標籤",
        "P_YS_FED_FW_0000021289": "寧波市",
        "P_YS_FED_IMP_IOT0000007062": "溧水縣",
        "P_YS_FED_FW_0000021287": "鞍山市",
        "P_YS_FED_FW_0000021288": "黃南藏族自治州",
        "P_YS_FED_FW_0001026042": "是否確認<%=cShowCaption%>此記錄",
        "P_YS_FED_IMP_IOT0000008394": "天柱縣",
        "P_YS_FED_IMP_IOT0000007068": "烏馬河區",
        "P_YS_FED_FW_0000021260": "文山壯族苗族自治州",
        "P_YS_FED_FW_0000021263": "九江市",
        "P_YS_FED_IMP_IOT0000008391": "喀什市",
        "P_YS_FED_FW_0000021264": "涼山彝族自治州",
        "P_YS_FED_IMP_IOT0000008392": "遼中縣",
        "P_YS_FED_FW_0000021261": "雲浮市",
        "P_YS_FED_FW_0000021262": "自貢市",
        "P_YS_FED_FW_0000021256": "北海市",
        "P_YS_FED_IMP_IOT0000007052": "潘集區",
        "P_YS_FED_FW_0000021257": "subConfig_Get 沒有找到對應的eChart  chartKey =",
        "P_YS_FED_IMP_IOT0000007051": "靜寧縣",
        "P_YS_FED_IMP_IOT0000008385": "岳陽樓區",
        "P_YS_FED_FW_0000021254": "孝感市",
        "P_YS_FED_FW_0000021255": "昭通市",
        "P_YS_FED_IMP_IOT0000007056": "永和縣",
        "P_YS_FED_IMP_IOT0000008388": "樂都縣",
        "P_YS_FED_IMP_IOT0000008389": "洱源縣",
        "P_YS_FED_FW_0000021258": "唐山市",
        "P_YS_FED_IMP_IOT0000008386": "天祝藏族自治縣",
        "P_YS_FED_FW_0000021259": "陽泉市",
        "P_YS_FED_FW_0000021270": "周口市",
        "P_YS_FED_FW_0000021271": "省直轄縣級行政區劃",
        "P_YS_FED_FW_0000021274": "寧夏",
        "P_YS_FED_FW_0000021275": "來賓市",
        "P_YS_FED_IMP_IOT0000008381": "翁牛特旗",
        "P_YS_FED_FW_0000021272": "怒江傈僳族自治州",
        "P_YS_FED_IMP_IOT0000007050": "廣州",
        "P_YS_FED_FW_0000021273": "根據filterId沒有獲取到任何移動端過濾方案",
        "P_YS_FED_FW_0001104071": "導航區",
        "P_YS_FED_IMP_IOT0000007049": "唐河縣",
        "P_YS_FED_FW_0000021267": "eChartCommon 更新過濾條件，去除裡面的空值 after param =",
        "P_YS_FED_IMP_IOT0000007041": "越西縣",
        "P_YS_FED_IMP_IOT0000008373": "澤普縣",
        "P_YS_FED_FW_0000021268": "杭州市",
        "P_YS_FED_IMP_IOT0000008374": "沅江市",
        "P_YS_FED_FW_0000021265": "吐魯番地區",
        "P_YS_FED_FW_0000021266": "區域經理大屏看板",
        "P_YS_FED_IMP_IOT0000007042": "乳源瑤族自治縣",
        "P_YS_FED_IMP_IOT0000008372": "蘇家屯區",
        "P_YS_FED_IMP_IOT0000008378": "海州區",
        "P_YS_FED_FW_0000021269": "淮北市",
        "P_YS_FED_IMP_IOT0000007047": "蓮湖區",
        "P_YS_FED_FW_0001026024": "<%=text%> 上傳失敗！<%=code%> : <%=message%>",
        "P_YS_FED_IMP_IOT0000007046": "新賓滿族自治縣",
        "P_YS_FED_FW_1486872262975422477": "已保存為草稿",
        "P_YS_FED_FW_1486872262975422474": "是否保存為草稿？",
        "P_YS_FED_EXAMP_0000020162": "房費商品時長不能為空！",
        "P_YS_FED_FW_1486872262975422471": "若不保存，所做編輯將不會被儲存",
        "P_YS_FED_EXAMP_0000020161": "),不得低於當前操作員金價折扣額上限(",
        "P_YS_FED_EXAMP_0000020164": "此種網絡狀況下，不允許電商結算！",
        "P_YS_FED_EXAMP_0000020163": "儲值卡售卡功能",
        "P_YS_FED_EXAMP_0000020160": "序列號[",
        "P_YS_FED_EXAMP_0000020159": "實體卡券不允許修改數量",
        "P_YS_FED_IMP_IOT0000007038": "鄂托克前旗",
        "P_YS_FED_EXAMP_0000020158": "當前時段區間為：",
        "P_YS_FED_IMP_IOT0000008368": "白玉縣",
        "P_YS_FED_IMP_IOT0000009699": "原陽縣",
        "P_YS_FED_IMP_IOT0000007039": "佛坪縣",
        "P_YS_FED_IMP_IOT0000008369": "衡南縣",
        "P_YS_FED_EXAMP_0000020155": "預訂退訂狀態下,不允許修改營業員！",
        "P_YS_FED_EXAMP_0000020154": "繳款",
        "P_YS_FED_EXAMP_0000020156": "登錄令牌失效，即將跳轉登陸頁面？",
        "P_YS_FED_IMP_IOT0000008362": "大關縣",
        "P_YS_FED_IMP_IOT0000009694": "清苑縣",
        "P_YS_FED_IMP_IOT0000008360": "景洪市",
        "P_YS_FED_IMP_IOT0000007032": "松潘縣",
        "P_YS_FED_IMP_IOT0000009691": "湖里區",
        "P_YS_FED_IMP_IOT0000007031": "紅星區",
        "P_YS_FED_IMP_IOT0000008361": "金鳳區",
        "P_YS_FED_IMP_IOT0000009697": "上猶縣",
        "P_YS_FED_IMP_IOT0000007033": "浮山縣",
        "P_YS_FED_IMP_IOT0000008367": "橋西區",
        "P_YS_FED_IMP_IOT0000009698": "沅陵縣",
        "P_YS_FED_FW_0001026078": "此匯總項已被<%=text%>公式引用不可取消",
        "P_YS_FED_IMP_IOT0000007036": "柘榮縣",
        "P_YS_FED_IMP_IOT0000009695": "鄲城縣",
        "P_YS_FED_IMP_IOT0000007035": "公安縣",
        "P_YS_FED_IMP_IOT0000008365": "聶拉木縣",
        "P_YS_FED_IMP_IOT0000009696": "蘆溪縣",
        "P_YS_FED_EXAMP_0000020173": "全部應用",
        "P_YS_FED_EXAMP_0000020172": "該卡券卡號已錄入, 請勿重複錄入",
        "P_YS_FED_EXAMP_0000020175": "房費商品結束時間不能為空！",
        "P_YS_FED_EXAMP_0000020174": "當前業務型別非儲值, 不允許使用充值調整",
        "P_YS_FED_EXAMP_0000020171": "卡券售卡功能",
        "P_YS_FED_FW_0001142287": "為單選，比較符不可選擇在列表中/不在列表中，請修改為等於/不等於；",
        "P_YS_FED_IMP_IOT0000007027": "甘泉縣",
        "P_YS_FED_FW_0001445832": "單據將被撤回為未提交狀態，確定要撤回單據嗎？",
        "P_YS_FED_EXAMP_0000020169": ";錯誤信息:",
        "P_YS_FED_IMP_IOT0000007029": "鄱陽縣",
        "P_YS_FED_IMP_IOT0000009688": "華池縣",
        "P_YS_FED_FW_0001142288": "為多選，比較符不可選擇等於/不等於，請修改為在列表中/不在列表中；",
        "P_YS_FED_IMP_IOT0000008358": "壽陽縣",
        "P_YS_FED_FW_0001026083": "模板內容匯入失敗，<%=text%>。",
        "P_YS_FED_EXAMP_0000020166": "電商退貨狀態下不能新增商品！",
        "P_YS_FED_FW_0001026084": "模板內容匯入失敗,返回信息：<%=text%>",
        "P_YS_FED_EXAMP_0000020165": "未找到該儲值卡號對應實體卡",
        "P_YS_FED_FW_0001444504": "共選中數據條數",
        "P_YS_FED_FW_0001026081": "<%=text%> 上傳成功!",
        "P_YS_FED_EXAMP_0000020168": "行中的商品沒有可用的批號，請調整！",
        "P_YS_FED_FW_0001026082": "確定刪除欄目【<%=text%>】麼？",
        "P_YS_FED_EXAMP_0000020167": "當前換貨行數量不能大於退貨行數量",
        "P_YS_FED_FW_0001026087": "共<%=actionText%><%=count%>條, 其中成功<%=sucessCount%>條,失敗<%=failCount%>條",
        "P_YS_FED_IMP_IOT0000008351": "肅州區",
        "P_YS_FED_FW_0001026088": "<%=actionText%>失敗：<%=messages%>",
        "P_YS_FED_IMP_IOT0000009683": "楚州區",
        "P_YS_FED_FW_0001026085": "<%=text%>成功",
        "P_YS_FED_FW_0001026086": "共<%=actionText%><%=count%>條, 其中成功<%=sucessCount%>條",
        "P_YS_FED_IMP_IOT0000009681": "泰興市",
        "P_YS_FED_IMP_IOT0000008355": "新北區",
        "P_YS_PF_PROCENTER_0000023573": "異常",
        "P_YS_FED_UIMG_0000154415": "模板校驗失敗！",
        "P_YS_FED_IMP_IOT0000007022": "潮陽區",
        "P_YS_FED_FW_0001026089": "<%=actionText%>成功",
        "P_YS_FED_IMP_IOT0000009684": "交城縣",
        "P_YS_FED_IMP_IOT0000008354": "奎文區",
        "P_YS_FED_IMP_IOT0000009685": "潼南縣",
        "P_YS_FED_EXAMP_0000020184": "預訂退訂狀態下，",
        "P_YS_FED_EXAMP_0000020183": "關閉",
        "P_YS_FED_EXAMP_0000020186": "調整狀態不允許執行現場折扣！",
        "P_YS_FED_EXAMP_0000020185": ")領位信息",
        "P_YS_FED_EXAMP_0000020180": "已經執行過優惠，不允許修改序列號！",
        "P_YS_FED_EXAMP_0000020182": "演示用戶密碼登錄失敗：【接口】",
        "P_YS_FED_EXAMP_0000020181": "充值狀態不允許執行",
        "P_YS_FED_IMP_IOT0000007016": "清流縣",
        "P_YS_FED_IMP_IOT0000009679": "船營區",
        "P_YS_FED_IMP_IOT0000007015": "霞山區",
        "P_YS_FED_IMP_IOT0000007017": "浦北縣",
        "P_YS_FED_IMP_IOT0000008347": "海興縣",
        "P_YS_FED_IMP_IOT0000009678": "橋東區",
        "P_YS_FED_EXAMP_0000020177": "請登錄會員並錄入商品。",
        "P_YS_FED_EXAMP_0000020176": "零售價",
        "P_YS_FED_EXAMP_0000020179": "獲取大屏開單設置失敗：",
        "P_YS_FED_FW_0001026054": "是否確認<%=cCaption%>此<%=text%>",
        "P_YS_FED_IMP_IOT0000008341": "萬載縣",
        "P_YS_FED_FW_0000021298": "其他信息:",
        "P_YS_FED_FW_0001026052": "該操作將會刪除當前<%=text%>及其子<%=text%>，是否繼續?",
        "P_YS_FED_FW_0000021299": "渭南市",
        "P_YS_FED_FW_0001026053": "是否確認刪除此<%=text%>",
        "P_YS_FED_FW_0001094182": "開始調用Action[",
        "P_YS_FED_FW_0001026058": "確定要<%=abandonText%>嗎？",
        "P_YS_FED_IMP_IOT0000008344": "西昌市",
        "P_YS_FED_IMP_IOT0000007012": "通榆縣",
        "P_YS_FED_IMP_IOT0000009675": "華縣",
        "P_YS_FED_IMP_IOT0000007011": "類烏齊縣",
        "P_YS_FED_IMP_IOT0000008345": "鳳岡縣",
        "P_YS_FED_IMP_IOT0000009676": "儀征市",
        "P_YS_FED_IMP_IOT0000008342": "江陵縣",
        "P_YS_FED_IMP_IOT0000009673": "且末縣",
        "P_YS_FED_FW_0001026057": "分類最多<%=level%>級",
        "P_YS_FED_IMP_IOT0000008343": "中方縣",
        "P_YS_FED_EXAMP_0000020195": "子件商品不允許執行優惠券",
        "P_YS_FED_EXAMP_0000020194": "當前攝像頭（攝像頭IP/ID）已離線,請檢查線路!",
        "P_YS_FED_EXAMP_0000020197": "當前網絡狀況不允許錄入會員，請重新開單！",
        "P_YS_FED_EXAMP_0000020196": "確定要切換帳號嗎？該操作將重新刷新頁面！",
        "P_YS_FED_EXAMP_0000020191": "調整後金額不能為空！",
        "P_YS_FED_EXAMP_0000020190": "已經存在相同的商品行!",
        "P_YS_FED_EXAMP_0000020193": "調整狀態不允許錄入會員！",
        "P_YS_FED_EXAMP_0000020192": "存在未錄入序列號的序列號商品行,請檢查!",
        "P_YS_FED_IMP_IOT0000007005": "富源縣",
        "P_YS_FED_IMP_IOT0000008337": "新晃侗族自治縣",
        "P_YS_FED_IMP_IOT0000009668": "天長市",
        "P_YS_FED_IMP_IOT0000007004": "洮南市",
        "P_YS_FED_IMP_IOT0000008335": "船山區",
        "P_YS_FED_IMP_IOT0000007006": "義縣",
        "P_YS_FED_EXAMP_0000020188": "駁回",
        "P_YS_FED_EXAMP_0000020187": "房費",
        "P_YS_FED_IMP_IOT0000008339": "富平縣",
        "P_YS_FED_EXAMP_0000020189": "再按一次退出應用",
        "P_YS_FED_IMP_IOT0000008330": "涇源縣",
        "P_YS_FED_IMP_IOT0000008333": "臨漳縣",
        "P_YS_FED_IMP_IOT0000007000": "睢寧縣",
        "P_YS_FED_IMP_IOT0000008334": "定遠縣",
        "P_YS_FED_IMP_IOT0000007003": "龍湖區",
        "P_YS_FED_IMP_IOT0000009663": "集賢縣",
        "P_YS_PF_PRINT_0000057998": "上遊單據號",
        "P_YS_FED_FW_0001220211": "參數返回數據錯誤,編碼為空.row =",
        "P_YS_FED_FW_0001220210": "func_CellCheck沒找到匹配的行信息",
        "P_YS_FED_FW_1478287954777997318": "顯示軌跡",
        "P_YS_FED_EXAMP_0000020120": "工費折扣率必須大於等於0小於等於100！",
        "P_YS_FED_FW_0001246843": "<%=name%>表體以下字段不能為空",
        "P_YS_FED_FW_0001246844": "<%=name%>表體的以下孫表不能為空",
        "P_YS_FED_FW_0000022529": "不存在, cBillType 只允許是",
        "P_YS_FED_EXAMP_0000020115": "切換",
        "P_YS_FED_EXAMP_0000020114": "獲取是否密碼校驗參數失敗",
        "P_YS_FED_IMP_IOT0000008327": "開封",
        "P_YS_FED_IMP_IOT0000009658": "徐匯區",
        "P_YS_FED_FW_0000022527": "沒有查詢到資料",
        "P_YS_FED_EXAMP_0000020117": "[公告] 門店新員工培訓學習",
        "P_YS_FED_IMP_IOT0000008324": "武江區",
        "P_YS_FED_IMP_IOT0000009655": "海城市",
        "P_YS_FED_FW_0000022528": "友零售",
        "P_YS_FED_IMP_IOT0000008325": "麟遊縣",
        "P_YS_FED_EXAMP_0000020111": "套餐商品未錄入完畢,不允許執行保存",
        "P_YS_PF_GZTSYS_0000015887": "設備",
        "P_YS_FED_EXAMP_0000020110": "儲值卡充值功能",
        "P_YS_FED_EXAMP_0000020113": "沒有可以改零售價的商品行",
        "P_YS_FED_IMP_IOT0000009659": "潯陽區",
        "P_YS_FED_EXAMP_0000020112": "暫無數據哦~",
        "P_YS_FED_IMP_IOT0000008329": "康樂縣",
        "P_YS_FED_FW_0000022521": "名稱不能為空",
        "P_YS_FED_FW_0000022522": "默認值最多保存5項",
        "P_YS_FED_FW_0000022520": "級次選擇",
        "P_YS_FED_FW_0000022525": "【接口】",
        "P_YS_FED_EXAMP_0000020119": "線上零售價",
        "P_YS_FED_IMP_IOT0000008322": "金台區",
        "P_YS_FED_IMP_IOT0000009653": "桃山區",
        "P_YS_FED_FW_0000022526": "參數：",
        "P_YS_FED_EXAMP_0000020118": "客戶名稱",
        "P_YS_FED_FW_0000022523": "文件打開出錯",
        "P_YS_FED_FW_0000022524": "billType 未錄入",
        "P_YS_FED_IMP_IOT0000009652": "邳州市",
        "P_YS_FED_FW_0001220209": "參數返回數據異常,編碼為空。",
        "P_YS_FED_EXAMP_0000020131": "規格:",
        "P_YS_FED_EXAMP_0000020130": "數量",
        "P_YS_PF_PRINT_0000056670": "操作人",
        "P_YS_FED_FW_0000021209": "許昌市",
        "P_YS_FED_EXAMP_0000020126": "該狀態下不能使用快捷結算",
        "P_YS_FED_IMP_IOT0000009646": "鳳城市",
        "P_YS_SCM_SACT-FE_0001196577": "/premises-cdn/iprint/用友雲列印助手.exe",
        "P_YS_FED_EXAMP_0000020125": "：指預先加工入庫在銷售的加工商品，如麵包、餅乾等；預製商品受業務參數“允許負出庫”控制。",
        "P_YS_FED_IMP_IOT0000008316": "威信縣",
        "P_YS_FED_IMP_IOT0000009647": "二道區",
        "P_YS_HR_HRJXF_0000184400": "取消關聯",
        "P_YS_PF_WORKBENCH-FE_0001242096": "暫不了解",
        "P_YS_FED_FW_0000021207": "臨夏回族自治州",
        "P_YS_FED_EXAMP_0000020128": "獲取開單設置失敗：",
        "P_YS_FED_IMP_IOT0000008313": "武安市",
        "P_YS_FED_EXAMP_0000020127": "上傳失敗",
        "P_YS_FED_FW_0000021208": "非預訂",
        "P_YS_FED_IMP_IOT0000009645": "宜陽縣",
        "P_YS_FED_EXAMP_0000020122": "改行",
        "P_YS_PF_GZTSYS_0000013235": "業務檔案",
        "P_YS_FED_EXAMP_0000020121": "已存在商品行，不能進行退訂！",
        "P_YS_FED_EXAMP_0000020124": "本次調整金額不能為空！",
        "P_YS_FED_EXAMP_0000020123": "確認結算",
        "P_YS_FED_IMP_IOT0000008318": "桓台縣",
        "P_YS_FED_FW_0000021201": "株洲市",
        "P_YS_FED_FW_0000021202": "分組方案由支持單圖改為支持多圖升級整個報表的配置信息出錯。eChartConfig",
        "P_YS_FED_FW_0000021200": "泰安市",
        "P_YS_FED_FW_0000021205": "張家口市",
        "P_YS_FED_IMP_IOT0000008311": "平遙縣",
        "P_YS_FED_FW_0000021206": "寶雞市",
        "P_YS_FED_EXAMP_0000020129": "不能執行促銷活動！您確定要取消",
        "P_YS_FED_IMP_IOT0000009643": "調兵山市",
        "P_YS_FED_FW_0000021203": "欽州市",
        "P_YS_FED_IMP_IOT0000009640": "晉安區",
        "P_YS_FED_FW_0000021204": "柱形圖配置信息",
        "OA_web_ad_000000095": "未分組",
        "P_YS_FED_EXAMP_0000020140": "數據權限設置",
        "P_YS_FED_FW_0001051041": "服務器連接失敗！",
        "P_YS_FED_EXAMP_0000020142": "銷售排名",
        "P_YS_FED_FW_0001051042": "{value} 星",
        "P_YS_FED_EXAMP_0000020141": "審核不通過",
        "P_YS_FED_FW_0000022507": "另存新方案",
        "P_YS_FED_EXAMP_0000020137": "個字",
        "P_YS_FED_IMP_IOT0000008304": "臨洮縣",
        "P_YS_FED_IMP_IOT0000009635": "開遠市",
        "P_YS_FED_FW_0000022508": "保存方案",
        "P_YS_FED_EXAMP_0000020136": "自動揀貨失敗！",
        "P_YS_FED_IMP_IOT0000009636": "高青縣",
        "P_YS_FED_FW_0000022505": "本周",
        "P_YS_FED_EXAMP_0000020139": "業務型別非售卡且開單行非空, 不允許售卡",
        "P_YS_FED_FW_0000022506": "下週",
        "P_YS_FED_EXAMP_0000020138": "原單退貨中，換貨行不允許改行！",
        "P_YS_FED_EXAMP_0000020133": "暱稱",
        "P_YS_FED_IMP_IOT0000008308": "郟縣",
        "P_YS_FED_IMP_IOT0000009639": "良慶區",
        "P_YS_FED_EXAMP_0000020132": "退品原因不能為空！",
        "P_YS_FED_IMP_IOT0000008309": "柯城區",
        "P_YS_FED_FW_0000022509": "日期選擇",
        "P_YS_FED_EXAMP_0000020135": "本次新增行請直接刪除！",
        "P_YS_FED_EXAMP_0000020134": "當前單據狀態下，不允許刪除行！",
        "P_YS_FED_FW_0000022500": "查看已選",
        "P_YS_FED_FW_0000022503": "預置方案",
        "P_YS_FED_IMP_IOT0000008300": "陽東縣",
        "P_YS_FED_FW_0000022504": "全部收起",
        "P_YS_FED_FW_0000022501": "查詢項不能為空",
        "P_YS_FED_FW_0000022502": "方案操作成功",
        "P_YS_FED_EXAMP_0000020151": "請先選擇單據！",
        "P_YS_FED_EXAMP_0000020150": "新增會員",
        "P_YS_FED_EXAMP_0000020153": "優惠券[",
        "P_YS_FED_FW_1556970089191309315": "編輯方案內查詢",
        "P_YS_FED_EXAMP_0000020152": "統計近",
        "P_YS_FED_FW_1556970089191309318": "編輯方案內",
        "P_YS_FED_FW_0000022518": "全部展開",
        "P_YS_FED_EXAMP_0000020148": "請輸入正確的卡券號碼",
        "P_YS_FED_FW_0000022519": "置底",
        "P_YS_FED_EXAMP_0000020147": "上次上傳任務未進行完",
        "P_YS_FED_IMP_IOT0000009625": "易門縣",
        "P_YS_FED_FW_0000022516": "已選（",
        "P_YS_FED_FW_0000022517": "今年",
        "P_YS_FED_EXAMP_0000020149": "稱重量高於標準重量，請檢查產品是否有堆疊並重新擺放商品！",
        "P_YS_FED_IMP_IOT0000009623": "驛城區",
        "P_YS_FED_EXAMP_0000020144": "請選擇商城訂單！",
        "P_YS_FED_EXAMP_0000020143": "沒有條碼為[",
        "P_YS_FED_IMP_IOT0000009629": "婁煩縣",
        "P_YS_FED_FW_1556970089191309321": "自定義過濾條件清單新增",
        "P_YS_FED_EXAMP_0000020146": "確定撥打",
        "P_YS_FED_EXAMP_0000020145": "獲取租戶信息失敗：【接口】",
        "P_YS_FED_FW_0000022510": "恢復預設",
        "P_YS_FED_FW_0000022511": "移除",
        "P_YS_FED_FW_0000022514": "高級",
        "P_YS_FED_FW_0000022515": "換位置拉",
        "P_YS_FED_FW_0000022512": "沒有搜索結果",
        "P_YS_FED_FW_0000022513": "置頂",
        "P_YS_FED_FW_0000021241": "看板配置信息-桌面-行列佈局",
        "P_YS_FED_FW_0000021242": "report/getGroupSetting(獲取報表分組方案的詳細設置進行顯示) 返回錯誤信息。",
        "P_YS_FED_FW_0000021240": "赤峰市",
        "P_YS_FED_FW_0001289933": "缺少scanQRCode方法",
        "P_YS_PF_GZTTMP_0000073505": "交換狀態",
        "P_YS_FED_IMP_IOT0000009611": "冕寧縣",
        "P_YS_FED_IMP_IOT0000009612": "白銀區",
        "P_YS_FED_FW_1593218496493781002": "單據聯查結果顯示",
        "P_YS_FED_IMP_IOT0000009618": "上城區",
        "P_YS_FED_IMP_IOT0000009615": "渠縣",
        "P_YS_FED_FW_1556970089191309312": "lineTab切換為",
        "P_YS_FED_FW_1593218496493781005": "Les résultats de la recherche conjointe de documents montrent",
        "P_YS_FED_FW_0000021234": "三沙市",
        "P_YS_FED_FW_0000021235": "通化市",
        "P_YS_FED_FW_0000021232": "濱州市",
        "P_YS_FED_FW_0000021233": "黃岡市",
        "P_YS_FED_FW_0000021238": "撫順市",
        "P_YS_FED_FW_0000021239": "開始日期",
        "P_YS_FED_IMP_IOT0000009610": "鳳凰縣",
        "P_YS_FED_FW_0000021236": "無明確信息",
        "P_YS_FED_FW_0000021237": "哈密地區",
        "P_YS_HR_HRJXF_0000184457": "確定刪除嗎？",
        "P_YS_FED_FW_0000021252": "南寧市",
        "P_YS_FED_FW_0000021253": "柱折圖配置信息",
        "P_YS_FED_FW_0000021250": "台灣省",
        "P_YS_FED_FW_0000021251": "表體存在必輸項，請輸入完整再嘗試保存！",
        "P_YS_FED_IMP_IOT0000009609": "伊通滿族自治縣",
        "P_YS_FED_IMP_IOT0000009600": "桂東縣",
        "P_YS_FED_FW_0000021245": "紅河哈尼族彝族自治州",
        "P_YS_FED_FW_0000021246": "萍鄉市",
        "P_YS_FED_FW_0000021243": "泰州市",
        "P_YS_FED_FW_0000021244": "常州市",
        "P_YS_FED_FW_0000021249": "保山市",
        "P_YS_FED_FW_0000021247": "小計",
        "P_YS_FED_FW_0000021248": "佛山市",
        "P_YS_FED_FW_0000021220": "崇左市",
        "P_YS_FED_FW_1596335448733515784": "(最多選擇5項)",
        "P_YS_FED_FW_1596335448733515781": "最多選擇5個分組項。",
        "P_YS_FED_FW_1596335448733515787": "分組項",
        "P_YS_FED_FW_0000021218": "菏澤市",
        "P_YS_FED_FW_0000021219": "大興安嶺地區",
        "P_YS_FED_FW_0000021212": "汕尾市",
        "P_YS_FED_FW_0000021213": "cStyle，預製錯誤！",
        "P_YS_FED_FW_0000021210": "金昌市",
        "P_YS_FED_FW_0000021211": "天津市",
        "P_YS_FED_FW_0000021216": "呂梁市",
        "P_YS_FED_FW_0000021217": "商洛市",
        "P_YS_FED_FW_0000021214": "張掖市",
        "P_YS_FED_FW_0000021215": "伊犁哈薩克自治州",
        "P_YS_FED_FW_0000021230": "德陽市",
        "P_YS_SD_URETAIL_0001049003": "promiseExecute1內部出錯：",
        "P_YS_FED_FW_0001322153": "還沒有圖表卡片哦",
        "P_YS_FED_FW_0000021231": "安徽",
        "P_YS_PF_METADATA_0001040101": "模板編號",
        "P_YS_FED_FW_1596335448733515790": "分組項設置",
        "P_YS_PF_PRINT_0000056691": "銷售類型",
        "P_YS_FED_FW_1596335448733515793": "(最多選擇15項)",
        "P_YS_FED_EXAMP_0000020104": "非原單退貨應收金額為負, 不能使用會員錢包支付",
        "P_YS_FED_EXAMP_0000020103": "套餐商品未錄入完畢,不允許執行結算",
        "P_YS_FED_FW_0000021229": "-￥",
        "P_YS_FED_EXAMP_0000020106": "積分抵扣",
        "P_YS_FED_EXAMP_0000020105": "退貨數量不能大於原單未退貨數量。",
        "P_YS_FED_FW_1596335448733515796": "匯總項設置",
        "P_YS_FED_EXAMP_0000020100": "應收不等於實收，無法結算",
        "P_YS_FED_EXAMP_0000020102": "定製型別不允許增加商品行！",
        "P_YS_FED_EXAMP_0000020101": "套餐商品需要全選",
        "P_YS_FED_FW_0000021223": "鐵嶺市",
        "P_YS_FED_FW_0000021224": "需要顯示為XY軸的名字超長，需要截斷，截斷前：",
        "P_YS_FED_FW_0000021221": "本單積分",
        "P_YS_FED_FW_0000021222": "合肥市",
        "P_YS_FED_FW_0000021227": "本溪市",
        "P_YS_FED_EXAMP_0000020108": "調整狀態不允許執行促銷活動！",
        "P_YS_FED_FW_0000021228": "移動報表 MobileReportSum firstQueryDone params =",
        "P_YS_FED_EXAMP_0000020107": "售卡狀態不允許執行該操作 請重新開單",
        "P_YS_FED_FW_0000021225": "通遼市",
        "P_YS_FED_FW_0000021226": "表全部數據成功",
        "P_YS_FED_EXAMP_0000020109": "獲取支付方式失敗",
        "P_YS_SD_UDHWN_0000050426": "萬寧市",
        "P_YS_SCM_USTOCK_0000064406": "未變更",
        "P_YS_FED_EXAMP_0000020511": "確認POS已經為閒置狀態？",
        "P_YS_FED_EXAMP_0000020510": "當前網絡不可用並且當前操作員無刪行權限，不能使用此功能！",
        "P_YS_FED_EXAMP_0000020513": "請選擇門店",
        "P_YS_FED_EXAMP_0000020512": "沒有選中商品行，無法批量指定,請檢查!",
        "P_YS_FED_EXAMP_0000020519": "已存在商品行，不能進行交貨！",
        "P_YS_FED_EXAMP_0000020518": "掛單並打印",
        "P_YS_FED_EXAMP_0000020515": "向主界面發送數據參數不正確。",
        "P_YS_FED_EXAMP_0000020514": "已收款:",
        "P_YS_FED_EXAMP_0000020517": "無該會員信息",
        "P_YS_FED_EXAMP_0000020516": "近7天",
        "P_YS_FED_EXAMP_0000020522": "三里屯店",
        "P_YS_FED_EXAMP_0000020521": "元數據失敗：",
        "P_YS_FED_EXAMP_0000020524": "已存在相同sku商品行!",
        "P_YS_FED_EXAMP_0000020523": "當前商品不參與抵扣操作。",
        "P_YS_FED_EXAMP_0000020520": "密碼修改成功",
        "P_YS_FED_EXAMP_0000020529": "上拉加載更多...",
        "P_YS_FED_EXAMP_0000020526": "套餐商品未錄入完畢,不允許執行現場折扣",
        "P_YS_FED_EXAMP_0000020525": "代金券",
        "P_YS_FED_EXAMP_0000020528": "當前房間存在未交貨的零售單，請處理後再領位",
        "P_YS_SD_SDMBF_0000141962": "輸入有誤",
        "P_YS_FED_EXAMP_0000020527": "已存在商品行，不能進行變更！",
        "P_YS_FED_FW_0001265743": "請檢查BUSINESS_LOG_SERVER配置是否正確",
        "P_YS_FED_FW_1430606138330578944": "除數不能為 0",
        "P_YS_FED_EXAMP_0000020533": "獲取儲值打印模板失敗",
        "P_YS_FED_IMP_IOT0000011802": "衡東縣",
        "P_YS_FED_FW_0001253754": "缺少changeScreenOrientation方法",
        "P_YS_FED_EXAMP_0000020532": "電商訂單退貨不能進行掛單解掛操作！",
        "P_YS_FED_FW_0001253753": "請錄入",
        "P_YS_FED_EXAMP_0000020535": "存在重複的序列號[",
        "P_YS_FED_FW_0001253756": "{\"（\":\"(\",\"）\":\")\",\"！\":\"!\",\"，\":\",\",\"。\":\".\",\"：\":\":\",\"；\":\";\",\"、\":\" \"}",
        "P_YS_FED_EXAMP_0000020534": "進貨價 :",
        "P_YS_FED_FW_0001253755": "確定取消操作嘛?",
        "P_YS_FED_FW_0001253750": "711連鎖便利店",
        "P_YS_FED_EXAMP_0000020531": "mac地址未取到，請退出程序重新登錄！",
        "P_YS_FED_FW_0001253752": "共&nbsp;",
        "P_YS_FED_EXAMP_0000020530": "]為在庫狀態,請檢查!",
        "P_YS_FED_FW_0001253751": "zjj普通",
        "P_YS_FED_IMP_IOT0000011809": "汝城縣",
        "P_YS_FED_EXAMP_0000020537": "SKU編碼",
        "P_YS_FED_IMP_IOT0000011806": "新巴爾虎右旗",
        "P_YS_FED_FW_1471272821425963008": "全部加載完成",
        "P_YS_FED_EXAMP_0000020536": "當前網絡不可用，不能銷售批次管理的商品！",
        "P_YS_FED_FW_0001253757": "缺少restoreScreenOrientation方法",
        "P_YS_FED_EXAMP_0000020539": "未取得門店的默認倉庫!",
        "P_YS_OA_XTLCZX_0000030825": "上傳中",
        "P_YS_FED_EXAMP_0000020538": "確 定",
        "P_YS_FED_EXAMP_0000020544": "當前操作員無卡券權限",
        "P_YS_FED_EXAMP_0000020543": "表體行營業員不能為空!",
        "P_YS_FED_IMP_IOT0000011812": "七里河區",
        "P_YS_FED_EXAMP_0000020546": "退品數量不能為空！",
        "P_YS_FED_EXAMP_0000020545": "無效錢包帳號",
        "P_YS_FED_IMP_IOT0000011814": "商都縣",
        "P_YS_FED_EXAMP_0000020540": "是否退出開單界面？",
        "P_YS_FED_FW_1439654302997020672": "沒有指定進度組件型別！",
        "P_YS_FED_EXAMP_0000020542": "您的軟件是最新版本",
        "P_YS_FED_IMP_IOT0000011811": "長豐縣",
        "P_YS_FED_EXAMP_0000020541": "重量不合法！",
        "P_YS_FED_EXAMP_0000020548": "沒有識別到商品!",
        "P_YS_FED_IMP_IOT0000011817": "詔安縣",
        "P_YS_FED_EXAMP_0000020547": "請輸入用戶名",
        "P_YS_FED_IMP_IOT0000011816": "武功縣",
        "P_YS_FED_FW_1575980902936215553": "｜",
        "P_YS_FED_EXAMP_0000020549": "卡券非原單退功能",
        "P_YS_FED_IMP_IOT0000011818": "襄城區",
        "P_YS_FED_FW_1529421301390245894": "請點擊側欄中的侯選條件進行加入",
        "P_YS_FED_IMP_IOT0000011824": "老邊區",
        "P_YS_FED_IMP_IOT0000011823": "永城市",
        "P_YS_FED_IMP_IOT0000011826": "嘉祥縣",
        "P_YS_PF_METADATA_0000083588": "檔案大小",
        "P_YS_FED_IMP_IOT0000011822": "石首市",
        "P_YS_FED_IMP_IOT0000011827": "象山縣",
        "P_YS_FED_IMP_IOT0000011829": "清河縣",
        "P_YS_FI_FINBD-UI_0000161964": "表參照",
        "P_YS_FED_FW_0000021407": "漯河市",
        "P_YS_FED_IMP_IOT0000010503": "攀枝花",
        "P_YS_FED_FW_0000021408": "廣元市",
        "P_YS_FED_FW_0000021405": "佳木斯市",
        "P_YS_FED_IMP_IOT0000011837": "官渡區",
        "P_YS_FED_FW_0001253745": "請輸入必填字段,",
        "P_YS_FED_FW_0000021406": "排名表配置信息-yySetting",
        "P_YS_FED_IMP_IOT0000010506": "崇州市",
        "P_YS_FED_IMP_IOT0000011836": "新田縣",
        "P_YS_ZNBZ_BZBX-FE_0001141300": "擔保合約",
        "P_YS_FED_FW_0000021409": "昌都地區",
        "P_YS_ZNBZ_BZBX-FE_0001141303": "借款",
        "P_YS_FED_IMP_IOT0000010502": "珠暉區",
        "P_YS_PF_GZTTMP_0000074571": "觸屏",
        "P_YS_FED_FW_0001023490": "cStyle配置異常",
        "P_YS_ZNBZ_BZBX-FE_0001141305": "抵/質押合約跟蹤",
        "P_YS_FED_FW_0000021400": "看板配置信息-模塊配置-公告",
        "P_YS_ZNBZ_BZBX-FE_0001141304": "聯保合約",
        "P_YS_HR_HRYGF_0001153277": "提示:",
        "P_YS_FED_FW_0000021403": "獲取圖形報表數據Err  查詢參數 =",
        "P_YS_FED_FW_0001253747": "連續掃碼",
        "P_YS_FED_IMP_IOT0000011838": "盱眙縣",
        "P_YS_FED_FW_0001253746": "數據區必輸字段",
        "P_YS_FED_FW_0000021401": "海西蒙古族藏族自治州",
        "P_YS_FED_IMP_IOT0000010509": "茌平縣",
        "P_YS_FED_FW_0001253749": "cell的寬度超過表格的寬度，無法渲染；節點資訊：",
        "P_YS_FED_FW_0000021402": "看板配置信息-移動-行列佈局",
        "P_YS_FED_FW_0001253748": "連掃",
        "P_YS_FED_FW_0001238122": "失敗&nbsp;",
        "P_YS_FED_IMP_IOT0000011840": "同江市",
        "P_YS_FED_FW_0001035432": "<p>無提示文字~</p>",
        "P_YS_FED_FW_0001576776": "&region=全國&output=json&ak=",
        "P_YS_FED_FW_0001035433": "您於<%=tmpTime%>發起的【<%=busName%>】",
        "P_YS_FED_IMP_IOT0000011845": "博樂市",
        "P_YS_FED_IMP_IOT0000005995": "新洲區",
        "P_YS_FED_IMP_IOT_0000115234": ",最小為",
        "P_YS_FED_IMP_IOT0000005994": "太谷縣",
        "P_YS_FED_IMP_IOT0000010510": "隆化縣",
        "P_YS_PF_SOCD_0000089208": "瑞典",
        "P_YS_FED_IMP_IOT0000005999": "東陽市",
        "P_YS_FED_IMP_IOT0000010512": "成武縣",
        "P_YS_FED_IMP_IOT_0000115238": "請選擇...",
        "P_YS_PF_SOCD_0000089209": "摩洛哥",
        "P_YS_FED_IMP_IOT0000011843": "寧遠縣",
        "P_YS_PF_SOCD_0000089206": "荷蘭",
        "P_YS_PF_SOCD_0000089207": "斯洛文尼亞",
        "P_YS_PF_SOCD_0000089204": "俄羅斯",
        "P_YS_PF_SOCD_0000089205": "斯里蘭卡",
        "P_YS_PF_SOCD_0000089203": "法國",
        "P_YS_FED_IMP_IOT0000011849": "嘉魚縣",
        "P_YS_FED_IMP_IOT0000005991": "五峰土家族自治縣",
        "P_YS_PF_SOCD_0000089201": "波蘭",
        "P_YS_FED_IMP_IOT0000005990": "江城區",
        "P_YS_FED_IMP_IOT0000005989": "合浦縣",
        "P_YS_FED_IMP_IOT0000011850": "平川區",
        "P_YS_PF_PRINT_0000062612": "子表",
        "P_YS_FED_EXAMP_0000020500": "待入庫",
        "P_YS_FED_IMP_IOT0000011857": "襄城縣",
        "P_YS_OA_XTXIANGMU_0000063884": "剩餘",
        "P_YS_FED_IMP_IOT0000005981": "達拉特旗",
        "P_YS_FED_EXAMP_0000020502": "獲取系統參數失敗：【接口】",
        "P_YS_FED_IMP_IOT0000010527": "武陟縣",
        "P_YS_FED_EXAMP_0000020501": "調整狀態不允許解掛！",
        "P_YS_FED_IMP_IOT0000011858": "彭澤縣",
        "P_YS_FED_IMP_IOT0000010521": "荔城區",
        "P_YS_FED_IMP_IOT_0000115225": "輸入值,最大值為",
        "P_YS_FED_IMP_IOT0000005985": "蒙陰縣",
        "P_YS_FED_IMP_IOT0000010523": "廣水市",
        "P_YS_FED_IMP_IOT0000011855": "沁水縣",
        "P_YS_FED_IMP_IOT0000010524": "朝天區",
        "P_YS_FED_EXAMP_0000020508": "座機",
        "P_YS_FED_EXAMP_0000020507": "每月一次",
        "P_YS_FED_EXAMP_0000020509": "商城上架數",
        "P_YS_FED_EXAMP_0000020504": "退貨充值",
        "P_YS_FED_EXAMP_0000020503": "解掛",
        "P_YS_FED_EXAMP_0000020506": "當前每克金價折扣額為(",
        "P_YS_FED_IMP_IOT0000005980": "昌江區",
        "P_YS_FED_EXAMP_0000020505": "已有商品行, 不允許錢包充值",
        "P_YS_PF_SOCD_0000089220": "南非",
        "P_YS_PF_SOCD_0000089221": "聖多美和普林西比",
        "P_YS_FED_FW_1551561479829848067": "為按單操作",
        "P_YS_HR_HRJQ_0000055421": "類型",
        "P_YS_OA_XTRIZHI_0000036814": "繼續編輯",
        "P_YS_FED_IMP_IOT0000005979": "龍安區",
        "P_YS_FED_IMP_IOT0000005978": "於都縣",
        "P_YS_FED_IMP_IOT0000010531": "寶豐縣",
        "P_YS_FI_CM_0000029055": "八月",
        "P_YS_FED_IMP_IOT0000010536": "通許縣",
        "P_YS_FED_IMP_IOT0000005970": "武強縣",
        "P_YS_FED_IMP_IOT0000010538": "景德鎮",
        "P_YS_FED_FW_0001661900": "超出最大長度限制\\t\\n",
        "P_YS_FED_IMP_IOT0000005972": "根河市",
        "P_YS_FED_IMP_IOT0000010539": "克東縣",
        "P_YS_FED_IMP_IOT0000010532": "興賓區",
        "P_YS_FED_IMP_IOT0000005974": "安寧區",
        "P_YS_FED_IMP_IOT0000010533": "沈丘縣",
        "P_YS_FED_IMP_IOT0000005977": "平橋區",
        "P_YS_FED_IMP_IOT0000010534": "西盟佤族自治縣",
        "P_YS_FED_IMP_IOT0000005976": "鄒城市",
        "P_YS_PF_SOCD_0000089228": "多哥",
        "P_YS_PF_SOCD_0000089226": "津巴布韋",
        "P_YS_PF_SOCD_0000089227": "孟加拉國",
        "P_YS_PF_SOCD_0000089225": "葡萄牙",
        "P_YS_PF_SOCD_0000089222": "巴哈馬",
        "P_YS_PF_SOCD_0000089223": "馬里",
        "P_YS_SD_SDMAUF_0000152388": "全部取消",
        "P_YS_FI_CM_0000030058": "單據編號",
        "P_YS_HR_HRJQ_0000055417": "部門",
        "P_YS_FED_IMP_IOT0000005967": "藍田縣",
        "P_YS_FED_IMP_IOT0000010540": "都勻市",
        "P_YS_FED_IMP_IOT0000010541": "望花區",
        "P_YS_FED_IMP_IOT0000010542": "澄海區",
        "P_YS_FED_IMP_IOT0000010547": "慈溪市",
        "P_YS_OA_XTWENKU_0000035690": "請選擇日期",
        "P_YS_FED_IMP_IOT0000005962": "五通橋區",
        "P_YS_FED_IMP_IOT0000005961": "登封市",
        "P_YS_FED_FW_0001253700": "沒有一維表模型",
        "P_DIWORK_YC_ORDER_0000061342": "－",
        "P_YS_PF_SOCD_0000089219": "伯利茲",
        "P_YS_FED_IMP_IOT0000005966": "連城縣",
        "P_YS_FED_IMP_IOT0000005965": "河西區",
        "P_YS_PF_SOCD_0000089217": "馬拉維",
        "P_YS_PF_SOCD_0000089218": "巴布亞新幾內亞",
        "P_YS_PF_SOCD_0000089215": "乍得",
        "P_YS_PF_SOCD_0000089216": "突尼斯",
        "P_YS_PF_SOCD_0000089213": "冰島",
        "P_YS_PF_SOCD_0000089214": "智利",
        "P_YS_FED_FW_0001073796": "永州冷",
        "P_YS_PF_SOCD_0000089243": "肯尼亞",
        "P_YS_FED_FW_0001073795": "達縣市",
        "P_YS_PF_SOCD_0000089240": "萊索托",
        "P_YS_FED_FW_0001073794": "襄城市",
        "P_YS_FI_CM_0000029074": "六月",
        "P_YS_FED_FW_0001380706": "請您先上傳附件",
        "P_YS_PF_SOCD_0000089241": "美國",
        "P_YS_FED_FW_0001073793": "株州市",
        "P_YS_FED_FW_0001073792": "錫林浩特",
        "P_YS_FED_IMP_IOT0000005957": "富民縣",
        "P_YS_FED_IMP_IOT0000010552": "集安市",
        "P_YS_FED_IMP_IOT0000010553": "海曙區",
        "P_YS_FED_FW_0001073799": "離石市",
        "P_YS_FED_FW_0001073798": "日喀則",
        "P_YS_FED_FW_0001073797": "揭西市",
        "P_YS_FED_IMP_IOT0000010559": "佳縣",
        "P_YS_FED_IMP_IOT0000010554": "固始縣",
        "P_YS_FED_IMP_IOT0000010555": "吉木薩爾縣",
        "P_YS_SD_SDMA_0000038452": "業務員",
        "P_YS_FED_IMP_IOT0000005954": "儀隴縣",
        "P_YS_ZNBZ_BZBX-FE_0001135440": "?",
        "P_YS_PF_SOCD_0000089247": "巴拿馬",
        "P_YS_PF_SOCD_0000089245": "尼加拉瓜",
        "P_YS_FI_CM_0000029087": "確認刪除？",
        "P_YS_PF_SOCD_0000089231": "贊比亞",
        "P_YS_PF_SOCD_0000089232": "文萊",
        "P_YS_FI_CM_0000029084": "此刻",
        "P_YS_FED_IMP_IOT0000010561": "贛縣",
        "P_YS_FED_IMP_IOT0000005945": "石門縣",
        "P_YS_FED_IMP_IOT0000005948": "綏寧縣",
        "P_YS_FED_IMP_IOT0000010563": "普蘭縣",
        "P_YS_FED_IMP_IOT0000010569": "兩當縣",
        "P_YS_FED_IMP_IOT0000005940": "太康縣",
        "P_YS_FED_FW_1602981773186695169": "領域擴展的上下文中沒獲取到key為",
        "P_YS_FED_IMP_IOT0000005942": "欒川縣",
        "P_YS_FED_IMP_IOT0000010565": "孟連傣族拉祜族佤族自治縣",
        "P_YS_FED_IMP_IOT0000010566": "勐海縣",
        "P_YS_FED_IMP_IOT0000005944": "韓城市",
        "P_YS_PF_SOCD_0000089239": "伊拉克",
        "P_YS_OA_XTWENKU_0000035676": "創建時間",
        "P_YS_PF_SOCD_0000089237": "巴拉圭",
        "P_YS_PF_SOCD_0000089235": "朝鮮",
        "P_YS_PF_SOCD_0000089236": "莫桑比克",
        "P_YS_PF_SOCD_0000089234": "尼日利亞",
        "P_YS_PF_SOCD_0000089265": "蘇丹",
        "P_YS_PF_SOCD_0000089262": "瑙魯",
        "P_YS_SCM_PU_0000027628": "已完成",
        "P_YS_PF_SOCD_0000089263": "白俄羅斯",
        "P_YS_PF_SOCD_0000089261": "伊朗",
        "P_YS_FED_IMP_IOT0000005935": "漢陰縣",
        "P_YS_FED_IMP_IOT0000005934": "牟定縣",
        "P_YS_FI_CM_0000030006": "切換為平鋪",
        "P_YS_FI_CM_0000029016": "≥",
        "P_YS_FED_IMP_IOT0000010575": "劍川縣",
        "P_YS_FI_CM_0000030008": "還原",
        "P_YS_FED_IMP_IOT0000005939": "閬中市",
        "P_YS_FED_IMP_IOT0000005938": "西夏區",
        "P_YS_FED_IMP_IOT0000005931": "福清市",
        "P_YS_FED_IMP_IOT0000005930": "東陵區",
        "P_YS_FED_IMP_IOT0000005933": "訥河市",
        "P_YS_FED_FW_0001384244": "每張圖片大小不可超過",
        "P_YS_PF_SOCD_0000089268": "也門",
        "P_YS_PF_SOCD_0000089269": "尼日爾",
        "P_YS_PF_SOCD_0000089266": "阿爾及利亞",
        "P_YS_PF_SOCD_0000089267": "斯洛伐克",
        "P_YS_PF_SOCD_0000089253": "埃塞俄比亞",
        "P_YS_FI_CM_0000029021": "跳至",
        "P_YS_PF_SOCD_0000089251": "老撾",
        "P_YS_PF_SOCD_0000089252": "摩納哥",
        "P_YS_FED_IMP_IOT0000010583": "保靖縣",
        "P_YS_FED_IMP_IOT0000005926": "融安縣",
        "P_YS_FED_IMP_IOT0000005925": "沂水縣",
        "P_YS_FED_IMP_IOT0000010586": "豐鎮市",
        "P_YS_FED_IMP_IOT0000010580": "站前區",
        "P_YS_FED_IMP_IOT0000010581": "樂昌市",
        "P_YS_FED_IMP_IOT0000010582": "三門峽",
        "P_YS_FED_IMP_IOT0000005920": "永年縣",
        "P_YS_FED_IMP_IOT0000010589": "雲陽縣",
        "P_YS_FED_IMP_IOT0000008197": "港口區",
        "P_YS_FED_FW_0001029632": "報價管理",
        "P_YS_PF_SOCD_0000089259": "安提瓜和巴布達",
        "P_YS_FED_IMP_IOT0000008195": "禮泉縣",
        "P_YS_FED_IMP_IOT0000008196": "銅陵縣",
        "P_YS_PF_SOCD_0000089257": "塞舌爾",
        "P_YS_PF_SOCD_0000089255": "印度",
        "P_YS_FED_IMP_IOT0000008199": "確山縣",
        "P_YS_PF_SOCD_0000089256": "聖盧西亞",
        "P_YS_PF_SOCD_0000089287": "布基納法索",
        "P_YS_PF_SOCD_0000089285": "洪都拉斯",
        "P_YS_PF_SOCD_0000089282": "列支敦士登",
        "P_YS_PF_SOCD_0000089283": "波多黎各",
        "P_YS_FED_IMP_IOT0000008192": "恩施市",
        "P_YS_FED_IMP_IOT0000005912": "岳麓區",
        "P_YS_FED_IMP_IOT0000005915": "豐滿區",
        "P_YS_FED_IMP_IOT0000010596": "昌邑市",
        "P_YS_FED_IMP_IOT0000010597": "利通區",
        "P_YS_FED_IMP_IOT0000010591": "東興市",
        "P_YS_FED_IMP_IOT0000005919": "淅川縣",
        "P_YS_FED_IMP_IOT0000005918": "忻城縣",
        "P_YS_FED_IMP_IOT0000010599": "磁縣",
        "P_YS_FED_IMP_IOT0000005911": "雨山區",
        "P_YS_FED_FW_1474274290590810117": "缺少 getConnectedDevice,方法丟失",
        "P_YS_FED_IMP_IOT0000005910": "魚峰區",
        "P_YS_FED_IMP_IOT0000008186": "沙河口區",
        "P_YS_FED_IMP_IOT0000008187": "河口瑤族自治縣",
        "P_YS_FED_IMP_IOT0000008184": "靖遠縣",
        "P_YS_PF_SOCD_0000089289": "沙特阿拉伯",
        "P_YS_PF_SOCD_0000089275": "土庫曼斯坦",
        "P_YS_PF_SOCD_0000089276": "關島",
        "P_YS_FED_IMP_IOT0000005909": "周寧縣",
        "P_YS_PF_SOCD_0000089274": "格魯吉亞",
        "P_YS_PF_SOCD_0000089271": "拉脫維亞",
        "P_YS_SD_UDHWN_0000122691": "物流單號：",
        "P_YS_PF_SOCD_0000089272": "喀麥隆",
        "P_YS_FED_UIMG_0001071360": "設計欄位不能設為必輸",
        "P_YS_PF_SOCD_0000089270": "格林納達",
        "P_YS_FED_IMP_IOT0000005902": "江川縣",
        "P_YS_FED_IMP_IOT0000005901": "望城縣",
        "P_YS_FED_FW_0001120581": "公共默認方案不可取消默認狀態",
        "P_YS_FED_IMP_IOT0000005904": "東豐縣",
        "P_YS_FED_IMP_IOT0000005903": "麻栗坡縣",
        "P_YS_FED_FW_0001204759": "】，請您參閱查看。",
        "P_YS_FED_FW_1474274290590810123": "getConnectedDevice success execute,但是未獲取到已連接設備",
        "P_YS_FED_FW_0001204758": "匯出已完成，文件名為【",
        "P_YS_FED_IMP_IOT0000005908": "全南縣",
        "P_YS_FED_FW_1474274290590810120": "不支持當前平臺,缺少必要方法",
        "P_YS_SD_SDOC_0000163474": "中華人民共和國",
        "P_YS_PF_SOCD_0000089279": "丹麥",
        "P_YS_PF_SOCD_0000089277": "坦桑尼亞",
        "P_YS_PF_SOCD_0000089278": "毛里求斯",
        "P_YS_FED_FW_1514390015376883745": "a ---直接填入資料",
        "P_YS_FED_FW_1514390015376883748": "&gt;=a ---大於等於a",
        "P_YS_FED_IMP_IOT0000008292": "新化縣",
        "P_YS_FED_IMP_IOT0000008290": "靈寶市",
        "P_YS_FED_IMP_IOT0000008291": "惠農區",
        "P_YS_FED_IMP_IOT0000010495": "長治縣",
        "P_YS_FED_FW_1616973608405958661": "的資料無操作權限",
        "P_YS_FED_IMP_IOT0000010496": "九台市",
        "P_YS_PF_GZTSYS_0000013194": "工作台",
        "P_YS_FED_FW_1514390015376883742": "[a,b] ---大於或等於a小於或等於b",
        "P_YS_FED_IMP_IOT0000010492": "尖山區",
        "P_YS_FED_IMP_IOT0000010494": "進賢縣",
        "P_YS_OA_XTSPZX_0000034652": "排序",
        "P_YS_FED_FW_0000021399": "抵扣積分",
        "P_YS_FED_IMP_IOT0000008286": "三水區",
        "P_YS_FED_FW_0000021397": "贛州市",
        "P_YS_FED_IMP_IOT0000008283": "扎囊縣",
        "P_YS_FED_FW_0000021398": "eChartDisplay 散點圖地圖信息正確 return",
        "P_YS_FED_IMP_IOT0000008284": "湟中縣",
        "P_YS_OA_XTWENKU_0000035721": "項目名稱",
        "P_YS_FED_IMP_IOT0000008288": "綏陽縣",
        "P_YS_PF_SOCD_0000089297": "聖馬力諾",
        "P_YS_SD_URETAIL-UI_0001036607": "繼續添加",
        "P_YS_FED_FW_1514390015376883757": "(a,b] ---大於a小於或等於b",
        "P_YS_PF_SOCD_0000089298": "博茨瓦納",
        "P_YS_PF_SOCD_0000089295": "塞浦路斯",
        "P_YS_FED_IMP_IOT0000008282": "興義市",
        "P_YS_PF_SOCD_0000089291": "厄瓜多爾",
        "P_YS_PF_SOCD_0000089292": "玻利維亞",
        "P_YS_FED_IMP_IOT0000008280": "石鼓區",
        "P_YS_PF_SOCD_0000089290": "秘魯",
        "P_YS_FED_FW_1514390015376883751": "示例:大於2.5, 小於等於8.7,則輸入(2.5,8.7]",
        "P_YS_FED_FW_1514390015376883754": "範圍值輸入有誤，請按照正確格式輸入",
        "P_YS_FI_RA_0000071687": "已確認",
        "P_YS_FED_UCFBASEDOC_0000024997": "退貨原因",
        "P_YS_SD_URETAILF_0001154205": "請至少選擇一條單據",
        "P_YS_FED_IMP_IOT0000008279": "沙依巴克區",
        "P_YS_FED_UCFBASEDOC_0000024992": "錯誤信息",
        "P_YS_FED_IMP_IOT0000008277": "項城市",
        "P_YS_FED_FW_0000021380": "撫州市",
        "P_YS_FED_UCFBASEDOC_0000024990": "密碼",
        "P_YS_FED_FW_0000021381": "恩施土家族苗族自治州",
        "P_YS_HR_HRJQF_0000054647": "佔位",
        "P_YS_FED_FW_0000021384": "柳州市",
        "P_YS_FED_FW_0000021385": "eChartCommon UnionDimensionName 出錯。Err =",
        "P_YS_FED_FW_0000021382": "楚雄彝族自治州",
        "P_YS_FED_FW_0000021383": "需驗貨數量",
        "P_YS_FED_UCFBASEDOC_0000024989": "讀寫",
        "P_YS_FED_FW_0000021377": "餅形圖示例",
        "P_YS_FED_IMP_IOT0000008263": "鹽亭縣",
        "P_YS_FED_IMP_IOT0000009594": "新昌縣",
        "P_YS_FED_FW_0000021378": "潮州市",
        "P_YS_FED_IMP_IOT0000008264": "威遠縣",
        "P_YS_FED_FW_0000021375": "麗水市",
        "P_YS_FED_IMP_IOT0000009592": "安縣",
        "P_YS_FED_FW_0000021376": "中國",
        "P_YS_FED_UCFBASEDOC_0000024986": "匯入",
        "P_YS_FED_IMP_IOT0000008267": "即墨市",
        "P_YS_FED_IMP_IOT0000009598": "阿克蘇市",
        "P_YS_FED_UCFBASEDOC_0000024984": "提交",
        "P_YS_FED_IMP_IOT0000008268": "平樂縣",
        "P_YS_FED_FW_0000021379": "北京",
        "P_YS_FED_IMP_IOT0000008265": "宿城區",
        "P_YS_FED_UCFBASEDOC_0000024982": "不保存",
        "P_YS_HR_HRJQF_0000054641": "申請人",
        "P_YS_FED_IMP_IOT0000008266": "甘谷縣",
        "P_YS_FED_IMP_IOT0000009597": "漢南區",
        "P_YS_FED_FW_0000021391": "銷售淨額",
        "P_YS_FED_FW_0000021392": "條數據",
        "P_YS_FED_FW_0000021390": "南陽市",
        "P_YS_FED_FW_0000021395": "哈爾濱市",
        "P_YS_FED_FW_0000021396": "鄂爾多斯市",
        "P_YS_FED_IMP_IOT0000008260": "鏡湖區",
        "P_YS_FED_FW_0000021393": "台州市",
        "P_YS_FED_FW_0000021394": "承德市",
        "P_YS_FED_IMP_IOT0000009589": "鎮康縣",
        "P_YS_FED_FW_0000021388": "石家莊市",
        "P_YS_FED_IMP_IOT0000008252": "故城縣",
        "P_YS_FED_FW_0000021389": "珠海市",
        "P_YS_FED_IMP_IOT0000009584": "賓陽縣",
        "P_YS_FED_FW_0000021386": "宿州市",
        "P_YS_FED_IMP_IOT0000009581": "鳳泉區",
        "P_YS_FED_FW_0000021387": "阿克蘇地區",
        "P_YS_FED_IMP_IOT0000009582": "疏勒縣",
        "P_YS_FED_IMP_IOT0000009587": "光山縣",
        "P_YS_OA_XTWENKU_0000035713": "上傳",
        "P_YS_FED_IMP_IOT0000009586": "句容市",
        "P_YS_FI_CM_0000029097": "今天",
        "P_YS_FED_IMP_IOT0000008249": "辰溪縣",
        "P_YS_FED_IMP_IOT0000008247": "相山區",
        "P_YS_FED_IMP_IOT0000008248": "開原市",
        "P_YS_FED_IMP_IOT0000008241": "尤溪縣",
        "P_YS_SD_SDMB_0000147207": "《",
        "P_YS_FED_IMP_IOT0000009570": "雲溪區",
        "P_YS_FED_IMP_IOT0000008240": "天元區",
        "P_YS_FED_IMP_IOT0000009576": "東川區",
        "P_YS_FED_UCFBASEDOC_0000024962": "開單",
        "P_YS_FED_IMP_IOT0000009577": "崇川區",
        "P_YS_FED_IMP_IOT0000009574": "魚台縣",
        "P_YS_FED_UCFBASEDOC_0000024960": "發布",
        "P_YS_PF_PRINT_0000056755": "家庭住址",
        "P_YS_FED_IMP_IOT0000008236": "金城江區",
        "P_YS_FED_IMP_IOT0000009567": "道孚縣",
        "P_YS_FI_CM_0000030090": "獲取參數失敗：【接口】",
        "P_YS_FED_IMP_IOT0000008230": "棲霞區",
        "P_YS_FED_IMP_IOT0000009561": "封丘縣",
        "P_YS_FED_IMP_IOT0000009560": "沽源縣",
        "P_YS_SD_UDHBN_0001144941": "交期：",
        "P_YS_SD_UDHBN_0001144942": "單號：",
        "P_YS_FED_IMP_IOT0000009566": "電白縣",
        "P_YS_PF_PROCENTER_0000023211": "男",
        "P_DIWORK_YC_ORDER_0000061307": "生效成功",
        "P_YS_PF_PRINT_0000056726": "變更時間",
        "P_YS_FED_FW_1514390015376883724": "範圍值按以下格式書寫:",
        "P_YS_FI_IA_0000151381": "保存數據失敗",
        "P_YS_FED_FW_1514390015376883727": "&gt;a ---大於a",
        "P_YS_FED_FW_1514390015376883721": "[a,b) ---大於或等於a小於b",
        "P_YS_FED_IMP_IOT0000009558": "武進區",
        "P_YS_FED_UCFBASEDOC_0000024949": "門戶控件",
        "P_YS_FED_FW_0001194811": "您的點擊頻率過高，請耐心等待...",
        "P_YS_FED_IMP_IOT0000009550": "蘇尼特右旗",
        "P_YS_FED_IMP_IOT0000009551": "磐石市",
        "P_YS_FED_UCFBASEDOC_0000024942": "加入",
        "P_YS_FED_IMP_IOT0000009554": "徐水縣",
        "P_YS_FED_IMP_IOT0000008224": "九龍坡區",
        "P_YS_FED_IMP_IOT0000008221": "勐臘縣",
        "P_YS_FED_IMP_IOT0000009553": "澤庫縣",
        "P_YS_FED_FW_1514390015376883736": "(a,b) ---大於a小於b",
        "P_YS_FED_FW_1514390015376883739": "&lt;b ---小於b",
        "P_YS_FED_FW_1514390015376883730": "&lt;=b ---小於等於b",
        "P_YS_FED_FW_1514390015376883733": "範圍值輸入有誤，左值需小於右值！",
        "P_YS_FED_IMP_IOT0000008217": "大餘縣",
        "P_YS_FED_IMP_IOT0000009548": "承德縣",
        "P_YS_FED_UCFBASEDOC_0000024939": "看板權限",
        "P_YS_FED_IMP_IOT0000009549": "安次區",
        "P_YS_FED_IMP_IOT0000009540": "阿壩縣",
        "P_YS_FED_IMP_IOT0000008212": "柳北區",
        "P_YS_FED_IMP_IOT0000009542": "涇陽縣",
        "P_YS_FED_EXAMP_0000020481": "保存成功！",
        "P_YS_FED_EXAMP_0000020480": "預訂交貨且“交貨時可修改商品”為否, 不允許執行退品",
        "P_YS_FED_EXAMP_0000020483": "卡券商品原單退貨,卡券數量應為-1",
        "P_YS_FED_EXAMP_0000020482": "預訂時未使用會員錢包支付, 退訂時不允許使用會員錢包支付",
        "P_YS_FED_FW_0000021319": "商品條碼：",
        "P_YS_FED_EXAMP_0000020478": "歸屬門店",
        "P_YS_FED_IMP_IOT0000008205": "林口縣",
        "P_YS_FED_EXAMP_0000020477": "將替換所有行營業員，是否繼續！",
        "P_YS_FED_FW_0000021317": "移動報表 MobileData Render",
        "P_YS_FED_FW_0000021318": "連雲港市",
        "P_YS_FED_EXAMP_0000020479": "富文本編輯器",
        "P_YS_FED_IMP_IOT0000008204": "瓊山區",
        "P_YS_FED_EXAMP_0000020474": "聯繫人：",
        "P_YS_FED_IMP_IOT0000008209": "長寧區",
        "P_YS_FED_EXAMP_0000020473": "錯：",
        "P_YS_FED_EXAMP_0000020476": "退貨",
        "P_YS_FED_IMP_IOT0000008207": "紫金縣",
        "P_YS_FED_IMP_IOT0000009538": "永定區",
        "P_YS_FED_EXAMP_0000020475": "預訂交貨且“交貨時可修改商品”為否, 不允許會員錢包結算",
        "P_YS_FED_IMP_IOT0000008208": "郊區",
        "P_YS_FED_IMP_IOT0000009539": "南潯區",
        "P_YS_FED_FW_0000021311": "張家界市",
        "P_YS_FED_FW_0000021312": "不限",
        "P_YS_FED_FW_0000021310": "侯厲害窮神卡（塑料會員）（普通會員）",
        "P_YS_FED_FW_0000021315": "郴州市",
        "P_YS_FED_FW_0000021316": "選擇數量超過上傳限制，請重新上傳！",
        "P_YS_FED_IMP_IOT0000008202": "天甯區",
        "P_YS_FED_IMP_IOT0000009533": "西山區",
        "P_YS_FED_FW_0000021313": "保存為圖片",
        "P_YS_FED_FW_0000021314": "參照",
        "P_YS_FED_IMP_IOT0000008200": "新平彞族傣族自治縣",
        "P_YS_FED_IMP_IOT0000009531": "尖扎縣",
        "P_YS_OA_XTLCZX_0000030786": "全部數據",
        "P_YS_FED_FW_0000021330": "邢台市",
        "P_YS_FED_EXAMP_0000020492": "贈品狀態不允許執行",
        "P_YS_FED_EXAMP_0000020494": "U訂貨上架數 :",
        "P_YS_FED_EXAMP_0000020493": "原單退貨中，換貨行不允許修改數量！",
        "P_YS_FED_FW_0001247825": "交互規則>>>",
        "P_YS_FED_EXAMP_0000020490": "權限範圍",
        "P_YS_FED_EXAMP_0000020489": "已經執行了現場折扣,不允許改數量！",
        "P_YS_PF_GZTSYS_0000013119": "用戶管理",
        "P_YS_FED_EXAMP_0000020488": "請檢查儲值卡是否正確有效",
        "P_YS_FED_IMP_IOT0000009526": "同安區",
        "P_YS_FED_FW_0000021328": "烏魯木齊市",
        "P_YS_PF_GZTSYS_0000015779": "商品",
        "P_YS_FED_IMP_IOT0000009523": "烏審旗",
        "P_YS_FED_FW_0000021329": "安康市",
        "P_YS_FED_EXAMP_0000020484": "未找到對應商品信息",
        "P_YS_FED_EXAMP_0000020487": "未錄入第",
        "P_YS_FED_IMP_IOT0000009527": "廣昌縣",
        "P_YS_FED_EXAMP_0000020486": "的商品行",
        "P_YS_FED_FW_0000021322": "徐州市",
        "P_YS_FED_FW_0000021323": "綿陽市",
        "P_YS_FED_FW_0000021320": "七台河市",
        "P_YS_FED_FW_0000021321": "達州市",
        "P_YS_OA_XTLCZX_0000030776": "正常",
        "P_YS_FED_FW_0000021326": "安陽市",
        "P_YS_FED_FW_0000021327": "零售金額",
        "P_YS_FED_IMP_IOT0000009522": "衢江區",
        "P_YS_FED_FW_0000021324": "阿拉善盟",
        "P_YS_FED_FW_0000021325": "廈門市",
        "P_YS_OA_XTLCZX_0000030790": "手動輸入",
        "P_YS_FED_EXAMP_0000020499": "改零售價",
        "P_YS_FED_IMP_IOT0000009515": "金秀瑤族自治縣",
        "P_YS_YYGJFW_YBUC_0001335796": "快捷鍵",
        "P_YS_FED_IMP_IOT0000009513": "博山區",
        "P_YS_FED_EXAMP_0000020496": "已經執行了促銷活動,不允許修改商品數量！",
        "P_YS_FED_EXAMP_0000020495": "支付。執行線上撤銷？",
        "P_YS_FED_EXAMP_0000020498": "儲值卡非原單退",
        "P_YS_FED_IMP_IOT0000009516": "萬源市",
        "P_YS_FED_EXAMP_0000020497": "獲取商品規格失敗。信息:",
        "P_YS_FED_IMP_IOT0000009510": "永德縣",
        "P_YS_FED_IMP_IOT0000009509": "固安縣",
        "P_YS_FED_FW_0000021308": "運城市",
        "P_YS_FED_FW_0000021309": "池州市",
        "P_YS_FED_FW_0000021306": "新疆",
        "P_YS_FED_IMP_IOT0000009501": "新興區",
        "P_YS_FED_FW_0000021307": "，支持格式：PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF",
        "P_YS_FED_IMP_IOT0000009502": "井岡山市",
        "P_YS_FED_IMP_IOT0000009507": "新絳縣",
        "P_YS_FED_FW_0000021300": "駐馬店市",
        "P_YS_FED_FW_0000021301": "subConfigArray_Operate  沒有找到對應的eChart  chartKey =",
        "P_YS_PF_PROCENTER_0000023238": "請至少選擇一條資料",
        "P_YS_FED_FW_0000021304": "陝西",
        "P_YS_FED_FW_0000021305": "青島市",
        "P_YS_FED_FW_0000021302": "興安盟",
        "P_YS_FED_FW_0000021303": "delete參數格式應為Array或者String",
        "P_YS_FED_FW_0000021362": "鄭州市",
        "P_YS_FED_FW_0000021363": "平涼市",
        "P_YS_FED_FW_0000021360": "老板模板",
        "P_YS_FED_FW_0000021361": "淮南市",
        "P_YS_OA_XTSPZX_0000034691": "提交人",
        "P_YS_FED_EXAMP_0000020434": "交貨不能修改商品時，不允許刪除商品！",
        "P_YS_FED_FW_0001253699": "[mdf-metaui-web] [CellModel] [RemodelingCell()] RemodelingFormatControl()返回用於顯示的text ==>",
        "P_YS_FED_FW_0001253698": "參照回顯字段",
        "P_YS_FED_EXAMP_0000020436": "零售",
        "P_YS_FED_EXAMP_0000020435": "POS退款成功",
        "P_YS_FED_EXAMP_0000020430": "選擇倉庫",
        "P_YS_FED_FW_0001253695": "加載查詢方案組件componentDidMount開始",
        "P_YS_FED_FW_0001253694": "]型別的模板",
        "P_YS_FED_EXAMP_0000020432": "預訂且“交貨時可修改商品”為是, 不允許會員錢包結算",
        "P_YS_FED_FW_0001253697": "PrintButton: 缺少printDomain設置",
        "P_YS_FED_EXAMP_0000020431": "採購訂單不能增加非自採商品!",
        "P_YS_FED_FW_0001253696": "配置資訊失敗。",
        "P_YS_FED_FW_0000021355": "圖表不能正常顯示，需要 report/getGroupSetting(獲取報表分組方案的詳細設置進行顯示) 返回的配置資訊中 _.isEmpty(json.data.chartConfig) == false",
        "P_YS_FED_FW_0000021356": "夜班",
        "P_YS_FED_FW_0000021353": "保存多條數據失敗！",
        "P_YS_FED_FW_0000021354": "六盤水市",
        "P_YS_SD_SDMB_0000137806": "”",
        "P_YS_FED_FW_0000021359": "江蘇",
        "P_YS_FED_EXAMP_0000020438": "交貨不能修改商品時,不允許修改營業員！",
        "P_YS_FED_EXAMP_0000020437": "未生成",
        "P_YS_FED_FW_0000021357": "吉林市",
        "P_YS_FED_FW_0000021358": "臨滄市",
        "P_YS_FED_EXAMP_0000020439": ",實際子表抹零合計：",
        "P_YS_FED_FW_0000021370": "移動報表 MobileReportSum Render",
        "P_YS_FED_FW_0000021373": "丹東市",
        "P_YS_FED_FW_0000021374": "神秘黑色",
        "P_YS_SD_UDHMC_0000051115": "下次再說",
        "P_YS_FED_FW_0000021371": "天水市",
        "P_YS_FED_FW_0000021372": "西寧市",
        "P_YS_FED_EXAMP_0000020450": "電商訂單",
        "P_YS_FED_EXAMP_0000020445": "錢包不適用全部商品, 不能快速結算",
        "P_YS_FED_EXAMP_0000020444": "（房間號）與預訂的房間號",
        "P_YS_FED_EXAMP_0000020447": "商品單價不能小於0！",
        "P_YS_FED_EXAMP_0000020446": "本單實收金額為0，請進行確認！",
        "P_YS_FED_EXAMP_0000020441": "非原單退不能使用會員多錢包支付",
        "P_YS_FED_EXAMP_0000020440": "未審核",
        "P_YS_PF_GZTSYS_0000013159": "報價",
        "P_YS_FED_EXAMP_0000020443": "手機號/會員號",
        "P_YS_FED_EXAMP_0000020442": "無可用會員錢包",
        "P_YS_FED_FW_0000021366": "溫州市",
        "P_YS_FED_FW_0000021367": "馬鞍山市",
        "P_YS_FED_FW_0001350929": "點聚合",
        "P_YS_FED_FW_0000021364": "衡水市",
        "P_YS_FED_FW_0000021365": "平頂山市",
        "P_YS_FED_EXAMP_0000020449": "歡迎登錄",
        "P_YS_FED_EXAMP_0000020448": "此帳號沒有該折扣的權限",
        "P_YS_FED_FW_0000021368": "甘肅",
        "P_YS_FED_FW_0000021369": "四川",
        "P_YS_FED_FW_0001350931": "2列",
        "P_YS_FED_FW_0001350932": "展示列數",
        "P_YS_FED_FW_0000021340": "嘉峪關市",
        "P_YS_OA_XTLCZX_0000030753": "未開始",
        "P_YS_FED_FW_0000021341": "刪除數據失敗",
        "P_YS_OA_XTLCZX_0000030752": "定位",
        "P_YS_FED_FW_0001253680": "加載查詢方案組件componentDidMount結束",
        "P_YS_FED_EXAMP_0000020461": "修改密碼成功！",
        "P_YS_PF_GZTSYS_0000015793": "組織機構",
        "P_YS_FED_FW_0001253682": "[mdf-metaui-web] [amap] [setValue()] saveType為json時，setValue(value)的參數value不是一個有效的JSONString",
        "P_YS_FED_EXAMP_0000020460": "市場價",
        "P_YS_FED_FW_0001253681": "，相容返回空字元串! text is",
        "P_YS_PF_GZTSYS_0000015790": "店員",
        "P_YS_FED_FW_0001350930": "1列",
        "P_YS_FED_EXAMP_0000020456": "調整狀態不允許修改商品行數量！",
        "P_YS_FED_FW_0001253677": "按鈕點擊，調用ConvenientQuery組件內部buttonClick方法開始",
        "P_YS_FED_EXAMP_0000020455": "回收品不允許修改數量！",
        "P_YS_FED_FW_0001253676": "InputIdentity [onBlur] canBubbleBlur == true,繼續冒泡blur事件",
        "P_YS_FED_FW_0000021339": "揚州市",
        "P_YS_FED_EXAMP_0000020458": "商品屬性",
        "P_YS_FED_FW_0001253679": "InputIdentity [onBlur] canBubbleBlur == false, 不冒泡blur事件",
        "P_YS_FED_EXAMP_0000020457": "本店自提",
        "P_YS_FED_FW_0001253678": "二維表第",
        "P_YS_FED_EXAMP_0000020452": "信息修改失敗！！",
        "P_YS_FED_FW_0001253673": "PrintButton: 缺少user資訊",
        "P_YS_PF_GZTSYS_0000015787": "查詢",
        "P_YS_FED_EXAMP_0000020451": "選擇地區",
        "P_YS_FED_FW_0001253672": "得到UI元數據，開始執行setState",
        "P_YS_PF_GZTLOG_0000028817": "請求失敗",
        "P_YS_FED_FW_0001253675": "領域為[",
        "P_YS_FED_EXAMP_0000020453": "電商退貨",
        "P_YS_FED_FW_0001253674": "加載查詢方案組件構造函數結束",
        "P_YS_FED_FW_0000021333": "堆疊柱形圖示例",
        "P_YS_FED_FW_0000021334": "看板配置信息-模塊配置-天氣",
        "P_YS_FED_FW_0000021331": "老闆大屏看板",
        "P_YS_FED_FW_0000021332": "空數據",
        "P_YS_FED_FW_0000021337": "橫",
        "P_YS_FED_FW_0000021338": "浙江",
        "P_YS_FED_EXAMP_0000020459": "重量小數位",
        "P_YS_OA_XTLCZX_0000030749": "年-月-日 時:分",
        "P_YS_FED_FW_0000021335": "遵義市",
        "P_YS_OA_XTLCZX_0000030748": "待選欄位",
        "P_YS_FED_FW_1463482661291950083": "加密文本長度小於加密起始位(encryptStart),加密數量(encryptCount)兩者相加長度,不在加密",
        "P_YS_FED_FW_0000021336": "果洛藏族自治州",
        "P_YS_FED_FW_1463482661291950080": "加密規則配置錯誤,加密起始位(encryptStart),加密數量(encryptCount)不能同時為負數,不在加密",
        "P_YS_FED_FW_0000021351": "重慶",
        "P_YS_FED_FW_0000021352": "婁底市",
        "P_YS_FED_FW_0000021350": "曲靖市",
        "P_YS_FED_EXAMP_0000020470": "正在開發中，敬請期待！",
        "P_YS_FED_FW_0001253691": "[mdf-metaui-web] [CellModel] RemodelingFormatControl() case map時，無法處理的數據，text is",
        "P_YS_FED_FW_0001253690": "得到UI元數據，結束執行setState",
        "P_YS_FED_FW_0001253693": "[mdf-cube] [getCellDataByCtrlType()] 不規範數據的map數據，相容處理時沒有合法的屬性address, 返回空字元串，text ==>",
        "P_YS_FED_EXAMP_0000020471": "預訂退訂狀態下不能新增商品！",
        "P_YS_FED_FW_0001253692": "按鈕點擊，調用ConvenientQuery組件內部buttonClick方法結束",
        "P_YS_FED_FW_0001265659": "顯示角度y軸",
        "P_YS_FED_EXAMP_0000020467": "預訂且“交貨時可修改商品”為是, 不允許儲值卡結算",
        "P_YS_FED_FW_0001253688": "]菜單服務，",
        "P_YS_FED_FW_0001253687": "行存在重複行標題",
        "P_YS_FED_EXAMP_0000020469": "該商品行不允許修改零售價！",
        "P_YS_FED_EXAMP_0000020468": "必輸！",
        "P_YS_FED_FW_0001253689": "加載查詢方案組件構造函數開始",
        "P_YS_FED_EXAMP_0000020463": "兌換券",
        "P_YS_FED_FW_0001253684": "配置資訊不全，請檢查。",
        "P_YS_FED_EXAMP_0000020462": "清空",
        "P_YS_FED_FW_0001253683": "支持excel格式檔、單檔；單個檔的大小限制不超過50MB，不超過5萬條數據",
        "P_YS_FED_EXAMP_0000020465": "輸入框不能為空!",
        "P_YS_FED_FW_0001253686": "該組織無參照編碼",
        "P_YS_FED_EXAMP_0000020464": "已交貨",
        "P_YS_FED_FW_0001253685": "[mdf-cube] [getCellDataByCtrlType()] 不規範數據的map數據，正在嘗試相容處理，text ==>",
        "P_YS_FED_FW_0000021344": "慶陽市",
        "P_YS_FED_FW_0000021345": "曲線圖示例",
        "P_YS_FED_FW_0000021342": "沒有更多數據了~",
        "P_YS_FED_FW_0001136114": "node端",
        "P_YS_FED_FW_0001265660": "顯示角度x軸",
        "P_YS_FED_FW_0000021343": "選擇文件格式不正確，請重新選擇！",
        "P_YS_FED_FW_0001265661": "顯示角度應該在-90-90之間",
        "P_YS_FED_FW_0000021348": "牡丹江市",
        "P_YS_FED_FW_0000021349": "鄂州市",
        "P_YS_FED_FW_0000021346": "銅陵市",
        "P_YS_FED_FW_0000021347": "南昌市",
        "P_YS_FI_ETL_0000111662": "網絡",
        "P_YS_FED_FW_0001073815": "中甸市",
        "P_YS_FED_FW_0001073814": "都均市",
        "P_YS_FED_FW_0001073813": "順德市",
        "P_YS_FED_FW_0001073812": "萬縣市",
        "P_YS_FED_FW_0001073811": "渾江市",
        "P_YS_SD_UDHWN_0000048223": "屯昌縣",
        "P_YS_FED_FW_0001073810": "德令哈",
        "P_YS_FED_FW_0001073819": "荊沙市",
        "P_YS_FED_FW_0001073818": "潮陽市",
        "P_YS_FED_FW_0001073817": "貴池市",
        "P_YS_FED_FW_0001073816": "海拉爾",
        "P_YS_SD_UDHWN_0001008650": "橫向選擇",
        "P_YS_SD_UDHWN_0000049569": "奉賢區",
        "P_YS_HR_HRFZ-UI_1474270717181689857": "UI模板ID",
        "P_YS_FED_FW_0001073826": "黃州市",
        "P_YS_FED_FW_0001073825": "東川市",
        "P_YS_FED_FW_0001073824": "隨棗市",
        "P_YS_FED_FW_0001073823": "臨川市",
        "P_YS_SD_UDHWN_0000049565": "百度地圖",
        "P_YS_FED_FW_0001073822": "瑪沁市",
        "P_YS_FED_FW_0001073821": "淮坊市",
        "P_YS_FED_FW_0001073820": "甘南州",
        "P_YS_FED_FW_0000088641": "請選擇左側樹節點",
        "P_YS_FED_EXAMP_0000020401": "修改密碼",
        "P_YS_FED_EXAMP_0000020400": "體驗帳戶信息錯誤！",
        "P_YS_FED_EXAMP_0000020403": "套餐商品未錄入完畢,不允許執行積分抵扣",
        "P_YS_FED_EXAMP_0000020402": "儲值",
        "P_YS_FED_EXAMP_0000020409": "售後",
        "P_YS_FED_FW_0001112266": "]的商品",
        "P_YS_FED_EXAMP_0000020408": "未取到該儲值卡號對應實體卡的初始價格",
        "P_YS_FED_EXAMP_0000020405": "生日",
        "P_YS_FED_EXAMP_0000020404": "--次日",
        "P_YS_FED_EXAMP_0000020407": "未獲取到重量，請檢查托盤是否放置正確！",
        "P_YS_FED_EXAMP_0000020406": "舊密碼",
        "P_YS_FED_FW_0001149575": "最多設置十個搜索列！",
        "P_YS_FED_FW_0001097806": "，結果：",
        "P_YS_FED_EXAMP_0000020412": "調整狀態不允許修改數量！",
        "P_YS_FED_EXAMP_0000020411": "建議零售價",
        "P_YS_PF_AUTHF_0000096105": "待選",
        "P_YS_FED_EXAMP_0000020414": "當前網絡不可用，不能銷售有效期管理的商品！",
        "P_YS_FED_EXAMP_0000020413": "立即體驗",
        "P_YS_FED_FW_0001097807": "當前平台：",
        "P_YS_FED_EXAMP_0000020410": "請先設置默認的支付方式",
        "P_YS_FI_CM_0000029118": "單據狀態",
        "P_YS_FED_EXAMP_0000020419": "儲值卡非原單退不允許修改數量",
        "P_YS_FED_EXAMP_0000020416": "商品中心",
        "P_YS_FED_EXAMP_0000020415": "未取得門店信息!",
        "P_YS_FED_EXAMP_0000020418": "已存在該序列號的商品！",
        "P_YS_FED_EXAMP_0000020417": "業務功能菜單(可調試)",
        "P_YS_PLM_PLM-GDS-UI_0001095906": "查看歷史",
        "P_YS_HR_HRJQ_0000031525": "張三",
        "P_YS_FED_FW_0001149583": "未來",
        "P_YS_FED_EXAMP_0000020423": "零售開單校驗失敗：未登錄到門店，不能開單",
        "P_YS_FED_EXAMP_0000020422": "當前商品不允許開單改價",
        "P_YS_FED_EXAMP_0000020425": "下不能進行預訂",
        "P_YS_FED_EXAMP_0000020424": "錄入電子卡券商品時請先登錄會員！",
        "P_YS_SD_DGYL-FE_1541228913807589381": "請配置移動模板",
        "P_YS_FED_EXAMP_0000020421": "請選擇商品明細！",
        "P_YS_FED_EXAMP_0000020420": "此模式下無法進行雲打印,請重新設置！！",
        "P_YS_FED_EXAMP_0000020427": "改數量",
        "P_YS_FED_EXAMP_0000020426": "詳細地址",
        "P_YS_FED_EXAMP_0000020429": "售卡狀態不允許添加非實體儲值卡商品行！",
        "P_YS_FED_EXAMP_0000020428": ")啟用了效期管理，請輸入效期！",
        "P_YS_FED_FW_0001367630": "無(計數)",
        "P_YS_SD_UDHWN_0000050500": "昌江黎族自治縣",
        "P_YS_FED_FW_0001367631": "聚合欄位",
        "P_YS_PLM_GDS-BE_0001160301": "上傳錯誤",
        "P_YS_FED_FW_0000021517": "移動報表 MobileFilter Render",
        "P_YS_FED_FW_0000021518": "看板配置信息-桌面",
        "P_YS_FED_IMP_IOT0000011702": "鳳縣",
        "P_YS_FED_FW_0001034253": "員工性別",
        "P_YS_FED_FW_0000021515": "北京市",
        "P_YS_FED_IMP_IOT0000011705": "豐台區",
        "P_YS_FED_FW_0001367629": "圖片欄位",
        "P_YS_FED_FW_0000021516": "巴彥淖爾市",
        "P_YS_FED_IMP_IOT0000005898": "北流市",
        "P_YS_FED_FW_0000021519": "無錫市",
        "P_YS_FED_FW_0001380601": "請錄入多語環境中的方案名稱",
        "P_YS_FED_FW_0000021510": "梧州市",
        "P_YS_FED_FW_0001100234": "該操作，對必輸項目<%=confirmMSGFields%>設置了隱藏，請再次確認",
        "P_YS_FED_FW_0001100235": "）設置了隱藏，請再次確認",
        "P_YS_FED_FW_0000021513": "錫林郭勒盟",
        "P_YS_FED_IMP_IOT0000005890": "阿拉善右旗",
        "P_YS_FED_IMP_IOT0000011707": "沙雅縣",
        "P_YS_FED_FW_0000021514": "滄州市",
        "P_YS_FED_FW_0000021511": "三亞市",
        "P_YS_FED_FW_0000021512": "雅安市",
        "P_YS_FED_FW_0000110004": "僅支持<%=text%>格式",
        "P_YS_SCM_STOCK_0001230696": "掃碼刪除",
        "P_YS_FED_FW_0000021528": "氣泡圖示例",
        "P_YS_PF_GZTSUPPLIER_0001241184": "]，",
        "P_YS_FED_FW_0000021529": "安順市",
        "P_YS_FED_IMP_IOT0000011713": "楊浦區",
        "P_YS_FED_FW_0000021526": "廣東",
        "P_YS_FED_FW_0000021527": "瀘州市",
        "P_YS_FED_IMP_IOT0000011710": "永修縣",
        "P_YS_FED_IMP_IOT0000005886": "閔行區",
        "P_YS_FED_FW_0000021520": "棗莊市",
        "P_YS_FED_FW_0000021521": "保定市",
        "P_YS_FED_FW_0001367632": "切換聚合欄位",
        "P_YS_FED_FW_0000021524": "宜昌市",
        "P_YS_FED_IMP_IOT0000011718": "隆昌縣",
        "P_YS_FED_FW_0000021525": "克拉瑪依市",
        "P_YS_FED_IMP_IOT0000011717": "歷城區",
        "P_YS_FED_FW_0000021522": "確定要返回麼",
        "P_YS_FED_FW_0000021523": "遼寧",
        "P_YS_FED_IMP_IOT0000005880": "精河縣",
        "P_YS_FED_IMP_IOT0000011719": "長島縣",
        "P_YS_FED_FW_1456081762615033856": "選擇起止時間",
        "P_YS_PF_GZTTMP_0000075994": "在列表中",
        "P_YS_FED_FW_0001253831": "展開2級",
        "P_YS_FED_FW_0001253830": "展開3級",
        "P_YS_FED_IMP_IOT0000011727": "武邑縣",
        "P_YS_FED_FW_0001253833": "展開1級",
        "P_YS_FED_IMP_IOT0000005873": "莘縣",
        "P_YS_FED_IMP_IOT0000011726": "慶元縣",
        "P_YS_FED_FW_0001253832": "展開4級",
        "P_YS_FED_IMP_IOT0000011721": "江永縣",
        "P_YS_FED_IMP_IOT0000005877": "準格爾旗",
        "P_YS_FED_IMP_IOT0000011722": "葉縣",
        "P_YS_OA_XTWENKU_0000035585": "暫無數據",
        "P_YS_FED_IMP_IOT0000011729": "赤水市",
        "P_YS_FED_FW_0000111353": "行缺少附件id",
        "P_YS_FED_IMP_IOT0000005870": "西固區",
        "P_YS_FED_FW_0000111354": "附件管理只能單行顯示",
        "P_YS_FED_FW_0000111355": "表格為空",
        "P_YS_FED_FW_0000111356": "附件管理",
        "P_YS_FED_FW_0000111357": "必輸項",
        "P_YS_FED_FW_0000111358": "未輸入，請輸入完整再嘗試保存！",
        "P_YS_FED_FW_0000111359": "輸入數字的整數部分長度不能大於",
        "P_YS_FED_FW_0001073804": "西峰市",
        "P_YS_FED_IMP_IOT0000005869": "黃平縣",
        "P_YS_FED_FW_0001073803": "江漢市",
        "P_YS_FED_FW_0001073802": "加格達奇",
        "P_YS_FED_IMP_IOT0000011730": "阿魯科爾沁旗",
        "P_YS_FED_FW_0001073801": "六庫市",
        "P_YS_FED_FW_0001073800": "馬爾康",
        "P_YS_FED_FW_0000021506": "四平市",
        "P_YS_FED_IMP_IOT0000005861": "蓮都區",
        "P_YS_FED_FW_0000021507": "現銷",
        "P_YS_FED_IMP_IOT0000005860": "林芝縣",
        "P_YS_FED_FW_0000021504": "大理白族自治州",
        "P_YS_FED_IMP_IOT0000010406": "雨花台區",
        "P_YS_FED_FW_0000021505": "喀什地區",
        "P_YS_FED_FW_0001073809": "同仁市",
        "P_YS_FED_IMP_IOT0000005862": "豐城市",
        "P_YS_FED_IMP_IOT0000011737": "劍閣縣",
        "P_YS_FED_FW_0001073808": "共和市",
        "P_YS_OA_XTWENKU_0000035594": "正在上傳",
        "P_YS_FED_FW_0001073807": "淮陰市",
        "P_YS_FED_IMP_IOT0000005864": "下花園區",
        "P_YS_FED_IMP_IOT0000010401": "安丘市",
        "P_YS_FED_FW_0000021508": "氣泡圖配置信息-eChartSetting",
        "P_YS_FED_FW_0001073806": "烏蘭浩特",
        "P_YS_FED_IMP_IOT0000010402": "新源縣",
        "P_YS_FED_IMP_IOT0000011734": "龍海市",
        "P_YS_FED_FW_0000021509": "柱折圖配置信息-eChartSetting",
        "P_YS_FED_FW_0001073805": "涪陵市",
        "P_YS_FED_IMP_IOT0000005866": "桑日縣",
        "P_YS_FED_IMP_IOT0000011733": "湄潭縣",
        "P_YS_FED_FW_0000111360": "請配置文件地址",
        "P_YS_FED_FW_0000111361": "方案名稱不能重複",
        "P_YS_FED_FW_0000021502": "西安市",
        "P_YS_FED_FW_0000111362": "條件已添加",
        "P_YS_FED_FW_0000021503": "貴州",
        "P_YS_FED_IMP_IOT0000010409": "敘永縣",
        "P_YS_FED_IMP_IOT0000011739": "普洱哈尼族彝族自治縣",
        "P_YS_FED_FW_0000021500": "揭陽市",
        "P_YS_FED_FW_0000021501": "採購部",
        "P_YS_FI_CM_0000029174": "備註",
        "P_YS_FED_IMP_IOT0000005858": "臨川區",
        "P_YS_FED_IMP_IOT0000005857": "漣源市",
        "P_YS_FED_IMP_IOT0000011741": "涿鹿縣",
        "P_YS_FED_IMP_IOT0000005859": "開化縣",
        "P_YS_FED_IMP_IOT0000011740": "永吉縣",
        "P_YS_SD_SDMAUF_0001064722": "繁體",
        "P_YS_FED_FW_1502904499728023562": "上一行",
        "P_YS_FED_IMP_IOT0000011747": "香坊區",
        "P_YS_FED_IMP_IOT0000010416": "海門市",
        "P_YS_FED_IMP_IOT0000011746": "科爾沁區",
        "P_YS_FED_FW_0000154407": "command cParameter JSON格式錯誤-->",
        "P_YS_FED_IMP_IOT0000005853": "高州市",
        "P_YS_FED_IMP_IOT0000010412": "寶應縣",
        "P_YS_FED_IMP_IOT0000011742": "岳陽縣",
        "P_YS_PF_SOCD_0000089109": "加納",
        "P_YS_FED_IMP_IOT0000010413": "淮上區",
        "P_YS_FED_IMP_IOT0000011745": "汾西縣",
        "P_YS_FED_IMP_IOT0000010414": "富縣",
        "P_YS_FED_IMP_IOT0000011744": "輝南縣",
        "P_YS_PF_SOCD_0000089107": "貝寧",
        "P_YS_PF_SOCD_0000089105": "新西蘭",
        "P_YS_PF_SOCD_0000089106": "布隆迪",
        "P_YS_PF_SOCD_0000089103": "委內瑞拉",
        "P_YS_PF_SOCD_0000089104": "約旦",
        "P_YS_PF_SOCD_0000089101": "斯威士蘭",
        "P_YS_FED_FW_1502904499728023559": "下一行",
        "P_YS_FED_IMP_IOT0000005847": "井陘縣",
        "P_YS_FED_IMP_IOT0000005846": "牡丹江",
        "P_YS_SD_SDMA_0000038357": "已簽收",
        "P_YS_FED_IMP_IOT0000010420": "桐鄉市",
        "P_YS_FED_IMP_IOT0000005848": "響水縣",
        "P_YS_FED_IMP_IOT0000010426": "施甸縣",
        "P_YS_FED_IMP_IOT0000011758": "五蓮縣",
        "P_YS_FED_IMP_IOT0000005841": "振興區",
        "P_YS_FED_IMP_IOT0000010428": "叢台區",
        "P_YS_FED_FW_0001253822": "if 配置不正確",
        "P_YS_FED_IMP_IOT0000010423": "莫力達瓦達斡爾族自治旗",
        "P_YS_FED_IMP_IOT0000011753": "鉛山縣",
        "P_YS_FED_IMP_IOT0000010424": "瑪沁縣",
        "P_YS_FED_IMP_IOT0000005844": "農安縣",
        "P_YS_FED_FW_0001253828": "單據id屬性不存在，請檢查數據建模",
        "P_YS_FED_FW_0001253827": "條。失敗原因",
        "P_YS_FED_FW_0001253829": "isMdfMobile 判斷出錯",
        "P_YS_FED_FW_0001253824": "，請填寫完整！",
        "P_YS_FED_FW_0001253823": "子表：",
        "P_YS_FED_FW_0001253826": "if 不符合條件",
        "P_YS_FED_FW_0000130443": "將文件拖拽至此區域上傳",
        "P_YS_FED_FW_0001253825": "條數據？",
        "P_YS_PF_SOCD_0000089121": "烏茲別克斯坦",
        "P_YS_PF_SOCD_0000089122": "韓國",
        "P_YS_PF_SOCD_0000089120": "卡塔爾",
        "P_YS_SD_SDMB_0000148482": "通知時間",
        "P_YS_FI_CM_0000029191": "區域縮放還原",
        "P_YS_FED_IMP_IOT0000005835": "邵東縣",
        "P_YS_FED_IMP_IOT0000011760": "龍泉驛區",
        "P_YS_FED_IMP_IOT0000010431": "貢山獨龍族怒族自治縣",
        "P_YS_FED_IMP_IOT0000005839": "浠水縣",
        "P_YS_FED_IMP_IOT0000010437": "紅花崗區",
        "P_YS_SD_UDHWN_0000122549": "請輸入部門",
        "P_YS_FED_IMP_IOT0000010438": "高明區",
        "P_YS_FED_IMP_IOT0000011768": "南芬區",
        "P_YS_FED_FW_0000154428": "[{\"nameType\":\"text\",\"value\":\"菜單\",\"key\":\"menu\"},{\"nameType\":\"text\",\"value\":\"許可權\",\"key\":\"auth\"},{\"nameType\":\"text\",\"value\":\"按鈕許可權\",\"key\":\"actionAuth\"},{\"nameType\":\"text\",\"value\":\"規則\",\"key\":\"rule\"},{\"nameType\":\"text\",\"value\":\"選項\",\"key\":\"option\"},{\"nameType\":\"text\",\"value\":\"枚舉\",\"key\":\"enum\"},{\"nameType\":\"text\",\"value\":\"ViewModel\",\"key\":\"viewmodel\"}]",
        "P_YS_FED_IMP_IOT0000010439": "嶧城區",
        "P_YS_FI_RA_0000071633": "執行時間",
        "P_YS_FED_FW_0000116163": "確定刪除當前行麼",
        "P_YS_OA_XTWENKU_0000035540": "選擇日期",
        "P_YS_FED_FW_1610361428967424002": "檔案型別必須為excel格式",
        "P_YS_FED_FW_0000116162": "確定刪除分組麼",
        "P_YS_FED_IMP_IOT0000010435": "黔西縣",
        "P_YS_FED_IMP_IOT0000011767": "巨野縣",
        "P_YS_FED_IMP_IOT0000011766": "沂南縣",
        "P_YS_PF_SOCD_0000089128": "立陶宛",
        "P_YS_PF_SOCD_0000089125": "哥倫比亞",
        "P_YS_PF_SOCD_0000089126": "德國",
        "P_YS_PF_SOCD_0000089124": "巴林",
        "P_YS_PF_SOCD_0000089111": "挪威",
        "P_YS_FED_FW_0001647750": "<%=type%>已轉入後臺處理，可進行其他操作！",
        "P_YS_FED_IMP_IOT0000005825": "祁縣",
        "P_YS_FED_IMP_IOT0000011772": "滑縣",
        "P_YS_FED_FW_1516608649439477761": "預設是模板級設置，若用戶設置了列寬或欄位顯隱後，便為用戶級設置",
        "P_YS_FED_IMP_IOT0000011771": "漢濱區",
        "P_YS_FED_IMP_IOT0000010442": "鄧州市",
        "P_YS_FED_IMP_IOT0000011774": "廣平縣",
        "P_YS_FED_IMP_IOT0000005826": "東麗區",
        "P_YS_FED_IMP_IOT0000011773": "君山區",
        "P_YS_FED_FW_1516608649439477764": "點擊”恢復預設”則恢復到模板級設置",
        "P_YS_FED_IMP_IOT0000005829": "宜良縣",
        "P_YS_FED_IMP_IOT0000005828": "永泰縣",
        "P_YS_FED_IMP_IOT0000011779": "洞頭縣",
        "P_YS_FED_FW_1427569433243549702": "行標題不可為空。",
        "P_YS_FED_IMP_IOT0000005821": "吉隆縣",
        "P_YS_FED_IMP_IOT0000010444": "黑山縣",
        "P_YS_FED_IMP_IOT0000005820": "本溪滿族自治縣",
        "P_YS_FED_IMP_IOT0000011775": "措勤縣",
        "P_YS_FED_IMP_IOT0000010446": "旬邑縣",
        "P_YS_FED_IMP_IOT0000005822": "始興縣",
        "P_YS_FED_IMP_IOT0000010447": "臨海市",
        "P_YS_FED_IMP_IOT0000011777": "四會市",
        "P_YS_FED_FW_0000154412": "〖當前租戶型別〗：",
        "P_YS_FED_IMP_IOT0000008099": "紮賚特旗",
        "P_YS_PF_SOCD_0000089116": "納米比亞",
        "P_YS_FED_IMP_IOT0000008096": "龍里縣",
        "P_YS_PF_SOCD_0000089117": "特立尼達和多巴哥",
        "P_YS_FED_IMP_IOT0000008097": "憑祥市",
        "P_YS_OA_XTWENKU_0000035553": "上傳完成",
        "P_YS_PF_SOCD_0000089114": "阿根廷",
        "P_YS_PF_SOCD_0000089115": "摩爾多瓦",
        "P_YS_FED_FW_0001647748": "共處理<%=totalCount%>條數據，成功<%=sucessCount%>條數據，失敗<%=failCount%>條數據。",
        "P_YS_FED_FW_0000154413": "〖客戶端原始協議型別〗：",
        "P_YS_FED_FW_0001647749": "最多只展示<%=count%>條數據，查看更多請點擊右上角按鈕【<%=title%>】",
        "P_YS_FED_FW_0000154414": "〖當前系統客戶端型別〗：",
        "P_YS_PF_SOCD_0000089113": "直布羅陀",
        "P_YS_PF_SOCD_0000089141": "土耳其",
        "P_YS_FED_FW_1457429918499995648": "最多只可輸入",
        "P_YS_PF_SOCD_0000089142": "芬蘭",
        "P_YS_FED_IMP_IOT0000008094": "正藍旗",
        "P_YS_FED_IMP_IOT0000008095": "黎城縣",
        "P_YS_FED_FW_0000154450": "內容區寬度",
        "P_YS_FED_IMP_IOT0000008093": "運河區",
        "P_YS_FED_IMP_IOT0000005813": "江華瑤族自治縣",
        "P_YS_SD_UDHWN_0000048262": "薊縣",
        "P_YS_FED_IMP_IOT0000005818": "南華縣",
        "P_YS_FED_IMP_IOT0000011781": "象山區",
        "P_YS_FED_IMP_IOT0000005819": "安國市",
        "P_YS_FED_IMP_IOT0000010450": "建寧縣",
        "P_YS_FED_IMP_IOT0000010459": "永春縣",
        "P_YS_SD_UDHWN_0001009945": "%d 分鐘",
        "P_YS_FED_IMP_IOT0000005810": "莒縣",
        "P_YS_SD_UDHWN_0001008617": "保持選擇",
        "P_YS_FED_IMP_IOT0000010456": "方正縣",
        "P_YS_SD_UDHWN_0001009949": "1 天",
        "P_YS_FED_IMP_IOT0000010457": "紹興縣",
        "P_YS_FED_IMP_IOT0000011789": "獅子山區",
        "P_YS_FED_IMP_IOT0000005811": "蒼梧縣",
        "P_YS_FED_IMP_IOT0000008088": "綏濱縣",
        "P_YS_PF_SOCD_0000089149": "圭亞那",
        "P_YS_FED_IMP_IOT0000008085": "峽江縣",
        "P_YS_PF_PRINT_0000056908": "表頭自定義項24",
        "P_YS_FED_IMP_IOT0000008086": "貴溪市",
        "P_YS_SD_SDOC_0000165986": "提交失敗",
        "P_YS_PF_PRINT_0000056906": "表頭自定義項20",
        "P_YS_PF_PRINT_0000056905": "表頭自定義項21",
        "P_YS_PF_SOCD_0000089145": "比利時",
        "P_YS_FED_IMP_IOT0000008089": "靈璧縣",
        "P_YS_FI_ETL_0000111612": "引用參照",
        "P_YS_PF_SOCD_0000089133": "所羅門群島",
        "P_YS_PF_SOCD_0000089130": "英國",
        "P_YS_FI_CM_0000029140": "九月",
        "P_YS_PF_PRINT_0000056911": "表頭自定義項22",
        "P_YS_PF_SOCD_0000089131": "馬耳他",
        "P_YS_PF_PRINT_0000056910": "表頭自定義項23",
        "P_YS_FED_FW_0001097815": "當前訪問的是高德地圖API，公網才能訪問，專屬化環境訪問不到",
        "P_YS_FED_IMP_IOT0000005803": "息烽縣",
        "P_YS_FED_IMP_IOT0000010463": "達阪城區",
        "P_YS_FED_IMP_IOT0000010464": "皋蘭縣",
        "P_YS_FED_IMP_IOT0000011796": "富裕縣",
        "P_YS_FED_IMP_IOT0000011795": "霍城縣",
        "P_YS_FED_IMP_IOT0000005807": "洛川縣",
        "P_YS_FED_IMP_IOT0000011790": "瀾滄拉祜族自治縣",
        "P_YS_FED_IMP_IOT0000005809": "松陽縣",
        "P_YS_FED_IMP_IOT0000011792": "慶安縣",
        "P_YS_FED_IMP_IOT0000005808": "嘉陵區",
        "P_YS_FED_IMP_IOT0000011791": "古浪縣",
        "P_DIWORK_YC_ORDER_0000061269": "未關閉",
        "P_YS_FED_IMP_IOT0000011797": "秀城區",
        "P_YS_SD_SDOC_0000163330": "交易完成",
        "P_YS_FED_IMP_IOT0000005801": "宣威市",
        "P_YS_FED_IMP_IOT0000010468": "天台縣",
        "P_YS_FED_IMP_IOT0000011799": "曲周縣",
        "P_YS_FED_IMP_IOT0000008076": "拜泉縣",
        "P_YS_CRM_CRM-FE_0001319951": "交易類型:",
        "P_YS_PF_SOCD_0000089138": "加蓬",
        "P_YS_FED_IMP_IOT0000008074": "濉溪縣",
        "P_YS_FED_IMP_IOT0000008075": "蚌山區",
        "P_YS_PF_SOCD_0000089136": "馬爾代夫",
        "P_YS_PF_PRINT_0000056917": "是否隱藏",
        "P_YS_OA_XTWENKU_0000035536": "下載",
        "P_YS_PF_SOCD_0000089137": "意大利",
        "P_YS_PF_SOCD_0000089134": "瑞士",
        "P_YS_PF_SOCD_0000089135": "奧地利",
        "P_YS_FI_ETL_0000111601": "新增公式",
        "P_YS_PF_SOCD_0000089165": "阿曼",
        "P_YS_FED_FW_0001318684": "存在重複行，第",
        "P_YS_FED_FW_1570959055392342017": "網絡開小差了，請稍後再試",
        "P_YS_FED_IMP_IOT0000008072": "寧強縣",
        "P_YS_FED_IMP_IOT0000008073": "紅河縣",
        "P_YS_FED_IMP_IOT0000008070": "溪湖區",
        "P_YS_OA_XTWENKU_0000035509": "檔案名",
        "P_YS_FED_IMP_IOT0000010475": "黃埔區",
        "P_YS_FED_IMP_IOT0000010476": "蔚縣",
        "P_YS_FED_IMP_IOT0000010471": "濮陽縣",
        "P_YS_FED_IMP_IOT0000010472": "四方區",
        "P_YS_FED_IMP_IOT0000010477": "滿城縣",
        "P_YS_FED_IMP_IOT0000010479": "鄯善縣",
        "P_YS_PF_SOCD-E_0000277718": "多米尼加共和國",
        "P_YS_FED_IMP_IOT0000009396": "上蔡縣",
        "P_YS_FED_IMP_IOT0000009397": "臨武縣",
        "P_YS_SD_UDHWN_0000121240": "共計：",
        "P_YS_FED_IMP_IOT0000009395": "唐海縣",
        "P_YS_FED_FW_1570959055392342020": "服務出錯了，請稍後再試",
        "P_YS_PF_SOCD_0000089169": "盧森堡",
        "P_YS_FED_IMP_IOT0000008069": "米易縣",
        "P_YS_PF_SOCD_0000089167": "巴基斯坦",
        "P_YS_FED_IMP_IOT0000008067": "武穴市",
        "P_YS_FED_IMP_IOT0000009398": "南丹縣",
        "P_YS_FED_IMP_IOT0000008068": "龍門縣",
        "P_YS_PF_SOCD_0000089155": "巴巴多斯",
        "P_YS_PF_SOCD_0000089152": "利比亞",
        "P_YS_PF_SOCD_0000089153": "敘利亞",
        "P_YS_PF_SOCD_0000089150": "索馬裡",
        "P_YS_FED_IMP_IOT0000008061": "婺源縣",
        "P_YS_FED_IMP_IOT0000009392": "黃龍縣",
        "P_YS_PF_SOCD_0000089151": "埃及",
        "P_YS_FED_IMP_IOT0000009393": "深圳",
        "P_YS_FED_IMP_IOT0000008060": "遼陽縣",
        "P_YS_FED_IMP_IOT0000009391": "廣南縣",
        "P_YS_FED_FW_1587381824922845184": "已勾選“移動端展現”，請設置移動端布局？",
        "P_YS_FED_IMP_IOT0000010480": "江北區",
        "P_YS_FED_IMP_IOT0000010481": "潁上縣",
        "P_YS_FED_FW_0000154455": "navbar,點擊左側返回圖標的回調",
        "P_YS_FED_IMP_IOT0000009385": "霸州市",
        "P_YS_FED_FW_0000154456": "卡片頁",
        "P_YS_FED_FW_0000154453": "顯示數據為空",
        "P_YS_FED_IMP_IOT0000009383": "清徐縣",
        "P_YS_FED_FW_0000154454": "列表高度",
        "P_YS_FED_IMP_IOT0000008053": "烏伊嶺區",
        "P_YS_PF_SOCD_0000089158": "阿爾巴尼亞",
        "P_YS_FED_IMP_IOT0000008058": "石柱土家族自治縣",
        "P_YS_FED_IMP_IOT0000009389": "蒸湘區",
        "P_YS_PF_SOCD_0000089159": "蒙古",
        "P_YS_FED_IMP_IOT0000008059": "彝良縣",
        "P_YS_FED_FW_0001215524": "]的",
        "P_YS_PF_SOCD_0000089156": "愛爾蘭",
        "P_YS_FED_FW_0000154457": "內容區高度",
        "P_YS_PF_SOCD_0000089187": "墨西哥",
        "P_YS_FED_FW_1563508103188054030": "%c check前後[childrenField][index][cellName]=>",
        "P_YS_PF_SOCD_0000089188": "危地馬拉",
        "P_YS_PF_SOCD_0000089185": "以色列",
        "P_YS_FED_FW_1462036124903407616": "點此編輯長內容",
        "P_YS_PF_SOCD_0000089183": "湯加",
        "P_YS_PF_SOCD_0000089184": "吉布提",
        "P_YS_FED_FW_1563508103188054033": "%c 當前操作列和check觸發源是同一個欄位，觸發target為",
        "P_YS_PF_SOCD_0000089181": "安哥拉",
        "P_YS_OA_XTWENKU_0000035608": "模糊搜索",
        "P_YS_FED_FW_1563508103188054036": "的公式",
        "P_YS_PF_SOCD_0000089182": "庫克群島",
        "P_YS_FED_IMP_IOT0000010375": "範縣",
        "P_YS_FED_IMP_IOT0000010376": "古塔區",
        "P_YS_FED_IMP_IOT0000010372": "望奎縣",
        "P_YS_ZNBZ_BZBX-FE_0001141299": "借款合約",
        "P_YS_FED_IMP_IOT0000010378": "和田市",
        "P_YS_FED_FW_1563508103188054027": "欄位都無值，不觸發target為",
        "P_YS_FED_IMP_IOT0000008165": "刪除",
        "P_YS_FED_IMP_IOT0000009496": "托克托縣",
        "P_YS_FED_IMP_IOT0000008162": "確認要刪除嗎 ?",
        "P_YS_FED_IMP_IOT0000008163": "桃源縣",
        "P_YS_FED_IMP_IOT0000008168": "連山壯族瑤族自治縣",
        "P_YS_PF_SOCD_0000089189": "希臘",
        "P_YS_FED_IMP_IOT0000009497": "鶴峰縣",
        "P_YS_PF_SOCD_0000089177": "利比里亞",
        "P_YS_PF_SOCD_0000089174": "尼泊爾",
        "P_YS_PF_SOCD_0000089175": "羅馬尼亞",
        "P_YS_FED_FW_1563508103188054042": "%c 公式中沒有因子，觸發target為",
        "P_YS_PF_SOCD_0000089172": "哥斯達黎加",
        "P_YS_FED_IMP_IOT0000008160": "翠巒區",
        "P_YS_PF_SOCD_0000089173": "法屬圭亞那",
        "P_YS_FED_IMP_IOT0000008161": "天鎮縣",
        "P_YS_FED_IMP_IOT0000009492": "阜南縣",
        "P_YS_PF_SOCD_0000089170": "古巴",
        "P_YS_PF_SOCD_0000089171": "黎巴嫩",
        "P_YS_SD_URETAILF_0001131470": "請輸入搜索",
        "P_YS_FED_IMP_IOT0000009490": "寧縣",
        "P_YS_FED_IMP_IOT0000010385": "金鄉縣",
        "P_YS_SD_UDHBI_0000082840": "數據異常",
        "P_YS_FED_IMP_IOT0000010383": "石渠縣",
        "P_YS_FED_FW_0001318710": ")項",
        "P_YS_PF_GZTTMP_0000079419": "上一頁",
        "P_YS_FED_FW_0001318704": "<%=count%>單",
        "P_YS_FED_IMP_IOT0000008153": "三元區",
        "P_YS_FED_IMP_IOT0000009484": "增城市",
        "P_YS_FED_IMP_IOT0000008154": "仁壽縣",
        "P_YS_FED_IMP_IOT0000009485": "色達縣",
        "P_YS_FED_IMP_IOT0000008151": "白朗縣",
        "P_YS_FED_IMP_IOT0000009482": "安福縣",
        "P_YS_FED_IMP_IOT0000009483": "南樂縣",
        "P_YS_FED_FW_1563508103188054039": "%c 欄位觸發check，check前值為:",
        "P_YS_FED_IMP_IOT0000008157": "礦區",
        "P_YS_OA_XTWENKU_0000035613": "正在上傳",
        "P_YS_FED_IMP_IOT0000009489": "光澤縣",
        "P_YS_PF_SOCD_0000089178": "幾內亞",
        "P_YS_FED_IMP_IOT0000009486": "定陶縣",
        "P_YS_FED_IMP_IOT0000008156": "東方",
        "P_YS_FED_IMP_IOT0000009487": "簡陽市",
        "P_YS_FED_IMP_IOT0000010391": "獲嘉縣",
        "P_YS_FED_IMP_IOT0000009480": "永定縣",
        "P_YS_FED_IMP_IOT0000008150": "大英縣",
        "P_YS_FED_IMP_IOT0000010396": "市中區",
        "P_YS_FED_IMP_IOT0000010397": "宜豐縣",
        "P_YS_FED_IMP_IOT0000010392": "祁陽縣",
        "P_YS_FED_IMP_IOT0000010393": "周村區",
        "P_YS_FED_FW_0000021498": "堆疊條形圖示例",
        "P_YS_FI_YYFI-UI_0000161175": "發起討論",
        "P_YS_FED_FW_0001197167": "掃碼編輯",
        "P_YS_FED_FW_0000021499": "重置",
        "P_YS_FED_IMP_IOT0000008143": "甕安縣",
        "P_YS_FED_FW_0000021496": "臨汾市",
        "P_YS_FED_FW_0000021497": "岳陽市",
        "P_YS_FED_IMP_IOT0000008141": "港閘區",
        "P_YS_FED_IMP_IOT0000008146": "珙縣",
        "P_YS_FED_IMP_IOT0000008144": "楚雄市",
        "P_YS_PF_SOCD_0000089198": "保加利亞",
        "P_YS_PF_SOCD_0000089199": "匈牙利",
        "P_YS_FED_FW_1577614631207698483": "請輸入URL",
        "P_YS_FED_FW_1563508103188054021": "%c 公式中表體欄位公式等於表頭，觸發target為",
        "P_YS_PF_SOCD_0000089194": "亞美尼亞",
        "P_YS_FED_FW_1577614631207698480": "請輸入鏈接文本",
        "P_YS_PF_SOCD_0000089195": "捷克",
        "P_YS_FED_FW_1563508103188054024": "欄位值不一樣，觸發target為",
        "P_YS_PF_SOCD_0000089191": "阿富汗",
        "P_YS_ZNBZ_BZBX-FE_0001141291": "合約審批",
        "P_YS_ZNBZ_BZBX-FE_0001141295": "抵/質押合約",
        "P_YS_FED_IMP_IOT0000008137": "武川縣",
        "P_YS_FED_IMP_IOT0000008138": "永仁縣",
        "P_YS_FED_IMP_IOT0000009469": "特克斯縣",
        "P_YS_FED_FW_1563508103188054018": "欄位值一樣，不觸發target為",
        "P_YS_FED_IMP_IOT0000008130": "雙江拉祜族佤族布朗族傣族自治縣",
        "P_YS_FED_IMP_IOT0000009461": "赤坎區",
        "P_YS_FED_FW_1576845857814216711": "業務階段未結束，不允許打印！",
        "P_YS_FED_IMP_IOT0000009464": "仙遊縣",
        "P_YS_SCM_STOCK_0001145534": "編輯行",
        "P_YS_FED_IMP_IOT0000008128": "瑞金市",
        "P_YS_FED_IMP_IOT0000009459": "偏關縣",
        "P_YS_FED_IMP_IOT0000008129": "桐廬縣",
        "P_YS_FED_EXAMP_0000020397": "姓名",
        "P_YS_FED_EXAMP_0000020396": "套餐商品未錄入完畢,不允許執行優惠券",
        "P_YS_FED_EXAMP_0000020399": "請繼續支付",
        "P_YS_FED_EXAMP_0000020398": "應收金額:",
        "P_YS_FED_IMP_IOT0000009451": "圍場滿族蒙古族自治縣",
        "P_YS_FED_IMP_IOT0000008121": "竹溪縣",
        "P_YS_FED_IMP_IOT0000009452": "夏邑縣",
        "P_YS_FED_IMP_IOT0000009455": "金東區",
        "P_YS_FED_IMP_IOT0000009456": "嶗山區",
        "P_YS_FED_IMP_IOT0000009453": "竹山縣",
        "P_YS_FED_IMP_IOT0000008123": "巴南區",
        "P_YS_FED_IMP_IOT0000008117": "金山屯區",
        "P_YS_FED_IMP_IOT0000009448": "東湖區",
        "P_YS_FED_FW_0001084598": "cStyle解析錯誤:",
        "P_YS_FED_IMP_IOT0000009446": "順平縣",
        "P_YS_FED_IMP_IOT0000009447": "邯山區",
        "P_YS_FED_IMP_IOT0000008119": "點軍區",
        "P_YS_FED_IMP_IOT0000008113": "金平苗族瑤族傣族自治縣",
        "P_YS_FED_IMP_IOT0000009442": "玉州區",
        "P_YS_FED_IMP_IOT0000008112": "北寧市",
        "P_YS_FI_FIEFA-FE_1498230827983044620": "觀看視頻",
        "P_YS_FED_FW_0001083281": "渲染異常，可通過控制台查看異常信息!",
        "P_YS_FED_IMP_IOT0000008106": "井研縣",
        "P_YS_FED_IMP_IOT0000009437": "嘉善縣",
        "P_YS_FED_IMP_IOT0000008104": "石峰區",
        "P_YS_FED_IMP_IOT0000009435": "南譙區",
        "P_YS_FED_IMP_IOT0000009436": "高唐縣",
        "P_YS_FED_IMP_IOT0000008108": "小店區",
        "P_YS_FI_AP_0000072097": "憑證日期",
        "P_YS_FED_IMP_IOT0000009430": "烏拉特前旗",
        "P_YS_FED_IMP_IOT0000008102": "蕭山區",
        "P_YS_FED_IMP_IOT0000008103": "烏蘭縣",
        "P_YS_FED_IMP_IOT0000009431": "烏達區",
        "P_YS_FED_IMP_IOT0000008101": "宏偉區",
        "P_YS_FED_FW_0001260928": "列表共",
        "P_YS_FED_IMP_IOT0000009427": "東明縣",
        "P_YS_FED_FW_0001260926": "枚舉：值對象配置，比如表示性別的字段，有固定的值配置和選擇範圍，包括男、女。",
        "P_YS_FED_FW_0001260927": "參照：用來確認引用關係定義。比如：採購訂單上的管理組織字段，表示的是該字段選擇的數據範圍為對應組織檔案的內容。（是系統已存在的啟用狀態下的數據，需在系統內查找進行填寫）",
        "P_YS_FED_IMP_IOT0000009429": "梁園區",
        "P_YS_FED_IMP_IOT0000009423": "臨邑縣",
        "P_YS_FED_FW_1495277402289340422": "保存成功，未做任何修改",
        "P_YS_FED_IMP_IOT0000009421": "華容縣",
        "P_YS_FED_FW_1581884103568916483": "協作助手",
        "P_YS_PF_PROCENTER_0000023382": "銀行卡",
        "P_YS_IMP_PCC-UI_0001116011": "卡片頭部",
        "P_YS_FED_FW_0000021440": "晉城市",
        "P_YS_FED_EXAMP_0000020360": "資金收付",
        "P_YS_FED_EXAMP_0000020362": "請選擇SKU的值",
        "P_YS_FED_EXAMP_0000020361": "當前網絡不可用，不能銷售序列號管理的商品！",
        "P_YS_FED_FW_0001312565": "列配置有問題，可能會導致列印內容錯誤!",
        "P_YS_FED_EXAMP_0000020357": "請求服務地址有誤!",
        "P_YS_FED_IMP_IOT0000009415": "旌陽區",
        "P_YS_FED_FW_1423240990981357568": "這是最後一條數據啦, 沒有更多數據了",
        "P_YS_FED_IMP_IOT0000009416": "馬鞍山",
        "P_YS_FED_EXAMP_0000020356": "該卡號已經錄入, 請勿重複錄入",
        "P_YS_FED_FW_0000021438": "添加圖片",
        "P_YS_FED_EXAMP_0000020359": "當前操作員無刪行權限！是否使用其他 操作員的刪行權限？",
        "P_YS_FED_IMP_IOT0000009413": "吉州區",
        "P_YS_FED_FW_0000021439": "----------- 點擊事件 選擇區域 params.name =",
        "P_YS_FED_EXAMP_0000020358": "原因碼",
        "P_YS_FED_IMP_IOT0000009414": "長陽土家族自治縣",
        "P_YS_FED_EXAMP_0000020353": "調撥待出",
        "P_YS_FED_IMP_IOT0000009419": "湯旺河區",
        "P_YS_FED_EXAMP_0000020352": "儲值卡售卡不允許修改數量",
        "P_YS_FED_EXAMP_0000020355": "現場折扣",
        "P_YS_FED_IMP_IOT0000009417": "城中區",
        "P_YS_FED_EXAMP_0000020354": "測試成功",
        "P_YS_FED_FW_0000021432": "截斷後：",
        "P_YS_FED_FW_0000021433": "區域經理模板",
        "P_YS_SD_UDHMC_0000051023": "÷",
        "P_YS_FED_FW_0000021430": "錄入不合法~",
        "P_YS_FED_FW_0000021431": "排名表配置信息-eChartSetting",
        "P_YS_FED_FW_0000021436": "雲南",
        "P_YS_FED_FW_0000021437": "結束日期",
        "P_YS_FED_FW_0000021434": "廣西",
        "P_YS_FED_FW_0000021435": "肇慶市",
        "P_YS_FED_FW_0000021450": "商品詳情",
        "P_YS_FED_FW_0000021451": "（",
        "P_YS_FED_FW_1555410955943804936": "服務出錯了，別擔心，刷新試試吧~",
        "P_YS_FED_EXAMP_0000020371": "],請檢查!",
        "P_YS_FED_EXAMP_0000020370": "個規格)",
        "P_YS_FED_EXAMP_0000020373": "商品規格",
        "P_YS_FED_EXAMP_0000020372": "POS退款失敗",
        "P_YS_FED_FW_1502799547894071302": "無效數據，請從新選擇數據",
        "P_YS_FED_EXAMP_0000020368": "硬件適配方案未啟用儲值卡",
        "P_YS_FED_IMP_IOT0000009404": "盤山縣",
        "P_YS_FED_IMP_IOT0000009405": "太湖縣",
        "P_YS_FED_FW_0000021449": "蘇州市",
        "P_YS_FED_EXAMP_0000020369": "驗證成功",
        "P_YS_FED_IMP_IOT0000009403": "鳳台縣",
        "P_YS_FED_EXAMP_0000020363": "是否需要廚打？",
        "P_YS_FED_IMP_IOT0000009409": "隆回縣",
        "P_YS_FED_FW_1452018122265460736": "導出錯誤原因",
        "P_YS_FED_EXAMP_0000020366": "序列號商品行的序列號不能為空,請檢查!",
        "P_YS_FED_IMP_IOT0000009406": "富陽市",
        "P_YS_FED_EXAMP_0000020365": "商城未上架",
        "P_YS_FED_IMP_IOT0000009407": "烏拉特中旗",
        "P_YS_FED_FW_0000021443": "濟南市",
        "P_YS_FED_FW_0000021444": "圖",
        "P_YS_FED_FW_0000021441": "白城市",
        "P_YS_FED_FW_0000021442": "大慶市",
        "P_YS_OA_XTLCZX_0000030897": "收藏成功",
        "P_YS_FED_FW_0000021447": "巴中市",
        "P_YS_FED_FW_0000021448": "銅仁市",
        "P_YS_FED_FW_0000021445": "新餘市",
        "P_YS_FED_FW_0000021446": "已收款完畢",
        "P_YS_FED_FW_0000110058": "設置交叉點的editRowModel時，不能從為gridModel緩存中獲取EditRowModel_2D",
        "P_YS_FED_EXAMP_0000020382": "比率小數位",
        "P_YS_FED_EXAMP_0000020381": "原單退貨",
        "P_YS_FED_EXAMP_0000020384": "支付失敗，需撤銷杉德支付。執行線上撤銷？",
        "P_YS_FED_EXAMP_0000020383": "請輸入",
        "P_YS_FED_EXAMP_0000020380": "餘額",
        "P_YS_FED_FW_0000021418": "白銀市",
        "P_YS_FED_EXAMP_0000020379": ")改型說明必輸！",
        "P_YS_FED_FW_0000021419": "成功刪除",
        "P_YS_FED_EXAMP_0000020378": "子件商品不允許執行現場折扣",
        "P_YS_FED_FW_0000021416": "折線圖配置信息-eChartSetting",
        "P_YS_FED_FW_0000021417": "南平市",
        "P_YS_FED_EXAMP_0000020375": "已退訂",
        "P_YS_FED_EXAMP_0000020374": "抹零金額不正確，請檢查抹零金額！預計抹零金額為：",
        "P_YS_FED_EXAMP_0000020377": "等於",
        "P_YS_FED_EXAMP_0000020376": "支付金額不相等",
        "P_YS_FED_FW_0001527931": "包含同級",
        "P_YS_FED_FW_0000021410": "eChartCommon 更新過濾條件，去除裡面的空值 before param =",
        "P_YS_FED_FW_0000021411": "綏化市",
        "P_YS_FED_FW_1431347776103383040": "確認要刪除",
        "P_YS_FED_FW_0000021414": "海東地區",
        "P_YS_FED_FW_1431347776103383043": "嘛",
        "P_YS_FED_FW_0000021415": "移動報表  isVertical =",
        "P_YS_FED_FW_0000021412": "排名",
        "P_YS_FED_FW_0000021413": "梅州市",
        "P_YS_FED_EXAMP_0000020393": "套餐中有未選擇的商品",
        "P_YS_FED_EXAMP_0000020392": "現制",
        "P_YS_FED_EXAMP_0000020395": "搜索",
        "P_YS_FED_EXAMP_0000020394": "全部",
        "P_YS_FED_EXAMP_0000020391": "加載中...",
        "P_YS_FED_FW_0000021429": "呼和浩特市",
        "P_YS_FED_EXAMP_0000020389": "已有充值或消費記錄, 不能退卡",
        "P_YS_FED_FW_0000021427": "圖表不能正常顯示，需要 report/getGroupSetting(獲取報表分組方案的詳細設置進行顯示) 返回的配置資訊中 json.data.isCrossTable == false && (json.data.displayStyle == 2 || json.data.displayStyle == 3)",
        "P_YS_FED_FW_0000021428": "拉薩市",
        "P_YS_FED_EXAMP_0000020386": "已經執行了促銷活動，不允許執行積分抵扣！",
        "P_YS_FED_EXAMP_0000020385": "取消",
        "P_YS_FED_EXAMP_0000020388": "(我自己)",
        "P_YS_FED_EXAMP_0000020387": "查詢商品失敗",
        "P_YS_FED_FW_0000021421": "景德鎮市",
        "P_YS_FED_FW_0000021422": "巴音郭楞蒙古自治州",
        "P_YS_FED_FW_0000110072": "所有信息-一維表數據 getRows  length =",
        "P_YS_FED_FW_0000110073": "所有信息-二維表數據 getRows  length =",
        "P_YS_FED_FW_0000021420": "邯鄲市",
        "P_YS_FED_FW_0000021425": "山南地區",
        "P_YS_FED_FW_0000021426": "漢中市",
        "P_YS_FED_FW_0000021423": "豎",
        "P_YS_FED_FW_0000021424": "看板配置信息-模塊配置-日期時間",
        "P_YS_FED_FW_0000021480": "玉林市",
        "P_YS_FED_FW_0001515920": "三列佈局右",
        "P_YS_FED_FW_0001515921": "頭像上傳",
        "P_YS_FED_FW_0001515922": "按單表頭",
        "P_YS_FED_FW_0000021483": "濮陽市",
        "P_YS_FED_FW_0000021484": "氣泡值",
        "P_YS_FED_FW_0000021481": "條保存失敗",
        "P_YS_FED_FW_0000021482": "基本信息",
        "P_YS_FED_EXAMP_0000020313": ",請重新選擇時間！",
        "P_YS_FED_EXAMP_0000020312": "相應退貨productId下的rowkey",
        "P_YS_FED_EXAMP_0000020315": "生成卡券號範圍失敗,請檢查",
        "P_YS_FED_EXAMP_0000020314": "銷售日期不可大於當前日期。",
        "P_YS_FED_EXAMP_0000020311": ";房型:",
        "P_YS_FED_EXAMP_0000020310": "有識別到的商品在商品檔案沒匹配到!",
        "P_YS_FED_FW_0000021476": "山西",
        "P_YS_FED_FW_0001515916": "卡片面板",
        "P_YS_FED_FW_0000021477": "白山市",
        "P_YS_FED_FW_0001515917": "固定按鈕",
        "P_YS_FED_FW_0000021474": "韶關市",
        "P_YS_FED_FW_0001515918": "清單拓展項",
        "P_YS_FED_FW_0000021475": "選擇日期",
        "P_YS_FED_FW_0001515919": "頭部導航",
        "P_YS_FED_EXAMP_0000020317": "開始卡券號和結束卡券號必須同時錄入",
        "P_YS_FED_FW_0001515912": "試圖切換",
        "P_YS_FED_EXAMP_0000020316": "該門店未啟用儲值卡業務",
        "P_YS_FED_FW_0001515913": "html片段",
        "P_YS_FED_FW_0000021478": "雙鴨山市",
        "P_YS_FED_EXAMP_0000020319": "請輸入密碼",
        "P_YS_FED_FW_0001515914": "三列佈局中",
        "P_YS_FED_FW_0000021479": "黃山市",
        "P_YS_OA_XTLCZX_0000030846": "發起協作",
        "P_YS_FED_EXAMP_0000020318": "號",
        "P_YS_FED_FW_0001515915": "高德地圖",
        "P_YS_FED_FW_0000021490": "三門峽市",
        "P_YS_FED_FW_0000021491": "成都市",
        "P_YS_FED_FW_0001515910": "metaui-mobile元件庫",
        "P_YS_FED_FW_0001515911": "ys按鈕",
        "P_YS_FED_FW_0000021494": "福建",
        "P_YS_FED_FW_0000021495": "深圳市",
        "P_YS_FED_FW_0000021492": "IDB_saveData存儲操作成功，事務失敗！",
        "P_YS_SD_SDMBF_0000141915": "今",
        "P_YS_FED_FW_0000021493": "呼倫貝爾市",
        "P_YS_FED_EXAMP_0000020324": "展開剩餘",
        "P_YS_PF_YHTTNT-FE_0001045613": "所在行",
        "P_YS_FED_EXAMP_0000020323": "已經執行了商品促銷/秒殺，不能錄入會員！",
        "P_YS_FED_EXAMP_0000020326": "中關村店",
        "P_YS_FED_EXAMP_0000020325": "批發價",
        "P_YS_FED_EXAMP_0000020320": "同馬店",
        "P_YS_FED_FW_0001515909": "圖片展示",
        "P_YS_FED_EXAMP_0000020322": "權限管理維度",
        "P_YS_FED_EXAMP_0000020321": "售卡",
        "P_YS_FED_FW_0000021487": "樂山市",
        "P_YS_FED_FW_0000021488": "廣安市",
        "P_YS_FED_FW_0001515906": "ys固定按鈕",
        "P_YS_FED_FW_0000021485": "阜新市",
        "P_YS_FED_FW_0001515907": "卡片頭部組",
        "P_YS_FED_FW_0000021486": "南京市",
        "P_YS_FED_FW_0001515908": "掃碼子表",
        "P_YS_FED_EXAMP_0000020328": "狀態",
        "P_YS_FED_EXAMP_0000020327": "已經執行了促銷活動，不允許執行現場折扣！",
        "P_YS_FED_FW_0000021489": "鎮江市",
        "P_YS_FED_FW_1587986667977310214": "獲取推拉按鈕的信息失敗",
        "P_YS_FED_EXAMP_0000020329": "微信回調失敗：【接口】",
        "P_YS_FED_FW_0001515941": "ys主按鈕",
        "P_YS_FED_FW_0001515942": "三列佈局",
        "P_YS_FED_FW_0001078769": "欄位元數據配置錯誤！",
        "P_YS_FED_FW_0001515943": "附件按鈕",
        "P_YS_FED_FW_0000021461": "昌吉回族自治州",
        "P_YS_FED_FW_0000021462": "最多可上傳",
        "P_YS_FED_FW_0000021460": "黔南布依族苗族自治州",
        "P_YS_FED_FW_0001515940": "清單表頭",
        "P_YS_FED_EXAMP_0000020340": "當前行營業員“",
        "P_YS_FED_EXAMP_0000020334": "選擇",
        "P_YS_FED_EXAMP_0000020337": "會員錢包充值",
        "P_YS_FED_EXAMP_0000020336": "數量欄位請錄入小於零的數字。",
        "P_YS_FED_EXAMP_0000020331": "沒有商品地址",
        "P_YS_FED_FW_1505489468750561282": "長度限制",
        "P_YS_FED_EXAMP_0000020330": "),不得低於當前操作員工費折扣率下限(",
        "P_YS_FED_EXAMP_0000020333": "該商品行不允許執行退品！",
        "P_YS_FED_EXAMP_0000020332": "當前折扣率為(",
        "P_YS_FED_FW_0000021454": "淄博市",
        "P_YS_FED_FW_0001515938": "掃碼區域",
        "P_YS_FED_FW_0000021455": "表體數據為空！不允許保存！",
        "P_YS_OA_XTLCZX_0000030866": "發起協作流程",
        "P_YS_FED_FW_0001515939": "卡片面板項",
        "P_YS_FED_FW_0000021452": "）",
        "P_YS_FED_FW_0000021453": "宿遷市",
        "P_YS_FED_FW_0000021458": "鹽城市",
        "P_YS_FED_EXAMP_0000020339": "當前退貨行存在對應的換貨行，不能刪除!",
        "P_YS_FED_FW_0001515934": "ys子表分頁",
        "P_YS_FED_FW_0000021459": "阜陽市",
        "P_YS_FED_EXAMP_0000020338": "子件商品不允許執行退品！",
        "P_YS_FED_FW_0001515935": "ys附件按鈕",
        "P_YS_FED_FW_0000021456": "看板配置信息-模塊配置-常用功能",
        "P_YS_FED_FW_0001515936": "日曆面板",
        "P_YS_FED_FW_0000021457": "中油一建",
        "P_YS_FED_FW_0001515937": "按單子表",
        "P_YS_FED_FW_0001515930": "純文字項",
        "P_YS_FED_FW_0001515931": "日期下拉分組",
        "P_YS_FED_FW_0001515932": "ys卡片頭部",
        "P_YS_FED_FW_0001515933": "鏈接(撥打電話)",
        "P_YS_FED_FW_0000021472": "模板C",
        "P_YS_FED_FW_0000021473": "張",
        "P_YS_FED_FW_0000021470": "荊門市",
        "P_YS_FED_FW_0000021471": "和田地區",
        "P_YS_FED_EXAMP_0000020351": "現銷充值",
        "P_YS_FED_EXAMP_0000020350": "找零",
        "P_YS_FED_EXAMP_0000020345": "請選擇",
        "P_YS_FED_EXAMP_0000020348": "啟用效期管理的表體行,有效期至不能為空!",
        "P_YS_FED_EXAMP_0000020347": "網絡不可用，密碼必須與上次登錄相同",
        "P_YS_OA_XTSPZX_0000034785": "確定",
        "P_YS_FED_EXAMP_0000020344": "否",
        "P_YS_FED_EXAMP_0000020343": "營",
        "P_YS_FED_FW_0000021465": "模板A",
        "P_YS_FED_FW_0001515927": "身份證上傳",
        "P_YS_FED_FW_0000021466": "模板D",
        "P_YS_FED_FW_0001515928": "三列佈局左",
        "P_YS_FED_FW_0000021463": "請輸入商品條碼",
        "P_YS_SD_UDHBI_0000032531": "訂單",
        "P_YS_FED_FW_0001515929": "頁面區域",
        "P_YS_FED_FW_0000021464": "防城港市",
        "P_YS_FED_FW_0000021469": "模板B",
        "P_YS_FED_FW_0001515923": "ys圖片展示",
        "P_YS_FED_EXAMP_0000020349": "選擇客戶",
        "P_YS_FED_FW_0001515924": "多分頁切換",
        "P_YS_FED_FW_0000021467": "模板E",
        "P_YS_FED_FW_0001515925": "清單參照",
        "P_YS_FED_FW_0000021468": "甘南藏族自治州",
        "P_YS_FED_FW_0001515926": "掃碼框",
        "P_YS_FED_FW_1478297498195329033": "獲取數據模板列表失敗",
        "P_YS_FED_FW_1478297498195329030": "暫無模板數據～",
        "P_YS_FED_UIMG_0000082816": "只讀狀態不可進行刪除操作",
        "P_YS_ZNBZ_BZBX-MFE_0001618094": "未保存",
        "P_YS_OA_YBMOB_0000036918": "開始",
        "P_YS_FED_FW_0001207667": "單據助手",
        "P_YS_FED_IMP_IOT0000005795": "瑪曲縣",
        "P_YS_FED_IMP_IOT0000005794": "東洲區",
        "P_YS_FED_IMP_IOT0000005797": "瑤海區",
        "P_YS_FED_FW_0001309650": "(已選擇<%placeholder%>條)",
        "P_YS_FED_IMP_IOT0000005793": "德城區",
        "P_YS_FED_IMP_IOT0000005792": "翔安區",
        "P_YS_IMP_DFM-UI_0001095230": "容器",
        "P_YS_OA_app_xtywlj_0000037585": "表達式",
        "P_YS_FED_IMP_IOT0000005789": "寧陽縣",
        "P_YS_FED_IMP_IOT0000005782": "梁子湖區",
        "P_YS_FED_FW_0001388453": "纯文字档案域錄入框換行",
        "P_YS_FED_IMP_IOT0000005775": "北川羌族自治縣",
        "P_YS_FED_IMP_IOT0000005777": "元江哈尼族彞族傣族自治縣",
        "P_YS_FED_IMP_IOT0000005776": "樂業縣",
        "P_YS_FED_IMP_IOT0000005779": "美蘭區",
        "P_YS_FED_FW_0001045499": "十八",
        "P_YS_FED_FW_0001045497": "十七",
        "P_YS_FED_FW_0001045498": "十五",
        "P_YS_FED_FW_0001237484": "該訂單中存在校驗失敗項，可以點擊查看",
        "P_YS_FED_IMP_IOT0000005769": "禮縣",
        "P_YS_SCM_PU_0000028333": "請先選擇倉庫！",
        "P_YS_OA_XTWENKU_0000035495": "修改時間",
        "P_YS_FED_IMP_IOT0000005765": "薛城區",
        "P_YS_PF_GZTORG_0000035405": "修改時間",
        "P_YS_FED_IMP_IOT0000005750": "陳巴爾虎旗",
        "P_YS_FED_IMP_IOT0000005753": "霍州市",
        "P_YS_FED_IMP_IOT0000011606": "星子縣",
        "P_YS_FED_IMP_IOT0000005752": "班瑪縣",
        "P_YS_FED_IMP_IOT0000011605": "圖們市",
        "P_YS_FED_IMP_IOT0000005755": "回民區",
        "P_YS_FED_IMP_IOT0000005757": "壽寧縣",
        "P_YS_FED_IMP_IOT0000011602": "振安區",
        "P_YS_FED_IMP_IOT0000005756": "甘州區",
        "P_YS_FED_IMP_IOT0000011609": "宿豫區",
        "P_YS_FED_FW_0001045496": "十三",
        "P_YS_FED_FW_1442544300594823168": "嗎 ?",
        "P_YS_FED_IMP_IOT0000005749": "巴馬瑤族自治縣",
        "P_YS_FED_IMP_IOT0000005740": "舒蘭市",
        "P_YS_FED_IMP_IOT0000011615": "福貢縣",
        "P_YS_FED_IMP_IOT0000005742": "玉屏侗族自治縣",
        "P_YS_FED_IMP_IOT0000011616": "襄汾縣",
        "P_YS_FED_FW_1497426122910466048": "參照擴展腳本加載異常",
        "P_YS_FED_IMP_IOT0000011610": "貴定縣",
        "P_YS_FED_IMP_IOT0000011613": "東阿縣",
        "P_YS_PF_WORKBENCH-FE_0001133350": "用友集團",
        "P_YS_FED_FW_0000022095": "ю",
        "P_YS_FED_FW_0000022096": "я",
        "P_YS_FED_FW_0000022093": "ь",
        "P_YS_FED_FW_0000022094": "э",
        "P_YS_FED_FW_0000022099": "小於",
        "P_YS_FED_FW_0000022097": "替換",
        "P_YS_FED_FW_0000022098": "熱區顯示圖 在CStyle中未能找到全部的熱區配置字段 codeField stateField captionFields mapConfigField",
        "P_YS_FED_FW_1520473424212262918": "卡片展示",
        "P_YS_FED_IMP_IOT0000005737": "安化縣",
        "P_YS_FED_IMP_IOT0000005739": "大邑縣",
        "P_YS_FED_IMP_IOT0000011620": "彭陽縣",
        "P_YS_FED_FW_0000022091": "ы",
        "P_YS_FED_FW_0000022092": "請填寫正確的電郵號",
        "P_YS_FED_FW_0000022090": "模版",
        "P_YS_FED_UCFBASEDOC_0000024807": "密碼登錄",
        "P_YS_MF_PO-FE_0001156335": "是否取消？",
        "P_YS_FED_IMP_IOT0000005733": "從化市",
        "P_YS_FED_IMP_IOT0000005732": "泗縣",
        "YS_YC_PORTAL-FE_1122935812": "創建人：",
        "P_YS_FED_IMP_IOT0000005728": "阿圖什市",
        "P_YS_FED_IMP_IOT0000010305": "永安市",
        "P_YS_FED_IMP_IOT0000011637": "漢沽區",
        "P_YS_FED_IMP_IOT0000011636": "高密市",
        "P_YS_FED_IMP_IOT0000005720": "文聖區",
        "P_YS_FED_IMP_IOT0000011639": "平昌縣",
        "P_YS_FED_IMP_IOT0000011638": "青銅峽市",
        "P_YS_FED_IMP_IOT0000005721": "連江縣",
        "P_YS_FED_IMP_IOT0000011632": "仙居縣",
        "P_YS_FED_FW_0000096305": "圖片必須小於",
        "P_YS_FED_FW_0000096304": "M，圖片僅支持JPG、PNG、BMP、GIF格式",
        "P_YS_FED_FW_0000096303": "(每張圖片大小不可超過",
        "P_YS_FED_FW_0000096302": "（每個附件大小不可超過",
        "P_YS_FED_FW_0000096300": "是否確認刪除此附件？",
        "P_YS_FED_IMP_IOT0000010309": "枝江市",
        "P_YS_PF_GZTORG_0000035435": "採購組織",
        "P_YS_FED_FW_0000022073": "о",
        "P_YS_FED_FW_0001077912": "條件配置錯誤",
        "P_YS_FED_FW_0000022074": "п",
        "P_YS_FED_FW_0000022071": "暫無附件~",
        "P_YS_FED_FW_0000022072": "н",
        "P_YS_FED_FW_0000022077": "с",
        "P_YS_FED_FW_0000022078": "т",
        "P_YS_FED_FW_0000022075": "р",
        "P_YS_FED_FW_0000022076": "基礎行操作",
        "P_YS_FED_IMP_IOT0000011640": "疊彩區",
        "P_YS_FED_IMP_IOT0000005714": "灤縣",
        "P_YS_FED_IMP_IOT0000011642": "樅陽縣",
        "P_YS_FED_IMP_IOT0000005716": "阿爾山市",
        "P_YS_FED_IMP_IOT0000010311": "延壽縣",
        "P_YS_FED_FW_0000022070": "м",
        "P_YS_FED_IMP_IOT0000010316": "大祥區",
        "P_YS_FED_IMP_IOT0000011648": "深澤縣",
        "P_YS_FED_IMP_IOT0000010317": "潼關縣",
        "P_YS_FED_IMP_IOT0000010318": "前進區",
        "P_YS_FED_IMP_IOT0000010319": "鄞州區",
        "P_YS_SD_SDSD-FE_0001486556": "備註",
        "P_YS_FED_IMP_IOT0000005710": "德格縣",
        "P_YS_FED_IMP_IOT0000011646": "花都區",
        "P_YS_FED_FW_1588736741075845125": "已選數據項不能為空，請先添加再保存",
        "P_YS_FED_FW_0000022068": "堆疊條形圖",
        "P_YS_FED_FW_0000022069": "л",
        "P_YS_PF_GZTSYS_0000011944": "自定義項設置",
        "P_YS_FED_FW_0000022084": "ч",
        "P_YS_FED_FW_0000022085": "ш",
        "P_YS_FED_FW_0000022082": "х",
        "P_YS_FED_FW_0000022083": "ц",
        "P_YS_FED_FW_0000022088": "大屏方案 設計 info",
        "P_YS_FED_FW_0000022089": "ъ",
        "P_YS_FED_FW_0000022086": "通過氣泡大小顯示數量信息",
        "P_YS_FED_FW_0000022087": "щ",
        "P_YS_FED_IMP_IOT0000005704": "珠山區",
        "P_YS_FED_IMP_IOT0000010320": "寧江區",
        "P_YS_FED_IMP_IOT0000011650": "東山縣",
        "P_YS_FED_IMP_IOT0000005706": "岑溪市",
        "P_YS_FED_IMP_IOT0000010321": "西疇縣",
        "P_YS_FED_IMP_IOT0000005705": "什邡市",
        "P_YS_FED_FW_0000022080": "у",
        "P_YS_FED_FW_0000022081": "ф",
        "P_YS_FED_IMP_IOT0000005707": "平江縣",
        "P_YS_FED_IMP_IOT0000005709": "南靖縣",
        "P_YS_FED_IMP_IOT0000011658": "寧河縣",
        "P_YS_FED_IMP_IOT0000010329": "陸豐市",
        "P_YS_FED_FW_1540539167842238469": "保存新建方案",
        "P_YS_PF_GZTSYS_0000011952": "商品分類",
        "P_YS_FED_IMP_IOT0000011655": "上甘嶺區",
        "P_YS_FED_IMP_IOT0000011657": "下陸區",
        "P_YS_FED_FW_0000022079": "最大化",
        "P_YS_FI_CM_0000029252": "警告",
        "P_YS_PF_ANALYTIC-FE_0001651222": "近15天",
        "P_YS_FED_IMP_IOT0000011662": "湘陰縣",
        "P_YS_FED_IMP_IOT0000010332": "大通區",
        "P_YS_FED_IMP_IOT0000011660": "漳平市",
        "P_YS_FED_IMP_IOT0000010338": "務川仡佬族苗族自治縣",
        "P_YS_FI_RA_0000071535": "空值",
        "P_YS_FED_IMP_IOT0000011666": "科爾沁右翼前旗",
        "P_YS_FED_FW_0001249401": "為必,請輸入後重試",
        "P_YS_FED_IMP_IOT0000011665": "眉縣",
        "P_YS_FED_FW_0001249400": "不合法，請修改後重試",
        "P_YS_FED_IMP_IOT0000010336": "興縣",
        "P_YS_FED_IMP_IOT0000009297": "師宗縣",
        "P_YS_FED_IMP_IOT0000009299": "海滄區",
        "P_YS_FI_YYFI-UI_0000167698": "其他入庫單列表區域",
        "P_YS_OA_LCGL_0000037077": "模版類型",
        "P_YS_FED_FW_1624915715923902472": "表頭+明顯",
        "P_YS_FED_IMP_IOT0000009290": "德惠市",
        "P_YS_FED_FW_0001025027": "請檢查SERVER_ENV配置是否正確",
        "P_YS_FI_CM_0000029260": "數據視圖",
        "P_YS_FED_IMP_IOT0000010341": "比如縣",
        "P_YS_FED_IMP_IOT0000011673": "鼓樓區",
        "P_YS_FED_IMP_IOT0000010344": "交口縣",
        "P_YS_FED_IMP_IOT0000011674": "科爾沁右翼中旗",
        "P_YS_FED_IMP_IOT0000011671": "延平區",
        "P_YS_SD_SDMA_0000122990": "獲取失敗",
        "P_YS_FED_IMP_IOT0000010340": "解放區",
        "P_YS_OA_XTTMCENTER_0000035125": "編號",
        "P_YS_FED_IMP_IOT0000010349": "古丈縣",
        "P_YS_FED_IMP_IOT0000010346": "定海區",
        "P_YS_FED_IMP_IOT0000010347": "伊金霍洛旗",
        "P_YS_FED_IMP_IOT0000011678": "東台市",
        "P_YS_FED_IMP_IOT0000009286": "晉寧縣",
        "P_YS_FED_FW_0001025032": "表格參照",
        "P_YS_FED_IMP_IOT0000009284": "道外區",
        "P_YS_FED_IMP_IOT0000009285": "環江毛南族自治縣",
        "P_YS_FED_IMP_IOT0000009289": "剛察縣",
        "P_YS_FED_IMP_IOT0000009282": "下關區",
        "P_YS_FED_IMP_IOT0000009283": "南岸區",
        "P_YS_FED_IMP_IOT0000011684": "達孜縣",
        "P_YS_FED_IMP_IOT0000011683": "長順縣",
        "P_YS_FED_FW_0001065929": "refEntity.extendField 不是標準的json字符串",
        "P_YS_FED_IMP_IOT0000010354": "浪卡子縣",
        "P_YS_FED_IMP_IOT0000011686": "源城區",
        "P_YS_FED_IMP_IOT0000011685": "望江縣",
        "P_YS_FED_IMP_IOT0000011680": "城北區",
        "P_YS_FED_IMP_IOT0000010350": "成都",
        "P_YS_FED_FW_0001065923": ",輸入小數小數位由",
        "P_YS_FED_FW_0001065924": ",輸入小數小數位為",
        "P_YS_FED_FW_0001065921": "最多允許輸入15位，目前整數長度為",
        "P_YS_FED_FW_0001065922": "位改為",
        "P_YS_FED_IMP_IOT0000011688": "青川縣",
        "P_YS_FED_IMP_IOT0000010357": "茂縣",
        "P_YS_FED_IMP_IOT0000011687": "廬山區",
        "P_YS_FED_FW_0001065925": "暫時沒有數據~",
        "P_YS_FED_FW_0001065926": "元數據協議錯誤",
        "P_YS_FED_FW_0001200151": "不允許上傳以下型別的文件:",
        "P_YS_FED_IMP_IOT0000009276": "東興區",
        "P_YS_FED_IMP_IOT0000009279": "左貢縣",
        "P_YS_FED_FW_1536081971023183878": "列印模板圖片地址為空,無法列印,請聯繫工作人員排查",
        "P_YS_FED_IMP_IOT0000009272": "昌邑區",
        "P_YS_FED_IMP_IOT0000009270": "東蘭縣",
        "P_YS_FED_IMP_IOT0000010363": "耀州區",
        "P_YS_FED_IMP_IOT0000010364": "虎丘區",
        "P_YS_FED_IMP_IOT0000011697": "改則縣",
        "P_YS_FED_IMP_IOT0000011696": "雲和縣",
        "P_YS_FED_IMP_IOT0000011691": "鄰水縣",
        "P_YS_FED_IMP_IOT0000010360": "微山縣",
        "P_YS_FED_IMP_IOT0000011692": "英德市",
        "P_YS_PF_GZTSYS_0000011991": "標籤分組",
        "P_YS_OA_LCGL_0000037083": "未完成",
        "P_YS_FED_IMP_IOT0000011699": "劍河縣",
        "P_YS_FED_IMP_IOT0000011698": "宣恩縣",
        "P_YS_FED_IMP_IOT0000010369": "會同縣",
        "P_YS_FED_IMP_IOT0000009264": "浦口區",
        "P_YS_FED_IMP_IOT0000009262": "孝昌縣",
        "P_YS_SD_URETAIL_0001048944": "%%db錯誤日誌%%【",
        "P_YS_FED_FW_0001389709": "取餘",
        "P_YS_FED_IMP_IOT0000009269": "紅崗區",
        "P_YS_FED_FW_0001389708": "切換查詢方式",
        "P_YS_FED_IMP_IOT0000009266": "尉氏縣",
        "P_YS_SD_SDMA_0000062743": "註冊",
        "P_YS_PF_PRINT_0000056946": "表頭自定義項14",
        "P_YS_PF_PRINT_0000056943": "表頭自定義項10",
        "P_YS_FED_FW_0000022011": "小票打印",
        "P_YS_FED_IMP_IOT0000008050": "清澗縣",
        "P_YS_FED_IMP_IOT0000009381": "阿合奇縣",
        "P_YS_FED_FW_0000022012": "2維表行列變化異常，沒有列型別t2DColType。data=",
        "P_YS_FED_IMP_IOT0000008051": "勉縣",
        "P_YS_FED_FW_0000022010": "未知控件",
        "P_YS_FED_IMP_IOT0000009380": "和田縣",
        "P_YS_FED_IMP_IOT0000010254": "鍾山區",
        "P_YS_FED_IMP_IOT0000010256": "諸城市",
        "P_YS_FED_IMP_IOT0000011586": "洮北區",
        "P_YS_FED_IMP_IOT0000011583": "肥鄉縣",
        "P_YS_FED_FW_0001077975": "控件崩潰!",
        "P_YS_FED_FW_1585773806330314768": "範圍值精度不允許為負值，請修改",
        "P_YS_FED_IMP_IOT0000010257": "淮陽縣",
        "P_YS_FED_IMP_IOT0000010258": "磐安縣",
        "P_YS_FED_IMP_IOT0000010259": "薌城區",
        "P_YS_FED_FW_0000022004": "查看",
        "P_YS_FED_IMP_IOT0000008043": "樺川縣",
        "P_YS_SD_UDHWS_0000066531": "主計量數量",
        "P_YS_FED_FW_0000022005": "報表分組方案配置信息-圖表Arr",
        "P_YS_FED_FW_0000022002": "大屏輪播：沒有找到能夠展示的大屏。模板ID",
        "P_YS_FED_IMP_IOT0000008041": "囊謙縣",
        "P_YS_FED_IMP_IOT0000009372": "南岳區",
        "P_YS_SD_UDHWN_0000047815": "分頁",
        "P_YS_FED_FW_0000022003": "請選擇行再進行下移操作！",
        "P_YS_FED_IMP_IOT0000008042": "彰武縣",
        "P_YS_FED_IMP_IOT0000009373": "牙克石市",
        "P_YS_FED_FW_0000022008": "熱區顯示圖  通過返回的數據集獲取 mapConfig 。 mapConfig",
        "P_YS_FED_IMP_IOT0000008047": "新都區",
        "P_YS_FED_IMP_IOT0000009378": "鶴山市",
        "P_YS_FED_FW_0000022009": "批量操作",
        "P_YS_PF_PRINT_0000056949": "表頭自定義項12",
        "P_YS_FED_FW_0000022006": "eChartDisplay 散點圖地圖信息正確    return",
        "P_YS_FED_IMP_IOT0000009376": "翼城縣",
        "P_YS_FED_FW_0000022007": "月觸發一次",
        "P_YS_FED_IMP_IOT0000008046": "稱多縣",
        "P_YS_FED_IMP_IOT0000009377": "金陽縣",
        "P_YS_PF_PRINT_0000056947": "表頭自定義項13",
        "P_YS_PF_PRINT_0000056956": "表頭自定義項18",
        "P_YS_FED_IMP_IOT0000011590": "貴南縣",
        "P_YS_FED_FW_0000022022": "請輸入別名代碼",
        "P_YS_FED_IMP_IOT0000009370": "伊川縣",
        "P_YS_FED_FW_0000022023": "篩選排序",
        "P_YS_FED_FW_0000022020": "eChartDisplay狀態改變 shouldComponentUpdate Begin",
        "P_YS_FED_FW_0000022021": "支持上傳10M以下png/jpg格式的圖片",
        "P_YS_PF_PRINT_0000056950": "表頭自定義項11",
        "P_YS_FED_IMP_IOT0000011596": "羅源縣",
        "P_YS_FED_IMP_IOT0000010265": "北塔區",
        "P_YS_FED_IMP_IOT0000011595": "雜多縣",
        "P_YS_FED_IMP_IOT0000010266": "易縣",
        "P_YS_FED_IMP_IOT0000010267": "肇源縣",
        "P_YS_FED_IMP_IOT0000011597": "東山區",
        "P_YS_FED_IMP_IOT0000011591": "臥龍區",
        "P_YS_FED_IMP_IOT0000011594": "石城縣",
        "P_YS_SCM_USTOCK-UI_0000173671": "增組",
        "P_YS_FED_IMP_IOT0000009369": "棗強縣",
        "P_YS_FED_FW_0001381042": "每張圖片大小不可超過50M, 支持格式:JPG、PNG等",
        "P_YS_FED_FW_0001381041": "圖片管理",
        "P_YS_FED_FW_1600567391678889987": "UI模板名稱:",
        "P_YS_FED_FW_1600567391678889984": "UI模板tplid:",
        "P_YS_FED_FW_0000022015": "確定刪除此模版麼？",
        "P_YS_FED_IMP_IOT0000008032": "金沙縣",
        "P_YS_FED_FW_0000022016": "報表方案已發布。",
        "P_YS_FED_IMP_IOT0000008033": "武勝縣",
        "P_YS_FED_IMP_IOT0000009364": "九里區",
        "P_YS_FED_FW_0000022013": "保存失敗",
        "P_YS_FED_FW_0000022014": "刷新頻率",
        "P_YS_FED_IMP_IOT0000009362": "華容區",
        "P_YS_FED_FW_0000022019": "搜索無結果",
        "P_YS_FED_IMP_IOT0000009367": "永寧縣",
        "P_YS_FED_IMP_IOT0000008037": "奉化市",
        "P_YS_FED_FW_0000022017": "輸入的數字不能小於",
        "P_YS_FED_IMP_IOT0000008034": "白鹼灘區",
        "P_YS_FED_FW_0000022018": "展示指標",
        "P_YS_FED_IMP_IOT0000009366": "魏都區",
        "P_YS_PF_PRINT_0000056958": "表頭自定義項17",
        "P_YS_PF_PRINT_0000056924": "出庫組織",
        "P_YS_FED_FW_0001344099": "可錄入單元格中“Z”字形順次跳轉",
        "P_YS_SCM_USTOCK-UI_0001025485": "必輸，請精確到sku",
        "P_YS_FED_FW_0001344095": "空格鍵",
        "P_YS_FED_IMP_IOT0000009360": "開魯縣",
        "P_YS_FED_FW_0001344096": "新增 (空白單據/檔案)",
        "P_YS_FED_FW_0001344097": "打開游標所在位置的參照對話框",
        "P_YS_FED_FW_0001344098": "表頭分組展開與收起",
        "P_YS_FED_IMP_IOT0000010275": "遠安縣",
        "P_YS_FED_FW_0001344091": "可錄入單元格中“Z”字形逆向跳轉",
        "P_YS_FED_FW_0001344092": "表格內焦點快速跳轉",
        "P_YS_FED_FW_0001344093": "↑;↓;←;→",
        "P_YS_FED_FW_0001344094": "↑/↓",
        "P_YS_FED_IMP_IOT0000010271": "芒康縣",
        "P_YS_FED_IMP_IOT0000010273": "德化縣",
        "P_YS_FED_FW_0001344090": "參照彈窗",
        "P_YS_FED_FW_1422515029828173824": "請錄入關鍵字搜索",
        "P_YS_FED_IMP_IOT0000008028": "丹寨縣",
        "P_YS_FED_IMP_IOT0000009359": "凌雲縣",
        "P_YS_FED_UCFBASEDOC_0000024749": "敏感數據權限",
        "P_YS_FED_IMP_IOT0000010279": "扶風縣",
        "P_YS_SD_URETAIL_0001048852": "==>>db日誌調用點【changeTable】【",
        "P_YS_FED_IMP_IOT0000009352": "積石山保安族東鄉族撒拉族自治縣",
        "P_YS_FED_IMP_IOT0000009350": "大荔縣",
        "P_YS_FED_IMP_IOT0000008020": "臨河市",
        "P_YS_FED_IMP_IOT0000008025": "汶川縣",
        "P_YS_FED_IMP_IOT0000008026": "城口縣",
        "P_YS_FED_IMP_IOT0000009357": "峨山彞族自治縣",
        "P_YS_FED_IMP_IOT0000008023": "贊皇縣",
        "P_YS_FED_IMP_IOT0000008024": "金溪縣",
        "P_YS_FED_IMP_IOT0000009355": "淳安縣",
        "P_YS_FED_FW_0001344088": "參照表格焦點上移 / 下移",
        "P_YS_FED_FW_0001154596": "匯入文件大小不能大於",
        "P_YS_FED_FW_0001344089": "底部操作欄",
        "P_YS_FED_IMP_IOT0000010281": "義馬市",
        "P_YS_FED_FW_0000022000": "消息內容",
        "P_YS_FED_FW_0001344084": "下拉面板中焦點上移 / 下移",
        "P_YS_FED_FW_0000022001": "寬度/高度",
        "P_YS_FED_FW_0001344085": "表頭與表體區域間循環跳轉",
        "P_YS_FED_FW_0001344086": "表單錄入",
        "P_YS_FED_FW_0001344087": "參照彈窗執行“確定”操作",
        "P_YS_FED_IMP_IOT0000010286": "侯馬市",
        "P_YS_FED_IMP_IOT0000010288": "深州市",
        "P_YS_FED_IMP_IOT0000010289": "西塞山區",
        "P_YS_FED_IMP_IOT0000008018": "會寧縣",
        "P_YS_FED_IMP_IOT0000009349": "伊春區",
        "P_YS_FED_IMP_IOT0000008019": "恆山區",
        "P_YS_FED_IMP_IOT0000008016": "盈江縣",
        "P_YS_FED_IMP_IOT0000009347": "晴隆縣",
        "P_YS_FED_IMP_IOT0000009341": "利川市",
        "P_YS_FED_IMP_IOT0000008011": "保康縣",
        "P_YS_FED_IMP_IOT0000009342": "通江縣",
        "P_YS_FED_IMP_IOT0000008014": "北湖區",
        "P_YS_FED_IMP_IOT0000008015": "原州區",
        "P_YS_FED_IMP_IOT0000009346": "武岡市",
        "P_YS_FED_IMP_IOT0000009343": "琅琊區",
        "P_YS_FED_FW_0000022051": "啟",
        "P_YS_FED_FW_0000022052": "а",
        "P_YS_FED_FW_0000022050": "大屏方案 設計 getDesignColType_Chart curCol",
        "P_YS_FED_IMP_IOT0000010292": "萬山特區",
        "P_YS_FED_FW_0000022055": "請輸入...",
        "P_YS_FED_FW_0000022056": "в",
        "P_YS_FED_FW_0000022053": "只顯示已選",
        "P_YS_FED_FW_0000022054": "б",
        "P_YS_FED_IMP_IOT0000010297": "任城區",
        "P_YS_FED_IMP_IOT0000010298": "雨城區",
        "P_YS_FED_IMP_IOT0000010293": "絳縣",
        "P_YS_FED_FW_1545658640009003030": "您好，“新增”按鈕不支持表體“1對多”型別的取值方式，請使用高級設計器設置，如：“高級設計器-欄位設置”、“高級設計器-公式”。",
        "P_YS_FED_IMP_IOT0000010296": "滄浪區",
        "P_YS_TBS_TBS-FE_0001148975": "南海諸島",
        "P_YS_FED_IMP_IOT0000008008": "仁布縣",
        "P_YS_FED_IMP_IOT0000009339": "台山市",
        "P_YS_FED_UCFBASEDOC_0000024727": "審核",
        "P_YS_FED_IMP_IOT0000008009": "麻城市",
        "P_YS_FED_FW_0000022048": "升序",
        "P_YS_FED_FW_0000022049": "過濾類型",
        "P_YS_FED_IMP_IOT0000008000": "贛榆縣",
        "P_YS_FED_FW_0000022046": "匹配一維表的行時，有多個匹配行，請檢查。 valueArr =",
        "P_YS_SD_URETAIL_0001048876": "==>>db日誌調用點【存儲元數據】【",
        "P_YS_FED_FW_0000022047": "訂閱條件",
        "P_YS_FED_IMP_IOT0000009334": "陽朔縣",
        "P_YS_FED_IMP_IOT0000008004": "定州市",
        "P_YS_FED_IMP_IOT0000009335": "延長縣",
        "P_YS_FED_IMP_IOT0000008001": "榆樹市",
        "P_YS_FED_IMP_IOT0000008002": "渭濱區",
        "P_YS_FED_FW_0000022062": "з",
        "P_YS_PF_SOCD_0000089099": "巴西",
        "P_YS_FED_FW_0000022063": "是否<%=abandonText%>?",
        "P_YS_FED_FW_0000022060": "е",
        "P_YS_FED_FW_0000022061": "ж",
        "P_YS_FED_FW_0000022066": "沒有找著用戶id，請確認",
        "P_YS_FED_FW_0000022067": "к",
        "P_YS_PF_PRINT_0000056996": "行號",
        "P_YS_FED_FW_0000022064": "暫無資料",
        "P_YS_FED_FW_0000022065": "й",
        "P_YS_FED_FW_1588671285764292613": "已勾選“移動端展現”，請設置移動端布局!",
        "P_YS_SD_SDMAUF_0000152989": "已失效",
        "P_YS_FI_RA_0000071482": "id為",
        "P_YS_FED_IMP_IOT0000009327": "朔城區",
        "P_YS_FED_IMP_IOT0000009325": "沈河區",
        "P_YS_FED_IMP_IOT0000009329": "錦屏縣",
        "P_YS_FED_FW_0000022059": "模版名稱更改",
        "P_YS_FED_UCFBASEDOC_0000024712": "保存並新增",
        "P_YS_FED_FW_0000022057": "г",
        "P_YS_FED_FW_0000022058": "д",
        "P_YS_FED_IMP_IOT0000009324": "湯陰縣",
        "P_YS_FED_IMP_IOT0000009321": "宜君縣",
        "P_YS_FED_FW_0000022030": "校驗成功",
        "P_YS_FED_FW_1545658640009003012": "selectFiled--要查詢的欄位",
        "P_YS_FED_FW_0000022033": "請設置solutionId",
        "P_YS_FED_FW_1545658640009003015": "1.打開高級設計器，選中表體，右邊屬性區點擊“欄位設置”按鈕，在彈窗左邊樹上，查詢到目標欄位拖到清單，最後保存。",
        "P_YS_FED_FW_0000022034": "僅支持",
        "P_YS_PF_PRINT_0000056963": "表頭自定義項15",
        "P_YS_FED_FW_0000022031": "標題字體大小設置不正確",
        "P_YS_FED_FW_0000022032": "eChartDisplay 沒有傳入 chartDisplayType ，請檢查",
        "P_YS_PF_PRINT_0000056961": "表頭自定義項16",
        "P_YS_FED_IMP_IOT0000009314": "銅鼓縣",
        "P_YS_FED_UCFBASEDOC_0000024708": "角色描述",
        "P_YS_FED_IMP_IOT0000009315": "大足縣",
        "P_YS_FED_IMP_IOT0000009319": "青縣",
        "P_YS_FED_FW_0000022026": "檔案值不可為空。",
        "P_YS_FED_UCFBASEDOC_0000024701": "出庫倉庫和入庫倉庫不可以相同！",
        "P_YS_FED_FW_0000022027": "2維表行數 =",
        "P_YS_FED_FW_0000022024": "上移當前行",
        "P_YS_FED_FW_0000022025": "保留外層間距",
        "P_YS_FED_IMP_IOT0000009312": "于田縣",
        "P_YS_FED_FW_0000022028": "模版組織名稱",
        "P_YS_FED_FW_0000022029": "每日",
        "P_YS_FED_IMP_IOT0000009311": "越秀區",
        "P_YS_FED_FW_0000022040": "向下",
        "P_YS_FED_FW_0000022041": "運算符",
        "P_YS_FED_FW_1545658640009003021": "conditionField--條件欄位",
        "P_YS_FED_FW_0000022044": "添加公告",
        "P_YS_FED_FW_0000022045": "增加物料",
        "P_YS_SD_UDHWN_0000047803": "定安縣",
        "P_YS_SD_UDHBN_0000032639": "內容",
        "P_YS_FED_FW_1545658640009003027": "fullName--檔案的uri",
        "P_YS_FED_FW_0000022042": "餅形圖",
        "P_YS_PF_PRINT_0000056973": "出庫倉庫",
        "P_YS_FED_FW_1545658640009003024": "conditionValue--條件值",
        "P_YS_FED_FW_0000022043": "您輸入的地址有誤，請填寫正確的地址",
        "P_YS_PF_PRINT_0000056970": "表頭自定義項19",
        "P_YS_FED_IMP_IOT0000009307": "金平區",
        "P_YS_FED_IMP_IOT0000009308": "措美縣",
        "P_YS_FED_FW_0000022037": "PC端展現",
        "P_YS_FED_FW_0001025097": "是否確定恢復默認？",
        "P_YS_FED_FW_0000022038": "大屏方案 Save editPanel",
        "P_YS_FED_FW_0000022035": "默認模板",
        "P_YS_FED_FW_0000022036": "請輸入聯繫人電話",
        "P_YS_FED_FW_1545658640009003018": "2.設置公式-業務函數",
        "P_YS_FED_IMP_IOT0000009302": "固鎮縣",
        "P_YS_FED_FW_0000022039": "大屏輪播：請檢查當前操作員是否有模板權限",
        "P_YS_OA_YBMOB_0000036998": "撤回成功",
        "P_YS_FED_FW_0001045501": "十四",
        "P_YS_FED_FW_0001045500": "十六",
        "P_YS_FED_FW_0001473539": "請輸入網址名稱",
        "P_YS_PF_METADATA_0001040427": "產地",
        "P_YS_FED_FW_0001071829": "帶有navbar的表格參照或者樹參照",
        "P_YS_FED_FW_0001071827": "帶有navbar和確認按鈕等樹參照",
        "P_YS_FED_FW_0001071828": "頭部返回回調",
        "P_YS_FED_FW_0001473541": "請配置彈窗型別fromType",
        "P_YS_SD_SDSD-FE_0001491115": "金額",
        "P_YS_FED_FW_0001473540": "組織存在未生效的變更，不支持停用，請在生效後或刪除未生效的變更，再次操作。",
        "P_YS_SD_SDMB_0000146962": "返回頂部",
        "P_YS_FED_FW_0001344079": "快捷鍵幫助",
        "P_YS_PF_PROCENTER_0000023062": "其他",
        "P_YS_FED_FW_0001034888": "定標",
        "P_YS_SD_SDMA_0000125113": "總部",
        "P_YS_OA_YBMOB_0000036941": "審批歷史",
        "P_YS_FED_FW_1551057439648907272": "參照配置錯誤: 未返回參照資料唯一值",
        "P_YS_PF_PROCENTER_0000023057": "庫存單位",
        "P_YS_SD_SDMAF_0000136181": "條件：",
        "P_YS_SD_UDHWN_0000047879": "東方市",
        "P_YS_FED_FW_0001534303": "搜索字段設置",
        "P_YS_FED_FW_0001648230": "失敗行號",
        "P_YS_FED_FW_0001662538": "請輸入關鍵字或者選擇分類",
        "P_YS_FED_UCFBASEDOC_0000024789": "刪除中...",
        "P_YS_FI_YYFI-UI_0001152516": "手動關閉",
        "P_YS_FED_UCFBASEDOC_0000024782": "操作失敗",
        "P_YS_FED_FW_0001219575": "<%=text%>不能為空",
        "P_YS_PF_PRINT_0000065042": "物料編碼",
        "P_YS_FED_FW_1497279621567610881": "請點擊錄入框右側圖示，補充其他語種名稱",
        "P_YS_FI_CM_0000029334": "下午",
        "P_YS_FED_FW_1422567557278203904": "數據處理中，請稍後...",
        "P_YS_FED_IMP_IOT0000005698": "靖安縣",
        "P_YS_FED_IMP_IOT0000005697": "五常市",
        "P_YS_SD_UDHWN_0000120970": "無標題",
        "P_YS_SD_UDHWN_0001008893": "圈選",
        "P_YS_FED_IMP_IOT0000005692": "撫松縣",
        "P_YS_FED_FW_0001411240": "值改變搜索",
        "P_YS_SD_UDHWN_0001008897": "縱向選擇",
        "P_YS_FED_FW_0001045594": "是否確認<%=params.cShowCaption%>此記錄",
        "P_YS_FED_FW_0001045595": "確定刪除欄目【<%=text%>】麼？",
        "P_YS_FED_FW_0001045593": "確定要刪除<%=text%>麼?",
        "P_YS_PF_GZTPRE_0001381653": "事件監聽",
        "P_YS_FI_FCWEB_0001131731": "列印",
        "P_YS_PF_PROCENTER_0000023090": "採購",
        "P_YS_SCM_PU_0000028400": "已關閉",
        "P_YS_FED_IMP_IOT0000005684": "資源縣",
        "P_YS_FED_IMP_IOT0000005687": "湘東區",
        "P_YS_FED_IMP_IOT0000005683": "鼎湖區",
        "P_YS_FED_IMP_IOT0000005676": "陳倉區",
        "P_YS_FED_IMP_IOT0000005679": "息縣",
        "P_YS_FED_FW_0001248291": "復原",
        "P_YS_FED_IMP_IOT0000005672": "湛河區",
        "P_YS_PES_PES-FE_0001231284": "未選擇",
        "P_YS_FED_IMP_IOT0000005663": "民權縣",
        "P_YS_FED_IMP_IOT0000006993": "秦皇島",
        "P_YS_FED_IMP_IOT0000005662": "維西傈僳族自治縣",
        "P_YS_FED_IMP_IOT0000005664": "江漢區",
        "P_YS_FED_IMP_IOT0000006995": "兗州市",
        "P_YS_FED_FW_0001273232": "系統級模板不可修改欄目",
        "P_YS_FED_FW_0001094529": "%c未處理的類型",
        "P_YS_FED_IMP_IOT0000006998": "安寧市",
        "P_YS_FED_IMP_IOT0000005666": "平江區",
        "P_YS_FED_IMP_IOT0000006997": "滴道區",
        "P_YS_FED_IMP_IOT0000006999": "默認篩選",
        "P_YS_FED_IMP_IOT0000005660": "石家莊",
        "P_YS_FED_FW_0001345200": "查詢區渲染成功，預設方案資料為空",
        "P_YS_FED_FW_0001345201": "查詢區渲染完成",
        "P_YS_FED_FW_0001071834": "支持方法：addListener、removeListener、select",
        "P_YS_FED_FW_0001071835": "addListener、removeListener、select、unselect、setPageIndex、execute",
        "P_YS_FED_FW_0001071832": "支持方法：addListener、removeListener、",
        "P_YS_FED_FW_0001071833": "搭配params中menuId使用，portal.tabs[menuId].panes",
        "P_YS_FED_FW_0001071830": "addListener、removeListener、_set_data、select、setFocusedRowIndex、execute",
        "P_YS_FED_FW_0001071831": "支持的方法：get、getCache",
        "P_DIWORK_YC_CPU-PORTAL_0000064667": "供應商名稱：",
        "P_YS_FED_IMP_IOT0000005651": "黃山區",
        "P_YS_FED_IMP_IOT0000006982": "吳橋縣",
        "P_YS_FED_IMP_IOT0000005654": "集美區",
        "P_YS_FED_IMP_IOT0000006985": "墨江哈尼族自治縣",
        "P_YS_FED_IMP_IOT0000005653": "阜平縣",
        "P_YS_FED_IMP_IOT0000005656": "合山市",
        "P_YS_FED_IMP_IOT0000006987": "梁平縣",
        "P_YS_FED_IMP_IOT0000006989": "潞城市",
        "P_YS_OA_LCGL_0000037113": "動作",
        "P_YS_FED_IMP_IOT0000006981": "連州市",
        "P_YS_SCM_USCMPUB-FE_1528671786657906690": "形狀備份",
        "P_YS_FED_IMP_IOT0000005648": "高台縣",
        "P_YS_FED_FW_0000083161": "調用獲取配置文件接口前",
        "P_YS_FED_FW_0000083160": "調用獲取配置文件接口後",
        "P_YS_FED_IMP_IOT0000005640": "靈石縣",
        "P_YS_FED_IMP_IOT0000006971": "京口區",
        "P_YS_FED_IMP_IOT0000005643": "漢陽區",
        "P_YS_FED_IMP_IOT0000005645": "吉縣",
        "P_YS_FED_IMP_IOT0000005644": "港北區",
        "P_YS_FED_IMP_IOT0000006975": "久治縣",
        "P_YS_OA_XTTMCENTER_0000035097": "上傳時間",
        "P_YS_FED_IMP_IOT0000005647": "臨清市",
        "P_YS_FED_IMP_IOT0000005646": "平原縣",
        "P_YS_OA_LCGL_0000037104": "激活",
        "P_YS_OA_XTTMCENTER_0000035090": "創建人",
        "P_YS_FED_FW_1581128541507420175": "休",
        "P_YS_FED_FW_1581128541507420172": "是否包含下級",
        "P_YS_FED_IMP_IOT0000005637": "曾都區",
        "P_YS_FI_CM_0000029313": "上午",
        "P_YS_FED_IMP_IOT0000005639": "青龍滿族自治縣",
        "P_YS_FED_FW_1541189374344953860": "正在加載數據",
        "P_YS_FED_IMP_IOT0000006961": "洪山區",
        "P_YS_FED_IMP_IOT0000006963": "茄子河區",
        "P_YS_FED_IMP_IOT0000006964": "奉新縣",
        "P_YS_FED_FW_1487823486562336780": "暫無公共方案",
        "P_YS_FED_IMP_IOT0000006966": "南市區",
        "P_YS_FI_CM_0000029316": "切換為堆疊",
        "P_YS_FED_FW_1541192982117482504": "正在加載數據~",
        "P_YS_FED_FW_0001236297": "任務進度",
        "P_YS_FED_FW_0001236296": "商品碼不存在",
        "P_YS_FED_IMP_IOT0000005627": "道里區",
        "P_YS_FED_IMP_IOT0000006957": "大新縣",
        "P_YS_FED_IMP_IOT0000005628": "岳塘區",
        "P_YS_HR_HRPUBF_0000053688": "設置成功",
        "P_YS_FED_FW_1581128541507420169": "還有",
        "P_YS_FED_IMP_IOT0000005621": "惠來縣",
        "P_YS_FED_IMP_IOT0000006952": "任丘市",
        "P_YS_FED_IMP_IOT0000006951": "順德區",
        "P_YS_FED_IMP_IOT0000006954": "建甌市",
        "P_YS_FED_IMP_IOT0000005624": "靖宇縣",
        "P_YS_SD_SDMB_0000149198": "共計",
        "P_YS_OA_LCGL_0000037124": "組織架構",
        "P_YS_FED_FW_1487823486562336777": "暫無個人方案",
        "P_YS_FED_IMP_IOT0000005616": "將樂縣",
        "P_YS_FED_IMP_IOT0000006947": "寬城滿族自治縣",
        "P_YS_FED_IMP_IOT0000005618": "黃陂區",
        "P_YS_FED_IMP_IOT0000006949": "獨山子區",
        "P_YS_FED_IMP_IOT0000005617": "舟曲縣",
        "P_YS_FED_IMP_IOT0000006948": "南城縣",
        "P_YS_OA_XTTMCENTER_0000035047": "友空間",
        "P_YS_OA_LCGL_0000037152": "異常信息",
        "P_YS_FED_IMP_IOT0000005610": "邯鄲縣",
        "P_YS_FED_IMP_IOT0000011507": "長洲區",
        "P_YS_FED_IMP_IOT0000006940": "清豐縣",
        "P_YS_FED_FW_0001249563": "取消包含",
        "P_YS_SD_SDMB_0000140730": "是否開票",
        "P_YS_FED_IMP_IOT0000005612": "荔波縣",
        "P_YS_OA_XTTMCENTER_0000035043": "鏈接",
        "P_YS_FED_IMP_IOT0000006942": "青山區",
        "P_YS_FED_IMP_IOT0000011500": "蒼溪縣",
        "P_YS_FED_IMP_IOT0000005614": "達日縣",
        "P_YS_FED_IMP_IOT0000006944": "西華縣",
        "P_YS_FED_IMP_IOT0000011502": "施秉縣",
        "P_YS_HR_HRPXF_0000056086": "匯入模板下載",
        "P_YS_FED_IMP_IOT0000011508": "鹽邊縣",
        "P_YS_FED_FW_0001026436": "«",
        "P_YS_FED_IMP_IOT0000006936": "梨樹縣",
        "P_YS_FED_IMP_IOT0000005604": "秦安縣",
        "P_YS_FED_FW_0001249569": "不能選擇小於1870-01-01的日期",
        "P_YS_FED_IMP_IOT0000005607": "齊齊哈爾",
        "P_YS_FED_IMP_IOT0000006937": "岷縣",
        "P_YS_FED_IMP_IOT0000005609": "泗水縣",
        "P_YS_FED_IMP_IOT0000011515": "長嶺縣",
        "P_YS_FED_UCFBASEDOC_0000024916": "請輸入角色名稱",
        "P_YS_FED_IMP_IOT0000006930": "奉節縣",
        "P_YS_FED_IMP_IOT0000011518": "巴林左旗",
        "P_YS_OA_XTTMCENTER_0000035056": "更新時間",
        "P_YS_FED_IMP_IOT0000011517": "古縣",
        "P_YS_FED_UCFBASEDOC_0000024914": "日結單庫存日報_",
        "P_YS_FED_IMP_IOT0000005601": "韶山市",
        "P_YS_FED_IMP_IOT0000006932": "道縣",
        "P_YS_FED_IMP_IOT0000011512": "渝北區",
        "P_YS_FED_UCFBASEDOC_0000024915": "最多支持100字哦！",
        "P_YS_FED_IMP_IOT0000005600": "大豐市",
        "P_YS_FED_IMP_IOT0000006934": "鬱南縣",
        "P_YS_FED_IMP_IOT0000011514": "曲阜市",
        "P_YS_OA_XTTMCENTER_0000035052": "請上傳",
        "P_YS_FED_IMP_IOT0000006933": "都江堰市",
        "P_YS_FED_IMP_IOT0000011513": "青岡縣",
        "P_YS_FED_FW_0001249571": "不能選擇超過9999-12-31的日期",
        "P_YS_FED_FW_0001249570": "為必輸,請輸入後重試",
        "P_YS_FED_FW_0000022194": "在1維表中發現多行符合當前交叉點行列鍵值的數據 t2DRowKey =",
        "P_YS_FED_FW_0000022195": "是否必輸",
        "P_YS_FED_FW_0000022192": "上移",
        "P_YS_FED_FW_0000022193": "請輸入1-100數字",
        "P_YS_FED_FW_0000022198": "發布菜單",
        "P_YS_FED_FW_0000022199": "編輯過濾項",
        "P_YS_FED_FW_0001294823": "您沒有打開此單據的權限，確認關閉頁面",
        "P_YS_FED_FW_0000022197": "展開",
        "P_YS_FED_IMP_IOT0000006927": "杜爾伯特蒙古族自治縣",
        "P_YS_FED_IMP_IOT0000011520": "德昌縣",
        "P_YS_FED_FW_0000022190": "折線圖",
        "P_YS_FED_IMP_IOT0000006929": "陽西縣",
        "P_YS_FED_FW_0000022191": "請設置圖形報表信息。",
        "P_YS_FED_IMP_IOT0000006928": "內丘縣",
        "P_YS_FED_IMP_IOT0000011526": "懷仁縣",
        "P_YS_FED_UCFBASEDOC_0000024903": "商品清單",
        "P_YS_FED_IMP_IOT0000011523": "淄川區",
        "P_YS_OA_XTTMCENTER_0000035064": "下載",
        "P_YS_FED_IMP_IOT0000006920": "博愛縣",
        "P_YS_PF_GZTTMP_0000074463": "公共",
        "P_YS_SD_SDMA_0000062670": "€",
        "P_YS_FED_FW_0000022189": "底部插入行",
        "P_YS_FED_IMP_IOT0000009196": "壺關縣",
        "P_YS_FED_IMP_IOT0000009197": "清新縣",
        "P_YS_FED_IMP_IOT0000009190": "葉城縣",
        "P_YS_FED_IMP_IOT0000009191": "鹽都區",
        "P_YS_FED_IMP_IOT0000009194": "通城縣",
        "P_YS_FED_IMP_IOT0000009192": "博羅縣",
        "P_YS_FED_IMP_IOT0000009193": "全椒縣",
        "P_YS_FED_IMP_IOT0000011530": "郾城區",
        "P_YS_FED_IMP_IOT0000006913": "嵐皋縣",
        "P_YS_FED_IMP_IOT0000011532": "晉江市",
        "P_YS_FED_IMP_IOT0000010200": "嶺東區",
        "P_YS_FED_IMP_IOT0000006915": "江達縣",
        "P_YS_FED_IMP_IOT0000010201": "大化瑤族自治縣",
        "P_YS_FED_IMP_IOT0000011531": "廬陽區",
        "P_YS_FED_IMP_IOT0000006917": "蕉城區",
        "P_YS_FED_IMP_IOT0000006919": "新浦區",
        "P_YS_FED_IMP_IOT0000010206": "東源縣",
        "P_YS_FED_IMP_IOT0000010207": "清水縣",
        "P_YS_FED_IMP_IOT0000011537": "岐山縣",
        "P_YS_FED_IMP_IOT0000010208": "南海區",
        "P_YS_FED_IMP_IOT0000006910": "昆山市",
        "P_YS_FED_IMP_IOT0000011533": "雁峰區",
        "P_YS_FED_IMP_IOT0000010204": "淩海市",
        "P_YS_FED_IMP_IOT0000010205": "鄖西縣",
        "P_YS_FED_IMP_IOT0000011535": "哈密市",
        "P_YS_FED_IMP_IOT0000009188": "習水縣",
        "P_YS_HR_HRPXF_0000056097": "掃碼",
        "P_YS_FED_IMP_IOT0000009189": "蒲縣",
        "P_YS_FED_IMP_IOT0000009180": "阜寧縣",
        "P_YS_FI_CM_0000029370": "區域縮放",
        "P_YS_FED_IMP_IOT0000009184": "金塔縣",
        "P_YS_FED_IMP_IOT0000009181": "水城縣",
        "P_YS_FED_IMP_IOT0000006903": "商州區",
        "P_YS_FED_IMP_IOT0000011541": "瀘水縣",
        "P_YS_FED_IMP_IOT0000011540": "碭山縣",
        "P_YS_FED_IMP_IOT0000006905": "渭城區",
        "P_YS_FED_IMP_IOT0000011543": "榮縣",
        "P_YS_FED_FW_0001570014": "暫無數據模型",
        "P_YS_FED_IMP_IOT0000006904": "滎陽市",
        "P_YS_FED_FW_0001570015": "未找到匹配的特徵",
        "P_YS_FED_IMP_IOT0000006907": "巍山彞族回族自治縣",
        "P_YS_FI_CM_0000029374": "國",
        "P_YS_FED_FW_0001064735": "輸入小數位超出",
        "P_YS_FED_IMP_IOT0000011549": "新幹縣",
        "P_YS_FED_FW_0001064736": "限制小數位為0",
        "P_YS_FED_IMP_IOT0000010219": "射陽縣",
        "P_YS_FED_IMP_IOT0000006901": "杭錦後旗",
        "P_YS_FED_IMP_IOT0000006900": "揚中市",
        "P_YS_FED_IMP_IOT0000011546": "永嘉縣",
        "P_YS_FED_IMP_IOT0000009176": "綏中縣",
        "P_YS_FED_IMP_IOT0000009174": "順慶區",
        "P_YS_FED_IMP_IOT0000009175": "永清縣",
        "P_YS_FED_IMP_IOT0000009178": "灌雲縣",
        "P_YS_FED_IMP_IOT0000009179": "臨潼區",
        "P_YS_FED_IMP_IOT0000009171": "漠河縣",
        "P_YS_FED_IMP_IOT0000010221": "巧家縣",
        "P_YS_FED_IMP_IOT0000011551": "貴德縣",
        "P_YS_FED_IMP_IOT0000010222": "湞江區",
        "P_YS_OA_XTTMCENTER_0000035014": "上傳人",
        "P_YS_OA_LCGL_0000037185": "總數量",
        "P_YS_FED_FW_0001141477": "表格不能為空",
        "P_YS_FED_IMP_IOT0000010224": "安鄉縣",
        "P_YS_FED_FW_0001141476": "無此條記錄，請重新輸入",
        "P_YS_PF_GZTSYS_0000011894": "菜單管理",
        "P_YS_FED_FW_0001141479": "以下表頭欄位不能為空",
        "P_YS_FED_FW_0001141478": "未找到dom節點",
        "P_YS_FED_IMP_IOT0000010227": "高坪區",
        "P_YS_FED_IMP_IOT0000009166": "巴里坤哈薩克自治縣",
        "P_YS_FED_IMP_IOT0000009169": "黃石港區",
        "P_YS_FED_IMP_IOT0000009167": "中牟縣",
        "P_YS_FED_FW_1622974871724097545": "---[本地讀取JSON檔案報錯:]",
        "P_YS_FED_IMP_IOT0000009161": "衛輝市",
        "P_YS_FED_IMP_IOT0000009160": "安塞縣",
        "P_YS_FED_FW_1622974871724097548": "---[獲取Redis快取報錯:]",
        "P_YS_FED_IMP_IOT0000011564": "建德市",
        "P_YS_OA_XTTMCENTER_0000035019": "用戶名",
        "P_YS_FED_IMP_IOT0000011567": "彭山縣",
        "P_YS_FED_IMP_IOT0000010236": "嵊州市",
        "P_YS_FED_IMP_IOT0000011566": "那曲縣",
        "P_YS_FED_IMP_IOT0000010237": "賓縣",
        "P_YS_FED_IMP_IOT0000009155": "連雲區",
        "P_YS_FED_IMP_IOT0000009152": "東昌區",
        "P_YS_FED_FW_1442618603529043968": "請在搜索框中錄入關鍵字搜索,或切換左側分類",
        "P_YS_SD_SDMA_0000062635": "…",
        "P_YS_FED_IMP_IOT0000009157": "邕甯區",
        "P_YS_FED_FW_1455751582723342336": "檔.xlsx",
        "P_YS_FED_FW_0001152150": "您的權限不足，將另存為個人方案，是否繼續？",
        "P_YS_FED_IMP_IOT0000009150": "織金縣",
        "P_YS_FED_IMP_IOT0000010242": "忠縣",
        "P_YS_FED_UIMG_0000080080": "關聯欄位不允許隱藏",
        "P_YS_FED_IMP_IOT0000010243": "寧明縣",
        "P_YS_FED_IMP_IOT0000011573": "陵川縣",
        "P_YS_FED_IMP_IOT0000010244": "邢台縣",
        "P_YS_FED_IMP_IOT0000010245": "普定縣",
        "P_YS_FED_IMP_IOT0000011570": "江都市",
        "P_YS_FED_IMP_IOT0000010240": "欽南區",
        "P_YS_FED_FW_1421773194486874118": "公式賦值 表頭 >>:",
        "P_YS_SD_SDMB_0000139799": "請求超時!",
        "P_YS_FED_IMP_IOT0000011578": "龍井市",
        "P_YS_FED_IMP_IOT0000011577": "老河口市",
        "P_YS_FED_FW_1421773194486874115": "公式賦值 表體>>:",
        "P_YS_FED_IMP_IOT0000010248": "鳳慶縣",
        "P_YS_FED_FW_0001152149": "個人方案無法修改為公共方案，將另存為個人方案，是否繼續？",
        "P_YS_FED_FW_0001152148": "公共方案無法修改為個人方案，將另存為個人方案，是否繼續？",
        "P_YS_FED_FW_1421773194486874112": "耗時>>",
        "P_YS_FED_IMP_IOT0000009142": "雙峰縣",
        "P_YS_FED_IMP_IOT0000009145": "江海區",
        "P_YS_FED_FW_0001026464": "»",
        "P_YS_FED_FW_0000022132": "行標題",
        "P_YS_FED_IMP_IOT0000009260": "匯川區",
        "P_YS_FED_FW_0000022133": "請輸入1-99數字",
        "P_YS_FED_FW_0000022130": "系統項不允許進行刪除操作！",
        "P_YS_FED_FW_0000022131": "刪除成功！",
        "P_YS_FED_IMP_IOT0000010133": "鹹安區",
        "P_YS_FED_IMP_IOT0000011463": "桐柏縣",
        "P_YS_FED_IMP_IOT0000010134": "克山縣",
        "P_YS_FED_IMP_IOT0000011466": "邗江區",
        "P_YS_FED_IMP_IOT0000011465": "北票市",
        "P_YS_SCM_UPU-UI_0001085778": "訂單動向",
        "P_YS_FED_IMP_IOT0000010131": "禹城市",
        "P_YS_FED_IMP_IOT0000011461": "沐川縣",
        "P_YS_FED_IMP_IOT0000010136": "雨湖區",
        "P_YS_FED_IMP_IOT0000011468": "陽新縣",
        "P_YS_FED_IMP_IOT0000011467": "松溪縣",
        "P_YS_FED_IMP_IOT0000010138": "武山縣",
        "P_YS_FED_FW_1570021833376792583": "跳過",
        "P_YS_FED_FW_0000022125": "僅選中記錄",
        "P_YS_FED_FW_0000022126": "（最多顯示16項）",
        "P_YS_FED_FW_0000022123": "編輯訂閱方案",
        "P_YS_FED_IMP_IOT0000009251": "張家界",
        "P_YS_FED_FW_0000022124": "貿易公司",
        "P_YS_FED_FW_0000022129": "保存數據模版",
        "P_YS_FED_FW_0000022127": "俄語",
        "P_YS_FED_IMP_IOT0000009255": "芙蓉區",
        "P_YS_FED_FW_0000022128": "輔維度最多一項",
        "P_YS_FED_IMP_IOT0000009256": "伊寧市",
        "P_YS_FED_FW_1582115439097413635": "請選擇移動端布局。",
        "P_YS_FED_FW_0000022140": "輔維度行數",
        "P_YS_FED_FW_0001152050": "新失效日期不能早於新生效時間~請修改新失效日期",
        "P_YS_FED_FW_0000022143": "包含於",
        "P_YS_FED_FW_0000022144": "啊哦！沒此節點哦！",
        "P_YS_FED_IMP_IOT0000009250": "信豐縣",
        "P_YS_FED_FW_0000022141": "沒有可以更改的記錄",
        "P_YS_FED_IMP_IOT0000010144": "橫縣",
        "P_YS_FED_IMP_IOT0000011474": "源匯區",
        "P_YS_FED_IMP_IOT0000011477": "沿灘區",
        "P_YS_FED_IMP_IOT0000010146": "鄉城縣",
        "P_YS_FED_IMP_IOT0000011476": "達縣",
        "P_YS_FED_IMP_IOT0000011470": "甘德縣",
        "P_YS_FED_IMP_IOT0000011473": "六盤水",
        "P_YS_FED_IMP_IOT0000010141": "蘭西縣",
        "P_YS_FED_IMP_IOT0000011472": "張北縣",
        "P_YS_FED_IMP_IOT0000009248": "祁門縣",
        "P_YS_FED_IMP_IOT0000011479": "梅縣",
        "P_YS_FED_IMP_IOT0000011478": "芷江侗族自治縣",
        "P_YS_FED_IMP_IOT0000010149": "梅河口市",
        "P_YS_FED_FW_0000022136": "請選擇篩選指標",
        "P_YS_FED_IMP_IOT0000009242": "未央區",
        "P_YS_FED_FW_0000022137": "項目名稱",
        "P_YS_FED_FW_0001152049": "新生效日期不能早於當前時間~請修改新生效日期",
        "P_YS_FED_IMP_IOT0000009243": "和平區",
        "P_YS_FED_FW_0000022134": "存在行標題重複的行",
        "P_YS_FED_FW_0000022135": "所有信息-分組數據 group =",
        "P_YS_FED_IMP_IOT0000009241": "桑植縣",
        "P_YS_FED_UCFBASEDOC_0000024874": "角色名稱",
        "P_YS_FED_FW_0000022138": "刷新失敗",
        "P_YS_FED_FW_0000022139": "顯示數值",
        "P_YS_FED_UCFBASEDOC_0000024870": "查看詳情",
        "P_YS_FED_IMP_IOT0000011480": "中陽縣",
        "P_YS_FED_FW_0000022111": "標題字體大小",
        "P_YS_SD_URETAIL_0001048982": "請傳遞正確的參數!",
        "P_YS_FED_IMP_IOT0000010154": "許昌縣",
        "P_YS_FED_IMP_IOT0000011486": "東平縣",
        "P_YS_FED_IMP_IOT0000011485": "滄縣",
        "P_YS_FED_IMP_IOT0000010156": "東勝市",
        "P_YS_FED_IMP_IOT0000011488": "黃梅縣",
        "P_YS_FED_IMP_IOT0000011487": "瀘定縣",
        "P_YS_FED_IMP_IOT0000010153": "黔江區",
        "P_YS_FED_FW_0000022109": "圖+表",
        "P_YS_FED_IMP_IOT0000009237": "宜城市",
        "P_YS_FED_FW_0000022103": "上傳失敗！",
        "P_YS_FED_FW_0000022104": "請選擇地圖信息。",
        "P_YS_FED_IMP_IOT0000009232": "龍泉市",
        "P_YS_FED_FW_0000022101": "有輔維度存在，展示指標只支持單選",
        "P_YS_FED_FW_0000022102": "· 數值型別欄位：[資本總額]*1000、[物料詳情.線上零售價]*[物料詳情.商城-線上庫存量]",
        "P_YS_FED_IMP_IOT0000009230": "雙檯子區",
        "P_YS_FED_FW_0000022107": "行列=",
        "P_YS_FED_FW_0000022108": "展開更多",
        "P_YS_FED_FW_1426978763591122944": "確定要撤回單據嗎？",
        "P_YS_FED_FW_0000022105": "請選擇行再進行上移操作！",
        "P_YS_FED_FW_0000022106": "請設置方案",
        "P_YS_FED_IMP_IOT0000011490": "洛南縣",
        "P_YS_FED_FW_0000022122": "編碼不允許存在中文！",
        "P_YS_FED_FW_0000022120": "排名表",
        "P_YS_SCM_UPU-UI_0001085764": "未收齊",
        "P_YS_FED_IMP_IOT0000010167": "雲夢縣",
        "P_YS_FED_IMP_IOT0000011499": "新撫區",
        "P_YS_FED_IMP_IOT0000010168": "撫順縣",
        "P_YS_FED_FW_1583735397671763971": "+添加標籤",
        "P_YS_FED_IMP_IOT0000011493": "清河區",
        "P_YS_FED_IMP_IOT0000011495": "青原區",
        "P_YS_FED_FW_0001316754": "無名節點",
        "P_YS_FI_FCWEB_0001047917": "請選擇至少一條數據",
        "P_YS_FED_FW_0000022114": "會計主體",
        "P_YS_FED_IMP_IOT0000009220": "城東區",
        "P_YS_FED_FW_0000022115": "標題不可為空",
        "P_YS_FED_IMP_IOT0000009221": "肅北蒙古族自治縣",
        "P_YS_FED_FW_0000022112": "當前文件不允許下載！",
        "P_YS_FED_FW_0000022113": "請輸入公司網址",
        "P_YS_FED_FW_0000022118": "展示指標必選，且最多4項",
        "P_YS_FED_FW_0000022119": "項，勾選多個主維度將用\"/\"拼接顯示",
        "P_YS_FED_IMP_IOT0000009225": "南漳縣",
        "P_YS_FED_FW_0000022116": "拆分數量",
        "P_YS_FED_FW_0000022117": "刪除當前行",
        "P_YS_SD_UDHBI_0000032336": "待確認",
        "P_YS_FED_FW_0000022172": "內半徑百分比",
        "P_YS_FED_FW_0000022173": "熱區設置圖 上傳圖片：調用服務出錯  info.file.response",
        "P_YS_FED_FW_0000022170": "輸入數字的長度不能大於",
        "P_YS_FED_IMP_IOT0000010170": "蒼南縣",
        "P_YS_FED_FW_0000022171": "啊哦~沒有搜索到~",
        "P_YS_FED_IMP_IOT0000010171": "望都縣",
        "P_YS_FED_FW_0000022176": "（最多支持三級導航）",
        "P_YS_FED_FW_0000022177": "大屏輪播: 切換 afterChange",
        "P_YS_FED_FW_0000022174": "上傳成功！",
        "P_YS_FED_IMP_IOT0000010178": "鐵山區",
        "P_YS_FED_IMP_IOT0000010179": "河北區",
        "P_YS_FED_IMP_IOT0000010173": "大冶市",
        "P_YS_FED_IMP_IOT0000010175": "容縣",
        "P_YS_FED_IMP_IOT0000009217": "武陵源區",
        "P_YS_FED_IMP_IOT0000009218": "當陽市",
        "P_YS_FED_IMP_IOT0000009219": "高郵市",
        "P_YS_FED_UCFBASEDOC_0000024847": "折",
        "P_YS_FED_FW_0000022169": "大屏方案 設計 eChartPanelDesigngetPreView End",
        "P_YS_FED_FW_0000022167": "當前模板無數據",
        "P_YS_FED_FW_0000022168": "請輸入關鍵字",
        "P_YS_FED_IMP_IOT0000009212": "豐都縣",
        "P_YS_FED_FW_0000022183": "大屏輪播:獲取模板列表信息出錯。模板 panelIds =",
        "P_YS_FED_FW_0000022184": "eChartPanelDisplay 雙擊事件",
        "P_YS_FED_IMP_IOT0000010180": "新城區",
        "P_YS_FED_FW_0000022181": "設置匯總區  eChartConfig",
        "P_YS_FED_IMP_IOT0000010181": "通州市",
        "P_YS_FED_FW_0000022187": "企業LOGO",
        "P_YS_FED_FW_0000022188": "更新",
        "P_YS_FED_FW_0000022186": "保存匯總區設置失敗。信息 :",
        "P_YS_FED_IMP_IOT0000010183": "五寨縣",
        "P_YS_FED_FW_0000022180": "字體大小",
        "P_YS_FED_IMP_IOT0000010185": "邊壩縣",
        "P_YS_FED_IMP_IOT0000010186": "彭水苗族土家族自治縣",
        "P_YS_FED_IMP_IOT0000009205": "皇姑區",
        "P_YS_FED_FW_0000022178": "按您喜歡的順序拖放菜單",
        "P_YS_FED_FW_0000022179": "對齊方式",
        "P_YS_FED_FW_0000022150": "eChartDisplay狀態改變 shouldComponentUpdate  End false",
        "P_YS_FED_FW_0000022151": "確認要停用嗎？",
        "P_YS_FED_FW_0000022154": "恢復",
        "P_YS_FED_FW_0000022155": "事業部",
        "P_YS_FED_FW_0001456968": "條資料允許列印\\n",
        "P_YS_FED_FW_0000022152": "大屏看板已保存。",
        "P_YS_OA_XTWEIYOU_0000046261": "文件夾",
        "P_YS_FED_FW_0000022153": "不包含於",
        "P_YS_FED_IMP_IOT0000010198": "鳳山縣",
        "P_YS_FED_IMP_IOT0000010194": "于洪區",
        "P_YS_OA_XTWEIYOU_0000046266": "發送",
        "P_YS_FED_FW_0000022147": "熱區獲取FieldValue出錯。 obj =",
        "P_YS_FED_FW_0000022148": "參照類型",
        "P_YS_FED_FW_0000022145": "添加圖表",
        "P_YS_FED_UCFBASEDOC_0000024820": "到",
        "P_YS_FED_FW_0000022146": "獲取維度列表失敗！",
        "P_YS_FED_FW_0000022149": "彙總",
        "P_YS_PF_GZTSYS_0000011901": "立帳規則",
        "P_YS_FED_FW_0000022161": "氣泡圖",
        "P_YS_FED_FW_0000022162": ")。",
        "P_YS_FED_FW_0000022160": "當前頁面加載不成功～",
        "P_YS_FED_FW_0000022165": "配置文件中分組項欄位[",
        "P_YS_FED_FW_0000022166": "是否合計",
        "P_YS_FED_FW_0000022163": "檔案值",
        "P_YS_FED_FW_0000022164": "最小",
        "P_YS_FED_FW_1593218496493780999": "Los resultados de la búsqueda conjunta de documentos muestran",
        "P_YS_FED_FW_0000022158": "上傳大小超出限制，請重新上傳！",
        "P_YS_FED_FW_0000022159": "請輸入1-31數字",
        "P_YS_FED_FW_0000022156": "條!",
        "P_YS_FED_FW_0000022157": "訂閱設置",
        "P_YS_PF_GZTSYS_0000011912": "供應商屬性",
        "P_YS_FED_FW_0001460129": "請輸入有效電郵地址",
        "P_YS_FED_FW_0001243335": "支持excel格式檔、單檔；單個檔的大小限制不超過",
        "P_YS_FED_FW_0001243334": "MB，不超過10萬條數據",
        "P_YS_FED_FW_0001243333": "進行中...",
        "P_YS_FED_FW_1554658615102537733": "最多允許輸入15位",
        "P_YS_OA_app_xtywlj_0000037515": "憑證名稱",
        "P_YS_FED_FW_0001460130": "請輸入7~8位電話號碼",
        "P_YS_FED_FW_0001460133": "請輸入有效手機號碼",
        "P_YS_FED_FW_0001460132": "請輸入3~4位區號",
        "P_YS_FED_FW_0001460131": "請輸入11位手機號碼",
        "P_YS_OA_XTWEIYOU_0000046277": "全部關閉",
        "P_YS_SD_UDHAR_0000116811": "附件不能為空",
        "P_YS_FED_FW_0001134231": "存在空白行標題的行或行標題未賦新值",
        "P_YS_FI_YYFI-UI_0000161301": "複製行",
        "P_YS_FED_FW_1604430517195243523": "不允許使用user.tenant.和user.option.獲取，請使用tenan.和option.！！",
        "P_YS_SD_UDHWS_0000067925": "單號",
        "P_YS_SD_UDHBA_0000137530": "總行數",
        "P_YS_SD_SDMAUF_0000151755": "定金",
        "P_YS_FED_FW_0001045602": "共 <%=total%> 條",
        "P_YS_FED_FW_0001045601": "不知道",
        "P_YS_FED_FW_1467112879311290368": "只看必填項",
        "P_YS_HR_HRXCF_0000072919": "全部選擇",
        "P_YS_FED_FW_0001031014": "≤",
        "P_YS_PF_PRINT_0000065174": "主計量",
        "P_YS_FED_FW_0001473475": "變更失敗",
        "P_YS_FED_UIMG_0001088007": "關聯tips",
        "P_YS_FED_FW_0001473474": "生效後將更新業務領域使用的業務單元，並且將不可逆回，是否繼續？",
        "P_YS_FED_FW_1610061184968425476": "---[獲取JSON檔案報錯:]",
        "P_YS_PF_PROCENTER_0000023174": "商品名稱",
        "P_YS_FED_FW_0001160539": "缺少電話號碼",
        "P_YS_FED_FW_0000022100": "訂閱狀態",
        "P_YS_SCM_UPU-UI_0001085746": "按單檢視表-物料子表區域",
        "P_YS_FED_FW_0001007382": "暫無數據~",
        "P_YS_PF_PRINT_0000065185": "件數",
        "P_YS_FED_FW_1450555256411258883": "獲取定位失敗, ERROR(",
        "P_YS_FED_FW_1450555256411258880": "%c重置地理位置為當前用戶所在位置",
        "P_YS_SCM_UPU-UI_0001085715": "催單",
        "P_YS_SD_UDHWN_0000047991": "海淀區",
        "P_YS_FED_FW_1521253227064459268": "有交集",
        "P_YS_FED_FW_0001233973": "缺少wpsPreview方法",
        "P_YS_FED_UIMG_0000157462": "【提示】若“系統語言”為空，則按照“當前語言”進行保存。",
        "P_YS_FED_UIMG_0000157460": "當前語言",
        "P_YS_FED_UIMG_0000157461": "系統語言",
        "P_YS_SD_UDHBN_0001144476": "單號：$var{code}$var_end",
        "P_YS_FED_IMP_IOT0000005578": "漳浦縣",
        "P_YS_FED_IMP_IOT0000005571": "泰和縣",
        "P_YS_FED_IMP_IOT0000005570": "台安縣",
        "P_YS_FED_IMP_IOT0000005572": "柏鄉縣",
        "P_YS_FED_FW_0001123276": "是否匯出全部數據？",
        "P_YS_FED_FW_0001123277": "自動搜索",
        "P_YS_FED_FW_0001123274": "單次最大匯出50000條,請重新設置查詢條件後重試！",
        "P_YS_FED_FW_0001123275": "當前查詢數據為空，請重新設置查詢條件",
        "000723": "請輸入網址",
        "P_YS_FED_IMP_IOT0000006894": "資陽區",
        "P_YS_FED_IMP_IOT0000006897": "南江縣",
        "P_YS_FED_IMP_IOT0000006899": "依蘭縣",
        "P_YS_FED_IMP_IOT0000005568": "組織3",
        "P_YS_FED_IMP_IOT0000005567": "確認",
        "P_YS_OA_app_xtywlj_0000037365": "忽略",
        "P_YS_FED_IMP_IOT0000006891": "豐順縣",
        "P_YS_FED_IMP_IOT0000006890": "信州區",
        "P_YS_FED_IMP_IOT0000006893": "墾利縣",
        "P_YS_FED_IMP_IOT0000006892": "郎溪縣",
        "P_YS_FED_UCFORG_0000027586": "開",
        "P_YS_FED_IMP_IOT0000006884": "墊江縣",
        "P_YS_FED_IMP_IOT0000006883": "江口縣",
        "P_YS_FED_IMP_IOT0000005557": "組織2",
        "P_YS_FED_IMP_IOT0000006887": "青羊區",
        "P_YS_FED_IMP_IOT0000005558": "組織1",
        "P_YS_FED_IMP_IOT0000006889": "平羅縣",
        "P_YS_FED_IMP_IOT0000006882": "東海縣",
        "P_YS_FED_IMP_IOT0000006873": "建平縣",
        "P_YS_FED_IMP_IOT0000005541": "非空",
        "P_YS_FED_IMP_IOT0000006872": "尚義縣",
        "P_YS_FED_IMP_IOT0000006875": "麻江縣",
        "P_YS_FED_IMP_IOT0000006877": "冷水江市",
        "P_YS_FED_IMP_IOT0000006876": "鎮賚縣",
        "P_YS_FED_FW_1482737996175769616": "佈局位置",
        "P_YS_FED_FW_1482737996175769619": "移動方案",
        "P_YS_FED_IMP_IOT0000006869": "龍子湖區",
        "P_YS_FED_FW_1482737996175769610": "設置項",
        "P_YS_FED_FW_1482737996175769613": "另存為新方案",
        "P_YS_FED_IMP_IOT0000005531": "開始 ~ 結束",
        "P_YS_FED_IMP_IOT0000006862": "大渡口區",
        "P_YS_FED_IMP_IOT0000006864": "弋陽縣",
        "P_YS_FED_UCFORG_0000027572": "關",
        "P_YS_FED_IMP_IOT0000006863": "普蘭店市",
        "P_YS_FED_IMP_IOT0000006866": "偃師市",
        "P_YS_FED_IMP_IOT0000006865": "錫林浩特市",
        "P_YS_FED_FW_1482737996175769604": "設為默認方案",
        "P_YS_FED_FW_1482737996175769607": "手動搜索",
        "P_YS_FI_CM_0000029423": "右鍵另存為圖片",
        "P_YS_FED_FW_1482737996175769601": "別看了啥也沒有",
        "P_YS_FED_IMP_IOT0000006851": "銅官山區",
        "P_YS_FED_FW_0001249254": "已複製到剪貼板",
        "P_YS_FED_IMP_IOT0000006850": "金水區",
        "P_YS_FED_IMP_IOT0000005522": "行，訂單編號為:",
        "P_YS_FED_IMP_IOT0000006854": "南皮縣",
        "P_YS_FED_IMP_IOT0000006856": "大武口區",
        "P_YS_HR_HRYGF_0000058851": "布爾",
        "P_YS_OA_XTGONGWEN_0000045538": "簽收",
        "P_YS_FED_FW_0001131726": "人員",
        "P_YS_FED_IMP_IOT0000006848": "城關區",
        "P_YS_FED_IMP_IOT0000006847": "雞冠區",
        "P_YS_FED_IMP_IOT0000006849": "青田縣",
        "P_YS_FED_FW_0001131728": "確 定",
        "P_YS_FED_FW_0001131727": "取 消",
        "P_YS_FED_FW_0001060872": "欄位值無效！",
        "P_YS_FED_IMP_IOT0000006840": "綏江縣",
        "P_YS_FED_FW_0001060873": "沒有配置文件服務！",
        "P_YS_FED_IMP_IOT0000006844": "康保縣",
        "P_YS_FED_IMP_IOT0000005514": "下一步",
        "P_YS_FED_FW_1556026785534574596": "當前查詢方案存在“非空”（或“為空”）查詢，是否繼續保存？",
        "P_YS_OA_LCGL_0000037254": "批量刪除",
        "P_YS_FED_FW_0001060869": "切換主組織將清空數據，是否繼續",
        "P_YS_FED_IMP_IOT0000006837": "扶餘縣",
        "P_YS_FED_IMP_IOT0000006836": "撫寧縣",
        "P_YS_SCM_PU_0000028543": "獲取數據失敗",
        "P_YS_SD_UDHBN_0001144481": "交期：$var{recieveDate}$var_end數量：$var{qty}$var_end",
        "P_YS_FED_IMP_IOT0000005507": "終止",
        "P_YS_FED_FW_1482737996175769622": "搜索方式",
        "P_YS_FED_IMP_IOT0000006830": "青雲譜區",
        "P_YS_FED_IMP_IOT0000006833": "稻城縣",
        "P_YS_FED_IMP_IOT0000006832": "青陽縣",
        "P_YS_FED_IMP_IOT0000006835": "定結縣",
        "P_YS_FED_IMP_IOT0000005503": "查詢",
        "P_YS_SCM_USTOCK-UI_0000176083": "電子圍欄",
        "P_YS_FED_IMP_IOT0000006826": "渦陽縣",
        "P_YS_FED_IMP_IOT0000006828": "潤州區",
        "P_YS_HR_HRYGF_0000058837": "枚舉",
        "P_YS_FED_IMP_IOT0000006829": "神池縣",
        "P_YS_FED_IMP_IOT0000006822": "臨沭縣",
        "P_YS_FED_IMP_IOT0000006823": "曲麻萊縣",
        "P_YS_FED_IMP_IOT0000009098": "張家港市",
        "P_YS_FED_IMP_IOT0000009091": "揭東縣",
        "P_YS_FED_IMP_IOT0000009090": "鄂溫克族自治旗",
        "P_YS_PF_SOCD-E_0000433293": "山南市",
        "P_YS_FED_IMP_IOT0000009096": "南豐縣",
        "P_YS_FED_IMP_IOT0000009093": "東西湖區",
        "P_YS_FED_IMP_IOT0000006815": "阿瓦提縣",
        "P_YS_FED_IMP_IOT0000006817": "龍川縣",
        "P_YS_FED_IMP_IOT0000006816": "平泉縣",
        "P_YS_OA_LCGL_0000037261": "高級查詢",
        "P_YS_FED_FW_0001143732": "lineNoStep()參數不是一個有效的數",
        "P_YS_FED_IMP_IOT0000009080": "渝中區",
        "P_YS_PF_SOCD_0000066122": "薩爾瓦多",
        "P_YS_FED_IMP_IOT0000009081": "榮昌縣",
        "project.tag.tag07": "互聯網",
        "P_YS_MF_PO-FE_0001118286": "✔",
        "P_YS_FED_IMP_IOT0000009083": "萬榮縣",
        "P_YS_FED_IMP_IOT0000006804": "龍州縣",
        "P_YS_FED_FW_0001264815": "列表設置",
        "P_YS_FED_IMP_IOT0000011400": "威寧彝族回族苗族自治縣",
        "P_YS_FED_IMP_IOT0000006808": "西安區",
        "P_YS_FED_IMP_IOT0000006809": "汝陽縣",
        "P_YS_FED_IMP_IOT0000011406": "溫江區",
        "P_YS_FED_IMP_IOT0000011405": "玉山縣",
        "P_YS_FED_IMP_IOT0000011408": "荊州區",
        "P_YS_FED_IMP_IOT0000006800": "監利縣",
        "P_YS_FED_IMP_IOT0000011403": "安仁縣",
        "P_YS_FED_IMP_IOT0000009075": "欽北區",
        "P_YS_PF_TRS_0000034743": "年齡",
        "P_YS_FED_IMP_IOT0000009076": "杭州",
        "P_YS_FED_IMP_IOT0000009079": "任縣",
        "P_YS_FED_IMP_IOT0000009074": "濮陽",
        "P_YS_FED_IMP_IOT0000011411": "洛寧縣",
        "P_YS_FED_IMP_IOT0000011416": "無為縣",
        "P_YS_FED_IMP_IOT0000011419": "雲岩區",
        "P_YS_FED_IMP_IOT0000011418": "駐馬店",
        "P_YS_PF_GZTTMP_0000074112": "食品",
        "P_YS_SD_UDHWN_0000050056": "文昌市",
        "P_YS_FED_IMP_IOT0000009065": "南岔區",
        "P_YS_FED_IMP_IOT0000009068": "合江縣",
        "P_YS_PF_SOCD_0000066131": "斐濟",
        "P_YS_FED_IMP_IOT0000009069": "新縣",
        "P_YS_FED_FW_0001026106": "<%=alertStrPrefix%>至少錄入一行數據！",
        "P_YS_FED_IMP_IOT0000009062": "防城港",
        "P_YS_FED_IMP_IOT0000009063": "昌樂縣",
        "P_YS_FED_IMP_IOT0000009060": "嘉定區",
        "P_YS_FED_IMP_IOT0000009061": "包河區",
        "P_YS_FED_IMP_IOT0000011421": "蘭溪市",
        "P_YS_FED_IMP_IOT0000011429": "復興區",
        "P_YS_FED_IMP_IOT0000011424": "景縣",
        "P_YS_FED_IMP_IOT0000011426": "修水縣",
        "P_YS_FED_IMP_IOT0000011425": "關閉",
        "P_YS_FED_IMP_IOT0000009054": "托克遜縣",
        "P_YS_FED_IMP_IOT0000009057": "永新縣",
        "P_YS_FED_IMP_IOT0000009051": "榆社縣",
        "P_YS_FED_IMP_IOT0000009050": "赤壁市",
        "P_YS_FED_IMP_IOT0000010100": "靈丘縣",
        "P_YS_FED_IMP_IOT0000010101": "北塘區",
        "P_YS_FED_IMP_IOT0000011432": "蘭山區",
        "P_YS_PF_VPA_0000082557": "調用失敗",
        "P_YS_FED_FW_0001125804": "specialcom的cStyle未配置:",
        "P_YS_FED_FW_0001125803": "未找到specialcom的目標model:",
        "P_YS_FED_IMP_IOT0000010104": "南康市",
        "P_YS_FED_IMP_IOT0000010105": "雅江縣",
        "P_YS_FED_IMP_IOT0000011437": "遂川縣",
        "P_YS_SD_SDOC_0000164303": "派件",
        "P_YS_FED_IMP_IOT0000009042": "細河區",
        "P_YS_FED_IMP_IOT0000009046": "寧化縣",
        "P_YS_FED_IMP_IOT0000009040": "紫陽縣",
        "P_YS_FED_IMP_IOT0000009041": "白雲區",
        "P_YS_FED_IMP_IOT0000010111": "天河區",
        "P_YS_FED_IMP_IOT0000011441": "旺蒼縣",
        "P_YS_FED_IMP_IOT0000011443": "衡山縣",
        "P_YS_FED_IMP_IOT0000011440": "巴東縣",
        "P_YS_FED_FW_0001143784": "交互規則",
        "P_YS_FED_IMP_IOT0000010118": "宣州區",
        "P_YS_FED_IMP_IOT0000010119": "新市區",
        "P_YS_FED_IMP_IOT0000011449": "敦煌市",
        "P_YS_FED_IMP_IOT0000009039": "革吉縣",
        "P_YS_FED_FW_0001143783": "交互規則初始化",
        "P_YS_FED_IMP_IOT0000010114": "峨眉山市",
        "P_YS_FED_IMP_IOT0000011447": "喀喇沁旗",
        "P_YS_FED_IMP_IOT0000009031": "水磨溝區",
        "P_YS_FED_IMP_IOT0000009037": "常寧市",
        "P_YS_FED_IMP_IOT0000009036": "政和縣",
        "P_YS_FED_FW_0001155764": "您的權限不足!",
        "P_YS_FED_FW_1503620195896262656": "精準搜索",
        "P_YS_FED_IMP_IOT0000011453": "含山縣",
        "P_YS_FED_IMP_IOT0000010122": "溧陽市",
        "P_YS_FED_IMP_IOT0000010123": "蓬江區",
        "P_YS_FED_IMP_IOT0000011454": "甘南縣",
        "P_YS_FED_IMP_IOT0000010120": "永興縣",
        "P_YS_FED_IMP_IOT0000011450": "秦都區",
        "P_YS_FED_IMP_IOT0000010129": "屏南縣",
        "P_YS_FED_IMP_IOT0000009028": "北辰區",
        "P_YS_FED_IMP_IOT0000010125": "大田縣",
        "P_YS_FED_IMP_IOT0000011456": "玉門市",
        "P_YS_FED_IMP_IOT0000009023": "開陽縣",
        "P_YS_OA_XTMENHUCMS_0000045358": "添加描述",
        "P_YS_FED_IMP_IOT0000009027": "平武縣",
        "P_YS_FED_IMP_IOT0000009025": "東光縣",
        "P_YS_FED_FW_0000022250": "初始化出錯。",
        "P_YS_FED_FW_0000022253": "當前區域沒有地圖組件。",
        "P_YS_FED_FW_0000022254": "的整數",
        "P_YS_FED_FW_0000022251": "地圖",
        "P_YS_FED_FW_0000022252": "操作成功！",
        "P_YS_FED_FW_1435891525106532352": "以下字段有誤(或存在必填項)",
        "P_YS_FED_EXAMP_0000020085": "訂單屬性",
        "P_YS_FED_IMP_IOT0000010011": "西鄉塘區",
        "P_YS_FED_EXAMP_0000020084": "沒有需要自動揀貨的商品行！",
        "P_YS_FED_EXAMP_0000020087": "請輸入起始卡券號",
        "P_YS_FED_IMP_IOT0000011345": "鯉城區",
        "server.rest.idcard.is.wrong": "身份證號格式不正確",
        "P_YS_FED_EXAMP_0000020086": "【異常】",
        "P_YS_OA_XTWEIYOU_0000046327": "全部已讀",
        "P_YS_FED_EXAMP_0000020081": "SKU名稱",
        "P_YS_FED_EXAMP_0000020080": "不能使用會員錢包結算",
        "P_YS_FED_EXAMP_0000020082": "沒有適用的促銷活動！",
        "P_YS_FED_IMP_IOT0000010010": "鳳陽縣",
        "P_YS_FED_IMP_IOT0000010019": "集寧市",
        "P_YS_FED_IMP_IOT0000009139": "堆龍德慶縣",
        "P_YS_FED_EXAMP_0000020078": "子件商品不允許執行積分抵扣",
        "P_YS_FED_IMP_IOT0000011347": "沛縣",
        "P_YS_FED_EXAMP_0000020077": "調試用戶校驗失敗",
        "P_YS_FED_IMP_IOT0000010017": "開平市",
        "P_YS_FED_EXAMP_0000020079": "獲取網絡打印設置失敗！",
        "P_YS_FED_FW_0000022246": "顯示條數設置不正確",
        "P_YS_FED_FW_0000022247": "保留內層間距",
        "P_YS_FED_FW_0001065740": "名稱長度不可超過20個字符",
        "P_YS_FED_IMP_IOT0000009133": "廣德縣",
        "P_YS_FED_FW_0000022244": "請設置匯總欄位",
        "P_YS_FED_IMP_IOT0000009130": "龍崗區",
        "P_YS_FED_FW_0000022245": "樣式",
        "P_YS_FED_IMP_IOT0000009137": "洛浦縣",
        "P_YS_FED_FW_0000022248": "大屏匯總區域設置不自動刷新。 refreshInterval",
        "P_YS_FED_FW_0001065741": "名稱已超過20個字符！",
        "P_YS_FED_IMP_IOT0000009134": "永靖縣",
        "P_YS_FED_FW_0000022249": "修改為",
        "P_YS_FED_IMP_IOT0000009135": "南陵縣",
        "P_YS_FED_FW_0000022260": "輸入的數字不能大於",
        "P_YS_FED_FW_0001345199": "當前模板沒有配置filterId,無法獲取查詢方案資料",
        "P_YS_FED_FW_0000022261": "反選",
        "P_YS_FED_EXAMP_0000020090": "稱重重量低於標準重量，請檢查托盤和產品是否擺放正確！",
        "P_YS_FED_FW_0000022264": "操作符不可為空，請檢查",
        "P_YS_FED_FW_0000022265": "折線展現",
        "P_YS_FED_FW_0000022262": "暫無模版數據～",
        "P_YS_FED_FW_0001371485": "聚合浮動顯示",
        "P_YS_FED_FW_0000022263": "條，失敗",
        "P_YS_FED_EXAMP_0000020096": "已使用卡券號範圍錄入方式, 不允許輸入卡號",
        "P_YS_FED_FW_0001292111": "請求介面地址:(",
        "P_YS_FED_EXAMP_0000020095": "當前網絡不可用，不能使用此功能!",
        "P_YS_FED_IMP_IOT0000011353": "建始縣",
        "P_YS_FED_EXAMP_0000020098": "不能執行現場折扣",
        "P_YS_FED_EXAMP_0000020097": "支付失敗，需撤銷暢捷支付。執行線上撤銷？",
        "P_YS_FED_IMP_IOT0000011355": "秦淮區",
        "P_YS_FED_FW_0001292112": "介面返回資料:(",
        "P_YS_FED_EXAMP_0000020092": "已經執行了整單折扣，不能再新增商品！",
        "P_YS_FED_IMP_IOT0000011350": "墨竹工卡縣",
        "P_YS_FED_EXAMP_0000020091": "周六",
        "P_YS_FED_EXAMP_0000020094": "零售金額為0，計算折扣錯誤！",
        "P_YS_FED_IMP_IOT0000010020": "雁塔區",
        "P_YS_FED_EXAMP_0000020093": "時段:",
        "P_YS_FED_IMP_IOT0000010021": "烏恰縣",
        "P_YS_FED_IMP_IOT0000011351": "肅南裕固族自治縣",
        "P_YS_FED_IMP_IOT0000009129": "文山縣",
        "P_YS_FED_EXAMP_0000020089": "銀聯",
        "P_YS_FED_EXAMP_0000020088": "服務器地址格式不正確",
        "P_YS_FED_IMP_IOT0000010028": "武漢",
        "P_YS_FED_IMP_IOT0000010029": "連南瑤族自治縣",
        "P_YS_FED_IMP_IOT0000011359": "舒城縣",
        "P_YS_FED_IMP_IOT0000009121": "廣宗縣",
        "P_YS_FED_FW_0000022258": "新增訂閱方案",
        "P_YS_FED_FW_0000022255": "增加",
        "P_YS_FED_FW_0000022256": "未選中任何行！",
        "P_YS_FED_IMP_IOT0000009125": "衛濱區",
        "P_YS_FED_FW_0001648419": "設為租戶級模版",
        "P_YS_FED_FW_0000022259": "氣泡圖展示指標只支持單選",
        "P_YS_FED_IMP_IOT0000009123": "梅里斯達斡爾族區",
        "P_YS_FED_FW_0001026167": "沒有找著編碼為<%=menuCode%>的菜單",
        "P_YS_FED_IMP_IOT0000009124": "靈台縣",
        "P_YS_FED_FW_0000022232": "小數位數",
        "P_YS_FED_FW_0000022230": "標題內容",
        "P_YS_FED_IMP_IOT0000010033": "費縣",
        "P_YS_FED_IMP_IOT0000011365": "思明區",
        "P_YS_FED_IMP_IOT0000011367": "吉利區",
        "P_YS_FED_IMP_IOT0000010036": "吉首市",
        "P_YS_FED_IMP_IOT0000011360": "西峽縣",
        "P_YS_FED_IMP_IOT0000010031": "鹿城區",
        "P_YS_FED_IMP_IOT0000011363": "扎魯特旗",
        "P_YS_FED_IMP_IOT0000009116": "黎平縣",
        "P_YS_FED_EXAMP_0000020099": "預制",
        "P_YS_FED_IMP_IOT0000010038": "大同縣",
        "P_YS_FED_IMP_IOT0000011368": "江南區",
        "P_YS_FED_FW_0000022224": "維度導航方案",
        "P_YS_FED_FW_0000022225": "共處理",
        "P_YS_FED_FW_0000022222": "（全部附件大小不可超過",
        "P_YS_FED_FW_0000022223": "使用",
        "P_YS_FED_FW_0001026130": "<%=text%> 上傳失敗!",
        "P_YS_FED_FW_0000022228": "欄目名稱",
        "P_YS_FED_IMP_IOT0000009114": "曲江區",
        "P_YS_FED_FW_0000022229": "請輸入漣漪特效個數",
        "P_YS_FED_IMP_IOT0000009115": "棲霞市",
        "P_YS_FED_FW_0000022226": "常用功能設置",
        "P_YS_FED_FW_0001026133": "文件必須小於<%=text%>M",
        "P_YS_FED_IMP_IOT0000009112": "西吉縣",
        "P_YS_FED_FW_0000022227": "未找到",
        "P_YS_FED_FW_0001026137": "<%=text%>已經在圖形報表中使用，不能刪除。",
        "P_YS_FED_FW_0000022242": "確認要啟用嗎？",
        "P_YS_FED_FW_0000022243": "數據項",
        "P_YS_FED_FW_0000022240": "主組織和模版名稱不能為空",
        "P_YS_FED_FW_0000022241": "請輸入方案名稱",
        "P_YS_FED_IMP_IOT0000010045": "丹棱縣",
        "P_YS_FED_IMP_IOT0000011375": "羅定市",
        "P_YS_FED_IMP_IOT0000011378": "泰順縣",
        "P_YS_FED_IMP_IOT0000010040": "鹿寨縣",
        "P_YS_FED_IMP_IOT0000011371": "襄垣縣",
        "P_YS_FED_IMP_IOT0000010042": "鑲黃旗",
        "P_YS_FED_IMP_IOT0000011374": "臨渭區",
        "P_YS_FED_IMP_IOT0000010043": "普安縣",
        "P_YS_FED_IMP_IOT0000011373": "索縣",
        "P_YS_FED_IMP_IOT0000009105": "寧國市",
        "P_YS_FED_IMP_IOT0000010048": "廣靈縣",
        "P_YS_FED_IMP_IOT0000010049": "大名縣",
        "P_YS_FED_IMP_IOT0000011379": "民樂縣",
        "P_YS_FED_FW_0000022235": "最多選擇5個匯總項。",
        "P_YS_SD_SDMBF_0000143365": "遊戲",
        "P_YS_FED_FW_0000022236": "導航",
        "P_YS_FED_FW_0000022233": "大屏方案 展現 this.serieNum =",
        "P_YS_FED_FW_0000022234": "葡萄牙語",
        "P_YS_FED_FW_0000022239": "點擊上傳背景圖片",
        "P_YS_FED_FW_0000022237": "顯示條數",
        "P_YS_FED_IMP_IOT0000009101": "和平縣",
        "P_YS_FED_FW_0000022238": "模版名稱不能為空",
        "P_YS_FED_IMP_IOT0000009102": "肥西縣",
        "P_YS_FED_FW_0000022293": "中度",
        "P_YS_FED_FW_0000022294": "操作信息",
        "P_YS_FED_FW_0000022291": "庫存組織",
        "P_YS_FED_IMP_IOT0000011381": "孟州市",
        "P_YS_FED_FW_0000022292": "大屏方案2 eChartPanelDisplay2 展現 constructor",
        "P_YS_FED_IMP_IOT0000010050": "新蔡縣",
        "P_YS_FED_IMP_IOT0000011380": "昌寧縣",
        "P_YS_FED_FW_0000022297": "確定要刪除嗎?",
        "P_YS_FED_FW_0000022298": "保存失敗！",
        "P_YS_FED_FW_0000022295": "暫無圖片~",
        "P_YS_FED_FW_0000022296": "請確保數據型別設置正確，啟用後不允許調整！",
        "P_YS_FED_EXAMP_0000020041": "建議零售價 :",
        "P_YS_FED_EXAMP_0000020040": "智能補貨規則",
        "P_YS_FED_EXAMP_0000020043": "數據錯誤,請檢查！",
        "P_YS_FED_IMP_IOT0000010057": "鎮沅彞族哈尼族拉祜族自治縣",
        "P_YS_FED_EXAMP_0000020042": "錢包帳戶信息錯誤",
        "P_YS_FED_IMP_IOT0000010058": "東港市",
        "P_YS_FED_IMP_IOT0000011388": "路南區",
        "P_YS_FED_IMP_IOT0000011383": "晉州市",
        "P_YS_SD_SDMAUF_0000152734": "你好",
        "P_YS_FED_FW_0000022290": "小於等於",
        "P_YS_FED_IMP_IOT0000010053": "淮濱縣",
        "P_YS_FED_IMP_IOT0000011385": "中山區",
        "P_YS_FED_EXAMP_0000020038": "折扣券",
        "P_YS_FED_EXAMP_0000020037": "重量",
        "P_YS_FED_EXAMP_0000020039": "選擇行業",
        "P_YS_FED_EXAMP_0000020034": "西單店",
        "P_YS_FED_IMP_IOT0000010059": "瑞麗市",
        "P_YS_FED_EXAMP_0000020033": "請檢查退款儲值卡是否正確有效",
        "P_YS_FED_EXAMP_0000020036": "本地未適配電子秤",
        "P_YS_FED_EXAMP_0000020035": "的菜單",
        "P_YS_FED_FW_0000022288": "(提示:刷新太頻繁會造成服務器壓力過大)",
        "P_YS_FED_FW_0000022289": "標題內容不可為空",
        "P_YS_FED_FW_1607450978713862149": "<div>UI模板名稱：",
        "P_YS_FED_FW_1607450978713862146": "</div><div>UI模板ID：",
        "P_YS_FED_IMP_IOT0000011392": "漢台區",
        "P_YS_SD_UDHWN_0000122271": "請輸入身份證號",
        "P_YS_FED_EXAMP_0000020052": "沒有可以執行",
        "P_YS_FED_IMP_IOT0000011398": "武鄉縣",
        "P_YS_FED_EXAMP_0000020051": "卡號範圍內",
        "P_YS_FED_IMP_IOT0000011397": "伊吾縣",
        "P_YS_FED_EXAMP_0000020054": "刪除行",
        "P_YS_FED_EXAMP_0000020053": "商品檔案",
        "P_YS_FED_IMP_IOT0000011399": "新沂市",
        "P_YS_FED_IMP_IOT0000010062": "昌圖縣",
        "P_YS_FED_IMP_IOT0000010063": "石林彞族自治縣",
        "P_YS_FED_EXAMP_0000020050": "業務菜單",
        "P_YS_FED_IMP_IOT0000011395": "雙牌縣",
        "P_YS_FED_EXAMP_0000020049": "未錄入儲值卡",
        "P_YS_FED_EXAMP_0000020048": "預訂成功",
        "P_YS_FED_EXAMP_0000020045": "交班",
        "P_YS_FED_FW_1420997849809682432": "YYYY-ww周",
        "P_YS_FED_EXAMP_0000020044": "稱重設備連接異常！",
        "P_YS_FED_EXAMP_0000020047": "點擊是將選擇當前優惠券，否則不選。",
        "P_YS_FED_EXAMP_0000020046": "調整",
        "P_YS_FED_FW_0000022299": "主維度排序",
        "P_YS_FED_FW_0000022271": "是否增加排名列",
        "P_YS_FED_FW_0000022272": "確定刪除所選模版麼？",
        "P_YS_FED_FW_0000022270": "3、邏輯表達式僅支持由“=、!=”構成的等式表達式之間的邏輯運算，例如：",
        "P_YS_FED_IMP_IOT0000010072": "臨淄區",
        "P_YS_FED_FW_0000022275": "指標",
        "P_YS_FED_FW_0000022276": "· or運算符（||）：[規格型號]!=null||[物料簡稱]!=null",
        "P_YS_FED_FW_0000022273": "暫無搜索結果哦~",
        "P_YS_FED_FW_0000022274": "研發中心",
        "P_YS_FED_EXAMP_0000020063": "]所對用的收款方式!",
        "P_YS_FED_EXAMP_0000020062": "商品標籤",
        "P_YS_FED_EXAMP_0000020065": "當前單據狀態下不允許修改數量！",
        "P_YS_FED_EXAMP_0000020064": "無此優惠券~",
        "P_YS_FED_IMP_IOT0000010074": "宣漢縣",
        "P_YS_FED_EXAMP_0000020061": "該卡號已經錄入",
        "P_YS_FED_EXAMP_0000020060": "推薦人手機",
        "P_YS_FED_IMP_IOT0000010076": "岑鞏縣",
        "P_YS_FED_EXAMP_0000020059": "定製",
        "P_YS_FED_EXAMP_0000020056": "無選配",
        "P_YS_FED_EXAMP_0000020055": "（房間號）的房間類型",
        "P_YS_FED_EXAMP_0000020058": "驗證碼錯誤",
        "P_YS_FED_EXAMP_0000020057": "售後服務",
        "P_YS_FED_FW_0000022268": "表頭",
        "P_YS_FED_FW_0001010614": "圖片高度不能超過",
        "P_YS_FED_FW_0000022269": "圖片大小要小於 1MB!",
        "P_YS_FED_FW_0001010613": "圖片尺寸不能超過",
        "P_YS_FED_FW_0000022266": "大屏方案3 eChartPanelDisplay3展現Render End",
        "P_YS_FED_FW_0001010616": "大圖預覽",
        "P_YS_FED_FW_0000022267": "大屏輪播:獲取模板配置信息。返回 json.data.length",
        "P_YS_FED_FW_0001010615": "像素的圖片！",
        "P_YS_FED_FW_0001010618": "圖片寬度不能超過",
        "P_YS_FED_FW_0001010617": "刪除後不可恢復，確認刪除已選附件？",
        "P_YS_FED_FW_0001010619": "只允許上傳",
        "P_YS_FED_FW_0000022282": "採購單",
        "P_YS_FED_IMP_IOT0000010080": "古田縣",
        "P_YS_FED_FW_0000022283": "計數",
        "P_YS_FED_IMP_IOT0000010081": "長沙縣",
        "P_YS_FED_FW_0000022280": "改名",
        "P_YS_FED_IMP_IOT0000010082": "岳池縣",
        "P_YS_FED_FW_0000022281": "請增加過濾條件。",
        "P_YS_FED_IMP_IOT0000010083": "尉犁縣",
        "P_YS_FED_FW_0000022286": "通過顏色深淺顯示數量信息",
        "P_YS_FED_FW_0000022287": "萬",
        "P_YS_FED_FW_0000022284": "地圖顯示",
        "P_YS_FED_FW_0000022285": "至少保留一個顯示列！",
        "P_YS_FED_EXAMP_0000020074": "錄入的序列號中不存在數值數據，無法自動指定,請檢查!",
        "P_YS_FED_EXAMP_0000020073": "本單使用了優惠券收款方式，不允許增行",
        "P_YS_FED_EXAMP_0000020076": "狀態下不能進行",
        "P_YS_FED_EXAMP_0000020075": "操作成功",
        "P_YS_FED_EXAMP_0000020070": "請輸入結束卡券號",
        "P_YS_FED_IMP_IOT0000010085": "漣水縣",
        "P_YS_FED_EXAMP_0000020072": "退貨待出",
        "P_YS_FED_EXAMP_0000020071": "整單金額小於原單金額，不能結算!",
        "P_YS_FED_IMP_IOT0000010087": "孫吳縣",
        "P_YS_FED_EXAMP_0000020067": "進貨價",
        "P_YS_FED_EXAMP_0000020066": "序列號重複!",
        "P_YS_FED_EXAMP_0000020069": "上傳中...",
        "P_YS_FED_EXAMP_0000020068": "買斷房費",
        "P_YS_FED_FW_0000022279": "未知",
        "P_YS_FED_FW_0000022277": "配置信息中欄位驗證失敗。包含欄目中不存在的欄位 轉換後",
        "P_YS_FED_FW_0000022278": "顯示名稱:",
        "P_YS_FED_IMP_IOT0000010092": "申紮縣",
        "P_YS_SCM_STOCK_0000034620": "保存並結算",
        "P_YS_SCM_STOCK_0000034621": "這裡空空蕩蕩的～",
        "P_YS_SCM_STOCK_0000034622": "新開單",
        "P_YS_FED_IMP_IOT0000010090": "豐寧滿族自治縣",
        "P_YS_FED_IMP_IOT0000010099": "牧野區",
        "P_YS_SCM_STOCK_0000034627": "的數據失敗！",
        "P_YS_SCM_STOCK_0000034628": "選擇業務類型",
        "P_YS_FED_IMP_IOT0000010096": "湘橋區",
        "P_YS_SD_URETAIL_0001048677": "】表出現其他表的數據！具體數據為::",
        "P_YS_FED_FW_0000111015": "當前選擇會導致行標題存在重複信息,請檢查。",
        "P_YS_FED_EXAMP_0000020010": "套餐沒有商品",
        "P_YS_FI_CM_0000029500": "頁",
        "P_YS_AM_AMBDF_0001625636": "手電筒",
        "P_YS_FED_EXAMP_0000020005": "模板",
        "P_YS_FED_FW_0001118762": "選擇文件格式不正確，請重新選擇",
        "P_YS_FED_EXAMP_0000020004": "共",
        "P_YS_FED_FW_0001118763": "支持jpg、bmp、png、jpeg，最大1M，700*700 以上的圖片可以在商品詳情頁主圖提供圖片放大功能",
        "P_YS_FED_EXAMP_0000020007": "儲值卡號為空",
        "P_YS_FED_FW_0001118761": "支持格式：jpg、bmp、png、jpeg",
        "P_YS_FED_EXAMP_0000020001": "支付失敗，需撤銷",
        "P_YS_FED_FW_0001010620": "像素！",
        "P_YS_FED_EXAMP_0000020000": "促銷活動",
        "P_YS_FED_EXAMP_0000020003": "未登錄到門店，不能開單",
        "P_YS_FED_EXAMP_0000020002": "促銷優惠",
        "P_YS_PF_PRINT_0000065262": "物料名稱",
        "P_YS_FED_EXAMP_0000020009": "該商品執行過促銷活動，退品後可能不滿足原促銷條件！",
        "P_YS_FED_EXAMP_0000020008": "會員帳號為空",
        "P_YS_FED_FW_0000137655": "必輸項<%=text%>未輸入，請輸入完整再嘗試保存！",
        "P_YS_FED_FW_0000137654": "Refer關聯定義",
        "P_YS_FED_FW_0000137653": "value值格式錯誤",
        "P_YS_FED_FW_0000137652": "有錯誤",
        "P_YS_FED_FW_0000137651": "未獲得billType",
        "P_YS_FED_FW_0000137650": "未配置tree 的billnumber ,在commend表的target中設置",
        "P_YS_FED_EXAMP_0000020021": "西直門店",
        "P_YS_FED_EXAMP_0000020020": "按鈕的功能權限，不能操作！",
        "P_YS_PF_QITDFE_0001344211": "匯出異常原因",
        "P_YS_SD_SDMAUF_0000152710": "分頁名稱",
        "P_YS_FED_EXAMP_0000020016": "首頁",
        "P_YS_FED_EXAMP_0000020015": "經營概況",
        "P_YS_FED_EXAMP_0000020018": "開始卡券號和結束卡券號長度必須相等",
        "P_YS_FED_EXAMP_0000020017": "卡券非原單退,卡券數量應為-1,請勾選退貨商品",
        "P_YS_FED_EXAMP_0000020012": "僅選擇一條單據情況下才能執行確定操作！",
        "P_YS_FED_EXAMP_0000020011": "此操作不能恢復，所選零售單是否已開票完畢？",
        "P_YS_FED_FW_0001557217": "【第<%=text%>行】",
        "P_YS_FED_EXAMP_0000020014": "預訂交貨狀態",
        "P_YS_FED_EXAMP_0000020013": "儲值業務型別下不能使用會員錢包支付",
        "P_YS_FED_FW_0000137649": "參照自定義項錯誤：",
        "P_YS_FED_EXAMP_0000020019": "機構人員",
        "P_YS_FED_FW_0000137666": "Tag關聯定義",
        "P_YS_FED_FW_0000137665": "列表cCarry JSON格式錯誤-->",
        "P_YS_FED_FW_0000137664": "孫表暫存出錯",
        "P_YS_FED_FW_0000137663": "[{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"菜單\\\",\\\"key\\\":\\\"menu\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"許可權\\\",\\\"key\\\":\\\"auth\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"按鈕許可權\\\",\\\"key\\\":\\\"actionAuth\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"規則\\\",\\\"key\\\":\\\"rule\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"選項\\\",\\\"key\\\":\\\"option\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"枚舉\\\",\\\"key\\\":\\\"enum\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"ViewModel\\\",\\\"key\\\":\\\"viewmodel\\\"}]",
        "P_YS_FED_FW_0000137661": "保存失敗--【",
        "P_YS_SCM_STOCK_0000034610": "驗貨中",
        "P_YS_FED_FW_0000137660": "menu中預製的billtype:",
        "P_YS_SCM_STOCK_0000034612": "無現金支付時實收大於應收，無法結算",
        "P_YS_SCM_STOCK_0000034613": ", 比例不得低於",
        "P_YS_FED_EXAMP_0000020030": "每天送",
        "P_YS_FED_EXAMP_0000020032": "確定要切換門店嗎？該操作將重新刷新頁面！",
        "P_YS_SCM_STOCK_0000034615": "單據編號/聯繫人/聯繫電話",
        "P_YS_FED_EXAMP_0000020031": "重量不合法",
        "P_YS_SCM_STOCK_0000034617": "退款時不能使用",
        "P_YS_FED_EXAMP_0000020027": "(最多選擇",
        "P_YS_FED_EXAMP_0000020026": "卡券原單退功能",
        "P_YS_FED_EXAMP_0000020029": "違規下架",
        "P_YS_FED_EXAMP_0000020028": "受控對象",
        "P_YS_FED_EXAMP_0000020023": "營業員",
        "P_YS_FED_EXAMP_0000020022": "近30天",
        "P_YS_FED_EXAMP_0000020025": "以下商品存量不足，請調整！",
        "P_YS_FED_FW_0000137659": "未在表單中定義",
        "P_YS_FED_FW_0000137658": "參照攜帶欄位",
        "P_YS_FED_FW_0000137657": "保存失敗---以下數據項校驗失敗：",
        "P_YS_FED_FW_0000137656": "刪除<%=text%>失敗!",
        "P_YS_FED_FW_0000137677": "刪除多條數據時候，id為：",
        "P_YS_FED_FW_0000137676": "數據刪除時候出錯；錯誤為：",
        "P_YS_FED_FW_0000137675": "openDB參數錯誤！",
        "P_YS_FED_FW_0000137674": "圖形報表&熱區日誌",
        "P_YS_FED_FW_0000137673": "連接數據庫成功",
        "P_YS_FED_FW_0000022210": "柱狀展現",
        "P_YS_FED_FW_0000137672": "的數據",
        "P_YS_FED_FW_0000137671": "資料庫版本變化時觸發（發生upgradeneeded事件，或調用indexedDB.deleteDatabase()）",
        "P_YS_FED_FW_0000137670": "方法不存在",
        "P_YS_FED_FW_0000022208": "納稅人識別號",
        "P_YS_FED_FW_0000022209": "eChartDisplay狀態改變 shouldComponentUpdate  params changed End True",
        "P_YS_FED_FW_0000022202": "初始化條件中沒有Model。",
        "P_YS_FED_FW_0000022203": "測試文字是否按規則顯示測試文字是否按規則顯示測試文字是否按規則顯示",
        "P_YS_FED_FW_0000022200": "當前",
        "P_YS_PF_PROCENTER_1518927132915400722": "的值",
        "P_YS_FED_FW_0000022201": "獲取表單模板列表失敗！",
        "P_YS_FED_FW_0000022206": "· 文本型別欄位：[客戶名稱]、[物料詳情.物料簡稱]=[物料名稱]",
        "P_YS_FED_FW_0000022207": "大屏方案 設計 doSetImageText info",
        "P_YS_FED_FW_0000137669": "url condition 參數JSON格式錯誤-->",
        "P_YS_FED_FW_0000137668": "校驗失敗：",
        "P_YS_FED_FW_0000022205": "下移",
        "P_YS_FED_FW_0000137688": "生單工作台傳入參數中沒有viewModel！",
        "P_YS_FED_FW_0000137687": "修改後ContainerModel中的髒數據欄位 ：",
        "P_YS_FED_FW_0000137686": "加載圖片錯誤。imgUrl =",
        "P_YS_FED_FW_0001219316": "請選擇表體數據",
        "P_YS_FED_FW_0000137685": "刪除多條數據時候tansaction error:",
        "P_YS_FED_FW_0000022220": "熱區設置圖 在CStyle中未能找到全部的熱區配置字段 codeField nameField fieldsCaption mapConfigField",
        "P_YS_FED_FW_0000137684": "取消選擇圖片",
        "P_YS_FED_FW_0000022221": "新增分組",
        "P_YS_FED_FW_0000137683": "表全部數據失敗！",
        "P_YS_FED_FW_0000137682": "上一次的數據庫連接還未關閉",
        "P_YS_FED_FW_0000137681": "成功保存多條數據:",
        "P_YS_FED_FW_0000137680": "成功保存id為",
        "P_YS_FED_FW_0001617303": "%c發起後端計算介面 /bill/executeFormulaCalculate： =>params =>action =>rule =>exprTag =>childTrigger",
        "P_YS_FED_FW_0001221613": "失敗,返回資訊：",
        "P_YS_FED_FW_0001221611": "未發現有效數據",
        "P_YS_FED_FW_0000022219": "圖表列數",
        "P_YS_FED_FW_0000022213": "無權",
        "P_YS_FED_FW_0000022214": "已選菜單",
        "P_YS_FED_FW_0000022211": "文件必須小於",
        "P_YS_SD_SDMA_0000098574": "加",
        "P_YS_FED_FW_0000022212": "條，成功",
        "P_YS_FED_FW_0000022217": "緯度",
        "P_YS_FED_FW_0000022218": "負責人",
        "P_YS_SD_SDMAF_0000137273": "收貨",
        "P_YS_FED_FW_0000022215": "分組",
        "P_YS_FED_FW_0000137679": "你的瀏覽器不支持IndexedDB!",
        "P_YS_FED_FW_0000022216": "保存全部",
        "P_YS_FED_FW_0000137678": "數據庫意外關閉",
        "P_YS_FED_FW_0000137699": "單據批改 row=",
        "P_YS_FED_FW_0000137698": "備註portal--tabs",
        "P_YS_FED_FW_0000137697": ":::[StatusBar] , 組件過期，不推薦使用.....",
        "P_YS_FED_FW_0000137696": "clearDimensionCache成功:groupCode =",
        "P_YS_FED_FW_0000137695": "clearDimensionCache失敗: json.message =",
        "P_YS_FED_FW_0000137694": "刪除分組條件失敗。信息 :",
        "P_YS_FED_FW_0000137693": "setShowActionRows------參數錯誤！",
        "P_YS_FED_FW_0000137692": "related控件不顯示  EcsuiteChat Render this.keyModel.getValue() =",
        "P_YS_FED_FW_0000137691": "列表批改 調用批改列表服務  參數 /bill/batchModify ----->",
        "P_YS_FED_FW_0001060913": "即時分析",
        "P_YS_FED_FW_0000137690": "獲取分組條件失敗。信息 :",
        "P_YS_FED_FW_0001060919": "-即時分析",
        "P_YS_FED_IMP_IOT0000005597": "印江土家族苗族自治縣",
        "P_YS_FED_IMP_IOT0000005599": "灣裡區",
        "P_YS_FED_IMP_IOT0000005591": "景東彝族自治縣",
        "P_YS_FED_IMP_IOT0000005592": "永平縣",
        "P_YS_FED_FW_1524239912962359303": "您的瀏覽器不支持此種視頻格式。",
        "P_YS_FED_IMP_IOT0000005595": "富寧縣",
        "P_YS_FED_FW_0000137689": "單據批改 符合條件行信息 ----->",
        "P_YS_FED_FW_1578184126673977344": "appCode使用錯誤，請聯繫文件服務朱士友zhushy@yonyou.com",
        "P_YS_FED_FW_0001060905": "成功調用custom/do/",
        "P_YS_FED_FW_0001060906": "select 沒有model",
        "P_YS_FED_FW_0001060907": "輸入的整數的最大長度不能大於",
        "P_YS_FED_IMP_IOT0000005586": "安新縣",
        "P_YS_FED_IMP_IOT0000005585": "連雲港",
        "P_YS_FED_IMP_IOT0000005588": "岱岳區",
        "P_YS_FED_IMP_IOT0000005587": "遂溪縣",
        "P_YS_FED_IMP_IOT0000005589": "德江縣",
        "P_YS_FED_IMP_IOT0000005580": "鐘樓區",
        "P_YS_FI_FP_0001073056": "主表：",
        "P_YS_FED_IMP_IOT0000005582": "二連浩特市",
        "P_YS_FED_IMP_IOT0000005581": "庫倫旗",
        "P_YS_FED_FW_0001287431": "列寬自適應",
        "P_YS_FED_FW_0001287435": "[object Object]",
        "P_YS_FI_CM_0000029573": "刪除",
        "P_YS_FED_IMP_IOT0000006784": "潛山縣",
        "P_YS_FED_IMP_IOT0000006787": "南安市",
        "P_YS_FED_IMP_IOT0000006789": "陸川縣",
        "draft": "草稿",
        "P_YS_FED_IMP_IOT0000006781": "平遠縣",
        "P_YS_FED_IMP_IOT0000006782": "興業縣",
        "P_YS_PF_METADATA_0000085603": "優先級",
        "P_YS_FED_FW_1530670329410093060": "<=b ---小於等於b",
        "P_YS_FED_FW_1530670329410093066": ">=a ---大於等於a",
        "P_YS_FED_FW_1530670329410093063": ">a ---大於a",
        "P_YS_FED_FW_0001503457": "填寫信息有誤!請重新填寫",
        "P_YS_FED_IMP_IOT0000005442": "刪除成功",
        "P_YS_FED_IMP_IOT0000006773": "呈貢縣",
        "P_YS_FED_IMP_IOT0000006775": "上杭縣",
        "P_YS_FED_IMP_IOT0000006778": "文水縣",
        "P_YS_FED_IMP_IOT0000006777": "乳山市",
        "P_YS_FED_IMP_IOT0000005448": "模板名稱",
        "P_YS_FED_FW_1530670329410093069": "<b ---小於b",
        "P_YS_FED_IMP_IOT0000006770": "秦城區",
        "P_YS_FED_IMP_IOT0000006763": "稷山縣",
        "P_YS_FED_FW_0001249386": "下載/製作模板工作臺",
        "P_YS_FED_FW_0001249385": "支持excel格式，檔大小限制不超過",
        "P_YS_FED_FW_0001249388": "異常位置",
        "P_YS_FED_IMP_IOT0000006764": "泊頭市",
        "P_YS_FED_FW_0001249387": "導出異常數據",
        "P_YS_FED_IMP_IOT0000006767": "旌德縣",
        "P_YS_FED_IMP_IOT0000006766": "新建縣",
        "P_YS_FED_FW_0001249389": "請重新上傳檔",
        "P_YS_SCM_STOCK_0001082855": "獲取數據錯誤",
        "P_YS_PF_GZTTMP_0000079071": "單據時間",
        "P_YS_FED_IMP_IOT0000006761": "美溪區",
        "P_YS_FED_IMP_IOT0000006759": "洛扎縣",
        "P_YS_SD_SDMB_0000150374": "未查詢到數據",
        "P_YS_FED_IMP_IOT0000005422": "未確認",
        "P_YS_FED_IMP_IOT0000005424": "編輯",
        "P_YS_FED_IMP_IOT0000006755": "榕城區",
        "P_YS_FED_IMP_IOT0000006757": "奎屯市",
        "P_YS_FED_IMP-DFM-FE_0000020911": "顯示全部",
        "P_YS_FED_IMP-DFM-FE_0000020910": "清除選擇",
        "P_YS_FED_IMP_IOT0000006748": "德保縣",
        "P_YS_FED_UIMG_0001050959": "查詢方案列表",
        "P_YS_FED_IMP_IOT0000006740": "青白江區",
        "P_YS_FED_IMP_IOT0000006742": "陵縣",
        "P_YS_FED_IMP_IOT0000006745": "峨邊彝族自治縣",
        "P_YS_FED_IMP_IOT0000005413": "操作",
        "P_YS_FED_IMP_IOT0000006747": "臨縣",
        "P_YS_PF_SOCD-K_0000182238": "千克",
        "P_YS_FED_IMP_IOT0000006738": "永福縣",
        "P_YS_FED_IMP_IOT0000006737": "新和縣",
        "P_YS_FI_CM_0000029543": "一月",
        "P_YS_FED_IMP_IOT0000006730": "台江區",
        "P_YS_FED_IMP_IOT0000006731": "康縣",
        "P_YS_FED_IMP_IOT0000006733": "東營區",
        "P_YS_FED_IMP_IOT0000006736": "曹縣",
        "P_YS_FED_IMP_IOT0000006735": "湘潭縣",
        "P_YS_FED_IMP_IOT0000006728": "慶城縣",
        "P_YS_FED_FW_0001377458": "/iprint/用友雲列印助手.exe",
        "P_YS_FED_UIMG_0001050970": "隱藏關聯欄位會對運行時產生影響，請謹慎操作",
        "P_YS_FED_IMP_IOT0000006721": "羅田縣",
        "P_YS_FED_IMP_IOT0000006720": "黃陵縣",
        "P_YS_FED_FW_0001208829": "選擇信息重複。",
        "P_YS_FED_UCFORG_0000088691": "再縮小就看不清了",
        "P_YS_FED_UCFORG_0000088692": "已到放大極限",
        "P_YS_FED_IMP_IOT0000006715": "孟津縣",
        "P_YS_FED_IMP_IOT0000006717": "濱城區",
        "P_YS_PF_GZTSYS_0001010812": "企業認證",
        "P_YS_FED_UIMG_0001050967": "模板校驗失敗",
        "P_YS_FED_UIMG_0001050968": "當前搜索結果對應實體元數據的屬性，非UI元數據屬性",
        "P_YS_FED_IMP_IOT0000006714": "無極縣",
        "P_YS_FI_CM_0000029569": "七月",
        "P_YS_FED_UIMG_0001050969": "確定刪除欄目",
        "P_YS_FED_IMP_IOT0000006705": "正定縣",
        "P_YS_FED_IMP_IOT0000006704": "科爾沁左翼中旗",
        "P_YS_FED_IMP_IOT0000006700": "龍遊縣",
        "P_YS_FED_FW_0001142513": "[mdf-cube] [lineNoGenerator] [_binaryGenerate()] 不能處理的index[",
        "P_YS_FED_IMP_IOT0000006702": "豐縣",
        "P_YS_FED_FW_0001142515": ", 按照",
        "P_YS_FED_FW_0001142514": "%c未識別的status:",
        "P_YS_FED_FW_0001142517": "至少設置一個搜索列！",
        "P_YS_FED_FW_0001142516": "狀態處理",
        "P_YS_FED_FW_1565223229652992000": "公式賦值 表頭特徵 >>:",
        "P_YS_FED_MDF-COMPS_0001378486": "基準語言",
        "P_YS_FED_MDF-COMPS_0001378484": "基準語言為空時，則預設取當前語言內容。",
        "P_YS_SD_UDHWN_0000049167": "圖木舒克市",
        "P_YS_PF_GZTSYS_0001010835": "多語言",
        "P_YS_FED_FW_1554678844398501896": "%c批量觸發動作： setCellStates >>>",
        "P_YS_FED_FW_0001377414": "/ 當前頁面篩選出",
        "P_YS_FED_FW_0001377415": "當前頁面篩選出",
        "P_YS_FI_FCWEB_0001498545": "結果：",
        "P_YS_FED_FW_1534689396612136962": "當前訪問的是用友企業雲API，公網才能訪問，專屬化環境訪問不到",
        "P_YS_SD_UDHMC_0000130713": "收起更多",
        "P_YS_FED_FW_0001026227": "<%=text%>參照",
        "P_YS_FED_FW_1497486003344506888": "請點擊側欄中的候選條件進行加入",
        "P_YS_FED_IMP_IOT0000011306": "高安市",
        "P_YS_FED_FW_0001141221": "%cGroup:meta客戶端緩存信息",
        "P_YS_FED_IMP_IOT0000011303": "雷波縣",
        "P_YS_FED_IMP_IOT0000011305": "衡陽縣",
        "P_YS_HR_HRJQ_0000031143": "無",
        "P_YS_PF_METADATA_0000086908": "矩形",
        "P_YS_FED_IMP_IOT0000011310": "蕪湖縣",
        "P_YS_FED_FW_0001141240": "按鈕點擊，調用dropdownbutton組件內部handleMenuClick方法結束",
        "P_YS_FED_IMP_IOT0000011318": "沙縣",
        "P_YS_FED_IMP_IOT0000011319": "團風縣",
        "P_YS_FED_IMP_IOT0000011314": "扎蘭屯市",
        "P_YS_FED_IMP_IOT0000011313": "香格里拉縣",
        "P_YS_FED_FW_0001141239": "按鈕點擊，調用dropdownbutton組件內部handleButtonClick方法結束",
        "P_YS_FED_FW_0001141238": "按鈕點擊，調用dropdownbutton組件內部handleMenuClick方法開始",
        "P_YS_FED_FW_0001295958": "請您註冊appcode",
        "P_YS_SD_UDHWN_0000050125": "天門市",
        "P_YS_SD_UDHWN_0000050128": "浦東新區",
        "P_YS_FED_IMP_IOT0000011321": "琿春市",
        "P_YS_FED_IMP_IOT0000011320": "安多縣",
        "P_YS_FED_FW_0001141241": "按鈕點擊，調用dropdownbutton組件內部handleButtonClick方法開始",
        "P_YS_FED_IMP_IOT0000011328": "崇陽縣",
        "P_YS_FED_FW_0001065806": "輸入錯誤",
        "P_YS_FED_FW_0001141246": "以下<%=text%>欄位不能為空",
        "P_YS_FED_FW_0001065807": "IP格式錯誤！",
        "P_YS_FED_IMP_IOT0000011324": "汨羅市",
        "P_YS_FED_FW_0001065805": "電郵格式錯誤！",
        "P_YS_FED_FW_0001141247": "第<%=text%>行",
        "P_YS_FED_FW_0001026213": "<%=text%><%=cName%>",
        "P_YS_HR_HRJQ_0000031164": "失敗！",
        "P_YS_FED_IMP_IOT0000011332": "沿河土家族自治縣",
        "P_YS_FED_IMP_IOT0000010001": "肇州縣",
        "P_YS_FED_FW_0001094323": "請求接口:",
        "P_YS_FED_FW_0001094324": ", 返回值為:",
        "P_YS_FED_FW_0001612626": "獲取操作列失敗",
        "P_YS_FED_IMP_IOT0000010008": "端州區",
        "P_YS_PF_GZTSYS_0000012963": "庫管員",
        "P_YS_FED_IMP_IOT0000010009": "璧山縣",
        "P_YS_FED_IMP_IOT0000010004": "清河門區",
        "P_YS_FED_IMP_IOT0000011338": "殷都區",
        "P_YS_FED_IMP_IOT0000011337": "呼和浩特",
        "P_YS_FED_IMP_IOT0000010007": "高港區",
        "P_YS_SD_URETAIL_0001048820": "】indexedDB中【",
        "P_YS_FED_FW_0000022370": "顯示時分",
        "P_YS_FED_FW_0000021040": "門店編碼",
        "P_YS_FED_FW_0000022371": "當前語種",
        "P_YS_FED_FW_0000021043": "咸寧市",
        "P_YS_FED_FW_0000022374": "配置文件中交叉點為空或者配置欄位不存在於源表欄目中，請檢查。",
        "P_YS_FED_FW_0000021044": "江門市",
        "P_YS_FED_FW_0000022375": "顯示角度應該在0-60之間",
        "P_YS_FED_FW_0000021041": "常德市",
        "P_YS_FED_FW_0000022372": "getMeasureValues沒有在1維表找到 t2DRowKey =",
        "P_YS_FED_FW_0000021042": "完成",
        "P_YS_FED_FW_0000022373": "報表分組方案配置信息-行列佈局",
        "P_YS_FED_IMP_IOT0000011224": "立山區",
        "P_YS_FED_FW_0001065868": ",已將輸入小數位設置為",
        "P_YS_FED_FW_0001065869": "輸入的整數長度為",
        "P_YS_FED_IMP_IOT0000011226": "康定縣",
        "P_YS_FED_IMP_IOT0000011228": "臨夏市",
        "P_YS_FED_FW_0000022367": "億",
        "P_YS_FED_FW_0000021036": "篩選",
        "P_YS_FED_IMP_IOT0000009011": "巴州區",
        "P_YS_FED_FW_0000022368": "請錄入正確的數值",
        "P_YS_FED_FW_0000021037": "長春市",
        "P_YS_FED_IMP_IOT0000009012": "嵩縣",
        "P_YS_FED_FW_0000021034": "天氣",
        "P_YS_FED_FW_0000022366": "修改成功！",
        "P_YS_FED_FW_0000021035": "貴陽市",
        "P_YS_FED_IMP_IOT0000009016": "新寧縣",
        "P_YS_FED_FW_0000022369": "(推薦)",
        "P_YS_FED_FW_0000021038": "set參數格式應是：{key: someKey, value: someValue}或者：[{key: someKey, value: someValue}]",
        "P_YS_FED_IMP_IOT0000009013": "孝南區",
        "P_YS_PF_SOCD-O_0000182516": "專科",
        "P_YS_FED_FW_0000021039": "柱折圖示例",
        "P_YS_FI_FP_0000034880": "維護",
        "P_YS_FED_FW_0000021050": "一列",
        "P_YS_FED_FW_0000022381": "請輸入0-99數字",
        "P_YS_FED_FW_0000021051": "黑河市",
        "P_YS_FED_FW_0000022382": "秒,系統設置輪播時間。cb.rest.AppContext.option.screenPlayTime",
        "P_YS_FED_FW_0000022380": "獲取圖形報表 /report/list 本次List請求開始 時間 =",
        "P_YS_FED_FW_0000021054": "連接數據庫失敗",
        "P_YS_FED_FW_0000022385": "保留內層邊框",
        "P_YS_FED_FW_0000021055": "餅形圖配置信息-eChartSetting",
        "P_YS_FED_FW_0000022386": "空分組項",
        "P_YS_FED_FW_0000021052": "西藏",
        "P_YS_FED_FW_0000022383": "暫無搜索結果~",
        "P_YS_FED_FW_0000021053": "吉安市",
        "P_YS_FED_FW_0000022384": "內外徑請輸入0到100的整數，且外徑大於內徑。",
        "P_YS_FI_FP_0000034879": "上月",
        "P_YS_FED_IMP_IOT0000011231": "羅江縣",
        "P_YS_FED_IMP_IOT0000011230": "灌南縣",
        "P_YS_FED_IMP_IOT0000009009": "丹鳳縣",
        "P_YS_FED_IMP_IOT0000009006": "遜克縣",
        "P_YS_FED_FW_0001317858": "該子表中存在未校驗通過的欄位，可進入詳情中查看",
        "P_YS_FED_IMP_IOT0000009007": "綏棱縣",
        "P_YS_FED_IMP_IOT0000011237": "思南縣",
        "P_YS_FED_IMP_IOT0000011236": "邵陽縣",
        "P_YS_PF_SOCD-O_0000182522": "本科",
        "P_YS_FED_FW_0000021047": "定西市",
        "P_YS_FED_FW_0000022378": "無法找到",
        "P_YS_FED_IMP_IOT0000009000": "鎮寧布依族苗族自治縣",
        "P_YS_FED_FW_0000021048": "海北藏族自治州",
        "P_YS_FED_FW_0000022379": "名使用漣漪特效",
        "P_YS_FED_FW_0000021045": "黑龍江",
        "P_YS_FED_FW_0000022376": "緯度欄位不可為空",
        "P_YS_FED_FW_0000021046": "左2右1",
        "P_YS_FED_FW_0000022377": "過濾表達式",
        "P_YS_HR_HRJQ_0000031063": "已駁回",
        "P_YS_FED_FW_0000021049": "吳忠市",
        "P_YS_FED_IMP_IOT0000009002": "東寶區",
        "P_YS_SD_URETAIL_0001048725": "離線數據轉換狀態成功",
        "P_YS_FED_FW_0000022352": "布局",
        "P_YS_FED_FW_0000021021": "匯出數據不允許為空，請重新選擇後重試！",
        "P_YS_FED_FW_0000022353": "查看錯誤日誌",
        "P_YS_FED_FW_0000021022": "日",
        "P_YS_FED_FW_0000022350": "請填寫正確的電話號碼",
        "P_YS_FED_FW_0000021020": "新增",
        "P_YS_FED_FW_0000022351": "請輸入關鍵詞",
        "P_YS_FED_IMP_IOT0000011243": "廣河縣",
        "P_YS_FED_IMP_IOT0000011246": "工布江達縣",
        "P_YS_FED_FW_0001255142": "此功能需要遠程地圖，當前無法訪問公網，暫時無法使用~",
        "P_YS_FED_IMP_IOT0000011240": "丁青縣",
        "P_YS_FED_IMP_IOT0000011241": "阜新蒙古族自治縣",
        "P_YS_FED_IMP_IOT0000011248": "恩平市",
        "P_YS_FED_IMP_IOT0000011247": "房縣",
        "P_YS_FED_FW_0000021014": "啟用",
        "P_YS_FED_FW_0000022345": "圖片僅支持",
        "P_YS_FED_FW_0000022346": "數據型別不可為空字符。",
        "P_YS_FED_FW_0000021015": "日期",
        "P_YS_FED_FW_0000022343": "發布報表方案失敗。err",
        "P_YS_FED_FW_0000021012": "刪除時要做業務引用校驗，可能等待的時間較長，是否確認刪除？",
        "P_YS_FED_FW_0000022344": "-----------點擊事件  scatterData",
        "P_YS_FED_FW_0000021013": "是否確認刪除此",
        "P_YS_FED_FW_0000022349": "設置為默認查詢方案",
        "P_YS_FED_FW_0000021018": "四",
        "P_YS_FED_FW_0000021019": "請選擇有效數據",
        "P_YS_FED_FW_0000022347": "簽名保存成功",
        "P_YS_FED_FW_0000021016": "所選數據中存在不符合生單規則的數據！",
        "P_YS_FED_FW_0000022348": "餅形圖展示指標只支持單選",
        "P_YS_FED_FW_0000021017": "確定要",
        "P_YS_FED_FW_0000022360": "數據型別不可為空,請檢查。",
        "P_YS_FED_FW_0000021032": "沒有取到提交參數",
        "P_YS_FED_FW_0000022363": "已經存在當前菜單，是否覆蓋？",
        "P_YS_FED_FW_0000022364": "監控視圖 刪除刷新頻率定時器 renderTime",
        "P_YS_FED_FW_0000021033": "元數據未配置cCardKey",
        "P_YS_FED_FW_0000022361": "格式化",
        "P_YS_FED_FW_0000021030": "模板內容匯入失敗,返回信息：",
        "P_YS_FED_FW_0000022362": "編輯區",
        "P_YS_FED_FW_0000021031": "日期時間",
        "P_YS_FED_IMP_IOT0000011255": "懷來縣",
        "P_YS_FED_IMP_IOT0000011254": "西區",
        "P_YS_FED_IMP_IOT0000011256": "龍文區",
        "P_YS_FED_IMP_IOT0000011251": "津市市",
        "P_YS_FED_IMP_IOT0000011259": "平南縣",
        "P_YS_FED_FW_0000022356": "全部類別",
        "P_YS_FED_FW_0000022357": "報表設置的自動刷新間隔太短。 refreshInterval",
        "P_YS_FED_FW_0000021026": "星期",
        "P_YS_FED_FW_0000022354": "輕度",
        "P_YS_FED_FW_0000021023": "失敗：",
        "P_YS_FED_FW_0000022355": "請設置顯示內容",
        "P_YS_FED_FW_0000021029": "參照數據中無此條記錄！請重試",
        "P_YS_FED_FW_0000022358": "去重計數",
        "P_YS_FED_FW_0000021027": "該操作將會刪除當前",
        "P_YS_FED_FW_0000022359": "提示信息",
        "P_YS_FED_FW_0000021028": "請選擇組織！",
        "P_YS_FED_FW_0000021083": "包頭市",
        "P_YS_FED_FW_0000021084": "開封市",
        "P_YS_FED_FW_0000021081": "三明市",
        "P_YS_FED_IMP_IOT0000011260": "冊亨縣",
        "P_YS_FED_FW_0000021082": "阿里地區",
        "P_YS_FED_FW_0000021087": "聊城市",
        "P_YS_FED_FW_0000021088": "荊州市",
        "P_YS_FED_FW_0000021085": "黃石市",
        "P_YS_FED_FW_0000021086": "普洱市",
        "P_YS_FED_IMP_IOT0000011266": "東烏珠穆沁旗",
        "P_YS_FED_FW_0001317893": "還沒有報表哦",
        "P_YS_FED_FW_0000021080": "遂寧市",
        "P_YS_SD_SDMB_0000139941": "行數據",
        "P_YS_SD_UDHWS_0000118032": "普通倉",
        "P_YS_FED_FW_0000021078": "自定義時間",
        "P_YS_FED_FW_0001008402": "參照編輯",
        "P_YS_SD_SDDM-UI_0001141637": "微博",
        "P_YS_FED_FW_0000021079": "看板配置信息-大屏-行列佈局",
        "P_YS_HR_HRJQF_0000053894": "是否取消",
        "P_YS_FED_FW_0000021094": "玉溪市",
        "P_YS_FED_FW_0000021095": "柱形圖配置信息-yySetting",
        "P_YS_FED_FW_0000021092": "長治市",
        "P_YS_FED_IMP_IOT0000011271": "陸良縣",
        "P_YS_FED_FW_0000021093": "累計",
        "P_YS_FED_FW_0000021098": "襄陽市",
        "P_YS_FED_FW_0000021099": "福州市",
        "P_YS_FED_FW_0000021096": "eChartDisplay 散點圖地圖信息不正確 errInfo =",
        "P_YS_FED_FW_0000021097": "延安市",
        "P_YS_FED_IMP_IOT0000011277": "徐聞縣",
        "P_YS_FED_IMP_IOT0000011276": "帶嶺區",
        "P_YS_FED_IMP_IOT0000011278": "建湖縣",
        "P_YS_FED_FW_0000021090": "左1右2",
        "P_YS_FED_IMP_IOT0000011273": "漵浦縣",
        "P_YS_FED_FW_0000021091": "資陽市",
        "P_YS_FED_FW_0000021089": "移動報表 MobileData renderTable  mobileDataScale",
        "P_YS_FED_FW_0000021061": "隴南市",
        "P_YS_FED_FW_0000022392": "月",
        "P_YS_FED_IMP_IOT0000011280": "威縣",
        "P_YS_FED_FW_0000021062": "扇區數值",
        "P_YS_FED_FW_0000022393": "沒有規格值",
        "P_YS_FED_FW_0000022390": "大屏方案2 eChartPanelDisplay2展現Render End",
        "P_YS_FED_IMP_IOT0000011282": "武義縣",
        "P_YS_FED_FW_0001509661": "搜索或點擊箭頭選擇",
        "P_YS_FED_FW_0000021060": "大連市",
        "P_YS_FED_FW_0000022391": "匹配一維表的行時，當前行前面已經匹配過，請檢查。 rowItemMatchInfo =",
        "P_YS_FED_IMP_IOT0000011281": "江寧區",
        "P_YS_HR_HRJQF_0000053875": "月份",
        "P_YS_HR_HRJQF_0001044571": "王五",
        "P_YS_FED_FW_0000021065": "河池市",
        "P_YS_FED_FW_0000022396": "顯示秒",
        "P_YS_FED_FW_1622974871736680453": "記錄上下文調用次數",
        "P_YS_FED_FW_0000021066": "折線圖配置信息-yySetting",
        "P_YS_FED_FW_0000022397": "僅支持JPG、JPEG、BMP、PNG格式，文件小於2M",
        "P_YS_FED_FW_0000021063": "湘西土家族苗族自治州",
        "P_YS_FED_FW_0000021064": "柱形圖配置信息-eChartSetting",
        "P_YS_FED_FW_0000022395": "優",
        "P_YS_FED_IMP_IOT0000011289": "蒙城縣",
        "P_YS_FED_IMP_IOT0000011286": "秀英區",
        "P_YS_FED_FW_0000021058": "迪慶藏族自治州",
        "P_YS_FED_FW_0000022389": "桌面看板已保存。",
        "P_YS_FED_FW_0000021059": "金華市",
        "P_YS_FED_FW_0000021056": "移動報表 MobileReportSum filterClick",
        "P_YS_FED_FW_0000021057": "雞西市",
        "P_YS_FED_FW_0000022388": "當前報表沒有移動過濾方案，不能發布到移動端。filterId",
        "P_YS_SD_UDHWN_0000050084": "密雲縣",
        "P_YS_FED_FW_0000021072": "成功保存",
        "P_YS_FED_FW_0000021073": "排名表示例",
        "P_YS_FED_FW_0000021070": "拍照",
        "P_YS_FED_FW_0000021071": "-----------點擊事件 scatterData",
        "P_YS_FED_FW_0000021076": "克孜勒蘇柯爾克孜自治州",
        "P_YS_FED_FW_0000021077": "衡陽市",
        "P_YS_FED_FW_0000021074": "銷售",
        "P_YS_FED_FW_1428685300106788864": "被除數不能為 0",
        "P_YS_FED_FW_0000021075": "讀取多條數據失敗！",
        "P_YS_FED_IMP_IOT0000011295": "新羅區",
        "P_YS_PF_SOCD-O_0000182541": "高中",
        "P_YS_FED_FW_0000021069": "日喀則地區",
        "P_YS_SD_UDHWS_0000119391": "不正確",
        "P_YS_FED_FW_0000021067": "伊春市",
        "P_YS_FED_FW_0000022398": "新增查詢方案",
        "P_YS_FED_FW_0000021068": "條形圖示例",
        "P_YS_FED_FW_0000022399": "獲取dimension失敗:",
        "P_YS_FED_FW_0001065870": "輸入的整數長度不能大於15位",
        "P_YS_FED_FW_1583596695997382657": "已勾選“移動端展現”，是否設置移動端布局？",
        "P_YS_OA_YBMOB_0000036871": "下拉刷新",
        "P_YS_FED_FW_1583596695997382660": "請設置移動端布局。",
        "P_YS_IMP_HSE-UI_0001216387": "子表分頁",
        "P_YS_FI_CM_0000029614": "二月",
        "P_YS_SD_SDSD-FE_0001491485": "規格",
        "P_YS_PF_ANALYTIC-FE_0001652194": "移動端佈局",
        "P_YS_SD_SDSD-FE_0001491490": "單價",
        "P_YS_FED_FW_0001221777": "是否確認<%=cCaption%>選中的<%=text%>",
        "P_YS_FED_FW_0001010742": "有異步處理正在進行，請檢查。",
        "P_YS_FI_CM_0000029625": "三月",
        "P_YS_FI_CM_0000029624": "返回首頁",
        "P_YS_FED_FW_1476478433683308552": "圖例1",
        "P_YS_FED_FW_1476478433683308555": "圖例2",
        "P_YS_FED_FW_1528487034344701957": "點擊確定過濾空值",
        "P_YS_OA_YBMOB_0000036891": "暫無相關數據",
        "P_YS_FED_FW_0001148642": "搜索(control+回車)",
        "P_YS_OA_YBMOB_0000036890": "檔案",
        "P_YS_OA_XTMENHU_0000046524": "待辦中心",
        "P_YS_FI_CM_0000029635": "單選框",
        "P_YS_FED_IMP-DFM-FE_0000020869": "箭頭",
        "P_YS_FED_IMP-DFM-FE_0000020868": "操作",
        "P_YS_PF_PRINT_0000065360": "項目編碼",
        "P_YS_FED_FW_0000022330": "請輸入納稅人識別號",
        "P_YS_FED_FW_0000021000": "級",
        "P_YS_FED_FW_0000022331": "初始化eChartDisplay的props裡沒有viewModel",
        "P_YS_SD_SDMAF_0000137147": "信息提示",
        "P_YS_FED_IMP-DFM-FE_0000020875": "編輯",
        "P_YS_FED_IMP-DFM-FE_0000020872": "°",
        "P_YS_FED_FW_0000022329": "沒有可設置信息。",
        "P_YS_FED_IMP_IOT0000005499": "全部",
        "P_YS_FED_FW_1550269983163940871": "預警信息提示：",
        "P_YS_FED_FW_0000022323": "回車方向",
        "P_YS_FED_FW_0000022324": "請設置背景圖片",
        "P_YS_FED_FW_0000022321": "格式",
        "P_YS_FED_FW_0000022322": "背景色",
        "P_YS_FED_FW_0000022327": "重度",
        "P_YS_FED_FW_0000022328": "年",
        "P_YS_FED_FW_0000022325": "確定刪除此過濾項麼？",
        "P_YS_FED_FW_0000022326": "Toolbar cStyle，預製錯誤！",
        "P_YS_FED_FW_0000022341": "柱折圖",
        "P_YS_FED_FW_0000021010": "有下級，不能刪除",
        "P_YS_FED_FW_0000022342": "校驗",
        "P_YS_FED_FW_0000021011": "所選數據不符合生單規則，請重新選擇數據！",
        "P_YS_FED_FW_0000022340": "大屏方案 設計 doSetChart info",
        "P_YS_FED_IMP-DFM-FE_0000020888": "序號",
        "P_YS_FED_IMP-DFM-FE_0000020886": "複製",
        "P_YS_YYGJFW_YBUC_0001336571": "協作套件",
        "P_YS_OA_XTYUNHUIWU_0000162483": "組織",
        "P_YS_FED_FW_0000021009": "切換主組織將清空數據，是否繼續？",
        "P_YS_FED_FW_0000021003": "星期一",
        "P_YS_FED_FW_0000022334": "熱區顯示圖渲染 熱區配置文件或者樓層圖片為空。",
        "P_YS_FED_FW_0000022335": "參照ID",
        "P_YS_FED_FW_0000021004": "此記錄",
        "P_YS_FED_FW_0000021001": "網絡異常",
        "P_YS_FED_FW_0000022332": "存在重複行,請檢查。",
        "P_YS_FED_FW_0000021002": "後台數據返回錯誤",
        "P_YS_FED_FW_0000022333": "設置圖形報表",
        "P_YS_FED_FW_0000021007": "數值",
        "P_YS_FED_FW_0000022338": "大屏方案日期時間 props.componentConfig",
        "P_YS_FED_FW_0000021008": "正在校驗中",
        "P_YS_FED_FW_0000022339": "分組條件",
        "P_YS_FED_FW_0001661538": "協作套件中附件",
        "P_YS_FED_FW_0000021005": "時間",
        "P_YS_FED_FW_0000022336": "百",
        "P_YS_FED_FW_0000022337": "監控視圖的圖形報表 eChartDisplay componentDidMount",
        "P_YS_FED_FW_0000021006": "是否確認",
        "P_YS_FED_FW_0001134039": "存在重複行",
        "P_YS_FED_IMP-DFM-FE_0000020898": "剪切",
        "P_YS_FED_FW_0000022309": "抵扣",
        "P_YS_FED_FW_1551057130410213379": "參照配置錯誤：未返回參照資料唯一值！",
        "P_YS_FED_FW_0000022307": "Абв",
        "P_YS_FED_FW_0000022308": "當前選擇的行的Index",
        "P_YS_FED_FW_0000022301": "匹配一維表的行時，當前行前面已經匹配過，請檢查。 matchArr =",
        "P_YS_FED_FW_0000022302": "大屏方案2 eChartPanelDisplay2展現Render Begin",
        "P_YS_FED_FW_0000022300": "滾動計數顯示",
        "P_YS_FED_FW_0000022305": "獲取數據模版列表失敗",
        "P_YS_FED_FW_0000022306": "維度",
        "P_YS_FED_IMP_IOT0000005471": "提示",
        "P_YS_FED_FW_0000022303": "添加圖文",
        "P_YS_FED_FW_0000022304": "確定啟用此模版嗎？",
        "P_YS_HR_HRXCF_0000056241": "近半年",
        "P_YS_FED_FW_0000022320": "已選數據項",
        "P_YS_FED_FW_1550269983163940868": "不合法信息提示（禁止下一步）：",
        "P_YS_FED_IMP_IOT0000006796": "瓦房店市",
        "P_YS_HR_HRJQF_0001007593": "是否系統模板",
        "P_YS_FED_FW_0000022318": "初始化沒有找到1維表editRowModel或者editRowModel中沒找到物料Model或者物料Model型別不是ReferModel",
        "P_YS_FED_IMP_IOT0000006798": "定興縣",
        "P_YS_FED_IMP_IOT0000005467": "這是第",
        "P_YS_FED_FW_0000022319": "過濾項名稱",
        "P_YS_FED_IMP_IOT0000006799": "弓長嶺區",
        "P_YS_FED_FW_0000022312": "大屏輪播: Carousel render 顯示輪播時間",
        "P_YS_FED_FW_0000022313": "一維表存在沒有匹配到二維表單元格的行。 rows =",
        "P_YS_FED_FW_0000022310": "點擊上傳",
        "P_YS_FED_IMP_IOT0000006790": "循化撒拉族自治縣",
        "P_YS_FED_FW_0000022311": "圖文",
        "P_YS_FED_FW_0000022316": "· 枚舉型別欄位：[是否散戶]",
        "P_YS_FED_FW_0000022317": "，支持格式：P12）",
        "P_YS_FED_IMP_IOT0000006791": "五營區",
        "P_YS_FED_FW_0000022314": "請選擇菜單！",
        "P_YS_FED_IMP_IOT0000006794": "橫山縣",
        "P_YS_FED_FW_0000022315": "符合條件的分組方案(displayStyle == 2 or 3,移動看板則需要isMobile == true)中沒有找到當前的分組方案(groupSchemaId=",
        "P_YS_FED_IMP_IOT0000006793": "三都水族自治縣",
        "P_YS_PF_ECON-FE_0001658831": "認證須知",
        "P_YS_PF_YHTU_1541976126441127960": "圖片要求",
        "P_YS_PF_YHTU_1541976126447943698": "認證內容：高效驗證本人的運營商信息",
        "P_YS_SD_SDMA_0000060954": "姓名不能為空",
        "P_YS_PF_YHTU_1541976126441127963": "需要提供運營商手機號關聯的姓名和身份證號信息",
        "P_YS_SD_SDMAF_0000137341": "已認證",
        "P_YS_PF_ECON-CONSLE_0001157552": "立即認證",
        "P_YS_PF_YHTU_1541976126441127969": "上傳檔案應不超過3MB",
        "P_YS_PF_YHTU_1541976126447943695": "《運營商三要素-認證服務協定》",
        "P_YS_PF_YHTU_1541976126441127966": "如果需要變更姓名和身份證號，需要取消之前所有認證後進行變更",
        "P_YS_PF_YHTU_1541976126447943692": "請勾選閱讀並同意認證協定",
        "P_YS_PF_PC-UI_0000160789": "身份證國徽面",
        "P_YS_PF_PC-UI_0000160788": "身份證人像面",
        "P_YS_PF_YHTU_1541976126441127972": "認證資料",
        "P_YS_FED_UCFBASEDOC_0000025252": "已閱讀並同意",
        "P_YS_PF_YHTU_1541976126447943686": "《銀行卡四要素-認證服務協定》",
        "P_YS_PF_YHTU_1557523229449912325": "《",
        "P_YS_PF_YHTU_1541976126447943689": "認證內容：高效驗證本人的銀行卡信息",
        "P_YS_PF_YHTU_1551617615053455362": "個人實名認證服務協定",
        "P_DIWORK_YC_SUP-MGR_0000059259": "認證中",
        "P_YS_PF_YHTU_1541976126447943680": "認證時效：1-2個工作日",
        "P_YS_PF_YHTU_1541976126441127975": "2、圖片大小：≦3MB",
        "P_YS_PF_YHTU_1541976126447943683": "《個人證件認證-認證服務協定》",
        "P_YS_SD_UDHMC_0001084273": "取消認證",
        "P_YS_PF_YHTU_1541976126441127978": "(包括面部)",
        "P_YS_PF_YHTU_1557523229449912320": "請輸入",
        "P_YS_SD_SDMBF_0000145206": "銀行卡號",
        "P_YS_PF_YHTU_1541976126441127984": "需要提供與銀行卡預留信息一致的相關信息",
        "P_YS_PF_YHTU_1541976126441127981": "運營商三要素認證",
        "P_YS_PF_YHTU_1541976126441127948": "1、圖片型別：jpg、jpeg、bmp、gif、png",
        "P_YS_PF_YHTU_1541976126441127942": "銀行卡四要素認證",
        "P_YS_PF_YHTU_1541976126441127987": "3、身份證反面照要求：身份證原件國徽面的彩色電子版圖片，不可使用複印件照片",
        "P_YS_PF_YHTU_1541976126441127945": "個人證件認證",
        "P_YS_PF_YHTU_1541976126441127939": "手機帳號變更或解綁時，三要素和四要素的認證狀態自動變更為未認證",
        "P_YS_PF_ECON-FE_0001136547": "身份證號不能為空",
        "P_YS_FED_UCFBASEDOC_0000024745": "驗證碼不能為空",
        "P_YS_FED_UCFBASEDOC_0000025558": "手機驗證碼",
        "P_YS_PF_YHTU_1541976126447943704": "認證時效：10分鐘內",
        "P_YS_SD_SDMBF_0000142003": "銀行卡號不能為空",
        "P_YS_IMP_PRM-BE_0001108771": "認證失敗",
        "P_YS_SD_SDMBF_0000141415": "修改手機號",
        "P_YS_PF_YHTU_1541976126441127951": "手持身份證合照",
        "P_YS_PF_YHTU_1541976126447943701": "認證內容：驗證身份證實名信息",
        "P_YS_PF_YHTU_1541976126441127957": "已完成至少一種個人認證時，姓名認證信息復用",
        "P_YS_PF_YHTU_1541976126441127954": "3、身份證手持照要求：本人手持身份證原件正面彩色電子版圖片",
        "P_YS_SD_SDMBF_0000144292": "未認證",
        "P_YS_PF_YHTU_1541976117851193351": "3、身份證正面照要求：身份證原件正面的彩色電子版圖片，不可使用複印件照片"
    },
    "enus": {
        "P_YS_FED_FW_1606608847296266242": "保存成功，请刷新当前页面生效",
        "P_YS_FI_CM_0000029697": "May",
        "P_YS_SD_SDMB_0000139476": "Not Uploaded",
        "P_YS_FED_IMP_IOT0000006664": "Huayuan County",
        "P_YS_FED_IMP_IOT0000007994": "Minhe Hui Autonomous County",
        "P_YS_FED_IMP_IOT0000006666": "Hutubi County",
        "P_YS_FED_IMP_IOT0000007997": "Danba County",
        "P_YS_FED_IMP_IOT0000006668": "Karaqin Left-Wing Mongolian Autonomous County",
        "P_YS_FED_IMP_IOT0000006669": "Chuanhui District",
        "P_YS_SD_UDHLIB_0000133275": "Tab",
        "P_YS_FED_IMP_IOT0000006660": "Chahar Right Wing Flag",
        "P_YS_FED_IMP_IOT0000006662": "Qixing District",
        "P_YS_OA_XTMENHU_0000046692": "Immediate Subordinate",
        "P_YS_SD_UDHWN_0000120629": "Name",
        "P_YS_OA_XTMENHU_0000046694": "View Larger Image",
        "P_YS_PF_PRINT_0000057000": "User-defined Field 10",
        "P_YS_FED_IMP_IOT0000006653": "Linghe District",
        "P_YS_FED_IMP_IOT0000007984": "Pingshun County",
        "P_YS_FED_IMP_IOT0000006652": "Luodian County",
        "P_YS_FED_IMP_IOT0000006655": "Yuhuan County",
        "P_YS_FED_IMP_IOT0000007986": "Longfeng District",
        "P_YS_FED_IMP_IOT0000006654": "Laian County",
        "P_YS_FED_IMP_IOT0000007985": "Xunwu County",
        "P_YS_FED_IMP_IOT0000007988": "Harbin",
        "P_YS_FED_IMP_IOT0000006656": "Nianzishan District",
        "P_YS_FED_IMP_IOT0000006658": "Tongliang County",
        "P_YS_FED_IMP_IOT0000007989": "Ziyun Miao Buyi Autonomous County",
        "P_YS_FED_IMP_IOT0000006650": "Jingtai County",
        "P_YS_FED_IMP_IOT0000007981": "Qiu County",
        "country66": "Thailand",
        "P_YS_FED_IMP_IOT0000006649": "Zhangwan District",
        "country65": "Singapore",
        "country63": "Philippines",
        "country62": "Indonesia",
        "P_YS_FED_FW_1582822863149727762": "And",
        "country61": "Australia",
        "P_YS_FED_FW_1582822863149727765": "Add expression",
        "country60": "Malaysia",
        "P_YS_FED_IMP_IOT0000006644": "Qihe County",
        "P_YS_FED_IMP_IOT_0001080960": "Dashboard",
        "P_YS_FED_IMP_IOT0000006643": "Dingcheng District",
        "P_YS_FED_IMP_IOT0000006646": "Zhen'an County",
        "P_YS_FED_IMP_IOT0000007977": "Xicheng District",
        "P_YS_FED_IMP_IOT0000006645": "Zhangxian",
        "P_YS_SD_URETAILF_0001130905": "Complete refreshing",
        "P_YS_FED_IMP_IOT0000006648": "Linxiang",
        "P_YS_FED_IMP_IOT0000007979": "Taocheng District",
        "P_YS_FED_IMP_IOT0000006647": "Luoshan County",
        "P_YS_FED_FW_0001044586": "No template Info obtained. Please check whether the current operator has template permissions or not",
        "P_YS_FED_IMP_IOT0000007971": "Dingbian County",
        "P_YS_FED_FW_0001044585": "Large screen slideshow: no template Info obtained. Please check whether the current operator has template permissions or not",
        "P_YS_FED_FW_1582822863149727756": "Between",
        "P_YS_FED_FW_1582822863149727759": "And",
        "P_YS_FED_IMP_IOT0000007969": "Liuzhi Special Zone",
        "P_YS_FED_FW_1582822863149727750": "Or",
        "P_YS_FED_FW_0000055406": "Failed to open cashbox",
        "P_YS_FED_FW_0000055407": "29",
        "P_YS_FED_FW_1582822863149727753": "Advanced scheme",
        "P_YS_FED_IMP_IOT0000007962": "Wuchang District",
        "P_YS_FED_IMP_IOT0000007961": "Lingchuan County",
        "P_YS_FED_IMP_IOT0000007964": "Yongji",
        "P_YS_FED_IMP_IOT0000006632": "Longnan County",
        "P_YS_FED_FW_0000157443": "%c syntax error",
        "P_YS_FED_FW_0000157444": "%c not found",
        "P_YS_FED_IMP_IOT0000006628": "Yunxiao County",
        "P_YS_FED_IMP_IOT0000007959": "Zhanhua County",
        "P_YS_FED_IMP_IOT0000006627": "Artesian well area",
        "P_YS_FED_IMP_IOT0000007958": "Heqing County",
        "P_YS_FED_IMP_IOT0000006629": "Filter by Criteria",
        "P_YS_PF_PRINT_0000057032": "User-defined Field 13",
        "P_YS_PF_PRINT_0000057031": "User-defined Field 14",
        "P_YS_PF_PRINT_0000057030": "User-defined Field 11",
        "P_YS_FED_IMP_IOT0000007951": "Xiapu County",
        "P_YS_FED_IMP_IOT0000006622": "Xiangyun County",
        "P_YS_FED_IMP_IOT0000007953": "Li County",
        "P_YS_FED_IMP_IOT0000006621": "Siziwangqi",
        "P_YS_FED_IMP_IOT0000006625": "Xinxiang County",
        "P_YS_SD_URETAILF_0001130967": "Release to refresh",
        "P_YS_FED_FW_1550127458969190407": "Report failure",
        "P_YS_FED_IMP_IOT0000007949": "Qibin District",
        "P_YS_SD_UDHWN_0000047462": "Jinshan District",
        "P_YS_FED_IMP_IOT0000007940": "Celle County",
        "P_YS_FED_FW_1554033164811763719": "Number of data display columns",
        "P_YS_FED_IMP_IOT0000006610": "Qiubei County",
        "P_YS_FED_IMP_IOT0000007941": "Yangshan County",
        "P_YS_FED_IMP_IOT0000007944": "Xicheng District",
        "P_YS_FED_IMP_IOT0000007943": "Longxi County",
        "P_YS_FED_IMP_IOT0000006615": "Yiyuan County",
        "P_YS_FED_IMP_IOT0000007946": "Taining County",
        "P_YS_FED_IMP_IOT0000006614": "Gaoyang County",
        "P_YS_FED_IMP_IOT0000007945": "Chengzihe District",
        "P_YS_FED_MDF-COMPS_0001573315": "么?",
        "P_YS_OA_XTMENHU_0000046682": "Keyword",
        "P_YS_FED_IMP_IOT0000007939": "Ganluo County",
        "P_YS_FED_IMP_IOT0000006607": "Shimian County",
        "P_YS_FED_IMP_IOT0000006609": "New balhu zuoqi",
        "P_YS_SD_UDHWN_0000047473": "Qianjiang",
        "P_YS_FED_FW_0001663472": "存在尚未完成的check",
        "P_YS_FED_IMP_IOT0000006600": "Taijiang County",
        "P_YS_FED_IMP_IOT0000007932": "Saga County",
        "P_YS_PF_PROCENTER_0000022911": "On-shelves",
        "P_YS_FED_IMP_IOT0000006604": "Jiujiang District",
        "P_YS_FED_IMP_IOT0000007934": "Zhabei District",
        "P_YS_FED_IMP_IOT0000007928": "Jiangyou",
        "P_YS_FED_IMP_IOT0000007927": "Chang'an District",
        "P_YS_SD_UDHWN_0000047486": "Huairou District",
        "P_YS_FED_IMP_IOT0000007922": "Louxing District",
        "P_YS_FED_IMP_IOT0000007923": "Xinghai County",
        "P_YS_HR_HRXC_0001197527": "Invalid data",
        "P_YS_FED_FW_1555933876791541761": "Refresh current list",
        "P_YS_FED_FW_1475374970712358918": "Noon | afternoon | evening",
        "P_YS_FED_IMP_IOT0000007915": "Muping District",
        "P_YS_FED_FW_1551464301900857353": "Operate for Whole Order",
        "P_YS_FED_IMP_IOT0000007914": "Shanghe County",
        "P_YS_FED_IMP_IOT0000007917": "Zaoyang",
        "P_YS_FED_FW_1551464301900857356": "Currently in detail mode",
        "P_YS_FED_IMP_IOT0000007919": "Jiangdong District",
        "P_YS_PF_PRINT_0000057075": "Contact Info",
        "P_YS_FED_FW_1581128902296207365": "模糊搜",
        "P_YS_SCM_STOCK_0000132840": "Error:",
        "P_YS_FED_IMP_IOT0000007913": "Dongkou County",
        "P_YS_FED_IMP_IOT0000007912": "Wucheng District",
        "P_YS_PF_GZTSYS_0000012816": "Personal",
        "P_YS_SCM_STOCK_0000132843": "Reference Carried Definition",
        "P_YS_PF_GZTSYS_0000012812": "To-dos",
        "P_YS_FED_FW_1581128902296207362": "精确搜",
        "P_YS_FED_FW_0001050401": "Level <%=text%>",
        "P_YS_FED_IMP_IOT0000007904": "Saga County",
        "P_YS_FED_IMP_IOT0000007906": "Gaoyi County",
        "P_YS_FED_IMP_IOT0000007909": "Luhe County",
        "P_YS_FED_IMP_IOT0000007900": "Guancheng Hui District",
        "P_YS_FED_IMP_IOT0000007902": "Chaling County",
        "P_YS_FED_FW_0001025471": "Failed to obtain data",
        "P_YS_FED_FW_0001025472": "No template service address is configured, or the configured address is incorrect. Current SERVER_ENV:",
        "P_YS_FED_FW_1535286379871207432": "Delete Scenario",
        "P_YS_PF_GZTSYS_0000012800": "Customer Category",
        "P_YS_PF_GZTSYS_0000012805": "Role Mgmt",
        "P_YS_FED_FW_0001491879": "Copy Text",
        "P_YS_FED_FW_1487292800403243012": "Sorry. An error occurred while saving. Try again?",
        "P_YS_SCM_STOCK_0000034385": "Current Store",
        "P_YS_SCM_STOCK_0000034388": "Booking Info Details",
        "P_YS_SCM_STOCK_0000034389": "Line",
        "country84": "Vietnam",
        "P_YS_FED_FW_0001320413": ". Please enter correctly",
        "P_YS_SCM_STOCK_0000034392": "Add to Cart",
        "P_YS_SCM_STOCK_0000034395": "Scan Voucher",
        "P_YS_SCM_STOCK_0000034397": "Member top-up is unavailable for online retailer orders",
        "P_YS_PF_GZTTMP_0000075261": "Start with",
        "country95": "Burma",
        "P_YS_FI_AR_0000058973": "Order Date",
        "P_YS_FED_FW_1617786585604947979": "年-月-日 时:分:秒",
        "P_YS_OA_XTMENHUCMS_0000045131": "Error Prompt",
        "P_YS_FED_FW_1617786585604947976": "年-月-日 时",
        "P_YS_SD_SDMBF_0000141364": "Scan Code to Query",
        "P_YS_SCM_STOCK_0000034363": "Production Date",
        "P_YS_SCM_STOCK_0000034364": "Supplier:",
        "P_YS_OA_XTLCZX_0000030196": "Attachment",
        "P_YS_SCM_STOCK_0000034367": "Collected",
        "P_YS_FED_FW_0001620384": "The Baidu Map API can only be accessed through the internet, but not in the exclusive environment",
        "P_YS_FED_IMP_IOT0000011200": "Dangchang County",
        "P_YS_FED_FW_1564304845386022921": "View Reference Details",
        "P_YS_FED_FW_0001291470": "The title of line ",
        "P_YS_FED_FW_0001573430": "! 重复的control对象为:%o",
        "P_YS_SCM_STOCK_0000132863": "Error Info:",
        "P_YS_FED_IMP_IOT0000011204": "Shuyang County",
        "P_YS_FED_IMP_IOT0000011203": "Wanxiu District",
        "P_YS_SCM_STOCK_0000132860": "Error in reading cache data during offline login",
        "P_YS_FED_FW_0001573427": "{\\\"1\\\":\\\"年\\\",\\\"2\\\":\\\"月\\\",\\\"6\\\":\\\"天\\\"}",
        "P_YS_FED_FW_0001007612": "Import",
        "P_YS_FED_FW_0001573428": "[{\\\"key\\\":\\\"1\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"年\\\"},{\\\"key\\\":\\\"2\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"月\\\"},{\\\"key\\\":\\\"6\\\",\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"天\\\"}]",
        "P_YS_FED_FW_0001573429": "Get the deleted data.",
        "P_YS_SCM_STOCK_0000034372": "It's currently in product examination status",
        "P_YS_SCM_STOCK_0000034375": "Qty to receive and receipt Qty do not match. Please confirm whether to abort product examination and save?",
        "P_YS_SCM_STOCK_0000034377": "Refund Amt",
        "P_YS_FED_FW_1500243140406149121": "Hello. Do you want to overwrite the existing user-level list settings (user-level template)?",
        "P_YS_FED_IMP_IOT0000011211": "old Town",
        "P_YS_FED_IMP_IOT0000011210": "Luannan County",
        "P_YS_FED_IMP_IOT0000011213": "Sifangtai District",
        "P_YS_FED_IMP_IOT0000011212": "Chenggu County",
        "P_YS_FED_FW_0001573431": "[bill-setting] [BillModal] [updateGridModelDataValueByCRefRetId()] 获取参照返回值ERROR:[",
        "P_YS_FED_FW_0001573432": "[bill-setting-new] [BillModal] [updateGridModelDataValueByCRefRetId()] 获取参照返回值ERROR:[",
        "P_YS_FED_FW_0001573433": "%c[bill-setting] [redux billmodal] [mergeDirtyDataInModalDataOriginal()] 重复的cName",
        "P_YS_FED_FW_0001080297": "No available operation. Please configure business process first",
        "P_YS_SCM_STOCK_0000132853": "Portal Component Layout",
        "P_YS_FED_FW_0001573434": ",阻止执行",
        "P_YS_FED_FW_0001573435": "渲染表格方法与组件",
        "P_YS_FED_FW_0001573436": "参照缺少必要配置cRefRetId、cRefType",
        "P_YS_FED_FW_0001573437": "获取下标为",
        "P_YS_FED_IMP_IOT0000011216": "Lazi County",
        "P_YS_SCM_STOCK_0000132858": "Error code: offline login error ==>",
        "P_YS_SCM_STOCK_0000132859": "Error code:",
        "P_YS_SCM_STOCK_0000034380": "Discount Rate %",
        "P_YS_FED_FW_1604492734089396228": "Attribute penetration above level <%=maxExpendLevel%> is not supported at present",
        "P_YS_OA_XTLCZX_0000030132": "No data",
        "P_YS_SCM_STOCK_0000034464": "Orig Doc Discount Amt",
        "P_YS_SCM_STOCK_0000034465": "Shopping cart is empty",
        "P_YS_FED_FW_0001151071": "Failed to obtain domainKey",
        "P_YS_SCM_STOCK_0000034467": "Actual Refund Price",
        "P_YS_FED_IMP_IOT0000011101": "Jinghai County",
        "P_YS_FED_IMP_IOT0000011103": "Xifeng District",
        "P_YS_PF_PRINT_0000065417": "Supplier",
        "P_YS_FED_IMP_IOT0000011108": "Yiwu",
        "P_YS_FED_IMP_IOT0000011105": "Liangcheng County",
        "P_YS_FED_IMP_IOT0000011106": "Chicheng County",
        "P_YS_FED_UCFBASEDOC_0000025614": "Mobile Phone",
        "ficloud.000550": "No operation permission",
        "P_YS_SCM_STOCK_0000034470": "Please enter product barcode",
        "P_YS_SCM_STOCK_0000034471": "Contact Phone",
        "P_YS_SCM_STOCK_0000034472": "Delete selected",
        "P_YS_FED_FW_0001542394": "You have a copy of draft data. Load?",
        "P_YS_SCM_STOCK_0000034473": "Deposit proportion cannot be less than",
        "P_YS_SD_USMP-UI_0001315551": "Tree Ref",
        "P_YS_SCM_STOCK_0000034475": "Select promotion activity",
        "P_YS_SCM_STOCK_0000034476": "Doc",
        "P_YS_FED_FW_0001007613": "Wrong value format",
        "P_YS_FED_IMP_IOT0000011112": "Yutian County",
        "P_YS_FED_IMP_IOT0000011114": "Zhongxiang",
        "P_YS_FED_IMP_IOT0000011113": "Nanxiong",
        "P_YS_OA_XTLCZX_0000030140": "Field Name",
        "P_YS_FED_IMP_IOT0000011118": "Southern County",
        "P_YS_FED_UCFBASEDOC_0000025601": "Please enter e-mail",
        "P_YS_SCM_STOCK_0000034442": "Orig. Sales Date",
        "P_YS_SCM_STOCK_0000034443": "Primary Salesperson",
        "P_YS_SCM_STOCK_0000034444": "Delivery Date",
        "P_YS_OA_XTLCZX_0000030159": "Approved At",
        "P_YS_SCM_STOCK_0000034446": "Selected",
        "P_YS_FED_IMP_IOT0000011120": "Chongli County",
        "P_YS_FED_IMP_IOT0000011127": "Jiexiu",
        "P_YS_FED_FW_1556016546332540933": "Refresh Search",
        "P_YS_FED_IMP_IOT0000011128": "Wuyishan City",
        "P_YS_OA_XTLCZX_0000030149": "Edit Formula",
        "P_YS_SCM_STOCK_0000034450": "Expected Delivery Date",
        "P_YS_SCM_STOCK_0000034451": "Returnable",
        "P_YS_SCM_STOCK_0000034454": "Login with Verification Code",
        "P_YS_SCM_STOCK_0000034455": "Unread",
        "P_YS_SCM_STOCK_0000034456": "Refund Amt is not equal to the Amt of the payment method in the original Doc",
        "P_YS_SCM_STOCK_0000034457": "0 Point",
        "P_YS_SCM_STOCK_0000034458": "Deposit Amt",
        "P_YS_FED_IMP_IOT0000011134": "Pakong Mountain",
        "P_YS_FED_IMP_IOT0000011133": "Yanyuan County",
        "P_YS_FED_IMP_IOT0000011136": "Shancheng District",
        "P_YS_FED_IMP_IOT0000011135": "Dawa County",
        "P_YS_FED_IMP_IOT0000011131": "Zhaosu County",
        "P_YS_OA_XTMENHUCMS_0000045155": "News",
        "P_YS_SCM_STOCK_0000034421": "Collected Amt (Deposit)",
        "P_YS_FED_FW_0000055378": "No column title in the profile. bodyItem!define6 will be used",
        "P_YS_FED_FW_0000055379": " and decimal digits",
        "P_YS_SCM_STOCK_0000034423": "A/R",
        "P_YS_FED_FW_0000055376": "All Info - 2-D table data  getRows =",
        "P_YS_SCM_STOCK_0000034424": "Please select salesperson",
        "P_YS_FED_FW_0000055377": "Please confirm whether to proceed",
        "P_YS_SCM_STOCK_0000034428": "Order Time",
        "P_YS_FED_IMP_IOT0000011147": "Jiang'an County",
        "P_YS_FED_IMP_IOT0000011141": "Huma County",
        "P_YS_FED_IMP_IOT0000011140": "Zhuji",
        "P_YS_FED_IMP_IOT0000011142": "Haiyang",
        "P_YS_FED_FW_1576846192821665795": "The data is allowed to print,",
        "P_YS_FED_FW_1576846192821665798": "Print confirmation",
        "P_YS_FED_FW_1576846192821665792": "If the data business phase is not completed, printing is not allowed:",
        "P_YS_FED_UIMG_0000025893": "Please set the field as Display first",
        "P_YS_FED_UIMG_0000025894": "Please set the field as Optional first",
        "P_YS_PES_PES-FE_0001104859": "Change Description",
        "P_YS_FED_FW_0000055383": "Set decimal digits:",
        "P_YS_FED_FW_0000055384": "Ref Name",
        "P_YS_FED_FW_0000055381": "groupFields will be set as empty",
        "P_YS_FED_FW_0000055382": "No more than",
        "P_YS_FED_FW_0000055380": "Group Info missing. groupFields returned from the interface =",
        "P_YS_SCM_STOCK_0000034430": "Check Out",
        "P_YS_FED_FW_1545658296411619334": "Hi, if you have set the column widths/fields to be visible in the top right corner of the user list, there are \"User Level Settings\", do your template level settings override them?",
        "P_YS_SCM_STOCK_0000034432": "Return Discount Rate",
        "P_YS_SCM_STOCK_0000034435": "Select voucher",
        "P_YS_PLM_GDS-FE_0001096721": "Drag files to the specified area to upload, or click to upload",
        "P_YS_SCM_STOCK_0000034438": "Matched correctly",
        "P_YS_FED_IMP_IOT0000011157": "Pingding County",
        "P_YS_FED_IMP_IOT0000011151": "Hu County",
        "P_YS_FED_IMP_IOT0000011154": "Hanchuan",
        "P_YS_FED_IMP_IOT0000011159": "Jinggu Dai and Yi Autonomous County",
        "P_YS_PF_GZTSYS_0000012907": "Accounting Services",
        "P_YS_PF_GZTSYS_0000012902": "Others",
        "P_YS_SCM_STOCK_0000034402": "Return by mixed payment method is not supported",
        "P_YS_SCM_STOCK_0000034404": "Sales Amt",
        "P_YS_SCM_STOCK_0000034405": "Modify Pre-order Info",
        "P_YS_FED_IMP_IOT0000011166": "Rugao",
        "P_YS_FED_IMP_IOT0000011168": "Taiping District",
        "P_YS_FED_IMP_IOT0000011163": "Tianjiaan District",
        "P_YS_FED_IMP_IOT0000011164": "Baishui County",
        "P_YS_PF_PRINT_0000065438": "A/R Pcs",
        "P_YS_FED_FW_0001253037": "Exception in exporting",
        "P_YS_FED_FW_0001388904": "Batch Modify All",
        "P_YS_FED_IMP_IOT0000011170": "Huidong County",
        "P_YS_FED_FW_1535273091242393606": "Cannot delete the documents involved in the approval process",
        "P_YS_SCM_STOCK_0000034412": "Please enter voucher",
        "P_YS_SCM_STOCK_0000034413": "Delivery Time",
        "P_YS_SCM_STOCK_0000034415": "A/R Amt cannot be less than the lowest deposit Amt (",
        "P_YS_FED_IMP_IOT0000011178": "Yanqi Hui Autonomous County",
        "P_YS_SCM_STOCK_0000034418": "Switch Scanning",
        "P_YS_SCM_STOCK_0000034419": "Manually enter barcode",
        "P_YS_FED_IMP_IOT0000011176": "Menyuan Hui Autonomous County",
        "P_YS_FED_FW_0000157485": "Route",
        "P_YS_FED_FW_0001157215": "Required. Please enter",
        "P_YS_FED_FW_0000157486": "Including the controls or containers field, only one of which is rendered. The priority of containers is higher than controls",
        "P_YS_FED_IMP_IOT0000011180": "Antu County",
        "P_YS_FED_FW_0000157487": "Only render containers",
        "P_YS_FED_FW_0000157488": "Obtain state.action",
        "P_YS_FED_IMP_IOT0000011182": "Qintang District",
        "P_YS_FED_FW_0000157482": "Icon Library",
        "P_YS_FED_FW_0000157483": "<SvgIcon/>Supported icon type",
        "P_YS_FED_FW_0000157484": "Can contain menuId field",
        "P_YS_FED_IMP_IOT0000011188": "Daishan County",
        "P_YS_FED_FW_0000157480": "Clicking Event",
        "P_YS_FED_FW_0001409434": "Display Subtotal/Total",
        "P_YS_FED_FW_0001409433": "The link text and URL must be entered at the same time",
        "P_YS_FED_FW_0001409432": "Incorrect URL format. Please enter the correct URL (note: the URL cannot contain Chinese characters)",
        "P_YS_FED_IMP_IOT0000011186": "Luolong District",
        "P_YS_FED_FW_0001409431": "Merge Column",
        "P_YS_FED_FW_0001255676": "Please check icon configuration--",
        "P_YS_FED_FW_0000157478": "No. of Columns",
        "P_YS_FI_CM_0000029738": "April",
        "P_YS_FED_FW_0000157479": "Replace Icon",
        "P_YS_FED_FW_0000055349": "] Hidden required data item exists:",
        "P_YS_FED_IMP_IOT0000011192": "Zhuozi County",
        "P_YS_FED_FW_0000157475": "Display SVG",
        "P_YS_FED_FW_0000055347": "Hidden required data item exists:",
        "P_YS_FED_FW_0000157476": "File Type",
        "P_YS_FED_FW_0000055348": "Request error",
        "P_YS_FED_FW_0000157477": "Display Upload List",
        "P_YS_SD_SDMA_0000061917": "Info",
        "P_YS_FED_FW_0000055346": "Please select data",
        "P_YS_FED_IMP_IOT0000011199": "Leishan County",
        "P_YS_FI_FP_0000034914": "This Year",
        "P_YS_FED_FW_0000055352": "Decrease [",
        "P_YS_FED_FW_0000055353": "Max length set",
        "P_YS_FED_FW_0000055350": "Change to [",
        "P_YS_FED_FW_0000055351": "(The size of each picture cannot exceed 5M; JPG, PNG, BMP and GIF formats supported",
        "P_YS_FED_FW_0000055358": "Increase [",
        "P_YS_FED_FW_0000055359": "No row title in the profile. bodyItem!define5 will be used",
        "P_YS_FED_FW_0000055356": "The selected Qty exceeds the upload limit. Please select again and retry",
        "P_YS_FI_CM_0000029752": "ár",
        "P_YS_FED_FW_0000055357": "All qualified records",
        "P_YS_FED_FW_0000055354": "Checked",
        "P_YS_FED_FW_0000055355": "All Info - 1-D table data  getRows =",
        "P_YS_FI_YYFI-UI_0001071709": "Black",
        "P_YS_FED_FW_0000055363": ")",
        "P_YS_FED_FW_0000055364": "Multiply [",
        "P_YS_FED_FW_0000055361": "All Info - 2-D table initialization data source =",
        "P_YS_FED_FW_0000055362": "All Info - 2-D table columns =",
        "P_YS_FED_FW_0000055360": ". Up to: ",
        "P_YS_FED_IMP_IOT0000005395": "Finished",
        "P_YS_FED_FW_0000157496": "Can contain itemName, menuId and parentItem fields",
        "P_YS_FED_FW_0000157497": "Only use meta.controls[0]",
        "P_YS_FED_FW_0000055369": "All Info - Rows of 1-D table and 2-D table  Rows of 1-D table =",
        "P_YS_FED_FW_0000055367": "Subtotal (",
        "P_YS_FED_FW_0000157492": "Can contain controls field",
        "P_YS_FED_FW_0000157493": "browse or other",
        "P_YS_FED_FW_0000055368": "Recalculate Total  Begin bReCalc =",
        "P_YS_FED_FW_0000055365": " pieces of records",
        "P_YS_FED_FW_0000157494": "Can contain params field",
        "P_YS_FED_FW_0000157495": "Can contain containers field",
        "P_YS_FED_FW_0000055366": "Recalculate Total End totalSum =",
        "P_YS_FED_FW_0000157491": "Includes itemName, menuId, itemIndex",
        "P_YS_SD_UDHWN_0000047440": "Lingao County",
        "P_YS_FED_FW_0001297661": "%c captures the shortcut key: %c",
        "P_YS_FED_FW_0000055374": "You will ",
        "P_YS_FED_FW_0000055375": "Clear All",
        "P_YS_HR_HRRCPDF_0001303021": "View Selected Only",
        "P_YS_FED_FW_0000055372": "Divide [",
        "P_YS_FED_FW_0000055373": ", plus the length of the entered number and decimal point",
        "P_YS_FED_UCFBASEDOC_0000025667": " pieces",
        "P_YS_FED_FW_0000055370": "Name length exceeds 10 chars",
        "P_YS_FED_FW_0000157489": "Display cShowCaption",
        "P_YS_FED_FW_0000055371": "File must be less than 2M",
        "P_YS_FED_IMP_IOT0000005384": "Dept 2",
        "P_YS_FED_IMP_IOT0000005385": "Dept 3",
        "P_YS_FED_IMP_IOT0000005386": "Dept 1",
        "P_YS_SD_SDMAF_0000137022": "Sorting Rules",
        "P_YS_SD_UDHWN_0000048714": "Wuqing District",
        "P_YS_FED_FW_0001312014": "Please configure the line editing metadata",
        "P_YS_FED_IMP_IOT0000006697": "Mingshan County",
        "P_YS_FED_IMP_IOT0000006696": "Rudong County",
        "P_YS_FED_IMP_IOT0000006691": "Youyang Tujia and Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000006690": "Wengyuan County",
        "P_YS_FI_FP_0000034988": "Last Year",
        "P_YS_OA_XTHUATI_0000046210": "Click to load more",
        "P_YS_FED_IMP_IOT0000006686": "Yangyuan County",
        "P_YS_FED_IMP_IOT0000006685": "Lezhi County",
        "P_YS_FED_IMP_IOT0000006687": "Sheqi County",
        "P_YS_FED_IMP_IOT0000006689": "Milin County",
        "P_YS_SD_SDMA_0000039189": "Approval Status",
        "P_YS_FED_FW_0001229378": "Please select the data to be restored",
        "P_YS_FED_IMP_IOT0000006682": "Longyao County",
        "P_YS_SD_UDHWN_0000048734": "Lingshui Li Autonomous County",
        "P_YS_SD_UDHWN_0000047405": "Apple",
        "P_YS_PES_PES-FE_0001108397": "Unread Info",
        "P_YS_PES_PES-FE_0001108394": "Read Info",
        "P_YS_FED_IMP_IOT0000006675": "Huangyan District",
        "P_YS_FED_IMP_IOT0000006674": "Angren County",
        "P_YS_FED_IMP_IOT0000006676": "Gaoyao",
        "P_YS_FED_IMP_IOT0000006678": "Zhenfeng County",
        "P_YS_FED_FW_0001097161": "Clicking OK will close the page and all the editing will be discarded. Continue?",
        "P_YS_FED_FW_0001097160": " days' Sales Qty (excluding the current day)",
        "P_YS_FED_IMP_IOT0000006671": "Taizihe District",
        "P_YS_FED_IMP_IOT0000006670": "Ningjin County",
        "P_YS_FED_IMP_IOT0000006673": "Zhenping County",
        "P_YS_FED_IMP_IOT0000006672": "Luozhuang District",
        "P_YS_FED_FW_1510095451785789446": "Expand as hovering button",
        "P_YS_HR_HRYG_0000154297": "Parameter type error",
        "P_YS_PF_GZTSYS_0000012776": "Templates",
        "P_YS_FED_IMP_IOT0000006543": "Shushan District",
        "P_YS_FED_IMP_IOT0000006542": "Shibei District",
        "P_YS_FED_IMP_IOT0000006545": "Xiqing District",
        "P_YS_FED_IMP_IOT0000007876": "Yizhang County",
        "P_YS_PF_GZTSYS_0000012772": "Supplier",
        "P_YS_FED_IMP_IOT0000007878": "Yingzhou District",
        "P_YS_FED_IMP_IOT0000006546": "Wudalianchi",
        "P_YS_FED_IMP_IOT0000007877": "Honggu District",
        "P_YS_FED_IMP_IOT0000006549": "Yanshan County",
        "P_YS_FED_IMP_IOT0000006548": "Meigu County",
        "P_YS_FED_IMP_IOT0000007879": "Changning County",
        "P_YS_FED_IMP_IOT0000007870": "Yadong County",
        "P_YS_FED_FW_1510095451785789449": "Collapse as permanent button",
        "P_YS_FED_IMP_IOT0000007871": "Heshan District",
        "P_YS_FED_IMP_IOT0000006531": "Yushui District",
        "P_YS_FED_IMP_IOT0000007862": "Songming County",
        "P_YS_FED_IMP_IOT0000007865": "Zhashui County",
        "P_YS_PF_GZTSYS_0000012789": "Purchase Contract",
        "P_YS_FED_IMP_IOT0000007864": "Alxa Left Banner",
        "P_YS_FED_IMP_IOT0000006536": "Dengkou County",
        "P_YS_FED_IMP_IOT0000007867": "Shuangliao",
        "P_YS_FED_IMP_IOT0000006535": "Gongjue County",
        "P_YS_FED_IMP_IOT0000007866": "Wuxuan County",
        "P_YS_FED_IMP_IOT0000006538": "Baqiao District",
        "P_YS_FED_IMP_IOT0000007869": "Yingze District",
        "P_YS_FED_IMP_IOT0000007861": "Xishan District",
        "P_YS_SD_SDMBF_0000143804": "Select",
        "P_YS_FED_IMP_IOT0000006529": "Nanming District",
        "P_YS_FED_IMP_IOT0000007851": "Shangyu",
        "P_YS_FED_IMP_IOT0000007854": "Jianyang",
        "P_YS_FED_IMP_IOT0000007853": "Xiuzhou District",
        "P_YS_PF_GZTSYS_0000012755": "Reimbursement",
        "P_YS_FED_IMP_IOT0000006525": "Dongxiang County",
        "P_YS_FED_IMP_IOT0000007855": "Hainan District",
        "P_YS_FED_IMP_IOT0000006527": "Xiangyang District",
        "P_YS_FED_IMP_IOT0000007858": "Zhangshu",
        "P_YS_FED_IMP_IOT0000006526": "Ruian",
        "P_YS_FED_IMP_IOT0000007857": "Zunyi County",
        "P_YS_FED_IMP_IOT0000006517": "Sharp lawn area",
        "P_YS_FED_IMP_IOT0000006519": "Kuandian Manchu Autonomous County",
        "P_YS_FED_IMP_IOT0000007841": "Kaifeng County",
        "P_YS_FED_IMP_IOT0000007840": "Mayang Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000006514": "Hongjiang",
        "P_YS_FED_IMP_IOT0000007845": "Wubao County",
        "P_YS_FED_IMP_IOT0000006516": "Nanchang County",
        "P_YS_FED_FW_0001193013": "Please enter these required items correctly",
        "P_YS_FED_IMP_IOT0000007838": "Liulin County",
        "P_YS_FED_IMP_IOT0000006506": "Shanyang County",
        "P_YS_PF_GZTPRE_0000071096": "Execute Now",
        "P_YS_FED_IMP_IOT0000006508": "Sanjiang Dong Autonomous County",
        "P_YS_FED_IMP_IOT0000007839": "Nanzhao County",
        "P_YS_HR_HRYG_0000154257": "Error Description",
        "P_YS_OA_XTMENHU_0000046789": "Copied successfully",
        "P_YS_FED_IMP_IOT0000006501": "Baihe County",
        "P_YS_FED_IMP_IOT0000007831": "Huishui County",
        "P_YS_FED_IMP_IOT0000006502": "Wushi County",
        "P_YS_FED_IMP_IOT0000007833": "Juancheng County",
        "P_YS_FED_IMP_IOT0000006505": "Pinghu",
        "P_YS_FED_IMP_IOT0000007836": "Doumen District",
        "P_YS_FED_IMP_IOT0000006504": "Du'an Yao Autonomous County",
        "P_YS_FI_CM_0000029778": "October",
        "P_YS_FED_IMP_IOT0000007827": "Yichuan County",
        "P_YS_FED_FW_0001079325": "Graph",
        "P_YS_FED_IMP_IOT0000007829": "Dali City",
        "P_YS_FED_IMP_IOT0000007828": "Maduo County",
        "P_YS_FED_FW_0001079326": "List",
        "P_YS_FED_IMP_IOT0000007821": "West Lake District",
        "P_YS_FED_IMP_IOT0000007820": "Yuanbaoshan",
        "P_YS_FED_IMP_IOT0000007823": "Shuangta District",
        "P_YS_FED_FW_0001469036": "全选(",
        "P_YS_FED_IMP_IOT0000007822": "Danjiangkou",
        "P_YS_FED_IMP_IOT0000007824": "Fukang",
        "P_YS_FED_IMP_IOT0000007816": "Fushan District",
        "P_YS_FED_IMP_IOT0000007815": "Wancheng District",
        "P_YS_FED_IMP_IOT0000007813": "Lianshan District",
        "P_YS_PF_GZTSYS_0000012795": "Job Level",
        "P_YS_FED_IMP_IOT0000007805": "Yangxin County",
        "P_YS_FED_IMP_IOT0000007804": "Youyi County",
        "P_YS_FED_IMP_IOT0000007806": "Taojiang County",
        "P_YS_FED_IMP_IOT0000007808": "Shexian",
        "P_YS_FED_IMP_IOT0000007801": "Jiexi County",
        "P_YS_FED_IMP_IOT0000007802": "Yunxian",
        "P_YS_HR_HRYGF_0000055686": "Calendar",
        "P_YS_PF_SUPPORT-UI_0001152916": "Date Format",
        "P_YS_FED_FW_0001121379": "Please set the value of the line title first",
        "P_YS_FED_FW_0001140573": "] does not exist in the source table column. Please check",
        "P_YS_PF_GZTSYS_0000012701": "Brand",
        "P_YS_SCM_USTOCK-UI_0000173950": "View Historical Daily Settlement",
        "P_YS_SD_UDHLIB_0000133325": "Switch",
        "P_YS_PF_SOCD-O_0000182693": "Junior High School",
        "P_YS_FED_FW_0001246031": "The page you want to access has been deleted or other exceptions have occurred. Please return to the list and try again",
        "P_YS_SD_SDMA_0000060490": "Failed to delete",
        "P_YS_FED_FW_1458899089362518016": "行子表的",
        "P_YS_FED_FW_1614877844774584320": "The draft box is empty",
        "P_YS_FED_FW_0001086504": "Failed to find valid data in the template",
        "P_YS_SD_URETAILF_0001130882": "Pull down to refresh",
        "P_YS_HR_HRYGF_0000055671": "Please enter name",
        "P_YS_FED_FW_0001025574": "The length of the entered number cannot exceed ",
        "P_YS_PF_SOCD_0000154844": "Military ID",
        "P_YS_FED_FW_1463414594656534528": "Error occurred in the map request.",
        "P_YS_PF_GZTSYS_0000012731": "Coding Rules",
        "P_YS_PF_GZTSYS_0000012736": "Pmt Method",
        "P_YS_PES_PES-UI_0001234764": "Data Table",
        "P_YS_FED_FW_1467090828949192704": "The input length exceeds the limit: the maximum length is 10 Chinese characters and the maximum length is 20 letters in English.",
        "P_YS_PF_GZTSYS_0000012745": "User-defined File",
        "P_YS_SCM_STOCK_0000034485": "Select specification",
        "P_YS_SCM_STOCK_0000034487": "Change Amt exceeds limit. Max change Amt:",
        "P_YS_SCM_STOCK_0000034490": "Error Qty",
        "P_YS_SCM_STOCK_0000034493": "Unavailable Vouchers",
        "P_YS_SCM_STOCK_0000034495": "Discount Rate",
        "P_YS_PF_SOCD_0000154855": "USD",
        "P_YS_SCM_STOCK_0000034497": "Delete Database",
        "P_YS_SCM_STOCK_0000034498": "Scan Barcode",
        "P_YS_SCM_STOCK_0000034585": "Subtotal",
        "P_YS_SCM_STOCK_0000034586": "Orig. Doc Linked Query",
        "P_YS_FED_FW_1575188275308527622": "Conditions of type \"not empty\" or \"empty\" cannot be cleared. Click \"Advanced\" to enter the pop-up window.",
        "P_YS_PF_PC-UI_0001072138": "For display. Input not required",
        "P_YS_OA_XTLCZX_0000030265": "Loading",
        "P_YS_SCM_STOCK_0000034595": "No voucher. Please add manually",
        "P_YS_SCM_STOCK_0000034596": "No available customer",
        "ficloud.000415": "Unsupported",
        "P_YS_SCM_STOCK_0000034599": "The following SN has been scanned: [",
        "P_YS_SCM_STOCK_0000034564": "Delivery Warehouse",
        "P_YS_SCM_STOCK_0000034569": "Insufficient balance",
        "P_YS_FED_IMP_IOT0000011003": "Beilin District",
        "P_YS_FED_IMP_IOT0000011000": "Minfeng County",
        "P_YS_FED_FW_1483255496785264644": "字段触发check，check前值为:",
        "P_YS_FED_IMP_IOT0000011009": "Tieling County",
        "P_YS_FED_IMP_IOT0000011006": "Xiamen",
        "P_YS_FED_IMP_IOT0000011007": "Jinkouhe District",
        "P_YS_FED_UCFBASEDOC_0000025713": "Please enter role code",
        "P_YS_SD_UDHWN_0000048808": "Wenshan City",
        "P_YS_FED_FW_0001301257": "The following header field is wrong",
        "P_YS_SCM_STOCK_0000034570": "Exceeds Qty to Receive",
        "P_YS_SCM_STOCK_0000034572": "Please enter verification code",
        "P_YS_SCM_STOCK_0000034573": "Confirm to mark all as read?",
        "P_YS_SCM_STOCK_0000034574": "Total Discount Amt",
        "P_YS_OA_XTLCZX_0000030284": "Confidentiality Period",
        "P_YS_SCM_STOCK_0000034579": "Doc date:",
        "P_YS_OA_XTLCZX_0000030288": "Load More",
        "P_YS_FED_IMP_IOT0000011015": "Tunxi District",
        "P_YS_FED_IMP_IOT0000011014": "Yangtang County",
        "P_YS_FED_FW_1510116436995997696": "The text length cannot be negative. Please modify",
        "P_YS_FED_FW_1510116436995997699": "The numeric precision cannot be negative. Please modify",
        "P_YS_FED_UCFBASEDOC_0000025709": "Project",
        "P_YS_FED_IMP_IOT0000011016": "Shigatse",
        "P_YS_FED_IMP_IOT0000011018": "Chaonan District",
        "P_YS_FED_UCFBASEDOC_0000025703": "Object",
        "P_YS_SCM_STOCK_0000034581": "Error Reason",
        "P_YS_SCM_STOCK_0000034582": "Enter code or scan",
        "P_YS_SCM_STOCK_0000034545": "Incomplete parameter",
        "P_YS_FED_IMP_IOT0000011020": "Fuling District",
        "P_YS_FED_IMP_IOT0000011022": "Huadian",
        "P_YS_FED_IMP_IOT0000011028": "Friendly zone",
        "P_YS_FED_IMP_IOT0000011027": "Yuanshi County",
        "P_YS_OA_XTLCZX_0000030206": "Hide",
        "P_YS_FED_FW_1550175803122122759": "Illegal information prompt(Prohibit Next Step)",
        "P_YS_SCM_STOCK_0000034550": "Refund Details",
        "P_YS_SCM_STOCK_0000034551": "Development in progress...",
        "P_YS_HR_HRSSC_0000135746": "Title is empty",
        "P_YS_SCM_STOCK_0000034554": "Light Off",
        "P_YS_FED_FW_1488664372439416833": "No picture ds",
        "P_YS_SCM_STOCK_0000034555": "Select account No.",
        "P_YS_OA_XTLCZX_0000030224": "Required",
        "P_YS_SCM_STOCK_0000034557": "Contact",
        "P_YS_FED_FW_1550175803122122762": "Warning information prompt",
        "P_YS_SCM_STOCK_0000034559": "Confirm to abort settlement?",
        "P_YS_FED_IMP_IOT0000011034": "Qin County",
        "P_YS_FED_FW_1483255496785264650": "。两个值不一样会再次触发check。请保持一样。",
        "P_YS_FED_IMP_IOT0000011037": "Lushan County",
        "P_YS_FED_IMP_IOT0000011031": "Zhenxiong County",
        "P_YS_FED_FW_1483255496785264653": ", check后值为:",
        "P_YS_FED_FW_1483255496785264647": "%c updateRows新旧值不一样会触发公式.. >>>target =>旧值 =>新值 => updateRows Params",
        "P_YS_FED_IMP_IOT0000011039": "Axe Kazakh Autonomous County",
        "P_YS_FED_IMP_IOT0000011038": "Zhangjiachuan Hui Autonomous County",
        "P_YS_PF_PRINT_0000065582": "Requisition Date",
        "P_YS_SCM_STOCK_0000034523": "Read",
        "P_YS_SCM_STOCK_0000034525": "Cashier",
        "P_YS_FED_IMP_IOT0000011045": "Ningjin County",
        "P_YS_SCM_STOCK_0000034529": "Multiple products matched",
        "P_YS_FED_IMP_IOT0000011044": "Fugu County",
        "P_YS_FED_IMP_IOT0000011043": "Wuyang County",
        "P_YS_PF_GZTSYS_0000108857": "Failure Reason:",
        "P_YS_SCM_USTOCK-UI_0001077879": "For display. Input not required",
        "P_YS_OA_XTLCZX_0000030242": "Main Table",
        "P_YS_SCM_STOCK_0000034530": "Modify Doc Info",
        "P_YS_SCM_STOCK_0000034531": "Created At",
        "P_YS_FED_IMP_IOT0000011050": "Gongshu District",
        "P_YS_SCM_STOCK_0000034533": "Ship-to Address",
        "P_YS_FED_FW_1461189750035054592": "Calendar days",
        "P_YS_FED_IMP_IOT0000011057": "Kuqa County",
        "P_YS_SCM_STOCK_0000034538": "Billing - Book",
        "P_YS_FED_IMP_IOT0000011053": "Yuexi County",
        "P_YS_OA_XTLCZX_0000030239": "Options",
        "P_YS_FED_FW_0001159999": "前7周",
        "P_YS_FED_IMP_IOT0000011060": "Shou County",
        "P_YS_FED_FW_0001159998": "第七周",
        "P_YS_FED_FW_0001159997": "Courier",
        "P_YS_FED_FW_0001159996": "以下数据项校验失败：'",
        "P_YS_FED_IMP_IOT0000011061": "Yuhang District",
        "P_YS_SCM_STOCK_0000034501": "Account",
        "P_YS_FED_IMP_IOT0000011068": "Shangzhi",
        "P_YS_SCM_STOCK_0000034504": "Clear All",
        "P_YS_FED_IMP_IOT0000011067": "Shehong County",
        "P_YS_FED_IMP_IOT0000011064": "Jinyuan District",
        "P_YS_FED_IMP_IOT0000011066": "White flag",
        "P_YS_FED_IMP_IOT0000011071": "Huize County",
        "P_YS_FED_IMP_IOT0000011070": "Quyang County",
        "P_YS_FED_FW_0001265118": "Saving. Please wait",
        "P_YS_FED_FW_0001265119": "Asynchronous saving timed out",
        "P_YS_SCM_STOCK_0000034513": "Select return Doc",
        "P_YS_FED_FW_0001567737": "There is no picture",
        "P_YS_SCM_STOCK_0000034514": "Join Now",
        "P_YS_FED_IMP_IOT0000011079": "Yanchi County",
        "P_YS_FED_IMP_IOT0000011078": "Balinyouqi",
        "P_YS_SCM_STOCK_0000034518": "Select at least one payment method",
        "P_YS_FED_IMP_IOT0000011075": "Hokkaido",
        "P_YS_FED_IMP_IOT0000011077": "Qingshuihe County",
        "P_YS_FED_IMP_IOT0000011076": "Shuangbai County",
        "P_YS_FI_CM_0000029869": "Please select the date",
        "P_YS_FED_IMP_IOT0000011082": "Panxian",
        "P_YS_FED_IMP_IOT0000011081": "Shuangqing District",
        "P_YS_FED_IMP_IOT0000011084": "Miquan",
        "P_YS_FI_CM_0000029876": "Year YYYY",
        "P_YS_PF_QITDFE_0000113168": "Reason for Failure",
        "P_YS_FED_IMP_IOT0000011088": "Nanzheng County",
        "P_YS_PF_PRINT_0000065599": "Group No.",
        "P_YS_FED_UIMG_0001156156": "Multilingual Text",
        "P_YS_HR_HRXC_0000177247": "Latest Ver",
        "P_YS_FED_IMP_IOT0000011091": "Jianshui County",
        "P_YS_FED_IMP_IOT0000011090": "Qidong County",
        "P_YS_FED_FW_1431429243042529280": "The following field is incorrect. Please enter correctly",
        "P_YS_FED_FW_0001253130": "Invalid address",
        "P_YS_PF_PROCENTER_0001131739": "UI Template",
        "P_YS_FED_IMP_IOT0000011099": "Xinghualing District",
        "P_YS_FED_IMP_IOT0000006598": "Dongfeng District",
        "P_YS_FED_IMP_IOT0000006597": "Lanxian",
        "P_YS_FED_IMP_IOT0000006599": "Gar county",
        "P_YS_FED_IMP_IOT0000006592": "Lishu District",
        "P_YS_FED_IMP_IOT0000006591": "Linxi County",
        "P_YS_FED_IMP_IOT0000006594": "Wudu District",
        "P_YS_FED_IMP_IOT0000006595": "Abaga Banner",
        "P_YS_PF_PRINT_0000106529": "Print Template",
        "P_YS_FI_CM_0000029811": "Please select time",
        "P_YS_FED_FW_0001097273": "No sub-table found",
        "P_YS_FED_FW_0001097272": "No associated gridmodel",
        "P_YS_FED_IMP_IOT0000006583": "Tiefeng District",
        "P_YS_FED_IMP_IOT0000006582": "Gongga County",
        "P_YS_FED_IMP_IOT0000006584": "Deleted",
        "P_YS_FED_IMP_IOT0000006577": "Ningling County",
        "P_YS_FED_IMP_IOT0000006579": "Tengxian",
        "P_YS_FED_FW_1549253106706939908": "The network is running out of steam, try refreshing~",
        "P_YS_FED_IMP_IOT0000006574": "Zanda County",
        "P_YS_FED_IMP_IOT0000006567": "Yuecheng District",
        "P_YS_FED_IMP_IOT0000007898": "Wanzhou District",
        "P_YS_FED_IMP_IOT0000007897": "Baoxing County",
        "P_YS_FED_IMP_IOT0000006569": "Badaojiang District",
        "P_YS_FED_IMP_IOT0000007899": "Jinjiazhuang District",
        "P_YS_FED_IMP_IOT0000006561": "Longgang District",
        "P_YS_FED_IMP_IOT0000006562": "Wanberlin",
        "P_YS_FED_IMP_IOT0000007893": "Beiguan District",
        "P_YS_FED_IMP_IOT0000007884": "Linzhou",
        "P_YS_FED_IMP_IOT0000006556": "Rongjiang County",
        "P_YS_FED_IMP_IOT0000007887": "Jianxi District",
        "P_YS_FED_IMP_IOT0000007886": "Qixian",
        "P_YS_FED_IMP_IOT0000006559": "Toutunhe District",
        "P_YS_FED_IMP_IOT0000006551": "Tianlin County",
        "P_YS_FED_IMP_IOT0000007882": "Jingshan County",
        "P_YS_FED_IMP_IOT0000006429": "Zhuoni County",
        "P_YS_FED_FW_0000020988": "Details",
        "P_YS_PF_GZTSYS_0000012655": "Data Permission",
        "P_YS_FED_FW_0000020987": "2.0",
        "P_YS_FED_IMP_IOT0000006424": "Lankao County",
        "P_YS_FED_IMP_IOT0000007755": "Laizhou",
        "P_YS_FED_FW_0000020989": "Confirm to abort the current modification?",
        "P_YS_FED_IMP_IOT0000006423": "Xide County",
        "P_YS_FED_IMP_IOT0000006426": "Dantu District",
        "P_YS_FED_IMP_IOT0000007757": "Wanquan County",
        "P_YS_FED_IMP_IOT0000006425": "Hecheng District",
        "P_YS_FED_FW_0001608880": "%c[mdf-cube] [staterule] [rule] parseCondition(), 无条件直接执行",
        "P_YS_FED_IMP_IOT0000006428": "Tengzhou",
        "P_YS_FED_IMP_IOT0000007759": "Jiaozhou",
        "P_YS_FED_FW_0001608881": "%c是否反转：",
        "P_YS_FED_IMP_IOT0000006427": "Quangang District",
        "P_YS_FED_FW_0001608882": "%c[mdf-cube] [staterule] [rule] runRule(), 执行交互规则事件监听：",
        "P_YS_FED_FW_0000020980": " pieces, of which, succeeded",
        "P_YS_FED_FW_0000020982": "Succeeded",
        "P_YS_FED_FW_0000020984": "Text",
        "P_YS_FED_FW_0000020983": "You've not made any changes",
        "P_YS_FED_FW_0000020986": "Please select a piece of data",
        "P_YS_FED_FW_0000020985": "Sun",
        "P_YS_PF_GZTSYS_0001106485": "Event Query",
        "P_YS_FED_IMP_IOT0000007750": "Siyang County",
        "P_YS_PF_GZTSYS_0000012671": "UOM",
        "P_YS_PF_GZTSYS_0000012670": "Enterprise Info",
        "P_YS_PF_PRINT_0000057241": "Unit Price in FC Excl. Tax",
        "P_YS_FED_FW_0000055626": "It' not allowed to hide required fields",
        "P_YS_FED_FW_0000020999": "Wed",
        "P_YS_FED_IMP_IOT0000006411": "Udang District",
        "P_YS_FED_IMP_IOT0000007742": "Yunan County",
        "P_YS_FED_FW_0001608872": "%c[mdf-cube] [staterule] [rule] runRule(), 给以下字段/表格绑定事件：",
        "P_YS_FED_FW_0001608873": "%c前端主动执行公式>>> ==>rules ==>targets",
        "P_YS_FED_IMP_IOT0000007744": "Kaili",
        "P_YS_FED_IMP_IOT0000006413": "Luoping County",
        "P_YS_PF_GZTSYS_0000012668": "Authorization",
        "P_YS_FED_FW_0001608874": "%c[mdf-cube] [staterule] [rule] showModal(), the parameter target==>, property=>, value==>, rule===> 弹出框：",
        "P_YS_FED_FW_0001608875": "%c>> 交互规则过滤出表格actions",
        "P_YS_FED_IMP_IOT0000006415": "Luxi County",
        "P_YS_FED_IMP_IOT0000007746": "Jingchuan County",
        "P_YS_FED_IMP_IOT0000007745": "Hequ County",
        "P_YS_FED_FW_1498007515453456390": "Obsolete",
        "P_YS_FED_IMP_IOT0000006417": "Datong Hui and Tu Autonomous County",
        "P_YS_FED_FW_0001608870": "%c[mdf-cube] [staterule] [rule] parseExprsCondtion(), 条件验证多列表格：",
        "P_YS_FED_IMP_IOT0000006416": "Jieshou City",
        "P_YS_FED_IMP_IOT0000007747": "Linze County",
        "P_YS_FED_FW_0001608871": "%c[mdf-cube] [staterule] [rule] runActionGroup(), 解析单个rule所有动作的条件：",
        "P_YS_FED_FW_0000020991": "5.0",
        "P_YS_FED_FW_1498007515453456393": "Manual Search:",
        "P_YS_FED_FW_0000020990": "Confirm to delete?",
        "P_YS_FED_FW_0000020993": "Cache refreshed successfully",
        "P_YS_FED_FW_0000020992": "Failed to verify the following data item:",
        "P_YS_FED_FW_1498007515453456396": "When the search conditions are changed, the query will not be performed immediately, instead you need to manually click [Search]",
        "P_YS_FED_FW_0000020995": "The category is already the last one of the same level",
        "P_YS_FED_FW_0001608876": "%c[mdf-cube] [staterule] [rule] setGroupMeta(), the parameter target==>, property=>, value==> 设置容器：",
        "P_YS_FED_FW_0000020994": "Integer Type",
        "P_YS_FED_FW_0001608877": "%c页面规则>>> rules => 执行方式 => 来源 =>",
        "P_YS_FED_FW_0000020997": "Failed to obtain the permission list",
        "P_YS_FED_IMP_IOT0000007740": "Qidong",
        "P_YS_FED_FW_0001608878": "%c[mdf-cube] [staterule] [rule] runRule(), 执行交互规则事件监听 条件返回结果：",
        "P_YS_FED_FW_1498007515453456399": "Trigger the search immediately when the query criteria values are changed",
        "P_YS_FED_FW_0000020996": "And its child",
        "P_YS_FED_FW_0001608879": "%c[mdf-cube] [staterule] [rule] runRule(), 绑定：",
        "P_YS_FED_IMP_IOT0000006408": "Pingshan County",
        "P_YS_FED_IMP_IOT0000007739": "Lichuan County",
        "P_YS_FED_IMP_IOT0000006407": "Konan District",
        "P_YS_FED_IMP_IOT0000006409": "Shangshui County",
        "P_YS_FED_FW_0000020965": " items",
        "P_YS_FED_FW_0001608862": "%c执行动作 start time：",
        "P_YS_FED_FW_0000020968": "Week",
        "P_YS_FED_IMP_IOT0000006402": "Sui County",
        "P_YS_FED_FW_0001608863": "%c公式解析失败>>",
        "P_YS_FED_FW_0000020967": "No specific Doc found",
        "P_YS_FED_FW_0001608864": "%c执行动作 end time：",
        "P_YS_FED_IMP_IOT0000006404": "Eastern District",
        "P_YS_FED_IMP_IOT0000007735": "Fugou County",
        "P_YS_FED_FW_0000020969": "Form user-defined fields upgraded successfully",
        "P_YS_FED_IMP_IOT0000006403": "Wen'an County",
        "P_YS_FED_IMP_IOT0000006406": "Please enter contact Info",
        "P_YS_PF_GZTSYS_0000012631": "Transaction Type",
        "P_YS_FED_IMP_IOT0000007736": "Xianghe County",
        "P_YS_FED_FW_0001608869": "%c[mdf-cube] [staterule] [rule] runRule(), 解析所有rules条件：",
        "P_YS_FED_FW_0000020960": "Continue?",
        "P_YS_FED_FW_0000020962": "Simpl. Chinese",
        "P_YS_FED_FW_0001608865": "%c调用后端计算接口获取到值 /bill/executeFormulaCalculate：",
        "P_YS_PF_PROCENTER_0000027569": "Preview",
        "P_YS_FED_FW_0000020961": "Saved successfully",
        "P_YS_FED_FW_0001608866": "%c[mdf-cube] [staterule] [rule] setValue(), the parameter target==>, value==> 赋值：",
        "P_YS_FED_FW_0000020964": "Please preset the cParameter Info of the Print button {printTplItemName: cItemName of the print template}",
        "P_YS_FED_FW_0001608867": "%c[mdf-cube] [staterule] [rule] compareJSON(), JSON串左右不匹配：",
        "P_YS_FED_FW_0000020963": "Info returned from importing template contents: xhr.readyState =",
        "P_YS_FED_FW_0001608868": "%c[mdf-cube] [staterule] [rule] setMeta(), the parameter target==>, property=>, value==> 设置属性：",
        "P_YS_PF_PROCENTER_0000027553": "Prompt",
        "P_YS_FED_IMP_IOT0000007728": "Xiangyang District",
        "P_YS_PF_MANAGER-FE_0001087905": "Label Mode",
        "P_YS_FED_IMP_IOT0000007727": "Export",
        "P_YS_PF_QITDFE_0001085652": "Organization Tree",
        "P_YS_FED_FW_0000020977": "Please enter the reason for voiding",
        "P_YS_FED_FW_0000020976": "Please select print template",
        "P_YS_FED_FW_0000020978": "Exception in starting the print plug-in. If you need help, please click OK",
        "P_YS_FED_IMP_IOT0000007723": "Jingzhou Miao and Dong Autonomous County",
        "P_YS_PF_GZTSYS_0000012642": "Supplier Category",
        "P_YS_FED_IMP_IOT0000007725": "Beibei District",
        "P_YS_FED_FW_0000020971": "Failed to import template contents",
        "P_YS_FED_FW_0000020970": "6.0",
        "P_YS_FED_FW_0000020973": "Required",
        "P_YS_FED_FW_0000020972": "Thu",
        "P_YS_FED_FW_0000020975": "Error in obtaining Doc coding rules:",
        "P_YS_FED_FW_0000020974": "Failed to request data",
        "P_YS_SD_SDMAUF_0001023417": "Yongchuan",
        "P_YS_FED_IMP_IOT0000007717": "Linxi County",
        "P_YS_SD_SDMAUF_0001023413": "Tongren area",
        "P_YS_PF_PRINT_0000057278": "User-defined Field 5",
        "P_YS_FED_IMP_IOT0000007716": "Chaoyang County",
        "P_YS_PF_PRINT_0000057281": "User-defined Field 4",
        "P_YS_FED_IMP_IOT0000007714": "Wangmo County",
        "P_YS_FED_FW_0001473890": "UI Template:",
        "P_YS_FED_FW_0001447586": "Total selected ",
        "P_YS_PF_PRINT_0000057288": "User-defined Field 1",
        "P_YS_PF_PRINT_0000057286": "User-defined Field 6",
        "P_YS_PF_PRINT_0000057283": "User-defined Field 7",
        "P_YS_PF_PRINT_0000057293": "User-defined Field 2",
        "P_YS_PF_PRINT_0000057291": "User-defined Field 3",
        "P_YS_FED_IMP_IOT0000007700": "Naxi District",
        "P_YS_FED_IMP_IOT0000007702": "Lianping County",
        "P_YS_FED_IMP_IOT0000007704": "Mianzhu",
        "P_YS_SD_SDMB-FE_0001535210": "Exception in rendering. You can view the exception Info in the console. comInfo =",
        "P_YS_FED_FW_0001235097": "Missing settingNavBar method",
        "P_YS_SD_SDMBF_0000143729": "Advanced Filtering",
        "P_YS_PF_PRINT_0000057259": "Sales Type Summary",
        "P_YS_PF_GZTSYS_0000012680": "Supplier File",
        "end": "Completed",
        "P_YS_HR_HRRCPDF_0001077675": "Selected (",
        "P_YS_PF_GZTSYS_0000012689": "Data Analysis",
        "P_YS_PF_GZTSYS_0000012684": "Payment Method",
        "P_YS_SCM_STOCK_0000034188": "Receipt Qty and SN Qty are inconsistent in the product line. Please check",
        "P_YS_SCM_STOCK_0000034189": "Voucher Amt will exceed the A/R Amt. Continue?",
        "P_YS_FED_FW_0000122939": "No line No. obtained",
        "P_YS_HR_HRJXF_0000059283": "Progress Bar",
        "HR": "HR",
        "P_YS_FED_FW_0001191808": "mdfChangeCustomScanMode method is missing",
        "P_YS_FED_FW_0001191809": "mdfCustomScanQRCode method is missing",
        "P_YS_FED_FW_1482770783956107324": "文本编辑栏目",
        "P_YS_PF_PROCENTER_0000022730": "Female",
        "P_YS_SCM_STOCK_0000034195": "Pre-order",
        "P_YS_SCM_STOCK_0000034197": "Return cannot be performed in the mobile App. Please operate on PC",
        "P_YS_SCM_STOCK_0000034198": "Uncollected Amt",
        "P_YS_FED_FW_0000020919": "1.0",
        "P_YS_FED_FW_0000020918": "√",
        "P_YS_FED_FW_1603072749183959045": "标签一",
        "P_YS_FED_FW_0001191810": "mdfChangeFlashLightStatus method is missing",
        "P_YS_FED_FW_0000020917": "Confirm",
        "P_YS_FED_FW_0001191811": "Result of Successful Scanning",
        "P_YS_FED_FW_1603072749183959042": "标签二",
        "P_YS_SCM_STOCK_0000034166": "Per Cust. Transa.",
        "P_YS_SCM_STOCK_0000034167": "Please enter barcode",
        "000357": "Delete Files",
        "P_YS_PF_GZTTMP_0000077606": "Logistics Info",
        "P_YS_FED_FW_0000097427": "getMeasureValues not found in 1-D table  t2DRowKey =",
        "P_YS_FED_FW_0000097426": "Exception in 2-D table row/column changes. There's no column type t2DColType. data=",
        "P_YS_FED_FW_0000097425": "There're multiple rows of data in the 1-D table conforming to the column/row key value of the current cross-point  t2DRowKey =",
        "P_YS_FED_FW_0000097423": "1-D table editRowModel is not found during initialization, material model is not found in editRowModel, or the material model type is not ReferModel",
        "P_YS_SCM_STOCK_0000034171": "Product added successfully",
        "P_YS_FI_IA_0000054929": "Doc Type",
        "P_YS_FED_FW_0000097420": "table2DRowColChange In 1-D table, current index =",
        "P_YS_FED_FW_0000110980": "Duplicated line exists. Info: code=",
        "P_YS_SCM_STOCK_0000034175": "Contact Mobile No.",
        "P_YS_FED_FW_1536786757976588288": "Sales Contract - Instant Analysis",
        "P_YS_FED_FW_1601623034510704640": "数据校验发生异常,请联系支持人员排查\\n",
        "P_YS_FED_FW_0000097418": "All Info - 2-D table columns =",
        "P_YS_FED_FW_0000097417": "A row with empty row key value exists in 1-D table. All rows in 1-D table =",
        "P_YS_FED_FW_0000097416": "A row with empty row key value exists in 1-D table. Blank row =",
        "P_YS_SCM_STOCK_0000034182": "Batch No.",
        "P_YS_SCM_STOCK_0000034183": "Orig. Sales Price",
        "P_YS_FED_FW_1588021594661322759": "Please select data to export",
        "P_YS_FED_FW_0001200368": "Scanned (",
        "P_YS_PF_PRINT_0000065739": "Material SKU Code",
        "P_YS_FED_FW_0000020944": "Confirm to abort?",
        "P_YS_FED_FW_0000020943": "Failed to import template contents",
        "P_YS_FED_FW_0000020946": "Fri",
        "P_YS_FED_FW_0000020945": " H599pieces, failed",
        "P_YS_FED_FW_0000020948": "You can export at most 2000 pieces each time. Please select again and retry",
        "P_YS_FED_FW_0000020947": "Display Doc Linked Query Result",
        "P_YS_FED_FW_0000020949": "Trad. Chinese",
        "P_YS_FED_FW_0000020940": "Most Categories",
        "P_YS_FED_FW_0000020941": "Totally imported",
        "P_YS_FED_FW_0000020955": "Disable",
        "P_YS_FED_FW_0000020954": "The data returned from the interface is not in application/json format:",
        "P_YS_FED_FW_0000020957": "File",
        "P_YS_FED_FW_0000020956": " ",
        "P_YS_FED_FW_0000020959": "No saving parameter obtained",
        "P_YS_FED_FW_0000020958": "Error in setting Doc coding rules:",
        "P_YS_PES_PES-FE_0001193111": "Clear Selected",
        "P_YS_SD_SDSD-FE_0001491730": "數量",
        "P_YS_FED_FW_0000020951": "Please select print template",
        "P_YS_FED_FW_0000020950": "Confirm to disable the record",
        "P_YS_SD_SDMA_0000061679": "Mall",
        "P_YS_FED_FW_0001212374": "The Doc has been deleted, or you do not have the permission",
        "P_YS_FED_FW_1529944651755683856": "Default Enumeration Value",
        "P_YS_PF_METADATA_0001044255": "Confir. Status",
        "P_YS_FED_FW_1529944651755683853": "At most 5 enumeration items can be selected",
        "P_YS_FED_FW_0000020929": "Error in the background",
        "P_YS_FED_FW_1529944651755683850": "Please select an enumeration date item",
        "P_YS_FED_FW_0000020922": "Approval process initialized successfully",
        "P_YS_FED_FW_0000020921": "The data volume is very large, so the preview may be slow. Do you want to use the print plug-in or perform silent print directly?",
        "P_YS_FED_FW_0000020924": "Please preset the cParameter Info of the Print button {printTplItemName: cItemName of the print template}",
        "P_YS_FED_FW_0000020923": " H582pieces, succeeded",
        "P_YS_FED_FW_0000020926": "3.0",
        "P_YS_FED_FW_0000020925": "Failed to submit merging request",
        "P_YS_PF_PROCENTER_0000022757": "Finance",
        "P_YS_FED_FW_0001656543": "Please select or enter",
        "P_YS_FED_FW_0000020927": "The import operation is carried out in the background. Other operations can be performed",
        "P_YS_FED_FW_0000020920": "Sat",
        "P_YS_FED_FW_1529944651755683847": "Common Enumeration Items",
        "P_YS_FED_FW_0000020933": "Please submit first",
        "P_YS_FED_FW_0000020932": "The address of the export template is empty",
        "P_YS_FED_FW_0000020935": "Failed",
        "P_YS_FED_FW_0000020934": "The category is already the first one in the same level",
        "P_YS_FED_FW_0000020937": "Tue",
        "P_YS_FED_FW_0000020936": "No data selected. Please select data and try again",
        "P_YS_FED_FW_0000020939": "Business object saved successfully",
        "P_YS_FED_FW_0000020938": ", returned Info:",
        "P_YS_FED_FW_0000020930": "Error in saving",
        "P_YS_SCM_STOCK_0000034222": "Return Discount Amt",
        "P_YS_SCM_STOCK_0000034225": "Pay by Scanning Code",
        "P_YS_OA_XTHUIYI_0000046356": "Option 2",
        "P_YS_PF_GZTTMP_0000076264": "Reconciliation",
        "P_YS_OA_XTHUIYI_0000046353": "Option 1",
        "P_YS_OA_XTHUIYI_0000046352": "Option 6",
        "P_YS_OA_XTHUIYI_0000046355": "Option 3",
        "P_YS_HR_HRJXF_0001080015": "Value Type",
        "P_YS_OA_XTHUIYI_0000046351": "Option 4",
        "P_YS_SCM_STOCK_0000034231": "Cannot recognize the product",
        "P_YS_SCM_STOCK_0000034232": "Please select operator",
        "P_YS_SCM_STOCK_0000034234": "Pushing Time",
        "P_YS_SCM_STOCK_0000034235": "No specification selected",
        "P_YS_SCM_STOCK_0000034238": "Total",
        "P_YS_SD_UDHWN_0001010199": "Within %s",
        "P_YS_FED_FW_0001049265": "{value} Star",
        "P_YS_SCM_PU_0000028093": "Approved",
        "P_YS_SCM_STOCK_0000034202": "Light On",
        "P_YS_SCM_STOCK_0000034208": "Change Discount Rate",
        "P_YS_FI_FA_0000033394": "Scheme Name",
        "P_YS_SCM_STOCK_0000034214": "Amt after Discount",
        "P_YS_SCM_STOCK_0000034216": "Effective To",
        "P_YS_FI_CM_0000029922": "ден",
        "P_YS_FED_FW_0001201615": "There's a required item:",
        "P_YS_FED_FW_1587131084714803208": "范围值精度不允许超过15，请修改",
        "P_YS_FED_FW_0001202951": "There's unsaved data in the page, which will be cleared and the page will be opened again after confirming. Continue?",
        "P_YS_SD_SDMAF_0000135935": "Load",
        "P_YS_FED_FW_1498007515453456402": "If there is no criteria you want in the preset scheme, you can customize the filter criteria",
        "P_YS_FED_FW_1498007515453456405": "Select the location of the query criterion",
        "P_YS_SD_SDMAF_0000135940": "Please enter date",
        "P_YS_FED_FW_1618507375587098631": "没有code或name",
        "P_YS_OA_app_xtywlj_0000037814": "Forecast",
        "P_YS_OA_XTHUIYI_0000046348": "Option 5",
        "P_YS_FED_FW_0001256796": "Defaults to all",
        "P_YS_FED_FW_0001382541": "Mobile Scheme (only effective in the mobile App)",
        "P_YS_FED_FW_0001382542": "Web Personal Scheme",
        "P_YS_FED_FW_0001382543": "Mobile Public Scheme",
        "P_YS_FED_FW_0001382544": "Web Scheme",
        "P_YS_FED_FW_0001382540": "Web Public Scheme",
        "P_YS_FED_FW_0001382545": "Mobile Personal Scheme",
        "P_YS_FED_UCFBASEDOC_0000025456": "Issue",
        "P_YS_FED_FW_0000080521": "Group Info missing. Defaults to product product_cCode product_cName",
        "P_YS_FED_FW_0000080522": "Group Info missing. groupFields returned from the interface =",
        "P_YS_FED_FW_0000080520": "Supplier File Template.xlsx",
        "P_YS_FED_FW_0001147663": "Template request failed:",
        "P_YS_FED_FW_0001147664": "Abnormal value returned",
        "P_YS_SD_UDHWN_0001010118": "Seconds",
        "P_YS_FED_IMP_IOT0000006491": "Ruoergai County",
        "P_YS_FED_IMP_IOT0000006493": "Pishan County",
        "P_YS_FED_UCFBASEDOC_0000025448": "Resend",
        "P_YS_FED_IMP_IOT0000006492": "Shanyin County",
        "P_YS_FED_FW_1441618872572051456": "Obsolete",
        "P_YS_FED_FW_1575378258895044792": "Hello, 1. The \"Add\" button does not support the data value of \"Multi-line\" in the table body; 2The Add button is expected to switch to Formula at 2022.12 .30, using advanced designer settings such as Advanced Designer-Field Settings, Advanced Designer-Formula.",
        "P_YS_FED_IMP_IOT0000006487": "Anding District",
        "P_YS_FED_IMP_IOT0000006489": "Shiping County",
        "P_YS_FED_IMP_IOT0000006480": "Cuiping District",
        "P_YS_FED_IMP_IOT0000006482": "Suiping County",
        "P_YS_FED_IMP_IOT0000006483": "Lengshuitan District",
        "P_YS_FED_UCFBASEDOC_0000025433": "Print",
        "P_YS_FED_IMP_IOT0000006486": "Changle",
        "P_YS_FED_IMP_IOT0000006485": "Xintai",
        "P_YS_FED_FW_0001428307": "The Doc will be revoked to the opened status. Confirm to revoke?",
        "P_YS_SD_UDHWN_0000120920": "Switch Language",
        "P_YS_FED_IMP_IOT0000006479": "Fengze District",
        "P_YS_FI_CM_0000026019": "]",
        "P_YS_FI_CM_0000026016": "[",
        "P_YS_FED_IMP_IOT0000006471": "Shiqian County",
        "P_YS_FED_IMP_IOT0000006470": "Yangcheng County",
        "P_YS_FED_IMP_IOT0000006475": "Huaining County",
        "P_YS_SD_UDHWN_0000048940": "Shihezi",
        "P_YS_FI_CM_0000029930": "OK",
        "P_YS_SD_UDHWN_0001010147": "%d Day(s)",
        "P_YS_FED_IMP_IOT0000006468": "Mingshui County",
        "P_YS_FED_FW_1545722866933170185": "为按单",
        "P_YS_FED_IMP_IOT0000006467": "Yongshun County",
        "P_YS_FED_IMP_IOT0000007798": "Nilek County",
        "P_YS_FED_FW_1598599506385436673": "个,请调整后重试",
        "P_YS_FED_FW_1598599506385436676": "已选数据项总数超过最大限制",
        "P_YS_FED_FW_1545722866933170188": "(当前为明细模式，",
        "P_YS_FED_IMP_IOT0000006460": "Songzi",
        "P_YS_FED_IMP_IOT0000007791": "Tonghua County",
        "P_YS_FED_IMP_IOT0000006462": "Cangshan County",
        "P_YS_FED_IMP_IOT0000007793": "Wendeng",
        "P_YS_FED_IMP_IOT0000006464": "Leping",
        "P_YS_OA_XTRICHENG_0000046040": "Entertainment",
        "P_YS_SD_UDHWN_0001010155": "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday",
        "P_YS_HR_HRJQ_0000030978": "You",
        "P_YS_SD_UDHWN_0000120944": "5 pages backward",
        "P_YS_FED_IMP_IOT0000006454": "Nanguan District",
        "P_YS_FED_IMP_IOT0000007785": "Yuhui District",
        "P_YS_FED_IMP_IOT0000006456": "Dingnan County",
        "P_YS_FED_IMP_IOT0000007787": "Dagang District",
        "P_YS_FED_IMP_IOT0000006459": "Shuangqiaoqu",
        "P_YS_SD_SDMAUF_0000151805": "No shipment info yet",
        "P_YS_FED_IMP_IOT0000007784": "Harbour area",
        "P_YS_FED_IMP_IOT0000006452": "Gaobeidian",
        "P_YS_FED_FW_0001296125": "imagesUrl: failed to obtain printed image url",
        "P_YS_FED_FW_0001296124": "Missing getBlueToothState method",
        "P_YS_FED_FW_0001296123": "No nearby Bluetooth printer was scanned",
        "P_YS_FED_IMP_IOT0000007774": "Helinger County",
        "P_YS_OA_app_xtywlj_0000037899": "Hour",
        "P_YS_FED_IMP_IOT0000006446": "Qilin District",
        "P_YS_SD_UDHWN_0001010128": "日en_一en_二en_三en_四en_五en_六en",
        "P_YS_FED_IMP_IOT0000006445": "Luxi County",
        "P_YS_FED_IMP_IOT0000006448": "Wuxi County",
        "P_YS_FED_IMP_IOT0000007779": "Anxi County",
        "P_YS_FI_CM_0000029954": "Switch to Line Chart",
        "P_YS_FED_IMP_IOT0000006442": "Yingcheng",
        "P_YS_FED_FW_0001368219": "Current Login User",
        "P_YS_FED_IMP_IOT0000007772": "Fogang County",
        "P_YS_SD_UDHWN_0001010130": "Morning",
        "P_YS_FED_IMP_IOT0000006433": "Shache County",
        "P_YS_FED_IMP_IOT0000007763": "Tangyuan County",
        "P_YS_FED_IMP_IOT0000006435": "Gonghe County",
        "P_YS_FED_IMP_IOT0000007766": "Baqing County",
        "P_YS_FED_IMP_IOT0000006434": "Jiahe County",
        "P_YS_FED_IMP_IOT0000007765": "Chaoyang District",
        "P_YS_FED_IMP_IOT0000006439": "Xingshan County",
        "P_YS_FED_IMP_IOT0000007760": "Jingbian County",
        "P_YS_FED_IMP_IOT0000006431": "Xingqing District",
        "P_YS_FED_IMP_IOT0000006430": "Liling",
        "P_YS_IDOC_RECORD-BE_0001375534": "Access Level",
        "P_YS_FED_FW_0001504309": "‰",
        "P_YS_FED_IMP_IOT0000006301": "Luqiao District",
        "P_YS_FED_IMP_IOT0000006300": "Taihe District",
        "P_YS_FED_IMP_IOT0000007631": "Zizhou County",
        "P_YS_FED_IMP_IOT0000008965": "Maojian District",
        "P_YS_FED_IMP_IOT0000007634": "Shuangyang District",
        "P_YS_SD_UDHWN_0000120730": "5 pages forward",
        "P_YS_FED_FW_0000157519": "Null Value",
        "P_YS_FED_IMP_IOT0000008968": "Jiamusi",
        "P_YS_FED_IMP_IOT0000006305": "Hongqi District",
        "P_YS_FED_IMP_IOT0000007635": "Longsha District",
        "P_YS_FED_IMP_IOT0000008969": "Haiyan County",
        "P_YS_FED_FW_0001504310": "Wrong Info entered. Please enter again",
        "P_YS_FED_IMP_IOT0000007638": "You County",
        "P_YS_FED_IMP_IOT0000006306": "Ludian County",
        "P_YS_FED_IMP_IOT0000008967": "Jinnan District",
        "P_YS_FED_FW_0000157515": "Select Time",
        "P_YS_FED_FW_0000157516": "Line Selection Event",
        "P_YS_FED_FW_0000157517": "Load by Pulling Up",
        "P_YS_FED_FW_0000157518": "Return Method",
        "P_YS_FED_FW_0000157511": "Selection Box",
        "P_YS_FED_FW_0000157512": "Line Clicking Event",
        "P_YS_FED_FW_0000157513": "Edited",
        "P_YS_FED_IMP_IOT0000007630": "Pingtang County",
        "P_YS_FED_FW_0000157514": "Input InspectionSheet Box",
        "P_YS_FED_FW_0000157510": "Changed Callback",
        "P_YS_PF_GZTSYS_0000012545": "Metadata",
        "P_YS_FED_IMP_IOT0000007620": "Holingol",
        "P_YS_FED_IMP_IOT0000007623": "Zizhong County",
        "P_YS_FED_IMP_IOT0000007622": "Xiong County",
        "P_YS_FED_FW_0000157508": "Close Method",
        "P_YS_FED_FW_0000157509": "Cancel Method",
        "P_YS_FED_IMP_IOT0000008958": "Changting County",
        "P_YS_FED_IMP_IOT0000008955": "Fuyuan County",
        "P_YS_FED_IMP_IOT0000007626": "Mingxi County",
        "P_YS_FED_IMP_IOT0000008956": "Guang'an District",
        "P_YS_FED_FW_0000157504": "Tree Ref",
        "P_YS_FED_FW_0000157505": "Multi-line Input",
        "P_YS_FED_FW_0000157506": "Search Box",
        "P_YS_FED_FW_0000157507": "Load",
        "P_YS_FED_FW_0000157502": "Multi-choice allowed",
        "P_YS_FED_FW_0000157503": "Number Input Box",
        "P_YS_FED_IMP_IOT0000007618": "Daan District",
        "P_YS_FED_IMP_IOT0000007617": "Shuncheng District",
        "P_YS_FED_IMP_IOT0000008948": "Potou District",
        "P_YS_FED_IMP_IOT0000008949": "Wuhua County",
        "P_YS_FED_IMP_IOT0000007610": "Lushunkou District",
        "P_YS_FED_IMP_IOT0000008943": "Hongshan District",
        "P_YS_HR_HRXCF_0000072620": "1.0",
        "P_YS_FED_IMP_IOT0000008941": "Sanyuan County",
        "P_YS_FED_IMP_IOT0000008947": "Yuyang District",
        "P_YS_FED_IMP_IOT0000008944": "Songtao Miao Autonomous County",
        "P_YS_FED_FW_1581848446750425093": "Synchronizing subordinates",
        "P_YS_PF_GZTSYS_0000012516": "Doc No.",
        "P_YS_FED_FW_0000096297": "Confirm to delete the selected attachment?",
        "P_YS_FED_IMP_IOT0000007607": "Yibin County",
        "P_YS_PF_PRINT_0000057345": "Group",
        "P_YS_FED_IMP_IOT0000007606": "Ningwu County",
        "P_YS_SD_SDMAUF_0001023367": "Acheng",
        "P_YS_FED_IMP_IOT0000008938": "Junlian County",
        "P_YS_FED_IMP_IOT0000008931": "Anze County",
        "P_YS_FED_IMP_IOT0000008932": "Quanshan District",
        "P_YS_FED_IMP_IOT0000007601": "Sansui County",
        "P_YS_FED_IMP_IOT0000008930": "Lindian County",
        "P_YS_FED_IMP_IOT0000007602": "Hedong District",
        "P_YS_FED_IMP_IOT0000007605": "Qian'an",
        "P_YS_FED_IMP_IOT0000008933": "Taibai County",
        "P_YS_FED_FW_1607451373850853376": "UI模板ID：",
        "P_YS_FED_IMP_IOT0000008934": "Xinhua District",
        "P_YS_FED_FW_1607451373850853379": "UI模板名称：",
        "P_YS_FED_FW_1440911671847026691": "Unsupported display type",
        "P_YS_PF_GZTSYS_0000012580": "Personal Info",
        "P_YS_FED_IMP_IOT0000008929": "Wuhou District",
        "P_YS_PF_GZTSYS_0000012583": "Customer",
        "P_YS_FED_FW_0001388572": "Print Template:",
        "P_YS_PF_PROCENTER_0000022808": "Shelf-life Unit",
        "P_YS_FED_IMP_IOT0000008920": "Mashan District",
        "P_YS_PF_GZTSYS_0000012577": "Shipping Method",
        "P_YS_FED_IMP_IOT0000008921": "Peng'an County",
        "P_YS_FED_IMP_IOT0000008924": "Yangqu County",
        "P_YS_FED_IMP_IOT0000008922": "Guangrao County",
        "P_YS_FED_FW_0001344100": "Close the reference popup window",
        "P_YS_FED_IMP_IOT0000008917": "Huoqiu County",
        "P_YS_PF_GZTSYS_0000012594": "Task",
        "P_YS_FED_IMP_IOT0000008916": "Xingwen County",
        "P_YS_FED_FW_1440911671847026688": "Data format error. It should be an array",
        "P_YS_PF_GZTSYS_0000012589": "Approval",
        "P_YS_FED_IMP_IOT0000008910": "Ruoqiang County",
        "P_YS_SD_SDDM_0001141756": "Current Day",
        "P_YS_FED_FW_1465534710770827264": "calsControls interface error",
        "P_YS_FED_IMP_IOT0000008913": "Duolun County",
        "P_YS_PF_GZTSYS_0000012587": "SN",
        "P_YS_FED_IMP_IOT0000008911": "Yinzhou District",
        "P_YS_FED_FW_1465534710770827267": "getAssignValue interface error",
        "P_YS_FED_IMP_IOT0000008912": "Yushu County",
        "P_YS_PF_GZTSYS_0000012586": "Training",
        "P_YS_FED_FW_0001026604": "No more than <%=text%>",
        "P_YS_FED_IMP_IOT0000008906": "Jishui County",
        "P_YS_PF_GZTSYS_0000012561": "Warehouse",
        "P_YS_FED_IMP_IOT0000008904": "Le'an County",
        "P_YS_FED_IMP_IOT0000008908": "Haiyan County",
        "P_YS_FI_CM_0000026041": "Unapproved",
        "P_YS_PF_GZTSYS_0000012557": "Department",
        "P_YS_FED_IMP_IOT0000008902": "Xin'an County",
        "P_YS_FED_IMP_IOT0000008901": "Songbei District",
        "P_YS_FED_FW_1593218831501230088": "以下字段有误(或存在必填项):",
        "P_YS_PF_ANALYTIC-FE_0001650866": "Last 10 Days",
        "P_YS_PF_GZTSYS_0000012567": "Customer Property",
        "P_YS_PF_GZTSYS_0000012563": "User-defined Fields",
        "P_YS_PF_GZTSYS_0000012565": "Product Line",
        "P_YS_OA_XTLCZX_0000030093": "Submitted On",
        "P_YS_SD_SDMA_0000060271": "QR Code",
        "P_YS_FED_FW_0000162048": "Duplicate line Info",
        "P_YS_FED_FW_0000162047": "setTable2DEditRowModel 2-D table editRowModel changed to 2-D table",
        "P_YS_FED_FW_0000162046": "setTable2DEditRowModel 2-D table editRowModel changed to 1-D table",
        "P_YS_PF_GZTTMP_0000075105": "End with",
        "P_YS_HR_HRRCPDF_0000071164": "Standards",
        "P_YS_SCM_STOCK_0000034286": "Done",
        "P_YS_SCM_STOCK_0000034289": "Please select specification property",
        "P_YS_FED_FW_0001479880": "The change failed to take effect",
        "P_YS_YYGJFW_YBUC_0001336088": "More",
        "P_YS_SD_SDMA_0000060254": "Order No.",
        "P_YS_SCM_STOCK_0000034290": "Order No.",
        "P_YS_SCM_STOCK_0000034292": "Select delivery method",
        "P_YS_SCM_STOCK_0000034293": "Please enter warehouse first",
        "000241": "Execute Query",
        "P_YS_SCM_STOCK_0000034295": "Available Qty",
        "P_YS_SCM_STOCK_0000034297": "Enter by Scanning Code",
        "P_YS_SCM_STOCK_0000034298": "Switch to Scan Code",
        "P_YS_SD_SDMBF_0000142308": "Option 2",
        "P_YS_SD_SDMBF_0000142307": "Option 3",
        "P_YS_FED_FW_0001543963": "End Point",
        "P_YS_SD_SDMBF_0000142309": "Option 1",
        "P_YS_FED_FW_0001543962": "Walk",
        "P_YS_FED_FW_1483362578909888518": "Manual search of the query criteria is not allowed in the navigation area",
        "P_YS_SCM_STOCK_0000034265": "Sales Amt:",
        "P_YS_SCM_STOCK_0000034269": "Message",
        "P_YS_SD_SDSD-FE_0001357089": "Loading data...",
        "P_YS_FED_FW_0001543959": "Start Point",
        "P_YS_FED_FW_1441228949671116830": "Collapse Group",
        "P_YS_FED_FW_0001543961": "Circular",
        "P_YS_FED_FW_0001543960": "Drive",
        "P_YS_SD_SDSD-FE_0001491840": "單據日期",
        "P_YS_SCM_STOCK_0000034275": "Online retailer orders do not support multiple payment methods",
        "P_YS_PF_BD-UI_0000157869": "Regular Purchase",
        "P_YS_SCM_STOCK_0000034276": "Select return reason",
        "P_YS_SCM_STOCK_0000034278": "Print a New Receipt",
        "P_YS_FED_FW_1441228949671116824": "Query Area Adj.",
        "P_YS_SD_SDMAUF_0001023389": "Simao",
        "P_YS_FED_FW_1441228949671116827": "lineTab Switching",
        "P_YS_SD_SDMAUF_0001023380": "Bijie area",
        "P_YS_FED_FW_1441228949671116821": "Switch Header Details",
        "P_YS_FED_FW_0001656634": "Failed to delete the draft",
        "P_YS_PF_PROCENTER_0000022885": "Shelf-life",
        "P_YS_SCM_STOCK_0000034280": "Continue Billing",
        "P_YS_SCM_STOCK_0000034281": "Enter",
        "P_YS_SD_SDMA_0000061552": "Cash on Delivery",
        "P_YS_SCM_STOCK_0000034282": "A/R Amt in current Doc",
        "P_YS_SCM_UPU-UI_0001368234": "Last 3 Months",
        "P_YS_SCM_STOCK_0000034284": "Product to Return",
        "P_YS_SCM_STOCK_0000034285": "Confirm?",
        "P_YS_SCM_STOCK_0000034243": "Please enter your password",
        "P_YS_SCM_STOCK_0000034244": "Collection succeeded",
        "P_YS_SCM_STOCK_0000034247": "Max change Amt exceeded. Cannot settle",
        "P_YS_FED_FW_1441228949671116815": "Obsolete",
        "P_YS_FED_FW_1441228949671116818": "Set Query Scheme as Default",
        "P_YS_FED_FW_1441228949671116812": "Query Scheme Auto Search Settings",
        "P_YS_SD_SDMB_0000140551": "User-defined Field 2",
        "P_YS_HR_HRRCPDF_0000071178": "Scheme name is required",
        "P_YS_SD_SDMB_0000140553": "User-defined Field 1",
        "P_YS_SCM_STOCK_0000034250": "Version No.",
        "P_YS_SCM_STOCK_0000034254": "Refund Amt",
        "P_YS_SCM_STOCK_0000034257": "Received Amt",
        "P_YS_SCM_STOCK_0000034259": "Voucher already exists. Please check",
        "P_YS_FED_FW_1441228949671116803": "Obsolete",
        "P_YS_FED_FW_1441228949671116806": "Obsolete",
        "P_YS_FED_FW_1441228949671116809": "Maximize",
        "P_YS_FED_FW_1441228949671116800": "More - Query Area",
        "P_YS_HR_HRRCPDF_0000071186": "Yonyou Network Tech Co., Ltd.",
        "P_YS_FED_FW_1615403591714471941": "Please enter keyword search in search box",
        "P_YS_SCM_STOCK_0000034263": "Promotion Activities",
        "P_YS_SCM_STOCK_0000034341": "Unit Price",
        "P_YS_SCM_STOCK_0000034343": "Sent to",
        "P_YS_FED_FW_0001523503": "Intelligent search in progress...",
        "P_YS_PF_PRINT_0000065776": "Material SKU Name",
        "P_YS_SCM_STOCK_0000034351": "Pre-order Details",
        "P_YS_PF_SOCD-E_0000490245": "Kangding City",
        "P_YS_SCM_STOCK_0000034354": "Product does not exist",
        "P_YS_SCM_STOCK_0000034357": "View and Edit Personal Info",
        "P_YS_SCM_STOCK_0000034358": "In the table, ID",
        "P_YS_OA_XTMENHUCMS_0000045057": "Being Executed",
        "P_YS_FED_FW_0000113165": "Enter at least one line of data",
        "P_YS_FED_FW_0000113164": "No approval details",
        "P_YS_FED_FW_0001455872": "The Doc has not been approved. Cannot print",
        "P_YS_SCM_STOCK_0000034362": "Member/Mobile No.",
        "P_YS_FED_FW_0001455873": "<%=abandonText%> pieces of data failed to get approved and cannot be printed",
        "P_YS_SCM_STOCK_0000034320": "No available SKU data in the current product line",
        "P_YS_SCM_STOCK_0000034321": "Delivery Method",
        "P_YS_SCM_STOCK_0000034328": "No more",
        "P_YS_SD_UDHWN_0001010044": "%d Hour",
        "P_YS_FED_FW_0001301010": "Calculating time",
        "P_YS_FED_FW_1555177996907708424": "Subtable row <%=rowno%>",
        "P_YS_SCM_STOCK_0000034335": "Product Total",
        "P_YS_PF_GZTORG_0000035173": "Modified By",
        "P_YS_OA_XTMENHUCMS_0000045039": "Completion",
        "P_YS_SCM_STOCK_0000034302": "A/R Amt",
        "P_YS_SCM_STOCK_0000034305": "Exceeds receipt range",
        "P_YS_SCM_STOCK_0000034307": "Receipt Qty is required",
        "P_YS_SCM_STOCK_0000034309": "Total Coll. Amt",
        "P_YS_FED_FW_0001625448": "The data in the current page has not changed",
        "P_YS_SCM_STOCK_0000034310": "Specification:",
        "P_YS_SCM_STOCK_0000034311": "Select product to return",
        "P_YS_SCM_STOCK_0000034312": "No product",
        "P_YS_SCM_STOCK_0000034318": "Refund succeeded",
        "P_YS_SCM_STOCK_0000034319": "Max Change Amt not set",
        "P_YS_FED_FW_0001061059": "command cParameters JSON format error-->",
        "P_YS_FED_FW_0001061051": "Kyrgyzstan",
        "P_YS_FED_FW_0001061052": "Saint Vincent",
        "P_YS_FED_FW_0001061053": "Montserrat",
        "P_YS_FED_FW_0001061054": "French Polynesia",
        "P_YS_FED_FW_0001061055": "Bermuda Islands",
        "P_YS_FED_FW_0001061056": "Saint Vincent Islands",
        "P_YS_FED_FW_0001061057": "Andorra",
        "P_YS_FED_FW_0001061058": "No model",
        "P_YS_FED_FW_0001455874": "Allow to print <%=abandonText%> pieces of data",
        "P_YS_OA_YBMOB_0000177961": "Please enter the min value",
        "P_YS_OA_YBMOB_0000177960": "Please enter the max value",
        "P_YS_SD_UDHWN_0001010080": "Sun_ Mon_ Tue_ Wed_ Thu_ Fri_ Sat",
        "P_YS_FED_MDF-COMPS_0001064728": "[Hint] If the content in the enterprise language is not provided, then system will populate the content in the current language",
        "P_YS_SD_UDHWN_0001010095": "[Tomorrow] LT",
        "P_YS_FED_IMP_IOT0000006391": "Dexing",
        "P_YS_FED_IMP_IOT0000006396": "Julu County",
        "P_YS_FED_IMP_IOT0000006395": "Shangjie",
        "P_YS_FED_IMP_IOT0000006398": "Minqin County",
        "P_YS_FED_FW_0001126032": "!!!Unprocessed Keyboard Event, e ==>",
        "P_YS_FED_FW_1575376867322494991": "Simplified Designer -",
        "P_YS_FED_IMP_IOT0000006388": "Yongfeng County",
        "P_YS_FED_FW_1546407879852949523": "Header information area",
        "P_YS_FED_FW_1546407879852949526": "Moving Layout Example",
        "P_YS_FED_IMP_IOT0000006381": "Penglai",
        "P_YS_FED_IMP_IOT0000006383": "Xingshan District",
        "P_YS_FED_IMP_IOT0000006385": "Huangyuan County",
        "P_YS_FED_FW_1546407879852949520": "* Number of data display columns",
        "P_YS_FED_IMP_IOT0000006379": "Tianjun County",
        "P_YS_FI_CM_0000026118": "Not exist",
        "P_YS_FED_IMP_IOT0000006370": "Hejing County",
        "P_YS_FED_FW_0001383748": "Round",
        "P_YS_MF_MR-FE_0001156422": "Only one piece of data can be selected",
        "P_YS_FED_IMP_IOT0000006374": "Jin'an District",
        "P_YS_FED_IMP_IOT0000006376": "Tailai County",
        "P_YS_FED_IMP_IOT0000006375": "Karamay",
        "P_YS_FED_UCFBASEDOC_0000025564": "Office Supplies",
        "P_YS_FED_FW_0001255540": "System default template. Cannot modify",
        "P_YS_FED_FW_0001255541": "The template has been published. Cannot modify",
        "P_YS_FED_FW_1546407879852949508": "请设置头部信息区！",
        "P_DIWORK_YC_YC-UI_0000058082": "Please enter supplier name",
        "P_YS_FED_FW_0001255537": "Template Ver. No.",
        "P_YS_FED_IMP_IOT0000006366": "Quanzhou County",
        "P_YS_FED_FW_0001255538": "Please enter the template version number",
        "P_YS_FED_IMP_IOT0000006368": "Lianghe County",
        "P_YS_PF_GZTSYS_0000012596": "Leave",
        "P_YS_FED_IMP_IOT0000007692": "Qishuyan District",
        "P_YS_FED_IMP_IOT0000006363": "Nanhui District",
        "P_YS_FED_IMP_IOT0000006362": "Huaian County",
        "P_YS_FED_IMP_IOT0000007693": "Hulin",
        "P_YS_PF_METADATA_0000086517": "Inv. Direction",
        "P_YS_FED_FW_0001255539": "The selected template has not been published",
        "P_YS_SD_SDMAUF_0000151992": "Passwords do not match",
        "P_YS_FED_IMP_IOT0000006356": "Shanxian",
        "P_YS_FED_IMP_IOT0000007687": "Anxi County",
        "P_YS_FED_FW_0001255548": "Cannot modify when the field is required",
        "P_YS_IPAAS_SSB-BE_1431199659860689346": "Collection",
        "P_YS_FED_IMP_IOT0000006355": "Ouhai District",
        "P_YS_FED_FW_0001255549": "Please select a line before operating",
        "P_YS_FED_FW_1546407879852949511": "Main Information Area",
        "P_YS_FED_FW_1575376867322494982": "Initialization is the need to determine if there are other expansions if there is a clear first",
        "P_YS_FED_IMP_IOT0000006358": "Yangxian",
        "P_YS_FED_IMP_IOT0000007689": "Changzi County",
        "P_YS_FED_FW_0001255546": "Please enter the template name",
        "P_YS_FED_FW_1556630812555214849": "Rule conditions:",
        "P_YS_FED_FW_1575376867322494985": "Hello, please go to the high-level designer to use feature-related extensions and designs.",
        "P_YS_FED_FW_0001255547": "Enumerated Field",
        "P_YS_FED_FW_0001255544": "Required",
        "P_YS_FED_FW_1546407879852949514": "Please set the main information area!",
        "P_YS_FED_IMP_IOT0000006359": "Hanting District",
        "P_YS_FED_FW_0001255545": "Please enter the template number",
        "P_YS_FED_FW_0001255542": "Set as Required",
        "P_YS_FED_FW_0001255543": "Incl. in Template",
        "P_YS_FED_FW_1546407879852949517": "Data display area",
        "P_YS_FED_FW_1575376867322494988": "Important data for rendering tables. No need to render modal without it",
        "P_YS_SCM_STOCK_0001113984": "By Material",
        "P_YS_FED_IMP_IOT0000007681": "Wushan County",
        "P_YS_FED_IMP_IOT0000007680": "Luxi",
        "P_YS_FED_IMP_IOT0000006352": "Cuona County",
        "P_YS_FED_IMP_IOT0000006351": "Zouping County",
        "P_YS_FED_IMP_IOT0000007682": "Pinglu District",
        "P_YS_FED_UCFBASEDOC_0000025543": "On-site Discount Permission",
        "P_YS_FED_IMP_IOT0000006354": "Furalki District",
        "P_YS_FED_IMP_IOT0000007685": "Huanxian",
        "P_YS_SCM_STOCK_0001113981": "By Order",
        "P_YS_FED_IMP_IOT0000007684": "Wujiang",
        "P_YS_SD_UDHWN_0001010021": "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sept_Oct_Nov_Dec",
        "P_YS_FED_IMP_IOT0000007675": "Raoping County",
        "P_YS_FED_IMP_IOT0000006346": "Luancheng County",
        "P_YS_SCM_PU_0000028165": "Processing",
        "P_YS_FED_UCFBASEDOC_0000025533": "Submitted successfully",
        "P_YS_FED_IMP_IOT0000006343": "Lushan County",
        "P_YS_FED_IMP_IOT0000007674": "Hunyuan County",
        "P_YS_FED_IMP_IOT0000006342": "Bachu County",
        "P_YS_FED_IMP_IOT0000007673": "Luquan Yi and Miao Autonomous County",
        "P_YS_SD_UDHWN_0001010033": "1 months",
        "P_YS_FED_IMP_IOT0000006333": "Caidian District",
        "P_YS_FED_IMP_IOT0000007664": "Yongkang",
        "P_YS_FED_IMP_IOT0000008998": "Jiajiang County",
        "P_YS_FED_IMP_IOT0000007667": "Tongcheng",
        "P_YS_FED_IMP_IOT0000007666": "Suning County",
        "P_YS_FED_IMP_IOT0000006339": "Xingtang County",
        "P_YS_FED_IMP_IOT0000008990": "Jianye District",
        "P_YS_FED_IMP_IOT0000006330": "Xulan County",
        "P_YS_FED_IMP_IOT0000007660": "Huaxi District",
        "P_YS_FED_IMP_IOT0000008991": "Xiangning County",
        "P_YS_FED_IMP_IOT0000006331": "Bungalow area",
        "P_YS_FED_IMP_IOT0000007662": "Xigong District",
        "P_YS_FED_IMP_IOT0000008992": "Kaiping District",
        "P_YS_SD_UDHWN_0000047752": "Chaohu",
        "P_YS_SD_UDHWN_0001010005": "1",
        "P_YS_FED_IMP_IOT0000007654": "Raoyang County",
        "P_YS_FED_IMP_IOT0000007656": "Delingha",
        "P_YS_FED_IMP_IOT0000008984": "Donggang District",
        "P_YS_FED_IMP_IOT0000007655": "Xiangxiang",
        "P_YS_FED_IMP_IOT0000006327": "Lincheng County",
        "P_YS_FED_IMP_IOT0000007650": "Changqing District",
        "P_YS_FED_IMP_IOT0000008982": "Xuanhua County",
        "P_YS_FED_IMP_IOT0000006321": "Congjiang County",
        "P_YS_FED_IMP_IOT0000007652": "Jiangyang District",
        "P_YS_FED_IMP_IOT0000008981": "Zhengyang County",
        "P_YS_FED_FW_0001097037": "[config]=>",
        "P_YS_FED_FW_0001097036": "Request user/getOrgsAndStores Interface success: [json.code]=>",
        "P_YS_FED_FW_0001097039": "[json.data]=>",
        "P_YS_FED_FW_0001097038": "Request user/getOrgsAndStores Interface: [url]=>",
        "P_YS_PF_PRINT_0000057301": "User-defined Field 8",
        "P_YS_FED_IMP_IOT0000006319": "Chengbu Miao Autonomous County",
        "P_YS_HR_HRXCF_1457191573584347175": "Common Scheme",
        "P_YS_FED_IMP_IOT0000006312": "Lianhua County",
        "P_YS_FED_IMP_IOT0000007643": "Jingxing mining area",
        "P_YS_FED_IMP_IOT0000006311": "Tian'e County",
        "P_YS_FED_IMP_IOT0000008976": "Shangli County",
        "P_YS_FED_IMP_IOT0000007645": "Luobei County",
        "P_YS_FED_IMP_IOT0000006313": "Ying County",
        "P_YS_FED_IMP_IOT0000007644": "Chengcheng County",
        "P_YS_FED_IMP_IOT0000006316": "Yingjisha County",
        "P_YS_FED_FW_1602706809380405256": "级以上的属性穿透",
        "P_YS_FED_IMP_IOT0000007649": "Yingshan County",
        "P_YS_OA_app_xtywlj_0000037784": "Notification",
        "P_YS_FED_FW_1602706809380405259": "Feature object",
        "P_YS_FED_IMP_IOT0000008971": "Jixi County",
        "P_YS_FED_IMP_IOT0000008972": "Tianquan County",
        "P_YS_FED_IMP_IOT0000007640": "Linyi County",
        "P_YS_FED_FW_1575377786445496320": "Simplified Designer Editing",
        "P_YS_SD_UDHWN_0000048340": "Baishali Autonomous County",
        "P_YS_FED_IMP_IOT_0001087104": "duplicated and/or omitted — the behavior is unsupported and",
        "P_YS_FED_EXAMP_0000020753": "You've not entered product \"",
        "P_YS_FED_IMP_IOT0000008843": "Lieshan District",
        "P_YS_FED_EXAMP_0000020752": "New Password",
        "P_YS_FED_IMP_IOT0000007510": "Pucheng County",
        "P_YS_FED_EXAMP_0000020755": "Fri",
        "P_YS_FED_IMP_IOT0000007513": "Tongdao Dong Autonomous County",
        "P_YS_FED_IMP_IOT0000008841": "Zitong County",
        "P_YS_FED_EXAMP_0000020754": "Online printing failed",
        "P_YS_FED_IMP_IOT0000008847": "Dazhu County",
        "P_YS_FED_IMP_IOT0000008848": "Liuyang",
        "P_YS_FED_EXAMP_0000020751": "Offline Doc",
        "P_YS_FED_IMP_IOT0000007517": "Yunlong District",
        "P_YS_FED_EXAMP_0000020750": "?",
        "P_YS_FED_EXAMP_0000020757": "Reason",
        "P_YS_FED_EXAMP_0000020756": "Failed to obtain login user: [interface]",
        "P_YS_FED_EXAMP_0000020759": "Receipt Notice",
        "P_YS_FED_EXAMP_0000020758": "Cannot modify the Qty in the product line",
        "P_YS_FED_UCFBASEDOC_0000025299": "Data Pending Daily Settlement",
        "P_YS_FED_IMP_IOT0000007508": "Xinghe County",
        "P_YS_FED_IMP_IOT0000007507": "Jiyang County",
        "P_YS_FED_FW_0001078398": "Please configure the report server address first",
        "P_YS_FED_IMP_IOT0000007509": "Zhangqiu",
        "P_YS_SD_UDHWN_0000047023": "Wuzhishan",
        "P_YS_FED_FW_0001241569": "The following <%=name%> detail field is required",
        "P_YS_FED_FW_0000021605": "Data",
        "P_YS_FED_EXAMP_0000020764": "All the product in the package not entered completely. Cannot change lines",
        "P_YS_FED_IMP_IOT0000008832": "Qushui County",
        "P_YS_FED_FW_0000021606": "Inner Mongolia",
        "P_YS_FED_EXAMP_0000020763": "retail Docs' invoicing statuses",
        "P_YS_FED_FW_0000021603": "Bijie",
        "P_YS_FED_EXAMP_0000020766": "Wholesale price:",
        "P_YS_FED_IMP_IOT0000008830": "Fucheng District",
        "P_YS_FED_FW_0000021604": "Hegang",
        "P_YS_FED_EXAMP_0000020765": "Room rate product start time is required",
        "P_YS_FED_IMP_IOT0000008831": "Jiangshan",
        "P_YS_FED_FW_0000021609": "Shangqiu",
        "P_YS_FED_EXAMP_0000020760": "Tue",
        "P_YS_FED_IMP_IOT0000008836": "Luolong County",
        "P_YS_FED_FW_0000021607": "Up 4 Down 1",
        "P_YS_FED_EXAMP_0000020762": "Enterprise",
        "P_YS_FED_FW_0000021608": "Nantong",
        "P_YS_FED_EXAMP_0000020761": "Inventory",
        "P_YS_FED_IMP_IOT0000007505": "Futian district",
        "P_YS_FED_FW_0001241570": "The grandson table field of the following <%=name%> detail is required",
        "P_YS_FED_IMP_IOT_0000761504": "Fit to Screen",
        "P_YS_FED_FW_0001241571": "In line <%=text%>, grandson table <%=name%> of sub-table",
        "P_YS_FED_FW_0000021601": "Error Details",
        "P_YS_FED_EXAMP_0000020768": "The returned Qty cannot be less than the replaced Qty of the current product",
        "P_YS_FED_FW_0000021602": "Wuhu",
        "P_YS_FED_EXAMP_0000020767": "Huilongguan Store",
        "P_YS_FED_FW_0000021600": "Guyuan",
        "P_YS_FED_EXAMP_0000020769": "For whole Doc return, please use the canceling order function",
        "P_YS_SD_UDHWN_0000050688": "Yanqing County",
        "P_YS_FED_IMP_IOT0000008829": "Xiangzhou District",
        "P_YS_FED_EXAMP_0000020780": "Amt after adjustment cannot be less than 0",
        "P_YS_FED_UIMG_0000101674": "Cannot modify the system field as Optional",
        "P_YS_FED_EXAMP_0000020775": "Voucher",
        "P_YS_FED_IMP_IOT0000008821": "Gulin County",
        "P_YS_FED_EXAMP_0000020774": "Deposit proportion is less than",
        "P_YS_FED_IMP_IOT0000008822": "Yizhou",
        "P_YS_IMP_IBD-FE_0001110516": "Exported Data.xlsx",
        "P_YS_FED_EXAMP_0000020777": "No product entered. Cannot match",
        "P_YS_FED_EXAMP_0000020776": "Open Album",
        "P_YS_FED_IMP_IOT0000008820": "Wangqing County",
        "P_YS_FED_EXAMP_0000020771": "Card/voucher No. and card/voucher range cannot be selected at the same time for card/voucher product",
        "P_YS_PF_GZTTMP_0000073892": "Order Type",
        "P_YS_FED_EXAMP_0000020770": "This operation is not supported for online retailer orders",
        "P_YS_FED_IMP_IOT0000008826": "Xingguo County",
        "P_YS_FED_EXAMP_0000020773": "Occupation",
        "P_YS_FED_IMP_IOT0000008823": "Gongyi City",
        "P_YS_FED_EXAMP_0000020772": "[Announcement] Description of the promotion activity on October 1st",
        "P_YS_FED_IMP_IOT0000008824": "Hongya County",
        "P_YS_FED_EXAMP_0000020779": "No associated Doc",
        "P_YS_FED_EXAMP_0000020778": "Payment via prepaid card or member wallet is not available under the top-up business type",
        "P_YS_FED_UCFBASEDOC_0000025276": "Daily Settlement Inv",
        "P_YS_FED_FW_0001587626": "Collaboration suite is required",
        "P_YS_FED_IMP_IOT0000008818": "Binxian",
        "P_YS_FED_EXAMP_0000020791": "Cannot return cards for the current business type",
        "P_YS_FED_EXAMP_0000020790": "You've not entered product [",
        "P_YS_FED_IMP_IOT0000008817": "Yuhua District",
        "P_YS_FED_IMP_IOT_0001087115": "?",
        "P_YS_FED_EXAMP_0000020786": "The points of returned product is greater than or equal to that of newly purchased product. No need to perform point deduction again",
        "P_YS_FED_EXAMP_0000020785": "Totally updated",
        "P_YS_FED_EXAMP_0000020788": "Promotion activity, on-site discount, point deduction or voucher has been executed. Cannot settle when the network is disconnected",
        "P_YS_FED_EXAMP_0000020787": "Please enter card/voucher No.",
        "P_YS_FED_EXAMP_0000020782": "] is a material type product",
        "P_YS_FED_IMP_IOT0000008815": "Dayao County",
        "P_YS_FED_EXAMP_0000020784": "Cannot add product lines in the current Doc status",
        "P_YS_FED_EXAMP_0000020783": "Entered",
        "P_YS_FED_EXAMP_0000020789": "), it cannot be less than the floor of current operator's discount rate (",
        "P_YS_FED_FW_0001047201": "34",
        "P_YS_FED_FW_0001047200": "40",
        "P_YS_FI_CM_0000026146": "Available",
        "P_YS_FED_IMP_IOT0000008805": "Longkou",
        "P_YS_SD_SDMB_0000139037": "Last Three Months",
        "P_YS_PF_GZTSYS_0000012457": "Draft Box",
        "P_YS_FED_FW_0000021638": "No billNo in the initialization conditions",
        "P_YS_FED_FW_0001269095": "New Ind. Formula",
        "P_YS_FED_FW_0000021636": "Duplicated row exists. Info is as follows",
        "P_YS_FED_EXAMP_0000020711": "Card/Voucher - Non-original Order Return",
        "P_YS_FED_FW_0001269093": "Do not display when all indicators are 0",
        "P_YS_FED_FW_0000021637": "Required item exists. Please fill in",
        "P_YS_FED_EXAMP_0000020710": "View QR Code",
        "P_YS_FED_FW_0001269094": "Edit Ind. Formula",
        "P_YS_FED_IMP_IOT0000008804": "Luocheng Mulao Autonomous County",
        "P_YS_PF_GZTSYS_0000012455": "Shipment Carrier",
        "P_YS_FED_IMP_IOT0000008801": "Renhuai",
        "P_YS_FED_FW_0000021630": "Right Y Axis",
        "P_YS_FED_EXAMP_0000020717": "Product line exists. Cannot execute free product",
        "P_YS_FED_FW_0000021631": "Example: YYYY-MM-DD HH:mm:ss",
        "P_YS_FED_EXAMP_0000020716": "Product Template",
        "P_YS_FED_EXAMP_0000020719": "Cannot find code",
        "P_YS_FED_EXAMP_0000020718": "Xi'erqi Store",
        "P_YS_FED_FW_1550827916596609026": "Hello, if the column width/field is hidden in the upper right corner of the user list, then there is \"user level setting,\" does your latest template level setting overwrite it?",
        "P_YS_FED_FW_0000021634": "Approval Process",
        "P_YS_FED_FW_0000111693": "【",
        "P_YS_FED_EXAMP_0000020713": "Mobile No.",
        "P_YS_FED_FW_0000021635": "Image",
        "P_YS_FED_FW_0000111692": "Enter the max number?",
        "P_YS_FED_EXAMP_0000020712": "Card/voucher can only be used as the collection method for cash sale",
        "P_YS_FED_FW_0000021632": "Please select area",
        "P_YS_FED_EXAMP_0000020715": "Reason for Approval Failure",
        "P_YS_FED_FW_0000021633": "Subscription Period",
        "P_YS_FED_EXAMP_0000020714": "Zero",
        "P_YS_FED_FW_0001047212": "29",
        "P_YS_FED_FW_0001047211": "25",
        "P_YS_FED_FW_0001047210": "47",
        "P_YS_FED_UCFBASEDOC_0000025251": "Please enter mobile number",
        "P_YS_PF_PROCENTER_0000027371": "Print Design",
        "P_YS_FED_IMP_IOT_0001087134": "1 Point",
        "P_YS_FED_FW_0000021649": "Failed to obtain the correct UEType",
        "P_YS_FED_EXAMP_0000020720": "Product sold cannot be returned. Please perform original order return after delivery",
        "P_YS_FED_FW_0000021647": "Filter Ind.",
        "P_YS_FED_EXAMP_0000020722": "Cannot retrieve SN product price in the current network status",
        "P_YS_FED_FW_0000021648": "Enable sensitive data access control",
        "P_YS_FED_EXAMP_0000020721": "Cannot use vouchers",
        "P_YS_SD_UDHWS_0000117752": "Order No.:",
        "P_YS_PF_GZTSYS_0000012466": "Product Query",
        "P_YS_FED_FW_0000021641": "Automatically set favorite functions according to their usage frequency",
        "P_YS_FED_FW_0001047209": "41",
        "P_YS_FED_EXAMP_0000020728": "Please enter and try again",
        "P_YS_FED_FW_0000021642": "Obtain whether: error in calling service   params=",
        "P_YS_FED_FW_0001047208": "27",
        "P_YS_FED_EXAMP_0000020727": "No product line under SN control",
        "P_YS_FED_FW_0001047207": "21",
        "P_YS_FED_FW_0000021640": "Year/Month/Day",
        "P_YS_FED_FW_0001047206": "23",
        "P_YS_FED_EXAMP_0000020729": "Starting card/voucher No. cannot be greater than ending card/voucher No.",
        "P_YS_FED_FW_0000021645": "Right",
        "P_YS_FED_FW_0001047205": "45",
        "P_YS_FED_EXAMP_0000020724": " !",
        "P_YS_FED_FW_0000021646": "Default Graph Example",
        "P_YS_FED_FW_0001047204": "42",
        "P_YS_FED_EXAMP_0000020723": "The product can be matched. Please match it first",
        "P_YS_FED_FW_0000021643": "Severe",
        "P_YS_FED_FW_0001047203": "43",
        "P_YS_FED_EXAMP_0000020726": "Failed to select vouchers. Info:",
        "P_YS_FED_FW_0000021644": "Set successfully",
        "P_YS_FED_FW_0001047202": "49",
        "P_YS_FED_EXAMP_0000020725": "Service internal error: (error Info)",
        "P_YS_HR_HRJQ_0000031679": "Invalid characters",
        "P_YS_PF_PRINT_0000057492": "Dept",
        "P_YS_FED_FW_0000021616": "Please set condition",
        "P_YS_FED_EXAMP_0000020731": "Center Distribution",
        "P_YS_FED_FW_0000021617": "Qty Precision",
        "P_YS_FED_EXAMP_0000020730": "Cannot modify the salesperson in the product line",
        "P_YS_FED_FW_0000021614": "Company",
        "P_YS_FED_EXAMP_0000020733": "Store Info",
        "P_YS_FED_FW_0000021615": "Draft",
        "P_YS_FED_EXAMP_0000020732": "Please set a valid card",
        "P_YS_FED_FW_0001078375": "eChartCommon.LogChartInfo('Large screen solution  Design eChartPanelDesigngetPreView End', '', 900);",
        "P_YS_FED_FW_0000021618": "Formula Editor",
        "P_YS_FED_FW_0000021619": "Split",
        "P_YS_FED_EXAMP_0000020739": "Member Info participates in settlement",
        "P_YS_FED_EXAMP_0000020738": "Cannot match during adjustment",
        "P_YS_HR_HRJXF_0000059422": "Progress",
        "P_YS_FED_FW_0000021612": "Failed to load",
        "P_YS_FED_EXAMP_0000020735": "Online Retailer Return Status",
        "P_YS_FED_FW_0000021613": "Please enter an integer between 1-999",
        "P_YS_FED_EXAMP_0000020734": ", ",
        "P_YS_FED_FW_0000021610": "Zhangzhou",
        "P_YS_PF_PROCENTER_0000027368": "Print",
        "P_YS_FED_EXAMP_0000020737": "The voucher collection method was used in the current Doc. Cannot delete line",
        "P_YS_FED_EXAMP_0000020736": "Hide",
        "P_YS_FED_FW_0000021611": "Delete Matl",
        "P_YS_FED_FW_0001162218": "View Error Details",
        "P_YS_FI_CM_0000026177": "Done",
        "P_YS_FED_FW_0000021627": "Triggered once every  week(s)",
        "P_YS_FED_EXAMP_0000020742": "Please check the record to operate first",
        "P_YS_FED_FW_0000021628": "Board Config. Info - Module Config. - Graph Example",
        "P_YS_FED_EXAMP_0000020741": "Weekly",
        "P_YS_FED_FW_0000021625": "Large screen slideshow: obtain all the boards with system permission. json.data.kanbans",
        "P_YS_FED_EXAMP_0000020744": "All the promotion activities will be cleared. Continue?",
        "P_YS_FED_FW_0000021626": "Large screen slideshow: eChartCarousel Render isInDesign =",
        "P_YS_FED_EXAMP_0000020743": "] does not exist",
        "P_YS_FED_FW_0000021629": "Query parameter =",
        "P_YS_FED_EXAMP_0000020740": "Required item \"",
        "P_YS_FED_EXAMP_0000020749": "Confirm to switch Org? This operation will refresh the page",
        "P_YS_FED_FW_0000021620": "Confirm to delete?",
        "P_YS_FED_FW_0000021623": "Large screen solution  Save params",
        "P_YS_FED_EXAMP_0000020746": "Retail Doc",
        "P_YS_FED_FW_0000021624": "Operation failed.",
        "P_YS_FED_EXAMP_0000020745": "Error in referencing preset data",
        "P_YS_FED_FW_0000021621": "Ranking Rows",
        "P_YS_FED_EXAMP_0000020748": "Cannot add product lines during top-up",
        "P_YS_FED_FW_0000021622": "Split Proportion",
        "P_YS_FED_EXAMP_0000020747": "Please enter mobile address",
        "P_YS_HR_HRJXF_0000059438": "Alignment",
        "P_YS_SD_SDMAUF_0000152156": "Please select address",
        "P_YS_FED_FW_0001396022": "更新数据sql为：",
        "P_YS_FED_FW_0001396021": "不支持executeDBOperate缓存！！！",
        "P_YS_FED_FW_0001396020": "建表sql为：",
        "P_YS_FED_FW_0001396025": "删除数据sql为：",
        "P_YS_FED_FW_0001396024": "删表sql为：",
        "P_YS_FED_FW_0001396023": "查询数据sql为：",
        "P_YS_FED_EXAMP_0000020709": "Gender",
        "P_YS_FED_FW_0000112925": "Call the interface for obtaining profile - After collating",
        "P_YS_FED_EXAMP_0000020700": "Point deduction cannot be executed during adjustment",
        "P_YS_FED_EXAMP_0000020706": "Failed to obtain business parameter: [interface]",
        "P_YS_FED_EXAMP_0000020705": "A product line with the batch No. already exists",
        "P_YS_FED_EXAMP_0000020708": "Obtain",
        "P_YS_FED_EXAMP_0000020707": "Please enter the member card No. or mobile No.",
        "P_YS_FED_EXAMP_0000020702": "Product has been entered. Cannot modify card/voucher business type",
        "P_YS_FED_EXAMP_0000020701": "No result returned",
        "P_YS_FED_EXAMP_0000020704": "No product line selected. Cannot return product",
        "P_YS_FED_EXAMP_0000020703": "Specification",
        "P_YS_FED_FW_0001456239": "条数据未审核通过，不允许打印",
        "P_YS_PF_GZTTMP_0000077446": "Next",
        "P_YS_PF_PC-UI_0000159832": "Personnel Ref",
        "P_YS_FED_FW_0001588923": "No. of entries filtered out on the current page:",
        "P_YS_SD_SDMAF_0000136999": "Inquiry",
        "OA_web_login_000000016": "Enter Mobile account",
        "P_YS_FED_FW_0001272625": "Please select the phase approver",
        "P_DIWORK_YC_MALL-BASEDOC_0000061927": "Entity",
        "P_YS_FED_UCFORG_0000066179": "Level 4",
        "P_YS_FED_FW_0001072283": " is being performed in the background. You can perform other operations",
        "P_YS_FED_UCFORG_0000066176": "PNG",
        "P_YS_FED_FW_0001120450": "Tree Node 6",
        "P_YS_FED_UCFORG_0000066181": "Level 2",
        "P_YS_FED_FW_0001120448": "Tree Node 5",
        "P_YS_FED_FW_0001120449": "Tree Node 4",
        "P_YS_FED_FW_0000115212": "Cannot parse by calling abstract class method",
        "P_YS_FED_UCFORG_0000066189": "Display Content",
        "P_YS_FED_UCFORG_0000066191": "Level 1",
        "P_YS_PF_PROCENTER_0000022566": "Disable",
        "P_YS_FED_UCFORG_0000066193": "Level 5",
        "P_YS_FED_UCFORG_0000066194": "Level 3",
        "P_YS_FED_UCFORG_0000066190": "Download Chart",
        "P_YS_PF_GZTLOG_0000025980": "List",
        "P_YS_FED_UCFORG_0000066197": "Expand All",
        "P_YS_PF_GZTLOG_0000025988": "Unlock",
        "P_YS_PF_GZTTMP_0000078669": "Physical Inv Amt",
        "P_YS_FI_CM_0000028824": "Switch to Column Chart",
        "P_YS_HR_HRYGF_0001023444": "Island of Anguilla",
        "P_YS_FED_FW_1488377941070446601": "Obsolete",
        "P_YS_PF_SOCD-G_0000827848": "22",
        "P_YS_PF_GZTLOG_0000025976": "Lock",
        "P_YS_PF_GZTLOG_0000025975": "Customize",
        "P_YS_FI_CM_0000028839": "Select Time",
        "P_YS_OA_XTLCZX_0000030575": "Year-Month-Day",
        "P_YS_PF_GZTLOG_0000025967": "Off-shelves",
        "P_YS_IMP_QAM-BE_0001122431": "-∞",
        "P_YS_FED_FW_0000115265": "Required item exists. Please fill in completely",
        "country886": "Taiwan, China",
        "P_YS_FED_IMP_IOT0000006296": "Luquan",
        "P_YS_PF_GZTSYS_0000109837": "Org Dept",
        "P_YS_FED_IMP_IOT0000006299": "Zhangjiakou",
        "P_YS_PF_PROCENTER_0000022591": "Verification failed",
        "P_YS_OA_XTLCZX_0000030592": "Associate",
        "P_YS_FED_FW_0001097561": "Switched to offline mode due to poor network condition. When the network is back to normal, click the network icon at the top of the page to switch to online mode",
        "P_YS_OA_XTLCZX_0000030590": "Telephone",
        "P_YS_FED_FW_0001486020": "[Hint] If the content in the benchmark language (<%=enterprise%>) is not provided, then system will populate the content in the current language (<%=current%>)",
        "country855": "Cambodia",
        "P_YS_FED_IMP_IOT0000006282": "Guangling District",
        "P_YS_FED_FW_0001264181": "以下",
        "P_YS_FED_IMP_IOT0000006286": "Tunliu County",
        "P_YS_FED_IMP_IOT0000006285": "Huayin City",
        "P_YS_FED_FW_0001084248": "Failed to delete attachment",
        "P_YS_FED_FW_1513779442797772807": "Loading the approval process js",
        "P_YS_FED_FW_1513779442797772804": "No approval process created for the Doc in Opened status",
        "P_YS_FED_FW_0000153522": "Required item is empty",
        "P_YS_FED_FW_0000021560": "Yiyang",
        "P_YS_FED_FW_0000021561": "Bengbu",
        "P_YS_FED_IMP_IOT0000006268": "Jiali County",
        "P_YS_FED_FW_0000021559": "Laiwu",
        "P_YS_PF_GZTSYS_0000012499": "Org",
        "P_YS_FED_FW_0000021553": "Jiaxing",
        "P_YS_FED_IMP_IOT0000006260": "Yantian District",
        "P_YS_FED_IMP_IOT0000007591": "Ninghai County",
        "P_YS_FED_FW_0000021554": "Tongchuan",
        "P_YS_FED_IMP_IOT0000007590": "Qianxian",
        "P_YS_FED_FW_0000021551": "Chaoyang",
        "P_YS_FED_IMP_IOT0000006262": "Guangfeng County",
        "P_YS_FED_IMP_IOT0000007593": "Helan County",
        "P_YS_FED_FW_0000021552": "Wuwei",
        "P_YS_FED_FW_0000021557": "Panjin",
        "P_YS_FED_UCFBASEDOC_0000025215": "Log In",
        "P_YS_FED_FW_0000021558": "Hong Kong S.A.R",
        "P_YS_FED_IMP_IOT0000006263": "Lingwu",
        "P_YS_FED_IMP_IOT0000007594": "Fenyi County",
        "P_YS_FED_FW_0000021555": "Report grouping schemes cannot be displayed in mobile Apps. Please check",
        "P_YS_FED_IMP_IOT0000007597": "Zhaoling District",
        "P_YS_FED_FW_0000021556": "Single Row",
        "P_YS_FED_IMP_IOT0000006265": "Macun District",
        "P_YS_FED_IMP_IOT0000007596": "Jingjiang",
        "P_YS_FED_FW_0001300469": "View More",
        "P_YS_FED_FW_0001300466": "Doc No.",
        "P_YS_FED_FW_0001300467": "Doc Date",
        "P_YS_FED_FW_0000021571": "Guigang",
        "P_YS_FED_FW_0000021572": "Nanchong",
        "P_YS_FED_FW_0000021570": "Naqu Prefecture",
        "P_YS_OA_XTLCZX_0000030541": "Table",
        "P_YS_FED_IMP_IOT0000007588": "Xinchengzi District",
        "P_YS_FED_IMP_IOT0000007587": "Pingli County",
        "P_YS_PF_UCFMDF_0000162014": "On-boarding",
        "P_YS_FI_CM_0000028899": "Log Out",
        "P_YS_FED_FW_0000021564": "Huai'an",
        "P_YS_FED_IMP_IOT0000007580": "Xietongmen County",
        "P_YS_FED_FW_0001300471": "By Order",
        "P_YS_FED_FW_0000021565": "Zhongshan",
        "P_YS_FED_FW_0001300472": "Previous",
        "P_YS_FED_FW_0000021562": "Select All",
        "P_YS_FED_FW_0000021563": "Rizhao",
        "P_YS_FED_IMP_IOT0000007581": "Gaizhou",
        "P_YS_FED_FW_0001300470": "By Material",
        "P_YS_FED_FW_0000021568": "Kunming",
        "P_YS_FED_IMP_IOT0000007584": "Shaowu",
        "P_YS_FED_FW_0000021569": "Xuancheng",
        "P_YS_FED_UCFBASEDOC_0000025203": "Get Verification Code",
        "P_YS_FED_IMP_IOT0000007583": "Neixiang County",
        "P_YS_HR_HRJQF_0000054016": "Service Age",
        "P_YS_FED_FW_0000021566": "Middle 3",
        "P_YS_FED_IMP_IOT0000006255": "Fujin",
        "P_YS_FED_IMP_IOT0000007586": "Chongren County",
        "P_YS_FED_FW_0001300473": "Next",
        "P_YS_FED_FW_0000021567": "Panzhihua",
        "P_YS_FED_UCFBASEDOC_0000025201": "String",
        "P_YS_FED_UCFBASEDOC_0000025200": "Mobile",
        "P_YS_PF_GZTVPA_0001137669": "Vertical",
        "P_YS_OA_XTLCZX_0000030555": "Tile",
        "P_YS_OA_XTLCZX_0000030553": "Process",
        "P_YS_FED_FW_0000021539": "Column/Line Chart Config. Info - yySetting",
        "P_YS_FED_IMP_IOT0000006246": "Tingri County",
        "P_YS_FED_IMP_IOT0000007576": "Boxing County",
        "P_YS_FED_FW_0000021537": "Tibetan Autonomous Prefecture of Hainan",
        "P_YS_FED_IMP_IOT0000006248": "Shanyang District",
        "P_YS_FED_FW_0000021538": "Huludao",
        "P_YS_FED_IMP_IOT0000007578": "Huizhou District",
        "P_YS_FED_IMP_IOT0000006249": "Lanshan County",
        "P_YS_FED_FW_0000021531": "Linzhi Prefecture",
        "P_YS_FED_FW_0000021532": "Shaoxing",
        "P_YS_FED_IMP_IOT0000007571": "Yuanmou County",
        "P_YS_FED_FW_0000021530": "Qiandongnan Miao and Dong Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000007570": "Wuding County",
        "P_YS_FED_FW_0000021535": "Datong",
        "P_YS_FED_FW_0000021536": "Wuhai",
        "P_YS_FED_FW_0000021533": "Qiqihar",
        "P_YS_FED_FW_0000021534": "Customized Large Screen Board",
        "P_YS_FED_IMP_IOT0000007574": "Malong County",
        "P_YS_SD_UDHWN_0000049625": "Qionghai",
        "P_YS_OA_XTLCZX_0000030560": "Jan.",
        "P_YS_FED_FW_0000021550": "Southwest Guizhou Autonomous Prefecture",
        "P_YS_FED_FW_1481951579073937412": "Currently set for template level",
        "P_YS_FED_FW_1481951579073937415": "Currently set for user level.",
        "P_YS_FED_FW_0001427697": "条记录：",
        "P_YS_FED_FW_0001223614": "Printed Content",
        "P_YS_FED_FW_1481951579073937418": "The default is the template level setting, and the modified field is the user level setting.",
        "P_YS_FED_FW_0001223613": "Please turn on Bluetooth",
        "P_YS_FED_FW_0001427696": "Please confirm whether to proceed",
        "P_YS_FED_IMP_IOT0000007566": "Green Park",
        "P_YS_PF_GZTSYS_0000012489": "Announcement",
        "P_YS_FED_IMP_IOT0000006234": "Xilin County",
        "P_YS_FED_IMP_IOT0000007565": "Kuancheng District",
        "P_YS_FED_FW_0000021548": "Xishuangbanna Dai Autonomous Prefecture",
        "P_YS_FED_FW_0000021549": "Shaoyang",
        "P_YS_FED_IMP_IOT0000006236": "Heshuo County",
        "P_YS_FED_IMP_IOT0000008897": "Dongchangfu District",
        "P_YS_FED_FW_0000021542": "Mobile Board A",
        "P_YS_FED_IMP_IOT0000008890": "Guangning County",
        "P_YS_FED_FW_0000021543": "Error in preset formatted field",
        "P_YS_FED_IMP_IOT0000008891": "Pingyi County",
        "P_YS_FED_FW_0000021540": "Graph Report  Because the x axis coordinate Info is tilted, the height needs to be increased",
        "P_YS_FED_IMP_IOT0000007560": "Chengxi District",
        "P_YS_FED_FW_0000021541": "Mobile Board B",
        "P_YS_FED_FW_0000021546": "Error reason:",
        "P_YS_FED_IMP_IOT0000006231": "Licang District",
        "P_YS_FED_FW_0000021547": "Haikou",
        "P_YS_FED_IMP_IOT0000007561": "Kaixian",
        "P_YS_FED_FW_0000021544": "Hubei",
        "P_YS_FED_IMP_IOT0000006233": "Qinyuan County",
        "P_YS_FED_FW_0000021545": "Shiyan",
        "P_YS_FED_FW_1481951579073937421": "The UI can refresh user-level settings and turn them into template-level settings.",
        "P_YS_FED_FW_1481951579073937424": "You can also use \"Restore Defaults\" to return to the template level settings.",
        "P_YS_FED_EXAMP_0000020681": "Top-up is currently in progress. Cannot add return top-up lines",
        "P_YS_FED_EXAMP_0000020680": "Please select the specific Doc",
        "P_YS_FED_EXAMP_0000020676": "Free product contain physical card/voucher product. Card/voucher No. is required",
        "P_YS_FED_IMP_IOT0000007555": "Youjiang District",
        "P_YS_FED_EXAMP_0000020675": "]'s product",
        "P_YS_FED_IMP_IOT0000007554": "Hailin",
        "P_YS_FED_EXAMP_0000020678": "Only one non-member/customer Doc can be selected for settlement",
        "P_YS_FED_IMP_IOT0000006226": "Chenghua District",
        "P_YS_FED_IMP_IOT0000007557": "Hongdong County",
        "P_YS_FED_IMP_IOT0000008885": "Guye District",
        "P_YS_FED_EXAMP_0000020677": "Pickup upon Arrival",
        "P_YS_FED_IMP_IOT0000007556": "Haian County",
        "P_YS_FED_IMP_IOT0000008886": "Hongta District",
        "P_YS_FED_EXAMP_0000020672": "Sales Amt (Yuan)",
        "P_YS_FED_IMP_IOT0000007559": "Chongwen District",
        "P_YS_FED_EXAMP_0000020671": "Reg. Source",
        "P_YS_FED_IMP_IOT0000007558": "Yunlong County",
        "P_YS_FED_EXAMP_0000020674": "Uncollected Amt can only be decreased",
        "P_YS_FED_IMP_IOT0000008889": "Wuhua District",
        "P_YS_FED_EXAMP_0000020673": "When the Amt in a product line changes and card/voucher is used for settlement, the executed promotion should be canceled and executed again",
        "P_YS_FED_FW_0000021597": "Maoming",
        "P_YS_PF_METADATA_0000088630": "Government Affairs",
        "P_YS_FED_FW_0000021598": "Zhoushan",
        "P_YS_FED_IMP_IOT0000008880": "Lanshan District",
        "P_YS_FED_FW_0000021595": "Board Config. Info - Large Screen",
        "P_YS_FED_FW_0000021596": "Shangrao",
        "P_YS_HR_HRYGF_0001023467": "The Central African Republic",
        "P_YS_FED_EXAMP_0000020679": "Online Retailer",
        "P_YS_FED_FW_1523248273733189640": "Switch to List",
        "P_YS_FED_FW_0000021599": "Mobile Report  MobileReport Render",
        "P_YS_FED_IMP_IOT0000007553": "Binchuan County",
        "P_YS_FED_FW_1523248273733189643": "Switch to Card",
        "P_YS_PF_PROCENTER_0000027411": "Warehouse File",
        "P_YS_OA_XTLCZX_0000030500": "Gateway",
        "P_YS_PF_SOCD_0000065988": "Haiti",
        "P_YS_FED_EXAMP_0000020692": "Current operator doesn't have the after-sales permission",
        "P_YS_FED_EXAMP_0000020691": "Order Canceled Status",
        "P_YS_FED_EXAMP_0000020687": "On-shelf Qty in Mall:",
        "P_YS_FED_IMP_IOT0000006213": "Beilun District",
        "P_YS_FED_EXAMP_0000020686": "Product [",
        "P_YS_FED_IMP_IOT0000007543": "Hongqiao District",
        "P_YS_FED_IMP_IOT0000008877": "Maguan County",
        "P_YS_FED_FW_1499700110520483841": "The name is required and the length should be less than 50 chars",
        "P_YS_FED_EXAMP_0000020689": "Login account No. is required",
        "P_YS_FED_IMP_IOT0000007546": "Changge",
        "P_YS_FED_IMP_IOT0000008874": "Yuncheng District",
        "P_YS_FED_EXAMP_0000020688": "Failed to delete",
        "P_YS_FED_EXAMP_0000020683": "Data returned:",
        "P_YS_FED_EXAMP_0000020682": "No line selected",
        "P_YS_FED_EXAMP_0000020685": "Cannot change Qty",
        "P_YS_FED_IMP_IOT0000006219": "Haizhu District",
        "P_YS_FED_EXAMP_0000020684": "Failed to refund",
        "P_YS_FED_IMP_IOT0000008879": "Nangang District",
        "P_YS_FED_FW_0001228492": "Please select the data to be recovered:",
        "P_YS_FED_IMP_IOT0000008872": "Taiqian County",
        "P_YS_SD_SDOC_0001150619": "Failed to deliver",
        "P_YS_FED_IMP_IOT0000008873": "Huzhu Autonomous County",
        "P_YS_FED_IMP_IOT0000006211": "Zhengning County",
        "P_YS_FED_IMP_IOT0000008870": "Jiaoling County",
        "P_YS_FED_FW_0001228491": "Data Recovery Confir.",
        "P_YS_FED_IMP_IOT0000006210": "Hong'an County",
        "P_YS_FED_IMP_IOT0000008871": "Wuming County",
        "P_YS_FED_FW_0001228490": "Please select the valid recovery data",
        "P_YS_FED_FW_0000021582": "Linyi",
        "P_YS_FED_FW_0000021583": "Shizuishan",
        "P_YS_FED_FW_0000021580": "Liaoyuan",
        "P_YS_FED_FW_0000021581": "Shanghai",
        "P_YS_FED_IMP_IOT0000006209": "Beilin District",
        "P_YS_SD_UDHWN_0001010363": "[Up] ddddLT",
        "P_YS_FED_EXAMP_0000020698": "Network is unavailable now. Cannot use this function",
        "P_YS_FED_IMP_IOT0000006202": "Shiquan County",
        "P_YS_FED_IMP_IOT0000008865": "Fushun County",
        "P_YS_FED_EXAMP_0000020697": "Last 90 Days",
        "P_YS_PF_GZTTMP_0000073851": "Region",
        "P_YS_FED_IMP_IOT0000006204": "Jing County",
        "P_YS_FED_IMP_IOT0000007535": "Jinjiang District",
        "P_YS_FED_EXAMP_0000020699": "Cannot execute promotion activity",
        "P_YS_FED_IMP_IOT0000008864": "Guiyang County",
        "P_YS_FED_EXAMP_0000020694": "Failed to obtain the member wallet enabling parameter",
        "P_YS_FED_IMP_IOT0000007537": "Xiao County",
        "P_YS_FED_IMP_IOT0000008869": "Wei County",
        "P_YS_FED_EXAMP_0000020693": "Success returned from the POS terminal, but no value is returned",
        "P_YS_FED_IMP_IOT0000006205": "Minhou County",
        "P_YS_FED_EXAMP_0000020696": "Demand Pending Submission",
        "P_YS_FED_IMP_IOT0000006208": "Hanjiang District",
        "P_YS_FED_IMP_IOT0000008867": "Gongjing District",
        "P_YS_FED_EXAMP_0000020695": "Available Bal",
        "P_YS_FED_FW_0000021575": "Shandong",
        "P_YS_FED_FW_0000021576": "Shantou",
        "P_YS_FED_FW_0000021573": "The total size of all the attachments cannot exceed",
        "P_YS_FED_FW_0000021574": "Yongzhou",
        "P_YS_FED_FW_0000021579": "Board Config. Info - Mobile",
        "P_YS_FED_IMP_IOT0000008862": "Jinchang District",
        "P_YS_FED_FW_0000021577": "Yibin",
        "P_YS_FED_FW_0000021578": "Qingyuan",
        "P_YS_FED_FW_0000021590": "Chuzhou",
        "P_YS_FED_FW_0000021593": "Chongming County",
        "P_YS_FED_FW_0000021594": "Incorrect get parameter format",
        "P_YS_OA_XTLCZX_0000030521": "Year-Month",
        "P_YS_FED_FW_0000021591": "County Administrative Divisions Directly under the Jurisdiction of Autonomous Region",
        "P_YS_FED_FW_0000021592": "Songyuan",
        "P_YS_PF_PRINT_0000057423": "Goods Receipt/Issue Summary",
        "P_YS_FED_IMP_IOT0000007529": "Jinzhai County",
        "P_YS_FED_IMP_IOT0000007521": "Xinfu District",
        "P_YS_PF_METADATA_0000088629": "Finance",
        "P_YS_FED_IMP_IOT0000008853": "Jize County",
        "P_YS_FED_IMP_IOT0000007525": "Jinwan District",
        "P_YS_FED_IMP_IOT0000008859": "Lixin County",
        "P_YS_FED_IMP_IOT0000007528": "Bohu County",
        "P_YS_FED_IMP_IOT0000008856": "Anda",
        "P_YS_FED_IMP_IOT0000007527": "Zhuanghe",
        "P_YS_FED_IMP_IOT0000008857": "Yuqing County",
        "P_YS_FED_FW_0000021586": "Zhongwei",
        "P_YS_FED_FW_0000021587": "Hunan",
        "P_YS_FED_FW_0000021584": "Quanzhou",
        "P_YS_FED_FW_0000021585": "Yushu Tibetan Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000008850": "Lintan County",
        "P_YS_FED_FW_0000021588": "Guangzhou",
        "P_YS_FED_IMP_IOT0000007520": "Leting County",
        "P_YS_FED_FW_0000021589": "Total Amt",
        "P_YS_FED_IMP_IOT_0000724684": "Error in uploading file",
        "P_YS_FED_IMP_IOT_0000724683": "test",
        "P_YS_FED_FW_0001253660": "==========> preProcessCommonViewMeta()...查找commonToolbarb并且已经删除",
        "P_YS_PF_PRINT_0000057596": "Copies",
        "P_YS_FED_FW_0000021715": "Cache Type",
        "P_YS_FED_EXAMP_0000020632": "Replenishment Qty = sales volume - in-transit Qty in the specified time period",
        "P_YS_FED_FW_0001253655": "==========> preProcessCommonViewMeta()...发生不可预期的错误，直接返回！根据[",
        "P_YS_FED_FW_0000021716": "Large screen solution  Design  getDesignColType_Sum curCol",
        "P_YS_FED_EXAMP_0000020631": "No print template set. Please check",
        "P_YS_FED_FW_0001253654": "==========> preProcessCommonViewMeta()...ERROR，异常信息为",
        "P_YS_FED_FW_0000021713": "] does not exist in the source table column. Please check",
        "P_YS_FED_EXAMP_0000020634": "All the product in the package not entered completely. Cannot change retail price",
        "P_YS_FED_FW_0001253657": "===> [mdf-cube] [preprocessViewMeta()] 开始预处理viewmeta",
        "P_YS_FED_FW_0000021714": "ü",
        "P_YS_FED_EXAMP_0000020633": "Sun",
        "P_YS_FED_FW_0001253656": "==========> preProcessCommonViewMeta方法未能合并CommonToobar!",
        "P_YS_FED_FW_0000021719": "Region",
        "P_YS_FED_IMP_IOT0000008726": "Laifeng County",
        "P_YS_FED_FW_0001253651": "initVM()时UI元数据meta协议错误!",
        "P_YS_FED_IMP_IOT0000008727": "Zhenping County",
        "P_YS_FED_FW_0001253650": "请覆盖effectivedate(生效日期)，expirationdate(失效日期)，creationtime(创建日期)字段，方便MDF统一处理",
        "P_YS_PF_GZTSYS_0000013621": "Batch No.",
        "P_YS_FED_FW_0000021717": "The Longitude field is required",
        "P_YS_FED_EXAMP_0000020630": "Sales Time",
        "P_YS_FED_IMP_IOT0000008724": "Shuifu County",
        "P_YS_FED_FW_0001253653": "===> [mdf-cube] [preprocessViewMeta()] [findCommonToolbar()]viewmeta.view.containers中找到commonToolbarb且已删除",
        "P_YS_FED_FW_0000021718": "User-defined Criteria",
        "P_YS_FED_FW_0001253652": "==========> preProcessCommonViewMeta()...[兼容]在#1中查找到targetToolbar#2:",
        "P_YS_FED_EXAMP_0000020639": "Cancel",
        "P_YS_FED_FW_0000021711": "Failed to open the database. The caching function is unavailable",
        "P_YS_FED_EXAMP_0000020636": "Payment with prepaid card is not allowed",
        "P_YS_FED_FW_0001253659": "===> [mdf-cube] preprocessViewMeta()...return, because commonToolbar不存在或不是一个Array",
        "P_YS_FED_FW_0000021712": "ö",
        "P_YS_FED_EXAMP_0000020635": "Off-shelf Qty in Mall:",
        "P_YS_FED_FW_0001253658": "===> [mdf-cube] preprocessViewMeta()...viewmeta?.cBillType 未知，无法处理",
        "P_YS_FED_EXAMP_0000020638": "No",
        "P_YS_FED_FW_0000021710": "Monitoring View  Set auto refresh rate timer  renderTime",
        "P_YS_FED_EXAMP_0000020637": "[Announcement] Description of store furnishing",
        "P_YS_FED_FW_0001253671": "===> [mdf-cube] preprocessViewMeta()...return, 未找到能处理的Header组件[",
        "P_YS_FED_FW_0001253670": "===> [mdf-cube] preprocessViewMeta方法未能合并CommonToobar!",
        "P_YS_FED_FW_0000021726": "eChartDisplay Scatter chart/map Info is incorrect errInfo =",
        "P_YS_FED_EXAMP_0000020643": "Please fill in return reason",
        "P_YS_FED_FW_0001253666": "==========> preProcessCommonViewMeta()...return, 未找到能处理的Header组件[",
        "P_YS_FED_FW_0000021727": "Title Name",
        "P_YS_FED_EXAMP_0000020642": "Store Sales Trend",
        "P_YS_FED_FW_0001253665": "===> [mdf-cube] preprocessViewMeta()...ERROR，异常信息为",
        "P_YS_FED_FW_0000021724": "No qualified line record",
        "P_YS_FED_EXAMP_0000020645": "https://cdn.yonyoucloud.com/iprint/Yonyou Cloud Print Assistant.exe",
        "P_YS_FED_FW_0001253668": "==========> preProcessCommonViewMeta()...viewmeta?.cBillType 未知，无法处理",
        "P_YS_FED_FW_0000021725": "Chart",
        "P_YS_FED_EXAMP_0000020644": "[Announcement]",
        "P_YS_FED_FW_0001253667": "不支持Header组件类型【",
        "P_YS_FED_FW_0001253662": "】, 无法处理CommonToolbar",
        "P_YS_FED_FW_0001253661": "]能找到targetHeader，但未找到targetHeaderParent, targetHeader为:",
        "P_YS_FED_FW_0000021728": "Picture size cannot exceed 10MB",
        "P_YS_FED_EXAMP_0000020641": "Room rate product Qty is below 1 hour. Charge for 1 hour?",
        "P_YS_FED_FW_0001253664": "==========> preProcessCommonViewMeta()...return, because commonToolbar不存在或不是一个Array",
        "P_YS_FED_FW_0000021729": "Day",
        "P_YS_FED_EXAMP_0000020640": "Cannot delete odds",
        "P_YS_FED_FW_0001253663": "===> [mdf-cube] preprocessViewMeta()...[兼容]在#1中查找到targetToolbar#2:",
        "P_YS_HR_HRJXF_0000059335": "Create Task",
        "P_YS_FED_FW_0000021722": "For chart columns, please enter an integer between 1-3",
        "P_YS_FED_EXAMP_0000020647": "(Current Store)",
        "P_YS_FED_FW_0000021723": "Enabled",
        "P_YS_FED_EXAMP_0000020646": "No available account",
        "P_YS_FED_FW_0001253669": "===> [mdf-cube] preprocessViewMeta()...发生不可预期的错误，直接返回！根据[",
        "P_YS_FED_FW_0000021720": "Reselecting template will overwrite the current template Info. Continue?",
        "P_YS_FED_EXAMP_0000020649": "Mon",
        "P_YS_PF_PROCENTER_0000027456": "Manual Input",
        "P_YS_FED_FW_0000021721": "]?",
        "P_YS_FED_EXAMP_0000020648": "SN",
        "P_YS_FED_IMP_IOT_0000724660": "test",
        "P_YS_FED_IMP_IOT_0000724664": "First",
        "P_YS_HR_HRJQ_0000031751": " time(s)",
        "P_YS_FED_IMP_IOT0000008709": "Hejin",
        "P_YS_FED_IMP_IOT0000008707": "Fanchang County",
        "P_YS_FED_IMP_IOT_0001010702": "yyyy-M-D HH:mm",
        "P_YS_FED_EXAMP_0000020654": "Bundle Sale",
        "P_YS_FED_FW_0001253633": ", 不返回meta，client端可以使用viewApplication的缓存",
        "P_YS_FED_EXAMP_0000020653": "Recommended By",
        "P_YS_FED_EXAMP_0000020656": "No product line selected. Cannot add SN. Please check",
        "P_YS_FED_EXAMP_0000020655": "Cannot select the current voucher",
        "P_YS_FED_EXAMP_0000020650": "China,",
        "P_YS_FED_EXAMP_0000020652": "No log",
        "P_YS_FED_IMP_IOT0000008702": "Copy",
        "P_YS_FED_EXAMP_0000020651": "Unqualified. Please select again",
        "P_YS_FED_IMP_IOT0000008703": "Ningdu County",
        "P_YS_HR_HRJQF_0000054083": "Time Range",
        "P_YS_FED_IMP_IOT_0000724668": "test",
        "P_YS_OA_XTRIZHI_0000036759": "Checkbox",
        "P_YS_FED_IMP_IOT_0000724667": "Minimize",
        "P_YS_PF_GZTSYS_0000013609": "Other Goods Receipt",
        "P_YS_OA_XTLCZX_0000030706": " ",
        "P_YS_FED_EXAMP_0000020658": "Retail billing verification failed: [interface]",
        "P_YS_FED_FW_0001253637": "初始化FilterViewModel_Extend开始",
        "P_YS_FED_EXAMP_0000020657": "Failed to obtain POS No.:",
        "P_YS_FED_FW_0001253636": "voucher editRow方法异常",
        "P_YS_FED_FW_0001253639": "Group:meta客户端缓存",
        "P_YS_FED_EXAMP_0000020659": "SN Qty is not equal to product Qty",
        "P_YS_FED_FW_0001253638": "开始执行",
        "P_YS_FED_UCFBASEDOC_0000025398": "Menu",
        "P_YS_PF_PROCENTER_0000027432": "Tony",
        "P_YS_FED_IMP_IOT_0000724653": "test",
        "P_YS_FED_FW_0001302904": "Requested Interface Addr.",
        "P_YS_HR_HRJQ_0000031765": "John",
        "P_YS_FED_EXAMP_0000020670": "Sales Ranking",
        "P_YS_FED_FW_0001302905": "Data Returned from Interface",
        "P_YS_FED_IMP_IOT_0001010712": "yyyy-M-D Ah:mm",
        "P_YS_FED_FW_0000021704": "Support up to 3 levels of dimension navigation",
        "P_YS_FED_EXAMP_0000020665": "When it's not allowed to modify product upon delivery,",
        "P_YS_FED_FW_0001253644": "]时遇到无法处理的不规范数据，暂时兼容处理，请联系相关开发及时修改。cell的值应该为JSON Object, cell ==>",
        "P_YS_FED_FW_0000021705": "Add Summary",
        "P_YS_FED_EXAMP_0000020664": "Addr. File",
        "P_YS_FED_FW_0001253643": "行的_status,",
        "P_YS_FED_FW_0000021702": "4. Example: an example of filtering expression of different types of fields is as follows:",
        "P_YS_FED_FW_0001253646": "]尝试获取UI模板!",
        "P_YS_FED_FW_0000021703": "Disabled",
        "P_YS_FED_EXAMP_0000020666": "Wed",
        "P_YS_FED_FW_0001253645": "调用communicateBillSetting()时，未指定envConfig.DOMAIN_CODE, 并且也未指定params.cParameter.domain参数，暂使用domainKey[",
        "P_YS_FED_FW_0000021708": "Display indicators are required (you can select up to 10 indicators)",
        "P_YS_FED_EXAMP_0000020661": "Cannot add product to online retailer orders",
        "P_YS_FED_FW_0001253640": "初始化FilterViewModel_Extend结束",
        "P_YS_FED_EXAMP_0000020660": "Me",
        "P_YS_FED_EXAMP_0000020663": "Card/Voucher No.",
        "P_YS_FED_FW_0001253642": "]时遇到无法处理的不规范数据，兼容处理时异常，cell ==>",
        "P_YS_FED_FW_0000021707": "ä",
        "P_YS_FED_EXAMP_0000020662": "Copied successfully",
        "P_YS_FED_FW_0001253641": "]---不存在",
        "P_YS_OA_XTLCZX_0000030711": "Unit",
        "P_YS_FED_FW_0000021700": "Subscription Name",
        "P_YS_FED_EXAMP_0000020669": "On-site Discount Approval",
        "P_YS_FED_FW_0001253648": "[mdf-cube] [getCellDataByCtrlType()] 处理[controlType=",
        "P_YS_FED_FW_0000021701": "No. of primary dimension lines cannot exceed 31",
        "P_YS_FED_EXAMP_0000020668": "Electronic cards/vouchers and physical cards/vouchers cannot be settled at the same time",
        "P_YS_FED_FW_0001253647": "] restoreRowState() 更新第",
        "P_YS_FED_FW_0001253649": "返回值result ==>",
        "P_YS_SD_UDHWN_0001010302": "%d month(s)",
        "P_YS_FED_FW_0000021759": "Title",
        "P_YS_SD_UDHWN_0001010306": "Evening",
        "P_YS_FED_FW_0000021757": "Error returned from calling the service of obtaining Doc configuration. url =",
        "P_YS_FED_FW_0000021758": "Primary Dimension is required; you can select up to three dimensions",
        "P_YS_FED_FW_0000021751": "Do not display the data lines with all the indicators being 0",
        "P_YS_FED_FW_0000021752": "File type field: [Customer Category.Category Name]",
        "P_YS_FED_FW_0000021750": "Display Thousandths Separator",
        "P_YS_SD_SDMBF_0000142981": "★",
        "P_YS_FED_FW_0000021755": "Decimal Digits must be an integer between 1~8",
        "P_YS_FED_FW_0000021756": "The longitude/latitude fields cannot be the same",
        "P_YS_FED_FW_0000021753": "Template Name/Org Name",
        "P_YS_FED_FW_0000021754": "Filter Rows",
        "P_YS_FED_IMP_IOT_0000724647": "test",
        "P_YS_FED_FW_0000021770": "Intersection",
        "P_YS_PF_GZTSYS_0000012346": "Brand Property",
        "P_YS_FED_FW_0000021768": "Large screen slideshow: Render activeTabKey",
        "P_YS_FED_EXAMP_0000020601": "] is a non-material type product",
        "P_YS_FED_EXAMP_0000020600": "Yes",
        "P_YS_FED_FW_0000021769": "Precision",
        "P_YS_FED_FW_0000021762": "Failed to delete draft",
        "P_YS_FED_EXAMP_0000020607": "The proportion cannot be less than",
        "P_YS_FED_FW_0000021763": "A row with no title exists. Please check",
        "P_YS_FED_EXAMP_0000020606": "Online Retail Price:",
        "P_YS_FED_FW_0000021760": "The summary area setting will not automatically refresh. refreshInterval",
        "P_YS_FED_EXAMP_0000020609": "Product are not the same before and after changing line",
        "P_YS_FED_FW_0000021761": "New Template",
        "P_YS_FED_EXAMP_0000020608": "Product Approval",
        "P_YS_FED_FW_0000021766": "Back",
        "P_YS_FED_EXAMP_0000020603": "All the product in the package not entered completely. Cannot execute promotion activity",
        "P_YS_FED_FW_0000021767": "Confirm to delete the column?",
        "P_YS_FED_EXAMP_0000020602": "Invalid gold price",
        "P_YS_FED_FW_0000021764": "· not Operator (!): [Specification]!=null",
        "P_YS_FED_EXAMP_0000020605": "Sample",
        "P_YS_FED_FW_0000021765": "Please enter industry",
        "P_YS_FED_EXAMP_0000020604": "Deposit proportion cannot be less than",
        "P_YS_FED_FW_0001238003": "This is the first one. There's no more data",
        "P_YS_FED_FW_0001238005": "This is the last one. There's no more data",
        "P_YS_SD_UDHWN_0000050766": "Haidong City",
        "P_YS_FED_FW_0001238004": "This is the last one. There's no more data",
        "P_YS_PF_PROCENTER_0000027482": "Share",
        "P_YS_FED_FW_0000021737": "Please select line",
        "P_YS_FED_EXAMP_0000020610": "The operation is unavailable in the current Doc status",
        "P_YS_FED_FW_0000021738": "Large screen slideshow: obtain the boards that type=1 with system permission. kanbans",
        "P_YS_FED_FW_0000021735": "Korean",
        "P_YS_FED_EXAMP_0000020612": "Deposit cannot be less than",
        "P_YS_FED_FW_0000021736": "Display Style",
        "P_YS_FED_EXAMP_0000020611": "For original order return, salespersons in return lines cannot be modified",
        "P_YS_FED_FW_0000021739": "A control exists in the current area. Please clear it first",
        "P_YS_FED_EXAMP_0000020618": "Purchase Price",
        "P_YS_FED_FW_0000021730": "Primary Org is required",
        "P_YS_FED_EXAMP_0000020617": "No more",
        "P_YS_FED_EXAMP_0000020619": "Auto picking is not required for Purchased Goods Receipt Docs of purchase type",
        "P_YS_FED_FW_0000021733": "Only one data item can be selected at a time",
        "P_YS_FED_EXAMP_0000020614": "Deleted successfully",
        "P_YS_FED_FW_0000021734": "Operation failed",
        "P_YS_FED_EXAMP_0000020613": "Consumer password management not enabled. Cannot modify password",
        "P_YS_FED_FW_0000021731": "Setting UI  EChartDesign  Initialization  state",
        "P_YS_FED_EXAMP_0000020616": "Discount Amt",
        "P_YS_FED_FW_0000021732": "When matching a row in a 1-D table, the previous rows must have already been matched. Please check. valueArr =",
        "P_YS_FED_EXAMP_0000020615": "Promotion activity has been executed. Cannot modify card/voucher No. and card/voucher No. range",
        "P_YS_FED_UCFORG_0000066201": "JPG",
        "P_YS_PF_GZTSYS_0000012330": "Address",
        "P_YS_FED_FW_0001037993": "Current field is required",
        "P_YS_FED_FW_0000021748": "Please set font size",
        "P_YS_FED_FW_0000021749": "You can try again later and refresh the service. If it is still unsuccessful, please contact the IT administrator",
        "P_YS_FED_EXAMP_0000020620": "Cannot find the corresponding product Info",
        "P_YS_FED_FW_1492257198466662407": "Please click the icon on the right side of the input box to maintain the multilingual name",
        "P_YS_FED_FW_0000021746": "Company Website",
        "P_YS_FED_EXAMP_0000020623": "End time should be later than start time",
        "P_YS_FED_FW_0000021747": "Authorized",
        "P_YS_FED_EXAMP_0000020622": "Cannot print receipts in the current status",
        "P_YS_FED_FW_0000021740": "Yuan",
        "P_YS_FED_EXAMP_0000020629": "10 Points = 1 Yuan",
        "P_YS_FED_FW_0000021741": "Please select record",
        "P_YS_FED_EXAMP_0000020628": "Cannot modify Qty for prepaid card top-up",
        "P_YS_HR_HRJQF_0000054031": "Nationwide",
        "P_YS_FED_FW_0000021744": "Greater than or equal to",
        "P_YS_FED_EXAMP_0000020625": "Booked/To be Shipped",
        "P_YS_FED_FW_0000021745": "Info Setting",
        "P_YS_FED_EXAMP_0000020624": "Cannot modify header Info",
        "P_YS_FED_FW_0000021742": "Monitoring View Summary Settings",
        "P_YS_FED_UCFBASEDOC_0000025345": "Move to",
        "P_YS_FED_EXAMP_0000020627": "Select batch No.",
        "P_YS_FED_FW_0000021743": "Data Type",
        "P_YS_FED_EXAMP_0000020626": "Current labor cost discount rate is (",
        "P_YS_FI_IA_0000054828": "Doc No.:",
        "P_YS_FED_FW_0000153308": "Only numbers can be pasted in the numeric column. Please modify and try again",
        "P_YS_FED_FW_0001084311": "Interface callback saving ends",
        "P_YS_FED_FW_0001084312": "fetchMeta request callback starts",
        "P_YS_FED_FW_0000153307": "Failed to obtain reference metadata:",
        "P_YS_FED_FW_0001084310": "Start calling",
        "P_YS_FED_FW_0001084319": "ajax request starts",
        "P_YS_FED_FW_0001084317": "Card page data interface callback starts",
        "P_YS_FED_FW_0001084318": "fetchMeta request callback ends",
        "P_YS_FED_FW_0001084315": "End executing the voucherlist init method",
        "P_YS_FED_FW_0001084316": "Saving interface callback starts",
        "P_YS_FED_FW_0001084313": "Start executing initVM",
        "P_YS_FED_FW_0001084314": "End calling",
        "P_YS_FED_FW_0001084322": "Initialization viewmodel callback ends",
        "P_YS_FED_FW_0001084323": "End requesting metadata fetchMeta",
        "P_YS_FED_FW_0001084320": "Start requesting metadata fetchMeta",
        "P_YS_FED_FW_0001084321": "ajax request ends",
        "P_YS_FED_FW_0001084328": "End executing the voucher init method",
        "P_YS_SD_SDMA_0000040405": "ID No.",
        "P_YS_FED_FW_0001084329": "Click Save Button",
        "P_YS_FED_FW_0001084326": "Card page data interface callback ends",
        "P_YS_FED_FW_0001084327": "Start executing the voucher init method",
        "P_YS_FED_FW_0001084324": "Initialization viewmodel callback starts",
        "P_YS_FED_FW_0001084325": "Page Initialization",
        "P_YS_SD_SDMB_0000147380": "Bus",
        "P_YS_FED_FW_0001084333": "Start executing the componentDidMount method of DynamicView",
        "P_YS_FED_FW_0001084334": "Click the button. Calling of the internal onClick method of button component ends",
        "P_YS_FED_FW_1494583954049597443": "The primary dimension is required, and there can be 4 primary dimensions at the most",
        "P_YS_FED_FW_0001084331": "Start executing the voucherlist init method",
        "P_YS_FED_FW_0001084332": "Click Button",
        "P_YS_FED_FW_0001084330": "End executing initVM",
        "P_YS_FED_FW_0001086990": "Pushing failed",
        "P_YS_FED_FW_0001084337": "Reported successfully",
        "P_YS_FED_FW_0001084335": "End executing the componentDidMount method of DynamicView",
        "P_YS_FED_FW_0001084336": "Click the button. Calling of the internal onClick method of button component starts",
        "P_YS_SCM_PU_0000027985": "Demand Application",
        "P_YS_HR_HRCOREF_0000058682": "Export All Data",
        "P_YS_FED_FW_0001331438": "SearchTable not configured",
        "P_YS_PF_BD-UI_0001050131": "Purchase/Demand",
        "P_YS_FED_FW_0001186384": "Print service error",
        "P_YS_FED_FW_1619244168636792834": "没有code和name",
        "P_YS_PLM_BASE-UI_0001105607": "Material Management",
        "P_YS_FED_FW_0001483717": "Selected Conditions:",
        "P_YS_FED_FW_0001098936": "jointQuery not configured",
        "P_YS_FED_FW_0001549489": "There is an item with verification failed. Click to view the details",
        "P_YS_FED_FW_0001086945": "Bank card format error.",
        "P_YS_PF_METADATA_0000084934": "File Name",
        "P_YS_FED_IMP_IOT_0000724693": "test",
        "P_YS_FED_IMP_IOT_0000724695": "test",
        "P_YS_FED_FW_0001260767": "存在重复行标题",
        "P_YS_FED_FW_1464019858621464576": "System printing failed error message:",
        "P_YS_FED_FW_0001120451": "Tree Node 1",
        "P_YS_FED_FW_0001120452": "Tree Node 3",
        "P_YS_FED_FW_0001120453": "Tree Node 2",
        "P_YS_FED_FW_0001272748": "The following fields in the detail of <%=name%> are missing or incorrect",
        "P_YS_FED_IMP_IOT_0000761604": "Zoom In",
        "P_YS_FED_FW_0001272749": "The following grandson table in the detail of <%=name%> is wrong (required items may left empty)",
        "P_YS_PF_MANAGER-FE_0001087798": "Integrated Development",
        "P_YS_PF_PROCENTER_0000022691": "Product Code",
        "P_YS_FED_FW_1540589728190955535": "The required items are not filled in. Please add the designator of each document",
        "P_YS_FED_FW_1565833123598958592": "Failed to get location",
        "P_YS_PF_GZTTMP_0000076150": "Method",
        "P_YS_FED_FW_1540589728190955529": "Batch Assign",
        "P_YS_FED_FW_1540589728190955532": "Add Designator",
        "P_YS_PF_PROCENTER_0000022686": "Doc Date",
        "P_YS_SD_UDHWN_0001010281": "[Down] ddddLT",
        "P_YS_SD_UDHWN_0001010291": "[Today] LT",
        "P_YS_FI_CM_0000028959": "December",
        "P_YS_FI_TP_0000071860": "Dirty Data Deletion",
        "P_YS_FED_IMP_IOT0000006194": "Nanchang District",
        "P_YS_SD_UDHWN_0001131752": "New Template",
        "P_YS_FED_IMP_IOT0000006198": "Dongzhi County",
        "P_YS_FED_IMP_IOT0000006197": "Putuo District",
        "P_YS_OA_XTLCZX_0000030692": "In Progress",
        "P_YS_FED_IMP_IOT0000006191": "Zheng'an County",
        "P_YS_FED_IMP_IOT0000006182": "Yangbi Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000006185": "Xian County",
        "P_YS_FED_IMP_IOT0000006187": "Huludao",
        "P_YS_SD_SCMSA-UI_0000162252": "Cum. Amt Collected",
        "P_YS_FED_IMP_IOT0000006189": "Akto County",
        "P_YS_FED_IMP_IOT0000006188": "Hetang District",
        "P_YS_FED_FW_1592308169585459201": "扫描数量",
        "P_YS_FED_FW_1521051784508342287": "Obsolete",
        "P_YS_FED_FW_0001295306": "Picture size cannot exceed 2MB. Please upload again",
        "P_YS_FED_FW_1521051784508342284": "Obsolete",
        "P_YS_FED_IMP_IOT0000006181": "Wenquan County",
        "P_YS_FED_FW_0001295305": "Only JPG, PNG and BMP formats are supported. Please upload again",
        "P_YS_FED_IMP_IOT0000006179": "Xilin District",
        "P_YS_FED_IMP_IOT0000006171": "Shangnan County",
        "P_YS_FED_FW_1521051784508342281": "Obsolete",
        "P_YS_FED_IMP_IOT0000006174": "Panlong District",
        "P_YS_FED_IMP_IOT0000006173": "Gamba County",
        "P_YS_FED_IMP_IOT0000006176": "Shanggao County",
        "P_YS_FED_IMP_IOT0000006175": "Rongcheng County",
        "P_YS_SD_SDMB_0000090886": "Pmt",
        "P_YS_FED_IMP_IOT0000006177": "Longxian",
        "P_YS_FED_IMP_IOT0000006170": "Zhiduo County",
        "P_YS_FED_IMP_IOT0000007499": "Duji District",
        "P_YS_FED_FW_0001085694": "и",
        "P_YS_FED_IMP_IOT0000006161": "Yinhai District",
        "P_YS_FED_IMP_IOT0000007491": "Pingshan District",
        "P_YS_FED_FW_0001155140": "No available print template",
        "P_YS_FED_IMP_IOT0000007494": "Gaoxian",
        "P_YS_FI_TP_0000071815": "China Unicom",
        "P_YS_FED_IMP_IOT0000006164": "Qianguoluosi Mongolian Autonomous County",
        "P_YS_FED_IMP_IOT0000006167": "Wuxing District",
        "P_YS_FED_IMP_IOT0000006166": "Mengshan County",
        "P_YS_FED_IMP_IOT0000007497": "Hulan District",
        "P_YS_FED_IMP_IOT0000006157": "Ningshan County",
        "P_YS_FED_IMP_IOT0000006159": "Tinghu District",
        "P_YS_FED_IMP_IOT0000007481": "Xinqiu District",
        "P_YS_FED_IMP_IOT0000006152": "Zhecheng County",
        "P_YS_FED_IMP_IOT0000007483": "Huimin County",
        "P_YS_FED_IMP_IOT0000006154": "Cheng'an County",
        "P_YS_FED_IMP_IOT0000007485": "Zhuzhou County",
        "P_YS_FED_IMP_IOT0000007484": "Wuning County",
        "P_YS_FI_CM_0000028918": "November",
        "P_YS_FED_IMP_IOT0000006155": "Yangming District",
        "P_YS_FED_IMP_IOT0000007486": "Derong County",
        "P_YS_FED_FW_0000021681": "Select at most 8 summary items",
        "P_YS_FED_FW_0000021682": "Common Summary Display",
        "P_YS_OA_XTLCZX_0000030653": "Common",
        "P_YS_OA_XTLCZX_0000030652": "Created On",
        "P_YS_FED_FW_0000021680": "Display Week",
        "P_YS_FED_IMP_IOT_0001010685": "yyyy-M-D Ah:mm",
        "P_YS_FED_EXAMP_0000020599": "Please enter store",
        "P_YS_FED_IMP_IOT0000006147": "Binjiang District",
        "P_YS_FED_EXAMP_0000020598": "Collection Amt and A/R Amt are inconsistent. A/R Amt:",
        "P_YS_FED_IMP_IOT0000006146": "Motuo County",
        "module1.UserExcelExportController_0000": "No data to export",
        "P_YS_FED_IMP_IOT_0000761593": "Basic Component",
        "P_YS_FED_EXAMP_0000020595": "Per Cust. Transa. (Yuan)",
        "P_YS_FED_EXAMP_0000020594": "Charles",
        "P_YS_FED_EXAMP_0000020597": "Please enter product",
        "P_YS_FED_EXAMP_0000020596": "Regenerate SKU",
        "P_YS_FED_IMP_IOT0000007470": "Wuchuan",
        "P_YS_FED_FW_0000021675": "The end of barcode must be a number",
        "P_YS_OA_XTLCZX_0000030646": "Left",
        "P_YS_FED_FW_0000021672": "The row title in the profile is empty or the configuration field does not exist in the source table column. Please check",
        "P_YS_FED_FW_0000021673": "Primary Dimension",
        "P_YS_FED_IMP_IOT0000006140": "Lin'an",
        "P_YS_FED_IMP_IOT0000007471": "Huating County",
        "P_YS_SD_UDHWN_0000049719": "Wujiaqu City",
        "P_YS_FED_FW_0000021678": "Add Query Criteria",
        "P_YS_FED_IMP_IOT0000006143": "Taihe County",
        "P_YS_FED_IMP_IOT0000007474": "Hongyuan County",
        "P_YS_FED_FW_0000021679": "No data (monitoring view)",
        "P_YS_FED_IMP_IOT0000007473": "Zhaoyang District",
        "P_YS_FED_FW_0000021676": "Group Scheme",
        "P_YS_FED_IMP_IOT0000006145": "Hekou District",
        "P_YS_FED_IMP_IOT0000007476": "Zhidan County",
        "P_YS_FED_FW_0000021677": "Doc Name",
        "P_YS_FED_IMP_IOT0000006144": "West Ujimqin Banner",
        "P_YS_OA_XTLCZX_0000030661": "Previous",
        "P_YS_FED_FW_0000021692": "Point",
        "P_YS_FED_FW_0000021693": "Get graphical report data  Query parameter =",
        "P_YS_FED_FW_0000021690": "·",
        "P_YS_OA_XTLCZX_0000030663": "Down",
        "P_YS_FED_FW_0000021691": "Data Template Name",
        "P_YS_FED_FW_0001209438": "The tenant-level extension script contains syntax errors. Please correct them and refresh your browser to try again",
        "P_YS_FED_IMP_IOT0000007467": "Tengchong County",
        "P_YS_FED_IMP_IOT0000008799": "Laishan District",
        "P_YS_FED_IMP_IOT0000007466": "Lusong District",
        "P_YS_FED_IMP_IOT0000006138": "Ang Ang District",
        "P_YS_FED_IMP_IOT0000007469": "Tieshan Port District",
        "P_YS_FED_IMP_IOT0000008797": "Yanggu County",
        "P_YS_FED_IMP_IOT0000007468": "Huanan County",
        "P_YS_FED_IMP_IOT0000008798": "Bucheon Yao Autonomous County",
        "P_YS_FED_FW_0000021685": "Stacked Column Chart",
        "P_YS_FED_IMP_IOT0000008791": "Yugan County",
        "P_YS_FED_FW_0000021686": "All operated successfully. In total",
        "P_YS_FED_FW_0000021683": "English",
        "P_YS_FED_IMP_IOT0000006130": "Anlong County",
        "P_YS_FED_FW_0000021684": "Redundant",
        "P_YS_FED_IMP_IOT0000008790": "Heshan District",
        "P_YS_FED_FW_0000021689": "Initialization",
        "P_YS_FED_IMP_IOT0000007463": "Longwan District",
        "P_YS_FED_IMP_IOT0000007462": "Yangchun",
        "P_YS_FED_FW_0000021687": "Setting UI  render",
        "P_YS_FED_IMP_IOT0000006134": "Hongkou District",
        "P_YS_FED_IMP_IOT0000007465": "Basu County",
        "P_YS_FED_IMP_IOT0000008793": "Anping County",
        "P_YS_FED_UCFBASEDOC_0000025323": "Receipt",
        "P_YS_FED_FW_0000021688": "Cannot modify user-defined fields for industry Apps",
        "P_YS_FED_IMP_IOT0000008794": "Gejiu",
        "P_YS_OA_XTLCZX_0000030671": "Pull Down",
        "P_YS_FED_FW_0000021660": "Unit Price Precision",
        "P_YS_FED_FW_0001223748": "Please connect the Bluetooth device",
        "P_YS_FED_IMP_IOT_0001010667": "%d Second",
        "P_YS_FED_IMP_IOT_0001010668": "yyyy-M-D HH:mm",
        "P_YS_FED_IMP_IOT0000007456": "Junan County",
        "P_YS_FED_FW_0000021658": "Refreshing. Please wait...",
        "P_YS_FED_IMP_IOT0000006127": "Yanji",
        "P_YS_FED_FW_0000021659": "My Announcement",
        "P_YS_FED_IMP_IOT0000007457": "Shanglin County",
        "P_YS_FED_IMP_IOT0000006128": "Fanzhi County",
        "P_YS_FED_UCFBASEDOC_0000025319": "Verification Code",
        "P_YS_FED_FW_0000021652": "Name:",
        "P_YS_FED_FW_0000021653": "Importing (",
        "P_YS_FED_FW_0000021650": "Stop",
        "P_YS_FED_IMP_IOT0000007450": "Jinhu County",
        "P_YS_FED_FW_0000021651": "Selected",
        "P_YS_FED_FW_0000021656": "Required",
        "P_YS_FED_FW_0000021657": "Error in the auto refresh interval set for the large screen summary area. refreshInterval",
        "P_YS_FED_IMP_IOT0000006120": "Lu County",
        "P_YS_FED_IMP_IOT0000007451": "She County",
        "P_YS_FED_FW_0000021654": "eChartWeather  Get the current city: error in calling service   params=",
        "P_YS_FED_IMP_IOT0000006123": "Oroqen Autonomous Banner",
        "P_YS_FED_FW_0000021655": "Please enter a number between 1-999",
        "P_YS_FED_IMP_IOT0000006122": "Horqin Zuoyihouqi",
        "P_YS_FED_IMP_IOT0000007453": "Zhaojue County",
        "P_YS_FED_FW_0000021670": "Large screen solution  Design  eChartPanelDesigngetPreView Begin",
        "P_YS_OA_XTLCZX_0000030687": "Start Time",
        "P_YS_FED_FW_0000021671": "New Scheme",
        "P_YS_SD_UDHWN_0001010211": "Before %s",
        "P_YS_OA_XTGONGGAO_0000045819": "Create by Ref.",
        "P_YS_FED_IMP_IOT0000008777": "Fangshan County",
        "P_YS_FED_IMP_IOT0000007444": "Ninglang Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000008778": "Chong'an District",
        "P_YS_SD_UDHWN_0001010219": "%d Year",
        "P_YS_FED_FW_0000021669": "specialcom  Error in preset cstyle",
        "P_YS_FED_IMP_IOT0000006116": "Yanjin County",
        "P_YS_FED_IMP_IOT0000007447": "Huanghua",
        "P_YS_FED_IMP_IOT0000007446": "Wuerhe District",
        "P_YS_FED_IMP_IOT0000008776": "Lighthouse City",
        "P_YS_FED_IMP_IOT0000007449": "Neidong County",
        "P_YS_FED_IMP_IOT0000006117": "Lingui County",
        "P_YS_FED_FW_0000021663": "Item",
        "P_YS_FED_FW_0000021664": "Please check",
        "P_YS_FED_IMP_IOT0000008770": "Etuoke Banner",
        "P_YS_FED_FW_0000021661": "Incorrect numeric font size settings",
        "P_YS_FED_FW_0000021662": "· and Operator (&&:[Specification]!=null&&[Matl Short Name]!=null",
        "P_YS_FED_FW_0001415599": "User-defined Qty",
        "P_YS_FED_FW_0000021667": "Primary Dimension Rows",
        "P_YS_FED_IMP_IOT0000007441": "Mengzi County",
        "P_YS_FED_FW_0000021668": "Column Title",
        "P_YS_FED_IMP_IOT0000008774": "Huaning County",
        "P_YS_FED_FW_0000021665": "Failed to match some rows in the 1-D table with 2-D table cells. index =",
        "P_YS_FED_FW_0000021666": "Scope",
        "P_YS_FED_IMP_IOT0000008772": "Xinlong County",
        "P_YS_FED_EXAMP_0000020560": "Failed to calculate validity period/production date",
        "P_YS_FED_EXAMP_0000020555": "Off-shelf Qty in U-Order:",
        "P_YS_FED_IMP_IOT0000008766": "Heshui County",
        "P_YS_FED_EXAMP_0000020554": "Please select specification first",
        "P_YS_FED_IMP_IOT0000007433": "Xingping",
        "P_YS_FED_IMP_IOT0000008767": "Pingyu County",
        "P_YS_FED_EXAMP_0000020557": "Cannot add product lines in member wallet status",
        "P_YS_FED_IMP_IOT0000007436": "Shunchang County",
        "P_YS_FED_EXAMP_0000020556": "Currently offline. Cannot modify card/voucher business type",
        "P_YS_FED_IMP_IOT0000006104": "Jingning She Autonomous County",
        "P_YS_FED_IMP_IOT0000007435": "Bayan County",
        "P_YS_FED_EXAMP_0000020551": "Name/Mobile",
        "P_YS_FED_IMP_IOT0000007438": "Please select this field",
        "P_YS_FED_EXAMP_0000020550": "The other types are not supported now",
        "P_YS_FED_EXAMP_0000020553": "Failed to obtain voucher Info. Error Info =",
        "P_YS_FED_IMP_IOT0000006109": "Huangdao District",
        "P_YS_FED_IMP_IOT0000008768": "Jidong County",
        "P_YS_FED_EXAMP_0000020552": "Return Reason is required",
        "P_YS_FED_IMP_IOT0000008769": "Taicang City",
        "P_YS_SD_SDMB_0000137925": "No. 5",
        "P_YS_FED_EXAMP_0000020559": "Revision",
        "P_YS_FED_IMP_IOT0000007430": "Hui'an County",
        "P_YS_FED_IMP_IOT0000008762": "Ancient city",
        "P_YS_FED_EXAMP_0000020558": ": refers to processed product that need to be produced and sold on site, such as coffee, drinks, etc.; these product are not controlled by the business parameter \"Allow Negative Issue\".",
        "P_YS_FED_IMP_IOT0000007432": "Jiulong County",
        "P_YS_FED_EXAMP_0000020571": "Discount has been executed. Cannot delete line",
        "P_YS_FED_IMP_IOT_0001010653": "yyyy-M-D",
        "P_YS_FED_EXAMP_0000020570": "Batch No. and validity period are required in the reservation delivery status",
        "P_YS_FED_FW_0001079845": ", supported format:",
        "P_YS_FED_FW_0001079846": "Not Configured",
        "P_YS_FED_EXAMP_0000020566": "WeChat",
        "P_YS_FED_IMP_IOT0000008755": "Haicheng District",
        "P_YS_FED_EXAMP_0000020565": "Please enter the card/voucher No. or card/voucher No. range for card/voucher product",
        "P_YS_FED_IMP_IOT0000007422": "Raohe County",
        "P_YS_FED_EXAMP_0000020568": "Please confirm the product to weigh first",
        "P_YS_FED_IMP_IOT0000007425": "Kaijiang County",
        "P_YS_FED_IMP_IOT0000008753": "Dong'an County",
        "P_YS_FED_EXAMP_0000020567": "Points",
        "P_YS_FED_EXAMP_0000020562": "Reason for Off-shelf",
        "P_YS_FED_EXAMP_0000020561": "Failed to obtain the member wallet enabling parameter",
        "P_YS_FED_IMP_IOT0000007426": "Meghetti County",
        "P_YS_FED_EXAMP_0000020564": "Cannot add physical prepaid card good lines when not selling cards",
        "P_YS_FED_EXAMP_0000020563": "Cannot obtain gold price in the current network status",
        "P_YS_FED_EXAMP_0000020569": "Cannot choose other product for original order return of card/voucher product",
        "P_YS_FED_IMP_IOT0000008752": "Chunhua County",
        "P_YS_FED_IMP_IOT0000007421": "Hejian",
        "P_YS_OA_XTLCZX_0000030616": "End Time",
        "P_YS_FED_IMP_IOT0000007420": "Xinglong County",
        "P_YS_FED_EXAMP_0000020580": "Switch Cloud Addr.",
        "P_YS_FED_IMP_IOT0000007419": "Qianyang County",
        "P_YS_FED_EXAMP_0000020582": "No product entered",
        "P_YS_FED_EXAMP_0000020581": "Profile Photo",
        "P_YS_OA_XTGONGGAO_0000045847": "Undo",
        "P_YS_FED_EXAMP_0000020577": "Off-shelves in U-Order",
        "P_YS_FED_IMP_IOT0000008744": "Nanpiao District",
        "P_YS_FED_EXAMP_0000020576": "Login failed. User does not exist",
        "P_YS_FED_EXAMP_0000020579": "Return Pending Approval",
        "P_YS_FED_IMP_IOT0000007414": "Zhaoping County",
        "P_YS_FED_IMP_IOT0000008742": "Qichun County",
        "P_YS_FED_EXAMP_0000020578": "Product \"",
        "P_YS_FED_EXAMP_0000020573": "Product (",
        "P_YS_FED_IMP_IOT0000007416": "Arong Banner",
        "P_YS_FED_IMP_IOT0000008748": "Wansheng District",
        "P_YS_FED_EXAMP_0000020572": "Failed to obtain card/voucher [",
        "P_YS_FED_IMP_IOT0000008749": "Shilou County",
        "P_YS_FED_EXAMP_0000020575": "Failed to allocate point Info. Error Info =",
        "P_YS_FED_IMP_IOT0000007418": "Xi County",
        "P_YS_FED_EXAMP_0000020574": "Confirm to cancel order?",
        "P_YS_FED_IMP_IOT0000008747": "Daixian",
        "P_YS_FED_FW_0000021696": "Save Business Object",
        "P_YS_FED_FW_0000021697": "Upload picture: error in calling service  info.file.response",
        "P_YS_FED_FW_0000021694": "Graph Report - Failed to read configuration Info or the cross table does not support displaying pictures  param =",
        "P_YS_FED_FW_0000021695": "Error in the auto refresh interval set for the summary area. refreshInterval",
        "P_YS_FED_FW_0001514845": "Field of App",
        "P_YS_FED_IMP_IOT0000008741": "Tanggu District",
        "P_YS_FED_FW_0001514846": "There is no historical data",
        "P_YS_FED_FW_0000021698": "Monitoring View Summary Settings  Triggering Event  filterClick",
        "P_YS_FED_FW_0001514847": "There is no retry history data",
        "P_YS_FED_FW_0000021699": "Yonyou Software Park",
        "P_YS_FED_FW_0001514844": "Historical Date",
        "P_YS_FED_EXAMP_0000020591": "Undelivered",
        "P_YS_FED_EXAMP_0000020590": "Package Price",
        "P_YS_FED_IMP_IOT0000007408": "Xianfeng County",
        "P_YS_FED_EXAMP_0000020593": "Delivered by Current Store",
        "P_YS_FED_EXAMP_0000020592": "Failed to obtain token by yxyToken: [interface]",
        "P_YS_FED_IMP_IOT0000008733": "Pingdingshan",
        "P_YS_FED_EXAMP_0000020588": "The product in the currently selected line is not subject to SN control. Please check",
        "P_YS_FED_EXAMP_0000020587": "Product Query",
        "P_YS_FED_IMP_IOT0000007400": "Xiushan Tujia and Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000007403": "Zezhou County",
        "P_YS_FED_EXAMP_0000020589": "Failed to print online orders online",
        "P_YS_FED_EXAMP_0000020584": "Pull up to load more",
        "P_YS_FED_IMP_IOT0000008737": "Cangyuan Wa Autonomous County",
        "P_YS_FED_EXAMP_0000020583": "Already executed:",
        "P_YS_FED_IMP_IOT0000007404": "Longjiang County",
        "P_YS_FED_EXAMP_0000020586": "Change",
        "P_YS_FED_EXAMP_0000020585": "Shipment",
        "P_YS_FED_IMP_IOT0000007406": "Wencheng County",
        "P_YS_FED_UCFBASEDOC_0000025061": "Role Code",
        "P_YS_FED_IMP_IOT0000008609": "Hualong District",
        "P_YS_FED_IMP_IOT0000009938": "Yingjing County",
        "P_YS_FED_FW_0000021836": "Failed to request data",
        "P_YS_FED_FW_0001078150": "Invalid Doc.",
        "P_YS_FED_IMP_IOT0000009932": "Linxia County",
        "P_YS_FED_IMP_IOT0000010932": "Sanhe",
        "P_YS_FED_FW_0000021837": "Keep Outer Border",
        "P_YS_FED_IMP_IOT0000009933": "Xing'an County",
        "P_YS_FED_FW_0000021834": "Dimension navigation tree  Empty tree node data returned from query. Line data",
        "P_YS_FED_FW_0001295182": "You do not have the permission to open this Doc. Confirm to close the page?",
        "P_YS_FED_FW_0000021835": "Set summary area - Failed to read configuration Info or the cross table is not supported  Query parameter =",
        "P_YS_FED_IMP_IOT0000010935": "Wutai County",
        "P_YS_FED_FW_0000021838": "Cannot find the Info needed to process lines",
        "P_YS_FED_IMP_IOT0000009934": "Mulan County",
        "P_YS_FED_FW_0000021839": "Factory",
        "P_YS_FED_FW_0001432065": "The network is disconnected. Please try again later",
        "P_YS_SD_URETAIL_0001049126": "rebootSave_per service error",
        "P_YS_FED_FW_0000021832": "Max",
        "P_YS_FED_FW_0000021833": "PR Print Template 1",
        "P_YS_FED_FW_0000021830": "No more than 10 chars",
        "P_YS_FED_IMP_IOT0000010938": "Wensu County",
        "P_YS_FED_FW_0000021831": "Please enter decimal digits",
        "P_YS_FED_IMP_IOT0000010939": "Lijin County",
        "P_YS_SD_SDOC_0000163818": "No data returned",
        "P_YS_FED_IMP_IOT0000009927": "Wujiagang District",
        "P_YS_FED_IMP_IOT0000009928": "Dushan County",
        "P_YS_PF_SOCD-E_0000317811": "Congo",
        "P_YS_FED_FW_0000021847": "All Info - Config. Info  config =",
        "P_YS_FED_FW_0000021848": "Greater than",
        "P_YS_FED_IMP_IOT0000009922": "Yongchang County",
        "P_YS_FED_FW_0000021845": "eChartPanelDesign cancelOpereate  Cancel designing template",
        "P_YS_FED_FW_0000021846": "Left",
        "P_YS_FED_IMP_IOT0000009920": "Zhanggong District",
        "P_YS_FED_IMP_IOT0000009925": "Tianyang County",
        "P_YS_FED_IMP_IOT0000010940": "Pingan County",
        "P_YS_FED_FW_0000021849": "Operation Column",
        "P_YS_FED_IMP_IOT0000010942": "Shanhaiguan District",
        "P_YS_FED_FW_0000021840": "No data",
        "P_YS_FED_FW_0000021843": "Move Current Line Down",
        "P_YS_FED_FW_0000021844": "Link Subordinates",
        "P_YS_FED_FW_0000021841": "Auto refresh monitoring view regularly. renderTime",
        "P_YS_FED_IMP_IOT0000010949": "Wulong County",
        "P_YS_FED_FW_0000021842": "Gallery",
        "P_YS_SD_URETAIL_0001049152": "Failed to delete cache data:",
        "P_YS_PF_PRINT_0000057698": "Amt in FC Excl. Tax",
        "P_YS_FED_FW_0000021814": "Minute",
        "P_YS_FED_IMP_IOT0000009910": "Hukou County",
        "P_YS_FED_IMP_IOT0000010954": "Malcon County",
        "P_YS_FED_FW_0000021815": "Right",
        "P_YS_FED_IMP_IOT0000010955": "Tianshan District",
        "P_YS_FED_FW_0000021812": "Please select display indicators",
        "P_YS_FED_IMP_IOT0000010956": "Qapqal Xibe Autonomous County",
        "P_YS_FED_FW_0000021813": "Not equal",
        "P_YS_FED_IMP_IOT0000010957": "Nenjiang County",
        "P_YS_FED_FW_0000021818": "No more available query criteria",
        "P_YS_PF_GZTTMP_0000074981": "Not in list",
        "P_YS_FED_IMP_IOT0000009914": "Huangzhou District",
        "P_YS_FED_FW_0000021819": "Most",
        "P_YS_FED_IMP_IOT0000009915": "Bomi County",
        "P_YS_FED_FW_0000021816": "Zoom Out",
        "P_YS_FED_IMP_IOT0000009912": "Huishan District",
        "P_YS_FED_FW_0000021817": "Not Enabled",
        "P_YS_PF_METADATA_0001147963": "Display Picture",
        "P_YS_FED_FW_0000021810": "Summary Settings",
        "P_YS_FED_FW_0000021811": "By Criteria",
        "P_YS_FED_UCFBASEDOC_0000025038": "Daily Settlement Doc/Daily Sales Report -",
        "P_YS_FED_UCFBASEDOC_0000025036": "Func. Permission",
        "P_YS_SD_URETAIL_0001049164": "Error in saving data",
        "P_YS_FED_IMP_IOT0000009908": "Santai County",
        "P_YS_FED_FW_0000021825": "Failed to switch",
        "P_YS_FED_FW_0000021826": "All",
        "P_YS_FED_FW_0000021823": "PR Print Template 3",
        "P_YS_FED_FW_0000021824": "PR Print Template 2",
        "P_YS_PES_PES-BE_0001231166": "Duplicate line",
        "P_YS_FED_FW_0000021829": "Large screen slideshow: switch beforeChange",
        "P_YS_FED_IMP_IOT0000009904": "Anlu",
        "P_YS_FED_IMP_IOT0000010962": "Mashan County",
        "P_YS_FED_FW_0000021827": "Delete Line",
        "P_YS_FED_IMP_IOT0000009901": "Gongnongqu",
        "P_YS_FED_FW_0000021828": "Cancel Splitting",
        "P_YS_FED_IMP_IOT0000010964": "Xinhe County",
        "P_YS_FED_FW_0001367336": "PredicateDatePicker_Popover referPopover",
        "P_YS_FED_FW_0000021821": "Default Language",
        "P_YS_FED_IMP_IOT0000010969": "Yuci City",
        "P_YS_FED_FW_0000021822": "Column Chart",
        "P_YS_FED_FW_0001066127": "The code cannot exceed 20 characters.",
        "P_YS_FED_FW_0000021820": "Dimension navigation tree  Select point filter item",
        "P_YS_FED_UCFBASEDOC_0000025024": "Click to query inventory static reports",
        "P_YS_FED_UCFBASEDOC_0000025023": "Export",
        "P_YS_FED_FW_0000021880": "1. Numeric type fields support four arithmetic operations, comparison operations, and logical operations, and can form simple four arithmetic expressions, relational expressions, and logical expressions.",
        "P_YS_FED_IMP_IOT_0000724760": "Previous",
        "P_YS_FED_EXAMP_0000019969": "Verification code sent successfully",
        "P_YS_FED_EXAMP_0000019968": "[Announcement] Store sales performance competition description",
        "P_YS_FED_EXAMP_0000019967": ") with batch management enabled. Please enter batch No.",
        "P_YS_SD_UDHWN_0000049873": " chars",
        "P_YS_FED_EXAMP_0000019973": "]. No default storage bin specified. Please enter it manually",
        "P_YS_FED_IMP_IOT0000010976": "Baode County",
        "P_YS_FED_EXAMP_0000019972": "]. Please enter card/voucher No.",
        "P_YS_FED_EXAMP_0000019971": "Promotion has been executed. Cannot modify return Info again",
        "P_YS_SD_UDHWS_0000118830": "Qty:",
        "P_YS_FED_FW_0000021879": "Cross-point",
        "P_YS_FED_EXAMP_0000019970": "Please select Doc first",
        "P_YS_FED_IMP_IOT0000010979": "Zunhua",
        "P_YS_FED_EXAMP_0000019977": "Requested address:",
        "P_YS_FED_IMP_IOT0000010972": "Hezheng County",
        "P_YS_PF_GZTSYS_0000012211": "Tenant",
        "P_YS_FED_EXAMP_0000019976": "Initializing. Please try again later",
        "P_YS_FED_IMP_IOT0000010973": "Xuanwu District",
        "P_YS_FED_EXAMP_0000019975": "The card/voucher is not for original order return. Cannot modify Qty",
        "P_YS_FED_EXAMP_0000019974": "Processing Type Desc.",
        "P_YS_FED_IMP_IOT0000010975": "Hailing District",
        "P_YS_FED_FW_0000021872": "Date type field: [Established On]",
        "P_YS_FED_FW_0000021873": "Control Entry Length",
        "P_YS_FED_FW_0000021870": "Empty",
        "P_YS_FED_FW_0000021871": "Unselected",
        "P_YS_FED_FW_0000021876": "Display Angle",
        "P_YS_FED_UCFBASEDOC_0000025017": "Read-only",
        "P_YS_FED_FW_0000021877": "Center",
        "P_YS_FED_FW_0000021874": "Type",
        "P_YS_FED_FW_0000021875": "Width",
        "P_YS_FED_MDF-COMPS_0001573108": "物料名稱",
        "P_YS_FED_MDF-COMPS_0001573109": "表体-0528test",
        "P_YS_FED_MDF-COMPS_0001573106": "組號",
        "P_YS_FED_MDF-COMPS_0001573107": "Move to",
        "P_YS_FED_FW_0000021890": "Japanese",
        "P_YS_FED_FW_0000021891": "When matching a row in a 1-D table, the previous rows must have already been matched. Please check. rows =",
        "P_YS_SD_URETAIL_0001049188": "Failed to delete multiple pieces of data",
        "P_YS_FED_IMP_IOT0000010980": "Jingle County",
        "P_YS_FED_EXAMP_0000019979": "Replenish by Historical Sales Volume",
        "P_YS_FED_EXAMP_0000019978": "Please select Org first",
        "P_YS_HR_HRJQ_0000055859": "Start Date",
        "P_YS_FED_EXAMP_0000019984": "Please select delivery frequency",
        "P_YS_FED_IMP_IOT0000010987": "Shapotou District",
        "P_YS_FED_EXAMP_0000019983": "Please select the same member for settlement",
        "P_YS_FED_FW_0000021889": "Incorrect font size settings",
        "P_YS_FED_EXAMP_0000019982": "Error code:",
        "P_YS_FED_EXAMP_0000019981": ", actual collection Amt:",
        "P_YS_HR_HRJQF_0000054172": "Disable",
        "P_YS_FED_EXAMP_0000019988": "Package product not entered completely",
        "P_YS_PF_GZTSYS_0000012221": "Brand Group",
        "P_YS_FED_EXAMP_0000019987": "There're multiple salespersons, and only full Amt collection is allowed. Continue?",
        "P_YS_FED_IMP_IOT0000010984": "Jianchang County",
        "P_YS_FED_EXAMP_0000019986": "Cannot add product lines during adjustment",
        "P_YS_FED_IMP_IOT0000010985": "Duchang County",
        "P_YS_FED_EXAMP_0000019985": "Already exists",
        "P_YS_FED_FW_0000021883": "Entry length must be an integer between 1~255",
        "P_YS_FED_IMP_IOT_0000724756": "test",
        "P_YS_FED_MDF-COMPS_0001573100": "ycx文本",
        "P_YS_FED_FW_0000021884": "Board Config. Info - Module Config. - Chart Group Scheme",
        "P_YS_FED_MDF-COMPS_0001573101": "表头-0528test",
        "P_YS_FED_FW_0000021881": " summary items",
        "P_YS_FED_IMP_IOT_0000724754": "test",
        "P_YS_FED_FW_0000021882": "Large screen solution  Display  constructor panelConfig",
        "P_YS_FED_FW_0000021887": "Contact Telephone",
        "P_YS_FED_MDF-COMPS_0001573104": "應收件數",
        "P_YS_FED_FW_0000021888": "Add More Query Criteria",
        "P_YS_FED_MDF-COMPS_0001573105": "客户分类3",
        "P_YS_FED_FW_0000021885": " Group Info missing. Defaults to product product_cCode product_cName",
        "P_YS_FED_MDF-COMPS_0001573102": "仓档案",
        "P_YS_SD_SDSD-FE_0001277778": "Last 3 Days",
        "P_YS_FED_FW_0000021886": "Enum Item",
        "P_YS_FED_MDF-COMPS_0001573103": "主計量",
        "P_YS_FED_IMP_IOT0000010990": "Haifeng County",
        "P_YS_FED_IMP_IOT0000010991": "Wenxi County",
        "P_YS_FED_EXAMP_0000019989": "No available shift",
        "P_YS_FED_FW_0000021858": "Aux. Dimension",
        "P_YS_FED_EXAMP_0000019995": "Updating service. Please wait a few seconds and try again",
        "P_YS_FED_IMP_IOT0000010998": "Yuanbao District",
        "P_YS_FED_FW_0000021859": "Supported formats: PDF, Word, Excel, Txt, JPG, PNG, BMP, GIF",
        "P_YS_FED_EXAMP_0000019994": "Package member item Qty comparison relationship should meet the following conditions:",
        "P_YS_FED_FW_0000021856": "eChartWeather  Get the current city  getLocalCity this.serieNum =",
        "P_YS_FED_FW_0001081771": "Request execution completed.",
        "P_YS_FED_EXAMP_0000019993": "Cannot execute member discount",
        "P_YS_FED_FW_0000021857": "Time Separator",
        "P_YS_FED_EXAMP_0000019992": "Amt by Free",
        "P_YS_FED_EXAMP_0000019999": "Transfer to Branch",
        "P_YS_FED_IMP_IOT0000010994": "Jean Hulu District",
        "P_YS_FED_EXAMP_0000019998": "Cannot modify Qty for buyout room rate",
        "P_YS_FED_IMP_IOT0000010995": "Fucheng County",
        "P_YS_FED_EXAMP_0000019997": "Debugging user verification succeeded",
        "P_YS_SD_UDHWN_0000121761": "Google",
        "P_YS_FED_EXAMP_0000019996": "Available wallet balance is insufficient. Cannot perform quick settlement",
        "P_YS_FED_IMP_IOT0000010997": "Xinji",
        "P_YS_HR_HRJQF_0000054160": "Import failed",
        "P_YS_FED_FW_0000021850": "First",
        "P_YS_FED_FW_0000021851": "Name is required",
        "P_YS_FED_FW_0001457385": "Please save first",
        "P_YS_FED_FW_0001457386": "Changed On:",
        "P_YS_FED_FW_0001457387": "Change Description:",
        "P_YS_FED_FW_0000021854": "Loading...",
        "P_YS_FED_EXAMP_0000019991": "Returned Qty cannot be greater than Qty not sold",
        "P_YS_FED_FW_0001457388": "View All",
        "P_YS_FED_FW_0000021855": "Doc generation completed",
        "P_YS_FED_EXAMP_0000019990": "Requested parameter:",
        "P_YS_FED_FW_0000021852": "Refresh",
        "P_YS_HR_HRJXF_0000059668": "Canceled successfully",
        "P_YS_FED_FW_0000021853": "Please add data items to the selected area",
        "P_YS_FED_IMP_IOT_0000724746": "Export",
        "P_YS_PF_PROCENTER_0000027111": "Modify",
        "P_YS_SCM_USTOCK_0001078433": "Receipt Completion Rate",
        "P_YS_FED_FW_0000021869": "Select All",
        "P_YS_FED_FW_0000021867": "Details",
        "P_YS_FED_FW_0000021868": "No data",
        "P_YS_PF_GZTSYS_0000012205": "Member Grade",
        "P_YS_FED_IMP_IOT_0000724739": "Next",
        "P_YS_FED_FW_0000021861": "Bottom",
        "P_YS_FED_FW_0000021862": "Top",
        "P_YS_FED_IMP_IOT_0000724733": "test",
        "P_YS_FED_FW_0000021860": "Database  eChartConfig",
        "P_YS_FED_IMP_IOT_0000724731": "test",
        "P_YS_FED_FW_0000021865": "No matching row found",
        "P_YS_FED_IMP_IOT_0000724738": "Paste to Last Line",
        "P_YS_FED_FW_0000021866": "Please select the items applicable for PC/mobile Apps",
        "P_YS_FED_IMP_IOT_0000724737": "test",
        "P_YS_FED_FW_0000021863": "Good",
        "P_YS_FED_FW_0000021864": "Clear Background Picture",
        "P_YS_FI_FIEFP-UI_0001288287": "Include",
        "P_YS_FED_EXAMP_0000019926": "]. Cannot find the corresponding payment method of card/voucher. Please set the store collection method of card/voucher",
        "P_YS_FED_EXAMP_0000019925": "Not yet checked in. Cannot deliver product",
        "P_YS_FED_EXAMP_0000019924": "Cannot pay with prepaid cards for top-up under the stored value business type",
        "P_YS_FED_EXAMP_0000019923": "No product selected",
        "P_YS_FED_EXAMP_0000019929": "Password is required",
        "P_YS_FED_EXAMP_0000019928": "No product line under card/voucher No. management",
        "P_YS_FED_EXAMP_0000019927": "Cannot use vouchers during adjustment",
        "P_YS_FED_EXAMP_0000019933": "Failed to allocate vouchers. Info:",
        "P_YS_FED_EXAMP_0000019932": "The voucher collection method is used in the current Doc. Cannot modify product Qty",
        "P_YS_FED_EXAMP_0000019931": "Email",
        "P_YS_FED_FW_0001566083": "Clear and Return",
        "P_YS_FED_EXAMP_0000019930": "Total Amt in product line:",
        "P_YS_FED_EXAMP_0000019937": "Obtain time period Info",
        "P_YS_FED_EXAMP_0000019936": "Cannot modify retail prices in return lines",
        "P_YS_FED_EXAMP_0000019935": "(Room No.) is not available. Please select again",
        "P_YS_FED_EXAMP_0000019934": "Product line is required",
        "P_YS_FED_EXAMP_0000019939": "OK",
        "P_YS_FED_EXAMP_0000019938": "Store Name",
        "P_YS_FED_EXAMP_0000019940": "Product SKU not obtained",
        "P_YS_FED_EXAMP_0000019944": " H120status, Docs cannot be held",
        "P_YS_FED_EXAMP_0000019943": "Start time cannot be later than or equal to end time",
        "P_YS_FED_EXAMP_0000019942": "The item recognition server is not connected or the connection is timed out",
        "P_YS_FED_EXAMP_0000019941": "Cannot find the corresponding card/voucher product of the card/voucher No.",
        "P_YS_FED_MDF-COMPS_0001573117": "提交時間",
        "P_YS_FED_MDF-COMPS_0001573118": "自定義項目測試202008060001",
        "P_YS_FED_EXAMP_0000019948": "Top-up Amt",
        "P_YS_FED_EXAMP_0000019947": "Online retailer settlement failed",
        "P_YS_FED_EXAMP_0000019946": "Cannot query available Qty in the current network status",
        "P_YS_FED_EXAMP_0000019945": "No SN line selected. Cannot specify in batch. Please check",
        "P_YS_FED_EXAMP_0000019949": "Cannot execute the operation in the card/voucher status. Please bill again",
        "P_YS_FED_EXAMP_0000019951": "Workdays",
        "P_YS_FED_EXAMP_0000019950": "The product line cannot be changed",
        "P_YS_FED_EXAMP_0000019955": "Top-up Amt is empty",
        "P_YS_FED_FW_0001272432": "Blurry image",
        "P_YS_FED_EXAMP_0000019954": "Member Discount",
        "P_YS_FED_FW_0001272431": "Incomplete Info. Please fill in completely",
        "P_YS_FED_EXAMP_0000019953": "Cannot execute promotional gifts in the current network status",
        "P_YS_FED_FW_0001272434": "Frame missing",
        "P_YS_FED_EXAMP_0000019952": "Product line exists. Cannot adjust",
        "P_YS_FED_FW_0001272433": "Overexposed",
        "P_YS_FI_YYFI-UI_0001096480": "Sub-table Line",
        "P_YS_FED_FW_0001272436": "Upload ID",
        "P_YS_FED_MDF-COMPS_0001573111": "ycx檔案類型",
        "P_YS_FED_FW_0000177620": "Enter Contents",
        "P_YS_FED_FW_0001272435": "Fill in the Info",
        "P_YS_FED_MDF-COMPS_0001573112": "likun-表体自定义项[文本]",
        "P_YS_FED_MDF-COMPS_0001573110": "枚舉",
        "P_YS_FED_MDF-COMPS_0001573115": "上游單據號",
        "P_YS_FED_MDF-COMPS_0001573116": "保質期單位",
        "P_YS_FED_MDF-COMPS_0001573113": "物料編碼",
        "P_YS_FED_MDF-COMPS_0001573114": "倉庫",
        "P_YS_PF_PROCENTER_0000027156": "View More",
        "P_YS_FED_EXAMP_0000019959": "Select operator again?",
        "P_YS_FED_EXAMP_0000019958": "Amt",
        "P_YS_FED_EXAMP_0000019957": "Card/Voucher No. Qty and product Qty are not equal. Please check",
        "P_YS_FED_EXAMP_0000019956": "Times Voucher",
        "P_YS_FED_EXAMP_0000019962": "System Settings",
        "P_YS_FED_FW_0001122799": "Restore to",
        "P_YS_FED_EXAMP_0000019961": "You can still enter",
        "P_YS_FED_EXAMP_0000019960": "Card Claimed On",
        "P_YS_FED_FW_1572432323657859076": "Return directly to clear this edit",
        "P_YS_FED_EXAMP_0000019966": "Timed Room Rate",
        "P_YS_FED_EXAMP_0000019965": "Weekends",
        "P_YS_FED_EXAMP_0000019964": "status, product cannot be deleted",
        "P_YS_FED_EXAMP_0000019963": "The product doesn't support matching",
        "P_YS_FED_FW_1580622998083207174": "只允许精准搜索",
        "P_YS_FED_FW_0000021809": "To",
        "P_YS_FED_FW_1472458481506189318": "searchDevices complete，信息：",
        "P_YS_FED_FW_1472458481506189315": "获取已连接的设备信息失败：",
        "P_YS_FED_FW_0000021803": "No. of auxiliary dimension lines cannot exceed 5",
        "P_YS_FED_FW_0000021804": "Batch Modify",
        "P_YS_FED_FW_0000021801": "*Template Code:",
        "P_YS_FED_FW_0000021802": "Multi-choice is supported. You can select at most",
        "P_YS_FED_FW_0000021807": "Descending",
        "P_YS_FED_EXAMP_0000019900": "Time interval can span across at most one day. Please select time again",
        "P_YS_FED_FW_1472458481506189312": "searchDevices failed，错误信息：",
        "P_YS_FED_FW_0000021808": "Template Code/Template Name is required",
        "P_YS_FED_FW_0000021805": "Display",
        "P_YS_FED_FW_0000021806": "Range",
        "P_YS_FED_FW_0000021800": "No qualified group scheme (displayStyle == 2 or 3, for mobile board, isMobile must be true) found",
        "P_YS_FED_EXAMP_0000019909": "Business Type",
        "P_YS_FED_EXAMP_0000019904": "The voucher collection method is used in the current Doc. Please perform whole Doc return",
        "P_YS_FED_FW_0001318326": "filterId查询报错",
        "P_YS_FED_EXAMP_0000019903": "Hold Doc",
        "P_YS_FED_EXAMP_0000019902": "Operation Overview",
        "P_YS_FED_EXAMP_0000019901": "Update successful",
        "P_YS_FED_EXAMP_0000019908": ", the salesperson in the product line is empty. Please allocate salesperson",
        "P_YS_FED_EXAMP_0000019907": "The business type is not top-up and the billing line is not empty. Cannot top up",
        "P_YS_FED_EXAMP_0000019906": "More",
        "P_YS_FED_EXAMP_0000019905": "When Customization/Remodeling is set to Remodeling, product (",
        "P_YS_FED_FW_1472458481506189327": "缺少YYEsnBridge,方法丢失",
        "P_YS_FED_FW_1472458481506189324": "未连接到打印设备,请按打印设备配网说明书配网或尝试重启打印设备",
        "P_YS_FED_EXAMP_0000019911": "Uncollected Amt",
        "P_YS_FED_EXAMP_0000019910": "Failed to print receipts",
        "P_YS_FED_FW_1472458481506189321": "未搜索到打印设备,请先扫描打印机上的二维码,配置网络或尝试重启打印设备",
        "P_YS_PF_SOCD-G_0000934651": "Jack",
        "P_YS_FED_EXAMP_0000019915": "Please cancel first",
        "P_YS_FED_FW_0001246115": "code: 999 exception in server logic",
        "P_YS_FED_FW_0001290394": "imgUrl: does not exist",
        "P_YS_FED_FW_1536786620552839169": "Sales Order - Instant Analysis",
        "P_YS_FED_EXAMP_0000019914": "My Favorites",
        "P_YS_FED_UCFBASEDOC_0000025070": "Enter a brief description of the role",
        "P_YS_FED_FW_0001290395": "Bluetooth is not turned on",
        "P_YS_FED_EXAMP_0000019913": "It's not supported to cancel orders by multiple payment methods now",
        "P_YS_FED_EXAMP_0000019912": "Card/voucher product [",
        "P_YS_FED_EXAMP_0000019919": "Failed to refund. Amt:",
        "P_YS_FED_FW_0001319664": "测试一下",
        "P_YS_FED_EXAMP_0000019918": "Return Reason is required in return lines",
        "P_YS_FED_FW_0001319665": "Duplicated rows exist. Line <%=index1%> and line  <%=index2%> are duplicate",
        "P_YS_FED_EXAMP_0000019917": "Prepaid Card - Non-original Order Return Function",
        "P_YS_FED_EXAMP_0000019916": "Confirm Password",
        "P_YS_FED_FW_0001290393": "Failed to obtain the picture",
        "P_YS_HR_HRCOREF_0000058569": "Importing",
        "P_YS_FED_FW_1472458481506189336": "getConnectedDevice执行成功，但是未获取到已连接设备",
        "P_YS_FED_FW_1472458481506189333": "printPicture failed，错误信息：",
        "P_YS_FED_EXAMP_0000019922": "]'s card/voucher number. Cannot execute",
        "P_YS_FED_EXAMP_0000019921": "The current operator does not have the non-original order return permission of card/voucher",
        "P_YS_FED_EXAMP_0000019920": "Select salesperson",
        "P_YS_FED_FW_1472458481506189330": "搜索打印设备失败,错误信息：",
        "P_YS_OA_XTLCZX_0000030377": "End",
        "P_YS_FI_FCWEB_0001324088": "Entries not connected to the multilingual center:",
        "P_YS_FI_FCWEB_0001324089": "Not exist. Please check the entry",
        "P_YS_FED_IMP_IOT0000006094": "Qingshan Lake District",
        "P_YS_FED_IMP_IOT0000006096": "Songshan District",
        "P_YS_OA_XTLCZX_0000030396": "Assign",
        "P_YS_FED_IMP_IOT0000006091": "Susong County",
        "P_YS_FED_IMP_IOT0000006093": "Tieli City",
        "P_YS_FED_IMP_IOT0000006092": "Suide County",
        "P_YS_FED_FW_1564919833163202571": "Drag: Height of upper and lower tables can be customized",
        "P_YS_FED_IMP_IOT0000006083": "Xingcheng",
        "P_YS_FED_IMP_IOT0000006086": "Xinjin County",
        "P_YS_FED_IMP_IOT0000006089": "Longhua District",
        "P_YS_FED_IMP_IOT0000006080": "Ganjingzi District",
        "P_YS_FED_IMP_IOT0000006082": "Zixing",
        "P_YS_FED_IMP_IOT0000006081": "Qiongjie County",
        "P_YS_HR_HRYGF_0000055713": "All Categories",
        "P_YS_FED_FW_1564919833163202562": "Double-click: The upper and lower layouts can be changed to the left and right layouts",
        "P_YS_FED_FW_1564919833163202565": "Drag: The width of left and right tables can be customized",
        "P_YS_FED_IMP_IOT0000006072": "Ruicheng County",
        "P_YS_FED_IMP_IOT0000006075": "Fancheng District",
        "P_YS_SD_SDMB_0000146326": "Jewelry",
        "P_YS_FED_IMP_IOT0000006077": "Guyang County",
        "P_YS_FED_IMP_IOT0000006079": "Kongtong District",
        "P_YS_FED_FW_1564919833163202568": "Double-click: The left and right layouts can be changed to top and bottom layouts",
        "P_YS_HR_HRJQF_0000066215": "Please enter employee name",
        "P_YS_FED_IMP_IOT0000006069": "Lake District",
        "P_YS_FED_IMP_IOT0000007393": "Zuoyun County",
        "P_YS_FED_IMP_IOT0000006061": "Naiman Banner",
        "P_YS_FED_IMP_IOT0000007392": "Baiyun mining area",
        "P_YS_FED_IMP_IOT0000006064": "Xiejiaji District",
        "P_YS_OA_XTLCZX_0000030325": "Upload",
        "P_YS_FED_IMP_IOT0000007394": "Xinle",
        "P_YS_FED_IMP_IOT0000006068": "Yingjiang District",
        "P_YS_FED_IMP_IOT0000007399": "Qingpu District",
        "P_YS_FED_IMP_IOT0000006060": "Qingzhou",
        "RPA_L7_00050014": "Confirm to delete?",
        "P_YS_FED_IMP_IOT0000007389": "Xichong County",
        "P_YS_FED_FW_0001236707": "Past",
        "P_YS_FED_IMP_IOT0000006051": "Beidaihe District",
        "P_YS_FED_IMP_IOT0000006050": "Changwu County",
        "P_YS_FED_IMP_IOT0000006052": "Tonghai County",
        "P_YS_FED_IMP_IOT0000007383": "Kangma County",
        "P_YS_FED_IMP_IOT0000006055": "Fuliang County",
        "P_YS_FED_IMP_IOT0000007386": "Midu County",
        "P_YS_FED_FW_0001236706": "Future",
        "P_YS_FED_IMP_IOT0000007388": "Shijingshan District",
        "P_YS_OA_app_xtyyjm_0000035731": "Effective",
        "P_YS_FED_IMP_IOT0000007387": "Xinshao County",
        "P_YS_OA_XTLCZX_0000030351": "Display",
        "P_YS_FED_FW_0001277251": "Error in parsing the interaction rule:",
        "P_YS_FED_FW_0001072028": "There are 8 summary items. Cannot add formula",
        "P_YS_HR_HRJQF_0000066237": "Recent",
        "P_YS_FED_FW_0001277253": "Null",
        "P_YS_FED_FW_0001277252": "Null",
        "P_YS_FED_IMP_IOT0000006048": "Fangcheng District",
        "P_YS_FED_IMP_IOT0000007379": "Qingshen County",
        "P_YS_FED_FW_0001087994": "Please try again after modification;",
        "P_YS_FED_FW_1607526372569776128": "获取上下文信息失败：【接口】",
        "P_YS_FED_IMP_IOT0000006040": "Shitai County",
        "P_YS_FED_IMP_IOT0000007371": "Ejin Banner",
        "P_YS_FED_IMP_IOT0000007370": "Pinglu County",
        "P_YS_FED_IMP_IOT0000006042": "Guichi District",
        "P_YS_FED_IMP_IOT0000007373": "Daning County",
        "P_YS_OA_XTLCZX_0000030347": "Uploaded",
        "P_YS_FED_IMP_IOT0000006044": "Dieshan District",
        "P_YS_FED_IMP_IOT0000007375": "Nanxi County",
        "P_YS_FED_IMP_IOT0000006046": "Changhai County",
        "P_YS_FED_IMP_IOT0000007377": "Fengfeng mining area",
        "P_YS_FED_IMP_IOT0000006045": "Renhua County",
        "P_YS_OA_XTLCZX_0000030361": "Approval Process",
        "P_YS_OA_XTLCZX_0000030367": "Please enter a number",
        "P_YS_FED_FW_0001209138": "View Doc Details",
        "P_YS_FED_IMP_IOT0000007368": "Gaoling County",
        "P_YS_FED_IMP_IOT0000008698": "Dashiqiao",
        "P_YS_FED_IMP_IOT0000006038": "Tancheng County",
        "P_YS_FED_IMP_IOT0000007369": "Anyuan District",
        "P_YS_FED_IMP_IOT0000008699": "Tongchuan District",
        "P_YS_FED_IMP_IOT0000007362": "Huancui District",
        "P_YS_FED_IMP_IOT0000006030": "Fu'an",
        "P_YS_FED_IMP_IOT0000008691": "Changxing County",
        "P_YS_HR_HRCOREF_0000058606": "ID Card",
        "P_YS_FED_IMP_IOT0000008697": "Xiuwu County",
        "P_YS_FED_IMP_IOT0000007365": "Pujiang County",
        "P_YS_FED_IMP_IOT0000008695": "Muli Tibetan Autonomous County",
        "P_YS_SD_UDHWN_0000050822": "Qingpu District",
        "P_YS_SD_UDHWN_0000049836": "Danzhou",
        "P_YS_PF_PRINT_0000057631": "Detail User-defined Field 7",
        "P_YS_PF_PRINT_0000057630": "Detail User-defined Field 8",
        "P_YS_SD_SDMA_0000123136": "Homepage",
        "P_YS_FED_IMP_IOT0000007357": "Deqing County",
        "P_YS_FED_IMP_IOT0000008689": "Ritu County",
        "P_YS_FED_IMP_IOT0000006025": "Honghu",
        "P_YS_FED_IMP_IOT0000007356": "Aimin District",
        "P_YS_FED_IMP_IOT0000006028": "Zixi County",
        "P_YS_FED_IMP_IOT0000007359": "Faku County",
        "P_YS_FED_IMP_IOT0000008687": "Deqin County",
        "P_YS_FED_IMP_IOT0000006027": "Xinfeng County",
        "P_YS_FED_IMP_IOT0000007358": "Fenyang City",
        "P_YS_FED_IMP_IOT0000006029": "Chongyi County",
        "P_YS_FED_FW_0000021795": "Display Date",
        "P_YS_FED_IMP_IOT0000008681": "Wuzhong District",
        "P_YS_QMS_QMS-QIT-WALSIN-MD_1545738062544242278": "Selection",
        "P_YS_FED_FW_0000021796": "Confirm to delete",
        "P_YS_FED_FW_0000021793": "No data in the original gridmodel",
        "P_YS_FED_IMP_IOT0000006020": "Ulanhot",
        "P_YS_FED_IMP_IOT0000007351": "Yu'an District",
        "P_YS_OA_app_xtyyjm_0000035760": "Select Year",
        "P_YS_FED_FW_0000021794": "Select the menus to add to My Favorites",
        "P_YS_FED_IMP_IOT0000007350": "Luyi County",
        "P_YS_FED_FW_0000021799": "Saving",
        "P_YS_FED_IMP_IOT0000008685": "Longshan County",
        "P_YS_FED_IMP_IOT0000007352": "Panyu District",
        "P_YS_FED_IMP_IOT0000008686": "Xingren County",
        "P_YS_FED_FW_0000021797": "No summary field set in the report. Please check",
        "P_YS_FED_IMP_IOT0000006024": "Luojiang District",
        "P_YS_FED_IMP_IOT0000008683": "Tang County",
        "P_YS_FED_FW_0000021798": "Large screen slideshow: error in calling service  json.message",
        "P_YS_FED_IMP_IOT0000008684": "Xuanhua District",
        "P_YS_SD_UDHWN_0000048515": "Baoting Li and Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000007346": "Pingshan County",
        "P_YS_FED_IMP_IOT0000008678": "Chancheng District",
        "P_YS_FED_IMP_IOT_0000724719": "Org Chart",
        "P_YS_FED_IMP_IOT0000006017": "Yuanqu County",
        "P_YS_FED_IMP_IOT0000007348": "Gacha County",
        "P_YS_FED_IMP_IOT0000008676": "Mianchi County",
        "P_YS_FED_IMP_IOT0000006016": "Ruzhou",
        "P_YS_FED_IMP_IOT0000008677": "Pingdu City",
        "P_YS_FED_IMP_IOT0000006019": "Please search",
        "P_YS_FED_IMP_IOT0000008671": "Dapu County",
        "P_YS_FED_IMP_IOT0000006011": "Weicheng District",
        "P_YS_FED_IMP_IOT0000007342": "Mentougou District",
        "P_YS_FED_IMP_IOT0000008674": "Xinhui District",
        "P_YS_FED_IMP_IOT0000007341": "Helong",
        "P_YS_FED_IMP_IOT0000008675": "Turpan City",
        "P_YS_FED_IMP_IOT_0000724715": "test",
        "P_YS_FED_IMP_IOT0000008672": "Xinzheng",
        "P_YS_FED_FW_0001228293": "Cannot edit the Doc",
        "P_YS_FED_IMP_IOT_0000724713": "test",
        "P_YS_SD_UDHWN_0000048524": "Yushu City",
        "P_YS_OA_app_xtyyjm_0000035788": "Published",
        "P_YS_FED_FW_0000021780": "Cannot modify associated fields",
        "P_YS_FED_FW_0000021781": "The page you are browsing is missing",
        "P_YS_FED_IMP_IOT0000007335": "Mazhangqu",
        "P_YS_FED_IMP_IOT0000008667": "Li County",
        "P_YS_FED_IMP_IOT0000009998": "Laishui County",
        "P_YS_FED_IMP_IOT_0000724709": "test",
        "P_YS_FED_FW_0000021779": "Outer Radius Percentage",
        "P_YS_FED_IMP_IOT0000008665": "Lanping Bai and Pumi Autonomous County",
        "P_YS_FED_IMP_IOT0000007339": "Shizuishan",
        "P_YS_FED_IMP_IOT0000006008": "Xundian Hui and Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000006007": "Yi'an County",
        "P_YS_FED_IMP_IOT0000007338": "Huangpu District",
        "P_YS_PF_GZTSYS_0000013564": "Other Goods Issue",
        "P_YS_FED_FW_0000021773": "Insert Line at Top",
        "P_YS_OA_XTLCZX_0000030306": "Multi-choice",
        "P_YS_FED_IMP_IOT0000009990": "Liucheng County",
        "P_YS_FED_FW_0000021774": "French",
        "P_YS_FED_IMP_IOT0000008660": "Hua'an County",
        "P_YS_FED_FW_0000021771": "Branch",
        "P_YS_FED_FW_0000021772": "Duplicated Info entered. Please check",
        "P_YS_FED_FW_0000021777": "Exclude",
        "P_YS_FED_IMP_IOT0000006000": "Mile County",
        "P_YS_FED_IMP_IOT0000009994": "Qilian County",
        "P_YS_FED_FW_0000021778": "Display Scale",
        "P_YS_FED_IMP_IOT0000007330": "Muling",
        "P_YS_FED_FW_0000021775": "Longitude",
        "P_YS_FED_IMP_IOT0000006002": "Longmatan District",
        "P_YS_FED_IMP_IOT0000008661": "Liunan District",
        "P_YS_FED_IMP_IOT0000009992": "Dangxiong County",
        "P_YS_FED_FW_0000021776": "User-defined Criteria List",
        "P_YS_FED_IMP_IOT0000007332": "Gucheng County",
        "P_YS_FED_IMP_IOT0000008662": "Zhuanglang County",
        "P_YS_FED_IMP_IOT0000009993": "Dongcheng District",
        "P_YS_FED_IMP_IOT_0000724702": "Last",
        "P_YS_OA_PACK_0001100802": "Please upload files",
        "P_YS_PF_PRINT_0000057628": "Detail User-defined Field 3",
        "P_YS_PF_PRINT_0000057627": "Detail User-defined Field 4",
        "P_YS_FED_FW_0000021791": "Triggered once every  day(s)",
        "P_YS_PF_PRINT_0000057624": "Detail User-defined Field 5",
        "P_YS_FED_FW_0000021792": "Preview",
        "P_YS_PF_PRINT_0000057622": "Detail User-defined Field 6",
        "P_YS_FED_FW_0000021790": "Jiao",
        "P_YS_SD_UDHWN_0000049869": "Qiongzhong Li and Miao Autonomous County",
        "P_YS_PF_PRINT_0000057621": "Detail User-defined Field 1",
        "P_YS_PF_PRINT_0000057620": "Detail User-defined Field 2",
        "P_YS_FED_IMP_IOT0000009987": "Xingning District",
        "P_YS_FED_IMP_IOT0000007323": "Manas County",
        "P_YS_FED_IMP_IOT0000009986": "Korla",
        "P_YS_FED_IMP_IOT0000007328": "Qianshan District",
        "P_YS_FED_IMP_IOT0000009989": "Bayuquan District",
        "P_YS_FED_IMP_IOT0000007329": "Longyang District",
        "P_YS_FED_IMP_IOT0000008659": "Anyang County",
        "P_YS_FED_FW_0000021784": "Confirm to enable the subscription?",
        "P_YS_FED_FW_0000021785": "Include",
        "P_YS_FED_FW_0000021782": "Only one field can be displayed for the rolling count display mode",
        "P_YS_FED_FW_0000021783": "Save Draft",
        "P_YS_HR_HRRCPDF_0000058740": "Search History",
        "P_YS_FED_FW_0000021788": "Please select group item",
        "P_YS_FED_IMP_IOT0000008652": "Zhaoyuan",
        "P_YS_FED_FW_0000021789": "Second",
        "P_YS_FED_IMP_IOT0000008653": "Longlin Autonomous County",
        "P_YS_FED_IMP_IOT0000009984": "Cooperation City",
        "P_YS_FED_FW_0000021786": "Hot Zone Info",
        "P_YS_FED_IMP_IOT0000008650": "Huazhou",
        "P_YS_FED_FW_0000021787": "Obtain graph report  /report/list Current List request end time (second) =",
        "P_YS_FED_IMP_IOT0000008651": "Dacheng County",
        "P_YS_OA_app_xtyyjm_0000035798": "Synchronize",
        "P_YS_FED_IMP_IOT0000009977": "Downtown area",
        "P_YS_FED_IMP_IOT0000007315": "Xuanwu District",
        "P_YS_FED_IMP_IOT0000008643": "Tiexi District",
        "P_YS_FED_IMP_IOT0000007314": "Nanmulin County",
        "P_YS_FED_IMP_IOT0000008644": "Pixian",
        "P_YS_FED_IMP_IOT0000009975": "Yongshan County",
        "P_YS_FED_IMP_IOT0000008649": "Pucheng County",
        "P_YS_FED_IMP_IOT0000009978": "Ulathouqi",
        "P_YS_FED_IMP_IOT0000007318": "Fangshan District",
        "P_YS_FED_IMP_IOT0000008648": "Changli County",
        "P_YS_IPAAS_UCG_0001072863": "Security",
        "P_YS_FED_IMP_IOT0000008641": "Longshan District",
        "P_YS_FED_IMP_IOT0000008642": "Huaping County",
        "P_YS_FED_IMP_IOT0000007311": "Jianggan District",
        "P_YS_FED_IMP_IOT0000009971": "Xigang District",
        "P_YS_FED_IMP_IOT0000007309": "Shufu County",
        "P_YS_FED_IMP_IOT0000007302": "Zhenba County",
        "P_YS_FED_IMP_IOT0000008634": "Qitai County",
        "P_YS_FED_IMP_IOT0000009965": "Heshun County",
        "P_YS_FED_IMP_IOT0000007301": "Mingguang",
        "P_YS_FED_IMP_IOT0000008635": "Erqi District",
        "P_YS_FED_FW_0001084078": "Sensitive Data",
        "P_YS_FED_IMP_IOT0000007304": "Suifenhe",
        "P_YS_FED_IMP_IOT0000009964": "Yongsheng County",
        "P_YS_FED_IMP_IOT0000009969": "Datong District",
        "P_YS_FED_IMP_IOT0000007308": "Juchao District",
        "P_YS_FED_IMP_IOT0000007307": "Golmud",
        "P_YS_FED_IMP_IOT0000009961": "Qingyun County",
        "P_YS_FED_IMP_IOT0000009962": "Huiyang District",
        "P_YS_FED_IMP_IOT0000010906": "Fengxiang County",
        "P_YS_PF_PRINT_0000057651": "Coll. Method Summary",
        "P_YS_FED_IMP_IOT0000008629": "Changyuan County",
        "P_YS_FED_IMP_IOT0000008624": "Yuncheng County",
        "P_YS_FED_IMP_IOT0000009955": "Yanshan District",
        "P_YS_FED_IMP_IOT0000010911": "Guanxian",
        "P_YS_FED_IMP_IOT0000009952": "Wannian County",
        "P_YS_FED_IMP_IOT0000010912": "Zhenhai District",
        "P_YS_FED_IMP_IOT0000008622": "Yingshouyingzi mining area",
        "P_YS_FED_IMP_IOT0000010913": "Luwan District",
        "P_YS_FED_IMP_IOT0000009958": "Lu County",
        "P_YS_FED_IMP_IOT0000009959": "Longzi County",
        "P_YS_FED_FW_0001084085": "Sensitive Data Group",
        "P_YS_FED_IMP_IOT0000008625": "Jiangyan",
        "P_YS_FED_IMP_IOT0000009956": "Tonghe County",
        "P_YS_FED_IMP_IOT0000008626": "Haining",
        "P_YS_FED_IMP_IOT0000010919": "Chongxin County",
        "P_YS_IMP_WJM-UI_0001114297": "Grandson Table",
        "P_YS_OA_XTMENHUCMS_0000044952": "Foshan",
        "P_YS_FED_IMP_IOT0000010914": "Daozhen Gelao and Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000008620": "Xiufeng District",
        "P_YS_FI_AR_0001121578": "Processing",
        "P_YS_FED_IMP_IOT0000010916": "Xiuning County",
        "P_YS_FED_IMP_IOT0000010917": "Babu District",
        "P_YS_FED_IMP_IOT0000008618": "Tumutyouqi",
        "P_YS_FED_FW_0001280803": "1. You can send a link to invite others to join in entry of the Doc",
        "P_YS_FED_IMP_IOT0000008610": "Nanshan District",
        "P_YS_FED_IMP_IOT0000010924": "Batang County",
        "P_YS_FED_IMP_IOT0000008616": "Zhangdian District",
        "P_YS_FED_IMP_IOT0000008617": "Qinyang",
        "P_YS_FED_IMP_IOT0000009946": "Lingshan County",
        "P_YS_FED_IMP_IOT0000010920": "Xingning",
        "P_YS_SD_UDHWN_0000049828": "Shennongjia Forest District",
        "P_YS_FED_IMP_IOT0000010925": "Wuhe County",
        "P_YS_FED_IMP_IOT0000009940": "Jiangxia District",
        "P_YS_FED_IMP_IOT0000010927": "De'an County",
        "P_YS_FED_IMP_IOT0000010928": "Pengxi County",
        "P_YS_HR_HRCOREF_0000058484": "Education",
        "P_YS_FED_FW_1588016191592464396": "[Save All] button moved here from the top right corner",
        "P_YS_FED_FW_1588016191592464393": "Button position update oh ~",
        "P_YS_FED_FW_0000021957": "Splitting Dir",
        "P_YS_FED_EXAMP_0000019896": "Failed to refund via POS terminal:",
        "P_YS_FED_FW_0000021958": "Monitoring View Chart Settings",
        "P_YS_FED_EXAMP_0000019895": "No standard weight Info",
        "P_YS_FED_FW_0000021955": "Auto refresh interval set for the summary area is too short. refreshInterval",
        "P_YS_FED_EXAMP_0000019894": "Replenishment date cannot be earlier than booking date",
        "P_YS_FED_IMP_IOT0000010813": "Yu County",
        "P_YS_FED_FW_0000021956": "Failed to save the large screen solution. err",
        "P_YS_FED_EXAMP_0000019893": "Please enter product first",
        "P_YS_HR_HRPUBF_0001009300": "No matching result",
        "P_YS_FED_EXAMP_0000019899": "Cannot modify retail prices in replacement lines during original order return",
        "P_YS_FED_FW_0000021959": "Control",
        "P_YS_FED_EXAMP_0000019898": "Doc held successfully:",
        "P_YS_FED_EXAMP_0000019897": "Error in querying cache data",
        "P_YS_FED_IMP_IOT0000009814": "Binhai County",
        "P_YS_FED_IMP_IOT0000010810": "Keshiketeng Qi",
        "P_YS_FED_IMP_IOT0000010819": "Taipusi Banner",
        "P_YS_FED_FW_0000021950": "10.0",
        "P_YS_FED_FW_0000021953": "Background picture is required",
        "P_YS_FED_EXAMP_0000019892": "Member Card No.",
        "P_YS_FED_FW_0000021954": "System items are not allowed to be designed",
        "P_YS_FED_EXAMP_0000019891": "The network is unavailable. You must use the account used for last login",
        "P_YS_FED_IMP_IOT0000010816": "Dachang Hui Autonomous County",
        "P_YS_FED_FW_0000021951": "Thousand",
        "P_YS_FED_EXAMP_0000019890": "Business Type is required",
        "P_YS_FED_IMP_IOT0000010817": "Yuanba District",
        "P_YS_FED_FW_0000021952": "Project No.",
        "P_YS_FED_IMP_IOT0000010818": "Yuehu District",
        "P_YS_FED_IMP_IOT0000009809": "Huixian",
        "P_YS_FED_FW_0000021968": "Jump to Index =",
        "P_YS_FED_IMP_IOT0000009800": "Luntai County",
        "P_YS_FED_FW_0000021969": "Upload Picture",
        "P_YS_FED_IMP_IOT0000009801": "Suiyang District",
        "P_YS_FED_FW_0000021966": "menuUrl is blank",
        "P_YS_FED_FW_0000021967": "Comparison Operator",
        "P_YS_FED_IMP_IOT0000010825": "Dadong District",
        "P_YS_FED_IMP_IOT0000009804": "Laiyang",
        "P_YS_FED_IMP_IOT0000009805": "Linzhou County",
        "P_YS_FED_IMP_IOT0000010820": "Nan'ao County",
        "P_YS_FED_FW_0000021960": "Add Line",
        "P_YS_FED_FW_0000021961": "Failure Info",
        "P_YS_FED_FW_0000021964": "Please check if the above Info is correct and confirm that the devices in the room are in good condition. Do not take any accessory items. If there is no problem, please sign for confirmation. Thank you",
        "P_YS_FED_FW_0000021965": "eChartDisplay  Status changed  shouldComponentUpdate  Query Criteria  changed End True",
        "P_YS_FED_FW_0000021962": "Display",
        "P_YS_FED_FW_0000021963": "Auto refresh interval set for the large screen summary area is too short. refreshInterval",
        "P_YS_FED_IMP_IOT0000010829": "Pengzhou",
        "P_YS_FED_FW_0000177590": "Inherit Orig. Report Permissions",
        "P_YS_FED_FW_0000177591": "Update",
        "P_YS_FED_FW_0000177592": "Cannot cancel formula reference",
        "P_YS_FED_FW_0000177593": "Please select PC terminal or mobile App",
        "P_YS_FED_FW_0000177594": "Cannot clear formulas",
        "P_YS_FED_FW_0000177595": "Chinese",
        "P_YS_FED_UCFBASEDOC_0000025160": "Permission",
        "P_YS_FED_FW_0000177596": "Already referenced by this formula. Circular reference is not allowed",
        "P_YS_FED_FW_0000021935": "Please select a line and add",
        "P_YS_FED_IMP_IOT0000010833": "Yuquan District",
        "P_YS_FED_IMP_IOT0000010834": "Longsheng Autonomous County",
        "P_YS_FED_FW_0000021933": "Large screen solution  Design  getDesignColType_Title curCol",
        "P_YS_FED_IMP_IOT0000010835": "Nayong County",
        "P_YS_FED_FW_0000021934": "Filtering Expression Desc.:",
        "P_YS_FED_IMP_IOT0000010836": "Gengma Dai and Wa Autonomous County",
        "P_YS_FED_FW_0000021939": "OK",
        "P_YS_FED_IMP_IOT0000010830": "Feidong County",
        "P_YS_FED_FW_0000021937": "Inner/Outer Radius",
        "P_YS_FED_FW_0000021938": "Enter the content to search",
        "P_YS_FED_FW_0000177586": "Formula alias is required",
        "P_YS_FED_FW_0000177587": "Precision Value",
        "P_YS_FED_FW_0000177588": "Confirm to delete this custom formula?",
        "P_YS_FED_FW_0000177589": "Cannot modify this property for non-numeric columns",
        "P_YS_FED_FW_0000021931": "New Filter Item",
        "P_YS_FED_IMP_IOT0000010837": "Rongcheng",
        "P_YS_FED_FW_0000021932": "Please enter company name",
        "P_YS_FED_FW_0000021930": "Line Chart",
        "P_YS_FED_FW_0001152737": "Import Record",
        "P_YS_FED_FW_0001152738": "View Import History",
        "P_YS_FED_FW_0000021946": "No column Info selected",
        "P_YS_FED_IMP_IOT0000010844": "Butuo County",
        "P_YS_FED_FW_0000021947": "Multi-language",
        "P_YS_FED_FW_0000021944": "Add Graph Report",
        "P_YS_FED_FW_0000021945": "Hot zone display picture  Initialize cStyle =",
        "P_YS_FED_FW_0000021948": "Category",
        "P_YS_FED_FW_0000021949": "Max length is 50 chars",
        "P_YS_FED_FW_0000177597": "Upgrade",
        "P_YS_FED_FW_0000177598": "The current menu already exists. Overwrite the settings in the PC terminal?",
        "P_YS_FED_FW_0000177599": "Get again?",
        "P_YS_OA_XTMENHUCMS_0000044985": "Component",
        "P_YS_FED_FW_0000021942": "Report settings will not automatically refresh. refreshInterval",
        "P_YS_FED_FW_0000021943": "Component",
        "P_YS_FED_FW_0000021940": "Board Config. Info - Module Config. - Summary",
        "P_YS_FED_FW_0001367218": "Check Matching Item",
        "P_YS_FED_FW_0000021941": "German",
        "P_YS_FED_FW_0001367219": "Uncheck Matching Item",
        "P_YS_PF_PROCENTER_0000027267": "Default Org",
        "P_YS_PF_PROCENTER_0000027268": "Settle",
        "P_YS_SD_SDOC-UI_0000175089": "Closed Status",
        "P_YS_PF_PROCENTER_0000027262": "Save as Draft",
        "P_YS_FED_EXAMP_0000019849": "Cannot execute the lowest price in the current network status",
        "P_YS_FED_EXAMP_0000019848": "Cannot add product again",
        "P_YS_FED_EXAMP_0000019847": "Product line exists. Cannot perform",
        "P_YS_FED_EXAMP_0000019846": "Settlement Rate",
        "P_YS_FED_FW_0001271292": "No change record",
        "P_YS_FED_EXAMP_0000020830": "Cannot sell cards under the current business type",
        "P_YS_FED_EXAMP_0000019852": "Actual received Amt is not equal to A/R Amt",
        "P_YS_FED_EXAMP_0000019851": "Failed to obtain print template:",
        "P_YS_FED_FW_0000021999": "Corresponding row",
        "P_YS_FED_EXAMP_0000019850": "Brand List",
        "P_YS_FED_EXAMP_0000020832": "Non-original Order Return",
        "P_YS_FED_IMP_IOT0000010857": "Wenfeng District",
        "P_YS_FED_EXAMP_0000020831": "Every-other-day Delivery",
        "P_YS_FED_EXAMP_0000019856": "Failed to obtain point Info. Info:",
        "P_YS_FED_IMP_IOT0000010851": "Nie Rong County",
        "P_YS_FED_EXAMP_0000019855": "Price",
        "P_YS_FED_EXAMP_0000019854": "Current line will not participate in discount calculation or the Amt is 0. Cannot execute on-site discount",
        "P_YS_FED_EXAMP_0000019853": "The current operator does not have the permission of setting on-site discount for this type of product",
        "P_YS_FED_IMP_IOT0000010854": "Ningcheng County",
        "P_YS_FED_FW_0000021993": "No corresponding value",
        "P_YS_FED_EXAMP_0000020838": "Please enter the card/voucher No. for card/voucher product",
        "P_YS_FED_FW_0000021994": "Set as Default",
        "P_YS_FED_EXAMP_0000020837": "User-defined type. Cannot delete line",
        "P_YS_SD_SDMAUF_0000152050": "Add Icon",
        "P_YS_FED_FW_0000021991": "Error in preset cEnumString",
        "P_YS_FED_FW_0000021992": "Exception returned from the service when getting a list of all grouping schemes in the report",
        "P_YS_FED_EXAMP_0000020839": "Product Qty",
        "P_YS_FED_FW_0000021997": "Data Template Mgmt",
        "P_YS_FED_EXAMP_0000020834": "My To-do",
        "P_YS_FED_FW_0000021998": "Data unchanged",
        "P_YS_FED_EXAMP_0000020833": "Auto promotion canceled successfully",
        "P_YS_FED_FW_0000021995": "Upload Background Picture",
        "P_YS_FED_EXAMP_0000020836": "Failed to obtain neighboring inventory. Info:",
        "P_YS_FED_FW_0000021996": "Ext. Type Name_",
        "P_YS_FED_EXAMP_0000020835": "Employee",
        "P_YS_FED_FW_0001050721": "Confirm to delete \"<%=cShowCaptionName%>\"?",
        "P_YS_SD_SDMAUF_0000152068": "No Info",
        "P_YS_FED_UCFBASEDOC_0000025132": "Open",
        "P_YS_FED_FW_0001050720": "Edit <%=templateName%>",
        "P_YS_FED_UCFBASEDOC_0000025130": "No more than 100 chars",
        "P_YS_FED_EXAMP_0000019859": "The available balance of member wallet is insufficient",
        "P_YS_FED_EXAMP_0000019858": "Header discount has been executed, and single line discount cannot be executed. Please cancel discount and try again",
        "P_YS_FED_IMP_IOT0000010860": "Liangzhou District",
        "P_YS_FED_EXAMP_0000019857": "Hardware Device Adaptation",
        "P_YS_FED_IMP_IOT0000010861": "Erdaojiang District",
        "P_YS_FED_EXAMP_0000019863": "Value",
        "P_YS_FED_EXAMP_0000020841": "No customer is entered, and only full Amt collection is allowed. Continue?",
        "P_YS_FED_EXAMP_0000019862": "Please enter the member to top up first",
        "P_YS_FED_EXAMP_0000020840": "s specification",
        "P_YS_FED_EXAMP_0000019861": "Batch No. is required in the detail lines with batch management enabled",
        "P_YS_FED_EXAMP_0000020843": "Notice Post",
        "P_YS_FED_FW_1535342643957989385": "按钮点击，调用RadioButtonGroup组件内部handleButtonClick方法开始",
        "P_YS_FED_EXAMP_0000020842": "Cannot modify the Qty of product subject to SN control",
        "P_YS_FED_EXAMP_0000019860": "Please fill in the value to change",
        "P_YS_FED_IMP_IOT0000010869": "Longde County",
        "P_YS_FED_EXAMP_0000019867": "The current line cannot be deleted",
        "P_YS_FED_EXAMP_0000019866": "Please select the same customer for settlement",
        "P_YS_FED_FW_0001062705": "voucher->do——",
        "P_YS_FED_EXAMP_0000019865": "Cannot pay via prepaid cards under the stored value business type",
        "P_YS_FED_EXAMP_0000019864": "No product selected. Cannot delete line",
        "P_YS_FED_IMP_IOT0000010865": "Chahar Youyiqianqi",
        "P_YS_FED_EXAMP_0000020849": "Cannot modify retail price during adjustment",
        "P_YS_FED_FW_0001204460": "Unsupported",
        "P_YS_FED_EXAMP_0000020848": "Cannot modify Qty during member wallet top-up",
        "P_YS_FED_FW_0001469273": "There're changes that have not yet taken effect for the Org, and changes cannot be made again. Please try again after the changes take effect or when they are deleted",
        "P_YS_FED_EXAMP_0000020845": "￥",
        "P_YS_FED_EXAMP_0000020844": "No business type entered. Please check",
        "P_YS_FED_EXAMP_0000020847": "Cannot find product Info",
        "P_YS_FED_EXAMP_0000020846": "s card/voucher number. Cannot execute",
        "P_YS_FED_EXAMP_0000019869": "Kitchen printing cannot be performed when cache settings is enabled. Continue?",
        "P_YS_FED_IMP_IOT0000010871": "Hualong Hui Autonomous County",
        "P_YS_FED_EXAMP_0000019868": ": refers to product that are booked first and then processed, received, and sold according to the orders, such as cakes, jewelry, and other customized products; these product are controlled by the business parameter \"Allow Negative Issue\", but they support negative available Qty.",
        "P_YS_FED_IMP_IOT0000010872": "Youyu County",
        "P_YS_FED_FW_0000021979": "2. The text, date, enumeration, and file type fields do not support four arithmetic operations and comparison operations (except for =, !=). Therefore, these types of fields are generally used as expressions, or form equality expressions or simple logical expressions.",
        "P_YS_FED_EXAMP_0000020852": "Prepaid Card Top-up",
        "P_YS_FED_EXAMP_0000019874": "It's prompted that the voucher Amt will exceed the A/R Amt. Continue?",
        "P_YS_FED_IMP_IOT0000010877": "Runan County",
        "P_YS_FED_EXAMP_0000019873": "Prepaid Card - Sell Card",
        "P_YS_FED_EXAMP_0000020851": "Sample doesn't support matching",
        "P_YS_FED_FW_0000021977": "There is a filtering line with the filter field or operator being empty. Please check",
        "P_YS_FED_EXAMP_0000020854": "Please enter the card/voucher No. for original order return of card/voucher product",
        "P_YS_FED_EXAMP_0000019872": "Package Qty",
        "P_YS_FED_FW_0000021978": "Cover Page",
        "P_YS_FED_EXAMP_0000020853": "Sales Analysis",
        "P_YS_FED_EXAMP_0000019871": "Delete",
        "P_YS_FED_EXAMP_0000019878": "A/R Amt must be greater than or equal to 0",
        "P_YS_FED_EXAMP_0000019877": "Member wallet does not apply to all product or the available balance is insufficient",
        "P_YS_FED_IMP_IOT0000010874": "Jinyun County",
        "P_YS_FED_EXAMP_0000019876": "Failed to obtain the current SN, which cannot be automatically specified. Please check",
        "P_YS_FED_EXAMP_0000020850": "No product line to execute on-site discount",
        "P_YS_FED_IMP_IOT0000010875": "Lufeng County",
        "P_YS_FED_EXAMP_0000019875": "Cannot be executed in booked status",
        "P_YS_FED_IMP_IOT0000010876": "Chahar Youyizhongqi",
        "P_YS_FED_FW_0000021971": "Display Name",
        "P_YS_FED_FW_0000021972": "Failed to match the currently modified 2-D table cells with any row in the 1-D table. Please check. data  =",
        "P_YS_FED_FW_0001050719": "View <%=templateName%>",
        "P_YS_FED_FW_0000021975": "Only JPG, JPEG, BMP and PNG formats are supported; picture size should be less than 1M (recommended size: 144*60px)",
        "P_YS_FED_FW_0000021976": "Multiple rows of 1-D table matched. Please check. rows =",
        "P_YS_FED_FW_0000021973": "Filter Criteria",
        "P_YS_FED_FW_0000021974": "Display indicators are required (you can select up to 5 indicators)",
        "P_YS_SD_UDHWN_0000047368": "Alar",
        "P_YS_FED_FW_0000021990": "No. of auxiliary dimension lines cannot exceed 99",
        "P_YS_FED_IMP_IOT0000010882": "Lueyang County",
        "P_YS_FED_FW_1509407191866540036": "The text content exceeds the max length limit. Please modify",
        "P_YS_FED_EXAMP_0000019879": "Please enter a number in the Retail Price field",
        "P_YS_OA_XTHUATI_0000046180": "Single Choice",
        "P_YS_FED_EXAMP_0000019885": "Decimal Digits of Qty",
        "P_YS_FED_IMP_IOT0000010888": "Longting District",
        "P_YS_FED_EXAMP_0000019884": "Member wallet not enabled",
        "P_YS_FED_IMP_IOT0000010889": "Yao'an County",
        "P_YS_FED_FW_0000021988": "Mobile Display",
        "P_YS_FED_EXAMP_0000019883": "Cannot find the card/voucher No. Info",
        "P_YS_FED_FW_0000021989": "Ref Returned Field",
        "P_YS_FED_EXAMP_0000019882": "Cannot add product of online retailers when the product are not allowed be modified upon delivery",
        "P_YS_FED_EXAMP_0000019889": "Default Ship-to Address",
        "P_YS_FED_IMP_IOT0000010884": "Tashkurgan Tajik Autonomous County",
        "P_YS_FED_FW_1546381431444340739": "点击按钮或按下空格键还原视图",
        "P_YS_FED_EXAMP_0000019888": "You do not have the function permission of the Qty button. Cannot operate",
        "P_YS_FED_EXAMP_0000019887": "Online retailer settlement succeeded",
        "P_YS_FED_IMP_IOT0000010886": "Fengkai County",
        "P_YS_FED_EXAMP_0000019886": "Prepaid Card",
        "P_YS_FED_FW_0000021982": "Option and primary dimension are mutually exclusive",
        "P_YS_FED_FW_0000021983": "Please enter template name",
        "P_YS_FED_UCFBASEDOC_0000025108": "Click to query sales static reports",
        "P_YS_FED_FW_0000021980": "Already used in graph reports, and cannot be deleted",
        "P_YS_FED_FW_0000021981": "Default Value",
        "P_YS_FED_FW_0000021986": "Large screen slideshow: template obtained. Template ID =",
        "P_YS_FED_EXAMP_0000019881": "Reason for Off-shelf:",
        "P_YS_FED_EXAMP_0000019880": "Please pay the remaining Amt",
        "P_YS_FED_UCFBASEDOC_0000025104": "Withdraw",
        "P_YS_FED_FW_0000021984": "E-mail (O)",
        "P_YS_FED_FW_0000021985": "Draft deleted successfully",
        "P_YS_SD_SDMBF_0000141424": "Online Store",
        "P_YS_FED_UCFORG_0000025904": "Confirm to disable the Org and its subordinate Orgs and Depts?",
        "P_YS_PF_PRINT_0000064968": "Cum. Pmt Amt",
        "P_YS_SCM_USTOCK_0001084187": "Expected to Be Completed",
        "P_YS_FED_IMP_IOT0000010899": "Yintai District",
        "P_YS_SCM_USTOCK_0001084186": "On-time completion rate: No. of order lines completed on time in the selected time range/Total of order lines.",
        "P_YS_FED_FW_0001321828": "Missing assignComp",
        "P_YS_FED_IMP_IOT0000010897": "Boli County",
        "P_YS_FED_IMP_IOT0000010898": "Shengsi County",
        "P_YS_FED_FW_0001321820": "Reset Column Width",
        "P_YS_SD_UDHMC_0000050989": "¥",
        "P_YS_FED_EXAMP_0000020809": "Operator",
        "P_YS_FED_EXAMP_0000020808": "Name",
        "P_YS_FED_FW_0001186101": "Proxy interface failed:",
        "P_YS_FED_FW_0000153548": "Opening Coll. Header",
        "P_YS_FED_EXAMP_0000020805": "Return Info",
        "P_YS_FED_EXAMP_0000020804": "] retail price is not conforming to the reduction/exemption Amt in the voucher file. Please check",
        "P_YS_FED_EXAMP_0000020807": "Org",
        "P_YS_FED_EXAMP_0000020806": "Select payment method",
        "P_YS_FED_EXAMP_0000020800": "Failed to open cashbox",
        "P_YS_FED_EXAMP_0000020803": "The status is order delivery and Allow to modify product upon delivery is set to No. Cannot pay with prepaid card",
        "P_YS_FED_EXAMP_0000020802": "Replenishment",
        "P_YS_FED_EXAMP_0000020819": "The new password cannot be the same as the old one",
        "P_YS_FED_EXAMP_0000020810": "Product return pending approval",
        "P_YS_FED_EXAMP_0000019834": "No salesperson selected",
        "P_YS_FED_EXAMP_0000019833": ".",
        "P_YS_FED_EXAMP_0000019832": ", ",
        "P_YS_FED_EXAMP_0000020816": "Invalid store name/type",
        "P_YS_FED_EXAMP_0000020815": "Failed to obtain tree structure: [interface]",
        "P_YS_FED_EXAMP_0000020818": "Product line exists. Cannot customize",
        "P_YS_FED_EXAMP_0000020817": "Product storage bin is required",
        "P_YS_FED_EXAMP_0000020812": "Discount after adjustment is required",
        "P_YS_FED_EXAMP_0000020811": ", product",
        "P_YS_FED_EXAMP_0000020814": "Entered [",
        "P_YS_FED_EXAMP_0000020813": "Canceled successfully",
        "P_YS_FED_FW_0001007915": "No search result",
        "P_YS_FED_FW_0001149184": "You can set 5 search columns at most",
        "P_YS_FED_EXAMP_0000019838": "Cannot modify the Qty in the current line",
        "P_YS_PF_PRINT_0000064959": "Print Info",
        "P_YS_FED_EXAMP_0000019837": "Failed to obtain online auto printing data",
        "P_YS_FED_EXAMP_0000019836": "Not sold. Cannot return card",
        "P_YS_FED_EXAMP_0000019835": "The member has no point",
        "P_YS_FED_EXAMP_0000019839": "Yesterday",
        "P_YS_FED_EXAMP_0000019841": "Points used must be greater than or equal to",
        "P_YS_FED_EXAMP_0000019840": "And booked",
        "P_YS_FED_EXAMP_0000020821": "Deposit is less than the predetermined proportional Amt",
        "P_YS_FED_EXAMP_0000020820": "Max Change Amt:",
        "P_YS_FED_EXAMP_0000019845": "Changping Store",
        "P_YS_HR_HRCOREF_0000058401": "Please select birth date",
        "P_YS_FED_EXAMP_0000019844": "Retail Amt in retail Doc is not equal to total product line Amt. Retail Amt:",
        "P_YS_FED_FW_0001387688": "图表不能正常显示，需要 report/getGroupSetting(获取报表分组方案的详细设置进行显示) 返回的配置信息中 isEmpty(json.data.chartConfig) == false",
        "P_YS_FED_EXAMP_0000019843": "Weight cannot be empty or 0",
        "P_YS_FED_EXAMP_0000019842": "Point deduction cannot be executed",
        "P_YS_FED_EXAMP_0000020827": "Refund Amt should be less than Amt to refund",
        "P_YS_FED_EXAMP_0000020826": "Storage bins are required in the warehouse lines with storage bin management enabled. Please check",
        "P_YS_FED_EXAMP_0000020829": "Demand Application",
        "P_YS_FED_EXAMP_0000020828": "Weight cannot be blank or 0",
        "P_YS_FED_EXAMP_0000020823": "Info modified successfully",
        "P_YS_FED_EXAMP_0000020822": "Cannot change line",
        "P_YS_FED_FW_0000154897": "Error in simulating in designing status",
        "P_YS_FED_EXAMP_0000020825": "Neighboring Inv",
        "P_YS_FED_EXAMP_0000020824": "The prepaid card No. has been entered. Please do not enter it again",
        "P_YS_FED_FW_0000177570": "OTP received",
        "P_YS_FED_FW_0000177571": "Generate New Permissions",
        "P_YS_FED_FW_0000177572": "]. Failed to cache data",
        "P_YS_FED_FW_0000177573": "Formula Name",
        "P_YS_FED_FW_0000177574": "The current menu already exists. Overwrite the settings in the mobile App?",
        "P_YS_SD_UDHMC_0000050930": "—",
        "P_YS_FED_FW_0000021919": "Supports selecting multiple display indicators (you can select up to",
        "P_YS_FED_FW_0000021913": "Alias Code",
        "P_YS_FED_FW_0001061466": "Personal Scheme",
        "P_YS_FED_FW_0000021914": "Current points:",
        "P_YS_FED_FW_0000021911": "Replace Picture",
        "P_YS_FED_FW_0000021912": "Subscription Time Point",
        "P_YS_FED_FW_0000021917": "Graphic Form",
        "P_YS_FED_FW_0000021918": "The names of newly published reports cannot be duplicate with those of system reports",
        "P_YS_FED_FW_0000021916": "Import request has been executed",
        "P_YS_FED_FW_0000177564": "], actual table name [",
        "P_YS_FED_MDF-COMPS_0001573056": "日期时间测试",
        "P_YS_FED_FW_0000177565": " ",
        "P_YS_FED_MDF-COMPS_0001573057": "固定資產檔案導出測試",
        "P_YS_FED_FW_0000177566": "Precision value cannot be less than 0 or greater than 6",
        "P_YS_FED_FW_0000177567": "]. Failed to save data transaction",
        "P_YS_FED_FW_0000177568": "After entering a number, click the button in the back to insert the number",
        "P_YS_FED_FW_0000021910": "The cross-point corresponds to multiple rows in the 1-D table. Please check. data  =",
        "P_YS_FED_FW_0000177569": "], submit table name [",
        "P_YS_FED_MDF-COMPS_0001573058": "z0客户3255830",
        "P_YS_FED_FW_0001061465": "Public Scheme",
        "P_YS_FED_MDF-COMPS_0001573059": "表體-0528test",
        "P_YS_FED_FW_0000177580": "The name already exists in the mobile App. Cannot modify permissions",
        "P_YS_FED_FW_0000177581": "@@db Log @@ [",
        "P_YS_FED_FW_0000177582": "The current menu already exists. Overwrite the settings in the PC terminal and mobile App?",
        "P_YS_FED_FW_0000177583": "The summary item has been",
        "P_YS_FED_FW_0000177584": "The name already exists in the PC terminal. Cannot modify permissions",
        "P_YS_FED_FW_0000177585": "Please enter formula alias",
        "P_YS_FED_FW_0000021924": "Large screen slideshow: start slideshow. Large Screen Qty",
        "P_YS_FED_FW_0000021925": "Insert row before",
        "P_YS_FED_MDF-COMPS_0001573060": "庫存組織",
        "P_YS_FED_FW_0000021922": "You",
        "P_YS_FED_FW_0000021923": "OK",
        "P_YS_FED_FW_0000021928": "Amt Precision",
        "P_YS_FED_MDF-COMPS_0001573063": "產地",
        "P_YS_FED_FW_0000021929": "Column verification passed in configuration Info",
        "P_YS_FED_MDF-COMPS_0001573064": "ycx档案类型",
        "P_YS_FED_FW_0000021926": "Template Mgmt",
        "P_YS_FED_MDF-COMPS_0001573061": "庫管員",
        "P_YS_FED_FW_0000021927": "Add Data Item",
        "P_YS_FED_MDF-COMPS_0001573062": "型號",
        "P_YS_FED_FW_0000177575": "seconds before resending",
        "P_YS_FED_MDF-COMPS_0001573067": "您对必输项设置了隐藏，请注意！",
        "P_YS_FED_FW_0000177576": "The No. of conditions required for a formula cannot be greater than 7",
        "P_YS_FED_MDF-COMPS_0001573068": "交易類型",
        "P_YS_FED_FW_0000177577": "The name already exists in the PC terminal and mobile App. Cannot modify permissions",
        "P_YS_FED_MDF-COMPS_0001573065": "NN表頭數值0630",
        "P_YS_FED_FW_0000177578": "The current menu already exists. Overwrite the settings in the PC terminal?",
        "P_YS_FED_MDF-COMPS_0001573066": "庫存單位",
        "P_YS_FED_FW_0000021920": "Operation succeeded",
        "P_YS_FED_FW_0000177579": "The current menu already exists. Overwrite the settings in the mobile App?",
        "P_YS_FED_FW_0000021921": "Confirm to disable the subscription?",
        "P_YS_FED_MDF-COMPS_0001573069": "表頭-0528test",
        "P_YS_FED_FW_0000177552": "txd - Header Text (enabled on 20190531)",
        "P_YS_FED_UCFBASEDOC_0000025199": "Form",
        "P_YS_FED_FW_0000177560": "Daily Settlement Card",
        "P_YS_FED_FW_0000177561": "This device can be used directly with barcode scanner",
        "P_YS_FED_FW_0000177562": "Failed to parse cParameter",
        "P_YS_FED_FW_0000177563": "Formulas can only be added after selecting the required conditions of the formulas",
        "P_YS_FED_FW_0000021908": "Please select the field to change",
        "P_YS_FED_FW_0000021909": "Please enter a number between 1-5",
        "P_YS_FED_FW_0000021902": "Please enter company e-mail",
        "P_YS_FED_FW_0000021903": "The current operation will undo the previous splitting operation. Continue?",
        "P_YS_FED_FW_0000021900": "Confirm to delete column [",
        "P_YS_FED_FW_0000021901": "Upload Attachment",
        "P_YS_FED_FW_0000021906": "Failed to delete",
        "P_YS_FED_FW_0000021907": "Enter at least one line of data",
        "P_YS_FED_FW_0000021904": "Hot zone display picture  The refresh interval set is too short. Change it to 5 seconds",
        "P_YS_FED_FW_0000021905": "Company",
        "P_YS_FED_FW_0000177553": "{\"0\": \"Not Submitted\", \"1\": \"Submitted\", \"2\": \"Approved\", \"3\": \"Rejected\"}",
        "P_YS_FED_FW_0000177554": "Demand Appl Display Template (Mobile)",
        "P_YS_FED_FW_0000177555": "Business Product Summary Region",
        "P_YS_FED_FW_0000177556": "Product Summary",
        "P_YS_FED_FW_0000177557": "{\"decimal\":\"<%option.amountofdecimal%>\",\"prefix\":\"￥\"}",
        "P_YS_FED_FW_0000177558": "{\"1\": \"Cash Sale\", \"2\": \"Book\", \"3\": \"Delivery\", \"4\": \"Cancel Order\", \"5\": \"Return\", \"6\": \"Other\", \"7\": \"After-sales\"}",
        "P_YS_FED_FW_0000177559": "Daily Settlement Doc (Mobile)",
        "P_YS_FED_FW_0001062762": "Select the template to delete",
        "P_YS_PF_GZTTMP_0000077237": "Model",
        "P_YS_FED_MDF-COMPS_0001573092": "Please select the line to operate",
        "P_YS_FED_MDF-COMPS_0001573093": "z0客户3627661",
        "P_YS_FED_MDF-COMPS_0001573090": "單據編號",
        "P_YS_FED_MDF-COMPS_0001573091": "likun-表頭自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573096": "likun-表體自定義項[文本]",
        "P_YS_FED_MDF-COMPS_0001573097": "必輸，請精確到sku",
        "P_YS_FED_MDF-COMPS_0001573094": "保質期",
        "P_YS_FED_MDF-COMPS_0001573095": "wjl测试自定义项",
        "P_YS_FED_MDF-COMPS_0001573098": "wjl測試自定義項",
        "P_YS_FED_MDF-COMPS_0001573099": "件數",
        "P_YS_FED_FW_1524792374620323848": "The No. of map calls exceeds the limit. Please apply for an independent Amap key",
        "P_YS_SD_SDOC_0001149954": "Problematic Express Item",
        "P_YS_FED_FW_0001047189": "46",
        "P_YS_FED_FW_0001047188": "19",
        "P_YS_OA_app_xtyyjm_0000035823": "Select Month",
        "P_YS_FED_FW_0001047187": "48",
        "P_YS_OA_app_xtyyjm_0000035824": "Ineffective",
        "P_YS_FED_FW_0001047186": "39",
        "P_YS_FED_FW_0001047185": "32",
        "P_YS_FED_FW_0001047184": "35",
        "P_YS_FED_FW_0001047183": "26",
        "P_YS_FED_FW_0001047182": "28",
        "P_YS_FED_FW_0001084171": "Details <NO.",
        "P_YS_FED_FW_0001084172": "Proxy interface request <NO.",
        "P_YS_FED_MDF-COMPS_0001573070": "NN物料查询1",
        "P_YS_FED_MDF-COMPS_0001573071": "The entered number is greater than the max value available. Please select again",
        "P_YS_FED_MDF-COMPS_0001573074": "專案編碼",
        "P_YS_FED_MDF-COMPS_0001573075": "数值型字段",
        "P_YS_FED_MDF-COMPS_0001573072": "數值型字段",
        "P_YS_FED_MDF-COMPS_0001573073": "The entered number is less than the min value available. Please select again",
        "P_YS_FED_MDF-COMPS_0001573078": "Material SKU Code",
        "P_YS_FED_IMP_IOT0000007293": "Ningxiang County",
        "P_YS_FED_MDF-COMPS_0001573079": "自定义项目测试202008060001",
        "P_YS_FED_MDF-COMPS_0001573076": "計量單位",
        "P_YS_FED_MDF-COMPS_0001573077": "固定资产档案导出测试",
        "P_YS_FED_FW_1556701636555440133": "Refresh current page",
        "P_YS_SD_SDMB_0000147545": "Fashion",
        "P_YS_FED_FW_1556701636555440136": "Last refresh time:",
        "P_YS_FED_IMP_IOT0000007297": "Yingshan County",
        "P_YS_FED_FW_0001047199": "48",
        "P_YS_FED_FW_0001047198": "36",
        "P_YS_FED_FW_0001047197": "50",
        "P_YS_FED_IMP_IOT0000007290": "Dafang County",
        "P_YS_FED_FW_0001047196": "44",
        "P_YS_FED_FW_0001047195": "24",
        "P_YS_FED_FW_0001047194": "30",
        "P_YS_FED_IMP_IOT0000007291": "Shishi",
        "P_YS_FED_FW_0001047193": "20",
        "P_YS_FED_FW_0001084182": "Ref code not configured. Please check the configuration",
        "P_YS_FED_FW_0001047192": "33",
        "P_YS_FED_FW_0001465649": "Metadata does not have billNum configured",
        "P_YS_FED_FW_0001047191": "31",
        "P_YS_FED_FW_0001047190": "37",
        "P_YS_FED_MDF-COMPS_0001573081": "業務員",
        "P_YS_FED_MDF-COMPS_0001573082": "时间H",
        "P_YS_FED_MDF-COMPS_0001573080": "Material SKU Name",
        "P_YS_FED_MDF-COMPS_0001573085": "自定義檔案",
        "P_YS_FED_MDF-COMPS_0001573086": "批次號",
        "P_YS_FED_FW_0001084173": "Proxy interface succeeded <NO.",
        "P_YS_FED_MDF-COMPS_0001573083": "跟踪号123",
        "P_YS_FED_FW_0001084174": "Proxy interface failed <NO.",
        "P_YS_FED_MDF-COMPS_0001573084": "likun-表头自定义项[文本]",
        "P_YS_FED_IMP_IOT0000007283": "Huangchuan County",
        "P_YS_FED_MDF-COMPS_0001573089": "門店",
        "P_YS_FED_IMP_IOT0000007285": "Kangping County",
        "P_YS_FED_MDF-COMPS_0001573087": "會計主體",
        "P_YS_FED_MDF-COMPS_0001573088": "NN表头数值0630",
        "P_YS_FED_IMP_IOT0000007289": "Lixia District",
        "P_YS_OA_XTLCZX_0000030451": "Approved By",
        "P_YS_SD_SDMA_0000060759": "Collected",
        "P_YS_FED_FW_0001157538": "(Ctrl+Enter)",
        "P_YS_OA_app_xtyyjm_0000035849": "Show Title",
        "P_YS_FED_IMP_IOT0000007280": "Wugang",
        "P_YS_FED_FW_0001097428": "Configuration parameter error",
        "P_YS_FED_FW_0001145546": "Ctrl+Enter",
        "P_YS_FED_IMP_IOT0000007272": "Weiyang District",
        "P_YS_FED_IMP_IOT0000007274": "Jintan",
        "P_YS_FED_FW_0000177600": "], save data keyPath [",
        "P_YS_FED_IMP_IOT0000007273": "Shandan County",
        "P_YS_FED_IMP_IOT0000007275": "Zhenyuan County",
        "P_YS_FED_IMP_IOT0000007278": "Jingxi County",
        "P_YS_FED_FW_0001031669": "ICBC",
        "P_YS_FED_IMP_IOT0000007270": "Nima County",
        "P_YS_FED_IMP_IOT0000007269": "Hezhang County",
        "P_YS_FED_IMP_IOT0000007268": "Jun County",
        "P_YS_FED_FW_0000177619": "Please enter text:",
        "P_YS_FED_IMP_IOT0000007261": "Xiaoyi",
        "P_YS_FED_IMP_IOT0000007263": "Tahe County",
        "P_YS_FED_IMP_IOT0000008591": "Shapingba District",
        "P_YS_FED_FW_1456067245639729152": "Open Ref Popup Window",
        "P_YS_FED_IMP_IOT0000008592": "Jintang County",
        "P_YS_FED_IMP_IOT0000008597": "Changji",
        "P_YS_OA_app_xtyyjm_0000035850": "Not Published",
        "P_YS_FED_FW_0000177614": "Main Button",
        "P_YS_FED_IMP_IOT0000007266": "Qianwei County",
        "P_YS_FED_IMP_IOT0000008596": "Yunxian",
        "P_YS_FED_UCFORG_0000025923": "Enabled successfully",
        "P_YS_OA_XTLCZX_0000030473": "Selected",
        "P_YS_PF_SOCD-G_0000807705": "Health",
        "P_YS_FED_IMP_IOT0000007257": "Twin cities",
        "P_YS_FED_IMP_IOT0000008588": "Tianxin District",
        "P_YS_FED_IMP_IOT0000007259": "Xiuyu District",
        "P_YS_FED_IMP_IOT0000008582": "North City",
        "P_YS_FED_IMP_IOT0000008583": "Qianxi County",
        "P_YS_FED_IMP_IOT0000007252": "Dingxiang County",
        "P_YS_FED_IMP_IOT0000008580": "Jiang'an District",
        "P_YS_OA_XTLCZX_0000030468": "Right",
        "P_YS_FED_IMP_IOT0000007254": "Lingyuan",
        "P_YS_FED_IMP_IOT0000008584": "Tuquan County",
        "P_YS_OA_XTLCZX_0000030486": "List Item",
        "P_YS_FED_IMP_IOT0000007247": "Tongshan County",
        "P_YS_FED_IMP_IOT0000008579": "Yanjiang District",
        "P_YS_FED_IMP_IOT0000007249": "Lishi District",
        "P_YS_FED_IMP_IOT0000008577": "Anji County",
        "P_YS_FED_IMP_IOT0000007248": "Chengxiang District",
        "P_YS_FED_IMP_IOT0000008571": "Tongren County",
        "P_YS_FED_IMP_IOT0000007241": "Baita District",
        "P_YS_FED_IMP_IOT0000008570": "Jiujiang County",
        "P_YS_FED_IMP_IOT0000007243": "Qian'an County",
        "P_YS_FED_IMP_IOT0000008575": "Huicheng District",
        "P_YS_FED_IMP_IOT0000007242": "Laicheng District",
        "P_YS_FED_IMP_IOT0000008576": "Aihuiqu",
        "P_YS_FED_IMP_IOT0000007245": "Yujiang County",
        "P_YS_FED_IMP_IOT0000008573": "Shawan District",
        "P_YS_FED_IMP_IOT0000007244": "Xiuyan Manchu Autonomous County",
        "P_YS_FED_IMP_IOT0000008574": "Wenling City",
        "P_YS_FED_UCFBASEDOC_0000025100": "], you can only enter a value greater than 0. Please check and try again",
        "P_YS_FED_FW_1572482677854961725": "Are you sure you want to leave?",
        "P_YS_FED_IMP_IOT0000007236": "Luqu County",
        "P_YS_FED_IMP_IOT0000009899": "Wuyuan County",
        "P_YS_FED_FW_0001144258": "gridModel.lineNoStep(val): parameter [val] is invalid",
        "P_YS_FED_IMP_IOT0000008566": "Lingshou County",
        "P_YS_FED_IMP_IOT0000009897": "Pagoda District",
        "P_YS_FED_IMP_IOT0000007237": "Huixian",
        "P_YS_FED_IMP_IOT0000009898": "Longtan District",
        "P_YS_FED_IMP_IOT0000007239": "Litang County",
        "P_YS_FED_IMP_IOT0000008560": "Mizhi County",
        "P_YS_FED_IMP_IOT0000009891": "Chayu County",
        "P_YS_OA_XTLCZX_0000030402": "Field",
        "P_YS_FED_IMP_IOT0000007232": "Leling",
        "P_YS_FED_IMP_IOT0000009896": "Lujiang County",
        "P_YS_FED_IMP_IOT0000009893": "Nankai District",
        "P_YS_PF_GZTSYS_0000013482": "UI Template",
        "P_YS_PF_GZTSYS_0000012149": "Merchant Product",
        "P_YS_FED_IMP_IOT0000007225": "Xiaojin County",
        "P_YS_FED_IMP_IOT0000008557": "Xunyang County",
        "P_YS_FED_IMP_IOT0000008558": "Sihong County",
        "P_YS_FED_IMP_IOT0000009889": "Luchun County",
        "P_YS_FED_IMP_IOT0000007227": "Jinchuan County",
        "P_YS_PF_GZTSYS_0000013477": "Save",
        "P_YS_FED_IMP_IOT0000007229": "Yanling County",
        "P_YS_FED_IMP_IOT0000007228": "Huade County",
        "P_YS_FED_IMP_IOT0000008559": "Yuanzhou District",
        "P_YS_SD_SDMBF_0000145004": "Amazon",
        "P_YS_FED_IMP_IOT0000007221": "Luhuo County",
        "P_YS_FED_IMP_IOT0000009884": "Xing'an District",
        "P_YS_FED_IMP_IOT0000008554": "Jiangyin",
        "P_YS_FED_IMP_IOT0000007223": "Shinan District",
        "P_YS_FED_IMP_IOT0000008551": "Shanting District",
        "P_YS_FED_IMP_IOT0000007222": "Yuanyang County",
        "P_YS_FED_IMP_IOT0000008552": "Linying County",
        "P_YS_FED_IMP_IOT0000009883": "Zhongshan County",
        "P_YS_FED_FW_0001078323": "Confirm to <%=abandonText%>?",
        "P_YS_FED_FW_0001078324": "Confirm to &lt;%=abandonText%>?",
        "P_YS_FED_FW_0001078322": "Confirm to <%=cCaption%><%=text%>",
        "P_YS_FED_FW_0001078325": "{total} pieces in total",
        "P_YS_FED_IMP_IOT0000007214": "Changshu",
        "P_YS_FED_IMP_IOT0000009875": "Huaiyin District",
        "P_YS_PF_GZTSYS_0000013447": "Un-invoiced",
        "P_YS_FED_IMP_IOT0000009876": "Dangtu County",
        "P_YS_FED_IMP_IOT0000009879": "Mawei District",
        "P_YS_PF_GZTSYS_0000012113": "Customer Grade",
        "P_YS_FED_FW_0000021894": "Value is required. Please check",
        "P_YS_FED_FW_0000021895": "Already rolled back to the original status before splitting",
        "P_YS_FED_IMP_IOT0000009870": "Xinmin",
        "P_YS_FED_FW_0000021892": "Success Info",
        "P_YS_FED_FW_0000021893": "The default template cannot be deleted",
        "P_YS_OA_XTLCZX_0000030424": "Consolidate",
        "P_YS_FED_FW_0000021898": "Template name cannot exceed 20 chars",
        "P_YS_FED_FW_0000021899": "Failed to obtain enumeration",
        "P_YS_FED_IMP_IOT0000009874": "Jizhou City",
        "P_YS_FED_FW_0000021896": "Large screen solution  Design  getDesignColType_Notice curCol",
        "P_YS_FED_FW_0000021897": "Please enter primary dimension rows",
        "P_YS_PF_PRINT_0000056408": "Daily Settlement Doc",
        "P_YS_FED_IMP_IOT0000009872": "Wenshang County",
        "P_YS_SD_URETAIL_0001049201": "Backend error:",
        "P_YS_FED_FW_0001224826": "Doc submitted successfully",
        "P_YS_FED_IMP_IOT0000009867": "Grand View Area",
        "P_YS_FED_IMP_IOT0000007205": "Bobai County",
        "P_YS_FED_IMP_IOT0000008533": "Mingshan District",
        "P_YS_FED_IMP_IOT0000009864": "Tongxin County",
        "P_YS_FED_IMP_IOT0000008534": "Heishui County",
        "P_YS_FED_IMP_IOT0000009865": "Pingguo County",
        "P_YS_PF_GZTSYS_0000012122": "Card/Voucher",
        "P_YS_PF_GZTSYS_0000012125": "Product Order Property",
        "P_YS_FED_IMP_IOT0000008537": "Pinghe County",
        "P_YS_FED_IMP_IOT0000008538": "Wenxian",
        "P_YS_FED_FW_0001381584": "&nbsp;/ 当前页面筛选出条",
        "P_YS_FED_FW_0001081985": "Please select the attachment to delete.",
        "P_YS_FED_FW_0001212858": "Loading more. Remaining",
        "P_YS_FED_IMP_IOT0000008531": "Huichang County",
        "P_YS_HR_HRJXF_0000059516": "Unpublish",
        "P_YS_HR_HRJXF_0000059517": "On-time Completion Rate",
        "P_YS_FED_FW_0001081984": "Batch Download",
        "P_YS_FED_IMP_IOT0000007201": "Baicheng County",
        "P_YS_FED_FW_0001081983": "Please select the attachment to download.",
        "P_YS_FED_IMP_IOT0000009861": "Baoshan District",
        "P_YS_FED_FW_0001241359": "Fuzzy search type control. A default search field needs to be set",
        "P_YS_SD_URETAIL_0001049211": "Failed to delete transaction",
        "P_YS_PF_PRINT_0000057797": "Header User-defined Field 4",
        "P_YS_PF_GZTSYS_0000012184": "Customer's Industry",
        "P_YS_PF_PRINT_0000057795": "Header User-defined Field 5",
        "P_YS_PF_PRINT_0000057794": "Header User-defined Field 6",
        "P_YS_PF_PRINT_0000057793": "Header User-defined Field 7",
        "P_YS_PF_PRINT_0000057792": "Header User-defined Field 1",
        "P_YS_PF_PRINT_0000057791": "Header User-defined Field 2",
        "P_YS_PF_PRINT_0000057790": "Header User-defined Field 3",
        "P_YS_FED_EXAMP_0000020797": "Postage",
        "P_YS_FED_IMP_IOT0000009855": "Shilong District",
        "P_YS_FED_EXAMP_0000020796": "Development in progress. Stay tuned",
        "P_YS_FED_EXAMP_0000020799": "Thu",
        "P_YS_FED_EXAMP_0000020798": "Currently offline. Cannot settle or save",
        "P_YS_FED_IMP_IOT0000008523": "Chengyang District",
        "P_YS_FED_EXAMP_0000020793": "Cannot modify the header in the current Doc status",
        "P_YS_FED_EXAMP_0000020792": "Take and Select Photos",
        "P_YS_FED_IMP_IOT0000008529": "Helen",
        "P_YS_FED_EXAMP_0000020795": "Cannot delete product when order is canceled",
        "P_YS_FED_EXAMP_0000020794": "By Gram",
        "P_YS_FED_IMP_IOT0000009858": "Guiping",
        "P_YS_FED_FW_0001241361": "All of them are fuzzy search type controls. At most one fuzzy search can be set for each scheme",
        "P_YS_SD_UDHWN_0000049917": "Changping District",
        "P_YS_FED_FW_0001241360": "Fuzzy search. Only Include can be selected as the comparison operator",
        "P_YS_FED_IMP_IOT0000009851": "Biyang County",
        "P_YS_FED_IMP_IOT0000008521": "Tongwei County",
        "P_YS_SD_URETAIL_0001049224": "Token refreshed successfully",
        "P_YS_FED_IMP_IOT0000008519": "Dong'an District",
        "P_YS_FED_IMP_IOT0000008513": "Pingtan County",
        "P_YS_FED_FW_0001195898": "Selected (",
        "P_YS_FED_IMP_IOT0000008514": "Qi County",
        "P_YS_FED_FW_0001195897": "Selected Reference",
        "P_YS_FED_IMP_IOT0000008512": "Linqu County",
        "P_YS_FED_IMP_IOT0000008517": "Bangor County",
        "P_YS_FED_IMP_IOT0000008515": "Jiaojiang District",
        "P_YS_FED_IMP_IOT0000009846": "Weidong District",
        "P_YS_FED_IMP_IOT0000008516": "Mellie District",
        "P_YS_FED_IMP_IOT0000009847": "Wuping County",
        "P_YS_FED_IMP_IOT0000009840": "Shangsi County",
        "P_YS_FED_FW_0001195896": "Assc. Sub.",
        "P_YS_ZNBZ_BZBX-MFE_0001617926": "前天",
        "P_YS_SD_UDHWN_0000049937": "Full Screen",
        "P_YS_PF_GZTTMP_0000073729": "Passport",
        "P_YS_FED_IMP_IOT0000008508": "Yanshan County",
        "P_YS_FED_IMP_IOT0000009839": "Xinxing County",
        "P_YS_PF_GZTSYS_0000012164": "Mobile Reports",
        "P_YS_FED_IMP_IOT0000008509": "Yixing",
        "P_YS_SCM_USTOCK-UI_0000174298": "Purchasing Req List",
        "P_YS_FED_IMP_IOT0000008502": "Haibowan District",
        "P_YS_FED_IMP_IOT0000008500": "Moyu County",
        "P_YS_FED_IMP_IOT0000008501": "Huashan District",
        "P_YS_FED_IMP_IOT0000009832": "Ningnan County",
        "P_YS_FED_IMP_IOT0000008506": "Yanling County",
        "P_YS_FED_IMP_IOT0000009837": "Kaifu District",
        "P_YS_FED_IMP_IOT0000009835": "Mudan District",
        "P_YS_FED_IMP_IOT0000009836": "Shunhe Hui District",
        "P_YS_FED_FW_0000082817": "All Attachments",
        "P_YS_FED_IMP_IOT0000009830": "Liujiang County",
        "P_YS_SD_URETAIL_0001049242": "Error in deleting data",
        "P_YS_FED_IMP_IOT0000009822": "Jiawang District",
        "P_YS_FED_IMP_IOT0000010800": "Deqing County",
        "P_YS_FED_IMP_IOT0000009823": "Anyue County",
        "P_YS_FED_IMP_IOT0000010801": "Xinmi",
        "P_YS_FED_IMP_IOT0000010802": "Urban area",
        "P_YS_FED_IMP_IOT0000009821": "Cangshan District",
        "P_YS_FED_IMP_IOT0000010803": "Xixiu District",
        "P_YS_FED_IMP_IOT0000009827": "Yueqing",
        "P_YS_FED_IMP_IOT0000009824": "Xiangzhou County",
        "P_YS_FED_IMP_IOT0000009825": "Zhouzhi County",
        "P_YS_SD_SCMSA-UI_0000162068": "Push",
        "P_YS_FED_IMP_IOT0000010808": "Xixiang County",
        "P_YS_FED_IMP_IOT0000010809": "Donghe District",
        "P_YS_FED_FW_1628158682522976263": "UI Template Name",
        "P_YS_FED_FW_0001252682": "Please complete the data and upload again",
        "P_YS_HR_HRXCF_0000056236": "Re-upload",
        "P_YS_SD_UDHWN_0001009862": "Early morning",
        "P_YS_FED_FW_0001073947": "Incorrect content entered",
        "P_YS_HR_HRCOREF_0000058351": "Changed On",
        "P_YS_FED_IMP_IOT0000010702": "Qingyuan Manchu Autonomous County",
        "P_YS_SD_UDHWN_0001008520": "Rectangular Selection",
        "P_YS_FED_IMP_IOT0000010707": "Zhuozhou",
        "P_YS_HR_HRXCF_0000056229": "Descending",
        "P_YS_FED_FW_0001160009": "Overdue Order Lines",
        "P_YS_FED_FW_0001160008": "缺少cAction参数",
        "P_YS_FED_FW_0001300832": "Order",
        "P_YS_FED_FW_0001160005": "缺少mtl.dail",
        "P_YS_FED_FW_0001300835": "Collected",
        "P_YS_FED_FW_0001160004": "\\n 节点信息：",
        "P_YS_FED_FW_0001300836": "Failed to deliver",
        "P_YS_HR_HRXCF_0000056212": "Ascending",
        "P_YS_FED_FW_0001160007": "缺少flowComp",
        "P_YS_FED_FW_0001300833": "Signed In",
        "P_YS_FED_FW_0001160006": "extra 提示",
        "P_YS_FED_FW_0001300834": "Delivering",
        "P_YS_FED_FW_0001160001": "Delivered",
        "P_YS_FED_FW_0001300839": "Intransit",
        "P_YS_FED_FW_0001160000": "On-time Order Lines",
        "P_YS_FED_FW_0001160003": "缺少window.flowCompParams.host",
        "P_YS_FED_FW_0001300837": "Problematic Express Item",
        "P_YS_FED_FW_0001160002": "缺少window.YYCooperationBridge",
        "P_YS_PF_GZTTMP_0000074737": "Website",
        "P_YS_FED_FW_0001300838": "Return Sign-in",
        "P_YS_AM_AMC-UI_0000170775": "Tree",
        "P_YS_FED_IMP_IOT0000010712": "Qingcheng District",
        "P_YS_FED_IMP_IOT0000010710": "Dalham Moomin United Flag",
        "P_YS_FED_FW_1525457613522206720": "<%=caption%> Details",
        "P_YS_FED_IMP_IOT0000010718": "Xinrong District",
        "P_YS_PF_GZTSYS_0000015903": "Store",
        "P_YS_SD_SDOC_0001150114": "Pickup",
        "P_YS_AM_AMC-UI_0000170769": "Query Area",
        "P_YS_SD_UDHWN_0000049220": "Baodi District",
        "P_YS_FED_EXAMP_0000020302": "Uploaded successfully",
        "P_YS_FED_EXAMP_0000020301": "Demo industry account login failed: [interface]",
        "P_YS_FED_IMP_IOT0000010724": "Yongshou County",
        "P_YS_FED_EXAMP_0000020304": "No product entered. Cannot return",
        "P_YS_FED_EXAMP_0000020303": "On-site discount has been executed. Cannot change retail price",
        "P_YS_FED_IMP_IOT0000010726": "Puge County",
        "P_YS_FED_EXAMP_0000020300": "Cannot find the refundable Amt of the times card",
        "P_YS_FED_IMP_IOT0000010721": "Gongcheng Yao Autonomous County",
        "P_YS_FED_EXAMP_0000020309": "Wallet payment Amt cannot be greater than the available wallet Amt",
        "P_YS_HR_HRXCF_0000056205": "Download Template",
        "P_YS_FED_FW_1530135219434684425": "Printing Equipment",
        "P_YS_OA_app_xtyyjm_0000036003": "Conflicting",
        "P_YS_FED_EXAMP_0000020306": "Permission Verification",
        "P_YS_FED_IMP_IOT0000010727": "Xihe County",
        "P_YS_FED_EXAMP_0000020305": "Points used must be an integer",
        "P_YS_PF_GZTSYS_0000015916": "Analysis",
        "P_YS_FED_IMP_IOT0000010728": "Taishan District",
        "P_YS_FED_EXAMP_0000020308": "menuId is blank",
        "P_YS_FED_EXAMP_0000020307": "SNs not entered in numbered product lines. Please check",
        "P_YS_FED_FW_0001160027": "Start to deliver",
        "P_YS_FED_FW_0001160026": "Predicted Delivery Time:",
        "P_YS_FED_FW_0001160029": "前5周",
        "P_YS_FED_FW_0001160028": "Second Circle",
        "P_YS_FED_FW_0001160023": "缺少协同套件方法缺失",
        "P_YS_FED_FW_0001160022": "缺失FilterViewModel",
        "P_YS_PF_SUPPORT-UI_0001122350": "Event Source",
        "P_YS_FED_FW_0001160025": "前6周",
        "P_YS_FED_FW_0001160024": "modelKey获取错误",
        "P_YS_FED_FW_0001160021": "No sorting field",
        "P_YS_FED_FW_0001160020": "供应商：$var{vendor_name}$var_end",
        "P_YS_PF_GZTSYS_0000015967": "Settings",
        "P_YS_FED_IMP_IOT0000010735": "Yuanping",
        "P_YS_FED_IMP_IOT0000010737": "Xiyang County",
        "P_YS_FED_IMP_IOT0000010731": "Sunite Zuoqi",
        "P_YS_FED_IMP_IOT0000010732": "Cili County",
        "P_YS_FED_IMP_IOT0000010733": "Henan Mongolian Autonomous County",
        "P_YS_FED_IMP_IOT0000010739": "Maogang District",
        "P_YS_FED_FW_0001160019": "Delivering",
        "P_YS_FED_FW_0001160016": "Delivery",
        "P_YS_FED_FW_0001160015": "Domestic Carrier:",
        "P_YS_FED_FW_0001160018": "金额$var{oriSum}$var_end $var{currency_name}$var_end",
        "P_YS_FED_FW_0001160017": "On-time completion rate = No. of order lines with products received on-time/total No. of order lines * 100%",
        "P_YS_FED_FW_0001160012": "缺少section格式错误",
        "P_YS_FED_FW_0001160011": "cell的宽度超过表格的宽度,无法渲染",
        "P_YS_FED_FW_0001160014": "No shipping Doc No.",
        "P_YS_FED_FW_0001160013": "第三周",
        "P_YS_FED_IMP_IOT0000010740": "Wudi County",
        "P_YS_PF_TRS-FE_0000103832": "Importing...",
        "P_YS_FED_FW_0001160010": "/10行",
        "P_YS_FED_FW_1503374162989678595": "Open Slide Panel",
        "P_YS_PF_GZTSYS_0000015975": "Barcode",
        "P_YS_FED_IMP_IOT0000010741": "Hanyuan County",
        "P_YS_FED_IMP_IOT0000010742": "Guanling Buyi and Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000010749": "Changtai County",
        "P_YS_FED_FW_0001160049": "缺少window.mtl",
        "P_YS_FED_FW_0001160048": "Search Location",
        "P_YS_FED_FW_0001160045": "parsecontrols缺少Collapse容器组件",
        "P_YS_FED_FW_0001160044": "listType 错误，不是refer",
        "P_YS_FED_FW_0001160047": "(已选择",
        "P_YS_FED_IMP_IOT0000010750": "Maonan District",
        "P_YS_FED_FW_0001160046": "portal缺少tabs",
        "P_YS_FED_IMP_IOT0000010751": "Heyang County",
        "P_YS_FED_FW_0001160041": "context缺失",
        "P_YS_FED_FW_0001312860": "Info displayed when hovering over",
        "P_YS_FED_FW_0001160040": "cTemplateTitle为空",
        "P_YS_FED_FW_0001160043": "路由params解析错误",
        "P_YS_FED_FW_0001312862": "GIS Map Configuration Info",
        "P_YS_FED_FW_0001160042": "这里是个toolbar",
        "P_YS_FED_FW_0001312861": "The title of the Info displayed when hovering over",
        "P_YS_FED_IMP_IOT0000010756": "Changshan County",
        "P_YS_FED_FW_0001201089": "View Order Details",
        "P_YS_PF_GZTSYS_0000015945": "Member",
        "P_YS_FED_FW_0001160050": "（已选",
        "P_YS_FED_IMP_IOT0000010758": "Luohu district",
        "P_YS_FED_IMP_IOT0000010759": "Chaya County",
        "P_YS_FED_FW_0001312857": "GIS Map Configuration Info - yySetting",
        "P_YS_FED_IMP_IOT0000010753": "Huaiji County",
        "P_YS_FED_FW_0001312856": "Display Title",
        "P_YS_FED_FW_1427569433243549696": "The cross-point is required",
        "P_YS_FED_FW_0001312859": "GIS Map Configuration Info - eChartSetting",
        "P_YS_FED_FW_1427569433243549699": "The column title is required",
        "P_YS_OA_app_xtyyjm_0000036032": "Optional",
        "P_YS_FED_FW_0001312858": "GIS Map",
        "P_YS_FED_FW_0001160038": "行）",
        "P_YS_FED_FW_0001160037": "Confirm to delete?",
        "P_YS_FED_FW_0001160039": "The Doc cannot be opened in the mobile App",
        "P_YS_FED_FW_0001160034": "Hello. For the products we purchased from your company, we hope that you can arrange shipment and inform us in time",
        "P_YS_FED_FW_0001160033": "Please enter the required fields",
        "P_YS_FED_FW_0001377324": "Please paste the correct field to search",
        "P_YS_FED_FW_0001160036": "缺少phone number",
        "P_YS_FED_FW_0001160035": "前4周",
        "P_YS_FED_FW_0001160030": "Pickup",
        "P_YS_FED_FW_0001160032": "缺少sectionParams",
        "P_YS_PF_GZTBDM_0000036354": "Refreshed successfully",
        "P_YS_FED_FW_0001160031": "六角螺母-细牙DIN934【DIN93489074873984】",
        "P_YS_FED_IMP_IOT0000010767": "Laiyuan County",
        "P_YS_FED_FW_0001312864": "GIS Map Example",
        "P_YS_FED_IMP_IOT0000010768": "Pingbian Miao Autonomous County",
        "P_YS_FED_FW_0001312863": "Location Field",
        "P_YS_FED_IMP_IOT0000010769": "Guanghan",
        "P_YS_FED_FW_0001493696": "Already reached the bottom",
        "P_YS_FED_IMP_IOT0000010763": "Pingba County",
        "P_YS_FED_FW_0001493695": "⇅",
        "P_YS_FED_IMP_IOT0000010765": "Suichang County",
        "P_YS_FED_FW_0001071353": "Editing Scheme",
        "P_YS_FED_FW_0001241952": "Failed to verify the template content",
        "P_YS_FED_FW_0001241953": "Verifying data",
        "P_YS_FED_FW_0001241950": "文件类型必须为",
        "P_YS_FED_FW_0001241951": "个，您将继续导入吗?",
        "P_YS_FED_IMP_IOT0000010770": "Chao'an County",
        "P_YS_FED_IMP_IOT0000010771": "Xinye County",
        "P_YS_FED_IMP_IOT0000010772": "Wuling District",
        "P_YS_FED_FW_0001241958": "No. of Reference Exceptions",
        "P_YS_FED_FW_0001241956": "上传导入文件",
        "P_YS_FED_FW_0001241957": "经系统校验",
        "P_YS_FED_FW_0001241954": "共存在",
        "P_YS_FED_FW_0001241955": "No abnormal data. Import is allowed",
        "P_YS_FED_IMP_IOT0000010778": "Changdu County",
        "P_YS_FED_IMP_IOT0000010779": "Suzhou",
        "P_YS_FED_IMP_IOT0000010777": "Zhaoxian",
        "P_YS_FED_FW_0001241963": "Total No. of Exceptions",
        "P_YS_HR_HRJQ_0000031222": "Dept",
        "P_YS_FED_FW_0001241964": "The required item is empty",
        "P_YS_FED_FW_1566299230629789705": "View Old Attachment",
        "P_YS_FED_FW_0001241961": "No. of Format Exceptions",
        "P_YS_FED_FW_0001241962": "Import Workbench",
        "P_YS_FED_FW_0001241960": "View More",
        "P_YS_FED_FW_1566299230629789708": "View Old Graphs",
        "P_YS_FED_FW_0001160056": "此处是个iframe",
        "P_YS_FED_FW_0001160055": "没有更多数据",
        "P_YS_FED_FW_0001160052": "Doc Time:",
        "P_YS_FED_FW_0001160051": "Enter to query",
        "P_YS_FED_FW_0001160054": "缺少toolbar",
        "P_YS_FED_FW_0001160053": "Please locate",
        "P_YS_FED_FW_1438107719627702272": "Set 5 search columns at most",
        "P_YS_OA_app_xtyyjm_0000036063": "Refresh",
        "P_YS_FED_IMP_IOT0000010786": "Yulong Naxi Autonomous County",
        "P_YS_FED_IMP_IOT0000010787": "Liuhe County",
        "P_YS_OA_XTSPZX_0000034801": "End Date",
        "P_YS_FED_FW_1529514021144231942": "The Docs in Being Approved status cannot be directly switched to editing status",
        "P_YS_FED_FW_1566299230629789711": "View History Attachment",
        "P_YS_PF_ANALYTIC-FE_0001652971": "Map Type",
        "P_YS_FED_FW_0001636725": "Template verification failed",
        "P_YS_FED_IMP_IOT0000010791": "Qionglai",
        "P_YS_FED_IMP_IOT0000010796": "Tongshan County",
        "P_YS_FED_IMP_IOT0000010797": "Gyangze County",
        "P_YS_FED_IMP_IOT0000010798": "Tianwait County",
        "P_YS_SD_UDHWN_0000050285": "Chengmai County",
        "P_YS_FED_FW_0001241949": "目前初步校验，异常总数",
        "P_YS_FED_FW_0001241948": "Export Modification",
        "P_YS_FED_FW_0001033077": "Store",
        "P_YS_OA_app_xtyyjm_0000036082": "Number",
        "P_YS_SD_UDHMC_0001057227": "?",
        "P_YS_OA_app_xtyyjm_0000036083": "Filter",
        "P_YS_FED_FW_0001256170": "二手房产权纠纷有哪些？ \\n",
        "P_YS_FED_FW_0001256171": "我是折叠区域的内容，点击按钮我就显示，再次点击就会隐藏。快来点击按钮体验我的交互效果吧，是不是很棒！赶快使用吧~~~",
        "P_YS_HR_HRJQ_0000031253": "11.0",
        "P_YS_HR_HRJQ_0000031259": "Overdue",
        "P_YS_FED_FW_0001256178": "住宅小区的大件垃圾有望得到回收利用 \\n",
        "P_YS_MF_ED-UI_0001095584": "Past",
        "P_YS_FED_FW_0001256179": "国际新闻",
        "P_YS_FED_FW_0001256176": "大按钮",
        "P_YS_FED_FW_0001256177": "中國",
        "P_YS_FED_FW_0001256174": "汽车保养只换机油，4个零件要是不换的 \\n",
        "P_YS_FED_FW_0001256175": "小按钮",
        "P_YS_FED_FW_0001256172": "最均衡国产10万元SUV推荐",
        "P_YS_FED_FW_0001256173": "Basic Slider，`step默认1`",
        "P_YS_FED_FW_0001256169": "网友偶遇贴特大号“实习”标志的豪车 \\n",
        "P_YS_SD_UDHWN_0001009822": "Noon",
        "P_YS_FED_FW_0001256181": "15万预算，适合年轻人的2台运动轿车，颜值高实力强 \\n",
        "P_YS_FED_FW_0001256182": "小户型榻榻米的制作流程 这样准没错 \\n",
        "P_YS_FED_FW_1609500210710446085": "mainOrigin值为：",
        "P_YS_FED_FW_0001256180": "地上忽现大坑 瞬间吞掉两幢房子 \\n",
        "P_YS_FED_FW_0001300824": "Click to load more",
        "P_YS_FED_FW_0001300825": "Associated with Children",
        "P_YS_FED_FW_0001300823": "Load More",
        "P_YS_FED_FW_0001300828": "Please locate",
        "P_YS_FED_FW_0001300829": "Continue to Add",
        "P_YS_SD_UDHWN_0000049240": "Shunyi District",
        "P_YS_FED_FW_0001300826": "Copied successfully",
        "P_YS_FED_FW_0001256183": "暫無數據~",
        "P_YS_SD_UDHWN_0001009818": "1-hour",
        "P_YS_FED_FW_0001256156": "更大更好吃的海蛎子有望端上青岛市民餐桌！ \\n",
        "P_YS_FED_FW_0001256157": "最低工资标准上调窗口开启 京鲁冀等多个省市 \\n",
        "P_YS_FED_FW_0001256154": "磁贴标题",
        "P_YS_FED_FW_0001256155": "这是一个很强的提醒！",
        "P_YS_FED_FW_0001256152": "「评论」“小降准”的大意义",
        "P_YS_FED_FW_0001256153": "追剧听相声玩手游 “歪果仁”为了学汉语也是拼了 \\n",
        "P_YS_FED_FW_0001256150": "测绘准入放宽在即，新玩家新规则倒逼产业转型 \\n",
        "P_YS_FED_FW_0001256151": "房产",
        "P_YS_FED_FW_0001256149": "戏曲进高校玩快闪 “圈粉”大学生 \\n",
        "P_YS_FED_FW_1583355559353516056": "No data at present.",
        "P_YS_FED_FW_0001256147": "智慧城市建设莫一哄而上 \\n",
        "P_YS_FED_FW_0001256148": "大众系SUV多到脸盲？一招教你如何选 \\n",
        "P_YS_FED_IMP_IOT0000007096": "Li County",
        "P_YS_FED_IMP_IOT0000007098": "Nimu County",
        "P_YS_FED_IMP_IOT0000007097": "Gongzhuling",
        "P_YS_FED_FW_0001256160": "請輸入您的手機號",
        "P_YS_FED_IMP_IOT0000007090": "Ergun",
        "P_YS_FED_IMP_IOT0000007092": "Jing'an District",
        "P_YS_FED_FW_0001256167": "电商平台不该为“代吵架服务”设摊 \\n",
        "P_YS_FED_FW_0001256168": "民众成都博物馆里享“餐桌上的文化之旅 \\n",
        "P_YS_FED_FW_0001256165": "点我啦",
        "P_YS_FED_FW_0001256166": "又一80后上市公司实控人被刑拘！ \\n",
        "P_YS_FED_FW_0001256163": "自定义 top",
        "P_YS_PF_GZTTMP_0000079605": "Invoice",
        "P_YS_FED_FW_0001256164": "回顾20年前A股那场轰轰烈烈的“519行情”",
        "P_YS_FED_FW_0001256161": "五月种菜大全来了，这些蔬菜您种了没有？ \\n",
        "P_YS_FED_FW_0001256162": "牌子大口碑好销量还高，12万左右的自动挡合资轿车 \\n",
        "P_YS_FED_FW_0001256158": "自定义 width",
        "P_YS_FED_FW_0001256159": "巨大按钮",
        "P_YS_FED_IMP_IOT0000007087": "Taierzhuang District",
        "P_YS_HR_HRJQ_0000031282": "Incorrect email format",
        "P_YS_FED_FW_0000021160": " ",
        "P_YS_FED_FW_0000022491": "Expand One Level",
        "P_YS_FED_FW_0000021161": "Line Chart Example",
        "P_YS_FED_FW_0000022492": "Available Criteria",
        "P_YS_FED_FW_0000022490": "Next Month",
        "P_YS_FED_FW_0000021164": "Bozhou",
        "P_YS_FED_FW_0000022495": "8.0",
        "P_YS_FED_FW_0000021165": "Pie Chart Config. Info",
        "P_YS_FED_FW_0000022496": "Incl. Subordinates during Execution",
        "P_YS_FED_FW_0000021162": "Qinhuangdao",
        "P_YS_FED_FW_0000022493": "9.0",
        "P_YS_FED_FW_1473069861501927428": "System printing failed. Error message:",
        "P_YS_FED_FW_0000021163": "Huaihua",
        "P_YS_FED_FW_0000022494": "Clear Value",
        "P_YS_FED_FW_0001256134": "鼠标滑过显示",
        "P_YS_FED_FW_0001256135": "如何解决室内干燥 一个加湿器是不行的 \\n",
        "P_YS_FED_FW_0001256132": "如何降低购房风险？ \\n",
        "P_YS_FED_FW_0001256133": "投资2000万美元狂赚7000倍 \\n",
        "P_YS_FED_FW_0001256130": "一季度轿车市场分析 \\n",
        "P_YS_FED_FW_0001256131": "《从0到1》序二——读书笔记 \\n",
        "P_YS_PF_GZTTMP_0000078208": "Transa. Pcs",
        "P_YS_SD_SDMAUF_0000152533": "Submit",
        "P_YS_FED_FW_0001256129": "哪些城市亮瞎眼，哪些城市很失落 \\n",
        "P_YS_FED_FW_0001256127": "当初没好好装卫生间 现在后悔死了 \\n",
        "P_YS_FED_FW_0001256128": "「重磅发布」2019年欧洲十大海上风电场排行榜！ \\n",
        "P_YS_FED_FW_0001256125": "美男摔落悬崖掉进活火山，躲过摄氏超过1000度 \\n",
        "P_YS_FED_FW_0001256126": "那些还在发朋友圈的朋友们，才是人间珍品 \\n",
        "P_YS_FED_FW_0000021157": "The name that needs to be displayed as Legend is too long and needs to be truncated. Before truncation:",
        "P_YS_FED_FW_0000022488": "This Month",
        "P_YS_FED_IMP_IOT0000007195": "Pingyang County",
        "P_YS_FED_FW_0000021158": "Pie Chart Config. Info - yySetting",
        "P_YS_FED_FW_0000022489": "Today",
        "P_YS_FED_IMP_IOT0000007194": "Longcheng District",
        "P_YS_FED_FW_0000021155": "Hainan",
        "P_YS_FED_FW_0000022486": "Display Disabled",
        "P_YS_FED_FW_0000021156": "upgradeConfig_ForScatter  Cannot find the corresponding area to upgrade. yySetting",
        "P_YS_FED_FW_0000022487": "Query Criteria",
        "P_YS_FED_IMP_IOT0000007196": "Jiaonan",
        "P_YS_FED_FW_0000021159": "cFormatData. Error in preset data",
        "P_YS_FED_FW_0000021171": "Suizhou",
        "P_YS_FED_FW_0000021172": "Xinxiang",
        "P_YS_FED_FW_0000021170": "Clear",
        "P_YS_PF_PRINT_0000057801": "Header User-defined Field 8",
        "P_YS_FED_FW_0000021175": "Tacheng Prefecture",
        "P_YS_PF_PRINT_0000057800": "Header User-defined Field 9",
        "P_YS_FED_FW_0000021176": "Yinchuan",
        "P_YS_FED_FW_0000021173": "Neijiang",
        "P_YS_FED_FW_1452079643387494400": "Failed to find the tab corresponding to %c",
        "P_YS_FED_FW_0000021174": "Lu'an",
        "P_YS_FED_FW_0001030895": "←",
        "P_YS_FED_FW_0001256145": "苏格兰媒体：凯尔特人没有向穆里尼奥开出邀约 \\n",
        "P_YS_FED_FW_0001256146": "去4S店“首保”，这3个细节要注意 \\n",
        "P_YS_FED_FW_0001256143": "一只好莱坞的 巨星猪 是怎么诞生的 \\n",
        "P_YS_FED_FW_0001256144": "五一消费账单来了！这个小长假，你的钱花哪了？ \\n",
        "P_YS_FED_FW_0001256141": "青少年手机成瘾危害大 各国政府纷纷出招应对 \\n",
        "P_YS_FED_FW_0001256142": "这是一段描述",
        "P_YS_FED_FW_0001256140": "光明日报头版：读懂中国经济的巨大韧性 \\n",
        "P_YS_FED_FW_0001256138": "一等奖得主齐现身 领奖不忘捐款献爱心 \\n",
        "P_YS_FED_FW_0001256139": "他或是安倍唯一不敢反对的男人！ \\n",
        "P_YS_FED_FW_0001256136": "长春年近六旬男子上演花样自行车绝技 \\n",
        "P_YS_FED_FW_0001256137": "状态(disabled)",
        "P_YS_FED_FW_0000021168": "highlight-control-cstyle- Error in preset data",
        "P_YS_FED_FW_0000022499": "Preset schemes cannot be overwritten",
        "P_YS_FED_FW_0000021169": "Xinyang",
        "P_YS_FED_FW_0000021166": "Chongqing",
        "P_YS_FED_FW_0000022497": "Query Criteria: (",
        "P_YS_FED_IMP_IOT0000007186": "Pingyin County",
        "P_YS_FED_FW_0000021167": "Anqing",
        "P_YS_FED_FW_0000022498": "Empty",
        "P_YS_FED_IMP_IOT0000007185": "Jiaohe",
        "P_YS_FED_IMP_IOT0000007188": "Yi County",
        "P_YS_FED_FW_0000022470": "No group Info",
        "P_YS_FED_FW_0001077518": "Actual Size",
        "P_YS_SD_UDHWN_0000046985": "Tongzhou District",
        "P_YS_FED_FW_0000021142": "Zhanjiang",
        "P_YS_FED_FW_0000022473": "From",
        "P_YS_FED_IMP_IOT0000007180": "He County",
        "P_YS_FED_FW_0000022474": "There cannot be an area with the code being empty",
        "P_YS_FED_FW_0000021143": "Ordinary Invoice",
        "P_YS_FED_FW_0000021140": "Product Code:",
        "P_YS_FED_FW_0000022471": "table2DRowColChange  In 1-D table, current index =",
        "P_YS_FED_IMP_IOT0000007182": "Luanping County",
        "P_YS_FED_FW_0000021141": "Column Chart Example",
        "P_YS_FED_FW_0000022472": "Exception in adding row. self.addGroupInfo =",
        "P_YS_FED_FW_0001232180": "hubble_collect_url is not configured. Hubble collection failed",
        "P_YS_FED_FW_0000021135": "Product Name:",
        "P_YS_FED_FW_0000022466": "Default",
        "P_YS_FED_IMP_IOT0000007173": "Sartu District",
        "P_YS_FED_FW_0000021136": "Technical Blue",
        "P_YS_FED_FW_0000022467": "5. Click [Verify], and the system verifies the syntax of the \"filtering expression\" according to the syntax of the SQL-where clause. If there is a syntax error, the verification fails.",
        "P_YS_FED_FW_0000021133": "Shanghai",
        "P_YS_FED_FW_0000022464": "When auxiliary dimensions exist, single-choice is supported; otherwise, multi-choice is supported. Select at most",
        "P_YS_FED_IMP_IOT0000007175": "Fangcheng County",
        "P_YS_FED_FW_0000021134": "Line Chart Config. Info",
        "P_YS_FED_FW_0000022465": "Name is required and the length should be less than 16 chars",
        "P_YS_FED_IMP_IOT0000007174": "Jinchuan District",
        "P_YS_FED_FW_0000021139": "Dongying",
        "P_YS_FED_IMP_IOT0000007177": "Hongze County",
        "P_YS_FED_IMP_IOT0000007176": "Shuangluan District",
        "P_YS_FED_FW_0000021137": "Dezhou",
        "P_YS_FED_FW_0000022468": "Keep at least one line",
        "P_YS_FED_IMP_IOT0000007179": "Xinyi",
        "P_YS_FED_FW_0000021138": "Bortala Mongolian Autonomous Prefecture",
        "P_YS_FED_FW_0000022469": "Failed to change name",
        "P_YS_FED_IMP_IOT0000007178": "Wan'an County",
        "P_YS_FED_FW_0000022480": "Template Name",
        "P_YS_FED_FW_0000021150": "Current regionInfo",
        "P_YS_FED_FW_0000022481": "7.0",
        "P_YS_FED_FW_0000021153": "Yulin",
        "P_YS_FED_FW_0000022484": "Program error",
        "P_YS_FED_FW_0000021154": "Hebei",
        "P_YS_FED_FW_0000022485": "Incl. Subordinates",
        "P_YS_FED_FW_0000021151": "Top N Bubble Values",
        "P_YS_FED_FW_0000022482": "Expand Level",
        "P_YS_FED_FW_0000021152": "Yingtan",
        "P_YS_FED_FW_0000022483": ":",
        "P_YS_FED_IMP_IOT0000007170": "Gaoping",
        "P_YS_FED_FW_0001256123": "人民铁道“中央厨房”今日上线 \\n",
        "P_YS_FED_FW_0001256124": "查找关键字,请输入1",
        "P_YS_FED_FW_0001256121": "新风系统有没有用 到底要不要装呢",
        "P_YS_FED_FW_0001256122": "国内要闻",
        "P_YS_FED_FW_0001256120": "单据状态异常，请重新提交。",
        "P_YS_FED_FW_0001256118": "记住这个落井之人 \\n",
        "P_YS_FED_FW_0001256119": "北京项目近况一览 \\n",
        "P_YS_FED_FW_0001256116": "让数字经济更好助力高质量发展 \\n",
        "P_YS_FED_FW_0001256117": "條/頁",
        "P_YS_FED_FW_0001256115": "要想涡轮坏得快，这四个错误天天犯！ \\n",
        "P_YS_FED_FW_0000021146": "Yangjiang",
        "P_YS_FED_FW_0000022477": "Header + Details",
        "P_YS_FED_IMP_IOT0000007162": "Jinzhou District",
        "P_YS_FED_IMP_IOT0000008494": "Pujiang County",
        "P_YS_FED_FW_0000021147": "Data format error",
        "P_YS_FED_FW_0000022478": "New Dimension Navigation Scheme",
        "P_YS_FED_IMP_IOT0000007161": "Guanyang County",
        "P_YS_FED_FW_0000021144": " pieces of data not read successfully",
        "P_YS_FED_FW_0000022475": "Industry",
        "P_YS_FED_FW_0000021145": "Bubble Chart Config. Info - yySetting",
        "P_YS_FED_FW_0000022476": "Failed to call add:",
        "P_YS_FED_IMP_IOT0000007163": "Neihuang County",
        "P_YS_FED_IMP_IOT0000008493": "Yucheng County",
        "P_YS_FED_IMP_IOT0000007165": "Zigui County",
        "P_YS_FED_FW_0000021148": "Yanbian Korean Autonomous Prefecture",
        "P_YS_FED_FW_0000022479": "Editing UI",
        "P_YS_FED_FW_0000021149": "Heyuan",
        "P_YS_FED_IMP_IOT0000007167": "Mishan",
        "P_YS_FED_IMP_IOT0000008490": "Qijiang County",
        "P_YS_FED_EXAMP_0000020283": "The Qty is 0 in a product line. Cannot settle",
        "P_YS_FED_FW_0001470928": "URL is required",
        "P_YS_FED_EXAMP_0000020282": "Please select product",
        "P_YS_FED_EXAMP_0000020285": "Returned Qty cannot be negative",
        "P_YS_FED_EXAMP_0000020284": "Business Partner Mgmt",
        "P_YS_FED_FW_0001470929": "Text is required",
        "P_YS_FED_EXAMP_0000020281": ") Details",
        "P_YS_FED_EXAMP_0000020280": "Cannot change retail prices",
        "P_YS_FED_IMP_IOT0000007159": "Linquan County",
        "P_YS_FED_EXAMP_0000020279": "Select SN",
        "P_YS_FED_EXAMP_0000020276": "Book",
        "P_YS_FED_EXAMP_0000020275": "Mgmt Category",
        "P_YS_FED_EXAMP_0000020278": "Please enter warehouse first",
        "P_YS_FED_FW_0001470926": "{\"linkText\":\"Baidu\",\"linkAddress\":\"http://baudi.com\"}",
        "P_YS_FED_EXAMP_0000020277": "No record to modify in the record line",
        "P_YS_FED_IMP_IOT0000007150": "Keping County",
        "P_YS_FED_FW_0000021199": "Langfang",
        "P_YS_FED_IMP_IOT0000007152": "Dongxiang Autonomous County",
        "P_YS_FED_IMP_IOT0000007155": "Jiuzhaigou County",
        "P_YS_FED_IMP_IOT0000008487": "Stabbing area",
        "P_YS_PF_PROCENTER_0000023464": "Enable",
        "P_YS_FED_IMP_IOT0000007156": "Chengjiang County",
        "P_YS_FED_IMP_IOT0000008486": "Zhongning County",
        "P_YS_FED_IMP_IOT0000008480": "Shashi District",
        "P_YS_FED_EXAMP_0000020294": "No. of Transa.",
        "P_YS_FED_EXAMP_0000020293": "Select at most 5 specifications",
        "P_YS_FED_EXAMP_0000020296": "The system version is low. Switching is not supported now",
        "P_YS_FED_EXAMP_0000020295": "Only one package product can be selected",
        "P_YS_FED_EXAMP_0000020290": "Cancel Order",
        "P_YS_FED_EXAMP_0000020292": "The current status is return top-up. Cannot add top-up lines",
        "P_YS_FED_EXAMP_0000020291": "Promotion has been executed. Cannot enter members",
        "P_YS_FED_IMP_IOT0000008478": "Please enter this field",
        "P_YS_FED_IMP_IOT0000007149": "Xiaohe District",
        "P_YS_FED_EXAMP_0000020286": "Code",
        "P_YS_FED_EXAMP_0000020289": " H266pieces of data bootSave, error occurred when saving",
        "P_YS_FED_EXAMP_0000020288": "Failed to obtain shift",
        "P_YS_FED_IMP_IOT0000007140": "Gongliu County",
        "P_YS_FED_IMP_IOT0000008472": "Guantao County",
        "P_YS_FED_IMP_IOT0000008473": "Pingxiang County",
        "P_YS_OA_XTSPZX_0000034846": "Expand",
        "P_YS_FED_IMP_IOT0000007144": "Tongzi County",
        "P_YS_FED_IMP_IOT0000007146": "Bao'an District",
        "P_YS_FED_IMP_IOT0000008474": "Kinmen County",
        "P_YS_FED_FW_0000021182": "Jiangxi",
        "P_YS_FED_FW_0000021183": "Error in preset cStyle",
        "P_YS_FED_FW_0000021180": "User-defined Template",
        "P_YS_FED_FW_0000021181": "Henan",
        "P_YS_SD_SDMB_0000149613": "Intransit",
        "P_YS_FED_FW_0000021186": "Error Info returned",
        "P_YS_FED_FW_0001204909": "Export completed. File name: [",
        "P_YS_FED_FW_0000021187": "Huzhou",
        "P_YS_FED_FW_0000021184": "Second Store in Chaoyang District, Beijing",
        "P_YS_FED_FW_0000021185": "Ningde",
        "P_YS_FED_IMP_IOT0000007137": "Liangshan County",
        "P_YS_FED_IMP_IOT0000008469": "Daan",
        "P_YS_FED_IMP_IOT0000009798": "Sanmen County",
        "P_YS_FED_IMP_IOT0000007138": "Shangcheng County",
        "P_YS_FED_IMP_IOT0000008468": "Ji'an County",
        "P_YS_FED_EXAMP_0000020298": "Free product contain physical card/voucher product. Card/voucher No. is required",
        "P_YS_FED_EXAMP_0000020297": "Cannot return product in the current Doc status",
        "P_YS_FED_EXAMP_0000020299": "Deliver by Day",
        "P_YS_FED_FW_0000021179": "China 100000",
        "P_YS_FED_IMP_IOT0000009792": "Jiashi County",
        "P_YS_OA_XTSPZX_0000034833": "Time",
        "P_YS_FED_IMP_IOT0000008462": "Dongning County",
        "P_YS_FED_IMP_IOT0000009793": "Quwo County",
        "P_YS_FED_FW_0000021177": "Baise",
        "P_YS_OA_XTSPZX_0000034835": "Enable",
        "P_YS_FED_FW_0000021178": "Jiuquan",
        "P_YS_FED_IMP_IOT0000007130": "Leiyang",
        "P_YS_FED_IMP_IOT0000008460": "Napo County",
        "P_YS_FED_IMP_IOT0000007133": "Longchuan County",
        "P_YS_FED_IMP_IOT0000009795": "Yanchuan County",
        "P_YS_FED_FW_0000021193": "Altay Prefecture",
        "P_YS_OA_XTSPZX_0000034819": "Confirm",
        "P_YS_FED_FW_0000021194": "Xiangtan",
        "P_YS_FED_FW_0000021191": "Shenyang",
        "P_YS_FED_FW_0000021192": "Wuhan",
        "P_YS_FED_FW_0000021197": "Bubble Chart Config. Info",
        "P_YS_FED_FW_0000021198": "Aux. Dimension Null Data",
        "P_YS_FED_FW_0000021195": "Putian",
        "P_YS_FED_FW_0000021196": "Luoyang",
        "P_YS_FED_FW_0000021190": "Ranking List Config. Info",
        "P_YS_FED_FW_0001204910": "]. Please check",
        "P_YS_FED_IMP_IOT0000007125": "Dunhua",
        "P_YS_FED_IMP_IOT0000008459": "Xinqing District",
        "P_YS_FED_IMP_IOT0000007128": "Yidu",
        "P_YS_FED_IMP_IOT0000009787": "Yongdeng County",
        "P_YS_FED_IMP_IOT0000007127": "Huili County",
        "P_YS_FED_IMP_IOT0000008457": "Mabian Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000009788": "Yanliang District",
        "P_YS_FED_IMP_IOT0000007129": "Zuoquan County",
        "P_YS_FED_IMP_IOT0000008450": "Yuepuhu County",
        "P_YS_FED_IMP_IOT0000009781": "Liuhe District",
        "P_YS_FED_FW_0000021188": "Tianjin",
        "P_YS_FED_FW_0001154160": "The personal scheme cannot be modified to a public scheme, and it will be saved as a public scheme. Continue?",
        "P_YS_FED_FW_0000021189": "Municipalities/Counties Directly under the Jurisdiction of Hubei Province",
        "P_YS_FED_IMP_IOT0000007122": "Nangong City",
        "P_YS_FED_IMP_IOT0000009785": "Suxian District",
        "P_YS_FED_IMP_IOT0000007121": "Qusong County",
        "P_YS_FED_IMP_IOT0000009786": "Gangcheng District",
        "P_YS_FED_IMP_IOT0000009783": "Lulong County",
        "P_YS_FED_IMP_IOT0000007123": "Baixia District",
        "P_YS_FED_IMP_IOT0000009784": "Xiping County",
        "P_YS_PF_PRINT_0000057874": "Total Order Qty",
        "P_YS_FED_EXAMP_0000020241": "Please select issue warehouse first",
        "P_YS_PF_GZTSYS_0000012021": "SKU Property",
        "P_YS_FED_EXAMP_0000020240": "Development in progress. Stay tuned",
        "P_YS_HR_HRRCPDF_0001127373": "View Progress",
        "P_YS_FED_FW_0000022408": "Ranking Column",
        "P_YS_FED_EXAMP_0000020236": "Copy Link",
        "P_YS_FED_FW_0000022409": "Average",
        "P_YS_FED_EXAMP_0000020235": "Current Adj Amt cannot be greater than 0",
        "P_YS_FED_IMP_IOT0000008448": "Lacey",
        "P_YS_FED_IMP_IOT0000009779": "Incorrect mobile number format",
        "P_YS_FED_FW_0000022406": "Error in metadata configuration",
        "P_YS_FED_EXAMP_0000020238": "Card/voucher sales business not enabled. Cannot select card/voucher business type",
        "P_YS_FED_IMP_IOT0000007117": "Fusui County",
        "P_YS_FED_FW_0000022407": "Confirm to disable this template?",
        "P_YS_PF_GZTACT_0000015996": "Employee",
        "P_YS_FED_EXAMP_0000020237": "Wrong product category data displayed",
        "P_YS_FED_IMP_IOT0000007116": "Xiangcheng District",
        "P_YS_FED_IMP_IOT0000009777": "Zhongzhan District",
        "P_YS_FED_EXAMP_0000020232": "Product Brand",
        "P_YS_FED_EXAMP_0000020231": "Cannot be executed during member wallet top-up",
        "P_YS_FED_IMP_IOT0000007118": "Nanjian Yi Autonomous County",
        "P_YS_FED_EXAMP_0000020234": "Only hold Doc",
        "P_YS_FED_IMP_IOT0000008449": "Linxiang District",
        "P_YS_FED_EXAMP_0000020233": "Number",
        "P_YS_FED_FW_0000022400": "Warehousing Center",
        "P_YS_FED_FW_0000022401": "Recipient",
        "P_YS_FED_FW_0000022404": "Close other tabs",
        "P_YS_FED_IMP_IOT0000007111": "Fangzi District",
        "P_YS_FED_IMP_IOT0000008443": "Dongpo District",
        "P_YS_FED_FW_0000022405": "Failed to verify the fields in configuration Info. There're fields that do not exist in the column; before conversion",
        "P_YS_FED_EXAMP_0000020239": "Changing the delivery warehouse will update the added product synchronously. Confirm to update?",
        "P_YS_FED_FW_0000022402": "Scheme Name:",
        "P_YS_FED_FW_0000022403": "Interval",
        "P_YS_FED_IMP_IOT0000008442": "Shuangliu County",
        "P_YS_FED_IMP_IOT0000009773": "Gaochun County",
        "P_YS_FED_EXAMP_0000020250": "Product File",
        "P_YS_FED_EXAMP_0000020252": "Rounding",
        "P_YS_PF_PRINT_0000057882": "Birth Date",
        "P_YS_FED_EXAMP_0000020251": "Select Store",
        "P_YS_FED_FW_1525642288515514373": "Auto hide the panel after querying",
        "P_YS_FED_FW_0000022419": "(No more than 1M; supported formats: jpg, bmp, png and jpeg; for pictures larger than 700*700, they can be zoomed in in the product details page)",
        "P_YS_FED_EXAMP_0000020247": "Confirm to clear whole Doc?",
        "P_YS_FED_IMP_IOT0000008436": "Huaiyuan County",
        "P_YS_FED_IMP_IOT0000009767": "Nanxian",
        "P_YS_FED_EXAMP_0000020246": "Promotion activity has been executed. Cannot modify card/voucher No.",
        "P_YS_FED_IMP_IOT0000007103": "Yanjin County",
        "P_YS_FED_IMP_IOT0000009768": "Zhongyuan District",
        "P_YS_FED_FW_0000022417": "Digit",
        "P_YS_FED_EXAMP_0000020249": "Login 124",
        "P_YS_FED_IMP_IOT0000007106": "Baoqing County",
        "P_YS_FED_IMP_IOT0000008434": "Haiyuan County",
        "P_YS_FED_FW_0000022418": "Publish Report Scheme  saveMenu  Parameter name =",
        "P_YS_FED_EXAMP_0000020248": "No camera ID/IP specified for POS terminal. Please configure",
        "P_YS_FED_IMP_IOT0000007105": "Zhifu District",
        "P_YS_FED_EXAMP_0000020243": "The warehouses in the detail lines must be consistent in the online retailer/online retailer return status",
        "P_YS_FED_IMP_IOT0000007108": "Xiahe County",
        "P_YS_FED_EXAMP_0000020242": "%. Confirm to settle?",
        "P_YS_PF_GZTSYS_0000012026": "Album",
        "P_YS_FED_EXAMP_0000020245": "Form Template Design",
        "P_YS_FED_IMP_IOT0000009769": "Wuxi",
        "P_YS_FED_EXAMP_0000020244": "The current period cannot span across days. Please select time again",
        "P_YS_FED_IMP_IOT0000007109": "Jinniu District",
        "P_YS_FED_IMP_IOT0000008439": "Youxian District",
        "P_YS_FED_FW_0000022411": "Failed to obtain data",
        "P_YS_FED_FW_0000022412": "Company Fax",
        "P_YS_FED_FW_0000022410": "Please enter the full address",
        "P_YS_FED_FW_0000022415": "Enable",
        "P_YS_FED_IMP_IOT0000007100": "Weiyuan County",
        "P_YS_FED_FW_0000022413": "Filter Name",
        "P_YS_FED_IMP_IOT0000007102": "Zhaodong",
        "P_YS_FED_IMP_IOT0000008430": "Qingxiu District",
        "P_YS_FED_FW_0000022414": "Subscription Frequency",
        "P_YS_FED_IMP_IOT0000009762": "Huanren Manchu Autonomous County",
        "P_YS_HR_HRXCF_0000056174": "Last Year",
        "P_YS_FED_FW_0001138953": "Data error. Failed to find the corresponding scheme",
        "P_YS_SCM_USTOCK_0001131722": "New",
        "P_YS_FED_EXAMP_0000020261": "The suffix of the starting card/voucher No. is not the same as that of the ending card/voucher No.",
        "P_YS_FED_EXAMP_0000020260": " ",
        "P_YS_FED_EXAMP_0000020263": "Gift",
        "P_YS_FED_EXAMP_0000020262": "The current line cannot be changed",
        "P_YS_FED_EXAMP_0000020258": "Card/voucher Qty should be 1 for physical card/voucher product sales",
        "P_YS_FED_EXAMP_0000020257": "Current Doc Amt is 0. Continue?",
        "P_YS_FED_IMP_IOT0000008426": "Fuquan",
        "P_YS_FED_IMP_IOT0000009757": "Tumutuoqi",
        "P_YS_PF_GZTSYS_0000013325": "Label",
        "P_YS_FED_IMP_IOT0000009754": "Haojiang District",
        "P_YS_FED_EXAMP_0000020259": "Cannot modify salespersons during adjustment",
        "P_YS_FED_IMP_IOT0000009755": "Longling County",
        "P_YS_FED_EXAMP_0000020254": "For original order return, salespersons in replacement lines cannot be modified",
        "P_YS_FED_IMP_IOT0000008429": "Wucheng County",
        "P_YS_PF_GZTSYS_0000015985": "Query Scheme",
        "P_YS_FED_EXAMP_0000020253": "Please enter member first",
        "P_YS_FED_EXAMP_0000020256": "Transfer from Branch",
        "P_YS_FED_EXAMP_0000020255": "User & Role",
        "P_YS_SCM_USTOCK_0001131725": "Save",
        "P_YS_FED_IMP_IOT0000009752": "Zhongjiang County",
        "P_YS_FED_FW_0001322216": "The currently selected node contains children. Confirm to delete?",
        "P_YS_FED_IMP_IOT0000009753": "Rongshui Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000009750": "Yanggao County",
        "P_YS_FED_IMP_IOT0000008420": "Hengfeng County",
        "P_YS_FED_IMP_IOT0000009751": "Linli County",
        "P_YS_FED_EXAMP_0000020272": "Book",
        "P_YS_FED_EXAMP_0000020271": "6-20 numbers or letters; spaces not allowed",
        "P_YS_FED_EXAMP_0000020274": "Return data processing failed",
        "P_YS_FED_EXAMP_0000020273": "Product with the SN already exists",
        "P_YS_FED_EXAMP_0000020270": "Failed to get the prompt of whether to display kitchen printing",
        "P_YS_FED_EXAMP_0000020269": "All the products of the bundle sale need to be selected",
        "P_YS_FED_IMP_IOT0000009745": "Aohan Banner",
        "P_YS_FED_EXAMP_0000020268": "Actual refunded Amt must be less than or equal to 0",
        "P_YS_FED_IMP_IOT0000008415": "Xiajin County",
        "P_YS_FED_IMP_IOT0000008413": "Anyuan County",
        "P_YS_FED_FW_1602282827388813325": "不显示列的值",
        "P_YS_FED_EXAMP_0000020265": "A/R Amt cannot be less than card/voucher settlement Amt. Please check",
        "P_YS_FI_FP_0001126682": "Service exception",
        "P_YS_FED_EXAMP_0000020264": "Cannot perform shortcut settlement in the status",
        "P_YS_FED_EXAMP_0000020267": "Voucher Function",
        "P_YS_FED_FW_1602282827388813328": "计算该数值列的平均值",
        "P_YS_FED_EXAMP_0000020266": "cannot be found in the salesperson list",
        "P_YS_FED_IMP_IOT0000008417": "Yining County",
        "P_YS_FED_IMP_IOT0000008410": "Anju District",
        "P_YS_FED_FW_1602282827388813322": "计算该数值列所有数据的和",
        "P_YS_FED_IMP_IOT0000009742": "Nanhe County",
        "P_YS_FED_IMP_IOT0000009740": "Tianqiao District",
        "P_YS_FED_FW_0000021120": "Jinzhong",
        "P_YS_FED_FW_0000022451": "Select at most",
        "P_YS_FED_FW_0000021121": "Error in preset Qty/Amt/unit price",
        "P_YS_FED_FW_0000022452": "Italian",
        "P_YS_FED_FW_0000022450": "Left Y Axis",
        "P_YS_PF_GZTSYS_0000013395": "Sales Region",
        "P_YS_PF_GZTSYS_0000013390": "Daily Settlement",
        "P_YS_FED_FW_1602282827388813316": "显示该列所有值，并用逗号分隔",
        "P_YS_FED_FW_0000021119": "Dehong Dai and Jingpo Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000008401": "Shangrao County",
        "P_YS_FED_FW_1602282827388813313": "显示该列中的最小值",
        "P_YS_FED_IMP_IOT0000008407": "Bei'an",
        "P_YS_FED_FW_1602282827388813319": "显示该列中的最大值",
        "P_YS_FED_IMP_IOT0000008408": "Yuyao",
        "P_YS_FED_IMP_IOT0000008405": "Mulei Kazakh Autonomous County",
        "P_YS_FED_IMP_IOT0000009737": "Shan County",
        "P_YS_FED_FW_0000021113": "Liaoyang",
        "P_YS_FED_FW_0000022444": "Keep at least one row of data",
        "P_YS_FED_FW_0001376079": "Incorrect. Please enter and try again",
        "P_YS_FED_FW_0000021114": "Aba Tibetan and Qiang Autonomous Prefecture",
        "P_YS_FED_FW_0000022445": "Close All",
        "P_YS_FED_FW_1435192751107342336": "Min value reached. Cannot decrease",
        "P_YS_FED_FW_0000021111": "Jiaozuo",
        "P_YS_FED_FW_0000022442": "Display Bar",
        "P_YS_FED_FW_0000021112": "Failed to cache data",
        "P_YS_FED_FW_0000022443": "Error in obtaining filter criteria",
        "P_YS_FED_FW_0000021117": "Taiwan",
        "P_YS_FED_FW_0000022448": "Select at most 16 menu items",
        "P_YS_FED_FW_1435192751107342339": "Max value reached. Cannot increase",
        "P_YS_FED_FW_0000021118": "Mobile Report  MobileReport Render sumFieldsCount",
        "P_YS_FED_FW_0000022449": "Report Group Scheme Config. Info",
        "P_YS_FED_IMP_IOT0000009731": "Changshou District",
        "P_YS_FED_FW_0000021115": "Yantai",
        "P_YS_FED_FW_0000022446": "Incorrect refresh rate settings",
        "P_YS_FED_FW_0000021116": "Hezhou",
        "P_YS_FED_FW_0000022447": "Draft Name",
        "P_YS_FED_FW_0000021131": "Yingkou",
        "P_YS_FED_FW_0000022462": "Update failed. Returned Info:",
        "P_YS_FED_FW_0000021132": "Jilin",
        "P_YS_FED_FW_0000022463": "Graph report for monitoring views  getConfig",
        "P_YS_FED_FW_0000022460": "Cannot move key fields",
        "P_YS_FED_FW_0000022461": "Column Name and Formula are required. Please fill in completely and try again",
        "P_YS_FED_FW_0000021130": "Online",
        "P_YS_FED_IMP_IOT0000009729": "Liuba County",
        "P_YS_FED_EXAMP_0000020203": "When Return to Store is set to No, return-to-warehouse is required",
        "P_YS_FED_EXAMP_0000020202": "Amt in the product line cannot be 0",
        "P_YS_FED_EXAMP_0000020205": "Failed to match the recognized product in the product file",
        "P_YS_FED_EXAMP_0000020204": ", prepaid card No. not entered for the product",
        "P_YS_FED_IMP_IOT0000009727": "Zhanyi County",
        "P_YS_FED_EXAMP_0000020201": "Role",
        "P_YS_FED_IMP_IOT0000009725": "Mengcun Hui Autonomous County",
        "P_YS_FED_EXAMP_0000020200": "Room Info not entered. Continue to settle?",
        "P_YS_FED_FW_0000021124": "Total",
        "P_YS_FED_FW_0000022455": "Currently only JPG/PNG files are supported",
        "P_YS_FED_FW_0000021125": "No data",
        "P_YS_FED_FW_0000022456": "Design",
        "P_YS_FED_FW_0000021122": "Macau S.A.R",
        "P_YS_FED_FW_0000022453": "Failed to obtain the favorite function list",
        "P_YS_FED_FW_0000022454": "Multiple rows of 1-D table matched. Please check. rowItemMatchInfo =",
        "P_YS_FED_FW_0000021123": "Trial Acct",
        "P_YS_FED_FW_0000021128": "Ulanchabu",
        "P_YS_FED_FW_0000022459": "Office",
        "P_YS_FED_EXAMP_0000020207": "Approved",
        "P_YS_FED_FW_0000021129": "Macao",
        "P_YS_FED_FW_0000021126": "Hebi",
        "P_YS_FED_FW_0000022457": "Save as Common Scheme",
        "P_YS_FED_EXAMP_0000020209": "Count sales volume in the specified date range",
        "P_YS_FED_FW_0000021127": "Guilin",
        "P_YS_FED_EXAMP_0000020208": "Picture",
        "P_YS_FED_FW_0000022458": "Copy Template",
        "P_YS_FED_FW_0000022430": "Date Separator",
        "P_YS_FED_IMP_IOT0000009719": "Changbai Korean Autonomous County",
        "P_YS_FED_EXAMP_0000020214": "Please modify the return Info in sub-line of bundle sale",
        "P_YS_FED_IMP_IOT0000009712": "Wenxian",
        "P_YS_FED_EXAMP_0000020213": "Only card/voucher product can be selected under the card/voucher business type",
        "P_YS_FED_FW_0000022428": "Please set filterId",
        "P_YS_FED_EXAMP_0000020216": "Amt in product line must be adjusted",
        "P_YS_FED_IMP_IOT0000009710": "Feicheng",
        "P_YS_FED_FW_0000022429": "Failed to get the sensitive data list",
        "P_YS_FED_EXAMP_0000020215": "Cancel auto promotion?",
        "P_YS_FED_EXAMP_0000020210": "Delivery",
        "P_YS_FED_EXAMP_0000020212": "Promotion activity has been executed. Cannot change retail price",
        "P_YS_FED_IMP_IOT0000009714": "Anyi County",
        "P_YS_FED_EXAMP_0000020211": "Warehouse in the detail line is required",
        "P_YS_FED_IMP_IOT0000009715": "Xiuwen County",
        "P_YS_FED_FW_0000022422": "*Template Name:",
        "P_YS_HR_HRJQF_0000054440": "Display Not Enabled",
        "P_YS_FED_FW_0000022423": "Enter a template code",
        "P_YS_FED_FW_0000022420": "Add Date/Time",
        "P_YS_FED_FW_0000022421": "An area with duplicate code exists:",
        "P_YS_FED_FW_0000022426": "Hot zone display picture will not be refreshed",
        "P_YS_FED_EXAMP_0000020218": "Cannot modify the retail prices of bundle sales",
        "P_YS_FED_FW_0000022427": "The file value and name field are required",
        "P_YS_FED_EXAMP_0000020217": "button's function permission. Cannot operate",
        "P_YS_FED_FW_0000022424": "Add Spec. Value",
        "P_YS_FED_FW_0000022425": "Bar Chart",
        "P_YS_FED_EXAMP_0000020219": "Compared to Previous Period",
        "P_YS_HR_HRJQF_0000054435": "Emp. Name",
        "P_YS_FED_FW_0000022440": "Background Style",
        "P_YS_FED_FW_1435759635250806784": "Environment variable process.env[domain.gpaas.url] and process.env[public.domain.gpaas.url] are not configured. Hubble collection failed",
        "P_YS_FED_FW_0000021110": "Yichun",
        "P_YS_FED_FW_0000022441": "No search result",
        "P_YS_HR_HRJQF_0000054439": "Length of Service",
        "P_YS_FED_IMP_IOT0000009709": "Tongde County",
        "P_YS_FED_FW_0001287429": "Locked as display",
        "P_YS_FED_EXAMP_0000020230": "Already executed",
        "P_YS_PF_GZTSYS_0000013382": "Form Template",
        "P_YS_FED_FW_1628198325042282505": "证件内容为空",
        "P_YS_FED_FW_1564270202179813377": "Legal value:",
        "P_YS_FED_EXAMP_0000020225": "Wangfujing Store",
        "P_YS_FED_IMP_IOT0000009701": "Yingquan District",
        "P_YS_HR_HRJXF_0000059839": "Feedback",
        "P_YS_FED_EXAMP_0000020224": "When it's not allowed to modify product upon delivery, product cannot be added",
        "P_YS_FED_FW_0000021108": "Qinghai",
        "P_YS_FED_FW_0000022439": "Display",
        "P_YS_FED_EXAMP_0000020227": "When Return to Store is set to No and return-to-warehouse is empty, settlement is not allowed",
        "P_YS_FED_FW_0000021109": "Two Columns",
        "P_YS_FED_EXAMP_0000020226": ") with SN control enabled. Please enter SN",
        "P_YS_FED_IMP_IOT0000009700": "Yuzhou",
        "P_YS_FED_EXAMP_0000020221": "Promotion activity has been executed. Cannot execute voucher",
        "P_YS_FED_EXAMP_0000020220": "] does not exist, or the SN is in Issued status",
        "P_YS_FED_IMP_IOT0000009706": "Yuzhong County",
        "P_YS_FED_EXAMP_0000020223": "Tel:",
        "P_YS_FED_IMP_IOT0000009703": "Shenmu County",
        "P_YS_FED_EXAMP_0000020222": "Only card/voucher product can be entered under the card/voucher business type",
        "P_YS_FED_IMP_IOT0000009704": "Diebu County",
        "P_YS_FED_FW_0000021102": "Xinzhou",
        "P_YS_FED_FW_0000022433": "No control",
        "P_YS_FED_FW_0000021103": "Weihai",
        "P_YS_FED_FW_0000022434": "Numeric Font Size",
        "P_YS_FED_FW_0001604215": "请选择行在进行下移操作！",
        "P_YS_FED_FW_0000021100": "Table",
        "P_YS_FED_FW_0000022431": "Only one attachment can be uploaded now. Please delete it and upload again",
        "P_YS_FED_FW_0000021101": "Lanzhou",
        "P_YS_FED_FW_0000022432": "Please enter company fax",
        "P_YS_FED_FW_0000021106": "Shuozhou",
        "P_YS_FED_FW_0000022437": "Template Code/Template Name cannot contain double-byte chars",
        "P_YS_FED_EXAMP_0000020229": "Member Wallet Top-up Function",
        "P_YS_FED_FW_0000021107": "Changsha",
        "P_YS_FED_FW_0000022438": "Error in loading picture. Picture address:",
        "P_YS_FED_EXAMP_0000020228": "Current Adj Amt cannot be 0",
        "P_YS_FED_FW_0000021104": "Mobile Report  getSolutionList Err",
        "P_YS_FED_FW_0000022435": "Invalid entry. Please check",
        "P_YS_FED_FW_0001287430": "Clear Filter",
        "P_YS_FED_FW_0001604216": "请选择行在进行上移操作！",
        "P_YS_FED_FW_0000021105": "Dongguan",
        "P_YS_FED_FW_0000022436": "Please set report",
        "P_YS_SD_UDHWN_0000049316": "Jiyuan City",
        "P_YS_SD_UDHWN_0000050306": "Pinggu District",
        "P_YS_PF_METADATA_0000084512": "Event Type",
        "P_YS_FI_FIEIA-FE_1519816251266301957": "子表第",
        "P_YS_PF_METADATA_0000085849": "Trademark",
        "P_YS_SD_UDHWN_0000050316": "Daxing District",
        "P_YS_FED_FW_1535350529502740485": "Null",
        "P_YS_FED_FW_1582845738146070530": "Click Start Sweep Code",
        "P_YS_PF_METADATA_0000085850": "Website",
        "P_YS_FED_FW_1535350529502740488": "Null",
        "P_YS_PF_GZTSYS_0000015817": "Board",
        "P_YS_FED_FW_0001045104": "restoreEditPanel Filtered Info should be obtained from items and assigned to pageLayout, but items is empty (may be due to Info loss). pageLayout =",
        "P_YS_SD_URETAIL_0001049031": "Error in updating data. Failure reason:",
        "P_YS_FED_FW_0001563307": "&region=北京&output=json&ak=",
        "P_YS_SD_UDHWN_0000050326": "Ledong Li Autonomous County",
        "P_YS_FED_UCFORG_0000031966": "Previous",
        "P_YS_FED_UIMG_0000111351": "Expression is required",
        "P_YS_FED_FW_1593218496493781008": "文献共同検索の結果",
        "P_YS_FED_IMP_IOT0000010600": "Danyang",
        "P_YS_FED_IMP_IOT0000010606": "Xinglongtai District",
        "P_YS_FED_IMP_IOT0000010607": "Xinghua City",
        "P_YS_FED_FW_0000137710": "to ：",
        "P_YS_FED_IMP_IOT0000010613": "Songjiang District",
        "P_YS_FED_IMP_IOT0000010614": "Liwan District",
        "P_YS_PF_SOCD_0000089309": "Ukraine",
        "P_YS_PF_SOCD_0000089307": "Yugoslavia",
        "P_YS_FED_IMP_IOT0000010611": "Tiedong District",
        "P_YS_FED_FW_0000137708": "Field ele currently edited in batch:",
        "P_YS_PF_SOCD_0000089308": "Spain",
        "P_YS_FED_FW_0000137707": "Cannot find all the list region configuration fields in the column: codeField stateField captionFields",
        "P_YS_PF_SOCD_0000089305": "Sierra Leone",
        "P_YS_FED_FW_0000137706": "Error in batch modification: this.gridModel.getColumns() is empty",
        "P_YS_PF_SOCD_0000089306": "Azerbaijan",
        "P_YS_FED_FW_0000137705": "The current operator is not supported during batchModify. filter =",
        "P_YS_FED_FW_0000137704": "Refresh time not set, or the refresh time set is too short",
        "P_YS_PF_SOCD_0000089304": "Kazakhstan",
        "P_YS_FED_FW_0000137703": "batchModify setUETypeAndDataType Err. Failed to obtain the correct field type during batch modification",
        "P_YS_FED_IMP_IOT0000010617": "Lubei District",
        "P_YS_FED_FW_0000137702": "Failed to obtain column definition. Info:",
        "P_YS_FED_FW_0000137701": "Failed to obtain grouping permission Info. Info:",
        "P_YS_FED_FW_0000137700": "::::[StatusBar] ,info: cus/getCusDigest No data requested",
        "P_YS_FED_FW_0000137721": "communication ---Parameter Conversion --> Error",
        "P_YS_FED_FW_0000137720": "False is returned for the condition. If you have any questions, please refer to the Doc https://www.yuque.com/gpgy5k/ucf/nzso9u",
        "P_YS_FED_IMP_IOT0000010626": "Xifeng County",
        "P_YS_FED_IMP_IOT0000010620": "Xiling District",
        "P_YS_FED_IMP_IOT0000010621": "Ganzi County",
        "P_YS_FED_IMP_IOT0000010623": "Dawu County",
        "P_YS_FED_FW_0000137718": "dbName---Error",
        "P_YS_FED_FW_0000137717": "No data matched",
        "P_YS_FED_FW_0000137716": "extendField data configuration error",
        "P_YS_SD_UDHWN_0001008443": "↑",
        "P_YS_FED_FW_0000137714": "Error in batch modification: no GridModel is found during batchModify initialization",
        "P_YS_FED_IMP_IOT0000010628": "Jianhua District",
        "P_YS_SD_UDHWN_0001008444": "↓",
        "P_YS_FED_FW_0000137713": "Your browser does not support IndexedDB",
        "P_YS_FED_IMP_IOT0000010629": "Minqing County",
        "P_YS_FED_FW_0000137712": "Failed to save grouping conditions. Info:",
        "P_YS_FED_FW_0000137711": "Filtered field Info filterObjs currently entered:",
        "P_YS_PF_GZTSYS_0000015859": "Data Source",
        "P_YS_FED_FW_0000137730": "---------OK Button-----------",
        "P_YS_SD_URETAIL_0001049078": "Log listening in progress...",
        "P_YS_FED_IMP_IOT0000010630": "Fuding",
        "P_YS_FED_IMP_IOT0000010632": "Leizhou",
        "P_YS_FED_IMP_IOT0000010633": "Huaiyin District",
        "P_YS_FED_FW_0000137729": " ",
        "P_YS_FED_FW_0000137728": "addAttachment needs to be configured for extended script",
        "P_YS_FED_FW_0000137727": "Sub-table ID missing",
        "P_YS_PF_SOCD_0000089325": "Kuwait",
        "P_YS_FED_FW_0000137726": "cb.lang not loaded. Error in multilingual configuration",
        "P_YS_PF_SOCD_0000089326": "Jamaica",
        "P_YS_PF_GZTSYS_0000015829": "Report",
        "P_YS_FED_FW_0000137725": "inputnumber has no model",
        "P_YS_FED_IMP_IOT0000010639": "Huidong County",
        "P_YS_FED_FW_0000137724": "  ",
        "P_YS_PF_SOCD_0000089324": "Senegal",
        "P_YS_FED_FW_0000137723": "%c 2-D Table Log Warning",
        "P_YS_PF_SOCD_0000089321": "Madagascar",
        "P_YS_FED_FW_0000137722": "2-D Table Log",
        "P_YS_PF_SOCD_0000089322": "Gambia",
        "P_YS_SD_URETAIL_0001049087": "Confirm to clear the selected product?",
        "P_YS_FED_FW_1437398955540348928": "Select 15 summary items at most",
        "P_YS_FED_FW_0000111115": " /page",
        "P_YS_FED_FW_0001425472": "条选中",
        "P_YS_FED_IMP_IOT0000010641": "Yihuang County",
        "P_YS_FED_IMP_IOT0000010646": "Dongliao County",
        "P_YS_FED_IMP_IOT0000010647": "Tiandong County",
        "P_YS_FED_IMP_IOT0000010642": "Qiaocheng District",
        "P_YS_FED_IMP_IOT0000010643": "Lake District",
        "P_YS_PF_SOCD_0000089318": "Estonia",
        "P_YS_PF_SOCD_0000089316": "Canada",
        "P_YS_PF_SOCD_0000089317": "Japan",
        "P_YS_PF_SOCD_0000089314": "Tajikistan",
        "P_YS_PF_SOCD_0000089315": "Uganda",
        "P_YS_PF_SOCD_0000089310": "Uruguay",
        "P_YS_PF_SOCD_0000089311": "Suriname",
        "P_YS_HR_HRJQ_0000031330": "12.0",
        "P_YS_FED_IMP_IOT0000010651": "Renhe District",
        "P_YS_FED_IMP_IOT0000010652": "Jiangcheng Hani and Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000010656": "Chengxian",
        "P_YS_SD_UDHWN_0000050384": "Xiantao",
        "P_YS_FED_IMP_IOT0000010661": "Shahe",
        "P_YS_FED_IMP_IOT0000010662": "Yingdong District",
        "P_YS_FED_IMP_IOT0000010669": "Shayang County",
        "P_YS_FED_IMP_IOT0000010664": "Ning'an",
        "P_YS_FED_IMP_IOT0000010665": "Wangyi District",
        "P_YS_FED_IMP_IOT0000010666": "Yiling District",
        "P_YS_FED_IMP_IOT0000010671": "Qingzhen",
        "P_YS_FED_IMP_IOT0000010672": "Urumqi County",
        "P_YS_FED_IMP_IOT0000010679": "Manzhouli",
        "P_YS_PF_PROCENTER_0000027049": "Save As",
        "P_YS_FED_IMP_IOT0000010682": "Puning",
        "P_YS_FED_IMP_IOT0000010685": "Hangjinqi",
        "P_YS_FED_UIMG_0001237120": "Left",
        "P_YS_FED_UIMG_0001237119": "Up",
        "P_YS_FED_IMP_IOT0000010686": "Hanshou County",
        "P_YS_FED_IMP_IOT0000010689": "Southern suburbs",
        "P_YS_SD_SDMB-UI_0001140276": "Please enter order number",
        "P_YS_FED_FW_0001083419": "ID card format error.",
        "P_YS_FED_IMP_IOT0000010693": "Long'an County",
        "P_YS_FED_IMP_IOT0000010692": "Zichang County",
        "P_YS_PF_PROCENTER_0000023508": " ",
        "P_YS_SD_SDSD-FE_0001486259": "日期時間",
        "P_YS_FED_IMP_IOT0000010697": "Dulan County",
        "P_YS_FED_FW_1525783781928599556": "Please obtain the location",
        "P_YS_FED_IMP_IOT0000010699": "Jiayin County",
        "P_YS_FED_FW_1443151222423420928": "——————————",
        "P_YS_OA_XTLCZX_0000032004": "No matching data",
        "P_YS_SD_SDOC_0001150290": "Return Sign-in",
        "P_YS_SD_UDHWN_0000122310": "Order Type:",
        "P_YS_FED_FW_0001083420": "Bank card format error.",
        "P_YS_FED_FW_0001154320": "Please enter the required items of <%=text%>",
        "P_YS_FED_UIMG_0001065827": "Cannot perform Sum on the non-numeric fields",
        "P_YS_FED_FW_0001154325": "Please enter the following required items",
        "P_YS_FED_FW_0001071458": "The length of the file name cannot exceed 10 chars",
        "P_YS_SD_UDHWN_0001009722": "1 Min",
        "P_YS_SD_SDMB_0000148279": "~",
        "P_YS_FED_FW_1572544576923631641": "Data loading ~",
        "P_YS_FED_FW_1473069861501927437": "searchDevices failed. Error Info:",
        "P_YS_FED_FW_1473069861501927434": "printPicture failed. Error Info:",
        "P_YS_SD_SDMB_0000150570": "App Center",
        "P_YS_FED_FW_0001096749": "Failed to obtain data. Interface error.",
        "P_YS_SD_UDHWN_0001009713": "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sept_Oct_Nov_Dec",
        "P_YS_SD_UDHWN_0001009717": "[Yesterday] LT",
        "P_YS_FED_FW_1572544576923631638": "It's over ~",
        "P_YS_FED_IMP_IOT0000008294": "Xia County",
        "P_YS_FED_IMP_IOT0000008298": "Zhenyuan County",
        "P_YS_FED_FW_1473069861501927431": "searchDevices complete. Info:",
        "P_YS_FED_FW_1572544576923631635": "Tag needs to be configured as select/input type",
        "P_YS_FED_FW_0000021281": "Meishan",
        "P_YS_FED_FW_0001026029": "Supports <%=accept%> only",
        "P_YS_FED_FW_0000021282": "Jinzhou",
        "P_YS_HR_HRJQ_0000031296": "Emp. No.",
        "P_YS_FED_FW_0000021280": "Longyan",
        "P_YS_FED_FW_0000021285": "Taiyuan",
        "P_YS_PF_SOCD-E_0000354672": "United Arab Emirates",
        "P_YS_FED_FW_0000021286": "Xianyang",
        "P_YS_FED_IMP_IOT0000007080": "Zhongba County",
        "P_YS_FED_FW_0000021283": "Huizhou",
        "P_YS_FED_IMP_IOT0000007083": "Meijiang District",
        "P_YS_FED_FW_0000021284": "Lijiang",
        "P_YS_FED_IMP_IOT0000007082": "Ruichang",
        "P_YS_SD_SDSD-FE_0001486298": "創建人",
        "P_YS_FED_EXAMP_0000020199": "Label List",
        "P_YS_FED_EXAMP_0000020198": "Inconsistent password entered",
        "P_YS_FED_FW_0000021278": "Exceeded upload limit. Please delete some and upload again",
        "P_YS_FED_FW_0001445807": "Total selected ",
        "P_YS_FED_FW_0000021279": "Data display area  width =",
        "P_YS_FED_IMP_IOT0000007073": "Lianjiang",
        "P_YS_HR_HRJQ_0000031291": "Import",
        "P_YS_FED_FW_0001445806": "Total selected ",
        "P_YS_FED_FW_0000021276": "Failed",
        "P_YS_FED_IMP_IOT0000007076": "Lang County",
        "P_YS_FED_FW_0000021277": "Weifang",
        "P_YS_FED_IMP_IOT0000007075": "Linjiang",
        "P_YS_FED_IMP_IOT0000007078": "Gujiao",
        "P_YS_FED_FW_0001026037": "<%=caption%> has been referenced by this formula. Circular reference is not allowed",
        "P_YS_FED_IMP_IOT0000007077": "Echeng District",
        "P_YS_FED_FW_0000021292": "Jining",
        "P_YS_FED_FW_0000021293": "Quzhou",
        "P_YS_FED_FW_0000021290": "Operation error",
        "P_YS_FED_FW_0001026038": "Confirm to <%=abandonText%>?",
        "P_YS_FED_FW_0000021291": "Ganzi Tibetan Autonomous Prefecture",
        "P_YS_FED_FW_0000021296": "Error in preset formatted field",
        "P_YS_FED_FW_0001094183": "] Method",
        "P_YS_FED_FW_0000021297": "refer  cFormatData. Error in preset data",
        "P_YS_FED_FW_0001094184": "End calling Action [",
        "P_YS_FED_FW_0000021294": "Hong Kong S.A.R",
        "P_YS_FED_IMP_IOT0000007072": "Shouguang",
        "P_YS_FED_FW_0000021295": "Mobile Report  MobileReport setSumFieldsCount sumFieldsCount",
        "P_YS_FED_IMP_IOT0000007071": "Huoshan County",
        "P_YS_HR_HRJQF_0000054539": "Year",
        "P_YS_HR_HRRCPDF_0000073182": "Not selected",
        "P_YS_FED_FW_1515244353091534848": "Please check the error reason and re-import after modification",
        "P_YS_OA_XTXIANGMU_0000063901": "Add Tag",
        "P_YS_FED_FW_0000021289": "Ningbo",
        "P_YS_FED_IMP_IOT0000007062": "Lishui County",
        "P_YS_FED_FW_0000021287": "Anshan",
        "P_YS_FED_FW_0000021288": "Huangnan Tibetan Autonomous Prefecture",
        "P_YS_FED_FW_0001026042": "Confirm to <%=cShowCaption%> the record?",
        "P_YS_FED_IMP_IOT0000008394": "Tianzhu County",
        "P_YS_FED_IMP_IOT0000007068": "Uma River District",
        "P_YS_FED_FW_0000021260": "Wenshan Zhuang and Miao Autonomous Prefecture",
        "P_YS_FED_FW_0000021263": "Jiujiang",
        "P_YS_FED_IMP_IOT0000008391": "Kashi",
        "P_YS_FED_FW_0000021264": "Liangshan Yi Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000008392": "Liaozhong County",
        "P_YS_FED_FW_0000021261": "Yunfu",
        "P_YS_FED_FW_0000021262": "Zigong",
        "P_YS_FED_FW_0000021256": "Beihai",
        "P_YS_FED_IMP_IOT0000007052": "Panji District",
        "P_YS_FED_FW_0000021257": "subConfig_Get  Cannot find the corresponding eChart  chartKey =",
        "P_YS_FED_IMP_IOT0000007051": "Jingning County",
        "P_YS_FED_IMP_IOT0000008385": "Yueyanglou District",
        "P_YS_FED_FW_0000021254": "Xiaogan",
        "P_YS_FED_FW_0000021255": "Zhaotong",
        "P_YS_FED_IMP_IOT0000007056": "Yonghe County",
        "P_YS_FED_IMP_IOT0000008388": "Ledu County",
        "P_YS_FED_IMP_IOT0000008389": "Eryuan County",
        "P_YS_FED_FW_0000021258": "Tangshan",
        "P_YS_FED_IMP_IOT0000008386": "Tianzhu Tibetan Autonomous County",
        "P_YS_FED_FW_0000021259": "Yangquan",
        "P_YS_FED_FW_0000021270": "Zhoukou",
        "P_YS_FED_FW_0000021271": "County Administrative Divisions Directly under the Jurisdiction of Province",
        "P_YS_FED_FW_0000021274": "Ningxia",
        "P_YS_FED_FW_0000021275": "Laibin",
        "P_YS_FED_IMP_IOT0000008381": "Wengniute Banner",
        "P_YS_FED_FW_0000021272": "Nujiang Lisu Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000007050": "Guangzhou",
        "P_YS_FED_FW_0000021273": "No mobile filter obtained by filterId",
        "P_YS_FED_FW_0001104071": "Navigation",
        "P_YS_FED_IMP_IOT0000007049": "Tanghe County",
        "P_YS_FED_FW_0000021267": "eChartCommon  Update the filter criteria to remove the null values  after param =",
        "P_YS_FED_IMP_IOT0000007041": "Yuexi County",
        "P_YS_FED_IMP_IOT0000008373": "Zepu County",
        "P_YS_FED_FW_0000021268": "Hangzhou",
        "P_YS_FED_IMP_IOT0000008374": "Yuanjiang",
        "P_YS_FED_FW_0000021265": "Turpan Prefecture",
        "P_YS_FED_FW_0000021266": "Regional Manager Large Screen Board",
        "P_YS_FED_IMP_IOT0000007042": "Ruyuan Yao Autonomous County",
        "P_YS_FED_IMP_IOT0000008372": "Sujiatun District",
        "P_YS_FED_IMP_IOT0000008378": "Haizhou District",
        "P_YS_FED_FW_0000021269": "Huaibei",
        "P_YS_FED_IMP_IOT0000007047": "Lianhu District",
        "P_YS_FED_FW_0001026024": "<%=text%> Upload failed<%=code%>: <%=message%>",
        "P_YS_FED_IMP_IOT0000007046": "Xinbin Manchu Autonomous County",
        "P_YS_FED_FW_1486872262975422477": "Saved as draft",
        "P_YS_FED_FW_1486872262975422474": "Save as draft?",
        "P_YS_FED_EXAMP_0000020162": "Room rate product duration is required",
        "P_YS_FED_FW_1486872262975422471": "If you do not save, the edits will not be saved",
        "P_YS_FED_EXAMP_0000020161": "), it cannot be less than the ceiling of current operator's gold price discount Amt (",
        "P_YS_FED_EXAMP_0000020164": "Online retailer settlement is not allowed in the network status",
        "P_YS_FED_EXAMP_0000020163": "Prepaid Card - Card Selling Function",
        "P_YS_FED_EXAMP_0000020160": "SN [",
        "P_YS_FED_EXAMP_0000020159": "Cannot modify the Qty of physical cards/vouchers",
        "P_YS_FED_IMP_IOT0000007038": "Etuokeqianqi",
        "P_YS_FED_EXAMP_0000020158": "Current time interval:",
        "P_YS_FED_IMP_IOT0000008368": "Baiyu County",
        "P_YS_FED_IMP_IOT0000009699": "Yuanyang County",
        "P_YS_FED_IMP_IOT0000007039": "Foping County",
        "P_YS_FED_IMP_IOT0000008369": "Hengnan County",
        "P_YS_FED_EXAMP_0000020155": "Cannot modify salespersons when an order is canceled",
        "P_YS_FED_EXAMP_0000020154": "Pay",
        "P_YS_FED_EXAMP_0000020156": "Login token is invalid. Jump to the login page?",
        "P_YS_FED_IMP_IOT0000008362": "Daguan County",
        "P_YS_FED_IMP_IOT0000009694": "Qingyuan County",
        "P_YS_FED_IMP_IOT0000008360": "Jinghong",
        "P_YS_FED_IMP_IOT0000007032": "Songpan County",
        "P_YS_FED_IMP_IOT0000009691": "Huli District",
        "P_YS_FED_IMP_IOT0000007031": "Red Star District",
        "P_YS_FED_IMP_IOT0000008361": "Jinfeng District",
        "P_YS_FED_IMP_IOT0000009697": "Shangyou County",
        "P_YS_FED_IMP_IOT0000007033": "Fushan County",
        "P_YS_FED_IMP_IOT0000008367": "Qiaoxi District",
        "P_YS_FED_IMP_IOT0000009698": "Yuanling County",
        "P_YS_FED_FW_0001026078": "The summary item has been referenced by formula <%=text%>. Cannot cancel",
        "P_YS_FED_IMP_IOT0000007036": "Zherong County",
        "P_YS_FED_IMP_IOT0000009695": "Dancheng County",
        "P_YS_FED_IMP_IOT0000007035": "Gong'an County",
        "P_YS_FED_IMP_IOT0000008365": "Nyalam County",
        "P_YS_FED_IMP_IOT0000009696": "Luxi County",
        "P_YS_FED_EXAMP_0000020173": "All Apps",
        "P_YS_FED_EXAMP_0000020172": "The card No. has been entered. Please do not enter it again",
        "P_YS_FED_EXAMP_0000020175": "Room rate product end time is required",
        "P_YS_FED_EXAMP_0000020174": "The current business type is not top-up. Cannot use top-up adjustment",
        "P_YS_FED_EXAMP_0000020171": "Card/Voucher - Card Selling Function",
        "P_YS_FED_FW_0001142287": "Single-choice; In list/Not in list cannot be selected for the comparison operator. Please change to Equal/Not equal",
        "P_YS_FED_IMP_IOT0000007027": "Ganquan County",
        "P_YS_FED_FW_0001445832": "The Doc will be revoked to Not Submitted status. Confirm to revoke?",
        "P_YS_FED_EXAMP_0000020169": "Error Info:",
        "P_YS_FED_IMP_IOT0000007029": "Poyang County",
        "P_YS_FED_IMP_IOT0000009688": "Huachi County",
        "P_YS_FED_FW_0001142288": "Multi-choice; Equal/Not equal cannot be selected for the comparison operator. Please change to In list/Not in list",
        "P_YS_FED_IMP_IOT0000008358": "Shouyang County",
        "P_YS_FED_FW_0001026083": "Failed to import template contents, <%=text%>",
        "P_YS_FED_EXAMP_0000020166": "Cannot add product during online retailer return",
        "P_YS_FED_FW_0001026084": "Failed to import template contents. Returned Info: <%=text%>",
        "P_YS_FED_EXAMP_0000020165": "Cannot find the corresponding physical card of the prepaid card No.",
        "P_YS_FED_FW_0001444504": "Total selected ",
        "P_YS_FED_FW_0001026081": "<%=text%> uploaded successfully",
        "P_YS_FED_EXAMP_0000020168": ", there's no available batch No. for the product. Please adjust",
        "P_YS_FED_FW_0001026082": "Confirm to delete \"<%=text%>\"?",
        "P_YS_FED_EXAMP_0000020167": "The Qty in the current replacement line cannot be greater than that in the return line",
        "P_YS_FED_FW_0001026087": "Total: <%=actionText%><%=count%>; successful: <%=sucessCount%>; failed: <%=failCount%>",
        "P_YS_FED_IMP_IOT0000008351": "Suzhou District",
        "P_YS_FED_FW_0001026088": "<%=actionText%> failed: <%=messages%>",
        "P_YS_FED_IMP_IOT0000009683": "Chuzhou District",
        "P_YS_FED_FW_0001026085": "<%=text%> successful",
        "P_YS_FED_FW_0001026086": "Total: <%=actionText%><%=count%>; successful: <%=sucessCount%>",
        "P_YS_FED_IMP_IOT0000009681": "Taixing",
        "P_YS_FED_IMP_IOT0000008355": "Xinbei District",
        "P_YS_PF_PROCENTER_0000023573": "Exception",
        "P_YS_FED_UIMG_0000154415": "Template verification failed",
        "P_YS_FED_IMP_IOT0000007022": "Chaoyang District",
        "P_YS_FED_FW_0001026089": "<%=actionText%> successful",
        "P_YS_FED_IMP_IOT0000009684": "Jiaocheng County",
        "P_YS_FED_IMP_IOT0000008354": "Kuiwen District",
        "P_YS_FED_IMP_IOT0000009685": "Tongnan County",
        "P_YS_FED_EXAMP_0000020184": "When order is canceled,",
        "P_YS_FED_EXAMP_0000020183": "Close",
        "P_YS_FED_EXAMP_0000020186": "On-site discount cannot be executed during adjustment",
        "P_YS_FED_EXAMP_0000020185": ") Ushering Info",
        "P_YS_FED_EXAMP_0000020180": "Discount has been executed. Cannot modify SN",
        "P_YS_FED_EXAMP_0000020182": "Failed to log in with the demo user password: [interface]",
        "P_YS_FED_EXAMP_0000020181": "Cannot be executed during top-up",
        "P_YS_FED_IMP_IOT0000007016": "Qingliu County",
        "P_YS_FED_IMP_IOT0000009679": "Boat camp",
        "P_YS_FED_IMP_IOT0000007015": "Xiashan District",
        "P_YS_FED_IMP_IOT0000007017": "Pubei County",
        "P_YS_FED_IMP_IOT0000008347": "Haixing County",
        "P_YS_FED_IMP_IOT0000009678": "Qiaodong District",
        "P_YS_FED_EXAMP_0000020177": "Please log in as member and enter product",
        "P_YS_FED_EXAMP_0000020176": "Retail Price",
        "P_YS_FED_EXAMP_0000020179": "Failed to obtain large screen billing settings:",
        "P_YS_FED_FW_0001026054": "Confirm to <%=cCaption%> the <%=text%>?",
        "P_YS_FED_IMP_IOT0000008341": "Wanzai County",
        "P_YS_FED_FW_0000021298": "Other Info:",
        "P_YS_FED_FW_0001026052": "This operation will delete the current <%=text%> and its sub-<%=text%>. Continue or not?",
        "P_YS_FED_FW_0000021299": "Weinan",
        "P_YS_FED_FW_0001026053": "Confirm to delete the <%=text%>?",
        "P_YS_FED_FW_0001094182": "Start calling Action [",
        "P_YS_FED_FW_0001026058": "Confirm to <%=abandonText%>?",
        "P_YS_FED_IMP_IOT0000008344": "Xichang",
        "P_YS_FED_IMP_IOT0000007012": "Tongyu County",
        "P_YS_FED_IMP_IOT0000009675": "Huaxian",
        "P_YS_FED_IMP_IOT0000007011": "Wuqi County",
        "P_YS_FED_IMP_IOT0000008345": "Fenggang County",
        "P_YS_FED_IMP_IOT0000009676": "Yizheng",
        "P_YS_FED_IMP_IOT0000008342": "Jiangling County",
        "P_YS_FED_IMP_IOT0000009673": "Qiemo County",
        "P_YS_FED_FW_0001026057": "At most <%=level%> level(s) of category",
        "P_YS_FED_IMP_IOT0000008343": "Zhongfang County",
        "P_YS_FED_EXAMP_0000020195": "Cannot use vouchers for child product",
        "P_YS_FED_EXAMP_0000020194": "Current camera (camera IP/ID) is offline. Please check the cable",
        "P_YS_FED_EXAMP_0000020197": "Cannot enter members in the current network status. Please bill again",
        "P_YS_FED_EXAMP_0000020196": "Confirm to switch account? This operation will refresh the page",
        "P_YS_FED_EXAMP_0000020191": "Amt after adjustment is required",
        "P_YS_FED_EXAMP_0000020190": "The same product line already exists",
        "P_YS_FED_EXAMP_0000020193": "Cannot enter members during adjustment",
        "P_YS_FED_EXAMP_0000020192": "SN not entered in a numbered product line. Please check",
        "P_YS_FED_IMP_IOT0000007005": "Fuyuan County",
        "P_YS_FED_IMP_IOT0000008337": "Xinhuang Dong Autonomous County",
        "P_YS_FED_IMP_IOT0000009668": "Tianchang",
        "P_YS_FED_IMP_IOT0000007004": "Taonan",
        "P_YS_FED_IMP_IOT0000008335": "Chuanshan District",
        "P_YS_FED_IMP_IOT0000007006": "Yixian",
        "P_YS_FED_EXAMP_0000020188": "Reject",
        "P_YS_FED_EXAMP_0000020187": "Room Rate",
        "P_YS_FED_IMP_IOT0000008339": "Fuping County",
        "P_YS_FED_EXAMP_0000020189": "Tap again to exit",
        "P_YS_FED_IMP_IOT0000008330": "Jingyuan County",
        "P_YS_FED_IMP_IOT0000008333": "Linzhang County",
        "P_YS_FED_IMP_IOT0000007000": "Suining County",
        "P_YS_FED_IMP_IOT0000008334": "Dingyuan County",
        "P_YS_FED_IMP_IOT0000007003": "Longhu District",
        "P_YS_FED_IMP_IOT0000009663": "Jixian County",
        "P_YS_PF_PRINT_0000057998": "Upstream Doc No.",
        "P_YS_FED_FW_0001220211": "Error in the returned data of the parameter. The code is null. row =",
        "P_YS_FED_FW_0001220210": "func_CellCheck failed to find matching line Info",
        "P_YS_FED_FW_1478287954777997318": "show track",
        "P_YS_FED_EXAMP_0000020120": "Labor cost discount rate must be greater than or equal to 0 and less than or equal to 100",
        "P_YS_FED_FW_0001246843": "The following fields of detail <%=name%> are required",
        "P_YS_FED_FW_0001246844": "The following grandson tables of detail <%=name%> are required",
        "P_YS_FED_FW_0000022529": "Not exist. cBillType can only be",
        "P_YS_FED_EXAMP_0000020115": "Switch",
        "P_YS_FED_EXAMP_0000020114": "Failed to obtain the password verification parameter",
        "P_YS_FED_IMP_IOT0000008327": "Kaifeng",
        "P_YS_FED_IMP_IOT0000009658": "Xuhui District",
        "P_YS_FED_FW_0000022527": "No data found",
        "P_YS_FED_EXAMP_0000020117": "[Announcement] New store employee training",
        "P_YS_FED_IMP_IOT0000008324": "Wujiang District",
        "P_YS_FED_IMP_IOT0000009655": "Haicheng",
        "P_YS_FED_FW_0000022528": "You Retail",
        "P_YS_FED_IMP_IOT0000008325": "Linyou County",
        "P_YS_FED_EXAMP_0000020111": "All the product in the package not entered completely. Cannot save",
        "P_YS_PF_GZTSYS_0000015887": "Equipment",
        "P_YS_FED_EXAMP_0000020110": "Prepaid Card Top-up Function",
        "P_YS_FED_EXAMP_0000020113": "No product line to change retail price",
        "P_YS_FED_IMP_IOT0000009659": "Xunyang District",
        "P_YS_FED_EXAMP_0000020112": "No data",
        "P_YS_FED_IMP_IOT0000008329": "Kangle County",
        "P_YS_FED_FW_0000022521": "Name is required",
        "P_YS_FED_FW_0000022522": "Save up to 5 default values",
        "P_YS_FED_FW_0000022520": "Select level",
        "P_YS_FED_FW_0000022525": "[Interface]",
        "P_YS_FED_EXAMP_0000020119": "Online Retail Price",
        "P_YS_FED_IMP_IOT0000008322": "Jintai District",
        "P_YS_FED_IMP_IOT0000009653": "Taoshan District",
        "P_YS_FED_FW_0000022526": "Parameter:",
        "P_YS_FED_EXAMP_0000020118": "Customer",
        "P_YS_FED_FW_0000022523": "Error in opening file",
        "P_YS_FED_FW_0000022524": "billType not entered",
        "P_YS_FED_IMP_IOT0000009652": "Pizhou",
        "P_YS_FED_FW_0001220209": "Exception in the returned data of the parameter. The code is null",
        "P_YS_FED_EXAMP_0000020131": "Specification:",
        "P_YS_FED_EXAMP_0000020130": "Qty",
        "P_YS_PF_PRINT_0000056670": "Operator",
        "P_YS_FED_FW_0000021209": "Xuchang",
        "P_YS_FED_EXAMP_0000020126": "Cannot use shortcut settlement in the status",
        "P_YS_FED_IMP_IOT0000009646": "Fengcheng",
        "P_YS_SCM_SACT-FE_0001196577": "/premises-cdn/iprint/用友云打印助手.exe",
        "P_YS_FED_EXAMP_0000020125": ": refers to processed product that are processed and received in advance before they can be sold, such as bread, biscuits, etc.; these product are controlled by the business parameter \"Allow Negative Issue\".",
        "P_YS_FED_IMP_IOT0000008316": "Weixin County",
        "P_YS_FED_IMP_IOT0000009647": "Erdao District",
        "P_YS_HR_HRJXF_0000184400": "Cancel Association",
        "P_YS_PF_WORKBENCH-FE_0001242096": "Skip",
        "P_YS_FED_FW_0000021207": "Linxia Hui Autonomous Prefecture",
        "P_YS_FED_EXAMP_0000020128": "Failed to obtain billing settings:",
        "P_YS_FED_IMP_IOT0000008313": "Wu'an",
        "P_YS_FED_EXAMP_0000020127": "Upload failed",
        "P_YS_FED_FW_0000021208": "Non-booked",
        "P_YS_FED_IMP_IOT0000009645": "Yiyang County",
        "P_YS_FED_EXAMP_0000020122": "Change Line",
        "P_YS_PF_GZTSYS_0000013235": "Business File",
        "P_YS_FED_EXAMP_0000020121": "Product line exists. Cannot cancel order",
        "P_YS_FED_EXAMP_0000020124": "Current Adj Amt is required",
        "P_YS_FED_EXAMP_0000020123": "Confirm Settlement",
        "P_YS_FED_IMP_IOT0000008318": "Huantai County",
        "P_YS_FED_FW_0000021201": "Zhuzhou",
        "P_YS_FED_FW_0000021202": "The grouping scheme supports multiple graphs instead of single graph; error in upgrading configuration Info of the entire report. eChartConfig",
        "P_YS_FED_FW_0000021200": "Tai'an",
        "P_YS_FED_FW_0000021205": "Zhangjiakou",
        "P_YS_FED_IMP_IOT0000008311": "Pingyao County",
        "P_YS_FED_FW_0000021206": "Baoji",
        "P_YS_FED_EXAMP_0000020129": "Cannot execute promotion activity. Confirm to cancel",
        "P_YS_FED_IMP_IOT0000009643": "Diaobingshan",
        "P_YS_FED_FW_0000021203": "Qinzhou",
        "P_YS_FED_IMP_IOT0000009640": "Jin'an District",
        "P_YS_FED_FW_0000021204": "Column Chart Config. Info",
        "OA_web_ad_000000095": "Ungrouped",
        "P_YS_FED_EXAMP_0000020140": "Data Permission Settings",
        "P_YS_FED_FW_0001051041": "Failed to connect to server",
        "P_YS_FED_EXAMP_0000020142": "Sales Ranking",
        "P_YS_FED_FW_0001051042": "{value} Star",
        "P_YS_FED_EXAMP_0000020141": "Approval failed",
        "P_YS_FED_FW_0000022507": "Save as New Scheme",
        "P_YS_FED_EXAMP_0000020137": "chars",
        "P_YS_FED_IMP_IOT0000008304": "Lintao County",
        "P_YS_FED_IMP_IOT0000009635": "Kaiyuan",
        "P_YS_FED_FW_0000022508": "Save Scheme",
        "P_YS_FED_EXAMP_0000020136": "Auto picking failed",
        "P_YS_FED_IMP_IOT0000009636": "Gaoqing County",
        "P_YS_FED_FW_0000022505": "This Week",
        "P_YS_FED_EXAMP_0000020139": "The business type is not selling card and the billing line is not empty. Cannot sell cards",
        "P_YS_FED_FW_0000022506": "Next Week",
        "P_YS_FED_EXAMP_0000020138": "Cannot change replacement lines during original order return",
        "P_YS_FED_EXAMP_0000020133": "Nickname",
        "P_YS_FED_IMP_IOT0000008308": "Jia County",
        "P_YS_FED_IMP_IOT0000009639": "Liangqing District",
        "P_YS_FED_EXAMP_0000020132": "Return Reason is required",
        "P_YS_FED_IMP_IOT0000008309": "Kecheng District",
        "P_YS_FED_FW_0000022509": "Select date",
        "P_YS_FED_EXAMP_0000020135": "Please directly delete the lines added this time",
        "P_YS_FED_EXAMP_0000020134": "Cannot delete lines in the current Doc status",
        "P_YS_FED_FW_0000022500": "View Selected",
        "P_YS_FED_FW_0000022503": "Preset Scheme",
        "P_YS_FED_IMP_IOT0000008300": "Yangdong County",
        "P_YS_FED_FW_0000022504": "Hide All",
        "P_YS_FED_FW_0000022501": "Query item is required",
        "P_YS_FED_FW_0000022502": "Scheme operation succeeded",
        "P_YS_FED_EXAMP_0000020151": "Please select Doc first",
        "P_YS_FED_EXAMP_0000020150": "New Member",
        "P_YS_FED_EXAMP_0000020153": "Voucher [",
        "P_YS_FED_FW_1556970089191309315": "Edit Intra-Scheme Query",
        "P_YS_FED_EXAMP_0000020152": "Count last",
        "P_YS_FED_FW_1556970089191309318": "Within the editing scheme",
        "P_YS_FED_FW_0000022518": "Expand All",
        "P_YS_FED_EXAMP_0000020148": "Please enter the correct card/voucher No.",
        "P_YS_FED_FW_0000022519": "Bottom",
        "P_YS_FED_EXAMP_0000020147": "Last upload task not completed",
        "P_YS_FED_IMP_IOT0000009625": "Yimen County",
        "P_YS_FED_FW_0000022516": "Selected (",
        "P_YS_FED_FW_0000022517": "This Year",
        "P_YS_FED_EXAMP_0000020149": "Measured weight is greater than the standard weight. Please check if the products are stacked and re-arrange them",
        "P_YS_FED_IMP_IOT0000009623": "Yicheng District",
        "P_YS_FED_EXAMP_0000020144": "Please select mall order",
        "P_YS_FED_EXAMP_0000020143": "No barcode [",
        "P_YS_FED_IMP_IOT0000009629": "Loufan County",
        "P_YS_FED_FW_1556970089191309321": "User-defined filter criteria list new",
        "P_YS_FED_EXAMP_0000020146": "Confirm to call",
        "P_YS_FED_EXAMP_0000020145": "Failed to obtain tenant Info: [interface]",
        "P_YS_FED_FW_0000022510": "Restore Default",
        "P_YS_FED_FW_0000022511": "Remove",
        "P_YS_FED_FW_0000022514": "Advanced",
        "P_YS_FED_FW_0000022515": "Position changed",
        "P_YS_FED_FW_0000022512": "No search result",
        "P_YS_FED_FW_0000022513": "Top",
        "P_YS_FED_FW_0000021241": "Board Config. Info - Desktop - Row/Column Layout",
        "P_YS_FED_FW_0000021242": "Error Info returned from report/getGroupSetting(the detailed settings of report group scheme needs to obtained to display)",
        "P_YS_FED_FW_0000021240": "Chifeng",
        "P_YS_FED_FW_0001289933": "Missing scanQRCode method",
        "P_YS_PF_GZTTMP_0000073505": "Ex. Status",
        "P_YS_FED_IMP_IOT0000009611": "Mianning County",
        "P_YS_FED_IMP_IOT0000009612": "Silver District",
        "P_YS_FED_FW_1593218496493781002": "單據聯查結果顯示",
        "P_YS_FED_IMP_IOT0000009618": "Uptown",
        "P_YS_FED_IMP_IOT0000009615": "Qu County",
        "P_YS_FED_FW_1556970089191309312": "LineTab Switch to",
        "P_YS_FED_FW_1593218496493781005": "Les résultats de la recherche conjointe de documents montrent",
        "P_YS_FED_FW_0000021234": "Sansha",
        "P_YS_FED_FW_0000021235": "Tonghua",
        "P_YS_FED_FW_0000021232": "Binzhou",
        "P_YS_FED_FW_0000021233": "Huanggang",
        "P_YS_FED_FW_0000021238": "Fushun",
        "P_YS_FED_FW_0000021239": "Start Date",
        "P_YS_FED_IMP_IOT0000009610": "Fenghuang County",
        "P_YS_FED_FW_0000021236": "No specific Info",
        "P_YS_FED_FW_0000021237": "Hami Prefecture",
        "P_YS_HR_HRJXF_0000184457": "Confirm to delete?",
        "P_YS_FED_FW_0000021252": "Nanning",
        "P_YS_FED_FW_0000021253": "Column/Line Chart Config. Info",
        "P_YS_FED_FW_0000021250": "Taiwan",
        "P_YS_FED_FW_0000021251": "Required items exist in the detail. Please enter them completely and try to save again",
        "P_YS_FED_IMP_IOT0000009609": "Yitong Manchu Autonomous County",
        "P_YS_FED_IMP_IOT0000009600": "Guidong County",
        "P_YS_FED_FW_0000021245": "Honghe Hani and Yi Autonomous Prefecture",
        "P_YS_FED_FW_0000021246": "Pingxiang",
        "P_YS_FED_FW_0000021243": "Taizhou",
        "P_YS_FED_FW_0000021244": "Changzhou",
        "P_YS_FED_FW_0000021249": "Baoshan",
        "P_YS_FED_FW_0000021247": "Subtotal",
        "P_YS_FED_FW_0000021248": "Foshan",
        "P_YS_FED_FW_0000021220": "Chongzuo",
        "P_YS_FED_FW_1596335448733515784": "(最多选择5项)",
        "P_YS_FED_FW_1596335448733515781": "最多选择5个分组项。",
        "P_YS_FED_FW_1596335448733515787": "分组项",
        "P_YS_FED_FW_0000021218": "Heze",
        "P_YS_FED_FW_0000021219": "Da Hinggan Ling Prefecture",
        "P_YS_FED_FW_0000021212": "Shanwei",
        "P_YS_FED_FW_0000021213": "Error in preset cStyle",
        "P_YS_FED_FW_0000021210": "Jinchang",
        "P_YS_FED_FW_0000021211": "Tianjin",
        "P_YS_FED_FW_0000021216": "Lvliang",
        "P_YS_FED_FW_0000021217": "Shangluo",
        "P_YS_FED_FW_0000021214": "Zhangye",
        "P_YS_FED_FW_0000021215": "Ili Kazakh Autonomous Prefecture",
        "P_YS_FED_FW_0000021230": "Deyang",
        "P_YS_SD_URETAIL_0001049003": "Internal error:",
        "P_YS_FED_FW_0001322153": "No chart card",
        "P_YS_FED_FW_0000021231": "Anhui",
        "P_YS_PF_METADATA_0001040101": "Template No.",
        "P_YS_FED_FW_1596335448733515790": "分组项设置",
        "P_YS_PF_PRINT_0000056691": "Sales Type",
        "P_YS_FED_FW_1596335448733515793": "(最多选择15项)",
        "P_YS_FED_EXAMP_0000020104": "A/R Amt is negative for non-original order return. Cannot pay via member wallet",
        "P_YS_FED_EXAMP_0000020103": "All the product in the package not entered completely. Cannot settle",
        "P_YS_FED_FW_0000021229": "29",
        "P_YS_FED_EXAMP_0000020106": "Use Reward Points",
        "P_YS_FED_EXAMP_0000020105": "Returned Qty cannot be greater than the un-returned Qty in the original Doc",
        "P_YS_FED_FW_1596335448733515796": "汇总项设置",
        "P_YS_FED_EXAMP_0000020100": "A/R Amt is not equal to actual received Amt. Cannot settle",
        "P_YS_FED_EXAMP_0000020102": "User-defined type. Cannot add product lines",
        "P_YS_FED_EXAMP_0000020101": "All the product of the package should be selected",
        "P_YS_FED_FW_0000021223": "Tieling",
        "P_YS_FED_FW_0000021224": "The name that needs to be displayed as XY axis is too long and needs to be truncated. Before truncation:",
        "P_YS_FED_FW_0000021221": "Points of Current Doc",
        "P_YS_FED_FW_0000021222": "Hefei",
        "P_YS_FED_FW_0000021227": "Benxi",
        "P_YS_FED_EXAMP_0000020108": "Cannot execute promotion activities during adjustment",
        "P_YS_FED_FW_0000021228": "Mobile Report  MobileReportSum firstQueryDone params =",
        "P_YS_FED_EXAMP_0000020107": "Cannot execute the operation when selling cards. Please bill again",
        "P_YS_FED_FW_0000021225": "Tongliao",
        "P_YS_FED_FW_0000021226": "All data in the table succeeded",
        "P_YS_FED_EXAMP_0000020109": "Failed to obtain payment method",
        "P_YS_SD_UDHWN_0000050426": "Wanning",
        "P_YS_SCM_USTOCK_0000064406": "Not changed",
        "P_YS_FED_EXAMP_0000020511": "Confirm the POS terminal is free?",
        "P_YS_FED_EXAMP_0000020510": "Network is unavailable now and the current operator doesn't have the permission to delete lines. Cannot use this function",
        "P_YS_FED_EXAMP_0000020513": "Please select store",
        "P_YS_FED_EXAMP_0000020512": "No product line selected. Cannot specify in batch. Please check",
        "P_YS_FED_EXAMP_0000020519": "Product line exists. Cannot deliver",
        "P_YS_FED_EXAMP_0000020518": "Hold Doc and Print",
        "P_YS_FED_EXAMP_0000020515": "Error in the submitted method parameter when sending data to the main UI",
        "P_YS_FED_EXAMP_0000020514": "Collected:",
        "P_YS_FED_EXAMP_0000020517": "No such member Info",
        "P_YS_FED_EXAMP_0000020516": "Last 7 Days",
        "P_YS_FED_EXAMP_0000020522": "Sanlitun Store",
        "P_YS_FED_EXAMP_0000020521": "Metadata failed:",
        "P_YS_FED_EXAMP_0000020524": "A product line with the same SKU already exists",
        "P_YS_FED_EXAMP_0000020523": "The current product will not participate in deduction",
        "P_YS_FED_EXAMP_0000020520": "Password modified successfully",
        "P_YS_FED_EXAMP_0000020529": "Pull up to load more...",
        "P_YS_FED_EXAMP_0000020526": "All the product in the package not entered completely. Cannot execute on-site discount",
        "P_YS_FED_EXAMP_0000020525": "Cash Voucher",
        "P_YS_FED_EXAMP_0000020528": "Undelivered retail Doc exists in the current room. Please process it before ushering",
        "P_YS_SD_SDMBF_0000141962": "Error in input",
        "P_YS_FED_EXAMP_0000020527": "Product line exists. Cannot change",
        "P_YS_FED_FW_0001265743": "Please check whether BUSINESS_LOG_SERVER is configured correctly",
        "P_YS_FED_FW_1430606138330578944": "The divisor cannot be 0",
        "P_YS_FED_EXAMP_0000020533": "Failed to obtain top-up print template",
        "P_YS_FED_IMP_IOT0000011802": "Hengdong County",
        "P_YS_FED_FW_0001253754": "缺少changeScreenOrientation方法",
        "P_YS_FED_EXAMP_0000020532": "Cannot hold Doc/cancel Doc holding during online retailer order return",
        "P_YS_FED_FW_0001253753": "Please enter",
        "P_YS_FED_EXAMP_0000020535": "There's duplicate SN [",
        "P_YS_FED_FW_0001253756": "{\"（\":\"(\",\"）\":\")\",\"！\":\"!\",\"，\":\",\",\"。\":\".\",\"：\":\":\",\"；\":\";\",\"、\":\" \"}",
        "P_YS_FED_EXAMP_0000020534": "Purchase price:",
        "P_YS_FED_FW_0001253755": "确定取消操作嘛?",
        "P_YS_FED_FW_0001253750": "711连锁便利店",
        "P_YS_FED_EXAMP_0000020531": "Failed to obtain mac address. Please exit the program and log in again",
        "P_YS_FED_FW_0001253752": "共&nbsp;",
        "P_YS_FED_EXAMP_0000020530": "] is in on-hand status. Please check",
        "P_YS_FED_FW_0001253751": "zjj普通",
        "P_YS_FED_IMP_IOT0000011809": "Rucheng County",
        "P_YS_FED_EXAMP_0000020537": "SKU Code",
        "P_YS_FED_IMP_IOT0000011806": "New Barhu Right Banner",
        "P_YS_FED_FW_1471272821425963008": "All loads complete.",
        "P_YS_FED_EXAMP_0000020536": "The network is currently unavailable. Cannot sell product under batch management",
        "P_YS_FED_FW_0001253757": "缺少restoreScreenOrientation方法",
        "P_YS_FED_EXAMP_0000020539": "Failed to obtain the default warehouse of store",
        "P_YS_OA_XTLCZX_0000030825": "Uploading",
        "P_YS_FED_EXAMP_0000020538": "OK",
        "P_YS_FED_EXAMP_0000020544": "The current operator does not have the card/voucher permission",
        "P_YS_FED_EXAMP_0000020543": "Salesperson in the detail line is required",
        "P_YS_FED_IMP_IOT0000011812": "Qilihe District",
        "P_YS_FED_EXAMP_0000020546": "Return Qty is required",
        "P_YS_FED_EXAMP_0000020545": "Invalid wallet account No.",
        "P_YS_FED_IMP_IOT0000011814": "Shangdu County",
        "P_YS_FED_EXAMP_0000020540": "Exit the billing UI?",
        "P_YS_FED_FW_1439654302997020672": "No progress component type specified",
        "P_YS_FED_EXAMP_0000020542": "Your software is the latest revision",
        "P_YS_FED_IMP_IOT0000011811": "Changfeng County",
        "P_YS_FED_EXAMP_0000020541": "Invalid weight",
        "P_YS_FED_EXAMP_0000020548": "No product recognized",
        "P_YS_FED_IMP_IOT0000011817": "Zhao'an County",
        "P_YS_FED_EXAMP_0000020547": "Please enter user name",
        "P_YS_FED_IMP_IOT0000011816": "Wugong County",
        "P_YS_FED_FW_1575980902936215553": "｜",
        "P_YS_FED_EXAMP_0000020549": "Card/Voucher - Non-Orig. Order Return Function",
        "P_YS_FED_IMP_IOT0000011818": "Xiangcheng District",
        "P_YS_FED_FW_1529421301390245894": "Please click the alternative conditions in the sidebar to add",
        "P_YS_FED_IMP_IOT0000011824": "Laobian District",
        "P_YS_FED_IMP_IOT0000011823": "Yongcheng",
        "P_YS_FED_IMP_IOT0000011826": "Jiaxiang County",
        "P_YS_PF_METADATA_0000083588": "File Size",
        "P_YS_FED_IMP_IOT0000011822": "Shishou",
        "P_YS_FED_IMP_IOT0000011827": "Xiangshan County",
        "P_YS_FED_IMP_IOT0000011829": "Qinghe County",
        "P_YS_FI_FINBD-UI_0000161964": "Table Ref",
        "P_YS_FED_FW_0000021407": "Luohe",
        "P_YS_FED_IMP_IOT0000010503": "Panzhihua",
        "P_YS_FED_FW_0000021408": "Guangyuan",
        "P_YS_FED_FW_0000021405": "Jiamusi",
        "P_YS_FED_IMP_IOT0000011837": "Guandu District",
        "P_YS_FED_FW_0001253745": "Please enter the required field, ",
        "P_YS_FED_FW_0000021406": "Ranking List Config. Info - yySetting",
        "P_YS_FED_IMP_IOT0000010506": "Chongzhou",
        "P_YS_FED_IMP_IOT0000011836": "Xintian County",
        "P_YS_ZNBZ_BZBX-FE_0001141300": "Guarantee Contract",
        "P_YS_FED_FW_0000021409": "Changdu Prefecture",
        "P_YS_ZNBZ_BZBX-FE_0001141303": "Loan",
        "P_YS_FED_IMP_IOT0000010502": "Zhuhui District",
        "P_YS_PF_GZTTMP_0000074571": "Touch Screen",
        "P_YS_FED_FW_0001023490": "cStyle configuration exception",
        "P_YS_ZNBZ_BZBX-FE_0001141305": "Collateral/Pledge Contract Tracking",
        "P_YS_FED_FW_0000021400": "Board Config. Info - Module Config. - Announcement",
        "P_YS_ZNBZ_BZBX-FE_0001141304": "Joint Guarantee Contract",
        "P_YS_HR_HRYGF_0001153277": "Prompt:",
        "P_YS_FED_FW_0000021403": "Get graphical report data  Query parameter =",
        "P_YS_FED_FW_0001253747": "连续扫码",
        "P_YS_FED_IMP_IOT0000011838": "Xuyi County",
        "P_YS_FED_FW_0001253746": "Required Field in Data Area",
        "P_YS_FED_FW_0000021401": "Haixi Mongolian and Tibetan Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000010509": "Chiping County",
        "P_YS_FED_FW_0001253749": "cell的宽度超过表格的宽度，无法渲染；节点信息：",
        "P_YS_FED_FW_0000021402": "Board Config. Info - Mobile - Row/Column Layout",
        "P_YS_FED_FW_0001253748": "连扫",
        "P_YS_FED_FW_0001238122": "Failed",
        "P_YS_FED_IMP_IOT0000011840": "Tongjiang",
        "P_YS_FED_FW_0001035432": "<p>No prompt</p>",
        "P_YS_FED_FW_0001576776": "&region=全国&output=json&ak=",
        "P_YS_FED_FW_0001035433": "You initiated <%=busName%> at <%=tmpTime%> ",
        "P_YS_FED_IMP_IOT0000011845": "Bole City",
        "P_YS_FED_IMP_IOT0000005995": "Xinzhou District",
        "P_YS_FED_IMP_IOT_0000115234": ", the min value is",
        "P_YS_FED_IMP_IOT0000005994": "Taigu County",
        "P_YS_FED_IMP_IOT0000010510": "Longhua County",
        "P_YS_PF_SOCD_0000089208": "Sweden",
        "P_YS_FED_IMP_IOT0000005999": "Dongyang",
        "P_YS_FED_IMP_IOT0000010512": "Chengwu County",
        "P_YS_FED_IMP_IOT_0000115238": "Please select...",
        "P_YS_PF_SOCD_0000089209": "Morocco",
        "P_YS_FED_IMP_IOT0000011843": "Ningyuan County",
        "P_YS_PF_SOCD_0000089206": "The Netherlands",
        "P_YS_PF_SOCD_0000089207": "Slovenia",
        "P_YS_PF_SOCD_0000089204": "Russia",
        "P_YS_PF_SOCD_0000089205": "Sri Lanka",
        "P_YS_PF_SOCD_0000089203": "France",
        "P_YS_FED_IMP_IOT0000011849": "Jiayu County",
        "P_YS_FED_IMP_IOT0000005991": "Wufeng Tujia Autonomous County",
        "P_YS_PF_SOCD_0000089201": "Poland",
        "P_YS_FED_IMP_IOT0000005990": "Jiangcheng District",
        "P_YS_FED_IMP_IOT0000005989": "Hepu County",
        "P_YS_FED_IMP_IOT0000011850": "Pingchuan District",
        "P_YS_PF_PRINT_0000062612": "Sub-table",
        "P_YS_FED_EXAMP_0000020500": "To Receive",
        "P_YS_FED_IMP_IOT0000011857": "Xiangcheng County",
        "P_YS_OA_XTXIANGMU_0000063884": "Remaining",
        "P_YS_FED_IMP_IOT0000005981": "Dalat Banner",
        "P_YS_FED_EXAMP_0000020502": "Failed to obtain system parameter: [interface]",
        "P_YS_FED_IMP_IOT0000010527": "Wuzhi County",
        "P_YS_FED_EXAMP_0000020501": "Cannot cancel holding during adjustment",
        "P_YS_FED_IMP_IOT0000011858": "Pengze County",
        "P_YS_FED_IMP_IOT0000010521": "Licheng District",
        "P_YS_FED_IMP_IOT_0000115225": "Enter a value. The max value is ",
        "P_YS_FED_IMP_IOT0000005985": "Mengyin County",
        "P_YS_FED_IMP_IOT0000010523": "Guangshui",
        "P_YS_FED_IMP_IOT0000011855": "Qinshui County",
        "P_YS_FED_IMP_IOT0000010524": "Chaotian District",
        "P_YS_FED_EXAMP_0000020508": "Tel",
        "P_YS_FED_EXAMP_0000020507": "Monthly",
        "P_YS_FED_EXAMP_0000020509": "On-shelf Qty in Mall",
        "P_YS_FED_EXAMP_0000020504": "Return/Top-up",
        "P_YS_FED_EXAMP_0000020503": "Unhold",
        "P_YS_FED_EXAMP_0000020506": "Current discount Amt for gold price (per gram) is (",
        "P_YS_FED_IMP_IOT0000005980": "Changjiang District",
        "P_YS_FED_EXAMP_0000020505": "Product line exists. Wallet top-up is not allowed",
        "P_YS_PF_SOCD_0000089220": "South Africa",
        "P_YS_PF_SOCD_0000089221": "Sao Tome and Principe",
        "P_YS_FED_FW_1551561479829848067": "To operate by order",
        "P_YS_HR_HRJQ_0000055421": "Type",
        "P_YS_OA_XTRIZHI_0000036814": "Continue editing",
        "P_YS_FED_IMP_IOT0000005979": "Long'an District",
        "P_YS_FED_IMP_IOT0000005978": "Yudu County",
        "P_YS_FED_IMP_IOT0000010531": "Baofeng County",
        "P_YS_FI_CM_0000029055": "August",
        "P_YS_FED_IMP_IOT0000010536": "Tongxu County",
        "P_YS_FED_IMP_IOT0000005970": "Wuqiang County",
        "P_YS_FED_IMP_IOT0000010538": "Jingdezhen",
        "P_YS_FED_FW_0001661900": "Exceeds the max length limit\\t\\n",
        "P_YS_FED_IMP_IOT0000005972": "Genhe",
        "P_YS_FED_IMP_IOT0000010539": "Kedong County",
        "P_YS_FED_IMP_IOT0000010532": "Xingbin District",
        "P_YS_FED_IMP_IOT0000005974": "Anning District",
        "P_YS_FED_IMP_IOT0000010533": "Shenqiu County",
        "P_YS_FED_IMP_IOT0000005977": "Pingqiao District",
        "P_YS_FED_IMP_IOT0000010534": "Ximen Wa Autonomous County",
        "P_YS_FED_IMP_IOT0000005976": "Zoucheng",
        "P_YS_PF_SOCD_0000089228": "Togo",
        "P_YS_PF_SOCD_0000089226": "Zimbabwe",
        "P_YS_PF_SOCD_0000089227": "Bangladesh",
        "P_YS_PF_SOCD_0000089225": "Portugal",
        "P_YS_PF_SOCD_0000089222": "Bahamas",
        "P_YS_PF_SOCD_0000089223": "Mali",
        "P_YS_SD_SDMAUF_0000152388": "Cancel All",
        "P_YS_FI_CM_0000030058": "Doc No.",
        "P_YS_HR_HRJQ_0000055417": "Dept",
        "P_YS_FED_IMP_IOT0000005967": "Lantian County",
        "P_YS_FED_IMP_IOT0000010540": "Duyun",
        "P_YS_FED_IMP_IOT0000010541": "Wanghua District",
        "P_YS_FED_IMP_IOT0000010542": "Chenghai District",
        "P_YS_FED_IMP_IOT0000010547": "Cixi City",
        "P_YS_OA_XTWENKU_0000035690": "Please select date",
        "P_YS_FED_IMP_IOT0000005962": "Wutongqiao District",
        "P_YS_FED_IMP_IOT0000005961": "Dengfeng",
        "P_YS_FED_FW_0001253700": "没有一维表模型",
        "P_DIWORK_YC_ORDER_0000061342": "-",
        "P_YS_PF_SOCD_0000089219": "Belize",
        "P_YS_FED_IMP_IOT0000005966": "Liancheng County",
        "P_YS_FED_IMP_IOT0000005965": "Hexi District",
        "P_YS_PF_SOCD_0000089217": "Malawi",
        "P_YS_PF_SOCD_0000089218": "Papua New Guinea",
        "P_YS_PF_SOCD_0000089215": "Chad",
        "P_YS_PF_SOCD_0000089216": "Tunisia",
        "P_YS_PF_SOCD_0000089213": "Iceland",
        "P_YS_PF_SOCD_0000089214": "Chile",
        "P_YS_FED_FW_0001073796": "Yongzhou City",
        "P_YS_PF_SOCD_0000089243": "Kenya",
        "P_YS_FED_FW_0001073795": "Daxian City",
        "P_YS_PF_SOCD_0000089240": "Lesotho",
        "P_YS_FED_FW_0001073794": "Xiangcheng City",
        "P_YS_FI_CM_0000029074": "June",
        "P_YS_FED_FW_0001380706": "Please upload the attachment first",
        "P_YS_PF_SOCD_0000089241": "USA",
        "P_YS_FED_FW_0001073793": "Zhuzhou City",
        "P_YS_FED_FW_0001073792": "Xilinhot",
        "P_YS_FED_IMP_IOT0000005957": "Fumin County",
        "P_YS_FED_IMP_IOT0000010552": "Ji'an",
        "P_YS_FED_IMP_IOT0000010553": "Haishu District",
        "P_YS_FED_FW_0001073799": "Lishi City",
        "P_YS_FED_FW_0001073798": "Shigatse",
        "P_YS_FED_FW_0001073797": "Jiexi City",
        "P_YS_FED_IMP_IOT0000010559": "Jiaxian",
        "P_YS_FED_IMP_IOT0000010554": "Gushi County",
        "P_YS_FED_IMP_IOT0000010555": "Jimsar County",
        "P_YS_SD_SDMA_0000038452": "Operator",
        "P_YS_FED_IMP_IOT0000005954": "Yilong County",
        "P_YS_ZNBZ_BZBX-FE_0001135440": "ⓧ",
        "P_YS_PF_SOCD_0000089247": "Panama",
        "P_YS_PF_SOCD_0000089245": "Nicaragua",
        "P_YS_FI_CM_0000029087": "Confirm to delete?",
        "P_YS_PF_SOCD_0000089231": "Zambia",
        "P_YS_PF_SOCD_0000089232": "Brunei",
        "P_YS_FI_CM_0000029084": "This Moment",
        "P_YS_FED_IMP_IOT0000010561": "Ganxian",
        "P_YS_FED_IMP_IOT0000005945": "Shimen County",
        "P_YS_FED_IMP_IOT0000005948": "Suining County",
        "P_YS_FED_IMP_IOT0000010563": "Pulan County",
        "P_YS_FED_IMP_IOT0000010569": "Liangdang County",
        "P_YS_FED_IMP_IOT0000005940": "Taikang County",
        "P_YS_FED_FW_1602981773186695169": "领域扩展的上下文中没获取到key为",
        "P_YS_FED_IMP_IOT0000005942": "Luanchuan County",
        "P_YS_FED_IMP_IOT0000010565": "Menglian Dai Lahu and Wa Autonomous County",
        "P_YS_FED_IMP_IOT0000010566": "Menghai County",
        "P_YS_FED_IMP_IOT0000005944": "Hancheng",
        "P_YS_PF_SOCD_0000089239": "Iraq",
        "P_YS_OA_XTWENKU_0000035676": "Created At",
        "P_YS_PF_SOCD_0000089237": "Paraguay",
        "P_YS_PF_SOCD_0000089235": "North Korea",
        "P_YS_PF_SOCD_0000089236": "Mozambique",
        "P_YS_PF_SOCD_0000089234": "Nigeria",
        "P_YS_PF_SOCD_0000089265": "Sudan",
        "P_YS_PF_SOCD_0000089262": "Nauru",
        "P_YS_SCM_PU_0000027628": "Finished",
        "P_YS_PF_SOCD_0000089263": "Belarus",
        "P_YS_PF_SOCD_0000089261": "Iran",
        "P_YS_FED_IMP_IOT0000005935": "Hanyin County",
        "P_YS_FED_IMP_IOT0000005934": "Muding County",
        "P_YS_FI_CM_0000030006": "Switch to Tile",
        "P_YS_FI_CM_0000029016": "≥",
        "P_YS_FED_IMP_IOT0000010575": "Jianchuan County",
        "P_YS_FI_CM_0000030008": "Restore",
        "P_YS_FED_IMP_IOT0000005939": "Langzhong",
        "P_YS_FED_IMP_IOT0000005938": "Xixia District",
        "P_YS_FED_IMP_IOT0000005931": "Fuqing",
        "P_YS_FED_IMP_IOT0000005930": "Tangling District",
        "P_YS_FED_IMP_IOT0000005933": "Nehe City",
        "P_YS_FED_FW_0001384244": "The size of each picture cannot exceed ",
        "P_YS_PF_SOCD_0000089268": "Yemen",
        "P_YS_PF_SOCD_0000089269": "Niger",
        "P_YS_PF_SOCD_0000089266": "Algeria",
        "P_YS_PF_SOCD_0000089267": "Slovakia",
        "P_YS_PF_SOCD_0000089253": "Ethiopia",
        "P_YS_FI_CM_0000029021": "Go to ",
        "P_YS_PF_SOCD_0000089251": "Laos",
        "P_YS_PF_SOCD_0000089252": "Monaco",
        "P_YS_FED_IMP_IOT0000010583": "Baojing County",
        "P_YS_FED_IMP_IOT0000005926": "Rong'an County",
        "P_YS_FED_IMP_IOT0000005925": "Yishui County",
        "P_YS_FED_IMP_IOT0000010586": "Fengzhen",
        "P_YS_FED_IMP_IOT0000010580": "Zhanqian District",
        "P_YS_FED_IMP_IOT0000010581": "Lechang",
        "P_YS_FED_IMP_IOT0000010582": "Sanmenxia",
        "P_YS_FED_IMP_IOT0000005920": "Yongnian County",
        "P_YS_FED_IMP_IOT0000010589": "Yunyang County",
        "P_YS_FED_IMP_IOT0000008197": "Port area",
        "P_YS_FED_FW_0001029632": "Quotation Mgmt",
        "P_YS_PF_SOCD_0000089259": "Antigua and Barbuda",
        "P_YS_FED_IMP_IOT0000008195": "Liquan County",
        "P_YS_FED_IMP_IOT0000008196": "Tongling County",
        "P_YS_PF_SOCD_0000089257": "Seychelles",
        "P_YS_PF_SOCD_0000089255": "India",
        "P_YS_FED_IMP_IOT0000008199": "Queshan County",
        "P_YS_PF_SOCD_0000089256": "Saint Lucia",
        "P_YS_PF_SOCD_0000089287": "Burkina Faso",
        "P_YS_PF_SOCD_0000089285": "Honduras",
        "P_YS_PF_SOCD_0000089282": "Liechtenstein",
        "P_YS_PF_SOCD_0000089283": "Puerto Rico",
        "P_YS_FED_IMP_IOT0000008192": "Enshi",
        "P_YS_FED_IMP_IOT0000005912": "Yuelu District",
        "P_YS_FED_IMP_IOT0000005915": "Fengmanqu",
        "P_YS_FED_IMP_IOT0000010596": "Changyi",
        "P_YS_FED_IMP_IOT0000010597": "Litong District",
        "P_YS_FED_IMP_IOT0000010591": "Dongxing",
        "P_YS_FED_IMP_IOT0000005919": "Xichuan County",
        "P_YS_FED_IMP_IOT0000005918": "Xincheng County",
        "P_YS_FED_IMP_IOT0000010599": "Ci County",
        "P_YS_FED_IMP_IOT0000005911": "Yushan District",
        "P_YS_FED_FW_1474274290590810117": "getConnectedDevice missing, method missing",
        "P_YS_FED_IMP_IOT0000005910": "Yufeng District",
        "P_YS_FED_IMP_IOT0000008186": "s",
        "P_YS_FED_IMP_IOT0000008187": "Hekou Yao Autonomous County",
        "P_YS_FED_IMP_IOT0000008184": "Jingyuan County",
        "P_YS_PF_SOCD_0000089289": "Saudi Arabia",
        "P_YS_PF_SOCD_0000089275": "Turkmenistan",
        "P_YS_PF_SOCD_0000089276": "Guam",
        "P_YS_FED_IMP_IOT0000005909": "Zhouning County",
        "P_YS_PF_SOCD_0000089274": "Georgia",
        "P_YS_PF_SOCD_0000089271": "Latvia",
        "P_YS_SD_UDHWN_0000122691": "Shipping Doc No.:",
        "P_YS_PF_SOCD_0000089272": "Cameroon",
        "P_YS_FED_UIMG_0001071360": "Fields created by calculation cannot be set as Required",
        "P_YS_PF_SOCD_0000089270": "Grenada",
        "P_YS_FED_IMP_IOT0000005902": "Jiangchuan County",
        "P_YS_FED_IMP_IOT0000005901": "Wangcheng County",
        "P_YS_FED_FW_0001120581": "Cannot cancel the default status of the public default scheme",
        "P_YS_FED_IMP_IOT0000005904": "Dongfeng County",
        "P_YS_FED_IMP_IOT0000005903": "Malipo County",
        "P_YS_FED_FW_0001204759": "】，请您参阅查看。",
        "P_YS_FED_FW_1474274290590810123": "getConnectedDevice success execute, but failed to obtain the connected device",
        "P_YS_FED_FW_0001204758": "导出已完成，文件名为【",
        "P_YS_FED_IMP_IOT0000005908": "Quannan County",
        "P_YS_FED_FW_1474274290590810120": "The current platform is not supported, and the necessary methods are missing",
        "P_YS_SD_SDOC_0000163474": "People's Republic of China",
        "P_YS_PF_SOCD_0000089279": "Denmark",
        "P_YS_PF_SOCD_0000089277": "Tanzania",
        "P_YS_PF_SOCD_0000089278": "Mauritius",
        "P_YS_FED_FW_1514390015376883745": "a --- enter data directly",
        "P_YS_FED_FW_1514390015376883748": "&gt;=a --- greater than or equal to a",
        "P_YS_FED_IMP_IOT0000008292": "Xinhua County",
        "P_YS_FED_IMP_IOT0000008290": "Lingbao",
        "P_YS_FED_IMP_IOT0000008291": "Huinong District",
        "P_YS_FED_IMP_IOT0000010495": "Changzhi County",
        "P_YS_FED_FW_1616973608405958661": "的数据无操作权限",
        "P_YS_FED_IMP_IOT0000010496": "Jiutai",
        "P_YS_PF_GZTSYS_0000013194": "Workbench",
        "P_YS_FED_FW_1514390015376883742": "[a,b] ---greater than or equal to a and less than or equal to b",
        "P_YS_FED_IMP_IOT0000010492": "Jianshan District",
        "P_YS_FED_IMP_IOT0000010494": "Jinxian County",
        "P_YS_OA_XTSPZX_0000034652": "Sort",
        "P_YS_FED_FW_0000021399": "Deduct Points",
        "P_YS_FED_IMP_IOT0000008286": "Sanshui District",
        "P_YS_FED_FW_0000021397": "Ganzhou",
        "P_YS_FED_IMP_IOT0000008283": "Zha Nang County",
        "P_YS_FED_FW_0000021398": "eChartDisplay Scatter chart/map Info is correct return",
        "P_YS_FED_IMP_IOT0000008284": "Huangzhong County",
        "P_YS_OA_XTWENKU_0000035721": "Project Name",
        "P_YS_FED_IMP_IOT0000008288": "Suiyang County",
        "P_YS_PF_SOCD_0000089297": "San Marino",
        "P_YS_SD_URETAIL-UI_0001036607": "Continue to Add",
        "P_YS_FED_FW_1514390015376883757": "(a,b] --- greater than a and less than or equal to b",
        "P_YS_PF_SOCD_0000089298": "Botswana",
        "P_YS_PF_SOCD_0000089295": "Cyprus",
        "P_YS_FED_IMP_IOT0000008282": "Xingyi",
        "P_YS_PF_SOCD_0000089291": "Ecuador",
        "P_YS_PF_SOCD_0000089292": "Bolivia",
        "P_YS_FED_IMP_IOT0000008280": "Shigu District",
        "P_YS_PF_SOCD_0000089290": "Peru",
        "P_YS_FED_FW_1514390015376883751": "Example: if greater than 2.5 and less than or equal to 8.7, then input (2.5,8.7]",
        "P_YS_FED_FW_1514390015376883754": "Range Value Error. Please enter in correct format",
        "P_YS_FI_RA_0000071687": "Confirmed",
        "P_YS_FED_UCFBASEDOC_0000024997": "Return Reason",
        "P_YS_SD_URETAILF_0001154205": "Please select at least one Doc",
        "P_YS_FED_IMP_IOT0000008279": "Shayback District",
        "P_YS_FED_UCFBASEDOC_0000024992": "Error Info",
        "P_YS_FED_IMP_IOT0000008277": "Xiangcheng",
        "P_YS_FED_FW_0000021380": "Fuzhou",
        "P_YS_FED_UCFBASEDOC_0000024990": "Password",
        "P_YS_FED_FW_0000021381": "Enshi Tujia and Miao Autonomous Prefecture",
        "P_YS_HR_HRJQF_0000054647": "Placeholder",
        "P_YS_FED_FW_0000021384": "Liuzhou",
        "P_YS_FED_FW_0000021385": "eChartCommon UnionDimensionName Error. Err =",
        "P_YS_FED_FW_0000021382": "Chuxiong Yi Autonomous Prefecture",
        "P_YS_FED_FW_0000021383": "Product Qty to Inspect",
        "P_YS_FED_UCFBASEDOC_0000024989": "Read/Write",
        "P_YS_FED_FW_0000021377": "Pie Chart Example",
        "P_YS_FED_IMP_IOT0000008263": "Yanting County",
        "P_YS_FED_IMP_IOT0000009594": "Xinchang County",
        "P_YS_FED_FW_0000021378": "Chaozhou",
        "P_YS_FED_IMP_IOT0000008264": "Weiyuan County",
        "P_YS_FED_FW_0000021375": "Lishui",
        "P_YS_FED_IMP_IOT0000009592": "Anxian",
        "P_YS_FED_FW_0000021376": "China",
        "P_YS_FED_UCFBASEDOC_0000024986": "Import",
        "P_YS_FED_IMP_IOT0000008267": "Jimo City",
        "P_YS_FED_IMP_IOT0000009598": "Aksu",
        "P_YS_FED_UCFBASEDOC_0000024984": "Submit",
        "P_YS_FED_IMP_IOT0000008268": "Pingle County",
        "P_YS_FED_FW_0000021379": "Beijing",
        "P_YS_FED_IMP_IOT0000008265": "Sucheng District",
        "P_YS_FED_UCFBASEDOC_0000024982": "Discard",
        "P_YS_HR_HRJQF_0000054641": "Applicant",
        "P_YS_FED_IMP_IOT0000008266": "Gangu County",
        "P_YS_FED_IMP_IOT0000009597": "Hannan District",
        "P_YS_FED_FW_0000021391": "Sales Net Amt",
        "P_YS_FED_FW_0000021392": "pieces of data",
        "P_YS_FED_FW_0000021390": "Nanyang",
        "P_YS_FED_FW_0000021395": "Harbin",
        "P_YS_FED_FW_0000021396": "Ordos",
        "P_YS_FED_IMP_IOT0000008260": "Jinghu District",
        "P_YS_FED_FW_0000021393": "Taizhou",
        "P_YS_FED_FW_0000021394": "Chengde",
        "P_YS_FED_IMP_IOT0000009589": "Zhenkang County",
        "P_YS_FED_FW_0000021388": "Shijiazhuang",
        "P_YS_FED_IMP_IOT0000008252": "Gucheng County",
        "P_YS_FED_FW_0000021389": "Zhuhai",
        "P_YS_FED_IMP_IOT0000009584": "Binyang County",
        "P_YS_FED_FW_0000021386": "Suzhou",
        "P_YS_FED_IMP_IOT0000009581": "Fengquan District",
        "P_YS_FED_FW_0000021387": "Aksu Prefecture",
        "P_YS_FED_IMP_IOT0000009582": "Shule County",
        "P_YS_FED_IMP_IOT0000009587": "Guangshan County",
        "P_YS_OA_XTWENKU_0000035713": "Upload",
        "P_YS_FED_IMP_IOT0000009586": "Jurong",
        "P_YS_FI_CM_0000029097": "Today",
        "P_YS_FED_IMP_IOT0000008249": "Chenxi County",
        "P_YS_FED_IMP_IOT0000008247": "Xiangshan District",
        "P_YS_FED_IMP_IOT0000008248": "Kaiyuan",
        "P_YS_FED_IMP_IOT0000008241": "Youxi County",
        "P_YS_SD_SDMB_0000147207": "<<",
        "P_YS_FED_IMP_IOT0000009570": "Yunxi District",
        "P_YS_FED_IMP_IOT0000008240": "Tianyuan District",
        "P_YS_FED_IMP_IOT0000009576": "Dongchuan District",
        "P_YS_FED_UCFBASEDOC_0000024962": "Billing",
        "P_YS_FED_IMP_IOT0000009577": "Chongchuan District",
        "P_YS_FED_IMP_IOT0000009574": "Yutai County",
        "P_YS_FED_UCFBASEDOC_0000024960": "Publish",
        "P_YS_PF_PRINT_0000056755": "Home Addr.",
        "P_YS_FED_IMP_IOT0000008236": "Jinchengjiang District",
        "P_YS_FED_IMP_IOT0000009567": "Daofu County",
        "P_YS_FI_CM_0000030090": "Failed to obtain parameter: [interface]",
        "P_YS_FED_IMP_IOT0000008230": "Qixia District",
        "P_YS_FED_IMP_IOT0000009561": "Fengqiu County",
        "P_YS_FED_IMP_IOT0000009560": "Guyuan County",
        "P_YS_SD_UDHBN_0001144941": "Delivery Date:",
        "P_YS_SD_UDHBN_0001144942": "Doc No.:",
        "P_YS_FED_IMP_IOT0000009566": "Dianbai County",
        "P_YS_PF_PROCENTER_0000023211": "Male",
        "P_DIWORK_YC_ORDER_0000061307": "Effective successfully",
        "P_YS_PF_PRINT_0000056726": "Change Time",
        "P_YS_FED_FW_1514390015376883724": "Please enter the range of values in the following format:",
        "P_YS_FI_IA_0000151381": "Failed to save data",
        "P_YS_FED_FW_1514390015376883727": "&gt;a --- greater than a",
        "P_YS_FED_FW_1514390015376883721": "[a,b) --- greater than or equal to a and less than b",
        "P_YS_FED_IMP_IOT0000009558": "Wujin District",
        "P_YS_FED_UCFBASEDOC_0000024949": "Portal Ctrl",
        "P_YS_FED_FW_0001194811": "Do not click too frequently. Please wait...",
        "P_YS_FED_IMP_IOT0000009550": "Sunite Right Banner",
        "P_YS_FED_IMP_IOT0000009551": "Panshi",
        "P_YS_FED_UCFBASEDOC_0000024942": "Add",
        "P_YS_FED_IMP_IOT0000009554": "Xushui County",
        "P_YS_FED_IMP_IOT0000008224": "Jiulongpo District",
        "P_YS_FED_IMP_IOT0000008221": "Mengla County",
        "P_YS_FED_IMP_IOT0000009553": "Zeku County",
        "P_YS_FED_FW_1514390015376883736": "(a,b) --- greater than a and less than b",
        "P_YS_FED_FW_1514390015376883739": "&lt;b --- less than b",
        "P_YS_FED_FW_1514390015376883730": "&lt;=b --- less than or equal to b",
        "P_YS_FED_FW_1514390015376883733": "Range Error. Values on the left side should be less than the right side.",
        "P_YS_FED_IMP_IOT0000008217": "Dayu County",
        "P_YS_FED_IMP_IOT0000009548": "Chengde County",
        "P_YS_FED_UCFBASEDOC_0000024939": "Board Permission",
        "P_YS_FED_IMP_IOT0000009549": "Anci District",
        "P_YS_FED_IMP_IOT0000009540": "Aba County",
        "P_YS_FED_IMP_IOT0000008212": "Liubei District",
        "P_YS_FED_IMP_IOT0000009542": "Jingyang County",
        "P_YS_FED_EXAMP_0000020481": "Saved successfully",
        "P_YS_FED_EXAMP_0000020480": "The status is order delivery and Allow to modify product upon delivery is set to No. Cannot return product",
        "P_YS_FED_EXAMP_0000020483": "For original order return of card/voucher product, card/voucher Qty should be -1",
        "P_YS_FED_EXAMP_0000020482": "Payment is not made via member wallet during booking. It's not allowed to make payment via member wallet when canceling order",
        "P_YS_FED_FW_0000021319": "Product Barcode:",
        "P_YS_FED_EXAMP_0000020478": "Store",
        "P_YS_FED_IMP_IOT0000008205": "Linkou County",
        "P_YS_FED_EXAMP_0000020477": "The salespersons in all the lines will be replaced. Continue?",
        "P_YS_FED_FW_0000021317": "Mobile Report  MobileData Render",
        "P_YS_FED_FW_0000021318": "Lianyungang",
        "P_YS_FED_EXAMP_0000020479": "Rich Text Editor",
        "P_YS_FED_IMP_IOT0000008204": "Qiongshan District",
        "P_YS_FED_EXAMP_0000020474": "Contact:",
        "P_YS_FED_IMP_IOT0000008209": "Changning District",
        "P_YS_FED_EXAMP_0000020473": "Error:",
        "P_YS_FED_EXAMP_0000020476": "Return",
        "P_YS_FED_IMP_IOT0000008207": "Zijin County",
        "P_YS_FED_IMP_IOT0000009538": "Yongding District",
        "P_YS_FED_EXAMP_0000020475": "The status is order delivery and Allow to modify product upon delivery is set to No. Cannot make payment via member wallet",
        "P_YS_FED_IMP_IOT0000008208": "suburbs",
        "P_YS_FED_IMP_IOT0000009539": "Nanxun District",
        "P_YS_FED_FW_0000021311": "Zhangjiajie",
        "P_YS_FED_FW_0000021312": "Any",
        "P_YS_FED_FW_0000021310": "Member Card (Plastic Member) (Ordinary Member)",
        "P_YS_FED_FW_0000021315": "Chenzhou",
        "P_YS_FED_FW_0000021316": "The selected Qty exceeds the upload limit. Please upload again",
        "P_YS_FED_IMP_IOT0000008202": "Tianning District",
        "P_YS_FED_IMP_IOT0000009533": "Xishan District",
        "P_YS_FED_FW_0000021313": "Save as Picture",
        "P_YS_FED_FW_0000021314": "Reference",
        "P_YS_FED_IMP_IOT0000008200": "Xinping Yi and Dai Autonomous County",
        "P_YS_FED_IMP_IOT0000009531": "Jianzha County",
        "P_YS_OA_XTLCZX_0000030786": "All Data",
        "P_YS_FED_FW_0000021330": "Xingtai",
        "P_YS_FED_EXAMP_0000020492": "Cannot be executed for free product",
        "P_YS_FED_EXAMP_0000020494": "On-shelf Qty of U-Order:",
        "P_YS_FED_EXAMP_0000020493": "Cannot modify the Qty in replacement lines during original order return",
        "P_YS_FED_FW_0001247825": "Interaction Rule >>>",
        "P_YS_FED_EXAMP_0000020490": "Permission Scope",
        "P_YS_FED_EXAMP_0000020489": "On-site discount has been executed. Cannot modify Qty",
        "P_YS_PF_GZTSYS_0000013119": "User Mgmt",
        "P_YS_FED_EXAMP_0000020488": "Please check if the prepaid card is correct and valid",
        "P_YS_FED_IMP_IOT0000009526": "Tongan District",
        "P_YS_FED_FW_0000021328": "Urumqi",
        "P_YS_PF_GZTSYS_0000015779": "Product",
        "P_YS_FED_IMP_IOT0000009523": "Wushenqi",
        "P_YS_FED_FW_0000021329": "Ankang",
        "P_YS_FED_EXAMP_0000020484": "Cannot find the corresponding product Info",
        "P_YS_FED_EXAMP_0000020487": "You've not entered No.  ",
        "P_YS_FED_IMP_IOT0000009527": "Guangchang County",
        "P_YS_FED_EXAMP_0000020486": "s product line",
        "P_YS_FED_FW_0000021322": "Xuzhou",
        "P_YS_FED_FW_0000021323": "Mianyang",
        "P_YS_FED_FW_0000021320": "Qitaihe",
        "P_YS_FED_FW_0000021321": "Dazhou",
        "P_YS_OA_XTLCZX_0000030776": "Normal",
        "P_YS_FED_FW_0000021326": "Anyang",
        "P_YS_FED_FW_0000021327": "Retail Amt",
        "P_YS_FED_IMP_IOT0000009522": "Qujiang District",
        "P_YS_FED_FW_0000021324": "Alxa League",
        "P_YS_FED_FW_0000021325": "Xiamen",
        "P_YS_OA_XTLCZX_0000030790": "Input manually",
        "P_YS_FED_EXAMP_0000020499": "Change Retail Price",
        "P_YS_FED_IMP_IOT0000009515": "Jinxiu Yao Autonomous County",
        "P_YS_YYGJFW_YBUC_0001335796": "Shortcut Key",
        "P_YS_FED_IMP_IOT0000009513": "Boshan District",
        "P_YS_FED_EXAMP_0000020496": "Promotion activity has been executed. Cannot modify product Qty",
        "P_YS_FED_EXAMP_0000020495": "Pay. Cancel it online?",
        "P_YS_FED_EXAMP_0000020498": "Prepaid Card - Non-original Order Return",
        "P_YS_FED_IMP_IOT0000009516": "Wanyuan",
        "P_YS_FED_EXAMP_0000020497": "Failed to obtain product specification. Info:",
        "P_YS_FED_IMP_IOT0000009510": "Yongde County",
        "P_YS_FED_IMP_IOT0000009509": "Gu'an County",
        "P_YS_FED_FW_0000021308": "Yuncheng",
        "P_YS_FED_FW_0000021309": "Chizhou",
        "P_YS_FED_FW_0000021306": "Xinjiang",
        "P_YS_FED_IMP_IOT0000009501": "Emerging District",
        "P_YS_FED_FW_0000021307": "Supported formats: PDF, Word, Excel, Txt, JPG, PNG, BMP, GIF",
        "P_YS_FED_IMP_IOT0000009502": "Jinggangshan",
        "P_YS_FED_IMP_IOT0000009507": "Xinjiang County",
        "P_YS_FED_FW_0000021300": "Zhumadian",
        "P_YS_FED_FW_0000021301": "subConfigArray_Operate  Cannot find the corresponding eChart  chartKey =",
        "P_YS_PF_PROCENTER_0000023238": "Please select at least one piece of data",
        "P_YS_FED_FW_0000021304": "Shaanxi",
        "P_YS_FED_FW_0000021305": "Qingdao",
        "P_YS_FED_FW_0000021302": "Xing'an League",
        "P_YS_FED_FW_0000021303": "The format of delete parameter should be Array or String",
        "P_YS_FED_FW_0000021362": "Zhengzhou",
        "P_YS_FED_FW_0000021363": "Pingliang",
        "P_YS_FED_FW_0000021360": "Boss Template",
        "P_YS_FED_FW_0000021361": "Huainan",
        "P_YS_OA_XTSPZX_0000034691": "Submitted By",
        "P_YS_FED_EXAMP_0000020434": "When it's not allowed to modify product upon delivery, product cannot be deleted",
        "P_YS_FED_FW_0001253699": "[mdf-metaui-web] [CellModel] [RemodelingCell()] RemodelingFormatControl()返回用于显示的text ==>",
        "P_YS_FED_FW_0001253698": "参照回显字段",
        "P_YS_FED_EXAMP_0000020436": "Retail",
        "P_YS_FED_EXAMP_0000020435": "Refund via POS terminal succeeded",
        "P_YS_FED_EXAMP_0000020430": "Select warehouse",
        "P_YS_FED_FW_0001253695": "加载查询方案组件componentDidMount开始",
        "P_YS_FED_FW_0001253694": "]类型的模板",
        "P_YS_FED_EXAMP_0000020432": "The status is booked and Allow to modify product upon delivery is set to Yes. Cannot pay via member wallet",
        "P_YS_FED_FW_0001253697": "PrintButton: 缺少printDomain设置",
        "P_YS_FED_EXAMP_0000020431": "Cannot add product that are not self-purchased to POs",
        "P_YS_FED_FW_0001253696": "配置信息失败。",
        "P_YS_FED_FW_0000021355": "The chart cannot be displayed properly. In the configuration Info returned from report/getGroupSetting (the detailed settings of report group scheme needs to obtained to display), _.isEmpty(json.data.chartConfig) == false",
        "P_YS_FED_FW_0000021356": "Night Shift",
        "P_YS_FED_FW_0000021353": "Failed to save multiple pieces of data",
        "P_YS_FED_FW_0000021354": "Liupanshui",
        "P_YS_SD_SDMB_0000137806": "”",
        "P_YS_FED_FW_0000021359": "Jiangsu",
        "P_YS_FED_EXAMP_0000020438": "When it's not allowed to modify product upon delivery, salespersons cannot be modified",
        "P_YS_FED_EXAMP_0000020437": "Not generated",
        "P_YS_FED_FW_0000021357": "Jilin",
        "P_YS_FED_FW_0000021358": "Lincang",
        "P_YS_FED_EXAMP_0000020439": "Total actual sub-table rounding Amt:",
        "P_YS_FED_FW_0000021370": "Mobile Report  MobileReportSum Render",
        "P_YS_FED_FW_0000021373": "Dandong",
        "P_YS_FED_FW_0000021374": "Mysterious Black",
        "P_YS_SD_UDHMC_0000051115": "Next Time",
        "P_YS_FED_FW_0000021371": "Tianshui",
        "P_YS_FED_FW_0000021372": "Xining",
        "P_YS_FED_EXAMP_0000020450": "Online Retailer Order",
        "P_YS_FED_EXAMP_0000020445": "Wallet does not apply to all product. Can perform quick settlement",
        "P_YS_FED_EXAMP_0000020444": "(Room No.) and booked room No.",
        "P_YS_FED_EXAMP_0000020447": "Product unit price cannot be less than 0",
        "P_YS_FED_EXAMP_0000020446": "Actual received Amt of this Doc is 0. Please confirm",
        "P_YS_FED_EXAMP_0000020441": "Cannot pay via member wallet for non-original order return",
        "P_YS_FED_EXAMP_0000020440": "Not Approved",
        "P_YS_PF_GZTSYS_0000013159": "Quotation",
        "P_YS_FED_EXAMP_0000020443": "Mobile No./Member No.",
        "P_YS_FED_EXAMP_0000020442": "No available member wallet",
        "P_YS_FED_FW_0000021366": "Wenzhou",
        "P_YS_FED_FW_0000021367": "Ma'anshan",
        "P_YS_FED_FW_0001350929": "Point Aggregation",
        "P_YS_FED_FW_0000021364": "Hengshui",
        "P_YS_FED_FW_0000021365": "Pingdingshan",
        "P_YS_FED_EXAMP_0000020449": "Welcome to log in",
        "P_YS_FED_EXAMP_0000020448": "The account doesn't have the permission of the discount",
        "P_YS_FED_FW_0000021368": "Gansu",
        "P_YS_FED_FW_0000021369": "Sichuan",
        "P_YS_FED_FW_0001350931": "2 Columns",
        "P_YS_FED_FW_0001350932": "No. of Columns Displayed",
        "P_YS_FED_FW_0000021340": "Jiayuguan",
        "P_YS_OA_XTLCZX_0000030753": "Not Started",
        "P_YS_FED_FW_0000021341": "Failed to delete data",
        "P_YS_OA_XTLCZX_0000030752": "Locate",
        "P_YS_FED_FW_0001253680": "加载查询方案组件componentDidMount结束",
        "P_YS_FED_EXAMP_0000020461": "Password modified successfully",
        "P_YS_PF_GZTSYS_0000015793": "Organization Settings",
        "P_YS_FED_FW_0001253682": "[mdf-metaui-web] [amap] [setValue()] saveType为json时，setValue(value)的参数value不是一个有效的JSONString",
        "P_YS_FED_EXAMP_0000020460": "Market Price",
        "P_YS_FED_FW_0001253681": "，兼容返回空字符串! text is",
        "P_YS_PF_GZTSYS_0000015790": "Clerk",
        "P_YS_FED_FW_0001350930": "1 Column",
        "P_YS_FED_EXAMP_0000020456": "Cannot modify the Qty in product lines during adjustment",
        "P_YS_FED_FW_0001253677": "按钮点击，调用ConvenientQuery组件内部buttonClick方法开始",
        "P_YS_FED_EXAMP_0000020455": "Cannot modify Qty of recovered items",
        "P_YS_FED_FW_0001253676": "InputIdentity [onBlur] canBubbleBlur == true,继续冒泡blur事件",
        "P_YS_FED_FW_0000021339": "Yangzhou",
        "P_YS_FED_EXAMP_0000020458": "Product Property",
        "P_YS_FED_FW_0001253679": "InputIdentity [onBlur] canBubbleBlur == false, 不冒泡blur事件",
        "P_YS_FED_EXAMP_0000020457": "Pick-up by Store",
        "P_YS_FED_FW_0001253678": "二维表第",
        "P_YS_FED_EXAMP_0000020452": "Failed to modify Info",
        "P_YS_FED_FW_0001253673": "PrintButton: 缺少user信息",
        "P_YS_PF_GZTSYS_0000015787": "Query",
        "P_YS_FED_EXAMP_0000020451": "Select region",
        "P_YS_FED_FW_0001253672": "得到UI元数据，开始执行setState",
        "P_YS_PF_GZTLOG_0000028817": "Request failed",
        "P_YS_FED_FW_0001253675": "领域为[",
        "P_YS_FED_EXAMP_0000020453": "Online Retailer Return",
        "P_YS_FED_FW_0001253674": "加载查询方案组件构造函数结束",
        "P_YS_FED_FW_0000021333": "Stacked Column Chart Example",
        "P_YS_FED_FW_0000021334": "Board Config. Info - Module Config. - Weather",
        "P_YS_FED_FW_0000021331": "Boss Large Screen Board",
        "P_YS_FED_FW_0000021332": "Null",
        "P_YS_FED_FW_0000021337": "Horizontal",
        "P_YS_FED_FW_0000021338": "Zhejiang",
        "P_YS_FED_EXAMP_0000020459": "Decimal Digits of Weight",
        "P_YS_OA_XTLCZX_0000030749": "Year-Month-Day HH:MM",
        "P_YS_FED_FW_0000021335": "Zunyi",
        "P_YS_OA_XTLCZX_0000030748": "Available Field",
        "P_YS_FED_FW_1463482661291950083": "The encrypted text length is less than the encrypted start bit (encryptStart) and the encrypted number (encryptCount), so it is not encrypted.",
        "P_YS_FED_FW_0000021336": "Guoluo Tibetan Autonomous Prefecture",
        "P_YS_FED_FW_1463482661291950080": "Error in encryption rule configuration, encryption start bit (encryptStart) and encryption count cannot be negative at the same time, so it is not encrypted.",
        "P_YS_FED_FW_0000021351": "Chongqing",
        "P_YS_FED_FW_0000021352": "Loudi",
        "P_YS_FED_FW_0000021350": "Qujing",
        "P_YS_FED_EXAMP_0000020470": "Development in progress. Stay tuned",
        "P_YS_FED_FW_0001253691": "[mdf-metaui-web] [CellModel] RemodelingFormatControl() case map时，无法处理的数据，text is",
        "P_YS_FED_FW_0001253690": "得到UI元数据，结束执行setState",
        "P_YS_FED_FW_0001253693": "[mdf-cube] [getCellDataByCtrlType()] 不规范数据的map数据，兼容处理时没有合法的属性address, 返回空字符串，text ==>",
        "P_YS_FED_EXAMP_0000020471": "Cannot add product when order is canceled",
        "P_YS_FED_FW_0001253692": "按钮点击，调用ConvenientQuery组件内部buttonClick方法结束",
        "P_YS_FED_FW_0001265659": "Display Angle - Y Axis",
        "P_YS_FED_EXAMP_0000020467": "The status is booked and Allow to modify product upon delivery is set to Yes. Cannot pay via prepaid card",
        "P_YS_FED_FW_0001253688": "]菜单服务，",
        "P_YS_FED_FW_0001253687": " in the 2-D table is duplicate",
        "P_YS_FED_EXAMP_0000020469": "Cannot modify the retail price in the product line",
        "P_YS_FED_EXAMP_0000020468": "Required",
        "P_YS_FED_FW_0001253689": "加载查询方案组件构造函数开始",
        "P_YS_FED_EXAMP_0000020463": "Redemption Voucher",
        "P_YS_FED_FW_0001253684": "Incomplete configuration Info. Please check",
        "P_YS_FED_EXAMP_0000020462": "Clear",
        "P_YS_FED_FW_0001253683": "Null",
        "P_YS_FED_EXAMP_0000020465": "Input box cannot be empty",
        "P_YS_FED_FW_0001253686": "No reference code for this Org",
        "P_YS_FED_EXAMP_0000020464": "Delivered",
        "P_YS_FED_FW_0001253685": "[mdf-cube] [getCellDataByCtrlType()] 不规范数据的map数据，正在尝试兼容处理，text ==>",
        "P_YS_FED_FW_0000021344": "Qingyang",
        "P_YS_FED_FW_0000021345": "Line Chart Example",
        "P_YS_FED_FW_0000021342": "No more data",
        "P_YS_FED_FW_0001136114": "node Client",
        "P_YS_FED_FW_0001265660": "Display Angle - X Axis",
        "P_YS_FED_FW_0000021343": "The format of the selected file is incorrect. Please select again",
        "P_YS_FED_FW_0001265661": "The display angle should be between -90~90",
        "P_YS_FED_FW_0000021348": "Mudanjiang",
        "P_YS_FED_FW_0000021349": "Ezhou",
        "P_YS_FED_FW_0000021346": "Tongling",
        "P_YS_FED_FW_0000021347": "Nanchang",
        "P_YS_FI_ETL_0000111662": "Network",
        "P_YS_FED_FW_0001073815": "Zhongdian City",
        "P_YS_FED_FW_0001073814": "Duyun City",
        "P_YS_FED_FW_0001073813": "Shunde City",
        "P_YS_FED_FW_0001073812": "Wanxian City",
        "P_YS_FED_FW_0001073811": "Hunjiang City",
        "P_YS_SD_UDHWN_0000048223": "Tunchang County",
        "P_YS_FED_FW_0001073810": "Delhi City",
        "P_YS_FED_FW_0001073819": "Jingsha City",
        "P_YS_FED_FW_0001073818": "Chaoyang City",
        "P_YS_FED_FW_0001073817": "Guichi City",
        "P_YS_FED_FW_0001073816": "Hailar",
        "P_YS_SD_UDHWN_0001008650": "Horizontal Selection",
        "P_YS_SD_UDHWN_0000049569": "Fengxian District",
        "P_YS_HR_HRFZ-UI_1474270717181689857": "UI Template ID",
        "P_YS_FED_FW_0001073826": "Huangzhou City",
        "P_YS_FED_FW_0001073825": "Dongchuan City",
        "P_YS_FED_FW_0001073824": "Suizao City",
        "P_YS_FED_FW_0001073823": "Linchuan City",
        "P_YS_SD_UDHWN_0000049565": "Baidu Map",
        "P_YS_FED_FW_0001073822": "Maqin County",
        "P_YS_FED_FW_0001073821": "Weifang City",
        "P_YS_FED_FW_0001073820": "Gannan Prefecture",
        "P_YS_FED_FW_0000088641": "Please select tree node on the left",
        "P_YS_FED_EXAMP_0000020401": "Change Password",
        "P_YS_FED_EXAMP_0000020400": "Error in the trial account Info",
        "P_YS_FED_EXAMP_0000020403": "All the product in the package not entered completely. Cannot execute point deduction",
        "P_YS_FED_EXAMP_0000020402": "Top Up",
        "P_YS_FED_EXAMP_0000020409": "After-sales",
        "P_YS_FED_FW_0001112266": "]'s product",
        "P_YS_FED_EXAMP_0000020408": "Failed to obtain the initial price of the physical card corresponding to the prepaid card No.",
        "P_YS_FED_EXAMP_0000020405": "Birthday",
        "P_YS_FED_EXAMP_0000020404": "Next Day",
        "P_YS_FED_EXAMP_0000020407": "Failed to obtain weight. Please check whether the tray is properly placed",
        "P_YS_FED_EXAMP_0000020406": "Old Password",
        "P_YS_FED_FW_0001149575": "You can set 10 search columns at most",
        "P_YS_FED_FW_0001097806": ", result:",
        "P_YS_FED_EXAMP_0000020412": "Cannot modify Qty during adjustment",
        "P_YS_FED_EXAMP_0000020411": "Suggested Retail Price",
        "P_YS_PF_AUTHF_0000096105": "Available",
        "P_YS_FED_EXAMP_0000020414": "The network is currently unavailable. Cannot sell product subject to validity period management",
        "P_YS_FED_EXAMP_0000020413": "Experience Now",
        "P_YS_FED_FW_0001097807": "Current platform:",
        "P_YS_FED_EXAMP_0000020410": "Please set the default payment method first",
        "P_YS_FI_CM_0000029118": "Doc Status",
        "P_YS_FED_EXAMP_0000020419": "The prepaid card is not for original order return. Cannot modify Qty",
        "P_YS_FED_EXAMP_0000020416": "Commodity Center",
        "P_YS_FED_EXAMP_0000020415": "Failed to obtain store Info",
        "P_YS_FED_EXAMP_0000020418": "Product with the SN already exists",
        "P_YS_FED_EXAMP_0000020417": "Business Function Menu (debuggable)",
        "P_YS_PLM_PLM-GDS-UI_0001095906": "View History",
        "P_YS_HR_HRJQ_0000031525": "Jack",
        "P_YS_FED_FW_0001149583": "Future",
        "P_YS_FED_EXAMP_0000020423": "Retail billing verification failed: you've not logged in to the store. Billing is not allowed",
        "P_YS_FED_EXAMP_0000020422": "It's not allowed to change the price of the current product after billing",
        "P_YS_FED_EXAMP_0000020425": "Cannot book",
        "P_YS_FED_EXAMP_0000020424": "Please log in as a member to enter electronic card/voucher product",
        "P_YS_SD_DGYL-FE_1541228913807589381": "Please configure the mobile template",
        "P_YS_FED_EXAMP_0000020421": "Please select product details",
        "P_YS_FED_EXAMP_0000020420": "Cannot perform cloud printing in this mode. Please set again",
        "P_YS_FED_EXAMP_0000020427": "Change Qty",
        "P_YS_FED_EXAMP_0000020426": "Full Address",
        "P_YS_FED_EXAMP_0000020429": "Cannot add non-physical prepaid card product lines when selling cards",
        "P_YS_FED_EXAMP_0000020428": ") with Validity Period Mgmt enabled. Please enter the validity period",
        "P_YS_FED_FW_0001367630": "Count",
        "P_YS_SD_UDHWN_0000050500": "Changjiang Li Autonomous County",
        "P_YS_FED_FW_0001367631": "Aggregated Field",
        "P_YS_PLM_GDS-BE_0001160301": "Error occurred while uploading.",
        "P_YS_FED_FW_0000021517": "Mobile Report  MobileFilter Render",
        "P_YS_FED_FW_0000021518": "Board Config. Info - Desktop",
        "P_YS_FED_IMP_IOT0000011702": "Fengxian",
        "P_YS_FED_FW_0001034253": "Emp. Gender",
        "P_YS_FED_FW_0000021515": "Beijing",
        "P_YS_FED_IMP_IOT0000011705": "Fengtai District",
        "P_YS_FED_FW_0001367629": "Picture Field",
        "P_YS_FED_FW_0000021516": "Bayannaoer",
        "P_YS_FED_IMP_IOT0000005898": "Beiliu",
        "P_YS_FED_FW_0000021519": "Wuxi",
        "P_YS_FED_FW_0001380601": "Please enter the scheme name in the multilingual environment",
        "P_YS_FED_FW_0000021510": "Wuzhou",
        "P_YS_FED_FW_0001100234": "The required item <%=confirmMSGFields%> is hidden for the operation. Please re-confirm",
        "P_YS_FED_FW_0001100235": ") is hidden for the operation. Please re-confirm",
        "P_YS_FED_FW_0000021513": "Xilin Gol League",
        "P_YS_FED_IMP_IOT0000005890": "Alxa Right Banner",
        "P_YS_FED_IMP_IOT0000011707": "Shaya County",
        "P_YS_FED_FW_0000021514": "Cangzhou",
        "P_YS_FED_FW_0000021511": "Sanya",
        "P_YS_FED_FW_0000021512": "Ya'an",
        "P_YS_FED_FW_0000110004": "Only <%=text%> format supported",
        "P_YS_SCM_STOCK_0001230696": "Delete by Scanning",
        "P_YS_FED_FW_0000021528": "Bubble Chart Example",
        "P_YS_PF_GZTSUPPLIER_0001241184": "]，",
        "P_YS_FED_FW_0000021529": "Anshun",
        "P_YS_FED_IMP_IOT0000011713": "Yangpu District",
        "P_YS_FED_FW_0000021526": "Guangdong",
        "P_YS_FED_FW_0000021527": "Luzhou",
        "P_YS_FED_IMP_IOT0000011710": "Yongxiu County",
        "P_YS_FED_IMP_IOT0000005886": "Minhang District",
        "P_YS_FED_FW_0000021520": "Zaozhuang",
        "P_YS_FED_FW_0000021521": "Baoding",
        "P_YS_FED_FW_0001367632": "Switch Aggregated Field",
        "P_YS_FED_FW_0000021524": "Yichang",
        "P_YS_FED_IMP_IOT0000011718": "Longchang County",
        "P_YS_FED_FW_0000021525": "Karamay",
        "P_YS_FED_IMP_IOT0000011717": "Licheng District",
        "P_YS_FED_FW_0000021522": "Confirm to return?",
        "P_YS_FED_FW_0000021523": "Liaoning",
        "P_YS_FED_IMP_IOT0000005880": "Jinghe County",
        "P_YS_FED_IMP_IOT0000011719": "Changdao County",
        "P_YS_FED_FW_1456081762615033856": "Select the start and end time",
        "P_YS_PF_GZTTMP_0000075994": "In list",
        "P_YS_FED_FW_0001253831": "Level 2",
        "P_YS_FED_FW_0001253830": "Level 3",
        "P_YS_FED_IMP_IOT0000011727": "Wuyi County",
        "P_YS_FED_FW_0001253833": "Level 1",
        "P_YS_FED_IMP_IOT0000005873": "Xinxian",
        "P_YS_FED_IMP_IOT0000011726": "Qingyuan County",
        "P_YS_FED_FW_0001253832": "Level 4",
        "P_YS_FED_IMP_IOT0000011721": "Jiangyong County",
        "P_YS_FED_IMP_IOT0000005877": "Jungar Banner",
        "P_YS_FED_IMP_IOT0000011722": "Ye County",
        "P_YS_OA_XTWENKU_0000035585": "No data",
        "P_YS_FED_IMP_IOT0000011729": "Chishui",
        "P_YS_FED_FW_0000111353": "Attachment ID missing in line",
        "P_YS_FED_IMP_IOT0000005870": "Xigu District",
        "P_YS_FED_FW_0000111354": "Only Display in One Line is supported in Attachments",
        "P_YS_FED_FW_0000111355": "Table is empty",
        "P_YS_FED_FW_0000111356": "Attachments",
        "P_YS_FED_FW_0000111357": "Required Item",
        "P_YS_FED_FW_0000111358": "Not entered. Please enter the data completely and try to save again",
        "P_YS_FED_FW_0000111359": "The length of the integer part in the entered number cannot exceed",
        "P_YS_FED_FW_0001073804": "Xifeng City",
        "P_YS_FED_IMP_IOT0000005869": "Huangping County",
        "P_YS_FED_FW_0001073803": "Jianghan City",
        "P_YS_FED_FW_0001073802": "Jagdaqi",
        "P_YS_FED_IMP_IOT0000011730": "Arukolqin Banner",
        "P_YS_FED_FW_0001073801": "Liuku City",
        "P_YS_FED_FW_0001073800": "Barkam",
        "P_YS_FED_FW_0000021506": "Siping",
        "P_YS_FED_IMP_IOT0000005861": "Liandu District",
        "P_YS_FED_FW_0000021507": "Cash Sale",
        "P_YS_FED_IMP_IOT0000005860": "Linzhi County",
        "P_YS_FED_FW_0000021504": "Dali Bai Autonomous Prefecture",
        "P_YS_FED_IMP_IOT0000010406": "Yuhuatai District",
        "P_YS_FED_FW_0000021505": "Kashgar Prefecture",
        "P_YS_FED_FW_0001073809": "Tongren City",
        "P_YS_FED_IMP_IOT0000005862": "Fengcheng",
        "P_YS_FED_IMP_IOT0000011737": "Jiange County",
        "P_YS_FED_FW_0001073808": "Gonghe City",
        "P_YS_OA_XTWENKU_0000035594": "Uploading...",
        "P_YS_FED_FW_0001073807": "Huaiyin City",
        "P_YS_FED_IMP_IOT0000005864": "Lower Garden District",
        "P_YS_FED_IMP_IOT0000010401": "Anqiu",
        "P_YS_FED_FW_0000021508": "Bubble Chart Config. Info - eChartSetting",
        "P_YS_FED_FW_0001073806": "Ulanhot",
        "P_YS_FED_IMP_IOT0000010402": "Xinyuan County",
        "P_YS_FED_IMP_IOT0000011734": "Longhai",
        "P_YS_FED_FW_0000021509": "Column/Line Chart Config. Info - eChartSetting",
        "P_YS_FED_FW_0001073805": "Fuling City",
        "P_YS_FED_IMP_IOT0000005866": "Sangri County",
        "P_YS_FED_IMP_IOT0000011733": "Meitan County",
        "P_YS_FED_FW_0000111360": "Please configure file address",
        "P_YS_FED_FW_0000111361": "Scheme name cannot be duplicate",
        "P_YS_FED_FW_0000021502": "Xi'an",
        "P_YS_FED_FW_0000111362": "Condition added",
        "P_YS_FED_FW_0000021503": "Guizhou",
        "P_YS_FED_IMP_IOT0000010409": "Xuyong County",
        "P_YS_FED_IMP_IOT0000011739": "Pu'er Hani and Yi Autonomous County",
        "P_YS_FED_FW_0000021500": "Jieyang",
        "P_YS_FED_FW_0000021501": "Purchasing Dept",
        "P_YS_FI_CM_0000029174": "Remarks",
        "P_YS_FED_IMP_IOT0000005858": "Linchuan District",
        "P_YS_FED_IMP_IOT0000005857": "Lianyuan",
        "P_YS_FED_IMP_IOT0000011741": "Zhuolu County",
        "P_YS_FED_IMP_IOT0000005859": "Kaihua County",
        "P_YS_FED_IMP_IOT0000011740": "Yongji County",
        "P_YS_SD_SDMAUF_0001064722": "Traditional Chinese",
        "P_YS_FED_FW_1502904499728023562": "Previous Line",
        "P_YS_FED_IMP_IOT0000011747": "Xiangfang District",
        "P_YS_FED_IMP_IOT0000010416": "Haimen",
        "P_YS_FED_IMP_IOT0000011746": "Horqin District",
        "P_YS_FED_FW_0000154407": "command cParameter JSON format error-->",
        "P_YS_FED_IMP_IOT0000005853": "Gaozhou",
        "P_YS_FED_IMP_IOT0000010412": "Baoying County",
        "P_YS_FED_IMP_IOT0000011742": "Yueyang County",
        "P_YS_PF_SOCD_0000089109": "Ghana",
        "P_YS_FED_IMP_IOT0000010413": "Huai Shang District",
        "P_YS_FED_IMP_IOT0000011745": "Fenxi County",
        "P_YS_FED_IMP_IOT0000010414": "Fuxian",
        "P_YS_FED_IMP_IOT0000011744": "Huinan County",
        "P_YS_PF_SOCD_0000089107": "Benin",
        "P_YS_PF_SOCD_0000089105": "New Zealand",
        "P_YS_PF_SOCD_0000089106": "Burundi",
        "P_YS_PF_SOCD_0000089103": "Venezuela",
        "P_YS_PF_SOCD_0000089104": "Jordan",
        "P_YS_PF_SOCD_0000089101": "Swaziland",
        "P_YS_FED_FW_1502904499728023559": "Next Line",
        "P_YS_FED_IMP_IOT0000005847": "Jingxing County",
        "P_YS_FED_IMP_IOT0000005846": "Mudanjiang",
        "P_YS_SD_SDMA_0000038357": "Signed In",
        "P_YS_FED_IMP_IOT0000010420": "Tongxiang",
        "P_YS_FED_IMP_IOT0000005848": "Xiangshui County",
        "P_YS_FED_IMP_IOT0000010426": "Shidian County",
        "P_YS_FED_IMP_IOT0000011758": "Wulian County",
        "P_YS_FED_IMP_IOT0000005841": "Revitalization District",
        "P_YS_FED_IMP_IOT0000010428": "Congtai District",
        "P_YS_FED_FW_0001253822": "if 配置不正确",
        "P_YS_FED_IMP_IOT0000010423": "Autonomous Banner",
        "P_YS_FED_IMP_IOT0000011753": "Qianshan County",
        "P_YS_FED_IMP_IOT0000010424": "Maqin County",
        "P_YS_FED_IMP_IOT0000005844": "Nong'an County",
        "P_YS_FED_FW_0001253828": "单据id属性不存在，请检查数据建模",
        "P_YS_FED_FW_0001253827": "条。失败原因",
        "P_YS_FED_FW_0001253829": "isMdfMobile 判断出错",
        "P_YS_FED_FW_0001253824": "，请填写完整！",
        "P_YS_FED_FW_0001253823": "子表：",
        "P_YS_FED_FW_0001253826": "if 不符合条件",
        "P_YS_FED_FW_0000130443": "Drag and drop to upload",
        "P_YS_FED_FW_0001253825": "条数据？",
        "P_YS_PF_SOCD_0000089121": "Uzbekistan",
        "P_YS_PF_SOCD_0000089122": "South Korea",
        "P_YS_PF_SOCD_0000089120": "Qatar",
        "P_YS_SD_SDMB_0000148482": "Notification Time",
        "P_YS_FI_CM_0000029191": "Restore area zooming",
        "P_YS_FED_IMP_IOT0000005835": "Shaodong County",
        "P_YS_FED_IMP_IOT0000011760": "Longquanyi District",
        "P_YS_FED_IMP_IOT0000010431": "Gongshan Dulong Nu Autonomous County",
        "P_YS_FED_IMP_IOT0000005839": "Xishui County",
        "P_YS_FED_IMP_IOT0000010437": "Honghuagang District",
        "P_YS_SD_UDHWN_0000122549": "Please enter department",
        "P_YS_FED_IMP_IOT0000010438": "Gaoming District",
        "P_YS_FED_IMP_IOT0000011768": "Nanfen District",
        "P_YS_FED_FW_0000154428": "[{\"nameType\":\"text\",\"value\":\"Menu\",\"key\":\"menu\"},{\"nameType\":\"text\",\"value\":\"Permission\",\"key\":\"auth\"},{\"nameType\":\"text\",\"value\":\"Button Permission\",\"key\":\"actionAuth\"},{\"nameType\":\"text\",\"value\":\"Rule\",\"key\":\"rule\"},{\"nameType\":\"text\",\"value\":\"Option\",\"key\":\"option\"},{\"nameType\":\"text\",\"value\":\"Enumeration\",\"key\":\"enum\"},{\"nameType\":\"text\",\"value\":\"ViewModel\",\"key\":\"viewmodel\"}]",
        "P_YS_FED_IMP_IOT0000010439": "Yicheng District",
        "P_YS_FI_RA_0000071633": "Executed On",
        "P_YS_FED_FW_0000116163": "Confirm to delete the current line?",
        "P_YS_OA_XTWENKU_0000035540": "Select Date",
        "P_YS_FED_FW_1610361428967424002": "文件类型必须为excel格式",
        "P_YS_FED_FW_0000116162": "Confirm to delete the group?",
        "P_YS_FED_IMP_IOT0000010435": "Qianxi County",
        "P_YS_FED_IMP_IOT0000011767": "Juye County",
        "P_YS_FED_IMP_IOT0000011766": "Yinan County",
        "P_YS_PF_SOCD_0000089128": "Lithuania",
        "P_YS_PF_SOCD_0000089125": "Columbia",
        "P_YS_PF_SOCD_0000089126": "Germany",
        "P_YS_PF_SOCD_0000089124": "Bahrain",
        "P_YS_PF_SOCD_0000089111": "Norway",
        "P_YS_FED_FW_0001647750": "<%=type%> is being processed in the background. Other operations can be performed",
        "P_YS_FED_IMP_IOT0000005825": "Qixian",
        "P_YS_FED_IMP_IOT0000011772": "Hua County",
        "P_YS_FED_FW_1516608649439477761": "Defaults to template level setting; the value is user level setting if the column width or field displaying/hiding is set",
        "P_YS_FED_IMP_IOT0000011771": "Hanbin District",
        "P_YS_FED_IMP_IOT0000010442": "Dengzhou",
        "P_YS_FED_IMP_IOT0000011774": "Guangping County",
        "P_YS_FED_IMP_IOT0000005826": "Dongli District",
        "P_YS_FED_IMP_IOT0000011773": "Junshan District",
        "P_YS_FED_FW_1516608649439477764": "Click Restore Default to restore the template level setting",
        "P_YS_FED_IMP_IOT0000005829": "Yiliang County",
        "P_YS_FED_IMP_IOT0000005828": "Yongtai County",
        "P_YS_FED_IMP_IOT0000011779": "Dongtou County",
        "P_YS_FED_FW_1427569433243549702": "The line title is required",
        "P_YS_FED_IMP_IOT0000005821": "Jilong County",
        "P_YS_FED_IMP_IOT0000010444": "Heishan County",
        "P_YS_FED_IMP_IOT0000005820": "Benxi Manchu Autonomous County",
        "P_YS_FED_IMP_IOT0000011775": "Cuoqin County",
        "P_YS_FED_IMP_IOT0000010446": "Xunyi County",
        "P_YS_FED_IMP_IOT0000005822": "Shixing County",
        "P_YS_FED_IMP_IOT0000010447": "Linhai",
        "P_YS_FED_IMP_IOT0000011777": "Sihui",
        "P_YS_FED_FW_0000154412": "[Current Tenant Type]:",
        "P_YS_FED_IMP_IOT0000008099": "Zhalat Banner",
        "P_YS_PF_SOCD_0000089116": "Namibia",
        "P_YS_FED_IMP_IOT0000008096": "Longli County",
        "P_YS_PF_SOCD_0000089117": "Trinidad and Tobago",
        "P_YS_FED_IMP_IOT0000008097": "Pingxiang",
        "P_YS_OA_XTWENKU_0000035553": "Uploaded",
        "P_YS_PF_SOCD_0000089114": "Argentina",
        "P_YS_PF_SOCD_0000089115": "Moldova",
        "P_YS_FED_FW_0001647748": "Total pieces of data processed: <%=totalCount%>; successful: <%=sucessCount%>; failed: <%=failCount%>",
        "P_YS_FED_FW_0000154413": "[Client Orig. Protocol Type]:",
        "P_YS_FED_FW_0001647749": "Display up to <%=count%> pieces of data. Please click [<%=title%>] in the upper right corner to view more",
        "P_YS_FED_FW_0000154414": "[Current System Client Type]:",
        "P_YS_PF_SOCD_0000089113": "Gibraltar",
        "P_YS_PF_SOCD_0000089141": "Turkey",
        "P_YS_FED_FW_1457429918499995648": "Enter at most ",
        "P_YS_PF_SOCD_0000089142": "Finland",
        "P_YS_FED_IMP_IOT0000008094": "Zhenglanqi",
        "P_YS_FED_IMP_IOT0000008095": "Licheng County",
        "P_YS_FED_FW_0000154450": "Content Area Width",
        "P_YS_FED_IMP_IOT0000008093": "Canal area",
        "P_YS_FED_IMP_IOT0000005813": "Jianghua Yao Autonomous County",
        "P_YS_SD_UDHWN_0000048262": "Jixian",
        "P_YS_FED_IMP_IOT0000005818": "Nanhua County",
        "P_YS_FED_IMP_IOT0000011781": "Xiangshan District",
        "P_YS_FED_IMP_IOT0000005819": "Anguo",
        "P_YS_FED_IMP_IOT0000010450": "Jianning County",
        "P_YS_FED_IMP_IOT0000010459": "Yongchun County",
        "P_YS_SD_UDHWN_0001009945": "%d Min",
        "P_YS_FED_IMP_IOT0000005810": "Ju County",
        "P_YS_SD_UDHWN_0001008617": "Keep Selection",
        "P_YS_FED_IMP_IOT0000010456": "Fangzheng County",
        "P_YS_SD_UDHWN_0001009949": "1 Days",
        "P_YS_FED_IMP_IOT0000010457": "Shaoxing County",
        "P_YS_FED_IMP_IOT0000011789": "Lion Mountain",
        "P_YS_FED_IMP_IOT0000005811": "Cangwu County",
        "P_YS_FED_IMP_IOT0000008088": "Suibin County",
        "P_YS_PF_SOCD_0000089149": "Guyana",
        "P_YS_FED_IMP_IOT0000008085": "Xiajiang County",
        "P_YS_PF_PRINT_0000056908": "Header User-defined Field 24",
        "P_YS_FED_IMP_IOT0000008086": "Guixi",
        "P_YS_SD_SDOC_0000165986": "Failed to submit",
        "P_YS_PF_PRINT_0000056906": "Header User-defined Field 20",
        "P_YS_PF_PRINT_0000056905": "Header User-defined Field 21",
        "P_YS_PF_SOCD_0000089145": "Belgium",
        "P_YS_FED_IMP_IOT0000008089": "Lingbi County",
        "P_YS_FI_ETL_0000111612": "Reference",
        "P_YS_PF_SOCD_0000089133": "Solomon Islands",
        "P_YS_PF_SOCD_0000089130": "United Kingdom",
        "P_YS_FI_CM_0000029140": "September",
        "P_YS_PF_PRINT_0000056911": "Header User-defined Field 22",
        "P_YS_PF_SOCD_0000089131": "Malta",
        "P_YS_PF_PRINT_0000056910": "Header User-defined Field 23",
        "P_YS_FED_FW_0001097815": "Currently you are accessing the AutoNavi API, which is only available on the Internet, and cannot be accessed from a dedicated environment",
        "P_YS_FED_IMP_IOT0000005803": "Xifeng County",
        "P_YS_FED_IMP_IOT0000010463": "Dabancheng District",
        "P_YS_FED_IMP_IOT0000010464": "Gaolan County",
        "P_YS_FED_IMP_IOT0000011796": "Fuyu County",
        "P_YS_FED_IMP_IOT0000011795": "Huocheng County",
        "P_YS_FED_IMP_IOT0000005807": "Luochuan County",
        "P_YS_FED_IMP_IOT0000011790": "Lancang Lahu Autonomous County",
        "P_YS_FED_IMP_IOT0000005809": "Songyang County",
        "P_YS_FED_IMP_IOT0000011792": "Qing'an County",
        "P_YS_FED_IMP_IOT0000005808": "Jialing District",
        "P_YS_FED_IMP_IOT0000011791": "Gulang County",
        "P_DIWORK_YC_ORDER_0000061269": "Unclosed",
        "P_YS_FED_IMP_IOT0000011797": "Xiucheng District",
        "P_YS_SD_SDOC_0000163330": "Transaction Completed",
        "P_YS_FED_IMP_IOT0000005801": "Xuanwei",
        "P_YS_FED_IMP_IOT0000010468": "Tiantai County",
        "P_YS_FED_IMP_IOT0000011799": "Quzhou County",
        "P_YS_FED_IMP_IOT0000008076": "Baiquan County",
        "P_YS_CRM_CRM-FE_0001319951": "Transaction Type:",
        "P_YS_PF_SOCD_0000089138": "Gabon",
        "P_YS_FED_IMP_IOT0000008074": "Suixi County",
        "P_YS_FED_IMP_IOT0000008075": "Bengshan District",
        "P_YS_PF_SOCD_0000089136": "Maldives",
        "P_YS_PF_PRINT_0000056917": "Hidden",
        "P_YS_OA_XTWENKU_0000035536": "Download",
        "P_YS_PF_SOCD_0000089137": "Italy",
        "P_YS_PF_SOCD_0000089134": "Switzerland",
        "P_YS_PF_SOCD_0000089135": "Austria",
        "P_YS_FI_ETL_0000111601": "New Formula",
        "P_YS_PF_SOCD_0000089165": "Oman",
        "P_YS_FED_FW_0001318684": "存在重复行，第",
        "P_YS_FED_FW_1570959055392342017": "The network is off. Please try again later",
        "P_YS_FED_IMP_IOT0000008072": "Ningqiang County",
        "P_YS_FED_IMP_IOT0000008073": "Honghe County",
        "P_YS_FED_IMP_IOT0000008070": "Xihu District",
        "P_YS_OA_XTWENKU_0000035509": "File Name",
        "P_YS_FED_IMP_IOT0000010475": "Huangpu District",
        "P_YS_FED_IMP_IOT0000010476": "Yuxian",
        "P_YS_FED_IMP_IOT0000010471": "Puyang County",
        "P_YS_FED_IMP_IOT0000010472": "Sifang District",
        "P_YS_FED_IMP_IOT0000010477": "Mancheng County",
        "P_YS_FED_IMP_IOT0000010479": "Shanshan County",
        "P_YS_PF_SOCD-E_0000277718": "Dominican Republic",
        "P_YS_FED_IMP_IOT0000009396": "Shangcai County",
        "P_YS_FED_IMP_IOT0000009397": "Linwu County",
        "P_YS_SD_UDHWN_0000121240": "Total:",
        "P_YS_FED_IMP_IOT0000009395": "Tanghai County",
        "P_YS_FED_FW_1570959055392342020": "Service error. Please try again later",
        "P_YS_PF_SOCD_0000089169": "Luxembourg",
        "P_YS_FED_IMP_IOT0000008069": "Miyi County",
        "P_YS_PF_SOCD_0000089167": "Pakistan",
        "P_YS_FED_IMP_IOT0000008067": "Wuxue",
        "P_YS_FED_IMP_IOT0000009398": "Nandan County",
        "P_YS_FED_IMP_IOT0000008068": "Longmen County",
        "P_YS_PF_SOCD_0000089155": "Barbados",
        "P_YS_PF_SOCD_0000089152": "Libya",
        "P_YS_PF_SOCD_0000089153": "Syria",
        "P_YS_PF_SOCD_0000089150": "Somalia",
        "P_YS_FED_IMP_IOT0000008061": "Wuyuan County",
        "P_YS_FED_IMP_IOT0000009392": "Huanglong County",
        "P_YS_PF_SOCD_0000089151": "Egypt",
        "P_YS_FED_IMP_IOT0000009393": "Shenzhen",
        "P_YS_FED_IMP_IOT0000008060": "Liaoyang County",
        "P_YS_FED_IMP_IOT0000009391": "Guangnan County",
        "P_YS_FED_FW_1587381824922845184": "已勾选“移动端展现”，请设置移动端布局？",
        "P_YS_FED_IMP_IOT0000010480": "Jiangbei District",
        "P_YS_FED_IMP_IOT0000010481": "Yingshang County",
        "P_YS_FED_FW_0000154455": "navbar; click on the left to return icon callback",
        "P_YS_FED_IMP_IOT0000009385": "Bazhou",
        "P_YS_FED_FW_0000154456": "Card Page",
        "P_YS_FED_FW_0000154453": "No data displayed",
        "P_YS_FED_IMP_IOT0000009383": "Qingxu County",
        "P_YS_FED_FW_0000154454": "List Height",
        "P_YS_FED_IMP_IOT0000008053": "Wuyiling District",
        "P_YS_PF_SOCD_0000089158": "Albania",
        "P_YS_FED_IMP_IOT0000008058": "Shizhu Tujia Autonomous County",
        "P_YS_FED_IMP_IOT0000009389": "Zhengxiang District",
        "P_YS_PF_SOCD_0000089159": "Mongolia",
        "P_YS_FED_IMP_IOT0000008059": "Yiliang County",
        "P_YS_FED_FW_0001215524": "]的",
        "P_YS_PF_SOCD_0000089156": "Ireland",
        "P_YS_FED_FW_0000154457": "Content Area Height",
        "P_YS_PF_SOCD_0000089187": "Mexico",
        "P_YS_FED_FW_1563508103188054030": "%c check前后[childrenField][index][cellName]=>",
        "P_YS_PF_SOCD_0000089188": "Guatemala",
        "P_YS_PF_SOCD_0000089185": "Israel",
        "P_YS_FED_FW_1462036124903407616": "Click here to edit long content.",
        "P_YS_PF_SOCD_0000089183": "Tonga",
        "P_YS_PF_SOCD_0000089184": "Djibouti",
        "P_YS_FED_FW_1563508103188054033": "%c 当前操作列和check触发源是同一个字段，触发target为",
        "P_YS_PF_SOCD_0000089181": "Angola",
        "P_YS_OA_XTWENKU_0000035608": "Fuzzy Search",
        "P_YS_FED_FW_1563508103188054036": "的公式",
        "P_YS_PF_SOCD_0000089182": "Cook Islands",
        "P_YS_FED_IMP_IOT0000010375": "Fan County",
        "P_YS_FED_IMP_IOT0000010376": "Guta District",
        "P_YS_FED_IMP_IOT0000010372": "Wangkui County",
        "P_YS_ZNBZ_BZBX-FE_0001141299": "Loan Contract",
        "P_YS_FED_IMP_IOT0000010378": "Hotan",
        "P_YS_FED_FW_1563508103188054027": "字段都无值，不触发target为",
        "P_YS_FED_IMP_IOT0000008165": "Delete",
        "P_YS_FED_IMP_IOT0000009496": "Tokto County",
        "P_YS_FED_IMP_IOT0000008162": "Confirm to delete?",
        "P_YS_FED_IMP_IOT0000008163": "Taoyuan County",
        "P_YS_FED_IMP_IOT0000008168": "Lianshan Zhuang and Yao Autonomous County",
        "P_YS_PF_SOCD_0000089189": "Greece",
        "P_YS_FED_IMP_IOT0000009497": "Hefeng County",
        "P_YS_PF_SOCD_0000089177": "Liberia",
        "P_YS_PF_SOCD_0000089174": "Nepal",
        "P_YS_PF_SOCD_0000089175": "Romania",
        "P_YS_FED_FW_1563508103188054042": "%c 公式中没有因子，触发target为",
        "P_YS_PF_SOCD_0000089172": "Costa Rica",
        "P_YS_FED_IMP_IOT0000008160": "Cuiluan District",
        "P_YS_PF_SOCD_0000089173": "French Guyana",
        "P_YS_FED_IMP_IOT0000008161": "Tianzhen County",
        "P_YS_FED_IMP_IOT0000009492": "Funan County",
        "P_YS_PF_SOCD_0000089170": "Cuba",
        "P_YS_PF_SOCD_0000089171": "Lebanon",
        "P_YS_SD_URETAILF_0001131470": "Please enter search contents",
        "P_YS_FED_IMP_IOT0000009490": "Ning County",
        "P_YS_FED_IMP_IOT0000010385": "Jinxiang County",
        "P_YS_SD_UDHBI_0000082840": "Data exception",
        "P_YS_FED_IMP_IOT0000010383": "Shiqu County",
        "P_YS_FED_FW_0001318710": ")项",
        "P_YS_PF_GZTTMP_0000079419": "Previous",
        "P_YS_FED_FW_0001318704": "<%=count%> orders",
        "P_YS_FED_IMP_IOT0000008153": "Sanyuan District",
        "P_YS_FED_IMP_IOT0000009484": "Zengcheng",
        "P_YS_FED_IMP_IOT0000008154": "Renshou County",
        "P_YS_FED_IMP_IOT0000009485": "Seda County",
        "P_YS_FED_IMP_IOT0000008151": "Bailang County",
        "P_YS_FED_IMP_IOT0000009482": "Anfu County",
        "P_YS_FED_IMP_IOT0000009483": "Nanle County",
        "P_YS_FED_FW_1563508103188054039": "%c 字段触发check，check前值为:",
        "P_YS_FED_IMP_IOT0000008157": "Mining area",
        "P_YS_OA_XTWENKU_0000035613": "Uploading...",
        "P_YS_FED_IMP_IOT0000009489": "Gloss county",
        "P_YS_PF_SOCD_0000089178": "Guinea",
        "P_YS_FED_IMP_IOT0000009486": "Dingtao County",
        "P_YS_FED_IMP_IOT0000008156": "Dongfang",
        "P_YS_FED_IMP_IOT0000009487": "Jianyang",
        "P_YS_FED_IMP_IOT0000010391": "Huojia County",
        "P_YS_FED_IMP_IOT0000009480": "Yongding County",
        "P_YS_FED_IMP_IOT0000008150": "Daying County",
        "P_YS_FED_IMP_IOT0000010396": "Shizhong District",
        "P_YS_FED_IMP_IOT0000010397": "Yifeng County",
        "P_YS_FED_IMP_IOT0000010392": "Qiyang County",
        "P_YS_FED_IMP_IOT0000010393": "Zhoucun District",
        "P_YS_FED_FW_0000021498": "Stacked Bar Chart Example",
        "P_YS_FI_YYFI-UI_0000161175": "Start Discussion",
        "P_YS_FED_FW_0001197167": "Edit by Scanning Code",
        "P_YS_FED_FW_0000021499": "Reset",
        "P_YS_FED_IMP_IOT0000008143": "Weng'an County",
        "P_YS_FED_FW_0000021496": "Linfen",
        "P_YS_FED_FW_0000021497": "Yueyang",
        "P_YS_FED_IMP_IOT0000008141": "Gangzha District",
        "P_YS_FED_IMP_IOT0000008146": "Gong County",
        "P_YS_FED_IMP_IOT0000008144": "Chuxiong",
        "P_YS_PF_SOCD_0000089198": "Bulgaria",
        "P_YS_PF_SOCD_0000089199": "Hungary",
        "P_YS_FED_FW_1577614631207698483": "Please enter URL",
        "P_YS_FED_FW_1563508103188054021": "%c 公式中表体字段公式等于表头，触发target为",
        "P_YS_PF_SOCD_0000089194": "Armenia",
        "P_YS_FED_FW_1577614631207698480": "Please enter link text",
        "P_YS_PF_SOCD_0000089195": "Czech Republic",
        "P_YS_FED_FW_1563508103188054024": "字段值不一样，触发target为",
        "P_YS_PF_SOCD_0000089191": "Afghanistan",
        "P_YS_ZNBZ_BZBX-FE_0001141291": "Contract Approval",
        "P_YS_ZNBZ_BZBX-FE_0001141295": "Collateral/Pledge Contract",
        "P_YS_FED_IMP_IOT0000008137": "Wuchuan County",
        "P_YS_FED_IMP_IOT0000008138": "Yongren County",
        "P_YS_FED_IMP_IOT0000009469": "Turks County",
        "P_YS_FED_FW_1563508103188054018": "字段值一样，不触发target为",
        "P_YS_FED_IMP_IOT0000008130": "Shuangjiang Lahu, Wa, Bulang and Dai Autonomous County",
        "P_YS_FED_IMP_IOT0000009461": "Chikan District",
        "P_YS_FED_FW_1576845857814216711": "Business phase does not end, printing is not allowed!",
        "P_YS_FED_IMP_IOT0000009464": "Xianyou County",
        "P_YS_SCM_STOCK_0001145534": "Edit Line",
        "P_YS_FED_IMP_IOT0000008128": "Ruijin",
        "P_YS_FED_IMP_IOT0000009459": "Pianguan County",
        "P_YS_FED_IMP_IOT0000008129": "Tonglu County",
        "P_YS_FED_EXAMP_0000020397": "Name",
        "P_YS_FED_EXAMP_0000020396": "Product in the package not entered completely. Cannot use voucher",
        "P_YS_FED_EXAMP_0000020399": "Please continue to pay",
        "P_YS_FED_EXAMP_0000020398": "A/R Amt:",
        "P_YS_FED_IMP_IOT0000009451": "Weichang Manchu and Mongolian Autonomous County",
        "P_YS_FED_IMP_IOT0000008121": "Zhuxi County",
        "P_YS_FED_IMP_IOT0000009452": "Xiayi County",
        "P_YS_FED_IMP_IOT0000009455": "Jindong District",
        "P_YS_FED_IMP_IOT0000009456": "Laoshan District",
        "P_YS_FED_IMP_IOT0000009453": "Zhushan County",
        "P_YS_FED_IMP_IOT0000008123": "Banan District",
        "P_YS_FED_IMP_IOT0000008117": "Jinshantun District",
        "P_YS_FED_IMP_IOT0000009448": "East Lake District",
        "P_YS_FED_FW_0001084598": "cStyle parsing error:",
        "P_YS_FED_IMP_IOT0000009446": "Shunping County",
        "P_YS_FED_IMP_IOT0000009447": "Hanshan District",
        "P_YS_FED_IMP_IOT0000008119": "Point Military District",
        "P_YS_FED_IMP_IOT0000008113": "Jinping Miao, Yao and Dai Autonomous County",
        "P_YS_FED_IMP_IOT0000009442": "Yuzhou District",
        "P_YS_FED_IMP_IOT0000008112": "Beining",
        "P_YS_FI_FIEFA-FE_1498230827983044620": "Watch Video",
        "P_YS_FED_FW_0001083281": "Render error. You can view Error Info from the console.",
        "P_YS_FED_IMP_IOT0000008106": "Jingyan County",
        "P_YS_FED_IMP_IOT0000009437": "Jiashan County",
        "P_YS_FED_IMP_IOT0000008104": "Shifeng District",
        "P_YS_FED_IMP_IOT0000009435": "Nanqiao District",
        "P_YS_FED_IMP_IOT0000009436": "Gaotang County",
        "P_YS_FED_IMP_IOT0000008108": "Xiaodian District",
        "P_YS_FI_AP_0000072097": "Voucher Date",
        "P_YS_FED_IMP_IOT0000009430": "Urad Front Banner",
        "P_YS_FED_IMP_IOT0000008102": "Xiaoshan Strict",
        "P_YS_FED_IMP_IOT0000008103": "Wulan County",
        "P_YS_FED_IMP_IOT0000009431": "Uda District",
        "P_YS_FED_IMP_IOT0000008101": "Hongwei District",
        "P_YS_FED_FW_0001260928": "列表共",
        "P_YS_FED_IMP_IOT0000009427": "Dongming County",
        "P_YS_FED_FW_0001260926": "Enumeration: value object configuration. For example, the gender field has a fixed value configuration and selection range, including male and female",
        "P_YS_FED_FW_0001260927": "Reference: used to confirm the definition of the reference relationship. For example: the management Org field in the purchase order indicates that the selection range of this field is the content of the corresponding Org file (including the data in enabled status that already exists in the system, which needs to be searched and filled in the system)",
        "P_YS_FED_IMP_IOT0000009429": "Liangyuan",
        "P_YS_FED_IMP_IOT0000009423": "Linyi County",
        "P_YS_FED_FW_1495277402289340422": "Saved successfully. No changes were made",
        "P_YS_FED_IMP_IOT0000009421": "Huarong County",
        "P_YS_FED_FW_1581884103568916483": "Collaboration Assistant",
        "P_YS_PF_PROCENTER_0000023382": "Bank Card",
        "P_YS_IMP_PCC-UI_0001116011": "Card Header",
        "P_YS_FED_FW_0000021440": "Jincheng",
        "P_YS_FED_EXAMP_0000020360": "Funds Coll./Pmt",
        "P_YS_FED_EXAMP_0000020362": "Please select the SKU value",
        "P_YS_FED_EXAMP_0000020361": "The network is currently unavailable. Cannot sell product subject to SN control",
        "P_YS_FED_FW_0001312565": "The column configuration is incorrect, which may lead to errors in the printed contents",
        "P_YS_FED_EXAMP_0000020357": "Error in the requested service address",
        "P_YS_FED_IMP_IOT0000009415": "Jingyang District",
        "P_YS_FED_FW_1423240990981357568": "This is the last entry. There's no more data",
        "P_YS_FED_IMP_IOT0000009416": "Ma'anshan",
        "P_YS_FED_EXAMP_0000020356": "The card No. has been entered. Please do not enter it again",
        "P_YS_FED_FW_0000021438": "Add Picture",
        "P_YS_FED_EXAMP_0000020359": "Current operator doesn't have the permission to delete lines. Use the line deletion permission of other operators?",
        "P_YS_FED_IMP_IOT0000009413": "Jizhou District",
        "P_YS_FED_FW_0000021439": "----------- Clicking event  Select area  params.name =",
        "P_YS_FED_EXAMP_0000020358": "Reason Code",
        "P_YS_FED_IMP_IOT0000009414": "Changyang Tujia Autonomous County",
        "P_YS_FED_EXAMP_0000020353": "Transfer/To be Issued",
        "P_YS_FED_IMP_IOT0000009419": "Tangwanghe District",
        "P_YS_FED_EXAMP_0000020352": "Cannot modify Qty when selling prepaid cards",
        "P_YS_FED_EXAMP_0000020355": "On-site Discount",
        "P_YS_FED_IMP_IOT0000009417": "Chengzhong District",
        "P_YS_FED_EXAMP_0000020354": "Test succeeded",
        "P_YS_FED_FW_0000021432": "After truncation:",
        "P_YS_FED_FW_0000021433": "Regional Manager Template",
        "P_YS_SD_UDHMC_0000051023": "÷",
        "P_YS_FED_FW_0000021430": "Invalid entry",
        "P_YS_FED_FW_0000021431": "Ranking List Config. Info - eChartSetting",
        "P_YS_FED_FW_0000021436": "Yunnan",
        "P_YS_FED_FW_0000021437": "End Date",
        "P_YS_FED_FW_0000021434": "Guangxi",
        "P_YS_FED_FW_0000021435": "Zhaoqing",
        "P_YS_FED_FW_0000021450": "Product Details",
        "P_YS_FED_FW_0000021451": "(",
        "P_YS_FED_FW_1555410955943804936": "The service is wrong, don't worry, try refreshing ~",
        "P_YS_FED_EXAMP_0000020371": "]. Please check",
        "P_YS_FED_EXAMP_0000020370": " specifications)",
        "P_YS_FED_EXAMP_0000020373": "Product Spec.",
        "P_YS_FED_EXAMP_0000020372": "Failed to refund via POS terminal",
        "P_YS_FED_FW_1502799547894071302": "The data is invalid. Please reselect data",
        "P_YS_FED_EXAMP_0000020368": "Prepaid card not enabled for the hardware adaptation scheme",
        "P_YS_FED_IMP_IOT0000009404": "Panshan County",
        "P_YS_FED_IMP_IOT0000009405": "Taihu County",
        "P_YS_FED_FW_0000021449": "Suzhou",
        "P_YS_FED_EXAMP_0000020369": "Verification succeeded",
        "P_YS_FED_IMP_IOT0000009403": "Fengtai County",
        "P_YS_FED_EXAMP_0000020363": "Do you need a kitchen printer?",
        "P_YS_FED_IMP_IOT0000009409": "Longhui County",
        "P_YS_FED_FW_1452018122265460736": "Reason for Export Error",
        "P_YS_FED_EXAMP_0000020366": "SNs in the numbered product lines are required. Please check",
        "P_YS_FED_IMP_IOT0000009406": "Fuyang",
        "P_YS_FED_EXAMP_0000020365": "Off-shelves in Mall",
        "P_YS_FED_IMP_IOT0000009407": "Uratzhongqi",
        "P_YS_FED_FW_0000021443": "Jinan",
        "P_YS_FED_FW_0000021444": "Picture",
        "P_YS_FED_FW_0000021441": "Baicheng",
        "P_YS_FED_FW_0000021442": "Daqing",
        "P_YS_OA_XTLCZX_0000030897": "Added to Favorites successfully",
        "P_YS_FED_FW_0000021447": "Bazhong",
        "P_YS_FED_FW_0000021448": "Tongren",
        "P_YS_FED_FW_0000021445": "Xinyu",
        "P_YS_FED_FW_0000021446": "Collection completed",
        "P_YS_FED_FW_0000110058": "Cannot get editrowmodel? 2D from cache for gridmodel when setting editrowmodel for intersection",
        "P_YS_FED_EXAMP_0000020382": "Decimal Digits of Rate",
        "P_YS_FED_EXAMP_0000020381": "Orig. Order Return",
        "P_YS_FED_EXAMP_0000020384": "Payment failed. Payment made via Sandpay needs to be canceled. Cancel it online?",
        "P_YS_FED_EXAMP_0000020383": "Please enter",
        "P_YS_FED_EXAMP_0000020380": "Balance",
        "P_YS_FED_FW_0000021418": "Baiyin",
        "P_YS_FED_EXAMP_0000020379": ") remodeling description is required",
        "P_YS_FED_FW_0000021419": "Deleted successfully",
        "P_YS_FED_EXAMP_0000020378": "On-site discount cannot be executed for child product",
        "P_YS_FED_FW_0000021416": "Line Chart Config. Info - eChartSetting",
        "P_YS_FED_FW_0000021417": "Nanping",
        "P_YS_FED_EXAMP_0000020375": "Order Canceled",
        "P_YS_FED_EXAMP_0000020374": "Incorrect rounding Amt. Please check. Predicted rounding Amt:",
        "P_YS_FED_EXAMP_0000020377": "Equal",
        "P_YS_FED_EXAMP_0000020376": "Pmt Amt is not equal",
        "P_YS_FED_FW_0001527931": "Incl. Siblings",
        "P_YS_FED_FW_0000021410": "eChartCommon  Update the filter criteria to remove the null values  before param =",
        "P_YS_FED_FW_0000021411": "Suihua",
        "P_YS_FED_FW_1431347776103383040": "确认要删除",
        "P_YS_FED_FW_0000021414": "Haidong Prefecture",
        "P_YS_FED_FW_1431347776103383043": "嘛",
        "P_YS_FED_FW_0000021415": "Mobile Report  isVertical =",
        "P_YS_FED_FW_0000021412": "Ranking",
        "P_YS_FED_FW_0000021413": "Meizhou",
        "P_YS_FED_EXAMP_0000020393": "Product in the package not selected",
        "P_YS_FED_EXAMP_0000020392": "Made-on-site",
        "P_YS_FED_EXAMP_0000020395": "Search",
        "P_YS_FED_EXAMP_0000020394": "All",
        "P_YS_FED_EXAMP_0000020391": "Loading...",
        "P_YS_FED_FW_0000021429": "Hohhot",
        "P_YS_FED_EXAMP_0000020389": "Top-up or consumption record exists. Cannot return card",
        "P_YS_FED_FW_0000021427": "The chart cannot be displayed properly. In the configuration Info returned from report/getGroupSetting (the detailed settings of report group scheme needs to obtained to display), json.data.isCrossTable == false && (json.data.displayStyle == 2 || json.data.displayStyle == 3)",
        "P_YS_FED_FW_0000021428": "Lhasa",
        "P_YS_FED_EXAMP_0000020386": "Promotion activity has been executed. Cannot execute point deduction",
        "P_YS_FED_EXAMP_0000020385": "Cancel",
        "P_YS_FED_EXAMP_0000020388": "(Myself)",
        "P_YS_FED_EXAMP_0000020387": "Failed to query product",
        "P_YS_FED_FW_0000021421": "Jingdezhen",
        "P_YS_FED_FW_0000021422": "Bayingol Mongolian Autonomous Prefecture",
        "P_YS_FED_FW_0000110072": "All Info - 1-D Table Data  getRows  length =",
        "P_YS_FED_FW_0000110073": "All Info - 2-D Table Data  getRows  length =",
        "P_YS_FED_FW_0000021420": "Handan",
        "P_YS_FED_FW_0000021425": "Shannan Prefecture",
        "P_YS_FED_FW_0000021426": "Hanzhong",
        "P_YS_FED_FW_0000021423": "Vertical",
        "P_YS_FED_FW_0000021424": "Board Config. Info - Module Config. - Date/Time",
        "P_YS_FED_FW_0000021480": "Yulin",
        "P_YS_FED_FW_0001515920": "三列布局右",
        "P_YS_FED_FW_0001515921": "头像上传",
        "P_YS_FED_FW_0001515922": "按单表头",
        "P_YS_FED_FW_0000021483": "Puyang",
        "P_YS_FED_FW_0000021484": "Bubble Values",
        "P_YS_FED_FW_0000021481": " pieces not saved successfully",
        "P_YS_FED_FW_0000021482": "Basic Info",
        "P_YS_FED_EXAMP_0000020313": "Please select time again",
        "P_YS_FED_EXAMP_0000020312": "rowkey under the corresponding returned product ID",
        "P_YS_FED_EXAMP_0000020315": "Failed to generate card/voucher No. range. Please check",
        "P_YS_FED_EXAMP_0000020314": "Sales date cannot be later than the current date",
        "P_YS_FED_EXAMP_0000020311": "; Room Type:",
        "P_YS_FED_EXAMP_0000020310": "Recognized product not matched in the product file",
        "P_YS_FED_FW_0000021476": "Shanxi",
        "P_YS_FED_FW_0001515916": "卡片面板",
        "P_YS_FED_FW_0000021477": "Baishan",
        "P_YS_FED_FW_0001515917": "固定按钮",
        "P_YS_FED_FW_0000021474": "Shaoguan",
        "P_YS_FED_FW_0001515918": "列表拓展项",
        "P_YS_FED_FW_0000021475": "Select Date",
        "P_YS_FED_FW_0001515919": "头部导航",
        "P_YS_FED_EXAMP_0000020317": "The starting card/voucher No. and ending card/voucher No. must be entered at the same time",
        "P_YS_FED_FW_0001515912": "试图切换",
        "P_YS_FED_EXAMP_0000020316": "Prepaid card business has not been enabled for the store",
        "P_YS_FED_FW_0001515913": "html片段",
        "P_YS_FED_FW_0000021478": "Shuangyashan",
        "P_YS_FED_EXAMP_0000020319": "Please enter your password",
        "P_YS_FED_FW_0001515914": "三列布局中",
        "P_YS_FED_FW_0000021479": "Huangshan",
        "P_YS_OA_XTLCZX_0000030846": "Initiate Collaboration",
        "P_YS_FED_EXAMP_0000020318": "No.",
        "P_YS_FED_FW_0001515915": "高德地图",
        "P_YS_FED_FW_0000021490": "Sanmenxia",
        "P_YS_FED_FW_0000021491": "Chengdu",
        "P_YS_FED_FW_0001515910": "metaui-mobile组件库",
        "P_YS_FED_FW_0001515911": "ys按钮",
        "P_YS_FED_FW_0000021494": "Fujian",
        "P_YS_FED_FW_0000021495": "Shenzhen",
        "P_YS_FED_FW_0000021492": "IDB_saveData stored successfully. Transaction failed",
        "P_YS_SD_SDMBF_0000141915": "Today",
        "P_YS_FED_FW_0000021493": "Hulunbeier",
        "P_YS_FED_EXAMP_0000020324": "Expand Remaining",
        "P_YS_PF_YHTTNT-FE_0001045613": "Line",
        "P_YS_FED_EXAMP_0000020323": "Product promotion/flash sale has been executed. Cannot enter members",
        "P_YS_FED_EXAMP_0000020326": "Zhongguancun Store",
        "P_YS_FED_EXAMP_0000020325": "Wholesale Price",
        "P_YS_FED_EXAMP_0000020320": "Tongma Store",
        "P_YS_FED_FW_0001515909": "Picture Display",
        "P_YS_FED_EXAMP_0000020322": "Permission Mgmt Dimension",
        "P_YS_FED_EXAMP_0000020321": "Sell Card",
        "P_YS_FED_FW_0000021487": "Leshan",
        "P_YS_FED_FW_0000021488": "Guang'an",
        "P_YS_FED_FW_0001515906": "ys固定按钮",
        "P_YS_FED_FW_0000021485": "Fuxin",
        "P_YS_FED_FW_0001515907": "卡片头部组",
        "P_YS_FED_FW_0000021486": "Nanjing",
        "P_YS_FED_FW_0001515908": "扫码子表",
        "P_YS_FED_EXAMP_0000020328": "Status",
        "P_YS_FED_EXAMP_0000020327": "Promotion activity has been executed. Cannot execute on-site discount",
        "P_YS_FED_FW_0000021489": "Zhenjiang",
        "P_YS_FED_FW_1587986667977310214": "获取推拉按钮的信息失败",
        "P_YS_FED_EXAMP_0000020329": "WeChat callback failed: [interface]",
        "P_YS_FED_FW_0001515941": "ys主按钮",
        "P_YS_FED_FW_0001515942": "三列布局",
        "P_YS_FED_FW_0001078769": "Field metadata configuration is incorrect.",
        "P_YS_FED_FW_0001515943": "附件按钮",
        "P_YS_FED_FW_0000021461": "Changji Hui Autonomous Prefecture",
        "P_YS_FED_FW_0000021462": " Up to: ",
        "P_YS_FED_FW_0000021460": "Qiannan Buyi and Miao Autonomous Prefecture",
        "P_YS_FED_FW_0001515940": "列表表头",
        "P_YS_FED_EXAMP_0000020340": "Salesperson in the current line",
        "P_YS_FED_EXAMP_0000020334": "Select",
        "P_YS_FED_EXAMP_0000020337": "Member Wallet Top-up",
        "P_YS_FED_EXAMP_0000020336": "For the Qty field, please enter a number less than 0",
        "P_YS_FED_EXAMP_0000020331": "No product address",
        "P_YS_FED_FW_1505489468750561282": "Length Limit",
        "P_YS_FED_EXAMP_0000020330": "), it cannot be less than the floor of current operator's labor cost discount rate (",
        "P_YS_FED_EXAMP_0000020333": "Product in the product line cannot be returned",
        "P_YS_FED_EXAMP_0000020332": "Current discount rate is (",
        "P_YS_FED_FW_0000021454": "Zibo",
        "P_YS_FED_FW_0001515938": "扫码区域",
        "P_YS_FED_FW_0000021455": "No data in the detail. Cannot save",
        "P_YS_OA_XTLCZX_0000030866": "Initiate Collaboration Process",
        "P_YS_FED_FW_0001515939": "卡片面板项",
        "P_YS_FED_FW_0000021452": ")",
        "P_YS_FED_FW_0000021453": "Suqian",
        "P_YS_FED_FW_0000021458": "Yancheng",
        "P_YS_FED_EXAMP_0000020339": "The corresponding replacement line of the current return line exists. Cannot delete",
        "P_YS_FED_FW_0001515934": "ys子表页签",
        "P_YS_FED_FW_0000021459": "Fuyang",
        "P_YS_FED_EXAMP_0000020338": "Child product are not allowed to be returned",
        "P_YS_FED_FW_0001515935": "ys附件按钮",
        "P_YS_FED_FW_0000021456": "Board Config. Info - Module Config. - My Favorites",
        "P_YS_FED_FW_0001515936": "日历面板",
        "P_YS_FED_FW_0000021457": "China Petroleum First Construction Corporation",
        "P_YS_FED_FW_0001515937": "按单子表",
        "P_YS_FED_FW_0001515930": "纯文字项",
        "P_YS_FED_FW_0001515931": "日期下拉分组",
        "P_YS_FED_FW_0001515932": "ys卡片头部",
        "P_YS_FED_FW_0001515933": "链接(拨打电话)",
        "P_YS_FED_FW_0000021472": "Template C",
        "P_YS_FED_FW_0000021473": "Pieces",
        "P_YS_FED_FW_0000021470": "Jingmen",
        "P_YS_FED_FW_0000021471": "Hotan Prefecture",
        "P_YS_FED_EXAMP_0000020351": "Cash Sale Top-up",
        "P_YS_FED_EXAMP_0000020350": "Change",
        "P_YS_FED_EXAMP_0000020345": "Please select",
        "P_YS_FED_EXAMP_0000020348": "Effective To is required in the detail lines with Validity Period Mgmt enabled",
        "P_YS_FED_EXAMP_0000020347": "Network is unavailable. The password must be the same as that used during last login",
        "P_YS_OA_XTSPZX_0000034785": "OK",
        "P_YS_FED_EXAMP_0000020344": "No",
        "P_YS_FED_EXAMP_0000020343": " ",
        "P_YS_FED_FW_0000021465": "Template A",
        "P_YS_FED_FW_0001515927": "身份证上传",
        "P_YS_FED_FW_0000021466": "Template D",
        "P_YS_FED_FW_0001515928": "三列布局左",
        "P_YS_FED_FW_0000021463": "Please enter product barcode",
        "P_YS_SD_UDHBI_0000032531": "Order",
        "P_YS_FED_FW_0001515929": "页面区域",
        "P_YS_FED_FW_0000021464": "Fangchenggang",
        "P_YS_FED_FW_0000021469": "Template B",
        "P_YS_FED_FW_0001515923": "ys图片展示",
        "P_YS_FED_EXAMP_0000020349": "Select customer",
        "P_YS_FED_FW_0001515924": "多页签切换",
        "P_YS_FED_FW_0000021467": "Template E",
        "P_YS_FED_FW_0001515925": "列表参照",
        "P_YS_FED_FW_0000021468": "Gannan Tibetan Autonomous Prefecture",
        "P_YS_FED_FW_0001515926": "扫码框",
        "P_YS_FED_FW_1478297498195329033": "Failed to get list of data templates",
        "P_YS_FED_FW_1478297498195329030": "No template data yet~",
        "P_YS_FED_UIMG_0000082816": "It's read-only and cannot be deleted",
        "P_YS_ZNBZ_BZBX-MFE_0001618094": "Unsaved",
        "P_YS_OA_YBMOB_0000036918": "Start",
        "P_YS_FED_FW_0001207667": "Doc Assistant",
        "P_YS_FED_IMP_IOT0000005795": "Maqu County",
        "P_YS_FED_IMP_IOT0000005794": "Dongzhou District",
        "P_YS_FED_IMP_IOT0000005797": "Yaohai District",
        "P_YS_FED_FW_0001309650": "(<%placeholder%> selected)",
        "P_YS_FED_IMP_IOT0000005793": "Decheng District",
        "P_YS_FED_IMP_IOT0000005792": "Xiang'an District",
        "P_YS_IMP_DFM-UI_0001095230": "Container",
        "P_YS_OA_app_xtywlj_0000037585": "Expression",
        "P_YS_FED_IMP_IOT0000005789": "Ningyang County",
        "P_YS_FED_IMP_IOT0000005782": "Liangzihu District",
        "P_YS_FED_FW_0001388453": "Wrap in Text Input Box",
        "P_YS_FED_IMP_IOT0000005775": "Beichuan Qiang Autonomous County",
        "P_YS_FED_IMP_IOT0000005777": "Yuanjiang Hani, Yi and Dai Autonomous County",
        "P_YS_FED_IMP_IOT0000005776": "Leye County",
        "P_YS_FED_IMP_IOT0000005779": "Meilan District",
        "P_YS_FED_FW_0001045499": "18",
        "P_YS_FED_FW_0001045497": "17",
        "P_YS_FED_FW_0001045498": "15",
        "P_YS_FED_FW_0001237484": "There is an item with verification failed in the order. Click to view the details",
        "P_YS_FED_IMP_IOT0000005769": "Li County",
        "P_YS_SCM_PU_0000028333": "Please select warehouse first",
        "P_YS_OA_XTWENKU_0000035495": "Modify Time",
        "P_YS_FED_IMP_IOT0000005765": "Xuecheng District",
        "P_YS_PF_GZTORG_0000035405": "Modified On",
        "P_YS_FED_IMP_IOT0000005750": "Chen Barhu",
        "P_YS_FED_IMP_IOT0000005753": "Huozhou",
        "P_YS_FED_IMP_IOT0000011606": "Xingzi County",
        "P_YS_FED_IMP_IOT0000005752": "Banma County",
        "P_YS_FED_IMP_IOT0000011605": "Tumen",
        "P_YS_FED_IMP_IOT0000005755": "Muslim District",
        "P_YS_FED_IMP_IOT0000005757": "Shouning County",
        "P_YS_FED_IMP_IOT0000011602": "Zhen'an District",
        "P_YS_FED_IMP_IOT0000005756": "Ganzhou District",
        "P_YS_FED_IMP_IOT0000011609": "Suyu District",
        "P_YS_FED_FW_0001045496": "13",
        "P_YS_FED_FW_1442544300594823168": "吗 ?",
        "P_YS_FED_IMP_IOT0000005749": "Bama Yao Autonomous County",
        "P_YS_FED_IMP_IOT0000005740": "Shulan",
        "P_YS_FED_IMP_IOT0000011615": "Fugong County",
        "P_YS_FED_IMP_IOT0000005742": "Yuping Dong Autonomous County",
        "P_YS_FED_IMP_IOT0000011616": "Xiangfen County",
        "P_YS_FED_FW_1497426122910466048": "Exception in loading by referencing extension scripts",
        "P_YS_FED_IMP_IOT0000011610": "Guiding County",
        "P_YS_FED_IMP_IOT0000011613": "Dong'a County",
        "P_YS_PF_WORKBENCH-FE_0001133350": "Yonyou Group",
        "P_YS_FED_FW_0000022095": "ю",
        "P_YS_FED_FW_0000022096": "я",
        "P_YS_FED_FW_0000022093": "ь",
        "P_YS_FED_FW_0000022094": "э",
        "P_YS_FED_FW_0000022099": "Less than",
        "P_YS_FED_FW_0000022097": "Replace",
        "P_YS_FED_FW_0000022098": "Hot zone display picture  Cannot find all the hot zone configuration fields in CStyle  codeField stateField captionFields mapConfigField",
        "P_YS_FED_FW_1520473424212262918": "Card Display",
        "P_YS_FED_IMP_IOT0000005737": "Anhua County",
        "P_YS_FED_IMP_IOT0000005739": "Dayi County",
        "P_YS_FED_IMP_IOT0000011620": "Pengyang County",
        "P_YS_FED_FW_0000022091": "ы",
        "P_YS_FED_FW_0000022092": "Please enter the correct email",
        "P_YS_FED_FW_0000022090": "Template",
        "P_YS_FED_UCFBASEDOC_0000024807": "Password Login",
        "P_YS_MF_PO-FE_0001156335": "Cancel?",
        "P_YS_FED_IMP_IOT0000005733": "Conghua",
        "P_YS_FED_IMP_IOT0000005732": "Si County",
        "YS_YC_PORTAL-FE_1122935812": "Created By:",
        "P_YS_FED_IMP_IOT0000005728": "Atushi",
        "P_YS_FED_IMP_IOT0000010305": "Yongan",
        "P_YS_FED_IMP_IOT0000011637": "Hangu District",
        "P_YS_FED_IMP_IOT0000011636": "Gaomi City",
        "P_YS_FED_IMP_IOT0000005720": "Wensheng District",
        "P_YS_FED_IMP_IOT0000011639": "Pingchang County",
        "P_YS_FED_IMP_IOT0000011638": "Qingtongxia",
        "P_YS_FED_IMP_IOT0000005721": "Lianjiang County",
        "P_YS_FED_IMP_IOT0000011632": "Xianju County",
        "P_YS_FED_FW_0000096305": "Picture must be less than",
        "P_YS_FED_FW_0000096304": " M; JPG, PNG, BMP and GIF formats supported",
        "P_YS_FED_FW_0000096303": "(The size of each picture cannot exceed ",
        "P_YS_FED_FW_0000096302": "(The size of each attachment cannot exceed ",
        "P_YS_FED_FW_0000096300": "Confirm to delete the attachment?",
        "P_YS_FED_IMP_IOT0000010309": "Zhijiang",
        "P_YS_PF_GZTORG_0000035435": "Purchasing Org",
        "P_YS_FED_FW_0000022073": "о",
        "P_YS_FED_FW_0001077912": "Condition Config Error",
        "P_YS_FED_FW_0000022074": "п",
        "P_YS_FED_FW_0000022071": "No attachment",
        "P_YS_FED_FW_0000022072": "н",
        "P_YS_FED_FW_0000022077": "с",
        "P_YS_FED_FW_0000022078": "т",
        "P_YS_FED_FW_0000022075": "р",
        "P_YS_FED_FW_0000022076": "Basic Line Operations",
        "P_YS_FED_IMP_IOT0000011640": "Diecai District",
        "P_YS_FED_IMP_IOT0000005714": "Luan County",
        "P_YS_FED_IMP_IOT0000011642": "Zongyang County",
        "P_YS_FED_IMP_IOT0000005716": "Aershan",
        "P_YS_FED_IMP_IOT0000010311": "Yanshou County",
        "P_YS_FED_FW_0000022070": "м",
        "P_YS_FED_IMP_IOT0000010316": "Daxiang District",
        "P_YS_FED_IMP_IOT0000011648": "Shenze County",
        "P_YS_FED_IMP_IOT0000010317": "Tongguan County",
        "P_YS_FED_IMP_IOT0000010318": "Forward zone",
        "P_YS_FED_IMP_IOT0000010319": "Yinzhou District",
        "P_YS_SD_SDSD-FE_0001486556": "備註",
        "P_YS_FED_IMP_IOT0000005710": "Dege County",
        "P_YS_FED_IMP_IOT0000011646": "Huadu District",
        "P_YS_FED_FW_1588736741075845125": "已选数据项不能为空，请先添加再保存",
        "P_YS_FED_FW_0000022068": "Stacked Bar Chart",
        "P_YS_FED_FW_0000022069": "л",
        "P_YS_PF_GZTSYS_0000011944": "User-defined Fields",
        "P_YS_FED_FW_0000022084": "ч",
        "P_YS_FED_FW_0000022085": "ш",
        "P_YS_FED_FW_0000022082": "х",
        "P_YS_FED_FW_0000022083": "ц",
        "P_YS_FED_FW_0000022088": "Large Screen Solution  Design  info",
        "P_YS_FED_FW_0000022089": "ъ",
        "P_YS_FED_FW_0000022086": "Display Qty Info by bubble size",
        "P_YS_FED_FW_0000022087": "щ",
        "P_YS_FED_IMP_IOT0000005704": "Zhushan District",
        "P_YS_FED_IMP_IOT0000010320": "Ningjiang District",
        "P_YS_FED_IMP_IOT0000011650": "Dongshan County",
        "P_YS_FED_IMP_IOT0000005706": "Cenxi",
        "P_YS_FED_IMP_IOT0000010321": "Xichou County",
        "P_YS_FED_IMP_IOT0000005705": "Shifang",
        "P_YS_FED_FW_0000022080": "у",
        "P_YS_FED_FW_0000022081": "ф",
        "P_YS_FED_IMP_IOT0000005707": "Pingjiang County",
        "P_YS_FED_IMP_IOT0000005709": "Nanjing County",
        "P_YS_FED_IMP_IOT0000011658": "Ninghe County",
        "P_YS_FED_IMP_IOT0000010329": "Lufeng",
        "P_YS_FED_FW_1540539167842238469": "Save New Scenario",
        "P_YS_PF_GZTSYS_0000011952": "Product Category",
        "P_YS_FED_IMP_IOT0000011655": "Upper Ganling District",
        "P_YS_FED_IMP_IOT0000011657": "Downland",
        "P_YS_FED_FW_0000022079": "Maximize",
        "P_YS_FI_CM_0000029252": "Warning",
        "P_YS_PF_ANALYTIC-FE_0001651222": "Last 15 Days",
        "P_YS_FED_IMP_IOT0000011662": "Xiangyin County",
        "P_YS_FED_IMP_IOT0000010332": "Datong District",
        "P_YS_FED_IMP_IOT0000011660": "Zhangping",
        "P_YS_FED_IMP_IOT0000010338": "Wuchuan Gelao and Miao Autonomous County",
        "P_YS_FI_RA_0000071535": "Null Value",
        "P_YS_FED_IMP_IOT0000011666": "Horqin Youyiqianqi",
        "P_YS_FED_FW_0001249401": "为必,请输入后重试",
        "P_YS_FED_IMP_IOT0000011665": "Meixian",
        "P_YS_FED_FW_0001249400": "Invalid. Please modify and try again",
        "P_YS_FED_IMP_IOT0000010336": "Xing County",
        "P_YS_FED_IMP_IOT0000009297": "Shizong County",
        "P_YS_FED_IMP_IOT0000009299": "Haicang District",
        "P_YS_FI_YYFI-UI_0000167698": "Other Goods Receipt Doc List Region",
        "P_YS_OA_LCGL_0000037077": "Template Type",
        "P_YS_FED_FW_1624915715923902472": "表头+明显",
        "P_YS_FED_IMP_IOT0000009290": "Dehui",
        "P_YS_FED_FW_0001025027": "Please check whether SERVER_ENV is configured correctly",
        "P_YS_FI_CM_0000029260": "Data View",
        "P_YS_FED_IMP_IOT0000010341": "County",
        "P_YS_FED_IMP_IOT0000011673": "Gulou District",
        "P_YS_FED_IMP_IOT0000010344": "Jiaokou County",
        "P_YS_FED_IMP_IOT0000011674": "Horqin Youyizhongqi",
        "P_YS_FED_IMP_IOT0000011671": "Yanping District",
        "P_YS_SD_SDMA_0000122990": "Failed to get",
        "P_YS_FED_IMP_IOT0000010340": "Liberated area",
        "P_YS_OA_XTTMCENTER_0000035125": "No.",
        "P_YS_FED_IMP_IOT0000010349": "Guzhang County",
        "P_YS_FED_IMP_IOT0000010346": "Dinghai District",
        "P_YS_FED_IMP_IOT0000010347": "Ejin Holo Banner",
        "P_YS_FED_IMP_IOT0000011678": "Dongtai",
        "P_YS_FED_IMP_IOT0000009286": "Jinning County",
        "P_YS_FED_FW_0001025032": "Table Ref",
        "P_YS_FED_IMP_IOT0000009284": "Daowai District",
        "P_YS_FED_IMP_IOT0000009285": "Huanjiang Maonan Autonomous County",
        "P_YS_FED_IMP_IOT0000009289": "Gangcha County",
        "P_YS_FED_IMP_IOT0000009282": "Shimonoseki District",
        "P_YS_FED_IMP_IOT0000009283": "South Bank area",
        "P_YS_FED_IMP_IOT0000011684": "Dazi County",
        "P_YS_FED_IMP_IOT0000011683": "Changshun County",
        "P_YS_FED_FW_0001065929": "refEntity.extendField is not standard JSON character string",
        "P_YS_FED_IMP_IOT0000010354": "Langkazi County",
        "P_YS_FED_IMP_IOT0000011686": "Yuancheng District",
        "P_YS_FED_IMP_IOT0000011685": "Wangjiang County",
        "P_YS_FED_IMP_IOT0000011680": "Chengbei District",
        "P_YS_FED_IMP_IOT0000010350": "Chengdu",
        "P_YS_FED_FW_0001065923": ", the input decimal precision",
        "P_YS_FED_FW_0001065924": ", the input decimal precision is",
        "P_YS_FED_FW_0001065921": "The Max. length is 15 bits. The current integer length is",
        "P_YS_FED_FW_0001065922": " changed to",
        "P_YS_FED_IMP_IOT0000011688": "Qingchuan County",
        "P_YS_FED_IMP_IOT0000010357": "Maoxian",
        "P_YS_FED_IMP_IOT0000011687": "Lushan District",
        "P_YS_FED_FW_0001065925": "No data~",
        "P_YS_FED_FW_0001065926": "Incorrect metadata protocol",
        "P_YS_FED_FW_0001200151": "Cannot upload the following type of file:",
        "P_YS_FED_IMP_IOT0000009276": "Dongxing District",
        "P_YS_FED_IMP_IOT0000009279": "Zuogong County",
        "P_YS_FED_FW_1536081971023183878": "The print template picture address is empty. Cannot print. Please contact the staff for troubleshooting",
        "P_YS_FED_IMP_IOT0000009272": "Changyi District",
        "P_YS_FED_IMP_IOT0000009270": "Donglan County",
        "P_YS_FED_IMP_IOT0000010363": "Yaozhou District",
        "P_YS_FED_IMP_IOT0000010364": "Huqiu District",
        "P_YS_FED_IMP_IOT0000011697": "Gaize County",
        "P_YS_FED_IMP_IOT0000011696": "Yunhe County",
        "P_YS_FED_IMP_IOT0000011691": "Linshui County",
        "P_YS_FED_IMP_IOT0000010360": "Weishan County",
        "P_YS_FED_IMP_IOT0000011692": "Yingde",
        "P_YS_PF_GZTSYS_0000011991": "Label Group",
        "P_YS_OA_LCGL_0000037083": "Incomplete",
        "P_YS_FED_IMP_IOT0000011699": "Jianhe County",
        "P_YS_FED_IMP_IOT0000011698": "Xuan'en County",
        "P_YS_FED_IMP_IOT0000010369": "Huitong County",
        "P_YS_FED_IMP_IOT0000009264": "Pukou District",
        "P_YS_FED_IMP_IOT0000009262": "Xiaochang County",
        "P_YS_SD_URETAIL_0001048944": "%%db Error Log %% [",
        "P_YS_FED_FW_0001389709": "Get Remainder",
        "P_YS_FED_IMP_IOT0000009269": "Honggang District",
        "P_YS_FED_FW_0001389708": "Switch Query Method",
        "P_YS_FED_IMP_IOT0000009266": "Weishi County",
        "P_YS_SD_SDMA_0000062743": "Register",
        "P_YS_PF_PRINT_0000056946": "Header User-defined Field 14",
        "P_YS_PF_PRINT_0000056943": "Header User-defined Field 10",
        "P_YS_FED_FW_0000022011": "Print Receipt",
        "P_YS_FED_IMP_IOT0000008050": "Qingjian County",
        "P_YS_FED_IMP_IOT0000009381": "Aheqi County",
        "P_YS_FED_FW_0000022012": "Exception in 2-D table row/column changes. There's no column type t2DColType. data=",
        "P_YS_FED_IMP_IOT0000008051": "Mian County",
        "P_YS_FED_FW_0000022010": "Unknown control",
        "P_YS_FED_IMP_IOT0000009380": "Hotan County",
        "P_YS_FED_IMP_IOT0000010254": "Zhongshan District",
        "P_YS_FED_IMP_IOT0000010256": "Zhucheng",
        "P_YS_FED_IMP_IOT0000011586": "Taobei District",
        "P_YS_FED_IMP_IOT0000011583": "Feixiang County",
        "P_YS_FED_FW_0001077975": "Control crashed.",
        "P_YS_FED_FW_1585773806330314768": "范围值精度不允许为负值，请修改",
        "P_YS_FED_IMP_IOT0000010257": "Huaiyang County",
        "P_YS_FED_IMP_IOT0000010258": "Pan'an County",
        "P_YS_FED_IMP_IOT0000010259": "Xiangcheng District",
        "P_YS_FED_FW_0000022004": "View",
        "P_YS_FED_IMP_IOT0000008043": "Huachuan County",
        "P_YS_SD_UDHWS_0000066531": "Qty (Pri. UOM)",
        "P_YS_FED_FW_0000022005": "Report Group Scheme Config. Info - Chart Arr",
        "P_YS_FED_FW_0000022002": "Large screen slideshow: failed to find a large screen that can be displayed. Template ID",
        "P_YS_FED_IMP_IOT0000008041": "Nangqian County",
        "P_YS_FED_IMP_IOT0000009372": "Nanyue District",
        "P_YS_SD_UDHWN_0000047815": "Pagination",
        "P_YS_FED_FW_0000022003": "Please select lines to move down",
        "P_YS_FED_IMP_IOT0000008042": "Zhangwu County",
        "P_YS_FED_IMP_IOT0000009373": "Yakeshi",
        "P_YS_FED_FW_0000022008": "Hot zone display picture  Get mapConfig according to the returned data set. mapConfig",
        "P_YS_FED_IMP_IOT0000008047": "Xindu District",
        "P_YS_FED_IMP_IOT0000009378": "Heshan",
        "P_YS_FED_FW_0000022009": "Batch Operation",
        "P_YS_PF_PRINT_0000056949": "Header User-defined Field 12",
        "P_YS_FED_FW_0000022006": "eChartDisplay  Scatter chart/map Info is correct    return",
        "P_YS_FED_IMP_IOT0000009376": "Yicheng County",
        "P_YS_FED_FW_0000022007": "Triggered once every  month(s)",
        "P_YS_FED_IMP_IOT0000008046": "Dao County",
        "P_YS_FED_IMP_IOT0000009377": "Jinyang County",
        "P_YS_PF_PRINT_0000056947": "Header User-defined Field 13",
        "P_YS_PF_PRINT_0000056956": "Header User-defined Field 18",
        "P_YS_FED_IMP_IOT0000011590": "Guinan County",
        "P_YS_FED_FW_0000022022": "Please enter alias code",
        "P_YS_FED_IMP_IOT0000009370": "Yichuan County",
        "P_YS_FED_FW_0000022023": "Filter/Sort",
        "P_YS_FED_FW_0000022020": "eChartDisplay  Status changed  shouldComponentUpdate Begin",
        "P_YS_FED_FW_0000022021": "Supported picture format: png/jpg; no more than 10M",
        "P_YS_PF_PRINT_0000056950": "Header User-defined Field 11",
        "P_YS_FED_IMP_IOT0000011596": "Luoyuan County",
        "P_YS_FED_IMP_IOT0000010265": "North Tower",
        "P_YS_FED_IMP_IOT0000011595": "Zaduo County",
        "P_YS_FED_IMP_IOT0000010266": "Yi County",
        "P_YS_FED_IMP_IOT0000010267": "Zhaoyuan County",
        "P_YS_FED_IMP_IOT0000011597": "Dongshan District",
        "P_YS_FED_IMP_IOT0000011591": "Wolong District",
        "P_YS_FED_IMP_IOT0000011594": "Shicheng County",
        "P_YS_SCM_USTOCK-UI_0000173671": "Add Group",
        "P_YS_FED_IMP_IOT0000009369": "Zaoqiang County",
        "P_YS_FED_FW_0001381042": "The size of each picture cannot exceed 50M; supported: JPG, PNG",
        "P_YS_FED_FW_0001381041": "Picture Mgmt",
        "P_YS_FED_FW_1600567391678889987": "UI模板名称:",
        "P_YS_FED_FW_1600567391678889984": "UI模板tplid:",
        "P_YS_FED_FW_0000022015": "Confirm to delete the template?",
        "P_YS_FED_IMP_IOT0000008032": "Jinsha County",
        "P_YS_FED_FW_0000022016": "Report scheme published",
        "P_YS_FED_IMP_IOT0000008033": "Wusheng County",
        "P_YS_FED_IMP_IOT0000009364": "Jiuli District",
        "P_YS_FED_FW_0000022013": "Save failed",
        "P_YS_FED_FW_0000022014": "Refresh Rate",
        "P_YS_FED_IMP_IOT0000009362": "Huarong District",
        "P_YS_FED_FW_0000022019": "No result found",
        "P_YS_FED_IMP_IOT0000009367": "Yongning County",
        "P_YS_FED_IMP_IOT0000008037": "Fenghua",
        "P_YS_FED_FW_0000022017": "The number entered cannot be less than",
        "P_YS_FED_IMP_IOT0000008034": "Baijiantan District",
        "P_YS_FED_FW_0000022018": "Display Indicators",
        "P_YS_FED_IMP_IOT0000009366": "Weidu District",
        "P_YS_PF_PRINT_0000056958": "Header User-defined Field 17",
        "P_YS_PF_PRINT_0000056924": "Issue Org",
        "P_YS_FED_FW_0001344099": "Jump sequentially among the available cells in \"Z\" shape",
        "P_YS_SCM_USTOCK-UI_0001025485": "Required. Please specify SKU",
        "P_YS_FED_FW_0001344095": "Space",
        "P_YS_FED_IMP_IOT0000009360": "Kailu County",
        "P_YS_FED_FW_0001344096": "New (Blank Doc/File)",
        "P_YS_FED_FW_0001344097": "Open the hovered over reference dialog box",
        "P_YS_FED_FW_0001344098": "Expand/hide group in the header",
        "P_YS_FED_IMP_IOT0000010275": "Yuan'an County",
        "P_YS_FED_FW_0001344091": "Jump reversely among the available cells in \"Z\" shape",
        "P_YS_FED_FW_0001344092": "Quickly jump in the table",
        "P_YS_FED_FW_0001344093": "↑; ↓; ←; →",
        "P_YS_FED_FW_0001344094": "↑/↓",
        "P_YS_FED_IMP_IOT0000010271": "Mankang County",
        "P_YS_FED_IMP_IOT0000010273": "Dehua County",
        "P_YS_FED_FW_0001344090": "Ref Popup Window",
        "P_YS_FED_FW_1422515029828173824": "Please enter keywords to search",
        "P_YS_FED_IMP_IOT0000008028": "Danzhai County",
        "P_YS_FED_IMP_IOT0000009359": "Lingyun County",
        "P_YS_FED_UCFBASEDOC_0000024749": "Sensitive Data Permission",
        "P_YS_FED_IMP_IOT0000010279": "Fufeng County",
        "P_YS_SD_URETAIL_0001048852": "0",
        "P_YS_FED_IMP_IOT0000009352": "Jishishan Baoan Nationality Dongxiang Nationality Salar Autonomous County",
        "P_YS_FED_IMP_IOT0000009350": "Dali County",
        "P_YS_FED_IMP_IOT0000008020": "Linhe City",
        "P_YS_FED_IMP_IOT0000008025": "Wenchuan County",
        "P_YS_FED_IMP_IOT0000008026": "Chengkou County",
        "P_YS_FED_IMP_IOT0000009357": "Eshan Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000008023": "Zanhuang County",
        "P_YS_FED_IMP_IOT0000008024": "Jinxi County",
        "P_YS_FED_IMP_IOT0000009355": "Chun'an County",
        "P_YS_FED_FW_0001344088": "Move cursor up/down by referencing the table",
        "P_YS_FED_FW_0001154596": "The size of the file to import cannot exceed ",
        "P_YS_FED_FW_0001344089": "Bottom Action Bar",
        "P_YS_FED_IMP_IOT0000010281": "Yima",
        "P_YS_FED_FW_0000022000": "Message Content",
        "P_YS_FED_FW_0001344084": "Move cursor up/down in the drop-down panel",
        "P_YS_FED_FW_0000022001": "Width/Height",
        "P_YS_FED_FW_0001344085": "Switch between the header and detail",
        "P_YS_FED_FW_0001344086": "Form Entry",
        "P_YS_FED_FW_0001344087": "Confirm by referencing the popup window",
        "P_YS_FED_IMP_IOT0000010286": "Houma",
        "P_YS_FED_IMP_IOT0000010288": "Shenzhou",
        "P_YS_FED_IMP_IOT0000010289": "Sisai",
        "P_YS_FED_IMP_IOT0000008018": "Huining County",
        "P_YS_FED_IMP_IOT0000009349": "Yichun District",
        "P_YS_FED_IMP_IOT0000008019": "Hengshan District",
        "P_YS_FED_IMP_IOT0000008016": "Yingjiang County",
        "P_YS_FED_IMP_IOT0000009347": "Qinglong County",
        "P_YS_FED_IMP_IOT0000009341": "Icheon",
        "P_YS_FED_IMP_IOT0000008011": "Baokang County",
        "P_YS_FED_IMP_IOT0000009342": "Tongjiang County",
        "P_YS_FED_IMP_IOT0000008014": "Beihu District",
        "P_YS_FED_IMP_IOT0000008015": "Yuanzhou District",
        "P_YS_FED_IMP_IOT0000009346": "Wugang",
        "P_YS_FED_IMP_IOT0000009343": "Langya District",
        "P_YS_FED_FW_0000022051": "Enable",
        "P_YS_FED_FW_0000022052": "а",
        "P_YS_FED_FW_0000022050": "Large screen solution  Design  getDesignColType_Chart curCol",
        "P_YS_FED_IMP_IOT0000010292": "Wanshan Special Zone",
        "P_YS_FED_FW_0000022055": "Please input...",
        "P_YS_FED_FW_0000022056": "в",
        "P_YS_FED_FW_0000022053": "Only display selected",
        "P_YS_FED_FW_0000022054": "б",
        "P_YS_FED_IMP_IOT0000010297": "Rencheng District",
        "P_YS_FED_IMP_IOT0000010298": "Yucheng District",
        "P_YS_FED_IMP_IOT0000010293": "Jiangxian",
        "P_YS_FED_FW_1545658640009003030": "Hello, the \"Add\" button does not support the table body \"1 to many\" type of value, please use the advanced designer settings, such as: \"advanced designer - field settings\", \"advanced designer - formula\", \"advanced designer - formula\". \"Advanced Designer - Formulas\".",
        "P_YS_FED_IMP_IOT0000010296": "Canglang District",
        "P_YS_TBS_TBS-FE_0001148975": "South China Sea Islands",
        "P_YS_FED_IMP_IOT0000008008": "Renbu County",
        "P_YS_FED_IMP_IOT0000009339": "Taishan",
        "P_YS_FED_UCFBASEDOC_0000024727": "Approve",
        "P_YS_FED_IMP_IOT0000008009": "Macheng",
        "P_YS_FED_FW_0000022048": "Ascending",
        "P_YS_FED_FW_0000022049": "Filter Type",
        "P_YS_FED_IMP_IOT0000008000": "Ganyu County",
        "P_YS_FED_FW_0000022046": "Multiple rows of 1-D table matched. Please check. valueArr =",
        "P_YS_SD_URETAIL_0001048876": "0",
        "P_YS_FED_FW_0000022047": "Subscription Condition",
        "P_YS_FED_IMP_IOT0000009334": "Yangshuo County",
        "P_YS_FED_IMP_IOT0000008004": "Dingzhou",
        "P_YS_FED_IMP_IOT0000009335": "Yanxian County",
        "P_YS_FED_IMP_IOT0000008001": "Elm City",
        "P_YS_FED_IMP_IOT0000008002": "Weibin District",
        "P_YS_FED_FW_0000022062": "з",
        "P_YS_PF_SOCD_0000089099": "Brazil",
        "P_YS_FED_FW_0000022063": "Confirm to <%=abandonText%>?",
        "P_YS_FED_FW_0000022060": "е",
        "P_YS_FED_FW_0000022061": "ж",
        "P_YS_FED_FW_0000022066": "Cannot find user ID. Please confirm",
        "P_YS_FED_FW_0000022067": "к",
        "P_YS_PF_PRINT_0000056996": "Line No.",
        "P_YS_FED_FW_0000022064": "No data",
        "P_YS_FED_FW_0000022065": "й",
        "P_YS_FED_FW_1588671285764292613": "已勾选“移动端展现”，请设置移动端布局!",
        "P_YS_SD_SDMAUF_0000152989": "Expired",
        "P_YS_FI_RA_0000071482": "ID is",
        "P_YS_FED_IMP_IOT0000009327": "Shuocheng District",
        "P_YS_FED_IMP_IOT0000009325": "Shenhe District",
        "P_YS_FED_IMP_IOT0000009329": "Jinping County",
        "P_YS_FED_FW_0000022059": "Change Template Name",
        "P_YS_FED_UCFBASEDOC_0000024712": "Save and Add",
        "P_YS_FED_FW_0000022057": "г",
        "P_YS_FED_FW_0000022058": "д",
        "P_YS_FED_IMP_IOT0000009324": "Tangyin County",
        "P_YS_FED_IMP_IOT0000009321": "Yijun County",
        "P_YS_FED_FW_0000022030": "Verification succeeded",
        "P_YS_FED_FW_1545658640009003012": "selectFiled - the field to query",
        "P_YS_FED_FW_0000022033": "Please set solutionId",
        "P_YS_FED_FW_1545658640009003015": "1. Open the Advanced Designer, select the table body, click on the \"Field Settings\" button in the right properties area, in the pop-up window on the left tree, query to the target field dragged to the list, and finally save.",
        "P_YS_FED_FW_0000022034": "Only support",
        "P_YS_PF_PRINT_0000056963": "Header User-defined Field 15",
        "P_YS_FED_FW_0000022031": "Incorrect title font size settings",
        "P_YS_FED_FW_0000022032": "eChartDisplay  chartDisplayType not submitted. Please check",
        "P_YS_PF_PRINT_0000056961": "Header User-defined Field 16",
        "P_YS_FED_IMP_IOT0000009314": "Tonggu County",
        "P_YS_FED_UCFBASEDOC_0000024708": "Role Desc.",
        "P_YS_FED_IMP_IOT0000009315": "Dazu County",
        "P_YS_FED_IMP_IOT0000009319": "Qingxian",
        "P_YS_FED_FW_0000022026": "File value is required",
        "P_YS_FED_UCFBASEDOC_0000024701": "Issue warehouse and receipt warehouse cannot be the same",
        "P_YS_FED_FW_0000022027": "Rows of 2-D table =",
        "P_YS_FED_FW_0000022024": "Move Current Line Up",
        "P_YS_FED_FW_0000022025": "Keep Outer Layer Spacing",
        "P_YS_FED_IMP_IOT0000009312": "Yutian County",
        "P_YS_FED_FW_0000022028": "Template Org Name",
        "P_YS_FED_FW_0000022029": "Daily",
        "P_YS_FED_IMP_IOT0000009311": "Yuexiu District",
        "P_YS_FED_FW_0000022040": "Down",
        "P_YS_FED_FW_0000022041": "Operator",
        "P_YS_FED_FW_1545658640009003021": "conditionField--condition field",
        "P_YS_FED_FW_0000022044": "Add Announcement",
        "P_YS_FED_FW_0000022045": "Add Matl",
        "P_YS_SD_UDHWN_0000047803": "Ding'an County",
        "P_YS_SD_UDHBN_0000032639": "Content",
        "P_YS_FED_FW_1545658640009003027": "fullName - uri of the file",
        "P_YS_FED_FW_0000022042": "Pie Chart",
        "P_YS_PF_PRINT_0000056973": "Issue Warehouse",
        "P_YS_FED_FW_1545658640009003024": "conditionValue--condition value",
        "P_YS_FED_FW_0000022043": "The address you entered is incorrect. Please fill in the correct address",
        "P_YS_PF_PRINT_0000056970": "Header User-defined Field 19",
        "P_YS_FED_IMP_IOT0000009307": "Jinping District",
        "P_YS_FED_IMP_IOT0000009308": "Cuomei County",
        "P_YS_FED_FW_0000022037": "Display in PC",
        "P_YS_FED_FW_0001025097": "Confirm to restore the default setting?",
        "P_YS_FED_FW_0000022038": "Large screen solution  Save editPanel",
        "P_YS_FED_FW_0000022035": "Default Template",
        "P_YS_FED_FW_0000022036": "Please enter contact phone number",
        "P_YS_FED_FW_1545658640009003018": "2. Set the formula - business functions",
        "P_YS_FED_IMP_IOT0000009302": "Guzhen County",
        "P_YS_FED_FW_0000022039": "Large screen slideshow: please check if the current operator has template permissions",
        "P_YS_OA_YBMOB_0000036998": "Withdrawn successfully",
        "P_YS_FED_FW_0001045501": "14",
        "P_YS_FED_FW_0001045500": "16",
        "P_YS_FED_FW_0001473539": "Please enter the site name",
        "P_YS_PF_METADATA_0001040427": "Place of Origin",
        "P_YS_FED_FW_0001071829": "Table Ref or Tree Ref with navbar",
        "P_YS_FED_FW_0001071827": "Tree Ref with navbar, Confirm button, etc",
        "P_YS_FED_FW_0001071828": "Header Return Callback",
        "P_YS_FED_FW_0001473541": "Please configure the type of popup window fromType",
        "P_YS_SD_SDSD-FE_0001491115": "金額",
        "P_YS_FED_FW_0001473540": "There're changes that have not yet taken effect for the Org, so the Org cannot be disabled. Please try again after the changes take effect or when they are deleted",
        "P_YS_SD_SDMB_0000146962": "Top",
        "P_YS_FED_FW_0001344079": "Shortcuts Help",
        "P_YS_PF_PROCENTER_0000023062": "Others",
        "P_YS_FED_FW_0001034888": "Bid Award",
        "P_YS_SD_SDMA_0000125113": "HQ",
        "P_YS_OA_YBMOB_0000036941": "Approval History",
        "P_YS_FED_FW_1551057439648907272": "Reference configuration error: Reference data unique value not returned",
        "P_YS_PF_PROCENTER_0000023057": "Inv Unit",
        "P_YS_SD_SDMAF_0000136181": "Condition:",
        "P_YS_SD_UDHWN_0000047879": "Oriental City",
        "P_YS_FED_FW_0001534303": "Search Field Settings",
        "P_YS_FED_FW_0001648230": "Failed Line No.",
        "P_YS_FED_FW_0001662538": "Please enter a keyword or select a category",
        "P_YS_FED_UCFBASEDOC_0000024789": "Deleting...",
        "P_YS_FI_YYFI-UI_0001152516": "Manually Close",
        "P_YS_FED_UCFBASEDOC_0000024782": "Operation failed",
        "P_YS_FED_FW_0001219575": "<%=text%> is required",
        "P_YS_PF_PRINT_0000065042": "Matl Code",
        "P_YS_FED_FW_1497279621567610881": "Please click the icon on the right side of the input box to add other language names",
        "P_YS_FI_CM_0000029334": "Afternoon",
        "P_YS_FED_FW_1422567557278203904": "Processing data. Please wait...",
        "P_YS_FED_IMP_IOT0000005698": "Jing'an County",
        "P_YS_FED_IMP_IOT0000005697": "Wuchang",
        "P_YS_SD_UDHWN_0000120970": "No title",
        "P_YS_SD_UDHWN_0001008893": "Select by Circling",
        "P_YS_FED_IMP_IOT0000005692": "Fusong County",
        "P_YS_FED_FW_0001411240": "Search Changes",
        "P_YS_SD_UDHWN_0001008897": "Vertical Selection",
        "P_YS_FED_FW_0001045594": "Confirm to <%=params.cShowCaption%> the record?",
        "P_YS_FED_FW_0001045595": "Confirm to delete \"<%=text%>\"?",
        "P_YS_FED_FW_0001045593": "Confirm to delete <%=text%>?",
        "P_YS_PF_GZTPRE_0001381653": "Event Listening",
        "P_YS_FI_FCWEB_0001131731": "Print",
        "P_YS_PF_PROCENTER_0000023090": "Purchase",
        "P_YS_SCM_PU_0000028400": "Closed",
        "P_YS_FED_IMP_IOT0000005684": "Resource County",
        "P_YS_FED_IMP_IOT0000005687": "Xiangdong District",
        "P_YS_FED_IMP_IOT0000005683": "Dinghu District",
        "P_YS_FED_IMP_IOT0000005676": "Chencang District",
        "P_YS_FED_IMP_IOT0000005679": "Xi County",
        "P_YS_FED_FW_0001248291": "Restore",
        "P_YS_FED_IMP_IOT0000005672": "Zhanhe District",
        "P_YS_PES_PES-FE_0001231284": "Not selected",
        "P_YS_FED_IMP_IOT0000005663": "Minquan County",
        "P_YS_FED_IMP_IOT0000006993": "Qinhuangdao",
        "P_YS_FED_IMP_IOT0000005662": "Weixi Lisu Autonomous County",
        "P_YS_FED_IMP_IOT0000005664": "Jianghan District",
        "P_YS_FED_IMP_IOT0000006995": "Yanzhou",
        "P_YS_FED_FW_0001273232": "System level template. Cannot modify the column",
        "P_YS_FED_FW_0001094529": "%c Unprocessed Type",
        "P_YS_FED_IMP_IOT0000006998": "Anning",
        "P_YS_FED_IMP_IOT0000005666": "Pingjiang District",
        "P_YS_FED_IMP_IOT0000006997": "Didao District",
        "P_YS_FED_IMP_IOT0000006999": "Filter by Default",
        "P_YS_FED_IMP_IOT0000005660": "Shijiazhuang",
        "P_YS_FED_FW_0001345200": "Query area rendered successfully. No default scheme data",
        "P_YS_FED_FW_0001345201": "Query area rendering completed",
        "P_YS_FED_FW_0001071834": "Supported: addListener, removeListener, select",
        "P_YS_FED_FW_0001071835": "addListener, removeListener, select, unselect, setPageIndex, execute",
        "P_YS_FED_FW_0001071832": "Supported: addListener, removeListener, ",
        "P_YS_FED_FW_0001071833": "Use with params中menuId. portal.tabs[menuId].panes",
        "P_YS_FED_FW_0001071830": "addListener, removeListener, _set_data, select, setFocusedRowIndex, execute",
        "P_YS_FED_FW_0001071831": "Supported: get, getCache",
        "P_DIWORK_YC_CPU-PORTAL_0000064667": "Supplier Name:",
        "P_YS_FED_IMP_IOT0000005651": "Huangshan District",
        "P_YS_FED_IMP_IOT0000006982": "Wuqiao County",
        "P_YS_FED_IMP_IOT0000005654": "Jimei District",
        "P_YS_FED_IMP_IOT0000006985": "Mojiang Hani Autonomous County",
        "P_YS_FED_IMP_IOT0000005653": "Fuping County",
        "P_YS_FED_IMP_IOT0000005656": "Heshan",
        "P_YS_FED_IMP_IOT0000006987": "Liangping County",
        "P_YS_FED_IMP_IOT0000006989": "Lucheng",
        "P_YS_OA_LCGL_0000037113": "Action",
        "P_YS_FED_IMP_IOT0000006981": "Lianzhou",
        "P_YS_SCM_USCMPUB-FE_1528671786657906690": "Shape Backup",
        "P_YS_FED_IMP_IOT0000005648": "Gaotai County",
        "P_YS_FED_FW_0000083161": "Before calling the interface for obtaining profile",
        "P_YS_FED_FW_0000083160": "After calling the interface for obtaining profile",
        "P_YS_FED_IMP_IOT0000005640": "Lingshi County",
        "P_YS_FED_IMP_IOT0000006971": "Jingkou District",
        "P_YS_FED_IMP_IOT0000005643": "Hanyang District",
        "P_YS_FED_IMP_IOT0000005645": "Ji County",
        "P_YS_FED_IMP_IOT0000005644": "Gangbei District",
        "P_YS_FED_IMP_IOT0000006975": "Jiuzhi County",
        "P_YS_OA_XTTMCENTER_0000035097": "Time Uploaded",
        "P_YS_FED_IMP_IOT0000005647": "Linqing",
        "P_YS_FED_IMP_IOT0000005646": "Plain County",
        "P_YS_OA_LCGL_0000037104": "Activate",
        "P_YS_OA_XTTMCENTER_0000035090": "Created By",
        "P_YS_FED_FW_1581128541507420175": "休",
        "P_YS_FED_FW_1581128541507420172": "是否包含下级",
        "P_YS_FED_IMP_IOT0000005637": "Zengdu District",
        "P_YS_FI_CM_0000029313": "Morning",
        "P_YS_FED_IMP_IOT0000005639": "Qinglong Manchu Autonomous County",
        "P_YS_FED_FW_1541189374344953860": "Loading data",
        "P_YS_FED_IMP_IOT0000006961": "Hongshan District",
        "P_YS_FED_IMP_IOT0000006963": "Eggplant River District",
        "P_YS_FED_IMP_IOT0000006964": "Fengxin County",
        "P_YS_FED_FW_1487823486562336780": "There is no public scheme",
        "P_YS_FED_IMP_IOT0000006966": "Nancheng District",
        "P_YS_FI_CM_0000029316": "Switch to Stack",
        "P_YS_FED_FW_1541192982117482504": "Loading data ~",
        "P_YS_FED_FW_0001236297": "Task Progress",
        "P_YS_FED_FW_0001236296": "No product code",
        "P_YS_FED_IMP_IOT0000005627": "Daoli District",
        "P_YS_FED_IMP_IOT0000006957": "Daxin County",
        "P_YS_FED_IMP_IOT0000005628": "Yuetang District",
        "P_YS_HR_HRPUBF_0000053688": "Set successfully",
        "P_YS_FED_FW_1581128541507420169": "还有",
        "P_YS_FED_IMP_IOT0000005621": "Huilai County",
        "P_YS_FED_IMP_IOT0000006952": "Renqiu",
        "P_YS_FED_IMP_IOT0000006951": "Shunde",
        "P_YS_FED_IMP_IOT0000006954": "Jian'ou",
        "P_YS_FED_IMP_IOT0000005624": "Jingyu County",
        "P_YS_SD_SDMB_0000149198": "Total",
        "P_YS_OA_LCGL_0000037124": "Organization Structure",
        "P_YS_FED_FW_1487823486562336777": "There is no personal scheme",
        "P_YS_FED_IMP_IOT0000005616": "Jiangle County",
        "P_YS_FED_IMP_IOT0000006947": "Kuancheng Manchu Autonomous County",
        "P_YS_FED_IMP_IOT0000005618": "Huangpi District",
        "P_YS_FED_IMP_IOT0000006949": "Dushanziqu",
        "P_YS_FED_IMP_IOT0000005617": "Zhouqu County",
        "P_YS_FED_IMP_IOT0000006948": "Nancheng County",
        "P_YS_OA_XTTMCENTER_0000035047": "YouZone",
        "P_YS_OA_LCGL_0000037152": "Exception Info",
        "P_YS_FED_IMP_IOT0000005610": "Handan County",
        "P_YS_FED_IMP_IOT0000011507": "Changzhou District",
        "P_YS_FED_IMP_IOT0000006940": "Qingfeng County",
        "P_YS_FED_FW_0001249563": "Un-include",
        "P_YS_SD_SDMB_0000140730": "Invoicing or not",
        "P_YS_FED_IMP_IOT0000005612": "Libo County",
        "P_YS_OA_XTTMCENTER_0000035043": "Link",
        "P_YS_FED_IMP_IOT0000006942": "Qingshan District",
        "P_YS_FED_IMP_IOT0000011500": "Cangxi County",
        "P_YS_FED_IMP_IOT0000005614": "Dari County",
        "P_YS_FED_IMP_IOT0000006944": "Xihua County",
        "P_YS_FED_IMP_IOT0000011502": "Shibing County",
        "P_YS_HR_HRPXF_0000056086": "Download Import Template",
        "P_YS_FED_IMP_IOT0000011508": "Yanbian County",
        "P_YS_FED_FW_0001026436": "?",
        "P_YS_FED_IMP_IOT0000006936": "Lishu County",
        "P_YS_FED_IMP_IOT0000005604": "Qin'an County",
        "P_YS_FED_FW_0001249569": "Cannot select a date earlier than 1870-01-01",
        "P_YS_FED_IMP_IOT0000005607": "Qiqihar",
        "P_YS_FED_IMP_IOT0000006937": "Minxian",
        "P_YS_FED_IMP_IOT0000005609": "Sishui County",
        "P_YS_FED_IMP_IOT0000011515": "Changling County",
        "P_YS_FED_UCFBASEDOC_0000024916": "Please enter role name",
        "P_YS_FED_IMP_IOT0000006930": "Fengjie County",
        "P_YS_FED_IMP_IOT0000011518": "Bahrain Zuoqi",
        "P_YS_OA_XTTMCENTER_0000035056": "Update Time",
        "P_YS_FED_IMP_IOT0000011517": "Guxian",
        "P_YS_FED_UCFBASEDOC_0000024914": "Daily Settlement Doc/Daily Inv Report -",
        "P_YS_FED_IMP_IOT0000005601": "Shaoshan",
        "P_YS_FED_IMP_IOT0000006932": "Daoxian",
        "P_YS_FED_IMP_IOT0000011512": "Yu Bei District",
        "P_YS_FED_UCFBASEDOC_0000024915": "No more than 10 chars",
        "P_YS_FED_IMP_IOT0000005600": "Dafeng",
        "P_YS_FED_IMP_IOT0000006934": "Yunan County",
        "P_YS_FED_IMP_IOT0000011514": "Qufu",
        "P_YS_OA_XTTMCENTER_0000035052": "Please upload",
        "P_YS_FED_IMP_IOT0000006933": "Dujiangyan",
        "P_YS_FED_IMP_IOT0000011513": "Qinggang County",
        "P_YS_FED_FW_0001249571": "Cannot select a date later than 9999-12-31",
        "P_YS_FED_FW_0001249570": "Required. Please enter and try again",
        "P_YS_FED_FW_0000022194": "There're multiple rows of data in the 1-D table conforming to the column/row key value of the current cross-point  t2DRowKey =",
        "P_YS_FED_FW_0000022195": "Required",
        "P_YS_FED_FW_0000022192": "Move Up",
        "P_YS_FED_FW_0000022193": "Please enter a number between 1-100",
        "P_YS_FED_FW_0000022198": "Publish Menu",
        "P_YS_FED_FW_0000022199": "Edit Filter Item",
        "P_YS_FED_FW_0001294823": "You do not have the permission to open this Doc. Confirm to close the page?",
        "P_YS_FED_FW_0000022197": "Expand",
        "P_YS_FED_IMP_IOT0000006927": "Durbat Mongolian Autonomous County",
        "P_YS_FED_IMP_IOT0000011520": "Dechang County",
        "P_YS_FED_FW_0000022190": "Line Chart",
        "P_YS_FED_IMP_IOT0000006929": "Yangxi County",
        "P_YS_FED_FW_0000022191": "Please set graph report Info",
        "P_YS_FED_IMP_IOT0000006928": "Neiqiu County",
        "P_YS_FED_IMP_IOT0000011526": "Huairen County",
        "P_YS_FED_UCFBASEDOC_0000024903": "Product List",
        "P_YS_FED_IMP_IOT0000011523": "Zichuan District",
        "P_YS_OA_XTTMCENTER_0000035064": "Download",
        "P_YS_FED_IMP_IOT0000006920": "Boai County",
        "P_YS_PF_GZTTMP_0000074463": "Public",
        "P_YS_SD_SDMA_0000062670": "€",
        "P_YS_FED_FW_0000022189": "Insert Line at Bottom",
        "P_YS_FED_IMP_IOT0000009196": "Huguan County",
        "P_YS_FED_IMP_IOT0000009197": "Qingxin County",
        "P_YS_FED_IMP_IOT0000009190": "Yecheng County",
        "P_YS_FED_IMP_IOT0000009191": "Yandu District",
        "P_YS_FED_IMP_IOT0000009194": "Tongcheng County",
        "P_YS_FED_IMP_IOT0000009192": "Boluo County",
        "P_YS_FED_IMP_IOT0000009193": "Quanjiao County",
        "P_YS_FED_IMP_IOT0000011530": "Yuncheng District",
        "P_YS_FED_IMP_IOT0000006913": "Langao County",
        "P_YS_FED_IMP_IOT0000011532": "Jinjiang",
        "P_YS_FED_IMP_IOT0000010200": "Lingdong District",
        "P_YS_FED_IMP_IOT0000006915": "Jiangda County",
        "P_YS_FED_IMP_IOT0000010201": "Dahua Yao Autonomous County",
        "P_YS_FED_IMP_IOT0000011531": "Luyang District",
        "P_YS_FED_IMP_IOT0000006917": "Jiaocheng District",
        "P_YS_FED_IMP_IOT0000006919": "Xinpu District",
        "P_YS_FED_IMP_IOT0000010206": "Dongyuan County",
        "P_YS_FED_IMP_IOT0000010207": "Qingshui County",
        "P_YS_FED_IMP_IOT0000011537": "Qishan County",
        "P_YS_FED_IMP_IOT0000010208": "Nanhai District",
        "P_YS_FED_IMP_IOT0000006910": "Kunshan",
        "P_YS_FED_IMP_IOT0000011533": "Yanfeng District",
        "P_YS_FED_IMP_IOT0000010204": "Linghai",
        "P_YS_FED_IMP_IOT0000010205": "Yunxi County",
        "P_YS_FED_IMP_IOT0000011535": "Hami",
        "P_YS_FED_IMP_IOT0000009188": "Xishui County",
        "P_YS_HR_HRPXF_0000056097": "Scan QR Code",
        "P_YS_FED_IMP_IOT0000009189": "Pu County",
        "P_YS_FED_IMP_IOT0000009180": "Funing County",
        "P_YS_FI_CM_0000029370": "Region Zoom",
        "P_YS_FED_IMP_IOT0000009184": "Jinta County",
        "P_YS_FED_IMP_IOT0000009181": "Shuicheng County",
        "P_YS_FED_IMP_IOT0000006903": "Shangzhou District",
        "P_YS_FED_IMP_IOT0000011541": "Lushui County",
        "P_YS_FED_IMP_IOT0000011540": "Dangshan County",
        "P_YS_FED_IMP_IOT0000006905": "Weicheng District",
        "P_YS_FED_IMP_IOT0000011543": "Rongxian",
        "P_YS_FED_FW_0001570014": "There is no data model",
        "P_YS_FED_IMP_IOT0000006904": "Xingyang",
        "P_YS_FED_FW_0001570015": "No matching feature found",
        "P_YS_FED_IMP_IOT0000006907": "Weishan Yi and Hui Autonomous County",
        "P_YS_FI_CM_0000029374": "Country",
        "P_YS_FED_FW_0001064735": "The number of decimal digits exceeds ",
        "P_YS_FED_IMP_IOT0000011549": "Xingan County",
        "P_YS_FED_FW_0001064736": "The number of decimal digits is 0",
        "P_YS_FED_IMP_IOT0000010219": "Sheyang County",
        "P_YS_FED_IMP_IOT0000006901": "Hangjinhouqi",
        "P_YS_FED_IMP_IOT0000006900": "Yangzhong",
        "P_YS_FED_IMP_IOT0000011546": "Yongjia County",
        "P_YS_FED_IMP_IOT0000009176": "Suizhong County",
        "P_YS_FED_IMP_IOT0000009174": "Shunqing District",
        "P_YS_FED_IMP_IOT0000009175": "Yongqing County",
        "P_YS_FED_IMP_IOT0000009178": "Guanyun County",
        "P_YS_FED_IMP_IOT0000009179": "Lintong District",
        "P_YS_FED_IMP_IOT0000009171": "Mohe County",
        "P_YS_FED_IMP_IOT0000010221": "Qiaojia County",
        "P_YS_FED_IMP_IOT0000011551": "Guide County",
        "P_YS_FED_IMP_IOT0000010222": "Zhenjiang District",
        "P_YS_OA_XTTMCENTER_0000035014": "Uploaded By",
        "P_YS_OA_LCGL_0000037185": "Total Qty",
        "P_YS_FED_FW_0001141477": "Table cannot be empty",
        "P_YS_FED_IMP_IOT0000010224": "Anxiang County",
        "P_YS_FED_FW_0001141476": "No such record. Please enter again",
        "P_YS_PF_GZTSYS_0000011894": "Menu Management",
        "P_YS_FED_FW_0001141479": "The following header field is required",
        "P_YS_FED_FW_0001141478": "Cannot find dom node",
        "P_YS_FED_IMP_IOT0000010227": "Gaoping District",
        "P_YS_FED_IMP_IOT0000009166": "Balikun Kazakh Autonomous County",
        "P_YS_FED_IMP_IOT0000009169": "Huangshigang District",
        "P_YS_FED_IMP_IOT0000009167": "Zhongmu County",
        "P_YS_FED_FW_1622974871724097545": "---[本地读取JSON文件报错:]",
        "P_YS_FED_IMP_IOT0000009161": "Weihui",
        "P_YS_FED_IMP_IOT0000009160": "Ansai County",
        "P_YS_FED_FW_1622974871724097548": "---[获取Redis缓存报错:]",
        "P_YS_FED_IMP_IOT0000011564": "Jiande",
        "P_YS_OA_XTTMCENTER_0000035019": "Username",
        "P_YS_FED_IMP_IOT0000011567": "Pengshan County",
        "P_YS_FED_IMP_IOT0000010236": "Shengzhou",
        "P_YS_FED_IMP_IOT0000011566": "Naqu County",
        "P_YS_FED_IMP_IOT0000010237": "Binxian",
        "P_YS_FED_IMP_IOT0000009155": "Lianyun District",
        "P_YS_FED_IMP_IOT0000009152": "Dongchang District",
        "P_YS_FED_FW_1442618603529043968": "Please enter a keyword in the search box to search or switch the category on the left",
        "P_YS_SD_SDMA_0000062635": "…",
        "P_YS_FED_IMP_IOT0000009157": "Yongning District",
        "P_YS_FED_FW_1455751582723342336": "File.xlsx",
        "P_YS_FED_FW_0001152150": "Your permission is insufficient, and it will be saved as a personal scheme. Continue?",
        "P_YS_FED_IMP_IOT0000009150": "Zhijin County",
        "P_YS_FED_IMP_IOT0000010242": "Zhongxian",
        "P_YS_FED_UIMG_0000080080": "It' not allowed to hide related fields",
        "P_YS_FED_IMP_IOT0000010243": "Ningming County",
        "P_YS_FED_IMP_IOT0000011573": "Lingchuan County",
        "P_YS_FED_IMP_IOT0000010244": "Xingtai County",
        "P_YS_FED_IMP_IOT0000010245": "Puding County",
        "P_YS_FED_IMP_IOT0000011570": "Jiangdu",
        "P_YS_FED_IMP_IOT0000010240": "Qinnan District",
        "P_YS_FED_FW_1421773194486874118": "Formula assignment (header) >>:",
        "P_YS_SD_SDMB_0000139799": "Request timed out.",
        "P_YS_FED_IMP_IOT0000011578": "Longjing",
        "P_YS_FED_IMP_IOT0000011577": "Laohekou",
        "P_YS_FED_FW_1421773194486874115": "Formula assignment (detail) >>:",
        "P_YS_FED_IMP_IOT0000010248": "Fengqing County",
        "P_YS_FED_FW_0001152149": "The personal scheme cannot be modified to a public scheme, and it will be saved as a personal scheme. Continue?",
        "P_YS_FED_FW_0001152148": "The public scheme cannot be modified to a personal scheme, and it will be saved as a personal scheme. Continue?",
        "P_YS_FED_FW_1421773194486874112": "Elapsed Time >>",
        "P_YS_FED_IMP_IOT0000009142": "Shuangfeng County",
        "P_YS_FED_IMP_IOT0000009145": "Jianghai District",
        "P_YS_FED_FW_0001026464": "?",
        "P_YS_FED_FW_0000022132": "Line Title",
        "P_YS_FED_IMP_IOT0000009260": "Huichuan District",
        "P_YS_FED_FW_0000022133": "Please enter a number between 1-99",
        "P_YS_FED_FW_0000022130": "System items are not allowed to be deleted",
        "P_YS_FED_FW_0000022131": "Deleted successfully",
        "P_YS_FED_IMP_IOT0000010133": "Xian'an District",
        "P_YS_FED_IMP_IOT0000011463": "Tongbai County",
        "P_YS_FED_IMP_IOT0000010134": "Keshan County",
        "P_YS_FED_IMP_IOT0000011466": "Hanjiang District",
        "P_YS_FED_IMP_IOT0000011465": "Beipiao City",
        "P_YS_SCM_UPU-UI_0001085778": "Order Trend",
        "P_YS_FED_IMP_IOT0000010131": "Yucheng",
        "P_YS_FED_IMP_IOT0000011461": "Muchuan County",
        "P_YS_FED_IMP_IOT0000010136": "Yuhu District",
        "P_YS_FED_IMP_IOT0000011468": "Yangxin County",
        "P_YS_FED_IMP_IOT0000011467": "Songxi County",
        "P_YS_FED_IMP_IOT0000010138": "Wushan County",
        "P_YS_FED_FW_1570021833376792583": "Skip",
        "P_YS_FED_FW_0000022125": "Selected Only",
        "P_YS_FED_FW_0000022126": "(Display at most 16 items)",
        "P_YS_FED_FW_0000022123": "Edit Subscription Scheme",
        "P_YS_FED_IMP_IOT0000009251": "Zhangjiajie",
        "P_YS_FED_FW_0000022124": "Trading Company",
        "P_YS_FED_FW_0000022129": "Save Template",
        "P_YS_FED_FW_0000022127": "Russian",
        "P_YS_FED_IMP_IOT0000009255": "Furong District",
        "P_YS_FED_FW_0000022128": "There can be at most one auxiliary dimension",
        "P_YS_FED_IMP_IOT0000009256": "Yining",
        "P_YS_FED_FW_1582115439097413635": "Please select the mobile side layout.",
        "P_YS_FED_FW_0000022140": "Aux. Dimension Rows",
        "P_YS_FED_FW_0001152050": "The new expiration date cannot be earlier than the new effective date. Please modify the new expiration date",
        "P_YS_FED_FW_0000022143": "Include",
        "P_YS_FED_FW_0000022144": "No such node",
        "P_YS_FED_IMP_IOT0000009250": "Xinfeng County",
        "P_YS_FED_FW_0000022141": "No record to change",
        "P_YS_FED_IMP_IOT0000010144": "Hengxian",
        "P_YS_FED_IMP_IOT0000011474": "Yuanhui District",
        "P_YS_FED_IMP_IOT0000011477": "Yantan District",
        "P_YS_FED_IMP_IOT0000010146": "Xiangcheng County",
        "P_YS_FED_IMP_IOT0000011476": "Daxian",
        "P_YS_FED_IMP_IOT0000011470": "Gand County",
        "P_YS_FED_IMP_IOT0000011473": "Liupanshui",
        "P_YS_FED_IMP_IOT0000010141": "Lanxi County",
        "P_YS_FED_IMP_IOT0000011472": "Zhangbei County",
        "P_YS_FED_IMP_IOT0000009248": "Qimen County",
        "P_YS_FED_IMP_IOT0000011479": "Meixian",
        "P_YS_FED_IMP_IOT0000011478": "Zhijiang Dong Autonomous County",
        "P_YS_FED_IMP_IOT0000010149": "Meihekou",
        "P_YS_FED_FW_0000022136": "Please select filter indicator",
        "P_YS_FED_IMP_IOT0000009242": "Weiyang District",
        "P_YS_FED_FW_0000022137": "Project Name",
        "P_YS_FED_FW_0001152049": "The new effective date cannot be earlier than the current time. Please modify the new effective date",
        "P_YS_FED_IMP_IOT0000009243": "Heping District",
        "P_YS_FED_FW_0000022134": "A row with the same title exists",
        "P_YS_FED_FW_0000022135": "All Info - Group Data  group =",
        "P_YS_FED_IMP_IOT0000009241": "Sangzhi County",
        "P_YS_FED_UCFBASEDOC_0000024874": "Role Name",
        "P_YS_FED_FW_0000022138": "Failed to refresh",
        "P_YS_FED_FW_0000022139": "Display Value",
        "P_YS_FED_UCFBASEDOC_0000024870": "Details",
        "P_YS_FED_IMP_IOT0000011480": "Zhongyang County",
        "P_YS_FED_FW_0000022111": "Title Font Size",
        "P_YS_SD_URETAIL_0001048982": "Please transfer correct parameter.",
        "P_YS_FED_IMP_IOT0000010154": "Xuchang County",
        "P_YS_FED_IMP_IOT0000011486": "Dongping County",
        "P_YS_FED_IMP_IOT0000011485": "Cangxian",
        "P_YS_FED_IMP_IOT0000010156": "Dongsheng City",
        "P_YS_FED_IMP_IOT0000011488": "Huangmei County",
        "P_YS_FED_IMP_IOT0000011487": "Luding County",
        "P_YS_FED_IMP_IOT0000010153": "Qianjiang District",
        "P_YS_FED_FW_0000022109": "Picture + Table",
        "P_YS_FED_IMP_IOT0000009237": "Yicheng",
        "P_YS_FED_FW_0000022103": "Failed to upload",
        "P_YS_FED_FW_0000022104": "Please select map Info",
        "P_YS_FED_IMP_IOT0000009232": "Longquan",
        "P_YS_FED_FW_0000022101": "Auxiliary dimensions exist. Indicators displayed only support single-choice",
        "P_YS_FED_FW_0000022102": "Numeric type fields: [Registered Capital] * 1000, [Matl Details.Online Retail Price]*[Matl Details.Mall - Online Stock Qty]",
        "P_YS_FED_IMP_IOT0000009230": "Shuangtaiziqu",
        "P_YS_FED_FW_0000022107": "Row/Column =",
        "P_YS_FED_FW_0000022108": "Expand More",
        "P_YS_FED_FW_1426978763591122944": "Confirm to withdraw the Doc?",
        "P_YS_FED_FW_0000022105": "Please select lines to move up",
        "P_YS_FED_FW_0000022106": "Please set scheme",
        "P_YS_FED_IMP_IOT0000011490": "Luonan County",
        "P_YS_FED_FW_0000022122": "Codes cannot contain Chinese chars",
        "P_YS_FED_FW_0000022120": "Ranking List",
        "P_YS_SCM_UPU-UI_0001085764": "Not Collected Completely",
        "P_YS_FED_IMP_IOT0000010167": "Yunmeng County",
        "P_YS_FED_IMP_IOT0000011499": "Xinfu District",
        "P_YS_FED_IMP_IOT0000010168": "Fushun County",
        "P_YS_FED_FW_1583735397671763971": "+添加标签",
        "P_YS_FED_IMP_IOT0000011493": "Qinghe District",
        "P_YS_FED_IMP_IOT0000011495": "Qingyuan District",
        "P_YS_FED_FW_0001316754": "Unnamed node",
        "P_YS_FI_FCWEB_0001047917": "Please select at least a row of data.",
        "P_YS_FED_FW_0000022114": "Accounting Entity",
        "P_YS_FED_IMP_IOT0000009220": "Chengdong District",
        "P_YS_FED_FW_0000022115": "Title is required",
        "P_YS_FED_IMP_IOT0000009221": "Subei Mongolian Autonomous County",
        "P_YS_FED_FW_0000022112": "Cannot download the current file",
        "P_YS_FED_FW_0000022113": "Please enter company website address",
        "P_YS_FED_FW_0000022118": "Display indicators are required (you can select up to 4 indicators)",
        "P_YS_FED_FW_0000022119": "When multiple primary dimensions are checked, they will be separated with \"/\"",
        "P_YS_FED_IMP_IOT0000009225": "Nanzhang County",
        "P_YS_FED_FW_0000022116": "Split Qty",
        "P_YS_FED_FW_0000022117": "Delete Current Line",
        "P_YS_SD_UDHBI_0000032336": "To be Confirmed",
        "P_YS_FED_FW_0000022172": "Inner Radius Percentage",
        "P_YS_FED_FW_0000022173": "Hot zone setting picture  Upload picture: error in calling service  info.file.response",
        "P_YS_FED_FW_0000022170": "Entered number length cannot exceed",
        "P_YS_FED_IMP_IOT0000010170": "Cangnan County",
        "P_YS_FED_FW_0000022171": "No data found",
        "P_YS_FED_IMP_IOT0000010171": "Wangdu County",
        "P_YS_FED_FW_0000022176": "(Support up to 3 levels of navigation)",
        "P_YS_FED_FW_0000022177": "Large screen slideshow: switch afterChange",
        "P_YS_FED_FW_0000022174": "Uploaded successfully",
        "P_YS_FED_IMP_IOT0000010178": "Tieshan District",
        "P_YS_FED_IMP_IOT0000010179": "Hebei District",
        "P_YS_FED_IMP_IOT0000010173": "Daye City",
        "P_YS_FED_IMP_IOT0000010175": "Rongxian",
        "P_YS_FED_IMP_IOT0000009217": "Wulingyuan District",
        "P_YS_FED_IMP_IOT0000009218": "Dangyang",
        "P_YS_FED_IMP_IOT0000009219": "Gaoyou",
        "P_YS_FED_UCFBASEDOC_0000024847": "Discount",
        "P_YS_FED_FW_0000022169": "Large Screen Solution  Design  eChartPanelDesigngetPreView End",
        "P_YS_FED_FW_0000022167": "No data in the current template",
        "P_YS_FED_FW_0000022168": "Please enter keywords",
        "P_YS_FED_IMP_IOT0000009212": "Fengdu County",
        "P_YS_FED_FW_0000022183": "Large screen slideshow: error in obtaining template list Info. Template panelIds =",
        "P_YS_FED_FW_0000022184": "eChartPanelDisplay Double-clicking Event",
        "P_YS_FED_IMP_IOT0000010180": "New town area",
        "P_YS_FED_FW_0000022181": "Set Summary Region  eChartConfig",
        "P_YS_FED_IMP_IOT0000010181": "Tongzhou",
        "P_YS_FED_FW_0000022187": "Enterprise Logo",
        "P_YS_FED_FW_0000022188": "Update",
        "P_YS_FED_FW_0000022186": "Failed to save summary area settings. Info:",
        "P_YS_FED_IMP_IOT0000010183": "Wuzhai County",
        "P_YS_FED_FW_0000022180": "Font Size",
        "P_YS_FED_IMP_IOT0000010185": "Bianba County",
        "P_YS_FED_IMP_IOT0000010186": "Pengshui Miao and Tujia Autonomous County",
        "P_YS_FED_IMP_IOT0000009205": "Huanggu District",
        "P_YS_FED_FW_0000022178": "Drag and drop menu items in the order you like",
        "P_YS_FED_FW_0000022179": "Alignment",
        "P_YS_FED_FW_0000022150": "eChartDisplay  Status changed  shouldComponentUpdate  End false",
        "P_YS_FED_FW_0000022151": "Confirm to disable?",
        "P_YS_FED_FW_0000022154": "Restore",
        "P_YS_FED_FW_0000022155": "Business Dept",
        "P_YS_FED_FW_0001456968": "条数据允许打印\\n",
        "P_YS_FED_FW_0000022152": "Large screen board saved",
        "P_YS_OA_XTWEIYOU_0000046261": "Folder",
        "P_YS_FED_FW_0000022153": "Exclude",
        "P_YS_FED_IMP_IOT0000010198": "Fengshan County",
        "P_YS_FED_IMP_IOT0000010194": "Yuhong District",
        "P_YS_OA_XTWEIYOU_0000046266": "Send",
        "P_YS_FED_FW_0000022147": "Error in obtaining FieldValue of hot zone. obj =",
        "P_YS_FED_FW_0000022148": "Ref Type",
        "P_YS_FED_FW_0000022145": "Add Chart",
        "P_YS_FED_UCFBASEDOC_0000024820": "To",
        "P_YS_FED_FW_0000022146": "Failed to obtain the dimension list",
        "P_YS_FED_FW_0000022149": "Summary",
        "P_YS_PF_GZTSYS_0000011901": "Doc Entry and Mgmt Rules",
        "P_YS_FED_FW_0000022161": "Bubble Chart",
        "P_YS_FED_FW_0000022162": ")",
        "P_YS_FED_FW_0000022160": "Failed to load the current page",
        "P_YS_FED_FW_0000022165": "In the profile, group item field [",
        "P_YS_FED_FW_0000022166": "Total",
        "P_YS_FED_FW_0000022163": "File Value",
        "P_YS_FED_FW_0000022164": "Min",
        "P_YS_FED_FW_1593218496493780999": "Los resultados de la búsqueda conjunta de documentos muestran",
        "P_YS_FED_FW_0000022158": "File to upload exceeds limit. Please upload again",
        "P_YS_FED_FW_0000022159": "Please enter a number between 1-31",
        "P_YS_FED_FW_0000022156": " pieces",
        "P_YS_FED_FW_0000022157": "Subscription Settings",
        "P_YS_PF_GZTSYS_0000011912": "Supplier Property",
        "P_YS_FED_FW_0001460129": "Please enter a valid email address",
        "P_YS_FED_FW_0001243335": "Null",
        "P_YS_FED_FW_0001243334": "MB, and the data volume cannot exceed 100,000 pieces",
        "P_YS_FED_FW_0001243333": "In progress...",
        "P_YS_FED_FW_1554658615102537733": "Up to 15 bits allowed",
        "P_YS_OA_app_xtywlj_0000037515": "Voucher Name",
        "P_YS_FED_FW_0001460130": "Please enter a 7~8-digit telephone number",
        "P_YS_FED_FW_0001460133": "Please enter a valid mobile number",
        "P_YS_FED_FW_0001460132": "Please enter a 3~4-digit area code",
        "P_YS_FED_FW_0001460131": "Please enter a 11-digit mobile number",
        "P_YS_OA_XTWEIYOU_0000046277": "Close All",
        "P_YS_SD_UDHAR_0000116811": "Attachment is required",
        "P_YS_FED_FW_0001134231": "There's a line with no title, or no new value is assigned to the line title",
        "P_YS_FI_YYFI-UI_0000161301": "Copy Line",
        "P_YS_FED_FW_1604430517195243523": "不允许使用user.tenant.和user.option.获取，请使用tenan.和option.！！",
        "P_YS_SD_UDHWS_0000067925": "Order No.",
        "P_YS_SD_UDHBA_0000137530": "Total Number of Rows",
        "P_YS_SD_SDMAUF_0000151755": "Deposit",
        "P_YS_FED_FW_0001045602": "<%=total%> pieces in total",
        "P_YS_FED_FW_0001045601": "I don't know",
        "P_YS_FED_FW_1467112879311290368": "Only view required items",
        "P_YS_HR_HRXCF_0000072919": "Select All",
        "P_YS_FED_FW_0001031014": "≤",
        "P_YS_PF_PRINT_0000065174": "Primary UOM",
        "P_YS_FED_FW_0001473475": "Failed to change",
        "P_YS_FED_UIMG_0001088007": "Tips",
        "P_YS_FED_FW_0001473474": "After it takes effect, the business unit used in the business field will be updated, which is irreversible. Continue?",
        "P_YS_FED_FW_1610061184968425476": "---[获取JSON文件报错:]",
        "P_YS_PF_PROCENTER_0000023174": "Product Name",
        "P_YS_FED_FW_0001160539": "Phone number missing",
        "P_YS_FED_FW_0000022100": "Subscription Status",
        "P_YS_SCM_UPU-UI_0001085746": "Null",
        "P_YS_FED_FW_0001007382": "No data",
        "P_YS_PF_PRINT_0000065185": "Pieces",
        "P_YS_FED_FW_1450555256411258883": "获取定位失败, ERROR(",
        "P_YS_FED_FW_1450555256411258880": "%c: reset the geographic location to the location of the current user",
        "P_YS_SCM_UPU-UI_0001085715": "Remind",
        "P_YS_SD_UDHWN_0000047991": "Haidian District",
        "P_YS_FED_FW_1521253227064459268": "Intersecting",
        "P_YS_FED_FW_0001233973": "Missing wpsPreview method",
        "P_YS_FED_UIMG_0000157462": "[Hint] If Enterprise Language is empty, then current language will be used",
        "P_YS_FED_UIMG_0000157460": "Current Language",
        "P_YS_FED_UIMG_0000157461": "Enterprise Language",
        "P_YS_SD_UDHBN_0001144476": "Doc No.：$var{code}$var_end",
        "P_YS_FED_IMP_IOT0000005578": "Zhangpu County",
        "P_YS_FED_IMP_IOT0000005571": "Taihe County",
        "P_YS_FED_IMP_IOT0000005570": "Tai'an County",
        "P_YS_FED_IMP_IOT0000005572": "Baixiang County",
        "P_YS_FED_FW_0001123276": "Export all data?",
        "P_YS_FED_FW_0001123277": "Auto Search",
        "P_YS_FED_FW_0001123274": "You can export at most 50,000 pieces each time. Please try again after resetting query criteria",
        "P_YS_FED_FW_0001123275": "No data found. Please reset query criteria",
        "000723": "Please enter the URL",
        "P_YS_FED_IMP_IOT0000006894": "Ziyang District",
        "P_YS_FED_IMP_IOT0000006897": "Nanjiang County",
        "P_YS_FED_IMP_IOT0000006899": "Yilan County",
        "P_YS_FED_IMP_IOT0000005568": "Org 3",
        "P_YS_FED_IMP_IOT0000005567": "Confirm",
        "P_YS_OA_app_xtywlj_0000037365": "Ignore",
        "P_YS_FED_IMP_IOT0000006891": "Fengshun County",
        "P_YS_FED_IMP_IOT0000006890": "Xinzhou District",
        "P_YS_FED_IMP_IOT0000006893": "Kenli County",
        "P_YS_FED_IMP_IOT0000006892": "Langxi County",
        "P_YS_FED_UCFORG_0000027586": "On",
        "P_YS_FED_IMP_IOT0000006884": "Dianjiang County",
        "P_YS_FED_IMP_IOT0000006883": "Jiangkou County",
        "P_YS_FED_IMP_IOT0000005557": "Org 2",
        "P_YS_FED_IMP_IOT0000006887": "Qingyang District",
        "P_YS_FED_IMP_IOT0000005558": "Org 1",
        "P_YS_FED_IMP_IOT0000006889": "Pingluo County",
        "P_YS_FED_IMP_IOT0000006882": "Donghai County",
        "P_YS_FED_IMP_IOT0000006873": "Jianping County",
        "P_YS_FED_IMP_IOT0000005541": "Non-empty",
        "P_YS_FED_IMP_IOT0000006872": "Shangyi County",
        "P_YS_FED_IMP_IOT0000006875": "Majiang County",
        "P_YS_FED_IMP_IOT0000006877": "Lengshuijiang",
        "P_YS_FED_IMP_IOT0000006876": "Zhenlai County",
        "P_YS_FED_FW_1482737996175769616": "Layout Location",
        "P_YS_FED_FW_1482737996175769619": "Mobile Scheme",
        "P_YS_FED_IMP_IOT0000006869": "Longzihu District",
        "P_YS_FED_FW_1482737996175769610": "Set Item",
        "P_YS_FED_FW_1482737996175769613": "Save as New Scheme",
        "P_YS_FED_IMP_IOT0000005531": "Start ~ End",
        "P_YS_FED_IMP_IOT0000006862": "Dadukou District",
        "P_YS_FED_IMP_IOT0000006864": "Yiyang County",
        "P_YS_FED_UCFORG_0000027572": "Close",
        "P_YS_FED_IMP_IOT0000006863": "Pulandian",
        "P_YS_FED_IMP_IOT0000006866": "Yanshi",
        "P_YS_FED_IMP_IOT0000006865": "Xilinhot",
        "P_YS_FED_FW_1482737996175769604": "Set as Default Scheme",
        "P_YS_FED_FW_1482737996175769607": "Manual Search",
        "P_YS_FI_CM_0000029423": "Right-click to Save as Picture",
        "P_YS_FED_FW_1482737996175769601": "别看了啥也没有",
        "P_YS_FED_IMP_IOT0000006851": "Tongguanshan District",
        "P_YS_FED_FW_0001249254": "Copied to the clipboard",
        "P_YS_FED_IMP_IOT0000006850": "Jinshui District",
        "P_YS_FED_IMP_IOT0000005522": ", order No.:",
        "P_YS_FED_IMP_IOT0000006854": "Nanpi County",
        "P_YS_FED_IMP_IOT0000006856": "Dawukou District",
        "P_YS_HR_HRYGF_0000058851": "Boolean",
        "P_YS_OA_XTGONGWEN_0000045538": "Sign in",
        "P_YS_FED_FW_0001131726": "Person",
        "P_YS_FED_IMP_IOT0000006848": "Chengguan District",
        "P_YS_FED_IMP_IOT0000006847": "Cockscomb",
        "P_YS_FED_IMP_IOT0000006849": "Qingtian County",
        "P_YS_FED_FW_0001131728": "OK",
        "P_YS_FED_FW_0001131727": "Cancel",
        "P_YS_FED_FW_0001060872": "Invalid value",
        "P_YS_FED_IMP_IOT0000006840": "Suijiang County",
        "P_YS_FED_FW_0001060873": "File service not configured",
        "P_YS_FED_IMP_IOT0000006844": "Kangbao County",
        "P_YS_FED_IMP_IOT0000005514": "Next",
        "P_YS_FED_FW_1556026785534574596": "There is a non-empty (or empty) query in the current query scheme. Do you want to continue saving?",
        "P_YS_OA_LCGL_0000037254": "Batch Delete",
        "P_YS_FED_FW_0001060869": "Switching the primary Org will clear the data. Continue?",
        "P_YS_FED_IMP_IOT0000006837": "Fuyu County",
        "P_YS_FED_IMP_IOT0000006836": "Funing County",
        "P_YS_SCM_PU_0000028543": "Failed to obtain data",
        "P_YS_SD_UDHBN_0001144481": "Delivery Date: $var{recieveDate}$var_end Amount: $var{qty}$var_end",
        "P_YS_FED_IMP_IOT0000005507": "Terminate",
        "P_YS_FED_FW_1482737996175769622": "Search Method",
        "P_YS_FED_IMP_IOT0000006830": "Qingyun spectrum area",
        "P_YS_FED_IMP_IOT0000006833": "Daocheng County",
        "P_YS_FED_IMP_IOT0000006832": "Qingyang County",
        "P_YS_FED_IMP_IOT0000006835": "Dingjie County",
        "P_YS_FED_IMP_IOT0000005503": "Query",
        "P_YS_SCM_USTOCK-UI_0000176083": "Electronic Fence",
        "P_YS_FED_IMP_IOT0000006826": "Guoyang County",
        "P_YS_FED_IMP_IOT0000006828": "Runzhou District",
        "P_YS_HR_HRYGF_0000058837": "Enumeration",
        "P_YS_FED_IMP_IOT0000006829": "Shenchi County",
        "P_YS_FED_IMP_IOT0000006822": "Linshu County",
        "P_YS_FED_IMP_IOT0000006823": "Qumalai County",
        "P_YS_FED_IMP_IOT0000009098": "Zhangjiagang",
        "P_YS_FED_IMP_IOT0000009091": "Jiedong County",
        "P_YS_FED_IMP_IOT0000009090": "Ewenki Autonomous Banner",
        "P_YS_PF_SOCD-E_0000433293": "Shannan City",
        "P_YS_FED_IMP_IOT0000009096": "Nanfeng County",
        "P_YS_FED_IMP_IOT0000009093": "Dongxihu District",
        "P_YS_FED_IMP_IOT0000006815": "Avati County",
        "P_YS_FED_IMP_IOT0000006817": "Longchuan County",
        "P_YS_FED_IMP_IOT0000006816": "Pingquan County",
        "P_YS_OA_LCGL_0000037261": "Advanced",
        "P_YS_FED_FW_0001143732": "lineNoStep() parameter is invalid",
        "P_YS_FED_IMP_IOT0000009080": "Yuzhong District",
        "P_YS_PF_SOCD_0000066122": "El Salvador",
        "P_YS_FED_IMP_IOT0000009081": "Rongchang County",
        "project.tag.tag07": "Internet",
        "P_YS_MF_PO-FE_0001118286": "?",
        "P_YS_FED_IMP_IOT0000009083": "Wanrong County",
        "P_YS_FED_IMP_IOT0000006804": "Longzhou County",
        "P_YS_FED_FW_0001264815": "List Settings",
        "P_YS_FED_IMP_IOT0000011400": "Weining Yi and Hui Autonomous County",
        "P_YS_FED_IMP_IOT0000006808": "Xi'an District",
        "P_YS_FED_IMP_IOT0000006809": "Ruyang County",
        "P_YS_FED_IMP_IOT0000011406": "Wenjiang District",
        "P_YS_FED_IMP_IOT0000011405": "Yushan County",
        "P_YS_FED_IMP_IOT0000011408": "Jingzhou District",
        "P_YS_FED_IMP_IOT0000006800": "Jianli County",
        "P_YS_FED_IMP_IOT0000011403": "Anren County",
        "P_YS_FED_IMP_IOT0000009075": "Qinbei District",
        "P_YS_PF_TRS_0000034743": "Age",
        "P_YS_FED_IMP_IOT0000009076": "Hangzhou",
        "P_YS_FED_IMP_IOT0000009079": "Renxian",
        "P_YS_FED_IMP_IOT0000009074": "Puyang",
        "P_YS_FED_IMP_IOT0000011411": "Luoning County",
        "P_YS_FED_IMP_IOT0000011416": "Wuwei County",
        "P_YS_FED_IMP_IOT0000011419": "Yunyan District",
        "P_YS_FED_IMP_IOT0000011418": "Zhumadian",
        "P_YS_PF_GZTTMP_0000074112": "Food",
        "P_YS_SD_UDHWN_0000050056": "Wenchang",
        "P_YS_FED_IMP_IOT0000009065": "Nancha District",
        "P_YS_FED_IMP_IOT0000009068": "Hejiang County",
        "P_YS_PF_SOCD_0000066131": "Fiji",
        "P_YS_FED_IMP_IOT0000009069": "Xinxian",
        "P_YS_FED_FW_0001026106": "<%=alertStrPrefix%> Enter at least one line of data",
        "P_YS_FED_IMP_IOT0000009062": "Fangchenggang",
        "P_YS_FED_IMP_IOT0000009063": "Changle County",
        "P_YS_FED_IMP_IOT0000009060": "Jiading District",
        "P_YS_FED_IMP_IOT0000009061": "Baohe District",
        "P_YS_FED_IMP_IOT0000011421": "Lanxi",
        "P_YS_FED_IMP_IOT0000011429": "Fuxing District",
        "P_YS_FED_IMP_IOT0000011424": "Jingxian",
        "P_YS_FED_IMP_IOT0000011426": "Xiushui County",
        "P_YS_FED_IMP_IOT0000011425": "Close",
        "P_YS_FED_IMP_IOT0000009054": "Toxon County",
        "P_YS_FED_IMP_IOT0000009057": "Yongxin County",
        "P_YS_FED_IMP_IOT0000009051": "Yushe County",
        "P_YS_FED_IMP_IOT0000009050": "Chibi City",
        "P_YS_FED_IMP_IOT0000010100": "Lingqiu County",
        "P_YS_FED_IMP_IOT0000010101": "Beitang District",
        "P_YS_FED_IMP_IOT0000011432": "Lanshan District",
        "P_YS_PF_VPA_0000082557": "Failed to call",
        "P_YS_FED_FW_0001125804": "specialcom's cStyle not configured",
        "P_YS_FED_FW_0001125803": "Cannot find specialcom's target model:",
        "P_YS_FED_IMP_IOT0000010104": "Nankang",
        "P_YS_FED_IMP_IOT0000010105": "Yajiang County",
        "P_YS_FED_IMP_IOT0000011437": "Suichuan County",
        "P_YS_SD_SDOC_0000164303": "Deliver",
        "P_YS_FED_IMP_IOT0000009042": "Xihe District",
        "P_YS_FED_IMP_IOT0000009046": "Ninghua County",
        "P_YS_FED_IMP_IOT0000009040": "Ziyang County",
        "P_YS_FED_IMP_IOT0000009041": "Baiyun District",
        "P_YS_FED_IMP_IOT0000010111": "Tianhe District",
        "P_YS_FED_IMP_IOT0000011441": "Wangcang County",
        "P_YS_FED_IMP_IOT0000011443": "Hengshan County",
        "P_YS_FED_IMP_IOT0000011440": "Badong County",
        "P_YS_FED_FW_0001143784": "Interaction Rule",
        "P_YS_FED_IMP_IOT0000010118": "Xuanzhou District",
        "P_YS_FED_IMP_IOT0000010119": "New City",
        "P_YS_FED_IMP_IOT0000011449": "Dunhuang",
        "P_YS_FED_IMP_IOT0000009039": "Geji County",
        "P_YS_FED_FW_0001143783": "Interaction Rule Initialization",
        "P_YS_FED_IMP_IOT0000010114": "Emeishan",
        "P_YS_FED_IMP_IOT0000011447": "Karaqin Banner",
        "P_YS_FED_IMP_IOT0000009031": "Shuimogou District",
        "P_YS_FED_IMP_IOT0000009037": "Changning",
        "P_YS_FED_IMP_IOT0000009036": "Zhenghe County",
        "P_YS_FED_FW_0001155764": "Insufficient permission",
        "P_YS_FED_FW_1503620195896262656": "Accurate Search",
        "P_YS_FED_IMP_IOT0000011453": "Hanshan County",
        "P_YS_FED_IMP_IOT0000010122": "Liyang City",
        "P_YS_FED_IMP_IOT0000010123": "Pengjiang District",
        "P_YS_FED_IMP_IOT0000011454": "Gannan County",
        "P_YS_FED_IMP_IOT0000010120": "Yongxing County",
        "P_YS_FED_IMP_IOT0000011450": "Qindu District",
        "P_YS_FED_IMP_IOT0000010129": "Pingnan County",
        "P_YS_FED_IMP_IOT0000009028": "Beichen District",
        "P_YS_FED_IMP_IOT0000010125": "Datian County",
        "P_YS_FED_IMP_IOT0000011456": "Yumen",
        "P_YS_FED_IMP_IOT0000009023": "Kaiyang County",
        "P_YS_OA_XTMENHUCMS_0000045358": "Add description",
        "P_YS_FED_IMP_IOT0000009027": "Pingwu County",
        "P_YS_FED_IMP_IOT0000009025": "Dongguang County",
        "P_YS_FED_FW_0000022250": "Error in initialization",
        "P_YS_FED_FW_0000022253": "No map component in the current area",
        "P_YS_FED_FW_0000022254": "s integer",
        "P_YS_FED_FW_0000022251": "Map",
        "P_YS_FED_FW_0000022252": "Operation succeeded",
        "P_YS_FED_FW_1435891525106532352": "The following field is incorrect (or required)",
        "P_YS_FED_EXAMP_0000020085": "Order Property",
        "P_YS_FED_IMP_IOT0000010011": "Xixiangtang District",
        "P_YS_FED_EXAMP_0000020084": "No product line that requires auto picking",
        "P_YS_FED_EXAMP_0000020087": "Please enter the starting card/voucher No.",
        "P_YS_FED_IMP_IOT0000011345": "Licheng District",
        "server.rest.idcard.is.wrong": "Incorrect ID No. format.",
        "P_YS_FED_EXAMP_0000020086": "[Exception]",
        "P_YS_OA_XTWEIYOU_0000046327": "All Read",
        "P_YS_FED_EXAMP_0000020081": "SKU Name",
        "P_YS_FED_EXAMP_0000020080": "Payment via member wallet is unavailable",
        "P_YS_FED_EXAMP_0000020082": "No applicable promotion activity",
        "P_YS_FED_IMP_IOT0000010010": "Fengyang County",
        "P_YS_FED_IMP_IOT0000010019": "Jining City",
        "P_YS_FED_IMP_IOT0000009139": "Dulong Deqing County",
        "P_YS_FED_EXAMP_0000020078": "Point deduction cannot be executed for child product",
        "P_YS_FED_IMP_IOT0000011347": "Peixian",
        "P_YS_FED_EXAMP_0000020077": "Debugging user verification failed",
        "P_YS_FED_IMP_IOT0000010017": "Kaiping City",
        "P_YS_FED_EXAMP_0000020079": "Failed to obtain network print settings",
        "P_YS_FED_FW_0000022246": "Incorrect setting of entries displayed",
        "P_YS_FED_FW_0000022247": "Keep Inner Layer Spacing",
        "P_YS_FED_FW_0001065740": "No more than 20 chars",
        "P_YS_FED_IMP_IOT0000009133": "Guangde County",
        "P_YS_FED_FW_0000022244": "Please set summary field",
        "P_YS_FED_IMP_IOT0000009130": "Longgang District",
        "P_YS_FED_FW_0000022245": "Style",
        "P_YS_FED_IMP_IOT0000009137": "Luopu County",
        "P_YS_FED_FW_0000022248": "The large screen summary area setting will not automatically refresh. refreshInterval",
        "P_YS_FED_FW_0001065741": "Name length exceeds 20 chars",
        "P_YS_FED_IMP_IOT0000009134": "Yongjing County",
        "P_YS_FED_FW_0000022249": "To",
        "P_YS_FED_IMP_IOT0000009135": "Nanling County",
        "P_YS_FED_FW_0000022260": "The number entered cannot be greater than",
        "P_YS_FED_FW_0001345199": "No filterId configured in the current template. Cannot obtain the query scheme data",
        "P_YS_FED_FW_0000022261": "Unselect",
        "P_YS_FED_EXAMP_0000020090": "Measured weight is lower than the standard weight. Please check if the tray and product are placed correctly",
        "P_YS_FED_FW_0000022264": "Operator is required. Please check",
        "P_YS_FED_FW_0000022265": "Display Line",
        "P_YS_FED_FW_0000022262": "No template data",
        "P_YS_FED_FW_0001371485": "Aggregate Floating Display",
        "P_YS_FED_FW_0000022263": " pieces, failed",
        "P_YS_FED_EXAMP_0000020096": "The card/voucher No. range entry method has been used. Cannot enter card No.",
        "P_YS_FED_FW_0001292111": "请求接口地址:(",
        "P_YS_FED_EXAMP_0000020095": "Network is unavailable now. Cannot use this function",
        "P_YS_FED_IMP_IOT0000011353": "Jianshi County",
        "P_YS_FED_EXAMP_0000020098": "Cannot execute on-site discount",
        "P_YS_FED_EXAMP_0000020097": "Payment failed. The payment made via ChanPay needs to be canceled. Cancel it online?",
        "P_YS_FED_IMP_IOT0000011355": "Qinhuai District",
        "P_YS_FED_FW_0001292112": "接口返回数据:(",
        "P_YS_FED_EXAMP_0000020092": "Header discount has been executed. Cannot add product again",
        "P_YS_FED_IMP_IOT0000011350": "Mozhugongka County",
        "P_YS_FED_EXAMP_0000020091": "Sat",
        "P_YS_FED_EXAMP_0000020094": "Retail Amt is 0. Error in calculating discount",
        "P_YS_FED_IMP_IOT0000010020": "Yanta District",
        "P_YS_FED_EXAMP_0000020093": "Period:",
        "P_YS_FED_IMP_IOT0000010021": "Wuqia County",
        "P_YS_FED_IMP_IOT0000011351": "Sunan Yugu Autonomous County",
        "P_YS_FED_IMP_IOT0000009129": "Wenshan County",
        "P_YS_FED_EXAMP_0000020089": "UnionPay",
        "P_YS_FED_EXAMP_0000020088": "Incorrect server address format",
        "P_YS_FED_IMP_IOT0000010028": "Wuhan",
        "P_YS_FED_IMP_IOT0000010029": "Liannan Yao Autonomous County",
        "P_YS_FED_IMP_IOT0000011359": "Shucheng County",
        "P_YS_FED_IMP_IOT0000009121": "Guangzong County",
        "P_YS_FED_FW_0000022258": "New Subscription Scheme",
        "P_YS_FED_FW_0000022255": "Add",
        "P_YS_FED_FW_0000022256": "No line selected",
        "P_YS_FED_IMP_IOT0000009125": "Weibin District",
        "P_YS_FED_FW_0001648419": "Set as Tenant-level Template",
        "P_YS_FED_FW_0000022259": "Indicators displayed in bubble charts only support single-choice",
        "P_YS_FED_IMP_IOT0000009123": "Merist Daur District",
        "P_YS_FED_FW_0001026167": "Cannot find menu code <%=menuCode%>",
        "P_YS_FED_IMP_IOT0000009124": "Lingtai County",
        "P_YS_FED_FW_0000022232": "Decimal Places",
        "P_YS_FED_FW_0000022230": "Title Content",
        "P_YS_FED_IMP_IOT0000010033": "Fei County",
        "P_YS_FED_IMP_IOT0000011365": "Siming District",
        "P_YS_FED_IMP_IOT0000011367": "Geely District",
        "P_YS_FED_IMP_IOT0000010036": "Jishou",
        "P_YS_FED_IMP_IOT0000011360": "Xixia County",
        "P_YS_FED_IMP_IOT0000010031": "Lucheng District",
        "P_YS_FED_IMP_IOT0000011363": "Zarut Banner",
        "P_YS_FED_IMP_IOT0000009116": "Liping County",
        "P_YS_FED_EXAMP_0000020099": "Preset",
        "P_YS_FED_IMP_IOT0000010038": "Datong County",
        "P_YS_FED_IMP_IOT0000011368": "Jiangnan District",
        "P_YS_FED_FW_0000022224": "Dimension Navigation Scheme",
        "P_YS_FED_FW_0000022225": "Processed in total",
        "P_YS_FED_FW_0000022222": "(The total size of all the attachments cannot exceed",
        "P_YS_FED_FW_0000022223": "Use",
        "P_YS_FED_FW_0001026130": "<%=text%> upload failed",
        "P_YS_FED_FW_0000022228": "Column Name",
        "P_YS_FED_IMP_IOT0000009114": "Qujiang District",
        "P_YS_FED_FW_0000022229": "Please enter the No. of ripple effects",
        "P_YS_FED_IMP_IOT0000009115": "Qixia",
        "P_YS_FED_FW_0000022226": "Favorite Function Settings",
        "P_YS_FED_FW_0001026133": "No more than <%=text%> M",
        "P_YS_FED_IMP_IOT0000009112": "Xiji County",
        "P_YS_FED_FW_0000022227": "No found",
        "P_YS_FED_FW_0001026137": "<%=text%> is already used in graph reports. Cannot delete",
        "P_YS_FED_FW_0000022242": "Confirm to enable?",
        "P_YS_FED_FW_0000022243": "Data Item",
        "P_YS_FED_FW_0000022240": "Primary Org and Template Name are required",
        "P_YS_FED_FW_0000022241": "Please enter scheme name",
        "P_YS_FED_IMP_IOT0000010045": "Danling County",
        "P_YS_FED_IMP_IOT0000011375": "Luoding",
        "P_YS_FED_IMP_IOT0000011378": "Taishun County",
        "P_YS_FED_IMP_IOT0000010040": "Luzhai County",
        "P_YS_FED_IMP_IOT0000011371": "Xiangyuan County",
        "P_YS_FED_IMP_IOT0000010042": "Yellow flag",
        "P_YS_FED_IMP_IOT0000011374": "Linwei District",
        "P_YS_FED_IMP_IOT0000010043": "Pu'an County",
        "P_YS_FED_IMP_IOT0000011373": "Suoxian",
        "P_YS_FED_IMP_IOT0000009105": "Ningguo",
        "P_YS_FED_IMP_IOT0000010048": "Guangling County",
        "P_YS_FED_IMP_IOT0000010049": "Daming County",
        "P_YS_FED_IMP_IOT0000011379": "Minle County",
        "P_YS_FED_FW_0000022235": "Select at most 5 summary items",
        "P_YS_SD_SDMBF_0000143365": "Game",
        "P_YS_FED_FW_0000022236": "Navigation",
        "P_YS_FED_FW_0000022233": "Large screen solution  Display  this.serieNum =",
        "P_YS_FED_FW_0000022234": "Portuguese",
        "P_YS_FED_FW_0000022239": "Click to upload background picture",
        "P_YS_FED_FW_0000022237": "Entries Displayed",
        "P_YS_FED_IMP_IOT0000009101": "Heping County",
        "P_YS_FED_FW_0000022238": "Template name is required",
        "P_YS_FED_IMP_IOT0000009102": "Feixi County",
        "P_YS_FED_FW_0000022293": "Medium",
        "P_YS_FED_FW_0000022294": "Operation information",
        "P_YS_FED_FW_0000022291": "Inv Org",
        "P_YS_FED_IMP_IOT0000011381": "Mengzhou",
        "P_YS_FED_FW_0000022292": "Large screen solution 2  eChartPanelDisplay2  Display  constructor",
        "P_YS_FED_IMP_IOT0000010050": "Xincai County",
        "P_YS_FED_IMP_IOT0000011380": "Changning County",
        "P_YS_FED_FW_0000022297": "Confirm to delete?",
        "P_YS_FED_FW_0000022298": "Save failed",
        "P_YS_FED_FW_0000022295": "No picture",
        "P_YS_FED_FW_0000022296": "Please ensure that the data type setting is correct. It cannot be adjusted once enabled",
        "P_YS_FED_EXAMP_0000020041": "Suggested retail price:",
        "P_YS_FED_EXAMP_0000020040": "Intelligent Repl. Rules",
        "P_YS_FED_EXAMP_0000020043": "Data error. Please check",
        "P_YS_FED_IMP_IOT0000010057": "Zhenyuan Yi Hani Lahu Autonomous County",
        "P_YS_FED_EXAMP_0000020042": "Error in the wallet account Info",
        "P_YS_FED_IMP_IOT0000010058": "Donggang",
        "P_YS_FED_IMP_IOT0000011388": "Lunan District",
        "P_YS_FED_IMP_IOT0000011383": "Jinzhou",
        "P_YS_SD_SDMAUF_0000152734": "Hello",
        "P_YS_FED_FW_0000022290": "Less than or equal to",
        "P_YS_FED_IMP_IOT0000010053": "Huaibin County",
        "P_YS_FED_IMP_IOT0000011385": "Zhongshan Area",
        "P_YS_FED_EXAMP_0000020038": "Discount Voucher",
        "P_YS_FED_EXAMP_0000020037": "Weight",
        "P_YS_FED_EXAMP_0000020039": "Select industry",
        "P_YS_FED_EXAMP_0000020034": "Xidan Store",
        "P_YS_FED_IMP_IOT0000010059": "Ruili",
        "P_YS_FED_EXAMP_0000020033": "Please check if the prepaid card for refund is correct and valid",
        "P_YS_FED_EXAMP_0000020036": "No local electronic scale adapted",
        "P_YS_FED_EXAMP_0000020035": "s menu",
        "P_YS_FED_FW_0000022288": "(Note: refreshing too often may cause excessive server pressure)",
        "P_YS_FED_FW_0000022289": "Title content is required",
        "P_YS_FED_FW_1607450978713862149": "<div>UI模板名称：",
        "P_YS_FED_FW_1607450978713862146": "</div><div>UI模板ID：",
        "P_YS_FED_IMP_IOT0000011392": "Hantai District",
        "P_YS_SD_UDHWN_0000122271": "Please enter ID number",
        "P_YS_FED_EXAMP_0000020052": "Not available to execute",
        "P_YS_FED_IMP_IOT0000011398": "Wuxiang County",
        "P_YS_FED_EXAMP_0000020051": "In card No. range",
        "P_YS_FED_IMP_IOT0000011397": "Yiwu County",
        "P_YS_FED_EXAMP_0000020054": "Delete Line",
        "P_YS_FED_EXAMP_0000020053": "Product File",
        "P_YS_FED_IMP_IOT0000011399": "Xinyi City",
        "P_YS_FED_IMP_IOT0000010062": "Changtu County",
        "P_YS_FED_IMP_IOT0000010063": "Shilin Yi Autonomous County",
        "P_YS_FED_EXAMP_0000020050": "Business Menu",
        "P_YS_FED_IMP_IOT0000011395": "Shuangpai County",
        "P_YS_FED_EXAMP_0000020049": "No prepaid card entered",
        "P_YS_FED_EXAMP_0000020048": "Booked successfully",
        "P_YS_FED_EXAMP_0000020045": "Shift Ex.",
        "P_YS_FED_FW_1420997849809682432": "YYYY-ww周",
        "P_YS_FED_EXAMP_0000020044": "Weighing device connection exception",
        "P_YS_FED_EXAMP_0000020047": "Click Yes to select the current voucher, otherwise, no voucher will be selected",
        "P_YS_FED_EXAMP_0000020046": "Adjust",
        "P_YS_FED_FW_0000022299": "Primary Dimension Sorting",
        "P_YS_FED_FW_0000022271": "Add Ranking Column",
        "P_YS_FED_FW_0000022272": "Confirm to delete the selected template?",
        "P_YS_FED_FW_0000022270": "3. Logical expressions only support logical operations between equality expressions consisting of \"=, !=\", for example:",
        "P_YS_FED_IMP_IOT0000010072": "Linzi District",
        "P_YS_FED_FW_0000022275": "Indicators",
        "P_YS_FED_FW_0000022276": "· or Operator (||):[Specification]!=null||[Matl Short Name]!=null",
        "P_YS_FED_FW_0000022273": "No search result",
        "P_YS_FED_FW_0000022274": "R&D Center",
        "P_YS_FED_EXAMP_0000020063": "]'s corresponding collection method",
        "P_YS_FED_EXAMP_0000020062": "Product Label",
        "P_YS_FED_EXAMP_0000020065": "Cannot modify Qty in the current Doc status",
        "P_YS_FED_EXAMP_0000020064": "No such voucher",
        "P_YS_FED_IMP_IOT0000010074": "Xuanhan County",
        "P_YS_FED_EXAMP_0000020061": "The card No. has been entered",
        "P_YS_FED_EXAMP_0000020060": "Recommender Mobile",
        "P_YS_FED_IMP_IOT0000010076": "Cengong County",
        "P_YS_FED_EXAMP_0000020059": "Customize",
        "P_YS_FED_EXAMP_0000020056": "Not matched",
        "P_YS_FED_EXAMP_0000020055": "Room type of (room No.)",
        "P_YS_FED_EXAMP_0000020058": "Wrong verification code",
        "P_YS_FED_EXAMP_0000020057": "After-sales Service",
        "P_YS_FED_FW_0000022268": "Header",
        "P_YS_FED_FW_0001010614": "Picture height cannot exceed",
        "P_YS_FED_FW_0000022269": "Picture size should be less than 1MB",
        "P_YS_FED_FW_0001010613": "Picture size cannot exceed",
        "P_YS_FED_FW_0000022266": "Large screen solution 3  eChartPanelDisplay3  Display  Render End",
        "P_YS_FED_FW_0001010616": "Large Picture Preview",
        "P_YS_FED_FW_0000022267": "Large screen slideshow: obtain template configuration Info. Return json.data.length",
        "P_YS_FED_FW_0001010615": "-pixel picture",
        "P_YS_FED_FW_0001010618": "Picture width cannot exceed",
        "P_YS_FED_FW_0001010617": "Confirm to delete the selected attachment? It cannot be restored once deleted",
        "P_YS_FED_FW_0001010619": "You can only upload",
        "P_YS_FED_FW_0000022282": "Purchase Doc",
        "P_YS_FED_IMP_IOT0000010080": "Gutian County",
        "P_YS_FED_FW_0000022283": "Count",
        "P_YS_FED_IMP_IOT0000010081": "Changsha County",
        "P_YS_FED_FW_0000022280": "Change Name",
        "P_YS_FED_IMP_IOT0000010082": "Yuechi County",
        "P_YS_FED_FW_0000022281": "Please add filter criteria",
        "P_YS_FED_IMP_IOT0000010083": "Yuli County",
        "P_YS_FED_FW_0000022286": "Display Qty Info by color depth",
        "P_YS_FED_FW_0000022287": "Ten Thousand",
        "P_YS_FED_FW_0000022284": "Map Display",
        "P_YS_FED_FW_0000022285": "Keep at least one display column",
        "P_YS_FED_EXAMP_0000020074": "No numerical data in the entered SN, which cannot be specified automatically. Please check",
        "P_YS_FED_EXAMP_0000020073": "The voucher collection method is used in the current Doc. Cannot add line",
        "P_YS_FED_EXAMP_0000020076": " H152status, you cannot perform",
        "P_YS_FED_EXAMP_0000020075": "Operation succeeded",
        "P_YS_FED_EXAMP_0000020070": "Please enter ending card/voucher No.",
        "P_YS_FED_IMP_IOT0000010085": "Lianshui County",
        "P_YS_FED_EXAMP_0000020072": "Returned/To be Issued",
        "P_YS_FED_EXAMP_0000020071": "Whole Doc Amt is less than original Doc Amt. Cannot settle",
        "P_YS_FED_IMP_IOT0000010087": "Sunwu County",
        "P_YS_FED_EXAMP_0000020067": "Purchase Price",
        "P_YS_FED_EXAMP_0000020066": "Duplicate SN",
        "P_YS_FED_EXAMP_0000020069": "Uploading...",
        "P_YS_FED_EXAMP_0000020068": "Buyout Room Rate",
        "P_YS_FED_FW_0000022279": "Unknown",
        "P_YS_FED_FW_0000022277": "Failed to verify the fields in configuration Info. There're fields that do not exist in the column; after conversion",
        "P_YS_FED_FW_0000022278": "Display Name:",
        "P_YS_FED_IMP_IOT0000010092": "Shenza County",
        "P_YS_SCM_STOCK_0000034620": "Save & Settle",
        "P_YS_SCM_STOCK_0000034621": "Empty",
        "P_YS_SCM_STOCK_0000034622": "New Billing",
        "P_YS_FED_IMP_IOT0000010090": "Fengning Manchu Autonomous County",
        "P_YS_FED_IMP_IOT0000010099": "Makino",
        "P_YS_SCM_STOCK_0000034627": "s data failed",
        "P_YS_SCM_STOCK_0000034628": "Select business type",
        "P_YS_FED_IMP_IOT0000010096": "Xiangqiao District",
        "P_YS_SD_URETAIL_0001048677": "] table contains data of other tables. Specific data:",
        "P_YS_FED_FW_0000111015": "The current selection will lead to duplicate line title. Please check",
        "P_YS_FED_EXAMP_0000020010": "No product in the package",
        "P_YS_FI_CM_0000029500": " ",
        "P_YS_AM_AMBDF_0001625636": "Flashlight",
        "P_YS_FED_EXAMP_0000020005": "Template",
        "P_YS_FED_FW_0001118762": "The format of the selected file is incorrect. Please select again",
        "P_YS_FED_EXAMP_0000020004": "Total ",
        "P_YS_FED_FW_0001118763": "Supported formats: JPG, BMP, PNG, and JPEG; no more than 1M; for pictures larger than 700*700, they can be zoomed in on the product details page",
        "P_YS_FED_EXAMP_0000020007": "Prepaid card No. is blank",
        "P_YS_FED_FW_0001118761": "Supported format: jpg, bmp, png, jpeg",
        "P_YS_FED_EXAMP_0000020001": "Payment failed. It needs to be canceled",
        "P_YS_FED_FW_0001010620": " pixels",
        "P_YS_FED_EXAMP_0000020000": "Promotion Activity",
        "P_YS_FED_EXAMP_0000020003": "You've not logged into the store. Billing not allowed",
        "P_YS_FED_EXAMP_0000020002": "Promotion Discount",
        "P_YS_PF_PRINT_0000065262": "Material Name",
        "P_YS_FED_EXAMP_0000020009": "Promotion activity has been executed for the product. The original promotion conditions may not be met after returning product",
        "P_YS_FED_EXAMP_0000020008": "Member account No. is blank",
        "P_YS_FED_FW_0000137655": "voucher->do——",
        "P_YS_FED_FW_0000137654": "Refer to association definition",
        "P_YS_FED_FW_0000137653": "Wrong value format",
        "P_YS_FED_FW_0000137652": "Error exists",
        "P_YS_FED_FW_0000137651": "No billType obtained",
        "P_YS_FED_FW_0000137650": "billnumber of tree not configured. Set it in target of the commend table",
        "P_YS_FED_EXAMP_0000020021": "Xizhimen Store",
        "P_YS_FED_EXAMP_0000020020": "button's function permission. Cannot operate",
        "P_YS_PF_QITDFE_0001344211": "Reason for Export Exception",
        "P_YS_SD_SDMAUF_0000152710": "Tab Name",
        "P_YS_FED_EXAMP_0000020016": "Homepage",
        "P_YS_FED_EXAMP_0000020015": "Operation Overview",
        "P_YS_FED_EXAMP_0000020018": "The length of the starting card/voucher No. must be equal to that of the ending card/voucher No.",
        "P_YS_FED_EXAMP_0000020017": "The card/voucher is not for original order return, so the card/voucher Qty should be -1. Please check the product to return",
        "P_YS_FED_EXAMP_0000020012": "Confirmation can only be performed after selecting a Doc",
        "P_YS_FED_EXAMP_0000020011": "The operation is non-recoverable. Has the selected retail Doc been invoiced?",
        "P_YS_FED_FW_0001557217": "[Line <%=text%>]",
        "P_YS_FED_EXAMP_0000020014": "Order Delivery Status",
        "P_YS_FED_EXAMP_0000020013": "Payment via member wallet is not available for the stored value business type",
        "P_YS_FED_FW_0000137649": "Error in referencing user-defined field:",
        "P_YS_FED_EXAMP_0000020019": "Org Personnel",
        "P_YS_FED_FW_0000137666": "Tag Association Definition",
        "P_YS_FED_FW_0000137665": "Error in the format of list cCarry JSON-->",
        "P_YS_FED_FW_0000137664": "Error in saving grandson table as draft",
        "P_YS_FED_FW_0000137663": "[{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"Menu\\\",\\\"key\\\":\\\"menu\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"Permission\\\",\\\"key\\\":\\\"auth\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"Button Permission\\\",\\\"key\\\":\\\"actionAuth\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"Rule\\\",\\\"key\\\":\\\"rule\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"Option\\\",\\\"key\\\":\\\"option\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"Enumeration\\\",\\\"key\\\":\\\"enum\\\"},{\\\"nameType\\\":\\\"text\\\",\\\"value\\\":\\\"ViewModel\\\",\\\"key\\\":\\\"viewmodel\\\"}]",
        "P_YS_FED_FW_0000137661": "Save failed - [",
        "P_YS_SCM_STOCK_0000034610": "Examining Product",
        "P_YS_FED_FW_0000137660": "Preset billtype in menu:",
        "P_YS_SCM_STOCK_0000034612": "Actual received Amt is greater than A/R Amt for cashless payment. Cannot settle",
        "P_YS_SCM_STOCK_0000034613": "The proportion cannot be less than",
        "P_YS_FED_EXAMP_0000020030": "Every Day",
        "P_YS_FED_EXAMP_0000020032": "Confirm to switch store? This operation will refresh the page",
        "P_YS_SCM_STOCK_0000034615": "Doc No./Contact/Tel",
        "P_YS_FED_EXAMP_0000020031": "Invalid weight",
        "P_YS_SCM_STOCK_0000034617": "Unavailable during refund",
        "P_YS_FED_EXAMP_0000020027": "(Select at most",
        "P_YS_FED_EXAMP_0000020026": "Card/Voucher - Orig. Order Return Function",
        "P_YS_FED_EXAMP_0000020029": "Off-shelf due to Violation",
        "P_YS_FED_EXAMP_0000020028": "Controlled Object",
        "P_YS_FED_EXAMP_0000020023": "Salesperson",
        "P_YS_FED_EXAMP_0000020022": "Last 30 Days",
        "P_YS_FED_EXAMP_0000020025": "The stock of the following products is insufficient. Please adjust",
        "P_YS_FED_FW_0000137659": "Not defined in the form",
        "P_YS_FED_FW_0000137658": "Refer to carried field",
        "P_YS_FED_FW_0000137657": "Failed to save---Failed to verify the following data item:",
        "P_YS_FED_FW_0000137656": "Failed to delete <%=text%>",
        "P_YS_FED_FW_0000137677": "When deleting multiple pieces of data, the ID is:",
        "P_YS_FED_FW_0000137676": "Error in deleting data. Error:",
        "P_YS_FED_FW_0000137675": "openDB parameter error",
        "P_YS_FED_FW_0000137674": "Graphical Report & Hotspot Log",
        "P_YS_FED_FW_0000137673": "Database connection succeeded",
        "P_YS_FED_FW_0000022210": "Display Column",
        "P_YS_FED_FW_0000137672": "'s data",
        "P_YS_FED_FW_0000137671": "Triggered when the database version changes (upgradeneeded event occurred, or indexedDB.deleteDatabase() is called）",
        "P_YS_FED_FW_0000137670": "Method does not exist",
        "P_YS_FED_FW_0000022208": "Taxpayer ID No.",
        "P_YS_FED_FW_0000022209": "eChartDisplay  Status changed  shouldComponentUpdate  params changed End True",
        "P_YS_FED_FW_0000022202": "No Model in the initialization conditions",
        "P_YS_FED_FW_0000022203": "Test whether text is displayed by rule",
        "P_YS_FED_FW_0000022200": "Current",
        "P_YS_PF_PROCENTER_1518927132915400722": "的值",
        "P_YS_FED_FW_0000022201": "Failed to obtain the form template list",
        "P_YS_FED_FW_0000022206": "Text type fields: [Cust. Name], [Material Details.Material Short Name] = [Material Name]",
        "P_YS_FED_FW_0000022207": "Large screen solution  Design  doSetImageText info",
        "P_YS_FED_FW_0000137669": "Error in the format of parameter JSON-->",
        "P_YS_FED_FW_0000137668": "Verification failed:",
        "P_YS_FED_FW_0000022205": "Move Down",
        "P_YS_FED_FW_0000137688": "No viewModel in the submitted parameters of the Doc generation workbench",
        "P_YS_FED_FW_0000137687": "Dirty data field in ContainerModel after modification:",
        "P_YS_FED_FW_0000137686": "Error in loading picture. imgUrl =",
        "P_YS_FED_FW_0001219316": "Please select the data in the detail",
        "P_YS_FED_FW_0000137685": "When deleting multiple pieces of data",
        "P_YS_FED_FW_0000022220": "Hot zone setting picture  Cannot find all the hot zone configuration fields in CStyle  codeField nameField fieldsCaption mapConfigField",
        "P_YS_FED_FW_0000137684": "Deselect Picture",
        "P_YS_FED_FW_0000022221": "New Group",
        "P_YS_FED_FW_0000137683": "All data in the table failed",
        "P_YS_FED_FW_0000137682": "The last database connection has not been closed",
        "P_YS_FED_FW_0000137681": "Multiple pieces of data saved successfully:",
        "P_YS_FED_FW_0000137680": "Saved successfully. ID:",
        "P_YS_FED_FW_0001617303": "%c发起后端计算接口 /bill/executeFormulaCalculate： =>params =>action =>rule =>exprTag =>childTrigger",
        "P_YS_FED_FW_0001221613": "失败,返回信息：",
        "P_YS_FED_FW_0001221611": "未发现有效数据",
        "P_YS_FED_FW_0000022219": "Chart Columns",
        "P_YS_FED_FW_0000022213": "No permission",
        "P_YS_FED_FW_0000022214": "Selected Menu",
        "P_YS_FED_FW_0000022211": "File size must be less than",
        "P_YS_SD_SDMA_0000098574": "Plus",
        "P_YS_FED_FW_0000022212": " pieces. Successful: ",
        "P_YS_FED_FW_0000022217": "Latitude",
        "P_YS_FED_FW_0000022218": "Person-in-charge",
        "P_YS_SD_SDMAF_0000137273": "Receipt",
        "P_YS_FED_FW_0000022215": "Group",
        "P_YS_FED_FW_0000137679": "Your browser does not support IndexedDB",
        "P_YS_FED_FW_0000022216": "Save All",
        "P_YS_FED_FW_0000137678": "Database shut down unexpectedly",
        "P_YS_FED_FW_0000137699": "Batch modify Docs; row=",
        "P_YS_FED_FW_0000137698": "Comments portal--tabs",
        "P_YS_FED_FW_0000137697": ":::[StatusBar]; component expired; not recommended...",
        "P_YS_FED_FW_0000137696": "clearDimensionCache successful: groupCode =",
        "P_YS_FED_FW_0000137695": "clearDimensionCache failed: json.message =",
        "P_YS_FED_FW_0000137694": "Failed to delete grouping conditions. Info:",
        "P_YS_FED_FW_0000137693": "setShowActionRows------Parameter error",
        "P_YS_FED_FW_0000137692": "Do not display related control EcsuiteChat Render this.keyModel.getValue() =",
        "P_YS_FED_FW_0000137691": " ",
        "P_YS_FED_FW_0001060913": "Instant Analysis",
        "P_YS_FED_FW_0000137690": "Failed to obtain grouping conditions. Info:",
        "P_YS_FED_FW_0001060919": "-Instant Analysis",
        "P_YS_FED_IMP_IOT0000005597": "Yinjiang Tujia and Miao Autonomous County",
        "P_YS_FED_IMP_IOT0000005599": "Wanli District",
        "P_YS_FED_IMP_IOT0000005591": "Jingdong Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000005592": "Yongping County",
        "P_YS_FED_FW_1524239912962359303": "Your browser does not support this video format",
        "P_YS_FED_IMP_IOT0000005595": "Funing County",
        "P_YS_FED_FW_0000137689": " ",
        "P_YS_FED_FW_1578184126673977344": "appCode use error, please contact file service Zhu Shiyou zhushy@yonyou.com",
        "P_YS_FED_FW_0001060905": "Succeeded in calling custom/do/",
        "P_YS_FED_FW_0001060906": "No model",
        "P_YS_FED_FW_0001060907": "The Max length of the entered integer cannot be greater than ",
        "P_YS_FED_IMP_IOT0000005586": "Anxin County",
        "P_YS_FED_IMP_IOT0000005585": "Lianyungang",
        "P_YS_FED_IMP_IOT0000005588": "Daiyue District",
        "P_YS_FED_IMP_IOT0000005587": "Suixi County",
        "P_YS_FED_IMP_IOT0000005589": "Dejiang County",
        "P_YS_FED_IMP_IOT0000005580": "Bell Tower District",
        "P_YS_FI_FP_0001073056": "Main Table:",
        "P_YS_FED_IMP_IOT0000005582": "Erenhot",
        "P_YS_FED_IMP_IOT0000005581": "Coulomb Banner",
        "P_YS_FED_FW_0001287431": "Adaptive Column Width",
        "P_YS_FED_FW_0001287435": "[object Object]",
        "P_YS_FI_CM_0000029573": "Delete",
        "P_YS_FED_IMP_IOT0000006784": "Qianshan County",
        "P_YS_FED_IMP_IOT0000006787": "Nan'an",
        "P_YS_FED_IMP_IOT0000006789": "Luchuan County",
        "draft": "Draft",
        "P_YS_FED_IMP_IOT0000006781": "Pingyuan County",
        "P_YS_FED_IMP_IOT0000006782": "Xingye County",
        "P_YS_PF_METADATA_0000085603": "Priority",
        "P_YS_FED_FW_1530670329410093060": "<=b -- Less than or equal to b",
        "P_YS_FED_FW_1530670329410093066": ">=a -- Greater than or equal to a",
        "P_YS_FED_FW_1530670329410093063": ">a -- Greater than a",
        "P_YS_FED_FW_0001503457": "Wrong Info entered. Please enter again",
        "P_YS_FED_IMP_IOT0000005442": "Deleted successfully",
        "P_YS_FED_IMP_IOT0000006773": "Chenggong County",
        "P_YS_FED_IMP_IOT0000006775": "Shanghang County",
        "P_YS_FED_IMP_IOT0000006778": "Wenshui County",
        "P_YS_FED_IMP_IOT0000006777": "Rushan",
        "P_YS_FED_IMP_IOT0000005448": "Template Name",
        "P_YS_FED_FW_1530670329410093069": "<b -- Less than b",
        "P_YS_FED_IMP_IOT0000006770": "Qincheng District",
        "P_YS_FED_IMP_IOT0000006763": "Jishan County",
        "P_YS_FED_FW_0001249386": "Template Downloading/Creation Workbench",
        "P_YS_FED_FW_0001249385": "Excel format is supported, and the file size cannot exceed ",
        "P_YS_FED_FW_0001249388": "Abnormal location",
        "P_YS_FED_IMP_IOT0000006764": "Botou City",
        "P_YS_FED_FW_0001249387": "Export abnormal data",
        "P_YS_FED_IMP_IOT0000006767": "Jingde County",
        "P_YS_FED_IMP_IOT0000006766": "Xinjian County",
        "P_YS_FED_FW_0001249389": "Please upload the file again",
        "P_YS_SCM_STOCK_0001082855": "Error obtaining data",
        "P_YS_PF_GZTTMP_0000079071": "Doc Time",
        "P_YS_FED_IMP_IOT0000006761": "Meixi District",
        "P_YS_FED_IMP_IOT0000006759": "Luoza County",
        "P_YS_SD_SDMB_0000150374": "No data found",
        "P_YS_FED_IMP_IOT0000005422": "Unconfirmed",
        "P_YS_FED_IMP_IOT0000005424": "Edit",
        "P_YS_FED_IMP_IOT0000006755": "Rongcheng District",
        "P_YS_FED_IMP_IOT0000006757": "Kuitun",
        "P_YS_FED_IMP-DFM-FE_0000020911": "Display All",
        "P_YS_FED_IMP-DFM-FE_0000020910": "Clear",
        "P_YS_FED_IMP_IOT0000006748": "Debao County",
        "P_YS_FED_UIMG_0001050959": "Query Scheme List",
        "P_YS_FED_IMP_IOT0000006740": "Qingbaijiang District",
        "P_YS_FED_IMP_IOT0000006742": "Ling County",
        "P_YS_FED_IMP_IOT0000006745": "Ebian Yi Autonomous County",
        "P_YS_FED_IMP_IOT0000005413": "Operation",
        "P_YS_FED_IMP_IOT0000006747": "Linxian",
        "P_YS_PF_SOCD-K_0000182238": "Kg",
        "P_YS_FED_IMP_IOT0000006738": "Yongfu County",
        "P_YS_FED_IMP_IOT0000006737": "Xinhe County",
        "P_YS_FI_CM_0000029543": "January",
        "P_YS_FED_IMP_IOT0000006730": "Taijiang District",
        "P_YS_FED_IMP_IOT0000006731": "Kang County",
        "P_YS_FED_IMP_IOT0000006733": "Dongying District",
        "P_YS_FED_IMP_IOT0000006736": "Caoxian",
        "P_YS_FED_IMP_IOT0000006735": "Xiangtan County",
        "P_YS_FED_IMP_IOT0000006728": "Qingcheng County",
        "P_YS_FED_FW_0001377458": "/iprint/用友云打印助手.exe",
        "P_YS_FED_UIMG_0001050970": "Hiding associated fields will affect runtime. Please operate with caution",
        "P_YS_FED_IMP_IOT0000006721": "Luotian County",
        "P_YS_FED_IMP_IOT0000006720": "Huangling County",
        "P_YS_FED_FW_0001208829": "Duplicate Info selected",
        "P_YS_FED_UCFORG_0000088691": "Cannot be smaller any more",
        "P_YS_FED_UCFORG_0000088692": "Already the Max Ratio",
        "P_YS_FED_IMP_IOT0000006715": "Mengjin County",
        "P_YS_FED_IMP_IOT0000006717": "Bincheng District",
        "P_YS_PF_GZTSYS_0001010812": "Enterprise Certification",
        "P_YS_FED_UIMG_0001050967": "Template verification failed",
        "P_YS_FED_UIMG_0001050968": "The current search result corresponds to entity metadata property, instead of UI metadata property",
        "P_YS_FED_IMP_IOT0000006714": "Wuji County",
        "P_YS_FI_CM_0000029569": "July",
        "P_YS_FED_UIMG_0001050969": "Confirm to delete column",
        "P_YS_FED_IMP_IOT0000006705": "Zhengding County",
        "P_YS_FED_IMP_IOT0000006704": "Horqin Zuoyizhongqi",
        "P_YS_FED_IMP_IOT0000006700": "Longyou County",
        "P_YS_FED_FW_0001142513": "Unprocessable index",
        "P_YS_FED_IMP_IOT0000006702": "Fengxian",
        "P_YS_FED_FW_0001142515": "Process by ",
        "P_YS_FED_FW_0001142514": "Unrecognized",
        "P_YS_FED_FW_0001142517": "Set at least one search column",
        "P_YS_FED_FW_0001142516": " status",
        "P_YS_FED_FW_1565223229652992000": "公式赋值 表头特征 >>:",
        "P_YS_FED_MDF-COMPS_0001378486": "Benchmark Language",
        "P_YS_FED_MDF-COMPS_0001378484": "The current language will be retrieved by default when the benchmark language is null",
        "P_YS_SD_UDHWN_0000049167": "Tumshuk",
        "P_YS_PF_GZTSYS_0001010835": "Language",
        "P_YS_FED_FW_1554678844398501896": "%c batch triggering action: SetCellStates >>>",
        "P_YS_FED_FW_0001377414": "/ 当前页面筛选出",
        "P_YS_FED_FW_0001377415": "当前页面筛选出",
        "P_YS_FI_FCWEB_0001498545": "Result:",
        "P_YS_FED_FW_1534689396612136962": "The Yonyou Cloud API can only be accessed through the Internet, but not in the exclusive environment",
        "P_YS_SD_UDHMC_0000130713": "Collapse",
        "P_YS_FED_FW_0001026227": "<%=text%> Reference",
        "P_YS_FED_FW_1497486003344506888": "Please click the alternative conditions in the sidebar to add",
        "P_YS_FED_IMP_IOT0000011306": "Gao'an",
        "P_YS_FED_FW_0001141221": "%cGroup: meta Client Cache Info",
        "P_YS_FED_IMP_IOT0000011303": "Leibo County",
        "P_YS_FED_IMP_IOT0000011305": "Hengyang County",
        "P_YS_HR_HRJQ_0000031143": "None",
        "P_YS_PF_METADATA_0000086908": "Rectangle",
        "P_YS_FED_IMP_IOT0000011310": "Wuhu County",
        "P_YS_FED_FW_0001141240": "Click the button. Calling of the internal handleMenuClick method of dropdownbutton component ends",
        "P_YS_FED_IMP_IOT0000011318": "Shaxian",
        "P_YS_FED_IMP_IOT0000011319": "Tuanfeng County",
        "P_YS_FED_IMP_IOT0000011314": "Zhalantun",
        "P_YS_FED_IMP_IOT0000011313": "Shangri-La County",
        "P_YS_FED_FW_0001141239": "Click the button. Calling of the internal handleButtonClick method of dropdownbutton component ends",
        "P_YS_FED_FW_0001141238": "Click the button. Calling of the internal handleMenuClick method of dropdownbutton component starts",
        "P_YS_FED_FW_0001295958": "Please register appcode",
        "P_YS_SD_UDHWN_0000050125": "Tianmen",
        "P_YS_SD_UDHWN_0000050128": "Pudong New District",
        "P_YS_FED_IMP_IOT0000011321": "Hunchun",
        "P_YS_FED_IMP_IOT0000011320": "Anduo County",
        "P_YS_FED_FW_0001141241": "Click the button. Calling of the internal handleButtonClick method of dropdownbutton component starts",
        "P_YS_FED_IMP_IOT0000011328": "Chongyang County",
        "P_YS_FED_FW_0001065806": "Incorrect input",
        "P_YS_FED_FW_0001141246": "The following <%=text%> field is required",
        "P_YS_FED_FW_0001065807": "Incorrect IP format",
        "P_YS_FED_IMP_IOT0000011324": "Miluo City",
        "P_YS_FED_FW_0001065805": "Incorrect mailbox format",
        "P_YS_FED_FW_0001141247": "Line <%=text%>",
        "P_YS_FED_FW_0001026213": "<%=text%> <%=cName%>",
        "P_YS_HR_HRJQ_0000031164": "Failed",
        "P_YS_FED_IMP_IOT0000011332": "Yanhe Tujia Autonomous County",
        "P_YS_FED_IMP_IOT0000010001": "Zhaozhou County",
        "P_YS_FED_FW_0001094323": "Request interface:",
        "P_YS_FED_FW_0001094324": ", returned value:",
        "P_YS_FED_FW_0001612626": "Failed to obtain the operation column",
        "P_YS_FED_IMP_IOT0000010008": "Duanzhou District",
        "P_YS_PF_GZTSYS_0000012963": "Warehouse Keeper",
        "P_YS_FED_IMP_IOT0000010009": "Bishan County",
        "P_YS_FED_IMP_IOT0000010004": "Qinghemen District",
        "P_YS_FED_IMP_IOT0000011338": "Yindu District",
        "P_YS_FED_IMP_IOT0000011337": "Hohhot",
        "P_YS_FED_IMP_IOT0000010007": "Gaogang District",
        "P_YS_SD_URETAIL_0001048820": "] indexedDB in which [",
        "P_YS_FED_FW_0000022370": "Display Hour/Minute",
        "P_YS_FED_FW_0000021040": "Store Code",
        "P_YS_FED_FW_0000022371": "Current Language",
        "P_YS_FED_FW_0000021043": "Xianning",
        "P_YS_FED_FW_0000022374": "The cross-point in the profile is empty or the configuration field does not exist in the source table column. Please check",
        "P_YS_FED_FW_0000021044": "Jiangmen",
        "P_YS_FED_FW_0000022375": "Display angle should be between 0-60",
        "P_YS_FED_FW_0000021041": "Changde",
        "P_YS_FED_FW_0000022372": "getMeasureValues not found in 1-D table  t2DRowKey =",
        "P_YS_FED_FW_0000021042": "Finish",
        "P_YS_FED_FW_0000022373": "Report Group Scheme Config. Info - Row/Column Layout",
        "P_YS_FED_IMP_IOT0000011224": "Lishan District",
        "P_YS_FED_FW_0001065868": ", input accuracy has been set to",
        "P_YS_FED_FW_0001065869": "The length of the input integer is",
        "P_YS_FED_IMP_IOT0000011226": "Kangding County",
        "P_YS_FED_IMP_IOT0000011228": "Linxia",
        "P_YS_FED_FW_0000022367": "Hundred Million",
        "P_YS_FED_FW_0000021036": "Filter",
        "P_YS_FED_IMP_IOT0000009011": "Bazhou District",
        "P_YS_FED_FW_0000022368": "Please enter the correct value",
        "P_YS_FED_FW_0000021037": "Changchun",
        "P_YS_FED_IMP_IOT0000009012": "Songxian",
        "P_YS_FED_FW_0000021034": "Weather",
        "P_YS_FED_FW_0000022366": "Modified successfully",
        "P_YS_FED_FW_0000021035": "Guiyang",
        "P_YS_FED_IMP_IOT0000009016": "Xinning County",
        "P_YS_FED_FW_0000022369": "(Recommended)",
        "P_YS_FED_FW_0000021038": "Example of set parameter format: {key: someKey, value: someValue}, or: [{key: someKey, value: someValue}]",
        "P_YS_FED_IMP_IOT0000009013": "Xiaonan District",
        "P_YS_PF_SOCD-O_0000182516": "College",
        "P_YS_FED_FW_0000021039": "Column/Line Chart Example",
        "P_YS_FI_FP_0000034880": "Maintenance",
        "P_YS_FED_FW_0000021050": "One Column",
        "P_YS_FED_FW_0000022381": "Please enter a number between 0-99",
        "P_YS_FED_FW_0000021051": "Heihe",
        "P_YS_FED_FW_0000022382": " seconds, the slideshow time set in the system. cb.rest.AppContext.option.screenPlayTime",
        "P_YS_FED_FW_0000022380": "Obtain graph report  /report/list  Current List request start time =",
        "P_YS_FED_FW_0000021054": "Failed to connect to the database",
        "P_YS_FED_FW_0000022385": "Keep Inner Border",
        "P_YS_FED_FW_0000021055": "Pie Chart Config. Info - eChartSetting",
        "P_YS_FED_FW_0000022386": "Empty Group Item",
        "P_YS_FED_FW_0000021052": "Tibet",
        "P_YS_FED_FW_0000022383": "No search result",
        "P_YS_FED_FW_0000021053": "Ji'an",
        "P_YS_FED_FW_0000022384": "Enter an integer between 0 and 100 for the inner and outer radiuses, and the outer radius should be greater than the inner radius",
        "P_YS_FI_FP_0000034879": "Last Month",
        "P_YS_FED_IMP_IOT0000011231": "Luojiang County",
        "P_YS_FED_IMP_IOT0000011230": "Guannan County",
        "P_YS_FED_IMP_IOT0000009009": "Danfeng County",
        "P_YS_FED_IMP_IOT0000009006": "Xunke County",
        "P_YS_FED_FW_0001317858": "A field in the sub-table failed to pass the verification. Check in the details",
        "P_YS_FED_IMP_IOT0000009007": "Suileng County",
        "P_YS_FED_IMP_IOT0000011237": "Sinan County",
        "P_YS_FED_IMP_IOT0000011236": "Shaoyang County",
        "P_YS_PF_SOCD-O_0000182522": "Undergraduate",
        "P_YS_FED_FW_0000021047": "Dingxi",
        "P_YS_FED_FW_0000022378": "Cannot find",
        "P_YS_FED_IMP_IOT0000009000": "Zhenning Buyi and Miao Autonomous County",
        "P_YS_FED_FW_0000021048": "Tibetan Autonomous Prefecture of Haibei",
        "P_YS_FED_FW_0000022379": "Use ripple effects",
        "P_YS_FED_FW_0000021045": "Heilongjiang",
        "P_YS_FED_FW_0000022376": "The Latitude field is required",
        "P_YS_FED_FW_0000021046": "Left 2 Right 1",
        "P_YS_FED_FW_0000022377": "Filter Expression",
        "P_YS_HR_HRJQ_0000031063": "Rejected",
        "P_YS_FED_FW_0000021049": "Wuzhong",
        "P_YS_FED_IMP_IOT0000009002": "Dongbao District",
        "P_YS_SD_URETAIL_0001048725": "Status converted successfully for offline data",
        "P_YS_FED_FW_0000022352": "Layout",
        "P_YS_FED_FW_0000021021": "Data to export is required. Please select again and retry",
        "P_YS_FED_FW_0000022353": "View Error Log",
        "P_YS_FED_FW_0000021022": "Day",
        "P_YS_FED_FW_0000022350": "Please enter the correct phone number",
        "P_YS_FED_FW_0000021020": "New",
        "P_YS_FED_FW_0000022351": "Please enter keyword",
        "P_YS_FED_IMP_IOT0000011243": "Guanghe County",
        "P_YS_FED_IMP_IOT0000011246": "Gongbujiangda County",
        "P_YS_FED_FW_0001255142": "This feature requires a remote map, but it is temporarily unavailable because the public network cannot be accessed",
        "P_YS_FED_IMP_IOT0000011240": "Dingqing County",
        "P_YS_FED_IMP_IOT0000011241": "Fuxin Mongolian Autonomous County",
        "P_YS_FED_IMP_IOT0000011248": "Enping",
        "P_YS_FED_IMP_IOT0000011247": "Fangxian",
        "P_YS_FED_FW_0000021014": "Enabled",
        "P_YS_FED_FW_0000022345": "Only support pictures",
        "P_YS_FED_FW_0000022346": "Data type cannot be null",
        "P_YS_FED_FW_0000021015": "Date",
        "P_YS_FED_FW_0000022343": "Failed to publish report scheme. err",
        "P_YS_FED_FW_0000021012": "Business reference verification must be performed when deleting. This may take some time. Delete anyway?",
        "P_YS_FED_FW_0000022344": "-----------Clicking event  scatterData",
        "P_YS_FED_FW_0000021013": "Confirm to delete the",
        "P_YS_FED_FW_0000022349": "Set as Default Query Scheme",
        "P_YS_FED_FW_0000021018": "4.0",
        "P_YS_FED_FW_0000021019": "Please select valid data",
        "P_YS_FED_FW_0000022347": "Signature saved successfully",
        "P_YS_FED_FW_0000021016": "Some of the selected data does not conform to the Doc generation rules",
        "P_YS_FED_FW_0000022348": "Display indicators in pie charts only support single-choice",
        "P_YS_FED_FW_0000021017": "Confirm to",
        "P_YS_FED_FW_0000022360": "Data Type is required. Please check",
        "P_YS_FED_FW_0000021032": "No submitted parameter obtained",
        "P_YS_FED_FW_0000022363": "The current menu already exists. Overwrite?",
        "P_YS_FED_FW_0000022364": "Monitoring View  Delete refresh rate timer  renderTime",
        "P_YS_FED_FW_0000021033": "cCardKey not configured for metadata",
        "P_YS_FED_FW_0000022361": "Format",
        "P_YS_FED_FW_0000021030": "Failed to import template contents. Info returned:",
        "P_YS_FED_FW_0000022362": "Editing Area",
        "P_YS_FED_FW_0000021031": "Date & Time",
        "P_YS_FED_IMP_IOT0000011255": "Huailai County",
        "P_YS_FED_IMP_IOT0000011254": "West District",
        "P_YS_FED_IMP_IOT0000011256": "Longwen District",
        "P_YS_FED_IMP_IOT0000011251": "City of Tsu",
        "P_YS_FED_IMP_IOT0000011259": "Pingnan County",
        "P_YS_FED_FW_0000022356": "All Categories",
        "P_YS_FED_FW_0000022357": "Auto refresh interval set for report is too short. refreshInterval",
        "P_YS_FED_FW_0000021026": "Day of Week",
        "P_YS_FED_FW_0000022354": "Mild",
        "P_YS_FED_FW_0000021023": "Failed:",
        "P_YS_FED_FW_0000022355": "Please set display contents",
        "P_YS_FED_FW_0000021029": "No such record in the reference data. Please try again",
        "P_YS_FED_FW_0000022358": "Dedup Count",
        "P_YS_FED_FW_0000021027": "The operation will delete the current",
        "P_YS_FED_FW_0000022359": "Message",
        "P_YS_FED_FW_0000021028": "Please select Org",
        "P_YS_FED_FW_0000021083": "Baotou",
        "P_YS_FED_FW_0000021084": "Kaifeng",
        "P_YS_FED_FW_0000021081": "Sanming",
        "P_YS_FED_IMP_IOT0000011260": "Ceheng County",
        "P_YS_FED_FW_0000021082": "Ngari Prefecture",
        "P_YS_FED_FW_0000021087": "Liaocheng",
        "P_YS_FED_FW_0000021088": "Jingzhou",
        "P_YS_FED_FW_0000021085": "Huangshi",
        "P_YS_FED_FW_0000021086": "Pu'er",
        "P_YS_FED_IMP_IOT0000011266": "East Ujimqin Banner",
        "P_YS_FED_FW_0001317893": "No report",
        "P_YS_FED_FW_0000021080": "Suining",
        "P_YS_SD_SDMB_0000139941": "Line Data",
        "P_YS_SD_UDHWS_0000118032": "Regular Warehouse",
        "P_YS_FED_FW_0000021078": "User-defined Time",
        "P_YS_FED_FW_0001008402": "Edit by Ref",
        "P_YS_SD_SDDM-UI_0001141637": "Weibo",
        "P_YS_FED_FW_0000021079": "Board Config. Info - Large Screen - Row/Column Layout",
        "P_YS_HR_HRJQF_0000053894": "Cancel",
        "P_YS_FED_FW_0000021094": "Yuxi",
        "P_YS_FED_FW_0000021095": "Column Chart Config. Info - yySetting",
        "P_YS_FED_FW_0000021092": "Changzhi",
        "P_YS_FED_IMP_IOT0000011271": "Luliang County",
        "P_YS_FED_FW_0000021093": "Accumulation",
        "P_YS_FED_FW_0000021098": "Xiangyang",
        "P_YS_FED_FW_0000021099": "Fuzhou",
        "P_YS_FED_FW_0000021096": "eChartDisplay  Scatter chart/map Info is incorrect  errInfo =",
        "P_YS_FED_FW_0000021097": "Yan'an",
        "P_YS_FED_IMP_IOT0000011277": "Xuwen County",
        "P_YS_FED_IMP_IOT0000011276": "Dailing District",
        "P_YS_FED_IMP_IOT0000011278": "Jianhu County",
        "P_YS_FED_FW_0000021090": "Left 1 Right 2",
        "P_YS_FED_IMP_IOT0000011273": "Xupu County",
        "P_YS_FED_FW_0000021091": "Ziyang",
        "P_YS_FED_FW_0000021089": "Mobile Report  MobileData renderTable  mobileDataScale",
        "P_YS_FED_FW_0000021061": "Longnan",
        "P_YS_FED_FW_0000022392": "Month",
        "P_YS_FED_IMP_IOT0000011280": "Wei County",
        "P_YS_FED_FW_0000021062": "Sector Value",
        "P_YS_FED_FW_0000022393": "No specification value",
        "P_YS_FED_FW_0000022390": "Large screen solution 2  eChartPanelDisplay2  Display  Render End",
        "P_YS_FED_IMP_IOT0000011282": "Wuyi County",
        "P_YS_FED_FW_0001509661": "Search or click the arrow to select",
        "P_YS_FED_FW_0000021060": "Dalian",
        "P_YS_FED_FW_0000022391": "When matching a row in a 1-D table, the previous rows must have already been matched. Please check. rowItemMatchInfo =",
        "P_YS_FED_IMP_IOT0000011281": "Jiangning District",
        "P_YS_HR_HRJQF_0000053875": "Month",
        "P_YS_HR_HRJQF_0001044571": "John",
        "P_YS_FED_FW_0000021065": "Hechi",
        "P_YS_FED_FW_0000022396": "Display Second",
        "P_YS_FED_FW_1622974871736680453": "记录上下文调用次数",
        "P_YS_FED_FW_0000021066": "Line Chart Config. Info - yySetting",
        "P_YS_FED_FW_0000022397": "Only JPG, JPEG, BMP and PNG formats are supported; file size should be less than 2M",
        "P_YS_FED_FW_0000021063": "Xiangxi Tujia and Miao Autonomous Prefecture",
        "P_YS_FED_FW_0000021064": "Column Chart Config. Info - eChartSetting",
        "P_YS_FED_FW_0000022395": "Excellent",
        "P_YS_FED_IMP_IOT0000011289": "Mengcheng County",
        "P_YS_FED_IMP_IOT0000011286": "Xiuying District",
        "P_YS_FED_FW_0000021058": "Diqing Tibetan Autonomous Prefecture",
        "P_YS_FED_FW_0000022389": "Desktop board saved",
        "P_YS_FED_FW_0000021059": "Jinhua",
        "P_YS_FED_FW_0000021056": "Mobile Report  MobileReportSum filterClick",
        "P_YS_FED_FW_0000021057": "Jixi",
        "P_YS_FED_FW_0000022388": "The current report does not have a mobile Filter, and cannot be published to mobile Apps. filterId",
        "P_YS_SD_UDHWN_0000050084": "Miyun County",
        "P_YS_FED_FW_0000021072": "Saved successfully",
        "P_YS_FED_FW_0000021073": "Ranking List Example",
        "P_YS_FED_FW_0000021070": "Camera",
        "P_YS_FED_FW_0000021071": "#NAME?",
        "P_YS_FED_FW_0000021076": "Kizilsu Kirghiz Autonomous Prefecture",
        "P_YS_FED_FW_0000021077": "Hengyang",
        "P_YS_FED_FW_0000021074": "Sales",
        "P_YS_FED_FW_1428685300106788864": "The dividend cannot be 0",
        "P_YS_FED_FW_0000021075": "Failed to read multiple pieces of data",
        "P_YS_FED_IMP_IOT0000011295": "Shilla District",
        "P_YS_PF_SOCD-O_0000182541": "Senior High School",
        "P_YS_FED_FW_0000021069": "Shigatse Prefecture",
        "P_YS_SD_UDHWS_0000119391": "Incorrect",
        "P_YS_FED_FW_0000021067": "Yichun",
        "P_YS_FED_FW_0000022398": "New Query Scheme",
        "P_YS_FED_FW_0000021068": "Bar Chart Example",
        "P_YS_FED_FW_0000022399": "Failed to obtain dimension:",
        "P_YS_FED_FW_0001065870": "The length of the input integer cannot exceed 15 bits",
        "P_YS_FED_FW_1583596695997382657": "已勾选“移动端展现”，是否设置移动端布局？",
        "P_YS_OA_YBMOB_0000036871": "Pull down to refresh",
        "P_YS_FED_FW_1583596695997382660": "请设置移动端布局。",
        "P_YS_IMP_HSE-UI_0001216387": "Sub-table Tab",
        "P_YS_FI_CM_0000029614": "February",
        "P_YS_SD_SDSD-FE_0001491485": "規格",
        "P_YS_PF_ANALYTIC-FE_0001652194": "Mobile Layout",
        "P_YS_SD_SDSD-FE_0001491490": "單價",
        "P_YS_FED_FW_0001221777": "Confirm to <%=cCaption%> the selected <%=text%>",
        "P_YS_FED_FW_0001010742": "Asynchronous processing is in progress. Please check",
        "P_YS_FI_CM_0000029625": "March",
        "P_YS_FI_CM_0000029624": "Homepage",
        "P_YS_FED_FW_1476478433683308552": "1 legend",
        "P_YS_FED_FW_1476478433683308555": "2 legend",
        "P_YS_FED_FW_1528487034344701957": "Click OK to filter null values",
        "P_YS_OA_YBMOB_0000036891": "No relevant data",
        "P_YS_FED_FW_0001148642": "Search(Ctrl+Enter)",
        "P_YS_OA_YBMOB_0000036890": "File",
        "P_YS_OA_XTMENHU_0000046524": "To-dos",
        "P_YS_FI_CM_0000029635": "Radio Box",
        "P_YS_FED_IMP-DFM-FE_0000020869": "Arrow",
        "P_YS_FED_IMP-DFM-FE_0000020868": "Operation",
        "P_YS_PF_PRINT_0000065360": "Project Code",
        "P_YS_FED_FW_0000022330": "Please enter taxpayer ID No.",
        "P_YS_FED_FW_0000021000": "Level",
        "P_YS_FED_FW_0000022331": "No viewModel in the props of initialized eChartDisplay",
        "P_YS_SD_SDMAF_0000137147": "Msg Prompt",
        "P_YS_FED_IMP-DFM-FE_0000020875": "Edit",
        "P_YS_FED_IMP-DFM-FE_0000020872": ".",
        "P_YS_FED_FW_0000022329": "No Info to set",
        "P_YS_FED_IMP_IOT0000005499": "All",
        "P_YS_FED_FW_1550269983163940871": "Warning information prompt:",
        "P_YS_FED_FW_0000022323": "Enter Dir",
        "P_YS_FED_FW_0000022324": "Please set background picture",
        "P_YS_FED_FW_0000022321": "Format",
        "P_YS_FED_FW_0000022322": "Background Color",
        "P_YS_FED_FW_0000022327": "Severe",
        "P_YS_FED_FW_0000022328": "Year",
        "P_YS_FED_FW_0000022325": "Confirm to delete the filter item?",
        "P_YS_FED_FW_0000022326": "Toolbar cStyle. Error in preset data",
        "P_YS_FED_FW_0000022341": "Column/Line Chart",
        "P_YS_FED_FW_0000021010": "Subordinate exists. Cannot delete",
        "P_YS_FED_FW_0000022342": "Verify",
        "P_YS_FED_FW_0000021011": "The selected data does not conform to the Doc generation rules. Please select again",
        "P_YS_FED_FW_0000022340": "Large screen solution  Design  doSetChart info",
        "P_YS_FED_IMP-DFM-FE_0000020888": "No.",
        "P_YS_FED_IMP-DFM-FE_0000020886": "Copy",
        "P_YS_YYGJFW_YBUC_0001336571": "Collaboration Suite",
        "P_YS_OA_XTYUNHUIWU_0000162483": "Org",
        "P_YS_FED_FW_0000021009": "Switching the primary Org will clear the data. Continue?",
        "P_YS_FED_FW_0000021003": "Mon",
        "P_YS_FED_FW_0000022334": "For hot zone display picture rendering. Hot zone profile or floor image is empty",
        "P_YS_FED_FW_0000022335": "Ref ID",
        "P_YS_FED_FW_0000021004": "The record",
        "P_YS_FED_FW_0000021001": "Network exception",
        "P_YS_FED_FW_0000022332": "Duplicated row exists. Please check",
        "P_YS_FED_FW_0000021002": "Error in the data returned from the background",
        "P_YS_FED_FW_0000022333": "Set Graph Report",
        "P_YS_FED_FW_0000021007": "Numeric Value",
        "P_YS_FED_FW_0000022338": "Large screen solution date/time  props.componentConfig",
        "P_YS_FED_FW_0000021008": "Verifying",
        "P_YS_FED_FW_0000022339": "Grouping Condition",
        "P_YS_FED_FW_0001661538": "Attachment in Collaboration Suite",
        "P_YS_FED_FW_0000021005": "Time",
        "P_YS_FED_FW_0000022336": "Hundred",
        "P_YS_FED_FW_0000022337": "Graph report for monitoring views  eChartDisplay componentDidMount",
        "P_YS_FED_FW_0000021006": "Confirm",
        "P_YS_FED_FW_0001134039": "Duplicate line exists",
        "P_YS_FED_IMP-DFM-FE_0000020898": "Cut",
        "P_YS_FED_FW_0000022309": "Deduction",
        "P_YS_FED_FW_1551057130410213379": "Reference configuration error: Reference data unique value is not returned!",
        "P_YS_FED_FW_0000022307": "Абв",
        "P_YS_FED_FW_0000022308": "Index of the currently selected line",
        "P_YS_FED_FW_0000022301": "When matching a row in a 1-D table, the previous rows must have already been matched. Please check. matchArr =",
        "P_YS_FED_FW_0000022302": "Large screen solution 2  eChartPanelDisplay2  Display  Render Begin",
        "P_YS_FED_FW_0000022300": "Rolling Count Display",
        "P_YS_FED_FW_0000022305": "Failed to obtain data template list",
        "P_YS_FED_FW_0000022306": "Dimension",
        "P_YS_FED_IMP_IOT0000005471": "Prompt",
        "P_YS_FED_FW_0000022303": "Add Graph",
        "P_YS_FED_FW_0000022304": "Confirm to enable this template?",
        "P_YS_HR_HRXCF_0000056241": "Last 6 Months",
        "P_YS_FED_FW_0000022320": "Selected Data Items",
        "P_YS_FED_FW_1550269983163940868": "Prompt of illegal information (forbid next step):",
        "P_YS_FED_IMP_IOT0000006796": "Wafangdian",
        "P_YS_HR_HRJQF_0001007593": "System Template",
        "P_YS_FED_FW_0000022318": "1-D table editRowModel is not found during initialization, material model is not found in editRowModel, or the material model type is not ReferModel",
        "P_YS_FED_IMP_IOT0000006798": "Dingxing County",
        "P_YS_FED_IMP_IOT0000005467": "This is number",
        "P_YS_FED_FW_0000022319": "Filter Item Name",
        "P_YS_FED_IMP_IOT0000006799": "Gongchangling District",
        "P_YS_FED_FW_0000022312": "Large screen slideshow: Carousel render  Display Slideshow Time",
        "P_YS_FED_FW_0000022313": "Failed to match some rows in the 1-D table with 2-D table cells. rows =",
        "P_YS_FED_FW_0000022310": "Click to upload",
        "P_YS_FED_IMP_IOT0000006790": "Xunhua Salar Autonomous County",
        "P_YS_FED_FW_0000022311": "Graph",
        "P_YS_FED_FW_0000022316": "Enumeration type field: [Short Term BP]",
        "P_YS_FED_FW_0000022317": "Supported format: P12)",
        "P_YS_FED_IMP_IOT0000006791": "Wuying District",
        "P_YS_FED_FW_0000022314": "Please select menu",
        "P_YS_FED_IMP_IOT0000006794": "Hengshan County",
        "P_YS_FED_FW_0000022315": "In the qualified group scheme (displayStyle == 2 or 3, for mobile board, isMobile must be true), cannot find the current group scheme (groupSchemaId=",
        "P_YS_FED_IMP_IOT0000006793": "Sandu Shui Autonomous County",
        "P_YS_PF_ECON-FE_0001658831": "Authentication Notes",
        "P_YS_PF_YHTU_1541976126441127960": "Photo requirements",
        "P_YS_PF_YHTU_1541976126447943698": "Authentication content: Efficient verification of my carrier information",
        "P_YS_SD_SDMA_0000060954": "Name is required",
        "P_YS_PF_YHTU_1541976126441127963": "The name and ID number associated with the operator's mobile phone number must be provided",
        "P_YS_SD_SDMAF_0000137341": "Certified",
        "P_YS_PF_ECON-CONSLE_0001157552": "Authenticate Now",
        "P_YS_PF_YHTU_1541976126441127969": "The uploaded file should not exceed 3MB",
        "P_YS_PF_YHTU_1541976126447943695": "Operator Three Elements - Authentication Service Agreement",
        "P_YS_PF_YHTU_1541976126441127966": "If you need to change your name and ID number, you need to change it after cancelling all previous certifications",
        "P_YS_PF_YHTU_1541976126447943692": "Please tick the box to read and agree to the authentication agreement",
        "P_YS_PF_PC-UI_0000160789": "Back Side of ID Card",
        "P_YS_PF_PC-UI_0000160788": "Front Side of ID Card",
        "P_YS_PF_YHTU_1541976126441127972": "Authentication information",
        "P_YS_FED_UCFBASEDOC_0000025252": "I have read and accepted all the terms",
        "P_YS_PF_YHTU_1541976126447943686": "The Four Elements of Bank Card - Authentication Service Agreement",
        "P_YS_PF_YHTU_1557523229449912325": "《",
        "P_YS_PF_YHTU_1541976126447943689": "Authentication content: Efficient verification of your bank card information",
        "P_YS_PF_YHTU_1551617615053455362": "Personal Real Name Authentication Service Agreement",
        "P_DIWORK_YC_SUP-MGR_0000059259": "Authentication in Progress",
        "P_YS_PF_YHTU_1541976126447943680": "Authentication time limit: 1-2 working days",
        "P_YS_PF_YHTU_1541976126441127975": "2. Picture size: ≦3MB",
        "P_YS_PF_YHTU_1541976126447943683": "Personal Certificate Authentication - Authentication Agreement",
        "P_YS_SD_UDHMC_0001084273": "Cancel certification",
        "P_YS_PF_YHTU_1541976126441127978": "(Including face)",
        "P_YS_PF_YHTU_1557523229449912320": "Please enter",
        "P_YS_SD_SDMBF_0000145206": "Bank Card No.",
        "P_YS_PF_YHTU_1541976126441127984": "Need to provide the relevant information consistent with the bank card reserved information",
        "P_YS_PF_YHTU_1541976126441127981": "Operator three elements authentication",
        "P_YS_PF_YHTU_1541976126441127948": "1. Image type: jpg, jpeg, bmp, gif, png",
        "P_YS_PF_YHTU_1541976126441127942": "Bank card four-factor authentication",
        "P_YS_PF_YHTU_1541976126441127987": "3. ID card reverse photo requirements: colour electronic version of the original ID card national emblem side of the picture, can not use photocopies of photos",
        "P_YS_PF_YHTU_1541976126441127945": "Personal Document Authentication",
        "P_YS_PF_YHTU_1541976126441127939": "When the mobile phone account is changed or unbundled, the authentication status of the three elements and four elements will be automatically changed to unauthenticated",
        "P_YS_PF_ECON-FE_0001136547": "ID No. is required.",
        "P_YS_FED_UCFBASEDOC_0000024745": "Verification Code is required",
        "P_YS_FED_UCFBASEDOC_0000025558": "Mobile Verification Code",
        "P_YS_PF_YHTU_1541976126447943704": "Authentication time limit: within 10 minutes",
        "P_YS_SD_SDMBF_0000142003": "Bank card No. is required.",
        "P_YS_IMP_PRM-BE_0001108771": "Certification failed",
        "P_YS_SD_SDMBF_0000141415": "Modify Mobile Phone No.",
        "P_YS_PF_YHTU_1541976126441127951": "Photo with ID card in hand",
        "P_YS_PF_YHTU_1541976126447943701": "Authentication content: Verification of ID card real name information",
        "P_YS_PF_YHTU_1541976126441127957": "If at least one type of personal authentication has been completed, the name authentication information will be reused",
        "P_YS_PF_YHTU_1541976126441127954": "3. ID card handheld photo requirement: a colour electronic version of the front of the original ID card in your hand",
        "P_YS_SD_SDMBF_0000144292": "Not Certified",
        "P_YS_PF_YHTU_1541976117851193351": "3. ID front photo requirements: the original front of the ID card colour electronic version of the picture, can not use photocopies of photos"
    }
}